// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CurrencyUSD: { input: CurrencyUSD; output: CurrencyUSD; }
  /**
   * Define a Relay Cursor type:
   * https://relay.dev/graphql/connections.htm#sec-Cursor
   */
  Cursor: { input: any; output: any; }
  Decimal: { input: GraphQLDecimal; output: GraphQLDecimal; }
  /** The `JSON` scalar type represents any valid JSON value. */
  JSON: { input: any; output: any; }
  /**
   * The `LexicalEditorState` scalar is a serialized Lexical editor state: the JSON
   * object that `editorState.toJSON()` returns, with a root node at the `root`
   * key. Each field that uses it states which nodes it accepts.
   */
  LexicalEditorState: { input: any; output: any; }
  /** The `Map` scalar type represents a JSON object with arbitrary key-value pairs. */
  Map: { input: any; output: any; }
  Percent: { input: Percent; output: Percent; }
  Time: { input: Time; output: Time; }
  URL: { input: any; output: any; }
  /** The `Upload` scalar type represents a multipart file upload. */
  Upload: { input: any; output: any; }
};

export type AiSuggestion = Node & {
  __typename?: 'AISuggestion';
  /** Whether the suggestion was accepted or rejected */
  acceptanceStatus?: Maybe<AiSuggestionAcceptanceStatus>;
  /** The FK to the kg_node table of the node that this suggestion was generated from */
  aiSuggestionKgNode?: Maybe<Scalars['ID']['output']>;
  /** A suggested asset */
  asset?: Maybe<AssetSuggestion>;
  /** The suggested beneficial owner. This should only be set if the kind is BENEFICIAL_OWNER */
  beneficialOwner?: Maybe<InferredBeneficialOwnerDetails>;
  /** The suggested date the beneficial owners were last updated. This should only be set if the kind is BENEFICIAL_OWNERS_AS_OF_DATE */
  beneficialOwnersAsOfDate?: Maybe<Scalars['Time']['output']>;
  /** The suggested beneficiary. This should only be set if the kind is BENEFICIARY. */
  beneficiary?: Maybe<InferredBeneficiaryDetails>;
  /** The suggested beneficiary. This should only be set if the kind is BENEFICIARY_V2. */
  beneficiaryV2?: Maybe<InferredBeneficiaryDetailsV2>;
  /** The suggested tax status for the business entity. This should only be set if the kind is BUSINESS_ENTITY_TAX_STATUS */
  businessEntityTaxStatus?: Maybe<AiSuggestionBusinessEntityTaxStatus>;
  /** If this is a non-onboarding suggestion for a trustee/trustAdvisor/beneficiary/keyPerson, this is the associated client organization */
  clientOrganization?: Maybe<ClientOrganization>;
  /** If this is a non-onboarding suggestion for a grantor/owner/trustee/trustAdvisor/beneficiary/keyPerson, this is the associated client profile. This gets set once the suggestion has been accepted and matched with an existing client_profile. */
  clientProfile?: Maybe<ClientProfile>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The suggested Crummey withdrawal period (in days). This should only be set if the kind is CRUMMEY_WITHDRAWAL_PERIOD_DAYS. */
  crummeyWithdrawalPeriodDays?: Maybe<Scalars['Int']['output']>;
  /** If this is a DP_RECIPIENT_GRANTOR_[1,2]_DIES_FIRST suggestion, this is the dispositive_provision that got created from this suggestion */
  dispositiveProvision?: Maybe<DispositiveProvision>;
  /** The suggested DBA name. This should only be set if the kind is DOING_BUSINESS_AS_NAME */
  doingBusinessAsName?: Maybe<Scalars['String']['output']>;
  /** The beneficiary-designation tier (PRIMARY or CONTINGENT) this DP_RECIPIENT_V2 suggestion belongs to. Distinct from dp_death_event: tier expresses primary-vs-contingent within a beneficiary designation group, while dp_death_event expresses which death triggers the disposition. Set only for suggestions whose target is a retirement / directly-held-insurance account; nil for all other DP suggestions. */
  dpBeneficiaryDesignationTier?: Maybe<AiSuggestionBeneficiaryDesignationTier>;
  /** The death event that triggers the disposition, given that the selected grantor dies first. This is separated out from the DispositiveProvisionRecipientSuggestion object because we want users to have the flexibility of moving all the DP's (and/or suggested DP's) from one death event to another on the form. This should only be set if the kind is DP_DEATH_EVENT_GRANTOR_[1,2]_DIES_FIRST */
  dpDeathEvent?: Maybe<AiSuggestionDispositiveProvisionDeathEvent>;
  /** For DP_RECIPIENT_V2 suggestions: the client profile of the grantor who dies first in this scenario */
  dpFirstDeathGrantorClientProfile?: Maybe<ClientProfile>;
  /** A suggested DP recipient. This should only be set if the kind is DP_RECIPIENT_GRANTOR_[1,2]_DIES_FIRST, or DP_RECIPIENT_TESTAMENTARY_ENTITY */
  dpRecipient?: Maybe<DispositiveProvisionRecipientSuggestion>;
  dpRecipientKgV2Nodes: Kgv2NodeConnection;
  /** The kind of the target for DP V2 suggestions. This should only be set if the kind is DP_RECIPIENT_V2. */
  dpTargetKind?: Maybe<AiSuggestionDpTargetKind>;
  /** For DP_RECIPIENT_V2 suggestions: the KG V2 node that is the target of the disposition */
  dpTargetNode?: Maybe<Kgv2Node>;
  /** The suggested effective date of the entity. This should only be set if the kind is EFFECTIVE_DATE. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  /** If this is a non-onboarding suggestion for a owner/beneficiary/keyPerson, this is the associated entity */
  entity?: Maybe<Entity>;
  /** The evidence (bounding regions) that supports this suggestion. This is only relevant if the suggestion was generated from the DocumentInferenceWorkflow. */
  evidence?: Maybe<Array<AiSuggestionEvidence>>;
  /** The file that this suggestion is from */
  file?: Maybe<File>;
  /** The suggested FinCEN ID for the business entity. This should only be set if the kind is FINCEN_ID */
  fincenID?: Maybe<Scalars['String']['output']>;
  /** The suggested GST status of the entity. This should only be set if the kind is GST_STATUS. */
  gstStatus?: Maybe<AiSuggestionEntityGstStatus>;
  /**
   * Only relevant if the suggestion is for a grantor/trustee/trustAdvisor/beneficiary. This indicates if the user has gone through the process to attempt to match the suggestion with a client profile/organization row.
   * @deprecated This is not needed, because we use the value of `acceptance_status` and the edges to determine if the suggestion has been matched.
   */
  hasMatched?: Maybe<Scalars['Boolean']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The suggested jurisdiction (state code) of the entity. This should only be set if the kind is JURISDICTION_STATE_CODE. */
  jurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  /** The suggested key person. This should only be set if the kind is KEY_PERSON */
  keyPerson?: Maybe<InferredKeyPersonDetails>;
  /** The KGNode that this suggestion was generated from. This should be a node that got created as part of the merging process while creating the KGRoot. This node might have multiple source nodes. */
  kgNode?: Maybe<KgNode>;
  /** The KGRoot that created this suggestion */
  kgRoot?: Maybe<KgRoot>;
  kgV2Statements: Kgv2StatementConnection;
  /** Indicates the field (or group of fields) the suggestion is for. */
  kind: AiSuggestionKind;
  /** The suggested legal name of the entity. This should only be set if the kind is LEGAL_NAME. */
  legalName?: Maybe<Scalars['String']['output']>;
  /** A suggested liability */
  liability?: Maybe<LiabilitySuggestion>;
  /** A suggested life insurance */
  lifeInsurance?: Maybe<LifeInsuranceSuggestion>;
  /** If this is an onboarding suggestion, this is the entity that got created from this suggestion */
  onboardedEntity?: Maybe<Entity>;
  /** If this is an onboarding suggestion, this is the client profile that got created from this suggestion */
  onboardedIndividual?: Maybe<ClientProfile>;
  /** If this is an onboarding suggestion, this is the client organization that got created from this suggestion */
  onboardedOrganization?: Maybe<ClientOrganization>;
  /** If this is an onboarding suggestion, this is the testamentary entity that got created from this suggestion */
  onboardedTestamentaryEntity?: Maybe<TestamentaryEntity>;
  /** The suggested entity to onboard. This should only be set if the kind is ONBOARDING_ENTITY */
  onboardingEntity?: Maybe<OnboardingEntitySuggestion>;
  /** The suggested person to onboard. This should only be set if the kind is ONBOARDING_INDIVIDUAL */
  onboardingIndividual?: Maybe<OnboardingIndividualSuggestion>;
  /** The suggested organization to onboard. This should only be set if the kind is ONBOARDING_ORGANIZATION */
  onboardingOrganization?: Maybe<OnboardingOrganizationSuggestion>;
  /** The suggested testamentary entity to onboard. This should only be set if the kind is ONBOARDING_TESTAMENTARY_ENTITY */
  onboardingTestamentaryEntity?: Maybe<OnboardingTestamentaryEntitySuggestion>;
  /** For ONBOARDING_TESTAMENTARY_ENTITY suggestions: the KG V2 trust node that is the parent/main trust instrument for the target subtrust */
  onboardingTestamentaryParentKgV2Node?: Maybe<Kgv2Node>;
  /** The entity (that got created from a suggestion) that has selected this suggestion as its owner */
  ownedOnboardedEntity?: Maybe<Array<Entity>>;
  /** When the suggestion has not been acknowledged, this is the potential existing client_organization this suggestion is associated with. */
  potentialClientOrganization?: Maybe<ClientOrganization>;
  /** When the suggestion has not been acknowledged, this is the potential existing client_profile this suggestion is associated with. */
  potentialClientProfile?: Maybe<ClientProfile>;
  /** When the suggestion has not been acknowledged, this is the potential existing entity this suggestion is associated with. */
  potentialEntity?: Maybe<Entity>;
  /** When the suggestion has not been acknowledged, this is the potential existing testamentary_entity this suggestion is associated with. */
  potentialTestamentaryEntity?: Maybe<TestamentaryEntity>;
  /** The suggested principal (grantor/owner/donor). This should only be set if the kind is PRINCIPAL. */
  principal?: Maybe<InferredGrantorDetails>;
  /** If this is an inferred_actor suggestion, this is the ai_onboarding suggestion that created the CP/CO/Entity/TestamentaryEntity row */
  referenceAiOnboardingSuggestion?: Maybe<AiSuggestion>;
  /** The ai_suggestions that reference this suggestion. This suggestion's onboarded CP/CO/Entity/TestamentaryEntity is use to pre-populate the other suggestion's field in the AISuggestionsMatcher */
  referencedBySuggestions?: Maybe<Array<AiSuggestion>>;
  sourceKgV2Nodes: Kgv2NodeConnection;
  /** The suggested parent trust entity that creates this sub-trust. This should only be set if the kind is SUBTRUST_CREATED_FROM. */
  subtrustCreatedFrom?: Maybe<InferredSubtrustCreatedFromDetails>;
  /** The suggested GST status of the sub-trust. This should only be set if the kind is SUBTRUST_GST_STATUS. */
  subtrustGstStatus?: Maybe<AiSuggestionEntityGstStatus>;
  /** The suggested sub-trust lifetime beneficiary. This should only be set if the kind is SUBTRUST_LIFETIME_BENEFICIARY. */
  subtrustLifetimeBeneficiary?: Maybe<InferredBeneficiaryDetailsV2>;
  /** The suggested sub-trust remainder beneficiary. This should only be set if the kind is SUBTRUST_REMAINDER_BENEFICIARY. */
  subtrustRemainderBeneficiary?: Maybe<InferredBeneficiaryDetailsV2>;
  /** The suggested sub-trust successor trustee. This should only be set if the kind is SUBTRUST_SUCCESSOR_TRUSTEE. */
  subtrustSuccessorTrustee?: Maybe<InferredTrusteeDetails>;
  /** The suggested sub-trust trust advisor. This should only be set if the kind is SUBTRUST_TRUST_ADVISOR. */
  subtrustTrustAdvisor?: Maybe<InferredTrustAdvisorDetails>;
  /** The suggested sub-trust trustee. This should only be set if the kind is SUBTRUST_TRUSTEE. */
  subtrustTrustee?: Maybe<InferredTrusteeDetails>;
  /** The suggested type of the sub-trust. This should only be set if the kind is SUBTRUST_TYPE. */
  subtrustType?: Maybe<AiSuggestionTestamentaryEntityKind>;
  /** The suggested successor trustee. This should only be set if the kind is SUCCESSOR_TRUSTEE. */
  successorTrustee?: Maybe<InferredTrusteeDetails>;
  /** The knowledge graph roots that generated other AISuggestions about this suggestion, and will be applied if the user accepts this suggestion. */
  suggestionKgRoots?: Maybe<Array<KgRoot>>;
  /** The suggested tax ID (EIN) for the business entity. This should only be set if the kind is TAX_ID */
  taxID?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The Testamentary Entity that this suggestion is for */
  testamentaryEntity?: Maybe<TestamentaryEntity>;
  /** The suggested trust advisor. This should only be set if the kind is TRUST_ADVISOR. */
  trustAdvisor?: Maybe<InferredTrustAdvisorDetails>;
  /** The suggested trustee. This should only be set if the kind is TRUSTEE. */
  trustee?: Maybe<InferredTrusteeDetails>;
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
  /** The version of the suggestion pipeline that produced this record. 1 = v1 (document inference), 2 = v2 (KG V2). */
  version?: Maybe<Scalars['Int']['output']>;
};


export type AiSuggestionDpRecipientKgV2NodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2NodeOrder>>;
  where?: InputMaybe<Kgv2NodeWhereInput>;
};


export type AiSuggestionKgV2StatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2StatementOrder>>;
  where?: InputMaybe<Kgv2StatementWhereInput>;
};


export type AiSuggestionSourceKgV2NodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2NodeOrder>>;
  where?: InputMaybe<Kgv2NodeWhereInput>;
};

/** AISuggestionAcceptanceStatus is enum for the field acceptance_status */
export enum AiSuggestionAcceptanceStatus {
  Accepted = 'ACCEPTED',
  AutoAccepted = 'AUTO_ACCEPTED',
  Rejected = 'REJECTED'
}

/** AISuggestionBeneficiaryDesignationTier is enum for the field dp_beneficiary_designation_tier */
export enum AiSuggestionBeneficiaryDesignationTier {
  Contingent = 'CONTINGENT',
  Primary = 'PRIMARY'
}

/** AISuggestionBusinessEntityTaxStatus is enum for the field business_entity_tax_status */
export enum AiSuggestionBusinessEntityTaxStatus {
  Corporation = 'CORPORATION',
  DisregardedEntity = 'DISREGARDED_ENTITY',
  NonTaxableEntity = 'NON_TAXABLE_ENTITY',
  Partnership = 'PARTNERSHIP'
}

/** A connection to a list of items. */
export type AiSuggestionConnection = {
  __typename?: 'AISuggestionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AiSuggestionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** AISuggestionDispositiveProvisionDeathEvent is enum for the field dp_death_event */
export enum AiSuggestionDispositiveProvisionDeathEvent {
  None = 'NONE',
  UponFirstDeath = 'UPON_FIRST_DEATH',
  UponSecondDeath = 'UPON_SECOND_DEATH'
}

/** AISuggestionDpTargetKind is enum for the field dp_target_kind */
export enum AiSuggestionDpTargetKind {
  Entity = 'ENTITY',
  TestamentaryEntity = 'TESTAMENTARY_ENTITY',
  UnresolvedPersonalAccountNode = 'UNRESOLVED_PERSONAL_ACCOUNT_NODE',
  UnresolvedSubtrustNode = 'UNRESOLVED_SUBTRUST_NODE',
  UnresolvedTrustNode = 'UNRESOLVED_TRUST_NODE'
}

/** An edge in a connection. */
export type AiSuggestionEdge = {
  __typename?: 'AISuggestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AiSuggestion>;
};

/** AISuggestionEntityGSTStatus is enum for the field gst_status */
export enum AiSuggestionEntityGstStatus {
  GstExempt = 'GST_EXEMPT',
  GstNonExempt = 'GST_NON_EXEMPT',
  MixedGst = 'MIXED_GST'
}

export type AiSuggestionEvidence = Node & {
  __typename?: 'AISuggestionEvidence';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  fileParagraphs: FileParagraphConnection;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The kg node that this evidence is for */
  kgNode?: Maybe<KgNode>;
  /** The suggestion that this evidence is for */
  suggestion?: Maybe<AiSuggestion>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type AiSuggestionEvidenceFileParagraphsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileParagraphOrder>>;
};

/** A connection to a list of items. */
export type AiSuggestionEvidenceConnection = {
  __typename?: 'AISuggestionEvidenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AiSuggestionEvidenceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AiSuggestionEvidenceEdge = {
  __typename?: 'AISuggestionEvidenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AiSuggestionEvidence>;
};

/** Ordering options for AISuggestionEvidence connections */
export type AiSuggestionEvidenceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AISuggestionEvidences. */
  field: AiSuggestionEvidenceOrderField;
};

/** Properties by which AISuggestionEvidence connections can be ordered. */
export enum AiSuggestionEvidenceOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * AISuggestionEvidenceWhereInput is used for filtering AISuggestionEvidence objects.
 * Input was generated by ent.
 */
export type AiSuggestionEvidenceWhereInput = {
  and?: InputMaybe<Array<AiSuggestionEvidenceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** kg_node edge predicates */
  hasKgNode?: InputMaybe<Scalars['Boolean']['input']>;
  hasKgNodeWith?: InputMaybe<Array<KgNodeWhereInput>>;
  /** suggestion edge predicates */
  hasSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuggestionWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AiSuggestionEvidenceWhereInput>;
  or?: InputMaybe<Array<AiSuggestionEvidenceWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** AISuggestionKind is enum for the field kind */
export enum AiSuggestionKind {
  Asset = 'ASSET',
  BeneficialOwner = 'BENEFICIAL_OWNER',
  BeneficialOwnersAsOfDate = 'BENEFICIAL_OWNERS_AS_OF_DATE',
  Beneficiary = 'BENEFICIARY',
  BeneficiaryV2 = 'BENEFICIARY_V2',
  BusinessEntityTaxStatus = 'BUSINESS_ENTITY_TAX_STATUS',
  CrummeyWithdrawalPeriodDays = 'CRUMMEY_WITHDRAWAL_PERIOD_DAYS',
  DoingBusinessAsName = 'DOING_BUSINESS_AS_NAME',
  DpDeathEventGrantor_1DiesFirst = 'DP_DEATH_EVENT_GRANTOR_1_DIES_FIRST',
  DpDeathEventGrantor_2DiesFirst = 'DP_DEATH_EVENT_GRANTOR_2_DIES_FIRST',
  DpRecipientGrantor_1DiesFirst = 'DP_RECIPIENT_GRANTOR_1_DIES_FIRST',
  DpRecipientGrantor_2DiesFirst = 'DP_RECIPIENT_GRANTOR_2_DIES_FIRST',
  DpRecipientTestamentaryEntity = 'DP_RECIPIENT_TESTAMENTARY_ENTITY',
  DpRecipientV2 = 'DP_RECIPIENT_V2',
  EffectiveDate = 'EFFECTIVE_DATE',
  FincenId = 'FINCEN_ID',
  GstStatus = 'GST_STATUS',
  JurisdictionStateCode = 'JURISDICTION_STATE_CODE',
  KeyPerson = 'KEY_PERSON',
  LegalName = 'LEGAL_NAME',
  Liability = 'LIABILITY',
  LifeInsurance = 'LIFE_INSURANCE',
  OnboardingEntity = 'ONBOARDING_ENTITY',
  OnboardingIndividual = 'ONBOARDING_INDIVIDUAL',
  OnboardingOrganization = 'ONBOARDING_ORGANIZATION',
  OnboardingTestamentaryEntity = 'ONBOARDING_TESTAMENTARY_ENTITY',
  Principal = 'PRINCIPAL',
  SubtrustCreatedFrom = 'SUBTRUST_CREATED_FROM',
  SubtrustGstStatus = 'SUBTRUST_GST_STATUS',
  SubtrustLifetimeBeneficiary = 'SUBTRUST_LIFETIME_BENEFICIARY',
  SubtrustRemainderBeneficiary = 'SUBTRUST_REMAINDER_BENEFICIARY',
  SubtrustSuccessorTrustee = 'SUBTRUST_SUCCESSOR_TRUSTEE',
  SubtrustTrustee = 'SUBTRUST_TRUSTEE',
  SubtrustTrustAdvisor = 'SUBTRUST_TRUST_ADVISOR',
  SubtrustType = 'SUBTRUST_TYPE',
  SuccessorTrustee = 'SUCCESSOR_TRUSTEE',
  TaxId = 'TAX_ID',
  TeDpRecipientGrantor_1DiesFirst = 'TE_DP_RECIPIENT_GRANTOR_1_DIES_FIRST',
  TeDpRecipientGrantor_2DiesFirst = 'TE_DP_RECIPIENT_GRANTOR_2_DIES_FIRST',
  Trustee = 'TRUSTEE',
  TrustAdvisor = 'TRUST_ADVISOR'
}

/** Ordering options for AISuggestion connections */
export type AiSuggestionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AISuggestions. */
  field: AiSuggestionOrderField;
};

/** Properties by which AISuggestion connections can be ordered. */
export enum AiSuggestionOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * AISuggestionRegenScope identifies which target a regen-completion
 * notification covers. The string value of each enum case is stamped onto
 * the notification's action URL (?scope=…) so the click-through handler can
 * route to the right destination per scope. Kept in sync with the backend
 * notifications.AISuggestionRegenScope constants.
 */
export enum AiSuggestionRegenScope {
  /** Single-target dispositive provisions regen. */
  Dispositions = 'DISPOSITIONS',
  /** Single-target entity details regen. */
  Entity = 'ENTITY',
  /** Full-household refresh, triggered by refreshHouseholdSuggestions. */
  Household = 'HOUSEHOLD',
  /** Single-target sub-trust (testamentary entity) details regen. */
  Subtrust = 'SUBTRUST'
}

/** AISuggestionTestamentaryEntityKind is enum for the field subtrust_type */
export enum AiSuggestionTestamentaryEntityKind {
  CharitableEntity = 'CHARITABLE_ENTITY',
  CharitableTrust = 'CHARITABLE_TRUST',
  GrantorEstate = 'GRANTOR_ESTATE',
  InheritedRetirementAccount = 'INHERITED_RETIREMENT_ACCOUNT',
  TestamentaryTrust = 'TESTAMENTARY_TRUST'
}

/**
 * AISuggestionWhereInput is used for filtering AISuggestion objects.
 * Input was generated by ent.
 */
export type AiSuggestionWhereInput = {
  /** acceptance_status field predicates */
  acceptanceStatus?: InputMaybe<AiSuggestionAcceptanceStatus>;
  acceptanceStatusIn?: InputMaybe<Array<AiSuggestionAcceptanceStatus>>;
  acceptanceStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  acceptanceStatusNEQ?: InputMaybe<AiSuggestionAcceptanceStatus>;
  acceptanceStatusNotIn?: InputMaybe<Array<AiSuggestionAcceptanceStatus>>;
  acceptanceStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ai_suggestion_kg_node field predicates */
  aiSuggestionKgNode?: InputMaybe<Scalars['ID']['input']>;
  aiSuggestionKgNodeIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  aiSuggestionKgNodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  aiSuggestionKgNodeNEQ?: InputMaybe<Scalars['ID']['input']>;
  aiSuggestionKgNodeNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  aiSuggestionKgNodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** beneficial_owners_as_of_date field predicates */
  beneficialOwnersAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  beneficialOwnersAsOfDateGT?: InputMaybe<Scalars['Time']['input']>;
  beneficialOwnersAsOfDateGTE?: InputMaybe<Scalars['Time']['input']>;
  beneficialOwnersAsOfDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  beneficialOwnersAsOfDateLT?: InputMaybe<Scalars['Time']['input']>;
  beneficialOwnersAsOfDateLTE?: InputMaybe<Scalars['Time']['input']>;
  beneficialOwnersAsOfDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** business_entity_tax_status field predicates */
  businessEntityTaxStatus?: InputMaybe<AiSuggestionBusinessEntityTaxStatus>;
  businessEntityTaxStatusIn?: InputMaybe<Array<AiSuggestionBusinessEntityTaxStatus>>;
  businessEntityTaxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  businessEntityTaxStatusNEQ?: InputMaybe<AiSuggestionBusinessEntityTaxStatus>;
  businessEntityTaxStatusNotIn?: InputMaybe<Array<AiSuggestionBusinessEntityTaxStatus>>;
  businessEntityTaxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** crummey_withdrawal_period_days field predicates */
  crummeyWithdrawalPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysGT?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysGTE?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  crummeyWithdrawalPeriodDaysLT?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysLTE?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysNEQ?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** doing_business_as_name field predicates */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  doingBusinessAsNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  doingBusinessAsNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** dp_beneficiary_designation_tier field predicates */
  dpBeneficiaryDesignationTier?: InputMaybe<AiSuggestionBeneficiaryDesignationTier>;
  dpBeneficiaryDesignationTierIn?: InputMaybe<Array<AiSuggestionBeneficiaryDesignationTier>>;
  dpBeneficiaryDesignationTierIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dpBeneficiaryDesignationTierNEQ?: InputMaybe<AiSuggestionBeneficiaryDesignationTier>;
  dpBeneficiaryDesignationTierNotIn?: InputMaybe<Array<AiSuggestionBeneficiaryDesignationTier>>;
  dpBeneficiaryDesignationTierNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** dp_death_event field predicates */
  dpDeathEvent?: InputMaybe<AiSuggestionDispositiveProvisionDeathEvent>;
  dpDeathEventIn?: InputMaybe<Array<AiSuggestionDispositiveProvisionDeathEvent>>;
  dpDeathEventIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dpDeathEventNEQ?: InputMaybe<AiSuggestionDispositiveProvisionDeathEvent>;
  dpDeathEventNotIn?: InputMaybe<Array<AiSuggestionDispositiveProvisionDeathEvent>>;
  dpDeathEventNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** dp_target_kind field predicates */
  dpTargetKind?: InputMaybe<AiSuggestionDpTargetKind>;
  dpTargetKindIn?: InputMaybe<Array<AiSuggestionDpTargetKind>>;
  dpTargetKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dpTargetKindNEQ?: InputMaybe<AiSuggestionDpTargetKind>;
  dpTargetKindNotIn?: InputMaybe<Array<AiSuggestionDpTargetKind>>;
  dpTargetKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** fincen_id field predicates */
  fincenID?: InputMaybe<Scalars['String']['input']>;
  fincenIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fincenIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<AiSuggestionEntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<AiSuggestionEntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<AiSuggestionEntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<AiSuggestionEntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** client_organization edge predicates */
  hasClientOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** client_profile edge predicates */
  hasClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientProfileWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** dispositive_provision edge predicates */
  hasDispositiveProvision?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositiveProvisionWith?: InputMaybe<Array<DispositiveProvisionWhereInput>>;
  /** dp_first_death_grantor_client_profile edge predicates */
  hasDpFirstDeathGrantorClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasDpFirstDeathGrantorClientProfileWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** dp_recipient_kg_v2_nodes edge predicates */
  hasDpRecipientKgV2Nodes?: InputMaybe<Scalars['Boolean']['input']>;
  hasDpRecipientKgV2NodesWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** dp_target_node edge predicates */
  hasDpTargetNode?: InputMaybe<Scalars['Boolean']['input']>;
  hasDpTargetNodeWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** evidence edge predicates */
  hasEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  hasEvidenceWith?: InputMaybe<Array<AiSuggestionEvidenceWhereInput>>;
  /** file edge predicates */
  hasFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileWith?: InputMaybe<Array<FileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** kg_node edge predicates */
  hasKgNode?: InputMaybe<Scalars['Boolean']['input']>;
  hasKgNodeWith?: InputMaybe<Array<KgNodeWhereInput>>;
  /** kg_root edge predicates */
  hasKgRoot?: InputMaybe<Scalars['Boolean']['input']>;
  hasKgRootWith?: InputMaybe<Array<KgRootWhereInput>>;
  /** kg_v2_statements edge predicates */
  hasKgV2Statements?: InputMaybe<Scalars['Boolean']['input']>;
  hasKgV2StatementsWith?: InputMaybe<Array<Kgv2StatementWhereInput>>;
  /** has_matched field predicates */
  hasMatched?: InputMaybe<Scalars['Boolean']['input']>;
  hasMatchedIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  hasMatchedNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** onboarded_entity edge predicates */
  hasOnboardedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasOnboardedEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** onboarded_individual edge predicates */
  hasOnboardedIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasOnboardedIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** onboarded_organization edge predicates */
  hasOnboardedOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOnboardedOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** onboarded_testamentary_entity edge predicates */
  hasOnboardedTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasOnboardedTestamentaryEntityWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** onboarding_testamentary_parent_kg_v2_node edge predicates */
  hasOnboardingTestamentaryParentKgV2Node?: InputMaybe<Scalars['Boolean']['input']>;
  hasOnboardingTestamentaryParentKgV2NodeWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** owned_onboarded_entity edge predicates */
  hasOwnedOnboardedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnedOnboardedEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** potential_client_organization edge predicates */
  hasPotentialClientOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasPotentialClientOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** potential_client_profile edge predicates */
  hasPotentialClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPotentialClientProfileWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** potential_entity edge predicates */
  hasPotentialEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasPotentialEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** potential_testamentary_entity edge predicates */
  hasPotentialTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasPotentialTestamentaryEntityWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** reference_ai_onboarding_suggestion edge predicates */
  hasReferenceAiOnboardingSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasReferenceAiOnboardingSuggestionWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** referenced_by_suggestions edge predicates */
  hasReferencedBySuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  hasReferencedBySuggestionsWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** source_kg_v2_nodes edge predicates */
  hasSourceKgV2Nodes?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceKgV2NodesWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** suggestion_kg_roots edge predicates */
  hasSuggestionKgRoots?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuggestionKgRootsWith?: InputMaybe<Array<KgRootWhereInput>>;
  /** testamentary_entity edge predicates */
  hasTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasTestamentaryEntityWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** jurisdiction_state_code field predicates */
  jurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  jurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<AiSuggestionKind>;
  kindIn?: InputMaybe<Array<AiSuggestionKind>>;
  kindNEQ?: InputMaybe<AiSuggestionKind>;
  kindNotIn?: InputMaybe<Array<AiSuggestionKind>>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<AiSuggestionWhereInput>;
  or?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** subtrust_gst_status field predicates */
  subtrustGstStatus?: InputMaybe<AiSuggestionEntityGstStatus>;
  subtrustGstStatusIn?: InputMaybe<Array<AiSuggestionEntityGstStatus>>;
  subtrustGstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  subtrustGstStatusNEQ?: InputMaybe<AiSuggestionEntityGstStatus>;
  subtrustGstStatusNotIn?: InputMaybe<Array<AiSuggestionEntityGstStatus>>;
  subtrustGstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** subtrust_type field predicates */
  subtrustType?: InputMaybe<AiSuggestionTestamentaryEntityKind>;
  subtrustTypeIn?: InputMaybe<Array<AiSuggestionTestamentaryEntityKind>>;
  subtrustTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  subtrustTypeNEQ?: InputMaybe<AiSuggestionTestamentaryEntityKind>;
  subtrustTypeNotIn?: InputMaybe<Array<AiSuggestionTestamentaryEntityKind>>;
  subtrustTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_id field predicates */
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** version field predicates */
  version?: InputMaybe<Scalars['Int']['input']>;
  versionGT?: InputMaybe<Scalars['Int']['input']>;
  versionGTE?: InputMaybe<Scalars['Int']['input']>;
  versionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  versionLT?: InputMaybe<Scalars['Int']['input']>;
  versionLTE?: InputMaybe<Scalars['Int']['input']>;
  versionNEQ?: InputMaybe<Scalars['Int']['input']>;
  versionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AcceptHouseholdAiSuggestionsInput = {
  householdID: Scalars['ID']['input'];
  scope: AcceptHouseholdAiSuggestionsScope;
};

export type AcceptHouseholdAiSuggestionsPayload = {
  __typename?: 'AcceptHouseholdAISuggestionsPayload';
  acceptedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

/** The pending suggestion categories to accept for a household. */
export enum AcceptHouseholdAiSuggestionsScope {
  All = 'ALL',
  ExcludeDpAndHoldings = 'EXCLUDE_DP_AND_HOLDINGS',
  ExcludeHoldings = 'EXCLUDE_HOLDINGS'
}

export type AccessAgeParameter = Node & {
  __typename?: 'AccessAgeParameter';
  /** the access parameter this access age parameter is for */
  accessParameter?: Maybe<AccessParameter>;
  /** The end of the age requirement for this distribution */
  ageRequirementEnd?: Maybe<Scalars['Int']['output']>;
  /** The start of the age requirement for this distribution */
  ageRequirementStart?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Free-form notes */
  notes?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type AccessAgeParameterConnection = {
  __typename?: 'AccessAgeParameterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccessAgeParameterEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccessAgeParameterEdge = {
  __typename?: 'AccessAgeParameterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AccessAgeParameter>;
};

/** Ordering options for AccessAgeParameter connections */
export type AccessAgeParameterOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AccessAgeParameters. */
  field: AccessAgeParameterOrderField;
};

/** Properties by which AccessAgeParameter connections can be ordered. */
export enum AccessAgeParameterOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type AccessAgeParameterView = {
  __typename?: 'AccessAgeParameterView';
  /** ageEnd is the end of the age requirement for this access */
  ageEnd?: Maybe<Scalars['Int']['output']>;
  /** ageStart is the start of the age requirement for this access */
  ageStart?: Maybe<Scalars['Int']['output']>;
};

/**
 * AccessAgeParameterWhereInput is used for filtering AccessAgeParameter objects.
 * Input was generated by ent.
 */
export type AccessAgeParameterWhereInput = {
  /** age_requirement_end field predicates */
  ageRequirementEnd?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementEndGT?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementEndGTE?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementEndIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ageRequirementEndLT?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementEndLTE?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementEndNEQ?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementEndNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** age_requirement_start field predicates */
  ageRequirementStart?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementStartGT?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementStartGTE?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementStartIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ageRequirementStartLT?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementStartLTE?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementStartNEQ?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementStartNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<AccessAgeParameterWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** access_parameter edge predicates */
  hasAccessParameter?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccessParameterWith?: InputMaybe<Array<AccessParameterWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AccessAgeParameterWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<AccessAgeParameterWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type AccessParameter = Node & {
  __typename?: 'AccessParameter';
  accessAgeParameters: AccessAgeParameterConnection;
  /** The amount of access, as a dollar value. Valid when kind is AMOUNT or TRUST_INCOME */
  amount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** the beneficiary this access parameter is for */
  beneficiary?: Maybe<Beneficiary>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The frequency of the access */
  frequency?: Maybe<AccessParameterFrequency>;
  /** If true, access will grow by the inflation rate specified in the growth profile.Only applicable if the access is kind AMOUNT or TRUST_INCOME. */
  growByInflation: Scalars['Boolean']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The kind of access parameter */
  kind: AccessParameterKind;
  /** The percentage of access. Valid when kind is PERCENTAGE or TRUST_INCOME */
  percentage?: Maybe<Scalars['Percent']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type AccessParameterAccessAgeParametersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccessAgeParameterOrder>>;
  where?: InputMaybe<AccessAgeParameterWhereInput>;
};

/** A connection to a list of items. */
export type AccessParameterConnection = {
  __typename?: 'AccessParameterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccessParameterEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccessParameterEdge = {
  __typename?: 'AccessParameterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AccessParameter>;
};

/** AccessParameterFrequency is enum for the field frequency */
export enum AccessParameterFrequency {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY'
}

/** AccessParameterKind is enum for the field kind */
export enum AccessParameterKind {
  AllTrustIncome = 'ALL_TRUST_INCOME',
  Amount = 'AMOUNT',
  Full = 'FULL',
  FullDiscretion = 'FULL_DISCRETION',
  Hems = 'HEMS',
  Hms = 'HMS',
  NetIncome = 'NET_INCOME',
  NetIncomeWithMakeup = 'NET_INCOME_WITH_MAKEUP',
  Other = 'OTHER',
  Percentage = 'PERCENTAGE',
  TrustIncome = 'TRUST_INCOME'
}

/** Ordering options for AccessParameter connections */
export type AccessParameterOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AccessParameters. */
  field: AccessParameterOrderField;
};

/** Properties by which AccessParameter connections can be ordered. */
export enum AccessParameterOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type AccessParameterView = AmountAccessParameterView | DiscretionaryAccessParameterView | PercentageAccessParameterView | TrustIncomeAccessParameterView;

/**
 * AccessParameterWhereInput is used for filtering AccessParameter objects.
 * Input was generated by ent.
 */
export type AccessParameterWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  amountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<AccessParameterWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** frequency field predicates */
  frequency?: InputMaybe<AccessParameterFrequency>;
  frequencyIn?: InputMaybe<Array<AccessParameterFrequency>>;
  frequencyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  frequencyNEQ?: InputMaybe<AccessParameterFrequency>;
  frequencyNotIn?: InputMaybe<Array<AccessParameterFrequency>>;
  frequencyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** grow_by_inflation field predicates */
  growByInflation?: InputMaybe<Scalars['Boolean']['input']>;
  /** access_age_parameters edge predicates */
  hasAccessAgeParameters?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccessAgeParametersWith?: InputMaybe<Array<AccessAgeParameterWhereInput>>;
  /** beneficiary edge predicates */
  hasBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiaryWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<AccessParameterKind>;
  kindIn?: InputMaybe<Array<AccessParameterKind>>;
  kindNEQ?: InputMaybe<AccessParameterKind>;
  kindNotIn?: InputMaybe<Array<AccessParameterKind>>;
  not?: InputMaybe<AccessParameterWhereInput>;
  or?: InputMaybe<Array<AccessParameterWhereInput>>;
  /** percentage field predicates */
  percentage?: InputMaybe<Scalars['Percent']['input']>;
  percentageGT?: InputMaybe<Scalars['Percent']['input']>;
  percentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  percentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  percentageLT?: InputMaybe<Scalars['Percent']['input']>;
  percentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  percentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  percentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Account = Node & {
  __typename?: 'Account';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Initial valuation of the account */
  initialValuation?: Maybe<AssetValuationV2>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  valuations: AssetValuationV2Connection;
};


export type AccountValuationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssetValuationV2Order>>;
  where?: InputMaybe<AssetValuationV2WhereInput>;
};

/** A connection to a list of items. */
export type AccountConnection = {
  __typename?: 'AccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccountEdge = {
  __typename?: 'AccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Account>;
};

/** Ordering options for Account connections */
export type AccountOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Accounts. */
  field: AccountOrderField;
};

/** Properties by which Account connections can be ordered. */
export enum AccountOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * AccountWhereInput is used for filtering Account objects.
 * Input was generated by ent.
 */
export type AccountWhereInput = {
  and?: InputMaybe<Array<AccountWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** initial_valuation edge predicates */
  hasInitialValuation?: InputMaybe<Scalars['Boolean']['input']>;
  hasInitialValuationWith?: InputMaybe<Array<AssetValuationV2WhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** valuations edge predicates */
  hasValuations?: InputMaybe<Scalars['Boolean']['input']>;
  hasValuationsWith?: InputMaybe<Array<AssetValuationV2WhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AccountWhereInput>;
  or?: InputMaybe<Array<AccountWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type AcknowledgeAiSuggestionInput = {
  clientOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  clientProfileID?: InputMaybe<Scalars['ID']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  status: AiSuggestionAcceptanceStatus;
  suggestionID: Scalars['ID']['input'];
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
};

export type ActiveEstateInsightsPage = Node & {
  __typename?: 'ActiveEstateInsightsPage';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The presentation page that this estate insight page is part of */
  presentationPage?: Maybe<PresentationPage>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type ActiveEstateInsightsPageConnection = {
  __typename?: 'ActiveEstateInsightsPageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ActiveEstateInsightsPageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ActiveEstateInsightsPageEdge = {
  __typename?: 'ActiveEstateInsightsPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ActiveEstateInsightsPage>;
};

export type Activity = Node & {
  __typename?: 'Activity';
  changes?: Maybe<Array<ActivityFieldChange>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  entities?: Maybe<Array<Entity>>;
  groupName?: Maybe<ActivityGroupName>;
  household?: Maybe<Household>;
  id: Scalars['ID']['output'];
  requestID?: Maybe<Scalars['String']['output']>;
  target: Node;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  verb: ActivityVerb;
};

/** A connection to a list of items. */
export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ActivityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ActivityEdge = {
  __typename?: 'ActivityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Activity>;
};

export type ActivityFieldChange = {
  __typename?: 'ActivityFieldChange';
  fieldDisplayName?: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  newValueCleared?: Maybe<Scalars['Boolean']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  /**
   * RemovedValue is typically only generated by edges
   * since they only have a notion of +/-
   */
  removedValue?: Maybe<Scalars['String']['output']>;
};

export type ActivityGroup = {
  __typename?: 'ActivityGroup';
  activities: Array<Activity>;
};

export type ActivityGroupConnection = {
  __typename?: 'ActivityGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ActivityGroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ActivityGroupEdge = {
  __typename?: 'ActivityGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ActivityGroup>;
};

/** ActivityGroupName is enum for the field group_name */
export enum ActivityGroupName {
  AssignEntityTasks = 'assign_entity_tasks',
  AssignStrategyTasks = 'assign_strategy_tasks',
  CreateEntity = 'create_entity',
  CreateStrategy = 'create_strategy',
  CreateTeam = 'create_team',
  DeleteEntity = 'delete_entity',
  DeleteStrategy = 'delete_strategy',
  DeleteTeam = 'delete_team',
  UpdateEntity = 'update_entity',
  UpdateEntityTask = 'update_entity_task',
  UpdateStrategy = 'update_strategy',
  UpdateTeam = 'update_team'
}

/** Ordering options for Activity connections */
export type ActivityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Activities. */
  field: ActivityOrderField;
};

/** Properties by which Activity connections can be ordered. */
export enum ActivityOrderField {
  CreatedAt = 'created_at',
  RequestId = 'request_id',
  UpdatedAt = 'updated_at'
}

/** ActivityVerb is enum for the field verb */
export enum ActivityVerb {
  Create = 'create',
  Delete = 'delete',
  Update = 'update'
}

/**
 * ActivityWhereInput is used for filtering Activity objects.
 * Input was generated by ent.
 */
export type ActivityWhereInput = {
  and?: InputMaybe<Array<ActivityWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** group_name field predicates */
  groupName?: InputMaybe<ActivityGroupName>;
  groupNameIn?: InputMaybe<Array<ActivityGroupName>>;
  groupNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  groupNameNEQ?: InputMaybe<ActivityGroupName>;
  groupNameNotIn?: InputMaybe<Array<ActivityGroupName>>;
  groupNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entities edge predicates */
  hasEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntitiesWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ActivityWhereInput>;
  or?: InputMaybe<Array<ActivityWhereInput>>;
  /** request_id field predicates */
  requestID?: InputMaybe<Scalars['String']['input']>;
  requestIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  requestIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requestIDLT?: InputMaybe<Scalars['String']['input']>;
  requestIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** verb field predicates */
  verb?: InputMaybe<ActivityVerb>;
  verbIn?: InputMaybe<Array<ActivityVerb>>;
  verbNEQ?: InputMaybe<ActivityVerb>;
  verbNotIn?: InputMaybe<Array<ActivityVerb>>;
};

/** Adds a new SSH public key without removing an existing rotation key. */
export type AddManagedSftpPublicKeyInput = {
  publicKeyText: Scalars['String']['input'];
};

/** Input for addWorkOSOrganizationDomain. */
export type AddWorkOsOrganizationDomainInput = {
  /** Email domain to bind to the WorkOSOrganization (e.g. "acme.com"). */
  emailDomain: Scalars['String']['input'];
  /** The WorkOSOrganization to attach the new routing domain to. */
  workosOrganizationID: Scalars['ID']['input'];
};

export type AddeparJobStatusAndResults = {
  __typename?: 'AddeparJobStatusAndResults';
  results?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AddeparQueryResults = {
  __typename?: 'AddeparQueryResults';
  requestMetadata?: Maybe<Scalars['String']['output']>;
  responseMetadata?: Maybe<Scalars['String']['output']>;
  results: Scalars['String']['output'];
};

export type Address = Node & {
  __typename?: 'Address';
  cityName?: Maybe<Scalars['String']['output']>;
  clientProfile?: Maybe<Array<ClientProfile>>;
  createdAt: Scalars['Time']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Whether the individual at this address resides outside the United States. */
  residesOutsideUnitedStates: Scalars['Boolean']['output'];
  stateCode: Scalars['String']['output'];
  streetLineOne?: Maybe<Scalars['String']['output']>;
  streetLineTwo?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type AddressConnection = {
  __typename?: 'AddressConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AddressEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AddressEdge = {
  __typename?: 'AddressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Address>;
};

/** Ordering options for Address connections */
export type AddressOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Addresses. */
  field: AddressOrderField;
};

/** Properties by which Address connections can be ordered. */
export enum AddressOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * AddressWhereInput is used for filtering Address objects.
 * Input was generated by ent.
 */
export type AddressWhereInput = {
  and?: InputMaybe<Array<AddressWhereInput>>;
  /** city_name field predicates */
  cityName?: InputMaybe<Scalars['String']['input']>;
  cityNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cityNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** client_profile edge predicates */
  hasClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientProfileWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AddressWhereInput>;
  or?: InputMaybe<Array<AddressWhereInput>>;
  /** postal_code field predicates */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  postalCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** resides_outside_united_states field predicates */
  residesOutsideUnitedStates?: InputMaybe<Scalars['Boolean']['input']>;
  /** state_code field predicates */
  stateCode?: InputMaybe<Scalars['String']['input']>;
  /** street_line_one field predicates */
  streetLineOne?: InputMaybe<Scalars['String']['input']>;
  streetLineOneIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  streetLineOneNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** street_line_two field predicates */
  streetLineTwo?: InputMaybe<Scalars['String']['input']>;
  streetLineTwoIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  streetLineTwoNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export enum AfterDeath {
  First = 'First',
  None = 'None',
  Second = 'Second'
}

export type AmountAccessParameterView = {
  __typename?: 'AmountAccessParameterView';
  accessAgeParameters: Array<AccessAgeParameterView>;
  amount: Scalars['CurrencyUSD']['output'];
  frequency?: Maybe<AccessParameterFrequency>;
  /** kind is the kind of access, always AMOUNT */
  kind: AccessParameterKind;
};

export type Answer = Node & {
  __typename?: 'Answer';
  /** When a user confirmed the selected revision */
  confirmedAt?: Maybe<Scalars['Time']['output']>;
  /** The user who confirmed the selected revision */
  confirmedBy?: Maybe<User>;
  /** The revision most recently confirmed by a user */
  confirmedRevision?: Maybe<AnswerRevision>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The revision currently selected for review and export */
  currentRevision?: Maybe<AnswerRevision>;
  /** The stable field identifier in the pinned FormVersion config */
  fieldID: Scalars['String']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The latest AI revision, independent of the user-selected currentRevision. */
  latestAIRevision?: Maybe<AnswerRevision>;
  /** The optimistic-concurrency version for revision pointer changes */
  lockVersion: Scalars['Int']['output'];
  /** The append-only revision history for this answer */
  revisions?: Maybe<Array<AnswerRevision>>;
  /** The submission that owns this field slot */
  submission: Submission;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};

export type AnswerEvidence = Node & {
  __typename?: 'AnswerEvidence';
  /** The exact answer revision that this evidence supports */
  answerRevision: AnswerRevision;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The source document that owns every cited paragraph */
  document: Document;
  /** One or more ordered file paragraphs that form the cited span */
  fileParagraphs?: Maybe<Array<FileParagraph>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The zero-based citation position within the revision */
  position: Scalars['Int']['output'];
  target?: Maybe<FormAnswerTarget>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for AnswerEvidence connections */
export type AnswerEvidenceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AnswerEvidences. */
  field: AnswerEvidenceOrderField;
};

/** Properties by which AnswerEvidence connections can be ordered. */
export enum AnswerEvidenceOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * AnswerEvidenceWhereInput is used for filtering AnswerEvidence objects.
 * Input was generated by ent.
 */
export type AnswerEvidenceWhereInput = {
  and?: InputMaybe<Array<AnswerEvidenceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** answer_revision edge predicates */
  hasAnswerRevision?: InputMaybe<Scalars['Boolean']['input']>;
  hasAnswerRevisionWith?: InputMaybe<Array<AnswerRevisionWhereInput>>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AnswerEvidenceWhereInput>;
  or?: InputMaybe<Array<AnswerEvidenceWhereInput>>;
  /** position field predicates */
  position?: InputMaybe<Scalars['Int']['input']>;
  positionGT?: InputMaybe<Scalars['Int']['input']>;
  positionGTE?: InputMaybe<Scalars['Int']['input']>;
  positionLT?: InputMaybe<Scalars['Int']['input']>;
  positionLTE?: InputMaybe<Scalars['Int']['input']>;
  positionNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Ordering options for Answer connections */
export type AnswerOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Answers. */
  field: AnswerOrderField;
};

/** Properties by which Answer connections can be ordered. */
export enum AnswerOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type AnswerRevision = Node & {
  __typename?: 'AnswerRevision';
  /** The answer whose history contains this revision */
  answer: Answer;
  answerTree?: Maybe<FormAnswerTree>;
  /** The categorical confidence for an AI revision */
  confidence?: Maybe<AnswerRevisionConfidence>;
  createdAt: Scalars['Time']['output'];
  /** The initiating user when one is associated with the revision */
  createdBy?: Maybe<User>;
  /** The complete ordered evidence set for this exact revision */
  evidence?: Maybe<Array<AnswerEvidence>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Whether the agent or a user authored this revision */
  origin: AnswerRevisionOrigin;
  /** CMK-encrypted concise reasoning for an AI revision */
  reasoning?: Maybe<Scalars['String']['output']>;
  /** Later revisions that copy this revision as an audited revert */
  restoredAsRevisions?: Maybe<Array<AnswerRevision>>;
  /** The earlier revision copied by an audited user revert */
  restoredFromRevision?: Maybe<AnswerRevision>;
  /** The monotonic revision number within one answer */
  revisionNumber: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  /** The decrypted JSON answer. Null means unanswered. */
  value?: Maybe<Scalars['JSON']['output']>;
  /** The extraction run that produced this AI revision */
  workflowTracker?: Maybe<WorkflowTracker>;
};

/** AnswerRevisionConfidence is enum for the field confidence */
export enum AnswerRevisionConfidence {
  High = 'HIGH',
  Medium = 'MEDIUM',
  NotFound = 'NOT_FOUND'
}

/** Ordering options for AnswerRevision connections */
export type AnswerRevisionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AnswerRevisions. */
  field: AnswerRevisionOrderField;
};

/** Properties by which AnswerRevision connections can be ordered. */
export enum AnswerRevisionOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** AnswerRevisionOrigin is enum for the field origin */
export enum AnswerRevisionOrigin {
  Ai = 'AI',
  User = 'USER'
}

/**
 * AnswerRevisionWhereInput is used for filtering AnswerRevision objects.
 * Input was generated by ent.
 */
export type AnswerRevisionWhereInput = {
  and?: InputMaybe<Array<AnswerRevisionWhereInput>>;
  /** confidence field predicates */
  confidence?: InputMaybe<AnswerRevisionConfidence>;
  confidenceIn?: InputMaybe<Array<AnswerRevisionConfidence>>;
  confidenceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  confidenceNEQ?: InputMaybe<AnswerRevisionConfidence>;
  confidenceNotIn?: InputMaybe<Array<AnswerRevisionConfidence>>;
  confidenceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** answer edge predicates */
  hasAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  hasAnswerWith?: InputMaybe<Array<AnswerWhereInput>>;
  /** created_by edge predicates */
  hasCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** evidence edge predicates */
  hasEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  hasEvidenceWith?: InputMaybe<Array<AnswerEvidenceWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** restored_as_revisions edge predicates */
  hasRestoredAsRevisions?: InputMaybe<Scalars['Boolean']['input']>;
  hasRestoredAsRevisionsWith?: InputMaybe<Array<AnswerRevisionWhereInput>>;
  /** restored_from_revision edge predicates */
  hasRestoredFromRevision?: InputMaybe<Scalars['Boolean']['input']>;
  hasRestoredFromRevisionWith?: InputMaybe<Array<AnswerRevisionWhereInput>>;
  /** workflow_tracker edge predicates */
  hasWorkflowTracker?: InputMaybe<Scalars['Boolean']['input']>;
  hasWorkflowTrackerWith?: InputMaybe<Array<WorkflowTrackerWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AnswerRevisionWhereInput>;
  or?: InputMaybe<Array<AnswerRevisionWhereInput>>;
  /** origin field predicates */
  origin?: InputMaybe<AnswerRevisionOrigin>;
  originIn?: InputMaybe<Array<AnswerRevisionOrigin>>;
  originNEQ?: InputMaybe<AnswerRevisionOrigin>;
  originNotIn?: InputMaybe<Array<AnswerRevisionOrigin>>;
  /** revision_number field predicates */
  revisionNumber?: InputMaybe<Scalars['Int']['input']>;
  revisionNumberGT?: InputMaybe<Scalars['Int']['input']>;
  revisionNumberGTE?: InputMaybe<Scalars['Int']['input']>;
  revisionNumberLT?: InputMaybe<Scalars['Int']['input']>;
  revisionNumberLTE?: InputMaybe<Scalars['Int']['input']>;
  revisionNumberNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * AnswerWhereInput is used for filtering Answer objects.
 * Input was generated by ent.
 */
export type AnswerWhereInput = {
  and?: InputMaybe<Array<AnswerWhereInput>>;
  /** confirmed_at field predicates */
  confirmedAt?: InputMaybe<Scalars['Time']['input']>;
  confirmedAtGT?: InputMaybe<Scalars['Time']['input']>;
  confirmedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  confirmedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedAtLT?: InputMaybe<Scalars['Time']['input']>;
  confirmedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  confirmedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** field_id field predicates */
  fieldID?: InputMaybe<Scalars['String']['input']>;
  /** confirmed_by edge predicates */
  hasConfirmedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasConfirmedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** confirmed_revision edge predicates */
  hasConfirmedRevision?: InputMaybe<Scalars['Boolean']['input']>;
  hasConfirmedRevisionWith?: InputMaybe<Array<AnswerRevisionWhereInput>>;
  /** current_revision edge predicates */
  hasCurrentRevision?: InputMaybe<Scalars['Boolean']['input']>;
  hasCurrentRevisionWith?: InputMaybe<Array<AnswerRevisionWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** revisions edge predicates */
  hasRevisions?: InputMaybe<Scalars['Boolean']['input']>;
  hasRevisionsWith?: InputMaybe<Array<AnswerRevisionWhereInput>>;
  /** submission edge predicates */
  hasSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubmissionWith?: InputMaybe<Array<SubmissionWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** lock_version field predicates */
  lockVersion?: InputMaybe<Scalars['Int']['input']>;
  lockVersionGT?: InputMaybe<Scalars['Int']['input']>;
  lockVersionGTE?: InputMaybe<Scalars['Int']['input']>;
  lockVersionLT?: InputMaybe<Scalars['Int']['input']>;
  lockVersionLTE?: InputMaybe<Scalars['Int']['input']>;
  lockVersionNEQ?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<AnswerWhereInput>;
  or?: InputMaybe<Array<AnswerWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * ApplicationAuthorization is a summarization of the current user's level of access that governs how the application
 * should behave.
 */
export type ApplicationAuthorization = {
  __typename?: 'ApplicationAuthorization';
  /** auditLogs describes the user's ability to view audit logs on the platform. */
  auditLogs: AuthorizationLevel;
  /** branding describes the user's ability to update the branding of the tenant */
  branding: AuthorizationLevel;
  /** canAccessTenantReporting describes the user's ability to access tenant-level reports. */
  canAccessTenantReporting: Scalars['Boolean']['output'];
  canActAsRelationshipOwner: Scalars['Boolean']['output'];
  /**
   * canApproveLuminarySupportTeamAccess describes the user's ability to configure Luminary support access policy for the tenant.
   * Only meaningful when luminaryAccessControlEnabled is true on TenantSecurityConfiguration.
   */
  canApproveLuminarySupportTeamAccess: Scalars['Boolean']['output'];
  /**
   * canApprovePresentations is true when the user can approve presentations in
   * the tenant: the user has the presentation approver capability or is a
   * Luminary admin. Approval of one presentation also needs update access to it;
   * use viewerCanApprove on the presentation for that check.
   */
  canApprovePresentations: Scalars['Boolean']['output'];
  /** Whether the user's roles allow dispositive provision editing. Household access is checked separately. */
  canEditDispositiveProvisions: Scalars['Boolean']['output'];
  /** Whether the user's roles allow waterfall editing. Household access is checked separately. */
  canEditEstateWaterfall: Scalars['Boolean']['output'];
  /**
   * True when the user can manage organization legal disclaimers. For ordinary
   * users, the current tenant must be the organization parent.
   */
  canManageOrganizationDisclaimers: Scalars['Boolean']['output'];
  /** True when the user can manage the current tenant's managed SFTP connection. */
  canManageSFTP: Scalars['Boolean']['output'];
  /**
   *  canModifyGlobalCategories describes the user's ability to modify the global categories on the platform, e.g. by adding, removing
   * or reordering asset classes, associated integration asset classes, and balance sheet categories
   */
  canModifyGlobalCategories: Scalars['Boolean']['output'];
  /** canModifyPrompts describes the user's ability to modify prompts on the platform */
  canModifyPrompts: Scalars['Boolean']['output'];
  /** Whether the user's roles allow waterfall presentation. Waterfall editors also have this capability. */
  canPresentEstateWaterfall: Scalars['Boolean']['output'];
  /**
   * collaborators describes the user's ability to add, edit, and delete the list of collaborators on the platform or modify
   * the collaborators' association with households that the user has access to.
   */
  collaborators: AuthorizationLevel;
  hasAllClientsAccess: Scalars['Boolean']['output'];
  /** households describes the user's ability to add, edit, and delete households on the platform. */
  households: AuthorizationLevel;
  /**
   * internalEmployees describes the user's ability to exhaustively list and/or modify the employees on the tenant via
   * user management interface. It doesn't relate to their ability to e.g. view a list of assignees.
   */
  internalEmployees: AuthorizationLevel;
  /** roles describes the user's ability to add, edit, and delete roles on the platform */
  roles: AuthorizationLevel;
  /** tenantPresentationTemplates describes the user's ability to manage presentation templates at the tenant level. */
  tenantPresentationTemplates: AuthorizationLevel;
  userKind: UserKind;
};

/** Final state of one created or updated manual asset. */
export type ApplicationRecordAsset = {
  __typename?: 'ApplicationRecordAsset';
  assetClass: Scalars['String']['output'];
  name: Scalars['String']['output'];
  owningEntity: ApplicationRecordReference;
  /** Owned value at preview creation. Null means not set. */
  previousValueUSD?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** True when the preview changes the value, including setting or clearing it. */
  valueChanged: Scalars['Boolean']['output'];
  valueUSD?: Maybe<Scalars['CurrencyUSD']['output']>;
};

/** Final state of one affected beneficiary-designation account tier. */
export type ApplicationRecordBeneficiaryDesignationProvisionGroup = {
  __typename?: 'ApplicationRecordBeneficiaryDesignationProvisionGroup';
  account: ApplicationRecordReference;
  provisions: Array<ApplicationRecordProvision>;
  tier: BeneficiaryDesignationTier;
};

/** Records affected by an application-record plan. */
export type ApplicationRecordChanges = {
  __typename?: 'ApplicationRecordChanges';
  assets: Array<ApplicationRecordAsset>;
  beneficiaryDesignationGroups: Array<ApplicationRecordBeneficiaryDesignationProvisionGroup>;
  /** @deprecated Use dispositionScenarioGroups instead */
  deletedDispositiveProvisions: Array<ApplicationRecordDispositiveProvision>;
  dispositionScenarioGroups: Array<ApplicationRecordDispositionScenarioProvisionGroup>;
  /** @deprecated Use dispositionScenarioGroups instead */
  dispositiveProvisions: Array<ApplicationRecordDispositiveProvision>;
  entities: Array<ApplicationRecordEntity>;
  liabilities: Array<ApplicationRecordLiability>;
  lifeInsurancePolicies: Array<ApplicationRecordLifeInsurancePolicy>;
  organizations: Array<ApplicationRecordOrganization>;
  people: Array<ApplicationRecordPerson>;
  testamentaryEntities: Array<ApplicationRecordTestamentaryEntity>;
};

/** Final state of one affected scenario death-event bucket. */
export type ApplicationRecordDispositionScenarioProvisionGroup = {
  __typename?: 'ApplicationRecordDispositionScenarioProvisionGroup';
  deathEvent: AiSuggestionDispositiveProvisionDeathEvent;
  firstDeathClient: ApplicationRecordReference;
  fundedFrom: ApplicationRecordReference;
  provisions: Array<ApplicationRecordProvision>;
};

/** Legacy final state of one scenario provision. */
export type ApplicationRecordDispositiveProvision = {
  __typename?: 'ApplicationRecordDispositiveProvision';
  bearsTax: Scalars['Boolean']['output'];
  deathEvent: AiSuggestionDispositiveProvisionDeathEvent;
  dispositionOrder: Scalars['Int']['output'];
  firstDeathClient: ApplicationRecordReference;
  fundedFrom: ApplicationRecordReference;
  notes?: Maybe<Scalars['String']['output']>;
  recipient: ApplicationRecordProvisionRecipient;
  share: ApplicationRecordProvisionShare;
  transferMethod: TransferMethod;
  transferTaxKind: DispositiveProvisionTransferTaxKind;
};

/** A living entity to create or an existing holding group to activate. */
export type ApplicationRecordEntity = {
  __typename?: 'ApplicationRecordEntity';
  accountOwners: Array<ApplicationRecordReference>;
  donors: Array<ApplicationRecordReference>;
  grantors: Array<ApplicationRecordReference>;
  inEstate?: Maybe<Scalars['Boolean']['output']>;
  /** True when activating an existing group without changing its contents; false for creation, including older confirmations. */
  isActivation: Scalars['Boolean']['output'];
  kind: EntityKind;
  name: Scalars['String']['output'];
  ownershipStakes: Array<ApplicationRecordOwnershipStake>;
};

/** Final state of one created or updated liability. */
export type ApplicationRecordLiability = {
  __typename?: 'ApplicationRecordLiability';
  amountAsOfDate?: Maybe<Scalars['String']['output']>;
  borrower: ApplicationRecordReference;
  currentAmountUSD?: Maybe<Scalars['CurrencyUSD']['output']>;
  lender?: Maybe<ApplicationRecordReference>;
  name: Scalars['String']['output'];
};

/** Final state of one created or updated life-insurance policy. */
export type ApplicationRecordLifeInsurancePolicy = {
  __typename?: 'ApplicationRecordLifeInsurancePolicy';
  carrierName?: Maybe<Scalars['String']['output']>;
  cashValueUSD?: Maybe<Scalars['CurrencyUSD']['output']>;
  deathBenefitUSD: Scalars['CurrencyUSD']['output'];
  insuredPeople: Array<ApplicationRecordReference>;
  kind: InsurancePolicyKind;
  owningEntity: ApplicationRecordReference;
  startDate?: Maybe<Scalars['String']['output']>;
  survivorship: Scalars['Boolean']['output'];
  termDurationYears?: Maybe<Scalars['Int']['output']>;
};

/** Final state of one created or updated client organization. */
export type ApplicationRecordOrganization = {
  __typename?: 'ApplicationRecordOrganization';
  kind?: Maybe<ClientOrganizationKind>;
  name: Scalars['String']['output'];
};

/** One person's or entity's final ownership share. */
export type ApplicationRecordOwnershipStake = {
  __typename?: 'ApplicationRecordOwnershipStake';
  owner: ApplicationRecordReference;
  percentage: Scalars['Percent']['output'];
};

/** Final state of one created or updated person. */
export type ApplicationRecordPerson = {
  __typename?: 'ApplicationRecordPerson';
  isPrimary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  relationships: Array<ApplicationRecordPersonRelationship>;
};

/** How one person relates to another person. */
export type ApplicationRecordPersonRelationship = {
  __typename?: 'ApplicationRecordPersonRelationship';
  person: ApplicationRecordReference;
  relationship: ClientProfileRelationshipType;
};

/** Complete state of one provision in an affected group. */
export type ApplicationRecordProvision = {
  __typename?: 'ApplicationRecordProvision';
  bearsTax: Scalars['Boolean']['output'];
  dispositionOrder: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  recipient: ApplicationRecordProvisionRecipient;
  share: ApplicationRecordProvisionShare;
  transferMethod: TransferMethod;
  transferTaxKind: DispositiveProvisionTransferTaxKind;
};

/** A fixed provision recipient or the special surviving-spouse recipient. */
export type ApplicationRecordProvisionRecipient = {
  __typename?: 'ApplicationRecordProvisionRecipient';
  kind: DispositiveProvisionRecipientKind;
  record?: Maybe<ApplicationRecordReference>;
};

/** The structured economics of one dispositive provision. */
export type ApplicationRecordProvisionShare = {
  __typename?: 'ApplicationRecordProvisionShare';
  amountUSD?: Maybe<Scalars['CurrencyUSD']['output']>;
  formulaicPercentage?: Maybe<Scalars['Percent']['output']>;
  growByInflation: Scalars['Boolean']['output'];
  kind: DispositiveProvisionDispositionKind;
  limitUSD?: Maybe<Scalars['CurrencyUSD']['output']>;
  percentage?: Maybe<Scalars['Percent']['output']>;
};

/** Another record referenced by its display name. */
export type ApplicationRecordReference = {
  __typename?: 'ApplicationRecordReference';
  displayName: Scalars['String']['output'];
};

/** Final state of one created testamentary entity. */
export type ApplicationRecordTestamentaryEntity = {
  __typename?: 'ApplicationRecordTestamentaryEntity';
  accountOwner?: Maybe<ApplicationRecordReference>;
  createdFromEntities: Array<ApplicationRecordReference>;
  inEstate: Scalars['Boolean']['output'];
  kind: TestamentaryEntityKind;
  name: Scalars['String']['output'];
};

/** A nonblocking risk associated with proposed application-record changes. */
export type ApplicationRecordWarning = {
  __typename?: 'ApplicationRecordWarning';
  message: Scalars['String']['output'];
};

export type Approval = Node & {
  __typename?: 'Approval';
  createdAt: Scalars['Time']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  kind: ApprovalKind;
  /** The target node ID, including a presentation ID; no foreign key because targets can have different types. */
  nodeID: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

/** ApprovalKind is enum for the field kind */
export enum ApprovalKind {
  PresentationApproved = 'PRESENTATION_APPROVED',
  PresentationAttested = 'PRESENTATION_ATTESTED'
}

/** Ordering options for Approval connections */
export type ApprovalOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Approvals. */
  field: ApprovalOrderField;
};

/** Properties by which Approval connections can be ordered. */
export enum ApprovalOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * ApprovalWhereInput is used for filtering Approval objects.
 * Input was generated by ent.
 */
export type ApprovalWhereInput = {
  and?: InputMaybe<Array<ApprovalWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<ApprovalKind>;
  kindIn?: InputMaybe<Array<ApprovalKind>>;
  kindNEQ?: InputMaybe<ApprovalKind>;
  kindNotIn?: InputMaybe<Array<ApprovalKind>>;
  /** node_id field predicates */
  nodeID?: InputMaybe<Scalars['ID']['input']>;
  nodeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  nodeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  nodeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ApprovalWhereInput>;
  or?: InputMaybe<Array<ApprovalWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ArchiveFormSubmissionInput = {
  id: Scalars['ID']['input'];
};

/**
 * Input for asking a question about a document.
 * If conversationID is null, a new conversation will be created with an initial system prompt.
 * If conversationID is provided, the message will be added to the existing conversation as the newest message.
 * The message is always treated as coming from the user (role: "user").
 */
export type AskDocumentQuestionInput = {
  /**
   * Optional conversation ID. If null, creates a new conversation.
   * If provided, adds the message to the existing conversation.
   */
  conversationID?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the document being discussed. */
  documentId: Scalars['ID']['input'];
  /**
   * The user's message to add to the conversation.
   * For new conversations, this is typically the user's first question.
   * For existing conversations, this is the next message in the thread.
   * The role is always "user" for this message.
   */
  message: Scalars['String']['input'];
};

/** Final result of an askDocumentQuestion streaming request. */
export type AskDocumentQuestionResult = {
  __typename?: 'AskDocumentQuestionResult';
  /** The complete answer text. */
  answer: Scalars['String']['output'];
  /** Additional non-document citation sources used to ground the answer. */
  citationSources: Array<Scalars['String']['output']>;
  /** The conversation that was created or updated. */
  conversation: Conversation;
  /** IDs of paragraphs that support the answer, used for citations. */
  supportingParagraphIds: Array<Scalars['ID']['output']>;
};

/**
 * Streaming event for askDocumentQuestionStreaming subscription.
 * Either textDelta or result will be set, but not both.
 */
export type AskDocumentQuestionStreamEvent = {
  __typename?: 'AskDocumentQuestionStreamEvent';
  /**
   * Final result sent once streaming is complete. Contains the full answer,
   * supporting paragraph IDs for citations, and the updated conversation.
   */
  result?: Maybe<AskDocumentQuestionResult>;
  /**
   * Text chunk sent during streaming. Multiple events with textDelta will be sent
   * as the response is generated.
   */
  textDelta?: Maybe<Scalars['String']['output']>;
};

export enum AssetCategoryGroup {
  CashAndCashEquivalents = 'CASH_AND_CASH_EQUIVALENTS',
  PrivateAsset = 'PRIVATE_ASSET',
  PublicAsset = 'PUBLIC_ASSET',
  UnknownAssetCategory = 'UNKNOWN_ASSET_CATEGORY'
}

export type AssetClass = Node & {
  __typename?: 'AssetClass';
  balanceSheetCategory?: Maybe<BalanceSheetCategory>;
  createdAt: Scalars['Time']['output'];
  displayName: Scalars['String']['output'];
  /** The defined growth rate for the asset class */
  growthRate?: Maybe<Scalars['Percent']['output']>;
  id: Scalars['ID']['output'];
  integrationAssetClasses: IntegrationAssetClassConnection;
  /** Whether this class is considered real or tangible personal property */
  isRealTpp: Scalars['Boolean']['output'];
  /** Whether this is a system class that cannot be deleted, renamed, or have liquidity status changed */
  isSystemClass: Scalars['Boolean']['output'];
  liquidityStatus: AssetClassLiquidityStatus;
  /** The order in which this asset class should be displayed in the UI */
  sortOrder: Scalars['Int']['output'];
  /** The share of annual return paid as income tax when a growth profile uses asset-category defaults */
  taxDragRate: Scalars['Percent']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type AssetClassIntegrationAssetClassesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IntegrationAssetClassOrder>>;
  where?: InputMaybe<IntegrationAssetClassWhereInput>;
};

/** A connection to a list of items. */
export type AssetClassConnection = {
  __typename?: 'AssetClassConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AssetClassEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssetClassEdge = {
  __typename?: 'AssetClassEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AssetClass>;
};

/** AssetClassLiquidityStatus is enum for the field liquidity_status */
export enum AssetClassLiquidityStatus {
  Illiquid = 'ILLIQUID',
  Liquid = 'LIQUID'
}

/** Ordering options for AssetClass connections */
export type AssetClassOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AssetClasses. */
  field: AssetClassOrderField;
};

/** Properties by which AssetClass connections can be ordered. */
export enum AssetClassOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * AssetClassWhereInput is used for filtering AssetClass objects.
 * Input was generated by ent.
 */
export type AssetClassWhereInput = {
  and?: InputMaybe<Array<AssetClassWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** growth_rate field predicates */
  growthRate?: InputMaybe<Scalars['Percent']['input']>;
  growthRateGT?: InputMaybe<Scalars['Percent']['input']>;
  growthRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  growthRateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  growthRateLT?: InputMaybe<Scalars['Percent']['input']>;
  growthRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  growthRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  growthRateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** balance_sheet_category edge predicates */
  hasBalanceSheetCategory?: InputMaybe<Scalars['Boolean']['input']>;
  hasBalanceSheetCategoryWith?: InputMaybe<Array<BalanceSheetCategoryWhereInput>>;
  /** integration_asset_classes edge predicates */
  hasIntegrationAssetClasses?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntegrationAssetClassesWith?: InputMaybe<Array<IntegrationAssetClassWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_real_tpp field predicates */
  isRealTpp?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_system_class field predicates */
  isSystemClass?: InputMaybe<Scalars['Boolean']['input']>;
  /** liquidity_status field predicates */
  liquidityStatus?: InputMaybe<AssetClassLiquidityStatus>;
  liquidityStatusIn?: InputMaybe<Array<AssetClassLiquidityStatus>>;
  liquidityStatusNEQ?: InputMaybe<AssetClassLiquidityStatus>;
  liquidityStatusNotIn?: InputMaybe<Array<AssetClassLiquidityStatus>>;
  not?: InputMaybe<AssetClassWhereInput>;
  or?: InputMaybe<Array<AssetClassWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tax_drag_rate field predicates */
  taxDragRate?: InputMaybe<Scalars['Percent']['input']>;
  taxDragRateGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragRateLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type AssetGroup = Node & {
  __typename?: 'AssetGroup';
  assets?: Maybe<Array<AssetStatic>>;
  children?: Maybe<Array<AssetGroup>>;
  createdAt: Scalars['Time']['output'];
  /** The dispositive provisions that distribute this asset group. */
  dispositiveProvisions?: Maybe<Array<DispositiveProvision>>;
  entity: Entity;
  entityID: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  integrationID?: Maybe<Scalars['String']['output']>;
  integrationKind?: Maybe<IntegrationExternalKind>;
  name: Scalars['String']['output'];
  parent?: Maybe<AssetGroup>;
  parentID?: Maybe<Scalars['ID']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type AssetGroupConnection = {
  __typename?: 'AssetGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AssetGroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssetGroupEdge = {
  __typename?: 'AssetGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AssetGroup>;
};

/** Ordering options for AssetGroup connections */
export type AssetGroupOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AssetGroups. */
  field: AssetGroupOrderField;
};

/** Properties by which AssetGroup connections can be ordered. */
export enum AssetGroupOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * AssetGroupWhereInput is used for filtering AssetGroup objects.
 * Input was generated by ent.
 */
export type AssetGroupWhereInput = {
  and?: InputMaybe<Array<AssetGroupWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** entity_id field predicates */
  entityID?: InputMaybe<Scalars['ID']['input']>;
  entityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  entityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** assets edge predicates */
  hasAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetsWith?: InputMaybe<Array<AssetStaticWhereInput>>;
  /** children edge predicates */
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildrenWith?: InputMaybe<Array<AssetGroupWhereInput>>;
  /** dispositive_provisions edge predicates */
  hasDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositiveProvisionsWith?: InputMaybe<Array<DispositiveProvisionWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** parent edge predicates */
  hasParent?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentWith?: InputMaybe<Array<AssetGroupWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integration_id field predicates */
  integrationID?: InputMaybe<Scalars['String']['input']>;
  integrationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  integrationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** integration_kind field predicates */
  integrationKind?: InputMaybe<IntegrationExternalKind>;
  integrationKindIn?: InputMaybe<Array<IntegrationExternalKind>>;
  integrationKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  integrationKindNEQ?: InputMaybe<IntegrationExternalKind>;
  integrationKindNotIn?: InputMaybe<Array<IntegrationExternalKind>>;
  integrationKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<AssetGroupWhereInput>;
  or?: InputMaybe<Array<AssetGroupWhereInput>>;
  /** parent_id field predicates */
  parentID?: InputMaybe<Scalars['ID']['input']>;
  parentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type AssetStatic = Node & {
  __typename?: 'AssetStatic';
  assets?: Maybe<Array<AssetV2>>;
  createdAt: Scalars['Time']['output'];
  /**
   * The value of this asset in its owning entity's current valuation
   * (most recent non-deleted valuation whose effective_date is <= NOW).
   * Null if no valuation matches or the static is not referenced by
   * any asset in the current valuation.
   *
   * Pairs with `Entity.currentHoldings.assets` and
   * `Household.entityHoldings`: when the caller has already fetched a
   * set of statics for an entity, this lets them fetch the
   * corresponding per-snapshot dollar figure for each in the same
   * round-trip.
   */
  currentValue?: Maybe<AssetValueV2>;
  /** The dispositive provisions that distribute this asset static. */
  dispositiveProvisions?: Maybe<Array<DispositiveProvision>>;
  entity: Entity;
  entityID: Scalars['ID']['output'];
  groups?: Maybe<Array<AssetGroup>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  integrationID?: Maybe<Scalars['String']['output']>;
  integrationKind?: Maybe<IntegrationExternalKind>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** The grantor whose residency determines this asset's tax situs when tax_situs_kind is GRANTOR_RESIDENCY. */
  taxSitusGrantor?: Maybe<ClientProfile>;
  taxSitusKind?: Maybe<AssetTaxSitusKind>;
  taxSitusStateCode?: Maybe<StateCode>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type AssetStaticConnection = {
  __typename?: 'AssetStaticConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AssetStaticEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssetStaticEdge = {
  __typename?: 'AssetStaticEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AssetStatic>;
};

/** Ordering options for AssetStatic connections */
export type AssetStaticOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AssetStatics. */
  field: AssetStaticOrderField;
};

/** Properties by which AssetStatic connections can be ordered. */
export enum AssetStaticOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * AssetStaticWhereInput is used for filtering AssetStatic objects.
 * Input was generated by ent.
 */
export type AssetStaticWhereInput = {
  and?: InputMaybe<Array<AssetStaticWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** entity_id field predicates */
  entityID?: InputMaybe<Scalars['ID']['input']>;
  entityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  entityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** assets edge predicates */
  hasAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetsWith?: InputMaybe<Array<AssetV2WhereInput>>;
  /** dispositive_provisions edge predicates */
  hasDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositiveProvisionsWith?: InputMaybe<Array<DispositiveProvisionWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** groups edge predicates */
  hasGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasGroupsWith?: InputMaybe<Array<AssetGroupWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** tax_situs_grantor edge predicates */
  hasTaxSitusGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaxSitusGrantorWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integration_id field predicates */
  integrationID?: InputMaybe<Scalars['String']['input']>;
  integrationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  integrationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** integration_kind field predicates */
  integrationKind?: InputMaybe<IntegrationExternalKind>;
  integrationKindIn?: InputMaybe<Array<IntegrationExternalKind>>;
  integrationKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  integrationKindNEQ?: InputMaybe<IntegrationExternalKind>;
  integrationKindNotIn?: InputMaybe<Array<IntegrationExternalKind>>;
  integrationKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<AssetStaticWhereInput>;
  or?: InputMaybe<Array<AssetStaticWhereInput>>;
  /** tax_situs_kind field predicates */
  taxSitusKind?: InputMaybe<AssetTaxSitusKind>;
  taxSitusKindIn?: InputMaybe<Array<AssetTaxSitusKind>>;
  taxSitusKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxSitusKindNEQ?: InputMaybe<AssetTaxSitusKind>;
  taxSitusKindNotIn?: InputMaybe<Array<AssetTaxSitusKind>>;
  taxSitusKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_situs_state_code field predicates */
  taxSitusStateCode?: InputMaybe<StateCode>;
  taxSitusStateCodeIn?: InputMaybe<Array<StateCode>>;
  taxSitusStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxSitusStateCodeNEQ?: InputMaybe<StateCode>;
  taxSitusStateCodeNotIn?: InputMaybe<Array<StateCode>>;
  taxSitusStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type AssetSuggestion = {
  __typename?: 'AssetSuggestion';
  assetCategoryID?: Maybe<Scalars['String']['output']>;
  assetTitle?: Maybe<Scalars['String']['output']>;
  assetValue?: Maybe<Scalars['String']['output']>;
  nodeID?: Maybe<Scalars['ID']['output']>;
  owningEntityID?: Maybe<Scalars['ID']['output']>;
  owningEntityName?: Maybe<Scalars['String']['output']>;
};

export type AssetSuggestionInput = {
  assetCategoryID?: InputMaybe<Scalars['String']['input']>;
  assetTitle?: InputMaybe<Scalars['String']['input']>;
  assetValue?: InputMaybe<Scalars['String']['input']>;
  nodeID?: InputMaybe<Scalars['ID']['input']>;
  owningEntityID?: InputMaybe<Scalars['ID']['input']>;
  owningEntityName?: InputMaybe<Scalars['String']['input']>;
};

/** AssetTaxSitusKind is enum for the field tax_situs_kind */
export enum AssetTaxSitusKind {
  FixedState = 'FIXED_STATE',
  GrantorResidency = 'GRANTOR_RESIDENCY'
}

export type AssetV2 = Node & {
  __typename?: 'AssetV2';
  /** The name of the account that this asset is part of. */
  accountName?: Maybe<Scalars['String']['output']>;
  assetStatic?: Maybe<AssetStatic>;
  assetStaticID?: Maybe<Scalars['ID']['output']>;
  assetValue?: Maybe<AssetValueV2>;
  class: AssetClass;
  createdAt: Scalars['Time']['output'];
  displayName: Scalars['String']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The entity ID of the integrated account that this asset is part of. */
  integratedAccountID?: Maybe<Scalars['Int']['output']>;
  /** The integration this asset was ingested as part of. */
  integrationType?: Maybe<AssetV2IntegrationType>;
  kgV2Nodes: Kgv2NodeConnection;
  ownedValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  qsbsEligibility: AssetV2QsbsEligibility;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  valuation?: Maybe<AssetValuationV2>;
};


export type AssetV2KgV2NodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2NodeOrder>>;
  where?: InputMaybe<Kgv2NodeWhereInput>;
};

/** A connection to a list of items. */
export type AssetV2Connection = {
  __typename?: 'AssetV2Connection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AssetV2Edge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssetV2Edge = {
  __typename?: 'AssetV2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AssetV2>;
};

/** AssetV2IntegrationType is enum for the field integration_type */
export enum AssetV2IntegrationType {
  Addepar = 'ADDEPAR',
  BlackDiamond = 'BLACK_DIAMOND',
  Emoney = 'EMONEY',
  Orion = 'ORION',
  Snowflake = 'SNOWFLAKE'
}

/** Ordering options for AssetV2 connections */
export type AssetV2Order = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AssetV2s. */
  field: AssetV2OrderField;
};

/** Properties by which AssetV2 connections can be ordered. */
export enum AssetV2OrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** AssetV2QsbsEligibility is enum for the field qsbs_eligibility */
export enum AssetV2QsbsEligibility {
  No = 'NO',
  NotConfirmed = 'NOT_CONFIRMED',
  Yes = 'YES'
}

/**
 * AssetV2WhereInput is used for filtering AssetV2 objects.
 * Input was generated by ent.
 */
export type AssetV2WhereInput = {
  /** account_name field predicates */
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  accountNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<AssetV2WhereInput>>;
  /** asset_static_id field predicates */
  assetStaticID?: InputMaybe<Scalars['ID']['input']>;
  assetStaticIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetStaticIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assetStaticIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assetStaticIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetStaticIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** asset_static edge predicates */
  hasAssetStatic?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetStaticWith?: InputMaybe<Array<AssetStaticWhereInput>>;
  /** asset_value edge predicates */
  hasAssetValue?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetValueWith?: InputMaybe<Array<AssetValueV2WhereInput>>;
  /** class edge predicates */
  hasClass?: InputMaybe<Scalars['Boolean']['input']>;
  hasClassWith?: InputMaybe<Array<AssetClassWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** kg_v2_nodes edge predicates */
  hasKgV2Nodes?: InputMaybe<Scalars['Boolean']['input']>;
  hasKgV2NodesWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** valuation edge predicates */
  hasValuation?: InputMaybe<Scalars['Boolean']['input']>;
  hasValuationWith?: InputMaybe<Array<AssetValuationV2WhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integrated_account_id field predicates */
  integratedAccountID?: InputMaybe<Scalars['Int']['input']>;
  integratedAccountIDGT?: InputMaybe<Scalars['Int']['input']>;
  integratedAccountIDGTE?: InputMaybe<Scalars['Int']['input']>;
  integratedAccountIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  integratedAccountIDLT?: InputMaybe<Scalars['Int']['input']>;
  integratedAccountIDLTE?: InputMaybe<Scalars['Int']['input']>;
  integratedAccountIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  integratedAccountIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** integration_type field predicates */
  integrationType?: InputMaybe<AssetV2IntegrationType>;
  integrationTypeIn?: InputMaybe<Array<AssetV2IntegrationType>>;
  integrationTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  integrationTypeNEQ?: InputMaybe<AssetV2IntegrationType>;
  integrationTypeNotIn?: InputMaybe<Array<AssetV2IntegrationType>>;
  integrationTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<AssetV2WhereInput>;
  or?: InputMaybe<Array<AssetV2WhereInput>>;
  /** owned_value field predicates */
  ownedValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ownedValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ownedValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ownedValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownedValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ownedValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ownedValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ownedValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** qsbs_eligibility field predicates */
  qsbsEligibility?: InputMaybe<AssetV2QsbsEligibility>;
  qsbsEligibilityIn?: InputMaybe<Array<AssetV2QsbsEligibility>>;
  qsbsEligibilityNEQ?: InputMaybe<AssetV2QsbsEligibility>;
  qsbsEligibilityNotIn?: InputMaybe<Array<AssetV2QsbsEligibility>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type AssetValuationV2 = Node & {
  __typename?: 'AssetValuationV2';
  account?: Maybe<Account>;
  assets: AssetV2Connection;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Free-form notes */
  description?: Maybe<Scalars['String']['output']>;
  /** documents that might be associated with or support this valuation */
  documents?: Maybe<Array<Document>>;
  effectiveDate: Scalars['Time']['output'];
  /**
   * Valuations can work in two ways.
   * The first is manually specifying all the assets+values for a valuation; we tally them up.
   * The second is by specifying a valuation_amount.
   * If a valuation amount is present, we use this to compute the value of a valuation
   * and ignore the value of underlying assets, etc.
   */
  fixedValuationAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The async job that is processing this valuation. A valuation can only be modified by one job. */
  ingestAsyncJob?: Maybe<AsyncJob>;
  previousValuation?: Maybe<AssetValuationV2>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  valuationReason?: Maybe<AssetValuationV2ValuationReason>;
  valuationSource: AssetValuationV2ValuationSource;
  valuationValue?: Maybe<Scalars['CurrencyUSD']['output']>;
};


export type AssetValuationV2AssetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssetV2Order>>;
  where?: InputMaybe<AssetV2WhereInput>;
};

/** A connection to a list of items. */
export type AssetValuationV2Connection = {
  __typename?: 'AssetValuationV2Connection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AssetValuationV2Edge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssetValuationV2Edge = {
  __typename?: 'AssetValuationV2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AssetValuationV2>;
};

/** Ordering options for AssetValuationV2 connections */
export type AssetValuationV2Order = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AssetValuationV2s. */
  field: AssetValuationV2OrderField;
};

/** Properties by which AssetValuationV2 connections can be ordered. */
export enum AssetValuationV2OrderField {
  CreatedAt = 'created_at',
  EffectiveDate = 'effective_date',
  UpdatedAt = 'updated_at'
}

/** AssetValuationV2ValuationReason is enum for the field valuation_reason */
export enum AssetValuationV2ValuationReason {
  AssetRevaluation = 'ASSET_REVALUATION',
  GratAnnuityPayment = 'GRAT_ANNUITY_PAYMENT',
  GratAssetSubstitution = 'GRAT_ASSET_SUBSTITUTION',
  GratRemainderDistribution = 'GRAT_REMAINDER_DISTRIBUTION',
  InitialFunding = 'INITIAL_FUNDING'
}

/** AssetValuationV2ValuationSource is enum for the field valuation_source */
export enum AssetValuationV2ValuationSource {
  Addepar = 'ADDEPAR',
  BlackDiamond = 'BLACK_DIAMOND',
  CsvImport = 'CSV_IMPORT',
  Emoney = 'EMONEY',
  Manual = 'MANUAL',
  Orion = 'ORION',
  Snowflake = 'SNOWFLAKE'
}

/**
 * AssetValuationV2WhereInput is used for filtering AssetValuationV2 objects.
 * Input was generated by ent.
 */
export type AssetValuationV2WhereInput = {
  and?: InputMaybe<Array<AssetValuationV2WhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  /** fixed_valuation_amount field predicates */
  fixedValuationAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  fixedValuationAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  fixedValuationAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  fixedValuationAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fixedValuationAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  fixedValuationAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  fixedValuationAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  fixedValuationAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** account edge predicates */
  hasAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** assets edge predicates */
  hasAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetsWith?: InputMaybe<Array<AssetV2WhereInput>>;
  /** documents edge predicates */
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** ingest_async_job edge predicates */
  hasIngestAsyncJob?: InputMaybe<Scalars['Boolean']['input']>;
  hasIngestAsyncJobWith?: InputMaybe<Array<AsyncJobWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AssetValuationV2WhereInput>;
  or?: InputMaybe<Array<AssetValuationV2WhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** valuation_reason field predicates */
  valuationReason?: InputMaybe<AssetValuationV2ValuationReason>;
  valuationReasonIn?: InputMaybe<Array<AssetValuationV2ValuationReason>>;
  valuationReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  valuationReasonNEQ?: InputMaybe<AssetValuationV2ValuationReason>;
  valuationReasonNotIn?: InputMaybe<Array<AssetValuationV2ValuationReason>>;
  valuationReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** valuation_source field predicates */
  valuationSource?: InputMaybe<AssetValuationV2ValuationSource>;
  valuationSourceIn?: InputMaybe<Array<AssetValuationV2ValuationSource>>;
  valuationSourceNEQ?: InputMaybe<AssetValuationV2ValuationSource>;
  valuationSourceNotIn?: InputMaybe<Array<AssetValuationV2ValuationSource>>;
};

export type AssetValueV2 = Node & {
  __typename?: 'AssetValueV2';
  asset?: Maybe<AssetV2>;
  createdAt: Scalars['Time']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  ownedPercent?: Maybe<Scalars['Percent']['output']>;
  ownedValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  ownershipType: AssetValueV2OwnershipType;
  shareCount?: Maybe<Scalars['Decimal']['output']>;
  shareValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  totalValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  updatedAt: Scalars['Time']['output'];
  value: Scalars['CurrencyUSD']['output'];
};

/** Ordering options for AssetValueV2 connections */
export type AssetValueV2Order = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AssetValueV2s. */
  field: AssetValueV2OrderField;
};

/** Properties by which AssetValueV2 connections can be ordered. */
export enum AssetValueV2OrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** AssetValueV2OwnershipType is enum for the field ownership_type */
export enum AssetValueV2OwnershipType {
  PercentBased = 'PERCENT_BASED',
  ShareBased = 'SHARE_BASED',
  ValueBased = 'VALUE_BASED'
}

/**
 * AssetValueV2WhereInput is used for filtering AssetValueV2 objects.
 * Input was generated by ent.
 */
export type AssetValueV2WhereInput = {
  and?: InputMaybe<Array<AssetValueV2WhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** currency field predicates */
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  currencyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset edge predicates */
  hasAsset?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetWith?: InputMaybe<Array<AssetV2WhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AssetValueV2WhereInput>;
  or?: InputMaybe<Array<AssetValueV2WhereInput>>;
  /** owned_percent field predicates */
  ownedPercent?: InputMaybe<Scalars['Percent']['input']>;
  ownedPercentGT?: InputMaybe<Scalars['Percent']['input']>;
  ownedPercentGTE?: InputMaybe<Scalars['Percent']['input']>;
  ownedPercentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownedPercentLT?: InputMaybe<Scalars['Percent']['input']>;
  ownedPercentLTE?: InputMaybe<Scalars['Percent']['input']>;
  ownedPercentNEQ?: InputMaybe<Scalars['Percent']['input']>;
  ownedPercentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** owned_value field predicates */
  ownedValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ownedValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ownedValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ownedValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownedValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ownedValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ownedValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ownedValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ownership_type field predicates */
  ownershipType?: InputMaybe<AssetValueV2OwnershipType>;
  ownershipTypeIn?: InputMaybe<Array<AssetValueV2OwnershipType>>;
  ownershipTypeNEQ?: InputMaybe<AssetValueV2OwnershipType>;
  ownershipTypeNotIn?: InputMaybe<Array<AssetValueV2OwnershipType>>;
  /** share_count field predicates */
  shareCount?: InputMaybe<Scalars['Decimal']['input']>;
  shareCountGT?: InputMaybe<Scalars['Decimal']['input']>;
  shareCountGTE?: InputMaybe<Scalars['Decimal']['input']>;
  shareCountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  shareCountLT?: InputMaybe<Scalars['Decimal']['input']>;
  shareCountLTE?: InputMaybe<Scalars['Decimal']['input']>;
  shareCountNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  shareCountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** share_value field predicates */
  shareValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  shareValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  shareValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  shareValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  shareValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  shareValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  shareValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  shareValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** total_value field predicates */
  totalValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  totalValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  totalValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  totalValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  totalValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  totalValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  totalValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  totalValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type AsyncJob = Node & {
  __typename?: 'AsyncJob';
  /** The AsyncJobs that were spawned by this AsyncJob. Example: AI_DP_BATCHED will spawn AI_DP jobs as children. */
  children?: Maybe<Array<AsyncJob>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  document?: Maybe<Array<Document>>;
  documentQuestion?: Maybe<Array<DocumentQuestion>>;
  entity?: Maybe<Array<Entity>>;
  id: Scalars['ID']['output'];
  jobID?: Maybe<Scalars['String']['output']>;
  kgRoot?: Maybe<Array<KgRoot>>;
  kind: AsyncJobKind;
  /** The parent AsyncJob that spawned this AsyncJob. Example: AI_DP jobs could have AI_DP_BATCHED as parent. */
  parent?: Maybe<AsyncJob>;
  /** This is the id of the parent async job that spawned this async job. */
  parentAsyncJobID?: Maybe<Scalars['ID']['output']>;
  status: AsyncJobStatus;
  testamentaryEntity?: Maybe<Array<TestamentaryEntity>>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type AsyncJobConnection = {
  __typename?: 'AsyncJobConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AsyncJobEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AsyncJobEdge = {
  __typename?: 'AsyncJobEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AsyncJob>;
};

/** AsyncJobKind is enum for the field kind */
export enum AsyncJobKind {
  AiDp = 'AI_DP',
  AiDpBatched = 'AI_DP_BATCHED',
  AiEntityDetailsFromKnowledgeGraph = 'AI_ENTITY_DETAILS_FROM_KNOWLEDGE_GRAPH',
  AiHoldingsAssets = 'AI_HOLDINGS_ASSETS',
  AiHoldingsLiabilities = 'AI_HOLDINGS_LIABILITIES',
  AiHoldingsLifeInsurance = 'AI_HOLDINGS_LIFE_INSURANCE',
  AiOnboarding = 'AI_ONBOARDING',
  AssetIngest = 'ASSET_INGEST',
  ClientAndEntityFetch = 'CLIENT_AND_ENTITY_FETCH',
  DocumentInferenceAiSuggestion = 'DOCUMENT_INFERENCE_AI_SUGGESTION',
  DocumentInferenceCreateEntity = 'DOCUMENT_INFERENCE_CREATE_ENTITY',
  DocumentInferenceDryRun = 'DOCUMENT_INFERENCE_DRY_RUN',
  DocumentInferenceEvaluation = 'DOCUMENT_INFERENCE_EVALUATION',
  DocumentInferenceEvidence = 'DOCUMENT_INFERENCE_EVIDENCE',
  DocumentInferenceGroundTruth = 'DOCUMENT_INFERENCE_GROUND_TRUTH',
  DocumentInferenceMetadata = 'DOCUMENT_INFERENCE_METADATA',
  DocumentInferenceTestPrompt = 'DOCUMENT_INFERENCE_TEST_PROMPT',
  DocumentInferenceUpdateEntity = 'DOCUMENT_INFERENCE_UPDATE_ENTITY',
  DocumentKnowledgeGraph = 'DOCUMENT_KNOWLEDGE_GRAPH',
  DocumentOcrBackfill = 'DOCUMENT_OCR_BACKFILL',
  DocumentQueryResponse = 'DOCUMENT_QUERY_RESPONSE',
  DocumentSummary = 'DOCUMENT_SUMMARY',
  Print = 'PRINT'
}

/** Ordering options for AsyncJob connections */
export type AsyncJobOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AsyncJobs. */
  field: AsyncJobOrderField;
};

/** Properties by which AsyncJob connections can be ordered. */
export enum AsyncJobOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** AsyncJobStatus is enum for the field status */
export enum AsyncJobStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Queued = 'QUEUED'
}

/**
 * AsyncJobWhereInput is used for filtering AsyncJob objects.
 * Input was generated by ent.
 */
export type AsyncJobWhereInput = {
  and?: InputMaybe<Array<AsyncJobWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** children edge predicates */
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildrenWith?: InputMaybe<Array<AsyncJobWhereInput>>;
  /** parent edge predicates */
  hasParent?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentWith?: InputMaybe<Array<AsyncJobWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** job_id field predicates */
  jobID?: InputMaybe<Scalars['String']['input']>;
  jobIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  jobIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<AsyncJobKind>;
  kindIn?: InputMaybe<Array<AsyncJobKind>>;
  kindNEQ?: InputMaybe<AsyncJobKind>;
  kindNotIn?: InputMaybe<Array<AsyncJobKind>>;
  not?: InputMaybe<AsyncJobWhereInput>;
  or?: InputMaybe<Array<AsyncJobWhereInput>>;
  /** parent_async_job_id field predicates */
  parentAsyncJobID?: InputMaybe<Scalars['ID']['input']>;
  parentAsyncJobIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentAsyncJobIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parentAsyncJobIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parentAsyncJobIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentAsyncJobIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<AsyncJobStatus>;
  statusIn?: InputMaybe<Array<AsyncJobStatus>>;
  statusNEQ?: InputMaybe<AsyncJobStatus>;
  statusNotIn?: InputMaybe<Array<AsyncJobStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * AugmentedCreateAISuggestionEvidenceInput is used for create AISuggestionEvidence object.
 * Input was generated by ent.
 */
export type AugmentedCreateAiSuggestionEvidenceInput = {
  create: CreateAiSuggestionEvidenceInput;
};

/**
 * AugmentedCreateAISuggestionInput is used for create AISuggestion object.
 * Input was generated by ent.
 */
export type AugmentedCreateAiSuggestionInput = {
  create: CreateAiSuggestionInput;
};

/**
 * AugmentedCreateAccessAgeParameterInput is used for create AccessAgeParameter object.
 * Input was generated by ent.
 */
export type AugmentedCreateAccessAgeParameterInput = {
  create: CreateAccessAgeParameterInput;
};

/**
 * AugmentedCreateAccessParameterInput is used for create AccessParameter object.
 * Input was generated by ent.
 */
export type AugmentedCreateAccessParameterInput = {
  create: CreateAccessParameterInput;
  withAccessAgeParameters?: InputMaybe<Array<AugmentedCreateAccessAgeParameterInput>>;
};

/**
 * AugmentedCreateAccountInput is used for create Account object.
 * Input was generated by ent.
 */
export type AugmentedCreateAccountInput = {
  create: CreateAccountInput;
  withInitialValuation?: InputMaybe<AugmentedCreateAssetValuationV2Input>;
  withValuations?: InputMaybe<Array<AugmentedCreateAssetValuationV2Input>>;
};

/**
 * AugmentedCreateActiveEstateInsightsPageInput is used for create ActiveEstateInsightsPage object.
 * Input was generated by ent.
 */
export type AugmentedCreateActiveEstateInsightsPageInput = {
  create: CreateActiveEstateInsightsPageInput;
};

/**
 * AugmentedCreateAddressInput is used for create Address object.
 * Input was generated by ent.
 */
export type AugmentedCreateAddressInput = {
  create: CreateAddressInput;
};

/**
 * AugmentedCreateAssetClassInput is used for create AssetClass object.
 * Input was generated by ent.
 */
export type AugmentedCreateAssetClassInput = {
  create: CreateAssetClassInput;
  withBalanceSheetCategory?: InputMaybe<AugmentedCreateBalanceSheetCategoryInput>;
  withIntegrationAssetClasses?: InputMaybe<Array<AugmentedCreateIntegrationAssetClassInput>>;
};

/**
 * AugmentedCreateAssetGroupInput is used for create AssetGroup object.
 * Input was generated by ent.
 */
export type AugmentedCreateAssetGroupInput = {
  create: CreateAssetGroupInput;
};

/**
 * AugmentedCreateAssetStaticInput is used for create AssetStatic object.
 * Input was generated by ent.
 */
export type AugmentedCreateAssetStaticInput = {
  create: CreateAssetStaticInput;
};

/**
 * AugmentedCreateAssetV2Input is used for create AssetV2 object.
 * Input was generated by ent.
 */
export type AugmentedCreateAssetV2Input = {
  create: CreateAssetV2Input;
  withAssetStatic?: InputMaybe<AugmentedCreateAssetStaticInput>;
  withAssetValue?: InputMaybe<AugmentedCreateAssetValueV2Input>;
};

/**
 * AugmentedCreateAssetValuationV2Input is used for create AssetValuationV2 object.
 * Input was generated by ent.
 */
export type AugmentedCreateAssetValuationV2Input = {
  create: CreateAssetValuationV2Input;
  withAssets?: InputMaybe<Array<AugmentedCreateAssetV2Input>>;
};

/**
 * AugmentedCreateAssetValueV2Input is used for create AssetValueV2 object.
 * Input was generated by ent.
 */
export type AugmentedCreateAssetValueV2Input = {
  create: CreateAssetValueV2Input;
};

/**
 * AugmentedCreateBalanceSheetBundleConfigurationInput is used for create BalanceSheetBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateBalanceSheetBundleConfigurationInput = {
  create: CreateBalanceSheetBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
  withPage?: InputMaybe<AugmentedCreatePresentationPageInput>;
};

/**
 * AugmentedCreateBalanceSheetCategoryInput is used for create BalanceSheetCategory object.
 * Input was generated by ent.
 */
export type AugmentedCreateBalanceSheetCategoryInput = {
  create: CreateBalanceSheetCategoryInput;
  withAssetClasses?: InputMaybe<Array<AugmentedCreateAssetClassInput>>;
};

/**
 * AugmentedCreateBeneficiariesBundleConfigurationInput is used for create BeneficiariesBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateBeneficiariesBundleConfigurationInput = {
  create: CreateBeneficiariesBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
};

/**
 * AugmentedCreateBeneficiariesTemplateBundleConfigurationInput is used for create BeneficiariesTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateBeneficiariesTemplateBundleConfigurationInput = {
  create: CreateBeneficiariesTemplateBundleConfigurationInput;
  withTemplateBundle?: InputMaybe<AugmentedCreatePresentationTemplateBundleInput>;
};

/**
 * AugmentedCreateBeneficiaryAccessParameterInput is used for create BeneficiaryAccessParameter object.
 * Input was generated by ent.
 */
export type AugmentedCreateBeneficiaryAccessParameterInput = {
  create: CreateBeneficiaryAccessParameterInput;
};

/**
 * AugmentedCreateBeneficiaryDesignationGroupInput is used for create BeneficiaryDesignationGroup object.
 * Input was generated by ent.
 */
export type AugmentedCreateBeneficiaryDesignationGroupInput = {
  create: CreateBeneficiaryDesignationGroupInput;
  withDispositiveProvisions?: InputMaybe<Array<AugmentedCreateDispositiveProvisionInput>>;
};

/**
 * AugmentedCreateBeneficiaryDistributionInput is used for create BeneficiaryDistribution object.
 * Input was generated by ent.
 */
export type AugmentedCreateBeneficiaryDistributionInput = {
  create: CreateBeneficiaryDistributionInput;
  withDistributionParameters?: InputMaybe<Array<AugmentedCreateBeneficiaryDistributionParameterInput>>;
};

/**
 * AugmentedCreateBeneficiaryDistributionParameterInput is used for create BeneficiaryDistributionParameter object.
 * Input was generated by ent.
 */
export type AugmentedCreateBeneficiaryDistributionParameterInput = {
  create: CreateBeneficiaryDistributionParameterInput;
  withDistribution?: InputMaybe<AugmentedCreateBeneficiaryDistributionInput>;
};

/**
 * AugmentedCreateBeneficiaryInput is used for create Beneficiary object.
 * Input was generated by ent.
 */
export type AugmentedCreateBeneficiaryInput = {
  create: CreateBeneficiaryInput;
  withAccessParameters?: InputMaybe<Array<AugmentedCreateAccessParameterInput>>;
  withDistributions?: InputMaybe<Array<AugmentedCreateBeneficiaryDistributionInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withIndividual?: InputMaybe<AugmentedCreateClientProfileInput>;
  withOrganization?: InputMaybe<AugmentedCreateClientOrganizationInput>;
  withPowerOfAppointment?: InputMaybe<AugmentedCreateBeneficiaryPowerOfAppointmentInput>;
  withScheduledDistributions?: InputMaybe<Array<AugmentedCreateScheduledDistributionInput>>;
  withTestamentaryEntity?: InputMaybe<AugmentedCreateTestamentaryEntityInput>;
};

/**
 * AugmentedCreateBeneficiaryPageInput is used for create BeneficiaryPage object.
 * Input was generated by ent.
 */
export type AugmentedCreateBeneficiaryPageInput = {
  create: CreateBeneficiaryPageInput;
  withPresentationPage?: InputMaybe<AugmentedCreatePresentationPageInput>;
};

/**
 * AugmentedCreateBeneficiaryPowerOfAppointmentInput is used for create BeneficiaryPowerOfAppointment object.
 * Input was generated by ent.
 */
export type AugmentedCreateBeneficiaryPowerOfAppointmentInput = {
  create: CreateBeneficiaryPowerOfAppointmentInput;
};

/**
 * AugmentedCreateCCorpBusinessEntityInput is used for create CCorpBusinessEntity object.
 * Input was generated by ent.
 */
export type AugmentedCreateCCorpBusinessEntityInput = {
  create: CreateCCorpBusinessEntityInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withKeyPeople?: InputMaybe<Array<AugmentedCreateKeyPersonInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedCreateCLTProposalInput is used for create CLTProposal object.
 * Input was generated by ent.
 */
export type AugmentedCreateCltProposalInput = {
  create: CreateCltProposalInput;
  withCharitableIncomeBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withProposal?: InputMaybe<AugmentedCreateProposalInput>;
  withRemainderBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
};

/**
 * AugmentedCreateCLTTrustInput is used for create CLTTrust object.
 * Input was generated by ent.
 */
export type AugmentedCreateCltTrustInput = {
  create: CreateCltTrustInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withGrantors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withLifetimeBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
  withRemainderBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedCreateCRTProposalInput is used for create CRTProposal object.
 * Input was generated by ent.
 */
export type AugmentedCreateCrtProposalInput = {
  create: CreateCrtProposalInput;
  withCharitableRemainderBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withIncomeBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withProposal?: InputMaybe<AugmentedCreateProposalInput>;
};

/**
 * AugmentedCreateCRTTrustInput is used for create CRTTrust object.
 * Input was generated by ent.
 */
export type AugmentedCreateCrtTrustInput = {
  create: CreateCrtTrustInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withGrantors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withLifetimeBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
  withRemainderBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedCreateCashflowInput is used for create Cashflow object.
 * Input was generated by ent.
 */
export type AugmentedCreateCashflowInput = {
  create: CreateCashflowInput;
};

/**
 * AugmentedCreateClientOrganizationInput is used for create ClientOrganization object.
 * Input was generated by ent.
 */
export type AugmentedCreateClientOrganizationInput = {
  create: CreateClientOrganizationInput;
  withAddress?: InputMaybe<AugmentedCreateAddressInput>;
  withProfessionalTeamRoles?: InputMaybe<Array<AugmentedCreateProfessionalTeamRoleInput>>;
};

/**
 * AugmentedCreateClientPresentationV2Input is used for create ClientPresentationV2 object.
 * Input was generated by ent.
 */
export type AugmentedCreateClientPresentationV2Input = {
  create: CreateClientPresentationV2Input;
  withBundles?: InputMaybe<Array<AugmentedCreatePresentationBundleInput>>;
};

/**
 * AugmentedCreateClientProfileInput is used for create ClientProfile object.
 * Input was generated by ent.
 */
export type AugmentedCreateClientProfileInput = {
  create: CreateClientProfileInput;
  withAddress?: InputMaybe<AugmentedCreateAddressInput>;
  withCashflows?: InputMaybe<Array<AugmentedCreateCashflowInput>>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withOwnedOwnershipStakes?: InputMaybe<Array<AugmentedCreateOwnershipStakeInput>>;
  withProfessionalTeamRoles?: InputMaybe<Array<AugmentedCreateProfessionalTeamRoleInput>>;
  withTestamentaryEntities?: InputMaybe<Array<AugmentedCreateTestamentaryEntityInput>>;
};

/**
 * AugmentedCreateClientProfileRelationshipInput is used for create ClientProfileRelationship object.
 * Input was generated by ent.
 */
export type AugmentedCreateClientProfileRelationshipInput = {
  create: CreateClientProfileRelationshipInput;
};

/**
 * AugmentedCreateCollaboratorInput is used for create Collaborator object.
 * Input was generated by ent.
 */
export type AugmentedCreateCollaboratorInput = {
  create: CreateCollaboratorInput;
};

/**
 * AugmentedCreateComparedWaterfallInput is used for create ComparedWaterfall object.
 * Input was generated by ent.
 */
export type AugmentedCreateComparedWaterfallInput = {
  create: CreateComparedWaterfallInput;
};

/**
 * AugmentedCreateCompletedEstateInsightsPageInput is used for create CompletedEstateInsightsPage object.
 * Input was generated by ent.
 */
export type AugmentedCreateCompletedEstateInsightsPageInput = {
  create: CreateCompletedEstateInsightsPageInput;
};

/**
 * AugmentedCreateControllingPartyInput is used for create ControllingParty object.
 * Input was generated by ent.
 */
export type AugmentedCreateControllingPartyInput = {
  create: CreateControllingPartyInput;
};

/**
 * AugmentedCreateCoverPageConfigurationInput is used for create CoverPageConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateCoverPageConfigurationInput = {
  create: CreateCoverPageConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
};

/**
 * AugmentedCreateCustodialPersonalAccountInput is used for create CustodialPersonalAccount object.
 * Input was generated by ent.
 */
export type AugmentedCreateCustodialPersonalAccountInput = {
  create: CreateCustodialPersonalAccountInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withOwner?: InputMaybe<AugmentedCreatePrincipalInput>;
};

/**
 * AugmentedCreateDSUEPortabilityInput is used for create DSUEPortability object.
 * Input was generated by ent.
 */
export type AugmentedCreateDsuePortabilityInput = {
  create: CreateDsuePortabilityInput;
};

/**
 * AugmentedCreateDispositionScenarioInput is used for create DispositionScenario object.
 * Input was generated by ent.
 */
export type AugmentedCreateDispositionScenarioInput = {
  create: CreateDispositionScenarioInput;
  withDispositiveProvisions?: InputMaybe<Array<AugmentedCreateDispositiveProvisionInput>>;
  withDispositiveProvisionsTemplate?: InputMaybe<AugmentedCreateDispositiveProvisionTemplateInput>;
  withSecondDeathDispositiveProvisions?: InputMaybe<Array<AugmentedCreateDispositiveProvisionInput>>;
  withSecondDeathDispositiveProvisionsTemplate?: InputMaybe<AugmentedCreateDispositiveProvisionTemplateInput>;
};

/**
 * AugmentedCreateDispositiveProvisionInput is used for create DispositiveProvision object.
 * Input was generated by ent.
 */
export type AugmentedCreateDispositiveProvisionInput = {
  create: CreateDispositiveProvisionInput;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withIndividual?: InputMaybe<AugmentedCreateClientProfileInput>;
  withOrganization?: InputMaybe<AugmentedCreateClientOrganizationInput>;
  withTestamentaryEntity?: InputMaybe<AugmentedCreateTestamentaryEntityInput>;
};

/**
 * AugmentedCreateDispositiveProvisionTemplateInput is used for create DispositiveProvisionTemplate object.
 * Input was generated by ent.
 */
export type AugmentedCreateDispositiveProvisionTemplateInput = {
  create: CreateDispositiveProvisionTemplateInput;
  withDispositiveProvisions?: InputMaybe<Array<AugmentedCreateDispositiveProvisionInput>>;
};

/**
 * AugmentedCreateDividerBundleConfigurationInput is used for create DividerBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateDividerBundleConfigurationInput = {
  create: CreateDividerBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
};

/**
 * AugmentedCreateDividerTemplateBundleConfigurationInput is used for create DividerTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateDividerTemplateBundleConfigurationInput = {
  create: CreateDividerTemplateBundleConfigurationInput;
  withTemplateBundle?: InputMaybe<AugmentedCreatePresentationTemplateBundleInput>;
};

/**
 * AugmentedCreateDocumentInput is used for create Document object.
 * Input was generated by ent.
 */
export type AugmentedCreateDocumentInput = {
  create: CreateDocumentInput;
};

/**
 * AugmentedCreateDocumentQuestionAnswersInput is used for create DocumentQuestionAnswers object.
 * Input was generated by ent.
 */
export type AugmentedCreateDocumentQuestionAnswersInput = {
  create: CreateDocumentQuestionAnswersInput;
};

/**
 * AugmentedCreateDocumentQuestionInput is used for create DocumentQuestion object.
 * Input was generated by ent.
 */
export type AugmentedCreateDocumentQuestionInput = {
  create: CreateDocumentQuestionInput;
  withAnswers?: InputMaybe<Array<AugmentedCreateDocumentQuestionAnswersInput>>;
};

/**
 * AugmentedCreateDocumentSummaryInput is used for create DocumentSummary object.
 * Input was generated by ent.
 */
export type AugmentedCreateDocumentSummaryInput = {
  create: CreateDocumentSummaryInput;
};

/**
 * AugmentedCreateDocumentSummaryPageInput is used for create DocumentSummaryPage object.
 * Input was generated by ent.
 */
export type AugmentedCreateDocumentSummaryPageInput = {
  create: CreateDocumentSummaryPageInput;
  withRelevantClientProfiles?: InputMaybe<Array<AugmentedCreateClientProfileInput>>;
};

/**
 * AugmentedCreateDocumentSummaryPromptInput is used for create DocumentSummaryPrompt object.
 * Input was generated by ent.
 */
export type AugmentedCreateDocumentSummaryPromptInput = {
  create: CreateDocumentSummaryPromptInput;
};

/**
 * AugmentedCreateDocumentSummaryTemplateBundleConfigurationInput is used for create DocumentSummaryTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateDocumentSummaryTemplateBundleConfigurationInput = {
  create: CreateDocumentSummaryTemplateBundleConfigurationInput;
  withTemplateBundle?: InputMaybe<AugmentedCreatePresentationTemplateBundleInput>;
};

/**
 * AugmentedCreateDonorAdvisedFundInput is used for create DonorAdvisedFund object.
 * Input was generated by ent.
 */
export type AugmentedCreateDonorAdvisedFundInput = {
  create: CreateDonorAdvisedFundInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withDonors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedCreateEmployeeInput is used for create Employee object.
 * Input was generated by ent.
 */
export type AugmentedCreateEmployeeInput = {
  create: CreateEmployeeInput;
};

/**
 * AugmentedCreateEntitiesOverviewBundleConfigurationEntityInput is used for create EntitiesOverviewBundleConfigurationEntity object.
 * Input was generated by ent.
 */
export type AugmentedCreateEntitiesOverviewBundleConfigurationEntityInput = {
  create: CreateEntitiesOverviewBundleConfigurationEntityInput;
  withEntitiesOverviewBundleConfiguration?: InputMaybe<AugmentedCreateEntitiesOverviewBundleConfigurationInput>;
};

/**
 * AugmentedCreateEntitiesOverviewBundleConfigurationInput is used for create EntitiesOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateEntitiesOverviewBundleConfigurationInput = {
  create: CreateEntitiesOverviewBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
  withEntities?: InputMaybe<Array<AugmentedCreateEntitiesOverviewBundleConfigurationEntityInput>>;
};

/**
 * AugmentedCreateEntityDiagramInput is used for create EntityDiagram object.
 * Input was generated by ent.
 */
export type AugmentedCreateEntityDiagramInput = {
  create: CreateEntityDiagramInput;
};

/**
 * AugmentedCreateEntityDocumentRelationshipInput is used for create EntityDocumentRelationship object.
 * Input was generated by ent.
 */
export type AugmentedCreateEntityDocumentRelationshipInput = {
  create: CreateEntityDocumentRelationshipInput;
};

/**
 * AugmentedCreateEntityGraphViewBundleConfigurationInput is used for create EntityGraphViewBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateEntityGraphViewBundleConfigurationInput = {
  create: CreateEntityGraphViewBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
};

/**
 * AugmentedCreateEntityGraphViewInput is used for create EntityGraphView object.
 * Input was generated by ent.
 */
export type AugmentedCreateEntityGraphViewInput = {
  create: CreateEntityGraphViewInput;
};

/**
 * AugmentedCreateEntityInput is used for create Entity object.
 * Input was generated by ent.
 */
export type AugmentedCreateEntityInput = {
  create: CreateEntityInput;
  withCashflows?: InputMaybe<Array<AugmentedCreateCashflowInput>>;
  withCcorpBusinessEntity?: InputMaybe<AugmentedCreateCCorpBusinessEntityInput>;
  withCltTrust?: InputMaybe<AugmentedCreateCltTrustInput>;
  withCrtTrust?: InputMaybe<AugmentedCreateCrtTrustInput>;
  withCustodialPersonalAccount?: InputMaybe<AugmentedCreateCustodialPersonalAccountInput>;
  withDeathOrderNotes?: InputMaybe<Array<AugmentedCreateEntityNotesInput>>;
  withDonorAdvisedFund?: InputMaybe<AugmentedCreateDonorAdvisedFundInput>;
  withEntityDocumentRelationships?: InputMaybe<Array<AugmentedCreateEntityDocumentRelationshipInput>>;
  withGpBusinessEntity?: InputMaybe<AugmentedCreateGpBusinessEntityInput>;
  withGratTrust?: InputMaybe<AugmentedCreateGratTrustInput>;
  withIlitTrust?: InputMaybe<AugmentedCreateIlitTrustInput>;
  withIndividualPersonalAccount?: InputMaybe<AugmentedCreateIndividualPersonalAccountInput>;
  withInsurancePersonalAccount?: InputMaybe<AugmentedCreateInsurancePersonalAccountInput>;
  withIrrevocableTrust?: InputMaybe<AugmentedCreateIrrevocableTrustInput>;
  withJointPersonalAccount?: InputMaybe<AugmentedCreateJointPersonalAccountInput>;
  withLiabilitiesOwed?: InputMaybe<Array<AugmentedCreateLiabilityInput>>;
  withLlcBusinessEntity?: InputMaybe<AugmentedCreateLlcBusinessEntityInput>;
  withLpBusinessEntity?: InputMaybe<AugmentedCreateLpBusinessEntityInput>;
  withOwnedByStakes?: InputMaybe<Array<AugmentedCreateOwnershipStakeInput>>;
  withOwnedOwnershipStakes?: InputMaybe<Array<AugmentedCreateOwnershipStakeInput>>;
  withPrivateFoundation?: InputMaybe<AugmentedCreatePrivateFoundationInput>;
  withQprtTrust?: InputMaybe<AugmentedCreateQprtTrustInput>;
  withQualifiedTuitionPersonalAccount?: InputMaybe<AugmentedCreateQualifiedTuitionPersonalAccountInput>;
  withRetirementPersonalAccount?: InputMaybe<AugmentedCreateRetirementPersonalAccountInput>;
  withRevocableTrust?: InputMaybe<AugmentedCreateRevocableTrustInput>;
  withScorpBusinessEntity?: InputMaybe<AugmentedCreateSCorpBusinessEntityInput>;
  withSlatTrust?: InputMaybe<AugmentedCreateSlatTrustInput>;
  withSoleProprietorshipBusinessEntity?: InputMaybe<AugmentedCreateSoleProprietorshipBusinessEntityInput>;
  withTaxInfo?: InputMaybe<AugmentedCreateEntityTaxInfoInput>;
};

/**
 * AugmentedCreateEntityNotesInput is used for create EntityNotes object.
 * Input was generated by ent.
 */
export type AugmentedCreateEntityNotesInput = {
  create: CreateEntityNotesInput;
};

/**
 * AugmentedCreateEntityProposalInput is used for create EntityProposal object.
 * Input was generated by ent.
 */
export type AugmentedCreateEntityProposalInput = {
  create: CreateEntityProposalInput;
  withProposal?: InputMaybe<AugmentedCreateProposalInput>;
  withProposalScenarios?: InputMaybe<Array<AugmentedCreateProposalScenarioInput>>;
};

/**
 * AugmentedCreateEntitySummaryBundleConfigurationInput is used for create EntitySummaryBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateEntitySummaryBundleConfigurationInput = {
  create: CreateEntitySummaryBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
};

/**
 * AugmentedCreateEntitySummaryTemplateBundleConfigurationInput is used for create EntitySummaryTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateEntitySummaryTemplateBundleConfigurationInput = {
  create: CreateEntitySummaryTemplateBundleConfigurationInput;
  withTemplateBundle?: InputMaybe<AugmentedCreatePresentationTemplateBundleInput>;
};

/**
 * AugmentedCreateEntityTaskInput is used for create EntityTask object.
 * Input was generated by ent.
 */
export type AugmentedCreateEntityTaskInput = {
  create: CreateEntityTaskInput;
};

/**
 * AugmentedCreateEntityTaxInfoInput is used for create EntityTaxInfo object.
 * Input was generated by ent.
 */
export type AugmentedCreateEntityTaxInfoInput = {
  create: CreateEntityTaxInfoInput;
};

/**
 * AugmentedCreateEstateInsightInput is used for create EstateInsight object.
 * Input was generated by ent.
 */
export type AugmentedCreateEstateInsightInput = {
  create: CreateEstateInsightInput;
};

/**
 * AugmentedCreateEstateInsightReferenceInput is used for create EstateInsightReference object.
 * Input was generated by ent.
 */
export type AugmentedCreateEstateInsightReferenceInput = {
  create: CreateEstateInsightReferenceInput;
};

/**
 * AugmentedCreateEstateInsightsBundleConfigurationInput is used for create EstateInsightsBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateEstateInsightsBundleConfigurationInput = {
  create: CreateEstateInsightsBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
};

/**
 * AugmentedCreateEstateTaxScenarioInput is used for create EstateTaxScenario object.
 * Input was generated by ent.
 */
export type AugmentedCreateEstateTaxScenarioInput = {
  create: CreateEstateTaxScenarioInput;
};

/**
 * AugmentedCreateEstateWaterfallHypotheticalStateChangeInput is used for create EstateWaterfallHypotheticalStateChange object.
 * Input was generated by ent.
 */
export type AugmentedCreateEstateWaterfallHypotheticalStateChangeInput = {
  create: CreateEstateWaterfallHypotheticalStateChangeInput;
  withHypotheticalWaterfall?: InputMaybe<AugmentedCreateEstateWaterfallInput>;
};

/**
 * AugmentedCreateEstateWaterfallHypotheticalTransferInput is used for create EstateWaterfallHypotheticalTransfer object.
 * Input was generated by ent.
 */
export type AugmentedCreateEstateWaterfallHypotheticalTransferInput = {
  create: CreateEstateWaterfallHypotheticalTransferInput;
  withDestinationEntity?: InputMaybe<AugmentedCreateEntityInput>;
};

/**
 * AugmentedCreateEstateWaterfallInput is used for create EstateWaterfall object.
 * Input was generated by ent.
 */
export type AugmentedCreateEstateWaterfallInput = {
  create: CreateEstateWaterfallInput;
  withHypotheticalStateChanges?: InputMaybe<Array<AugmentedCreateEstateWaterfallHypotheticalStateChangeInput>>;
  withHypotheticalTransfers?: InputMaybe<Array<AugmentedCreateEstateWaterfallHypotheticalTransferInput>>;
  withVisualizationConfig?: InputMaybe<AugmentedCreateEstateWaterfallVisualizationConfigInput>;
  withVisualizationGroups?: InputMaybe<Array<AugmentedCreateGraphVisualizationGroupInput>>;
};

/**
 * AugmentedCreateEstateWaterfallVisualizationConfigInput is used for create EstateWaterfallVisualizationConfig object.
 * Input was generated by ent.
 */
export type AugmentedCreateEstateWaterfallVisualizationConfigInput = {
  create: CreateEstateWaterfallVisualizationConfigInput;
};

/**
 * AugmentedCreateEstateWaterfallVisualizationFilterInput is used for create EstateWaterfallVisualizationFilter object.
 * Input was generated by ent.
 */
export type AugmentedCreateEstateWaterfallVisualizationFilterInput = {
  create: CreateEstateWaterfallVisualizationFilterInput;
};

/**
 * AugmentedCreateFamilyTreeBundleConfigurationInput is used for create FamilyTreeBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateFamilyTreeBundleConfigurationInput = {
  create: CreateFamilyTreeBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
};

/**
 * AugmentedCreateFeatureFlagInput is used for create FeatureFlag object.
 * Input was generated by ent.
 */
export type AugmentedCreateFeatureFlagInput = {
  create: CreateFeatureFlagInput;
};

/**
 * AugmentedCreateFeatureFlagQueryRuleInput is used for create FeatureFlagQueryRule object.
 * Input was generated by ent.
 */
export type AugmentedCreateFeatureFlagQueryRuleInput = {
  create: CreateFeatureFlagQueryRuleInput;
};

/**
 * AugmentedCreateFileInput is used for create File object.
 * Input was generated by ent.
 */
export type AugmentedCreateFileInput = {
  create: CreateFileInput;
};

/**
 * AugmentedCreateFilePageInput is used for create FilePage object.
 * Input was generated by ent.
 */
export type AugmentedCreateFilePageInput = {
  create: CreateFilePageInput;
};

/**
 * AugmentedCreateFormInput is used for create Form object.
 * Input was generated by ent.
 */
export type AugmentedCreateFormInput = {
  create: CreateFormInput;
};

/**
 * AugmentedCreateGPBusinessEntityInput is used for create GPBusinessEntity object.
 * Input was generated by ent.
 */
export type AugmentedCreateGpBusinessEntityInput = {
  create: CreateGpBusinessEntityInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withKeyPeople?: InputMaybe<Array<AugmentedCreateKeyPersonInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedCreateGRATAnnuityV2Input is used for create GRATAnnuityV2 object.
 * Input was generated by ent.
 */
export type AugmentedCreateGratAnnuityV2Input = {
  create: CreateGratAnnuityV2Input;
};

/**
 * AugmentedCreateGRATProposalScenarioInput is used for create GRATProposalScenario object.
 * Input was generated by ent.
 */
export type AugmentedCreateGratProposalScenarioInput = {
  create: CreateGratProposalScenarioInput;
  withProposalScenario?: InputMaybe<AugmentedCreateProposalScenarioInput>;
};

/**
 * AugmentedCreateGRATTrustInput is used for create GRATTrust object.
 * Input was generated by ent.
 */
export type AugmentedCreateGratTrustInput = {
  create: CreateGratTrustInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withAnnuities?: InputMaybe<Array<AugmentedCreateGratAnnuityV2Input>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withDistributionAssetValuation?: InputMaybe<AugmentedCreateAssetValuationV2Input>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withGrantor?: InputMaybe<AugmentedCreatePrincipalInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedCreateGiftingProposalCashFlowInput is used for create GiftingProposalCashFlow object.
 * Input was generated by ent.
 */
export type AugmentedCreateGiftingProposalCashFlowInput = {
  create: CreateGiftingProposalCashFlowInput;
};

/**
 * AugmentedCreateGiftingProposalGiftInput is used for create GiftingProposalGift object.
 * Input was generated by ent.
 */
export type AugmentedCreateGiftingProposalGiftInput = {
  create: CreateGiftingProposalGiftInput;
  withRecipientClientOrganization?: InputMaybe<AugmentedCreateClientOrganizationInput>;
  withRecipientClientProfile?: InputMaybe<AugmentedCreateClientProfileInput>;
  withRecipientPortfolio?: InputMaybe<AugmentedCreateGiftingProposalPortfolioInput>;
  withSenders?: InputMaybe<Array<AugmentedCreateGiftingProposalGiftSenderInput>>;
};

/**
 * AugmentedCreateGiftingProposalGiftSenderInput is used for create GiftingProposalGiftSender object.
 * Input was generated by ent.
 */
export type AugmentedCreateGiftingProposalGiftSenderInput = {
  create: CreateGiftingProposalGiftSenderInput;
};

/**
 * AugmentedCreateGiftingProposalInput is used for create GiftingProposal object.
 * Input was generated by ent.
 */
export type AugmentedCreateGiftingProposalInput = {
  create: CreateGiftingProposalInput;
  withBaseCashFlows?: InputMaybe<Array<AugmentedCreateGiftingProposalCashFlowInput>>;
  withDefaultGiftingScenario?: InputMaybe<AugmentedCreateGiftingProposalScenarioInput>;
  withGiftingScenarios?: InputMaybe<Array<AugmentedCreateGiftingProposalScenarioInput>>;
  withOutOfEstatePortfolios?: InputMaybe<Array<AugmentedCreateGiftingProposalPortfolioInput>>;
  withProposal?: InputMaybe<AugmentedCreateProposalInput>;
};

/**
 * AugmentedCreateGiftingProposalPortfolioInput is used for create GiftingProposalPortfolio object.
 * Input was generated by ent.
 */
export type AugmentedCreateGiftingProposalPortfolioInput = {
  create: CreateGiftingProposalPortfolioInput;
  withCashflows?: InputMaybe<Array<AugmentedCreateGiftingProposalCashFlowInput>>;
};

/**
 * AugmentedCreateGiftingProposalScenarioInput is used for create GiftingProposalScenario object.
 * Input was generated by ent.
 */
export type AugmentedCreateGiftingProposalScenarioInput = {
  create: CreateGiftingProposalScenarioInput;
  withScenarioCashFlows?: InputMaybe<Array<AugmentedCreateGiftingProposalCashFlowInput>>;
  withScenarioGifts?: InputMaybe<Array<AugmentedCreateGiftingProposalGiftInput>>;
};

/**
 * AugmentedCreateGraphVisualizationGroupInput is used for create GraphVisualizationGroup object.
 * Input was generated by ent.
 */
export type AugmentedCreateGraphVisualizationGroupInput = {
  create: CreateGraphVisualizationGroupInput;
};

/**
 * AugmentedCreateGrowthProfileInput is used for create GrowthProfile object.
 * Input was generated by ent.
 */
export type AugmentedCreateGrowthProfileInput = {
  create: CreateGrowthProfileInput;
  withGrowthProfileOverrides?: InputMaybe<Array<AugmentedCreateGrowthProfileOverrideInput>>;
  withIncomeTaxPaymentConfig?: InputMaybe<AugmentedCreateIncomeTaxPaymentConfigInput>;
  withTaxDragConfig?: InputMaybe<AugmentedCreateTaxDragConfigInput>;
  withTaxDragOverrides?: InputMaybe<Array<AugmentedCreateTaxDragOverrideInput>>;
};

/**
 * AugmentedCreateGrowthProfileOverrideInput is used for create GrowthProfileOverride object.
 * Input was generated by ent.
 */
export type AugmentedCreateGrowthProfileOverrideInput = {
  create: CreateGrowthProfileOverrideInput;
};

/**
 * AugmentedCreateHouseholdInput is used for create Household object.
 * Input was generated by ent.
 */
export type AugmentedCreateHouseholdInput = {
  create: CreateHouseholdInput;
  withClientProfiles?: InputMaybe<Array<AugmentedCreateClientProfileInput>>;
  withEstateTaxScenarios?: InputMaybe<Array<AugmentedCreateEstateTaxScenarioInput>>;
};

/**
 * AugmentedCreateHypotheticalCLTInput is used for create HypotheticalCLT object.
 * Input was generated by ent.
 */
export type AugmentedCreateHypotheticalCltInput = {
  create: CreateHypotheticalCltInput;
  withFunding?: InputMaybe<AugmentedCreateHypotheticalTransferFundingSourceInput>;
};

/**
 * AugmentedCreateHypotheticalCRTInput is used for create HypotheticalCRT object.
 * Input was generated by ent.
 */
export type AugmentedCreateHypotheticalCrtInput = {
  create: CreateHypotheticalCrtInput;
  withFunding?: InputMaybe<AugmentedCreateHypotheticalTransferFundingSourceInput>;
};

/**
 * AugmentedCreateHypotheticalGRATInput is used for create HypotheticalGRAT object.
 * Input was generated by ent.
 */
export type AugmentedCreateHypotheticalGratInput = {
  create: CreateHypotheticalGratInput;
  withFunding?: InputMaybe<AugmentedCreateHypotheticalTransferFundingSourceInput>;
};

/**
 * AugmentedCreateHypotheticalInsuranceInput is used for create HypotheticalInsurance object.
 * Input was generated by ent.
 */
export type AugmentedCreateHypotheticalInsuranceInput = {
  create: CreateHypotheticalInsuranceInput;
  withCreatedInsurancePolicy?: InputMaybe<AugmentedCreateInsurancePolicyInput>;
  withDestinationEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withExistingInsurancePolicy?: InputMaybe<AugmentedCreateInsurancePolicyInput>;
};

/**
 * AugmentedCreateHypotheticalSaleLoanInput is used for create HypotheticalSaleLoan object.
 * Input was generated by ent.
 */
export type AugmentedCreateHypotheticalSaleLoanInput = {
  create: CreateHypotheticalSaleLoanInput;
  withFunding?: InputMaybe<AugmentedCreateHypotheticalTransferFundingSourceInput>;
};

/**
 * AugmentedCreateHypotheticalTransferAssetInput is used for create HypotheticalTransferAsset object.
 * Input was generated by ent.
 */
export type AugmentedCreateHypotheticalTransferAssetInput = {
  create: CreateHypotheticalTransferAssetInput;
  withHypotheticalTransferFundingSource?: InputMaybe<AugmentedCreateHypotheticalTransferFundingSourceInput>;
};

/**
 * AugmentedCreateHypotheticalTransferFundingSourceInput is used for create HypotheticalTransferFundingSource object.
 * Input was generated by ent.
 */
export type AugmentedCreateHypotheticalTransferFundingSourceInput = {
  create: CreateHypotheticalTransferFundingSourceInput;
  withAssets?: InputMaybe<Array<AugmentedCreateHypotheticalTransferAssetInput>>;
  withHypotheticalClt?: InputMaybe<AugmentedCreateHypotheticalCltInput>;
  withHypotheticalCrt?: InputMaybe<AugmentedCreateHypotheticalCrtInput>;
  withHypotheticalGrat?: InputMaybe<AugmentedCreateHypotheticalGratInput>;
  withHypotheticalSaleLoan?: InputMaybe<AugmentedCreateHypotheticalSaleLoanInput>;
};

/**
 * AugmentedCreateHypotheticalWaterfallDispositiveProvisionTemplateInput is used for create HypotheticalWaterfallDispositiveProvisionTemplate object.
 * Input was generated by ent.
 */
export type AugmentedCreateHypotheticalWaterfallDispositiveProvisionTemplateInput = {
  create: CreateHypotheticalWaterfallDispositiveProvisionTemplateInput;
};

/**
 * AugmentedCreateILITCrummeyLetterInput is used for create ILITCrummeyLetter object.
 * Input was generated by ent.
 */
export type AugmentedCreateIlitCrummeyLetterInput = {
  create: CreateIlitCrummeyLetterInput;
};

/**
 * AugmentedCreateILITTrustInput is used for create ILITTrust object.
 * Input was generated by ent.
 */
export type AugmentedCreateIlitTrustInput = {
  create: CreateIlitTrustInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withCrummeyLetters?: InputMaybe<Array<AugmentedCreateIlitCrummeyLetterInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withGrantors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedCreateIncomeTaxPaymentConfigInput is used for create IncomeTaxPaymentConfig object.
 * Input was generated by ent.
 */
export type AugmentedCreateIncomeTaxPaymentConfigInput = {
  create: CreateIncomeTaxPaymentConfigInput;
  withGrowthProfile?: InputMaybe<AugmentedCreateGrowthProfileInput>;
};

/**
 * AugmentedCreateIndividualPersonalAccountInput is used for create IndividualPersonalAccount object.
 * Input was generated by ent.
 */
export type AugmentedCreateIndividualPersonalAccountInput = {
  create: CreateIndividualPersonalAccountInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withOwner?: InputMaybe<AugmentedCreatePrincipalInput>;
};

/**
 * AugmentedCreateInferredFieldEvidenceInput is used for create InferredFieldEvidence object.
 * Input was generated by ent.
 */
export type AugmentedCreateInferredFieldEvidenceInput = {
  create: CreateInferredFieldEvidenceInput;
};

/**
 * AugmentedCreateInferredFieldInput is used for create InferredField object.
 * Input was generated by ent.
 */
export type AugmentedCreateInferredFieldInput = {
  create: CreateInferredFieldInput;
  withEvidence?: InputMaybe<Array<AugmentedCreateInferredFieldEvidenceInput>>;
};

/**
 * AugmentedCreateInsightsTemplateBundleConfigurationInput is used for create InsightsTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateInsightsTemplateBundleConfigurationInput = {
  create: CreateInsightsTemplateBundleConfigurationInput;
  withTemplateBundle?: InputMaybe<AugmentedCreatePresentationTemplateBundleInput>;
};

/**
 * AugmentedCreateInsurancePersonalAccountInput is used for create InsurancePersonalAccount object.
 * Input was generated by ent.
 */
export type AugmentedCreateInsurancePersonalAccountInput = {
  create: CreateInsurancePersonalAccountInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaryDesignationGroups?: InputMaybe<Array<AugmentedCreateBeneficiaryDesignationGroupInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withHypotheticalBeneficiaryDesignationGroups?: InputMaybe<Array<AugmentedCreateBeneficiaryDesignationGroupInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withOwners?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedCreateInsurancePolicyInput is used for create InsurancePolicy object.
 * Input was generated by ent.
 */
export type AugmentedCreateInsurancePolicyInput = {
  create: CreateInsurancePolicyInput;
  withPremiumPayments?: InputMaybe<Array<AugmentedCreateInsurancePremiumPaymentInput>>;
};

/**
 * AugmentedCreateInsurancePremiumPaymentInput is used for create InsurancePremiumPayment object.
 * Input was generated by ent.
 */
export type AugmentedCreateInsurancePremiumPaymentInput = {
  create: CreateInsurancePremiumPaymentInput;
};

/**
 * AugmentedCreateIntegrationAssetClassInput is used for create IntegrationAssetClass object.
 * Input was generated by ent.
 */
export type AugmentedCreateIntegrationAssetClassInput = {
  create: CreateIntegrationAssetClassInput;
  withAssetClass?: InputMaybe<AugmentedCreateAssetClassInput>;
};

/**
 * AugmentedCreateIntegrationConfigurationInput is used for create IntegrationConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateIntegrationConfigurationInput = {
  create: CreateIntegrationConfigurationInput;
};

/**
 * AugmentedCreateIrrevocableTrustInput is used for create IrrevocableTrust object.
 * Input was generated by ent.
 */
export type AugmentedCreateIrrevocableTrustInput = {
  create: CreateIrrevocableTrustInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withGrantors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedCreateJointPersonalAccountInput is used for create JointPersonalAccount object.
 * Input was generated by ent.
 */
export type AugmentedCreateJointPersonalAccountInput = {
  create: CreateJointPersonalAccountInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withOwners?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
};

/**
 * AugmentedCreateKGRootInput is used for create KGRoot object.
 * Input was generated by ent.
 */
export type AugmentedCreateKgRootInput = {
  create: CreateKgRootInput;
  withAiSuggestions?: InputMaybe<Array<AugmentedCreateAiSuggestionInput>>;
};

/**
 * AugmentedCreateKeyPersonInput is used for create KeyPerson object.
 * Input was generated by ent.
 */
export type AugmentedCreateKeyPersonInput = {
  create: CreateKeyPersonInput;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withIndividual?: InputMaybe<AugmentedCreateClientProfileInput>;
  withOrganization?: InputMaybe<AugmentedCreateClientOrganizationInput>;
  withRoles?: InputMaybe<Array<AugmentedCreateKeyPersonRoleInput>>;
};

/**
 * AugmentedCreateKeyPersonRoleInput is used for create KeyPersonRole object.
 * Input was generated by ent.
 */
export type AugmentedCreateKeyPersonRoleInput = {
  create: CreateKeyPersonRoleInput;
  withKeyPerson?: InputMaybe<AugmentedCreateKeyPersonInput>;
};

/**
 * AugmentedCreateLLCBusinessEntityInput is used for create LLCBusinessEntity object.
 * Input was generated by ent.
 */
export type AugmentedCreateLlcBusinessEntityInput = {
  create: CreateLlcBusinessEntityInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withKeyPeople?: InputMaybe<Array<AugmentedCreateKeyPersonInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedCreateLPBusinessEntityInput is used for create LPBusinessEntity object.
 * Input was generated by ent.
 */
export type AugmentedCreateLpBusinessEntityInput = {
  create: CreateLpBusinessEntityInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withKeyPeople?: InputMaybe<Array<AugmentedCreateKeyPersonInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedCreateLiabilitiesBundleConfigurationInput is used for create LiabilitiesBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateLiabilitiesBundleConfigurationInput = {
  create: CreateLiabilitiesBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
};

/**
 * AugmentedCreateLiabilityInput is used for create Liability object.
 * Input was generated by ent.
 */
export type AugmentedCreateLiabilityInput = {
  create: CreateLiabilityInput;
};

/**
 * AugmentedCreateLifeInsuranceBundleConfigurationInput is used for create LifeInsuranceBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateLifeInsuranceBundleConfigurationInput = {
  create: CreateLifeInsuranceBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
};

/**
 * AugmentedCreateLifetimeExclusionEventInput is used for create LifetimeExclusionEvent object.
 * Input was generated by ent.
 */
export type AugmentedCreateLifetimeExclusionEventInput = {
  create: CreateLifetimeExclusionEventInput;
  withRecipient?: InputMaybe<AugmentedCreateBeneficiaryInput>;
};

/**
 * AugmentedCreateLoggedTransferInput is used for create LoggedTransfer object.
 * Input was generated by ent.
 */
export type AugmentedCreateLoggedTransferInput = {
  create: CreateLoggedTransferInput;
  withLifetimeExclusionEvents?: InputMaybe<Array<AugmentedCreateLifetimeExclusionEventInput>>;
};

/**
 * AugmentedCreateLuminaryTenantJITInput is used for create LuminaryTenantJIT object.
 * Input was generated by ent.
 */
export type AugmentedCreateLuminaryTenantJitInput = {
  create: CreateLuminaryTenantJitInput;
};

/**
 * AugmentedCreateMemoInput is used for create Memo object.
 * Input was generated by ent.
 */
export type AugmentedCreateMemoInput = {
  create: CreateMemoInput;
};

/**
 * AugmentedCreateMissingDocumentsPageInput is used for create MissingDocumentsPage object.
 * Input was generated by ent.
 */
export type AugmentedCreateMissingDocumentsPageInput = {
  create: CreateMissingDocumentsPageInput;
};

/**
 * AugmentedCreateModelMappingInput is used for create ModelMapping object.
 * Input was generated by ent.
 */
export type AugmentedCreateModelMappingInput = {
  create: CreateModelMappingInput;
  withConfig?: InputMaybe<AugmentedCreateOpenaiSdkConfigInput>;
};

/**
 * AugmentedCreateOpenaiSdkConfigInput is used for create OpenaiSdkConfig object.
 * Input was generated by ent.
 */
export type AugmentedCreateOpenaiSdkConfigInput = {
  create: CreateOpenaiSdkConfigInput;
  withModelMappings?: InputMaybe<Array<AugmentedCreateModelMappingInput>>;
};

/**
 * AugmentedCreateOrganizationDisclaimerConfigurationInput is used for create OrganizationDisclaimerConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateOrganizationDisclaimerConfigurationInput = {
  create: CreateOrganizationDisclaimerConfigurationInput;
};

/**
 * AugmentedCreateOwnershipStakeInput is used for create OwnershipStake object.
 * Input was generated by ent.
 */
export type AugmentedCreateOwnershipStakeInput = {
  create: CreateOwnershipStakeInput;
  withOwnedEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withOwningEntity?: InputMaybe<AugmentedCreateEntityInput>;
};

/**
 * AugmentedCreatePlatformDocumentInput is used for create PlatformDocument object.
 * Input was generated by ent.
 */
export type AugmentedCreatePlatformDocumentInput = {
  create: CreatePlatformDocumentInput;
};

/**
 * AugmentedCreatePresentationAssetDistributionBundleConfigurationInput is used for create PresentationAssetDistributionBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationAssetDistributionBundleConfigurationInput = {
  create: CreatePresentationAssetDistributionBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
  withDistributionItems?: InputMaybe<Array<AugmentedCreatePresentationAssetDistributionItemConfigurationInput>>;
};

/**
 * AugmentedCreatePresentationAssetDistributionItemConfigurationInput is used for create PresentationAssetDistributionItemConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationAssetDistributionItemConfigurationInput = {
  create: CreatePresentationAssetDistributionItemConfigurationInput;
  withBundleConfiguration?: InputMaybe<AugmentedCreatePresentationAssetDistributionBundleConfigurationInput>;
  withItemDetails?: InputMaybe<Array<AugmentedCreatePresentationAssetDistributionItemDetailInput>>;
};

/**
 * AugmentedCreatePresentationAssetDistributionItemDetailInput is used for create PresentationAssetDistributionItemDetail object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationAssetDistributionItemDetailInput = {
  create: CreatePresentationAssetDistributionItemDetailInput;
  withCitations?: InputMaybe<Array<AugmentedCreatePresentationItemCitationInput>>;
  withItemConfiguration?: InputMaybe<AugmentedCreatePresentationAssetDistributionItemConfigurationInput>;
};

/**
 * AugmentedCreatePresentationBundleCoverPageInput is used for create PresentationBundleCoverPage object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationBundleCoverPageInput = {
  create: CreatePresentationBundleCoverPageInput;
};

/**
 * AugmentedCreatePresentationBundleInput is used for create PresentationBundle object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationBundleInput = {
  create: CreatePresentationBundleInput;
  generate?: InputMaybe<Scalars['Boolean']['input']>;
  withAssetDistributionBundleConfiguration?: InputMaybe<AugmentedCreatePresentationAssetDistributionBundleConfigurationInput>;
  withBalanceSheetBundleConfiguration?: InputMaybe<AugmentedCreateBalanceSheetBundleConfigurationInput>;
  withBeneficiariesBundleConfiguration?: InputMaybe<AugmentedCreateBeneficiariesBundleConfigurationInput>;
  withBusinessOverviewBundleConfiguration?: InputMaybe<AugmentedCreatePresentationBusinessOverviewBundleConfigurationInput>;
  withCoverPageConfiguration?: InputMaybe<AugmentedCreateCoverPageConfigurationInput>;
  withCustomPageBundleConfiguration?: InputMaybe<AugmentedCreatePresentationCustomPageBundleConfigurationInput>;
  withDividerBundleConfiguration?: InputMaybe<AugmentedCreateDividerBundleConfigurationInput>;
  withDocumentsReviewedBundleConfiguration?: InputMaybe<AugmentedCreatePresentationDocumentsReviewedBundleConfigurationInput>;
  withEntitiesOverviewBundleConfiguration?: InputMaybe<AugmentedCreateEntitiesOverviewBundleConfigurationInput>;
  withEntityGraphViewBundleConfiguration?: InputMaybe<AugmentedCreateEntityGraphViewBundleConfigurationInput>;
  withEntitySummaryBundleConfiguration?: InputMaybe<AugmentedCreateEntitySummaryBundleConfigurationInput>;
  withEstateInsightsBundleConfiguration?: InputMaybe<AugmentedCreateEstateInsightsBundleConfigurationInput>;
  withFamilyOverviewBundleConfiguration?: InputMaybe<AugmentedCreatePresentationFamilyOverviewBundleConfigurationInput>;
  withFamilyTreeBundleConfiguration?: InputMaybe<AugmentedCreateFamilyTreeBundleConfigurationInput>;
  withHealthcareDirectiveBundleConfiguration?: InputMaybe<AugmentedCreatePresentationHealthcareDirectiveBundleConfigurationInput>;
  withLiabilitiesBundleConfiguration?: InputMaybe<AugmentedCreateLiabilitiesBundleConfigurationInput>;
  withLifeInsuranceBundleConfiguration?: InputMaybe<AugmentedCreateLifeInsuranceBundleConfigurationInput>;
  withPages?: InputMaybe<Array<AugmentedCreatePresentationPageInput>>;
  withPlanningOpportunitiesBundleConfiguration?: InputMaybe<AugmentedCreatePresentationPlanningOpportunitiesBundleConfigurationInput>;
  withPowerOfAttorneyBundleConfiguration?: InputMaybe<AugmentedCreatePresentationPowerOfAttorneyBundleConfigurationInput>;
  withTrustOverviewBundleConfiguration?: InputMaybe<AugmentedCreatePresentationTrustOverviewBundleConfigurationInput>;
  withWaterfallBundleConfiguration?: InputMaybe<AugmentedCreateWaterfallBundleConfigurationInput>;
  withWaterfallComparisonBundleConfiguration?: InputMaybe<AugmentedCreateWaterfallComparisonBundleConfigurationInput>;
  withWillBundleConfiguration?: InputMaybe<AugmentedCreatePresentationWillBundleConfigurationInput>;
};

/**
 * AugmentedCreatePresentationBusinessOverviewBundleConfigurationInput is used for create PresentationBusinessOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationBusinessOverviewBundleConfigurationInput = {
  create: CreatePresentationBusinessOverviewBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
  withBusinesses?: InputMaybe<Array<AugmentedCreatePresentationBusinessOverviewBusinessConfigurationInput>>;
};

/**
 * AugmentedCreatePresentationBusinessOverviewBusinessConfigurationInput is used for create PresentationBusinessOverviewBusinessConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationBusinessOverviewBusinessConfigurationInput = {
  create: CreatePresentationBusinessOverviewBusinessConfigurationInput;
  withBundleConfiguration?: InputMaybe<AugmentedCreatePresentationBusinessOverviewBundleConfigurationInput>;
  withBusinessItems?: InputMaybe<Array<AugmentedCreatePresentationBusinessOverviewItemInput>>;
};

/**
 * AugmentedCreatePresentationBusinessOverviewItemInput is used for create PresentationBusinessOverviewItem object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationBusinessOverviewItemInput = {
  create: CreatePresentationBusinessOverviewItemInput;
  withBusinessConfiguration?: InputMaybe<AugmentedCreatePresentationBusinessOverviewBusinessConfigurationInput>;
  withCitations?: InputMaybe<Array<AugmentedCreatePresentationItemCitationInput>>;
};

/**
 * AugmentedCreatePresentationCoverPageInput is used for create PresentationCoverPage object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationCoverPageInput = {
  create: CreatePresentationCoverPageInput;
  withPage?: InputMaybe<AugmentedCreatePresentationPageInput>;
};

/**
 * AugmentedCreatePresentationCustomPageBundleConfigurationInput is used for create PresentationCustomPageBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationCustomPageBundleConfigurationInput = {
  create: CreatePresentationCustomPageBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
};

/**
 * AugmentedCreatePresentationCustomPageInput is used for create PresentationCustomPage object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationCustomPageInput = {
  create: CreatePresentationCustomPageInput;
  withPage?: InputMaybe<AugmentedCreatePresentationPageInput>;
};

/**
 * AugmentedCreatePresentationDiagramPageInput is used for create PresentationDiagramPage object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationDiagramPageInput = {
  create: CreatePresentationDiagramPageInput;
  withPage?: InputMaybe<AugmentedCreatePresentationPageInput>;
};

/**
 * AugmentedCreatePresentationDocumentsReviewedBundleConfigurationInput is used for create PresentationDocumentsReviewedBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationDocumentsReviewedBundleConfigurationInput = {
  create: CreatePresentationDocumentsReviewedBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
  withReviewedDocuments?: InputMaybe<Array<AugmentedCreatePresentationDocumentsReviewedDocumentInput>>;
};

/**
 * AugmentedCreatePresentationDocumentsReviewedDocumentInput is used for create PresentationDocumentsReviewedDocument object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationDocumentsReviewedDocumentInput = {
  create: CreatePresentationDocumentsReviewedDocumentInput;
  withBundleConfiguration?: InputMaybe<AugmentedCreatePresentationDocumentsReviewedBundleConfigurationInput>;
};

/**
 * AugmentedCreatePresentationFamilyOverviewBundleConfigurationInput is used for create PresentationFamilyOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationFamilyOverviewBundleConfigurationInput = {
  create: CreatePresentationFamilyOverviewBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
  withMembers?: InputMaybe<Array<AugmentedCreatePresentationFamilyOverviewMemberConfigurationInput>>;
};

/**
 * AugmentedCreatePresentationFamilyOverviewMemberConfigurationInput is used for create PresentationFamilyOverviewMemberConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationFamilyOverviewMemberConfigurationInput = {
  create: CreatePresentationFamilyOverviewMemberConfigurationInput;
  withBundleConfiguration?: InputMaybe<AugmentedCreatePresentationFamilyOverviewBundleConfigurationInput>;
  withCitations?: InputMaybe<Array<AugmentedCreatePresentationItemCitationInput>>;
};

/**
 * AugmentedCreatePresentationHealthcareDirectiveBundleConfigurationInput is used for create PresentationHealthcareDirectiveBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationHealthcareDirectiveBundleConfigurationInput = {
  create: CreatePresentationHealthcareDirectiveBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
  withClients?: InputMaybe<Array<AugmentedCreatePresentationHealthcareDirectiveClientConfigurationInput>>;
};

/**
 * AugmentedCreatePresentationHealthcareDirectiveClientConfigurationInput is used for create PresentationHealthcareDirectiveClientConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationHealthcareDirectiveClientConfigurationInput = {
  create: CreatePresentationHealthcareDirectiveClientConfigurationInput;
  withBundleConfiguration?: InputMaybe<AugmentedCreatePresentationHealthcareDirectiveBundleConfigurationInput>;
  withHealthcareDirectiveItems?: InputMaybe<Array<AugmentedCreatePresentationHealthcareDirectiveItemInput>>;
};

/**
 * AugmentedCreatePresentationHealthcareDirectiveItemInput is used for create PresentationHealthcareDirectiveItem object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationHealthcareDirectiveItemInput = {
  create: CreatePresentationHealthcareDirectiveItemInput;
  withCitations?: InputMaybe<Array<AugmentedCreatePresentationItemCitationInput>>;
  withClientConfiguration?: InputMaybe<AugmentedCreatePresentationHealthcareDirectiveClientConfigurationInput>;
};

/**
 * AugmentedCreatePresentationItemCitationInput is used for create PresentationItemCitation object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationItemCitationInput = {
  create: CreatePresentationItemCitationInput;
};

/**
 * AugmentedCreatePresentationPageInput is used for create PresentationPage object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationPageInput = {
  create: CreatePresentationPageInput;
  withActiveEstateInsightsPage?: InputMaybe<AugmentedCreateActiveEstateInsightsPageInput>;
  withBalanceSheetBundleConfiguration?: InputMaybe<AugmentedCreateBalanceSheetBundleConfigurationInput>;
  withBeneficiaryPage?: InputMaybe<AugmentedCreateBeneficiaryPageInput>;
  withCompletedEstateInsightsPage?: InputMaybe<AugmentedCreateCompletedEstateInsightsPageInput>;
  withCoverPage?: InputMaybe<AugmentedCreatePresentationCoverPageInput>;
  withCustomPage?: InputMaybe<AugmentedCreatePresentationCustomPageInput>;
  withDiagramPage?: InputMaybe<AugmentedCreatePresentationDiagramPageInput>;
  withDocumentSummaryPage?: InputMaybe<AugmentedCreateDocumentSummaryPageInput>;
  withMissingDocumentsPage?: InputMaybe<AugmentedCreateMissingDocumentsPageInput>;
  withPresentationBundleCoverPage?: InputMaybe<AugmentedCreatePresentationBundleCoverPageInput>;
  withWaterfallBundleCoverPage?: InputMaybe<AugmentedCreateWaterfallBundleCoverPageInput>;
};

/**
 * AugmentedCreatePresentationPlanningOpportunitiesBundleConfigurationInput is used for create PresentationPlanningOpportunitiesBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationPlanningOpportunitiesBundleConfigurationInput = {
  create: CreatePresentationPlanningOpportunitiesBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
  withItems?: InputMaybe<Array<AugmentedCreatePresentationPlanningOpportunitiesItemInput>>;
};

/**
 * AugmentedCreatePresentationPlanningOpportunitiesItemInput is used for create PresentationPlanningOpportunitiesItem object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationPlanningOpportunitiesItemInput = {
  create: CreatePresentationPlanningOpportunitiesItemInput;
  withBundleConfiguration?: InputMaybe<AugmentedCreatePresentationPlanningOpportunitiesBundleConfigurationInput>;
};

/**
 * AugmentedCreatePresentationPowerOfAttorneyBundleConfigurationInput is used for create PresentationPowerOfAttorneyBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationPowerOfAttorneyBundleConfigurationInput = {
  create: CreatePresentationPowerOfAttorneyBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
  withClients?: InputMaybe<Array<AugmentedCreatePresentationPowerOfAttorneyClientConfigurationInput>>;
};

/**
 * AugmentedCreatePresentationPowerOfAttorneyClientConfigurationInput is used for create PresentationPowerOfAttorneyClientConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationPowerOfAttorneyClientConfigurationInput = {
  create: CreatePresentationPowerOfAttorneyClientConfigurationInput;
  withBundleConfiguration?: InputMaybe<AugmentedCreatePresentationPowerOfAttorneyBundleConfigurationInput>;
  withPowerOfAttorneyItems?: InputMaybe<Array<AugmentedCreatePresentationPowerOfAttorneyItemInput>>;
};

/**
 * AugmentedCreatePresentationPowerOfAttorneyItemInput is used for create PresentationPowerOfAttorneyItem object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationPowerOfAttorneyItemInput = {
  create: CreatePresentationPowerOfAttorneyItemInput;
  withCitations?: InputMaybe<Array<AugmentedCreatePresentationItemCitationInput>>;
  withClientConfiguration?: InputMaybe<AugmentedCreatePresentationPowerOfAttorneyClientConfigurationInput>;
};

/**
 * AugmentedCreatePresentationTemplateBundleInput is used for create PresentationTemplateBundle object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationTemplateBundleInput = {
  create: CreatePresentationTemplateBundleInput;
  withBeneficiariesTemplateBundleConfiguration?: InputMaybe<AugmentedCreateBeneficiariesTemplateBundleConfigurationInput>;
  withDividerTemplateBundleConfiguration?: InputMaybe<AugmentedCreateDividerTemplateBundleConfigurationInput>;
  withDocumentSummaryTemplateBundleConfiguration?: InputMaybe<AugmentedCreateDocumentSummaryTemplateBundleConfigurationInput>;
  withEntitySummaryTemplateBundleConfiguration?: InputMaybe<AugmentedCreateEntitySummaryTemplateBundleConfigurationInput>;
  withInsightsTemplateBundleConfiguration?: InputMaybe<AugmentedCreateInsightsTemplateBundleConfigurationInput>;
  withPages?: InputMaybe<Array<AugmentedCreatePresentationTemplatePageInput>>;
  withWaterfallComparisonTemplateBundleConfiguration?: InputMaybe<AugmentedCreateWaterfallComparisonTemplateBundleConfigurationInput>;
  withWaterfallTemplateBundleConfiguration?: InputMaybe<AugmentedCreateWaterfallTemplateBundleConfigurationInput>;
};

/**
 * AugmentedCreatePresentationTemplateCoverPageInput is used for create PresentationTemplateCoverPage object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationTemplateCoverPageInput = {
  create: CreatePresentationTemplateCoverPageInput;
  withTemplatePage?: InputMaybe<AugmentedCreatePresentationTemplatePageInput>;
};

/**
 * AugmentedCreatePresentationTemplateCustomPageInput is used for create PresentationTemplateCustomPage object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationTemplateCustomPageInput = {
  create: CreatePresentationTemplateCustomPageInput;
  withTemplatePage?: InputMaybe<AugmentedCreatePresentationTemplatePageInput>;
};

/**
 * AugmentedCreatePresentationTemplateDiagramPageInput is used for create PresentationTemplateDiagramPage object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationTemplateDiagramPageInput = {
  create: CreatePresentationTemplateDiagramPageInput;
  withTemplatePage?: InputMaybe<AugmentedCreatePresentationTemplatePageInput>;
};

/**
 * AugmentedCreatePresentationTemplateInput is used for create PresentationTemplate object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationTemplateInput = {
  create: CreatePresentationTemplateInput;
  withBundles?: InputMaybe<Array<AugmentedCreatePresentationTemplateBundleInput>>;
};

/**
 * AugmentedCreatePresentationTemplatePageInput is used for create PresentationTemplatePage object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationTemplatePageInput = {
  create: CreatePresentationTemplatePageInput;
  withCoverPage?: InputMaybe<AugmentedCreatePresentationTemplateCoverPageInput>;
  withCustomPage?: InputMaybe<AugmentedCreatePresentationTemplateCustomPageInput>;
  withDiagramPage?: InputMaybe<AugmentedCreatePresentationTemplateDiagramPageInput>;
};

/**
 * AugmentedCreatePresentationTrustOverviewBundleConfigurationInput is used for create PresentationTrustOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationTrustOverviewBundleConfigurationInput = {
  create: CreatePresentationTrustOverviewBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
  withTrusts?: InputMaybe<Array<AugmentedCreatePresentationTrustOverviewTrustConfigurationInput>>;
};

/**
 * AugmentedCreatePresentationTrustOverviewItemInput is used for create PresentationTrustOverviewItem object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationTrustOverviewItemInput = {
  create: CreatePresentationTrustOverviewItemInput;
  withCitations?: InputMaybe<Array<AugmentedCreatePresentationItemCitationInput>>;
  withTrustConfiguration?: InputMaybe<AugmentedCreatePresentationTrustOverviewTrustConfigurationInput>;
};

/**
 * AugmentedCreatePresentationTrustOverviewTrustConfigurationInput is used for create PresentationTrustOverviewTrustConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationTrustOverviewTrustConfigurationInput = {
  create: CreatePresentationTrustOverviewTrustConfigurationInput;
  withBundleConfiguration?: InputMaybe<AugmentedCreatePresentationTrustOverviewBundleConfigurationInput>;
  withTrustItems?: InputMaybe<Array<AugmentedCreatePresentationTrustOverviewItemInput>>;
};

/**
 * AugmentedCreatePresentationWillBundleConfigurationInput is used for create PresentationWillBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationWillBundleConfigurationInput = {
  create: CreatePresentationWillBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
  withClients?: InputMaybe<Array<AugmentedCreatePresentationWillClientConfigurationInput>>;
};

/**
 * AugmentedCreatePresentationWillClientConfigurationInput is used for create PresentationWillClientConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationWillClientConfigurationInput = {
  create: CreatePresentationWillClientConfigurationInput;
  withBundleConfiguration?: InputMaybe<AugmentedCreatePresentationWillBundleConfigurationInput>;
  withWillItems?: InputMaybe<Array<AugmentedCreatePresentationWillItemInput>>;
};

/**
 * AugmentedCreatePresentationWillItemInput is used for create PresentationWillItem object.
 * Input was generated by ent.
 */
export type AugmentedCreatePresentationWillItemInput = {
  create: CreatePresentationWillItemInput;
  withCitations?: InputMaybe<Array<AugmentedCreatePresentationItemCitationInput>>;
  withClientConfiguration?: InputMaybe<AugmentedCreatePresentationWillClientConfigurationInput>;
};

/**
 * AugmentedCreatePrincipalInput is used for create Principal object.
 * Input was generated by ent.
 */
export type AugmentedCreatePrincipalInput = {
  create: CreatePrincipalInput;
};

/**
 * AugmentedCreatePrivateFoundationInput is used for create PrivateFoundation object.
 * Input was generated by ent.
 */
export type AugmentedCreatePrivateFoundationInput = {
  create: CreatePrivateFoundationInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withDonors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedCreateProfessionalTeamRoleInput is used for create ProfessionalTeamRole object.
 * Input was generated by ent.
 */
export type AugmentedCreateProfessionalTeamRoleInput = {
  create: CreateProfessionalTeamRoleInput;
  withIndividual?: InputMaybe<AugmentedCreateClientProfileInput>;
  withOrganization?: InputMaybe<AugmentedCreateClientOrganizationInput>;
};

/**
 * AugmentedCreateProposalInput is used for create Proposal object.
 * Input was generated by ent.
 */
export type AugmentedCreateProposalInput = {
  create: CreateProposalInput;
  withCltProposal?: InputMaybe<AugmentedCreateCltProposalInput>;
  withCrtProposal?: InputMaybe<AugmentedCreateCrtProposalInput>;
  withEntityProposals?: InputMaybe<Array<AugmentedCreateEntityProposalInput>>;
  withGiftingProposal?: InputMaybe<AugmentedCreateGiftingProposalInput>;
};

/**
 * AugmentedCreateProposalScenarioInput is used for create ProposalScenario object.
 * Input was generated by ent.
 */
export type AugmentedCreateProposalScenarioInput = {
  create: CreateProposalScenarioInput;
  withGratProposalScenario?: InputMaybe<AugmentedCreateGratProposalScenarioInput>;
};

/**
 * AugmentedCreateQPRTTrustInput is used for create QPRTTrust object.
 * Input was generated by ent.
 */
export type AugmentedCreateQprtTrustInput = {
  create: CreateQprtTrustInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withGrantors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedCreateQualifiedTuitionPersonalAccountInput is used for create QualifiedTuitionPersonalAccount object.
 * Input was generated by ent.
 */
export type AugmentedCreateQualifiedTuitionPersonalAccountInput = {
  create: CreateQualifiedTuitionPersonalAccountInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withOwner?: InputMaybe<AugmentedCreatePrincipalInput>;
};

/**
 * AugmentedCreateRetirementPersonalAccountInput is used for create RetirementPersonalAccount object.
 * Input was generated by ent.
 */
export type AugmentedCreateRetirementPersonalAccountInput = {
  create: CreateRetirementPersonalAccountInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withBeneficiaryDesignationGroups?: InputMaybe<Array<AugmentedCreateBeneficiaryDesignationGroupInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withHypotheticalBeneficiaryDesignationGroups?: InputMaybe<Array<AugmentedCreateBeneficiaryDesignationGroupInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withOwner?: InputMaybe<AugmentedCreatePrincipalInput>;
};

/**
 * AugmentedCreateRevocableTrustInput is used for create RevocableTrust object.
 * Input was generated by ent.
 */
export type AugmentedCreateRevocableTrustInput = {
  create: CreateRevocableTrustInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withGrantors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedCreateRoleInput is used for create Role object.
 * Input was generated by ent.
 */
export type AugmentedCreateRoleInput = {
  create: CreateRoleInput;
};

/**
 * AugmentedCreateSCorpBusinessEntityInput is used for create SCorpBusinessEntity object.
 * Input was generated by ent.
 */
export type AugmentedCreateSCorpBusinessEntityInput = {
  create: CreateSCorpBusinessEntityInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withKeyPeople?: InputMaybe<Array<AugmentedCreateKeyPersonInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedCreateSLATTrustInput is used for create SLATTrust object.
 * Input was generated by ent.
 */
export type AugmentedCreateSlatTrustInput = {
  create: CreateSlatTrustInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withGrantor?: InputMaybe<AugmentedCreatePrincipalInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withLifetimeBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
  withRemainderBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedCreateSSOConnectionInput is used for create SSOConnection object.
 * Input was generated by ent.
 */
export type AugmentedCreateSsoConnectionInput = {
  create: CreateSsoConnectionInput;
};

/**
 * AugmentedCreateScheduledDistributionInput is used for create ScheduledDistribution object.
 * Input was generated by ent.
 */
export type AugmentedCreateScheduledDistributionInput = {
  create: CreateScheduledDistributionInput;
};

/**
 * AugmentedCreateSoleProprietorshipBusinessEntityInput is used for create SoleProprietorshipBusinessEntity object.
 * Input was generated by ent.
 */
export type AugmentedCreateSoleProprietorshipBusinessEntityInput = {
  create: CreateSoleProprietorshipBusinessEntityInput;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withKeyPeople?: InputMaybe<Array<AugmentedCreateKeyPersonInput>>;
};

/**
 * AugmentedCreateSubBrandDisclaimerConfigurationInput is used for create SubBrandDisclaimerConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateSubBrandDisclaimerConfigurationInput = {
  create: CreateSubBrandDisclaimerConfigurationInput;
};

/**
 * AugmentedCreateSubBrandInput is used for create SubBrand object.
 * Input was generated by ent.
 */
export type AugmentedCreateSubBrandInput = {
  create: CreateSubBrandInput;
};

/**
 * AugmentedCreateTaxDragConfigInput is used for create TaxDragConfig object.
 * Input was generated by ent.
 */
export type AugmentedCreateTaxDragConfigInput = {
  create: CreateTaxDragConfigInput;
  withGrowthProfile?: InputMaybe<AugmentedCreateGrowthProfileInput>;
};

/**
 * AugmentedCreateTaxDragOverrideInput is used for create TaxDragOverride object.
 * Input was generated by ent.
 */
export type AugmentedCreateTaxDragOverrideInput = {
  create: CreateTaxDragOverrideInput;
  withGrowthProfile?: InputMaybe<AugmentedCreateGrowthProfileInput>;
};

/**
 * AugmentedCreateTeamInput is used for create Team object.
 * Input was generated by ent.
 */
export type AugmentedCreateTeamInput = {
  create: CreateTeamInput;
};

/**
 * AugmentedCreateTenantBrandingInput is used for create TenantBranding object.
 * Input was generated by ent.
 */
export type AugmentedCreateTenantBrandingInput = {
  create: CreateTenantBrandingInput;
};

/**
 * AugmentedCreateTenantDocumentInput is used for create TenantDocument object.
 * Input was generated by ent.
 */
export type AugmentedCreateTenantDocumentInput = {
  create: CreateTenantDocumentInput;
};

/**
 * AugmentedCreateTenantInput is used for create Tenant object.
 * Input was generated by ent.
 */
export type AugmentedCreateTenantInput = {
  create: CreateTenantInput;
};

/**
 * AugmentedCreateTenantSSOConnectionInput is used for create TenantSSOConnection object.
 * Input was generated by ent.
 */
export type AugmentedCreateTenantSsoConnectionInput = {
  create: CreateTenantSsoConnectionInput;
};

/**
 * AugmentedCreateTenantSlideConfigInput is used for create TenantSlideConfig object.
 * Input was generated by ent.
 */
export type AugmentedCreateTenantSlideConfigInput = {
  create: CreateTenantSlideConfigInput;
};

/**
 * AugmentedCreateTestCMKEncryptionInput is used for create TestCMKEncryption object.
 * Input was generated by ent.
 */
export type AugmentedCreateTestCmkEncryptionInput = {
  create: CreateTestCmkEncryptionInput;
};

/**
 * AugmentedCreateTestamentaryEntityInput is used for create TestamentaryEntity object.
 * Input was generated by ent.
 */
export type AugmentedCreateTestamentaryEntityInput = {
  create: CreateTestamentaryEntityInput;
  withAccountOwner?: InputMaybe<AugmentedCreateClientProfileInput>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withBeneficiariesAfterBothGrantorDeaths?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withDispositiveProvisions?: InputMaybe<Array<AugmentedCreateDispositiveProvisionInput>>;
  withDispositiveProvisionsTemplate?: InputMaybe<AugmentedCreateDispositiveProvisionTemplateInput>;
  withEntityDocumentRelationships?: InputMaybe<Array<AugmentedCreateEntityDocumentRelationshipInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalDispositiveProvisions?: InputMaybe<Array<AugmentedCreateDispositiveProvisionInput>>;
  withHypotheticalDispositiveProvisionsTemplates?: InputMaybe<Array<AugmentedCreateHypotheticalWaterfallDispositiveProvisionTemplateInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTaxInfo?: InputMaybe<AugmentedCreateEntityTaxInfoInput>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedCreateTrustAdvisorInput is used for create TrustAdvisor object.
 * Input was generated by ent.
 */
export type AugmentedCreateTrustAdvisorInput = {
  create: CreateTrustAdvisorInput;
  withRoles?: InputMaybe<Array<AugmentedCreateTrustAdvisorRoleInput>>;
};

/**
 * AugmentedCreateTrustAdvisorRoleInput is used for create TrustAdvisorRole object.
 * Input was generated by ent.
 */
export type AugmentedCreateTrustAdvisorRoleInput = {
  create: CreateTrustAdvisorRoleInput;
  withTrustAdvisor?: InputMaybe<AugmentedCreateTrustAdvisorInput>;
};

/**
 * AugmentedCreateTrusteeDutyInput is used for create TrusteeDuty object.
 * Input was generated by ent.
 */
export type AugmentedCreateTrusteeDutyInput = {
  create: CreateTrusteeDutyInput;
  withTrustee?: InputMaybe<AugmentedCreateTrusteeInput>;
};

/**
 * AugmentedCreateTrusteeInput is used for create Trustee object.
 * Input was generated by ent.
 */
export type AugmentedCreateTrusteeInput = {
  create: CreateTrusteeInput;
  withDuties?: InputMaybe<Array<AugmentedCreateTrusteeDutyInput>>;
};

/**
 * AugmentedCreateUserFeedbackInput is used for create UserFeedback object.
 * Input was generated by ent.
 */
export type AugmentedCreateUserFeedbackInput = {
  create: CreateUserFeedbackInput;
};

/**
 * AugmentedCreateUserInput is used for create User object.
 * Input was generated by ent.
 */
export type AugmentedCreateUserInput = {
  create: CreateUserInput;
};

/**
 * AugmentedCreateUserNotificationConfigurationInput is used for create UserNotificationConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateUserNotificationConfigurationInput = {
  create: CreateUserNotificationConfigurationInput;
};

/**
 * AugmentedCreateWaterfallBundleConfigurationInput is used for create WaterfallBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateWaterfallBundleConfigurationInput = {
  create: CreateWaterfallBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
};

/**
 * AugmentedCreateWaterfallBundleCoverPageInput is used for create WaterfallBundleCoverPage object.
 * Input was generated by ent.
 */
export type AugmentedCreateWaterfallBundleCoverPageInput = {
  create: CreateWaterfallBundleCoverPageInput;
};

/**
 * AugmentedCreateWaterfallComparisonBundleConfigurationInput is used for create WaterfallComparisonBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateWaterfallComparisonBundleConfigurationInput = {
  create: CreateWaterfallComparisonBundleConfigurationInput;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
  withComparedWaterfalls?: InputMaybe<Array<AugmentedCreateComparedWaterfallInput>>;
};

/**
 * AugmentedCreateWaterfallComparisonTemplateBundleConfigurationInput is used for create WaterfallComparisonTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateWaterfallComparisonTemplateBundleConfigurationInput = {
  create: CreateWaterfallComparisonTemplateBundleConfigurationInput;
  withTemplateBundle?: InputMaybe<AugmentedCreatePresentationTemplateBundleInput>;
};

/**
 * AugmentedCreateWaterfallTemplateBundleConfigurationInput is used for create WaterfallTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedCreateWaterfallTemplateBundleConfigurationInput = {
  create: CreateWaterfallTemplateBundleConfigurationInput;
  withTemplateBundle?: InputMaybe<AugmentedCreatePresentationTemplateBundleInput>;
};

export type AugmentedSetGratTrustAnnuityV2PaidInput = {
  annuityId: Scalars['ID']['input'];
  assetValuation: AugmentedCreateAssetValuationV2Input;
  failedAnnuityPaymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
};

/**
 * AugmentedUpdateAISuggestionInput is used for update AISuggestion object.
 * Input was generated by ent.
 */
export type AugmentedUpdateAiSuggestionInput = {
  id: Scalars['ID']['input'];
  update: UpdateAiSuggestionInput;
};

/**
 * AugmentedUpdateAccessAgeParameterInput is used for update AccessAgeParameter object.
 * Input was generated by ent.
 */
export type AugmentedUpdateAccessAgeParameterInput = {
  id: Scalars['ID']['input'];
  update: UpdateAccessAgeParameterInput;
};

/**
 * AugmentedUpdateAccessParameterInput is used for update AccessParameter object.
 * Input was generated by ent.
 */
export type AugmentedUpdateAccessParameterInput = {
  id: Scalars['ID']['input'];
  update: UpdateAccessParameterInput;
  updateAccessAgeParameters?: InputMaybe<Array<AugmentedUpdateAccessAgeParameterInput>>;
  withAccessAgeParameters?: InputMaybe<Array<AugmentedCreateAccessAgeParameterInput>>;
};

/**
 * AugmentedUpdateAccountInput is used for update Account object.
 * Input was generated by ent.
 */
export type AugmentedUpdateAccountInput = {
  id: Scalars['ID']['input'];
  update: UpdateAccountInput;
  updateInitialValuation?: InputMaybe<AugmentedUpdateAssetValuationV2Input>;
  updateValuations?: InputMaybe<Array<AugmentedUpdateAssetValuationV2Input>>;
  withInitialValuation?: InputMaybe<AugmentedCreateAssetValuationV2Input>;
  withValuations?: InputMaybe<Array<AugmentedCreateAssetValuationV2Input>>;
};

/**
 * AugmentedUpdateActiveEstateInsightsPageInput is used for update ActiveEstateInsightsPage object.
 * Input was generated by ent.
 */
export type AugmentedUpdateActiveEstateInsightsPageInput = {
  id: Scalars['ID']['input'];
  update: UpdateActiveEstateInsightsPageInput;
};

/**
 * AugmentedUpdateAddressInput is used for update Address object.
 * Input was generated by ent.
 */
export type AugmentedUpdateAddressInput = {
  id: Scalars['ID']['input'];
  update: UpdateAddressInput;
};

/**
 * AugmentedUpdateAssetClassInput is used for update AssetClass object.
 * Input was generated by ent.
 */
export type AugmentedUpdateAssetClassInput = {
  id: Scalars['ID']['input'];
  update: UpdateAssetClassInput;
  updateBalanceSheetCategory?: InputMaybe<AugmentedUpdateBalanceSheetCategoryInput>;
  updateIntegrationAssetClasses?: InputMaybe<Array<AugmentedUpdateIntegrationAssetClassInput>>;
  withBalanceSheetCategory?: InputMaybe<AugmentedCreateBalanceSheetCategoryInput>;
  withIntegrationAssetClasses?: InputMaybe<Array<AugmentedCreateIntegrationAssetClassInput>>;
};

/**
 * AugmentedUpdateAssetGroupInput is used for update AssetGroup object.
 * Input was generated by ent.
 */
export type AugmentedUpdateAssetGroupInput = {
  id: Scalars['ID']['input'];
  update: UpdateAssetGroupInput;
};

/**
 * AugmentedUpdateAssetStaticInput is used for update AssetStatic object.
 * Input was generated by ent.
 */
export type AugmentedUpdateAssetStaticInput = {
  id: Scalars['ID']['input'];
  update: UpdateAssetStaticInput;
};

/**
 * AugmentedUpdateAssetV2Input is used for update AssetV2 object.
 * Input was generated by ent.
 */
export type AugmentedUpdateAssetV2Input = {
  id: Scalars['ID']['input'];
  update: UpdateAssetV2Input;
  updateAssetStatic?: InputMaybe<AugmentedUpdateAssetStaticInput>;
  updateAssetValue?: InputMaybe<AugmentedUpdateAssetValueV2Input>;
  withAssetStatic?: InputMaybe<AugmentedCreateAssetStaticInput>;
};

/**
 * AugmentedUpdateAssetValuationV2Input is used for update AssetValuationV2 object.
 * Input was generated by ent.
 */
export type AugmentedUpdateAssetValuationV2Input = {
  id: Scalars['ID']['input'];
  update: UpdateAssetValuationV2Input;
  updateAssets?: InputMaybe<Array<AugmentedUpdateAssetV2Input>>;
  withAssets?: InputMaybe<Array<AugmentedCreateAssetV2Input>>;
};

/**
 * AugmentedUpdateAssetValueV2Input is used for update AssetValueV2 object.
 * Input was generated by ent.
 */
export type AugmentedUpdateAssetValueV2Input = {
  id: Scalars['ID']['input'];
  update: UpdateAssetValueV2Input;
};

/**
 * AugmentedUpdateBalanceSheetBundleConfigurationInput is used for update BalanceSheetBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateBalanceSheetBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateBalanceSheetBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
  updatePage?: InputMaybe<AugmentedUpdatePresentationPageInput>;
};

/**
 * AugmentedUpdateBalanceSheetCategoryInput is used for update BalanceSheetCategory object.
 * Input was generated by ent.
 */
export type AugmentedUpdateBalanceSheetCategoryInput = {
  id: Scalars['ID']['input'];
  update: UpdateBalanceSheetCategoryInput;
  updateAssetClasses?: InputMaybe<Array<AugmentedUpdateAssetClassInput>>;
  withAssetClasses?: InputMaybe<Array<AugmentedCreateAssetClassInput>>;
};

/**
 * AugmentedUpdateBalanceSheetViewConfigurationInput is used for update BalanceSheetViewConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateBalanceSheetViewConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateBalanceSheetViewConfigurationInput;
};

/**
 * AugmentedUpdateBeneficiariesBundleConfigurationInput is used for update BeneficiariesBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateBeneficiariesBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateBeneficiariesBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
};

/**
 * AugmentedUpdateBeneficiariesTemplateBundleConfigurationInput is used for update BeneficiariesTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateBeneficiariesTemplateBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateBeneficiariesTemplateBundleConfigurationInput;
  updateTemplateBundle?: InputMaybe<AugmentedUpdatePresentationTemplateBundleInput>;
};

/**
 * AugmentedUpdateBeneficiaryAccessParameterInput is used for update BeneficiaryAccessParameter object.
 * Input was generated by ent.
 */
export type AugmentedUpdateBeneficiaryAccessParameterInput = {
  id: Scalars['ID']['input'];
  update: UpdateBeneficiaryAccessParameterInput;
};

/**
 * AugmentedUpdateBeneficiaryDesignationGroupInput is used for update BeneficiaryDesignationGroup object.
 * Input was generated by ent.
 */
export type AugmentedUpdateBeneficiaryDesignationGroupInput = {
  id: Scalars['ID']['input'];
  update: UpdateBeneficiaryDesignationGroupInput;
  updateDispositiveProvisions?: InputMaybe<Array<AugmentedUpdateDispositiveProvisionInput>>;
  withDispositiveProvisions?: InputMaybe<Array<AugmentedCreateDispositiveProvisionInput>>;
};

/**
 * AugmentedUpdateBeneficiaryDistributionInput is used for update BeneficiaryDistribution object.
 * Input was generated by ent.
 */
export type AugmentedUpdateBeneficiaryDistributionInput = {
  id: Scalars['ID']['input'];
  update: UpdateBeneficiaryDistributionInput;
  updateDistributionParameters?: InputMaybe<Array<AugmentedUpdateBeneficiaryDistributionParameterInput>>;
  withDistributionParameters?: InputMaybe<Array<AugmentedCreateBeneficiaryDistributionParameterInput>>;
};

/**
 * AugmentedUpdateBeneficiaryDistributionParameterInput is used for update BeneficiaryDistributionParameter object.
 * Input was generated by ent.
 */
export type AugmentedUpdateBeneficiaryDistributionParameterInput = {
  id: Scalars['ID']['input'];
  update: UpdateBeneficiaryDistributionParameterInput;
  updateDistribution?: InputMaybe<AugmentedUpdateBeneficiaryDistributionInput>;
};

/**
 * AugmentedUpdateBeneficiaryInput is used for update Beneficiary object.
 * Input was generated by ent.
 */
export type AugmentedUpdateBeneficiaryInput = {
  id: Scalars['ID']['input'];
  update: UpdateBeneficiaryInput;
  updateAccessParameters?: InputMaybe<Array<AugmentedUpdateAccessParameterInput>>;
  updateDistributions?: InputMaybe<Array<AugmentedUpdateBeneficiaryDistributionInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateIndividual?: InputMaybe<AugmentedUpdateClientProfileInput>;
  updateOrganization?: InputMaybe<AugmentedUpdateClientOrganizationInput>;
  updatePowerOfAppointment?: InputMaybe<AugmentedUpdateBeneficiaryPowerOfAppointmentInput>;
  updateScheduledDistributions?: InputMaybe<Array<AugmentedUpdateScheduledDistributionInput>>;
  updateTestamentaryEntity?: InputMaybe<AugmentedUpdateTestamentaryEntityInput>;
  withAccessParameters?: InputMaybe<Array<AugmentedCreateAccessParameterInput>>;
  withDistributions?: InputMaybe<Array<AugmentedCreateBeneficiaryDistributionInput>>;
  withPowerOfAppointment?: InputMaybe<AugmentedCreateBeneficiaryPowerOfAppointmentInput>;
  withScheduledDistributions?: InputMaybe<Array<AugmentedCreateScheduledDistributionInput>>;
};

/**
 * AugmentedUpdateBeneficiaryPageInput is used for update BeneficiaryPage object.
 * Input was generated by ent.
 */
export type AugmentedUpdateBeneficiaryPageInput = {
  id: Scalars['ID']['input'];
  update: UpdateBeneficiaryPageInput;
  updatePresentationPage?: InputMaybe<AugmentedUpdatePresentationPageInput>;
};

/**
 * AugmentedUpdateBeneficiaryPowerOfAppointmentInput is used for update BeneficiaryPowerOfAppointment object.
 * Input was generated by ent.
 */
export type AugmentedUpdateBeneficiaryPowerOfAppointmentInput = {
  id: Scalars['ID']['input'];
  update: UpdateBeneficiaryPowerOfAppointmentInput;
};

/**
 * AugmentedUpdateCCorpBusinessEntityInput is used for update CCorpBusinessEntity object.
 * Input was generated by ent.
 */
export type AugmentedUpdateCCorpBusinessEntityInput = {
  id: Scalars['ID']['input'];
  update: UpdateCCorpBusinessEntityInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateKeyPeople?: InputMaybe<Array<AugmentedUpdateKeyPersonInput>>;
  updatePolicies?: InputMaybe<Array<AugmentedUpdateInsurancePolicyInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withKeyPeople?: InputMaybe<Array<AugmentedCreateKeyPersonInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedUpdateCLTProposalInput is used for update CLTProposal object.
 * Input was generated by ent.
 */
export type AugmentedUpdateCltProposalInput = {
  id: Scalars['ID']['input'];
  update: UpdateCltProposalInput;
  updateCharitableIncomeBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateProposal?: InputMaybe<AugmentedUpdateProposalInput>;
  updateRemainderBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  withCharitableIncomeBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withRemainderBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
};

/**
 * AugmentedUpdateCLTTrustInput is used for update CLTTrust object.
 * Input was generated by ent.
 */
export type AugmentedUpdateCltTrustInput = {
  id: Scalars['ID']['input'];
  update: UpdateCltTrustInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateGrantors?: InputMaybe<Array<AugmentedUpdatePrincipalInput>>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateLifetimeBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updatePolicies?: InputMaybe<Array<AugmentedUpdateInsurancePolicyInput>>;
  updateRemainderBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateSuccessorTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  updateTrustAdvisors?: InputMaybe<Array<AugmentedUpdateTrustAdvisorInput>>;
  updateTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withGrantors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withLifetimeBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
  withRemainderBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedUpdateCRTProposalInput is used for update CRTProposal object.
 * Input was generated by ent.
 */
export type AugmentedUpdateCrtProposalInput = {
  id: Scalars['ID']['input'];
  update: UpdateCrtProposalInput;
  updateCharitableRemainderBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateIncomeBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateProposal?: InputMaybe<AugmentedUpdateProposalInput>;
  withCharitableRemainderBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withIncomeBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
};

/**
 * AugmentedUpdateCRTTrustInput is used for update CRTTrust object.
 * Input was generated by ent.
 */
export type AugmentedUpdateCrtTrustInput = {
  id: Scalars['ID']['input'];
  update: UpdateCrtTrustInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateGrantors?: InputMaybe<Array<AugmentedUpdatePrincipalInput>>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateLifetimeBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updatePolicies?: InputMaybe<Array<AugmentedUpdateInsurancePolicyInput>>;
  updateRemainderBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateSuccessorTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  updateTrustAdvisors?: InputMaybe<Array<AugmentedUpdateTrustAdvisorInput>>;
  updateTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withGrantors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withLifetimeBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
  withRemainderBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedUpdateCashflowInput is used for update Cashflow object.
 * Input was generated by ent.
 */
export type AugmentedUpdateCashflowInput = {
  id: Scalars['ID']['input'];
  update: UpdateCashflowInput;
};

/**
 * AugmentedUpdateClientOrganizationInput is used for update ClientOrganization object.
 * Input was generated by ent.
 */
export type AugmentedUpdateClientOrganizationInput = {
  id: Scalars['ID']['input'];
  update: UpdateClientOrganizationInput;
  updateAddress?: InputMaybe<AugmentedUpdateAddressInput>;
  updateProfessionalTeamRoles?: InputMaybe<Array<AugmentedUpdateProfessionalTeamRoleInput>>;
  withAddress?: InputMaybe<AugmentedCreateAddressInput>;
  withProfessionalTeamRoles?: InputMaybe<Array<AugmentedCreateProfessionalTeamRoleInput>>;
};

/**
 * AugmentedUpdateClientPresentationV2Input is used for update ClientPresentationV2 object.
 * Input was generated by ent.
 */
export type AugmentedUpdateClientPresentationV2Input = {
  id: Scalars['ID']['input'];
  update: UpdateClientPresentationV2Input;
  updateBundles?: InputMaybe<Array<AugmentedUpdatePresentationBundleInput>>;
  withBundles?: InputMaybe<Array<AugmentedCreatePresentationBundleInput>>;
};

/**
 * AugmentedUpdateClientProfileInput is used for update ClientProfile object.
 * Input was generated by ent.
 */
export type AugmentedUpdateClientProfileInput = {
  id: Scalars['ID']['input'];
  update: UpdateClientProfileInput;
  updateAddress?: InputMaybe<AugmentedUpdateAddressInput>;
  updateCashflows?: InputMaybe<Array<AugmentedUpdateCashflowInput>>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateOwnedOwnershipStakes?: InputMaybe<Array<AugmentedUpdateOwnershipStakeInput>>;
  updateProfessionalTeamRoles?: InputMaybe<Array<AugmentedUpdateProfessionalTeamRoleInput>>;
  updateTestamentaryEntities?: InputMaybe<Array<AugmentedUpdateTestamentaryEntityInput>>;
  withAddress?: InputMaybe<AugmentedCreateAddressInput>;
  withCashflows?: InputMaybe<Array<AugmentedCreateCashflowInput>>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withOwnedOwnershipStakes?: InputMaybe<Array<AugmentedCreateOwnershipStakeInput>>;
  withProfessionalTeamRoles?: InputMaybe<Array<AugmentedCreateProfessionalTeamRoleInput>>;
  withTestamentaryEntities?: InputMaybe<Array<AugmentedCreateTestamentaryEntityInput>>;
};

/**
 * AugmentedUpdateClientProfileRelationshipInput is used for update ClientProfileRelationship object.
 * Input was generated by ent.
 */
export type AugmentedUpdateClientProfileRelationshipInput = {
  id: Scalars['ID']['input'];
  update: UpdateClientProfileRelationshipInput;
};

/**
 * AugmentedUpdateCollaboratorInput is used for update Collaborator object.
 * Input was generated by ent.
 */
export type AugmentedUpdateCollaboratorInput = {
  id: Scalars['ID']['input'];
  update: UpdateCollaboratorInput;
};

/**
 * AugmentedUpdateComparedWaterfallInput is used for update ComparedWaterfall object.
 * Input was generated by ent.
 */
export type AugmentedUpdateComparedWaterfallInput = {
  id: Scalars['ID']['input'];
  update: UpdateComparedWaterfallInput;
};

/**
 * AugmentedUpdateCompletedEstateInsightsPageInput is used for update CompletedEstateInsightsPage object.
 * Input was generated by ent.
 */
export type AugmentedUpdateCompletedEstateInsightsPageInput = {
  id: Scalars['ID']['input'];
  update: UpdateCompletedEstateInsightsPageInput;
};

/**
 * AugmentedUpdateControllingPartyInput is used for update ControllingParty object.
 * Input was generated by ent.
 */
export type AugmentedUpdateControllingPartyInput = {
  id: Scalars['ID']['input'];
  update: UpdateControllingPartyInput;
};

/**
 * AugmentedUpdateCoverPageConfigurationInput is used for update CoverPageConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateCoverPageConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateCoverPageConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
  withBundle?: InputMaybe<AugmentedCreatePresentationBundleInput>;
};

/**
 * AugmentedUpdateCustodialPersonalAccountInput is used for update CustodialPersonalAccount object.
 * Input was generated by ent.
 */
export type AugmentedUpdateCustodialPersonalAccountInput = {
  id: Scalars['ID']['input'];
  update: UpdateCustodialPersonalAccountInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateControllingParties?: InputMaybe<Array<AugmentedUpdateControllingPartyInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateOwner?: InputMaybe<AugmentedUpdatePrincipalInput>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withOwner?: InputMaybe<AugmentedCreatePrincipalInput>;
};

/**
 * AugmentedUpdateDSUEPortabilityInput is used for update DSUEPortability object.
 * Input was generated by ent.
 */
export type AugmentedUpdateDsuePortabilityInput = {
  id: Scalars['ID']['input'];
  update: UpdateDsuePortabilityInput;
};

/**
 * AugmentedUpdateDispositionScenarioInput is used for update DispositionScenario object.
 * Input was generated by ent.
 */
export type AugmentedUpdateDispositionScenarioInput = {
  id: Scalars['ID']['input'];
  update: UpdateDispositionScenarioInput;
  updateDispositiveProvisions?: InputMaybe<Array<AugmentedUpdateDispositiveProvisionInput>>;
  updateDispositiveProvisionsTemplate?: InputMaybe<AugmentedUpdateDispositiveProvisionTemplateInput>;
  updateSecondDeathDispositiveProvisions?: InputMaybe<Array<AugmentedUpdateDispositiveProvisionInput>>;
  updateSecondDeathDispositiveProvisionsTemplate?: InputMaybe<AugmentedUpdateDispositiveProvisionTemplateInput>;
  withDispositiveProvisions?: InputMaybe<Array<AugmentedCreateDispositiveProvisionInput>>;
  withDispositiveProvisionsTemplate?: InputMaybe<AugmentedCreateDispositiveProvisionTemplateInput>;
  withSecondDeathDispositiveProvisions?: InputMaybe<Array<AugmentedCreateDispositiveProvisionInput>>;
  withSecondDeathDispositiveProvisionsTemplate?: InputMaybe<AugmentedCreateDispositiveProvisionTemplateInput>;
};

/**
 * AugmentedUpdateDispositiveProvisionInput is used for update DispositiveProvision object.
 * Input was generated by ent.
 */
export type AugmentedUpdateDispositiveProvisionInput = {
  id: Scalars['ID']['input'];
  update: UpdateDispositiveProvisionInput;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateIndividual?: InputMaybe<AugmentedUpdateClientProfileInput>;
  updateOrganization?: InputMaybe<AugmentedUpdateClientOrganizationInput>;
  updateTestamentaryEntity?: InputMaybe<AugmentedUpdateTestamentaryEntityInput>;
};

/**
 * AugmentedUpdateDispositiveProvisionTemplateInput is used for update DispositiveProvisionTemplate object.
 * Input was generated by ent.
 */
export type AugmentedUpdateDispositiveProvisionTemplateInput = {
  id: Scalars['ID']['input'];
  update: UpdateDispositiveProvisionTemplateInput;
  updateDispositiveProvisions?: InputMaybe<Array<AugmentedUpdateDispositiveProvisionInput>>;
  withDispositiveProvisions?: InputMaybe<Array<AugmentedCreateDispositiveProvisionInput>>;
};

/**
 * AugmentedUpdateDividerBundleConfigurationInput is used for update DividerBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateDividerBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateDividerBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
};

/**
 * AugmentedUpdateDividerTemplateBundleConfigurationInput is used for update DividerTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateDividerTemplateBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateDividerTemplateBundleConfigurationInput;
  updateTemplateBundle?: InputMaybe<AugmentedUpdatePresentationTemplateBundleInput>;
};

/**
 * AugmentedUpdateDocumentInput is used for update Document object.
 * Input was generated by ent.
 */
export type AugmentedUpdateDocumentInput = {
  id: Scalars['ID']['input'];
  update: UpdateDocumentInput;
};

/**
 * AugmentedUpdateDocumentSummaryInput is used for update DocumentSummary object.
 * Input was generated by ent.
 */
export type AugmentedUpdateDocumentSummaryInput = {
  id: Scalars['ID']['input'];
  update: UpdateDocumentSummaryInput;
};

/**
 * AugmentedUpdateDocumentSummaryPageInput is used for update DocumentSummaryPage object.
 * Input was generated by ent.
 */
export type AugmentedUpdateDocumentSummaryPageInput = {
  id: Scalars['ID']['input'];
  update: UpdateDocumentSummaryPageInput;
  updateRelevantClientProfiles?: InputMaybe<Array<AugmentedUpdateClientProfileInput>>;
  withRelevantClientProfiles?: InputMaybe<Array<AugmentedCreateClientProfileInput>>;
};

/**
 * AugmentedUpdateDocumentSummaryPromptInput is used for update DocumentSummaryPrompt object.
 * Input was generated by ent.
 */
export type AugmentedUpdateDocumentSummaryPromptInput = {
  id: Scalars['ID']['input'];
  update: UpdateDocumentSummaryPromptInput;
};

/**
 * AugmentedUpdateDocumentSummaryTemplateBundleConfigurationInput is used for update DocumentSummaryTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateDocumentSummaryTemplateBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateDocumentSummaryTemplateBundleConfigurationInput;
  updateTemplateBundle?: InputMaybe<AugmentedUpdatePresentationTemplateBundleInput>;
};

/**
 * AugmentedUpdateDonorAdvisedFundInput is used for update DonorAdvisedFund object.
 * Input was generated by ent.
 */
export type AugmentedUpdateDonorAdvisedFundInput = {
  id: Scalars['ID']['input'];
  update: UpdateDonorAdvisedFundInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateControllingParties?: InputMaybe<Array<AugmentedUpdateControllingPartyInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateDonors?: InputMaybe<Array<AugmentedUpdatePrincipalInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updatePolicies?: InputMaybe<Array<AugmentedUpdateInsurancePolicyInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withDonors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedUpdateEmployeeInput is used for update Employee object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEmployeeInput = {
  id: Scalars['ID']['input'];
  update: UpdateEmployeeInput;
};

/**
 * AugmentedUpdateEntitiesOverviewBundleConfigurationEntityInput is used for update EntitiesOverviewBundleConfigurationEntity object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEntitiesOverviewBundleConfigurationEntityInput = {
  id: Scalars['ID']['input'];
  update: UpdateEntitiesOverviewBundleConfigurationEntityInput;
  updateEntitiesOverviewBundleConfiguration?: InputMaybe<AugmentedUpdateEntitiesOverviewBundleConfigurationInput>;
};

/**
 * AugmentedUpdateEntitiesOverviewBundleConfigurationInput is used for update EntitiesOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEntitiesOverviewBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateEntitiesOverviewBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
  updateEntities?: InputMaybe<Array<AugmentedUpdateEntitiesOverviewBundleConfigurationEntityInput>>;
  withEntities?: InputMaybe<Array<AugmentedCreateEntitiesOverviewBundleConfigurationEntityInput>>;
};

/**
 * AugmentedUpdateEntityDiagramInput is used for update EntityDiagram object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEntityDiagramInput = {
  id: Scalars['ID']['input'];
  update: UpdateEntityDiagramInput;
};

/**
 * AugmentedUpdateEntityDocumentRelationshipInput is used for update EntityDocumentRelationship object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEntityDocumentRelationshipInput = {
  id: Scalars['ID']['input'];
  update: UpdateEntityDocumentRelationshipInput;
};

/**
 * AugmentedUpdateEntityGraphViewBundleConfigurationInput is used for update EntityGraphViewBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEntityGraphViewBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateEntityGraphViewBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
};

/**
 * AugmentedUpdateEntityGraphViewInput is used for update EntityGraphView object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEntityGraphViewInput = {
  id: Scalars['ID']['input'];
  update: UpdateEntityGraphViewInput;
};

/**
 * AugmentedUpdateEntityInput is used for update Entity object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEntityInput = {
  id: Scalars['ID']['input'];
  update: UpdateEntityInput;
  updateCashflows?: InputMaybe<Array<AugmentedUpdateCashflowInput>>;
  updateCcorpBusinessEntity?: InputMaybe<AugmentedUpdateCCorpBusinessEntityInput>;
  updateCltTrust?: InputMaybe<AugmentedUpdateCltTrustInput>;
  updateCrtTrust?: InputMaybe<AugmentedUpdateCrtTrustInput>;
  updateCustodialPersonalAccount?: InputMaybe<AugmentedUpdateCustodialPersonalAccountInput>;
  updateDeathOrderNotes?: InputMaybe<Array<AugmentedUpdateEntityNotesInput>>;
  updateDonorAdvisedFund?: InputMaybe<AugmentedUpdateDonorAdvisedFundInput>;
  updateEntityDocumentRelationships?: InputMaybe<Array<AugmentedUpdateEntityDocumentRelationshipInput>>;
  updateGpBusinessEntity?: InputMaybe<AugmentedUpdateGpBusinessEntityInput>;
  updateGratTrust?: InputMaybe<AugmentedUpdateGratTrustInput>;
  updateIlitTrust?: InputMaybe<AugmentedUpdateIlitTrustInput>;
  updateIndividualPersonalAccount?: InputMaybe<AugmentedUpdateIndividualPersonalAccountInput>;
  updateInsurancePersonalAccount?: InputMaybe<AugmentedUpdateInsurancePersonalAccountInput>;
  updateIrrevocableTrust?: InputMaybe<AugmentedUpdateIrrevocableTrustInput>;
  updateJointPersonalAccount?: InputMaybe<AugmentedUpdateJointPersonalAccountInput>;
  updateLiabilitiesOwed?: InputMaybe<Array<AugmentedUpdateLiabilityInput>>;
  updateLlcBusinessEntity?: InputMaybe<AugmentedUpdateLlcBusinessEntityInput>;
  updateLpBusinessEntity?: InputMaybe<AugmentedUpdateLpBusinessEntityInput>;
  updateOwnedByStakes?: InputMaybe<Array<AugmentedUpdateOwnershipStakeInput>>;
  updateOwnedOwnershipStakes?: InputMaybe<Array<AugmentedUpdateOwnershipStakeInput>>;
  updatePrivateFoundation?: InputMaybe<AugmentedUpdatePrivateFoundationInput>;
  updateQprtTrust?: InputMaybe<AugmentedUpdateQprtTrustInput>;
  updateQualifiedTuitionPersonalAccount?: InputMaybe<AugmentedUpdateQualifiedTuitionPersonalAccountInput>;
  updateRetirementPersonalAccount?: InputMaybe<AugmentedUpdateRetirementPersonalAccountInput>;
  updateRevocableTrust?: InputMaybe<AugmentedUpdateRevocableTrustInput>;
  updateScorpBusinessEntity?: InputMaybe<AugmentedUpdateSCorpBusinessEntityInput>;
  updateSlatTrust?: InputMaybe<AugmentedUpdateSlatTrustInput>;
  updateSoleProprietorshipBusinessEntity?: InputMaybe<AugmentedUpdateSoleProprietorshipBusinessEntityInput>;
  updateTaxInfo?: InputMaybe<AugmentedUpdateEntityTaxInfoInput>;
  withCashflows?: InputMaybe<Array<AugmentedCreateCashflowInput>>;
  withDeathOrderNotes?: InputMaybe<Array<AugmentedCreateEntityNotesInput>>;
  withEntityDocumentRelationships?: InputMaybe<Array<AugmentedCreateEntityDocumentRelationshipInput>>;
  withIndividualPersonalAccount?: InputMaybe<AugmentedCreateIndividualPersonalAccountInput>;
  withIrrevocableTrust?: InputMaybe<AugmentedCreateIrrevocableTrustInput>;
  withJointPersonalAccount?: InputMaybe<AugmentedCreateJointPersonalAccountInput>;
  withLiabilitiesOwed?: InputMaybe<Array<AugmentedCreateLiabilityInput>>;
  withOwnedByStakes?: InputMaybe<Array<AugmentedCreateOwnershipStakeInput>>;
  withOwnedOwnershipStakes?: InputMaybe<Array<AugmentedCreateOwnershipStakeInput>>;
  withRevocableTrust?: InputMaybe<AugmentedCreateRevocableTrustInput>;
  withTaxInfo?: InputMaybe<AugmentedCreateEntityTaxInfoInput>;
};

/**
 * AugmentedUpdateEntityNotesInput is used for update EntityNotes object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEntityNotesInput = {
  id: Scalars['ID']['input'];
  update: UpdateEntityNotesInput;
};

/**
 * AugmentedUpdateEntityProposalInput is used for update EntityProposal object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEntityProposalInput = {
  id: Scalars['ID']['input'];
  update: UpdateEntityProposalInput;
  updateProposal?: InputMaybe<AugmentedUpdateProposalInput>;
  updateProposalScenarios?: InputMaybe<Array<AugmentedUpdateProposalScenarioInput>>;
  withProposalScenarios?: InputMaybe<Array<AugmentedCreateProposalScenarioInput>>;
};

/**
 * AugmentedUpdateEntitySummaryBundleConfigurationInput is used for update EntitySummaryBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEntitySummaryBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateEntitySummaryBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
};

/**
 * AugmentedUpdateEntitySummaryTemplateBundleConfigurationInput is used for update EntitySummaryTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEntitySummaryTemplateBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateEntitySummaryTemplateBundleConfigurationInput;
  updateTemplateBundle?: InputMaybe<AugmentedUpdatePresentationTemplateBundleInput>;
};

/**
 * AugmentedUpdateEntityTaskInput is used for update EntityTask object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEntityTaskInput = {
  id: Scalars['ID']['input'];
  update: UpdateEntityTaskInput;
};

/**
 * AugmentedUpdateEntityTaxInfoInput is used for update EntityTaxInfo object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEntityTaxInfoInput = {
  id: Scalars['ID']['input'];
  update: UpdateEntityTaxInfoInput;
};

/**
 * AugmentedUpdateEstateInsightInput is used for update EstateInsight object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEstateInsightInput = {
  id: Scalars['ID']['input'];
  update: UpdateEstateInsightInput;
};

/**
 * AugmentedUpdateEstateInsightReferenceInput is used for update EstateInsightReference object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEstateInsightReferenceInput = {
  id: Scalars['ID']['input'];
  update: UpdateEstateInsightReferenceInput;
};

/**
 * AugmentedUpdateEstateInsightsBundleConfigurationInput is used for update EstateInsightsBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEstateInsightsBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateEstateInsightsBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
};

/**
 * AugmentedUpdateEstateTaxScenarioInput is used for update EstateTaxScenario object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEstateTaxScenarioInput = {
  id: Scalars['ID']['input'];
  update: UpdateEstateTaxScenarioInput;
};

/**
 * AugmentedUpdateEstateWaterfallHypotheticalStateChangeInput is used for update EstateWaterfallHypotheticalStateChange object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEstateWaterfallHypotheticalStateChangeInput = {
  id: Scalars['ID']['input'];
  update: UpdateEstateWaterfallHypotheticalStateChangeInput;
  updateHypotheticalWaterfall?: InputMaybe<AugmentedUpdateEstateWaterfallInput>;
};

/**
 * AugmentedUpdateEstateWaterfallHypotheticalTransferInput is used for update EstateWaterfallHypotheticalTransfer object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEstateWaterfallHypotheticalTransferInput = {
  id: Scalars['ID']['input'];
  update: UpdateEstateWaterfallHypotheticalTransferInput;
  updateDestinationEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  withDestinationEntity?: InputMaybe<AugmentedCreateEntityInput>;
};

/**
 * AugmentedUpdateEstateWaterfallInput is used for update EstateWaterfall object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEstateWaterfallInput = {
  id: Scalars['ID']['input'];
  update: UpdateEstateWaterfallInput;
  updateHypotheticalStateChanges?: InputMaybe<Array<AugmentedUpdateEstateWaterfallHypotheticalStateChangeInput>>;
  updateHypotheticalTransfers?: InputMaybe<Array<AugmentedUpdateEstateWaterfallHypotheticalTransferInput>>;
  updateVisualizationConfig?: InputMaybe<AugmentedUpdateEstateWaterfallVisualizationConfigInput>;
  updateVisualizationGroups?: InputMaybe<Array<AugmentedUpdateGraphVisualizationGroupInput>>;
  withHypotheticalStateChanges?: InputMaybe<Array<AugmentedCreateEstateWaterfallHypotheticalStateChangeInput>>;
  withHypotheticalTransfers?: InputMaybe<Array<AugmentedCreateEstateWaterfallHypotheticalTransferInput>>;
  withVisualizationConfig?: InputMaybe<AugmentedCreateEstateWaterfallVisualizationConfigInput>;
  withVisualizationGroups?: InputMaybe<Array<AugmentedCreateGraphVisualizationGroupInput>>;
};

/**
 * AugmentedUpdateEstateWaterfallVisualizationConfigInput is used for update EstateWaterfallVisualizationConfig object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEstateWaterfallVisualizationConfigInput = {
  id: Scalars['ID']['input'];
  update: UpdateEstateWaterfallVisualizationConfigInput;
};

/**
 * AugmentedUpdateEstateWaterfallVisualizationFilterInput is used for update EstateWaterfallVisualizationFilter object.
 * Input was generated by ent.
 */
export type AugmentedUpdateEstateWaterfallVisualizationFilterInput = {
  id: Scalars['ID']['input'];
  update: UpdateEstateWaterfallVisualizationFilterInput;
};

/**
 * AugmentedUpdateFamilyTreeBundleConfigurationInput is used for update FamilyTreeBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateFamilyTreeBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateFamilyTreeBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
};

/**
 * AugmentedUpdateFeatureFlagInput is used for update FeatureFlag object.
 * Input was generated by ent.
 */
export type AugmentedUpdateFeatureFlagInput = {
  id: Scalars['ID']['input'];
  update: UpdateFeatureFlagInput;
};

/**
 * AugmentedUpdateFeatureFlagQueryRuleInput is used for update FeatureFlagQueryRule object.
 * Input was generated by ent.
 */
export type AugmentedUpdateFeatureFlagQueryRuleInput = {
  id: Scalars['ID']['input'];
  update: UpdateFeatureFlagQueryRuleInput;
};

/**
 * AugmentedUpdateFormInput is used for update Form object.
 * Input was generated by ent.
 */
export type AugmentedUpdateFormInput = {
  id: Scalars['ID']['input'];
  update: UpdateFormInput;
};

/**
 * AugmentedUpdateGPBusinessEntityInput is used for update GPBusinessEntity object.
 * Input was generated by ent.
 */
export type AugmentedUpdateGpBusinessEntityInput = {
  id: Scalars['ID']['input'];
  update: UpdateGpBusinessEntityInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateKeyPeople?: InputMaybe<Array<AugmentedUpdateKeyPersonInput>>;
  updatePolicies?: InputMaybe<Array<AugmentedUpdateInsurancePolicyInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withKeyPeople?: InputMaybe<Array<AugmentedCreateKeyPersonInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedUpdateGRATAnnuityV2Input is used for update GRATAnnuityV2 object.
 * Input was generated by ent.
 */
export type AugmentedUpdateGratAnnuityV2Input = {
  id: Scalars['ID']['input'];
  update: UpdateGratAnnuityV2Input;
};

/**
 * AugmentedUpdateGRATProposalScenarioInput is used for update GRATProposalScenario object.
 * Input was generated by ent.
 */
export type AugmentedUpdateGratProposalScenarioInput = {
  id: Scalars['ID']['input'];
  update: UpdateGratProposalScenarioInput;
  updateProposalScenario?: InputMaybe<AugmentedUpdateProposalScenarioInput>;
};

/**
 * AugmentedUpdateGRATTrustInput is used for update GRATTrust object.
 * Input was generated by ent.
 */
export type AugmentedUpdateGratTrustInput = {
  id: Scalars['ID']['input'];
  setAnnuityToPaid?: InputMaybe<AugmentedSetGratTrustAnnuityV2PaidInput>;
  update: UpdateGratTrustInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateAnnuities?: InputMaybe<Array<AugmentedUpdateGratAnnuityV2Input>>;
  updateBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateDistributionAssetValuation?: InputMaybe<AugmentedUpdateAssetValuationV2Input>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateGrantor?: InputMaybe<AugmentedUpdatePrincipalInput>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateSuccessorTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  updateTrustAdvisors?: InputMaybe<Array<AugmentedUpdateTrustAdvisorInput>>;
  updateTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withAnnuities?: InputMaybe<Array<AugmentedCreateGratAnnuityV2Input>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withDistributionAssetValuation?: InputMaybe<AugmentedCreateAssetValuationV2Input>;
  withGrantor?: InputMaybe<AugmentedCreatePrincipalInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedUpdateGiftingProposalCashFlowInput is used for update GiftingProposalCashFlow object.
 * Input was generated by ent.
 */
export type AugmentedUpdateGiftingProposalCashFlowInput = {
  id: Scalars['ID']['input'];
  update: UpdateGiftingProposalCashFlowInput;
};

/**
 * AugmentedUpdateGiftingProposalGiftInput is used for update GiftingProposalGift object.
 * Input was generated by ent.
 */
export type AugmentedUpdateGiftingProposalGiftInput = {
  id: Scalars['ID']['input'];
  update: UpdateGiftingProposalGiftInput;
  updateRecipientClientOrganization?: InputMaybe<AugmentedUpdateClientOrganizationInput>;
  updateRecipientClientProfile?: InputMaybe<AugmentedUpdateClientProfileInput>;
  updateRecipientPortfolio?: InputMaybe<AugmentedUpdateGiftingProposalPortfolioInput>;
  updateSenders?: InputMaybe<Array<AugmentedUpdateGiftingProposalGiftSenderInput>>;
  withRecipientClientOrganization?: InputMaybe<AugmentedCreateClientOrganizationInput>;
  withRecipientClientProfile?: InputMaybe<AugmentedCreateClientProfileInput>;
  withRecipientPortfolio?: InputMaybe<AugmentedCreateGiftingProposalPortfolioInput>;
  withSenders?: InputMaybe<Array<AugmentedCreateGiftingProposalGiftSenderInput>>;
};

/**
 * AugmentedUpdateGiftingProposalGiftSenderInput is used for update GiftingProposalGiftSender object.
 * Input was generated by ent.
 */
export type AugmentedUpdateGiftingProposalGiftSenderInput = {
  id: Scalars['ID']['input'];
  update: UpdateGiftingProposalGiftSenderInput;
};

/**
 * AugmentedUpdateGiftingProposalInput is used for update GiftingProposal object.
 * Input was generated by ent.
 */
export type AugmentedUpdateGiftingProposalInput = {
  id: Scalars['ID']['input'];
  update: UpdateGiftingProposalInput;
  updateBaseCashFlows?: InputMaybe<Array<AugmentedUpdateGiftingProposalCashFlowInput>>;
  updateDefaultGiftingScenario?: InputMaybe<AugmentedUpdateGiftingProposalScenarioInput>;
  updateGiftingScenarios?: InputMaybe<Array<AugmentedUpdateGiftingProposalScenarioInput>>;
  updateOutOfEstatePortfolios?: InputMaybe<Array<AugmentedUpdateGiftingProposalPortfolioInput>>;
  updateProposal?: InputMaybe<AugmentedUpdateProposalInput>;
  withBaseCashFlows?: InputMaybe<Array<AugmentedCreateGiftingProposalCashFlowInput>>;
  withDefaultGiftingScenario?: InputMaybe<AugmentedCreateGiftingProposalScenarioInput>;
  withGiftingScenarios?: InputMaybe<Array<AugmentedCreateGiftingProposalScenarioInput>>;
  withOutOfEstatePortfolios?: InputMaybe<Array<AugmentedCreateGiftingProposalPortfolioInput>>;
};

/**
 * AugmentedUpdateGiftingProposalPortfolioInput is used for update GiftingProposalPortfolio object.
 * Input was generated by ent.
 */
export type AugmentedUpdateGiftingProposalPortfolioInput = {
  id: Scalars['ID']['input'];
  update: UpdateGiftingProposalPortfolioInput;
  updateCashflows?: InputMaybe<Array<AugmentedUpdateGiftingProposalCashFlowInput>>;
  withCashflows?: InputMaybe<Array<AugmentedCreateGiftingProposalCashFlowInput>>;
};

/**
 * AugmentedUpdateGiftingProposalScenarioInput is used for update GiftingProposalScenario object.
 * Input was generated by ent.
 */
export type AugmentedUpdateGiftingProposalScenarioInput = {
  id: Scalars['ID']['input'];
  update: UpdateGiftingProposalScenarioInput;
  updateScenarioCashFlows?: InputMaybe<Array<AugmentedUpdateGiftingProposalCashFlowInput>>;
  updateScenarioGifts?: InputMaybe<Array<AugmentedUpdateGiftingProposalGiftInput>>;
  withScenarioCashFlows?: InputMaybe<Array<AugmentedCreateGiftingProposalCashFlowInput>>;
  withScenarioGifts?: InputMaybe<Array<AugmentedCreateGiftingProposalGiftInput>>;
};

/**
 * AugmentedUpdateGraphVisualizationGroupInput is used for update GraphVisualizationGroup object.
 * Input was generated by ent.
 */
export type AugmentedUpdateGraphVisualizationGroupInput = {
  id: Scalars['ID']['input'];
  update: UpdateGraphVisualizationGroupInput;
};

/**
 * AugmentedUpdateGrowthProfileInput is used for update GrowthProfile object.
 * Input was generated by ent.
 */
export type AugmentedUpdateGrowthProfileInput = {
  id: Scalars['ID']['input'];
  update: UpdateGrowthProfileInput;
  updateGrowthProfileOverrides?: InputMaybe<Array<AugmentedUpdateGrowthProfileOverrideInput>>;
  updateIncomeTaxPaymentConfig?: InputMaybe<AugmentedUpdateIncomeTaxPaymentConfigInput>;
  updateTaxDragConfig?: InputMaybe<AugmentedUpdateTaxDragConfigInput>;
  updateTaxDragOverrides?: InputMaybe<Array<AugmentedUpdateTaxDragOverrideInput>>;
  withGrowthProfileOverrides?: InputMaybe<Array<AugmentedCreateGrowthProfileOverrideInput>>;
  withIncomeTaxPaymentConfig?: InputMaybe<AugmentedCreateIncomeTaxPaymentConfigInput>;
  withTaxDragConfig?: InputMaybe<AugmentedCreateTaxDragConfigInput>;
  withTaxDragOverrides?: InputMaybe<Array<AugmentedCreateTaxDragOverrideInput>>;
};

/**
 * AugmentedUpdateGrowthProfileOverrideInput is used for update GrowthProfileOverride object.
 * Input was generated by ent.
 */
export type AugmentedUpdateGrowthProfileOverrideInput = {
  id: Scalars['ID']['input'];
  update: UpdateGrowthProfileOverrideInput;
};

/**
 * AugmentedUpdateHouseholdInput is used for update Household object.
 * Input was generated by ent.
 */
export type AugmentedUpdateHouseholdInput = {
  id: Scalars['ID']['input'];
  update: UpdateHouseholdInput;
  updateClientProfiles?: InputMaybe<Array<AugmentedUpdateClientProfileInput>>;
  updateEstateTaxScenarios?: InputMaybe<Array<AugmentedUpdateEstateTaxScenarioInput>>;
  withClientProfiles?: InputMaybe<Array<AugmentedCreateClientProfileInput>>;
  withEstateTaxScenarios?: InputMaybe<Array<AugmentedCreateEstateTaxScenarioInput>>;
};

/**
 * AugmentedUpdateHypotheticalCLTInput is used for update HypotheticalCLT object.
 * Input was generated by ent.
 */
export type AugmentedUpdateHypotheticalCltInput = {
  id: Scalars['ID']['input'];
  update: UpdateHypotheticalCltInput;
  updateFunding?: InputMaybe<AugmentedUpdateHypotheticalTransferFundingSourceInput>;
  withFunding?: InputMaybe<AugmentedCreateHypotheticalTransferFundingSourceInput>;
};

/**
 * AugmentedUpdateHypotheticalCRTInput is used for update HypotheticalCRT object.
 * Input was generated by ent.
 */
export type AugmentedUpdateHypotheticalCrtInput = {
  id: Scalars['ID']['input'];
  update: UpdateHypotheticalCrtInput;
  updateFunding?: InputMaybe<AugmentedUpdateHypotheticalTransferFundingSourceInput>;
  withFunding?: InputMaybe<AugmentedCreateHypotheticalTransferFundingSourceInput>;
};

/**
 * AugmentedUpdateHypotheticalGRATInput is used for update HypotheticalGRAT object.
 * Input was generated by ent.
 */
export type AugmentedUpdateHypotheticalGratInput = {
  id: Scalars['ID']['input'];
  update: UpdateHypotheticalGratInput;
  updateFunding?: InputMaybe<AugmentedUpdateHypotheticalTransferFundingSourceInput>;
  withFunding?: InputMaybe<AugmentedCreateHypotheticalTransferFundingSourceInput>;
};

/**
 * AugmentedUpdateHypotheticalInsuranceInput is used for update HypotheticalInsurance object.
 * Input was generated by ent.
 */
export type AugmentedUpdateHypotheticalInsuranceInput = {
  id: Scalars['ID']['input'];
  update: UpdateHypotheticalInsuranceInput;
  updateCreatedInsurancePolicy?: InputMaybe<AugmentedUpdateInsurancePolicyInput>;
  updateDestinationEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateExistingInsurancePolicy?: InputMaybe<AugmentedUpdateInsurancePolicyInput>;
  withCreatedInsurancePolicy?: InputMaybe<AugmentedCreateInsurancePolicyInput>;
  withDestinationEntity?: InputMaybe<AugmentedCreateEntityInput>;
  withExistingInsurancePolicy?: InputMaybe<AugmentedCreateInsurancePolicyInput>;
};

/**
 * AugmentedUpdateHypotheticalSaleLoanInput is used for update HypotheticalSaleLoan object.
 * Input was generated by ent.
 */
export type AugmentedUpdateHypotheticalSaleLoanInput = {
  id: Scalars['ID']['input'];
  update: UpdateHypotheticalSaleLoanInput;
  updateFunding?: InputMaybe<AugmentedUpdateHypotheticalTransferFundingSourceInput>;
  withFunding?: InputMaybe<AugmentedCreateHypotheticalTransferFundingSourceInput>;
};

/**
 * AugmentedUpdateHypotheticalTransferAssetInput is used for update HypotheticalTransferAsset object.
 * Input was generated by ent.
 */
export type AugmentedUpdateHypotheticalTransferAssetInput = {
  id: Scalars['ID']['input'];
  update: UpdateHypotheticalTransferAssetInput;
  updateHypotheticalTransferFundingSource?: InputMaybe<AugmentedUpdateHypotheticalTransferFundingSourceInput>;
  withHypotheticalTransferFundingSource?: InputMaybe<AugmentedCreateHypotheticalTransferFundingSourceInput>;
};

/**
 * AugmentedUpdateHypotheticalTransferFundingSourceInput is used for update HypotheticalTransferFundingSource object.
 * Input was generated by ent.
 */
export type AugmentedUpdateHypotheticalTransferFundingSourceInput = {
  id: Scalars['ID']['input'];
  update: UpdateHypotheticalTransferFundingSourceInput;
  updateAssets?: InputMaybe<Array<AugmentedUpdateHypotheticalTransferAssetInput>>;
  updateHypotheticalClt?: InputMaybe<AugmentedUpdateHypotheticalCltInput>;
  updateHypotheticalCrt?: InputMaybe<AugmentedUpdateHypotheticalCrtInput>;
  updateHypotheticalGrat?: InputMaybe<AugmentedUpdateHypotheticalGratInput>;
  updateHypotheticalSaleLoan?: InputMaybe<AugmentedUpdateHypotheticalSaleLoanInput>;
  withAssets?: InputMaybe<Array<AugmentedCreateHypotheticalTransferAssetInput>>;
  withHypotheticalClt?: InputMaybe<AugmentedCreateHypotheticalCltInput>;
  withHypotheticalCrt?: InputMaybe<AugmentedCreateHypotheticalCrtInput>;
  withHypotheticalGrat?: InputMaybe<AugmentedCreateHypotheticalGratInput>;
  withHypotheticalSaleLoan?: InputMaybe<AugmentedCreateHypotheticalSaleLoanInput>;
};

/**
 * AugmentedUpdateHypotheticalWaterfallDispositiveProvisionTemplateInput is used for update HypotheticalWaterfallDispositiveProvisionTemplate object.
 * Input was generated by ent.
 */
export type AugmentedUpdateHypotheticalWaterfallDispositiveProvisionTemplateInput = {
  id: Scalars['ID']['input'];
  update: UpdateHypotheticalWaterfallDispositiveProvisionTemplateInput;
};

/**
 * AugmentedUpdateILITCrummeyLetterInput is used for update ILITCrummeyLetter object.
 * Input was generated by ent.
 */
export type AugmentedUpdateIlitCrummeyLetterInput = {
  id: Scalars['ID']['input'];
  update: UpdateIlitCrummeyLetterInput;
};

/**
 * AugmentedUpdateILITTrustInput is used for update ILITTrust object.
 * Input was generated by ent.
 */
export type AugmentedUpdateIlitTrustInput = {
  id: Scalars['ID']['input'];
  update: UpdateIlitTrustInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateCrummeyLetters?: InputMaybe<Array<AugmentedUpdateIlitCrummeyLetterInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateGrantors?: InputMaybe<Array<AugmentedUpdatePrincipalInput>>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updatePolicies?: InputMaybe<Array<AugmentedUpdateInsurancePolicyInput>>;
  updateSuccessorTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  updateTrustAdvisors?: InputMaybe<Array<AugmentedUpdateTrustAdvisorInput>>;
  updateTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withCrummeyLetters?: InputMaybe<Array<AugmentedCreateIlitCrummeyLetterInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withGrantors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedUpdateIncomeTaxPaymentConfigInput is used for update IncomeTaxPaymentConfig object.
 * Input was generated by ent.
 */
export type AugmentedUpdateIncomeTaxPaymentConfigInput = {
  id: Scalars['ID']['input'];
  update: UpdateIncomeTaxPaymentConfigInput;
  updateGrowthProfile?: InputMaybe<AugmentedUpdateGrowthProfileInput>;
};

/**
 * AugmentedUpdateIndividualPersonalAccountInput is used for update IndividualPersonalAccount object.
 * Input was generated by ent.
 */
export type AugmentedUpdateIndividualPersonalAccountInput = {
  id: Scalars['ID']['input'];
  update: UpdateIndividualPersonalAccountInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateControllingParties?: InputMaybe<Array<AugmentedUpdateControllingPartyInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateOwner?: InputMaybe<AugmentedUpdatePrincipalInput>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withOwner?: InputMaybe<AugmentedCreatePrincipalInput>;
};

/**
 * AugmentedUpdateInferredFieldEvidenceInput is used for update InferredFieldEvidence object.
 * Input was generated by ent.
 */
export type AugmentedUpdateInferredFieldEvidenceInput = {
  id: Scalars['ID']['input'];
  update: UpdateInferredFieldEvidenceInput;
};

/**
 * AugmentedUpdateInferredFieldInput is used for update InferredField object.
 * Input was generated by ent.
 */
export type AugmentedUpdateInferredFieldInput = {
  id: Scalars['ID']['input'];
  update: UpdateInferredFieldInput;
  updateEvidence?: InputMaybe<Array<AugmentedUpdateInferredFieldEvidenceInput>>;
  withEvidence?: InputMaybe<Array<AugmentedCreateInferredFieldEvidenceInput>>;
};

/**
 * AugmentedUpdateInsightsTemplateBundleConfigurationInput is used for update InsightsTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateInsightsTemplateBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateInsightsTemplateBundleConfigurationInput;
  updateTemplateBundle?: InputMaybe<AugmentedUpdatePresentationTemplateBundleInput>;
};

/**
 * AugmentedUpdateInsurancePersonalAccountInput is used for update InsurancePersonalAccount object.
 * Input was generated by ent.
 */
export type AugmentedUpdateInsurancePersonalAccountInput = {
  id: Scalars['ID']['input'];
  update: UpdateInsurancePersonalAccountInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateBeneficiaryDesignationGroups?: InputMaybe<Array<AugmentedUpdateBeneficiaryDesignationGroupInput>>;
  updateControllingParties?: InputMaybe<Array<AugmentedUpdateControllingPartyInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateHypotheticalBeneficiaryDesignationGroups?: InputMaybe<Array<AugmentedUpdateBeneficiaryDesignationGroupInput>>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateOwners?: InputMaybe<Array<AugmentedUpdatePrincipalInput>>;
  updatePolicies?: InputMaybe<Array<AugmentedUpdateInsurancePolicyInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaryDesignationGroups?: InputMaybe<Array<AugmentedCreateBeneficiaryDesignationGroupInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalBeneficiaryDesignationGroups?: InputMaybe<Array<AugmentedCreateBeneficiaryDesignationGroupInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withOwners?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedUpdateInsurancePolicyInput is used for update InsurancePolicy object.
 * Input was generated by ent.
 */
export type AugmentedUpdateInsurancePolicyInput = {
  id: Scalars['ID']['input'];
  update: UpdateInsurancePolicyInput;
  updatePremiumPayments?: InputMaybe<Array<AugmentedUpdateInsurancePremiumPaymentInput>>;
  withPremiumPayments?: InputMaybe<Array<AugmentedCreateInsurancePremiumPaymentInput>>;
};

/**
 * AugmentedUpdateInsurancePremiumPaymentInput is used for update InsurancePremiumPayment object.
 * Input was generated by ent.
 */
export type AugmentedUpdateInsurancePremiumPaymentInput = {
  id: Scalars['ID']['input'];
  update: UpdateInsurancePremiumPaymentInput;
};

/**
 * AugmentedUpdateIntegrationAssetClassInput is used for update IntegrationAssetClass object.
 * Input was generated by ent.
 */
export type AugmentedUpdateIntegrationAssetClassInput = {
  id: Scalars['ID']['input'];
  update: UpdateIntegrationAssetClassInput;
  updateAssetClass?: InputMaybe<AugmentedUpdateAssetClassInput>;
  withAssetClass?: InputMaybe<AugmentedCreateAssetClassInput>;
};

/**
 * AugmentedUpdateIntegrationConfigurationInput is used for update IntegrationConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateIntegrationConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateIntegrationConfigurationInput;
};

/**
 * AugmentedUpdateIrrevocableTrustInput is used for update IrrevocableTrust object.
 * Input was generated by ent.
 */
export type AugmentedUpdateIrrevocableTrustInput = {
  id: Scalars['ID']['input'];
  update: UpdateIrrevocableTrustInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateGrantors?: InputMaybe<Array<AugmentedUpdatePrincipalInput>>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updatePolicies?: InputMaybe<Array<AugmentedUpdateInsurancePolicyInput>>;
  updateSuccessorTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  updateTrustAdvisors?: InputMaybe<Array<AugmentedUpdateTrustAdvisorInput>>;
  updateTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withGrantors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedUpdateJointPersonalAccountInput is used for update JointPersonalAccount object.
 * Input was generated by ent.
 */
export type AugmentedUpdateJointPersonalAccountInput = {
  id: Scalars['ID']['input'];
  update: UpdateJointPersonalAccountInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateControllingParties?: InputMaybe<Array<AugmentedUpdateControllingPartyInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateOwners?: InputMaybe<Array<AugmentedUpdatePrincipalInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withOwners?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
};

/**
 * AugmentedUpdateKGRootInput is used for update KGRoot object.
 * Input was generated by ent.
 */
export type AugmentedUpdateKgRootInput = {
  id: Scalars['ID']['input'];
  update: UpdateKgRootInput;
  updateAiSuggestions?: InputMaybe<Array<AugmentedUpdateAiSuggestionInput>>;
  withAiSuggestions?: InputMaybe<Array<AugmentedCreateAiSuggestionInput>>;
};

/**
 * AugmentedUpdateKeyPersonInput is used for update KeyPerson object.
 * Input was generated by ent.
 */
export type AugmentedUpdateKeyPersonInput = {
  id: Scalars['ID']['input'];
  update: UpdateKeyPersonInput;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateIndividual?: InputMaybe<AugmentedUpdateClientProfileInput>;
  updateOrganization?: InputMaybe<AugmentedUpdateClientOrganizationInput>;
  updateRoles?: InputMaybe<Array<AugmentedUpdateKeyPersonRoleInput>>;
  withRoles?: InputMaybe<Array<AugmentedCreateKeyPersonRoleInput>>;
};

/**
 * AugmentedUpdateKeyPersonRoleInput is used for update KeyPersonRole object.
 * Input was generated by ent.
 */
export type AugmentedUpdateKeyPersonRoleInput = {
  id: Scalars['ID']['input'];
  update: UpdateKeyPersonRoleInput;
  updateKeyPerson?: InputMaybe<AugmentedUpdateKeyPersonInput>;
};

/**
 * AugmentedUpdateLLCBusinessEntityInput is used for update LLCBusinessEntity object.
 * Input was generated by ent.
 */
export type AugmentedUpdateLlcBusinessEntityInput = {
  id: Scalars['ID']['input'];
  update: UpdateLlcBusinessEntityInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateKeyPeople?: InputMaybe<Array<AugmentedUpdateKeyPersonInput>>;
  updatePolicies?: InputMaybe<Array<AugmentedUpdateInsurancePolicyInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withKeyPeople?: InputMaybe<Array<AugmentedCreateKeyPersonInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedUpdateLPBusinessEntityInput is used for update LPBusinessEntity object.
 * Input was generated by ent.
 */
export type AugmentedUpdateLpBusinessEntityInput = {
  id: Scalars['ID']['input'];
  update: UpdateLpBusinessEntityInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateKeyPeople?: InputMaybe<Array<AugmentedUpdateKeyPersonInput>>;
  updatePolicies?: InputMaybe<Array<AugmentedUpdateInsurancePolicyInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withKeyPeople?: InputMaybe<Array<AugmentedCreateKeyPersonInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedUpdateLiabilitiesBundleConfigurationInput is used for update LiabilitiesBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateLiabilitiesBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateLiabilitiesBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
};

/**
 * AugmentedUpdateLiabilityInput is used for update Liability object.
 * Input was generated by ent.
 */
export type AugmentedUpdateLiabilityInput = {
  id: Scalars['ID']['input'];
  update: UpdateLiabilityInput;
};

/**
 * AugmentedUpdateLifeInsuranceBundleConfigurationInput is used for update LifeInsuranceBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateLifeInsuranceBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateLifeInsuranceBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
};

/**
 * AugmentedUpdateLifetimeExclusionEventInput is used for update LifetimeExclusionEvent object.
 * Input was generated by ent.
 */
export type AugmentedUpdateLifetimeExclusionEventInput = {
  id: Scalars['ID']['input'];
  update: UpdateLifetimeExclusionEventInput;
  updateRecipient?: InputMaybe<AugmentedUpdateBeneficiaryInput>;
  withRecipient?: InputMaybe<AugmentedCreateBeneficiaryInput>;
};

/**
 * AugmentedUpdateLoggedTransferInput is used for update LoggedTransfer object.
 * Input was generated by ent.
 */
export type AugmentedUpdateLoggedTransferInput = {
  id: Scalars['ID']['input'];
  update: UpdateLoggedTransferInput;
  updateLifetimeExclusionEvents?: InputMaybe<Array<AugmentedUpdateLifetimeExclusionEventInput>>;
  withLifetimeExclusionEvents?: InputMaybe<Array<AugmentedCreateLifetimeExclusionEventInput>>;
};

/**
 * AugmentedUpdateMemoInput is used for update Memo object.
 * Input was generated by ent.
 */
export type AugmentedUpdateMemoInput = {
  id: Scalars['ID']['input'];
  update: UpdateMemoInput;
};

/**
 * AugmentedUpdateMissingDocumentsPageInput is used for update MissingDocumentsPage object.
 * Input was generated by ent.
 */
export type AugmentedUpdateMissingDocumentsPageInput = {
  id: Scalars['ID']['input'];
  update: UpdateMissingDocumentsPageInput;
};

/**
 * AugmentedUpdateModelMappingInput is used for update ModelMapping object.
 * Input was generated by ent.
 */
export type AugmentedUpdateModelMappingInput = {
  id: Scalars['ID']['input'];
  update: UpdateModelMappingInput;
  updateConfig?: InputMaybe<AugmentedUpdateOpenaiSdkConfigInput>;
  withConfig?: InputMaybe<AugmentedCreateOpenaiSdkConfigInput>;
};

/**
 * AugmentedUpdateNotificationPreferenceInput is used for update NotificationPreference object.
 * Input was generated by ent.
 */
export type AugmentedUpdateNotificationPreferenceInput = {
  id: Scalars['ID']['input'];
  update: UpdateNotificationPreferenceInput;
};

/**
 * AugmentedUpdateOpenaiSdkConfigInput is used for update OpenaiSdkConfig object.
 * Input was generated by ent.
 */
export type AugmentedUpdateOpenaiSdkConfigInput = {
  id: Scalars['ID']['input'];
  update: UpdateOpenaiSdkConfigInput;
  updateModelMappings?: InputMaybe<Array<AugmentedUpdateModelMappingInput>>;
  withModelMappings?: InputMaybe<Array<AugmentedCreateModelMappingInput>>;
};

/**
 * AugmentedUpdateOrganizationApplicationConfigurationInput is used for update OrganizationApplicationConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateOrganizationApplicationConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateOrganizationApplicationConfigurationInput;
};

/**
 * AugmentedUpdateOrganizationDisclaimerConfigurationInput is used for update OrganizationDisclaimerConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateOrganizationDisclaimerConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateOrganizationDisclaimerConfigurationInput;
};

/**
 * AugmentedUpdateOwnershipStakeInput is used for update OwnershipStake object.
 * Input was generated by ent.
 */
export type AugmentedUpdateOwnershipStakeInput = {
  id: Scalars['ID']['input'];
  update: UpdateOwnershipStakeInput;
  updateOwnedEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateOwningEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  withOwnedEntity?: InputMaybe<AugmentedCreateEntityInput>;
};

/**
 * AugmentedUpdatePlatformDocumentInput is used for update PlatformDocument object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePlatformDocumentInput = {
  id: Scalars['ID']['input'];
  update: UpdatePlatformDocumentInput;
};

/**
 * AugmentedUpdatePresentationAssetDistributionBundleConfigurationInput is used for update PresentationAssetDistributionBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationAssetDistributionBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationAssetDistributionBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
  updateDistributionItems?: InputMaybe<Array<AugmentedUpdatePresentationAssetDistributionItemConfigurationInput>>;
  withDistributionItems?: InputMaybe<Array<AugmentedCreatePresentationAssetDistributionItemConfigurationInput>>;
};

/**
 * AugmentedUpdatePresentationAssetDistributionItemConfigurationInput is used for update PresentationAssetDistributionItemConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationAssetDistributionItemConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationAssetDistributionItemConfigurationInput;
  updateBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationAssetDistributionBundleConfigurationInput>;
  updateItemDetails?: InputMaybe<Array<AugmentedUpdatePresentationAssetDistributionItemDetailInput>>;
  withItemDetails?: InputMaybe<Array<AugmentedCreatePresentationAssetDistributionItemDetailInput>>;
};

/**
 * AugmentedUpdatePresentationAssetDistributionItemDetailInput is used for update PresentationAssetDistributionItemDetail object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationAssetDistributionItemDetailInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationAssetDistributionItemDetailInput;
  updateCitations?: InputMaybe<Array<AugmentedUpdatePresentationItemCitationInput>>;
  updateItemConfiguration?: InputMaybe<AugmentedUpdatePresentationAssetDistributionItemConfigurationInput>;
  withCitations?: InputMaybe<Array<AugmentedCreatePresentationItemCitationInput>>;
};

/**
 * AugmentedUpdatePresentationBundleCoverPageInput is used for update PresentationBundleCoverPage object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationBundleCoverPageInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationBundleCoverPageInput;
};

/**
 * AugmentedUpdatePresentationBundleInput is used for update PresentationBundle object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationBundleInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationBundleInput;
  updateAssetDistributionBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationAssetDistributionBundleConfigurationInput>;
  updateBalanceSheetBundleConfiguration?: InputMaybe<AugmentedUpdateBalanceSheetBundleConfigurationInput>;
  updateBeneficiariesBundleConfiguration?: InputMaybe<AugmentedUpdateBeneficiariesBundleConfigurationInput>;
  updateBusinessOverviewBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationBusinessOverviewBundleConfigurationInput>;
  updateCoverPageConfiguration?: InputMaybe<AugmentedUpdateCoverPageConfigurationInput>;
  updateCustomPageBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationCustomPageBundleConfigurationInput>;
  updateDividerBundleConfiguration?: InputMaybe<AugmentedUpdateDividerBundleConfigurationInput>;
  updateDocumentsReviewedBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationDocumentsReviewedBundleConfigurationInput>;
  updateEntitiesOverviewBundleConfiguration?: InputMaybe<AugmentedUpdateEntitiesOverviewBundleConfigurationInput>;
  updateEntityGraphViewBundleConfiguration?: InputMaybe<AugmentedUpdateEntityGraphViewBundleConfigurationInput>;
  updateEntitySummaryBundleConfiguration?: InputMaybe<AugmentedUpdateEntitySummaryBundleConfigurationInput>;
  updateEstateInsightsBundleConfiguration?: InputMaybe<AugmentedUpdateEstateInsightsBundleConfigurationInput>;
  updateFamilyOverviewBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationFamilyOverviewBundleConfigurationInput>;
  updateFamilyTreeBundleConfiguration?: InputMaybe<AugmentedUpdateFamilyTreeBundleConfigurationInput>;
  updateHealthcareDirectiveBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationHealthcareDirectiveBundleConfigurationInput>;
  updateLiabilitiesBundleConfiguration?: InputMaybe<AugmentedUpdateLiabilitiesBundleConfigurationInput>;
  updateLifeInsuranceBundleConfiguration?: InputMaybe<AugmentedUpdateLifeInsuranceBundleConfigurationInput>;
  updatePages?: InputMaybe<Array<AugmentedUpdatePresentationPageInput>>;
  updatePlanningOpportunitiesBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationPlanningOpportunitiesBundleConfigurationInput>;
  updatePowerOfAttorneyBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationPowerOfAttorneyBundleConfigurationInput>;
  updateTrustOverviewBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationTrustOverviewBundleConfigurationInput>;
  updateWaterfallBundleConfiguration?: InputMaybe<AugmentedUpdateWaterfallBundleConfigurationInput>;
  updateWaterfallComparisonBundleConfiguration?: InputMaybe<AugmentedUpdateWaterfallComparisonBundleConfigurationInput>;
  updateWillBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationWillBundleConfigurationInput>;
  withAssetDistributionBundleConfiguration?: InputMaybe<AugmentedCreatePresentationAssetDistributionBundleConfigurationInput>;
  withBalanceSheetBundleConfiguration?: InputMaybe<AugmentedCreateBalanceSheetBundleConfigurationInput>;
  withBeneficiariesBundleConfiguration?: InputMaybe<AugmentedCreateBeneficiariesBundleConfigurationInput>;
  withBusinessOverviewBundleConfiguration?: InputMaybe<AugmentedCreatePresentationBusinessOverviewBundleConfigurationInput>;
  withCoverPageConfiguration?: InputMaybe<AugmentedCreateCoverPageConfigurationInput>;
  withCustomPageBundleConfiguration?: InputMaybe<AugmentedCreatePresentationCustomPageBundleConfigurationInput>;
  withDividerBundleConfiguration?: InputMaybe<AugmentedCreateDividerBundleConfigurationInput>;
  withDocumentsReviewedBundleConfiguration?: InputMaybe<AugmentedCreatePresentationDocumentsReviewedBundleConfigurationInput>;
  withEntitiesOverviewBundleConfiguration?: InputMaybe<AugmentedCreateEntitiesOverviewBundleConfigurationInput>;
  withEntityGraphViewBundleConfiguration?: InputMaybe<AugmentedCreateEntityGraphViewBundleConfigurationInput>;
  withEntitySummaryBundleConfiguration?: InputMaybe<AugmentedCreateEntitySummaryBundleConfigurationInput>;
  withEstateInsightsBundleConfiguration?: InputMaybe<AugmentedCreateEstateInsightsBundleConfigurationInput>;
  withFamilyOverviewBundleConfiguration?: InputMaybe<AugmentedCreatePresentationFamilyOverviewBundleConfigurationInput>;
  withFamilyTreeBundleConfiguration?: InputMaybe<AugmentedCreateFamilyTreeBundleConfigurationInput>;
  withHealthcareDirectiveBundleConfiguration?: InputMaybe<AugmentedCreatePresentationHealthcareDirectiveBundleConfigurationInput>;
  withLiabilitiesBundleConfiguration?: InputMaybe<AugmentedCreateLiabilitiesBundleConfigurationInput>;
  withLifeInsuranceBundleConfiguration?: InputMaybe<AugmentedCreateLifeInsuranceBundleConfigurationInput>;
  withPages?: InputMaybe<Array<AugmentedCreatePresentationPageInput>>;
  withPlanningOpportunitiesBundleConfiguration?: InputMaybe<AugmentedCreatePresentationPlanningOpportunitiesBundleConfigurationInput>;
  withPowerOfAttorneyBundleConfiguration?: InputMaybe<AugmentedCreatePresentationPowerOfAttorneyBundleConfigurationInput>;
  withTrustOverviewBundleConfiguration?: InputMaybe<AugmentedCreatePresentationTrustOverviewBundleConfigurationInput>;
  withWaterfallBundleConfiguration?: InputMaybe<AugmentedCreateWaterfallBundleConfigurationInput>;
  withWaterfallComparisonBundleConfiguration?: InputMaybe<AugmentedCreateWaterfallComparisonBundleConfigurationInput>;
  withWillBundleConfiguration?: InputMaybe<AugmentedCreatePresentationWillBundleConfigurationInput>;
};

/**
 * AugmentedUpdatePresentationBusinessOverviewBundleConfigurationInput is used for update PresentationBusinessOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationBusinessOverviewBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationBusinessOverviewBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
  updateBusinesses?: InputMaybe<Array<AugmentedUpdatePresentationBusinessOverviewBusinessConfigurationInput>>;
  withBusinesses?: InputMaybe<Array<AugmentedCreatePresentationBusinessOverviewBusinessConfigurationInput>>;
};

/**
 * AugmentedUpdatePresentationBusinessOverviewBusinessConfigurationInput is used for update PresentationBusinessOverviewBusinessConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationBusinessOverviewBusinessConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationBusinessOverviewBusinessConfigurationInput;
  updateBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationBusinessOverviewBundleConfigurationInput>;
  updateBusinessItems?: InputMaybe<Array<AugmentedUpdatePresentationBusinessOverviewItemInput>>;
  withBusinessItems?: InputMaybe<Array<AugmentedCreatePresentationBusinessOverviewItemInput>>;
};

/**
 * AugmentedUpdatePresentationBusinessOverviewItemInput is used for update PresentationBusinessOverviewItem object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationBusinessOverviewItemInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationBusinessOverviewItemInput;
  updateBusinessConfiguration?: InputMaybe<AugmentedUpdatePresentationBusinessOverviewBusinessConfigurationInput>;
  updateCitations?: InputMaybe<Array<AugmentedUpdatePresentationItemCitationInput>>;
  withCitations?: InputMaybe<Array<AugmentedCreatePresentationItemCitationInput>>;
};

/**
 * AugmentedUpdatePresentationCoverPageInput is used for update PresentationCoverPage object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationCoverPageInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationCoverPageInput;
  updatePage?: InputMaybe<AugmentedUpdatePresentationPageInput>;
};

/**
 * AugmentedUpdatePresentationCoverSlideConfigInput is used for update PresentationCoverSlideConfig object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationCoverSlideConfigInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationCoverSlideConfigInput;
};

/**
 * AugmentedUpdatePresentationCustomPageBundleConfigurationInput is used for update PresentationCustomPageBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationCustomPageBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationCustomPageBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
};

/**
 * AugmentedUpdatePresentationCustomPageInput is used for update PresentationCustomPage object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationCustomPageInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationCustomPageInput;
  updatePage?: InputMaybe<AugmentedUpdatePresentationPageInput>;
};

/**
 * AugmentedUpdatePresentationDiagramPageInput is used for update PresentationDiagramPage object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationDiagramPageInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationDiagramPageInput;
  updatePage?: InputMaybe<AugmentedUpdatePresentationPageInput>;
};

/**
 * AugmentedUpdatePresentationDocumentsReviewedBundleConfigurationInput is used for update PresentationDocumentsReviewedBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationDocumentsReviewedBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationDocumentsReviewedBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
  updateReviewedDocuments?: InputMaybe<Array<AugmentedUpdatePresentationDocumentsReviewedDocumentInput>>;
  withReviewedDocuments?: InputMaybe<Array<AugmentedCreatePresentationDocumentsReviewedDocumentInput>>;
};

/**
 * AugmentedUpdatePresentationDocumentsReviewedDocumentInput is used for update PresentationDocumentsReviewedDocument object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationDocumentsReviewedDocumentInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationDocumentsReviewedDocumentInput;
  updateBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationDocumentsReviewedBundleConfigurationInput>;
};

/**
 * AugmentedUpdatePresentationFamilyOverviewBundleConfigurationInput is used for update PresentationFamilyOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationFamilyOverviewBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationFamilyOverviewBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
  updateMembers?: InputMaybe<Array<AugmentedUpdatePresentationFamilyOverviewMemberConfigurationInput>>;
  withMembers?: InputMaybe<Array<AugmentedCreatePresentationFamilyOverviewMemberConfigurationInput>>;
};

/**
 * AugmentedUpdatePresentationFamilyOverviewMemberConfigurationInput is used for update PresentationFamilyOverviewMemberConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationFamilyOverviewMemberConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationFamilyOverviewMemberConfigurationInput;
  updateBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationFamilyOverviewBundleConfigurationInput>;
  updateCitations?: InputMaybe<Array<AugmentedUpdatePresentationItemCitationInput>>;
  withCitations?: InputMaybe<Array<AugmentedCreatePresentationItemCitationInput>>;
};

/**
 * AugmentedUpdatePresentationHealthcareDirectiveBundleConfigurationInput is used for update PresentationHealthcareDirectiveBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationHealthcareDirectiveBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationHealthcareDirectiveBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
  updateClients?: InputMaybe<Array<AugmentedUpdatePresentationHealthcareDirectiveClientConfigurationInput>>;
  withClients?: InputMaybe<Array<AugmentedCreatePresentationHealthcareDirectiveClientConfigurationInput>>;
};

/**
 * AugmentedUpdatePresentationHealthcareDirectiveClientConfigurationInput is used for update PresentationHealthcareDirectiveClientConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationHealthcareDirectiveClientConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationHealthcareDirectiveClientConfigurationInput;
  updateBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationHealthcareDirectiveBundleConfigurationInput>;
  updateHealthcareDirectiveItems?: InputMaybe<Array<AugmentedUpdatePresentationHealthcareDirectiveItemInput>>;
  withHealthcareDirectiveItems?: InputMaybe<Array<AugmentedCreatePresentationHealthcareDirectiveItemInput>>;
};

/**
 * AugmentedUpdatePresentationHealthcareDirectiveItemInput is used for update PresentationHealthcareDirectiveItem object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationHealthcareDirectiveItemInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationHealthcareDirectiveItemInput;
  updateCitations?: InputMaybe<Array<AugmentedUpdatePresentationItemCitationInput>>;
  updateClientConfiguration?: InputMaybe<AugmentedUpdatePresentationHealthcareDirectiveClientConfigurationInput>;
  withCitations?: InputMaybe<Array<AugmentedCreatePresentationItemCitationInput>>;
};

/**
 * AugmentedUpdatePresentationItemCitationInput is used for update PresentationItemCitation object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationItemCitationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationItemCitationInput;
};

/**
 * AugmentedUpdatePresentationPageInput is used for update PresentationPage object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationPageInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationPageInput;
  updateActiveEstateInsightsPage?: InputMaybe<AugmentedUpdateActiveEstateInsightsPageInput>;
  updateBalanceSheetBundleConfiguration?: InputMaybe<AugmentedUpdateBalanceSheetBundleConfigurationInput>;
  updateBeneficiaryPage?: InputMaybe<AugmentedUpdateBeneficiaryPageInput>;
  updateCompletedEstateInsightsPage?: InputMaybe<AugmentedUpdateCompletedEstateInsightsPageInput>;
  updateCoverPage?: InputMaybe<AugmentedUpdatePresentationCoverPageInput>;
  updateCustomPage?: InputMaybe<AugmentedUpdatePresentationCustomPageInput>;
  updateDiagramPage?: InputMaybe<AugmentedUpdatePresentationDiagramPageInput>;
  updateDocumentSummaryPage?: InputMaybe<AugmentedUpdateDocumentSummaryPageInput>;
  updateMissingDocumentsPage?: InputMaybe<AugmentedUpdateMissingDocumentsPageInput>;
  updatePresentationBundleCoverPage?: InputMaybe<AugmentedUpdatePresentationBundleCoverPageInput>;
  updateWaterfallBundleCoverPage?: InputMaybe<AugmentedUpdateWaterfallBundleCoverPageInput>;
  withActiveEstateInsightsPage?: InputMaybe<AugmentedCreateActiveEstateInsightsPageInput>;
  withBalanceSheetBundleConfiguration?: InputMaybe<AugmentedCreateBalanceSheetBundleConfigurationInput>;
  withBeneficiaryPage?: InputMaybe<AugmentedCreateBeneficiaryPageInput>;
  withCompletedEstateInsightsPage?: InputMaybe<AugmentedCreateCompletedEstateInsightsPageInput>;
  withCoverPage?: InputMaybe<AugmentedCreatePresentationCoverPageInput>;
  withCustomPage?: InputMaybe<AugmentedCreatePresentationCustomPageInput>;
  withDiagramPage?: InputMaybe<AugmentedCreatePresentationDiagramPageInput>;
  withDocumentSummaryPage?: InputMaybe<AugmentedCreateDocumentSummaryPageInput>;
  withMissingDocumentsPage?: InputMaybe<AugmentedCreateMissingDocumentsPageInput>;
  withPresentationBundleCoverPage?: InputMaybe<AugmentedCreatePresentationBundleCoverPageInput>;
  withWaterfallBundleCoverPage?: InputMaybe<AugmentedCreateWaterfallBundleCoverPageInput>;
};

/**
 * AugmentedUpdatePresentationPlanningOpportunitiesBundleConfigurationInput is used for update PresentationPlanningOpportunitiesBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationPlanningOpportunitiesBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationPlanningOpportunitiesBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
  updateItems?: InputMaybe<Array<AugmentedUpdatePresentationPlanningOpportunitiesItemInput>>;
  withItems?: InputMaybe<Array<AugmentedCreatePresentationPlanningOpportunitiesItemInput>>;
};

/**
 * AugmentedUpdatePresentationPlanningOpportunitiesItemInput is used for update PresentationPlanningOpportunitiesItem object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationPlanningOpportunitiesItemInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationPlanningOpportunitiesItemInput;
  updateBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationPlanningOpportunitiesBundleConfigurationInput>;
};

/**
 * AugmentedUpdatePresentationPowerOfAttorneyBundleConfigurationInput is used for update PresentationPowerOfAttorneyBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationPowerOfAttorneyBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationPowerOfAttorneyBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
  updateClients?: InputMaybe<Array<AugmentedUpdatePresentationPowerOfAttorneyClientConfigurationInput>>;
  withClients?: InputMaybe<Array<AugmentedCreatePresentationPowerOfAttorneyClientConfigurationInput>>;
};

/**
 * AugmentedUpdatePresentationPowerOfAttorneyClientConfigurationInput is used for update PresentationPowerOfAttorneyClientConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationPowerOfAttorneyClientConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationPowerOfAttorneyClientConfigurationInput;
  updateBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationPowerOfAttorneyBundleConfigurationInput>;
  updatePowerOfAttorneyItems?: InputMaybe<Array<AugmentedUpdatePresentationPowerOfAttorneyItemInput>>;
  withPowerOfAttorneyItems?: InputMaybe<Array<AugmentedCreatePresentationPowerOfAttorneyItemInput>>;
};

/**
 * AugmentedUpdatePresentationPowerOfAttorneyItemInput is used for update PresentationPowerOfAttorneyItem object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationPowerOfAttorneyItemInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationPowerOfAttorneyItemInput;
  updateCitations?: InputMaybe<Array<AugmentedUpdatePresentationItemCitationInput>>;
  updateClientConfiguration?: InputMaybe<AugmentedUpdatePresentationPowerOfAttorneyClientConfigurationInput>;
  withCitations?: InputMaybe<Array<AugmentedCreatePresentationItemCitationInput>>;
};

/**
 * AugmentedUpdatePresentationTemplateBundleInput is used for update PresentationTemplateBundle object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationTemplateBundleInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationTemplateBundleInput;
  updateBeneficiariesTemplateBundleConfiguration?: InputMaybe<AugmentedUpdateBeneficiariesTemplateBundleConfigurationInput>;
  updateDividerTemplateBundleConfiguration?: InputMaybe<AugmentedUpdateDividerTemplateBundleConfigurationInput>;
  updateDocumentSummaryTemplateBundleConfiguration?: InputMaybe<AugmentedUpdateDocumentSummaryTemplateBundleConfigurationInput>;
  updateEntitySummaryTemplateBundleConfiguration?: InputMaybe<AugmentedUpdateEntitySummaryTemplateBundleConfigurationInput>;
  updateInsightsTemplateBundleConfiguration?: InputMaybe<AugmentedUpdateInsightsTemplateBundleConfigurationInput>;
  updatePages?: InputMaybe<Array<AugmentedUpdatePresentationTemplatePageInput>>;
  updateWaterfallComparisonTemplateBundleConfiguration?: InputMaybe<AugmentedUpdateWaterfallComparisonTemplateBundleConfigurationInput>;
  updateWaterfallTemplateBundleConfiguration?: InputMaybe<AugmentedUpdateWaterfallTemplateBundleConfigurationInput>;
  withBeneficiariesTemplateBundleConfiguration?: InputMaybe<AugmentedCreateBeneficiariesTemplateBundleConfigurationInput>;
  withDividerTemplateBundleConfiguration?: InputMaybe<AugmentedCreateDividerTemplateBundleConfigurationInput>;
  withDocumentSummaryTemplateBundleConfiguration?: InputMaybe<AugmentedCreateDocumentSummaryTemplateBundleConfigurationInput>;
  withEntitySummaryTemplateBundleConfiguration?: InputMaybe<AugmentedCreateEntitySummaryTemplateBundleConfigurationInput>;
  withInsightsTemplateBundleConfiguration?: InputMaybe<AugmentedCreateInsightsTemplateBundleConfigurationInput>;
  withPages?: InputMaybe<Array<AugmentedCreatePresentationTemplatePageInput>>;
  withWaterfallComparisonTemplateBundleConfiguration?: InputMaybe<AugmentedCreateWaterfallComparisonTemplateBundleConfigurationInput>;
  withWaterfallTemplateBundleConfiguration?: InputMaybe<AugmentedCreateWaterfallTemplateBundleConfigurationInput>;
};

/**
 * AugmentedUpdatePresentationTemplateCoverPageInput is used for update PresentationTemplateCoverPage object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationTemplateCoverPageInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationTemplateCoverPageInput;
  updateTemplatePage?: InputMaybe<AugmentedUpdatePresentationTemplatePageInput>;
};

/**
 * AugmentedUpdatePresentationTemplateCustomPageInput is used for update PresentationTemplateCustomPage object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationTemplateCustomPageInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationTemplateCustomPageInput;
  updateTemplatePage?: InputMaybe<AugmentedUpdatePresentationTemplatePageInput>;
};

/**
 * AugmentedUpdatePresentationTemplateDiagramPageInput is used for update PresentationTemplateDiagramPage object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationTemplateDiagramPageInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationTemplateDiagramPageInput;
  updateTemplatePage?: InputMaybe<AugmentedUpdatePresentationTemplatePageInput>;
};

/**
 * AugmentedUpdatePresentationTemplateInput is used for update PresentationTemplate object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationTemplateInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationTemplateInput;
  updateBundles?: InputMaybe<Array<AugmentedUpdatePresentationTemplateBundleInput>>;
  withBundles?: InputMaybe<Array<AugmentedCreatePresentationTemplateBundleInput>>;
};

/**
 * AugmentedUpdatePresentationTemplatePageInput is used for update PresentationTemplatePage object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationTemplatePageInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationTemplatePageInput;
  updateCoverPage?: InputMaybe<AugmentedUpdatePresentationTemplateCoverPageInput>;
  updateCustomPage?: InputMaybe<AugmentedUpdatePresentationTemplateCustomPageInput>;
  updateDiagramPage?: InputMaybe<AugmentedUpdatePresentationTemplateDiagramPageInput>;
  withCoverPage?: InputMaybe<AugmentedCreatePresentationTemplateCoverPageInput>;
  withCustomPage?: InputMaybe<AugmentedCreatePresentationTemplateCustomPageInput>;
  withDiagramPage?: InputMaybe<AugmentedCreatePresentationTemplateDiagramPageInput>;
};

/**
 * AugmentedUpdatePresentationTrustOverviewBundleConfigurationInput is used for update PresentationTrustOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationTrustOverviewBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationTrustOverviewBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
  updateTrusts?: InputMaybe<Array<AugmentedUpdatePresentationTrustOverviewTrustConfigurationInput>>;
  withTrusts?: InputMaybe<Array<AugmentedCreatePresentationTrustOverviewTrustConfigurationInput>>;
};

/**
 * AugmentedUpdatePresentationTrustOverviewItemInput is used for update PresentationTrustOverviewItem object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationTrustOverviewItemInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationTrustOverviewItemInput;
  updateCitations?: InputMaybe<Array<AugmentedUpdatePresentationItemCitationInput>>;
  updateTrustConfiguration?: InputMaybe<AugmentedUpdatePresentationTrustOverviewTrustConfigurationInput>;
  withCitations?: InputMaybe<Array<AugmentedCreatePresentationItemCitationInput>>;
};

/**
 * AugmentedUpdatePresentationTrustOverviewTrustConfigurationInput is used for update PresentationTrustOverviewTrustConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationTrustOverviewTrustConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationTrustOverviewTrustConfigurationInput;
  updateBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationTrustOverviewBundleConfigurationInput>;
  updateTrustItems?: InputMaybe<Array<AugmentedUpdatePresentationTrustOverviewItemInput>>;
  withTrustItems?: InputMaybe<Array<AugmentedCreatePresentationTrustOverviewItemInput>>;
};

/**
 * AugmentedUpdatePresentationWillBundleConfigurationInput is used for update PresentationWillBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationWillBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationWillBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
  updateClients?: InputMaybe<Array<AugmentedUpdatePresentationWillClientConfigurationInput>>;
  withClients?: InputMaybe<Array<AugmentedCreatePresentationWillClientConfigurationInput>>;
};

/**
 * AugmentedUpdatePresentationWillClientConfigurationInput is used for update PresentationWillClientConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationWillClientConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationWillClientConfigurationInput;
  updateBundleConfiguration?: InputMaybe<AugmentedUpdatePresentationWillBundleConfigurationInput>;
  updateWillItems?: InputMaybe<Array<AugmentedUpdatePresentationWillItemInput>>;
  withWillItems?: InputMaybe<Array<AugmentedCreatePresentationWillItemInput>>;
};

/**
 * AugmentedUpdatePresentationWillItemInput is used for update PresentationWillItem object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePresentationWillItemInput = {
  id: Scalars['ID']['input'];
  update: UpdatePresentationWillItemInput;
  updateCitations?: InputMaybe<Array<AugmentedUpdatePresentationItemCitationInput>>;
  updateClientConfiguration?: InputMaybe<AugmentedUpdatePresentationWillClientConfigurationInput>;
  withCitations?: InputMaybe<Array<AugmentedCreatePresentationItemCitationInput>>;
};

/**
 * AugmentedUpdatePrincipalInput is used for update Principal object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePrincipalInput = {
  id: Scalars['ID']['input'];
  update: UpdatePrincipalInput;
};

/**
 * AugmentedUpdatePrivateFoundationInput is used for update PrivateFoundation object.
 * Input was generated by ent.
 */
export type AugmentedUpdatePrivateFoundationInput = {
  id: Scalars['ID']['input'];
  update: UpdatePrivateFoundationInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateControllingParties?: InputMaybe<Array<AugmentedUpdateControllingPartyInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateDonors?: InputMaybe<Array<AugmentedUpdatePrincipalInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updatePolicies?: InputMaybe<Array<AugmentedUpdateInsurancePolicyInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withDonors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedUpdateProfessionalTeamRoleInput is used for update ProfessionalTeamRole object.
 * Input was generated by ent.
 */
export type AugmentedUpdateProfessionalTeamRoleInput = {
  id: Scalars['ID']['input'];
  update: UpdateProfessionalTeamRoleInput;
  updateIndividual?: InputMaybe<AugmentedUpdateClientProfileInput>;
  updateOrganization?: InputMaybe<AugmentedUpdateClientOrganizationInput>;
};

/**
 * AugmentedUpdateProposalInput is used for update Proposal object.
 * Input was generated by ent.
 */
export type AugmentedUpdateProposalInput = {
  id: Scalars['ID']['input'];
  update: UpdateProposalInput;
  updateCltProposal?: InputMaybe<AugmentedUpdateCltProposalInput>;
  updateCrtProposal?: InputMaybe<AugmentedUpdateCrtProposalInput>;
  updateEntityProposals?: InputMaybe<Array<AugmentedUpdateEntityProposalInput>>;
  updateGiftingProposal?: InputMaybe<AugmentedUpdateGiftingProposalInput>;
  withCltProposal?: InputMaybe<AugmentedCreateCltProposalInput>;
  withCrtProposal?: InputMaybe<AugmentedCreateCrtProposalInput>;
  withEntityProposals?: InputMaybe<Array<AugmentedCreateEntityProposalInput>>;
  withGiftingProposal?: InputMaybe<AugmentedCreateGiftingProposalInput>;
};

/**
 * AugmentedUpdateProposalScenarioInput is used for update ProposalScenario object.
 * Input was generated by ent.
 */
export type AugmentedUpdateProposalScenarioInput = {
  id: Scalars['ID']['input'];
  update: UpdateProposalScenarioInput;
  updateGratProposalScenario?: InputMaybe<AugmentedUpdateGratProposalScenarioInput>;
  withGratProposalScenario?: InputMaybe<AugmentedCreateGratProposalScenarioInput>;
};

/**
 * AugmentedUpdateQPRTTrustInput is used for update QPRTTrust object.
 * Input was generated by ent.
 */
export type AugmentedUpdateQprtTrustInput = {
  id: Scalars['ID']['input'];
  update: UpdateQprtTrustInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateGrantors?: InputMaybe<Array<AugmentedUpdatePrincipalInput>>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateSuccessorTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  updateTrustAdvisors?: InputMaybe<Array<AugmentedUpdateTrustAdvisorInput>>;
  updateTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withGrantors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedUpdateQualifiedTuitionPersonalAccountInput is used for update QualifiedTuitionPersonalAccount object.
 * Input was generated by ent.
 */
export type AugmentedUpdateQualifiedTuitionPersonalAccountInput = {
  id: Scalars['ID']['input'];
  update: UpdateQualifiedTuitionPersonalAccountInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateControllingParties?: InputMaybe<Array<AugmentedUpdateControllingPartyInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateOwner?: InputMaybe<AugmentedUpdatePrincipalInput>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withOwner?: InputMaybe<AugmentedCreatePrincipalInput>;
};

/**
 * AugmentedUpdateRetirementPersonalAccountInput is used for update RetirementPersonalAccount object.
 * Input was generated by ent.
 */
export type AugmentedUpdateRetirementPersonalAccountInput = {
  id: Scalars['ID']['input'];
  update: UpdateRetirementPersonalAccountInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateBeneficiaryDesignationGroups?: InputMaybe<Array<AugmentedUpdateBeneficiaryDesignationGroupInput>>;
  updateControllingParties?: InputMaybe<Array<AugmentedUpdateControllingPartyInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateHypotheticalBeneficiaryDesignationGroups?: InputMaybe<Array<AugmentedUpdateBeneficiaryDesignationGroupInput>>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateOwner?: InputMaybe<AugmentedUpdatePrincipalInput>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withBeneficiaryDesignationGroups?: InputMaybe<Array<AugmentedCreateBeneficiaryDesignationGroupInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalBeneficiaryDesignationGroups?: InputMaybe<Array<AugmentedCreateBeneficiaryDesignationGroupInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withOwner?: InputMaybe<AugmentedCreatePrincipalInput>;
};

/**
 * AugmentedUpdateRevocableTrustInput is used for update RevocableTrust object.
 * Input was generated by ent.
 */
export type AugmentedUpdateRevocableTrustInput = {
  id: Scalars['ID']['input'];
  update: UpdateRevocableTrustInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateGrantors?: InputMaybe<Array<AugmentedUpdatePrincipalInput>>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updatePolicies?: InputMaybe<Array<AugmentedUpdateInsurancePolicyInput>>;
  updateSuccessorTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  updateTrustAdvisors?: InputMaybe<Array<AugmentedUpdateTrustAdvisorInput>>;
  updateTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withGrantors?: InputMaybe<Array<AugmentedCreatePrincipalInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedUpdateRoleInput is used for update Role object.
 * Input was generated by ent.
 */
export type AugmentedUpdateRoleInput = {
  id: Scalars['ID']['input'];
  update: UpdateRoleInput;
};

/**
 * AugmentedUpdateSCorpBusinessEntityInput is used for update SCorpBusinessEntity object.
 * Input was generated by ent.
 */
export type AugmentedUpdateSCorpBusinessEntityInput = {
  id: Scalars['ID']['input'];
  update: UpdateSCorpBusinessEntityInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateKeyPeople?: InputMaybe<Array<AugmentedUpdateKeyPersonInput>>;
  updatePolicies?: InputMaybe<Array<AugmentedUpdateInsurancePolicyInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withKeyPeople?: InputMaybe<Array<AugmentedCreateKeyPersonInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
};

/**
 * AugmentedUpdateSLATTrustInput is used for update SLATTrust object.
 * Input was generated by ent.
 */
export type AugmentedUpdateSlatTrustInput = {
  id: Scalars['ID']['input'];
  update: UpdateSlatTrustInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateGrantor?: InputMaybe<AugmentedUpdatePrincipalInput>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateLifetimeBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updatePolicies?: InputMaybe<Array<AugmentedUpdateInsurancePolicyInput>>;
  updateRemainderBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateSuccessorTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  updateTrustAdvisors?: InputMaybe<Array<AugmentedUpdateTrustAdvisorInput>>;
  updateTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withGrantor?: InputMaybe<AugmentedCreatePrincipalInput>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withLifetimeBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withPolicies?: InputMaybe<Array<AugmentedCreateInsurancePolicyInput>>;
  withRemainderBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedUpdateSSOConnectionInput is used for update SSOConnection object.
 * Input was generated by ent.
 */
export type AugmentedUpdateSsoConnectionInput = {
  id: Scalars['ID']['input'];
  update: UpdateSsoConnectionInput;
};

/**
 * AugmentedUpdateScheduledDistributionInput is used for update ScheduledDistribution object.
 * Input was generated by ent.
 */
export type AugmentedUpdateScheduledDistributionInput = {
  id: Scalars['ID']['input'];
  update: UpdateScheduledDistributionInput;
};

/**
 * AugmentedUpdateSoleProprietorshipBusinessEntityInput is used for update SoleProprietorshipBusinessEntity object.
 * Input was generated by ent.
 */
export type AugmentedUpdateSoleProprietorshipBusinessEntityInput = {
  id: Scalars['ID']['input'];
  update: UpdateSoleProprietorshipBusinessEntityInput;
  updateAccounts?: InputMaybe<Array<AugmentedUpdateAccountInput>>;
  updateDesignerAccount?: InputMaybe<AugmentedUpdateAccountInput>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateEntity?: InputMaybe<AugmentedUpdateEntityInput>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateKeyPeople?: InputMaybe<Array<AugmentedUpdateKeyPersonInput>>;
  withAccounts?: InputMaybe<Array<AugmentedCreateAccountInput>>;
  withDesignerAccount?: InputMaybe<AugmentedCreateAccountInput>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withKeyPeople?: InputMaybe<Array<AugmentedCreateKeyPersonInput>>;
};

/**
 * AugmentedUpdateSubBrandDisclaimerConfigurationInput is used for update SubBrandDisclaimerConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateSubBrandDisclaimerConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateSubBrandDisclaimerConfigurationInput;
};

/**
 * AugmentedUpdateSubBrandInput is used for update SubBrand object.
 * Input was generated by ent.
 */
export type AugmentedUpdateSubBrandInput = {
  id: Scalars['ID']['input'];
  update: UpdateSubBrandInput;
};

/**
 * AugmentedUpdateTaxDragConfigInput is used for update TaxDragConfig object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTaxDragConfigInput = {
  id: Scalars['ID']['input'];
  update: UpdateTaxDragConfigInput;
  updateGrowthProfile?: InputMaybe<AugmentedUpdateGrowthProfileInput>;
};

/**
 * AugmentedUpdateTaxDragOverrideInput is used for update TaxDragOverride object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTaxDragOverrideInput = {
  id: Scalars['ID']['input'];
  update: UpdateTaxDragOverrideInput;
  updateGrowthProfile?: InputMaybe<AugmentedUpdateGrowthProfileInput>;
};

/**
 * AugmentedUpdateTeamInput is used for update Team object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTeamInput = {
  id: Scalars['ID']['input'];
  update: UpdateTeamInput;
};

/**
 * AugmentedUpdateTenantApplicationConfigurationInput is used for update TenantApplicationConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTenantApplicationConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateTenantApplicationConfigurationInput;
};

/**
 * AugmentedUpdateTenantBrandingInput is used for update TenantBranding object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTenantBrandingInput = {
  id: Scalars['ID']['input'];
  update: UpdateTenantBrandingInput;
};

/**
 * AugmentedUpdateTenantDisclaimerConfigurationInput is used for update TenantDisclaimerConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTenantDisclaimerConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateTenantDisclaimerConfigurationInput;
};

/**
 * AugmentedUpdateTenantDocumentInput is used for update TenantDocument object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTenantDocumentInput = {
  id: Scalars['ID']['input'];
  update: UpdateTenantDocumentInput;
};

/**
 * AugmentedUpdateTenantInput is used for update Tenant object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTenantInput = {
  id: Scalars['ID']['input'];
  update: UpdateTenantInput;
};

/**
 * AugmentedUpdateTenantReminderEmailsConfigurationInput is used for update TenantReminderEmailsConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTenantReminderEmailsConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateTenantReminderEmailsConfigurationInput;
};

/**
 * AugmentedUpdateTenantSSOConnectionInput is used for update TenantSSOConnection object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTenantSsoConnectionInput = {
  id: Scalars['ID']['input'];
  update: UpdateTenantSsoConnectionInput;
};

/**
 * AugmentedUpdateTenantSecurityConfigurationInput is used for update TenantSecurityConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTenantSecurityConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateTenantSecurityConfigurationInput;
};

/**
 * AugmentedUpdateTenantSlideConfigInput is used for update TenantSlideConfig object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTenantSlideConfigInput = {
  id: Scalars['ID']['input'];
  update: UpdateTenantSlideConfigInput;
};

/**
 * AugmentedUpdateTestCMKEncryptionInput is used for update TestCMKEncryption object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTestCmkEncryptionInput = {
  id: Scalars['ID']['input'];
  update: UpdateTestCmkEncryptionInput;
};

/**
 * AugmentedUpdateTestamentaryEntityInput is used for update TestamentaryEntity object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTestamentaryEntityInput = {
  id: Scalars['ID']['input'];
  update: UpdateTestamentaryEntityInput;
  updateAccountOwner?: InputMaybe<AugmentedUpdateClientProfileInput>;
  updateBeneficiaries?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateBeneficiariesAfterBothGrantorDeaths?: InputMaybe<Array<AugmentedUpdateBeneficiaryInput>>;
  updateControllingParties?: InputMaybe<Array<AugmentedUpdateControllingPartyInput>>;
  updateDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateDispositiveProvisions?: InputMaybe<Array<AugmentedUpdateDispositiveProvisionInput>>;
  updateDispositiveProvisionsTemplate?: InputMaybe<AugmentedUpdateDispositiveProvisionTemplateInput>;
  updateEntityDocumentRelationships?: InputMaybe<Array<AugmentedUpdateEntityDocumentRelationshipInput>>;
  updateHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedUpdateDispositionScenarioInput>>;
  updateHypotheticalDispositiveProvisions?: InputMaybe<Array<AugmentedUpdateDispositiveProvisionInput>>;
  updateHypotheticalDispositiveProvisionsTemplates?: InputMaybe<Array<AugmentedUpdateHypotheticalWaterfallDispositiveProvisionTemplateInput>>;
  updateSuccessorTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  updateTaxInfo?: InputMaybe<AugmentedUpdateEntityTaxInfoInput>;
  updateTrustAdvisors?: InputMaybe<Array<AugmentedUpdateTrustAdvisorInput>>;
  updateTrustees?: InputMaybe<Array<AugmentedUpdateTrusteeInput>>;
  withAccountOwner?: InputMaybe<AugmentedCreateClientProfileInput>;
  withBeneficiaries?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withBeneficiariesAfterBothGrantorDeaths?: InputMaybe<Array<AugmentedCreateBeneficiaryInput>>;
  withControllingParties?: InputMaybe<Array<AugmentedCreateControllingPartyInput>>;
  withDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withDispositiveProvisions?: InputMaybe<Array<AugmentedCreateDispositiveProvisionInput>>;
  withDispositiveProvisionsTemplate?: InputMaybe<AugmentedCreateDispositiveProvisionTemplateInput>;
  withEntityDocumentRelationships?: InputMaybe<Array<AugmentedCreateEntityDocumentRelationshipInput>>;
  withHypotheticalDispositionScenarios?: InputMaybe<Array<AugmentedCreateDispositionScenarioInput>>;
  withHypotheticalDispositiveProvisions?: InputMaybe<Array<AugmentedCreateDispositiveProvisionInput>>;
  withHypotheticalDispositiveProvisionsTemplates?: InputMaybe<Array<AugmentedCreateHypotheticalWaterfallDispositiveProvisionTemplateInput>>;
  withSuccessorTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
  withTaxInfo?: InputMaybe<AugmentedCreateEntityTaxInfoInput>;
  withTrustAdvisors?: InputMaybe<Array<AugmentedCreateTrustAdvisorInput>>;
  withTrustees?: InputMaybe<Array<AugmentedCreateTrusteeInput>>;
};

/**
 * AugmentedUpdateTrustAdvisorInput is used for update TrustAdvisor object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTrustAdvisorInput = {
  id: Scalars['ID']['input'];
  update: UpdateTrustAdvisorInput;
  updateRoles?: InputMaybe<Array<AugmentedUpdateTrustAdvisorRoleInput>>;
  withRoles?: InputMaybe<Array<AugmentedCreateTrustAdvisorRoleInput>>;
};

/**
 * AugmentedUpdateTrustAdvisorRoleInput is used for update TrustAdvisorRole object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTrustAdvisorRoleInput = {
  id: Scalars['ID']['input'];
  update: UpdateTrustAdvisorRoleInput;
  updateTrustAdvisor?: InputMaybe<AugmentedUpdateTrustAdvisorInput>;
};

/**
 * AugmentedUpdateTrusteeDutyInput is used for update TrusteeDuty object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTrusteeDutyInput = {
  id: Scalars['ID']['input'];
  update: UpdateTrusteeDutyInput;
  updateTrustee?: InputMaybe<AugmentedUpdateTrusteeInput>;
};

/**
 * AugmentedUpdateTrusteeInput is used for update Trustee object.
 * Input was generated by ent.
 */
export type AugmentedUpdateTrusteeInput = {
  id: Scalars['ID']['input'];
  update: UpdateTrusteeInput;
  updateDuties?: InputMaybe<Array<AugmentedUpdateTrusteeDutyInput>>;
  withDuties?: InputMaybe<Array<AugmentedCreateTrusteeDutyInput>>;
};

/**
 * AugmentedUpdateUserInput is used for update User object.
 * Input was generated by ent.
 */
export type AugmentedUpdateUserInput = {
  id: Scalars['ID']['input'];
  update: UpdateUserInput;
};

/**
 * AugmentedUpdateUserNotificationConfigurationInput is used for update UserNotificationConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateUserNotificationConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateUserNotificationConfigurationInput;
};

/**
 * AugmentedUpdateWaterfallBundleConfigurationInput is used for update WaterfallBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateWaterfallBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateWaterfallBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
};

/**
 * AugmentedUpdateWaterfallBundleCoverPageInput is used for update WaterfallBundleCoverPage object.
 * Input was generated by ent.
 */
export type AugmentedUpdateWaterfallBundleCoverPageInput = {
  id: Scalars['ID']['input'];
  update: UpdateWaterfallBundleCoverPageInput;
};

/**
 * AugmentedUpdateWaterfallComparisonBundleConfigurationInput is used for update WaterfallComparisonBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateWaterfallComparisonBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateWaterfallComparisonBundleConfigurationInput;
  updateBundle?: InputMaybe<AugmentedUpdatePresentationBundleInput>;
  updateComparedWaterfalls?: InputMaybe<Array<AugmentedUpdateComparedWaterfallInput>>;
  withComparedWaterfalls?: InputMaybe<Array<AugmentedCreateComparedWaterfallInput>>;
};

/**
 * AugmentedUpdateWaterfallComparisonTemplateBundleConfigurationInput is used for update WaterfallComparisonTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateWaterfallComparisonTemplateBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateWaterfallComparisonTemplateBundleConfigurationInput;
  updateTemplateBundle?: InputMaybe<AugmentedUpdatePresentationTemplateBundleInput>;
};

/**
 * AugmentedUpdateWaterfallTemplateBundleConfigurationInput is used for update WaterfallTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type AugmentedUpdateWaterfallTemplateBundleConfigurationInput = {
  id: Scalars['ID']['input'];
  update: UpdateWaterfallTemplateBundleConfigurationInput;
  updateTemplateBundle?: InputMaybe<AugmentedUpdatePresentationTemplateBundleInput>;
};

/**
 * AuthorizationLevel is a description of the authorization level for a specific user for a specific
 * set of application functionality
 */
export enum AuthorizationLevel {
  /** EDITOR: Read, write, delete, and potentially other elevated access to a functionality set. */
  Admin = 'ADMIN',
  /** EDITOR: Read and write access to a functionality set. */
  Editor = 'EDITOR',
  /** NONE: No read or write access to a functionality set. */
  None = 'NONE',
  /** VIEW: Read access to a functionality set. */
  View = 'VIEW'
}

export type BalanceSheet = {
  __typename?: 'BalanceSheet';
  columnGroups: Array<BalanceSheetColumnGroup>;
  columns: Array<BalanceSheetColumn>;
  hasNoValues: Scalars['Boolean']['output'];
  rows: Array<BalanceSheetRow>;
};

export type BalanceSheetBundleConfiguration = Node & {
  __typename?: 'BalanceSheetBundleConfiguration';
  bundle?: Maybe<PresentationBundle>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The display name for the bundle. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Column IDs that should be hidden from the balance sheet display */
  hiddenColumns: Array<Scalars['String']['output']>;
  /** Whether to hide small values on the balance sheet */
  hideSmallValues: Scalars['Boolean']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** When true, life insurance death benefit drives balance sheet totals and summary metrics; when false, cash value does */
  includeDeathBenefitInTotals: Scalars['Boolean']['output'];
  /** Whether to include a separate expanded asset categories slide in the bundle */
  includeExpandedAssetCategoriesSlide: Scalars['Boolean']['output'];
  /** Whether to include a full export slide that is not confined to standard page dimensions */
  includeExportSlide: Scalars['Boolean']['output'];
  page?: Maybe<PresentationPage>;
  /** Whether to separate directly held assets in the estate into client 1/client 2/joint */
  separateInEstateDirectlyHeld: Scalars['Boolean']['output'];
  /** Whether to show separate columns for trusts that are in the estate */
  separateInEstateTrusts: Scalars['Boolean']['output'];
  /** Whether to show separate columns for trusts that are out of the estate */
  separateOutOfEstateTrusts: Scalars['Boolean']['output'];
  /** Whether to show expanded asset categories on the balance sheet */
  showExpandedAssetCategories: Scalars['Boolean']['output'];
  /** Whether to show assets in the estate */
  showInEstate: Scalars['Boolean']['output'];
  /** Whether to show assets out of the estate */
  showOutOfEstate: Scalars['Boolean']['output'];
  /** Whether to display summary metrics at the top of the balance sheet */
  showSummaryMetrics: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type BalanceSheetBundleConfigurationConnection = {
  __typename?: 'BalanceSheetBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BalanceSheetBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BalanceSheetBundleConfigurationEdge = {
  __typename?: 'BalanceSheetBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BalanceSheetBundleConfiguration>;
};

/** Ordering options for BalanceSheetBundleConfiguration connections */
export type BalanceSheetBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BalanceSheetBundleConfigurations. */
  field: BalanceSheetBundleConfigurationOrderField;
};

/** Properties by which BalanceSheetBundleConfiguration connections can be ordered. */
export enum BalanceSheetBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * BalanceSheetBundleConfigurationWhereInput is used for filtering BalanceSheetBundleConfiguration objects.
 * Input was generated by ent.
 */
export type BalanceSheetBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<BalanceSheetBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** page edge predicates */
  hasPage?: InputMaybe<Scalars['Boolean']['input']>;
  hasPageWith?: InputMaybe<Array<PresentationPageWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** hide_small_values field predicates */
  hideSmallValues?: InputMaybe<Scalars['Boolean']['input']>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_death_benefit_in_totals field predicates */
  includeDeathBenefitInTotals?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_expanded_asset_categories_slide field predicates */
  includeExpandedAssetCategoriesSlide?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_export_slide field predicates */
  includeExportSlide?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BalanceSheetBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<BalanceSheetBundleConfigurationWhereInput>>;
  /** separate_in_estate_directly_held field predicates */
  separateInEstateDirectlyHeld?: InputMaybe<Scalars['Boolean']['input']>;
  /** separate_in_estate_trusts field predicates */
  separateInEstateTrusts?: InputMaybe<Scalars['Boolean']['input']>;
  /** separate_out_of_estate_trusts field predicates */
  separateOutOfEstateTrusts?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_expanded_asset_categories field predicates */
  showExpandedAssetCategories?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_in_estate field predicates */
  showInEstate?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_out_of_estate field predicates */
  showOutOfEstate?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_summary_metrics field predicates */
  showSummaryMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type BalanceSheetCategory = Node & {
  __typename?: 'BalanceSheetCategory';
  assetClasses: AssetClassConnection;
  createdAt: Scalars['Time']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Whether this is a system category that cannot be deleted */
  isSystemCategory: Scalars['Boolean']['output'];
  /** The order in which this balance sheet category should be displayed in the UI */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  type: BalanceSheetCategoryType;
  updatedAt: Scalars['Time']['output'];
};


export type BalanceSheetCategoryAssetClassesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssetClassOrder>>;
  where?: InputMaybe<AssetClassWhereInput>;
};

/** A connection to a list of items. */
export type BalanceSheetCategoryConnection = {
  __typename?: 'BalanceSheetCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BalanceSheetCategoryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BalanceSheetCategoryEdge = {
  __typename?: 'BalanceSheetCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BalanceSheetCategory>;
};

/** Ordering options for BalanceSheetCategory connections */
export type BalanceSheetCategoryOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BalanceSheetCategories. */
  field: BalanceSheetCategoryOrderField;
};

/** Properties by which BalanceSheetCategory connections can be ordered. */
export enum BalanceSheetCategoryOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/** BalanceSheetCategoryType is enum for the field type */
export enum BalanceSheetCategoryType {
  Asset = 'ASSET',
  Insurance = 'INSURANCE',
  Liabilities = 'LIABILITIES',
  Receivables = 'RECEIVABLES',
  Unspecified = 'UNSPECIFIED'
}

/**
 * BalanceSheetCategoryWhereInput is used for filtering BalanceSheetCategory objects.
 * Input was generated by ent.
 */
export type BalanceSheetCategoryWhereInput = {
  and?: InputMaybe<Array<BalanceSheetCategoryWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** asset_classes edge predicates */
  hasAssetClasses?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetClassesWith?: InputMaybe<Array<AssetClassWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_system_category field predicates */
  isSystemCategory?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BalanceSheetCategoryWhereInput>;
  or?: InputMaybe<Array<BalanceSheetCategoryWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** type field predicates */
  type?: InputMaybe<BalanceSheetCategoryType>;
  typeIn?: InputMaybe<Array<BalanceSheetCategoryType>>;
  typeNEQ?: InputMaybe<BalanceSheetCategoryType>;
  typeNotIn?: InputMaybe<Array<BalanceSheetCategoryType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type BalanceSheetColumn = {
  __typename?: 'BalanceSheetColumn';
  ID: Scalars['String']['output'];
  display: Scalars['String']['output'];
  group: Scalars['String']['output'];
  isHidden: Scalars['Boolean']['output'];
  variant?: Maybe<BalanceSheetColumnVariant>;
};

export type BalanceSheetColumnGroup = {
  __typename?: 'BalanceSheetColumnGroup';
  ID: Scalars['String']['output'];
  display: Scalars['String']['output'];
};

export enum BalanceSheetColumnVariant {
  Highlight = 'HIGHLIGHT'
}

export type BalanceSheetRow = {
  __typename?: 'BalanceSheetRow';
  ID: Scalars['String']['output'];
  /**
   * associatedNodes is a link to associated entities or liabilites that are related to information in the
   * balance sheet row.
   */
  associatedNodes?: Maybe<Array<Maybe<Node>>>;
  categoryType?: Maybe<BalanceSheetCategoryType>;
  children?: Maybe<Array<BalanceSheetRow>>;
  description?: Maybe<Scalars['String']['output']>;
  display: Scalars['String']['output'];
  type: BalanceSheetRowType;
  values: Array<BalanceSheetRowValue>;
};

export enum BalanceSheetRowType {
  Category = 'CATEGORY',
  LineItem = 'LINE_ITEM',
  NetWorth = 'NET_WORTH',
  Total = 'TOTAL'
}

export type BalanceSheetRowValue = {
  __typename?: 'BalanceSheetRowValue';
  columnID: Scalars['String']['output'];
  /**
   * secondaryValue is, as of now, only used to communicate the cash value total of an insurance policy
   * (death benefits are communicated through the main number)
   */
  secondaryValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** secondaryValueDescription is, as of now, only used to add additional context/label the secondaryValue */
  secondaryValueDescription?: Maybe<Scalars['String']['output']>;
  /**
   * supportsCashValue indicates whether the underlying insurance policy kind can
   * carry a cash value. When false (e.g. term life) the client renders "-" instead
   * of a cash-value amount for the secondary line. Null when not applicable
   * (non-insurance rows, or the death-benefit config is off).
   */
  supportsCashValue?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['CurrencyUSD']['output'];
};

export type BalanceSheetViewConfiguration = Node & {
  __typename?: 'BalanceSheetViewConfiguration';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Column IDs that should be hidden from the balance sheet display */
  hiddenColumns: Array<Scalars['String']['output']>;
  /** Whether to hide small values on the balance sheet */
  hideSmallValues: Scalars['Boolean']['output'];
  household: Household;
  id: Scalars['ID']['output'];
  /** When true, life insurance death benefit drives balance sheet totals and summary metrics; when false, cash value does */
  includeDeathBenefitInTotals: Scalars['Boolean']['output'];
  /** Whether to separate directly held assets in the estate into client 1/client 2/joint */
  separateInEstateDirectlyHeld: Scalars['Boolean']['output'];
  /** Whether to show separate columns for trusts that are in the estate */
  separateInEstateTrusts: Scalars['Boolean']['output'];
  /** Whether to show separate columns for trusts that are out of the estate */
  separateOutOfEstateTrusts: Scalars['Boolean']['output'];
  /** Whether to show expanded asset categories on the balance sheet */
  showExpandedAssetCategories: Scalars['Boolean']['output'];
  /** Whether to show assets in the estate */
  showInEstate: Scalars['Boolean']['output'];
  /** Whether to show assets out of the estate */
  showOutOfEstate: Scalars['Boolean']['output'];
  /** Whether to display summary metrics at the top of the balance sheet */
  showSummaryMetrics: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for BalanceSheetViewConfiguration connections */
export type BalanceSheetViewConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BalanceSheetViewConfigurations. */
  field: BalanceSheetViewConfigurationOrderField;
};

/** Properties by which BalanceSheetViewConfiguration connections can be ordered. */
export enum BalanceSheetViewConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * BalanceSheetViewConfigurationWhereInput is used for filtering BalanceSheetViewConfiguration objects.
 * Input was generated by ent.
 */
export type BalanceSheetViewConfigurationWhereInput = {
  and?: InputMaybe<Array<BalanceSheetViewConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** hide_small_values field predicates */
  hideSmallValues?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_death_benefit_in_totals field predicates */
  includeDeathBenefitInTotals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BalanceSheetViewConfigurationWhereInput>;
  or?: InputMaybe<Array<BalanceSheetViewConfigurationWhereInput>>;
  /** separate_in_estate_directly_held field predicates */
  separateInEstateDirectlyHeld?: InputMaybe<Scalars['Boolean']['input']>;
  /** separate_in_estate_trusts field predicates */
  separateInEstateTrusts?: InputMaybe<Scalars['Boolean']['input']>;
  /** separate_out_of_estate_trusts field predicates */
  separateOutOfEstateTrusts?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_expanded_asset_categories field predicates */
  showExpandedAssetCategories?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_in_estate field predicates */
  showInEstate?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_out_of_estate field predicates */
  showOutOfEstate?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_summary_metrics field predicates */
  showSummaryMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type BasicEntityDetailsSuggestion = {
  __typename?: 'BasicEntityDetailsSuggestion';
  beneficiaries?: Maybe<Array<PrincipalSuggestion>>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityKind?: Maybe<EntityKind>;
  grantorsOrDonors?: Maybe<Array<PrincipalSuggestion>>;
  inEstateStatus?: Maybe<EntityInEstateStatus>;
  trustees?: Maybe<Array<PrincipalSuggestion>>;
  valuationAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
};

/** Creates a single-entity diagram and its groups in one operation. */
export type BatchCreateEntityDiagramInput = {
  create: CreateEntityDiagramInput;
  createGroups?: InputMaybe<Array<BatchGraphVisualizationGroupCreateInput>>;
};

export type BatchCreateEntityDiagramPayload = {
  __typename?: 'BatchCreateEntityDiagramPayload';
  createdGroupIdMapping: Array<GroupIdMapping>;
  entityDiagram: EntityDiagram;
};

/**
 * BatchEstateWaterfallGroupCreateInput is used to create a new visualization group
 * with a client-generated temporary ID that will be mapped to a real server ID.
 */
export type BatchEstateWaterfallGroupCreateInput = {
  /** Optional description for the group. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the group. */
  displayName: Scalars['String']['input'];
  /** The household this group belongs to. */
  householdID: Scalars['ID']['input'];
  /** The namespace (afterDeath section) for this group. */
  namespace: AfterDeath;
  /** The IDs of the nodes to include in this group. */
  nodeIds: Array<Scalars['ID']['input']>;
  /**
   * Client-generated temporary ID (format: "UI_ONLY_GROUP_NODE{n}" where n is an incrementing counter).
   * When combined with namespace, the full ID looks like "firstDeath:UI_ONLY_GROUP_NODE1".
   * Used to map back to real IDs in the response.
   */
  tempId: Scalars['String']['input'];
};

/** BatchEstateWaterfallGroupUpdateInput is used to update an existing visualization group. */
export type BatchEstateWaterfallGroupUpdateInput = {
  /** Updated description. If not provided, the existing value is kept. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Updated display name. If not provided, the existing value is kept. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the existing group to update. */
  id: Scalars['ID']['input'];
  /**
   * Full replacement of group membership. All existing nodes are removed
   * and replaced with these nodes.
   */
  nodeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Creates a visualization group and maps its frontend-generated ID. */
export type BatchGraphVisualizationGroupCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  namespace?: InputMaybe<Scalars['String']['input']>;
  nodeIds: Array<Scalars['ID']['input']>;
  /**
   * Frontend-generated ID for an unsaved group. Must be nonempty and unique within
   * createGroups. Node configurations can reference this ID, optionally prefixed
   * by a section namespace. The server replaces these references with the saved
   * group ID and returns the mapping in createdGroupIdMapping.
   */
  tempId: Scalars['String']['input'];
};

/** Updates an existing visualization group. */
export type BatchGraphVisualizationGroupUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  nodeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * BatchUpdateEstateWaterfallInput contains all operations to perform atomically
 * on an estate waterfall diagram.
 */
export type BatchUpdateEstateWaterfallInput = {
  /** Groups to create. Executed first so updates can reference new groups. */
  createGroups?: InputMaybe<Array<BatchEstateWaterfallGroupCreateInput>>;
  /**
   * IDs of groups to delete. Executed after updates.
   * Must not include any tempId from createGroups.
   */
  deleteGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The ID of the estate waterfall to update. */
  id: Scalars['ID']['input'];
  /** Position/size/notes for diagram tiles. These are upserted by nodeID. */
  nodeConfigurations?: InputMaybe<Array<EntityGraphNodeConfigurationInput>>;
  /** Existing groups to update. Executed after creates. */
  updateGroups?: InputMaybe<Array<BatchEstateWaterfallGroupUpdateInput>>;
  /** Optional update to the visualization config (zoom, pan, etc.) */
  updateVisualizationConfig?: InputMaybe<UpdateEstateWaterfallVisualizationConfigInput>;
};

/** BatchUpdateEstateWaterfallPayload is the response from the batchUpdateEstateWaterfall mutation. */
export type BatchUpdateEstateWaterfallPayload = {
  __typename?: 'BatchUpdateEstateWaterfallPayload';
  /** Mapping from client tempIds to server-assigned real IDs for created groups. */
  createdGroupIdMapping: Array<GroupIdMapping>;
  /** The complete updated waterfall with all changes applied. */
  waterfall: EstateWaterfall;
};

/** Applies all editable group and layout fields to one saved diagram. */
export type BatchUpdateGraphVisualizationInput = {
  createGroups?: InputMaybe<Array<BatchGraphVisualizationGroupCreateInput>>;
  deleteGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  firstGrantorDeathID?: InputMaybe<Scalars['ID']['input']>;
  hideEntitiesListInGroups?: InputMaybe<Scalars['Boolean']['input']>;
  nodeConfigurations?: InputMaybe<Array<EntityGraphNodeConfigurationInput>>;
  ownerID: Scalars['ID']['input'];
  ownerType: GraphVisualizationOwnerType;
  updateGroups?: InputMaybe<Array<BatchGraphVisualizationGroupUpdateInput>>;
};

export type BatchUpdateGraphVisualizationPayload = {
  __typename?: 'BatchUpdateGraphVisualizationPayload';
  createdGroupIdMapping: Array<GroupIdMapping>;
};

export type BeneficiariesBundleConfiguration = Node & {
  __typename?: 'BeneficiariesBundleConfiguration';
  /** Used in beneficiary reporting to calculate non-quantifiable accessto a single entity across multiple beneficiaries. */
  beneficiaryAccessCalcMethod: BeneficiariesBundleConfigurationBeneficiaryAccessCalcMethod;
  bundle?: Maybe<PresentationBundle>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The display name for the bundle. */
  displayName?: Maybe<Scalars['String']['output']>;
  estateWaterfall?: Maybe<EstateWaterfall>;
  /**
   * estateWaterfallBeneficiaryReport is a waterfall beneficiary report that respects the
   * configuration found in the bundle.
   */
  estateWaterfallBeneficiaryReport?: Maybe<EstateWaterfallBeneficiaryReport>;
  /** The year of the first death in the beneficiaries bundle. */
  firstDeathYear?: Maybe<Scalars['Int']['output']>;
  growthProfile?: Maybe<GrowthProfile>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  householdOverviewOrganizations?: Maybe<Array<ClientOrganization>>;
  householdOverviewProfiles?: Maybe<Array<ClientProfile>>;
  id: Scalars['ID']['output'];
  /** If true, include the detailed breakdown in each individual report alongside the chart in individual_overview_profiles and individual_overview_organizations */
  includeDetailedBreakdownsInIndividualOverviews: Scalars['Boolean']['output'];
  /** If true, include a household-level slide that compares the beneficiaries in household_overview_profiles and household_overview_organizations */
  includeHouseholdOverview: Scalars['Boolean']['output'];
  /** If true, include a chart for each profile and organization in individual_overview_profiles and individual_overview_organizations */
  includeIndividualOverviews: Scalars['Boolean']['output'];
  individualOverviewOrganizations?: Maybe<Array<ClientOrganization>>;
  individualOverviewProfiles?: Maybe<Array<ClientProfile>>;
  /** The year of the second death in the beneficiaries bundle. */
  secondDeathYear?: Maybe<Scalars['Int']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** BeneficiariesBundleConfigurationBeneficiaryAccessCalcMethod is enum for the field beneficiary_access_calc_method */
export enum BeneficiariesBundleConfigurationBeneficiaryAccessCalcMethod {
  Full = 'FULL',
  None = 'NONE',
  Proportional = 'PROPORTIONAL'
}

/** Ordering options for BeneficiariesBundleConfiguration connections */
export type BeneficiariesBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BeneficiariesBundleConfigurations. */
  field: BeneficiariesBundleConfigurationOrderField;
};

/** Properties by which BeneficiariesBundleConfiguration connections can be ordered. */
export enum BeneficiariesBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * BeneficiariesBundleConfigurationWhereInput is used for filtering BeneficiariesBundleConfiguration objects.
 * Input was generated by ent.
 */
export type BeneficiariesBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<BeneficiariesBundleConfigurationWhereInput>>;
  /** beneficiary_access_calc_method field predicates */
  beneficiaryAccessCalcMethod?: InputMaybe<BeneficiariesBundleConfigurationBeneficiaryAccessCalcMethod>;
  beneficiaryAccessCalcMethodIn?: InputMaybe<Array<BeneficiariesBundleConfigurationBeneficiaryAccessCalcMethod>>;
  beneficiaryAccessCalcMethodNEQ?: InputMaybe<BeneficiariesBundleConfigurationBeneficiaryAccessCalcMethod>;
  beneficiaryAccessCalcMethodNotIn?: InputMaybe<Array<BeneficiariesBundleConfigurationBeneficiaryAccessCalcMethod>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** first_death_year field predicates */
  firstDeathYear?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearGT?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearGTE?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  firstDeathYearLT?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearLTE?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** estate_waterfall edge predicates */
  hasEstateWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasEstateWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** growth_profile edge predicates */
  hasGrowthProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrowthProfileWith?: InputMaybe<Array<GrowthProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  /** household_overview_organizations edge predicates */
  hasHouseholdOverviewOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdOverviewOrganizationsWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** household_overview_profiles edge predicates */
  hasHouseholdOverviewProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdOverviewProfilesWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** individual_overview_organizations edge predicates */
  hasIndividualOverviewOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndividualOverviewOrganizationsWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** individual_overview_profiles edge predicates */
  hasIndividualOverviewProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndividualOverviewProfilesWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_detailed_breakdowns_in_individual_overviews field predicates */
  includeDetailedBreakdownsInIndividualOverviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_household_overview field predicates */
  includeHouseholdOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_individual_overviews field predicates */
  includeIndividualOverviews?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BeneficiariesBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<BeneficiariesBundleConfigurationWhereInput>>;
  /** second_death_year field predicates */
  secondDeathYear?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearGT?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearGTE?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  secondDeathYearLT?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearLTE?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type BeneficiariesTemplateBundleConfiguration = Node & {
  __typename?: 'BeneficiariesTemplateBundleConfiguration';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** If true, includes the household overview slide in the beneficiaries bundle. */
  includeHouseholdOverview: Scalars['Boolean']['output'];
  /** If true, includes the individual overview slides in the beneficiaries bundle. */
  includeIndividualOverviews: Scalars['Boolean']['output'];
  templateBundle?: Maybe<PresentationTemplateBundle>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type BeneficiariesTemplateBundleConfigurationConnection = {
  __typename?: 'BeneficiariesTemplateBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BeneficiariesTemplateBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BeneficiariesTemplateBundleConfigurationEdge = {
  __typename?: 'BeneficiariesTemplateBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BeneficiariesTemplateBundleConfiguration>;
};

/** Ordering options for BeneficiariesTemplateBundleConfiguration connections */
export type BeneficiariesTemplateBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BeneficiariesTemplateBundleConfigurations. */
  field: BeneficiariesTemplateBundleConfigurationOrderField;
};

/** Properties by which BeneficiariesTemplateBundleConfiguration connections can be ordered. */
export enum BeneficiariesTemplateBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * BeneficiariesTemplateBundleConfigurationWhereInput is used for filtering BeneficiariesTemplateBundleConfiguration objects.
 * Input was generated by ent.
 */
export type BeneficiariesTemplateBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<BeneficiariesTemplateBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** template_bundle edge predicates */
  hasTemplateBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasTemplateBundleWith?: InputMaybe<Array<PresentationTemplateBundleWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_household_overview field predicates */
  includeHouseholdOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_individual_overviews field predicates */
  includeIndividualOverviews?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BeneficiariesTemplateBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<BeneficiariesTemplateBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Beneficiary = Node & {
  __typename?: 'Beneficiary';
  accessParameters: AccessParameterConnection;
  /** Reverse edge from GRATs to denote a GRAT remainder distribution */
  beneficiaryGrat?: Maybe<GratTrust>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /**
   * An edge to the distributions for this beneficiary
   * @deprecated Use access parameters and scheduled distributions instead
   */
  distributions?: Maybe<Array<BeneficiaryDistribution>>;
  /** An edge to the beneficiary, which is an entity */
  entity?: Maybe<Entity>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** An edge to the beneficiary, which is an individual */
  individual?: Maybe<ClientProfile>;
  /**
   * The kind of beneficiary. Tells us which edge to traverse.
   *       In the case of SURVIVING_SPOUSE, no edge will be set and the beneficiary will be dynamically set to the surviving spouse in the household.
   */
  kind?: Maybe<BeneficiaryKind>;
  level?: Maybe<BeneficiaryLevel>;
  /** Free-form notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** An edge to the beneficiary, which is an organization */
  organization?: Maybe<ClientOrganization>;
  /** An edge to the power of appointment for this beneficiary */
  powerOfAppointment?: Maybe<BeneficiaryPowerOfAppointment>;
  scheduledDistributions: ScheduledDistributionConnection;
  summary: SummaryBeneficiaryv2;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** An edge to the beneficiary, which is a testamentary entity */
  testamentaryEntity?: Maybe<TestamentaryEntity>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type BeneficiaryAccessParametersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccessParameterOrder>>;
  where?: InputMaybe<AccessParameterWhereInput>;
};


export type BeneficiaryScheduledDistributionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduledDistributionOrder>>;
  where?: InputMaybe<ScheduledDistributionWhereInput>;
};

export type BeneficiaryAccessParameter = Node & {
  __typename?: 'BeneficiaryAccessParameter';
  /** Notes for when age is an access parameter */
  accessParameterAgeNote?: Maybe<Scalars['String']['output']>;
  /** Notes for when other is an access parameter */
  accessParameterOtherNote?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The kind of distribution parameter */
  kind: BeneficiaryAccessParameterKind;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** BeneficiaryAccessParameterKind is enum for the field kind */
export enum BeneficiaryAccessParameterKind {
  HealthEducationMaintenanceSupport = 'HEALTH_EDUCATION_MAINTENANCE_SUPPORT',
  MandatoryDistribution = 'MANDATORY_DISTRIBUTION',
  Other = 'OTHER',
  UnderFullDiscretionOfTrustee = 'UNDER_FULL_DISCRETION_OF_TRUSTEE',
  UponReachingAge = 'UPON_REACHING_AGE'
}

/** Ordering options for BeneficiaryAccessParameter connections */
export type BeneficiaryAccessParameterOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BeneficiaryAccessParameters. */
  field: BeneficiaryAccessParameterOrderField;
};

/** Properties by which BeneficiaryAccessParameter connections can be ordered. */
export enum BeneficiaryAccessParameterOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * BeneficiaryAccessParameterWhereInput is used for filtering BeneficiaryAccessParameter objects.
 * Input was generated by ent.
 */
export type BeneficiaryAccessParameterWhereInput = {
  /** access_parameter_age_note field predicates */
  accessParameterAgeNote?: InputMaybe<Scalars['String']['input']>;
  accessParameterAgeNoteIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  accessParameterAgeNoteNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** access_parameter_other_note field predicates */
  accessParameterOtherNote?: InputMaybe<Scalars['String']['input']>;
  accessParameterOtherNoteIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  accessParameterOtherNoteNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<BeneficiaryAccessParameterWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<BeneficiaryAccessParameterKind>;
  kindIn?: InputMaybe<Array<BeneficiaryAccessParameterKind>>;
  kindNEQ?: InputMaybe<BeneficiaryAccessParameterKind>;
  kindNotIn?: InputMaybe<Array<BeneficiaryAccessParameterKind>>;
  not?: InputMaybe<BeneficiaryAccessParameterWhereInput>;
  or?: InputMaybe<Array<BeneficiaryAccessParameterWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type BeneficiaryDesignationGroup = Node & {
  __typename?: 'BeneficiaryDesignationGroup';
  /** If this beneficiary designation group is hypothetical, this is the waterfall that is associated with it. */
  associatedHypotheticalWaterfall?: Maybe<EstateWaterfall>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  dispositiveProvisions: DispositiveProvisionConnection;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  /** The insurance personal account this group belongs to (hypothetical scope). */
  hypotheticalInsurancePersonalAccount?: Maybe<InsurancePersonalAccount>;
  /** The retirement personal account this group belongs to (hypothetical scope). */
  hypotheticalRetirementPersonalAccount?: Maybe<RetirementPersonalAccount>;
  id: Scalars['ID']['output'];
  /** The insurance personal account this group belongs to (production scope). */
  insurancePersonalAccount?: Maybe<InsurancePersonalAccount>;
  /** if true, the residuary recipient(s) for this group's tier pays taxes by default. if false, each recipient's bearsTax field can be configured separately */
  residuaryPaysAllTaxes: Scalars['Boolean']['output'];
  /** The retirement personal account this group belongs to (production scope). */
  retirementPersonalAccount?: Maybe<RetirementPersonalAccount>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** Whether this group represents primary or contingent beneficiaries on the account. */
  tier: BeneficiaryDesignationTier;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type BeneficiaryDesignationGroupDispositiveProvisionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositiveProvisionOrder>>;
  where?: InputMaybe<DispositiveProvisionWhereInput>;
};

/** A connection to a list of items. */
export type BeneficiaryDesignationGroupConnection = {
  __typename?: 'BeneficiaryDesignationGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BeneficiaryDesignationGroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BeneficiaryDesignationGroupEdge = {
  __typename?: 'BeneficiaryDesignationGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BeneficiaryDesignationGroup>;
};

/** Ordering options for BeneficiaryDesignationGroup connections */
export type BeneficiaryDesignationGroupOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BeneficiaryDesignationGroups. */
  field: BeneficiaryDesignationGroupOrderField;
};

/** Properties by which BeneficiaryDesignationGroup connections can be ordered. */
export enum BeneficiaryDesignationGroupOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * BeneficiaryDesignationGroupWhereInput is used for filtering BeneficiaryDesignationGroup objects.
 * Input was generated by ent.
 */
export type BeneficiaryDesignationGroupWhereInput = {
  and?: InputMaybe<Array<BeneficiaryDesignationGroupWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** associated_hypothetical_waterfall edge predicates */
  hasAssociatedHypotheticalWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssociatedHypotheticalWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** dispositive_provisions edge predicates */
  hasDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositiveProvisionsWith?: InputMaybe<Array<DispositiveProvisionWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_insurance_personal_account edge predicates */
  hasHypotheticalInsurancePersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalInsurancePersonalAccountWith?: InputMaybe<Array<InsurancePersonalAccountWhereInput>>;
  /** hypothetical_retirement_personal_account edge predicates */
  hasHypotheticalRetirementPersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalRetirementPersonalAccountWith?: InputMaybe<Array<RetirementPersonalAccountWhereInput>>;
  /** insurance_personal_account edge predicates */
  hasInsurancePersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasInsurancePersonalAccountWith?: InputMaybe<Array<InsurancePersonalAccountWhereInput>>;
  /** retirement_personal_account edge predicates */
  hasRetirementPersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasRetirementPersonalAccountWith?: InputMaybe<Array<RetirementPersonalAccountWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<BeneficiaryDesignationGroupWhereInput>;
  or?: InputMaybe<Array<BeneficiaryDesignationGroupWhereInput>>;
  /** residuary_pays_all_taxes field predicates */
  residuaryPaysAllTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** tier field predicates */
  tier?: InputMaybe<BeneficiaryDesignationTier>;
  tierIn?: InputMaybe<Array<BeneficiaryDesignationTier>>;
  tierNEQ?: InputMaybe<BeneficiaryDesignationTier>;
  tierNotIn?: InputMaybe<Array<BeneficiaryDesignationTier>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** BeneficiaryDesignationTier is enum for the field tier */
export enum BeneficiaryDesignationTier {
  Contingent = 'CONTINGENT',
  Primary = 'PRIMARY'
}

/**
 * BeneficiaryDesignations holds the primary and contingent beneficiary designation
 * groups for a retirement or insurance personal account.
 */
export type BeneficiaryDesignations = {
  __typename?: 'BeneficiaryDesignations';
  /** Contingent beneficiary designation group, or null if none exists. */
  contingent?: Maybe<BeneficiaryDesignationGroup>;
  /** Primary beneficiary designation group, or null if none exists. */
  primary?: Maybe<BeneficiaryDesignationGroup>;
};

export type BeneficiaryDistribution = Node & {
  __typename?: 'BeneficiaryDistribution';
  /** the beneficiary this distribution is for */
  beneficiary?: Maybe<Beneficiary>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The AMOUNT kind of distribution. Only valid when distribution_kind is AMOUNT */
  distributionAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The frequency of the distribution to beneficiaries */
  distributionFrequency?: Maybe<BeneficiaryDistributionDistributionFrequency>;
  /** The kind of distribution for this beneficiary */
  distributionKind: BeneficiaryDistributionDistributionKind;
  /** @deprecated Use `distribution_parameters` instead. */
  distributionParameter?: Maybe<BeneficiaryDistributionDistributionParameter>;
  /** The age at which the beneficiary will receive the distribution. Only valid when distribution_parameter is UPON_REACHING_AGE */
  distributionParameterUponReachingAge?: Maybe<Scalars['Int']['output']>;
  /** Distribution parameters of this distribution */
  distributionParameters?: Maybe<Array<BeneficiaryDistributionParameter>>;
  /** The percentage of the distribution. Only valid when distribution_kind is PERCENTAGE */
  distributionPercentage?: Maybe<Scalars['Percent']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** BeneficiaryDistributionDistributionFrequency is enum for the field distribution_frequency */
export enum BeneficiaryDistributionDistributionFrequency {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY'
}

/** BeneficiaryDistributionDistributionKind is enum for the field distribution_kind */
export enum BeneficiaryDistributionDistributionKind {
  AllIncome = 'ALL_INCOME',
  Amount = 'AMOUNT',
  NetIncome = 'NET_INCOME',
  NetIncomeWithMakeup = 'NET_INCOME_WITH_MAKEUP',
  Other = 'OTHER',
  Percentage = 'PERCENTAGE'
}

/** BeneficiaryDistributionDistributionParameter is enum for the field distribution_parameter */
export enum BeneficiaryDistributionDistributionParameter {
  HealthEducationMaintenanceSupport = 'HEALTH_EDUCATION_MAINTENANCE_SUPPORT',
  MandatoryDistribution = 'MANDATORY_DISTRIBUTION',
  Other = 'OTHER',
  UnderFullDiscretionOfTrustee = 'UNDER_FULL_DISCRETION_OF_TRUSTEE',
  UponReachingAge = 'UPON_REACHING_AGE'
}

/** Ordering options for BeneficiaryDistribution connections */
export type BeneficiaryDistributionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BeneficiaryDistributions. */
  field: BeneficiaryDistributionOrderField;
};

/** Properties by which BeneficiaryDistribution connections can be ordered. */
export enum BeneficiaryDistributionOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type BeneficiaryDistributionParameter = Node & {
  __typename?: 'BeneficiaryDistributionParameter';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** distribution that this distribution parameter belongs to */
  distribution: BeneficiaryDistribution;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The kind of distribution parameter for this distribution */
  kind: BeneficiaryDistributionParameterKind;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** BeneficiaryDistributionParameterKind is enum for the field kind */
export enum BeneficiaryDistributionParameterKind {
  HealthEducationMaintenanceSupport = 'HEALTH_EDUCATION_MAINTENANCE_SUPPORT',
  MandatoryDistribution = 'MANDATORY_DISTRIBUTION',
  Other = 'OTHER',
  UnderFullDiscretionOfTrustee = 'UNDER_FULL_DISCRETION_OF_TRUSTEE',
  UponReachingAge = 'UPON_REACHING_AGE'
}

/** Ordering options for BeneficiaryDistributionParameter connections */
export type BeneficiaryDistributionParameterOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BeneficiaryDistributionParameters. */
  field: BeneficiaryDistributionParameterOrderField;
};

/** Properties by which BeneficiaryDistributionParameter connections can be ordered. */
export enum BeneficiaryDistributionParameterOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * BeneficiaryDistributionParameterWhereInput is used for filtering BeneficiaryDistributionParameter objects.
 * Input was generated by ent.
 */
export type BeneficiaryDistributionParameterWhereInput = {
  and?: InputMaybe<Array<BeneficiaryDistributionParameterWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** distribution edge predicates */
  hasDistribution?: InputMaybe<Scalars['Boolean']['input']>;
  hasDistributionWith?: InputMaybe<Array<BeneficiaryDistributionWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<BeneficiaryDistributionParameterKind>;
  kindIn?: InputMaybe<Array<BeneficiaryDistributionParameterKind>>;
  kindNEQ?: InputMaybe<BeneficiaryDistributionParameterKind>;
  kindNotIn?: InputMaybe<Array<BeneficiaryDistributionParameterKind>>;
  not?: InputMaybe<BeneficiaryDistributionParameterWhereInput>;
  or?: InputMaybe<Array<BeneficiaryDistributionParameterWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * BeneficiaryDistributionWhereInput is used for filtering BeneficiaryDistribution objects.
 * Input was generated by ent.
 */
export type BeneficiaryDistributionWhereInput = {
  and?: InputMaybe<Array<BeneficiaryDistributionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** distribution_amount field predicates */
  distributionAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  distributionAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  distributionAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  distributionAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  distributionAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  distributionAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  distributionAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  distributionAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** distribution_frequency field predicates */
  distributionFrequency?: InputMaybe<BeneficiaryDistributionDistributionFrequency>;
  distributionFrequencyIn?: InputMaybe<Array<BeneficiaryDistributionDistributionFrequency>>;
  distributionFrequencyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  distributionFrequencyNEQ?: InputMaybe<BeneficiaryDistributionDistributionFrequency>;
  distributionFrequencyNotIn?: InputMaybe<Array<BeneficiaryDistributionDistributionFrequency>>;
  distributionFrequencyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** distribution_kind field predicates */
  distributionKind?: InputMaybe<BeneficiaryDistributionDistributionKind>;
  distributionKindIn?: InputMaybe<Array<BeneficiaryDistributionDistributionKind>>;
  distributionKindNEQ?: InputMaybe<BeneficiaryDistributionDistributionKind>;
  distributionKindNotIn?: InputMaybe<Array<BeneficiaryDistributionDistributionKind>>;
  /** distribution_parameter field predicates */
  distributionParameter?: InputMaybe<BeneficiaryDistributionDistributionParameter>;
  distributionParameterIn?: InputMaybe<Array<BeneficiaryDistributionDistributionParameter>>;
  distributionParameterIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  distributionParameterNEQ?: InputMaybe<BeneficiaryDistributionDistributionParameter>;
  distributionParameterNotIn?: InputMaybe<Array<BeneficiaryDistributionDistributionParameter>>;
  distributionParameterNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** distribution_parameter_upon_reaching_age field predicates */
  distributionParameterUponReachingAge?: InputMaybe<Scalars['Int']['input']>;
  distributionParameterUponReachingAgeGT?: InputMaybe<Scalars['Int']['input']>;
  distributionParameterUponReachingAgeGTE?: InputMaybe<Scalars['Int']['input']>;
  distributionParameterUponReachingAgeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  distributionParameterUponReachingAgeLT?: InputMaybe<Scalars['Int']['input']>;
  distributionParameterUponReachingAgeLTE?: InputMaybe<Scalars['Int']['input']>;
  distributionParameterUponReachingAgeNEQ?: InputMaybe<Scalars['Int']['input']>;
  distributionParameterUponReachingAgeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** distribution_percentage field predicates */
  distributionPercentage?: InputMaybe<Scalars['Percent']['input']>;
  distributionPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  distributionPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  distributionPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  distributionPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  distributionPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  distributionPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  distributionPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** beneficiary edge predicates */
  hasBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiaryWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** distribution_parameters edge predicates */
  hasDistributionParameters?: InputMaybe<Scalars['Boolean']['input']>;
  hasDistributionParametersWith?: InputMaybe<Array<BeneficiaryDistributionParameterWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<BeneficiaryDistributionWhereInput>;
  or?: InputMaybe<Array<BeneficiaryDistributionWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** BeneficiaryKind is enum for the field kind */
export enum BeneficiaryKind {
  Entity = 'ENTITY',
  Individual = 'INDIVIDUAL',
  Organization = 'ORGANIZATION',
  SurvivingSpouse = 'SURVIVING_SPOUSE',
  TestamentaryEntity = 'TESTAMENTARY_ENTITY'
}

/** BeneficiaryLevel is enum for the field level */
export enum BeneficiaryLevel {
  Other = 'OTHER',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

/** Ordering options for Beneficiary connections */
export type BeneficiaryOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Beneficiaries. */
  field: BeneficiaryOrderField;
};

/** Properties by which Beneficiary connections can be ordered. */
export enum BeneficiaryOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type BeneficiaryPage = Node & {
  __typename?: 'BeneficiaryPage';
  /** The ID of the beneficiary to display - either a client profile or client organization. */
  beneficiaryID: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  presentationPage: PresentationPage;
  presentationPageID: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type BeneficiaryPageConnection = {
  __typename?: 'BeneficiaryPageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BeneficiaryPageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BeneficiaryPageEdge = {
  __typename?: 'BeneficiaryPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BeneficiaryPage>;
};

export type BeneficiaryPowerOfAppointment = Node & {
  __typename?: 'BeneficiaryPowerOfAppointment';
  /** the beneficiary this power of appointment is for */
  beneficiary?: Maybe<Beneficiary>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The power of appointment for the beneficiary */
  power?: Maybe<BeneficiaryPowerOfAppointmentPower>;
  /** Notes for when other is an access parameter */
  powerOtherNote?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for BeneficiaryPowerOfAppointment connections */
export type BeneficiaryPowerOfAppointmentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BeneficiaryPowerOfAppointments. */
  field: BeneficiaryPowerOfAppointmentOrderField;
};

/** Properties by which BeneficiaryPowerOfAppointment connections can be ordered. */
export enum BeneficiaryPowerOfAppointmentOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** BeneficiaryPowerOfAppointmentPower is enum for the field power */
export enum BeneficiaryPowerOfAppointmentPower {
  General = 'GENERAL',
  Other = 'OTHER',
  Special = 'SPECIAL'
}

/**
 * BeneficiaryPowerOfAppointmentWhereInput is used for filtering BeneficiaryPowerOfAppointment objects.
 * Input was generated by ent.
 */
export type BeneficiaryPowerOfAppointmentWhereInput = {
  and?: InputMaybe<Array<BeneficiaryPowerOfAppointmentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** beneficiary edge predicates */
  hasBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiaryWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<BeneficiaryPowerOfAppointmentWhereInput>;
  or?: InputMaybe<Array<BeneficiaryPowerOfAppointmentWhereInput>>;
  /** power field predicates */
  power?: InputMaybe<BeneficiaryPowerOfAppointmentPower>;
  powerIn?: InputMaybe<Array<BeneficiaryPowerOfAppointmentPower>>;
  powerIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  powerNEQ?: InputMaybe<BeneficiaryPowerOfAppointmentPower>;
  powerNotIn?: InputMaybe<Array<BeneficiaryPowerOfAppointmentPower>>;
  powerNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** power_other_note field predicates */
  powerOtherNote?: InputMaybe<Scalars['String']['input']>;
  powerOtherNoteIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  powerOtherNoteNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type BeneficiaryReportAccessBreakdown = {
  __typename?: 'BeneficiaryReportAccessBreakdown';
  _cacheKey: Scalars['String']['output'];
  /**
   * beneficialTotal is the total amount of funds that the beneficiary has access to at this point in time
   * @deprecated No longer supported
   */
  beneficialTotal?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** entities contains the breakdown of each entity for the given individual at this point in time */
  entities?: Maybe<Array<BeneficiaryReportEntityBreakdown>>;
};

export enum BeneficiaryReportAccessCalculationMethod {
  Full = 'FULL',
  None = 'NONE',
  Proportional = 'PROPORTIONAL'
}

export enum BeneficiaryReportAccessSource {
  Cumulative = 'CUMULATIVE',
  Existing = 'EXISTING',
  New = 'NEW'
}

export type BeneficiaryReportBeneficiaryBreakdown = {
  __typename?: 'BeneficiaryReportBeneficiaryBreakdown';
  _cacheKey: Scalars['String']['output'];
  /**
   * beneficiary is the client profile beneficiary.
   * Only valid if the beneficiaryKind is CLIENT_PROFILE.
   */
  beneficiary?: Maybe<ClientProfile>;
  /**
   * beneficiaryAge is the age of the beneficiary.
   * Only valid if the beneficiary is a client profile and if their DoB is available.
   */
  beneficiaryAge?: Maybe<Scalars['Int']['output']>;
  beneficiaryKind: BeneficiaryReportBeneficiaryKind;
  /** calculationMethod is how we calculate access to trust value when there are multiple beneficiaries */
  calculationMethod?: Maybe<BeneficiaryReportAccessCalculationMethod>;
  /** currentAccessAmount is the total amount that the beneficiary has access to as of today */
  currentAccessAmount: Scalars['CurrencyUSD']['output'];
  /** currentAccessBreakdown contains a breakdown of what the beneficiary has access to as of today */
  currentAccessBreakdown: BeneficiaryReportAccessBreakdown;
  /**
   * firstDeathEntityAccess summarizes, per entity, the share of the entity's
   * value the beneficiary has access to at the end of the first grantor death
   * year. Reflects trust access parameters and powers of appointment only;
   * distribution transfers and direct ownership are excluded. Null for the
   * first-to-die client and for beneficiaries with no access at that point.
   * For same-year deaths, primary clients use their pre-death snapshot.
   */
  firstDeathEntityAccess?: Maybe<Array<BeneficiaryReportEntityAccess>>;
  /** futureAccessAmount is the total amount of trust value that the beneficiary will have access to by the last death event */
  futureAccessAmount: Scalars['CurrencyUSD']['output'];
  /**
   * futureAccessBreakdown contains the breakdowns of what the beneficiary will have access to
   * broken up by future access and distribution milestones.
   */
  futureAccessBreakdown?: Maybe<Array<BeneficiaryReportFutureAccess>>;
  /** futureDistributions is the total amount that the beneficiary will have received via distributions by the last death event */
  futureDistributions: Scalars['CurrencyUSD']['output'];
  /**
   * orgBeneficiary is the client organization beneficiary.
   * Only valid if the beneficiaryKind is ORGANIZATION.
   */
  orgBeneficiary?: Maybe<ClientOrganization>;
  /**
   * pastDistributionAmount is an optional, user-entered value representing any past distributions this
   * beneficiary has received
   */
  pastDistributionAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** yearByYearAccess contains a cumulative array of beneficiary access broken down by year. */
  yearByYearAccess?: Maybe<Array<BeneficiaryReportYearByYearBeneficiaryAccess>>;
};

export enum BeneficiaryReportBeneficiaryKind {
  ClientProfile = 'CLIENT_PROFILE',
  Organization = 'ORGANIZATION'
}

export type BeneficiaryReportEntityAccess = {
  __typename?: 'BeneficiaryReportEntityAccess';
  _cacheKey: Scalars['String']['output'];
  /**
   * accessFraction is accessibleValue relative to entityValue, as a 0-100
   * percent. Prorate by this field rather than re-deriving the ratio: entities
   * with a negative value report 100 while accessibleValue floors at zero.
   * Zero-value entities are omitted from the list entirely.
   */
  accessFraction: Scalars['Percent']['output'];
  /**
   * accessibleValue is the portion of entityValue the beneficiary has access to,
   * capped at entityValue and floored at zero
   */
  accessibleValue: Scalars['CurrencyUSD']['output'];
  /** entityValue is the projected value of the full entity at this point in time */
  entityValue: Scalars['CurrencyUSD']['output'];
  /** id is the id of the entity/sub-trust the beneficiary has access to */
  id: Scalars['ID']['output'];
};

export type BeneficiaryReportEntityBreakdown = {
  __typename?: 'BeneficiaryReportEntityBreakdown';
  _cacheKey: Scalars['String']['output'];
  /**
   * accessDetail refers to what kind(s) of access the beneficiary has to this entity
   * @deprecated Use accessDetails instead
   */
  accessDetail?: Maybe<Array<AccessParameterKind>>;
  /** accessDetails refers to what kind(s) of access the beneficiary has to this entity */
  accessDetails: Scalars['String']['output'];
  /**
   * accessDetailsSubtext is additional context shown below the access details,
   * e.g. the template name and "pro rata" label when a dispositive provision
   * belongs to a pro rata template.
   */
  accessDetailsSubtext?: Maybe<Scalars['String']['output']>;
  /**
   * accessParameters contains the access parameter(s) that granted access to this entity
   * note that this will be null if this breakdown is a distribution
   */
  accessParameters?: Maybe<Array<AccessParameter>>;
  /**
   * accessParametersResolved contains the expanded access parameter(s) and their age access to this node
   * note that this will be empty if this breakdown is a distribution
   */
  accessParametersResolved: Array<AccessParameterView>;
  /** accessSource refers to when the beneficiary gained access to this entity */
  accessSource: BeneficiaryReportAccessSource;
  /**
   * associatedHypothetical contains the object that triggered this access
   * or distribution, if relevant.
   */
  associatedObject?: Maybe<Node>;
  /**
   * associatedObjectID contains the ID of the object that triggered this access
   * or distribution, if relevant.
   */
  associatedObjectID?: Maybe<Scalars['ID']['output']>;
  /** beneficialAmount is the projected value of the entity that the beneficiary will have access to */
  beneficialAmount: Scalars['CurrencyUSD']['output'];
  /** displayName is the name of the node that the beneficiary has access to */
  displayName: Scalars['String']['output'];
  /**
   * dispositiveProvision contains the dispositive provision that this breakdown entry represents.
   * Only relevant if this breakdown is a distribution.
   */
  dispositiveProvision?: Maybe<DispositiveProvision>;
  /** when the accessSource is CUMULATIVE, the distributionFrequency indicates the frequency of the distributions */
  distributionFrequency?: Maybe<BeneficiaryDistributionDistributionFrequency>;
  /** @deprecated Use the node field instead */
  entity?: Maybe<Entity>;
  /** entityValue is the projected value of the full entity at this point in time */
  entityValue: Scalars['CurrencyUSD']['output'];
  /** id is the id of the node that the beneficiary has access to */
  id: Scalars['ID']['output'];
  /** node is the object that the beneficiary has access to */
  node: Node;
  /** notes are free form notes adding more context to the access parameter */
  notes?: Maybe<Scalars['String']['output']>;
  /** powerOfAppointment holds the power of appointment, if available, for this beneficiary on this entity. */
  powerOfAppointment?: Maybe<BeneficiaryPowerOfAppointment>;
  /**
   * scheduledDistribution contains the scheduled distribution that this breakdown entry represents.
   * Only relevant if this breakdown is a distribution.
   */
  scheduledDistribution?: Maybe<ScheduledDistribution>;
  /** sourceKind is the kind of the node that the beneficiary has access to */
  sourceKind: BeneficiaryReportSourceKind;
};

export type BeneficiaryReportFutureAccess = {
  __typename?: 'BeneficiaryReportFutureAccess';
  _cacheKey: Scalars['String']['output'];
  breakdown: BeneficiaryReportAccessBreakdown;
  /**
   * milestone refers to the major milestone of this access event
   * @deprecated Use milestones instead
   */
  milestone?: Maybe<Scalars['String']['output']>;
  /** milestones refers to the major milestone(s) of this access event */
  milestones: Array<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

export enum BeneficiaryReportSourceKind {
  ClientProfile = 'CLIENT_PROFILE',
  Entity = 'ENTITY',
  TestamentaryEntity = 'TESTAMENTARY_ENTITY'
}

export type BeneficiaryReportYearByYearBeneficiaryAccess = {
  __typename?: 'BeneficiaryReportYearByYearBeneficiaryAccess';
  _cacheKey: Scalars['String']['output'];
  age?: Maybe<Scalars['Int']['output']>;
  /** distributionsToDate is the total amount that the beneficiary has received via distributions */
  distributionsToDate: Scalars['CurrencyUSD']['output'];
  /**
   * milestone refers to the major milestone of this year, if it exists
   * @deprecated Use milestones instead
   */
  milestone?: Maybe<Scalars['String']['output']>;
  /** milestones refers to the major milestone(s) of this access event */
  milestones?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * newTrustAccess is the net new amount of trust value that the beneficiary has access to
   * as of this year. This aligns with a new milestone event.
   */
  newTrustAccess?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** trustAccessToDate is the total amount of trust value that the beneficiary has access to */
  trustAccessToDate: Scalars['CurrencyUSD']['output'];
  year: Scalars['Int']['output'];
};

export type BeneficiarySummaryQueryv2 = {
  id: Scalars['ID']['input'];
  kind: SummaryBeneficiaryKindv2;
};

/**
 * BeneficiaryWhereInput is used for filtering Beneficiary objects.
 * Input was generated by ent.
 */
export type BeneficiaryWhereInput = {
  and?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** access_parameters edge predicates */
  hasAccessParameters?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccessParametersWith?: InputMaybe<Array<AccessParameterWhereInput>>;
  /** beneficiary_grat edge predicates */
  hasBeneficiaryGrat?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiaryGratWith?: InputMaybe<Array<GratTrustWhereInput>>;
  /** distributions edge predicates */
  hasDistributions?: InputMaybe<Scalars['Boolean']['input']>;
  hasDistributionsWith?: InputMaybe<Array<BeneficiaryDistributionWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** individual edge predicates */
  hasIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** power_of_appointment edge predicates */
  hasPowerOfAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  hasPowerOfAppointmentWith?: InputMaybe<Array<BeneficiaryPowerOfAppointmentWhereInput>>;
  /** scheduled_distributions edge predicates */
  hasScheduledDistributions?: InputMaybe<Scalars['Boolean']['input']>;
  hasScheduledDistributionsWith?: InputMaybe<Array<ScheduledDistributionWhereInput>>;
  /** testamentary_entity edge predicates */
  hasTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasTestamentaryEntityWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<BeneficiaryKind>;
  kindIn?: InputMaybe<Array<BeneficiaryKind>>;
  kindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  kindNEQ?: InputMaybe<BeneficiaryKind>;
  kindNotIn?: InputMaybe<Array<BeneficiaryKind>>;
  kindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** level field predicates */
  level?: InputMaybe<BeneficiaryLevel>;
  levelIn?: InputMaybe<Array<BeneficiaryLevel>>;
  levelIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  levelNEQ?: InputMaybe<BeneficiaryLevel>;
  levelNotIn?: InputMaybe<Array<BeneficiaryLevel>>;
  levelNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BeneficiaryWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type BlackDiamondBulkQueryResults = {
  __typename?: 'BlackDiamondBulkQueryResults';
  files: Array<BlackDiamondBulkQueryResultsFile>;
};

export type BlackDiamondBulkQueryResultsFile = {
  __typename?: 'BlackDiamondBulkQueryResultsFile';
  content: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BlackDiamondQueryResults = {
  __typename?: 'BlackDiamondQueryResults';
  results: Scalars['String']['output'];
};

export type BoundingRegion = {
  __typename?: 'BoundingRegion';
  PageNumber: Scalars['Int']['output'];
  Polygon: Array<Coordinate>;
};

export type Branded = {
  buttonsLinkColor: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  darkSquareLogoURL?: Maybe<Scalars['String']['output']>;
  darkWideLogoURL?: Maybe<Scalars['String']['output']>;
  dataVisualizationNegativeColor?: Maybe<Scalars['String']['output']>;
  dataVisualizationPrimaryColor: Scalars['String']['output'];
  dataVisualizationSecondaryColor: Scalars['String']['output'];
  dataVisualizationTertiaryColor?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logoURL: Scalars['String']['output'];
  presentationHeaderFontFace: PresentationHeaderFontFace;
  primaryColor: Scalars['String']['output'];
  secondaryColor: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/**
 * BusinessEntity is a common interface for all
 * the business entities. It enforces some common
 * properties across all business entities.
 */
export type BusinessEntity = {
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  description?: Maybe<Scalars['String']['output']>;
  designerAccount?: Maybe<Account>;
  displayName: Scalars['String']['output'];
  doingBusinessAsName?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entityExists: Scalars['Boolean']['output'];
  finCenID?: Maybe<Scalars['String']['output']>;
  formationJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  grantorControlledDiscountedValue: Scalars['CurrencyUSD']['output'];
  grantorControlledPercentage: Scalars['Percent']['output'];
  grantorControlledValue: Scalars['CurrencyUSD']['output'];
  id: Scalars['ID']['output'];
  keyPeople?: Maybe<Array<KeyPerson>>;
  keyPeopleNotes?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  nongrantorControlledPercentage: Scalars['Percent']['output'];
  nongrantorControlledValue: Scalars['CurrencyUSD']['output'];
  ownershipAsOfDate?: Maybe<Scalars['Time']['output']>;
  requiresCtaReporting?: Maybe<Scalars['Boolean']['output']>;
  taxID?: Maybe<Scalars['String']['output']>;
  taxStatus?: Maybe<BusinessEntityTaxStatus>;
};

/** BusinessEntityTaxStatus is enum for the field tax_status */
export enum BusinessEntityTaxStatus {
  Corporation = 'CORPORATION',
  DisregardedEntity = 'DISREGARDED_ENTITY',
  NonTaxableEntity = 'NON_TAXABLE_ENTITY',
  Partnership = 'PARTNERSHIP'
}

export type CCorpBusinessEntity = BusinessEntity & EntitySubtype & Named & Node & {
  __typename?: 'CCorpBusinessEntity';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this business entity */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in trusts that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: Maybe<Scalars['String']['output']>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: Maybe<Scalars['Boolean']['output']>;
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: Maybe<Scalars['String']['output']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  grantorControlledDiscountedValue: Scalars['CurrencyUSD']['output'];
  grantorControlledPercentage: Scalars['Percent']['output'];
  grantorControlledValue: Scalars['CurrencyUSD']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  keyPeople?: Maybe<Array<KeyPerson>>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: Maybe<Scalars['String']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  nongrantorControlledPercentage: Scalars['Percent']['output'];
  nongrantorControlledValue: Scalars['CurrencyUSD']['output'];
  /** Ownership as-of date. */
  ownershipAsOfDate?: Maybe<Scalars['Time']['output']>;
  policies?: Maybe<Array<InsurancePolicy>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: Maybe<Scalars['Boolean']['output']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxID?: Maybe<Scalars['String']['output']>;
  taxStatus?: Maybe<BusinessEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type CCorpBusinessEntityHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type CCorpBusinessEntityConnection = {
  __typename?: 'CCorpBusinessEntityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CCorpBusinessEntityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CCorpBusinessEntityEdge = {
  __typename?: 'CCorpBusinessEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CCorpBusinessEntity>;
};

/** Ordering options for CCorpBusinessEntity connections */
export type CCorpBusinessEntityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order CCorpBusinessEntities. */
  field: CCorpBusinessEntityOrderField;
};

/** Properties by which CCorpBusinessEntity connections can be ordered. */
export enum CCorpBusinessEntityOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * CCorpBusinessEntityWhereInput is used for filtering CCorpBusinessEntity objects.
 * Input was generated by ent.
 */
export type CCorpBusinessEntityWhereInput = {
  and?: InputMaybe<Array<CCorpBusinessEntityWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** doing_business_as_name field predicates */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  doingBusinessAsNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  doingBusinessAsNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable_real_tpp_tax_exposure field predicates */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  enableRealTppTaxExposureIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  enableRealTppTaxExposureNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** fin_cen_id field predicates */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  finCenIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  finCenIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** formation_jurisdiction_state_code field predicates */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  formationJurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  formationJurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** key_people edge predicates */
  hasKeyPeople?: InputMaybe<Scalars['Boolean']['input']>;
  hasKeyPeopleWith?: InputMaybe<Array<KeyPersonWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key_people_notes field predicates */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  keyPeopleNotesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  keyPeopleNotesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<CCorpBusinessEntityWhereInput>;
  or?: InputMaybe<Array<CCorpBusinessEntityWhereInput>>;
  /** ownership_as_of_date field predicates */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateGT?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateGTE?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownershipAsOfDateLT?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateLTE?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** requires_cta_reporting field predicates */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCtaReportingIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCtaReportingNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_id field predicates */
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<BusinessEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<BusinessEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<BusinessEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type CltOptimization = {
  __typename?: 'CLTOptimization';
  annuityPayoutAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  unitrustPayoutPercent?: Maybe<Scalars['Percent']['output']>;
};

export type CltOptimizationInput = {
  donorsYearOfBirth?: InputMaybe<Array<Scalars['Int']['input']>>;
  fundingAmount: Scalars['CurrencyUSD']['input'];
  optimizationTarget: CharitableTrustOptimizationTarget;
  payoutFrequency: CharitableTrustPayoutFrequency;
  payoutKind: CharitableTrustPayoutKind;
  rate7520?: InputMaybe<Scalars['Percent']['input']>;
  termKind: CharitableTrustTermKind;
  termYears: Scalars['Int']['input'];
};

export type CltProposal = Node & {
  __typename?: 'CLTProposal';
  /** The amount of the annuity payout. Only valid when payout_kind is ANNUITY */
  annuityPayoutAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The cost basis of assets proposed to be transferred to this CRT */
  assetCostBasis: Scalars['CurrencyUSD']['output'];
  /** Notes about the assets proposed to be transferred to this CRT */
  assetNotes?: Maybe<Scalars['String']['output']>;
  /** The total value of assets proposed to be transferred to this CRT */
  assetValue: Scalars['CurrencyUSD']['output'];
  calculationMethod?: Maybe<CharitableTrustCalculationMethod>;
  charitableIncomeBeneficiaries?: Maybe<Array<Beneficiary>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  donors: Array<ClientProfile>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  noPlanProjectionHigh: NoPlanProjection;
  noPlanProjectionLow: NoPlanProjection;
  noPlanProjectionMedium: NoPlanProjection;
  optimizationTarget?: Maybe<CharitableTrustOptimizationTarget>;
  /** The frequency of payouts for this charitable trust. */
  payoutFrequency: CharitableTrustPayoutFrequency;
  payoutKind: CharitableTrustPayoutKind;
  /** The high end of the pre-tax return percentage assumption */
  preTaxReturnPercentageHigh?: Maybe<Scalars['Percent']['output']>;
  /** The low end of the pre-tax return assumption */
  preTaxReturnPercentageLow?: Maybe<Scalars['Percent']['output']>;
  /** The medium pre-tax return percentage assumption */
  preTaxReturnPercentageMedium?: Maybe<Scalars['Percent']['output']>;
  projectionHigh: CltProposalProjection;
  projectionLow: CltProposalProjection;
  projectionMedium: CltProposalProjection;
  proposal: Proposal;
  rate7520?: Maybe<Scalars['Percent']['output']>;
  remainderBeneficiaries?: Maybe<Array<Beneficiary>>;
  /** The associated tax drag for the high pre-tax return */
  taxDragPercentageHigh?: Maybe<Scalars['Percent']['output']>;
  /** The associated tax drag for the low pre-tax return */
  taxDragPercentageLow?: Maybe<Scalars['Percent']['output']>;
  /** The associated tax drag for the medium pre-tax return */
  taxDragPercentageMedium?: Maybe<Scalars['Percent']['output']>;
  /** Tax status for this trust */
  taxStatus: TrustTaxStatus;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  termKind: CharitableTrustTermKind;
  /** The number of years the CRT will pay out for. Only valid if term_kind is FIXED */
  termYears: Scalars['Int']['output'];
  /** The kind of unitrust. Only valid when payout_kind is UNITRUST; ignored otherwise. */
  unitrustKind?: Maybe<CharitableTrustUnitrustKind>;
  /** The percent of the unitrust payout. Only valid when payout_kind is UNITRUST */
  unitrustPayoutPercent?: Maybe<Scalars['Percent']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  /** This is the year of analysis. If not specified, it will either default to the actuarial tables or the term_years */
  yearOfAnalysis?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type CltProposalConnection = {
  __typename?: 'CLTProposalConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CltProposalEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CltProposalEdge = {
  __typename?: 'CLTProposalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CltProposal>;
};

/** Ordering options for CLTProposal connections */
export type CltProposalOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order CLTProposals. */
  field: CltProposalOrderField;
};

/** Properties by which CLTProposal connections can be ordered. */
export enum CltProposalOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type CltProposalProjection = {
  __typename?: 'CLTProposalProjection';
  capitalGainsDeferred: Scalars['CurrencyUSD']['output'];
  capitalGainsTaxDeferred: Scalars['CurrencyUSD']['output'];
  charitableBenefit: Scalars['CurrencyUSD']['output'];
  estateTaxSaved: Scalars['CurrencyUSD']['output'];
  ordinaryIncomeTaxSaved: Scalars['CurrencyUSD']['output'];
  personalBenefit: Scalars['CurrencyUSD']['output'];
  personalRemainder: Scalars['CurrencyUSD']['output'];
  projectedCharitableBenefit: Scalars['CurrencyUSD']['output'];
  rate7520?: Maybe<Scalars['Percent']['output']>;
  taxableGift: Scalars['CurrencyUSD']['output'];
  yearly: Array<CltProposalYearlyProjection>;
};

export type CltProposalProjectionInput = {
  annuityPayoutAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  costBasis: Scalars['CurrencyUSD']['input'];
  donorsYearOfBirth?: InputMaybe<Array<Scalars['Int']['input']>>;
  fundingAmount: Scalars['CurrencyUSD']['input'];
  payoutFrequency: CharitableTrustPayoutFrequency;
  payoutKind: CharitableTrustPayoutKind;
  preTaxReturnPercentage: Scalars['Percent']['input'];
  rate7520?: InputMaybe<Scalars['Percent']['input']>;
  taxDrag: Scalars['Percent']['input'];
  termKind: CharitableTrustTermKind;
  termYears: Scalars['Int']['input'];
  unitrustPayoutPercent?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * CLTProposalWhereInput is used for filtering CLTProposal objects.
 * Input was generated by ent.
 */
export type CltProposalWhereInput = {
  and?: InputMaybe<Array<CltProposalWhereInput>>;
  /** annuity_payout_amount field predicates */
  annuityPayoutAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annuityPayoutAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annuityPayoutAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annuityPayoutAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  annuityPayoutAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annuityPayoutAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annuityPayoutAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annuityPayoutAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_cost_basis field predicates */
  assetCostBasis?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetCostBasisGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetCostBasisGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetCostBasisLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetCostBasisLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetCostBasisNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** asset_notes field predicates */
  assetNotes?: InputMaybe<Scalars['String']['input']>;
  assetNotesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assetNotesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_value field predicates */
  assetValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** calculation_method field predicates */
  calculationMethod?: InputMaybe<CharitableTrustCalculationMethod>;
  calculationMethodIn?: InputMaybe<Array<CharitableTrustCalculationMethod>>;
  calculationMethodIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  calculationMethodNEQ?: InputMaybe<CharitableTrustCalculationMethod>;
  calculationMethodNotIn?: InputMaybe<Array<CharitableTrustCalculationMethod>>;
  calculationMethodNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** charitable_income_beneficiaries edge predicates */
  hasCharitableIncomeBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasCharitableIncomeBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** donors edge predicates */
  hasDonors?: InputMaybe<Scalars['Boolean']['input']>;
  hasDonorsWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** proposal edge predicates */
  hasProposal?: InputMaybe<Scalars['Boolean']['input']>;
  hasProposalWith?: InputMaybe<Array<ProposalWhereInput>>;
  /** remainder_beneficiaries edge predicates */
  hasRemainderBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasRemainderBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CltProposalWhereInput>;
  /** optimization_target field predicates */
  optimizationTarget?: InputMaybe<CharitableTrustOptimizationTarget>;
  optimizationTargetIn?: InputMaybe<Array<CharitableTrustOptimizationTarget>>;
  optimizationTargetIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  optimizationTargetNEQ?: InputMaybe<CharitableTrustOptimizationTarget>;
  optimizationTargetNotIn?: InputMaybe<Array<CharitableTrustOptimizationTarget>>;
  optimizationTargetNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<CltProposalWhereInput>>;
  /** payout_frequency field predicates */
  payoutFrequency?: InputMaybe<CharitableTrustPayoutFrequency>;
  payoutFrequencyIn?: InputMaybe<Array<CharitableTrustPayoutFrequency>>;
  payoutFrequencyNEQ?: InputMaybe<CharitableTrustPayoutFrequency>;
  payoutFrequencyNotIn?: InputMaybe<Array<CharitableTrustPayoutFrequency>>;
  /** payout_kind field predicates */
  payoutKind?: InputMaybe<CharitableTrustPayoutKind>;
  payoutKindIn?: InputMaybe<Array<CharitableTrustPayoutKind>>;
  payoutKindNEQ?: InputMaybe<CharitableTrustPayoutKind>;
  payoutKindNotIn?: InputMaybe<Array<CharitableTrustPayoutKind>>;
  /** pre_tax_return_percentage_high field predicates */
  preTaxReturnPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighGT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighGTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  preTaxReturnPercentageHighLT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighLTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighNEQ?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** pre_tax_return_percentage_low field predicates */
  preTaxReturnPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowGT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowGTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  preTaxReturnPercentageLowLT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowLTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowNEQ?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** pre_tax_return_percentage_medium field predicates */
  preTaxReturnPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumGT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumGTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  preTaxReturnPercentageMediumLT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumLTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumNEQ?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** rate_7520 field predicates */
  rate7520?: InputMaybe<Scalars['Percent']['input']>;
  rate7520GT?: InputMaybe<Scalars['Percent']['input']>;
  rate7520GTE?: InputMaybe<Scalars['Percent']['input']>;
  rate7520IsNil?: InputMaybe<Scalars['Boolean']['input']>;
  rate7520LT?: InputMaybe<Scalars['Percent']['input']>;
  rate7520LTE?: InputMaybe<Scalars['Percent']['input']>;
  rate7520NEQ?: InputMaybe<Scalars['Percent']['input']>;
  rate7520NotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_drag_percentage_high field predicates */
  taxDragPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDragPercentageHighLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_drag_percentage_low field predicates */
  taxDragPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDragPercentageLowLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_drag_percentage_medium field predicates */
  taxDragPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDragPercentageMediumLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<TrustTaxStatus>;
  taxStatusIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusNEQ?: InputMaybe<TrustTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<TrustTaxStatus>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** term_kind field predicates */
  termKind?: InputMaybe<CharitableTrustTermKind>;
  termKindIn?: InputMaybe<Array<CharitableTrustTermKind>>;
  termKindNEQ?: InputMaybe<CharitableTrustTermKind>;
  termKindNotIn?: InputMaybe<Array<CharitableTrustTermKind>>;
  /** term_years field predicates */
  termYears?: InputMaybe<Scalars['Int']['input']>;
  termYearsGT?: InputMaybe<Scalars['Int']['input']>;
  termYearsGTE?: InputMaybe<Scalars['Int']['input']>;
  termYearsLT?: InputMaybe<Scalars['Int']['input']>;
  termYearsLTE?: InputMaybe<Scalars['Int']['input']>;
  termYearsNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** unitrust_kind field predicates */
  unitrustKind?: InputMaybe<CharitableTrustUnitrustKind>;
  unitrustKindIn?: InputMaybe<Array<CharitableTrustUnitrustKind>>;
  unitrustKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  unitrustKindNEQ?: InputMaybe<CharitableTrustUnitrustKind>;
  unitrustKindNotIn?: InputMaybe<Array<CharitableTrustUnitrustKind>>;
  unitrustKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** unitrust_payout_percent field predicates */
  unitrustPayoutPercent?: InputMaybe<Scalars['Percent']['input']>;
  unitrustPayoutPercentGT?: InputMaybe<Scalars['Percent']['input']>;
  unitrustPayoutPercentGTE?: InputMaybe<Scalars['Percent']['input']>;
  unitrustPayoutPercentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  unitrustPayoutPercentLT?: InputMaybe<Scalars['Percent']['input']>;
  unitrustPayoutPercentLTE?: InputMaybe<Scalars['Percent']['input']>;
  unitrustPayoutPercentNEQ?: InputMaybe<Scalars['Percent']['input']>;
  unitrustPayoutPercentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** year_of_analysis field predicates */
  yearOfAnalysis?: InputMaybe<Scalars['Int']['input']>;
  yearOfAnalysisGT?: InputMaybe<Scalars['Int']['input']>;
  yearOfAnalysisGTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfAnalysisIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  yearOfAnalysisLT?: InputMaybe<Scalars['Int']['input']>;
  yearOfAnalysisLTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfAnalysisNEQ?: InputMaybe<Scalars['Int']['input']>;
  yearOfAnalysisNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CltProposalYearlyProjection = {
  __typename?: 'CLTProposalYearlyProjection';
  beginningOfYear: Scalars['CurrencyUSD']['output'];
  cumulativeCharity: Scalars['CurrencyUSD']['output'];
  cumulativeTaxed: Scalars['CurrencyUSD']['output'];
  growth: Scalars['CurrencyUSD']['output'];
  payout: Scalars['CurrencyUSD']['output'];
  remainderValue: Scalars['CurrencyUSD']['output'];
  taxed: Scalars['CurrencyUSD']['output'];
  year: Scalars['Int']['output'];
};

export type CltTrust = EntitySubtype & Named & Node & Trust & {
  __typename?: 'CLTTrust';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  /** Taxable deduction that was recorded for funding this CLT */
  charitableDeduction?: Maybe<Scalars['CurrencyUSD']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this trust */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in trusts that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  grantors?: Maybe<Array<Principal>>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  lifetimeBeneficiaries?: Maybe<Array<Beneficiary>>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  officialInterestRatePercent?: Maybe<Scalars['Percent']['output']>;
  policies?: Maybe<Array<InsurancePolicy>>;
  remainderBeneficiaries?: Maybe<Array<Beneficiary>>;
  stateInEstateStatus: EntityInEstateStatus;
  successorTrustees?: Maybe<Array<Trustee>>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<TrustTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** If true, term_duration_years will be ignored */
  termDurationLifetime: Scalars['Boolean']['output'];
  termDurationYears?: Maybe<Scalars['Int']['output']>;
  termEndDate?: Maybe<Scalars['Time']['output']>;
  terminationDate?: Maybe<Scalars['Time']['output']>;
  trustAdvisors?: Maybe<Array<TrustAdvisor>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  trustees?: Maybe<Array<Trustee>>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type CltTrustHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type CltTrustConnection = {
  __typename?: 'CLTTrustConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CltTrustEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CltTrustEdge = {
  __typename?: 'CLTTrustEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CltTrust>;
};

/** Ordering options for CLTTrust connections */
export type CltTrustOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order CLTTrusts. */
  field: CltTrustOrderField;
};

/** Properties by which CLTTrust connections can be ordered. */
export enum CltTrustOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * CLTTrustWhereInput is used for filtering CLTTrust objects.
 * Input was generated by ent.
 */
export type CltTrustWhereInput = {
  and?: InputMaybe<Array<CltTrustWhereInput>>;
  /** charitable_deduction field predicates */
  charitableDeduction?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  charitableDeductionGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  charitableDeductionGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  charitableDeductionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  charitableDeductionLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  charitableDeductionLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  charitableDeductionNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  charitableDeductionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** grantors edge predicates */
  hasGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrantorsWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** lifetime_beneficiaries edge predicates */
  hasLifetimeBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasLifetimeBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** remainder_beneficiaries edge predicates */
  hasRemainderBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasRemainderBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** successor_trustees edge predicates */
  hasSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuccessorTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** trust_advisors edge predicates */
  hasTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrustAdvisorsWith?: InputMaybe<Array<TrustAdvisorWhereInput>>;
  /** trustees edge predicates */
  hasTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<CltTrustWhereInput>;
  /** official_interest_rate_percent field predicates */
  officialInterestRatePercent?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentGT?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentGTE?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  officialInterestRatePercentLT?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentLTE?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentNEQ?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<CltTrustWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<TrustTaxStatus>;
  taxStatusIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<TrustTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** term_duration_lifetime field predicates */
  termDurationLifetime?: InputMaybe<Scalars['Boolean']['input']>;
  /** term_duration_years field predicates */
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsGT?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsGTE?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  termDurationYearsLT?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsLTE?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsNEQ?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** termination_date field predicates */
  terminationDate?: InputMaybe<Scalars['Time']['input']>;
  terminationDateGT?: InputMaybe<Scalars['Time']['input']>;
  terminationDateGTE?: InputMaybe<Scalars['Time']['input']>;
  terminationDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  terminationDateLT?: InputMaybe<Scalars['Time']['input']>;
  terminationDateLTE?: InputMaybe<Scalars['Time']['input']>;
  terminationDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** trust_jurisdiction_state_code field predicates */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trustJurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  trustJurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type CrtOptimization = {
  __typename?: 'CRTOptimization';
  annuityPayoutAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  unitrustPayoutPercent?: Maybe<Scalars['Percent']['output']>;
};

export type CrtOptimizationInput = {
  donorsYearOfBirth?: InputMaybe<Array<Scalars['Int']['input']>>;
  fundingAmount: Scalars['CurrencyUSD']['input'];
  optimizationTarget: CharitableTrustOptimizationTarget;
  payoutFrequency: CharitableTrustPayoutFrequency;
  payoutKind: CharitableTrustPayoutKind;
  rate7520?: InputMaybe<Scalars['Percent']['input']>;
  termKind: CharitableTrustTermKind;
  termYears: Scalars['Int']['input'];
};

export type CrtProposal = Node & {
  __typename?: 'CRTProposal';
  /** The amount of the annuity payout. Only valid when payout_kind is ANNUITY */
  annuityPayoutAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The cost basis of assets proposed to be transferred to this CRT */
  assetCostBasis: Scalars['CurrencyUSD']['output'];
  /** Notes about the assets proposed to be transferred to this CRT */
  assetNotes?: Maybe<Scalars['String']['output']>;
  /** The total value of assets proposed to be transferred to this CRT */
  assetValue: Scalars['CurrencyUSD']['output'];
  calculationMethod?: Maybe<CharitableTrustCalculationMethod>;
  charitableRemainderBeneficiaries?: Maybe<Array<Beneficiary>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  donors: Array<ClientProfile>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  incomeBeneficiaries?: Maybe<Array<Beneficiary>>;
  noPlanProjectionHigh: NoPlanProjection;
  noPlanProjectionLow: NoPlanProjection;
  noPlanProjectionMedium: NoPlanProjection;
  optimizationTarget?: Maybe<CharitableTrustOptimizationTarget>;
  /** The frequency of payouts for this charitable trust. */
  payoutFrequency: CharitableTrustPayoutFrequency;
  payoutKind: CharitableTrustPayoutKind;
  /** The high end of the pre-tax return percentage assumption */
  preTaxReturnPercentageHigh?: Maybe<Scalars['Percent']['output']>;
  /** The low end of the pre-tax return assumption */
  preTaxReturnPercentageLow?: Maybe<Scalars['Percent']['output']>;
  /** The medium pre-tax return percentage assumption */
  preTaxReturnPercentageMedium?: Maybe<Scalars['Percent']['output']>;
  projectionHigh: CrtProposalProjection;
  projectionLow: CrtProposalProjection;
  projectionMedium: CrtProposalProjection;
  proposal: Proposal;
  rate7520?: Maybe<Scalars['Percent']['output']>;
  /** The associated tax drag for the high pre-tax return */
  taxDragPercentageHigh?: Maybe<Scalars['Percent']['output']>;
  /** The associated tax drag for the low pre-tax return */
  taxDragPercentageLow?: Maybe<Scalars['Percent']['output']>;
  /** The associated tax drag for the medium pre-tax return */
  taxDragPercentageMedium?: Maybe<Scalars['Percent']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  termKind: CharitableTrustTermKind;
  /** The number of years the CRT will pay out for. Only valid if term_kind is FIXED; ignored otherwise. */
  termYears: Scalars['Int']['output'];
  /** The kind of unitrust. Only valid when payout_kind is UNITRUST; ignored otherwise. */
  unitrustKind?: Maybe<CharitableTrustUnitrustKind>;
  /** The percent of the unitrust payout. Only valid when payout_kind is UNITRUST */
  unitrustPayoutPercent?: Maybe<Scalars['Percent']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  /** This is the year of analysis. If not specified, it will either default to the actuarial tables or the term_years */
  yearOfAnalysis?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type CrtProposalConnection = {
  __typename?: 'CRTProposalConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CrtProposalEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CrtProposalEdge = {
  __typename?: 'CRTProposalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CrtProposal>;
};

/** Ordering options for CRTProposal connections */
export type CrtProposalOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order CRTProposals. */
  field: CrtProposalOrderField;
};

/** Properties by which CRTProposal connections can be ordered. */
export enum CrtProposalOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type CrtProposalProjection = {
  __typename?: 'CRTProposalProjection';
  capitalGainsDeferred: Scalars['CurrencyUSD']['output'];
  capitalGainsTaxDeferred: Scalars['CurrencyUSD']['output'];
  charitableRemainder: Scalars['CurrencyUSD']['output'];
  metCharitableThreshold: Scalars['Boolean']['output'];
  ordinaryIncomeTaxSaved: Scalars['CurrencyUSD']['output'];
  personalBenefit: Scalars['CurrencyUSD']['output'];
  personalPortfolio: Scalars['CurrencyUSD']['output'];
  projectedCharitableRemainder: Scalars['CurrencyUSD']['output'];
  rate7520?: Maybe<Scalars['Percent']['output']>;
  yearly: Array<CrtProposalYearlyProjection>;
};

export type CrtProposalProjectionInput = {
  annuityPayoutAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  costBasis: Scalars['CurrencyUSD']['input'];
  donorsYearOfBirth?: InputMaybe<Array<Scalars['Int']['input']>>;
  fundingAmount: Scalars['CurrencyUSD']['input'];
  payoutFrequency: CharitableTrustPayoutFrequency;
  payoutKind: CharitableTrustPayoutKind;
  preTaxReturnPercentage: Scalars['Percent']['input'];
  rate7520?: InputMaybe<Scalars['Percent']['input']>;
  taxDrag: Scalars['Percent']['input'];
  termKind: CharitableTrustTermKind;
  termYears: Scalars['Int']['input'];
  unitrustPayoutPercent?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * CRTProposalWhereInput is used for filtering CRTProposal objects.
 * Input was generated by ent.
 */
export type CrtProposalWhereInput = {
  and?: InputMaybe<Array<CrtProposalWhereInput>>;
  /** annuity_payout_amount field predicates */
  annuityPayoutAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annuityPayoutAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annuityPayoutAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annuityPayoutAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  annuityPayoutAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annuityPayoutAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annuityPayoutAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annuityPayoutAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_cost_basis field predicates */
  assetCostBasis?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetCostBasisGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetCostBasisGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetCostBasisLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetCostBasisLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetCostBasisNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** asset_notes field predicates */
  assetNotes?: InputMaybe<Scalars['String']['input']>;
  assetNotesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assetNotesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_value field predicates */
  assetValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  assetValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** calculation_method field predicates */
  calculationMethod?: InputMaybe<CharitableTrustCalculationMethod>;
  calculationMethodIn?: InputMaybe<Array<CharitableTrustCalculationMethod>>;
  calculationMethodIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  calculationMethodNEQ?: InputMaybe<CharitableTrustCalculationMethod>;
  calculationMethodNotIn?: InputMaybe<Array<CharitableTrustCalculationMethod>>;
  calculationMethodNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** charitable_remainder_beneficiaries edge predicates */
  hasCharitableRemainderBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasCharitableRemainderBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** donors edge predicates */
  hasDonors?: InputMaybe<Scalars['Boolean']['input']>;
  hasDonorsWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** income_beneficiaries edge predicates */
  hasIncomeBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasIncomeBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** proposal edge predicates */
  hasProposal?: InputMaybe<Scalars['Boolean']['input']>;
  hasProposalWith?: InputMaybe<Array<ProposalWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CrtProposalWhereInput>;
  /** optimization_target field predicates */
  optimizationTarget?: InputMaybe<CharitableTrustOptimizationTarget>;
  optimizationTargetIn?: InputMaybe<Array<CharitableTrustOptimizationTarget>>;
  optimizationTargetIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  optimizationTargetNEQ?: InputMaybe<CharitableTrustOptimizationTarget>;
  optimizationTargetNotIn?: InputMaybe<Array<CharitableTrustOptimizationTarget>>;
  optimizationTargetNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<CrtProposalWhereInput>>;
  /** payout_frequency field predicates */
  payoutFrequency?: InputMaybe<CharitableTrustPayoutFrequency>;
  payoutFrequencyIn?: InputMaybe<Array<CharitableTrustPayoutFrequency>>;
  payoutFrequencyNEQ?: InputMaybe<CharitableTrustPayoutFrequency>;
  payoutFrequencyNotIn?: InputMaybe<Array<CharitableTrustPayoutFrequency>>;
  /** payout_kind field predicates */
  payoutKind?: InputMaybe<CharitableTrustPayoutKind>;
  payoutKindIn?: InputMaybe<Array<CharitableTrustPayoutKind>>;
  payoutKindNEQ?: InputMaybe<CharitableTrustPayoutKind>;
  payoutKindNotIn?: InputMaybe<Array<CharitableTrustPayoutKind>>;
  /** pre_tax_return_percentage_high field predicates */
  preTaxReturnPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighGT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighGTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  preTaxReturnPercentageHighLT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighLTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighNEQ?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** pre_tax_return_percentage_low field predicates */
  preTaxReturnPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowGT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowGTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  preTaxReturnPercentageLowLT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowLTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowNEQ?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** pre_tax_return_percentage_medium field predicates */
  preTaxReturnPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumGT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumGTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  preTaxReturnPercentageMediumLT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumLTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumNEQ?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** rate_7520 field predicates */
  rate7520?: InputMaybe<Scalars['Percent']['input']>;
  rate7520GT?: InputMaybe<Scalars['Percent']['input']>;
  rate7520GTE?: InputMaybe<Scalars['Percent']['input']>;
  rate7520IsNil?: InputMaybe<Scalars['Boolean']['input']>;
  rate7520LT?: InputMaybe<Scalars['Percent']['input']>;
  rate7520LTE?: InputMaybe<Scalars['Percent']['input']>;
  rate7520NEQ?: InputMaybe<Scalars['Percent']['input']>;
  rate7520NotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_drag_percentage_high field predicates */
  taxDragPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDragPercentageHighLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_drag_percentage_low field predicates */
  taxDragPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDragPercentageLowLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_drag_percentage_medium field predicates */
  taxDragPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDragPercentageMediumLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** term_kind field predicates */
  termKind?: InputMaybe<CharitableTrustTermKind>;
  termKindIn?: InputMaybe<Array<CharitableTrustTermKind>>;
  termKindNEQ?: InputMaybe<CharitableTrustTermKind>;
  termKindNotIn?: InputMaybe<Array<CharitableTrustTermKind>>;
  /** term_years field predicates */
  termYears?: InputMaybe<Scalars['Int']['input']>;
  termYearsGT?: InputMaybe<Scalars['Int']['input']>;
  termYearsGTE?: InputMaybe<Scalars['Int']['input']>;
  termYearsLT?: InputMaybe<Scalars['Int']['input']>;
  termYearsLTE?: InputMaybe<Scalars['Int']['input']>;
  termYearsNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** unitrust_kind field predicates */
  unitrustKind?: InputMaybe<CharitableTrustUnitrustKind>;
  unitrustKindIn?: InputMaybe<Array<CharitableTrustUnitrustKind>>;
  unitrustKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  unitrustKindNEQ?: InputMaybe<CharitableTrustUnitrustKind>;
  unitrustKindNotIn?: InputMaybe<Array<CharitableTrustUnitrustKind>>;
  unitrustKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** unitrust_payout_percent field predicates */
  unitrustPayoutPercent?: InputMaybe<Scalars['Percent']['input']>;
  unitrustPayoutPercentGT?: InputMaybe<Scalars['Percent']['input']>;
  unitrustPayoutPercentGTE?: InputMaybe<Scalars['Percent']['input']>;
  unitrustPayoutPercentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  unitrustPayoutPercentLT?: InputMaybe<Scalars['Percent']['input']>;
  unitrustPayoutPercentLTE?: InputMaybe<Scalars['Percent']['input']>;
  unitrustPayoutPercentNEQ?: InputMaybe<Scalars['Percent']['input']>;
  unitrustPayoutPercentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** year_of_analysis field predicates */
  yearOfAnalysis?: InputMaybe<Scalars['Int']['input']>;
  yearOfAnalysisGT?: InputMaybe<Scalars['Int']['input']>;
  yearOfAnalysisGTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfAnalysisIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  yearOfAnalysisLT?: InputMaybe<Scalars['Int']['input']>;
  yearOfAnalysisLTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfAnalysisNEQ?: InputMaybe<Scalars['Int']['input']>;
  yearOfAnalysisNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CrtProposalYearlyProjection = {
  __typename?: 'CRTProposalYearlyProjection';
  beginningOfYear: Scalars['CurrencyUSD']['output'];
  cumulativeIncome: Scalars['CurrencyUSD']['output'];
  cumulativeTaxed: Scalars['CurrencyUSD']['output'];
  growth: Scalars['CurrencyUSD']['output'];
  payout: Scalars['CurrencyUSD']['output'];
  remainderValue: Scalars['CurrencyUSD']['output'];
  taxed: Scalars['CurrencyUSD']['output'];
  year: Scalars['Int']['output'];
};

export type CrtTrust = EntitySubtype & Named & Node & Trust & {
  __typename?: 'CRTTrust';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  /** Taxable deduction that was recorded for funding this CRT */
  charitableDeduction?: Maybe<Scalars['CurrencyUSD']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this trust */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in trusts that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  grantors?: Maybe<Array<Principal>>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  lifetimeBeneficiaries?: Maybe<Array<Beneficiary>>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  officialInterestRatePercent?: Maybe<Scalars['Percent']['output']>;
  policies?: Maybe<Array<InsurancePolicy>>;
  remainderBeneficiaries?: Maybe<Array<Beneficiary>>;
  stateInEstateStatus: EntityInEstateStatus;
  successorTrustees?: Maybe<Array<Trustee>>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<TrustTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** If true, term_duration_years will be ignored */
  termDurationLifetime: Scalars['Boolean']['output'];
  termDurationYears?: Maybe<Scalars['Int']['output']>;
  termEndDate?: Maybe<Scalars['Time']['output']>;
  terminationDate?: Maybe<Scalars['Time']['output']>;
  trustAdvisors?: Maybe<Array<TrustAdvisor>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  trustees?: Maybe<Array<Trustee>>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type CrtTrustHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type CrtTrustConnection = {
  __typename?: 'CRTTrustConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CrtTrustEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CrtTrustEdge = {
  __typename?: 'CRTTrustEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CrtTrust>;
};

/** Ordering options for CRTTrust connections */
export type CrtTrustOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order CRTTrusts. */
  field: CrtTrustOrderField;
};

/** Properties by which CRTTrust connections can be ordered. */
export enum CrtTrustOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * CRTTrustWhereInput is used for filtering CRTTrust objects.
 * Input was generated by ent.
 */
export type CrtTrustWhereInput = {
  and?: InputMaybe<Array<CrtTrustWhereInput>>;
  /** charitable_deduction field predicates */
  charitableDeduction?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  charitableDeductionGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  charitableDeductionGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  charitableDeductionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  charitableDeductionLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  charitableDeductionLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  charitableDeductionNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  charitableDeductionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** grantors edge predicates */
  hasGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrantorsWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** lifetime_beneficiaries edge predicates */
  hasLifetimeBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasLifetimeBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** remainder_beneficiaries edge predicates */
  hasRemainderBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasRemainderBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** successor_trustees edge predicates */
  hasSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuccessorTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** trust_advisors edge predicates */
  hasTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrustAdvisorsWith?: InputMaybe<Array<TrustAdvisorWhereInput>>;
  /** trustees edge predicates */
  hasTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<CrtTrustWhereInput>;
  /** official_interest_rate_percent field predicates */
  officialInterestRatePercent?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentGT?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentGTE?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  officialInterestRatePercentLT?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentLTE?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentNEQ?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<CrtTrustWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<TrustTaxStatus>;
  taxStatusIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<TrustTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** term_duration_lifetime field predicates */
  termDurationLifetime?: InputMaybe<Scalars['Boolean']['input']>;
  /** term_duration_years field predicates */
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsGT?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsGTE?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  termDurationYearsLT?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsLTE?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsNEQ?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** termination_date field predicates */
  terminationDate?: InputMaybe<Scalars['Time']['input']>;
  terminationDateGT?: InputMaybe<Scalars['Time']['input']>;
  terminationDateGTE?: InputMaybe<Scalars['Time']['input']>;
  terminationDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  terminationDateLT?: InputMaybe<Scalars['Time']['input']>;
  terminationDateLTE?: InputMaybe<Scalars['Time']['input']>;
  terminationDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** trust_jurisdiction_state_code field predicates */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trustJurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  trustJurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type CsvAccountImportResponse = {
  __typename?: 'CSVAccountImportResponse';
  file: File;
  numEntitiesUpdated: Scalars['Int']['output'];
};

export type CsvValuationImportResponse = {
  __typename?: 'CSVValuationImportResponse';
  file: File;
  numValuationsUpdated: Scalars['Int']['output'];
  valuationUpdateErrorMessages: Array<EntityValuationErrorMessage>;
};

export type Capability = Node & {
  __typename?: 'Capability';
  authzedRelationName: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The roles that have this capability. */
  role?: Maybe<Array<Role>>;
  updatedAt: Scalars['Time']['output'];
};

/** Ordering options for Capability connections */
export type CapabilityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Capabilities. */
  field: CapabilityOrderField;
};

/** Properties by which Capability connections can be ordered. */
export enum CapabilityOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * CapabilityWhereInput is used for filtering Capability objects.
 * Input was generated by ent.
 */
export type CapabilityWhereInput = {
  and?: InputMaybe<Array<CapabilityWhereInput>>;
  /** authzed_relation_name field predicates */
  authzedRelationName?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** role edge predicates */
  hasRole?: InputMaybe<Scalars['Boolean']['input']>;
  hasRoleWith?: InputMaybe<Array<RoleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CapabilityWhereInput>;
  or?: InputMaybe<Array<CapabilityWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Cashflow = Node & {
  __typename?: 'Cashflow';
  /** This dynamically sets the end date of this transfer to the year when both individuals die. It superceeds end_year and end_at_clients_death. Ignored if start_year is not set.  */
  afterBothDeaths?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Time']['output'];
  displayName: Scalars['String']['output'];
  /** This sets the end date of this transfer when the client dies. This superceeds the end_year field. This is ignored if start_year is not set. */
  endAtClientsDeath?: Maybe<ClientProfile>;
  /** The year this transfer ends. Ignored if start_year is not set. */
  endYear?: Maybe<Scalars['Int']['output']>;
  entity?: Maybe<Entity>;
  /** The yearly growth percent of this transfer. Can be negative. Only valid when kind is AMOUNT */
  growthPercent?: Maybe<Scalars['Percent']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated only direct to entities */
  individual?: Maybe<ClientProfile>;
  integrationCashflow?: Maybe<IntegrationCashflow>;
  /** The year this transfer starts. If start_year is not set, it is assumed to be a one time transfer happening in the current year. If start_year is set, this is a yearly recurring transfer until end_year is reached. */
  startYear?: Maybe<Scalars['Int']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The percentage of the transfer. Positive for income, negative for expense. Only valid when kind is PERCENTAGE */
  transferPercentage?: Maybe<Scalars['Percent']['output']>;
  /** Value of this transfer. Positive for income, negative for expense. Only valid when kind is AMOUNT */
  transferValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type CashflowConnection = {
  __typename?: 'CashflowConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CashflowEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CashflowEdge = {
  __typename?: 'CashflowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Cashflow>;
};

/** Ordering options for Cashflow connections */
export type CashflowOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Cashflows. */
  field: CashflowOrderField;
};

/** Properties by which Cashflow connections can be ordered. */
export enum CashflowOrderField {
  CreatedAt = 'created_at',
  StartYear = 'start_year',
  TransferValue = 'transfer_value',
  UpdatedAt = 'updated_at'
}

/**
 * CashflowWhereInput is used for filtering Cashflow objects.
 * Input was generated by ent.
 */
export type CashflowWhereInput = {
  /** after_both_deaths field predicates */
  afterBothDeaths?: InputMaybe<Scalars['Boolean']['input']>;
  afterBothDeathsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  afterBothDeathsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<CashflowWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** end_year field predicates */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  endYearGT?: InputMaybe<Scalars['Int']['input']>;
  endYearGTE?: InputMaybe<Scalars['Int']['input']>;
  endYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endYearLT?: InputMaybe<Scalars['Int']['input']>;
  endYearLTE?: InputMaybe<Scalars['Int']['input']>;
  endYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  endYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** growth_percent field predicates */
  growthPercent?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentGT?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentGTE?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  growthPercentLT?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentLTE?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentNEQ?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** end_at_clients_death edge predicates */
  hasEndAtClientsDeath?: InputMaybe<Scalars['Boolean']['input']>;
  hasEndAtClientsDeathWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** individual edge predicates */
  hasIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** integration_cashflow edge predicates */
  hasIntegrationCashflow?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntegrationCashflowWith?: InputMaybe<Array<IntegrationCashflowWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CashflowWhereInput>;
  or?: InputMaybe<Array<CashflowWhereInput>>;
  /** start_year field predicates */
  startYear?: InputMaybe<Scalars['Int']['input']>;
  startYearGT?: InputMaybe<Scalars['Int']['input']>;
  startYearGTE?: InputMaybe<Scalars['Int']['input']>;
  startYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startYearLT?: InputMaybe<Scalars['Int']['input']>;
  startYearLTE?: InputMaybe<Scalars['Int']['input']>;
  startYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  startYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** transfer_percentage field predicates */
  transferPercentage?: InputMaybe<Scalars['Percent']['input']>;
  transferPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  transferPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  transferPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  transferPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  transferPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  transferPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  transferPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** transfer_value field predicates */
  transferValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  transferValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type CharitableOrganizationPerformanceReport = {
  __typename?: 'CharitableOrganizationPerformanceReport';
  directGifts: Scalars['CurrencyUSD']['output'];
  grantsFromDAFs?: Maybe<Array<GrantsToCharitableOrganizations>>;
  grantsFromPrivateFoundations?: Maybe<Array<GrantsToCharitableOrganizations>>;
  totalWealthTransferred: Scalars['CurrencyUSD']['output'];
};

/** CharitableTrustCalculationMethod is enum for the field calculation_method */
export enum CharitableTrustCalculationMethod {
  Calculated = 'CALCULATED',
  Manual = 'MANUAL'
}

/** CharitableTrustOptimizationTarget is enum for the field optimization_target */
export enum CharitableTrustOptimizationTarget {
  Charitable = 'CHARITABLE',
  NonCharitable = 'NON_CHARITABLE'
}

/** CharitableTrustPayoutFrequency is enum for the field payout_frequency */
export enum CharitableTrustPayoutFrequency {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY'
}

/** CharitableTrustPayoutKind is enum for the field payout_kind */
export enum CharitableTrustPayoutKind {
  Annuity = 'ANNUITY',
  Unitrust = 'UNITRUST'
}

/** CharitableTrustTermKind is enum for the field term_kind */
export enum CharitableTrustTermKind {
  Fixed = 'FIXED',
  Lifetime = 'LIFETIME'
}

/** CharitableTrustUnitrustKind is enum for the field unitrust_kind */
export enum CharitableTrustUnitrustKind {
  Flip = 'FLIP',
  NetIncome = 'NET_INCOME',
  NetIncomeWithMakeup = 'NET_INCOME_WITH_MAKEUP',
  Standard = 'STANDARD'
}

/**
 * Research mode for a household chat turn. Both modes use the same answer-shape
 * rules and can read records, documents, and citations; QUICK is the latency-first
 * pass on a lighter model, while DEEP is the quality-first pass (including deep
 * research) on the standard reasoning model.
 */
export enum ChatMode {
  Deep = 'DEEP',
  Quick = 'QUICK'
}

/**
 * Specialized persona for a household chat turn. Selecting a persona replaces the
 * default household chat behavior with a purpose-built specialist configuration
 * (system prompt, tools, and subagents).
 */
export enum ChatPersona {
  /**
   * An expert fiduciary decision-support agent responsible for evaluating
   * requests for distributions from trusts.
   */
  DistributionEvaluation = 'DISTRIBUTION_EVALUATION',
  /**
   * An expert planning-analysis agent that reviews the household's estate plan
   * and quantifies lawful tax-minimization strategies for advisor and attorney
   * review.
   */
  WealthStrategist = 'WEALTH_STRATEGIST'
}

/**
 * Shared fields for structured chat results.
 * Extend with additional implementing types as new chat surfaces are added,
 * for example: HouseholdChatResult.
 */
export type ChatResult = {
  answer: Scalars['String']['output'];
  conversation: Conversation;
};

/** Result of the cleanUpSuggestionsForV2Migration mutation. */
export type CleanUpSuggestionsForV2MigrationPayload = {
  __typename?: 'CleanUpSuggestionsForV2MigrationPayload';
  /** The number of v2 AISuggestions deleted. */
  deletedV2Count: Scalars['Int']['output'];
  /** The number of v1 AISuggestions transitioned from pending to REJECTED. */
  rejectedV1Count: Scalars['Int']['output'];
};

export type ClearFormSubmissionAnswerInput = {
  expectedLockVersion: Scalars['Int']['input'];
  fieldID: Scalars['String']['input'];
  submissionID: Scalars['ID']['input'];
};

export type ClientOrganization = Node & {
  __typename?: 'ClientOrganization';
  address?: Maybe<Address>;
  beneficiariesBundleHouseholdOrganizations?: Maybe<Array<BeneficiariesBundleConfiguration>>;
  beneficiariesBundleIndividualOrganizations?: Maybe<Array<BeneficiariesBundleConfiguration>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  id: Scalars['ID']['output'];
  kgV2Nodes: Kgv2NodeConnection;
  kind?: Maybe<ClientOrganizationKind>;
  name: Scalars['String']['output'];
  /** Free-form notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** The AI onboarding suggestion that created this client organization */
  onboardedOrganizationSuggestion?: Maybe<Array<AiSuggestion>>;
  performanceReport: CharitableOrganizationPerformanceReport;
  pointOfContactEmail?: Maybe<Scalars['String']['output']>;
  pointOfContactLastName?: Maybe<Scalars['String']['output']>;
  pointOfContactName?: Maybe<Scalars['String']['output']>;
  pointOfContactPhone?: Maybe<Scalars['String']['output']>;
  /** The existing client organization that potentially matches the suggestion based on the LLM's analysis of the existing client organization names (before the suggestion is accepted) */
  potentialClientOrganizationSuggestion?: Maybe<Array<AiSuggestion>>;
  professionalTeamRoles: ProfessionalTeamRoleConnection;
  /** The client organization that the suggestion is associated with (once the suggestion is accepted) */
  suggestedClientOrganization?: Maybe<Array<AiSuggestion>>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type ClientOrganizationKgV2NodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2NodeOrder>>;
  where?: InputMaybe<Kgv2NodeWhereInput>;
};


export type ClientOrganizationProfessionalTeamRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProfessionalTeamRoleOrder>>;
  where?: InputMaybe<ProfessionalTeamRoleWhereInput>;
};

/** A connection to a list of items. */
export type ClientOrganizationConnection = {
  __typename?: 'ClientOrganizationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ClientOrganizationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ClientOrganizationEdge = {
  __typename?: 'ClientOrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClientOrganization>;
};

/** ClientOrganizationKind is enum for the field kind */
export enum ClientOrganizationKind {
  CharitableOrganization = 'CHARITABLE_ORGANIZATION',
  CorporateTrustee = 'CORPORATE_TRUSTEE',
  Other = 'OTHER'
}

/** Ordering options for ClientOrganization connections */
export type ClientOrganizationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ClientOrganizations. */
  field: ClientOrganizationOrderField;
};

/** Properties by which ClientOrganization connections can be ordered. */
export enum ClientOrganizationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * ClientOrganizationWhereInput is used for filtering ClientOrganization objects.
 * Input was generated by ent.
 */
export type ClientOrganizationWhereInput = {
  and?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** address edge predicates */
  hasAddress?: InputMaybe<Scalars['Boolean']['input']>;
  hasAddressWith?: InputMaybe<Array<AddressWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** kg_v2_nodes edge predicates */
  hasKgV2Nodes?: InputMaybe<Scalars['Boolean']['input']>;
  hasKgV2NodesWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** onboarded_organization_suggestion edge predicates */
  hasOnboardedOrganizationSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasOnboardedOrganizationSuggestionWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** potential_client_organization_suggestion edge predicates */
  hasPotentialClientOrganizationSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasPotentialClientOrganizationSuggestionWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** professional_team_roles edge predicates */
  hasProfessionalTeamRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfessionalTeamRolesWith?: InputMaybe<Array<ProfessionalTeamRoleWhereInput>>;
  /** suggested_client_organization edge predicates */
  hasSuggestedClientOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuggestedClientOrganizationWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<ClientOrganizationKind>;
  kindIn?: InputMaybe<Array<ClientOrganizationKind>>;
  kindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  kindNEQ?: InputMaybe<ClientOrganizationKind>;
  kindNotIn?: InputMaybe<Array<ClientOrganizationKind>>;
  kindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<ClientOrganizationWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** point_of_contact_email field predicates */
  pointOfContactEmail?: InputMaybe<Scalars['String']['input']>;
  pointOfContactEmailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  pointOfContactEmailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** point_of_contact_last_name field predicates */
  pointOfContactLastName?: InputMaybe<Scalars['String']['input']>;
  pointOfContactLastNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  pointOfContactLastNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** point_of_contact_name field predicates */
  pointOfContactName?: InputMaybe<Scalars['String']['input']>;
  pointOfContactNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  pointOfContactNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** point_of_contact_phone field predicates */
  pointOfContactPhone?: InputMaybe<Scalars['String']['input']>;
  pointOfContactPhoneIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  pointOfContactPhoneNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type ClientOverallPerformanceReport = {
  __typename?: 'ClientOverallPerformanceReport';
  impliedEstateTaxSavings: Scalars['CurrencyUSD']['output'];
  outOfEstateGrowth: Scalars['CurrencyUSD']['output'];
  totalWealthTransferred: Scalars['CurrencyUSD']['output'];
};

export type ClientPresentationV2 = Node & {
  __typename?: 'ClientPresentationV2';
  /** The approval and attestation records for this presentation, oldest first. */
  approvals: Array<Approval>;
  bundles: PresentationBundleConnection;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pageNumberToStartFrom: Scalars['Int']['output'];
  /**
   * The review steps that this presentation must complete before it is no
   * longer a draft. It is the effective requirePresentationApproval
   * configuration, except that a presentation created before the firm started
   * to require a step does not need that step: a presentation created before
   * attestation was required needs no review, and one created before approval
   * was required needs only attestation.
   */
  reviewRequirement: PresentationApprovalRequirement;
  showClientNamesInHeader: Scalars['Boolean']['output'];
  showLegalDisclaimer: Scalars['Boolean']['output'];
  showPageNumbers: Scalars['Boolean']['output'];
  showPageNumbersOnCoverSlide: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  /**
   * True when the current user has permission to approve presentations in the
   * household of this presentation. The permission requires the presentation
   * approver capability and update access to the household.
   */
  viewerCanApprove: Scalars['Boolean']['output'];
};


export type ClientPresentationV2BundlesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationBundleOrder>>;
  where?: InputMaybe<PresentationBundleWhereInput>;
};

/** A connection to a list of items. */
export type ClientPresentationV2Connection = {
  __typename?: 'ClientPresentationV2Connection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ClientPresentationV2Edge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ClientPresentationV2Edge = {
  __typename?: 'ClientPresentationV2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClientPresentationV2>;
};

/** Ordering options for ClientPresentationV2 connections */
export type ClientPresentationV2Order = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ClientPresentationV2s. */
  field: ClientPresentationV2OrderField;
};

/** Properties by which ClientPresentationV2 connections can be ordered. */
export enum ClientPresentationV2OrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * ClientPresentationV2WhereInput is used for filtering ClientPresentationV2 objects.
 * Input was generated by ent.
 */
export type ClientPresentationV2WhereInput = {
  and?: InputMaybe<Array<ClientPresentationV2WhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** bundles edge predicates */
  hasBundles?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundlesWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<ClientPresentationV2WhereInput>;
  or?: InputMaybe<Array<ClientPresentationV2WhereInput>>;
  /** page_number_to_start_from field predicates */
  pageNumberToStartFrom?: InputMaybe<Scalars['Int']['input']>;
  pageNumberToStartFromGT?: InputMaybe<Scalars['Int']['input']>;
  pageNumberToStartFromGTE?: InputMaybe<Scalars['Int']['input']>;
  pageNumberToStartFromLT?: InputMaybe<Scalars['Int']['input']>;
  pageNumberToStartFromLTE?: InputMaybe<Scalars['Int']['input']>;
  pageNumberToStartFromNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** show_client_names_in_header field predicates */
  showClientNamesInHeader?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_legal_disclaimer field predicates */
  showLegalDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_page_numbers field predicates */
  showPageNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_page_numbers_on_cover_slide field predicates */
  showPageNumbersOnCoverSlide?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type ClientProfile = Node & {
  __typename?: 'ClientProfile';
  address?: Maybe<Address>;
  beneficiariesBundleHouseholdProfiles?: Maybe<Array<BeneficiariesBundleConfiguration>>;
  beneficiariesBundleIndividualProfiles?: Maybe<Array<BeneficiariesBundleConfiguration>>;
  cashflows: CashflowConnection;
  cltProposalDonors?: Maybe<Array<CltProposal>>;
  createdAt: Scalars['Time']['output'];
  crtProposalDonors?: Maybe<Array<CrtProposal>>;
  currentAnnualExclusionUsed: Scalars['CurrencyUSD']['output'];
  dateOfBirth?: Maybe<Scalars['Time']['output']>;
  dateOfDeath?: Maybe<Scalars['Time']['output']>;
  displayGivenName: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  /** Controls which name parts appear in the client profile display name. */
  displayNamePattern: ClientProfileDisplayNamePattern;
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  documents: DocumentConnection;
  /**
   * The DSUE for this client profile.
   * 	This is the leftover, unused lifetime exemption from a previous, now deceased, spouse.
   */
  dsue?: Maybe<DsuePortability>;
  email?: Maybe<Scalars['String']['output']>;
  /** Estate waterfall filters associated with this client. Here to force the M2M relationship. */
  estateWaterfallFilters?: Maybe<Array<EstateWaterfallVisualizationFilter>>;
  /** Customer-supplied identifier from an external system. Unique per tenant when set. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** The dedicated financial entity for this person; optional until backfill is complete. */
  financialEntity?: Maybe<Entity>;
  /** The dedicated financial entity for this person. A link does not mean that legacy dispositions have been reconciled. */
  financialEntityID?: Maybe<Scalars['ID']['output']>;
  firstName: Scalars['String']['output'];
  gstExclusionUsed: Scalars['CurrencyUSD']['output'];
  /** The Hargrove client ID. Unique per tenant when set. */
  hargroveClientID?: Maybe<Scalars['String']['output']>;
  household: Household;
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  hypotheticalInsuranceDonors?: Maybe<Array<HypotheticalInsurance>>;
  hypotheticalTransfer?: Maybe<Array<EstateWaterfallHypotheticalTransfer>>;
  id: Scalars['ID']['output'];
  insurancePolicy?: Maybe<Array<InsurancePolicy>>;
  /** Integration person linked to this client profile */
  integrationPerson?: Maybe<IntegrationPerson>;
  /** Whether this client profile is deceased. */
  isDeceased: Scalars['Boolean']['output'];
  /** Whether this client profile should be an eligible grantor/owner/other principal for entities. */
  isGrantor: Scalars['Boolean']['output'];
  /** Whether this client_profile is one of the (at most) two primary clients on this household. */
  isPrimary: Scalars['Boolean']['output'];
  kgV2Nodes: Kgv2NodeConnection;
  lastName: Scalars['String']['output'];
  legalName: Scalars['String']['output'];
  lifetimeExclusionEvents?: Maybe<Array<LifetimeExclusionEvent>>;
  lifetimeExclusionUsed: Scalars['CurrencyUSD']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  /** Missing document overrides associated with this client profile */
  missingDocumentOverrides?: Maybe<Array<MissingDocumentOverride>>;
  /** Free-form notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** The AI onboarding suggestion that created this client profile */
  onboardedIndividualSuggestion?: Maybe<Array<AiSuggestion>>;
  /** Ownership stakes this individual has. */
  ownedOwnershipStakes?: Maybe<Array<OwnershipStake>>;
  /** Used in beneficiary reporting to adjust beneficiary totalswith distributions made in the past */
  pastDistributions?: Maybe<Scalars['CurrencyUSD']['output']>;
  performanceReportGifts: GiftsToIndividualsPerformanceReport;
  policies?: Maybe<Array<InsurancePolicy>>;
  /** The existing client profile that potentially matches the suggestion based on the LLM's analysis of the existing client profile names (before the suggestion is accepted) */
  potentialClientProfileSuggestion?: Maybe<Array<AiSuggestion>>;
  preferredName?: Maybe<Scalars['String']['output']>;
  professionalTeamRoles: ProfessionalTeamRoleConnection;
  relations?: Maybe<Array<ClientProfile>>;
  relationships?: Maybe<Array<ClientProfileRelationship>>;
  remainingGSTExclusion: Scalars['CurrencyUSD']['output'];
  remainingLifetimeExclusion: Scalars['CurrencyUSD']['output'];
  remainingStateExemption: Scalars['CurrencyUSD']['output'];
  stateExemptionUsed: Scalars['CurrencyUSD']['output'];
  suffix?: Maybe<Scalars['String']['output']>;
  /** The client profile that the suggestion is associated with (once the suggestion is accepted) */
  suggestedClientProfile?: Maybe<Array<AiSuggestion>>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  testamentaryEntities: TestamentaryEntityConnection;
  totalAnnualExclusionUsed: Scalars['CurrencyUSD']['output'];
  totalStateExemption: Scalars['CurrencyUSD']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type ClientProfileCashflowsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CashflowOrder>>;
  where?: InputMaybe<CashflowWhereInput>;
};


export type ClientProfileDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentOrder>>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type ClientProfileHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};


export type ClientProfileKgV2NodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2NodeOrder>>;
  where?: InputMaybe<Kgv2NodeWhereInput>;
};


export type ClientProfileProfessionalTeamRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProfessionalTeamRoleOrder>>;
  where?: InputMaybe<ProfessionalTeamRoleWhereInput>;
};


export type ClientProfileTestamentaryEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TestamentaryEntityOrder>>;
  where?: InputMaybe<TestamentaryEntityWhereInput>;
};

/** A connection to a list of items. */
export type ClientProfileConnection = {
  __typename?: 'ClientProfileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ClientProfileEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** ClientProfileDisplayNamePattern is enum for the field display_name_pattern */
export enum ClientProfileDisplayNamePattern {
  FirstLast = 'FIRST_LAST',
  FirstLastSuffix = 'FIRST_LAST_SUFFIX',
  FirstMiddleLastSuffix = 'FIRST_MIDDLE_LAST_SUFFIX',
  FirstMiLastSuffix = 'FIRST_MI_LAST_SUFFIX'
}

/** An edge in a connection. */
export type ClientProfileEdge = {
  __typename?: 'ClientProfileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClientProfile>;
};

/** Ordering options for ClientProfile connections */
export type ClientProfileOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ClientProfiles. */
  field: ClientProfileOrderField;
};

/** Properties by which ClientProfile connections can be ordered. */
export enum ClientProfileOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type ClientProfileRelationship = Node & {
  __typename?: 'ClientProfileRelationship';
  clientProfileID: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  fromClientProfile: ClientProfile;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Free-form notes */
  notes?: Maybe<Scalars['String']['output']>;
  relationID: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  toClientProfile: ClientProfile;
  /** the relationship between the 'from' ClientProfile and the 'to' ClientProfile */
  type: ClientProfileRelationshipType;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type ClientProfileRelationshipConnection = {
  __typename?: 'ClientProfileRelationshipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ClientProfileRelationshipEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ClientProfileRelationshipEdge = {
  __typename?: 'ClientProfileRelationshipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ClientProfileRelationship>;
};

/** Ordering options for ClientProfileRelationship connections */
export type ClientProfileRelationshipOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ClientProfileRelationships. */
  field: ClientProfileRelationshipOrderField;
};

/** Properties by which ClientProfileRelationship connections can be ordered. */
export enum ClientProfileRelationshipOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** ClientProfileRelationshipType is enum for the field type */
export enum ClientProfileRelationshipType {
  Child = 'CHILD',
  ChildInLaw = 'CHILD_IN_LAW',
  Cousin = 'COUSIN',
  CousinInLaw = 'COUSIN_IN_LAW',
  DomesticPartner = 'DOMESTIC_PARTNER',
  ExChildInLaw = 'EX_CHILD_IN_LAW',
  ExCousinInLaw = 'EX_COUSIN_IN_LAW',
  ExDomesticPartner = 'EX_DOMESTIC_PARTNER',
  ExGrandchildInLaw = 'EX_GRANDCHILD_IN_LAW',
  ExGreatGrandchildInLaw = 'EX_GREAT_GRANDCHILD_IN_LAW',
  ExGreatGreatGrandchildInLaw = 'EX_GREAT_GREAT_GRANDCHILD_IN_LAW',
  ExNephewNieceInLaw = 'EX_NEPHEW_NIECE_IN_LAW',
  ExSiblingInLaw = 'EX_SIBLING_IN_LAW',
  ExSpouse = 'EX_SPOUSE',
  ExUncleAuntInLaw = 'EX_UNCLE_AUNT_IN_LAW',
  Friend = 'FRIEND',
  Grandchild = 'GRANDCHILD',
  GrandchildInLaw = 'GRANDCHILD_IN_LAW',
  Grandparent = 'GRANDPARENT',
  GreatGrandchild = 'GREAT_GRANDCHILD',
  GreatGrandchildInLaw = 'GREAT_GRANDCHILD_IN_LAW',
  GreatGrandparent = 'GREAT_GRANDPARENT',
  GreatGreatGrandchild = 'GREAT_GREAT_GRANDCHILD',
  GreatGreatGrandchildInLaw = 'GREAT_GREAT_GRANDCHILD_IN_LAW',
  NephewNiece = 'NEPHEW_NIECE',
  NephewNieceInLaw = 'NEPHEW_NIECE_IN_LAW',
  OtherNonRelative = 'OTHER_NON_RELATIVE',
  OtherRelative = 'OTHER_RELATIVE',
  Parent = 'PARENT',
  Sibling = 'SIBLING',
  SiblingInLaw = 'SIBLING_IN_LAW',
  Spouse = 'SPOUSE',
  StepChild = 'STEP_CHILD',
  StepParent = 'STEP_PARENT',
  UncleAunt = 'UNCLE_AUNT',
  UncleAuntInLaw = 'UNCLE_AUNT_IN_LAW'
}

/**
 * ClientProfileRelationshipWhereInput is used for filtering ClientProfileRelationship objects.
 * Input was generated by ent.
 */
export type ClientProfileRelationshipWhereInput = {
  and?: InputMaybe<Array<ClientProfileRelationshipWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ClientProfileRelationshipWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<ClientProfileRelationshipWhereInput>>;
  /** type field predicates */
  type?: InputMaybe<ClientProfileRelationshipType>;
  typeIn?: InputMaybe<Array<ClientProfileRelationshipType>>;
  typeNEQ?: InputMaybe<ClientProfileRelationshipType>;
  typeNotIn?: InputMaybe<Array<ClientProfileRelationshipType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * ClientProfileWhereInput is used for filtering ClientProfile objects.
 * Input was generated by ent.
 */
export type ClientProfileWhereInput = {
  and?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** display_name_pattern field predicates */
  displayNamePattern?: InputMaybe<ClientProfileDisplayNamePattern>;
  displayNamePatternIn?: InputMaybe<Array<ClientProfileDisplayNamePattern>>;
  displayNamePatternNEQ?: InputMaybe<ClientProfileDisplayNamePattern>;
  displayNamePatternNotIn?: InputMaybe<Array<ClientProfileDisplayNamePattern>>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  emailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** financial_entity_id field predicates */
  financialEntityID?: InputMaybe<Scalars['ID']['input']>;
  financialEntityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  financialEntityIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  financialEntityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  financialEntityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  financialEntityIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** first_name field predicates */
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNameContains?: InputMaybe<Scalars['String']['input']>;
  /** address edge predicates */
  hasAddress?: InputMaybe<Scalars['Boolean']['input']>;
  hasAddressWith?: InputMaybe<Array<AddressWhereInput>>;
  /** cashflows edge predicates */
  hasCashflows?: InputMaybe<Scalars['Boolean']['input']>;
  hasCashflowsWith?: InputMaybe<Array<CashflowWhereInput>>;
  /** clt_proposal_donors edge predicates */
  hasCltProposalDonors?: InputMaybe<Scalars['Boolean']['input']>;
  hasCltProposalDonorsWith?: InputMaybe<Array<CltProposalWhereInput>>;
  /** crt_proposal_donors edge predicates */
  hasCrtProposalDonors?: InputMaybe<Scalars['Boolean']['input']>;
  hasCrtProposalDonorsWith?: InputMaybe<Array<CrtProposalWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** documents edge predicates */
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** dsue edge predicates */
  hasDsue?: InputMaybe<Scalars['Boolean']['input']>;
  hasDsueWith?: InputMaybe<Array<DsuePortabilityWhereInput>>;
  /** estate_waterfall_filters edge predicates */
  hasEstateWaterfallFilters?: InputMaybe<Scalars['Boolean']['input']>;
  hasEstateWaterfallFiltersWith?: InputMaybe<Array<EstateWaterfallVisualizationFilterWhereInput>>;
  /** financial_entity edge predicates */
  hasFinancialEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasFinancialEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** hypothetical_insurance_donors edge predicates */
  hasHypotheticalInsuranceDonors?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalInsuranceDonorsWith?: InputMaybe<Array<HypotheticalInsuranceWhereInput>>;
  /** hypothetical_transfer edge predicates */
  hasHypotheticalTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalTransferWith?: InputMaybe<Array<EstateWaterfallHypotheticalTransferWhereInput>>;
  /** insurance_policy edge predicates */
  hasInsurancePolicy?: InputMaybe<Scalars['Boolean']['input']>;
  hasInsurancePolicyWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** integration_person edge predicates */
  hasIntegrationPerson?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntegrationPersonWith?: InputMaybe<Array<IntegrationPersonWhereInput>>;
  /** kg_v2_nodes edge predicates */
  hasKgV2Nodes?: InputMaybe<Scalars['Boolean']['input']>;
  hasKgV2NodesWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** lifetime_exclusion_events edge predicates */
  hasLifetimeExclusionEvents?: InputMaybe<Scalars['Boolean']['input']>;
  hasLifetimeExclusionEventsWith?: InputMaybe<Array<LifetimeExclusionEventWhereInput>>;
  /** missing_document_overrides edge predicates */
  hasMissingDocumentOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  hasMissingDocumentOverridesWith?: InputMaybe<Array<MissingDocumentOverrideWhereInput>>;
  /** onboarded_individual_suggestion edge predicates */
  hasOnboardedIndividualSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasOnboardedIndividualSuggestionWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** owned_ownership_stakes edge predicates */
  hasOwnedOwnershipStakes?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnedOwnershipStakesWith?: InputMaybe<Array<OwnershipStakeWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** potential_client_profile_suggestion edge predicates */
  hasPotentialClientProfileSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasPotentialClientProfileSuggestionWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** professional_team_roles edge predicates */
  hasProfessionalTeamRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfessionalTeamRolesWith?: InputMaybe<Array<ProfessionalTeamRoleWhereInput>>;
  /** relations edge predicates */
  hasRelations?: InputMaybe<Scalars['Boolean']['input']>;
  hasRelationsWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** relationships edge predicates */
  hasRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasRelationshipsWith?: InputMaybe<Array<ClientProfileRelationshipWhereInput>>;
  /** suggested_client_profile edge predicates */
  hasSuggestedClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuggestedClientProfileWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** testamentary_entities edge predicates */
  hasTestamentaryEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasTestamentaryEntitiesWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_deceased field predicates */
  isDeceased?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_grantor field predicates */
  isGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_primary field predicates */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_name field predicates */
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastNameContains?: InputMaybe<Scalars['String']['input']>;
  /** middle_name field predicates */
  middleName?: InputMaybe<Scalars['String']['input']>;
  middleNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  middleNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ClientProfileWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** past_distributions field predicates */
  pastDistributions?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  pastDistributionsGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  pastDistributionsGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  pastDistributionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  pastDistributionsLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  pastDistributionsLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  pastDistributionsNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  pastDistributionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** preferred_name field predicates */
  preferredName?: InputMaybe<Scalars['String']['input']>;
  preferredNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  preferredNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** suffix field predicates */
  suffix?: InputMaybe<Scalars['String']['input']>;
  suffixIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  suffixNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Collaborator = Named & Node & {
  __typename?: 'Collaborator';
  createdAt: Scalars['Time']['output'];
  displayName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** Households this collaborator is assigned to */
  households?: Maybe<Array<Household>>;
  id: Scalars['ID']['output'];
  /** The role of the collaborator, for display purposes only */
  kind: CollaboratorKind;
  lastName: Scalars['String']['output'];
  /** The timestamp when the collaborator last viewed the notifications list */
  lastViewedNotificationsListAt?: Maybe<Scalars['Time']['output']>;
  /** The name of the organization this collaborator works for */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Roles this collaborator is assigned to */
  roles?: Maybe<Array<Role>>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The professional title of the collaborator, e.g. 'Associate' */
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  /** The user associated with this collaborator */
  user?: Maybe<User>;
};

/** A connection to a list of items. */
export type CollaboratorConnection = {
  __typename?: 'CollaboratorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CollaboratorEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CollaboratorEdge = {
  __typename?: 'CollaboratorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Collaborator>;
};

/** CollaboratorKind is enum for the field kind */
export enum CollaboratorKind {
  Attorney = 'ATTORNEY',
  Client = 'CLIENT',
  Cpa = 'CPA',
  FinancialAdvisor = 'FINANCIAL_ADVISOR',
  Other = 'OTHER'
}

/** Ordering options for Collaborator connections */
export type CollaboratorOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Collaborators. */
  field: CollaboratorOrderField;
};

/** Properties by which Collaborator connections can be ordered. */
export enum CollaboratorOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * CollaboratorWhereInput is used for filtering Collaborator objects.
 * Input was generated by ent.
 */
export type CollaboratorWhereInput = {
  and?: InputMaybe<Array<CollaboratorWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** first_name field predicates */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** roles edge predicates */
  hasRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasRolesWith?: InputMaybe<Array<RoleWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<CollaboratorKind>;
  kindIn?: InputMaybe<Array<CollaboratorKind>>;
  kindNEQ?: InputMaybe<CollaboratorKind>;
  kindNotIn?: InputMaybe<Array<CollaboratorKind>>;
  /** last_name field predicates */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** last_viewed_notifications_list_at field predicates */
  lastViewedNotificationsListAt?: InputMaybe<Scalars['Time']['input']>;
  lastViewedNotificationsListAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastViewedNotificationsListAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastViewedNotificationsListAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastViewedNotificationsListAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastViewedNotificationsListAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastViewedNotificationsListAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<CollaboratorWhereInput>;
  or?: InputMaybe<Array<CollaboratorWhereInput>>;
  /** organization_name field predicates */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organizationNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  titleNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type ComparedWaterfall = Node & {
  __typename?: 'ComparedWaterfall';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The display name for the compared waterfall. */
  displayName: Scalars['String']['output'];
  estateWaterfall?: Maybe<EstateWaterfall>;
  estateWaterfallViz: EstateWaterfallViz;
  /** The year of the first death in the compared waterfall. */
  firstDeathYear?: Maybe<Scalars['Int']['output']>;
  growthProfile?: Maybe<GrowthProfile>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The year of the second death in the compared waterfall. */
  secondDeathYear?: Maybe<Scalars['Int']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type ComparedWaterfallConnection = {
  __typename?: 'ComparedWaterfallConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ComparedWaterfallEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ComparedWaterfallEdge = {
  __typename?: 'ComparedWaterfallEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ComparedWaterfall>;
};

/** Ordering options for ComparedWaterfall connections */
export type ComparedWaterfallOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ComparedWaterfalls. */
  field: ComparedWaterfallOrderField;
};

/** Properties by which ComparedWaterfall connections can be ordered. */
export enum ComparedWaterfallOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * ComparedWaterfallWhereInput is used for filtering ComparedWaterfall objects.
 * Input was generated by ent.
 */
export type ComparedWaterfallWhereInput = {
  and?: InputMaybe<Array<ComparedWaterfallWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** first_death_year field predicates */
  firstDeathYear?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearGT?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearGTE?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  firstDeathYearLT?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearLTE?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** estate_waterfall edge predicates */
  hasEstateWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasEstateWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** growth_profile edge predicates */
  hasGrowthProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrowthProfileWith?: InputMaybe<Array<GrowthProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ComparedWaterfallWhereInput>;
  or?: InputMaybe<Array<ComparedWaterfallWhereInput>>;
  /** second_death_year field predicates */
  secondDeathYear?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearGT?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearGTE?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  secondDeathYearLT?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearLTE?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type CompleteFormSubmissionInput = {
  id: Scalars['ID']['input'];
};

export type CompletedEstateInsightsPage = Node & {
  __typename?: 'CompletedEstateInsightsPage';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The presentation page that this estate insight page is part of */
  presentationPage?: Maybe<PresentationPage>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type CompletedEstateInsightsPageConnection = {
  __typename?: 'CompletedEstateInsightsPageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CompletedEstateInsightsPageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CompletedEstateInsightsPageEdge = {
  __typename?: 'CompletedEstateInsightsPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CompletedEstateInsightsPage>;
};

/**
 * Typed content of a CONFIRMATION_MESSAGE — the card a response-gated tool call
 * presents to the user. The markdown summary is carried in Message.content;
 * this type carries the rest of the card. Bound to the Go type
 * messagecontent.ConfirmationMessageContent via gqlgen.yml; stored
 * CMK-encrypted and decrypted by the Message.confirmationContent resolver.
 */
export type ConfirmationMessageContent = {
  __typename?: 'ConfirmationMessageContent';
  /**
   * Final application-record state produced when the user confirms the plan.
   * The client decides how to present and group these domain records.
   */
  applicationRecordChanges?: Maybe<ApplicationRecordChanges>;
  /**
   * Optional bounded structured display data supplied by the tool's presenter
   * (for example the affected suggestions), for richer card rendering than the
   * markdown summary alone.
   */
  details?: Maybe<Scalars['Map']['output']>;
  /** Short heading for the card. */
  title: Scalars['String']['output'];
  /** Nonblocking risks to consider before confirming the proposed action. */
  warnings: Array<ApplicationRecordWarning>;
};

export type ControllingParty = Node & {
  __typename?: 'ControllingParty';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** An edge to the controlling party individual */
  individual?: Maybe<ClientProfile>;
  /** Free-form notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** An edge to the controlling party organization */
  organization?: Maybe<ClientOrganization>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for ControllingParty connections */
export type ControllingPartyOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ControllingParties. */
  field: ControllingPartyOrderField;
};

/** Properties by which ControllingParty connections can be ordered. */
export enum ControllingPartyOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * ControllingPartyWhereInput is used for filtering ControllingParty objects.
 * Input was generated by ent.
 */
export type ControllingPartyWhereInput = {
  and?: InputMaybe<Array<ControllingPartyWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** individual edge predicates */
  hasIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ControllingPartyWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<ControllingPartyWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Conversation = Node & {
  __typename?: 'Conversation';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The document this conversation is about, if applicable */
  document?: Maybe<Document>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The interaction surface or workflow that created this conversation. */
  kind?: Maybe<ConversationKind>;
  messages: MessageConnection;
  /** Conversation-level context captured when the chat was started (e.g. the page URL the user was on). Distinct from the user's first message; set server-side at conversation creation. */
  metadata?: Maybe<ConversationMetadata>;
  /**
   * Research mode for this conversation, derived from the most recent user
   * message that carried a mode. Computed server-side via a resolver (there is no
   * stored column); null when no user message has selected a mode.
   */
  mode?: Maybe<ChatMode>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type ConversationMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessageOrder>>;
  where?: InputMaybe<MessageWhereInput>;
};

/**
 * Conversation-level metadata captured when a household chat is started.
 * Typed and intended to grow over time (e.g. documentID, entityID, assetID).
 * This is distinct from the user's first message.
 */
export type ConversationChatMetadataInput = {
  /** The page/URL the chat was started from. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConversationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConversationEdge = {
  __typename?: 'ConversationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Conversation>;
};

/** ConversationKind is enum for the field kind */
export enum ConversationKind {
  DocumentChat = 'DOCUMENT_CHAT',
  EstateWaterfallChat = 'ESTATE_WATERFALL_CHAT',
  HouseholdChat = 'HOUSEHOLD_CHAT',
  ValidationQuestions = 'VALIDATION_QUESTIONS'
}

/**
 * Conversation-level metadata as stored on a conversation. Bound to the Go type
 * customstruct.ConversationMetadata via gqlgen.yml; the output counterpart of
 * ConversationChatMetadataInput.
 */
export type ConversationMetadata = {
  __typename?: 'ConversationMetadata';
  /** The page/URL the chat was started from. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Ordering options for Conversation connections */
export type ConversationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Conversations. */
  field: ConversationOrderField;
};

/** Properties by which Conversation connections can be ordered. */
export enum ConversationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * ConversationWhereInput is used for filtering Conversation objects.
 * Input was generated by ent.
 */
export type ConversationWhereInput = {
  and?: InputMaybe<Array<ConversationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** messages edge predicates */
  hasMessages?: InputMaybe<Scalars['Boolean']['input']>;
  hasMessagesWith?: InputMaybe<Array<MessageWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<ConversationKind>;
  kindIn?: InputMaybe<Array<ConversationKind>>;
  kindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  kindNEQ?: InputMaybe<ConversationKind>;
  kindNotIn?: InputMaybe<Array<ConversationKind>>;
  kindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ConversationWhereInput>;
  or?: InputMaybe<Array<ConversationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type CoordinateInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CopyDocumentSummaryInput = {
  /** ID of the document the new summary should be attached to. Must belong to householdID. */
  documentID: Scalars['ID']['input'];
  /** ID of the document summary to copy. Must belong to householdID. */
  documentSummaryID: Scalars['ID']['input'];
  /** Household that owns both the source document summary and the target document. */
  householdID: Scalars['ID']['input'];
};

export type CopyMemoInput = {
  /** Household that owns both the source memo and the new copy. */
  householdID: Scalars['ID']['input'];
  /** ID of the memo to copy. Must belong to householdID. */
  memoID: Scalars['ID']['input'];
};

export type CorePlatformEntity = Document | Household | Proposal;

export type CoverPageConfiguration = Node & {
  __typename?: 'CoverPageConfiguration';
  bundle?: Maybe<PresentationBundle>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The custom text to display on the cover page, stored as Markdown. */
  customText?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The title to display on the cover page. */
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type CoverPageConfigurationConnection = {
  __typename?: 'CoverPageConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CoverPageConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CoverPageConfigurationEdge = {
  __typename?: 'CoverPageConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CoverPageConfiguration>;
};

/** Ordering options for CoverPageConfiguration connections */
export type CoverPageConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order CoverPageConfigurations. */
  field: CoverPageConfigurationOrderField;
};

/** Properties by which CoverPageConfiguration connections can be ordered. */
export enum CoverPageConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * CoverPageConfigurationWhereInput is used for filtering CoverPageConfiguration objects.
 * Input was generated by ent.
 */
export type CoverPageConfigurationWhereInput = {
  and?: InputMaybe<Array<CoverPageConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** custom_text field predicates */
  customText?: InputMaybe<Scalars['String']['input']>;
  customTextIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customTextNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<CoverPageConfigurationWhereInput>;
  or?: InputMaybe<Array<CoverPageConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  titleNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateAISuggestionEvidenceInput is used for create AISuggestionEvidence object.
 * Input was generated by ent.
 */
export type CreateAiSuggestionEvidenceInput = {
  fileParagraphIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  kgNodeID?: InputMaybe<Scalars['ID']['input']>;
  suggestionID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateAISuggestionInput is used for create AISuggestion object.
 * Input was generated by ent.
 */
export type CreateAiSuggestionInput = {
  /** Whether the suggestion was accepted or rejected */
  acceptanceStatus?: InputMaybe<AiSuggestionAcceptanceStatus>;
  /** A suggested asset */
  asset?: InputMaybe<AssetSuggestionInput>;
  /** The suggested date the beneficial owners were last updated. This should only be set if the kind is BENEFICIAL_OWNERS_AS_OF_DATE */
  beneficialOwnersAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  /** The suggested tax status for the business entity. This should only be set if the kind is BUSINESS_ENTITY_TAX_STATUS */
  businessEntityTaxStatus?: InputMaybe<AiSuggestionBusinessEntityTaxStatus>;
  clientOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  clientProfileID?: InputMaybe<Scalars['ID']['input']>;
  /** The suggested Crummey withdrawal period (in days). This should only be set if the kind is CRUMMEY_WITHDRAWAL_PERIOD_DAYS. */
  crummeyWithdrawalPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  dispositiveProvisionID?: InputMaybe<Scalars['ID']['input']>;
  /** The suggested DBA name. This should only be set if the kind is DOING_BUSINESS_AS_NAME */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  /** The beneficiary-designation tier (PRIMARY or CONTINGENT) this DP_RECIPIENT_V2 suggestion belongs to. Distinct from dp_death_event: tier expresses primary-vs-contingent within a beneficiary designation group, while dp_death_event expresses which death triggers the disposition. Set only for suggestions whose target is a retirement / directly-held-insurance account; nil for all other DP suggestions. */
  dpBeneficiaryDesignationTier?: InputMaybe<AiSuggestionBeneficiaryDesignationTier>;
  /** The death event that triggers the disposition, given that the selected grantor dies first. This is separated out from the DispositiveProvisionRecipientSuggestion object because we want users to have the flexibility of moving all the DP's (and/or suggested DP's) from one death event to another on the form. This should only be set if the kind is DP_DEATH_EVENT_GRANTOR_[1,2]_DIES_FIRST */
  dpDeathEvent?: InputMaybe<AiSuggestionDispositiveProvisionDeathEvent>;
  dpFirstDeathGrantorClientProfileID?: InputMaybe<Scalars['ID']['input']>;
  /** A suggested DP recipient. This should only be set if the kind is DP_RECIPIENT_GRANTOR_[1,2]_DIES_FIRST, or DP_RECIPIENT_TESTAMENTARY_ENTITY */
  dpRecipient?: InputMaybe<DispositiveProvisionRecipientSuggestionInput>;
  dpRecipientKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The kind of the target for DP V2 suggestions. This should only be set if the kind is DP_RECIPIENT_V2. */
  dpTargetKind?: InputMaybe<AiSuggestionDpTargetKind>;
  dpTargetNodeID?: InputMaybe<Scalars['ID']['input']>;
  /** The suggested effective date of the entity. This should only be set if the kind is EFFECTIVE_DATE. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  evidenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileID?: InputMaybe<Scalars['ID']['input']>;
  /** The suggested FinCEN ID for the business entity. This should only be set if the kind is FINCEN_ID */
  fincenID?: InputMaybe<Scalars['String']['input']>;
  /** The suggested GST status of the entity. This should only be set if the kind is GST_STATUS. */
  gstStatus?: InputMaybe<AiSuggestionEntityGstStatus>;
  /** Only relevant if the suggestion is for a grantor/trustee/trustAdvisor/beneficiary. This indicates if the user has gone through the process to attempt to match the suggestion with a client profile/organization row. */
  hasMatched?: InputMaybe<Scalars['Boolean']['input']>;
  householdID: Scalars['ID']['input'];
  /** The suggested jurisdiction (state code) of the entity. This should only be set if the kind is JURISDICTION_STATE_CODE. */
  jurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  kgNodeID?: InputMaybe<Scalars['ID']['input']>;
  kgRootID?: InputMaybe<Scalars['ID']['input']>;
  kgV2StatementIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Indicates the field (or group of fields) the suggestion is for. */
  kind: AiSuggestionKind;
  /** The suggested legal name of the entity. This should only be set if the kind is LEGAL_NAME. */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** A suggested liability */
  liability?: InputMaybe<LiabilitySuggestionInput>;
  /** A suggested life insurance */
  lifeInsurance?: InputMaybe<LifeInsuranceSuggestionInput>;
  onboardedEntityID?: InputMaybe<Scalars['ID']['input']>;
  onboardedIndividualID?: InputMaybe<Scalars['ID']['input']>;
  onboardedOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  onboardedTestamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
  /** The suggested entity to onboard. This should only be set if the kind is ONBOARDING_ENTITY */
  onboardingEntity?: InputMaybe<OnboardingEntitySuggestionInput>;
  /** The suggested person to onboard. This should only be set if the kind is ONBOARDING_INDIVIDUAL */
  onboardingIndividual?: InputMaybe<OnboardingIndividualSuggestionInput>;
  /** The suggested organization to onboard. This should only be set if the kind is ONBOARDING_ORGANIZATION */
  onboardingOrganization?: InputMaybe<OnboardingOrganizationSuggestionInput>;
  /** The suggested testamentary entity to onboard. This should only be set if the kind is ONBOARDING_TESTAMENTARY_ENTITY */
  onboardingTestamentaryEntity?: InputMaybe<OnboardingTestamentaryEntitySuggestionInput>;
  onboardingTestamentaryParentKgV2NodeID?: InputMaybe<Scalars['ID']['input']>;
  ownedOnboardedEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  potentialClientOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  potentialClientProfileID?: InputMaybe<Scalars['ID']['input']>;
  potentialEntityID?: InputMaybe<Scalars['ID']['input']>;
  potentialTestamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
  referenceAiOnboardingSuggestionID?: InputMaybe<Scalars['ID']['input']>;
  referencedBySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The suggested GST status of the sub-trust. This should only be set if the kind is SUBTRUST_GST_STATUS. */
  subtrustGstStatus?: InputMaybe<AiSuggestionEntityGstStatus>;
  /** The suggested type of the sub-trust. This should only be set if the kind is SUBTRUST_TYPE. */
  subtrustType?: InputMaybe<AiSuggestionTestamentaryEntityKind>;
  suggestionKgRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The suggested tax ID (EIN) for the business entity. This should only be set if the kind is TAX_ID */
  taxID?: InputMaybe<Scalars['String']['input']>;
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
  /** The version of the suggestion pipeline that produced this record. 1 = v1 (document inference), 2 = v2 (KG V2). */
  version?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreateAccessAgeParameterInput is used for create AccessAgeParameter object.
 * Input was generated by ent.
 */
export type CreateAccessAgeParameterInput = {
  accessParameterID?: InputMaybe<Scalars['ID']['input']>;
  /** The end of the age requirement for this distribution */
  ageRequirementEnd?: InputMaybe<Scalars['Int']['input']>;
  /** The start of the age requirement for this distribution */
  ageRequirementStart?: InputMaybe<Scalars['Int']['input']>;
  householdID: Scalars['ID']['input'];
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateAccessParameterInput is used for create AccessParameter object.
 * Input was generated by ent.
 */
export type CreateAccessParameterInput = {
  accessAgeParameterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The amount of access, as a dollar value. Valid when kind is AMOUNT or TRUST_INCOME */
  amount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  beneficiaryID?: InputMaybe<Scalars['ID']['input']>;
  /** The frequency of the access */
  frequency?: InputMaybe<AccessParameterFrequency>;
  /** If true, access will grow by the inflation rate specified in the growth profile.Only applicable if the access is kind AMOUNT or TRUST_INCOME. */
  growByInflation?: InputMaybe<Scalars['Boolean']['input']>;
  householdID: Scalars['ID']['input'];
  /** The kind of access parameter */
  kind: AccessParameterKind;
  /** The percentage of access. Valid when kind is PERCENTAGE or TRUST_INCOME */
  percentage?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * CreateAccountInput is used for create Account object.
 * Input was generated by ent.
 */
export type CreateAccountInput = {
  displayName: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
  initialValuationID?: InputMaybe<Scalars['ID']['input']>;
  valuationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateActiveEstateInsightsPageInput is used for create ActiveEstateInsightsPage object.
 * Input was generated by ent.
 */
export type CreateActiveEstateInsightsPageInput = {
  householdID: Scalars['ID']['input'];
  presentationPageID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateAddressInput is used for create Address object.
 * Input was generated by ent.
 */
export type CreateAddressInput = {
  cityName?: InputMaybe<Scalars['String']['input']>;
  clientProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Whether the individual at this address resides outside the United States. */
  residesOutsideUnitedStates?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode: Scalars['String']['input'];
  streetLineOne?: InputMaybe<Scalars['String']['input']>;
  streetLineTwo?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateAssetClassInput is used for create AssetClass object.
 * Input was generated by ent.
 */
export type CreateAssetClassInput = {
  balanceSheetCategoryID?: InputMaybe<Scalars['ID']['input']>;
  displayName: Scalars['String']['input'];
  /** The defined growth rate for the asset class */
  growthRate?: InputMaybe<Scalars['Percent']['input']>;
  integrationAssetClassIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether this class is considered real or tangible personal property */
  isRealTpp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is a system class that cannot be deleted, renamed, or have liquidity status changed */
  isSystemClass?: InputMaybe<Scalars['Boolean']['input']>;
  liquidityStatus: AssetClassLiquidityStatus;
  /** The order in which this asset class should be displayed in the UI */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The share of annual return paid as income tax when a growth profile uses asset-category defaults */
  taxDragRate?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * CreateAssetGroupInput is used for create AssetGroup object.
 * Input was generated by ent.
 */
export type CreateAssetGroupInput = {
  assetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  childIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  dispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  integrationID?: InputMaybe<Scalars['String']['input']>;
  integrationKind?: InputMaybe<IntegrationExternalKind>;
  name: Scalars['String']['input'];
  parentID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateAssetStaticInput is used for create AssetStatic object.
 * Input was generated by ent.
 */
export type CreateAssetStaticInput = {
  assetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  dispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityID: Scalars['ID']['input'];
  groupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  integrationID?: InputMaybe<Scalars['String']['input']>;
  integrationKind?: InputMaybe<IntegrationExternalKind>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  taxSitusGrantorID?: InputMaybe<Scalars['ID']['input']>;
  taxSitusKind?: InputMaybe<AssetTaxSitusKind>;
  taxSitusStateCode?: InputMaybe<StateCode>;
};

/**
 * CreateAssetV2Input is used for create AssetV2 object.
 * Input was generated by ent.
 */
export type CreateAssetV2Input = {
  /** The name of the account that this asset is part of. */
  accountName?: InputMaybe<Scalars['String']['input']>;
  assetStaticID?: InputMaybe<Scalars['ID']['input']>;
  classID: Scalars['ID']['input'];
  displayName: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
  /** The entity ID of the integrated account that this asset is part of. */
  integratedAccountID?: InputMaybe<Scalars['Int']['input']>;
  /** The integration this asset was ingested as part of. */
  integrationType?: InputMaybe<AssetV2IntegrationType>;
  kgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownedValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  qsbsEligibility?: InputMaybe<AssetV2QsbsEligibility>;
  valuationID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateAssetValuationV2Input is used for create AssetValuationV2 object.
 * Input was generated by ent.
 */
export type CreateAssetValuationV2Input = {
  accountID?: InputMaybe<Scalars['ID']['input']>;
  /** Free-form notes */
  description?: InputMaybe<Scalars['String']['input']>;
  documentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  effectiveDate: Scalars['Time']['input'];
  /**
   * Valuations can work in two ways.
   * The first is manually specifying all the assets+values for a valuation; we tally them up.
   * The second is by specifying a valuation_amount.
   * If a valuation amount is present, we use this to compute the value of a valuation
   * and ignore the value of underlying assets, etc.
   */
  fixedValuationAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  householdID: Scalars['ID']['input'];
  valuationReason?: InputMaybe<AssetValuationV2ValuationReason>;
  valuationSource?: InputMaybe<AssetValuationV2ValuationSource>;
};

/**
 * CreateAssetValueV2Input is used for create AssetValueV2 object.
 * Input was generated by ent.
 */
export type CreateAssetValueV2Input = {
  assetID?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  ownedPercent?: InputMaybe<Scalars['Percent']['input']>;
  ownedValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ownershipType: AssetValueV2OwnershipType;
  shareCount?: InputMaybe<Scalars['Decimal']['input']>;
  shareValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  totalValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
};

/**
 * CreateBalanceSheetBundleConfigurationInput is used for create BalanceSheetBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateBalanceSheetBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** The order that columns should show up */
  columnOrder: Array<Scalars['String']['input']>;
  /** The display name for the bundle. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Column IDs that should be hidden from the balance sheet display */
  hiddenColumns: Array<Scalars['String']['input']>;
  /** Whether to hide small values on the balance sheet */
  hideSmallValues?: InputMaybe<Scalars['Boolean']['input']>;
  householdID: Scalars['ID']['input'];
  /** When true, life insurance death benefit drives balance sheet totals and summary metrics; when false, cash value does */
  includeDeathBenefitInTotals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include a separate expanded asset categories slide in the bundle */
  includeExpandedAssetCategoriesSlide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include a full export slide that is not confined to standard page dimensions */
  includeExportSlide?: InputMaybe<Scalars['Boolean']['input']>;
  pageID?: InputMaybe<Scalars['ID']['input']>;
  /** Whether to separate directly held assets in the estate into client 1/client 2/joint */
  separateInEstateDirectlyHeld?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show separate columns for trusts that are in the estate */
  separateInEstateTrusts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show separate columns for trusts that are out of the estate */
  separateOutOfEstateTrusts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show expanded asset categories on the balance sheet */
  showExpandedAssetCategories?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show assets in the estate */
  showInEstate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show assets out of the estate */
  showOutOfEstate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to display summary metrics at the top of the balance sheet */
  showSummaryMetrics?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateBalanceSheetCategoryInput is used for create BalanceSheetCategory object.
 * Input was generated by ent.
 */
export type CreateBalanceSheetCategoryInput = {
  assetClassIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  displayName: Scalars['String']['input'];
  /** Whether this is a system category that cannot be deleted */
  isSystemCategory?: InputMaybe<Scalars['Boolean']['input']>;
  /** The order in which this balance sheet category should be displayed in the UI */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<BalanceSheetCategoryType>;
};

/**
 * CreateBeneficiariesBundleConfigurationInput is used for create BeneficiariesBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateBeneficiariesBundleConfigurationInput = {
  /** Used in beneficiary reporting to calculate non-quantifiable accessto a single entity across multiple beneficiaries. */
  beneficiaryAccessCalcMethod?: InputMaybe<BeneficiariesBundleConfigurationBeneficiaryAccessCalcMethod>;
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name for the bundle. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  estateWaterfallID?: InputMaybe<Scalars['ID']['input']>;
  /** The year of the first death in the beneficiaries bundle. */
  firstDeathYear?: InputMaybe<Scalars['Int']['input']>;
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  householdOverviewOrganizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdOverviewProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If true, include the detailed breakdown in each individual report alongside the chart in individual_overview_profiles and individual_overview_organizations */
  includeDetailedBreakdownsInIndividualOverviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, include a household-level slide that compares the beneficiaries in household_overview_profiles and household_overview_organizations */
  includeHouseholdOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, include a chart for each profile and organization in individual_overview_profiles and individual_overview_organizations */
  includeIndividualOverviews?: InputMaybe<Scalars['Boolean']['input']>;
  individualOverviewOrganizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  individualOverviewProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The year of the second death in the beneficiaries bundle. */
  secondDeathYear?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreateBeneficiariesTemplateBundleConfigurationInput is used for create BeneficiariesTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateBeneficiariesTemplateBundleConfigurationInput = {
  /** If true, includes the household overview slide in the beneficiaries bundle. */
  includeHouseholdOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the individual overview slides in the beneficiaries bundle. */
  includeIndividualOverviews?: InputMaybe<Scalars['Boolean']['input']>;
  templateBundleID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateBeneficiaryAccessParameterInput is used for create BeneficiaryAccessParameter object.
 * Input was generated by ent.
 */
export type CreateBeneficiaryAccessParameterInput = {
  /** Notes for when age is an access parameter */
  accessParameterAgeNote?: InputMaybe<Scalars['String']['input']>;
  /** Notes for when other is an access parameter */
  accessParameterOtherNote?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  /** The kind of distribution parameter */
  kind: BeneficiaryAccessParameterKind;
};

/**
 * CreateBeneficiaryDesignationGroupInput is used for create BeneficiaryDesignationGroup object.
 * Input was generated by ent.
 */
export type CreateBeneficiaryDesignationGroupInput = {
  associatedHypotheticalWaterfallID?: InputMaybe<Scalars['ID']['input']>;
  dispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  hypotheticalInsurancePersonalAccountID?: InputMaybe<Scalars['ID']['input']>;
  hypotheticalRetirementPersonalAccountID?: InputMaybe<Scalars['ID']['input']>;
  insurancePersonalAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** if true, the residuary recipient(s) for this group's tier pays taxes by default. if false, each recipient's bearsTax field can be configured separately */
  residuaryPaysAllTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  retirementPersonalAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Whether this group represents primary or contingent beneficiaries on the account. */
  tier: BeneficiaryDesignationTier;
};

/**
 * CreateBeneficiaryDistributionInput is used for create BeneficiaryDistribution object.
 * Input was generated by ent.
 */
export type CreateBeneficiaryDistributionInput = {
  beneficiaryID?: InputMaybe<Scalars['ID']['input']>;
  /** The AMOUNT kind of distribution. Only valid when distribution_kind is AMOUNT */
  distributionAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The frequency of the distribution to beneficiaries */
  distributionFrequency?: InputMaybe<BeneficiaryDistributionDistributionFrequency>;
  /** The kind of distribution for this beneficiary */
  distributionKind: BeneficiaryDistributionDistributionKind;
  distributionParameter?: InputMaybe<BeneficiaryDistributionDistributionParameter>;
  distributionParameterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The age at which the beneficiary will receive the distribution. Only valid when distribution_parameter is UPON_REACHING_AGE */
  distributionParameterUponReachingAge?: InputMaybe<Scalars['Int']['input']>;
  /** The percentage of the distribution. Only valid when distribution_kind is PERCENTAGE */
  distributionPercentage?: InputMaybe<Scalars['Percent']['input']>;
  householdID: Scalars['ID']['input'];
};

/**
 * CreateBeneficiaryDistributionParameterInput is used for create BeneficiaryDistributionParameter object.
 * Input was generated by ent.
 */
export type CreateBeneficiaryDistributionParameterInput = {
  householdID: Scalars['ID']['input'];
  /** The kind of distribution parameter for this distribution */
  kind: BeneficiaryDistributionParameterKind;
};

/**
 * CreateBeneficiaryInput is used for create Beneficiary object.
 * Input was generated by ent.
 */
export type CreateBeneficiaryInput = {
  accessParameterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryGratID?: InputMaybe<Scalars['ID']['input']>;
  distributionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  individualID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The kind of beneficiary. Tells us which edge to traverse.
   *       In the case of SURVIVING_SPOUSE, no edge will be set and the beneficiary will be dynamically set to the surviving spouse in the household.
   */
  kind?: InputMaybe<BeneficiaryKind>;
  level?: InputMaybe<BeneficiaryLevel>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  powerOfAppointmentID?: InputMaybe<Scalars['ID']['input']>;
  scheduledDistributionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateBeneficiaryPageInput is used for create BeneficiaryPage object.
 * Input was generated by ent.
 */
export type CreateBeneficiaryPageInput = {
  /** The ID of the beneficiary to display - either a client profile or client organization. */
  beneficiaryID: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
};

/**
 * CreateBeneficiaryPowerOfAppointmentInput is used for create BeneficiaryPowerOfAppointment object.
 * Input was generated by ent.
 */
export type CreateBeneficiaryPowerOfAppointmentInput = {
  beneficiaryID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** The power of appointment for the beneficiary */
  power?: InputMaybe<BeneficiaryPowerOfAppointmentPower>;
  /** Notes for when other is an access parameter */
  powerOtherNote?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateCCorpBusinessEntityInput is used for create CCorpBusinessEntity object.
 * Input was generated by ent.
 */
export type CreateCCorpBusinessEntityInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this business entity */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  keyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Ownership as-of date. */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
};

/**
 * CreateCLTProposalInput is used for create CLTProposal object.
 * Input was generated by ent.
 */
export type CreateCltProposalInput = {
  /** The amount of the annuity payout. Only valid when payout_kind is ANNUITY */
  annuityPayoutAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The cost basis of assets proposed to be transferred to this CRT */
  assetCostBasis: Scalars['CurrencyUSD']['input'];
  /** Notes about the assets proposed to be transferred to this CRT */
  assetNotes?: InputMaybe<Scalars['String']['input']>;
  /** The total value of assets proposed to be transferred to this CRT */
  assetValue: Scalars['CurrencyUSD']['input'];
  calculationMethod?: InputMaybe<CharitableTrustCalculationMethod>;
  charitableIncomeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  donorIDs: Array<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  optimizationTarget?: InputMaybe<CharitableTrustOptimizationTarget>;
  /** The frequency of payouts for this charitable trust. */
  payoutFrequency?: InputMaybe<CharitableTrustPayoutFrequency>;
  payoutKind: CharitableTrustPayoutKind;
  /** The high end of the pre-tax return percentage assumption */
  preTaxReturnPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  /** The low end of the pre-tax return assumption */
  preTaxReturnPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  /** The medium pre-tax return percentage assumption */
  preTaxReturnPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  rate7520?: InputMaybe<Scalars['Percent']['input']>;
  remainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The associated tax drag for the high pre-tax return */
  taxDragPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  /** The associated tax drag for the low pre-tax return */
  taxDragPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  /** The associated tax drag for the medium pre-tax return */
  taxDragPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  /** Tax status for this trust */
  taxStatus: TrustTaxStatus;
  termKind: CharitableTrustTermKind;
  /** The number of years the CRT will pay out for. Only valid if term_kind is FIXED */
  termYears: Scalars['Int']['input'];
  /** The kind of unitrust. Only valid when payout_kind is UNITRUST; ignored otherwise. */
  unitrustKind?: InputMaybe<CharitableTrustUnitrustKind>;
  /** The percent of the unitrust payout. Only valid when payout_kind is UNITRUST */
  unitrustPayoutPercent?: InputMaybe<Scalars['Percent']['input']>;
  /** This is the year of analysis. If not specified, it will either default to the actuarial tables or the term_years */
  yearOfAnalysis?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreateCLTTrustInput is used for create CLTTrust object.
 * Input was generated by ent.
 */
export type CreateCltTrustInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Taxable deduction that was recorded for funding this CLT */
  charitableDeduction?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  grantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  lifetimeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  officialInterestRatePercent?: InputMaybe<Scalars['Percent']['input']>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  remainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  successorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  /** If true, term_duration_years will be ignored */
  termDurationLifetime?: InputMaybe<Scalars['Boolean']['input']>;
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  terminationDate?: InputMaybe<Scalars['Time']['input']>;
  trustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateCRTProposalInput is used for create CRTProposal object.
 * Input was generated by ent.
 */
export type CreateCrtProposalInput = {
  /** The amount of the annuity payout. Only valid when payout_kind is ANNUITY */
  annuityPayoutAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The cost basis of assets proposed to be transferred to this CRT */
  assetCostBasis: Scalars['CurrencyUSD']['input'];
  /** Notes about the assets proposed to be transferred to this CRT */
  assetNotes?: InputMaybe<Scalars['String']['input']>;
  /** The total value of assets proposed to be transferred to this CRT */
  assetValue: Scalars['CurrencyUSD']['input'];
  calculationMethod?: InputMaybe<CharitableTrustCalculationMethod>;
  charitableRemainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  donorIDs: Array<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  incomeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  optimizationTarget?: InputMaybe<CharitableTrustOptimizationTarget>;
  /** The frequency of payouts for this charitable trust. */
  payoutFrequency?: InputMaybe<CharitableTrustPayoutFrequency>;
  payoutKind: CharitableTrustPayoutKind;
  /** The high end of the pre-tax return percentage assumption */
  preTaxReturnPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  /** The low end of the pre-tax return assumption */
  preTaxReturnPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  /** The medium pre-tax return percentage assumption */
  preTaxReturnPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  rate7520?: InputMaybe<Scalars['Percent']['input']>;
  /** The associated tax drag for the high pre-tax return */
  taxDragPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  /** The associated tax drag for the low pre-tax return */
  taxDragPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  /** The associated tax drag for the medium pre-tax return */
  taxDragPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  termKind: CharitableTrustTermKind;
  /** The number of years the CRT will pay out for. Only valid if term_kind is FIXED; ignored otherwise. */
  termYears: Scalars['Int']['input'];
  /** The kind of unitrust. Only valid when payout_kind is UNITRUST; ignored otherwise. */
  unitrustKind?: InputMaybe<CharitableTrustUnitrustKind>;
  /** The percent of the unitrust payout. Only valid when payout_kind is UNITRUST */
  unitrustPayoutPercent?: InputMaybe<Scalars['Percent']['input']>;
  /** This is the year of analysis. If not specified, it will either default to the actuarial tables or the term_years */
  yearOfAnalysis?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreateCRTTrustInput is used for create CRTTrust object.
 * Input was generated by ent.
 */
export type CreateCrtTrustInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Taxable deduction that was recorded for funding this CRT */
  charitableDeduction?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  grantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  lifetimeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  officialInterestRatePercent?: InputMaybe<Scalars['Percent']['input']>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  remainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  successorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  /** If true, term_duration_years will be ignored */
  termDurationLifetime?: InputMaybe<Scalars['Boolean']['input']>;
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  terminationDate?: InputMaybe<Scalars['Time']['input']>;
  trustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateCashflowInput is used for create Cashflow object.
 * Input was generated by ent.
 */
export type CreateCashflowInput = {
  /** This dynamically sets the end date of this transfer to the year when both individuals die. It superceeds end_year and end_at_clients_death. Ignored if start_year is not set.  */
  afterBothDeaths?: InputMaybe<Scalars['Boolean']['input']>;
  displayName: Scalars['String']['input'];
  endAtClientsDeathID?: InputMaybe<Scalars['ID']['input']>;
  /** The year this transfer ends. Ignored if start_year is not set. */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** The yearly growth percent of this transfer. Can be negative. Only valid when kind is AMOUNT */
  growthPercent?: InputMaybe<Scalars['Percent']['input']>;
  householdID: Scalars['ID']['input'];
  individualID?: InputMaybe<Scalars['ID']['input']>;
  integrationCashflowID?: InputMaybe<Scalars['ID']['input']>;
  /** The year this transfer starts. If start_year is not set, it is assumed to be a one time transfer happening in the current year. If start_year is set, this is a yearly recurring transfer until end_year is reached. */
  startYear?: InputMaybe<Scalars['Int']['input']>;
  /** The percentage of the transfer. Positive for income, negative for expense. Only valid when kind is PERCENTAGE */
  transferPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** Value of this transfer. Positive for income, negative for expense. Only valid when kind is AMOUNT */
  transferValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
};

/**
 * CreateClientOrganizationInput is used for create ClientOrganization object.
 * Input was generated by ent.
 */
export type CreateClientOrganizationInput = {
  addressID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  kgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  kind?: InputMaybe<ClientOrganizationKind>;
  name: Scalars['String']['input'];
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  onboardedOrganizationSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  pointOfContactEmail?: InputMaybe<Scalars['String']['input']>;
  pointOfContactLastName?: InputMaybe<Scalars['String']['input']>;
  pointOfContactName?: InputMaybe<Scalars['String']['input']>;
  pointOfContactPhone?: InputMaybe<Scalars['String']['input']>;
  potentialClientOrganizationSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  professionalTeamRoleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  suggestedClientOrganizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateClientPresentationV2Input is used for create ClientPresentationV2 object.
 * Input was generated by ent.
 */
export type CreateClientPresentationV2Input = {
  bundleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumberToStartFrom?: InputMaybe<Scalars['Int']['input']>;
  showClientNamesInHeader?: InputMaybe<Scalars['Boolean']['input']>;
  showLegalDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  showPageNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  showPageNumbersOnCoverSlide?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateClientProfileInput is used for create ClientProfile object.
 * Input was generated by ent.
 */
export type CreateClientProfileInput = {
  address?: InputMaybe<CreateAddressInput>;
  addressID?: InputMaybe<Scalars['ID']['input']>;
  cashflowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateOfBirth?: InputMaybe<Scalars['Time']['input']>;
  dateOfDeath?: InputMaybe<Scalars['Time']['input']>;
  /** Controls which name parts appear in the client profile display name. */
  displayNamePattern?: InputMaybe<ClientProfileDisplayNamePattern>;
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  dsueID?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  estateWaterfallFilterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Customer-supplied identifier from an external system. Unique per tenant when set. */
  externalID?: InputMaybe<Scalars['String']['input']>;
  familyTreeNodeSettingsID?: InputMaybe<Scalars['ID']['input']>;
  firstName: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  integrationPersonID?: InputMaybe<Scalars['ID']['input']>;
  /** Whether this client profile is deceased. */
  isDeceased?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this client profile should be an eligible grantor/owner/other principal for entities. */
  isGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this client_profile is one of the (at most) two primary clients on this household. */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  kgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastName: Scalars['String']['input'];
  lifetimeExclusionEventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  missingDocumentOverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  onboardedIndividualSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownedOwnershipStakeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Used in beneficiary reporting to adjust beneficiary totalswith distributions made in the past */
  pastDistributions?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  potentialClientProfileSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  professionalTeamRoleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  relationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  suggestedClientProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  testamentaryEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateClientProfileRelationshipInput is used for create ClientProfileRelationship object.
 * Input was generated by ent.
 */
export type CreateClientProfileRelationshipInput = {
  fromClientProfileID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  toClientProfileID: Scalars['ID']['input'];
  /** the relationship between the 'from' ClientProfile and the 'to' ClientProfile */
  type: ClientProfileRelationshipType;
};

export type CreateClientProfileWithDetailsInput = {
  clientProfile: CreateClientProfileInput;
  relationships?: InputMaybe<Array<CreateNewClientProfileRelationshipInput>>;
};

/**
 * CreateCollaboratorInput is used for create Collaborator object.
 * Input was generated by ent.
 */
export type CreateCollaboratorInput = {
  firstName: Scalars['String']['input'];
  householdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The role of the collaborator, for display purposes only */
  kind?: InputMaybe<CollaboratorKind>;
  lastName: Scalars['String']['input'];
  /** The timestamp when the collaborator last viewed the notifications list */
  lastViewedNotificationsListAt?: InputMaybe<Scalars['Time']['input']>;
  /** The name of the organization this collaborator works for */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  roleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The professional title of the collaborator, e.g. 'Associate' */
  title?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCollaboratorWithEmailInput = {
  create: CreateCollaboratorInput;
  email: Scalars['String']['input'];
};

/**
 * CreateComparedWaterfallInput is used for create ComparedWaterfall object.
 * Input was generated by ent.
 */
export type CreateComparedWaterfallInput = {
  /** The display name for the compared waterfall. */
  displayName: Scalars['String']['input'];
  estateWaterfallID?: InputMaybe<Scalars['ID']['input']>;
  /** The year of the first death in the compared waterfall. */
  firstDeathYear?: InputMaybe<Scalars['Int']['input']>;
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** The year of the second death in the compared waterfall. */
  secondDeathYear?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreateCompletedEstateInsightsPageInput is used for create CompletedEstateInsightsPage object.
 * Input was generated by ent.
 */
export type CreateCompletedEstateInsightsPageInput = {
  householdID: Scalars['ID']['input'];
  presentationPageID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateControllingPartyInput is used for create ControllingParty object.
 * Input was generated by ent.
 */
export type CreateControllingPartyInput = {
  householdID: Scalars['ID']['input'];
  individualID?: InputMaybe<Scalars['ID']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateCoverPageConfigurationInput is used for create CoverPageConfiguration object.
 * Input was generated by ent.
 */
export type CreateCoverPageConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** The custom text to display on the cover page, stored as Markdown. */
  customText?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  /** The title to display on the cover page. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateCustodialPersonalAccountInput is used for create CustodialPersonalAccount object.
 * Input was generated by ent.
 */
export type CreateCustodialPersonalAccountInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  controllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
};

/**
 * CreateDSUEPortabilityInput is used for create DSUEPortability object.
 * Input was generated by ent.
 */
export type CreateDsuePortabilityInput = {
  /** The amount of DSUE ported to the recipient */
  amount: Scalars['CurrencyUSD']['input'];
  documentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The date of when the DSUE was recorded */
  eventDate: Scalars['Time']['input'];
  householdID: Scalars['ID']['input'];
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  recipientID: Scalars['ID']['input'];
};

/**
 * CreateDispositionScenarioInput is used for create DispositionScenario object.
 * Input was generated by ent.
 */
export type CreateDispositionScenarioInput = {
  associatedHypotheticalWaterfallID?: InputMaybe<Scalars['ID']['input']>;
  dispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  dispositiveProvisionsTemplateID?: InputMaybe<Scalars['ID']['input']>;
  /** if true, the residuary recipient(s) for this death order pays taxes by default. if false, each recipient's bearsTax field can be configured separately */
  firstDeathResiduaryPaysAllTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  firstGrantorDeathID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  jointAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** The time at which the scenario was last reviewed. This can be used to indicate that a user has looked at these provisions and they are correct, even if they are empty. */
  reviewedAt?: InputMaybe<Scalars['Time']['input']>;
  secondDeathDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  secondDeathDispositiveProvisionsTemplateID?: InputMaybe<Scalars['ID']['input']>;
  /** if true, the residuary recipient(s) for this death order pays taxes by default. if false, each recipient's bearsTax field can be configured separately */
  secondDeathResiduaryPaysAllTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** How the transfer is made to the recipient. IN_KIND preserves the asset thus keeping the source asset growth characteristics, LIQUIDATE_TO_CASH sells the asset thus gaining the destination asset growth characteristics. */
  transferMethod?: InputMaybe<TransferMethod>;
};

/**
 * CreateDispositiveProvisionInput is used for create DispositiveProvision object.
 * Input was generated by ent.
 */
export type CreateDispositiveProvisionInput = {
  assetGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetStaticIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  associatedHypotheticalWaterfallID?: InputMaybe<Scalars['ID']['input']>;
  /** If true, the disposition will bear (pay) taxes. */
  bearsTax?: InputMaybe<Scalars['Boolean']['input']>;
  /** The AMOUNT kind of disposition. Only valid when disposition_kind is AMOUNT */
  dispositionAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The percentage of the disposition. Only valid when disposition_kind is formulaic */
  dispositionFormulaicPercentage?: InputMaybe<Scalars['Percent']['input']>;
  dispositionKind: DispositiveProvisionDispositionKind;
  /** If set, the disposition will be no more than the set amount.Only applicable if the disposition is not kind AMOUNT. */
  dispositionLimit?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The order of the disposition in the list of dispositions */
  dispositionOrder: Scalars['Int']['input'];
  /** The percentage of the disposition. Only valid when disposition_kind is PERCENTAGE */
  dispositionPercentage?: InputMaybe<Scalars['Percent']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** If true, the disposition amount will be grossed up to try and make disposition_amount the post-tax amount. This is only valid when disposition_kind is AMOUNT. */
  grossUpDispositionAmount?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the disposition will grow by the inflation rate specified in the growth profile.Only applicable if the disposition is kind AMOUNT. */
  growByInflation?: InputMaybe<Scalars['Boolean']['input']>;
  householdID: Scalars['ID']['input'];
  individualID?: InputMaybe<Scalars['ID']['input']>;
  insurancePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  ownershipStakeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The kind of recpient. Tells us which edge to traverse.
   *       In the case of SURVIVING_SPOUSE, no edge will be set and the recipient will be dynamically set to the surviving spouse in the household.
   */
  recipientKind?: InputMaybe<DispositiveProvisionRecipientKind>;
  suggestedDpRecipientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
  /** How the transfer is made to the recipient.IN_KIND preserves the asset thus keeping the source asset growth characteristics,LIQUIDATE_TO_CASH sells the asset thus gaining the destination asset growth characteristics.The default is IN_KIND. */
  transferMethod?: InputMaybe<TransferMethod>;
  transferTaxKind: DispositiveProvisionTransferTaxKind;
};

/**
 * CreateDispositiveProvisionTemplateInput is used for create DispositiveProvisionTemplate object.
 * Input was generated by ent.
 */
export type CreateDispositiveProvisionTemplateInput = {
  /** The name of the template */
  displayName: Scalars['String']['input'];
  dispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** The kind of dispositive provision tempalte */
  kind?: InputMaybe<DispositiveProvisionTemplateKind>;
  /** If true, disposition amounts will be sourced from the total sum of all entities linked to this template.Otherwise amounts will be sourced from each entity linked. */
  proRata?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the residuary pays all taxes; only applies to DEFAULT kinds */
  residuaryPaysAllTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** The sub kind of dispositive provision tempalte */
  subKind?: InputMaybe<DispositiveProvisionTemplateSubKind>;
};

/**
 * CreateDividerBundleConfigurationInput is used for create DividerBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateDividerBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** The content of the divider page, rendered as Markdown. */
  customContent?: InputMaybe<Scalars['String']['input']>;
  /** The title displayed on the divider page. */
  dividerTitle?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
};

/**
 * CreateDividerTemplateBundleConfigurationInput is used for create DividerTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateDividerTemplateBundleConfigurationInput = {
  /** The content of the divider page, rendered as Markdown. */
  customContent?: InputMaybe<Scalars['String']['input']>;
  /** The title displayed on the divider page. */
  dividerTitle?: InputMaybe<Scalars['String']['input']>;
  templateBundleID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateDocumentInput is used for create Document object.
 * Input was generated by ent.
 */
export type CreateDocumentInput = {
  additionalEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  additionalTestamentaryEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The precedence that the suggestions from this document should take when extracting data. If this is not explicitly set, suggestions order will be inferred by uploaded date (most recent first). Only applicable for documents associated with entities. */
  aiSuggestionOrder?: InputMaybe<Scalars['Int']['input']>;
  clientProfileID?: InputMaybe<Scalars['ID']['input']>;
  conversationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  defaultDocumentOfEntityID?: InputMaybe<Scalars['ID']['input']>;
  dsueIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityDocumentRelationshipIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  estateInsightIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  lifetimeExclusionEventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  loggedTransferIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  memoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  nextVersionID?: InputMaybe<Scalars['ID']['input']>;
  /** The current processing stage or terminal result for this document. */
  parsingStatus?: InputMaybe<DocumentParsingStatus>;
  pdfFileID?: InputMaybe<Scalars['ID']['input']>;
  previousVersionID?: InputMaybe<Scalars['ID']['input']>;
  sourceBinderID?: InputMaybe<Scalars['ID']['input']>;
  splitDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  summaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  type: DocumentType;
  workflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateDocumentQuestionAnswersInput is used for create DocumentQuestionAnswers object.
 * Input was generated by ent.
 */
export type CreateDocumentQuestionAnswersInput = {
  answer: Scalars['String']['input'];
  chain: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
};

/**
 * CreateDocumentQuestionInput is used for create DocumentQuestion object.
 * Input was generated by ent.
 */
export type CreateDocumentQuestionInput = {
  answerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  asyncJobID?: InputMaybe<Scalars['ID']['input']>;
  documentID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  /** Helps us determine how to parse the answer */
  kind?: InputMaybe<DocumentQuestionKind>;
  question: Scalars['String']['input'];
};

/**
 * CreateDocumentSummaryInput is used for create DocumentSummary object.
 * Input was generated by ent.
 */
export type CreateDocumentSummaryInput = {
  /** The user's feedback on the AI-generated summary. Ignore if entry_mode is USER */
  aiSummaryFeedback?: InputMaybe<Scalars['String']['input']>;
  /** The user's rating of the AI-generated summary. Ignore if entry_mode is USER */
  aiSummaryRating?: InputMaybe<DocumentSummaryAiSummaryRating>;
  /** Display name for the document summary. Default: 'Default summary' */
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentv2ID: Scalars['ID']['input'];
  entityNoteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Indicates if the summary content was updated by the user or generated by AI. Default: AI_AUTO */
  entryMode?: InputMaybe<DocumentSummaryEntryMode>;
  feedbackFromID?: InputMaybe<Scalars['ID']['input']>;
  generatedFromPromptID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  presentationPageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The most recently-edited summary for the document */
  summary: Scalars['String']['input'];
  /** The format of the summary string when displaying it to the user on the frontend. Default: MARKDOWN */
  summaryFormat?: InputMaybe<DocumentSummarySummaryFormat>;
  workflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateDocumentSummaryPageInput is used for create DocumentSummaryPage object.
 * Input was generated by ent.
 */
export type CreateDocumentSummaryPageInput = {
  /** The document type for this document summary page. */
  documentType?: InputMaybe<PresentationDocumentType>;
  householdID: Scalars['ID']['input'];
  relevantClientProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  summaryID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateDocumentSummaryPromptInput is used for create DocumentSummaryPrompt object.
 * Input was generated by ent.
 */
export type CreateDocumentSummaryPromptInput = {
  /** Display name for the prompt */
  displayName: Scalars['String']['input'];
  /** The document type this prompt is for */
  documentType: DocumentSummaryPromptDocumentType;
  /** Whether this prompt is the default for the document type; if set to true, clears any other default for the document type */
  isDefaultForDocType: Scalars['Boolean']['input'];
  /** Whether this is a system-provided prompt */
  isSystemPrompt: Scalars['Boolean']['input'];
  /** The prompt content in markdown format. Required for non-system prompts. */
  promptMarkdown?: InputMaybe<Scalars['String']['input']>;
  /** When enabled, this prompt will auto-run for uploads of its document type. */
  shouldAutoRun?: InputMaybe<Scalars['Boolean']['input']>;
  testRunIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When enabled, uses a more capable model to generate the summary. */
  useExtendedThinkingModal?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateDocumentSummaryTemplateBundleConfigurationInput is used for create DocumentSummaryTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateDocumentSummaryTemplateBundleConfigurationInput = {
  /** The document type filter for this document summary bundle. */
  documentType?: InputMaybe<PresentationDocumentType>;
  /** If true, includes document summaries for the first grantor. */
  includeFirstGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes document summaries for the second grantor. */
  includeSecondGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  templateBundleID?: InputMaybe<Scalars['ID']['input']>;
};

/** This input is used to create a document and its relationships with entities. */
export type CreateDocumentWithEntityRelationshipsInput = {
  document: CreateDocumentInput;
  relationships: Array<CreateRelationshipWithEntityInput>;
};

/**
 * CreateDonorAdvisedFundInput is used for create DonorAdvisedFund object.
 * Input was generated by ent.
 */
export type CreateDonorAdvisedFundInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  controllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  donorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
};

/**
 * CreateEmployeeInput is used for create Employee object.
 * Input was generated by ent.
 */
export type CreateEmployeeInput = {
  assignedHouseholdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The user's unique id in their identify provider (automatically mapped as idp_id in WorkOS) */
  idpID?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** The timestamp when the employee last viewed the notifications list */
  lastViewedNotificationsListAt?: InputMaybe<Scalars['Time']['input']>;
  roleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamOwnerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tier?: InputMaybe<EmployeeTier>;
  userID: Scalars['ID']['input'];
};

/**
 * CreateEntitiesOverviewBundleConfigurationEntityInput is used for create EntitiesOverviewBundleConfigurationEntity object.
 * Input was generated by ent.
 */
export type CreateEntitiesOverviewBundleConfigurationEntityInput = {
  entityID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  /** The order of the entity in the bundle. */
  index: Scalars['Int']['input'];
  /** If true, the entity is hidden in the bundle. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateEntitiesOverviewBundleConfigurationInput is used for create EntitiesOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateEntitiesOverviewBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name for the bundle. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  /** If true, shows summary metrics in the bundle. */
  showSummaryMetrics?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateEntityDiagramInput is used for create EntityDiagram object.
 * Input was generated by ent.
 */
export type CreateEntityDiagramInput = {
  entityID: Scalars['ID']['input'];
  firstGrantorDeathID?: InputMaybe<Scalars['ID']['input']>;
  /** Whether group tiles hide their entity lists by default */
  hideEntitiesListInGroups?: InputMaybe<Scalars['Boolean']['input']>;
  householdID: Scalars['ID']['input'];
  /** Type of diagram. Determines which visualization this configuration applies to */
  kind: EntityDiagramKind;
  /** Array of node configurations containing positions and other display properties */
  nodeConfigurations?: InputMaybe<Array<EntityGraphNodeConfigurationInput>>;
  visualizationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateEntityDocumentRelationshipInput is used for create EntityDocumentRelationship object.
 * Input was generated by ent.
 */
export type CreateEntityDocumentRelationshipInput = {
  documentID: Scalars['ID']['input'];
  entityID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** Type of relationship between entity and document */
  relationshipType: EntityDocumentRelationshipRelationshipType;
  /** The precedence for AI suggestions. Only applies when relationship_type is SOURCE_DOCUMENT */
  suggestionPrecedenceOrder?: InputMaybe<Scalars['Int']['input']>;
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateEntityGraphViewBundleConfigurationInput is used for create EntityGraphViewBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateEntityGraphViewBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name for the entity graph view. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityGraphViewID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
};

/**
 * CreateEntityGraphViewInput is used for create EntityGraphView object.
 * Input was generated by ent.
 */
export type CreateEntityGraphViewInput = {
  displayName: Scalars['String']['input'];
  /** Whether group tiles hide their entity lists by default */
  hideEntitiesListInGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides dollar values on entity tiles. */
  hideEntityValues?: InputMaybe<Scalars['Boolean']['input']>;
  householdID: Scalars['ID']['input'];
  kind?: InputMaybe<EntityGraphViewKind>;
  /** the definitions of the nodes in the graph */
  nodeConfigurations: Array<EntityGraphNodeConfigurationInput>;
  orientation?: InputMaybe<EntityGraphViewOrientation>;
  /** If true, shows labels on ownership lines. */
  showLineLabels?: InputMaybe<Scalars['Boolean']['input']>;
  visualizationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateEntityInput is used for create Entity object.
 * Input was generated by ent.
 */
export type CreateEntityInput = {
  activityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** when true, indicates that the addepar entity this is linked to isn't owned by the grantor on addepar. this could be because the grantor on addepar is deceased or not present on Luminary. */
  addeparLinkedToNongrantorEntity?: InputMaybe<Scalars['Boolean']['input']>;
  additionalDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** how the entity got created */
  attributionSource?: InputMaybe<EntityAttributionSource>;
  balanceSheetCategoryOverrideID?: InputMaybe<Scalars['ID']['input']>;
  cashflowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ccorpBusinessEntityID?: InputMaybe<Scalars['ID']['input']>;
  cltTrustID?: InputMaybe<Scalars['ID']['input']>;
  createdSubtrustIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  crtTrustID?: InputMaybe<Scalars['ID']['input']>;
  custodialPersonalAccountID?: InputMaybe<Scalars['ID']['input']>;
  deathOrderNoteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  defaultDocumentID?: InputMaybe<Scalars['ID']['input']>;
  documentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  donorAdvisedFundID?: InputMaybe<Scalars['ID']['input']>;
  emailNotificationRecordIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityDiagramIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityDocumentRelationshipIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityProposalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  estateWaterfallFilterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Customer-supplied identifier from an external system. Unique per tenant when set. */
  externalID?: InputMaybe<Scalars['String']['input']>;
  gpBusinessEntityID?: InputMaybe<Scalars['ID']['input']>;
  gratTrustID?: InputMaybe<Scalars['ID']['input']>;
  /** When true, assets will be grouped by category and account in the valuation */
  groupIntegrationAssetValues?: InputMaybe<Scalars['Boolean']['input']>;
  householdID: Scalars['ID']['input'];
  ilitTrustID?: InputMaybe<Scalars['ID']['input']>;
  individualPersonalAccountID?: InputMaybe<Scalars['ID']['input']>;
  insurancePersonalAccountID?: InputMaybe<Scalars['ID']['input']>;
  integrationEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  irrevocableTrustID?: InputMaybe<Scalars['ID']['input']>;
  jointPersonalAccountID?: InputMaybe<Scalars['ID']['input']>;
  kgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  liabilitiesOwedIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Controls how liquidity is determined for this entity. ASSET_BASED derives from underlying asset classes, LIQUID/ILLIQUID overrides all owned assets beneath it. */
  liquidityStatus?: InputMaybe<EntityLiquidityStatus>;
  llcBusinessEntityID?: InputMaybe<Scalars['ID']['input']>;
  lpBusinessEntityID?: InputMaybe<Scalars['ID']['input']>;
  onboardingEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownedByStakeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownedOwnershipStakeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  owningOnboardingEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When true, integration syncs do not update this entity's valuations or ownership. */
  pauseIntegrationSync?: InputMaybe<Scalars['Boolean']['input']>;
  potentialEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  privateFoundationID?: InputMaybe<Scalars['ID']['input']>;
  qprtTrustID?: InputMaybe<Scalars['ID']['input']>;
  qualifiedTuitionPersonalAccountID?: InputMaybe<Scalars['ID']['input']>;
  relatedSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  retirementPersonalAccountID?: InputMaybe<Scalars['ID']['input']>;
  revocableTrustID?: InputMaybe<Scalars['ID']['input']>;
  scorpBusinessEntityID?: InputMaybe<Scalars['ID']['input']>;
  /** When true, the entity name will be shown on the balance sheet rather than the names of the underlying assets */
  showEntityNameOnBalanceSheet?: InputMaybe<Scalars['Boolean']['input']>;
  slatTrustID?: InputMaybe<Scalars['ID']['input']>;
  soleProprietorshipBusinessEntityID?: InputMaybe<Scalars['ID']['input']>;
  /** the lifecycle stage of the entity. not all stages are applicable to all entities; most go directly into ACTIVE */
  stage: EntityStage;
  suggestionKgRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When true, the same entity notes apply for all client profiles in the household */
  syncDeathOrderNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to sync ownership percentage from integrations. */
  syncOwnership?: InputMaybe<Scalars['Boolean']['input']>;
  taskIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  taxInfoID?: InputMaybe<Scalars['ID']['input']>;
  workflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateEntityNotesFromDocumentSummaryInput = {
  /**
   * Expect time bound entities to have no clientProfile associated with the entity note
   * Nominally, we may choose to set entity notes for either or both client profiles in a household for the entity
   */
  clientProfileIDs: Array<Scalars['ID']['input']>;
  documentSummaryID: Scalars['ID']['input'];
  entityID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
};

/**
 * CreateEntityNotesInput is used for create EntityNotes object.
 * Input was generated by ent.
 */
export type CreateEntityNotesInput = {
  clientProfileID?: InputMaybe<Scalars['ID']['input']>;
  documentSummaryID?: InputMaybe<Scalars['ID']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** Markdown formatted notes for this entity's death order */
  notes: Scalars['String']['input'];
};

/**
 * CreateEntityProposalInput is used for create EntityProposal object.
 * Input was generated by ent.
 */
export type CreateEntityProposalInput = {
  assetValuationProjectionType: EntityProposalAssetValuationProjectionType;
  entityID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  proposalID?: InputMaybe<Scalars['ID']['input']>;
  proposalScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** the percent value for tax drag for the entity */
  taxDrag?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * CreateEntitySummaryBundleConfigurationInput is used for create EntitySummaryBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateEntitySummaryBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  deathOrderID: Scalars['ID']['input'];
  documentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  /** If true, includes the full-sheet entity balance sheet page in the bundle. */
  includeBalanceSheetExportPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the entity balance sheet page in the bundle. */
  includeBalanceSheetPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the beneficiaries and dispositions page in the bundle. */
  includeBeneficiariesAndDispositionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the notes and diagram page in the bundle. */
  includeDiagramAndNotesPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the entity notes on the diagram page. */
  includeEntityNotesOnSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the entity summary/title page in the bundle. */
  includeEntitySummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the insurance policy slides in the bundle. */
  includeInsurancePolicySlides?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateEntitySummaryTemplateBundleConfigurationInput is used for create EntitySummaryTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateEntitySummaryTemplateBundleConfigurationInput = {
  /** Which household entities this bundle expands into, one runtime bundle per match. */
  entityTypes: Array<EntitySummaryEntityType>;
  /** If true, includes the full-sheet entity balance sheet page in each expanded bundle. */
  includeBalanceSheetExportPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the entity balance sheet page in each expanded bundle. */
  includeBalanceSheetPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the beneficiaries and dispositions page in each expanded bundle. */
  includeBeneficiariesAndDispositionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the notes and diagram page in each expanded bundle. */
  includeDiagramAndNotesPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the entity notes on the diagram page in each expanded bundle. */
  includeEntityNotesOnSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the entity summary/title page in each expanded bundle. */
  includeEntitySummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the insurance policy slides in each expanded bundle. */
  includeInsurancePolicySlides?: InputMaybe<Scalars['Boolean']['input']>;
  templateBundleID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateEntityTaskInput is used for create EntityTask object.
 * Input was generated by ent.
 */
export type CreateEntityTaskInput = {
  assignedByID?: InputMaybe<Scalars['ID']['input']>;
  assignedToID?: InputMaybe<Scalars['ID']['input']>;
  /** the reason this task was cancelled. if present, the task status is computed as canceled */
  cancelledReason?: InputMaybe<Scalars['String']['input']>;
  /** the timestamp at which this task was marked as complete */
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  completedByID?: InputMaybe<Scalars['ID']['input']>;
  /** the date at which this task is due */
  dueAt: Scalars['Time']['input'];
  entityID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  ilitCrummeyLetterID?: InputMaybe<Scalars['ID']['input']>;
  loggedTransferIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  premiumPaymentID?: InputMaybe<Scalars['ID']['input']>;
  reminderEmailNotificationRecordIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskDependencyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskDependentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  type: EntityTaskType;
};

/**
 * CreateEntityTaxInfoInput is used for create EntityTaxInfo object.
 * Input was generated by ent.
 */
export type CreateEntityTaxInfoInput = {
  entityID?: InputMaybe<Scalars['ID']['input']>;
  federalInEstate?: InputMaybe<Scalars['Boolean']['input']>;
  householdID: Scalars['ID']['input'];
  stateCode?: InputMaybe<StateCode>;
  stateInEstate?: InputMaybe<Scalars['Boolean']['input']>;
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateEstateInsightInput is used for create EstateInsight object.
 * Input was generated by ent.
 */
export type CreateEstateInsightInput = {
  /** Whether this insight needs review or represents a concern or opportunity */
  bucket: EstateInsightBucket;
  /** Category classification of the estate insight */
  category: EstateInsightCategory;
  /** Date when the estate insight was marked as completed */
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  /** Markdown formatted detailed consideration for the estate insight */
  consideration: Scalars['String']['input'];
  documentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  estateInsightsBundleConfigurationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  /** Whether this insight is marked as critical */
  isCritical?: InputMaybe<Scalars['Boolean']['input']>;
  /** The specific type of estate insight identified */
  kind: EstateInsightKind;
  /** 0‑based ordinal within this household's insights within bucket */
  position: Scalars['Int']['input'];
  referenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Current status of the estate insight */
  status?: InputMaybe<EstateInsightStatus>;
  /** Plain text summary of the estate insight */
  summary: Scalars['String']['input'];
  /** Title of the estate insight */
  title: Scalars['String']['input'];
};

/**
 * CreateEstateInsightReferenceInput is used for create EstateInsightReference object.
 * Input was generated by ent.
 */
export type CreateEstateInsightReferenceInput = {
  /** Description of the reference */
  description: Scalars['String']['input'];
  estateInsightID: Scalars['ID']['input'];
  fileParagraphIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  /** Optional section label for the reference */
  sectionLabel?: InputMaybe<Scalars['String']['input']>;
  /** Title of the reference */
  title: Scalars['String']['input'];
};

/**
 * CreateEstateInsightsBundleConfigurationInput is used for create EstateInsightsBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateEstateInsightsBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name for the bundle. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  estateInsightIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  /** If true, includes the annual exclusion gifting insight in the bundle. */
  includeAnnualExclusionGiftingPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the automatic outright distribution to spouse insight in the bundle. */
  includeAutomaticOutrightDistributionToSpousePage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the bypass trust funded solely via disclaimer insight in the bundle. */
  includeBypassTrustFundedSolelyViaDisclaimerPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the corporate trustee insight in the bundle. */
  includeCorporateTrusteePage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes this different state of residence from estate documents insight in the bundle. */
  includeDifferentStateOfResidenceFromEstateDocumentsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the ex spouse listed as beneficiary insight in the bundle. */
  includeExSpouseListedAsBeneficiaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the ex spouse listed as trustee insight in the bundle. */
  includeExSpouseListedAsTrusteePage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the ex spouse listed in will insight in the bundle. */
  includeExSpouseListedInWillPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the full use of lifetime exemption insight in the bundle. */
  includeFullUseOfLifetimeExemptionPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the gift to charity insight in the bundle. */
  includeGiftToCharityPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes this missing documents page in the bundle. */
  includeMissingDocumentsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the missing guardian provisions insight in the bundle. */
  includeMissingGuardianProvisionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the missing powers of appointment for surviving spouse insight in the bundle. */
  includeMissingPoaForSurivivingSpousePage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the no alternative agent listed in healthcare proxy insight in the bundle. */
  includeNoAlternativeAgentListedHealthcareProxyPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the no alternative agent listed in power of attorney insight in the bundle. */
  includeNoAlternativeAgentListedPoaPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the open 529 account insight in the bundle. */
  includeOpen529AccountPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the outright distributions to children insight in the bundle. */
  includeOutrightDistributionsToChildrenPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the retirement account beneficiary designations insight in the bundle. */
  includeRetirementAccountBeneficiaryDesignationsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes this retitle assets to revocable trust insight in the bundle. */
  includeRetitleAssetsToRevocableTrustPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes this specific bequests insight in the bundle. */
  includeSpecificBequestsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the state estate tax insight in the bundle. */
  includeStateEstateTaxPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the state inheritance tax insight in the bundle. */
  includeStateInheritanceTaxPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes this trustee domiciled in different state insight in the bundle. */
  includeTrusteeDomiciledInDifferentState?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the trustees not updated insight in the bundle. */
  includeTrusteesNotUpdatedPage?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateEstateTaxScenarioInput is used for create EstateTaxScenario object.
 * Input was generated by ent.
 */
export type CreateEstateTaxScenarioInput = {
  displayName: Scalars['String']['input'];
  /** The order of payout for the first death. Includes Entities and Testamentary Entities. */
  firstDeathPayoutOrder: Array<Scalars['ID']['input']>;
  firstGrantorDeathID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  isExemptionPortable?: InputMaybe<Scalars['Boolean']['input']>;
  payoutKind: EstateTaxScenarioPayoutKind;
  /** The order of payout for the second death, only valid when there are multiple grantors. Includes Entities and Testamentary Entities. */
  secondDeathPayoutOrder?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateEstateWaterfallHypotheticalStateChangeInput is used for create EstateWaterfallHypotheticalStateChange object.
 * Input was generated by ent.
 */
export type CreateEstateWaterfallHypotheticalStateChangeInput = {
  grantorID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  hypotheticalWaterfallID?: InputMaybe<Scalars['ID']['input']>;
  /** The state change applies from the start of this year until the grantor's next state change or death. If not set, it applies from the start of the projection. */
  startYear?: InputMaybe<Scalars['Int']['input']>;
  /** The grantor's state of residence in this hypothetical scenario. */
  stateCode: StateCode;
};

/**
 * CreateEstateWaterfallHypotheticalTransferInput is used for create EstateWaterfallHypotheticalTransfer object.
 * Input was generated by ent.
 */
export type CreateEstateWaterfallHypotheticalTransferInput = {
  /** This dynamically sets the end date of this transfer to the year when both individuals die. It superceeds end_year and end_at_clients_death. Ignored if start_year is not set.  */
  afterBothDeaths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Assume transfers will grow/shrink by this percentage each year. Only valid for recurring transfers. */
  assetGrowthReturn?: InputMaybe<Scalars['Percent']['input']>;
  destinationEntityID?: InputMaybe<Scalars['ID']['input']>;
  destinationIndividualID?: InputMaybe<Scalars['ID']['input']>;
  /** The kind of destination for this transfer. */
  destinationKind: EstateWaterfallHypotheticalTransferDestinationKind;
  destinationOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  endAtClientsDeathID?: InputMaybe<Scalars['ID']['input']>;
  /** The year this transfer ends. Ignored if start_year is not set. */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  giftingGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  hypotheticalWaterfallID?: InputMaybe<Scalars['ID']['input']>;
  /** If true, this is a GST gift. Only valid when transfer_tax_kind is GRANTOR_TAXABLE_GIFT. */
  isGstGift?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  sourceInsurancePolicyID?: InputMaybe<Scalars['ID']['input']>;
  /** The kind of the source for this transfer. */
  sourceKind: EstateWaterfallHypotheticalTransferSourceKind;
  sourceOwnedBusinessEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceOwnedEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceOwnershipStakeID?: InputMaybe<Scalars['ID']['input']>;
  /** The year this transfer starts. If start_year is not set, it is assumed to be a one time transfer happening in the current year. If start_year is set, this is a yearly recurring transfer until end_year is reached. */
  startYear?: InputMaybe<Scalars['Int']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  /** Taxable value of the transfer. If nil, it will be calculated. */
  taxableValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The order of this transfer in the list of transfers for a given source. */
  transferOrder: Scalars['Int']['input'];
  transferTaxKind: EstateWaterfallHypotheticalTransferTransferTaxKind;
  /** Value of this transfer. */
  transferValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
};

/**
 * CreateEstateWaterfallInput is used for create EstateWaterfall object.
 * Input was generated by ent.
 */
export type CreateEstateWaterfallInput = {
  /** Used in beneficiary reporting to calculate non-quantifiable accessto a single entity across multiple beneficiaries. */
  beneficiaryAccessCalcMethod?: InputMaybe<EstateWaterfallBeneficiaryAccessCalcMethod>;
  displayName: Scalars['String']['input'];
  filterID?: InputMaybe<Scalars['ID']['input']>;
  firstGrantorDeathID: Scalars['ID']['input'];
  /** Projected year that the first grantor dies. */
  firstGrantorDeathYear?: InputMaybe<Scalars['Int']['input']>;
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  hypotheticalCltIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  hypotheticalCrtIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  hypotheticalGratIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  hypotheticalInsuranceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  hypotheticalSaleLoanIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  hypotheticalScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  hypotheticalStateChangeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  hypotheticalTransferIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The kind of estate waterfall. BASE is a normal estate waterfall. HYPOTHETICAL is a hypothetical scenario. */
  kind?: InputMaybe<EstateWaterfallKind>;
  /** the definitions of the nodes in the graph */
  nodeConfigurations?: InputMaybe<Array<EntityGraphNodeConfigurationInput>>;
  parentID?: InputMaybe<Scalars['ID']['input']>;
  /** Projected year that the second grantor dies. Only applicable when there are two grantors. */
  secondGrantorDeathYear?: InputMaybe<Scalars['Int']['input']>;
  /** When set, controls whether summary tile details are shown or hidden. */
  showSummaryTileDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** When set, asset growth is not applied in the current year of the waterfall projection. */
  skipCurrentYearGrowth?: InputMaybe<Scalars['Boolean']['input']>;
  visualizationConfigID?: InputMaybe<Scalars['ID']['input']>;
  visualizationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateEstateWaterfallOptsInput = {
  applyAutoGrouping?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateEstateWaterfallVisualizationConfigInput is used for create EstateWaterfallVisualizationConfig object.
 * Input was generated by ent.
 */
export type CreateEstateWaterfallVisualizationConfigInput = {
  /** If true, always shows edge labels. */
  alwaysShowEdgeLabels?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides edges. */
  hideEdges?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides list of entities in a group. */
  hideEntitiesListInGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides dollar values on the entity tile. */
  hideEntityValues?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides all tax tiles. */
  hideTaxTiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides unfunded tiles. */
  hideUnfundedTiles?: InputMaybe<Scalars['Boolean']['input']>;
  householdID: Scalars['ID']['input'];
  /** If true, shows zero dollar tiles. */
  showZeroDollarTiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, uses brand colors instead of luminary defaults. */
  useBrandColors?: InputMaybe<Scalars['Boolean']['input']>;
  waterfallID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateEstateWaterfallVisualizationFilterInput is used for create EstateWaterfallVisualizationFilter object.
 * Input was generated by ent.
 */
export type CreateEstateWaterfallVisualizationFilterInput = {
  householdID: Scalars['ID']['input'];
  includedClientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  includedEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  waterfallID: Scalars['ID']['input'];
};

/**
 * CreateFamilyTreeBundleConfigurationInput is used for create FamilyTreeBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateFamilyTreeBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name for the family tree. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  familyTreeConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
};

/**
 * CreateFeatureFlagInput is used for create FeatureFlag object.
 * Input was generated by ent.
 */
export type CreateFeatureFlagInput = {
  flagDescription?: InputMaybe<Scalars['String']['input']>;
  flagName: Scalars['String']['input'];
  flagStatus?: InputMaybe<FeatureFlagFlagStatus>;
  /** Conceptual group for flag */
  group?: InputMaybe<FeatureFlagGroup>;
  ownedBy?: InputMaybe<Scalars['String']['input']>;
  queryRuleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Luminary engineering team responsible for the feature flag */
  team?: InputMaybe<FeatureFlagTeam>;
};

/**
 * CreateFeatureFlagQueryRuleInput is used for create FeatureFlagQueryRule object.
 * Input was generated by ent.
 */
export type CreateFeatureFlagQueryRuleInput = {
  featureFlagID: Scalars['ID']['input'];
  flagQuery: Scalars['String']['input'];
  flagVariationName: Scalars['String']['input'];
  kind?: InputMaybe<FeatureFlagQueryRuleKind>;
  releaseGroupID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateFileInput is used for create File object.
 * Input was generated by ent.
 */
export type CreateFileInput = {
  aiSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The sha256 of the file to be uploaded. We check the file integrity S3 side. */
  contentsSha256: Scalars['String']['input'];
  /** The context in which the file is meant to exist. */
  context?: InputMaybe<FileContext>;
  documentID?: InputMaybe<Scalars['ID']['input']>;
  householdID?: InputMaybe<Scalars['ID']['input']>;
  inferredFieldIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  kgRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  pageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  pdfDocumentID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateFilePageInput is used for create FilePage object.
 * Input was generated by ent.
 */
export type CreateFilePageInput = {
  /** The angle of the page. This helps establish an orientation. */
  angle?: InputMaybe<Scalars['Float']['input']>;
  fileID?: InputMaybe<Scalars['ID']['input']>;
  /** The height of the page. */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** The page number of the file. 1-indexed. */
  pageNumber: Scalars['Int']['input'];
  /** The unit of measurement for the page. Typically 'inch'. */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** The width of the page. */
  width?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * CreateFormInput is used for create Form object.
 * Input was generated by ent.
 */
export type CreateFormInput = {
  /** Description of the form */
  description: Scalars['String']['input'];
  /** Mutable working copy of the form configuration */
  draftConfig: Scalars['Map']['input'];
  /** Display name for the form */
  name: Scalars['String']['input'];
};

export type CreateFormSubmissionInput = {
  formVersionID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentIDs: Array<Scalars['ID']['input']>;
};

export type CreateFormTestSnapshotInput = {
  id: Scalars['ID']['input'];
};

/**
 * CreateGPBusinessEntityInput is used for create GPBusinessEntity object.
 * Input was generated by ent.
 */
export type CreateGpBusinessEntityInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this business entity */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  keyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Ownership as-of date. */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
};

/**
 * CreateGRATAnnuityV2Input is used for create GRATAnnuityV2 object.
 * Input was generated by ent.
 */
export type CreateGratAnnuityV2Input = {
  associatedAssetValuationID?: InputMaybe<Scalars['ID']['input']>;
  associatedTaskID?: InputMaybe<Scalars['ID']['input']>;
  /** if the annuity payment failed, this is the amount that was actually paid */
  failedAnnuityPaymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  householdID: Scalars['ID']['input'];
  /** the percent of the initial funding value due to be paid with this annuity */
  initialFundingValuePercent: Scalars['Percent']['input'];
  /** the date the annuity was paid on */
  paidOn?: InputMaybe<Scalars['Time']['input']>;
  /** the term duration of the GRAT that this annuity is associated with */
  termDurationYears: Scalars['Int']['input'];
  /** which 1-indexed annuity payment this represents; if a 2, represents the second annuity payment */
  yearOfTerm: Scalars['Int']['input'];
};

/**
 * CreateGRATProposalScenarioInput is used for create GRATProposalScenario object.
 * Input was generated by ent.
 */
export type CreateGratProposalScenarioInput = {
  householdID: Scalars['ID']['input'];
  inTermValuationType?: InputMaybe<GratProposalScenarioInTermValuationType>;
  /** the percent value for projected return after the lifetime of the GRAT */
  projectedAnnualReturnAfterTerm?: InputMaybe<Scalars['Percent']['input']>;
  /** the percent value for projected return during the lifetime of the GRAT */
  projectedAnnualReturnThroughTerm?: InputMaybe<Scalars['Percent']['input']>;
  projectedMarketValueAtTerm?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** the default selected time period for this projection */
  projectionTimePeriodYears: Scalars['Int']['input'];
};

/**
 * CreateGRATTrustInput is used for create GRATTrust object.
 * Input was generated by ent.
 */
export type CreateGratTrustInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** the percent by which the annuity should increase each year in a variable annuity amount scenario */
  annuityAnnualIncreasePercent?: InputMaybe<Scalars['Percent']['input']>;
  annuityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  distributionAssetValuationID?: InputMaybe<Scalars['ID']['input']>;
  /** the date that the trust remainder was distributed */
  distributionDate?: InputMaybe<Scalars['Time']['input']>;
  downsideThresholdPercent?: InputMaybe<Scalars['Percent']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  grantorID?: InputMaybe<Scalars['ID']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** notes from the advisor team to the implementing attorney */
  implementationNotesToAttorney?: InputMaybe<Scalars['String']['input']>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  officialInterestRatePercent?: InputMaybe<Scalars['Percent']['input']>;
  projectedMarketValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedRateOfReturn?: InputMaybe<Scalars['Percent']['input']>;
  projectedSharePrice?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  rollingPeriodYears?: InputMaybe<Scalars['Int']['input']>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  successorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** taxable gift that the advisor is trying to achieve; should be used as an input for annuities calcs */
  targetTaxableGift?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  /** The actual taxable gift that was recorded for this GRAT */
  taxableGift?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  trustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If true, the upside threshold value is used for the GRAT substitution threshold instead of the upside threshold percent. */
  upsideAsTargetSurplus?: InputMaybe<Scalars['Boolean']['input']>;
  upsideThresholdPercent?: InputMaybe<Scalars['Percent']['input']>;
  upsideThresholdValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
};

/**
 * CreateGiftingProposalCashFlowInput is used for create GiftingProposalCashFlow object.
 * Input was generated by ent.
 */
export type CreateGiftingProposalCashFlowInput = {
  /** Cash flow amount */
  amount: Scalars['CurrencyUSD']['input'];
  /** Whether this cash flow occurs every year or only once */
  annuallyRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the cash flow is an income or expense */
  cashFlowType: GiftingProposalCashFlowCashFlowType;
  /** the user-friendly name of this cash flow */
  displayName: Scalars['String']['input'];
  /** If recurring, the year this cash flow ends. If not recurring, this field is not set. */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  /** If recurring, the percentage that the cash flow amount grows each year */
  growthPercentage?: InputMaybe<Scalars['Percent']['input']>;
  householdID: Scalars['ID']['input'];
  /** The order to display cash flows in the UI */
  order: Scalars['Int']['input'];
  portfolioID?: InputMaybe<Scalars['ID']['input']>;
  /** If recurring, the year this cash flow starts. If not recurring, the year this cash flow occurs. */
  startYear: Scalars['Int']['input'];
};

/**
 * CreateGiftingProposalGiftInput is used for create GiftingProposalGift object.
 * Input was generated by ent.
 */
export type CreateGiftingProposalGiftInput = {
  /** Gift amount */
  amount: Scalars['CurrencyUSD']['input'];
  /** Whether this gift occurs every year or only once */
  annuallyRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, gift amount is discounted for gift tax purposes */
  discount?: InputMaybe<Scalars['Boolean']['input']>;
  /** If discount is true, the discount percentage applied to the gift amount */
  discountPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** the user-friendly name of this gifting scenario */
  displayName: Scalars['String']['input'];
  /** If recurring, the year this gift ends. If not recurring, this field is not set. */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  /** If recurring, the percentage that the gift amount grows each year */
  growthPercentage?: InputMaybe<Scalars['Percent']['input']>;
  householdID: Scalars['ID']['input'];
  /** If true, gift is taxable, and sender will be one or both grantors. If false, can be annual exclusion, or charitable. */
  isTaxable: Scalars['Boolean']['input'];
  /** Will be null (or ignored) if gift is taxable. */
  nonTaxableGiftType?: InputMaybe<GiftingProposalGiftNonTaxableGiftType>;
  /** The order to display, and process the gifts when simulating the proposal scenarios */
  order: Scalars['Int']['input'];
  recipientClientOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  recipientClientProfileID?: InputMaybe<Scalars['ID']['input']>;
  /** The kind of recipient for this gift. Either one of the modeled out-of-estate portfolios, an individual, or an organization. */
  recipientKind?: InputMaybe<GiftingProposalGiftRecipientKind>;
  recipientPortfolioID?: InputMaybe<Scalars['ID']['input']>;
  senderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If recurring, the year this gift starts. If not recurring, the year this gift occurs. */
  startYear: Scalars['Int']['input'];
};

/**
 * CreateGiftingProposalGiftSenderInput is used for create GiftingProposalGiftSender object.
 * Input was generated by ent.
 */
export type CreateGiftingProposalGiftSenderInput = {
  grantorID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
};

/**
 * CreateGiftingProposalInput is used for create GiftingProposal object.
 * Input was generated by ent.
 */
export type CreateGiftingProposalInput = {
  baseCashFlowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  defaultGiftingScenarioID?: InputMaybe<Scalars['ID']['input']>;
  /** Gift exemption grows by this amount each year. */
  exemptionGrowthRate?: InputMaybe<Scalars['Percent']['input']>;
  /** If true, exemption amount is halved at the end of 2025, then continues growing. DEPRECATED: The 2017 Tax Cuts and Jobs Act sunset provision is no longer relevant */
  exemptionSunsets?: InputMaybe<Scalars['Boolean']['input']>;
  giftingScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  /** The total value of all assets in the client's estate */
  inEstatePortfolioValue: Scalars['CurrencyUSD']['input'];
  /** number of years to run the gifting analysis */
  lengthOfAnalysis?: InputMaybe<Scalars['Int']['input']>;
  outOfEstatePortfolioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The high end of the pre-tax return percentage assumption */
  preTaxReturnPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  /** The low end of the pre-tax return assumption */
  preTaxReturnPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  /** The medium pre-tax return percentage assumption */
  preTaxReturnPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  /** The selected pre-tax return (and tax drag) category. Used when computing projections for scenarios. */
  selectedPreTaxReturnCategory?: InputMaybe<GiftingProposalSelectedPreTaxReturnCategory>;
  /** The selected year of analysis. Defaults to end year. Used when computing projections for scenarios. */
  selectedYearOfAnalysis?: InputMaybe<Scalars['Int']['input']>;
  /** If true, show after estate tax */
  showAfterEstateTax?: InputMaybe<Scalars['Boolean']['input']>;
  /** Status of the gifting proposal */
  status?: InputMaybe<GiftingProposalStatus>;
  /** The associated tax drag for the high pre-tax return */
  taxDragPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  /** The associated tax drag for the low pre-tax return */
  taxDragPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  /** The associated tax drag for the medium pre-tax return */
  taxDragPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * CreateGiftingProposalPortfolioInput is used for create GiftingProposalPortfolio object.
 * Input was generated by ent.
 */
export type CreateGiftingProposalPortfolioInput = {
  cashflowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** the user-friendly name of the out-of-estate portfolio */
  displayName: Scalars['String']['input'];
  giftingProposalID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** The order to display portfolios in the UI */
  order: Scalars['Int']['input'];
  /** Portfolio type */
  portfolioType: GiftingProposalPortfolioPortfolioType;
  recipientOfIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The starting value of the out-of-estate portfolio */
  startingAssetValue: Scalars['CurrencyUSD']['input'];
};

/**
 * CreateGiftingProposalScenarioInput is used for create GiftingProposalScenario object.
 * Input was generated by ent.
 */
export type CreateGiftingProposalScenarioInput = {
  /** the user-friendly name of this gifting scenario */
  displayName: Scalars['String']['input'];
  /** If true, exemption amount is halved at the end of 2025, then continues growing. When absent, uses the proposal level setting. DEPRECATED: The 2017 Tax Cuts and Jobs Act sunset provision is no longer relevant */
  exemptionSunsets?: InputMaybe<Scalars['Boolean']['input']>;
  householdID: Scalars['ID']['input'];
  /** Whether this scenario is the default for its gifting proposal. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The order to display scenarios in the UI */
  order: Scalars['Int']['input'];
  scenarioCashFlowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  scenarioGiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateGraphVisualizationGroupInput is used for create GraphVisualizationGroup object.
 * Input was generated by ent.
 */
export type CreateGraphVisualizationGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  /** An optional namespace for this group. Can correspond to sections in the Graph Visualization. */
  namespace?: InputMaybe<Scalars['String']['input']>;
  /** The IDs of the nodes in this group. */
  nodeIds: Array<Scalars['ID']['input']>;
};

/**
 * CreateGrowthProfileInput is used for create GrowthProfile object.
 * Input was generated by ent.
 */
export type CreateGrowthProfileInput = {
  /** Assume assets will grow/shrink by this percentage each year. */
  assetGrowthReturn?: InputMaybe<Scalars['Percent']['input']>;
  displayName: Scalars['String']['input'];
  estateWaterfallIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Lifetime exemption grows by around this each year. */
  exemptionGrowthRate: Scalars['Percent']['input'];
  growthProfileOverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The type of growth to use for the growth profile. */
  growthType: GrowthProfileGrowthType;
  householdID: Scalars['ID']['input'];
  incomeTaxPaymentConfigID?: InputMaybe<Scalars['ID']['input']>;
  /** If true, new waterfalls for this household will default to this growth profile. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  taxDragConfigID?: InputMaybe<Scalars['ID']['input']>;
  taxDragOverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateGrowthProfileOverrideInput is used for create GrowthProfileOverride object.
 * Input was generated by ent.
 */
export type CreateGrowthProfileOverrideInput = {
  assetClassID?: InputMaybe<Scalars['ID']['input']>;
  /** Expected growth rate. */
  customGrowthRate?: InputMaybe<Scalars['Percent']['input']>;
  /** Expected future value of the entity. */
  entityFutureValuationValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The year by which the entity is expected to reach its expected value. */
  entityFutureValuationYear?: InputMaybe<Scalars['Int']['input']>;
  /** Expected growth rate after the future valuation year. */
  entityGrowthAfterFutureValuation?: InputMaybe<Scalars['Percent']['input']>;
  /** Expected growth rate before the future valuation year. */
  entityGrowthBeforeFutureValuation?: InputMaybe<Scalars['Percent']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** The type of wealth module. */
  kind: GrowthProfileOverrideKind;
  proposalID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateHouseholdInput is used for create Household object.
 * Input was generated by ent.
 */
export type CreateHouseholdInput = {
  activityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When this household was archived */
  archivedAt?: InputMaybe<Scalars['Time']['input']>;
  assignedEmployeeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedTeamIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  balanceSheetViewConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** whether this client is billable or not. if not BILLABLE, this client's entities should be excluding from customer billing */
  billableKind?: InputMaybe<HouseholdBillableKind>;
  cashflowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientOrganizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  collaboratorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Enables Smart Review and records the authenticated caller as the enabler. */
  enableSmartReview?: InputMaybe<Scalars['Boolean']['input']>;
  entityGraphViewIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  estateTaxScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  estateWaterfallIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Customer-supplied identifier from an external system. Unique per tenant when set. */
  externalID?: InputMaybe<Scalars['String']['input']>;
  familyTreeConfigurationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  growthProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  integrationClientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  liabilityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When set, individuals in this household were automatically accepted at this time; the frontend shows a banner prompting users to review them */
  newIndividualsAutomaticallyOnboardedAt?: InputMaybe<Scalars['Time']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  onboardingKgRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  presentationv2IDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  primaryRelationshipOwnerID: Scalars['ID']['input'];
  /** Disables tenant-wide household access when true. */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  profiles?: InputMaybe<Array<CreateClientProfileWithDetailsInput>>;
  proposalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Show the prompt to generate V2 AI suggestions for a household on the frontend. This can be deprecated when no longer useful */
  showGenerateV2SuggestionsPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  smartReviewEnabledByUserID?: InputMaybe<Scalars['ID']['input']>;
  subBrandID?: InputMaybe<Scalars['ID']['input']>;
  testamentaryEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateHypotheticalCLTInput is used for create HypotheticalCLT object.
 * Input was generated by ent.
 */
export type CreateHypotheticalCltInput = {
  displayName: Scalars['String']['input'];
  fundingID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  hypotheticalWaterfallID: Scalars['ID']['input'];
  simulatedCltID: Scalars['ID']['input'];
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  sourceKind?: InputMaybe<HypotheticalCltSourceKind>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * CreateHypotheticalCRTInput is used for create HypotheticalCRT object.
 * Input was generated by ent.
 */
export type CreateHypotheticalCrtInput = {
  displayName: Scalars['String']['input'];
  fundingID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  hypotheticalWaterfallID: Scalars['ID']['input'];
  simulatedCrtID: Scalars['ID']['input'];
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  sourceKind?: InputMaybe<HypotheticalCrtSourceKind>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * CreateHypotheticalGRATInput is used for create HypotheticalGRAT object.
 * Input was generated by ent.
 */
export type CreateHypotheticalGratInput = {
  displayName: Scalars['String']['input'];
  fundingID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  hypotheticalWaterfallID: Scalars['ID']['input'];
  simulatedGratID: Scalars['ID']['input'];
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  sourceKind: HypotheticalGratSourceKind;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * CreateHypotheticalInsuranceInput is used for create HypotheticalInsurance object.
 * Input was generated by ent.
 */
export type CreateHypotheticalInsuranceInput = {
  createdInsurancePolicyID?: InputMaybe<Scalars['ID']['input']>;
  destinationEntityID?: InputMaybe<Scalars['ID']['input']>;
  displayName: Scalars['String']['input'];
  /** The year this hypothetical insurance ends. Ignored if end_on_kind:YEAR is not set. */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  /** The kind of the end date for this hypothetical insurance. */
  endsOnKind: HypotheticalInsuranceEndsOnKind;
  estateWaterfallID: Scalars['ID']['input'];
  existingInsurancePolicyHolderID?: InputMaybe<Scalars['ID']['input']>;
  existingInsurancePolicyID?: InputMaybe<Scalars['ID']['input']>;
  giftingGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  /** The kind of the source for this hypothetical insurance. */
  sourceKind: HypotheticalInsuranceSourceKind;
  /** The year this insurance policy starts or is transferred. If not set then it is assumed to be the current year. */
  startYear?: InputMaybe<Scalars['Int']['input']>;
  /** The frequency of the transfer. */
  transferFrequency: HypotheticalInsuranceTransferFrequency;
  transferTaxKind: HypotheticalInsuranceTransferTaxKind;
  /** Value of this transfer. */
  transferValue: Scalars['CurrencyUSD']['input'];
};

/**
 * CreateHypotheticalSaleLoanInput is used for create HypotheticalSaleLoan object.
 * Input was generated by ent.
 */
export type CreateHypotheticalSaleLoanInput = {
  /** Applicable AFR for the sale or loan. */
  afrRate: Scalars['Percent']['input'];
  displayName: Scalars['String']['input'];
  fundingID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  hypotheticalWaterfallID: Scalars['ID']['input'];
  kind: HypotheticalSaleLoanKind;
  paymentModel: HypotheticalSaleLoanPaymentModel;
  pretermGrantorDeathHandling: HypotheticalSaleLoanPretermGrantorDeathHandling;
  recipientEntityID?: InputMaybe<Scalars['ID']['input']>;
  recipientIndividualID?: InputMaybe<Scalars['ID']['input']>;
  recipientKind: HypotheticalSaleLoanRecipientKind;
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  sourceKind: HypotheticalSaleLoanSourceKind;
  /** The effective date of the sale or loan for modeling purposes */
  startDate: Scalars['Time']['input'];
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  termLengthYears: Scalars['Int']['input'];
  /** How the transfer is made to the recipient. IN_KIND preserves the asset thus keeping the source asset growth characteristics, LIQUIDATE_TO_CASH sells the asset thus gaining the destination asset growth characteristics. */
  transferMethod?: InputMaybe<TransferMethod>;
};

/**
 * CreateHypotheticalTransferAssetInput is used for create HypotheticalTransferAsset object.
 * Input was generated by ent.
 */
export type CreateHypotheticalTransferAssetInput = {
  assetClassID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  hypotheticalTransferFundingSourceID?: InputMaybe<Scalars['ID']['input']>;
  kind: HypotheticalTransferAssetKind;
  ownedBusinessID?: InputMaybe<Scalars['ID']['input']>;
  /** The absolute value of this business or asset class being transferred. Present if the source `kind` is SPECIFIC_ASSETS_AMOUNT. */
  valueAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The percentage of the business or asset class being transferred. Present if the source `kind` is SPECIFIC_ASSETS_PERCENTAGE. */
  valuePercentage?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * CreateHypotheticalTransferFundingSourceInput is used for create HypotheticalTransferFundingSource object.
 * Input was generated by ent.
 */
export type CreateHypotheticalTransferFundingSourceInput = {
  assetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  hypotheticalCltID?: InputMaybe<Scalars['ID']['input']>;
  hypotheticalCrtID?: InputMaybe<Scalars['ID']['input']>;
  hypotheticalGratID?: InputMaybe<Scalars['ID']['input']>;
  hypotheticalSaleLoanID?: InputMaybe<Scalars['ID']['input']>;
  /** The strategy used to fund the transfer. NOTE: PRO_RATA_xxx is not actually pro_rata but rather our default disbursement strategy instead. */
  kind: HypotheticalTransferFundingSourceKind;
  /** The amount of the transfer. Only valid when kind is PRO_RATA_AMOUNT */
  proRataAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The percentage of the transfer. Only valid when kind is PRO_RATA_PERCENTAGE */
  proRataPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** How the transfer is made to the recipient. IN_KIND preserves the asset thus keeping the source asset growth characteristics, LIQUIDATE_TO_CASH sells the asset thus gaining the destination asset growth characteristics. */
  transferMethod?: InputMaybe<TransferMethod>;
};

/**
 * CreateHypotheticalWaterfallDispositiveProvisionTemplateInput is used for create HypotheticalWaterfallDispositiveProvisionTemplate object.
 * Input was generated by ent.
 */
export type CreateHypotheticalWaterfallDispositiveProvisionTemplateInput = {
  associatedHypotheticalWaterfallID: Scalars['ID']['input'];
  dispositiveProvisionTemplateID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateILITCrummeyLetterInput is used for create ILITCrummeyLetter object.
 * Input was generated by ent.
 */
export type CreateIlitCrummeyLetterInput = {
  associatedTaskID?: InputMaybe<Scalars['ID']['input']>;
  crummeyWithdrawalPeriodDays: Scalars['Int']['input'];
  documentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  ilitTrustID?: InputMaybe<Scalars['ID']['input']>;
  recipientID?: InputMaybe<Scalars['ID']['input']>;
  sendBefore?: InputMaybe<Scalars['Time']['input']>;
  sentOn?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateILITTrustInput is used for create ILITTrust object.
 * Input was generated by ent.
 */
export type CreateIlitTrustInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  crummeyWithdrawalPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  grantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  successorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  trustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateIncomeTaxPaymentConfigInput is used for create IncomeTaxPaymentConfig object.
 * Input was generated by ent.
 */
export type CreateIncomeTaxPaymentConfigInput = {
  /** The ordered entity IDs used when grantor_payment_method is CUSTOM. */
  customPayerOrder?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The method used to assign tax payments for grantor trusts and direct holdings. */
  grantorPaymentMethod: IncomeTaxPaymentConfigGrantorPaymentMethod;
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** The method used to assign tax payments for non-grantor entities. */
  nonGrantorPaymentMethod: IncomeTaxPaymentConfigNonGrantorPaymentMethod;
};

/**
 * CreateIndividualPersonalAccountInput is used for create IndividualPersonalAccount object.
 * Input was generated by ent.
 */
export type CreateIndividualPersonalAccountInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  controllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
};

/**
 * CreateInferredFieldEvidenceInput is used for create InferredFieldEvidence object.
 * Input was generated by ent.
 */
export type CreateInferredFieldEvidenceInput = {
  householdID: Scalars['ID']['input'];
  inferredFieldID?: InputMaybe<Scalars['ID']['input']>;
  /** The page (in the file) that this evidence is for */
  pageNumber: Scalars['Int']['input'];
  /** the polygon that was drawn to infer the field */
  polygon: Array<CoordinateInput>;
};

/**
 * CreateInferredFieldInput is used for create InferredField object.
 * Input was generated by ent.
 */
export type CreateInferredFieldInput = {
  /** Whether the user has accepted or rejected the inferred field */
  acceptanceStatus?: InputMaybe<InferredFieldAcceptanceStatus>;
  /** When the user set the acceptance status */
  acceptanceStatusSetAt?: InputMaybe<Scalars['Time']['input']>;
  evidenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name of the field (db column) that we inferred for the `target_id` object. If absent, evidence is for the entire object. */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fileID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  /** The object we inferred the field for */
  targetID: Scalars['String']['input'];
};

/**
 * CreateInsightsTemplateBundleConfigurationInput is used for create InsightsTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateInsightsTemplateBundleConfigurationInput = {
  /** If true, includes active insights in the insights bundle. */
  includeActiveInsights?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes completed insights in the insights bundle. */
  includeCompletedInsights?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes missing documents in the insights bundle. */
  includeMissingDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  templateBundleID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateInsurancePersonalAccountInput is used for create InsurancePersonalAccount object.
 * Input was generated by ent.
 */
export type CreateInsurancePersonalAccountInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryDesignationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The time at which the account's beneficiary designations were last reviewed/acknowledged. Used to suppress the 'no beneficiary designations' badge for accounts where the user has confirmed the empty state is intentional. */
  beneficiaryDesignationsReviewedAt?: InputMaybe<Scalars['Time']['input']>;
  controllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalBeneficiaryDesignationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
};

/**
 * CreateInsurancePolicyInput is used for create InsurancePolicy object.
 * Input was generated by ent.
 */
export type CreateInsurancePolicyInput = {
  carrierName?: InputMaybe<Scalars['String']['input']>;
  /** Only applicable for non-term policies */
  cashValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  cashValueDate?: InputMaybe<Scalars['Time']['input']>;
  /** Only applicable for term policies */
  conversionDate?: InputMaybe<Scalars['Time']['input']>;
  deathBenefitAmount: Scalars['CurrencyUSD']['input'];
  dispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  hypotheticalInsuranceID?: InputMaybe<Scalars['ID']['input']>;
  initialPremiumDueDate?: InputMaybe<Scalars['Time']['input']>;
  integrationInsuranceID?: InputMaybe<Scalars['ID']['input']>;
  kgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  kind: InsurancePolicyKind;
  /** Only applicable for non-term policies */
  loanBalanceOutstanding?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  policyHolderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  premiumAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumFrequency?: InputMaybe<InsurancePolicyPremiumFrequency>;
  premiumPaymentGiftingGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  premiumPaymentSourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  premiumPaymentSourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  /** The source of the premium payments. If not set, the waterfall will not process premium payments. */
  premiumPaymentSourceKind?: InputMaybe<InsurancePolicyPremiumPaymentSourceKind>;
  premiumPaymentSourceTestamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
  /** The type of transfer of the premium payment, for tax purposes. Required if the premium payment source kind is not SELF. */
  premiumPaymentTransferTaxKind?: InputMaybe<InsurancePolicyPremiumPaymentTransferTaxKind>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  /** Only applicable for non-term policies. Allows multiple holders. */
  survivorship?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only applicable for term policies */
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreateInsurancePremiumPaymentInput is used for create InsurancePremiumPayment object.
 * Input was generated by ent.
 */
export type CreateInsurancePremiumPaymentInput = {
  associatedTaskID?: InputMaybe<Scalars['ID']['input']>;
  documentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  dueOn?: InputMaybe<Scalars['Time']['input']>;
  householdID: Scalars['ID']['input'];
  paidOn?: InputMaybe<Scalars['Time']['input']>;
  policyID?: InputMaybe<Scalars['ID']['input']>;
  premiumAmount: Scalars['CurrencyUSD']['input'];
};

/**
 * CreateIntegrationAssetClassInput is used for create IntegrationAssetClass object.
 * Input was generated by ent.
 */
export type CreateIntegrationAssetClassInput = {
  assetClassID?: InputMaybe<Scalars['ID']['input']>;
  /** We use this to map this integration_asset_class to the provider's asset class name. This is imperfect, because if someone updates a name then we will make a new asset class and reconnect it. */
  integrationName: Scalars['String']['input'];
  provider: IntegrationAssetClassProvider;
};

/**
 * CreateIntegrationConfigurationInput is used for create IntegrationConfiguration object.
 * Input was generated by ent.
 */
export type CreateIntegrationConfigurationInput = {
  /** The client ID for the Addepar OAuth app. */
  addeparClientID?: InputMaybe<Scalars['String']['input']>;
  /** The client Secret for the Addepar OAuth app. */
  addeparClientSecret?: InputMaybe<Scalars['String']['input']>;
  addeparClientType?: InputMaybe<IntegrationConfigurationAddeparClientType>;
  /** If set, we will attempt to query this asset class as a property from Addepar and use it to populate IntegrationAssetClasses. */
  addeparCustomAssetClassName?: InputMaybe<Scalars['String']['input']>;
  /** If set, we will use this field as the attribute ID to set the custom asset name in Addepar. */
  addeparCustomAssetNameAPIField?: InputMaybe<Scalars['String']['input']>;
  /** Addepar attribute ID used to exclude holding accounts and securities when its value is yes or true, ignoring case. */
  addeparCustomExclusionAPIField?: InputMaybe<Scalars['String']['input']>;
  /** When true, requests the entities_write property for Addepar OAuth and syncs household summary values to integrated Addepar households/clients. */
  addeparEnableHouseholdSummarySync?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID for Addepar account. */
  addeparFirmID?: InputMaybe<Scalars['String']['input']>;
  addeparLookThroughCompositeSecurities?: InputMaybe<Scalars['Boolean']['input']>;
  /** The subdomain of the Addepar instance to connect to. */
  addeparSubdomain?: InputMaybe<Scalars['String']['input']>;
  /** Whether the tenant expects to use Black Diamond. We use this to expose prompts to users to authenticate to Black Diamond. */
  blackDiamondEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user-defined name for the source of the file valuation import. Exposed alongside the valuation to show where it came from. */
  csvValuationImportName?: InputMaybe<Scalars['String']['input']>;
  /** Whether the tenant expects to use eMoney. We use this to expose prompts to users to authenticate to eMoney. */
  emoneyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** true to enable customer-owned LLM providers */
  enableLlmByok?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the tenant expects to use the integration user for valuation syncing. */
  integrationUserEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the tenant expects to use Orion. We use this to expose prompts to users to authenticate to Orion. */
  orionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Legacy optional Snowflake assets view retained for API compatibility; integrations use SNOWFLAKE_ASSETS_VIEW */
  snowflakeDataSharingAssetsView?: InputMaybe<Scalars['String']['input']>;
  /** If snowflake_data_sharing_enabled=true, we will load customer asset data via this shared snowflake database */
  snowflakeDataSharingDatabase?: InputMaybe<Scalars['String']['input']>;
  /** true to enable customer data asset ingestion via snowflake data sharing */
  snowflakeDataSharingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If snowflake_data_sharing_enabled=true, we will load customer asset data using this tenant-specific snowflake role */
  snowflakeDataSharingRole?: InputMaybe<Scalars['String']['input']>;
  /** Legacy optional Snowflake schema retained for API compatibility; integrations use SNOWFLAKE_INTEGRATION_SCHEMA */
  snowflakeDataSharingSchema?: InputMaybe<Scalars['String']['input']>;
  /** Whether Snowflake household synchronization is enabled for this tenant */
  snowflakeHouseholdSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name to use for the snowflake integration (most customers do not know what snowflake is) */
  snowflakeIntegrationDisplayName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateIrrevocableTrustInput is used for create IrrevocableTrust object.
 * Input was generated by ent.
 */
export type CreateIrrevocableTrustInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  grantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  successorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  trustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateJointPersonalAccountInput is used for create JointPersonalAccount object.
 * Input was generated by ent.
 */
export type CreateJointPersonalAccountInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  controllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
  type?: InputMaybe<JointPersonalAccountType>;
};

/**
 * CreateKGRootInput is used for create KGRoot object.
 * Input was generated by ent.
 */
export type CreateKgRootInput = {
  aiSuggestionID?: InputMaybe<Scalars['ID']['input']>;
  aiSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  asyncJobID?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  fileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  /** What is this knowledge graph a representation of. */
  kind: KgRootKind;
  nodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The status of the construction of this KGRoot. It will be COMPLETE when the KGNodes have all been generated for the associated files and merged into the root. */
  status?: InputMaybe<KgRootStatus>;
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateKeyPersonInput is used for create KeyPerson object.
 * Input was generated by ent.
 */
export type CreateKeyPersonInput = {
  entityID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  individualID?: InputMaybe<Scalars['ID']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  roleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateKeyPersonRoleInput is used for create KeyPersonRole object.
 * Input was generated by ent.
 */
export type CreateKeyPersonRoleInput = {
  householdID: Scalars['ID']['input'];
  kind?: InputMaybe<KeyPersonRoleKind>;
};

/**
 * CreateLLCBusinessEntityInput is used for create LLCBusinessEntity object.
 * Input was generated by ent.
 */
export type CreateLlcBusinessEntityInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this business entity */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  keyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Ownership as-of date. */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
};

/**
 * CreateLPBusinessEntityInput is used for create LPBusinessEntity object.
 * Input was generated by ent.
 */
export type CreateLpBusinessEntityInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this business entity */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  keyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Ownership as-of date. */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
};

/**
 * CreateLiabilitiesBundleConfigurationInput is used for create LiabilitiesBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateLiabilitiesBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name for the liabilities bundle. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
};

/**
 * CreateLiabilityInput is used for create Liability object.
 * Input was generated by ent.
 */
export type CreateLiabilityInput = {
  currentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  currentAmountAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  displayName: Scalars['String']['input'];
  finalPaymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  householdID: Scalars['ID']['input'];
  initialAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  integrationLiabilityID?: InputMaybe<Scalars['ID']['input']>;
  interestPaid?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  interestRate?: InputMaybe<Scalars['Percent']['input']>;
  kgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  payFromEntityID?: InputMaybe<Scalars['ID']['input']>;
  paymentFrequency?: InputMaybe<LiabilityPaymentFrequency>;
  paymentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentKind?: InputMaybe<LiabilityPaymentKind>;
  recipientEntityID?: InputMaybe<Scalars['ID']['input']>;
  recurringPaymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  sourceClientOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  sourceClientProfileID?: InputMaybe<Scalars['ID']['input']>;
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  termEnd?: InputMaybe<Scalars['Time']['input']>;
  termStart?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateLifeInsuranceBundleConfigurationInput is used for create LifeInsuranceBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateLifeInsuranceBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name for the life insurance bundle. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
};

/**
 * CreateLifetimeExclusionEventInput is used for create LifetimeExclusionEvent object.
 * Input was generated by ent.
 */
export type CreateLifetimeExclusionEventInput = {
  /** The amount of annual exclusion this gift used */
  annualExclusionAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  associatedTaskID?: InputMaybe<Scalars['ID']['input']>;
  benefitOfID?: InputMaybe<Scalars['ID']['input']>;
  /** The amount of (implied) Connecticut exemption used */
  ctImpliedExemptionUsed?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The amount of Connecticut taxes paid for this gift */
  ctTaxesPaidAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** Amount asset was discounted for exclusion */
  discountAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  documentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The date of gifting or when the adjustment was recorded */
  eventDate: Scalars['Time']['input'];
  /** The amount gifted to the recipient */
  giftAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  giftCategory?: InputMaybe<LifetimeExclusionEventGiftCategory>;
  grantorID: Scalars['ID']['input'];
  /** The amount of GST exclusion this gift used */
  gstExclusionAmount: Scalars['CurrencyUSD']['input'];
  householdID: Scalars['ID']['input'];
  /** Whether or not this gift is subject to Connecticut state gift taxes */
  isSubjectToCtTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  kind: LifetimeExclusionEventKind;
  /** The amount of lifetime exclusion this gift used */
  lifetimeExclusionAmount: Scalars['CurrencyUSD']['input'];
  loggedTransferID?: InputMaybe<Scalars['ID']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  recipientID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateLoggedTransferInput is used for create LoggedTransfer object.
 * Input was generated by ent.
 */
export type CreateLoggedTransferInput = {
  /** The amount of logged transfer. */
  amount: Scalars['CurrencyUSD']['input'];
  associatedTaskID?: InputMaybe<Scalars['ID']['input']>;
  documentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  lifetimeExclusionEventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Custom purpose if "Other" purpose is selected. */
  otherPurposeDescription?: InputMaybe<Scalars['String']['input']>;
  /** Purpose of transfer */
  purpose?: InputMaybe<LoggedTransferPurpose>;
  receivingEntityID?: InputMaybe<Scalars['ID']['input']>;
  receivingGrantorID?: InputMaybe<Scalars['ID']['input']>;
  receivingOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceGrantorID?: InputMaybe<Scalars['ID']['input']>;
  sourceOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  transactionDate: Scalars['Time']['input'];
};

/**
 * Creates a LuminaryOrganization, its corresponding WorkOS organization, and
 * any initial routing domains.
 */
export type CreateLuminaryOrganizationInput = {
  /** Human-readable name used for both organizations. */
  displayName: Scalars['String']['input'];
  /** Initial email domains without the @ prefix. */
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Designates the singleton Luminary organization. Defaults to false; the
   * partial unique index permits at most one row with isLuminary = true.
   */
  isLuminary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether customer JIT access is enabled when the organization is created. */
  jitEnabled?: Scalars['Boolean']['input'];
  /** The organization's parent tenant. */
  parentTenant: CreateTenantInput;
};

/** Input for creating an immutable member tenant in an organization. */
export type CreateLuminaryOrganizationMemberTenantInput = {
  /** The new member tenant. */
  tenant: CreateTenantInput;
};

/** Result of coordinated organization and parent-tenant creation. */
export type CreateLuminaryOrganizationOutput = {
  __typename?: 'CreateLuminaryOrganizationOutput';
  organization: LuminaryOrganization;
  parentTenant: Tenant;
  workosOrganization: WorkOsOrganization;
};

/**
 * CreateLuminaryTenantJITInput is used for create LuminaryTenantJIT object.
 * Input was generated by ent.
 */
export type CreateLuminaryTenantJitInput = {
  /** When this JIT grant expires. NULL = no expiry (internal/demo). Paid tenants typically set this during onboarding. */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  tenantID: Scalars['ID']['input'];
};

/**
 * CreateMemoInput is used for create Memo object.
 * Input was generated by ent.
 */
export type CreateMemoInput = {
  /** User feedback for AI-generated memo quality */
  aiFeedback?: InputMaybe<Scalars['String']['input']>;
  /** User rating for AI-generated memo quality */
  aiRating?: InputMaybe<MemoAiRating>;
  documentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether the memo was AI-generated or user-authored */
  entryMode?: InputMaybe<MemoEntryMode>;
  feedbackFromID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  memoPromptID?: InputMaybe<Scalars['ID']['input']>;
  /** User-editable memo name */
  name: Scalars['String']['input'];
  /** User-provided instructions used for generation */
  specificInstructions?: InputMaybe<Scalars['String']['input']>;
  workflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * This input is used to create a missing document override for a household and document type.
 * Creates the override only if it doesn't already exist and associates an optional client profile.
 */
export type CreateMissingDocumentOverrideInput = {
  clientProfileID?: InputMaybe<Scalars['ID']['input']>;
  documentType: MissingDocumentOverrideDocumentType;
  householdID: Scalars['ID']['input'];
};

/**
 * CreateMissingDocumentsPageInput is used for create MissingDocumentsPage object.
 * Input was generated by ent.
 */
export type CreateMissingDocumentsPageInput = {
  householdID: Scalars['ID']['input'];
  presentationPageID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateModelMappingInput is used for create ModelMapping object.
 * Input was generated by ent.
 */
export type CreateModelMappingInput = {
  /** The model name (e.g. gpt-4, claud-3-opus) */
  modelName: Scalars['String']['input'];
  modelPurpose: ModelMappingModelPurpose;
};

export type CreateNewClientProfileRelationshipInput = {
  toClientProfileID: Scalars['ID']['input'];
  type: ClientProfileRelationshipType;
};

/**
 * CreateOpenaiSdkConfigInput is used for create OpenaiSdkConfig object.
 * Input was generated by ent.
 */
export type CreateOpenaiSdkConfigInput = {
  /** The API key for the provider. */
  apiKey: Scalars['String']['input'];
  /** The base URL for the provider API. */
  baseURL?: InputMaybe<Scalars['String']['input']>;
  /** true to enable 'bring your own model provider' */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  modelMappingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  provider: OpenaiSdkConfigProvider;
};

/**
 * CreateOrganizationDisclaimerConfigurationInput is used for create OrganizationDisclaimerConfiguration object.
 * Input was generated by ent.
 */
export type CreateOrganizationDisclaimerConfigurationInput = {
  /** If true, include the default Luminary company disclosures in the presentation */
  includeLuminaryDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  presentationCoverDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationCoverDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
  presentationFooterDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationFooterDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
  presentationStandaloneDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationStandaloneDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateOwnershipStakeInput is used for create OwnershipStake object.
 * Input was generated by ent.
 */
export type CreateOwnershipStakeInput = {
  dispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  ownedEntityID?: InputMaybe<Scalars['ID']['input']>;
  /** The percentage ownership of the underlying entity. */
  ownershipPercentage?: InputMaybe<Scalars['Percent']['input']>;
  owningEntityID?: InputMaybe<Scalars['ID']['input']>;
  owningIndividualID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreatePlatformDocumentInput is used for create PlatformDocument object.
 * Input was generated by ent.
 */
export type CreatePlatformDocumentInput = {
  jurisdictionKind: PlatformDocumentJurisdictionKind;
  /** Descriptive source context. Fields that control application behavior use typed columns. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  sourceFileID: Scalars['ID']['input'];
  sourceVersion?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<PlatformDocumentStateCode>;
};

/**
 * CreatePresentationAssetDistributionBundleConfigurationInput is used for create PresentationAssetDistributionBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationAssetDistributionBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** Display label indicating the death-order context for this distribution (e.g., 'After John's death' or 'After both deaths'). */
  deathOrderDisplay: Scalars['String']['input'];
  /** Prose description of the distribution scenario rendered beneath the page heading. */
  description: Scalars['String']['input'];
  /** Optional override for the bundle's display name on the asset-distribution page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  distributionItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  /** Maximum number of distribution items rendered on each page. */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationAssetDistributionItemConfigurationInput is used for create PresentationAssetDistributionItemConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationAssetDistributionItemConfigurationInput = {
  bundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name of the distribution item as it should appear on the page. */
  displayName: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
  itemDetailIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The order in which this distribution item is rendered within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationAssetDistributionItemDetailInput is used for create PresentationAssetDistributionItemDetail object.
 * Input was generated by ent.
 */
export type CreatePresentationAssetDistributionItemDetailInput = {
  /** Body text rendered for the item. */
  body: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
  itemConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** Short label rendered above the item body. */
  label: Scalars['String']['input'];
  /** The order in which this item is rendered within its parent. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationBundleCoverPageInput is used for create PresentationBundleCoverPage object.
 * Input was generated by ent.
 */
export type CreatePresentationBundleCoverPageInput = {
  /** The content of the cover page. */
  content: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
};

/**
 * CreatePresentationBundleInput is used for create PresentationBundle object.
 * Input was generated by ent.
 */
export type CreatePresentationBundleInput = {
  assetDistributionBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  balanceSheetBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  beneficiariesBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  businessOverviewBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  clientPresentationV2ID?: InputMaybe<Scalars['ID']['input']>;
  coverPageConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  customPageBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  dividerBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  documentsReviewedBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  entitiesOverviewBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  entityGraphViewBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  entitySummaryBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  estateInsightsBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** will not be included in printed output if true */
  excludeFromOutput?: InputMaybe<Scalars['Boolean']['input']>;
  /** Per-instance context prepended to runtime page prompts for expanded bundles. */
  expansionContext?: InputMaybe<Scalars['String']['input']>;
  familyOverviewBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  familyTreeBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  healthcareDirectiveBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** The index of the bundle in the presentation */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates the kind of bundle this is. */
  kind: PresentationBundleKind;
  liabilitiesBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  lifeInsuranceBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  pageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  planningOpportunitiesBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  powerOfAttorneyBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  sourceTemplateBundleID?: InputMaybe<Scalars['ID']['input']>;
  /** Notes to advisors on how to use the bundle */
  templateNotes?: InputMaybe<Scalars['String']['input']>;
  trustOverviewBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  waterfallBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  waterfallComparisonBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  willBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreatePresentationBusinessOverviewBundleConfigurationInput is used for create PresentationBusinessOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationBusinessOverviewBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  businessIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional override for the bundle's display name on the business-overview page. CMK-encrypted. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  /** Maximum number of businesses rendered on each page. */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationBusinessOverviewBusinessConfigurationInput is used for create PresentationBusinessOverviewBusinessConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationBusinessOverviewBusinessConfigurationInput = {
  bundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  businessItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The display name of the business as it should appear on the page. CMK-encrypted. */
  displayName: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
  /** The order in which this business is rendered within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationBusinessOverviewItemInput is used for create PresentationBusinessOverviewItem object.
 * Input was generated by ent.
 */
export type CreatePresentationBusinessOverviewItemInput = {
  /** Body text rendered for the item. */
  body: Scalars['String']['input'];
  businessConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** Short label rendered above the item body. */
  label: Scalars['String']['input'];
  /** The order in which this item is rendered within its parent. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationCoverPageInput is used for create PresentationCoverPage object.
 * Input was generated by ent.
 */
export type CreatePresentationCoverPageInput = {
  /** The content of the cover page, rendered as Markdown. */
  customContent?: InputMaybe<Scalars['String']['input']>;
  /** Prompt used to generate the custom content. */
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Customizable title to display on the cover page. */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  pageID?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePresentationCoverSlideBackgroundImageInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentsSha256: Scalars['String']['input'];
};

/**
 * CreatePresentationCustomPageBundleConfigurationInput is used for create PresentationCustomPageBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationCustomPageBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** If true, the page header and sub-header will be included on the page. */
  includePageHeader?: InputMaybe<Scalars['Boolean']['input']>;
  /** The header to display on the page. */
  pageHeader?: InputMaybe<Scalars['String']['input']>;
  /** The sub-header to display on the page. */
  pageSubheader?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreatePresentationCustomPageInput is used for create PresentationCustomPage object.
 * Input was generated by ent.
 */
export type CreatePresentationCustomPageInput = {
  /** Prompt used to generate the page content. */
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  /** The content of a MARKDOWN custom page, rendered as Markdown. CANVAS pages store an empty string. */
  pageContent: Scalars['String']['input'];
  pageID?: InputMaybe<Scalars['ID']['input']>;
  /** The title to display on the custom page. */
  pageName: Scalars['String']['input'];
};

/**
 * CreatePresentationDiagramPageInput is used for create PresentationDiagramPage object.
 * Input was generated by ent.
 */
export type CreatePresentationDiagramPageInput = {
  /** Prompt used to generate/update the diagram. */
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Canonical edge definitions for the diagram graph. */
  edgeDefinitions?: InputMaybe<Array<PresentationDiagramEdgeDefinitionInput>>;
  householdID: Scalars['ID']['input'];
  /** Canonical node definitions plus layout settings for the diagram graph. */
  nodeConfigurations?: InputMaybe<Array<PresentationDiagramNodeConfigurationInput>>;
  pageID?: InputMaybe<Scalars['ID']['input']>;
  /** The title to display on the diagram page. */
  pageName: Scalars['String']['input'];
  /** Optional life-event eras (phase bands) structuring the diagram top-to-bottom. */
  phases?: InputMaybe<PresentationDiagramPhasesInput>;
};

/**
 * CreatePresentationDocumentsReviewedBundleConfigurationInput is used for create PresentationDocumentsReviewedBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationDocumentsReviewedBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** Optional override for the bundle's display name on the documents-reviewed page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  reviewedDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreatePresentationDocumentsReviewedDocumentInput is used for create PresentationDocumentsReviewedDocument object.
 * Input was generated by ent.
 */
export type CreatePresentationDocumentsReviewedDocumentInput = {
  bundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** Pre-formatted date label rendered alongside the document name. */
  dateDisplay: Scalars['String']['input'];
  documentID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name of the reviewed document. */
  documentName: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
  /** The order in which this document should be displayed within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationFamilyOverviewBundleConfigurationInput is used for create PresentationFamilyOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationFamilyOverviewBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** Optional override for the bundle's display name on the family-overview page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  memberIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreatePresentationFamilyOverviewMemberConfigurationInput is used for create PresentationFamilyOverviewMemberConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationFamilyOverviewMemberConfigurationInput = {
  bundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** A short prose description of the family member rendered beneath the name and relationship. */
  description: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
  /** The display name of the family member as it should appear on the page. */
  name: Scalars['String']['input'];
  /** The family member's relationship to the household (e.g., 'Spouse', 'Daughter'). */
  relationship: Scalars['String']['input'];
  /** The order in which this family member is rendered within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationHealthcareDirectiveBundleConfigurationInput is used for create PresentationHealthcareDirectiveBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationHealthcareDirectiveBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  clientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional override for the bundle's display name on the healthcare-directive page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  /** Maximum number of clients rendered on each page. */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationHealthcareDirectiveClientConfigurationInput is used for create PresentationHealthcareDirectiveClientConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationHealthcareDirectiveClientConfigurationInput = {
  bundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name of the client as it should appear on the page. */
  client: Scalars['String']['input'];
  healthcareDirectiveItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  /** The order in which this client is rendered within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationHealthcareDirectiveItemInput is used for create PresentationHealthcareDirectiveItem object.
 * Input was generated by ent.
 */
export type CreatePresentationHealthcareDirectiveItemInput = {
  /** Body text rendered for the item. */
  body: Scalars['String']['input'];
  clientConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** Short label rendered above the item body. */
  label: Scalars['String']['input'];
  /** The order in which this item is rendered within its parent. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationItemCitationInput is used for create PresentationItemCitation object.
 * Input was generated by ent.
 */
export type CreatePresentationItemCitationInput = {
  documentID: Scalars['ID']['input'];
  fileParagraphIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
};

/**
 * CreatePresentationPageInput is used for create PresentationPage object.
 * Input was generated by ent.
 */
export type CreatePresentationPageInput = {
  activeEstateInsightsPageID?: InputMaybe<Scalars['ID']['input']>;
  balanceSheetBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  beneficiaryPageID?: InputMaybe<Scalars['ID']['input']>;
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  completedEstateInsightsPageID?: InputMaybe<Scalars['ID']['input']>;
  coverPageID?: InputMaybe<Scalars['ID']['input']>;
  customPageID?: InputMaybe<Scalars['ID']['input']>;
  diagramPageID?: InputMaybe<Scalars['ID']['input']>;
  documentSummaryPageID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** The index of the page in the bundle */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates the kind of page this is. */
  kind: PresentationPageKind;
  missingDocumentsPageID?: InputMaybe<Scalars['ID']['input']>;
  presentationBundleCoverPageID?: InputMaybe<Scalars['ID']['input']>;
  waterfallBundleCoverPageID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreatePresentationPlanningOpportunitiesBundleConfigurationInput is used for create PresentationPlanningOpportunitiesBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationPlanningOpportunitiesBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** Optional override for the bundle's display name on the planning-opportunities page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  itemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreatePresentationPlanningOpportunitiesItemInput is used for create PresentationPlanningOpportunitiesItem object.
 * Input was generated by ent.
 */
export type CreatePresentationPlanningOpportunitiesItemInput = {
  /** DEPRECATED: use the section-specific *_body fields instead. */
  body?: InputMaybe<Scalars['String']['input']>;
  bundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** DEPRECATED: use the section-specific *_label fields instead. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Body text for the next step section of the item. */
  nextStepBody?: InputMaybe<Scalars['String']['input']>;
  /** Short label for the next step section of the item. */
  nextStepLabel?: InputMaybe<Scalars['String']['input']>;
  /** Body text for the opportunity section of the item. */
  opportunityBody?: InputMaybe<Scalars['String']['input']>;
  /** Short label for the opportunity section of the item. */
  opportunityLabel?: InputMaybe<Scalars['String']['input']>;
  /** Body text for the rationale section of the item. */
  rationaleBody?: InputMaybe<Scalars['String']['input']>;
  /** Short label for the rationale section of the item. */
  rationaleLabel?: InputMaybe<Scalars['String']['input']>;
  /** The order in which this item is rendered within its parent. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationPowerOfAttorneyBundleConfigurationInput is used for create PresentationPowerOfAttorneyBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationPowerOfAttorneyBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  clientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional override for the bundle's display name on the powers-of-attorney page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  /** Maximum number of clients rendered on each page. */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationPowerOfAttorneyClientConfigurationInput is used for create PresentationPowerOfAttorneyClientConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationPowerOfAttorneyClientConfigurationInput = {
  bundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name of the client as it should appear on the page. */
  client: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
  powerOfAttorneyItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The order in which this client is rendered within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationPowerOfAttorneyItemInput is used for create PresentationPowerOfAttorneyItem object.
 * Input was generated by ent.
 */
export type CreatePresentationPowerOfAttorneyItemInput = {
  /** Body text rendered for the item. */
  body: Scalars['String']['input'];
  clientConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** Short label rendered above the item body. */
  label: Scalars['String']['input'];
  /** The order in which this item is rendered within its parent. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationTemplateBundleInput is used for create PresentationTemplateBundle object.
 * Input was generated by ent.
 */
export type CreatePresentationTemplateBundleInput = {
  /** Firm-authored instructions appended to the built-in AI generation prompt for this bundle. Only DIAGRAM_BUNDLE (the Estate 360 asset distribution diagram) reads this value. */
  additionalPromptContext?: InputMaybe<Scalars['String']['input']>;
  beneficiariesTemplateBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  dividerTemplateBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  documentSummaryTemplateBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  entitySummaryTemplateBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** will not be included in printed output if true */
  excludeFromOutput?: InputMaybe<Scalars['Boolean']['input']>;
  /** Controls whether the template bundle expands into one runtime bundle or a planned set of runtime bundles. */
  expansionMode?: InputMaybe<PresentationTemplateBundleExpansionMode>;
  /** Instructions for planning 0..N runtime bundle instances when expansion_mode is PLANNED. */
  expansionPrompt?: InputMaybe<Scalars['String']['input']>;
  /** The index of the bundle in the presentation */
  index?: InputMaybe<Scalars['Int']['input']>;
  insightsTemplateBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  kind: PresentationBundleKind;
  pageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  presentationTemplateID?: InputMaybe<Scalars['ID']['input']>;
  runtimeBundleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Notes to advisors on how to use the bundle */
  templateNotes?: InputMaybe<Scalars['String']['input']>;
  waterfallComparisonTemplateBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  waterfallTemplateBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreatePresentationTemplateCoverPageInput is used for create PresentationTemplateCoverPage object.
 * Input was generated by ent.
 */
export type CreatePresentationTemplateCoverPageInput = {
  /** The content of the cover page, rendered as Markdown. */
  customContent?: InputMaybe<Scalars['String']['input']>;
  /** Prompt used to generate the custom content. */
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Customizable title to display on the cover page. */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  templatePageID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreatePresentationTemplateCustomPageInput is used for create PresentationTemplateCustomPage object.
 * Input was generated by ent.
 */
export type CreatePresentationTemplateCustomPageInput = {
  /** Prompt used to generate the page content. */
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include the page header on the custom page. */
  includePageHeader?: InputMaybe<Scalars['Boolean']['input']>;
  /** The content of a MARKDOWN custom page, rendered as Markdown. CANVAS pages store an empty string. */
  pageContent: Scalars['String']['input'];
  /** The header to display on the custom page. */
  pageHeader?: InputMaybe<Scalars['String']['input']>;
  /** The title to display on the custom page. */
  pageName: Scalars['String']['input'];
  /** The subheader to display on the custom page. */
  pageSubheader?: InputMaybe<Scalars['String']['input']>;
  templatePageID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreatePresentationTemplateDiagramPageInput is used for create PresentationTemplateDiagramPage object.
 * Input was generated by ent.
 */
export type CreatePresentationTemplateDiagramPageInput = {
  /** Prompt used to generate the diagram when materializing this template. */
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  /** The title to display on the diagram page. */
  pageName: Scalars['String']['input'];
  templatePageID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreatePresentationTemplateInput is used for create PresentationTemplate object.
 * Input was generated by ent.
 */
export type CreatePresentationTemplateInput = {
  bundleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  displayName: Scalars['String']['input'];
  /** Whether this template is the tenant's default presentation template. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this template is available as a pinned presentation template. */
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  type: PresentationTemplateType;
};

/**
 * CreatePresentationTemplatePageInput is used for create PresentationTemplatePage object.
 * Input was generated by ent.
 */
export type CreatePresentationTemplatePageInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  coverPageID?: InputMaybe<Scalars['ID']['input']>;
  customPageID?: InputMaybe<Scalars['ID']['input']>;
  diagramPageID?: InputMaybe<Scalars['ID']['input']>;
  /** The index of the page in the bundle */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates the kind of page this is. */
  kind: PresentationPageKind;
};

/**
 * CreatePresentationTrustOverviewBundleConfigurationInput is used for create PresentationTrustOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationTrustOverviewBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** Optional override for the bundle's display name on the trust-overview page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  /** Maximum number of trusts rendered on each page. */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  trustIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreatePresentationTrustOverviewItemInput is used for create PresentationTrustOverviewItem object.
 * Input was generated by ent.
 */
export type CreatePresentationTrustOverviewItemInput = {
  /** Body text rendered for the item. */
  body: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
  /** Short label rendered above the item body. */
  label: Scalars['String']['input'];
  /** The order in which this item is rendered within its parent. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  trustConfigurationID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreatePresentationTrustOverviewTrustConfigurationInput is used for create PresentationTrustOverviewTrustConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationTrustOverviewTrustConfigurationInput = {
  bundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name of the trust as it should appear on the page. */
  displayName: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
  /** The order in which this trust is rendered within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  trustItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreatePresentationWillBundleConfigurationInput is used for create PresentationWillBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationWillBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  clientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional override for the bundle's display name on the wills page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  /** Maximum number of clients rendered on each page. */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePresentationWillClientConfigurationInput is used for create PresentationWillClientConfiguration object.
 * Input was generated by ent.
 */
export type CreatePresentationWillClientConfigurationInput = {
  bundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name of the client as it should appear on the page. */
  client: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
  /** The order in which this client is rendered within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  willItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreatePresentationWillItemInput is used for create PresentationWillItem object.
 * Input was generated by ent.
 */
export type CreatePresentationWillItemInput = {
  /** Body text rendered for the item. */
  body: Scalars['String']['input'];
  clientConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** Short label rendered above the item body. */
  label: Scalars['String']['input'];
  /** The order in which this item is rendered within its parent. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreatePrincipalInput is used for create Principal object.
 * Input was generated by ent.
 */
export type CreatePrincipalInput = {
  householdID: Scalars['ID']['input'];
  individualID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The percentage ownership of the underlying entity, funded by these principals.
   * 			Typically only valid for multiple ownership, non-trust non-charitable entities (eg: LLC, LP, ...)
   */
  ownershipPercentage?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * CreatePrivateFoundationInput is used for create PrivateFoundation object.
 * Input was generated by ent.
 */
export type CreatePrivateFoundationInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  controllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  donorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
};

/**
 * CreateProfessionalTeamRoleInput is used for create ProfessionalTeamRole object.
 * Input was generated by ent.
 */
export type CreateProfessionalTeamRoleInput = {
  associatedClientIndividualID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  individualID?: InputMaybe<Scalars['ID']['input']>;
  kind: ProfessionalTeamRoleKind;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  /** If the kind is OTHER, this is the custom role name */
  otherRoleName?: InputMaybe<Scalars['String']['input']>;
  /** If the kind is POWER_OF_ATTORNEY, this is the type of power of attorney */
  powerOfAttorneyKind?: InputMaybe<ProfessionalTeamRolePowerOfAttorneyKind>;
};

/**
 * CreateProposalInput is used for create Proposal object.
 * Input was generated by ent.
 */
export type CreateProposalInput = {
  /** notes to the client that accompany the proposal */
  clientNotes: Scalars['String']['input'];
  cltProposalID?: InputMaybe<Scalars['ID']['input']>;
  crtProposalID?: InputMaybe<Scalars['ID']['input']>;
  /** the user-friendly name of the proposal */
  displayName: Scalars['String']['input'];
  entityProposalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  giftingProposalID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** whether or not to include a "cumulative view" tab on the proposal */
  includeCumulativeView: Scalars['Boolean']['input'];
};

/**
 * CreateProposalScenarioInput is used for create ProposalScenario object.
 * Input was generated by ent.
 */
export type CreateProposalScenarioInput = {
  gratProposalScenarioID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
};

/**
 * CreateQPRTTrustInput is used for create QPRTTrust object.
 * Input was generated by ent.
 */
export type CreateQprtTrustInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  grantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  officialInterestRatePercent?: InputMaybe<Scalars['Percent']['input']>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  successorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  /** The actual taxable gift that was recorded for this QPRT */
  taxableGift?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  terminationDate?: InputMaybe<Scalars['Time']['input']>;
  trustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateQualifiedTuitionPersonalAccountInput is used for create QualifiedTuitionPersonalAccount object.
 * Input was generated by ent.
 */
export type CreateQualifiedTuitionPersonalAccountInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  controllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
};

/**
 * This input is used to create a relationship between an entity and a document,
 * when the document is being created. At this time, we do not have the documentID,
 * so this input type is the same as CreateEntityDocumentRelationshipInput, just
 * without the required documentID field.
 */
export type CreateRelationshipWithEntityInput = {
  entityID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  relationshipType: EntityDocumentRelationshipRelationshipType;
  suggestionPrecedenceOrder?: InputMaybe<Scalars['Int']['input']>;
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateRetirementPersonalAccountInput is used for create RetirementPersonalAccount object.
 * Input was generated by ent.
 */
export type CreateRetirementPersonalAccountInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryDesignationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The time at which the account's beneficiary designations were last reviewed/acknowledged. Used to suppress the 'no beneficiary designations' badge for accounts where the user has confirmed the empty state is intentional. */
  beneficiaryDesignationsReviewedAt?: InputMaybe<Scalars['Time']['input']>;
  beneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  controllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The custodian institution that holds this retirement account. */
  custodian?: InputMaybe<Scalars['String']['input']>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalBeneficiaryDesignationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
  type?: InputMaybe<RetirementPersonalAccountType>;
};

/**
 * CreateRevocableTrustInput is used for create RevocableTrust object.
 * Input was generated by ent.
 */
export type CreateRevocableTrustInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  grantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  successorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  trustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateRoleInput is used for create Role object.
 * Input was generated by ent.
 */
export type CreateRoleInput = {
  capabilityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  collaboratorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  displayName: Scalars['String']['input'];
  employeeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * ADMINISTRATOR roles are assigned to administrators, and are not editable.
   * COLLABORATOR roles are assigned to collaborators, and are not editable.
   * CUSTOM roles are editable, even the initially-populated roles.
   */
  kind?: InputMaybe<RoleKind>;
  slug: Scalars['String']['input'];
};

/**
 * CreateSCorpBusinessEntityInput is used for create SCorpBusinessEntity object.
 * Input was generated by ent.
 */
export type CreateSCorpBusinessEntityInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this business entity */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  keyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Ownership as-of date. */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
};

/**
 * CreateSLATTrustInput is used for create SLATTrust object.
 * Input was generated by ent.
 */
export type CreateSlatTrustInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  grantorID?: InputMaybe<Scalars['ID']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  lifetimeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  remainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  successorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  trustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateSSOConnectionInput is used for create SSOConnection object.
 * Input was generated by ent.
 */
export type CreateSsoConnectionInput = {
  /** A list of email domains that are allowed to use this SSO connection. Do not include the @ symbol. */
  boundEmailDomains: Array<Scalars['String']['input']>;
  configuredTenantIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name of the SSO connection. */
  displayName: Scalars['String']['input'];
  /** Special designator for the Luminary sso connection */
  isLuminary?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the WorkOS organization this SSO connection corresponds to. */
  workosOrganizationID: Scalars['String']['input'];
};

/**
 * CreateScheduledDistributionInput is used for create ScheduledDistribution object.
 * Input was generated by ent.
 */
export type CreateScheduledDistributionInput = {
  /** The end of the age requirement for this distribution */
  ageRequirementEnd?: InputMaybe<Scalars['Int']['input']>;
  /** The start of the age requirement for this distribution */
  ageRequirementStart?: InputMaybe<Scalars['Int']['input']>;
  /** The AMOUNT kind of distribution. Only valid when kind is AMOUNT */
  amount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  beneficiaryID?: InputMaybe<Scalars['ID']['input']>;
  /** The frequency of the distribution to beneficiaries */
  frequency?: InputMaybe<ScheduledDistributionFrequency>;
  /** If true, the distribution will grow by the inflation rate specified in the growth profile.Only applicable if the distribution is kind AMOUNT. */
  growByInflation?: InputMaybe<Scalars['Boolean']['input']>;
  householdID: Scalars['ID']['input'];
  /** The kind of scheduled distribution */
  kind: ScheduledDistributionKind;
  /** The percentage of the distribution. Only valid when kind is PERCENTAGE or ALL_INCOME */
  percentage?: InputMaybe<Scalars['Percent']['input']>;
  /** The notes for the scheduled distribution */
  scheduledDistributionNotes?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateSoleProprietorshipBusinessEntityInput is used for create SoleProprietorshipBusinessEntity object.
 * Input was generated by ent.
 */
export type CreateSoleProprietorshipBusinessEntityInput = {
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this business entity */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  keyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Ownership as-of date. */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
};

/**
 * CreateSubBrandDisclaimerConfigurationInput is used for create SubBrandDisclaimerConfiguration object.
 * Input was generated by ent.
 */
export type CreateSubBrandDisclaimerConfigurationInput = {
  /** If true, include the default Luminary company disclosures in the presentation */
  includeLuminaryDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  presentationCoverDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationCoverDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
  presentationFooterDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationFooterDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
  presentationStandaloneDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationStandaloneDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
  subBrandID: Scalars['ID']['input'];
};

/**
 * CreateSubBrandInput is used for create SubBrand object.
 * Input was generated by ent.
 */
export type CreateSubBrandInput = {
  buttonsLinkColor: Scalars['String']['input'];
  darkSquareLogoURL?: InputMaybe<Scalars['String']['input']>;
  darkWideLogoURL?: InputMaybe<Scalars['String']['input']>;
  dataVisualizationNegativeColor?: InputMaybe<Scalars['String']['input']>;
  dataVisualizationPrimaryColor: Scalars['String']['input'];
  dataVisualizationSecondaryColor: Scalars['String']['input'];
  dataVisualizationTertiaryColor?: InputMaybe<Scalars['String']['input']>;
  disclaimerConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  displayName: Scalars['String']['input'];
  householdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  logoURL: Scalars['String']['input'];
  presentationCoverSlideConfigID?: InputMaybe<Scalars['ID']['input']>;
  presentationDividerSlideConfigID?: InputMaybe<Scalars['ID']['input']>;
  /** Font face for presentation headers and cover/divider slides. */
  presentationHeaderFontFace?: InputMaybe<PresentationHeaderFontFace>;
  primaryColor: Scalars['String']['input'];
  secondaryColor: Scalars['String']['input'];
};

/**
 * CreateTaxDragConfigInput is used for create TaxDragConfig object.
 * Input was generated by ent.
 */
export type CreateTaxDragConfigInput = {
  /** The method used to determine the tax drag percentage. */
  calculationMethod: TaxDragConfigCalculationMethod;
  /** The federal ordinary income tax rate used for a computed tax drag. */
  federalIncomeTaxRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The federal long-term capital gains tax rate used for a computed tax drag. */
  federalLongTermCapitalGainsRate?: InputMaybe<Scalars['Percent']['input']>;
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** The share of investment return treated as long-term capital gains. */
  longTermCapitalGainReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** Whether the computed tax drag includes net investment income tax. */
  niitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The share of investment return treated as ordinary income. */
  ordinaryIncomeReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** The share of investment return treated as qualified dividends. */
  qualifiedDividendReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** The state ordinary income tax rate used for a computed tax drag. */
  stateIncomeTaxRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The state long-term capital gains tax rate used for a computed tax drag. */
  stateLongTermCapitalGainsRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The manual or server-computed effective tax drag percentage. */
  taxDragPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** The share of investment return treated as tax-free income. */
  taxFreeIncomeReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * CreateTaxDragOverrideInput is used for create TaxDragOverride object.
 * Input was generated by ent.
 */
export type CreateTaxDragOverrideInput = {
  /** The method used to determine the tax drag percentage. */
  calculationMethod: TaxDragOverrideCalculationMethod;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** The federal ordinary income tax rate used for a computed tax drag. */
  federalIncomeTaxRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The federal long-term capital gains tax rate used for a computed tax drag. */
  federalLongTermCapitalGainsRate?: InputMaybe<Scalars['Percent']['input']>;
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** The share of investment return treated as long-term capital gains. */
  longTermCapitalGainReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** Whether the computed tax drag includes net investment income tax. */
  niitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The share of investment return treated as ordinary income. */
  ordinaryIncomeReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  proposalID?: InputMaybe<Scalars['ID']['input']>;
  /** The share of investment return treated as qualified dividends. */
  qualifiedDividendReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** The state ordinary income tax rate used for a computed tax drag. */
  stateIncomeTaxRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The state long-term capital gains tax rate used for a computed tax drag. */
  stateLongTermCapitalGainsRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The manual or server-computed effective tax drag percentage. */
  taxDragPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** The share of investment return treated as tax-free income. */
  taxFreeIncomeReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * CreateTeamInput is used for create Team object.
 * Input was generated by ent.
 */
export type CreateTeamInput = {
  assignedHouseholdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  childIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  employeeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  parentID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateTenantBrandingInput is used for create TenantBranding object.
 * Input was generated by ent.
 */
export type CreateTenantBrandingInput = {
  buttonsLinkColor: Scalars['String']['input'];
  darkSquareLogoURL?: InputMaybe<Scalars['String']['input']>;
  darkWideLogoURL?: InputMaybe<Scalars['String']['input']>;
  dataVisualizationNegativeColor?: InputMaybe<Scalars['String']['input']>;
  dataVisualizationPrimaryColor: Scalars['String']['input'];
  dataVisualizationSecondaryColor: Scalars['String']['input'];
  dataVisualizationTertiaryColor?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  logoURL: Scalars['String']['input'];
  /** Font face for presentation headers and cover/divider slides. */
  presentationHeaderFontFace?: InputMaybe<PresentationHeaderFontFace>;
  primaryColor: Scalars['String']['input'];
  secondaryColor: Scalars['String']['input'];
  tenantID: Scalars['ID']['input'];
};

export type CreateTenantBrandingLogoInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentsSha256: Scalars['String']['input'];
};

/**
 * CreateTenantDocumentInput is used for create TenantDocument object.
 * Input was generated by ent.
 */
export type CreateTenantDocumentInput = {
  name: Scalars['String']['input'];
  pdfFileID?: InputMaybe<Scalars['ID']['input']>;
  sourceFileID: Scalars['ID']['input'];
  status?: InputMaybe<TenantDocumentStatus>;
};

/**
 * CreateTenantInput is used for create Tenant object.
 * Input was generated by ent.
 */
export type CreateTenantInput = {
  /** Whether the tenant has the asset provider integration addon enabled. */
  addonAssetProviderIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  brandingID?: InputMaybe<Scalars['ID']['input']>;
  /** WARNING: FOR ANALYTICS/REPORTING ONLY. NOT FOR BUSINESS LOGIC. The date the contract started. */
  contractStartDate?: InputMaybe<Scalars['Time']['input']>;
  kind: TenantKind;
  /** NOTE: Name is only used to initialize the tenant name. It is not used for display purposes. Use the TenantBranding.DisplayName property instead. */
  name: Scalars['String']['input'];
  /** The product tier for this tenant. */
  productTier?: InputMaybe<TenantProductTier>;
  ssoConnectionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  subdomain: Scalars['String']['input'];
  /** The date when the tenant's trial period ends. */
  trialEndDate?: InputMaybe<Scalars['Time']['input']>;
  /** WARNING: FOR ANALYTICS/REPORTING ONLY. NOT FOR BUSINESS LOGIC. This is the bucket that the tenant falls into for usage tracking. */
  usageBucket?: InputMaybe<TenantUsageBucket>;
  /** The WorkOS directory id, if directory sync is enabled for this workos organization */
  workosDirectoryID?: InputMaybe<Scalars['String']['input']>;
  /** The WorkOS M2M application client_id for this tenant. When set, M2M access tokens must carry an app_client_id claim matching this value. */
  workosM2mClientID?: InputMaybe<Scalars['String']['input']>;
  /** The WorkOS Connect (OAuth) application client_id for this tenant. When set, Connect access tokens must carry an app_client_id claim matching this value. */
  workosOauthClientID?: InputMaybe<Scalars['String']['input']>;
  /** The corresponding WorkOS organization ID for this tenant. */
  workosOrganizationID?: InputMaybe<Scalars['String']['input']>;
  /** The WorkOS updated_at timestamp */
  workosUpdatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateTenantSSOConnectionInput is used for create TenantSSOConnection object.
 * Input was generated by ent.
 */
export type CreateTenantSsoConnectionInput = {
  enableJIT?: InputMaybe<Scalars['Boolean']['input']>;
  /** The time at which JIT was enabled for this tenant. If null, JIT is disabled. JIT means that users will be created on the fly when they sign in with SSO. */
  jitEnabledAt?: InputMaybe<Scalars['Time']['input']>;
  ssoConnectionID: Scalars['ID']['input'];
};

/**
 * CreateTenantSlideConfigInput is used for create TenantSlideConfig object.
 * Input was generated by ent.
 */
export type CreateTenantSlideConfigInput = {
  /** The type of slide configuration */
  configType: TenantSlideConfigConfigType;
  /** Custom slide content in JSON format with versioned block structure */
  contentJSON: Scalars['Map']['input'];
  /** Display name for the slide (for admin UI organization and custom template titles) */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** When true, this slide will not be available to use in presentations */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identifier for the slide being configured. For education overrides, this is the education slide type (e.g., 'CLT_STRATEGY_EXPLAINER'). For custom templates, this is a user-defined identifier. For other overrides, this references the slide being overridden. */
  slideIdentifier: Scalars['String']['input'];
};

/**
 * CreateTestCMKEncryptionInput is used for create TestCMKEncryption object.
 * Input was generated by ent.
 */
export type CreateTestCmkEncryptionInput = {
  /** encrypted int */
  encryptedInt: Scalars['Int']['input'];
  /** encrypted string */
  encryptedString: Scalars['String']['input'];
  /** encrypted time */
  encryptedTime: Scalars['Time']['input'];
  householdID: Scalars['ID']['input'];
  ignoreMe: Scalars['String']['input'];
  /** nillable encrypted string */
  nilEncryptedString?: InputMaybe<Scalars['String']['input']>;
  /** optional encrypted string */
  optionalEncryptedString?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateTestamentaryEntityInput is used for create TestamentaryEntity object.
 * Input was generated by ent.
 */
export type CreateTestamentaryEntityInput = {
  accountOwnerID?: InputMaybe<Scalars['ID']['input']>;
  additionalDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiariesAfterBothGrantorDeathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  benefitsFromIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  controllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdFromEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description for this testamentary entity */
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  dispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  dispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  dispositiveProvisionsTemplateID?: InputMaybe<Scalars['ID']['input']>;
  entityDocumentRelationshipIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  grantorDeathID?: InputMaybe<Scalars['ID']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  householdID: Scalars['ID']['input'];
  hypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  hypotheticalDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  hypotheticalDispositiveProvisionsTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  kgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Type of testamentary entity. */
  kind: TestamentaryEntityKind;
  onboardingTestamentaryEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  potentialTestamentaryEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The time at which the scenario was last reviewed. This can be used to indicate that a user has looked at these provisions and they are correct, even if they are empty. */
  reviewedAt?: InputMaybe<Scalars['Time']['input']>;
  successorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  suggestionKgRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  survivingSpouseStateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  taxInfoID?: InputMaybe<Scalars['ID']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
  trustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  trusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  workflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateTrustAdvisorInput is used for create TrustAdvisor object.
 * Input was generated by ent.
 */
export type CreateTrustAdvisorInput = {
  householdID: Scalars['ID']['input'];
  individualID?: InputMaybe<Scalars['ID']['input']>;
  /** The level of this trust advisor. */
  level: TrustAdvisorLevel;
  /** A Note about this trust advisor. Only relevant if the level is "OTHER". */
  note?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  roleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateTrustAdvisorRoleInput is used for create TrustAdvisorRole object.
 * Input was generated by ent.
 */
export type CreateTrustAdvisorRoleInput = {
  householdID: Scalars['ID']['input'];
  /** The role of this trust advisor. */
  kind: TrustAdvisorRoleKind;
};

/**
 * CreateTrusteeDutyInput is used for create TrusteeDuty object.
 * Input was generated by ent.
 */
export type CreateTrusteeDutyInput = {
  householdID: Scalars['ID']['input'];
  /** The kind of duty for this trustee */
  kind: TrusteeDutyKind;
};

/**
 * CreateTrusteeInput is used for create Trustee object.
 * Input was generated by ent.
 */
export type CreateTrusteeInput = {
  dutyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  individualID?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<TrusteeLevel>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  trusteeCategory?: InputMaybe<TrusteeTrusteeCategory>;
};

/**
 * CreateUserFeedbackInput is used for create UserFeedback object.
 * Input was generated by ent.
 */
export type CreateUserFeedbackInput = {
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** The user's feedback */
  feedback: Scalars['String']['input'];
  /** The piece of functionality the feedback is about */
  feedbackCategory: UserFeedbackFeedbackCategory;
  householdID: Scalars['ID']['input'];
};

/**
 * CreateUserInput is used for create User object.
 * Input was generated by ent.
 */
export type CreateUserInput = {
  assignedTaskIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  asyncJobIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  collaboratorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  email: Scalars['String']['input'];
  employeeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  relationshipOwnerHouseholdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateUserNotificationConfigurationInput is used for create UserNotificationConfiguration object.
 * Input was generated by ent.
 */
export type CreateUserNotificationConfigurationInput = {
  /** Whether or not the user has enabled receiving reminder email notifications. */
  allRemainderEmailsDisabled: Scalars['Boolean']['input'];
  receivingUserID: Scalars['ID']['input'];
};

/**
 * CreateWaterfallBundleConfigurationInput is used for create WaterfallBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateWaterfallBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name for the waterfall. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  estateWaterfallID?: InputMaybe<Scalars['ID']['input']>;
  /** The year of the first death in the waterfall. */
  firstDeathYear?: InputMaybe<Scalars['Int']['input']>;
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  /** Include the state after the first death in the waterfall summary page. */
  includeAfterFirstDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include the state after the second death in the waterfall summary page. */
  includeAfterSecondDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the assumptions page in the waterfall bundle. */
  includeAssumptionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include the state before the first death in the waterfall summary page. */
  includeBeforeFirstDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the beneficiary page in the waterfall bundle. */
  includeBeneficiaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the cover page in the waterfall bundle. */
  includeCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the diagrams page in the waterfall bundle. */
  includeDiagramPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include the overview in the waterfall summary page. */
  includeOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the summary bars on the summary page in the waterfall bundle. */
  includeSummaryBars?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the summary page in the waterfall bundle. */
  includeSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the summary tiles on the summary page in the waterfall bundle. */
  includeSummaryTiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the tax overview page in the waterfall bundle. */
  includeTaxOverviewPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** The year of the second death in the waterfall. */
  secondDeathYear?: InputMaybe<Scalars['Int']['input']>;
  /** If true, shows the line-item details on the summary tiles on the summary page in the waterfall bundle. */
  showSummaryTileDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides line items with a $0 value and no insurance from the updated waterfall summary page. */
  summaryHideZeroDollarItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use the updated waterfall summary page instead of the original design. */
  useUpdatedSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateWaterfallBundleCoverPageInput is used for create WaterfallBundleCoverPage object.
 * Input was generated by ent.
 */
export type CreateWaterfallBundleCoverPageInput = {
  /** The content of the cover page. */
  content: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
};

/**
 * CreateWaterfallComparisonBundleConfigurationInput is used for create WaterfallComparisonBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateWaterfallComparisonBundleConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  comparedWaterfallIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The display name for the waterfall comparison bundle. */
  displayName: Scalars['String']['input'];
  householdID: Scalars['ID']['input'];
  /** If true, includes the assumptions page in the waterfall comparison bundle. */
  includeAssumptionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the cover page in the waterfall comparison bundle. */
  includeCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateWaterfallComparisonTemplateBundleConfigurationInput is used for create WaterfallComparisonTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateWaterfallComparisonTemplateBundleConfigurationInput = {
  /** If true, includes the assumptions page in the waterfall comparison bundle. */
  includeAssumptionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the cover page in the waterfall comparison bundle. */
  includeCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  templateBundleID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateWaterfallTemplateBundleConfigurationInput is used for create WaterfallTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type CreateWaterfallTemplateBundleConfigurationInput = {
  /** Include the state after the first death in the waterfall summary page. */
  includeAfterFirstDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include the state after the second death in the waterfall summary page. */
  includeAfterSecondDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the assumptions page in the waterfall bundle. */
  includeAssumptionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include the state before the first death in the waterfall summary page. */
  includeBeforeFirstDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the cover page in the waterfall bundle. */
  includeCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the diagrams page in the waterfall bundle. */
  includeDiagramPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include the overview in the waterfall summary page. */
  includeOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the summary bars on the summary page in the waterfall bundle. */
  includeSummaryBars?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the summary page in the waterfall bundle. */
  includeSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the summary tiles on the summary page in the waterfall bundle. */
  includeSummaryTiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the tax overview page in the waterfall bundle. */
  includeTaxOverviewPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, shows the line-item details on the summary tiles on the summary page in the waterfall bundle. */
  showSummaryTileDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides line items with a $0 value and no insurance from the updated waterfall summary page. */
  summaryHideZeroDollarItems?: InputMaybe<Scalars['Boolean']['input']>;
  templateBundleID?: InputMaybe<Scalars['ID']['input']>;
};

export type CrossTenantCopyHouseholdInput = {
  /** ID of household to copy from source tenant */
  householdID: Scalars['ID']['input'];
  /** ID of source tenant */
  sourceTenantID: Scalars['ID']['input'];
};

/**
 * Filtering options for the current user's workflow tracker history. All
 * populated fields are combined with AND. Values within statusIn, statuses, kinds, and
 * householdIDs are combined with OR.
 */
export type CurrentUserWorkflowTrackerFilter = {
  /** Return trackers that ended after this time. */
  endedAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Return trackers that ended before this time. */
  endedBefore?: InputMaybe<Scalars['Time']['input']>;
  /** Return trackers associated with any listed household. */
  householdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Return trackers whose kind is any listed value. */
  kinds?: InputMaybe<Array<WorkflowTrackerKind>>;
  /** Return trackers that started after this time. */
  startedAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Return trackers that started before this time. */
  startedBefore?: InputMaybe<Scalars['Time']['input']>;
  /** Return trackers whose status is any listed value. */
  statusIn?: InputMaybe<Array<WorkflowTrackerStatus>>;
  /** Return trackers whose status is any listed value. */
  statuses?: InputMaybe<Array<WorkflowTrackerStatus>>;
};

export type CustodialPersonalAccount = EntitySubtype & Named & Node & PersonalAccount & {
  __typename?: 'CustodialPersonalAccount';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  beneficiaries?: Maybe<Array<Beneficiary>>;
  controllingParties?: Maybe<Array<ControllingParty>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this personal account */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in entities that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  owner?: Maybe<Principal>;
  stateInEstateStatus: EntityInEstateStatus;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<NonTrustEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type CustodialPersonalAccountHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type CustodialPersonalAccountConnection = {
  __typename?: 'CustodialPersonalAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustodialPersonalAccountEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustodialPersonalAccountEdge = {
  __typename?: 'CustodialPersonalAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CustodialPersonalAccount>;
};

/** Ordering options for CustodialPersonalAccount connections */
export type CustodialPersonalAccountOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order CustodialPersonalAccounts. */
  field: CustodialPersonalAccountOrderField;
};

/** Properties by which CustodialPersonalAccount connections can be ordered. */
export enum CustodialPersonalAccountOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * CustodialPersonalAccountWhereInput is used for filtering CustodialPersonalAccount objects.
 * Input was generated by ent.
 */
export type CustodialPersonalAccountWhereInput = {
  and?: InputMaybe<Array<CustodialPersonalAccountWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** beneficiaries edge predicates */
  hasBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** controlling_parties edge predicates */
  hasControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  hasControllingPartiesWith?: InputMaybe<Array<ControllingPartyWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<CustodialPersonalAccountWhereInput>;
  or?: InputMaybe<Array<CustodialPersonalAccountWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type DsuePortability = Node & {
  __typename?: 'DSUEPortability';
  /** The amount of DSUE ported to the recipient */
  amount: Scalars['CurrencyUSD']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  documents?: Maybe<Array<Document>>;
  /** The date of when the DSUE was recorded */
  eventDate: Scalars['Time']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Free-form notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** The individual who is receiving the DSUE */
  recipient: ClientProfile;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for DSUEPortability connections */
export type DsuePortabilityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DSUEPortabilities. */
  field: DsuePortabilityOrderField;
};

/** Properties by which DSUEPortability connections can be ordered. */
export enum DsuePortabilityOrderField {
  CreatedAt = 'created_at',
  EventDate = 'event_date',
  UpdatedAt = 'updated_at'
}

/**
 * DSUEPortabilityWhereInput is used for filtering DSUEPortability objects.
 * Input was generated by ent.
 */
export type DsuePortabilityWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  and?: InputMaybe<Array<DsuePortabilityWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** event_date field predicates */
  eventDate?: InputMaybe<Scalars['Time']['input']>;
  eventDateGT?: InputMaybe<Scalars['Time']['input']>;
  eventDateGTE?: InputMaybe<Scalars['Time']['input']>;
  eventDateLT?: InputMaybe<Scalars['Time']['input']>;
  eventDateLTE?: InputMaybe<Scalars['Time']['input']>;
  /** documents edge predicates */
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** recipient edge predicates */
  hasRecipient?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecipientWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DsuePortabilityWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<DsuePortabilityWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Target data model record to link a KG V2 node to. Exactly one field must be set. */
export type DataModelTargetInput = {
  clientOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  clientProfileID?: InputMaybe<Scalars['ID']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
};

export type DecryptLogValueInput = {
  /** The log-encrypted value (must start with 'log_v1:') */
  ciphertext: Scalars['String']['input'];
  /** Justification for decryption (required, logged for audit) */
  reason: Scalars['String']['input'];
};

export type DefaultDiagramPrompt = {
  __typename?: 'DefaultDiagramPrompt';
  diagramArtifactPromptType: DiagramArtifactPromptDiagramArtifactPromptType;
  promptText: Scalars['String']['output'];
};

export type DefaultMemoPrompt = {
  __typename?: 'DefaultMemoPrompt';
  memoType: MemoPromptMemoPromptType;
  promptText: Scalars['String']['output'];
};

export type DefaultNoDocumentsOnboardingPrompt = {
  __typename?: 'DefaultNoDocumentsOnboardingPrompt';
  noDocumentsOnboardingPromptType: NoDocumentsOnboardingPromptType;
  promptText: Scalars['String']['output'];
};

/** Options for de-identified document fields. */
export type DeidentifyOptions = {
  /** Replace surrogate tokens with realistic, deterministic fake data. Defaults to false (token output). */
  synthetic?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteEntityDocumentRelationshipInput = {
  /**  documentID is the ID of the document to delete the relationship for  */
  documentID: Scalars['ID']['input'];
  /**
   * entityID is the ID of the entity to delete the relationship for.
   * either entityID or testamentaryEntityID must be provided.
   */
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * relationshipType is the type of relationship to delete.
   * if this is not provided, all relationships between the document and the entity or TE will be deleted.
   */
  relationshipType?: InputMaybe<EntityDocumentRelationshipRelationshipType>;
  /**
   * testamentaryEntityID is the ID of the testamentary entity to delete the relationship for.
   * either entityID or testamentaryEntityID must be provided.
   */
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for permanently deleting KG V2 nodes from a household's active graph. */
export type DeleteKgv2NodesInput = {
  /** The household that owns the nodes. */
  householdID: Scalars['ID']['input'];
  /** The IDs of the active KG V2 nodes to delete. Max 500. */
  nodeIDs: Array<Scalars['ID']['input']>;
};

/** Result of deleting KG V2 nodes and the statements that reference them. */
export type DeleteKgv2NodesPayload = {
  __typename?: 'DeleteKGV2NodesPayload';
  /** The number of nodes deleted. */
  deletedNodeCount: Scalars['Int']['output'];
  /** The number of statements deleted because they referenced a deleted node. */
  deletedStatementCount: Scalars['Int']['output'];
};

export type DeleteTenantInput = {
  subdomain: Scalars['String']['input'];
  subdomainSHA256: Scalars['String']['input'];
};

export type DesignSummaryDetails = {
  __typename?: 'DesignSummaryDetails';
  annuityPaymentAnnualIncreasePercentage: Scalars['String']['output'];
  annuityPayments: Array<SummaryAnnuityPaymentDetails>;
  assets: Array<SummaryAsset>;
  attorneyNotes?: Maybe<Scalars['String']['output']>;
  beneficiaries: Array<SummaryBeneficiary>;
  displayName: Scalars['String']['output'];
  grantor: SummaryPerson;
  grantorRetainedInterest: Scalars['String']['output'];
  initialFundingValue: Scalars['String']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  officialInterestRate: Scalars['String']['output'];
  spouseDisplayName?: Maybe<Scalars['String']['output']>;
  successorTrustees: Array<SummaryPerson>;
  taxableGiftAmount: Scalars['String']['output'];
  termDescription: Scalars['String']['output'];
  termDetailsInfo: TermDetailsInfo;
  /** @deprecated Use termDetailsInfo instead */
  termDetailsWarning?: Maybe<Scalars['String']['output']>;
  trustSitus?: Maybe<Scalars['String']['output']>;
  trustees: Array<SummaryPerson>;
};

/** A complete, editable diagram snapshot. It is not a saved resource. */
export type Diagram = {
  __typename?: 'Diagram';
  content: DiagramContent;
  schemaVersion: Scalars['Int']['output'];
};

export type DiagramArtifact = Node & {
  __typename?: 'DiagramArtifact';
  /** CMK-encrypted diagram content, including its schema version, graph, and positions */
  content: Scalars['JSON']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The current saved content as typed diagram fields. */
  diagram: Diagram;
  /** The prompt used to generate this diagram; absent for freeform diagrams or after prompt deletion */
  diagramArtifactPrompt?: Maybe<DiagramArtifactPrompt>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  messages: MessageConnection;
  /** CMK-encrypted library name, separate from the canvas title */
  name: Scalars['String']['output'];
  /** Saved revision; advances with each accepted save and rejects edits based on older content */
  revision: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
  workflowTrackers: WorkflowTrackerConnection;
};


export type DiagramArtifactMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessageOrder>>;
  where?: InputMaybe<MessageWhereInput>;
};


export type DiagramArtifactWorkflowTrackersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkflowTrackerOrder>>;
  where?: InputMaybe<WorkflowTrackerWhereInput>;
};

/** A connection to a list of items. */
export type DiagramArtifactConnection = {
  __typename?: 'DiagramArtifactConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DiagramArtifactEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DiagramArtifactEdge = {
  __typename?: 'DiagramArtifactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DiagramArtifact>;
};

/** Ordering options for DiagramArtifact connections */
export type DiagramArtifactOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DiagramArtifacts. */
  field: DiagramArtifactOrderField;
};

/** Properties by which DiagramArtifact connections can be ordered. */
export enum DiagramArtifactOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type DiagramArtifactPrompt = Node & {
  __typename?: 'DiagramArtifactPrompt';
  createdAt: Scalars['Time']['output'];
  /** Short description displayed in diagram prompt cards */
  description: Scalars['String']['output'];
  /** Standard diagram prompt type */
  diagramArtifactPromptType: DiagramArtifactPromptDiagramArtifactPromptType;
  diagramArtifacts: DiagramArtifactConnection;
  id: Scalars['ID']['output'];
  /** Whether this is a predefined diagram prompt type rather than a custom prompt-library entry */
  isSystemPrompt: Scalars['Boolean']['output'];
  /** Human-readable prompt name */
  name: Scalars['String']['output'];
  /** Prompt markdown content. Required when a custom, non-system prompt is added to the prompt library. */
  promptMarkdown?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type DiagramArtifactPromptDiagramArtifactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DiagramArtifactOrder>>;
  where?: InputMaybe<DiagramArtifactWhereInput>;
};

/** A connection to a list of items. */
export type DiagramArtifactPromptConnection = {
  __typename?: 'DiagramArtifactPromptConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DiagramArtifactPromptEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** DiagramArtifactPromptDiagramArtifactPromptType is enum for the field diagram_artifact_prompt_type */
export enum DiagramArtifactPromptDiagramArtifactPromptType {
  EstateDistributionDetailed = 'ESTATE_DISTRIBUTION_DETAILED',
  EstateDistributionSimple = 'ESTATE_DISTRIBUTION_SIMPLE'
}

/** An edge in a connection. */
export type DiagramArtifactPromptEdge = {
  __typename?: 'DiagramArtifactPromptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DiagramArtifactPrompt>;
};

/** Ordering options for DiagramArtifactPrompt connections */
export type DiagramArtifactPromptOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DiagramArtifactPrompts. */
  field: DiagramArtifactPromptOrderField;
};

/** Properties by which DiagramArtifactPrompt connections can be ordered. */
export enum DiagramArtifactPromptOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * DiagramArtifactPromptWhereInput is used for filtering DiagramArtifactPrompt objects.
 * Input was generated by ent.
 */
export type DiagramArtifactPromptWhereInput = {
  and?: InputMaybe<Array<DiagramArtifactPromptWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  /** diagram_artifact_prompt_type field predicates */
  diagramArtifactPromptType?: InputMaybe<DiagramArtifactPromptDiagramArtifactPromptType>;
  diagramArtifactPromptTypeIn?: InputMaybe<Array<DiagramArtifactPromptDiagramArtifactPromptType>>;
  diagramArtifactPromptTypeNEQ?: InputMaybe<DiagramArtifactPromptDiagramArtifactPromptType>;
  diagramArtifactPromptTypeNotIn?: InputMaybe<Array<DiagramArtifactPromptDiagramArtifactPromptType>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_system_prompt field predicates */
  isSystemPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<DiagramArtifactPromptWhereInput>;
  or?: InputMaybe<Array<DiagramArtifactPromptWhereInput>>;
  /** prompt_markdown field predicates */
  promptMarkdown?: InputMaybe<Scalars['String']['input']>;
  promptMarkdownIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  promptMarkdownNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * DiagramArtifactWhereInput is used for filtering DiagramArtifact objects.
 * Input was generated by ent.
 */
export type DiagramArtifactWhereInput = {
  and?: InputMaybe<Array<DiagramArtifactWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** diagram_artifact_prompt edge predicates */
  hasDiagramArtifactPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiagramArtifactPromptWith?: InputMaybe<Array<DiagramArtifactPromptWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** messages edge predicates */
  hasMessages?: InputMaybe<Scalars['Boolean']['input']>;
  hasMessagesWith?: InputMaybe<Array<MessageWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** workflow_trackers edge predicates */
  hasWorkflowTrackers?: InputMaybe<Scalars['Boolean']['input']>;
  hasWorkflowTrackersWith?: InputMaybe<Array<WorkflowTrackerWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DiagramArtifactWhereInput>;
  or?: InputMaybe<Array<DiagramArtifactWhereInput>>;
  /** revision field predicates */
  revision?: InputMaybe<Scalars['Int']['input']>;
  revisionGT?: InputMaybe<Scalars['Int']['input']>;
  revisionGTE?: InputMaybe<Scalars['Int']['input']>;
  revisionLT?: InputMaybe<Scalars['Int']['input']>;
  revisionLTE?: InputMaybe<Scalars['Int']['input']>;
  revisionNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DiagramBuilderEdge = {
  __typename?: 'DiagramBuilderEdge';
  edgeID: Scalars['ID']['output'];
  edgeStyle?: Maybe<DiagramEdgeStyle>;
  label: Scalars['String']['output'];
  /** Finite fraction along the line from source (0) to target (1). Null uses the default midpoint. */
  labelPosition?: Maybe<Scalars['Float']['output']>;
  sourceNodeID: Scalars['ID']['output'];
  sourceSide?: Maybe<DiagramSide>;
  targetNodeID: Scalars['ID']['output'];
  targetSide?: Maybe<DiagramSide>;
  /** Manual interior bends, source to target, in canvas pixels. Null or empty uses automatic routing. Excludes endpoints. */
  waypoints?: Maybe<Array<DiagramPosition>>;
};

/** Content and structure. Null position and style use frontend defaults. */
export type DiagramBuilderNode = {
  __typename?: 'DiagramBuilderNode';
  detail: Scalars['String']['output'];
  /** Estate inclusion for this occurrence, independent of style overrides. Null when unspecified or not applicable. */
  estateCategory?: Maybe<DiagramNodeEstateCategory>;
  /** Optional footer text, separate from detail (notes). */
  footerLabel?: Maybe<Scalars['String']['output']>;
  kind: DiagramNodeKind;
  label: Scalars['String']['output'];
  /** Null for a single item; an array selects a collection of this kind. IDs reference member occurrences; empty means unspecified members. */
  memberNodeIds?: Maybe<Array<Scalars['String']['output']>>;
  nodeID: Scalars['ID']['output'];
  nodeStyle?: Maybe<DiagramNodeStyle>;
  position?: Maybe<DiagramPosition>;
  stageId?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<DiagramNodeSubtype>;
};

export type DiagramContent = {
  __typename?: 'DiagramContent';
  direction: DiagramDirection;
  edges: Array<DiagramBuilderEdge>;
  nodes: Array<DiagramBuilderNode>;
  /** Ordered groups separated by horizontal dividers. Empty disables stages. */
  stages: Array<DiagramStage>;
  title: Scalars['String']['output'];
};

export type DiagramContentInput = {
  direction: DiagramDirection;
  edges: Array<DiagramEdgeInput>;
  nodes: Array<DiagramNodeInput>;
  stages: Array<DiagramStageInput>;
  title: Scalars['String']['input'];
};

export enum DiagramDirection {
  LeftToRight = 'LEFT_TO_RIGHT',
  TopToBottom = 'TOP_TO_BOTTOM'
}

/** Shared connections. A legal transfer condition is not a line style. */
export type DiagramEdge = {
  edgeID: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  sourceNodeID: Scalars['ID']['output'];
  targetNodeID: Scalars['ID']['output'];
};

export type DiagramEdgeInput = {
  edgeID: Scalars['ID']['input'];
  edgeStyle?: InputMaybe<DiagramEdgeStyleInput>;
  label: Scalars['String']['input'];
  /** Finite fraction from source (0) to target (1). Omit or use null for the default midpoint. */
  labelPosition?: InputMaybe<Scalars['Float']['input']>;
  sourceNodeID: Scalars['ID']['input'];
  sourceSide?: InputMaybe<DiagramSide>;
  targetNodeID: Scalars['ID']['input'];
  targetSide?: InputMaybe<DiagramSide>;
  /** Manual interior bends in canvas pixels. Moving nodes must update or clear these points. */
  waypoints?: InputMaybe<Array<DiagramPositionInput>>;
};

/** Explicit connection overrides. Unset properties use frontend defaults. */
export type DiagramEdgeStyle = {
  __typename?: 'DiagramEdgeStyle';
  /** none, end (target), start (source), or both, in source-to-target order. */
  arrowheads?: Maybe<Scalars['String']['output']>;
  /** Theme palette token (primary, secondary, destructive, accent) or opaque #RGB or #RRGGBB override. */
  color?: Maybe<Scalars['String']['output']>;
  /** True hides the edge label and keeps its text. Null or false shows it. */
  hideLabel?: Maybe<Scalars['Boolean']['output']>;
  /** solid, dashed, or dotted. */
  lineStyle?: Maybe<Scalars['String']['output']>;
  /** elbow, straight, or curved. */
  route?: Maybe<Scalars['String']['output']>;
  /** Positive, finite stroke width in canvas pixels. Editor presets are 1, 2, and 3. */
  strokeWidth?: Maybe<Scalars['Float']['output']>;
};

export type DiagramEdgeStyleInput = {
  /** none, end (target), start (source), or both, in source-to-target order. */
  arrowheads?: InputMaybe<Scalars['String']['input']>;
  /** Theme palette token (primary, secondary, destructive, accent) or opaque #RGB or #RRGGBB override. */
  color?: InputMaybe<Scalars['String']['input']>;
  /** True hides the edge label and keeps its text. Omit, null, or false shows it. */
  hideLabel?: InputMaybe<Scalars['Boolean']['input']>;
  /** solid, dashed, or dotted. */
  lineStyle?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  /** Positive, finite canvas-pixel width. Editor presets are 1, 2, and 3. */
  strokeWidth?: InputMaybe<Scalars['Float']['input']>;
};

/** Untrusted editor state; identity and permissions come from the authenticated host. */
export type DiagramEditorContextInput = {
  /** The current editor snapshot; takes precedence over saved artifact content. */
  diagram?: InputMaybe<DiagramInput>;
  /** The selected saved diagram. Omit it for creation; never selects the latest diagram. */
  diagramArtifactID?: InputMaybe<Scalars['ID']['input']>;
  /** The last saved revision read. Required with diagramArtifactID to reject stale updates. */
  expectedRevision?: InputMaybe<Scalars['Int']['input']>;
  selectedElementIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DiagramInput = {
  content: DiagramContentInput;
  schemaVersion: Scalars['Int']['input'];
};

/** A historical diagram snapshot. Reopen its artifact to read the current saved content. */
export type DiagramMessageContent = {
  __typename?: 'DiagramMessageContent';
  diagram: Diagram;
  /** The saved household diagram; absent for a legacy unsaved snapshot. */
  diagramArtifactID?: Maybe<Scalars['ID']['output']>;
  /** The revision that accepted this snapshot, not the artifact's current revision. */
  revision?: Maybe<Scalars['Int']['output']>;
  /** The parent chat tracker ID; associates this result with its submitted draft. */
  turnID: Scalars['ID']['output'];
};

/** Shared flat node fields. Producers validate their supported appearance values. */
export type DiagramNode = {
  iconShape?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  nodeID: Scalars['ID']['output'];
  tileEmphasis?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum DiagramNodeEstateCategory {
  InEstate = 'IN_ESTATE',
  OutOfEstateCharity = 'OUT_OF_ESTATE_CHARITY',
  OutOfEstateFamily = 'OUT_OF_ESTATE_FAMILY'
}

export type DiagramNodeInput = {
  detail: Scalars['String']['input'];
  estateCategory?: InputMaybe<DiagramNodeEstateCategory>;
  /** Optional footer text, separate from detail (notes). */
  footerLabel?: InputMaybe<Scalars['String']['input']>;
  kind: DiagramNodeKind;
  label: Scalars['String']['input'];
  /** Null for a single item; an array selects a collection. No separate item count is stored. */
  memberNodeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  nodeID: Scalars['ID']['input'];
  nodeStyle?: InputMaybe<DiagramNodeStyleInput>;
  position?: InputMaybe<DiagramPositionInput>;
  stageId?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtype?: InputMaybe<DiagramNodeSubtype>;
};

/** TEXT is standalone text; SHAPE uses nodeStyle.shape. Both require null subtype, estateCategory, and memberNodeIds. */
export enum DiagramNodeKind {
  Asset = 'ASSET',
  Document = 'DOCUMENT',
  Entity = 'ENTITY',
  Payment = 'PAYMENT',
  Person = 'PERSON',
  Shape = 'SHAPE',
  Summary = 'SUMMARY',
  Text = 'TEXT'
}

/** Explicit overrides. Unset properties use frontend defaults. */
export type DiagramNodeStyle = {
  __typename?: 'DiagramNodeStyle';
  /** Theme palette token (primary, secondary, tertiary, destructive, external, default) or opaque #RGB or #RRGGBB override. */
  color?: Maybe<Scalars['String']['output']>;
  /** TILE, TILE_ICON, or SHAPE. Changes rendering, not kind; SHAPE uses shape. */
  display?: Maybe<Scalars['String']['output']>;
  emphasis?: Maybe<Scalars['String']['output']>;
  /** filled or outlined body for SHAPE nodes and nodes displayed as SHAPE. Null uses filled. */
  fill?: Maybe<Scalars['String']['output']>;
  fontSize?: Maybe<Scalars['String']['output']>;
  /** Positive, finite height in canvas pixels. Null fits the content. */
  height?: Maybe<Scalars['Float']['output']>;
  /** True hides the notes (detail) of this tile and keeps the text. Null or false shows them. */
  hideDetail?: Maybe<Scalars['Boolean']['output']>;
  /** True hides the footer label of this tile and keeps the text. Null or false shows it. */
  hideFooterLabel?: Maybe<Scalars['Boolean']['output']>;
  /** person, house, heart, currency, document, family (People), charity; legacy entity, subtrust, account, organization, hidden also accepted. */
  icon?: Maybe<Scalars['String']['output']>;
  iconShape?: Maybe<Scalars['String']['output']>;
  /** Node outline: circle, triangle, diamond, square, rounded (rectangle). Legacy rectangle and ellipse also accepted. Separate from iconShape. */
  shape?: Maybe<Scalars['String']['output']>;
  /** Horizontal text alignment: left or center. */
  textAlign?: Maybe<Scalars['String']['output']>;
  /** Positive, finite width in canvas pixels. Null uses the renderer default. */
  width?: Maybe<Scalars['Float']['output']>;
};

export type DiagramNodeStyleInput = {
  /** Theme palette token (primary, secondary, tertiary, destructive, external, default) or opaque #RGB or #RRGGBB override. */
  color?: InputMaybe<Scalars['String']['input']>;
  /** TILE, TILE_ICON, or SHAPE. Changes rendering, not kind; SHAPE uses shape. */
  display?: InputMaybe<Scalars['String']['input']>;
  emphasis?: InputMaybe<Scalars['String']['input']>;
  /** filled or outlined body for SHAPE nodes and nodes displayed as SHAPE. Omit or use null for filled. */
  fill?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
  /** Positive, finite height in canvas pixels. Omit or use null to fit the content. */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** True hides the notes (detail) of this tile and keeps the text. Omit, null, or false shows them. */
  hideDetail?: InputMaybe<Scalars['Boolean']['input']>;
  /** True hides the footer label of this tile and keeps the text. Omit, null, or false shows it. */
  hideFooterLabel?: InputMaybe<Scalars['Boolean']['input']>;
  /** person, house, heart, currency, document, family (People), charity; legacy entity, subtrust, account, organization, hidden also accepted. */
  icon?: InputMaybe<Scalars['String']['input']>;
  iconShape?: InputMaybe<Scalars['String']['input']>;
  /** circle, triangle, diamond, square, rounded (rectangle); legacy rectangle and ellipse also accepted. */
  shape?: InputMaybe<Scalars['String']['input']>;
  textAlign?: InputMaybe<Scalars['String']['input']>;
  /** Positive, finite width in canvas pixels. Omit or use null for the renderer default. */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export enum DiagramNodeSubtype {
  Account = 'ACCOUNT',
  Business = 'BUSINESS',
  Charity = 'CHARITY',
  DonorAdvisedFund = 'DONOR_ADVISED_FUND',
  Expense = 'EXPENSE',
  Foundation = 'FOUNDATION',
  LiabilityPayment = 'LIABILITY_PAYMENT',
  LifeInsurance = 'LIFE_INSURANCE',
  RealEstate = 'REAL_ESTATE',
  Tax = 'TAX',
  Trust = 'TRUST',
  TrustInstrument = 'TRUST_INSTRUMENT',
  Will = 'WILL'
}

export type DiagramPosition = {
  __typename?: 'DiagramPosition';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type DiagramPositionInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

/** Node boundary for an edge endpoint. Null selects the side automatically. */
export enum DiagramSide {
  Bottom = 'BOTTOM',
  Left = 'LEFT',
  Right = 'RIGHT',
  Top = 'TOP'
}

/** An ordered group. The first stage has no label or dividerY. Flat fields take precedence over deprecated fields when either is non-null. */
export type DiagramStage = {
  __typename?: 'DiagramStage';
  /** @deprecated Use label. */
  deathEvent?: Maybe<Scalars['String']['output']>;
  /** Vertical canvas coordinate. Null before layout; coordinates strictly increase in stage order. */
  dividerY?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  /** Null for the first stage. An empty string leaves later dividers visible. */
  label?: Maybe<Scalars['String']['output']>;
};

export type DiagramStageInput = {
  /** @deprecated Use label. */
  deathEvent?: InputMaybe<Scalars['String']['input']>;
  /** Null for the first stage. Later stages must all have coordinates or all be unpositioned. */
  dividerY?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  /** Null for the first stage; required for later stages, including an empty string. */
  label?: InputMaybe<Scalars['String']['input']>;
};

export type DiscretionaryAccessParameterView = {
  __typename?: 'DiscretionaryAccessParameterView';
  accessAgeParameters: Array<AccessAgeParameterView>;
  /** kind is the kind of access, never AMOUNT, PERCENTAGE, or TRUST_INCOME */
  kind: AccessParameterKind;
};

export type DispositionScenario = Node & {
  __typename?: 'DispositionScenario';
  /** If this disposition scenario is hypothetical, this is the waterfall that is associated with it. */
  associatedHypotheticalWaterfall?: Maybe<EstateWaterfall>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  dispositiveProvisions: DispositiveProvisionConnection;
  /** The dispositive provision template associated with this scenario. When present, dispositive_provisions will be ignored. */
  dispositiveProvisionsTemplate?: Maybe<DispositiveProvisionTemplate>;
  /** if true, the residuary recipient(s) for this death order pays taxes by default. if false, each recipient's bearsTax field can be configured separately */
  firstDeathResiduaryPaysAllTaxes?: Maybe<Scalars['Boolean']['output']>;
  /** This disposition scenario corresponds to the death of the associated grantor. */
  firstGrantorDeath: ClientProfile;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  jointAccount?: Maybe<JointPersonalAccount>;
  /** The time at which the scenario was last reviewed. This can be used to indicate that a user has looked at these provisions and they are correct, even if they are empty. */
  reviewedAt?: Maybe<Scalars['Time']['output']>;
  secondDeathDispositiveProvisions: DispositiveProvisionConnection;
  /** The dispositive provision template associated with this scenario and second grantor's death. When present, second_death_dispositive_provisions will be ignored. */
  secondDeathDispositiveProvisionsTemplate?: Maybe<DispositiveProvisionTemplate>;
  /** if true, the residuary recipient(s) for this death order pays taxes by default. if false, each recipient's bearsTax field can be configured separately */
  secondDeathResiduaryPaysAllTaxes?: Maybe<Scalars['Boolean']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** How the transfer is made to the recipient. IN_KIND preserves the asset thus keeping the source asset growth characteristics, LIQUIDATE_TO_CASH sells the asset thus gaining the destination asset growth characteristics. */
  transferMethod?: Maybe<TransferMethod>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type DispositionScenarioDispositiveProvisionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositiveProvisionOrder>>;
  where?: InputMaybe<DispositiveProvisionWhereInput>;
};


export type DispositionScenarioSecondDeathDispositiveProvisionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositiveProvisionOrder>>;
  where?: InputMaybe<DispositiveProvisionWhereInput>;
};

/** A connection to a list of items. */
export type DispositionScenarioConnection = {
  __typename?: 'DispositionScenarioConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DispositionScenarioEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DispositionScenarioEdge = {
  __typename?: 'DispositionScenarioEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DispositionScenario>;
};

/** Ordering options for DispositionScenario connections */
export type DispositionScenarioOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DispositionScenarios. */
  field: DispositionScenarioOrderField;
};

/** Properties by which DispositionScenario connections can be ordered. */
export enum DispositionScenarioOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * DispositionScenarioWhereInput is used for filtering DispositionScenario objects.
 * Input was generated by ent.
 */
export type DispositionScenarioWhereInput = {
  and?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** first_death_residuary_pays_all_taxes field predicates */
  firstDeathResiduaryPaysAllTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  firstDeathResiduaryPaysAllTaxesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  firstDeathResiduaryPaysAllTaxesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** associated_hypothetical_waterfall edge predicates */
  hasAssociatedHypotheticalWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssociatedHypotheticalWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** dispositive_provisions edge predicates */
  hasDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  /** dispositive_provisions_template edge predicates */
  hasDispositiveProvisionsTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositiveProvisionsTemplateWith?: InputMaybe<Array<DispositiveProvisionTemplateWhereInput>>;
  hasDispositiveProvisionsWith?: InputMaybe<Array<DispositiveProvisionWhereInput>>;
  /** first_grantor_death edge predicates */
  hasFirstGrantorDeath?: InputMaybe<Scalars['Boolean']['input']>;
  hasFirstGrantorDeathWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** joint_account edge predicates */
  hasJointAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasJointAccountWith?: InputMaybe<Array<JointPersonalAccountWhereInput>>;
  /** second_death_dispositive_provisions edge predicates */
  hasSecondDeathDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  /** second_death_dispositive_provisions_template edge predicates */
  hasSecondDeathDispositiveProvisionsTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  hasSecondDeathDispositiveProvisionsTemplateWith?: InputMaybe<Array<DispositiveProvisionTemplateWhereInput>>;
  hasSecondDeathDispositiveProvisionsWith?: InputMaybe<Array<DispositiveProvisionWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DispositionScenarioWhereInput>;
  or?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** reviewed_at field predicates */
  reviewedAt?: InputMaybe<Scalars['Time']['input']>;
  reviewedAtGT?: InputMaybe<Scalars['Time']['input']>;
  reviewedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  reviewedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  reviewedAtLT?: InputMaybe<Scalars['Time']['input']>;
  reviewedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  reviewedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** second_death_residuary_pays_all_taxes field predicates */
  secondDeathResiduaryPaysAllTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  secondDeathResiduaryPaysAllTaxesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  secondDeathResiduaryPaysAllTaxesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** transfer_method field predicates */
  transferMethod?: InputMaybe<TransferMethod>;
  transferMethodIn?: InputMaybe<Array<TransferMethod>>;
  transferMethodIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  transferMethodNEQ?: InputMaybe<TransferMethod>;
  transferMethodNotIn?: InputMaybe<Array<TransferMethod>>;
  transferMethodNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type DispositiveProvision = Node & {
  __typename?: 'DispositiveProvision';
  /** The asset groups that this dispositive provision distributes. Only applicable when source_kind is ASSET_SPECIFIC. */
  assetGroups?: Maybe<Array<AssetGroup>>;
  /** The asset statics that this dispositive provision distributes. Only applicable when source_kind is ASSET_SPECIFIC. */
  assetStatics?: Maybe<Array<AssetStatic>>;
  /** If this disposition provision is hypothetical, this is the waterfall that is associated with it. */
  associatedHypotheticalWaterfall?: Maybe<EstateWaterfall>;
  /** If true, the disposition will bear (pay) taxes. */
  bearsTax: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The AMOUNT kind of disposition. Only valid when disposition_kind is AMOUNT */
  dispositionAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The percentage of the disposition. Only valid when disposition_kind is formulaic */
  dispositionFormulaicPercentage?: Maybe<Scalars['Percent']['output']>;
  dispositionKind: DispositiveProvisionDispositionKind;
  /** If set, the disposition will be no more than the set amount.Only applicable if the disposition is not kind AMOUNT. */
  dispositionLimit?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The order of the disposition in the list of dispositions */
  dispositionOrder: Scalars['Int']['output'];
  /** The percentage of the disposition. Only valid when disposition_kind is PERCENTAGE */
  dispositionPercentage?: Maybe<Scalars['Percent']['output']>;
  /** An edge to the beneficiary, which is an entity */
  entity?: Maybe<Entity>;
  /**
   * If true, the disposition amount will be grossed up to try and make disposition_amount the post-tax amount. This is only valid when disposition_kind is AMOUNT.
   * @deprecated use bears_tax instead
   */
  grossUpDispositionAmount: Scalars['Boolean']['output'];
  /** If true, the disposition will grow by the inflation rate specified in the growth profile.Only applicable if the disposition is kind AMOUNT. */
  growByInflation: Scalars['Boolean']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** An edge to the beneficiary, which is an individual */
  individual?: Maybe<ClientProfile>;
  /** The insurance policies that this dispositive provision distributes. Only applicable when source_kind is INSURANCE_POLICY. */
  insurancePolicies?: Maybe<Array<InsurancePolicy>>;
  /** Free-form notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** An edge to the beneficiary, which is an organization */
  organization?: Maybe<ClientOrganization>;
  /** The ownership stakes that this dispositive provision distributes. Only applicable when source_kind is OWNERSHIP_STAKE. */
  ownershipStakes?: Maybe<Array<OwnershipStake>>;
  /**
   * The kind of recpient. Tells us which edge to traverse.
   *       In the case of SURVIVING_SPOUSE, no edge will be set and the recipient will be dynamically set to the surviving spouse in the household.
   */
  recipientKind?: Maybe<DispositiveProvisionRecipientKind>;
  /** The AI suggestion that this dispositive provision is associated with */
  suggestedDpRecipient?: Maybe<Array<AiSuggestion>>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** An edge to the beneficiary, which is a testamentary entity */
  testamentaryEntity?: Maybe<TestamentaryEntity>;
  /** How the transfer is made to the recipient.IN_KIND preserves the asset thus keeping the source asset growth characteristics,LIQUIDATE_TO_CASH sells the asset thus gaining the destination asset growth characteristics.The default is IN_KIND. */
  transferMethod: TransferMethod;
  transferTaxKind: DispositiveProvisionTransferTaxKind;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type DispositiveProvisionConnection = {
  __typename?: 'DispositiveProvisionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DispositiveProvisionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** DispositiveProvisionDispositionKind is enum for the field disposition_kind */
export enum DispositiveProvisionDispositionKind {
  Amount = 'AMOUNT',
  AnythingLeftOver = 'ANYTHING_LEFT_OVER',
  LesserOfRemainingStateOrFederalExemption = 'LESSER_OF_REMAINING_STATE_OR_FEDERAL_EXEMPTION',
  Percentage = 'PERCENTAGE',
  RemainingFederalLifetimeExemptionInExcessOfStateExemption = 'REMAINING_FEDERAL_LIFETIME_EXEMPTION_IN_EXCESS_OF_STATE_EXEMPTION',
  RemainingGstExclusionOfGrantor = 'REMAINING_GST_EXCLUSION_OF_GRANTOR',
  RemainingGstExclusionOfGrantorInExcessOfLifetimeExclusion = 'REMAINING_GST_EXCLUSION_OF_GRANTOR_IN_EXCESS_OF_LIFETIME_EXCLUSION',
  RemainingLifetimeExclusionOfGrantor = 'REMAINING_LIFETIME_EXCLUSION_OF_GRANTOR',
  RemainingStateExemption = 'REMAINING_STATE_EXEMPTION'
}

/** An edge in a connection. */
export type DispositiveProvisionEdge = {
  __typename?: 'DispositiveProvisionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DispositiveProvision>;
};

/** Ordering options for DispositiveProvision connections */
export type DispositiveProvisionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DispositiveProvisions. */
  field: DispositiveProvisionOrderField;
};

/** Properties by which DispositiveProvision connections can be ordered. */
export enum DispositiveProvisionOrderField {
  DispositionOrder = 'DISPOSITION_ORDER',
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** DispositiveProvisionRecipientKind is enum for the field recipient_kind */
export enum DispositiveProvisionRecipientKind {
  Entity = 'ENTITY',
  Individual = 'INDIVIDUAL',
  Organization = 'ORGANIZATION',
  SurvivingSpouse = 'SURVIVING_SPOUSE',
  TestamentaryEntity = 'TESTAMENTARY_ENTITY'
}

/** The suggested recipient of a dispositive provision. */
export type DispositiveProvisionRecipientSuggestion = {
  __typename?: 'DispositiveProvisionRecipientSuggestion';
  /**
   * Suggested overlay percent for a formulaic dispositionKind (REMAINING_* or
   * LESSER_*). Null for AMOUNT, PERCENTAGE, ANYTHING_LEFT_OVER, and unscaled
   * formula fundings.
   */
  dispositionFormulaicPercentage?: Maybe<Scalars['String']['output']>;
  dispositionKind?: Maybe<DispositiveProvisionDispositionKind>;
  /**
   * Suggested dollar cap on a non-AMOUNT disposition. Null for AMOUNT rows
   * and for rows the source clause does not cap.
   */
  dispositionLimit?: Maybe<Scalars['String']['output']>;
  dispositionOrder?: Maybe<Scalars['Int']['output']>;
  distributionAmount?: Maybe<Scalars['String']['output']>;
  distributionDeathEvent?: Maybe<Scalars['String']['output']>;
  distributionPercentage?: Maybe<Scalars['String']['output']>;
  /**
   * Suggested inflation indexation for an AMOUNT disposition. Null for
   * non-AMOUNT rows and for AMOUNT bequests not indexed in the source clause.
   */
  growByInflation?: Maybe<Scalars['Boolean']['output']>;
  nodeID?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  recipientEntityName?: Maybe<Scalars['String']['output']>;
  recipientID?: Maybe<Scalars['ID']['output']>;
  recipientKind?: Maybe<DispositiveProvisionRecipientKind>;
  recipientNameParts?: Maybe<PersonNameParts>;
  recipientOrganizationName?: Maybe<Scalars['String']['output']>;
  recipientTransferTaxKind?: Maybe<DispositiveProvisionTransferTaxKind>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type DispositiveProvisionRecipientSuggestionInput = {
  dispositionFormulaicPercentage?: InputMaybe<Scalars['String']['input']>;
  dispositionKind?: InputMaybe<DispositiveProvisionDispositionKind>;
  dispositionLimit?: InputMaybe<Scalars['String']['input']>;
  dispositionOrder?: InputMaybe<Scalars['Int']['input']>;
  distributionAmount?: InputMaybe<Scalars['String']['input']>;
  distributionDeathEvent?: InputMaybe<Scalars['String']['input']>;
  distributionPercentage?: InputMaybe<Scalars['String']['input']>;
  growByInflation?: InputMaybe<Scalars['Boolean']['input']>;
  nodeID?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  recipientEntityName?: InputMaybe<Scalars['String']['input']>;
  recipientID?: InputMaybe<Scalars['ID']['input']>;
  recipientKind?: InputMaybe<DispositiveProvisionRecipientKind>;
  recipientNameParts?: InputMaybe<PersonNamePartsInput>;
  recipientOrganizationName?: InputMaybe<Scalars['String']['input']>;
  recipientTransferTaxKind?: InputMaybe<DispositiveProvisionTransferTaxKind>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type DispositiveProvisionTemplate = Node & {
  __typename?: 'DispositiveProvisionTemplate';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The name of the template */
  displayName: Scalars['String']['output'];
  dispositiveProvisions: DispositiveProvisionConnection;
  /** The document associated with this template */
  document?: Maybe<Document>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The kind of dispositive provision tempalte */
  kind: DispositiveProvisionTemplateKind;
  /** If true, disposition amounts will be sourced from the total sum of all entities linked to this template.Otherwise amounts will be sourced from each entity linked. */
  proRata: Scalars['Boolean']['output'];
  /** Whether the residuary pays all taxes; only applies to DEFAULT kinds */
  residuaryPaysAllTaxes: Scalars['Boolean']['output'];
  /** The sub kind of dispositive provision tempalte */
  subKind: DispositiveProvisionTemplateSubKind;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};


export type DispositiveProvisionTemplateDispositiveProvisionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositiveProvisionOrder>>;
  where?: InputMaybe<DispositiveProvisionWhereInput>;
};

/** A connection to a list of items. */
export type DispositiveProvisionTemplateConnection = {
  __typename?: 'DispositiveProvisionTemplateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DispositiveProvisionTemplateEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DispositiveProvisionTemplateEdge = {
  __typename?: 'DispositiveProvisionTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DispositiveProvisionTemplate>;
};

/** DispositiveProvisionTemplateKind is enum for the field kind */
export enum DispositiveProvisionTemplateKind {
  AbcTrust = 'ABC_TRUST',
  AbTrust = 'AB_TRUST',
  Default = 'DEFAULT',
  MaritalTrust = 'MARITAL_TRUST',
  OutrightToSurvivingSpouse = 'OUTRIGHT_TO_SURVIVING_SPOUSE',
  PouroverWill = 'POUROVER_WILL'
}

/** Ordering options for DispositiveProvisionTemplate connections */
export type DispositiveProvisionTemplateOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DispositiveProvisionTemplates. */
  field: DispositiveProvisionTemplateOrderField;
};

/** Properties by which DispositiveProvisionTemplate connections can be ordered. */
export enum DispositiveProvisionTemplateOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** DispositiveProvisionTemplateSubKind is enum for the field sub_kind */
export enum DispositiveProvisionTemplateSubKind {
  ClaytonQtip = 'CLAYTON_QTIP',
  Disclaimer = 'DISCLAIMER',
  None = 'NONE',
  Survivor = 'SURVIVOR'
}

/**
 * DispositiveProvisionTemplateWhereInput is used for filtering DispositiveProvisionTemplate objects.
 * Input was generated by ent.
 */
export type DispositiveProvisionTemplateWhereInput = {
  and?: InputMaybe<Array<DispositiveProvisionTemplateWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** dispositive_provisions edge predicates */
  hasDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositiveProvisionsWith?: InputMaybe<Array<DispositiveProvisionWhereInput>>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<DispositiveProvisionTemplateKind>;
  kindIn?: InputMaybe<Array<DispositiveProvisionTemplateKind>>;
  kindNEQ?: InputMaybe<DispositiveProvisionTemplateKind>;
  kindNotIn?: InputMaybe<Array<DispositiveProvisionTemplateKind>>;
  not?: InputMaybe<DispositiveProvisionTemplateWhereInput>;
  or?: InputMaybe<Array<DispositiveProvisionTemplateWhereInput>>;
  /** pro_rata field predicates */
  proRata?: InputMaybe<Scalars['Boolean']['input']>;
  /** residuary_pays_all_taxes field predicates */
  residuaryPaysAllTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** sub_kind field predicates */
  subKind?: InputMaybe<DispositiveProvisionTemplateSubKind>;
  subKindIn?: InputMaybe<Array<DispositiveProvisionTemplateSubKind>>;
  subKindNEQ?: InputMaybe<DispositiveProvisionTemplateSubKind>;
  subKindNotIn?: InputMaybe<Array<DispositiveProvisionTemplateSubKind>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** DispositiveProvisionTransferTaxKind is enum for the field transfer_tax_kind */
export enum DispositiveProvisionTransferTaxKind {
  Charitable = 'CHARITABLE',
  Generation_2OrOtherIndividual = 'GENERATION_2_OR_OTHER_INDIVIDUAL',
  Generation_2Then_3 = 'GENERATION_2_THEN_3',
  Generation_3 = 'GENERATION_3',
  Pourover = 'POUROVER',
  SpouseCreditShelter = 'SPOUSE_CREDIT_SHELTER',
  SpouseFederalCreditShelterStateMaritalExclusion = 'SPOUSE_FEDERAL_CREDIT_SHELTER_STATE_MARITAL_EXCLUSION',
  SpouseMaritalExclusion = 'SPOUSE_MARITAL_EXCLUSION'
}

/**
 * DispositiveProvisionWhereInput is used for filtering DispositiveProvision objects.
 * Input was generated by ent.
 */
export type DispositiveProvisionWhereInput = {
  and?: InputMaybe<Array<DispositiveProvisionWhereInput>>;
  /** bears_tax field predicates */
  bearsTax?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** disposition_amount field predicates */
  dispositionAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  dispositionAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  dispositionAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  dispositionAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dispositionAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  dispositionAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  dispositionAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  dispositionAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disposition_formulaic_percentage field predicates */
  dispositionFormulaicPercentage?: InputMaybe<Scalars['Percent']['input']>;
  dispositionFormulaicPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  dispositionFormulaicPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  dispositionFormulaicPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dispositionFormulaicPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  dispositionFormulaicPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  dispositionFormulaicPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  dispositionFormulaicPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disposition_kind field predicates */
  dispositionKind?: InputMaybe<DispositiveProvisionDispositionKind>;
  dispositionKindIn?: InputMaybe<Array<DispositiveProvisionDispositionKind>>;
  dispositionKindNEQ?: InputMaybe<DispositiveProvisionDispositionKind>;
  dispositionKindNotIn?: InputMaybe<Array<DispositiveProvisionDispositionKind>>;
  /** disposition_limit field predicates */
  dispositionLimit?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  dispositionLimitGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  dispositionLimitGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  dispositionLimitIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dispositionLimitLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  dispositionLimitLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  dispositionLimitNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  dispositionLimitNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** disposition_order field predicates */
  dispositionOrder?: InputMaybe<Scalars['Int']['input']>;
  dispositionOrderGT?: InputMaybe<Scalars['Int']['input']>;
  dispositionOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  dispositionOrderLT?: InputMaybe<Scalars['Int']['input']>;
  dispositionOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  dispositionOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** disposition_percentage field predicates */
  dispositionPercentage?: InputMaybe<Scalars['Percent']['input']>;
  dispositionPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  dispositionPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  dispositionPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dispositionPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  dispositionPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  dispositionPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  dispositionPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** gross_up_disposition_amount field predicates */
  grossUpDispositionAmount?: InputMaybe<Scalars['Boolean']['input']>;
  /** grow_by_inflation field predicates */
  growByInflation?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_groups edge predicates */
  hasAssetGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetGroupsWith?: InputMaybe<Array<AssetGroupWhereInput>>;
  /** asset_statics edge predicates */
  hasAssetStatics?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetStaticsWith?: InputMaybe<Array<AssetStaticWhereInput>>;
  /** associated_hypothetical_waterfall edge predicates */
  hasAssociatedHypotheticalWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssociatedHypotheticalWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** individual edge predicates */
  hasIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** insurance_policies edge predicates */
  hasInsurancePolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasInsurancePoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** ownership_stakes edge predicates */
  hasOwnershipStakes?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnershipStakesWith?: InputMaybe<Array<OwnershipStakeWhereInput>>;
  /** suggested_dp_recipient edge predicates */
  hasSuggestedDpRecipient?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuggestedDpRecipientWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** testamentary_entity edge predicates */
  hasTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasTestamentaryEntityWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DispositiveProvisionWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<DispositiveProvisionWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** transfer_method field predicates */
  transferMethod?: InputMaybe<TransferMethod>;
  transferMethodIn?: InputMaybe<Array<TransferMethod>>;
  transferMethodNEQ?: InputMaybe<TransferMethod>;
  transferMethodNotIn?: InputMaybe<Array<TransferMethod>>;
  /** transfer_tax_kind field predicates */
  transferTaxKind?: InputMaybe<DispositiveProvisionTransferTaxKind>;
  transferTaxKindIn?: InputMaybe<Array<DispositiveProvisionTransferTaxKind>>;
  transferTaxKindNEQ?: InputMaybe<DispositiveProvisionTransferTaxKind>;
  transferTaxKindNotIn?: InputMaybe<Array<DispositiveProvisionTransferTaxKind>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type DividerBundleConfiguration = Node & {
  __typename?: 'DividerBundleConfiguration';
  bundle?: Maybe<PresentationBundle>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The content of the divider page, rendered as Markdown. */
  customContent?: Maybe<Scalars['String']['output']>;
  /** The title displayed on the divider page. */
  dividerTitle?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type DividerBundleConfigurationConnection = {
  __typename?: 'DividerBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DividerBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DividerBundleConfigurationEdge = {
  __typename?: 'DividerBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DividerBundleConfiguration>;
};

/** Ordering options for DividerBundleConfiguration connections */
export type DividerBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DividerBundleConfigurations. */
  field: DividerBundleConfigurationOrderField;
};

/** Properties by which DividerBundleConfiguration connections can be ordered. */
export enum DividerBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * DividerBundleConfigurationWhereInput is used for filtering DividerBundleConfiguration objects.
 * Input was generated by ent.
 */
export type DividerBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<DividerBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** custom_content field predicates */
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customContentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** divider_title field predicates */
  dividerTitle?: InputMaybe<Scalars['String']['input']>;
  dividerTitleIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dividerTitleNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DividerBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<DividerBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type DividerTemplateBundleConfiguration = Node & {
  __typename?: 'DividerTemplateBundleConfiguration';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The content of the divider page, rendered as Markdown. */
  customContent?: Maybe<Scalars['String']['output']>;
  /** The title displayed on the divider page. */
  dividerTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  templateBundle?: Maybe<PresentationTemplateBundle>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type DividerTemplateBundleConfigurationConnection = {
  __typename?: 'DividerTemplateBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DividerTemplateBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DividerTemplateBundleConfigurationEdge = {
  __typename?: 'DividerTemplateBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DividerTemplateBundleConfiguration>;
};

/** Ordering options for DividerTemplateBundleConfiguration connections */
export type DividerTemplateBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DividerTemplateBundleConfigurations. */
  field: DividerTemplateBundleConfigurationOrderField;
};

/** Properties by which DividerTemplateBundleConfiguration connections can be ordered. */
export enum DividerTemplateBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * DividerTemplateBundleConfigurationWhereInput is used for filtering DividerTemplateBundleConfiguration objects.
 * Input was generated by ent.
 */
export type DividerTemplateBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<DividerTemplateBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** custom_content field predicates */
  customContent?: InputMaybe<Scalars['String']['input']>;
  customContentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customContentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** divider_title field predicates */
  dividerTitle?: InputMaybe<Scalars['String']['input']>;
  dividerTitleIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dividerTitleNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** template_bundle edge predicates */
  hasTemplateBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasTemplateBundleWith?: InputMaybe<Array<PresentationTemplateBundleWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DividerTemplateBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<DividerTemplateBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Document = Node & {
  __typename?: 'Document';
  /** Entities that are associated with this document, but are not the owner of the document. */
  additionalEntities?: Maybe<Array<Entity>>;
  /** Testamentary entities that are associated with this document, but are not the owner of the document. */
  additionalTestamentaryEntities?: Maybe<Array<TestamentaryEntity>>;
  /** The precedence that the suggestions from this document should take when extracting data. If this is not explicitly set, suggestions order will be inferred by uploaded date (most recent first). Only applicable for documents associated with entities. */
  aiSuggestionOrder?: Maybe<Scalars['Int']['output']>;
  annotatedDocumentContent?: Maybe<Scalars['String']['output']>;
  asyncJobs: AsyncJobConnection;
  /** Client profile associated with this document which must be a will, health care proxy, or POA */
  clientProfile?: Maybe<ClientProfile>;
  conversations: ConversationConnection;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** If set, this document is the default document for the entity */
  defaultDocumentOfEntity?: Maybe<Entity>;
  /**
   * annotatedDocumentContent with detected PII replaced by consistent,
   * irreversible pseudonyms via Google Cloud DLP. Paragraph-ID annotations are
   * preserved. Requires DLP configuration; errors when the environment or
   * authenticated tenant is not permitted. null when there is no content.
   */
  deidentifiedAnnotatedDocumentContent?: Maybe<Scalars['String']['output']>;
  /**
   * ocrExtractedMarkdownContent with detected PII replaced by consistent,
   * irreversible pseudonyms via Google Cloud DLP. Requires DLP configuration;
   * errors when the environment or authenticated tenant is not permitted.
   * null when there is no OCR content.
   */
  deidentifiedOcrExtractedMarkdownContent?: Maybe<Scalars['String']['output']>;
  displayType: Scalars['String']['output'];
  dsue?: Maybe<Array<DsuePortability>>;
  /** Entity that owns this document */
  entity?: Maybe<Entity>;
  entityDocumentRelationships: EntityDocumentRelationshipConnection;
  /** The estate insights of the document */
  estateInsights?: Maybe<Array<EstateInsight>>;
  file: File;
  household: Household;
  id: Scalars['ID']['output'];
  lifetimeExclusionEvent?: Maybe<Array<LifetimeExclusionEvent>>;
  loggedTransfers?: Maybe<Array<LoggedTransfer>>;
  memos: MemoConnection;
  name: Scalars['String']['output'];
  /** The next version of the document. This is used to associate amendments, restatements, codicils, etc. This helps us make suggestions and summaries more accurate. */
  nextVersion?: Maybe<Document>;
  /**
   * Full saved Azure Layout JSON, without field filtering. null when the artifact
   * is absent. Reading this field does not run OCR.
   */
  ocrExtractedLayoutJSON?: Maybe<Scalars['String']['output']>;
  ocrExtractedMarkdownContent?: Maybe<Scalars['String']['output']>;
  /** The current processing stage or terminal result for this document. */
  parsingStatus?: Maybe<DocumentParsingStatus>;
  /** the PDF version of the file */
  pdfFile?: Maybe<File>;
  /** The previous version of the document. This is used to associate amendments, restatements, codicils, etc. This helps us make suggestions and summaries more accurate. */
  previousVersion?: Maybe<Document>;
  questions: DocumentQuestionConnection;
  /** The binder document this document was split from during binder splitting. */
  sourceBinder?: Maybe<Document>;
  /** Documents that were created by splitting this binder document. */
  splitDocuments?: Maybe<Array<Document>>;
  /** All of the summaries for this document */
  summaries?: Maybe<Array<DocumentSummary>>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  type: DocumentType;
  updatedAt: Scalars['Time']['output'];
  user: User;
  workflowTrackers: WorkflowTrackerConnection;
};


export type DocumentAsyncJobsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AsyncJobOrder>>;
  where?: InputMaybe<AsyncJobWhereInput>;
};


export type DocumentConversationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConversationOrder>>;
  where?: InputMaybe<ConversationWhereInput>;
};


export type DocumentDeidentifiedAnnotatedDocumentContentArgs = {
  options?: InputMaybe<DeidentifyOptions>;
};


export type DocumentDeidentifiedOcrExtractedMarkdownContentArgs = {
  options?: InputMaybe<DeidentifyOptions>;
};


export type DocumentEntityDocumentRelationshipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityDocumentRelationshipOrder>>;
  where?: InputMaybe<EntityDocumentRelationshipWhereInput>;
};


export type DocumentMemosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemoOrder>>;
  where?: InputMaybe<MemoWhereInput>;
};


export type DocumentQuestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentQuestionOrder>>;
  where?: InputMaybe<DocumentQuestionWhereInput>;
};


export type DocumentWorkflowTrackersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkflowTrackerOrder>>;
  where?: InputMaybe<WorkflowTrackerWhereInput>;
};

export type DocumentBoundingRegionQueryInput = {
  documentID: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  matchThreshold?: InputMaybe<Scalars['Float']['input']>;
  /**
   * This field will be injected as the question within the search prompt.
   * Only if this field is present, a generated response will be returned,
   * (unless the caller chooses to skip it).
   */
  query?: InputMaybe<Scalars['String']['input']>;
  /**
   * This field will be used to override the search prompt. Use this to avoid
   * the search prompt preamble, or if not asking a question.
   */
  searchPromptOverride?: InputMaybe<Scalars['String']['input']>;
  skipGeneratedResponse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of items. */
export type DocumentConnection = {
  __typename?: 'DocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/**
 * DocumentDownloadToken is a signed token for authenticating the download request.
 * The token can be used with the /api/download/document endpoint.
 */
export type DocumentDownloadToken = {
  __typename?: 'DocumentDownloadToken';
  /** Token expiration time in seconds */
  expiresInSeconds: Scalars['Int']['output'];
  /** Signed token for authenticating the download request */
  token: Scalars['String']['output'];
};

/** An edge in a connection. */
export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Document>;
};

export type DocumentEvidenceSearch = {
  __typename?: 'DocumentEvidenceSearch';
  documentID: Scalars['ID']['output'];
  searchString: Scalars['String']['output'];
};

export type DocumentEvidenceSearchInput = {
  documentID: Scalars['ID']['input'];
  searchString: Scalars['String']['input'];
};

/** Ordering options for Document connections */
export type DocumentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Documents. */
  field: DocumentOrderField;
};

/** Properties by which Document connections can be ordered. */
export enum DocumentOrderField {
  AiSuggestionOrder = 'ai_suggestion_order',
  CreatedAt = 'created_at',
  Name = 'name',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

/** DocumentParsingStatus is enum for the field parsing_status */
export enum DocumentParsingStatus {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  Extracting = 'EXTRACTING',
  OcrError = 'OCR_ERROR',
  Processing = 'PROCESSING'
}

export type DocumentQuestion = Node & {
  __typename?: 'DocumentQuestion';
  /** Answer(s) to this question, generated from the LLM, using the document */
  answers?: Maybe<Array<DocumentQuestionAnswers>>;
  /** The async job that generated the question/answer response */
  asyncJob?: Maybe<AsyncJob>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The document that this question is about */
  document: Document;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Helps us determine how to parse the answer */
  kind?: Maybe<DocumentQuestionKind>;
  question: Scalars['String']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

export type DocumentQuestionAnswers = Node & {
  __typename?: 'DocumentQuestionAnswers';
  answer: Scalars['String']['output'];
  chain: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  question?: Maybe<DocumentQuestion>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type DocumentQuestionAnswersConnection = {
  __typename?: 'DocumentQuestionAnswersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DocumentQuestionAnswersEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DocumentQuestionAnswersEdge = {
  __typename?: 'DocumentQuestionAnswersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DocumentQuestionAnswers>;
};

/** Ordering options for DocumentQuestionAnswers connections */
export type DocumentQuestionAnswersOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DocumentQuestionAnswersSlice. */
  field: DocumentQuestionAnswersOrderField;
};

/** Properties by which DocumentQuestionAnswers connections can be ordered. */
export enum DocumentQuestionAnswersOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * DocumentQuestionAnswersWhereInput is used for filtering DocumentQuestionAnswers objects.
 * Input was generated by ent.
 */
export type DocumentQuestionAnswersWhereInput = {
  and?: InputMaybe<Array<DocumentQuestionAnswersWhereInput>>;
  /** answer field predicates */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** chain field predicates */
  chain?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** question edge predicates */
  hasQuestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasQuestionWith?: InputMaybe<Array<DocumentQuestionWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DocumentQuestionAnswersWhereInput>;
  or?: InputMaybe<Array<DocumentQuestionAnswersWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** A connection to a list of items. */
export type DocumentQuestionConnection = {
  __typename?: 'DocumentQuestionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DocumentQuestionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DocumentQuestionEdge = {
  __typename?: 'DocumentQuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DocumentQuestion>;
};

/** DocumentQuestionKind is enum for the field kind */
export enum DocumentQuestionKind {
  BeneficialOwnerDetails = 'BENEFICIAL_OWNER_DETAILS',
  BeneficialOwnerDetailsNoEvidence = 'BENEFICIAL_OWNER_DETAILS_NO_EVIDENCE',
  BeneficiaryDetails = 'BENEFICIARY_DETAILS',
  BeneficiaryDetailsNoEvidence = 'BENEFICIARY_DETAILS_NO_EVIDENCE',
  BeneficiaryDetailsV2 = 'BENEFICIARY_DETAILS_V2',
  BeneficiaryDetailsV2NoEvidence = 'BENEFICIARY_DETAILS_V2_NO_EVIDENCE',
  BusinessEntityDetails = 'BUSINESS_ENTITY_DETAILS',
  BusinessEntityDetailsNoEvidence = 'BUSINESS_ENTITY_DETAILS_NO_EVIDENCE',
  BusinessEntityFincen = 'BUSINESS_ENTITY_FINCEN',
  BusinessEntityFincenNoEvidence = 'BUSINESS_ENTITY_FINCEN_NO_EVIDENCE',
  BusinessEntityTax = 'BUSINESS_ENTITY_TAX',
  BusinessEntityTaxNoEvidence = 'BUSINESS_ENTITY_TAX_NO_EVIDENCE',
  ConsolidatedTrustDetails = 'CONSOLIDATED_TRUST_DETAILS',
  GrantorDetails = 'GRANTOR_DETAILS',
  GrantorDetailsNoEvidence = 'GRANTOR_DETAILS_NO_EVIDENCE',
  KeyPersonDetails = 'KEY_PERSON_DETAILS',
  KeyPersonDetailsNoEvidence = 'KEY_PERSON_DETAILS_NO_EVIDENCE',
  Summary = 'SUMMARY',
  TrusteeDetails = 'TRUSTEE_DETAILS',
  TrusteeDetailsNoEvidence = 'TRUSTEE_DETAILS_NO_EVIDENCE',
  TrustAdvisorDetails = 'TRUST_ADVISOR_DETAILS',
  TrustAdvisorDetailsNoEvidence = 'TRUST_ADVISOR_DETAILS_NO_EVIDENCE',
  TrustDetails = 'TRUST_DETAILS',
  TrustDetailsNoEvidence = 'TRUST_DETAILS_NO_EVIDENCE'
}

/** Ordering options for DocumentQuestion connections */
export type DocumentQuestionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DocumentQuestions. */
  field: DocumentQuestionOrderField;
};

/** Properties by which DocumentQuestion connections can be ordered. */
export enum DocumentQuestionOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * DocumentQuestionWhereInput is used for filtering DocumentQuestion objects.
 * Input was generated by ent.
 */
export type DocumentQuestionWhereInput = {
  and?: InputMaybe<Array<DocumentQuestionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** answers edge predicates */
  hasAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAnswersWith?: InputMaybe<Array<DocumentQuestionAnswersWhereInput>>;
  /** async_job edge predicates */
  hasAsyncJob?: InputMaybe<Scalars['Boolean']['input']>;
  hasAsyncJobWith?: InputMaybe<Array<AsyncJobWhereInput>>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<DocumentQuestionKind>;
  kindIn?: InputMaybe<Array<DocumentQuestionKind>>;
  kindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  kindNEQ?: InputMaybe<DocumentQuestionKind>;
  kindNotIn?: InputMaybe<Array<DocumentQuestionKind>>;
  kindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<DocumentQuestionWhereInput>;
  or?: InputMaybe<Array<DocumentQuestionWhereInput>>;
  /** question field predicates */
  question?: InputMaybe<Scalars['String']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * A connected group of readable household documents for selection.
 * Each document appears in exactly one group. Links in either direction join
 * groups, including a document that relates to multiple otherwise separate roots.
 * Grouping does not establish legal precedence or expand extraction scope.
 */
export type DocumentSelectionGroup = {
  __typename?: 'DocumentSelectionGroup';
  /**
   * Display representative, not necessarily the current or controlling document.
   * The lowest-ID member without an accepted predecessor link is preferred.
   * If every member has a predecessor, the lowest-ID member is used.
   */
  primaryDocument: Document;
  /** All other group members, ordered by ID. Empty for an unlinked document. */
  relatedDocuments: Array<Document>;
};

export type DocumentSummary = Node & {
  __typename?: 'DocumentSummary';
  /** The user's feedback on the AI-generated summary. Ignore if entry_mode is USER */
  aiSummaryFeedback?: Maybe<Scalars['String']['output']>;
  /** The user's rating of the AI-generated summary. Ignore if entry_mode is USER */
  aiSummaryRating?: Maybe<DocumentSummaryAiSummaryRating>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /**
   * summary with detected PII replaced by consistent, irreversible pseudonyms
   * via Google Cloud DLP. Requires DLP configuration; errors when the environment
   * or authenticated tenant is not permitted.
   */
  deidentifiedSummary?: Maybe<Scalars['String']['output']>;
  /** Display name for the document summary. Default: 'Default summary' */
  displayName: Scalars['String']['output'];
  /** The document that this summary is associated with. */
  documentv2: Document;
  /** The entity notes for which this document summary generated AI client presentation notes */
  entityNotes?: Maybe<Array<EntityNotes>>;
  /** Indicates if the summary content was updated by the user or generated by AI. Default: AI_AUTO */
  entryMode?: Maybe<DocumentSummaryEntryMode>;
  /** The user who provided feedback on this document summary */
  feedbackFrom?: Maybe<User>;
  /** The prompt that was used to generate this document summary */
  generatedFromPrompt?: Maybe<DocumentSummaryPrompt>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The presentation pages that this summary is associated with */
  presentationPages?: Maybe<Array<DocumentSummaryPage>>;
  sourceDocuments: DocumentConnection;
  /** The most recently-edited summary for the document */
  summary: Scalars['String']['output'];
  /** The format of the summary string when displaying it to the user on the frontend. Default: MARKDOWN */
  summaryFormat?: Maybe<DocumentSummarySummaryFormat>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
  workflowTrackers: WorkflowTrackerConnection;
};


export type DocumentSummaryDeidentifiedSummaryArgs = {
  options?: InputMaybe<DeidentifyOptions>;
};


export type DocumentSummarySourceDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentOrder>>;
};


export type DocumentSummaryWorkflowTrackersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkflowTrackerOrder>>;
  where?: InputMaybe<WorkflowTrackerWhereInput>;
};

/** DocumentSummaryAiSummaryRating is enum for the field ai_summary_rating */
export enum DocumentSummaryAiSummaryRating {
  Bad = 'BAD',
  Good = 'GOOD'
}

/** A connection to a list of items. */
export type DocumentSummaryConnection = {
  __typename?: 'DocumentSummaryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DocumentSummaryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DocumentSummaryEdge = {
  __typename?: 'DocumentSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DocumentSummary>;
};

/** DocumentSummaryEntryMode is enum for the field entry_mode */
export enum DocumentSummaryEntryMode {
  AiAuto = 'AI_AUTO',
  AiUserInvoked = 'AI_USER_INVOKED',
  User = 'USER'
}

/** Ordering options for DocumentSummary connections */
export type DocumentSummaryOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DocumentSummaries. */
  field: DocumentSummaryOrderField;
};

/** Properties by which DocumentSummary connections can be ordered. */
export enum DocumentSummaryOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type DocumentSummaryPage = Node & {
  __typename?: 'DocumentSummaryPage';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The document type for this document summary page. */
  documentType?: Maybe<PresentationDocumentType>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  relevantClientProfiles: ClientProfileConnection;
  /** The summary that this page is about */
  summary?: Maybe<DocumentSummary>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type DocumentSummaryPageRelevantClientProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClientProfileOrder>>;
  where?: InputMaybe<ClientProfileWhereInput>;
};

/** A connection to a list of items. */
export type DocumentSummaryPageConnection = {
  __typename?: 'DocumentSummaryPageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DocumentSummaryPageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DocumentSummaryPageEdge = {
  __typename?: 'DocumentSummaryPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DocumentSummaryPage>;
};

export type DocumentSummaryPrompt = Node & {
  __typename?: 'DocumentSummaryPrompt';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Display name for the prompt */
  displayName: Scalars['String']['output'];
  /** The document type this prompt is for */
  documentType: DocumentSummaryPromptDocumentType;
  id: Scalars['ID']['output'];
  /** Whether this prompt is the default for the document type; if set to true, clears any other default for the document type */
  isDefaultForDocType: Scalars['Boolean']['output'];
  /** Whether this is a system-provided prompt */
  isSystemPrompt: Scalars['Boolean']['output'];
  /** The prompt content in markdown format. Required for non-system prompts. */
  promptMarkdown?: Maybe<Scalars['String']['output']>;
  /** When enabled, this prompt will auto-run for uploads of its document type. */
  shouldAutoRun: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  testRuns: DocumentSummaryPromptTestRunConnection;
  updatedAt: Scalars['Time']['output'];
  /** When enabled, uses a more capable model to generate the summary. */
  useExtendedThinkingModal: Scalars['Boolean']['output'];
  user: User;
};


export type DocumentSummaryPromptTestRunsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSummaryPromptTestRunOrder>>;
  where?: InputMaybe<DocumentSummaryPromptTestRunWhereInput>;
};

/** A connection to a list of items. */
export type DocumentSummaryPromptConnection = {
  __typename?: 'DocumentSummaryPromptConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DocumentSummaryPromptEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** DocumentSummaryPromptDocumentType is enum for the field document_type */
export enum DocumentSummaryPromptDocumentType {
  AccountDocumentationStatement = 'ACCOUNT_DOCUMENTATION_STATEMENT',
  AdvanceDirective = 'ADVANCE_DIRECTIVE',
  ArticlesOfIncorporation = 'ARTICLES_OF_INCORPORATION',
  AssetValuation = 'ASSET_VALUATION',
  AssignmentOfInterest = 'ASSIGNMENT_OF_INTEREST',
  AssignmentOfTangibleProperty = 'ASSIGNMENT_OF_TANGIBLE_PROPERTY',
  BalanceSheet = 'BALANCE_SHEET',
  BeneficialOwnershipInformationReport = 'BENEFICIAL_OWNERSHIP_INFORMATION_REPORT',
  BeneficiaryDesignation = 'BENEFICIARY_DESIGNATION',
  Binder = 'BINDER',
  CertificateOfTrust = 'CERTIFICATE_OF_TRUST',
  CorporateBylaws = 'CORPORATE_BYLAWS',
  CrummeyLetter = 'CRUMMEY_LETTER',
  Deed = 'DEED',
  DivorceSettlement = 'DIVORCE_SETTLEMENT',
  DriversLicense = 'DRIVERS_LICENSE',
  ExistingRemainderTrustDocument = 'EXISTING_REMAINDER_TRUST_DOCUMENT',
  FincenFiling = 'FINCEN_FILING',
  GeneratedDocument = 'GENERATED_DOCUMENT',
  GeneratedPresentation = 'GENERATED_PRESENTATION',
  GiftTaxReturn = 'GIFT_TAX_RETURN',
  GratDesignSummary = 'GRAT_DESIGN_SUMMARY',
  HealthcareProxy = 'HEALTHCARE_PROXY',
  HipaaWaiver = 'HIPAA_WAIVER',
  HouseholdExport = 'HOUSEHOLD_EXPORT',
  IncomeTaxReturn = 'INCOME_TAX_RETURN',
  InsurancePolicy = 'INSURANCE_POLICY',
  InsurancePremiumPayment = 'INSURANCE_PREMIUM_PAYMENT',
  LetterOfWishes = 'LETTER_OF_WISHES',
  LivingWill = 'LIVING_WILL',
  LlcAgreement = 'LLC_AGREEMENT',
  LlcAgreementAmendment = 'LLC_AGREEMENT_AMENDMENT',
  LoanNoteAgreement = 'LOAN_NOTE_AGREEMENT',
  LoggedContribution = 'LOGGED_CONTRIBUTION',
  LoggedDistribution = 'LOGGED_DISTRIBUTION',
  OperatingAgreement = 'OPERATING_AGREEMENT',
  OperatingAgreementAmendment = 'OPERATING_AGREEMENT_AMENDMENT',
  Other = 'OTHER',
  PartnershipAgreement = 'PARTNERSHIP_AGREEMENT',
  PartnershipAgreementAmendment = 'PARTNERSHIP_AGREEMENT_AMENDMENT',
  Passport = 'PASSPORT',
  PowerOfAttorney = 'POWER_OF_ATTORNEY',
  PrenuptialAgreement = 'PRENUPTIAL_AGREEMENT',
  ShareholdersAgreement = 'SHAREHOLDERS_AGREEMENT',
  SignedTrustDocument = 'SIGNED_TRUST_DOCUMENT',
  StateBusinessFiling = 'STATE_BUSINESS_FILING',
  TaxFiling = 'TAX_FILING',
  TaxIdConfirmation = 'TAX_ID_CONFIRMATION',
  TaxReceipt = 'TAX_RECEIPT',
  TransferConfirmation = 'TRANSFER_CONFIRMATION',
  TrustAmendment = 'TRUST_AMENDMENT',
  TrustRelatedDocument = 'TRUST_RELATED_DOCUMENT',
  Will = 'WILL',
  WillCodicil = 'WILL_CODICIL'
}

/** An edge in a connection. */
export type DocumentSummaryPromptEdge = {
  __typename?: 'DocumentSummaryPromptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DocumentSummaryPrompt>;
};

/** Ordering options for DocumentSummaryPrompt connections */
export type DocumentSummaryPromptOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DocumentSummaryPrompts. */
  field: DocumentSummaryPromptOrderField;
};

/** Properties by which DocumentSummaryPrompt connections can be ordered. */
export enum DocumentSummaryPromptOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type DocumentSummaryPromptTestRun = Node & {
  __typename?: 'DocumentSummaryPromptTestRun';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The document this test run was executed against */
  document: Document;
  /** The document summary prompt this test run is based on */
  documentSummaryPrompt?: Maybe<DocumentSummaryPrompt>;
  id: Scalars['ID']['output'];
  /** The prompt content in markdown format used for this test run */
  promptMarkdown: Scalars['String']['output'];
  /** The generated summary result from this test run. This will be initialized to nil, then populated as the test run is finished. */
  summaryResult?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  /** The workflow tracker for this test run */
  workflowTracker?: Maybe<WorkflowTracker>;
};

/** A connection to a list of items. */
export type DocumentSummaryPromptTestRunConnection = {
  __typename?: 'DocumentSummaryPromptTestRunConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DocumentSummaryPromptTestRunEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DocumentSummaryPromptTestRunEdge = {
  __typename?: 'DocumentSummaryPromptTestRunEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DocumentSummaryPromptTestRun>;
};

/** Ordering options for DocumentSummaryPromptTestRun connections */
export type DocumentSummaryPromptTestRunOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DocumentSummaryPromptTestRuns. */
  field: DocumentSummaryPromptTestRunOrderField;
};

/** Properties by which DocumentSummaryPromptTestRun connections can be ordered. */
export enum DocumentSummaryPromptTestRunOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * DocumentSummaryPromptTestRunWhereInput is used for filtering DocumentSummaryPromptTestRun objects.
 * Input was generated by ent.
 */
export type DocumentSummaryPromptTestRunWhereInput = {
  and?: InputMaybe<Array<DocumentSummaryPromptTestRunWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  /** document_summary_prompt edge predicates */
  hasDocumentSummaryPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentSummaryPromptWith?: InputMaybe<Array<DocumentSummaryPromptWhereInput>>;
  hasDocumentWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** workflow_tracker edge predicates */
  hasWorkflowTracker?: InputMaybe<Scalars['Boolean']['input']>;
  hasWorkflowTrackerWith?: InputMaybe<Array<WorkflowTrackerWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DocumentSummaryPromptTestRunWhereInput>;
  or?: InputMaybe<Array<DocumentSummaryPromptTestRunWhereInput>>;
  /** prompt_markdown field predicates */
  promptMarkdown?: InputMaybe<Scalars['String']['input']>;
  /** summary_result field predicates */
  summaryResult?: InputMaybe<Scalars['String']['input']>;
  summaryResultIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  summaryResultNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * DocumentSummaryPromptWhereInput is used for filtering DocumentSummaryPrompt objects.
 * Input was generated by ent.
 */
export type DocumentSummaryPromptWhereInput = {
  and?: InputMaybe<Array<DocumentSummaryPromptWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** document_type field predicates */
  documentType?: InputMaybe<DocumentSummaryPromptDocumentType>;
  documentTypeIn?: InputMaybe<Array<DocumentSummaryPromptDocumentType>>;
  documentTypeNEQ?: InputMaybe<DocumentSummaryPromptDocumentType>;
  documentTypeNotIn?: InputMaybe<Array<DocumentSummaryPromptDocumentType>>;
  /** test_runs edge predicates */
  hasTestRuns?: InputMaybe<Scalars['Boolean']['input']>;
  hasTestRunsWith?: InputMaybe<Array<DocumentSummaryPromptTestRunWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_default_for_doc_type field predicates */
  isDefaultForDocType?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_system_prompt field predicates */
  isSystemPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<DocumentSummaryPromptWhereInput>;
  or?: InputMaybe<Array<DocumentSummaryPromptWhereInput>>;
  /** prompt_markdown field predicates */
  promptMarkdown?: InputMaybe<Scalars['String']['input']>;
  promptMarkdownIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  promptMarkdownNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** should_auto_run field predicates */
  shouldAutoRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** use_extended_thinking_modal field predicates */
  useExtendedThinkingModal?: InputMaybe<Scalars['Boolean']['input']>;
};

/** DocumentSummarySummaryFormat is enum for the field summary_format */
export enum DocumentSummarySummaryFormat {
  Markdown = 'MARKDOWN',
  PlainText = 'PLAIN_TEXT'
}

export type DocumentSummaryTemplateBundleConfiguration = Node & {
  __typename?: 'DocumentSummaryTemplateBundleConfiguration';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The document type filter for this document summary bundle. */
  documentType?: Maybe<PresentationDocumentType>;
  id: Scalars['ID']['output'];
  /** If true, includes document summaries for the first grantor. */
  includeFirstGrantor: Scalars['Boolean']['output'];
  /** If true, includes document summaries for the second grantor. */
  includeSecondGrantor: Scalars['Boolean']['output'];
  templateBundle?: Maybe<PresentationTemplateBundle>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type DocumentSummaryTemplateBundleConfigurationConnection = {
  __typename?: 'DocumentSummaryTemplateBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DocumentSummaryTemplateBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DocumentSummaryTemplateBundleConfigurationEdge = {
  __typename?: 'DocumentSummaryTemplateBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DocumentSummaryTemplateBundleConfiguration>;
};

/** Ordering options for DocumentSummaryTemplateBundleConfiguration connections */
export type DocumentSummaryTemplateBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DocumentSummaryTemplateBundleConfigurations. */
  field: DocumentSummaryTemplateBundleConfigurationOrderField;
};

/** Properties by which DocumentSummaryTemplateBundleConfiguration connections can be ordered. */
export enum DocumentSummaryTemplateBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * DocumentSummaryTemplateBundleConfigurationWhereInput is used for filtering DocumentSummaryTemplateBundleConfiguration objects.
 * Input was generated by ent.
 */
export type DocumentSummaryTemplateBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<DocumentSummaryTemplateBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** document_type field predicates */
  documentType?: InputMaybe<PresentationDocumentType>;
  documentTypeIn?: InputMaybe<Array<PresentationDocumentType>>;
  documentTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  documentTypeNEQ?: InputMaybe<PresentationDocumentType>;
  documentTypeNotIn?: InputMaybe<Array<PresentationDocumentType>>;
  documentTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** template_bundle edge predicates */
  hasTemplateBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasTemplateBundleWith?: InputMaybe<Array<PresentationTemplateBundleWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_first_grantor field predicates */
  includeFirstGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_second_grantor field predicates */
  includeSecondGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<DocumentSummaryTemplateBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<DocumentSummaryTemplateBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * DocumentSummaryWhereInput is used for filtering DocumentSummary objects.
 * Input was generated by ent.
 */
export type DocumentSummaryWhereInput = {
  /** ai_summary_feedback field predicates */
  aiSummaryFeedback?: InputMaybe<Scalars['String']['input']>;
  aiSummaryFeedbackIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  aiSummaryFeedbackNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ai_summary_rating field predicates */
  aiSummaryRating?: InputMaybe<DocumentSummaryAiSummaryRating>;
  aiSummaryRatingIn?: InputMaybe<Array<DocumentSummaryAiSummaryRating>>;
  aiSummaryRatingIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  aiSummaryRatingNEQ?: InputMaybe<DocumentSummaryAiSummaryRating>;
  aiSummaryRatingNotIn?: InputMaybe<Array<DocumentSummaryAiSummaryRating>>;
  aiSummaryRatingNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<DocumentSummaryWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** entry_mode field predicates */
  entryMode?: InputMaybe<DocumentSummaryEntryMode>;
  entryModeIn?: InputMaybe<Array<DocumentSummaryEntryMode>>;
  entryModeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  entryModeNEQ?: InputMaybe<DocumentSummaryEntryMode>;
  entryModeNotIn?: InputMaybe<Array<DocumentSummaryEntryMode>>;
  entryModeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** documentv2 edge predicates */
  hasDocumentv2?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentv2With?: InputMaybe<Array<DocumentWhereInput>>;
  /** entity_notes edge predicates */
  hasEntityNotes?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityNotesWith?: InputMaybe<Array<EntityNotesWhereInput>>;
  /** feedback_from edge predicates */
  hasFeedbackFrom?: InputMaybe<Scalars['Boolean']['input']>;
  hasFeedbackFromWith?: InputMaybe<Array<UserWhereInput>>;
  /** generated_from_prompt edge predicates */
  hasGeneratedFromPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeneratedFromPromptWith?: InputMaybe<Array<DocumentSummaryPromptWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** workflow_trackers edge predicates */
  hasWorkflowTrackers?: InputMaybe<Scalars['Boolean']['input']>;
  hasWorkflowTrackersWith?: InputMaybe<Array<WorkflowTrackerWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DocumentSummaryWhereInput>;
  or?: InputMaybe<Array<DocumentSummaryWhereInput>>;
  /** summary field predicates */
  summary?: InputMaybe<Scalars['String']['input']>;
  /** summary_format field predicates */
  summaryFormat?: InputMaybe<DocumentSummarySummaryFormat>;
  summaryFormatIn?: InputMaybe<Array<DocumentSummarySummaryFormat>>;
  summaryFormatIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  summaryFormatNEQ?: InputMaybe<DocumentSummarySummaryFormat>;
  summaryFormatNotIn?: InputMaybe<Array<DocumentSummarySummaryFormat>>;
  summaryFormatNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** DocumentType is enum for the field type */
export enum DocumentType {
  AccountDocumentationStatement = 'ACCOUNT_DOCUMENTATION_STATEMENT',
  AdvanceDirective = 'ADVANCE_DIRECTIVE',
  ArticlesOfIncorporation = 'ARTICLES_OF_INCORPORATION',
  AssetValuation = 'ASSET_VALUATION',
  AssignmentOfInterest = 'ASSIGNMENT_OF_INTEREST',
  AssignmentOfTangibleProperty = 'ASSIGNMENT_OF_TANGIBLE_PROPERTY',
  BalanceSheet = 'BALANCE_SHEET',
  BeneficialOwnershipInformationReport = 'BENEFICIAL_OWNERSHIP_INFORMATION_REPORT',
  BeneficiaryDesignation = 'BENEFICIARY_DESIGNATION',
  Binder = 'BINDER',
  CertificateOfTrust = 'CERTIFICATE_OF_TRUST',
  CorporateBylaws = 'CORPORATE_BYLAWS',
  CrummeyLetter = 'CRUMMEY_LETTER',
  Deed = 'DEED',
  DivorceSettlement = 'DIVORCE_SETTLEMENT',
  DriversLicense = 'DRIVERS_LICENSE',
  ExistingRemainderTrustDocument = 'EXISTING_REMAINDER_TRUST_DOCUMENT',
  FincenFiling = 'FINCEN_FILING',
  GeneratedDocument = 'GENERATED_DOCUMENT',
  GeneratedPresentation = 'GENERATED_PRESENTATION',
  GiftTaxReturn = 'GIFT_TAX_RETURN',
  GratDesignSummary = 'GRAT_DESIGN_SUMMARY',
  HealthcareProxy = 'HEALTHCARE_PROXY',
  HipaaWaiver = 'HIPAA_WAIVER',
  HouseholdExport = 'HOUSEHOLD_EXPORT',
  IncomeTaxReturn = 'INCOME_TAX_RETURN',
  InsurancePolicy = 'INSURANCE_POLICY',
  InsurancePremiumPayment = 'INSURANCE_PREMIUM_PAYMENT',
  LetterOfWishes = 'LETTER_OF_WISHES',
  LivingWill = 'LIVING_WILL',
  LlcAgreement = 'LLC_AGREEMENT',
  LlcAgreementAmendment = 'LLC_AGREEMENT_AMENDMENT',
  LoanNoteAgreement = 'LOAN_NOTE_AGREEMENT',
  LoggedContribution = 'LOGGED_CONTRIBUTION',
  LoggedDistribution = 'LOGGED_DISTRIBUTION',
  OperatingAgreement = 'OPERATING_AGREEMENT',
  OperatingAgreementAmendment = 'OPERATING_AGREEMENT_AMENDMENT',
  Other = 'OTHER',
  PartnershipAgreement = 'PARTNERSHIP_AGREEMENT',
  PartnershipAgreementAmendment = 'PARTNERSHIP_AGREEMENT_AMENDMENT',
  Passport = 'PASSPORT',
  PowerOfAttorney = 'POWER_OF_ATTORNEY',
  PrenuptialAgreement = 'PRENUPTIAL_AGREEMENT',
  ShareholdersAgreement = 'SHAREHOLDERS_AGREEMENT',
  SignedTrustDocument = 'SIGNED_TRUST_DOCUMENT',
  StateBusinessFiling = 'STATE_BUSINESS_FILING',
  TaxFiling = 'TAX_FILING',
  TaxIdConfirmation = 'TAX_ID_CONFIRMATION',
  TaxReceipt = 'TAX_RECEIPT',
  TransferConfirmation = 'TRANSFER_CONFIRMATION',
  TrustAmendment = 'TRUST_AMENDMENT',
  TrustRelatedDocument = 'TRUST_RELATED_DOCUMENT',
  Will = 'WILL',
  WillCodicil = 'WILL_CODICIL'
}

/**
 * DocumentWhereInput is used for filtering Document objects.
 * Input was generated by ent.
 */
export type DocumentWhereInput = {
  /** ai_suggestion_order field predicates */
  aiSuggestionOrder?: InputMaybe<Scalars['Int']['input']>;
  aiSuggestionOrderGT?: InputMaybe<Scalars['Int']['input']>;
  aiSuggestionOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  aiSuggestionOrderIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  aiSuggestionOrderLT?: InputMaybe<Scalars['Int']['input']>;
  aiSuggestionOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  aiSuggestionOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  aiSuggestionOrderNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<DocumentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** additional_entities edge predicates */
  hasAdditionalEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasAdditionalEntitiesWith?: InputMaybe<Array<EntityWhereInput>>;
  /** additional_testamentary_entities edge predicates */
  hasAdditionalTestamentaryEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasAdditionalTestamentaryEntitiesWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** async_jobs edge predicates */
  hasAsyncJobs?: InputMaybe<Scalars['Boolean']['input']>;
  hasAsyncJobsWith?: InputMaybe<Array<AsyncJobWhereInput>>;
  /** client_profile edge predicates */
  hasClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientProfileWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** conversations edge predicates */
  hasConversations?: InputMaybe<Scalars['Boolean']['input']>;
  hasConversationsWith?: InputMaybe<Array<ConversationWhereInput>>;
  /** default_document_of_entity edge predicates */
  hasDefaultDocumentOfEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasDefaultDocumentOfEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** dsue edge predicates */
  hasDsue?: InputMaybe<Scalars['Boolean']['input']>;
  hasDsueWith?: InputMaybe<Array<DsuePortabilityWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_document_relationships edge predicates */
  hasEntityDocumentRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityDocumentRelationshipsWith?: InputMaybe<Array<EntityDocumentRelationshipWhereInput>>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** estate_insights edge predicates */
  hasEstateInsights?: InputMaybe<Scalars['Boolean']['input']>;
  hasEstateInsightsWith?: InputMaybe<Array<EstateInsightWhereInput>>;
  /** file edge predicates */
  hasFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileWith?: InputMaybe<Array<FileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** lifetime_exclusion_event edge predicates */
  hasLifetimeExclusionEvent?: InputMaybe<Scalars['Boolean']['input']>;
  hasLifetimeExclusionEventWith?: InputMaybe<Array<LifetimeExclusionEventWhereInput>>;
  /** logged_transfers edge predicates */
  hasLoggedTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  hasLoggedTransfersWith?: InputMaybe<Array<LoggedTransferWhereInput>>;
  /** memos edge predicates */
  hasMemos?: InputMaybe<Scalars['Boolean']['input']>;
  hasMemosWith?: InputMaybe<Array<MemoWhereInput>>;
  /** next_version edge predicates */
  hasNextVersion?: InputMaybe<Scalars['Boolean']['input']>;
  hasNextVersionWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** pdf_file edge predicates */
  hasPdfFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPdfFileWith?: InputMaybe<Array<FileWhereInput>>;
  /** previous_version edge predicates */
  hasPreviousVersion?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreviousVersionWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** questions edge predicates */
  hasQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  hasQuestionsWith?: InputMaybe<Array<DocumentQuestionWhereInput>>;
  /** source_binder edge predicates */
  hasSourceBinder?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceBinderWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** split_documents edge predicates */
  hasSplitDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasSplitDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** summaries edge predicates */
  hasSummaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasSummariesWith?: InputMaybe<Array<DocumentSummaryWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** workflow_trackers edge predicates */
  hasWorkflowTrackers?: InputMaybe<Scalars['Boolean']['input']>;
  hasWorkflowTrackersWith?: InputMaybe<Array<WorkflowTrackerWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<DocumentWhereInput>;
  or?: InputMaybe<Array<DocumentWhereInput>>;
  /** parsing_status field predicates */
  parsingStatus?: InputMaybe<DocumentParsingStatus>;
  parsingStatusIn?: InputMaybe<Array<DocumentParsingStatus>>;
  parsingStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parsingStatusNEQ?: InputMaybe<DocumentParsingStatus>;
  parsingStatusNotIn?: InputMaybe<Array<DocumentParsingStatus>>;
  parsingStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** type field predicates */
  type?: InputMaybe<DocumentType>;
  typeIn?: InputMaybe<Array<DocumentType>>;
  typeNEQ?: InputMaybe<DocumentType>;
  typeNotIn?: InputMaybe<Array<DocumentType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type DonorAdvisedFund = EntitySubtype & Named & Node & {
  __typename?: 'DonorAdvisedFund';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  beneficiaries?: Maybe<Array<Beneficiary>>;
  controllingParties?: Maybe<Array<ControllingParty>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this personal account */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in entities that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  donors?: Maybe<Array<Principal>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  performanceReport: PerformanceReport;
  policies?: Maybe<Array<InsurancePolicy>>;
  stateInEstateStatus: EntityInEstateStatus;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<NonTrustEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type DonorAdvisedFundHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type DonorAdvisedFundConnection = {
  __typename?: 'DonorAdvisedFundConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DonorAdvisedFundEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DonorAdvisedFundEdge = {
  __typename?: 'DonorAdvisedFundEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DonorAdvisedFund>;
};

/** Ordering options for DonorAdvisedFund connections */
export type DonorAdvisedFundOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DonorAdvisedFunds. */
  field: DonorAdvisedFundOrderField;
};

/** Properties by which DonorAdvisedFund connections can be ordered. */
export enum DonorAdvisedFundOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * DonorAdvisedFundWhereInput is used for filtering DonorAdvisedFund objects.
 * Input was generated by ent.
 */
export type DonorAdvisedFundWhereInput = {
  and?: InputMaybe<Array<DonorAdvisedFundWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** beneficiaries edge predicates */
  hasBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** controlling_parties edge predicates */
  hasControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  hasControllingPartiesWith?: InputMaybe<Array<ControllingPartyWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** donors edge predicates */
  hasDonors?: InputMaybe<Scalars['Boolean']['input']>;
  hasDonorsWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<DonorAdvisedFundWhereInput>;
  or?: InputMaybe<Array<DonorAdvisedFundWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type DuplicateEstateWaterfallHypotheticalTransferInput = {
  id: Scalars['ID']['input'];
};

export type DuplicateEstateWaterfallInput = {
  id: Scalars['ID']['input'];
  makeHypothetical?: InputMaybe<Scalars['Boolean']['input']>;
  newName: Scalars['String']['input'];
};

export type DuplicateEstateWaterfallOptsInput = {
  applyAutoGrouping?: InputMaybe<Scalars['Boolean']['input']>;
  resetAssumptions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EMoneyQueryResults = {
  __typename?: 'EMoneyQueryResults';
  results: Scalars['String']['output'];
};

/**
 * The application configuration currently in effect for the authenticated tenant.
 * Organization configuration is authoritative for organization-member tenants;
 * otherwise the tenant's own configuration is returned.
 */
export type EffectiveApplicationConfiguration = {
  __typename?: 'EffectiveApplicationConfiguration';
  allowUserPresentationTemplates: Scalars['Boolean']['output'];
  collaboratorDomainAllowList?: Maybe<Array<Scalars['String']['output']>>;
  disableAdvancedAnalytics: Scalars['Boolean']['output'];
  disableAiCapabilities: Scalars['Boolean']['output'];
  disableAiInsights: Scalars['Boolean']['output'];
  disableRoleManagement: Scalars['Boolean']['output'];
  disclaimerConfigurationOverridesDescendants: Scalars['Boolean']['output'];
  enableEmployeeIdpID: Scalars['Boolean']['output'];
  maxSessionDuration: EffectiveApplicationConfigurationMaxSessionDuration;
  mcpAccess: McpAccess;
  /** The review steps that client presentations require. */
  requirePresentationApproval: PresentationApprovalRequirement;
  /** The owner of the effective configuration. */
  scope: EffectiveApplicationConfigurationScope;
  smartReviewEnabled: Scalars['Boolean']['output'];
  userSessionInactivityTimeout: EffectiveApplicationConfigurationUserSessionInactivityTimeout;
};

export enum EffectiveApplicationConfigurationMaxSessionDuration {
  EightHours = 'EIGHT_HOURS',
  OneHour = 'ONE_HOUR',
  TwelveHours = 'TWELVE_HOURS',
  TwentyEightDays = 'TWENTY_EIGHT_DAYS'
}

export enum EffectiveApplicationConfigurationScope {
  Organization = 'ORGANIZATION',
  Tenant = 'TENANT'
}

export enum EffectiveApplicationConfigurationUserSessionInactivityTimeout {
  FifteenMinutes = 'FIFTEEN_MINUTES',
  FiveSecondsForTesting = 'FIVE_SECONDS_FOR_TESTING',
  Off = 'OFF',
  OneHour = 'ONE_HOUR'
}

/**
 * The disclaimer configuration currently in effect for the authenticated tenant.
 * Tenant values are the default. Sub-brand values override tenant values when
 * present. Organization values can override either source when the organization
 * policy is on.
 */
export type EffectiveDisclaimerConfiguration = {
  __typename?: 'EffectiveDisclaimerConfiguration';
  includeLuminaryDisclaimer: Scalars['Boolean']['output'];
  presentationCoverDisclaimerBody?: Maybe<Scalars['String']['output']>;
  presentationCoverDisclaimerTitle?: Maybe<Scalars['String']['output']>;
  presentationFooterDisclaimerBody?: Maybe<Scalars['String']['output']>;
  presentationFooterDisclaimerTitle?: Maybe<Scalars['String']['output']>;
  presentationStandaloneDisclaimerBody?: Maybe<Scalars['String']['output']>;
  presentationStandaloneDisclaimerTitle?: Maybe<Scalars['String']['output']>;
};

/**
 * The effective database override for one Education Page. The frontend's bundled
 * content remains the default when no result exists.
 */
export type EffectiveEducationPageOverride = {
  __typename?: 'EffectiveEducationPageOverride';
  contentJSON: Scalars['Map']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  isHidden: Scalars['Boolean']['output'];
  /** Whether another tenant in the organization manages this override. */
  isOrganizationManaged: Scalars['Boolean']['output'];
  slideIdentifier: Scalars['String']['output'];
};

export type Employee = Named & Node & {
  __typename?: 'Employee';
  assignedHouseholds?: Maybe<Array<Household>>;
  createdAt: Scalars['Time']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The user's unique id in their identify provider (automatically mapped as idp_id in WorkOS) */
  idpID?: Maybe<Scalars['String']['output']>;
  /** The workos_organization_id associated with the idp_id */
  idpWorkosOrganizationID?: Maybe<Scalars['String']['output']>;
  initials: Scalars['String']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** The timestamp when the employee last viewed the notifications list */
  lastViewedNotificationsListAt?: Maybe<Scalars['Time']['output']>;
  /** The timestamp when the employee last viewed the presentation approval requests list. Requests created after this time are new to the employee. A null value means that the employee has not viewed the list. */
  lastViewedPresentationApprovalsAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The number of open presentation approval requests that ask this employee's
   * user to approve and that were created after
   * lastViewedPresentationApprovalsAt. When lastViewedPresentationApprovalsAt is
   * null, the number of all open requests. Only the employee's own user can read
   * this field.
   */
  newPresentationApprovalRequestCount: Scalars['Int']['output'];
  roles?: Maybe<Array<Role>>;
  /** Employees can be team owners */
  teamOwner?: Maybe<Array<Team>>;
  /** Employees can belong to teams */
  teams?: Maybe<Array<Team>>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  tier: EmployeeTier;
  updatedAt: Scalars['Time']['output'];
  user: User;
  /** The WorkOS directory user id */
  workosDirectoryUserID?: Maybe<Scalars['String']['output']>;
  /** The WorkOS updated_at timestamp */
  workosUpdatedAt?: Maybe<Scalars['Time']['output']>;
};

/** A connection to a list of items. */
export type EmployeeConnection = {
  __typename?: 'EmployeeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmployeeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EmployeeEdge = {
  __typename?: 'EmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Employee>;
};

/** Ordering options for Employee connections */
export type EmployeeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Employees. */
  field: EmployeeOrderField;
};

/** Properties by which Employee connections can be ordered. */
export enum EmployeeOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** EmployeeTier is enum for the field tier */
export enum EmployeeTier {
  Advanced = 'ADVANCED',
  Basic = 'BASIC',
  ViewOnly = 'VIEW_ONLY'
}

/**
 * EmployeeWhereInput is used for filtering Employee objects.
 * Input was generated by ent.
 */
export type EmployeeWhereInput = {
  and?: InputMaybe<Array<EmployeeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** roles edge predicates */
  hasRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasRolesWith?: InputMaybe<Array<RoleWhereInput>>;
  /** team_owner edge predicates */
  hasTeamOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasTeamOwnerWith?: InputMaybe<Array<TeamWhereInput>>;
  /** teams edge predicates */
  hasTeams?: InputMaybe<Scalars['Boolean']['input']>;
  hasTeamsWith?: InputMaybe<Array<TeamWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** idp_id field predicates */
  idpID?: InputMaybe<Scalars['String']['input']>;
  idpIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  idpIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** idp_workos_organization_id field predicates */
  idpWorkosOrganizationID?: InputMaybe<Scalars['String']['input']>;
  idpWorkosOrganizationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  idpWorkosOrganizationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_admin field predicates */
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isAdminIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  isAdminNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_viewed_notifications_list_at field predicates */
  lastViewedNotificationsListAt?: InputMaybe<Scalars['Time']['input']>;
  lastViewedNotificationsListAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastViewedNotificationsListAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastViewedNotificationsListAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastViewedNotificationsListAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastViewedNotificationsListAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastViewedNotificationsListAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_viewed_presentation_approvals_at field predicates */
  lastViewedPresentationApprovalsAt?: InputMaybe<Scalars['Time']['input']>;
  lastViewedPresentationApprovalsAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastViewedPresentationApprovalsAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastViewedPresentationApprovalsAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastViewedPresentationApprovalsAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastViewedPresentationApprovalsAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastViewedPresentationApprovalsAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<EmployeeWhereInput>;
  or?: InputMaybe<Array<EmployeeWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** tier field predicates */
  tier?: InputMaybe<EmployeeTier>;
  tierIn?: InputMaybe<Array<EmployeeTier>>;
  tierNEQ?: InputMaybe<EmployeeTier>;
  tierNotIn?: InputMaybe<Array<EmployeeTier>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** workos_directory_user_id field predicates */
  workosDirectoryUserID?: InputMaybe<Scalars['String']['input']>;
  workosDirectoryUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  workosDirectoryUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** workos_updated_at field predicates */
  workosUpdatedAt?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  workosUpdatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EntitiesOverviewBundleConfiguration = Node & {
  __typename?: 'EntitiesOverviewBundleConfiguration';
  bundle?: Maybe<PresentationBundle>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The display name for the bundle. */
  displayName?: Maybe<Scalars['String']['output']>;
  entities: EntitiesOverviewBundleConfigurationEntityConnection;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  /** householdMetrics returns a summary of the household's assets and liabilities, filtered by the entities in the bundle configuration. */
  householdMetrics?: Maybe<HouseholdMetrics>;
  id: Scalars['ID']['output'];
  /** If true, shows summary metrics in the bundle. */
  showSummaryMetrics: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type EntitiesOverviewBundleConfigurationEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntitiesOverviewBundleConfigurationEntityOrder>>;
  where?: InputMaybe<EntitiesOverviewBundleConfigurationEntityWhereInput>;
};

/** A connection to a list of items. */
export type EntitiesOverviewBundleConfigurationConnection = {
  __typename?: 'EntitiesOverviewBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntitiesOverviewBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntitiesOverviewBundleConfigurationEdge = {
  __typename?: 'EntitiesOverviewBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntitiesOverviewBundleConfiguration>;
};

export type EntitiesOverviewBundleConfigurationEntity = Node & {
  __typename?: 'EntitiesOverviewBundleConfigurationEntity';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  entitiesOverviewBundleConfiguration: EntitiesOverviewBundleConfiguration;
  /** The EntitiesOverviewBundleConfiguration ID that this relationship references. */
  entitiesOverviewBundleConfigurationID: Scalars['ID']['output'];
  entity: Entity;
  /** The Entity ID that this relationship references. */
  entityID: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The order of the entity in the bundle. */
  index: Scalars['Int']['output'];
  /** If true, the entity is hidden in the bundle. */
  isHidden: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type EntitiesOverviewBundleConfigurationEntityConnection = {
  __typename?: 'EntitiesOverviewBundleConfigurationEntityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntitiesOverviewBundleConfigurationEntityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntitiesOverviewBundleConfigurationEntityEdge = {
  __typename?: 'EntitiesOverviewBundleConfigurationEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntitiesOverviewBundleConfigurationEntity>;
};

/** Ordering options for EntitiesOverviewBundleConfigurationEntity connections */
export type EntitiesOverviewBundleConfigurationEntityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EntitiesOverviewBundleConfigurationEntities. */
  field: EntitiesOverviewBundleConfigurationEntityOrderField;
};

/** Properties by which EntitiesOverviewBundleConfigurationEntity connections can be ordered. */
export enum EntitiesOverviewBundleConfigurationEntityOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EntitiesOverviewBundleConfigurationEntityWhereInput is used for filtering EntitiesOverviewBundleConfigurationEntity objects.
 * Input was generated by ent.
 */
export type EntitiesOverviewBundleConfigurationEntityWhereInput = {
  and?: InputMaybe<Array<EntitiesOverviewBundleConfigurationEntityWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** entities_overview_bundle_configuration_id field predicates */
  entitiesOverviewBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  entitiesOverviewBundleConfigurationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  entitiesOverviewBundleConfigurationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  entitiesOverviewBundleConfigurationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** entity_id field predicates */
  entityID?: InputMaybe<Scalars['ID']['input']>;
  entityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  entityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** entities_overview_bundle_configuration edge predicates */
  hasEntitiesOverviewBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntitiesOverviewBundleConfigurationWith?: InputMaybe<Array<EntitiesOverviewBundleConfigurationWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** index field predicates */
  index?: InputMaybe<Scalars['Int']['input']>;
  indexGT?: InputMaybe<Scalars['Int']['input']>;
  indexGTE?: InputMaybe<Scalars['Int']['input']>;
  indexLT?: InputMaybe<Scalars['Int']['input']>;
  indexLTE?: InputMaybe<Scalars['Int']['input']>;
  indexNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** is_hidden field predicates */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<EntitiesOverviewBundleConfigurationEntityWhereInput>;
  or?: InputMaybe<Array<EntitiesOverviewBundleConfigurationEntityWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Ordering options for EntitiesOverviewBundleConfiguration connections */
export type EntitiesOverviewBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EntitiesOverviewBundleConfigurations. */
  field: EntitiesOverviewBundleConfigurationOrderField;
};

/** Properties by which EntitiesOverviewBundleConfiguration connections can be ordered. */
export enum EntitiesOverviewBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EntitiesOverviewBundleConfigurationWhereInput is used for filtering EntitiesOverviewBundleConfiguration objects.
 * Input was generated by ent.
 */
export type EntitiesOverviewBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<EntitiesOverviewBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** entities edge predicates */
  hasEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntitiesWith?: InputMaybe<Array<EntitiesOverviewBundleConfigurationEntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<EntitiesOverviewBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<EntitiesOverviewBundleConfigurationWhereInput>>;
  /** show_summary_metrics field predicates */
  showSummaryMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Entity = Node & {
  __typename?: 'Entity';
  activities?: Maybe<Array<Activity>>;
  /** when true, indicates that the addepar entity this is linked to isn't owned by the grantor on addepar. this could be because the grantor on addepar is deceased or not present on Luminary. */
  addeparLinkedToNongrantorEntity?: Maybe<Scalars['Boolean']['output']>;
  additionalDocuments: DocumentConnection;
  assetGroups: AssetGroupConnection;
  assetStatics: AssetStaticConnection;
  asyncJobs: AsyncJobConnection;
  /** how the entity got created */
  attributionSource?: Maybe<EntityAttributionSource>;
  /** When set, all assets for this entity will be categorized under the specified balance sheet category rather than the true category for the asset. */
  balanceSheetCategoryOverride?: Maybe<BalanceSheetCategory>;
  cashflows: CashflowConnection;
  /** CCorp business entity subtype associated with this entity */
  ccorpBusinessEntity?: Maybe<CCorpBusinessEntity>;
  /** The person represented by this dedicated financial entity. The foreign key is stored on the client profile. */
  clientProfile?: Maybe<ClientProfile>;
  /** CLT trust subtype associated with this entity */
  cltTrust?: Maybe<CltTrust>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  createdSubtrusts: TestamentaryEntityConnection;
  /** CRT trust subtype associated with this entity */
  crtTrust?: Maybe<CrtTrust>;
  /**
   * The DP-targetable things this entity holds right now: asset
   * statics from its designer account's current valuation, owned
   * ownership stakes, and insurance policies (where the subtype
   * carries them). "Currently" means the most recent non-deleted
   * valuation whose effective_date is <= NOW. Empty sub-lists are
   * returned where a category does not apply (e.g. ownership stakes
   * for an entity that owns none).
   *
   * Use this in place of the legacy
   * `subtype.designerAccount.valuations(first:1, orderBy:effective_date DESC).assets`
   * + `ownedOwnershipStakes` + `subtype.policies` triple when the
   * caller wants "what this entity holds right now" rather than raw
   * access to the underlying edges.
   *
   * For the cross-entity (household-wide) case, prefer
   * `Household.entityHoldings` — it batches the underlying loads in a
   * single round-trip rather than fanning out per entity.
   */
  currentHoldings: EntityHoldings;
  /** The liabilities that this entity owes to others */
  currentLiabilitiesOwed: Scalars['CurrencyUSD']['output'];
  /** The liabilities that are owed to this entity */
  currentLiabilitiesOwned: Scalars['CurrencyUSD']['output'];
  /** Custodial personal account subtype associated with this entity */
  custodialPersonalAccount?: Maybe<CustodialPersonalAccount>;
  /** Notes associated with this a given death order for this entity */
  deathOrderNotes?: Maybe<Array<EntityNotes>>;
  /** The default document for this entity. */
  defaultDocument?: Maybe<Document>;
  documents: DocumentConnection;
  /** Donor advised fund subtype associated with this entity */
  donorAdvisedFund?: Maybe<DonorAdvisedFund>;
  /** Email notification records associated with this entity */
  emailNotificationRecords?: Maybe<Array<ReminderEmailNotificationRecord>>;
  entityDiagrams: EntityDiagramConnection;
  entityDocumentRelationships: EntityDocumentRelationshipConnection;
  entityProposals?: Maybe<Array<EntityProposal>>;
  /** Estate waterfall filters associated with this entity. Here to force the M2M relationship. */
  estateWaterfallFilters?: Maybe<Array<EstateWaterfallVisualizationFilter>>;
  extendedDisplayKind: Scalars['String']['output'];
  /** Customer-supplied identifier from an external system. Unique per tenant when set. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** GP business entity subtype associated with this entity */
  gpBusinessEntity?: Maybe<GpBusinessEntity>;
  /** GRAT trust subtype associated with this entity */
  gratTrust?: Maybe<GratTrust>;
  /** When true, assets will be grouped by category and account in the valuation */
  groupIntegrationAssetValues: Scalars['Boolean']['output'];
  household: Household;
  /** The hypothetical GRAT that is being simulated. */
  hypotheticalGrats?: Maybe<Array<HypotheticalGrat>>;
  id: Scalars['ID']['output'];
  /** ILIT trust subtype associated with this entity */
  ilitTrust?: Maybe<IlitTrust>;
  /** Individual personal account subtype associated with this entity */
  individualPersonalAccount?: Maybe<IndividualPersonalAccount>;
  /** Insurance personal account subtype associated with this entity */
  insurancePersonalAccount?: Maybe<InsurancePersonalAccount>;
  integrationEntities?: Maybe<Array<IntegrationEntity>>;
  /** Irrevocable trust subtype associated with this entity */
  irrevocableTrust?: Maybe<IrrevocableTrust>;
  /** Joint personal account subtype associated with this entity */
  jointPersonalAccount?: Maybe<JointPersonalAccount>;
  kgV2Nodes: Kgv2NodeConnection;
  /** Type of entity. This tells us what subtype edge to traverse */
  kind: EntityKind;
  liabilitiesLent: LiabilityConnection;
  liabilitiesOwed: LiabilityConnection;
  /** Controls how liquidity is determined for this entity. ASSET_BASED derives from underlying asset classes, LIQUID/ILLIQUID overrides all owned assets beneath it. */
  liquidityStatus: EntityLiquidityStatus;
  /** LLC business entity subtype associated with this entity */
  llcBusinessEntity?: Maybe<LlcBusinessEntity>;
  /** LP business entity subtype associated with this entity */
  lpBusinessEntity?: Maybe<LpBusinessEntity>;
  nextTask?: Maybe<EntityTask>;
  /** The onboarding suggestion that this entity was created from */
  onboardingEntitySuggestion?: Maybe<Array<AiSuggestion>>;
  /** The ownership stake of this entity for another individual or entity. */
  ownedByStakes?: Maybe<Array<OwnershipStake>>;
  /** Ownership stakes this entity has */
  ownedOwnershipStakes?: Maybe<Array<OwnershipStake>>;
  /** If this entity was created from an onboarding suggestion and is owned by another entity(ies), this is the associated ONBOARDING_ENTITY suggestion that is an owner of this entity. This will be used to create the ownership stake. */
  owningOnboardingEntitySuggestion?: Maybe<Array<AiSuggestion>>;
  /** When true, integration syncs do not update this entity's valuations or ownership. */
  pauseIntegrationSync: Scalars['Boolean']['output'];
  /** The existing entity that potentially matches the suggestion based on the LLM's analysis of the existing entity names (before the suggestion is accepted) */
  potentialEntitySuggestion?: Maybe<Array<AiSuggestion>>;
  /** Private foundation subtype associated with this entity */
  privateFoundation?: Maybe<PrivateFoundation>;
  /** QPRT trust subtype associated with this entity */
  qprtTrust?: Maybe<QprtTrust>;
  /** Qualified tuition personal account subtype associated with this entity */
  qualifiedTuitionPersonalAccount?: Maybe<QualifiedTuitionPersonalAccount>;
  /** AISuggestions that are about this entity. For example, entity details, AI DPs, etc. */
  relatedSuggestions?: Maybe<Array<AiSuggestion>>;
  /** Retirement personal account subtype associated with this entity */
  retirementPersonalAccount?: Maybe<RetirementPersonalAccount>;
  /** Revocable trust subtype associated with this entity */
  revocableTrust?: Maybe<RevocableTrust>;
  /** SCorp business entity subtype associated with this entity */
  scorpBusinessEntity?: Maybe<SCorpBusinessEntity>;
  /** When true, the entity name will be shown on the balance sheet rather than the names of the underlying assets */
  showEntityNameOnBalanceSheet: Scalars['Boolean']['output'];
  /** SLAT trust subtype associated with this entity */
  slatTrust?: Maybe<SlatTrust>;
  /** Sole Proprietorship business entity subtype associated with this entity */
  soleProprietorshipBusinessEntity?: Maybe<SoleProprietorshipBusinessEntity>;
  /** the lifecycle stage of the entity. not all stages are applicable to all entities; most go directly into ACTIVE */
  stage: EntityStage;
  /** The subtype of the entity. */
  subtype: EntitySubtype;
  /** The knowledge graph roots that are associated with this entity. */
  suggestionKgRoots?: Maybe<Array<KgRoot>>;
  /** When true, the same entity notes apply for all client profiles in the household */
  syncDeathOrderNotes: Scalars['Boolean']['output'];
  /** Whether to sync ownership percentage from integrations. */
  syncOwnership: Scalars['Boolean']['output'];
  tasks: EntityTaskConnection;
  /** Normalized tax inclusion information for this entity */
  taxInfo?: Maybe<EntityTaxInfo>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  /** Workflow trackers associated with this entity for things like valuation syncs */
  workflowTrackers?: Maybe<Array<WorkflowTracker>>;
};


export type EntityAdditionalDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentOrder>>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type EntityAssetGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssetGroupOrder>>;
  where?: InputMaybe<AssetGroupWhereInput>;
};


export type EntityAssetStaticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssetStaticOrder>>;
  where?: InputMaybe<AssetStaticWhereInput>;
};


export type EntityAsyncJobsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AsyncJobOrder>>;
  where?: InputMaybe<AsyncJobWhereInput>;
};


export type EntityCashflowsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CashflowOrder>>;
  where?: InputMaybe<CashflowWhereInput>;
};


export type EntityCreatedSubtrustsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TestamentaryEntityOrder>>;
  where?: InputMaybe<TestamentaryEntityWhereInput>;
};


export type EntityDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentOrder>>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type EntityEntityDiagramsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityDiagramOrder>>;
  where?: InputMaybe<EntityDiagramWhereInput>;
};


export type EntityEntityDocumentRelationshipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityDocumentRelationshipOrder>>;
  where?: InputMaybe<EntityDocumentRelationshipWhereInput>;
};


export type EntityKgV2NodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2NodeOrder>>;
  where?: InputMaybe<Kgv2NodeWhereInput>;
};


export type EntityLiabilitiesLentArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiabilityOrder>>;
  where?: InputMaybe<LiabilityWhereInput>;
};


export type EntityLiabilitiesOwedArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiabilityOrder>>;
  where?: InputMaybe<LiabilityWhereInput>;
};


export type EntityTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityTaskOrder>>;
  where?: InputMaybe<EntityTaskWhereInput>;
};

/** EntityAttributionSource is enum for the field attribution_source */
export enum EntityAttributionSource {
  AddeparBulkImport = 'ADDEPAR_BULK_IMPORT',
  DocumentExtraction = 'DOCUMENT_EXTRACTION',
  Duplicate = 'DUPLICATE',
  FromSpeech = 'FROM_SPEECH',
  IntakeForm = 'INTAKE_FORM',
  LuminaryAi = 'LUMINARY_AI',
  StrategyDesigner = 'STRATEGY_DESIGNER'
}

/** A connection to a list of items. */
export type EntityConnection = {
  __typename?: 'EntityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type EntityDiagram = Node & {
  __typename?: 'EntityDiagram';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The entity this diagram configuration belongs to */
  entity: Entity;
  /** The client profile representing the first grantor to die. Required when diagram kind is DISPOSITIONS */
  firstGrantorDeath?: Maybe<ClientProfile>;
  /** Whether group tiles hide their entity lists by default */
  hideEntitiesListInGroups: Scalars['Boolean']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Type of diagram. Determines which visualization this configuration applies to */
  kind: EntityDiagramKind;
  /** Array of node configurations containing positions and other display properties */
  nodeConfigurations: Array<EntityGraphNodeConfiguration>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  visualizationGroups: GraphVisualizationGroupConnection;
};


export type EntityDiagramVisualizationGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GraphVisualizationGroupOrder>>;
  where?: InputMaybe<GraphVisualizationGroupWhereInput>;
};

/** A connection to a list of items. */
export type EntityDiagramConnection = {
  __typename?: 'EntityDiagramConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntityDiagramEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntityDiagramEdge = {
  __typename?: 'EntityDiagramEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntityDiagram>;
};

/** EntityDiagramKind is enum for the field kind */
export enum EntityDiagramKind {
  CltTerm = 'CLT_TERM',
  CrtTerm = 'CRT_TERM',
  Dispositions = 'DISPOSITIONS',
  GratTerm = 'GRAT_TERM',
  Ownership = 'OWNERSHIP',
  QprtTerm = 'QPRT_TERM'
}

/** Display settings for a single-entity diagram node. */
export type EntityDiagramNodeConfig = {
  __typename?: 'EntityDiagramNodeConfig';
  hideGroupContents: Scalars['Boolean']['output'];
};

export type EntityDiagramNodeConfigInput = {
  hideGroupContents: Scalars['Boolean']['input'];
};

/** Ordering options for EntityDiagram connections */
export type EntityDiagramOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EntityDiagrams. */
  field: EntityDiagramOrderField;
};

/** Properties by which EntityDiagram connections can be ordered. */
export enum EntityDiagramOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EntityDiagramWhereInput is used for filtering EntityDiagram objects.
 * Input was generated by ent.
 */
export type EntityDiagramWhereInput = {
  and?: InputMaybe<Array<EntityDiagramWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** first_grantor_death edge predicates */
  hasFirstGrantorDeath?: InputMaybe<Scalars['Boolean']['input']>;
  hasFirstGrantorDeathWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** visualization_groups edge predicates */
  hasVisualizationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasVisualizationGroupsWith?: InputMaybe<Array<GraphVisualizationGroupWhereInput>>;
  /** hide_entities_list_in_groups field predicates */
  hideEntitiesListInGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<EntityDiagramKind>;
  kindIn?: InputMaybe<Array<EntityDiagramKind>>;
  kindNEQ?: InputMaybe<EntityDiagramKind>;
  kindNotIn?: InputMaybe<Array<EntityDiagramKind>>;
  not?: InputMaybe<EntityDiagramWhereInput>;
  or?: InputMaybe<Array<EntityDiagramWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type EntityDocumentRelationship = Node & {
  __typename?: 'EntityDocumentRelationship';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  document: Document;
  /** The Document ID that this relationship references. */
  documentID: Scalars['ID']['output'];
  entity?: Maybe<Entity>;
  /** The Entity ID that this relationship references. Either this or testamentary_entity_id must be set. */
  entityID?: Maybe<Scalars['ID']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Type of relationship between entity and document */
  relationshipType: EntityDocumentRelationshipRelationshipType;
  /** The precedence for AI suggestions. Only applies when relationship_type is SOURCE_DOCUMENT */
  suggestionPrecedenceOrder?: Maybe<Scalars['Int']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  testamentaryEntity?: Maybe<TestamentaryEntity>;
  /** The TestamentaryEntity ID that this relationship references. Either this or entity_id must be set. */
  testamentaryEntityID?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type EntityDocumentRelationshipConnection = {
  __typename?: 'EntityDocumentRelationshipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntityDocumentRelationshipEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntityDocumentRelationshipEdge = {
  __typename?: 'EntityDocumentRelationshipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntityDocumentRelationship>;
};

/** Ordering options for EntityDocumentRelationship connections */
export type EntityDocumentRelationshipOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EntityDocumentRelationships. */
  field: EntityDocumentRelationshipOrderField;
};

/** Properties by which EntityDocumentRelationship connections can be ordered. */
export enum EntityDocumentRelationshipOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** EntityDocumentRelationshipRelationshipType is enum for the field relationship_type */
export enum EntityDocumentRelationshipRelationshipType {
  Mentioned = 'MENTIONED',
  SourceDocument = 'SOURCE_DOCUMENT'
}

/**
 * EntityDocumentRelationshipWhereInput is used for filtering EntityDocumentRelationship objects.
 * Input was generated by ent.
 */
export type EntityDocumentRelationshipWhereInput = {
  and?: InputMaybe<Array<EntityDocumentRelationshipWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** document_id field predicates */
  documentID?: InputMaybe<Scalars['ID']['input']>;
  documentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  documentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** entity_id field predicates */
  entityID?: InputMaybe<Scalars['ID']['input']>;
  entityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  entityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  entityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** testamentary_entity edge predicates */
  hasTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasTestamentaryEntityWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<EntityDocumentRelationshipWhereInput>;
  or?: InputMaybe<Array<EntityDocumentRelationshipWhereInput>>;
  /** relationship_type field predicates */
  relationshipType?: InputMaybe<EntityDocumentRelationshipRelationshipType>;
  relationshipTypeIn?: InputMaybe<Array<EntityDocumentRelationshipRelationshipType>>;
  relationshipTypeNEQ?: InputMaybe<EntityDocumentRelationshipRelationshipType>;
  relationshipTypeNotIn?: InputMaybe<Array<EntityDocumentRelationshipRelationshipType>>;
  /** suggestion_precedence_order field predicates */
  suggestionPrecedenceOrder?: InputMaybe<Scalars['Int']['input']>;
  suggestionPrecedenceOrderGT?: InputMaybe<Scalars['Int']['input']>;
  suggestionPrecedenceOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  suggestionPrecedenceOrderIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  suggestionPrecedenceOrderLT?: InputMaybe<Scalars['Int']['input']>;
  suggestionPrecedenceOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  suggestionPrecedenceOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  suggestionPrecedenceOrderNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** testamentary_entity_id field predicates */
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
  testamentaryEntityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  testamentaryEntityIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  testamentaryEntityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  testamentaryEntityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  testamentaryEntityIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** An edge in a connection. */
export type EntityEdge = {
  __typename?: 'EntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Entity>;
};

/** EntityGSTStatus is enum for the field gst_status */
export enum EntityGstStatus {
  GstExempt = 'GST_EXEMPT',
  GstNonExempt = 'GST_NON_EXEMPT',
  MixedGst = 'MIXED_GST'
}

export type EntityGraphNodeConfiguration = {
  __typename?: 'EntityGraphNodeConfiguration';
  /**
   * dimensionsFinalized is true once the user has explicitly sized this tile
   * (via NodeResizer, +/- controls, or bulk resize). When false/null, the tile
   * is treated as legacy and the client renders icon tiles with overflow visible
   * so pre-icon-scaling diagrams don't clip. When true, the client trusts the
   * stored height/width and clips overflow.
   */
  dimensionsFinalized?: Maybe<Scalars['Boolean']['output']>;
  entityDiagramConfig?: Maybe<EntityDiagramNodeConfig>;
  entityGraphViewConfig?: Maybe<EntityGraphViewNodeConfig>;
  estateWaterfallConfig?: Maybe<EstateWaterfallEntityGraphNodeConfig>;
  fontSize?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /**
   * iconShape controls the rendered shape of the node's icon/tile.
   * Expected values: "CIRCLE", "SQUARE", "TRIANGLE", "DIAMOND".
   * A null value defaults to circle on the client. Not enforced at the API layer.
   */
  iconShape?: Maybe<Scalars['String']['output']>;
  nodeID: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * tileEmphasis controls the contrast level of non-icon tiles.
   * Expected values: "LOW", "MEDIUM", "HIGH".
   * A null value defaults to low on the client. Not enforced at the API layer.
   */
  tileEmphasis?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  xPosition?: Maybe<Scalars['Float']['output']>;
  yPosition?: Maybe<Scalars['Float']['output']>;
};

export type EntityGraphNodeConfigurationInput = {
  /**
   * dimensionsFinalized is true once the user has explicitly sized this tile
   * (via NodeResizer, +/- controls, or bulk resize). When false/null, the tile
   * is treated as legacy and the client renders icon tiles with overflow visible
   * so pre-icon-scaling diagrams don't clip. When true, the client trusts the
   * stored height/width and clips overflow.
   */
  dimensionsFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  entityDiagramConfig?: InputMaybe<EntityDiagramNodeConfigInput>;
  entityGraphViewConfig?: InputMaybe<EntityGraphViewNodeConfigInput>;
  estateWaterfallConfig?: InputMaybe<EstateWaterfallEntityGraphNodeConfigInput>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * iconShape controls the rendered shape of the node's icon/tile.
   * Expected values: "CIRCLE", "SQUARE", "TRIANGLE", "DIAMOND".
   * A null value defaults to circle on the client. Not enforced at the API layer.
   */
  iconShape?: InputMaybe<Scalars['String']['input']>;
  nodeID: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /**
   * tileEmphasis controls the contrast level of non-icon tiles.
   * Expected values: "LOW", "MEDIUM", "HIGH".
   * A null value defaults to low on the client. Not enforced at the API layer.
   */
  tileEmphasis?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  xPosition?: InputMaybe<Scalars['Float']['input']>;
  yPosition?: InputMaybe<Scalars['Float']['input']>;
};

export type EntityGraphView = Node & {
  __typename?: 'EntityGraphView';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
  /** Whether group tiles hide their entity lists by default */
  hideEntitiesListInGroups: Scalars['Boolean']['output'];
  /** If true, hides dollar values on entity tiles. */
  hideEntityValues: Scalars['Boolean']['output'];
  household: Household;
  id: Scalars['ID']['output'];
  kind?: Maybe<EntityGraphViewKind>;
  /** the definitions of the nodes in the graph */
  nodeConfigurations: Array<EntityGraphNodeConfiguration>;
  orientation?: Maybe<EntityGraphViewOrientation>;
  /** If true, shows labels on ownership lines. */
  showLineLabels: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  visualizationGroups: GraphVisualizationGroupConnection;
};


export type EntityGraphViewVisualizationGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GraphVisualizationGroupOrder>>;
  where?: InputMaybe<GraphVisualizationGroupWhereInput>;
};

export type EntityGraphViewBundleConfiguration = Node & {
  __typename?: 'EntityGraphViewBundleConfiguration';
  bundle?: Maybe<PresentationBundle>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The display name for the entity graph view. */
  displayName?: Maybe<Scalars['String']['output']>;
  entityGraphView?: Maybe<EntityGraphView>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type EntityGraphViewBundleConfigurationConnection = {
  __typename?: 'EntityGraphViewBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntityGraphViewBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntityGraphViewBundleConfigurationEdge = {
  __typename?: 'EntityGraphViewBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntityGraphViewBundleConfiguration>;
};

/** Ordering options for EntityGraphViewBundleConfiguration connections */
export type EntityGraphViewBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EntityGraphViewBundleConfigurations. */
  field: EntityGraphViewBundleConfigurationOrderField;
};

/** Properties by which EntityGraphViewBundleConfiguration connections can be ordered. */
export enum EntityGraphViewBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EntityGraphViewBundleConfigurationWhereInput is used for filtering EntityGraphViewBundleConfiguration objects.
 * Input was generated by ent.
 */
export type EntityGraphViewBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<EntityGraphViewBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** entity_graph_view edge predicates */
  hasEntityGraphView?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityGraphViewWith?: InputMaybe<Array<EntityGraphViewWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<EntityGraphViewBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<EntityGraphViewBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** A connection to a list of items. */
export type EntityGraphViewConnection = {
  __typename?: 'EntityGraphViewConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntityGraphViewEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntityGraphViewEdge = {
  __typename?: 'EntityGraphViewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntityGraphView>;
};

/** EntityGraphViewKind is enum for the field kind */
export enum EntityGraphViewKind {
  Beneficiary = 'BENEFICIARY',
  Ownership = 'OWNERSHIP'
}

/** Display settings for an ownership-map node. */
export type EntityGraphViewNodeConfig = {
  __typename?: 'EntityGraphViewNodeConfig';
  hideGroupContents: Scalars['Boolean']['output'];
};

export type EntityGraphViewNodeConfigInput = {
  hideGroupContents: Scalars['Boolean']['input'];
};

/** Ordering options for EntityGraphView connections */
export type EntityGraphViewOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EntityGraphViews. */
  field: EntityGraphViewOrderField;
};

/** Properties by which EntityGraphView connections can be ordered. */
export enum EntityGraphViewOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** EntityGraphViewOrientation is enum for the field orientation */
export enum EntityGraphViewOrientation {
  BottomTop = 'BOTTOM_TOP',
  LeftRight = 'LEFT_RIGHT',
  RightLeft = 'RIGHT_LEFT',
  TopBottom = 'TOP_BOTTOM'
}

/**
 * EntityGraphViewWhereInput is used for filtering EntityGraphView objects.
 * Input was generated by ent.
 */
export type EntityGraphViewWhereInput = {
  and?: InputMaybe<Array<EntityGraphViewWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** visualization_groups edge predicates */
  hasVisualizationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasVisualizationGroupsWith?: InputMaybe<Array<GraphVisualizationGroupWhereInput>>;
  /** hide_entities_list_in_groups field predicates */
  hideEntitiesListInGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** hide_entity_values field predicates */
  hideEntityValues?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<EntityGraphViewKind>;
  kindIn?: InputMaybe<Array<EntityGraphViewKind>>;
  kindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  kindNEQ?: InputMaybe<EntityGraphViewKind>;
  kindNotIn?: InputMaybe<Array<EntityGraphViewKind>>;
  kindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<EntityGraphViewWhereInput>;
  or?: InputMaybe<Array<EntityGraphViewWhereInput>>;
  /** orientation field predicates */
  orientation?: InputMaybe<EntityGraphViewOrientation>;
  orientationIn?: InputMaybe<Array<EntityGraphViewOrientation>>;
  orientationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  orientationNEQ?: InputMaybe<EntityGraphViewOrientation>;
  orientationNotIn?: InputMaybe<Array<EntityGraphViewOrientation>>;
  orientationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_line_labels field predicates */
  showLineLabels?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * EntityHoldings bundles the three categories of things an entity holds
 * that can be referenced by a dispositive provision: persistent asset
 * identities (AssetStatic), ownership stakes in other entities, and
 * insurance policies. Each category renders distinctly in the UI.
 */
export type EntityHoldings = {
  __typename?: 'EntityHoldings';
  /** Asset statics referenced by the entity's current valuation. */
  assets: Array<AssetStatic>;
  /**
   * Insurance policies held by the entity. Only entity subtypes that
   * can hold policies (trusts, business entities, foundations, DAFs,
   * insurance personal accounts) will populate this list; others
   * return empty.
   */
  insurancePolicies: Array<InsurancePolicy>;
  /** Ownership stakes the entity owns in other entities. */
  ownershipStakes: Array<OwnershipStake>;
};

/**
 * EntityHoldingsBucket pairs an entity with its current holdings, the
 * shape returned per-entity from `Household.entityHoldings`. Used by
 * the cross-entity DP selector to render assets / stakes / policies
 * grouped by their owning entity in a single round-trip.
 */
export type EntityHoldingsBucket = {
  __typename?: 'EntityHoldingsBucket';
  entity: Entity;
  holdings: EntityHoldings;
};

/** EntityInEstateStatus is enum for the field in_estate_status */
export enum EntityInEstateStatus {
  InEstate = 'IN_ESTATE',
  OutOfEstate = 'OUT_OF_ESTATE'
}

/** EntityKind is enum for the field kind */
export enum EntityKind {
  CcorpBusinessEntity = 'CCORP_BUSINESS_ENTITY',
  CltTrust = 'CLT_TRUST',
  CrtTrust = 'CRT_TRUST',
  CustodialPersonalAccount = 'CUSTODIAL_PERSONAL_ACCOUNT',
  DonorAdvisedFund = 'DONOR_ADVISED_FUND',
  GpBusinessEntity = 'GP_BUSINESS_ENTITY',
  GratTrust = 'GRAT_TRUST',
  IlitTrust = 'ILIT_TRUST',
  IndividualPersonalAccount = 'INDIVIDUAL_PERSONAL_ACCOUNT',
  InsurancePersonalAccount = 'INSURANCE_PERSONAL_ACCOUNT',
  IrrevocableTrust = 'IRREVOCABLE_TRUST',
  JointPersonalAccount = 'JOINT_PERSONAL_ACCOUNT',
  LlcBusinessEntity = 'LLC_BUSINESS_ENTITY',
  LpBusinessEntity = 'LP_BUSINESS_ENTITY',
  PrivateFoundation = 'PRIVATE_FOUNDATION',
  QprtTrust = 'QPRT_TRUST',
  QualifiedTuitionPersonalAccount = 'QUALIFIED_TUITION_PERSONAL_ACCOUNT',
  RetirementPersonalAccount = 'RETIREMENT_PERSONAL_ACCOUNT',
  RevocableTrust = 'REVOCABLE_TRUST',
  ScorpBusinessEntity = 'SCORP_BUSINESS_ENTITY',
  SlatTrust = 'SLAT_TRUST',
  SoleProprietorshipBusinessEntity = 'SOLE_PROPRIETORSHIP_BUSINESS_ENTITY'
}

/** EntityLiquidityStatus is enum for the field liquidity_status */
export enum EntityLiquidityStatus {
  AssetBased = 'ASSET_BASED',
  Illiquid = 'ILLIQUID',
  Liquid = 'LIQUID'
}

export type EntityNotes = Node & {
  __typename?: 'EntityNotes';
  clientProfile?: Maybe<ClientProfile>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The document summary that was used to generate this entity's notes */
  documentSummary?: Maybe<DocumentSummary>;
  entity?: Maybe<Entity>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Markdown formatted notes for this entity's death order */
  notes: Scalars['String']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for EntityNotes connections */
export type EntityNotesOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EntityNotesSlice. */
  field: EntityNotesOrderField;
};

/** Properties by which EntityNotes connections can be ordered. */
export enum EntityNotesOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EntityNotesWhereInput is used for filtering EntityNotes objects.
 * Input was generated by ent.
 */
export type EntityNotesWhereInput = {
  and?: InputMaybe<Array<EntityNotesWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** client_profile edge predicates */
  hasClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientProfileWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** document_summary edge predicates */
  hasDocumentSummary?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentSummaryWith?: InputMaybe<Array<DocumentSummaryWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<EntityNotesWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<EntityNotesWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Ordering options for Entity connections */
export type EntityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Entities. */
  field: EntityOrderField;
};

/** Properties by which Entity connections can be ordered. */
export enum EntityOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type EntityProposal = Node & {
  __typename?: 'EntityProposal';
  assetValuationProjectionType: EntityProposalAssetValuationProjectionType;
  createdAt: Scalars['Time']['output'];
  entity: Entity;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  proposal: Proposal;
  proposalScenarios?: Maybe<Array<ProposalScenario>>;
  /** the percent value for tax drag for the entity */
  taxDrag?: Maybe<Scalars['Percent']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** EntityProposalAssetValuationProjectionType is enum for the field asset_valuation_projection_type */
export enum EntityProposalAssetValuationProjectionType {
  ProjectedRateOfReturn = 'PROJECTED_RATE_OF_RETURN',
  ProjectedValue = 'PROJECTED_VALUE'
}

/** A connection to a list of items. */
export type EntityProposalConnection = {
  __typename?: 'EntityProposalConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntityProposalEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntityProposalEdge = {
  __typename?: 'EntityProposalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntityProposal>;
};

/** Ordering options for EntityProposal connections */
export type EntityProposalOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EntityProposals. */
  field: EntityProposalOrderField;
};

/** Properties by which EntityProposal connections can be ordered. */
export enum EntityProposalOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EntityProposalWhereInput is used for filtering EntityProposal objects.
 * Input was generated by ent.
 */
export type EntityProposalWhereInput = {
  and?: InputMaybe<Array<EntityProposalWhereInput>>;
  /** asset_valuation_projection_type field predicates */
  assetValuationProjectionType?: InputMaybe<EntityProposalAssetValuationProjectionType>;
  assetValuationProjectionTypeIn?: InputMaybe<Array<EntityProposalAssetValuationProjectionType>>;
  assetValuationProjectionTypeNEQ?: InputMaybe<EntityProposalAssetValuationProjectionType>;
  assetValuationProjectionTypeNotIn?: InputMaybe<Array<EntityProposalAssetValuationProjectionType>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** proposal edge predicates */
  hasProposal?: InputMaybe<Scalars['Boolean']['input']>;
  /** proposal_scenarios edge predicates */
  hasProposalScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasProposalScenariosWith?: InputMaybe<Array<ProposalScenarioWhereInput>>;
  hasProposalWith?: InputMaybe<Array<ProposalWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<EntityProposalWhereInput>;
  or?: InputMaybe<Array<EntityProposalWhereInput>>;
  /** tax_drag field predicates */
  taxDrag?: InputMaybe<Scalars['Percent']['input']>;
  taxDragGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDragLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDragNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export enum EntityReportColumn {
  EntityAssetsSummary = 'ENTITY_ASSETS_SUMMARY',
  EntityAssetsValue = 'ENTITY_ASSETS_VALUE',
  EntityName = 'ENTITY_NAME',
  GratNextAnnuityDueDate = 'GRAT_NEXT_ANNUITY_DUE_DATE',
  GratRemainingAnnuityAmounts = 'GRAT_REMAINING_ANNUITY_AMOUNTS',
  GratRemainingAnnuityPayments = 'GRAT_REMAINING_ANNUITY_PAYMENTS',
  GratSurplus = 'GRAT_SURPLUS'
}

export type EntityReportOptions = {
  columns: Array<EntityReportColumn>;
  /** This currently only supports GRATs */
  entityKinds: Array<EntityKind>;
};

/** EntityStage is enum for the field stage */
export enum EntityStage {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Implementation = 'IMPLEMENTATION',
  PreCreated = 'PRE_CREATED',
  ReadyForProposal = 'READY_FOR_PROPOSAL'
}

/**
 * Entity is a generic type that can be used to represent any entity that
 * has a name and an ID and a related advisor client.
 */
export type EntitySubtype = {
  /** The current value of the entity, discounted by the discount rate */
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  /** The current value of the entity. */
  currentValue: Scalars['CurrencyUSD']['output'];
  designerAccount?: Maybe<Account>;
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** The effective discount percentage applied to the entity. */
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entityExists: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  /** The discount percentage applied to the entity. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
};

export type EntitySummaryBundleConfiguration = Node & {
  __typename?: 'EntitySummaryBundleConfiguration';
  bundle?: Maybe<PresentationBundle>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  deathOrder: ClientProfile;
  documents?: Maybe<Array<Document>>;
  entity: Entity;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** If true, includes the full-sheet entity balance sheet page in the bundle. */
  includeBalanceSheetExportPage: Scalars['Boolean']['output'];
  /** If true, includes the entity balance sheet page in the bundle. */
  includeBalanceSheetPage: Scalars['Boolean']['output'];
  /** If true, includes the beneficiaries and dispositions page in the bundle. */
  includeBeneficiariesAndDispositionsPage: Scalars['Boolean']['output'];
  /** If true, includes the notes and diagram page in the bundle. */
  includeDiagramAndNotesPage: Scalars['Boolean']['output'];
  /** If true, includes the entity notes on the diagram page. */
  includeEntityNotesOnSummaryPage: Scalars['Boolean']['output'];
  /** If true, includes the entity summary/title page in the bundle. */
  includeEntitySummaryPage: Scalars['Boolean']['output'];
  /** If true, includes the insurance policy slides in the bundle. */
  includeInsurancePolicySlides: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type EntitySummaryBundleConfigurationConnection = {
  __typename?: 'EntitySummaryBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntitySummaryBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntitySummaryBundleConfigurationEdge = {
  __typename?: 'EntitySummaryBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntitySummaryBundleConfiguration>;
};

/** Ordering options for EntitySummaryBundleConfiguration connections */
export type EntitySummaryBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EntitySummaryBundleConfigurations. */
  field: EntitySummaryBundleConfigurationOrderField;
};

/** Properties by which EntitySummaryBundleConfiguration connections can be ordered. */
export enum EntitySummaryBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EntitySummaryBundleConfigurationWhereInput is used for filtering EntitySummaryBundleConfiguration objects.
 * Input was generated by ent.
 */
export type EntitySummaryBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<EntitySummaryBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** death_order edge predicates */
  hasDeathOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeathOrderWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** documents edge predicates */
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_balance_sheet_export_page field predicates */
  includeBalanceSheetExportPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_balance_sheet_page field predicates */
  includeBalanceSheetPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_beneficiaries_and_dispositions_page field predicates */
  includeBeneficiariesAndDispositionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_diagram_and_notes_page field predicates */
  includeDiagramAndNotesPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_entity_notes_on_summary_page field predicates */
  includeEntityNotesOnSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_entity_summary_page field predicates */
  includeEntitySummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_insurance_policy_slides field predicates */
  includeInsurancePolicySlides?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<EntitySummaryBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<EntitySummaryBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * One selection in an entity summary template bundle's entityTypes list. Selects which
 * household entities the bundle expands into; an entity matching any selected type is
 * included once. Declared by hand because entityTypes is a list field, and Ent only
 * generates enum declarations for single-value enum columns.
 */
export enum EntitySummaryEntityType {
  /** Every entity kind the other types cover. */
  All = 'ALL',
  /** Business entities. */
  Business = 'BUSINESS',
  /** CLTs, CRTs, donor advised funds and private foundations. */
  Charitable = 'CHARITABLE',
  /** Directly held personal accounts. */
  DirectHoldings = 'DIRECT_HOLDINGS',
  /** Irrevocable trusts, including SLATs, ILITs, QPRTs and GRATs. */
  Irrevocable = 'IRREVOCABLE',
  /** Revocable trusts. */
  Revocable = 'REVOCABLE'
}

export type EntitySummaryTemplateBundleConfiguration = Node & {
  __typename?: 'EntitySummaryTemplateBundleConfiguration';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Which household entities this bundle expands into, one runtime bundle per match. */
  entityTypes: Array<EntitySummaryEntityType>;
  id: Scalars['ID']['output'];
  /** If true, includes the full-sheet entity balance sheet page in each expanded bundle. */
  includeBalanceSheetExportPage: Scalars['Boolean']['output'];
  /** If true, includes the entity balance sheet page in each expanded bundle. */
  includeBalanceSheetPage: Scalars['Boolean']['output'];
  /** If true, includes the beneficiaries and dispositions page in each expanded bundle. */
  includeBeneficiariesAndDispositionsPage: Scalars['Boolean']['output'];
  /** If true, includes the notes and diagram page in each expanded bundle. */
  includeDiagramAndNotesPage: Scalars['Boolean']['output'];
  /** If true, includes the entity notes on the diagram page in each expanded bundle. */
  includeEntityNotesOnSummaryPage: Scalars['Boolean']['output'];
  /** If true, includes the entity summary/title page in each expanded bundle. */
  includeEntitySummaryPage: Scalars['Boolean']['output'];
  /** If true, includes the insurance policy slides in each expanded bundle. */
  includeInsurancePolicySlides: Scalars['Boolean']['output'];
  templateBundle?: Maybe<PresentationTemplateBundle>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type EntitySummaryTemplateBundleConfigurationConnection = {
  __typename?: 'EntitySummaryTemplateBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntitySummaryTemplateBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntitySummaryTemplateBundleConfigurationEdge = {
  __typename?: 'EntitySummaryTemplateBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntitySummaryTemplateBundleConfiguration>;
};

/** Ordering options for EntitySummaryTemplateBundleConfiguration connections */
export type EntitySummaryTemplateBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EntitySummaryTemplateBundleConfigurations. */
  field: EntitySummaryTemplateBundleConfigurationOrderField;
};

/** Properties by which EntitySummaryTemplateBundleConfiguration connections can be ordered. */
export enum EntitySummaryTemplateBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EntitySummaryTemplateBundleConfigurationWhereInput is used for filtering EntitySummaryTemplateBundleConfiguration objects.
 * Input was generated by ent.
 */
export type EntitySummaryTemplateBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<EntitySummaryTemplateBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** template_bundle edge predicates */
  hasTemplateBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasTemplateBundleWith?: InputMaybe<Array<PresentationTemplateBundleWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_balance_sheet_export_page field predicates */
  includeBalanceSheetExportPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_balance_sheet_page field predicates */
  includeBalanceSheetPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_beneficiaries_and_dispositions_page field predicates */
  includeBeneficiariesAndDispositionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_diagram_and_notes_page field predicates */
  includeDiagramAndNotesPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_entity_notes_on_summary_page field predicates */
  includeEntityNotesOnSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_entity_summary_page field predicates */
  includeEntitySummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_insurance_policy_slides field predicates */
  includeInsurancePolicySlides?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<EntitySummaryTemplateBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<EntitySummaryTemplateBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type EntityTask = Node & {
  __typename?: 'EntityTask';
  assignedBy?: Maybe<User>;
  assignedTo?: Maybe<User>;
  /** the reason this task was cancelled. if present, the task status is computed as canceled */
  cancelledReason?: Maybe<Scalars['String']['output']>;
  /** the timestamp at which this task was marked as complete */
  completedAt?: Maybe<Scalars['Time']['output']>;
  completedBy?: Maybe<User>;
  completionState: EntityTaskCompletionState;
  createdAt: Scalars['Time']['output'];
  /**
   * dependency_checksum is an optional validation mechanism where we summarize the underlying data that supports this task.
   * If the checksum changes, then we consider this task invalid.
   */
  dependencyChecksum?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  /** the date at which this task is due */
  dueAt: Scalars['Time']['output'];
  entity: Entity;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  ilitCrummeyLetter?: Maybe<IlitCrummeyLetter>;
  loggedTransfers?: Maybe<Array<LoggedTransfer>>;
  premiumPayment?: Maybe<InsurancePremiumPayment>;
  reminderEmailNotificationRecord?: Maybe<Array<ReminderEmailNotificationRecord>>;
  shortTitle: Scalars['String']['output'];
  taskDependencies?: Maybe<Array<EntityTask>>;
  taskDependents?: Maybe<Array<EntityTask>>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: EntityTaskType;
  updatedAt: Scalars['Time']['output'];
};

export enum EntityTaskCompletionState {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  CompleteWithErrors = 'COMPLETE_WITH_ERRORS',
  Incomplete = 'INCOMPLETE'
}

/** A connection to a list of items. */
export type EntityTaskConnection = {
  __typename?: 'EntityTaskConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EntityTaskEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EntityTaskEdge = {
  __typename?: 'EntityTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EntityTask>;
};

/** Ordering options for EntityTask connections */
export type EntityTaskOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EntityTasks. */
  field: EntityTaskOrderField;
};

/** Properties by which EntityTask connections can be ordered. */
export enum EntityTaskOrderField {
  CompletedAt = 'completed_at',
  CreatedAt = 'created_at',
  DueAt = 'due_at',
  UpdatedAt = 'updated_at'
}

/** EntityTaskType is enum for the field type */
export enum EntityTaskType {
  GratAnnuityPayment = 'GRAT_ANNUITY_PAYMENT',
  GratAttorneySelection = 'GRAT_ATTORNEY_SELECTION',
  GratCompleteDesignSummary = 'GRAT_COMPLETE_DESIGN_SUMMARY',
  GratConfirmAnnuities = 'GRAT_CONFIRM_ANNUITIES',
  GratConfirmAssetTransfer = 'GRAT_CONFIRM_ASSET_TRANSFER',
  GratConfirmFunding = 'GRAT_CONFIRM_FUNDING',
  GratConfirmTrustDetails = 'GRAT_CONFIRM_TRUST_DETAILS',
  GratCreateTrustAccount = 'GRAT_CREATE_TRUST_ACCOUNT',
  GratDistributeTrustRemainder = 'GRAT_DISTRIBUTE_TRUST_REMAINDER',
  GratFinalizeImplementation = 'GRAT_FINALIZE_IMPLEMENTATION',
  GratSetSubstitutionThresholds = 'GRAT_SET_SUBSTITUTION_THRESHOLDS',
  GratShareDesignSummary = 'GRAT_SHARE_DESIGN_SUMMARY',
  GratUploadTrustDocument = 'GRAT_UPLOAD_TRUST_DOCUMENT',
  IlitMakeAnnualExclusionGifts = 'ILIT_MAKE_ANNUAL_EXCLUSION_GIFTS',
  IlitMakePremiumPayment = 'ILIT_MAKE_PREMIUM_PAYMENT',
  IlitSendCrummeyLetters = 'ILIT_SEND_CRUMMEY_LETTERS'
}

/**
 * EntityTaskWhereInput is used for filtering EntityTask objects.
 * Input was generated by ent.
 */
export type EntityTaskWhereInput = {
  and?: InputMaybe<Array<EntityTaskWhereInput>>;
  /** cancelled_reason field predicates */
  cancelledReason?: InputMaybe<Scalars['String']['input']>;
  cancelledReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cancelledReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** completed_at field predicates */
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  completedAtGT?: InputMaybe<Scalars['Time']['input']>;
  completedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  completedAtLT?: InputMaybe<Scalars['Time']['input']>;
  completedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** dependency_checksum field predicates */
  dependencyChecksum?: InputMaybe<Scalars['String']['input']>;
  dependencyChecksumIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dependencyChecksumNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** due_at field predicates */
  dueAt?: InputMaybe<Scalars['Time']['input']>;
  dueAtGT?: InputMaybe<Scalars['Time']['input']>;
  dueAtGTE?: InputMaybe<Scalars['Time']['input']>;
  dueAtLT?: InputMaybe<Scalars['Time']['input']>;
  dueAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** assigned_by edge predicates */
  hasAssignedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssignedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** assigned_to edge predicates */
  hasAssignedTo?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssignedToWith?: InputMaybe<Array<UserWhereInput>>;
  /** completed_by edge predicates */
  hasCompletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCompletedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** ilit_crummey_letter edge predicates */
  hasIlitCrummeyLetter?: InputMaybe<Scalars['Boolean']['input']>;
  hasIlitCrummeyLetterWith?: InputMaybe<Array<IlitCrummeyLetterWhereInput>>;
  /** logged_transfers edge predicates */
  hasLoggedTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  hasLoggedTransfersWith?: InputMaybe<Array<LoggedTransferWhereInput>>;
  /** premium_payment edge predicates */
  hasPremiumPayment?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumPaymentWith?: InputMaybe<Array<InsurancePremiumPaymentWhereInput>>;
  /** reminder_email_notification_record edge predicates */
  hasReminderEmailNotificationRecord?: InputMaybe<Scalars['Boolean']['input']>;
  hasReminderEmailNotificationRecordWith?: InputMaybe<Array<ReminderEmailNotificationRecordWhereInput>>;
  /** task_dependencies edge predicates */
  hasTaskDependencies?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaskDependenciesWith?: InputMaybe<Array<EntityTaskWhereInput>>;
  /** task_dependents edge predicates */
  hasTaskDependents?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaskDependentsWith?: InputMaybe<Array<EntityTaskWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<EntityTaskWhereInput>;
  or?: InputMaybe<Array<EntityTaskWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** type field predicates */
  type?: InputMaybe<EntityTaskType>;
  typeIn?: InputMaybe<Array<EntityTaskType>>;
  typeNEQ?: InputMaybe<EntityTaskType>;
  typeNotIn?: InputMaybe<Array<EntityTaskType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type EntityTaxInfo = Node & {
  __typename?: 'EntityTaxInfo';
  createdAt: Scalars['Time']['output'];
  entity?: Maybe<Entity>;
  federalInEstate: Scalars['Boolean']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  stateCode?: Maybe<StateCode>;
  stateInEstate: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  testamentaryEntity?: Maybe<TestamentaryEntity>;
  updatedAt: Scalars['Time']['output'];
};

/** Ordering options for EntityTaxInfo connections */
export type EntityTaxInfoOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EntityTaxInfos. */
  field: EntityTaxInfoOrderField;
};

/** Properties by which EntityTaxInfo connections can be ordered. */
export enum EntityTaxInfoOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EntityTaxInfoWhereInput is used for filtering EntityTaxInfo objects.
 * Input was generated by ent.
 */
export type EntityTaxInfoWhereInput = {
  and?: InputMaybe<Array<EntityTaxInfoWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** federal_in_estate field predicates */
  federalInEstate?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** testamentary_entity edge predicates */
  hasTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasTestamentaryEntityWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<EntityTaxInfoWhereInput>;
  or?: InputMaybe<Array<EntityTaxInfoWhereInput>>;
  /** state_code field predicates */
  stateCode?: InputMaybe<StateCode>;
  stateCodeIn?: InputMaybe<Array<StateCode>>;
  stateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  stateCodeNEQ?: InputMaybe<StateCode>;
  stateCodeNotIn?: InputMaybe<Array<StateCode>>;
  stateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state_in_estate field predicates */
  stateInEstate?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type EntityValuationErrorMessage = {
  __typename?: 'EntityValuationErrorMessage';
  entity: Entity;
  errorMessage: Scalars['String']['output'];
};

/**
 * EntityWhereInput is used for filtering Entity objects.
 * Input was generated by ent.
 */
export type EntityWhereInput = {
  /** addepar_linked_to_nongrantor_entity field predicates */
  addeparLinkedToNongrantorEntity?: InputMaybe<Scalars['Boolean']['input']>;
  addeparLinkedToNongrantorEntityIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  addeparLinkedToNongrantorEntityNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<EntityWhereInput>>;
  /** attribution_source field predicates */
  attributionSource?: InputMaybe<EntityAttributionSource>;
  attributionSourceIn?: InputMaybe<Array<EntityAttributionSource>>;
  attributionSourceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  attributionSourceNEQ?: InputMaybe<EntityAttributionSource>;
  attributionSourceNotIn?: InputMaybe<Array<EntityAttributionSource>>;
  attributionSourceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** group_integration_asset_values field predicates */
  groupIntegrationAssetValues?: InputMaybe<Scalars['Boolean']['input']>;
  /** activities edge predicates */
  hasActivities?: InputMaybe<Scalars['Boolean']['input']>;
  hasActivitiesWith?: InputMaybe<Array<ActivityWhereInput>>;
  /** additional_documents edge predicates */
  hasAdditionalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasAdditionalDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** asset_groups edge predicates */
  hasAssetGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetGroupsWith?: InputMaybe<Array<AssetGroupWhereInput>>;
  /** asset_statics edge predicates */
  hasAssetStatics?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetStaticsWith?: InputMaybe<Array<AssetStaticWhereInput>>;
  /** async_jobs edge predicates */
  hasAsyncJobs?: InputMaybe<Scalars['Boolean']['input']>;
  hasAsyncJobsWith?: InputMaybe<Array<AsyncJobWhereInput>>;
  /** balance_sheet_category_override edge predicates */
  hasBalanceSheetCategoryOverride?: InputMaybe<Scalars['Boolean']['input']>;
  hasBalanceSheetCategoryOverrideWith?: InputMaybe<Array<BalanceSheetCategoryWhereInput>>;
  /** cashflows edge predicates */
  hasCashflows?: InputMaybe<Scalars['Boolean']['input']>;
  hasCashflowsWith?: InputMaybe<Array<CashflowWhereInput>>;
  /** ccorp_business_entity edge predicates */
  hasCcorpBusinessEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasCcorpBusinessEntityWith?: InputMaybe<Array<CCorpBusinessEntityWhereInput>>;
  /** client_profile edge predicates */
  hasClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientProfileWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** clt_trust edge predicates */
  hasCltTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasCltTrustWith?: InputMaybe<Array<CltTrustWhereInput>>;
  /** created_subtrusts edge predicates */
  hasCreatedSubtrusts?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedSubtrustsWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** crt_trust edge predicates */
  hasCrtTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasCrtTrustWith?: InputMaybe<Array<CrtTrustWhereInput>>;
  /** custodial_personal_account edge predicates */
  hasCustodialPersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustodialPersonalAccountWith?: InputMaybe<Array<CustodialPersonalAccountWhereInput>>;
  /** death_order_notes edge predicates */
  hasDeathOrderNotes?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeathOrderNotesWith?: InputMaybe<Array<EntityNotesWhereInput>>;
  /** default_document edge predicates */
  hasDefaultDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDefaultDocumentWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** documents edge predicates */
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** donor_advised_fund edge predicates */
  hasDonorAdvisedFund?: InputMaybe<Scalars['Boolean']['input']>;
  hasDonorAdvisedFundWith?: InputMaybe<Array<DonorAdvisedFundWhereInput>>;
  /** email_notification_records edge predicates */
  hasEmailNotificationRecords?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmailNotificationRecordsWith?: InputMaybe<Array<ReminderEmailNotificationRecordWhereInput>>;
  /** entity_diagrams edge predicates */
  hasEntityDiagrams?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityDiagramsWith?: InputMaybe<Array<EntityDiagramWhereInput>>;
  /** entity_document_relationships edge predicates */
  hasEntityDocumentRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityDocumentRelationshipsWith?: InputMaybe<Array<EntityDocumentRelationshipWhereInput>>;
  /** entity_proposals edge predicates */
  hasEntityProposals?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityProposalsWith?: InputMaybe<Array<EntityProposalWhereInput>>;
  /** estate_waterfall_filters edge predicates */
  hasEstateWaterfallFilters?: InputMaybe<Scalars['Boolean']['input']>;
  hasEstateWaterfallFiltersWith?: InputMaybe<Array<EstateWaterfallVisualizationFilterWhereInput>>;
  /** gp_business_entity edge predicates */
  hasGpBusinessEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasGpBusinessEntityWith?: InputMaybe<Array<GpBusinessEntityWhereInput>>;
  /** grat_trust edge predicates */
  hasGratTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasGratTrustWith?: InputMaybe<Array<GratTrustWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_grats edge predicates */
  hasHypotheticalGrats?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalGratsWith?: InputMaybe<Array<HypotheticalGratWhereInput>>;
  /** ilit_trust edge predicates */
  hasIlitTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasIlitTrustWith?: InputMaybe<Array<IlitTrustWhereInput>>;
  /** individual_personal_account edge predicates */
  hasIndividualPersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndividualPersonalAccountWith?: InputMaybe<Array<IndividualPersonalAccountWhereInput>>;
  /** insurance_personal_account edge predicates */
  hasInsurancePersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasInsurancePersonalAccountWith?: InputMaybe<Array<InsurancePersonalAccountWhereInput>>;
  /** integration_entities edge predicates */
  hasIntegrationEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntegrationEntitiesWith?: InputMaybe<Array<IntegrationEntityWhereInput>>;
  /** irrevocable_trust edge predicates */
  hasIrrevocableTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasIrrevocableTrustWith?: InputMaybe<Array<IrrevocableTrustWhereInput>>;
  /** joint_personal_account edge predicates */
  hasJointPersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasJointPersonalAccountWith?: InputMaybe<Array<JointPersonalAccountWhereInput>>;
  /** kg_v2_nodes edge predicates */
  hasKgV2Nodes?: InputMaybe<Scalars['Boolean']['input']>;
  hasKgV2NodesWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** liabilities_lent edge predicates */
  hasLiabilitiesLent?: InputMaybe<Scalars['Boolean']['input']>;
  hasLiabilitiesLentWith?: InputMaybe<Array<LiabilityWhereInput>>;
  /** liabilities_owed edge predicates */
  hasLiabilitiesOwed?: InputMaybe<Scalars['Boolean']['input']>;
  hasLiabilitiesOwedWith?: InputMaybe<Array<LiabilityWhereInput>>;
  /** llc_business_entity edge predicates */
  hasLlcBusinessEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasLlcBusinessEntityWith?: InputMaybe<Array<LlcBusinessEntityWhereInput>>;
  /** lp_business_entity edge predicates */
  hasLpBusinessEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasLpBusinessEntityWith?: InputMaybe<Array<LpBusinessEntityWhereInput>>;
  /** onboarding_entity_suggestion edge predicates */
  hasOnboardingEntitySuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasOnboardingEntitySuggestionWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** owned_by_stakes edge predicates */
  hasOwnedByStakes?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnedByStakesWith?: InputMaybe<Array<OwnershipStakeWhereInput>>;
  /** owned_ownership_stakes edge predicates */
  hasOwnedOwnershipStakes?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnedOwnershipStakesWith?: InputMaybe<Array<OwnershipStakeWhereInput>>;
  /** owning_onboarding_entity_suggestion edge predicates */
  hasOwningOnboardingEntitySuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwningOnboardingEntitySuggestionWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** potential_entity_suggestion edge predicates */
  hasPotentialEntitySuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasPotentialEntitySuggestionWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** private_foundation edge predicates */
  hasPrivateFoundation?: InputMaybe<Scalars['Boolean']['input']>;
  hasPrivateFoundationWith?: InputMaybe<Array<PrivateFoundationWhereInput>>;
  /** qprt_trust edge predicates */
  hasQprtTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasQprtTrustWith?: InputMaybe<Array<QprtTrustWhereInput>>;
  /** qualified_tuition_personal_account edge predicates */
  hasQualifiedTuitionPersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasQualifiedTuitionPersonalAccountWith?: InputMaybe<Array<QualifiedTuitionPersonalAccountWhereInput>>;
  /** related_suggestions edge predicates */
  hasRelatedSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  hasRelatedSuggestionsWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** retirement_personal_account edge predicates */
  hasRetirementPersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasRetirementPersonalAccountWith?: InputMaybe<Array<RetirementPersonalAccountWhereInput>>;
  /** revocable_trust edge predicates */
  hasRevocableTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasRevocableTrustWith?: InputMaybe<Array<RevocableTrustWhereInput>>;
  /** scorp_business_entity edge predicates */
  hasScorpBusinessEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasScorpBusinessEntityWith?: InputMaybe<Array<SCorpBusinessEntityWhereInput>>;
  /** slat_trust edge predicates */
  hasSlatTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasSlatTrustWith?: InputMaybe<Array<SlatTrustWhereInput>>;
  /** sole_proprietorship_business_entity edge predicates */
  hasSoleProprietorshipBusinessEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasSoleProprietorshipBusinessEntityWith?: InputMaybe<Array<SoleProprietorshipBusinessEntityWhereInput>>;
  /** suggestion_kg_roots edge predicates */
  hasSuggestionKgRoots?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuggestionKgRootsWith?: InputMaybe<Array<KgRootWhereInput>>;
  /** tasks edge predicates */
  hasTasks?: InputMaybe<Scalars['Boolean']['input']>;
  hasTasksWith?: InputMaybe<Array<EntityTaskWhereInput>>;
  /** tax_info edge predicates */
  hasTaxInfo?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaxInfoWith?: InputMaybe<Array<EntityTaxInfoWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** workflow_trackers edge predicates */
  hasWorkflowTrackers?: InputMaybe<Scalars['Boolean']['input']>;
  hasWorkflowTrackersWith?: InputMaybe<Array<WorkflowTrackerWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<EntityKind>;
  kindIn?: InputMaybe<Array<EntityKind>>;
  kindNEQ?: InputMaybe<EntityKind>;
  kindNotIn?: InputMaybe<Array<EntityKind>>;
  /** liquidity_status field predicates */
  liquidityStatus?: InputMaybe<EntityLiquidityStatus>;
  liquidityStatusIn?: InputMaybe<Array<EntityLiquidityStatus>>;
  liquidityStatusNEQ?: InputMaybe<EntityLiquidityStatus>;
  liquidityStatusNotIn?: InputMaybe<Array<EntityLiquidityStatus>>;
  not?: InputMaybe<EntityWhereInput>;
  or?: InputMaybe<Array<EntityWhereInput>>;
  /** pause_integration_sync field predicates */
  pauseIntegrationSync?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_entity_name_on_balance_sheet field predicates */
  showEntityNameOnBalanceSheet?: InputMaybe<Scalars['Boolean']['input']>;
  /** stage field predicates */
  stage?: InputMaybe<EntityStage>;
  stageIn?: InputMaybe<Array<EntityStage>>;
  stageNEQ?: InputMaybe<EntityStage>;
  stageNotIn?: InputMaybe<Array<EntityStage>>;
  /** sync_death_order_notes field predicates */
  syncDeathOrderNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** sync_ownership field predicates */
  syncOwnership?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export enum ErrorCodes {
  UserAlreadyExists = 'USER_ALREADY_EXISTS'
}

export type EstateInsight = Node & {
  __typename?: 'EstateInsight';
  /** Whether this insight needs review or represents a concern or opportunity */
  bucket: EstateInsightBucket;
  /** Category classification of the estate insight */
  category: EstateInsightCategory;
  /** Date when the estate insight was marked as completed */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** Markdown formatted detailed consideration for the estate insight */
  consideration: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The document this estate insight was extracted from */
  documents?: Maybe<Array<Document>>;
  /** The estate insights bundle configurations using this insight */
  estateInsightsBundleConfiguration?: Maybe<Array<EstateInsightsBundleConfiguration>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Whether this insight is marked as critical */
  isCritical: Scalars['Boolean']['output'];
  /** The specific type of estate insight identified */
  kind: EstateInsightKind;
  /** 0‑based ordinal within this household's insights within bucket */
  position: Scalars['Int']['output'];
  /** References supporting this estate insight */
  references?: Maybe<Array<EstateInsightReference>>;
  /** Current status of the estate insight */
  status: EstateInsightStatus;
  /** Plain text summary of the estate insight */
  summary: Scalars['String']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** Title of the estate insight */
  title: Scalars['String']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};

/** EstateInsightBucket is enum for the field bucket */
export enum EstateInsightBucket {
  Concern = 'CONCERN',
  NeedsReview = 'NEEDS_REVIEW',
  Opportunity = 'OPPORTUNITY'
}

/** EstateInsightCategory is enum for the field category */
export enum EstateInsightCategory {
  BasicPlanning = 'BASIC_PLANNING',
  Children = 'CHILDREN',
  Fiduciaries = 'FIDUCIARIES',
  Gifting = 'GIFTING',
  Retirement = 'RETIREMENT',
  Tax = 'TAX',
  Trusts = 'TRUSTS'
}

/** A connection to a list of items. */
export type EstateInsightConnection = {
  __typename?: 'EstateInsightConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstateInsightEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EstateInsightEdge = {
  __typename?: 'EstateInsightEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstateInsight>;
};

/** EstateInsightKind is enum for the field kind */
export enum EstateInsightKind {
  AnnualExclusionGifting = 'ANNUAL_EXCLUSION_GIFTING',
  AutomaticOutrightDistributionToSpouse = 'AUTOMATIC_OUTRIGHT_DISTRIBUTION_TO_SPOUSE',
  BypassTrustFundedSolelyViaDisclaimer = 'BYPASS_TRUST_FUNDED_SOLELY_VIA_DISCLAIMER',
  CorporateTrustee = 'CORPORATE_TRUSTEE',
  DifferentStateOfResidenceFromEstateDocuments = 'DIFFERENT_STATE_OF_RESIDENCE_FROM_ESTATE_DOCUMENTS',
  ExSpouseListedAsBeneficiary = 'EX_SPOUSE_LISTED_AS_BENEFICIARY',
  ExSpouseListedAsTrustee = 'EX_SPOUSE_LISTED_AS_TRUSTEE',
  ExSpouseListedInWill = 'EX_SPOUSE_LISTED_IN_WILL',
  FullUseOfLifetimeExemption = 'FULL_USE_OF_LIFETIME_EXEMPTION',
  GiftToCharity = 'GIFT_TO_CHARITY',
  MissingGuardianProvisions = 'MISSING_GUARDIAN_PROVISIONS',
  MissingPowersOfAppointmentForSurivivingSpouse = 'MISSING_POWERS_OF_APPOINTMENT_FOR_SURIVIVING_SPOUSE',
  NoAlternativeAgentListedHealthcareProxy = 'NO_ALTERNATIVE_AGENT_LISTED_HEALTHCARE_PROXY',
  NoAlternativeAgentListedPoa = 'NO_ALTERNATIVE_AGENT_LISTED_POA',
  Open_529Account = 'OPEN_529_ACCOUNT',
  OutrightDistributionsToChildren = 'OUTRIGHT_DISTRIBUTIONS_TO_CHILDREN',
  RetirementAccountBeneficiaryDesignations = 'RETIREMENT_ACCOUNT_BENEFICIARY_DESIGNATIONS',
  RetitleAssetsToRevocableTrust = 'RETITLE_ASSETS_TO_REVOCABLE_TRUST',
  SpecificBequestsInWill = 'SPECIFIC_BEQUESTS_IN_WILL',
  StateEstateTax = 'STATE_ESTATE_TAX',
  StateInheritanceTax = 'STATE_INHERITANCE_TAX',
  TrusteesNotUpdated = 'TRUSTEES_NOT_UPDATED',
  TrusteeDomiciledInDifferentState = 'TRUSTEE_DOMICILED_IN_DIFFERENT_STATE'
}

/** Ordering options for EstateInsight connections */
export type EstateInsightOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EstateInsights. */
  field: EstateInsightOrderField;
};

/** Properties by which EstateInsight connections can be ordered. */
export enum EstateInsightOrderField {
  Position = 'POSITION',
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type EstateInsightReference = Node & {
  __typename?: 'EstateInsightReference';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Description of the reference */
  description: Scalars['String']['output'];
  /** The estate insight this reference supports */
  estateInsight: EstateInsight;
  /** File paragraphs that support this reference */
  fileParagraphs?: Maybe<Array<FileParagraph>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Optional section label for the reference */
  sectionLabel?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** Title of the reference */
  title: Scalars['String']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};

/** A connection to a list of items. */
export type EstateInsightReferenceConnection = {
  __typename?: 'EstateInsightReferenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstateInsightReferenceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EstateInsightReferenceEdge = {
  __typename?: 'EstateInsightReferenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstateInsightReference>;
};

/** Ordering options for EstateInsightReference connections */
export type EstateInsightReferenceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EstateInsightReferences. */
  field: EstateInsightReferenceOrderField;
};

/** Properties by which EstateInsightReference connections can be ordered. */
export enum EstateInsightReferenceOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EstateInsightReferenceWhereInput is used for filtering EstateInsightReference objects.
 * Input was generated by ent.
 */
export type EstateInsightReferenceWhereInput = {
  and?: InputMaybe<Array<EstateInsightReferenceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  /** estate_insight edge predicates */
  hasEstateInsight?: InputMaybe<Scalars['Boolean']['input']>;
  hasEstateInsightWith?: InputMaybe<Array<EstateInsightWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<EstateInsightReferenceWhereInput>;
  or?: InputMaybe<Array<EstateInsightReferenceWhereInput>>;
  /** section_label field predicates */
  sectionLabel?: InputMaybe<Scalars['String']['input']>;
  sectionLabelIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sectionLabelNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** EstateInsightStatus is enum for the field status */
export enum EstateInsightStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Dismissed = 'DISMISSED'
}

/**
 * EstateInsightWhereInput is used for filtering EstateInsight objects.
 * Input was generated by ent.
 */
export type EstateInsightWhereInput = {
  and?: InputMaybe<Array<EstateInsightWhereInput>>;
  /** bucket field predicates */
  bucket?: InputMaybe<EstateInsightBucket>;
  bucketIn?: InputMaybe<Array<EstateInsightBucket>>;
  bucketNEQ?: InputMaybe<EstateInsightBucket>;
  bucketNotIn?: InputMaybe<Array<EstateInsightBucket>>;
  /** category field predicates */
  category?: InputMaybe<EstateInsightCategory>;
  categoryIn?: InputMaybe<Array<EstateInsightCategory>>;
  categoryNEQ?: InputMaybe<EstateInsightCategory>;
  categoryNotIn?: InputMaybe<Array<EstateInsightCategory>>;
  /** completed_at field predicates */
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  completedAtGT?: InputMaybe<Scalars['Time']['input']>;
  completedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  completedAtLT?: InputMaybe<Scalars['Time']['input']>;
  completedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** consideration field predicates */
  consideration?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** documents edge predicates */
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** references edge predicates */
  hasReferences?: InputMaybe<Scalars['Boolean']['input']>;
  hasReferencesWith?: InputMaybe<Array<EstateInsightReferenceWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_critical field predicates */
  isCritical?: InputMaybe<Scalars['Boolean']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<EstateInsightKind>;
  kindIn?: InputMaybe<Array<EstateInsightKind>>;
  kindNEQ?: InputMaybe<EstateInsightKind>;
  kindNotIn?: InputMaybe<Array<EstateInsightKind>>;
  not?: InputMaybe<EstateInsightWhereInput>;
  or?: InputMaybe<Array<EstateInsightWhereInput>>;
  /** position field predicates */
  position?: InputMaybe<Scalars['Int']['input']>;
  positionGT?: InputMaybe<Scalars['Int']['input']>;
  positionGTE?: InputMaybe<Scalars['Int']['input']>;
  positionLT?: InputMaybe<Scalars['Int']['input']>;
  positionLTE?: InputMaybe<Scalars['Int']['input']>;
  positionNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** status field predicates */
  status?: InputMaybe<EstateInsightStatus>;
  statusIn?: InputMaybe<Array<EstateInsightStatus>>;
  statusNEQ?: InputMaybe<EstateInsightStatus>;
  statusNotIn?: InputMaybe<Array<EstateInsightStatus>>;
  /** summary field predicates */
  summary?: InputMaybe<Scalars['String']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EstateInsightsBundleConfiguration = Node & {
  __typename?: 'EstateInsightsBundleConfiguration';
  bundle?: Maybe<PresentationBundle>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The display name for the bundle. */
  displayName?: Maybe<Scalars['String']['output']>;
  estateInsights?: Maybe<Array<EstateInsight>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** If true, includes the annual exclusion gifting insight in the bundle. */
  includeAnnualExclusionGiftingPage: Scalars['Boolean']['output'];
  /** If true, includes the automatic outright distribution to spouse insight in the bundle. */
  includeAutomaticOutrightDistributionToSpousePage: Scalars['Boolean']['output'];
  /** If true, includes the bypass trust funded solely via disclaimer insight in the bundle. */
  includeBypassTrustFundedSolelyViaDisclaimerPage: Scalars['Boolean']['output'];
  /** If true, includes the corporate trustee insight in the bundle. */
  includeCorporateTrusteePage: Scalars['Boolean']['output'];
  /** If true, includes this different state of residence from estate documents insight in the bundle. */
  includeDifferentStateOfResidenceFromEstateDocumentsPage: Scalars['Boolean']['output'];
  /** If true, includes the ex spouse listed as beneficiary insight in the bundle. */
  includeExSpouseListedAsBeneficiaryPage: Scalars['Boolean']['output'];
  /** If true, includes the ex spouse listed as trustee insight in the bundle. */
  includeExSpouseListedAsTrusteePage: Scalars['Boolean']['output'];
  /** If true, includes the ex spouse listed in will insight in the bundle. */
  includeExSpouseListedInWillPage: Scalars['Boolean']['output'];
  /** If true, includes the full use of lifetime exemption insight in the bundle. */
  includeFullUseOfLifetimeExemptionPage: Scalars['Boolean']['output'];
  /** If true, includes the gift to charity insight in the bundle. */
  includeGiftToCharityPage: Scalars['Boolean']['output'];
  /** If true, includes this missing documents page in the bundle. */
  includeMissingDocumentsPage: Scalars['Boolean']['output'];
  /** If true, includes the missing guardian provisions insight in the bundle. */
  includeMissingGuardianProvisionsPage: Scalars['Boolean']['output'];
  /** If true, includes the missing powers of appointment for surviving spouse insight in the bundle. */
  includeMissingPoaForSurivivingSpousePage: Scalars['Boolean']['output'];
  /** If true, includes the no alternative agent listed in healthcare proxy insight in the bundle. */
  includeNoAlternativeAgentListedHealthcareProxyPage: Scalars['Boolean']['output'];
  /** If true, includes the no alternative agent listed in power of attorney insight in the bundle. */
  includeNoAlternativeAgentListedPoaPage: Scalars['Boolean']['output'];
  /** If true, includes the open 529 account insight in the bundle. */
  includeOpen529AccountPage: Scalars['Boolean']['output'];
  /** If true, includes the outright distributions to children insight in the bundle. */
  includeOutrightDistributionsToChildrenPage: Scalars['Boolean']['output'];
  /** If true, includes the retirement account beneficiary designations insight in the bundle. */
  includeRetirementAccountBeneficiaryDesignationsPage: Scalars['Boolean']['output'];
  /** If true, includes this retitle assets to revocable trust insight in the bundle. */
  includeRetitleAssetsToRevocableTrustPage: Scalars['Boolean']['output'];
  /** If true, includes this specific bequests insight in the bundle. */
  includeSpecificBequestsPage: Scalars['Boolean']['output'];
  /** If true, includes the state estate tax insight in the bundle. */
  includeStateEstateTaxPage: Scalars['Boolean']['output'];
  /** If true, includes the state inheritance tax insight in the bundle. */
  includeStateInheritanceTaxPage: Scalars['Boolean']['output'];
  /** If true, includes this trustee domiciled in different state insight in the bundle. */
  includeTrusteeDomiciledInDifferentState: Scalars['Boolean']['output'];
  /** If true, includes the trustees not updated insight in the bundle. */
  includeTrusteesNotUpdatedPage: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type EstateInsightsBundleConfigurationConnection = {
  __typename?: 'EstateInsightsBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstateInsightsBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EstateInsightsBundleConfigurationEdge = {
  __typename?: 'EstateInsightsBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstateInsightsBundleConfiguration>;
};

/** Ordering options for EstateInsightsBundleConfiguration connections */
export type EstateInsightsBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EstateInsightsBundleConfigurations. */
  field: EstateInsightsBundleConfigurationOrderField;
};

/** Properties by which EstateInsightsBundleConfiguration connections can be ordered. */
export enum EstateInsightsBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EstateInsightsBundleConfigurationWhereInput is used for filtering EstateInsightsBundleConfiguration objects.
 * Input was generated by ent.
 */
export type EstateInsightsBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<EstateInsightsBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** estate_insights edge predicates */
  hasEstateInsights?: InputMaybe<Scalars['Boolean']['input']>;
  hasEstateInsightsWith?: InputMaybe<Array<EstateInsightWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_annual_exclusion_gifting_page field predicates */
  includeAnnualExclusionGiftingPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_automatic_outright_distribution_to_spouse_page field predicates */
  includeAutomaticOutrightDistributionToSpousePage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_bypass_trust_funded_solely_via_disclaimer_page field predicates */
  includeBypassTrustFundedSolelyViaDisclaimerPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_corporate_trustee_page field predicates */
  includeCorporateTrusteePage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_different_state_of_residence_from_estate_documents_page field predicates */
  includeDifferentStateOfResidenceFromEstateDocumentsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_ex_spouse_listed_as_beneficiary_page field predicates */
  includeExSpouseListedAsBeneficiaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_ex_spouse_listed_as_trustee_page field predicates */
  includeExSpouseListedAsTrusteePage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_ex_spouse_listed_in_will_page field predicates */
  includeExSpouseListedInWillPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_full_use_of_lifetime_exemption_page field predicates */
  includeFullUseOfLifetimeExemptionPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_gift_to_charity_page field predicates */
  includeGiftToCharityPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_missing_documents_page field predicates */
  includeMissingDocumentsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_missing_guardian_provisions_page field predicates */
  includeMissingGuardianProvisionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_missing_poa_for_suriviving_spouse_page field predicates */
  includeMissingPoaForSurivivingSpousePage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_no_alternative_agent_listed_healthcare_proxy_page field predicates */
  includeNoAlternativeAgentListedHealthcareProxyPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_no_alternative_agent_listed_poa_page field predicates */
  includeNoAlternativeAgentListedPoaPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_open_529_account_page field predicates */
  includeOpen529AccountPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_outright_distributions_to_children_page field predicates */
  includeOutrightDistributionsToChildrenPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_retirement_account_beneficiary_designations_page field predicates */
  includeRetirementAccountBeneficiaryDesignationsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_retitle_assets_to_revocable_trust_page field predicates */
  includeRetitleAssetsToRevocableTrustPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_specific_bequests_page field predicates */
  includeSpecificBequestsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_state_estate_tax_page field predicates */
  includeStateEstateTaxPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_state_inheritance_tax_page field predicates */
  includeStateInheritanceTaxPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_trustee_domiciled_in_different_state field predicates */
  includeTrusteeDomiciledInDifferentState?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_trustees_not_updated_page field predicates */
  includeTrusteesNotUpdatedPage?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<EstateInsightsBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<EstateInsightsBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type EstateTaxScenario = Node & {
  __typename?: 'EstateTaxScenario';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
  firstDeathPayoutOrder: Array<Node>;
  firstDeathPayoutOrderMissingEntities: Array<Node>;
  /** This estate tax scenario corresponds to the death of the associated grantor. */
  firstGrantorDeath: ClientProfile;
  household: Household;
  id: Scalars['ID']['output'];
  isExemptionPortable: Scalars['Boolean']['output'];
  payoutKind: EstateTaxScenarioPayoutKind;
  secondDeathPayoutOrder?: Maybe<Array<Node>>;
  secondDeathPayoutOrderMissingEntities?: Maybe<Array<Node>>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type EstateTaxScenarioConnection = {
  __typename?: 'EstateTaxScenarioConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstateTaxScenarioEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EstateTaxScenarioEdge = {
  __typename?: 'EstateTaxScenarioEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstateTaxScenario>;
};

/** Ordering options for EstateTaxScenario connections */
export type EstateTaxScenarioOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EstateTaxScenarios. */
  field: EstateTaxScenarioOrderField;
};

/** Properties by which EstateTaxScenario connections can be ordered. */
export enum EstateTaxScenarioOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** EstateTaxScenarioPayoutKind is enum for the field payout_kind */
export enum EstateTaxScenarioPayoutKind {
  Custom = 'CUSTOM',
  ProRata = 'PRO_RATA'
}

export type EstateTaxScenarioPossibleEntitiesInput = {
  clientProfileDeathConsidered: Scalars['ID']['input'];
  firstGrantorDeath: Scalars['ID']['input'];
};

/**
 * EstateTaxScenarioWhereInput is used for filtering EstateTaxScenario objects.
 * Input was generated by ent.
 */
export type EstateTaxScenarioWhereInput = {
  and?: InputMaybe<Array<EstateTaxScenarioWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** first_grantor_death edge predicates */
  hasFirstGrantorDeath?: InputMaybe<Scalars['Boolean']['input']>;
  hasFirstGrantorDeathWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_exemption_portable field predicates */
  isExemptionPortable?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<EstateTaxScenarioWhereInput>;
  or?: InputMaybe<Array<EstateTaxScenarioWhereInput>>;
  /** payout_kind field predicates */
  payoutKind?: InputMaybe<EstateTaxScenarioPayoutKind>;
  payoutKindIn?: InputMaybe<Array<EstateTaxScenarioPayoutKind>>;
  payoutKindNEQ?: InputMaybe<EstateTaxScenarioPayoutKind>;
  payoutKindNotIn?: InputMaybe<Array<EstateTaxScenarioPayoutKind>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type EstateWaterfall = Node & {
  __typename?: 'EstateWaterfall';
  /** Used in beneficiary reporting to calculate non-quantifiable accessto a single entity across multiple beneficiaries. */
  beneficiaryAccessCalcMethod: EstateWaterfallBeneficiaryAccessCalcMethod;
  /**
   * beneficiaryReport returns a detailed breakdown of all beneficiaries using
   * the given estate waterfall's assumptions
   */
  beneficiaryReport: EstateWaterfallBeneficiaryReport;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
  /** When present, the filter to use for this waterfall. */
  filter?: Maybe<EstateWaterfallVisualizationFilter>;
  /** This disposition scenario corresponds to the death of the associated grantor. */
  firstGrantorDeath: ClientProfile;
  /** Projected year that the first grantor dies. */
  firstGrantorDeathYear?: Maybe<Scalars['Int']['output']>;
  /** The growth profile applied to this waterfall. */
  growthProfile?: Maybe<GrowthProfile>;
  household: Household;
  hypotheticalClts: HypotheticalCltConnection;
  hypotheticalCrts: HypotheticalCrtConnection;
  hypotheticalGrats: HypotheticalGratConnection;
  hypotheticalInsurance: HypotheticalInsuranceConnection;
  hypotheticalSaleLoans: HypotheticalSaleLoanConnection;
  hypotheticalScenarios?: Maybe<Array<EstateWaterfall>>;
  hypotheticalStateChanges: EstateWaterfallHypotheticalStateChangeConnection;
  hypotheticalTransfers: EstateWaterfallHypotheticalTransferConnection;
  id: Scalars['ID']['output'];
  isTwoGrantor: Scalars['Boolean']['output'];
  /** The kind of estate waterfall. BASE is a normal estate waterfall. HYPOTHETICAL is a hypothetical scenario. */
  kind?: Maybe<EstateWaterfallKind>;
  localShowSummaryTileDetails: Scalars['Boolean']['output'];
  /** the definitions of the nodes in the graph */
  nodeConfigurations: Array<EntityGraphNodeConfiguration>;
  /** An estate waterfall can have hypothetical scenarios */
  parent?: Maybe<EstateWaterfall>;
  /**
   * primaryClientValuesBeforeDispositions returns one result for each primary
   * client. Each result contains values before the first and, when applicable,
   * second death's dispositions. Values use current-year deaths and zero growth.
   */
  primaryClientValuesBeforeDispositions: Array<EstateWaterfallPrimaryClientValuesBeforeDispositions>;
  /** Projected year that the second grantor dies. Only applicable when there are two grantors. */
  secondGrantorDeathYear?: Maybe<Scalars['Int']['output']>;
  /** When set, controls whether summary tile details are shown or hidden. */
  showSummaryTileDetails?: Maybe<Scalars['Boolean']['output']>;
  /** When set, asset growth is not applied in the current year of the waterfall projection. */
  skipCurrentYearGrowth: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  visualization: EstateWaterfallViz;
  /** Used to set various options in the visualization. */
  visualizationConfig?: Maybe<EstateWaterfallVisualizationConfig>;
  visualizationGroups: GraphVisualizationGroupConnection;
  visualizationWithProjections: EstateWaterfallViz;
};


export type EstateWaterfallBeneficiaryReportArgs = {
  input?: InputMaybe<EstateWaterfallProjectionInput>;
};


export type EstateWaterfallHypotheticalCltsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HypotheticalCltOrder>>;
  where?: InputMaybe<HypotheticalCltWhereInput>;
};


export type EstateWaterfallHypotheticalCrtsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HypotheticalCrtOrder>>;
  where?: InputMaybe<HypotheticalCrtWhereInput>;
};


export type EstateWaterfallHypotheticalGratsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HypotheticalGratOrder>>;
  where?: InputMaybe<HypotheticalGratWhereInput>;
};


export type EstateWaterfallHypotheticalInsuranceArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HypotheticalInsuranceOrder>>;
  where?: InputMaybe<HypotheticalInsuranceWhereInput>;
};


export type EstateWaterfallHypotheticalSaleLoansArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HypotheticalSaleLoanOrder>>;
  where?: InputMaybe<HypotheticalSaleLoanWhereInput>;
};


export type EstateWaterfallHypotheticalStateChangesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EstateWaterfallHypotheticalStateChangeOrder>>;
  where?: InputMaybe<EstateWaterfallHypotheticalStateChangeWhereInput>;
};


export type EstateWaterfallHypotheticalTransfersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EstateWaterfallHypotheticalTransferOrder>>;
  where?: InputMaybe<EstateWaterfallHypotheticalTransferWhereInput>;
};


export type EstateWaterfallLocalShowSummaryTileDetailsArgs = {
  where?: InputMaybe<WaterfallSummaryTileDetailsWhereInput>;
};


export type EstateWaterfallVisualizationArgs = {
  opts?: InputMaybe<EstateWaterfallVizConfigOptsInput>;
};


export type EstateWaterfallVisualizationGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GraphVisualizationGroupOrder>>;
  where?: InputMaybe<GraphVisualizationGroupWhereInput>;
};


export type EstateWaterfallVisualizationWithProjectionsArgs = {
  input?: InputMaybe<EstateWaterfallProjectionInput>;
  opts?: InputMaybe<EstateWaterfallVizConfigOptsInput>;
};

/** EstateWaterfallBeneficiaryAccessCalcMethod is enum for the field beneficiary_access_calc_method */
export enum EstateWaterfallBeneficiaryAccessCalcMethod {
  Full = 'FULL',
  None = 'NONE',
  Proportional = 'PROPORTIONAL'
}

export type EstateWaterfallBeneficiaryReport = {
  __typename?: 'EstateWaterfallBeneficiaryReport';
  _cacheKey: Scalars['String']['output'];
  beneficiariesBreakdown?: Maybe<Array<BeneficiaryReportBeneficiaryBreakdown>>;
  /**
   * beneficiariesMissingDateOfBirth are client profiles who exist as benficiaries with age based
   * access parameters, but are missing a date of birth.
   */
  beneficiariesMissingDateOfBirth?: Maybe<Array<Maybe<ClientProfile>>>;
  householdID: Scalars['ID']['output'];
  /**
   * materializedInputParams is the parameters used to create the waterfall visualization
   * and henceforth this beneficiary report
   */
  materializedInputParams: EstateWaterfallMaterializedInputParams;
};

/** A connection to a list of items. */
export type EstateWaterfallConnection = {
  __typename?: 'EstateWaterfallConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstateWaterfallEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EstateWaterfallEdge = {
  __typename?: 'EstateWaterfallEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstateWaterfall>;
};

export enum EstateWaterfallEdgeKind {
  Disposition = 'DISPOSITION',
  HypotheticalSaleLoan = 'HYPOTHETICAL_SALE_LOAN',
  Pourover = 'POUROVER',
  Transfer = 'TRANSFER'
}

export type EstateWaterfallEntityGraphNodeConfig = {
  __typename?: 'EstateWaterfallEntityGraphNodeConfig';
  /** hideGroupContents hides the list of grouped entities on a group tile. */
  hideGroupContents?: Maybe<Scalars['Boolean']['output']>;
  showTaxBreakout?: Maybe<Scalars['Boolean']['output']>;
};

export type EstateWaterfallEntityGraphNodeConfigInput = {
  /** hideGroupContents hides the list of grouped entities on a group tile. */
  hideGroupContents?: InputMaybe<Scalars['Boolean']['input']>;
  showTaxBreakout?: InputMaybe<Scalars['Boolean']['input']>;
};

/** EstateWaterfallEvent is an event that occured during the computation of the waterfall. */
export type EstateWaterfallEvent = {
  __typename?: 'EstateWaterfallEvent';
  /**
   * associatedObject is the object that is associated with the event
   * Corresponds to associatedObjectID
   */
  associatedObject?: Maybe<Node>;
  /** AssociatedObjectID is the ID of the object that is associated with the event */
  associatedObjectID?: Maybe<Scalars['ID']['output']>;
  /** code is a shorthand code that describes the event */
  code: EstateWaterfallEventCode;
  /** message that describes the event */
  message: Scalars['String']['output'];
  /** severity is the severity of the event */
  severity: EstateWaterfallEventSeverity;
  /** year is the year the event occured */
  year: Scalars['Int']['output'];
};

/** EstateWaterfallEventCode is the shorthand code that describes the event */
export enum EstateWaterfallEventCode {
  CltOnDeath = 'CLT_ON_DEATH',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  InvalidHypotheticalStrategy = 'INVALID_HYPOTHETICAL_STRATEGY',
  LiabilityOnDeath = 'LIABILITY_ON_DEATH',
  MissingObject = 'MISSING_OBJECT',
  Other = 'OTHER'
}

/** EstateWaterfallEventSeverity is the severity of the event */
export enum EstateWaterfallEventSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warn = 'WARN'
}

export type EstateWaterfallHypotheticalStateChange = Node & {
  __typename?: 'EstateWaterfallHypotheticalStateChange';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The client profile whose state of residence changes in this scenario. */
  grantor: ClientProfile;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  /** The hypothetical waterfall that owns this state change. */
  hypotheticalWaterfall: EstateWaterfall;
  id: Scalars['ID']['output'];
  /** The state change applies from the start of this year until the grantor's next state change or death. If not set, it applies from the start of the projection. */
  startYear?: Maybe<Scalars['Int']['output']>;
  /** The grantor's state of residence in this hypothetical scenario. */
  stateCode: StateCode;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type EstateWaterfallHypotheticalStateChangeConnection = {
  __typename?: 'EstateWaterfallHypotheticalStateChangeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstateWaterfallHypotheticalStateChangeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EstateWaterfallHypotheticalStateChangeEdge = {
  __typename?: 'EstateWaterfallHypotheticalStateChangeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstateWaterfallHypotheticalStateChange>;
};

/** Ordering options for EstateWaterfallHypotheticalStateChange connections */
export type EstateWaterfallHypotheticalStateChangeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EstateWaterfallHypotheticalStateChanges. */
  field: EstateWaterfallHypotheticalStateChangeOrderField;
};

/** Properties by which EstateWaterfallHypotheticalStateChange connections can be ordered. */
export enum EstateWaterfallHypotheticalStateChangeOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EstateWaterfallHypotheticalStateChangeWhereInput is used for filtering EstateWaterfallHypotheticalStateChange objects.
 * Input was generated by ent.
 */
export type EstateWaterfallHypotheticalStateChangeWhereInput = {
  and?: InputMaybe<Array<EstateWaterfallHypotheticalStateChangeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** grantor edge predicates */
  hasGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrantorWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_waterfall edge predicates */
  hasHypotheticalWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<EstateWaterfallHypotheticalStateChangeWhereInput>;
  or?: InputMaybe<Array<EstateWaterfallHypotheticalStateChangeWhereInput>>;
  /** start_year field predicates */
  startYear?: InputMaybe<Scalars['Int']['input']>;
  startYearGT?: InputMaybe<Scalars['Int']['input']>;
  startYearGTE?: InputMaybe<Scalars['Int']['input']>;
  startYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startYearLT?: InputMaybe<Scalars['Int']['input']>;
  startYearLTE?: InputMaybe<Scalars['Int']['input']>;
  startYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  startYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state_code field predicates */
  stateCode?: InputMaybe<StateCode>;
  stateCodeIn?: InputMaybe<Array<StateCode>>;
  stateCodeNEQ?: InputMaybe<StateCode>;
  stateCodeNotIn?: InputMaybe<Array<StateCode>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type EstateWaterfallHypotheticalTransfer = Node & {
  __typename?: 'EstateWaterfallHypotheticalTransfer';
  /** This dynamically sets the end date of this transfer to the year when both individuals die. It superceeds end_year and end_at_clients_death. Ignored if start_year is not set.  */
  afterBothDeaths?: Maybe<Scalars['Boolean']['output']>;
  /** Assume transfers will grow/shrink by this percentage each year. Only valid for recurring transfers. */
  assetGrowthReturn?: Maybe<Scalars['Percent']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** If the destination is an entity, this is the entity. */
  destinationEntity?: Maybe<Entity>;
  /** If the destination is an individual, this is the individual. */
  destinationIndividual?: Maybe<ClientProfile>;
  /** The kind of destination for this transfer. */
  destinationKind: EstateWaterfallHypotheticalTransferDestinationKind;
  /** If the destination is an organization, this is the organization. */
  destinationOrganization?: Maybe<ClientOrganization>;
  /** This sets the end date of this transfer when the client dies. This superceeds the end_year field. This is ignored if start_year is not set. */
  endAtClientsDeath?: Maybe<ClientProfile>;
  /** The year this transfer ends. Ignored if start_year is not set. */
  endYear?: Maybe<Scalars['Int']['output']>;
  /**
   * This is the list of grantors that made the gift.
   * Will only be read if the transfer tax kind is GRANTOR_TAXABLE_GIFT.
   * Can set one or both grantors.
   * MUST NOT be empty if the transfer tax kind is GRANTOR_TAXABLE_GIFT.
   */
  giftingGrantors?: Maybe<Array<ClientProfile>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalWaterfall?: Maybe<EstateWaterfall>;
  id: Scalars['ID']['output'];
  /** If true, this is a GST gift. Only valid when transfer_tax_kind is GRANTOR_TAXABLE_GIFT. */
  isGstGift: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** If the source is an entity, this is the entity. */
  sourceEntity?: Maybe<Entity>;
  /** If the source is an individual, this is the individual. */
  sourceIndividual?: Maybe<ClientProfile>;
  /** The insurance policy to be transferred. If present, the policy must belong to the source. */
  sourceInsurancePolicy?: Maybe<InsurancePolicy>;
  /** The kind of the source for this transfer. */
  sourceKind: EstateWaterfallHypotheticalTransferSourceKind;
  /** DEPRECATED: use source_owned_entity instead */
  sourceOwnedBusinessEntity?: Maybe<Entity>;
  /**
   * If we want to transfer assets specifically related to an owned business entity, specify the entity here.
   * 			There must be an ownership stake for this to take effect.
   */
  sourceOwnedEntity?: Maybe<Entity>;
  /** DEPRECATED: use source_owned_entity instead */
  sourceOwnershipStake?: Maybe<OwnershipStake>;
  /** The year this transfer starts. If start_year is not set, it is assumed to be a one time transfer happening in the current year. If start_year is set, this is a yearly recurring transfer until end_year is reached. */
  startYear?: Maybe<Scalars['Int']['output']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  /** Taxable value of the transfer. If nil, it will be calculated. */
  taxableValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The order of this transfer in the list of transfers for a given source. */
  transferOrder: Scalars['Int']['output'];
  transferTaxKind: EstateWaterfallHypotheticalTransferTransferTaxKind;
  /** Value of this transfer. */
  transferValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type EstateWaterfallHypotheticalTransferConnection = {
  __typename?: 'EstateWaterfallHypotheticalTransferConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstateWaterfallHypotheticalTransferEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** EstateWaterfallHypotheticalTransferDestinationKind is enum for the field destination_kind */
export enum EstateWaterfallHypotheticalTransferDestinationKind {
  Entity = 'ENTITY',
  External = 'EXTERNAL',
  Individual = 'INDIVIDUAL',
  Organization = 'ORGANIZATION'
}

/** An edge in a connection. */
export type EstateWaterfallHypotheticalTransferEdge = {
  __typename?: 'EstateWaterfallHypotheticalTransferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstateWaterfallHypotheticalTransfer>;
};

/** Ordering options for EstateWaterfallHypotheticalTransfer connections */
export type EstateWaterfallHypotheticalTransferOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EstateWaterfallHypotheticalTransfers. */
  field: EstateWaterfallHypotheticalTransferOrderField;
};

/** Properties by which EstateWaterfallHypotheticalTransfer connections can be ordered. */
export enum EstateWaterfallHypotheticalTransferOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** EstateWaterfallHypotheticalTransferSourceKind is enum for the field source_kind */
export enum EstateWaterfallHypotheticalTransferSourceKind {
  Entity = 'ENTITY',
  External = 'EXTERNAL',
  Individual = 'INDIVIDUAL'
}

/** EstateWaterfallHypotheticalTransferTransferTaxKind is enum for the field transfer_tax_kind */
export enum EstateWaterfallHypotheticalTransferTransferTaxKind {
  AnualExclusionGift = 'ANUAL_EXCLUSION_GIFT',
  CharitableGift = 'CHARITABLE_GIFT',
  GenericNonTaxableGift = 'GENERIC_NON_TAXABLE_GIFT',
  GrantorTaxableGift = 'GRANTOR_TAXABLE_GIFT',
  NonGiftTransfer = 'NON_GIFT_TRANSFER'
}

/**
 * EstateWaterfallHypotheticalTransferWhereInput is used for filtering EstateWaterfallHypotheticalTransfer objects.
 * Input was generated by ent.
 */
export type EstateWaterfallHypotheticalTransferWhereInput = {
  /** after_both_deaths field predicates */
  afterBothDeaths?: InputMaybe<Scalars['Boolean']['input']>;
  afterBothDeathsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  afterBothDeathsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<EstateWaterfallHypotheticalTransferWhereInput>>;
  /** asset_growth_return field predicates */
  assetGrowthReturn?: InputMaybe<Scalars['Percent']['input']>;
  assetGrowthReturnGT?: InputMaybe<Scalars['Percent']['input']>;
  assetGrowthReturnGTE?: InputMaybe<Scalars['Percent']['input']>;
  assetGrowthReturnIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assetGrowthReturnLT?: InputMaybe<Scalars['Percent']['input']>;
  assetGrowthReturnLTE?: InputMaybe<Scalars['Percent']['input']>;
  assetGrowthReturnNEQ?: InputMaybe<Scalars['Percent']['input']>;
  assetGrowthReturnNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** destination_kind field predicates */
  destinationKind?: InputMaybe<EstateWaterfallHypotheticalTransferDestinationKind>;
  destinationKindIn?: InputMaybe<Array<EstateWaterfallHypotheticalTransferDestinationKind>>;
  destinationKindNEQ?: InputMaybe<EstateWaterfallHypotheticalTransferDestinationKind>;
  destinationKindNotIn?: InputMaybe<Array<EstateWaterfallHypotheticalTransferDestinationKind>>;
  /** end_year field predicates */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  endYearGT?: InputMaybe<Scalars['Int']['input']>;
  endYearGTE?: InputMaybe<Scalars['Int']['input']>;
  endYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endYearLT?: InputMaybe<Scalars['Int']['input']>;
  endYearLTE?: InputMaybe<Scalars['Int']['input']>;
  endYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  endYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** destination_entity edge predicates */
  hasDestinationEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasDestinationEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** destination_individual edge predicates */
  hasDestinationIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasDestinationIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** destination_organization edge predicates */
  hasDestinationOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasDestinationOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** end_at_clients_death edge predicates */
  hasEndAtClientsDeath?: InputMaybe<Scalars['Boolean']['input']>;
  hasEndAtClientsDeathWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** gifting_grantors edge predicates */
  hasGiftingGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  hasGiftingGrantorsWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_waterfall edge predicates */
  hasHypotheticalWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** source_entity edge predicates */
  hasSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** source_individual edge predicates */
  hasSourceIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** source_insurance_policy edge predicates */
  hasSourceInsurancePolicy?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceInsurancePolicyWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** source_owned_business_entity edge predicates */
  hasSourceOwnedBusinessEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceOwnedBusinessEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** source_owned_entity edge predicates */
  hasSourceOwnedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceOwnedEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** source_ownership_stake edge predicates */
  hasSourceOwnershipStake?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceOwnershipStakeWith?: InputMaybe<Array<OwnershipStakeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_gst_gift field predicates */
  isGstGift?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<EstateWaterfallHypotheticalTransferWhereInput>;
  or?: InputMaybe<Array<EstateWaterfallHypotheticalTransferWhereInput>>;
  /** source_kind field predicates */
  sourceKind?: InputMaybe<EstateWaterfallHypotheticalTransferSourceKind>;
  sourceKindIn?: InputMaybe<Array<EstateWaterfallHypotheticalTransferSourceKind>>;
  sourceKindNEQ?: InputMaybe<EstateWaterfallHypotheticalTransferSourceKind>;
  sourceKindNotIn?: InputMaybe<Array<EstateWaterfallHypotheticalTransferSourceKind>>;
  /** start_year field predicates */
  startYear?: InputMaybe<Scalars['Int']['input']>;
  startYearGT?: InputMaybe<Scalars['Int']['input']>;
  startYearGTE?: InputMaybe<Scalars['Int']['input']>;
  startYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startYearLT?: InputMaybe<Scalars['Int']['input']>;
  startYearLTE?: InputMaybe<Scalars['Int']['input']>;
  startYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  startYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** taxable_value field predicates */
  taxableValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxableValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** transfer_order field predicates */
  transferOrder?: InputMaybe<Scalars['Int']['input']>;
  transferOrderGT?: InputMaybe<Scalars['Int']['input']>;
  transferOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  transferOrderLT?: InputMaybe<Scalars['Int']['input']>;
  transferOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  transferOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** transfer_tax_kind field predicates */
  transferTaxKind?: InputMaybe<EstateWaterfallHypotheticalTransferTransferTaxKind>;
  transferTaxKindIn?: InputMaybe<Array<EstateWaterfallHypotheticalTransferTransferTaxKind>>;
  transferTaxKindNEQ?: InputMaybe<EstateWaterfallHypotheticalTransferTransferTaxKind>;
  transferTaxKindNotIn?: InputMaybe<Array<EstateWaterfallHypotheticalTransferTransferTaxKind>>;
  /** transfer_value field predicates */
  transferValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  transferValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** EstateWaterfallKind is enum for the field kind */
export enum EstateWaterfallKind {
  Base = 'BASE',
  Hypothetical = 'HYPOTHETICAL'
}

/** EstateWaterfallLoan is a loan in the estate waterfall. */
export type EstateWaterfallLoan = {
  __typename?: 'EstateWaterfallLoan';
  /**
   * The ID of the underlying loan object, if it exists.
   * Conflicts with the pseudoID field; only one should be present.
   */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * The node that the loan is attached to, if it exists.
   * Only present if id is present.
   */
  node?: Maybe<Node>;
  /**
   * The pseudo ID of the simulated loan, if it is a simulation.
   * Conflicts with the ID field; only one should be present.
   */
  pseudoID?: Maybe<Scalars['String']['output']>;
  /** The value history of the simulated loan. */
  valueHistory: Array<EstateWaterfallLoanValueHistory>;
};

/** EstateWaterfallLoanValueHistory is the value history for a loan. */
export type EstateWaterfallLoanValueHistory = {
  __typename?: 'EstateWaterfallLoanValueHistory';
  /** The beginning of the year value of the loan. */
  beginningOfYearValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The end of the year value of the loan. */
  endOfYearValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The interest paid for the year. */
  interestPaid?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The principal paid for the year. */
  principalPaid?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The year of the value history. */
  year: Scalars['Int']['output'];
};

/** EstateWaterfallMaterializedInputParams is the parameters used to create the waterfall visualization. */
export type EstateWaterfallMaterializedInputParams = {
  __typename?: 'EstateWaterfallMaterializedInputParams';
  /**
   * beneficiaryCalcMethod is how we calculate access to trust value when there are multiple beneficiaries
   * This is only relevant for beneficiary reporting.
   */
  beneficiaryCalcMethod: BeneficiaryReportAccessCalculationMethod;
  firstGrantorDeathYear: Scalars['Int']['output'];
  secondGrantorDeathYear?: Maybe<Scalars['Int']['output']>;
  selectedGrowthProfile?: Maybe<GrowthProfile>;
};

export type EstateWaterfallMessageContext = Node & {
  __typename?: 'EstateWaterfallMessageContext';
  createdAt: Scalars['Time']['output'];
  /** The waterfall this context references. It is not required for this waterfall to still exist */
  estateWaterfallID: Scalars['String']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The message this context belongs to */
  message: Message;
  /** Version of the persisted estate waterfall snapshot payload contract */
  snapshotSchemaVersion: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type EstateWaterfallMessageContextConnection = {
  __typename?: 'EstateWaterfallMessageContextConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstateWaterfallMessageContextEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EstateWaterfallMessageContextEdge = {
  __typename?: 'EstateWaterfallMessageContextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstateWaterfallMessageContext>;
};

/** Ordering options for EstateWaterfallMessageContext connections */
export type EstateWaterfallMessageContextOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EstateWaterfallMessageContexts. */
  field: EstateWaterfallMessageContextOrderField;
};

/** Properties by which EstateWaterfallMessageContext connections can be ordered. */
export enum EstateWaterfallMessageContextOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EstateWaterfallMessageContextWhereInput is used for filtering EstateWaterfallMessageContext objects.
 * Input was generated by ent.
 */
export type EstateWaterfallMessageContextWhereInput = {
  and?: InputMaybe<Array<EstateWaterfallMessageContextWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** estate_waterfall_id field predicates */
  estateWaterfallID?: InputMaybe<Scalars['String']['input']>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** message edge predicates */
  hasMessage?: InputMaybe<Scalars['Boolean']['input']>;
  hasMessageWith?: InputMaybe<Array<MessageWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<EstateWaterfallMessageContextWhereInput>;
  or?: InputMaybe<Array<EstateWaterfallMessageContextWhereInput>>;
  /** snapshot_schema_version field predicates */
  snapshotSchemaVersion?: InputMaybe<Scalars['Int']['input']>;
  snapshotSchemaVersionGT?: InputMaybe<Scalars['Int']['input']>;
  snapshotSchemaVersionGTE?: InputMaybe<Scalars['Int']['input']>;
  snapshotSchemaVersionLT?: InputMaybe<Scalars['Int']['input']>;
  snapshotSchemaVersionLTE?: InputMaybe<Scalars['Int']['input']>;
  snapshotSchemaVersionNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** EstateWaterfallNodeValueHistory is the value history for a node */
export type EstateWaterfallNodeValueHistory = {
  __typename?: 'EstateWaterfallNodeValueHistory';
  /** assetGrowth is how much the value of the node increased/decreased due to growth */
  assetGrowth?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** beginningOfYearValue is the value of the node at the beginning of the year */
  beginningOfYearValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** endOfYearValue is the value of the node at the end of the year */
  endOfYearValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  /**
   * ownedObjects is the list of objects that are owned by the node.
   * NOTE: that these values are already included in the node value history field
   * so be careful not to double count them.
   * NOTE: these are end of year values.
   */
  ownedObjects: Array<EstateWaterfallOwnedObject>;
  /** valueBeforeDispositions is the value of the node before any dispositions were applied */
  valueBeforeDispositions?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** year is the year that this node value history corresponds to */
  year: Scalars['Int']['output'];
};

/** Ordering options for EstateWaterfall connections */
export type EstateWaterfallOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EstateWaterfalls. */
  field: EstateWaterfallOrderField;
};

/** Properties by which EstateWaterfall connections can be ordered. */
export enum EstateWaterfallOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** EstateWaterfallOwnedObject is an object that is owned by a node */
export type EstateWaterfallOwnedObject = {
  __typename?: 'EstateWaterfallOwnedObject';
  /** ownedObject is the object that is owned by the node */
  ownedObject: Node;
  /** ownedObjectID is the ID of the object that is owned by the node */
  ownedObjectID: Scalars['ID']['output'];
  /** ownershipPercentage is the percentage of the owned stake in the object */
  ownershipPercentage: Scalars['Percent']['output'];
  /** value is the value of the owned stake in the object */
  value: Scalars['CurrencyUSD']['output'];
};

/**
 * EstateWaterfallPrimaryClientValuesBeforeDispositions contains one primary
 * client's values before each applicable death event's dispositions run.
 */
export type EstateWaterfallPrimaryClientValuesBeforeDispositions = {
  __typename?: 'EstateWaterfallPrimaryClientValuesBeforeDispositions';
  /**
   * The value before first-death dispositions run.
   * A null value means that the client has no directly held assets. Zero means
   * that the client has directly held assets with no net value.
   */
  firstDeathValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  firstGrantorDeathID: Scalars['ID']['output'];
  primaryClientID: Scalars['ID']['output'];
  /**
   * The value before second-death dispositions run.
   * A null value means that no value is available for second-death dispositions.
   * Zero means that the client has directly held assets with no net value.
   */
  secondDeathValue?: Maybe<Scalars['CurrencyUSD']['output']>;
};

export type EstateWaterfallProjectionInput = {
  /**
   * beneficiaryCalcMethod is how we calculate access to trust value when there are multiple beneficiaries
   * This is only relevant for beneficiary reporting.
   */
  beneficiaryCalcMethod?: InputMaybe<BeneficiaryReportAccessCalculationMethod>;
  firstGrantorDeathYear?: InputMaybe<Scalars['Int']['input']>;
  /** forceZeroGrowth when set, will run this waterfall simulation with 0% asset and exemption growth. */
  forceZeroGrowth?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * growthProfileID when set, will run this waterfall simulation with the growth assumptions specified in the profile.
   * when present, it will override the profile that is set directly on the waterfall.
   */
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  secondGrantorDeathYear?: InputMaybe<Scalars['Int']['input']>;
  /** simulationInputs is used to simulate objects in the estate waterfall. */
  simulationInputs?: InputMaybe<EstateWaterfallSimulationInputs>;
  sourceWaterfallID?: InputMaybe<Scalars['ID']['input']>;
};

/** EstateWaterfallSimulateHypotheticalSaleLoanInput is used to simulate a hypothetical sale loan. */
export type EstateWaterfallSimulateHypotheticalSaleLoanInput = {
  /**
   * The input to create the hypothetical sale loan for simulation.
   * If not present, no simulated loan but the replaceID loan will be skipped
   */
  create?: InputMaybe<AugmentedCreateHypotheticalSaleLoanInput>;
  /**
   * An ID that uniquely identifies the hypothetical sale loan to simulate.
   * It will be reflected back in the response so it is up to the client to
   * choose a value that is unique and meaningful.
   */
  pseudoID: Scalars['String']['input'];
  /**
   * When present, this hypothetical sale/loan will be disabled and replaced by the simulated one.
   * If not present, the simulated loan is purely additive.
   */
  replaces?: InputMaybe<Scalars['ID']['input']>;
};

/** EstateWaterfallSimulationInputs is used to simulate objects in the estate waterfall. */
export type EstateWaterfallSimulationInputs = {
  /** The list of hypothetical sale loans to simulate. */
  hypotheticalSaleLoans: Array<EstateWaterfallSimulateHypotheticalSaleLoanInput>;
};

/**
 * EstateWaterfallTransfer is a transfer of value from one node to another
 * in the estate waterfall graph.
 * Can be through a transfer, disposition, pourover, hypothetical sale loan, etc...
 */
export type EstateWaterfallTransfer = {
  __typename?: 'EstateWaterfallTransfer';
  /**
   * associatedObject is the object that is associated with the transfer
   * it typically caused the transfer.
   * Corresponds to associatedObjectID
   */
  associatedObject?: Maybe<Node>;
  /**
   * AssociatedObjectID is the ID of the object that is associated with the transfer
   * it typically caused the transfer
   */
  associatedObjectID?: Maybe<Scalars['ID']['output']>;
  /** availableTransferAmount is the amount of the transfer that is available */
  availableTransferAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** desiredTransferAmount is the amount of the transfer that is desired */
  desiredTransferAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** destination is the node that the transfer is going to */
  destination?: Maybe<EstateWaterfallVizNode>;
  /** finalTransferAmount is the amount of the transfer that is actually transferred */
  finalTransferAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /**
   * isHypothetical indicates whether or not the transfer was a product of
   * a hypothetical scenario
   */
  isHypothetical: Scalars['Boolean']['output'];
  /** Kind is the kind of transfer */
  kind: EstateWaterfallTransferKind;
  /** For HYPOTHETICAL_SALE_LOAN transfers, specifies the exact type (SALE or LOAN) */
  saleOrLoanType?: Maybe<SaleOrLoanType>;
  /** source is the node that the transfer is coming from */
  source?: Maybe<EstateWaterfallVizNode>;
  /** year is the year of the transfer */
  year: Scalars['Int']['output'];
};

/** EstateWaterfallTransferKind is the kind of transfer */
export enum EstateWaterfallTransferKind {
  BeneficiaryPayment = 'BENEFICIARY_PAYMENT',
  CancelledLoan = 'CANCELLED_LOAN',
  CltBeneficiaryRemainder = 'CLT_BENEFICIARY_REMAINDER',
  CltIncomePayment = 'CLT_INCOME_PAYMENT',
  CrtCharitableRemainder = 'CRT_CHARITABLE_REMAINDER',
  CrtIncomePayment = 'CRT_INCOME_PAYMENT',
  DispositiveProvision = 'DISPOSITIVE_PROVISION',
  FinalDistribution = 'FINAL_DISTRIBUTION',
  GratAnnuityPayment = 'GRAT_ANNUITY_PAYMENT',
  HypotheticalCltFunding = 'HYPOTHETICAL_CLT_FUNDING',
  HypotheticalCrtFunding = 'HYPOTHETICAL_CRT_FUNDING',
  HypotheticalGratFunding = 'HYPOTHETICAL_GRAT_FUNDING',
  HypotheticalInsurancePolicy = 'HYPOTHETICAL_INSURANCE_POLICY',
  HypotheticalInsurancePolicyFunding = 'HYPOTHETICAL_INSURANCE_POLICY_FUNDING',
  HypotheticalOwnershipStake = 'HYPOTHETICAL_OWNERSHIP_STAKE',
  HypotheticalSaleLoan = 'HYPOTHETICAL_SALE_LOAN',
  HypotheticalValue = 'HYPOTHETICAL_VALUE',
  LiabilityPayment = 'LIABILITY_PAYMENT',
  LiabilityPaymentOnDeath = 'LIABILITY_PAYMENT_ON_DEATH',
  PouroverWill = 'POUROVER_WILL',
  QprtBeneficiaryPayment = 'QPRT_BENEFICIARY_PAYMENT'
}

export type EstateWaterfallVisualizationConfig = Node & {
  __typename?: 'EstateWaterfallVisualizationConfig';
  /** If true, always shows edge labels. */
  alwaysShowEdgeLabels: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  /** If true, hides edges. */
  hideEdges: Scalars['Boolean']['output'];
  /** If true, hides list of entities in a group. */
  hideEntitiesListInGroups: Scalars['Boolean']['output'];
  /** If true, hides dollar values on the entity tile. */
  hideEntityValues: Scalars['Boolean']['output'];
  /** If true, hides all tax tiles. */
  hideTaxTiles: Scalars['Boolean']['output'];
  /** If true, hides unfunded tiles. */
  hideUnfundedTiles: Scalars['Boolean']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** If true, shows zero dollar tiles. */
  showZeroDollarTiles: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  /** If true, uses brand colors instead of luminary defaults. */
  useBrandColors: Scalars['Boolean']['output'];
  waterfall?: Maybe<EstateWaterfall>;
};

/** A connection to a list of items. */
export type EstateWaterfallVisualizationConfigConnection = {
  __typename?: 'EstateWaterfallVisualizationConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstateWaterfallVisualizationConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EstateWaterfallVisualizationConfigEdge = {
  __typename?: 'EstateWaterfallVisualizationConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstateWaterfallVisualizationConfig>;
};

/** Ordering options for EstateWaterfallVisualizationConfig connections */
export type EstateWaterfallVisualizationConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EstateWaterfallVisualizationConfigs. */
  field: EstateWaterfallVisualizationConfigOrderField;
};

/** Properties by which EstateWaterfallVisualizationConfig connections can be ordered. */
export enum EstateWaterfallVisualizationConfigOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EstateWaterfallVisualizationConfigWhereInput is used for filtering EstateWaterfallVisualizationConfig objects.
 * Input was generated by ent.
 */
export type EstateWaterfallVisualizationConfigWhereInput = {
  /** always_show_edge_labels field predicates */
  alwaysShowEdgeLabels?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<EstateWaterfallVisualizationConfigWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** waterfall edge predicates */
  hasWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** hide_edges field predicates */
  hideEdges?: InputMaybe<Scalars['Boolean']['input']>;
  /** hide_entities_list_in_groups field predicates */
  hideEntitiesListInGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** hide_entity_values field predicates */
  hideEntityValues?: InputMaybe<Scalars['Boolean']['input']>;
  /** hide_tax_tiles field predicates */
  hideTaxTiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** hide_unfunded_tiles field predicates */
  hideUnfundedTiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<EstateWaterfallVisualizationConfigWhereInput>;
  or?: InputMaybe<Array<EstateWaterfallVisualizationConfigWhereInput>>;
  /** show_zero_dollar_tiles field predicates */
  showZeroDollarTiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** use_brand_colors field predicates */
  useBrandColors?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EstateWaterfallVisualizationFilter = Node & {
  __typename?: 'EstateWaterfallVisualizationFilter';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  includedClients: ClientProfileConnection;
  includedEntities: EntityConnection;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
  waterfall: EstateWaterfall;
};


export type EstateWaterfallVisualizationFilterIncludedClientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClientProfileOrder>>;
  where?: InputMaybe<ClientProfileWhereInput>;
};


export type EstateWaterfallVisualizationFilterIncludedEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityOrder>>;
  where?: InputMaybe<EntityWhereInput>;
};

/** A connection to a list of items. */
export type EstateWaterfallVisualizationFilterConnection = {
  __typename?: 'EstateWaterfallVisualizationFilterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstateWaterfallVisualizationFilterEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EstateWaterfallVisualizationFilterEdge = {
  __typename?: 'EstateWaterfallVisualizationFilterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EstateWaterfallVisualizationFilter>;
};

/** Ordering options for EstateWaterfallVisualizationFilter connections */
export type EstateWaterfallVisualizationFilterOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order EstateWaterfallVisualizationFilters. */
  field: EstateWaterfallVisualizationFilterOrderField;
};

/** Properties by which EstateWaterfallVisualizationFilter connections can be ordered. */
export enum EstateWaterfallVisualizationFilterOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * EstateWaterfallVisualizationFilterWhereInput is used for filtering EstateWaterfallVisualizationFilter objects.
 * Input was generated by ent.
 */
export type EstateWaterfallVisualizationFilterWhereInput = {
  and?: InputMaybe<Array<EstateWaterfallVisualizationFilterWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** included_clients edge predicates */
  hasIncludedClients?: InputMaybe<Scalars['Boolean']['input']>;
  hasIncludedClientsWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** included_entities edge predicates */
  hasIncludedEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasIncludedEntitiesWith?: InputMaybe<Array<EntityWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** waterfall edge predicates */
  hasWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<EstateWaterfallVisualizationFilterWhereInput>;
  or?: InputMaybe<Array<EstateWaterfallVisualizationFilterWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EstateWaterfallViz = {
  __typename?: 'EstateWaterfallViz';
  _cacheKey: Scalars['String']['output'];
  /**
   * beforeFirstDeathTaxSummary is the tax summary before the first client death.
   * Only present for hypothetical waterfalls.
   */
  beforeFirstDeathTaxSummary?: Maybe<TaxSummary>;
  /**
   * beforeFirstDeathTaxSummaryV2 is the tax summary before the first client death.
   * Note that only gift tax is relevant before first death
   */
  beforeFirstDeathTaxSummaryV2?: Maybe<GiftTaxSummary>;
  /** The edges between nodes in the waterfall */
  edges: Array<EstateWaterfallVizEdge>;
  /**
   * estateTaxScenario is the estate tax scenario used
   * if one is defined for the advisor client.
   * Default to pro-rata if no estate tax scenario is defined.
   */
  estateTaxScenario?: Maybe<EstateTaxScenario>;
  /** eventLog is a list of key events that transpired during the computation of the waterfall. */
  eventLog: Array<EstateWaterfallEvent>;
  /**
   * firstDeathInEstateInsuranceBenefit is the insurance death benefit paid at the first client death
   * to in-estate entities.
   */
  firstDeathInEstateInsuranceBenefit: Scalars['CurrencyUSD']['output'];
  /** firstDeathInsuranceBenefit is the total insurance death benefit paid at the first client death. */
  firstDeathInsuranceBenefit: Scalars['CurrencyUSD']['output'];
  /**
   * firstDeathOutOfEstateInsuranceBenefit is the insurance death benefit paid at the first client death
   * to out-of-estate entities.
   */
  firstDeathOutOfEstateInsuranceBenefit: Scalars['CurrencyUSD']['output'];
  /**
   * firstDeathRemainingLifetimeExemption is the remaining lifetime exemption
   * at first grantor death, and used to calculate the estate tax at the time.
   */
  firstDeathRemainingLifetimeExemption: Scalars['CurrencyUSD']['output'];
  /** firstDeathTaxSummary is the tax summary at the first client death. */
  firstDeathTaxSummary: TaxSummary;
  /** firstDeathTaxSummaryV2 is the tax summary at the first client death. */
  firstDeathTaxSummaryV2: TaxSummaryV2;
  /**
   * firstGrantorRemainingLifetimeExemptionAtDeath is the remaining lifetime exemption
   * for the first to die grantor upon their death.
   */
  firstGrantorRemainingLifetimeExemptionAtDeath: Scalars['CurrencyUSD']['output'];
  /**
   * growthProfile is the growth profile that was used to
   * compute the visualization of the estate waterfall.
   */
  growthProfile: GrowthProfile;
  /**
   * Whether the response has estate waterfall data. This remains true when
   * zero-value filtering hides every node for a configured disposition.
   */
  hasWaterfallData: Scalars['Boolean']['output'];
  /**
   * lifetimeExemptionAppliedTowardsGiftTax is the amount of lifetime exemption
   * applied towards gift tax.
   * Only present for hypothetical waterfalls.
   */
  lifetimeExemptionAppliedTowardsGiftTax?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** loans is the list of loans in the waterfall. */
  loans: Array<EstateWaterfallLoan>;
  /** materializedInputParams is the parameters used to create the waterfall visualization. */
  materializedInputParams: EstateWaterfallMaterializedInputParams;
  /** The nodes in the waterfall */
  nodes: Array<EstateWaterfallVizNode>;
  /**
   * secondDeathInEstateInsuranceBenefit is the insurance death benefit paid at the second client death
   * to in-estate entities.
   * Only present for two client waterfalls.
   */
  secondDeathInEstateInsuranceBenefit?: Maybe<Scalars['CurrencyUSD']['output']>;
  /**
   * secondDeathInsuranceBenefit is the total insurance death benefit paid at the second client death.
   * Only present for two client waterfalls.
   */
  secondDeathInsuranceBenefit?: Maybe<Scalars['CurrencyUSD']['output']>;
  /**
   * secondDeathOutOfEstateInsuranceBenefit is the insurance death benefit paid at the second client death
   * to out-of-estate entities.
   * Only present for two client waterfalls.
   */
  secondDeathOutOfEstateInsuranceBenefit?: Maybe<Scalars['CurrencyUSD']['output']>;
  /**
   * secondDeathRemainingLifetimeExemption is the remaining lifetime exemption
   * at second grantor death, and used to calculate the estate tax at the time.
   */
  secondDeathRemainingLifetimeExemption: Scalars['CurrencyUSD']['output'];
  /**
   * secondDeathTaxSummary is the tax summary at the second client death.
   * Only present for two client waterfalls.
   */
  secondDeathTaxSummary?: Maybe<TaxSummary>;
  /**
   * secondDeathTaxSummaryV2 is the tax summary at the second client death.
   * Only present for two client waterfalls.
   */
  secondDeathTaxSummaryV2?: Maybe<TaxSummaryV2>;
  /**
   * secondGrantorRemainingLifetimeExemptionAtDeath is the remaining lifetime exemption
   * for the second to die grantor upon their death.
   */
  secondGrantorRemainingLifetimeExemptionAtDeath?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** transferLog is the list of transfers in the waterfall. */
  transferLog: Array<EstateWaterfallTransfer>;
};

/**
 * EstateWaterfallVizConfigOptsInput is used to override values
 * for the waterfall visualization.
 */
export type EstateWaterfallVizConfigOptsInput = {
  /**
   * clientSideVisibilityRules when true returns all nodes/edges and annotates
   * each with default hiding metadata instead of skipping server-side.
   */
  clientSideVisibilityRules?: InputMaybe<Scalars['Boolean']['input']>;
  /** enableV2DispositiveProvisions when true, enables the v2 dispositive provisions engine. */
  enableV2DispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * hideUnfundedTiles when nil, we use the default value as set by the EstateWaterfallVisualizationConfig.
   * when true, we hide unfunded tiles.
   */
  hideUnfundedTiles?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * runWaterfallAsNonHypothetical when true, runs a hypothetical estate waterfall as a non-hypothetical.
   * it does nothing for non-hypothetical waterfalls.
   */
  runWaterfallAsNonHypothetical?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * showZeroDollarTiles when nil, we use the default value as set by the EstateWaterfallVisualizationConfig.
   * when true, we show zero dollar edges, which implies zero dollar tiles are also shown.
   * @deprecated use hideUnfundedTiles instead
   */
  showZeroDollarTiles?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EstateWaterfallVizEdge = {
  __typename?: 'EstateWaterfallVizEdge';
  associatedDispositiveProvisions?: Maybe<Array<Maybe<EstateWaterfallVizEdgeAssociatedDispositiveProvision>>>;
  /** associatedHypotheticalCLTs are the hypothetical CLTs associated with this edge. */
  associatedHypotheticalCLTs?: Maybe<Array<EstateWaterfallVizEdgeAssociatedHypotheticalClt>>;
  /** associatedHypotheticalCRTs are the hypothetical CRTs associated with this edge. */
  associatedHypotheticalCRTs?: Maybe<Array<EstateWaterfallVizEdgeAssociatedHypotheticalCrt>>;
  /** associatedHypotheticalGRATs are the hypothetical GRATs associated with this edge. */
  associatedHypotheticalGRATs?: Maybe<Array<EstateWaterfallVizEdgeAssociatedHypotheticalGrat>>;
  /** associatedHypotheticalInsurances are the hypotehtical insurances associated with this edge. */
  associatedHypotheticalInsurances?: Maybe<Array<EstateWaterfallVizEdgeAssociatedHypotheticalInsurance>>;
  /** associatedLoans are the loans associated with this edge. */
  associatedLoans?: Maybe<Array<EstateWaterfallVizEdgeAssociatedLoan>>;
  /**
   * associatedPouroverDispositions are the dispositive provisions associated with this edge
   * that are part of a pourover template. When present, the destination can be considered a pourover
   * entity.
   */
  associatedPouroverDispositions?: Maybe<Array<Maybe<EstateWaterfallVizEdgeAssociatedDispositiveProvision>>>;
  /** associatedTransferLogItems are the transfers from the transfer log that correspond to this edge. */
  associatedTransferLogItems?: Maybe<Array<EstateWaterfallTransfer>>;
  associatedTransfers?: Maybe<Array<Maybe<EstateWaterfallVizEdgeAssociatedTransfer>>>;
  /** defaultHiddenReasons contains stable backend reason codes for default hiding. */
  defaultHiddenReasons: Array<Scalars['String']['output']>;
  from: EstateWaterfallVizNode;
  /**
   * isDefaultHidden is true when backend default visibility rules would hide this edge.
   * This is provided so clients can apply visibility rules without refetching.
   */
  isDefaultHidden: Scalars['Boolean']['output'];
  kind: EstateWaterfallEdgeKind;
  to: EstateWaterfallVizNode;
  value: Scalars['CurrencyUSD']['output'];
};

/**
 * EstateWaterfallVizEdgeAssociatedDispositiveProvision is used to carry some metadata
 * about the DP in the viz edge.
 */
export type EstateWaterfallVizEdgeAssociatedDispositiveProvision = {
  __typename?: 'EstateWaterfallVizEdgeAssociatedDispositiveProvision';
  dispositiveProvision: DispositiveProvision;
  value: Scalars['CurrencyUSD']['output'];
};

/**
 * EstateWaterfallVizEdgeAssociatedHypotheticalCLT is used to carry some metadata
 * about the hypothetical CLT in the viz edge.
 */
export type EstateWaterfallVizEdgeAssociatedHypotheticalClt = {
  __typename?: 'EstateWaterfallVizEdgeAssociatedHypotheticalCLT';
  /** hypotheticalCLT is the hypothetical CLT that is associated with the edge. */
  hypotheticalCLT?: Maybe<HypotheticalClt>;
  /** value is the transfer value used to fund the hypothetical CLT */
  value: Scalars['CurrencyUSD']['output'];
};

/**
 * EstateWaterfallVizEdgeAssociatedHypotheticalCRT is used to carry some metadata
 * about the hypothetical CRT in the viz edge.
 */
export type EstateWaterfallVizEdgeAssociatedHypotheticalCrt = {
  __typename?: 'EstateWaterfallVizEdgeAssociatedHypotheticalCRT';
  /** hypotheticalCRT is the hypothetical CRT that is associated with the edge. */
  hypotheticalCRT?: Maybe<HypotheticalCrt>;
  /** value is the transfer value used to fund the hypothetical CRT */
  value: Scalars['CurrencyUSD']['output'];
};

/**
 * EstateWaterfallVizEdgeAssociatedHypotheticalGRAT is used to carry some metadata
 * about the hypothetical GRAT in the viz edge.
 */
export type EstateWaterfallVizEdgeAssociatedHypotheticalGrat = {
  __typename?: 'EstateWaterfallVizEdgeAssociatedHypotheticalGRAT';
  /** hypotheticalGRAT is the hypothetical GRAT that is associated with the edge. */
  hypotheticalGRAT?: Maybe<HypotheticalGrat>;
  /** value is the value of the hypothetical GRAT that is transferred to fund the GRAT */
  value: Scalars['CurrencyUSD']['output'];
};

/**
 * EstateWaterfallVizEdgeAssociatedHypotheticalInsurance is used to carry some metadata
 * about the hypothetical insurance in the viz edge.
 */
export type EstateWaterfallVizEdgeAssociatedHypotheticalInsurance = {
  __typename?: 'EstateWaterfallVizEdgeAssociatedHypotheticalInsurance';
  /** hypotheticalInsurance is the hypothetical insurance that is associated with the edge. */
  hypotheticalInsurance?: Maybe<HypotheticalInsurance>;
  /** value is the transfer value used to fund the hypothetical CLT */
  value: Scalars['CurrencyUSD']['output'];
};

/**
 * EstateWaterfallVizEdgeAssociatedLoan is used to carry some metadata
 * about the loan in the viz edge.
 */
export type EstateWaterfallVizEdgeAssociatedLoan = {
  __typename?: 'EstateWaterfallVizEdgeAssociatedLoan';
  /**
   * loan is the loan that is associated with the edge.
   * absent if the loan is a simulated one
   */
  loan?: Maybe<EstateWaterfallLoan>;
  /** value is the value of the loan that is transferred to the node */
  value: Scalars['CurrencyUSD']['output'];
};

/**
 * EstateWaterfallVizEdgeAssociatedTransfer is used to carry some metadata
 * about the transfer in the viz edge. This was a bit poorly named, but it
 * corresponds to a 'hypothetical transfer' object
 */
export type EstateWaterfallVizEdgeAssociatedTransfer = {
  __typename?: 'EstateWaterfallVizEdgeAssociatedTransfer';
  transfer: EstateWaterfallHypotheticalTransfer;
  value: Scalars['CurrencyUSD']['output'];
};

export type EstateWaterfallVizNode = GraphVisualizationNode & {
  __typename?: 'EstateWaterfallVizNode';
  /** _cacheKey is a unique key used for client-side caching. */
  _cacheKey: Scalars['String']['output'];
  /** addedDeathBenefit is the death benefit added to the node during this death event */
  addedDeathBenefit?: Maybe<Scalars['CurrencyUSD']['output']>;
  afterDeath: AfterDeath;
  /** assetValue is the value of the assets in this node. */
  assetValue: Scalars['CurrencyUSD']['output'];
  /** defaultHiddenReasons contains stable backend reason codes for default hiding. */
  defaultHiddenReasons: Array<Scalars['String']['output']>;
  /** futureDeathBenefit is the value to be added to the node after the death of the grantors. */
  futureDeathBenefit?: Maybe<Scalars['CurrencyUSD']['output']>;
  group?: Maybe<GraphVisualizationGroup>;
  /**
   * The ID of the node.
   * This is a bit redundant given the `node` field, but it's useful.
   */
  id: Scalars['ID']['output'];
  /**
   * inEstateStatus lets us know if this node is in the estate or not.
   * if the underlying data is inconclusive, we default to in-estate.
   */
  inEstateStatus: EntityInEstateStatus;
  /**
   * isDefaultHidden is true when backend default visibility rules would hide this node.
   * This is provided so clients can apply visibility rules without refetching.
   */
  isDefaultHidden: Scalars['Boolean']['output'];
  /**
   * isHidden is true if this node is hidden in the waterfall view due to
   * the associated estate waterfall visualization filter
   */
  isHidden: Scalars['Boolean']['output'];
  /** isHypothetical is true if this node is hypothetical and belongs to a hypothetical waterfall. */
  isHypothetical: Scalars['Boolean']['output'];
  /** liabilityValue is the value of the liabilities owed to others by this node. */
  liabilityValue: Scalars['CurrencyUSD']['output'];
  /**
   * The namespace for this node.
   * Always corresponds to afterDeath in the EW context.
   * This triplet should uniquely identify a node in the waterfall, important for client-side caching.
   */
  namespace?: Maybe<Scalars['String']['output']>;
  node: Node;
  /** We may or may not always have one of these */
  nodeConfiguration?: Maybe<EntityGraphNodeConfiguration>;
  /**
   * nonTaxableValue is the value of any transfers to charitable recipients, or
   * that use the unlimited marital exclusion
   */
  nonTaxableValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** receivableValue is the value of the liabilities owed to this node. */
  receivableValue: Scalars['CurrencyUSD']['output'];
  /** stateInEstateStatus is the in-estate status of this node for applicable states. */
  stateInEstateStatus?: Maybe<Array<NodeStateInEstateStatus>>;
  /**
   * taxableValue is the value of this node that is subject to estate tax.
   * As long as estate tax rate is 40%: taxableValue * 40% = transferredToEstateTax.
   * For CUSTOM payout, this is: value - nonTaxableValue
   * For PRO-RATA payout, this is: value - exemptionApplied - nonTaxableValue
   */
  taxableValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  /**
   * transferredToEstateTax is the amount transferred to the estate tax
   * when we simulate the death of the corresponding grantor.
   */
  transferredToEstateTax?: Maybe<Scalars['CurrencyUSD']['output']>;
  /**
   * transferredToGiftingTax is the amount transferred to the gifting tax tile
   * when we simulate hypothetical transfers.
   * This is only present at death "current" for now.
   * This is only present for hypothetical waterfalls.
   */
  transferredToGiftingTax?: Maybe<Scalars['CurrencyUSD']['output']>;
  /**
   * value is the value of this node in the waterfall.
   * it can either be the current value of the node (afterDeathNone)
   * or the amount transferred into the entity (or remaining in the entity)
   * after the death of a grantor (afterDeathFirst or afterDeathSecond)
   */
  value: Scalars['CurrencyUSD']['output'];
  /**
   * valueBeforeDispositions is the value of this node before any dispositions
   * at death. For projection waterfalls, this typically includes the appreciated assets.
   * This property is absent for nodes after the last death.
   */
  valueBeforeDispositions?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** valueBeforePouroverWills is the value of this node before any pourover wills were applied. */
  valueBeforePouroverWills?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** valueHistory is the value of the node for each year. */
  valueHistory: Array<EstateWaterfallNodeValueHistory>;
  waterfallID: Scalars['ID']['output'];
};

/**
 * EstateWaterfallWhereInput is used for filtering EstateWaterfall objects.
 * Input was generated by ent.
 */
export type EstateWaterfallWhereInput = {
  and?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** beneficiary_access_calc_method field predicates */
  beneficiaryAccessCalcMethod?: InputMaybe<EstateWaterfallBeneficiaryAccessCalcMethod>;
  beneficiaryAccessCalcMethodIn?: InputMaybe<Array<EstateWaterfallBeneficiaryAccessCalcMethod>>;
  beneficiaryAccessCalcMethodNEQ?: InputMaybe<EstateWaterfallBeneficiaryAccessCalcMethod>;
  beneficiaryAccessCalcMethodNotIn?: InputMaybe<Array<EstateWaterfallBeneficiaryAccessCalcMethod>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** first_grantor_death_year field predicates */
  firstGrantorDeathYear?: InputMaybe<Scalars['Int']['input']>;
  firstGrantorDeathYearGT?: InputMaybe<Scalars['Int']['input']>;
  firstGrantorDeathYearGTE?: InputMaybe<Scalars['Int']['input']>;
  firstGrantorDeathYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  firstGrantorDeathYearLT?: InputMaybe<Scalars['Int']['input']>;
  firstGrantorDeathYearLTE?: InputMaybe<Scalars['Int']['input']>;
  firstGrantorDeathYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  firstGrantorDeathYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter edge predicates */
  hasFilter?: InputMaybe<Scalars['Boolean']['input']>;
  hasFilterWith?: InputMaybe<Array<EstateWaterfallVisualizationFilterWhereInput>>;
  /** first_grantor_death edge predicates */
  hasFirstGrantorDeath?: InputMaybe<Scalars['Boolean']['input']>;
  hasFirstGrantorDeathWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** growth_profile edge predicates */
  hasGrowthProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrowthProfileWith?: InputMaybe<Array<GrowthProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_clts edge predicates */
  hasHypotheticalClts?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalCltsWith?: InputMaybe<Array<HypotheticalCltWhereInput>>;
  /** hypothetical_crts edge predicates */
  hasHypotheticalCrts?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalCrtsWith?: InputMaybe<Array<HypotheticalCrtWhereInput>>;
  /** hypothetical_grats edge predicates */
  hasHypotheticalGrats?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalGratsWith?: InputMaybe<Array<HypotheticalGratWhereInput>>;
  /** hypothetical_insurance edge predicates */
  hasHypotheticalInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalInsuranceWith?: InputMaybe<Array<HypotheticalInsuranceWhereInput>>;
  /** hypothetical_sale_loans edge predicates */
  hasHypotheticalSaleLoans?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalSaleLoansWith?: InputMaybe<Array<HypotheticalSaleLoanWhereInput>>;
  /** hypothetical_scenarios edge predicates */
  hasHypotheticalScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalScenariosWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** hypothetical_state_changes edge predicates */
  hasHypotheticalStateChanges?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalStateChangesWith?: InputMaybe<Array<EstateWaterfallHypotheticalStateChangeWhereInput>>;
  /** hypothetical_transfers edge predicates */
  hasHypotheticalTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalTransfersWith?: InputMaybe<Array<EstateWaterfallHypotheticalTransferWhereInput>>;
  /** parent edge predicates */
  hasParent?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** visualization_config edge predicates */
  hasVisualizationConfig?: InputMaybe<Scalars['Boolean']['input']>;
  hasVisualizationConfigWith?: InputMaybe<Array<EstateWaterfallVisualizationConfigWhereInput>>;
  /** visualization_groups edge predicates */
  hasVisualizationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasVisualizationGroupsWith?: InputMaybe<Array<GraphVisualizationGroupWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<EstateWaterfallKind>;
  kindIn?: InputMaybe<Array<EstateWaterfallKind>>;
  kindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  kindNEQ?: InputMaybe<EstateWaterfallKind>;
  kindNotIn?: InputMaybe<Array<EstateWaterfallKind>>;
  kindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<EstateWaterfallWhereInput>;
  or?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** second_grantor_death_year field predicates */
  secondGrantorDeathYear?: InputMaybe<Scalars['Int']['input']>;
  secondGrantorDeathYearGT?: InputMaybe<Scalars['Int']['input']>;
  secondGrantorDeathYearGTE?: InputMaybe<Scalars['Int']['input']>;
  secondGrantorDeathYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  secondGrantorDeathYearLT?: InputMaybe<Scalars['Int']['input']>;
  secondGrantorDeathYearLTE?: InputMaybe<Scalars['Int']['input']>;
  secondGrantorDeathYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  secondGrantorDeathYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_summary_tile_details field predicates */
  showSummaryTileDetails?: InputMaybe<Scalars['Boolean']['input']>;
  showSummaryTileDetailsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  showSummaryTileDetailsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** skip_current_year_growth field predicates */
  skipCurrentYearGrowth?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type ExportDocumentSummaryWordInput = {
  documentSummaryID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
};

export type ExportFormSubmissionWordInput = {
  submissionID: Scalars['ID']['input'];
};

export type ExportMemoWordInput = {
  householdID: Scalars['ID']['input'];
  memoID: Scalars['ID']['input'];
};

export type ExtendedCreateUserInput = {
  create: CreateUserInput;
  withCollaborator?: InputMaybe<PartialCreateCollaboratorInput>;
  withEmployee?: InputMaybe<PartialCreateEmployeeInput>;
};

export type FamilyTree = {
  __typename?: 'FamilyTree';
  /** The household this family tree belongs to */
  household: Household;
  /** Marriage relationships showing spousal connections and their children */
  marriages: Array<Marriage>;
  /**
   * All people in the family tree with their generation information.
   * Includes people connected via direct family relationship paths and standalone non-family
   * relationship nodes. Excludes people connected only via extended family relationships
   * (cousin, grandparent, etc.).
   */
  people: Array<FamilyTreePerson>;
  /** The primary clients (generation 0) in this household */
  primaryClients: Array<FamilyTreePerson>;
  /** Tree-level configuration settings for the family tree diagram */
  settings: FamilyTreeSettings;
  /**
   * All household people not connected to primary clients via parent/child/spouse graph
   * (generation is set to 0 for these people)
   */
  unconnectedPeople: Array<FamilyTreePerson>;
  /** Warnings about relationship conflicts, data inconsistencies, or unlinked family members */
  warnings: Array<FamilyTreeWarning>;
};

export type FamilyTreeBundleConfiguration = Node & {
  __typename?: 'FamilyTreeBundleConfiguration';
  bundle?: Maybe<PresentationBundle>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The display name for the family tree. */
  displayName?: Maybe<Scalars['String']['output']>;
  familyTreeConfiguration?: Maybe<FamilyTreeConfiguration>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type FamilyTreeBundleConfigurationConnection = {
  __typename?: 'FamilyTreeBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FamilyTreeBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FamilyTreeBundleConfigurationEdge = {
  __typename?: 'FamilyTreeBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FamilyTreeBundleConfiguration>;
};

/** Ordering options for FamilyTreeBundleConfiguration connections */
export type FamilyTreeBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order FamilyTreeBundleConfigurations. */
  field: FamilyTreeBundleConfigurationOrderField;
};

/** Properties by which FamilyTreeBundleConfiguration connections can be ordered. */
export enum FamilyTreeBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * FamilyTreeBundleConfigurationWhereInput is used for filtering FamilyTreeBundleConfiguration objects.
 * Input was generated by ent.
 */
export type FamilyTreeBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<FamilyTreeBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** family_tree_configuration edge predicates */
  hasFamilyTreeConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasFamilyTreeConfigurationWith?: InputMaybe<Array<FamilyTreeConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<FamilyTreeBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<FamilyTreeBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type FamilyTreeConfiguration = Node & {
  __typename?: 'FamilyTreeConfiguration';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Node positions and display settings for both individual nodes (client_profile_id) and marriage nodes (computed IDs like 'spouse1_spouse2' or 'single_parentid') */
  nodeConfigurations: Array<EntityGraphNodeConfiguration>;
  /** Whether to show age on the family tree diagram */
  showAge: Scalars['Boolean']['output'];
  /** Whether to show hidden individuals on the family tree diagram */
  showHiddenIndividuals: Scalars['Boolean']['output'];
  /** Whether to show notes for all nodes on the family tree diagram */
  showNotes: Scalars['Boolean']['output'];
  /** Whether to show state of residence on the family tree diagram */
  showStateOfResidence: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for FamilyTreeConfiguration connections */
export type FamilyTreeConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order FamilyTreeConfigurations. */
  field: FamilyTreeConfigurationOrderField;
};

/** Properties by which FamilyTreeConfiguration connections can be ordered. */
export enum FamilyTreeConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * FamilyTreeConfigurationWhereInput is used for filtering FamilyTreeConfiguration objects.
 * Input was generated by ent.
 */
export type FamilyTreeConfigurationWhereInput = {
  and?: InputMaybe<Array<FamilyTreeConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<FamilyTreeConfigurationWhereInput>;
  or?: InputMaybe<Array<FamilyTreeConfigurationWhereInput>>;
  /** show_age field predicates */
  showAge?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_hidden_individuals field predicates */
  showHiddenIndividuals?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_notes field predicates */
  showNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_state_of_residence field predicates */
  showStateOfResidence?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type FamilyTreeNodeSettings = {
  __typename?: 'FamilyTreeNodeSettings';
  /** Whether to show this individual on the tree diagram */
  showIndividualOnTree: Scalars['Boolean']['output'];
  /** Whether to show notes for this individual on the tree diagram */
  showNotesForIndividual: Scalars['Boolean']['output'];
};

export type FamilyTreePerson = {
  __typename?: 'FamilyTreePerson';
  /** The client profile for this person in the family tree */
  clientProfile: ClientProfile;
  /**
   * The generation this person belongs to relative to primary clients.
   * Primary clients = 0, parents = -1, children = 1, grandparents = -2,
   * grandchildren = 2, great-grandparents = -3, great-grandchildren = 3, etc.
   * Nephews/nieces = 1, uncles/aunts are -1, cousins/siblings/spouses = 0,
   * others = -99 (indeterminate/unspecified relationships). Supports unlimited generational depth.
   */
  generation: Scalars['Int']['output'];
  /** Unique identifier for this person in the family tree context */
  id: Scalars['ID']['output'];
  /**
   * Indicates this is a synthetic placeholder parent node created to connect
   * unlinked siblings of primary clients to the family tree.
   * UI should render these as invisible nodes (max 2 per household).
   */
  isSynthetic: Scalars['Boolean']['output'];
  /** Per-node settings for this person in the family tree diagram */
  nodeSettings: FamilyTreeNodeSettings;
};

export type FamilyTreeSettings = {
  __typename?: 'FamilyTreeSettings';
  /** Node positions and display settings for both individual nodes (client_profile_id) and marriage nodes (computed IDs like 'spouse1_spouse2' or 'single_parentid') */
  nodeConfigurations: Array<EntityGraphNodeConfiguration>;
  /** Whether to show age on the family tree diagram */
  showAge: Scalars['Boolean']['output'];
  /** Whether to show hidden individuals on the family tree diagram */
  showHiddenIndividuals: Scalars['Boolean']['output'];
  /** Whether to show notes for all nodes on the family tree diagram */
  showNotes: Scalars['Boolean']['output'];
  /** Whether to show state of residence on the family tree diagram */
  showStateOfResidence: Scalars['Boolean']['output'];
};

export type FamilyTreeWarning = {
  __typename?: 'FamilyTreeWarning';
  /** The client profile ID(s) this warning relates to */
  clientProfileIds: Array<Scalars['ID']['output']>;
  /** Unique identifier for this warning */
  id: Scalars['ID']['output'];
  /** Human-readable message describing the warning and any guidance */
  message: Scalars['String']['output'];
  /** The type of warning */
  type: FamilyTreeWarningType;
};

export enum FamilyTreeWarningType {
  /** Person appears in multiple relationships with conflicting generations */
  GenerationConflict = 'GENERATION_CONFLICT',
  /** Person has more than 2 biological parent relationships */
  MultipleBiologicalParents = 'MULTIPLE_BIOLOGICAL_PARENTS',
  /** Person has multiple current spouse/partner relationships (should only have one current spouse at a time) */
  MultipleCurrentSpouses = 'MULTIPLE_CURRENT_SPOUSES',
  /** Detected a cycle in family relationships, which is impossible in a family tree */
  RelationshipCycle = 'RELATIONSHIP_CYCLE',
  /** Person could not be connected to the family tree graph via clear relationship paths */
  UnlinkedFamilyMember = 'UNLINKED_FAMILY_MEMBER'
}

/** FeatureEnablementStatus indicates whether a feature is enabled or disabled for a tenant */
export enum FeatureEnablementStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type FeatureFlag = Node & {
  __typename?: 'FeatureFlag';
  createdAt: Scalars['Time']['output'];
  flagDescription?: Maybe<Scalars['String']['output']>;
  flagName: Scalars['String']['output'];
  flagStatus: FeatureFlagFlagStatus;
  /** Conceptual group for flag */
  group?: Maybe<FeatureFlagGroup>;
  id: Scalars['ID']['output'];
  ownedBy: Scalars['String']['output'];
  queryRules?: Maybe<Array<FeatureFlagQueryRule>>;
  /** The Luminary engineering team responsible for the feature flag */
  team?: Maybe<FeatureFlagTeam>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type FeatureFlagConnection = {
  __typename?: 'FeatureFlagConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FeatureFlagEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FeatureFlagEdge = {
  __typename?: 'FeatureFlagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FeatureFlag>;
};

/**
 * Runtime evaluation of a single feature flag for the current caller: the flag name
 * and its resolved value, nothing else. Exposes no flag metadata or targeting rules,
 * so it is safe for all authenticated users (cf. FeatureFlagEvaluationResult).
 */
export type FeatureFlagEvaluation = {
  __typename?: 'FeatureFlagEvaluation';
  name: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type FeatureFlagEvaluationResult = {
  __typename?: 'FeatureFlagEvaluationResult';
  flag: FeatureFlag;
  flagEnablementStatus: FlagEnablementStatus;
  flagEvaluationResult: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** FeatureFlagFlagStatus is enum for the field flag_status */
export enum FeatureFlagFlagStatus {
  Off = 'OFF',
  On = 'ON'
}

/** FeatureFlagGroup is enum for the field group */
export enum FeatureFlagGroup {
  ArtifactStudio = 'ARTIFACT_STUDIO',
  Cmk = 'CMK',
  Estate_360 = 'ESTATE_360',
  EstateWaterfall = 'ESTATE_WATERFALL',
  HouseholdChat = 'HOUSEHOLD_CHAT',
  Kg = 'KG',
  Smartreview = 'SMARTREVIEW',
  TrustAdmin = 'TRUST_ADMIN'
}

/** Ordering options for FeatureFlag connections */
export type FeatureFlagOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order FeatureFlags. */
  field: FeatureFlagOrderField;
};

/** Properties by which FeatureFlag connections can be ordered. */
export enum FeatureFlagOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type FeatureFlagQueryRule = Node & {
  __typename?: 'FeatureFlagQueryRule';
  createdAt: Scalars['Time']['output'];
  /** A query rule can only be associated with a single flag. */
  featureFlag: FeatureFlag;
  flagQuery: Scalars['String']['output'];
  flagVariationName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind?: Maybe<FeatureFlagQueryRuleKind>;
  /** Set when kind=RELEASE_GROUP; stable identity for upsert/delete. */
  releaseGroup?: Maybe<ReleaseGroup>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type FeatureFlagQueryRuleConnection = {
  __typename?: 'FeatureFlagQueryRuleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FeatureFlagQueryRuleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FeatureFlagQueryRuleEdge = {
  __typename?: 'FeatureFlagQueryRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FeatureFlagQueryRule>;
};

/** FeatureFlagQueryRuleKind is enum for the field kind */
export enum FeatureFlagQueryRuleKind {
  ReleaseGroup = 'RELEASE_GROUP',
  Tenant = 'TENANT',
  User = 'USER'
}

/** Ordering options for FeatureFlagQueryRule connections */
export type FeatureFlagQueryRuleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order FeatureFlagQueryRules. */
  field: FeatureFlagQueryRuleOrderField;
};

/** Properties by which FeatureFlagQueryRule connections can be ordered. */
export enum FeatureFlagQueryRuleOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * FeatureFlagQueryRuleWhereInput is used for filtering FeatureFlagQueryRule objects.
 * Input was generated by ent.
 */
export type FeatureFlagQueryRuleWhereInput = {
  and?: InputMaybe<Array<FeatureFlagQueryRuleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** flag_query field predicates */
  flagQuery?: InputMaybe<Scalars['String']['input']>;
  flagQueryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** flag_variation_name field predicates */
  flagVariationName?: InputMaybe<Scalars['String']['input']>;
  /** feature_flag edge predicates */
  hasFeatureFlag?: InputMaybe<Scalars['Boolean']['input']>;
  hasFeatureFlagWith?: InputMaybe<Array<FeatureFlagWhereInput>>;
  /** release_group edge predicates */
  hasReleaseGroup?: InputMaybe<Scalars['Boolean']['input']>;
  hasReleaseGroupWith?: InputMaybe<Array<ReleaseGroupWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<FeatureFlagQueryRuleKind>;
  kindIn?: InputMaybe<Array<FeatureFlagQueryRuleKind>>;
  kindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  kindNEQ?: InputMaybe<FeatureFlagQueryRuleKind>;
  kindNotIn?: InputMaybe<Array<FeatureFlagQueryRuleKind>>;
  kindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<FeatureFlagQueryRuleWhereInput>;
  or?: InputMaybe<Array<FeatureFlagQueryRuleWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** FeatureFlagTeam is enum for the field team */
export enum FeatureFlagTeam {
  Platform = 'PLATFORM',
  T1Tribeta = 'T1_TRIBETA',
  T2Arco = 'T2_ARCO',
  TrustAdmin = 'TRUST_ADMIN',
  WealthStrategies = 'WEALTH_STRATEGIES'
}

/** Effective enablement for one feature flag and one tenant. */
export type FeatureFlagTenantEnablement = {
  __typename?: 'FeatureFlagTenantEnablement';
  enabled: Scalars['Boolean']['output'];
  enablementStatus: FlagEnablementStatus;
  flag: FeatureFlag;
  tenant: Tenant;
};

/**
 * FeatureFlagWhereInput is used for filtering FeatureFlag objects.
 * Input was generated by ent.
 */
export type FeatureFlagWhereInput = {
  and?: InputMaybe<Array<FeatureFlagWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** flag_description field predicates */
  flagDescription?: InputMaybe<Scalars['String']['input']>;
  flagDescriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  flagDescriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** flag_name field predicates */
  flagName?: InputMaybe<Scalars['String']['input']>;
  flagNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** flag_status field predicates */
  flagStatus?: InputMaybe<FeatureFlagFlagStatus>;
  flagStatusIn?: InputMaybe<Array<FeatureFlagFlagStatus>>;
  flagStatusNEQ?: InputMaybe<FeatureFlagFlagStatus>;
  flagStatusNotIn?: InputMaybe<Array<FeatureFlagFlagStatus>>;
  /** group field predicates */
  group?: InputMaybe<FeatureFlagGroup>;
  groupIn?: InputMaybe<Array<FeatureFlagGroup>>;
  groupIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  groupNEQ?: InputMaybe<FeatureFlagGroup>;
  groupNotIn?: InputMaybe<Array<FeatureFlagGroup>>;
  groupNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** query_rules edge predicates */
  hasQueryRules?: InputMaybe<Scalars['Boolean']['input']>;
  hasQueryRulesWith?: InputMaybe<Array<FeatureFlagQueryRuleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<FeatureFlagWhereInput>;
  or?: InputMaybe<Array<FeatureFlagWhereInput>>;
  /** owned_by field predicates */
  ownedBy?: InputMaybe<Scalars['String']['input']>;
  /** team field predicates */
  team?: InputMaybe<FeatureFlagTeam>;
  teamIn?: InputMaybe<Array<FeatureFlagTeam>>;
  teamIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  teamNEQ?: InputMaybe<FeatureFlagTeam>;
  teamNotIn?: InputMaybe<Array<FeatureFlagTeam>>;
  teamNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type FederalTaxDetail = {
  __typename?: 'FederalTaxDetail';
  _cacheKey: Scalars['String']['output'];
  /** exemptionAvailable is the total available exemption before processing this tax event. */
  exemptionAvailable: Scalars['CurrencyUSD']['output'];
  /** exemptionUsed is the amount of exemption used during this tax event. */
  exemptionUsed: Scalars['CurrencyUSD']['output'];
  grossEstate: Scalars['CurrencyUSD']['output'];
  gstTaxDeductions?: Maybe<Scalars['CurrencyUSD']['output']>;
  nonTaxableTransfers: Scalars['CurrencyUSD']['output'];
  stateTaxDeductions?: Maybe<Scalars['CurrencyUSD']['output']>;
  tax: Scalars['CurrencyUSD']['output'];
  taxableAmount: Scalars['CurrencyUSD']['output'];
  /** valuationDiscount is the amount by which the taxable portion of the gross estate is reduced. */
  valuationDiscount?: Maybe<Scalars['CurrencyUSD']['output']>;
};

export type FetchHouseholdKgv2Input = {
  householdID: Scalars['ID']['input'];
};

export type FetchHouseholdKgv2NodesInput = {
  /** The household that owns the nodes. */
  householdID: Scalars['ID']['input'];
  /** The IDs of the KG V2 nodes to resolve. Max 500. */
  nodeIDs: Array<Scalars['ID']['input']>;
};

export type File = Node & {
  __typename?: 'File';
  /** The AI Suggestions for this file */
  aiSuggestions?: Maybe<Array<AiSuggestion>>;
  /** The sha256 of the file to be uploaded. We check the file integrity S3 side. */
  contentsSha256: Scalars['String']['output'];
  /** The context in which the file is meant to exist. */
  context?: Maybe<FileContext>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  document?: Maybe<Document>;
  download: FileDownload;
  /**
   * This is the time at which we first detected the file in s3.
   * 			We need to do this asynchronously since uploads go directly to s3.
   * 			Set by Temporal.
   */
  fileUploadedAt?: Maybe<Scalars['Time']['output']>;
  household?: Maybe<Household>;
  /** the household this object belongs to */
  householdID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  inferredFields?: Maybe<Array<InferredField>>;
  ingestionKind: FileIngestionKind;
  kgNodes: KgNodeConnection;
  /** The KGRoots that the knowledge graph nodes of this file are included in. This is mainly used to track when the construction of the KGRoot is complete; when the nodes of all files are merged into the root. */
  kgRoots?: Maybe<Array<KgRoot>>;
  pages?: Maybe<Array<FilePage>>;
  pdfDocument?: Maybe<Document>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type FileKgNodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KgNodeOrder>>;
  where?: InputMaybe<KgNodeWhereInput>;
};

/** A connection to a list of items. */
export type FileConnection = {
  __typename?: 'FileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FileEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** FileContext is enum for the field context */
export enum FileContext {
  Household = 'HOUSEHOLD',
  Logo = 'LOGO',
  Platform = 'PLATFORM',
  Tenant = 'TENANT'
}

export type FileDownload = {
  __typename?: 'FileDownload';
  downloadURL: Scalars['String']['output'];
  downloadURLExpiresInSeconds: Scalars['Int']['output'];
};

/**
 * FileDownloadToken is a signed token for authenticating the file download request.
 * The token can be used with the /api/download/file endpoint.
 */
export type FileDownloadToken = {
  __typename?: 'FileDownloadToken';
  /** Token expiration time in seconds */
  expiresInSeconds: Scalars['Int']['output'];
  /** Signed token for authenticating the download request */
  token: Scalars['String']['output'];
};

/** An edge in a connection. */
export type FileEdge = {
  __typename?: 'FileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<File>;
};

/** FileIngestionKind is enum for the field ingestion_kind */
export enum FileIngestionKind {
  Generated = 'GENERATED',
  Uploaded = 'UPLOADED'
}

/** Ordering options for File connections */
export type FileOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Files. */
  field: FileOrderField;
};

/** Properties by which File connections can be ordered. */
export enum FileOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type FilePage = Node & {
  __typename?: 'FilePage';
  /** The angle of the page. This helps establish an orientation. */
  angle?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The corresponding file for this page metadata */
  file?: Maybe<File>;
  /** The height of the page. */
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** The page number of the file. 1-indexed. */
  pageNumber: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The unit of measurement for the page. Typically 'inch'. */
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  /** The width of the page. */
  width?: Maybe<Scalars['Float']['output']>;
};

/** A connection to a list of items. */
export type FilePageConnection = {
  __typename?: 'FilePageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FilePageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FilePageEdge = {
  __typename?: 'FilePageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FilePage>;
};

/** Ordering options for FilePage connections */
export type FilePageOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order FilePages. */
  field: FilePageOrderField;
};

/** Properties by which FilePage connections can be ordered. */
export enum FilePageOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * FilePageWhereInput is used for filtering FilePage objects.
 * Input was generated by ent.
 */
export type FilePageWhereInput = {
  and?: InputMaybe<Array<FilePageWhereInput>>;
  /** angle field predicates */
  angle?: InputMaybe<Scalars['Float']['input']>;
  angleGT?: InputMaybe<Scalars['Float']['input']>;
  angleGTE?: InputMaybe<Scalars['Float']['input']>;
  angleIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  angleLT?: InputMaybe<Scalars['Float']['input']>;
  angleLTE?: InputMaybe<Scalars['Float']['input']>;
  angleNEQ?: InputMaybe<Scalars['Float']['input']>;
  angleNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** height field predicates */
  height?: InputMaybe<Scalars['Float']['input']>;
  heightGT?: InputMaybe<Scalars['Float']['input']>;
  heightGTE?: InputMaybe<Scalars['Float']['input']>;
  heightIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  heightLT?: InputMaybe<Scalars['Float']['input']>;
  heightLTE?: InputMaybe<Scalars['Float']['input']>;
  heightNEQ?: InputMaybe<Scalars['Float']['input']>;
  heightNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<FilePageWhereInput>;
  or?: InputMaybe<Array<FilePageWhereInput>>;
  /** page_number field predicates */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageNumberGT?: InputMaybe<Scalars['Int']['input']>;
  pageNumberGTE?: InputMaybe<Scalars['Int']['input']>;
  pageNumberLT?: InputMaybe<Scalars['Int']['input']>;
  pageNumberLTE?: InputMaybe<Scalars['Int']['input']>;
  pageNumberNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** unit field predicates */
  unit?: InputMaybe<Scalars['String']['input']>;
  unitIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  unitNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** width field predicates */
  width?: InputMaybe<Scalars['Float']['input']>;
  widthGT?: InputMaybe<Scalars['Float']['input']>;
  widthGTE?: InputMaybe<Scalars['Float']['input']>;
  widthIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  widthLT?: InputMaybe<Scalars['Float']['input']>;
  widthLTE?: InputMaybe<Scalars['Float']['input']>;
  widthNEQ?: InputMaybe<Scalars['Float']['input']>;
  widthNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileParagraph = Node & {
  __typename?: 'FileParagraph';
  /** AISuggestionEvidence rows that cite this paragraph */
  aiSuggestionEvidence?: Maybe<Array<AiSuggestionEvidence>>;
  /** Form answer evidence that cites this paragraph */
  answerEvidence?: Maybe<Array<AnswerEvidence>>;
  /** the bounding regions correspondign to this paragraph. */
  boundingRegions: Array<BoundingRegion>;
  /** the content of the paragraph */
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The references that are supported by this paragraph */
  estateInsightReferences?: Maybe<Array<EstateInsightReference>>;
  /** The corresponding file for this paragraph metadata */
  file?: Maybe<File>;
  household?: Maybe<Household>;
  /** the household this object belongs to */
  householdID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** the implied paragraph number in the file. this is implied from the list of paragraphs as retured from Azure Form Recognizer */
  impliedParagraphNumber: Scalars['Int']['output'];
  /** The evidence that is supported by this paragraph */
  kgStatementEvidence?: Maybe<Array<Kgv2StatementEvidence>>;
  /** Messages that reference this paragraph */
  messages?: Maybe<Array<Message>>;
  /**
   * Saved Azure Layout role, spans, and outermost-first section path. null for
   * paragraphs created without Layout extraction. Empty paths mean no detected
   * section membership, not a guessed legal provision.
   */
  ocrStructure?: Maybe<OcrParagraphStructure>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type FileParagraphConnection = {
  __typename?: 'FileParagraphConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FileParagraphEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FileParagraphEdge = {
  __typename?: 'FileParagraphEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FileParagraph>;
};

/** Ordering options for FileParagraph connections */
export type FileParagraphOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order FileParagraphs. */
  field: FileParagraphOrderField;
};

/** Properties by which FileParagraph connections can be ordered. */
export enum FileParagraphOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type FileUpload = {
  __typename?: 'FileUpload';
  file: File;
  uploadMethod: Scalars['String']['output'];
  uploadURL: Scalars['String']['output'];
  uploadURLExpiresInSeconds: Scalars['Int']['output'];
};

/**
 * FileWhereInput is used for filtering File objects.
 * Input was generated by ent.
 */
export type FileWhereInput = {
  and?: InputMaybe<Array<FileWhereInput>>;
  /** contents_sha256 field predicates */
  contentsSha256?: InputMaybe<Scalars['String']['input']>;
  /** context field predicates */
  context?: InputMaybe<FileContext>;
  contextIn?: InputMaybe<Array<FileContext>>;
  contextIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  contextNEQ?: InputMaybe<FileContext>;
  contextNotIn?: InputMaybe<Array<FileContext>>;
  contextNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** file_uploaded_at field predicates */
  fileUploadedAt?: InputMaybe<Scalars['Time']['input']>;
  fileUploadedAtGT?: InputMaybe<Scalars['Time']['input']>;
  fileUploadedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  fileUploadedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fileUploadedAtLT?: InputMaybe<Scalars['Time']['input']>;
  fileUploadedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  fileUploadedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ai_suggestions edge predicates */
  hasAiSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  hasAiSuggestionsWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** inferred_fields edge predicates */
  hasInferredFields?: InputMaybe<Scalars['Boolean']['input']>;
  hasInferredFieldsWith?: InputMaybe<Array<InferredFieldWhereInput>>;
  /** kg_nodes edge predicates */
  hasKgNodes?: InputMaybe<Scalars['Boolean']['input']>;
  hasKgNodesWith?: InputMaybe<Array<KgNodeWhereInput>>;
  /** kg_roots edge predicates */
  hasKgRoots?: InputMaybe<Scalars['Boolean']['input']>;
  hasKgRootsWith?: InputMaybe<Array<KgRootWhereInput>>;
  /** pages edge predicates */
  hasPages?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagesWith?: InputMaybe<Array<FilePageWhereInput>>;
  /** pdf_document edge predicates */
  hasPdfDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasPdfDocumentWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ingestion_kind field predicates */
  ingestionKind?: InputMaybe<FileIngestionKind>;
  ingestionKindIn?: InputMaybe<Array<FileIngestionKind>>;
  ingestionKindNEQ?: InputMaybe<FileIngestionKind>;
  ingestionKindNotIn?: InputMaybe<Array<FileIngestionKind>>;
  not?: InputMaybe<FileWhereInput>;
  or?: InputMaybe<Array<FileWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export enum FlagEnablementStatus {
  ClearReleaseGroup = 'CLEAR_RELEASE_GROUP',
  ClearTenant = 'CLEAR_TENANT',
  Off = 'OFF',
  OffForReleaseGroup = 'OFF_FOR_RELEASE_GROUP',
  OffForTenant = 'OFF_FOR_TENANT',
  OnForEnv = 'ON_FOR_ENV',
  OnForReleaseGroup = 'ON_FOR_RELEASE_GROUP',
  OnForTenant = 'ON_FOR_TENANT'
}

export type Form = Node & {
  __typename?: 'Form';
  /** When this form was archived */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The user who archived this form */
  archivedBy?: Maybe<User>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The version new submissions pin to */
  currentPublishedVersion?: Maybe<FormVersion>;
  /** Description of the form */
  description: Scalars['String']['output'];
  /** Mutable working copy of the form configuration */
  draftConfig: Scalars['Map']['output'];
  /** Version of the draft configuration format */
  draftSchemaVersion: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Display name for the form */
  name: Scalars['String']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
  versions: FormVersionConnection;
};


export type FormVersionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FormVersionOrder>>;
  where?: InputMaybe<FormVersionWhereInput>;
};

export type FormAnswerArrayItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  value: FormAnswerValueInput;
};

export type FormAnswerNode = {
  __typename?: 'FormAnswerNode';
  dateValue?: Maybe<Scalars['String']['output']>;
  isNull: Scalars['Boolean']['output'];
  itemIDs?: Maybe<Array<Scalars['ID']['output']>>;
  kind: FormAnswerNodeKind;
  multiSelectValue?: Maybe<Array<Scalars['String']['output']>>;
  numberValue?: Maybe<Scalars['Decimal']['output']>;
  singleSelectValue?: Maybe<Scalars['String']['output']>;
  target: FormAnswerTarget;
  textValue?: Maybe<Scalars['String']['output']>;
};

export enum FormAnswerNodeKind {
  Array = 'ARRAY',
  Date = 'DATE',
  LongText = 'LONG_TEXT',
  MultiSelect = 'MULTI_SELECT',
  Number = 'NUMBER',
  Object = 'OBJECT',
  ShortText = 'SHORT_TEXT',
  SingleSelect = 'SINGLE_SELECT'
}

export type FormAnswerPropertyInput = {
  schemaNodeID: Scalars['String']['input'];
  value: FormAnswerValueInput;
};

export type FormAnswerTarget = {
  __typename?: 'FormAnswerTarget';
  arrayItemID?: Maybe<Scalars['String']['output']>;
  schemaNodeID: Scalars['String']['output'];
};

export type FormAnswerTargetInput = {
  arrayItemID?: InputMaybe<Scalars['String']['input']>;
  schemaNodeID: Scalars['String']['input'];
};

export type FormAnswerTree = {
  __typename?: 'FormAnswerTree';
  assessments: Array<FormNodeAssessment>;
  nodes: Array<FormAnswerNode>;
};

export type FormAnswerValueInput = {
  dateValue?: InputMaybe<Scalars['String']['input']>;
  isNull: Scalars['Boolean']['input'];
  items?: InputMaybe<Array<FormAnswerArrayItemInput>>;
  multiSelectValue?: InputMaybe<Array<Scalars['String']['input']>>;
  numberValue?: InputMaybe<Scalars['Decimal']['input']>;
  properties?: InputMaybe<Array<FormAnswerPropertyInput>>;
  singleSelectValue?: InputMaybe<Scalars['String']['input']>;
  textValue?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of items. */
export type FormConnection = {
  __typename?: 'FormConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FormEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Platform-owned V1 draft import documentation. Semantic rules are checked by normalization. */
export type FormDraftImportContract = {
  __typename?: 'FormDraftImportContract';
  jsonSchema: Scalars['String']['output'];
  sampleJson: Scalars['String']['output'];
  schemaVersion: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FormEdge = {
  __typename?: 'FormEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Form>;
};

export type FormNodeAssessment = {
  __typename?: 'FormNodeAssessment';
  aiRevisionID: Scalars['ID']['output'];
  reasoning: Scalars['String']['output'];
  status: FormNodeAssessmentStatus;
  target: FormAnswerTarget;
};

export enum FormNodeAssessmentStatus {
  Empty = 'EMPTY',
  High = 'HIGH',
  Medium = 'MEDIUM',
  NotFound = 'NOT_FOUND'
}

/** Ordering options for Form connections */
export type FormOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Forms. */
  field: FormOrderField;
};

/** Properties by which Form connections can be ordered. */
export enum FormOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type FormSubmissionAnswerConflict = {
  __typename?: 'FormSubmissionAnswerConflict';
  actualLockVersion: Scalars['Int']['output'];
  currentAnswer?: Maybe<Answer>;
  expectedLockVersion: Scalars['Int']['output'];
};

export type FormSubmissionAnswerMutationPayload = {
  __typename?: 'FormSubmissionAnswerMutationPayload';
  answer?: Maybe<Answer>;
  conflict?: Maybe<FormSubmissionAnswerConflict>;
};

export type FormSubmissionDiagnosticAttempt = {
  __typename?: 'FormSubmissionDiagnosticAttempt';
  endedAt?: Maybe<Scalars['Time']['output']>;
  startedAt: Scalars['Time']['output'];
  status: WorkflowTrackerStatus;
  temporalID: Scalars['String']['output'];
  temporalRunID: Scalars['String']['output'];
  workflowTrackerID: Scalars['ID']['output'];
};

export type FormSubmissionDiagnostics = {
  __typename?: 'FormSubmissionDiagnostics';
  attempts: Array<FormSubmissionDiagnosticAttempt>;
  submissionID: Scalars['ID']['output'];
};

export type FormTestCaseInput = {
  householdID: Scalars['ID']['input'];
  sourceDocumentIDs: Array<Scalars['ID']['input']>;
};

export type FormVersion = Node & {
  __typename?: 'FormVersion';
  /** The snapshotted form configuration, including author-written extraction prompts */
  config: Scalars['Map']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The form this version was published from */
  form: Form;
  id: Scalars['ID']['output'];
  /** Whether this snapshot is published or used only for extraction tests */
  kind: FormVersionKind;
  /** Version of the schema format, not of this form. Readers must support every value ever published */
  schemaVersion: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  /** Monotonic per-form version number, starting at 1 */
  version: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type FormVersionConnection = {
  __typename?: 'FormVersionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FormVersionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FormVersionEdge = {
  __typename?: 'FormVersionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FormVersion>;
};

/** FormVersionKind is enum for the field kind */
export enum FormVersionKind {
  Published = 'PUBLISHED',
  Test = 'TEST'
}

/** Ordering options for FormVersion connections */
export type FormVersionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order FormVersions. */
  field: FormVersionOrderField;
};

/** Properties by which FormVersion connections can be ordered. */
export enum FormVersionOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * FormVersionWhereInput is used for filtering FormVersion objects.
 * Input was generated by ent.
 */
export type FormVersionWhereInput = {
  and?: InputMaybe<Array<FormVersionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** form edge predicates */
  hasForm?: InputMaybe<Scalars['Boolean']['input']>;
  hasFormWith?: InputMaybe<Array<FormWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<FormVersionKind>;
  kindIn?: InputMaybe<Array<FormVersionKind>>;
  kindNEQ?: InputMaybe<FormVersionKind>;
  kindNotIn?: InputMaybe<Array<FormVersionKind>>;
  not?: InputMaybe<FormVersionWhereInput>;
  or?: InputMaybe<Array<FormVersionWhereInput>>;
  /** schema_version field predicates */
  schemaVersion?: InputMaybe<Scalars['Int']['input']>;
  schemaVersionGT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersionGTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersionLT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersionLTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersionNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** version field predicates */
  version?: InputMaybe<Scalars['Int']['input']>;
  versionGT?: InputMaybe<Scalars['Int']['input']>;
  versionGTE?: InputMaybe<Scalars['Int']['input']>;
  versionLT?: InputMaybe<Scalars['Int']['input']>;
  versionLTE?: InputMaybe<Scalars['Int']['input']>;
  versionNEQ?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * FormWhereInput is used for filtering Form objects.
 * Input was generated by ent.
 */
export type FormWhereInput = {
  and?: InputMaybe<Array<FormWhereInput>>;
  /** archived_at field predicates */
  archivedAt?: InputMaybe<Scalars['Time']['input']>;
  archivedAtGT?: InputMaybe<Scalars['Time']['input']>;
  archivedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  archivedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  archivedAtLT?: InputMaybe<Scalars['Time']['input']>;
  archivedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  archivedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  /** draft_schema_version field predicates */
  draftSchemaVersion?: InputMaybe<Scalars['Int']['input']>;
  draftSchemaVersionGT?: InputMaybe<Scalars['Int']['input']>;
  draftSchemaVersionGTE?: InputMaybe<Scalars['Int']['input']>;
  draftSchemaVersionLT?: InputMaybe<Scalars['Int']['input']>;
  draftSchemaVersionLTE?: InputMaybe<Scalars['Int']['input']>;
  draftSchemaVersionNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** archived_by edge predicates */
  hasArchivedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasArchivedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** current_published_version edge predicates */
  hasCurrentPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  hasCurrentPublishedVersionWith?: InputMaybe<Array<FormVersionWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** versions edge predicates */
  hasVersions?: InputMaybe<Scalars['Boolean']['input']>;
  hasVersionsWith?: InputMaybe<Array<FormVersionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<FormWhereInput>;
  or?: InputMaybe<Array<FormWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Typed content of a FREE_FORM_QUESTION_MESSAGE. The question is stored
 * CMK-encrypted and decrypted by the Message.freeFormQuestionContent resolver.
 */
export type FreeFormQuestionMessageContent = {
  __typename?: 'FreeFormQuestionMessageContent';
  /**
   * Optional supporting context shown under the title; empty when the question
   * declares none.
   */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The single focused question shown to the user. */
  title: Scalars['String']['output'];
};

export type GpBusinessEntity = BusinessEntity & EntitySubtype & Named & Node & {
  __typename?: 'GPBusinessEntity';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this business entity */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in trusts that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: Maybe<Scalars['String']['output']>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: Maybe<Scalars['Boolean']['output']>;
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: Maybe<Scalars['String']['output']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  grantorControlledDiscountedValue: Scalars['CurrencyUSD']['output'];
  grantorControlledPercentage: Scalars['Percent']['output'];
  grantorControlledValue: Scalars['CurrencyUSD']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  keyPeople?: Maybe<Array<KeyPerson>>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: Maybe<Scalars['String']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  nongrantorControlledPercentage: Scalars['Percent']['output'];
  nongrantorControlledValue: Scalars['CurrencyUSD']['output'];
  /** Ownership as-of date. */
  ownershipAsOfDate?: Maybe<Scalars['Time']['output']>;
  policies?: Maybe<Array<InsurancePolicy>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: Maybe<Scalars['Boolean']['output']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxID?: Maybe<Scalars['String']['output']>;
  taxStatus?: Maybe<BusinessEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type GpBusinessEntityHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type GpBusinessEntityConnection = {
  __typename?: 'GPBusinessEntityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GpBusinessEntityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GpBusinessEntityEdge = {
  __typename?: 'GPBusinessEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GpBusinessEntity>;
};

/** Ordering options for GPBusinessEntity connections */
export type GpBusinessEntityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GPBusinessEntities. */
  field: GpBusinessEntityOrderField;
};

/** Properties by which GPBusinessEntity connections can be ordered. */
export enum GpBusinessEntityOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * GPBusinessEntityWhereInput is used for filtering GPBusinessEntity objects.
 * Input was generated by ent.
 */
export type GpBusinessEntityWhereInput = {
  and?: InputMaybe<Array<GpBusinessEntityWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** doing_business_as_name field predicates */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  doingBusinessAsNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  doingBusinessAsNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable_real_tpp_tax_exposure field predicates */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  enableRealTppTaxExposureIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  enableRealTppTaxExposureNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** fin_cen_id field predicates */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  finCenIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  finCenIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** formation_jurisdiction_state_code field predicates */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  formationJurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  formationJurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** key_people edge predicates */
  hasKeyPeople?: InputMaybe<Scalars['Boolean']['input']>;
  hasKeyPeopleWith?: InputMaybe<Array<KeyPersonWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key_people_notes field predicates */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  keyPeopleNotesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  keyPeopleNotesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<GpBusinessEntityWhereInput>;
  or?: InputMaybe<Array<GpBusinessEntityWhereInput>>;
  /** ownership_as_of_date field predicates */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateGT?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateGTE?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownershipAsOfDateLT?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateLTE?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** requires_cta_reporting field predicates */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCtaReportingIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCtaReportingNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_id field predicates */
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<BusinessEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<BusinessEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<BusinessEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type GratAnnuityV2 = Node & {
  __typename?: 'GRATAnnuityV2';
  actualPaymentAmount: Scalars['CurrencyUSD']['output'];
  /** the asset valuation that was created as a result of this annuity payment */
  associatedAssetValuation?: Maybe<AssetValuationV2>;
  associatedTask?: Maybe<EntityTask>;
  /** @deprecated Use initialFundingValuePercentage instead */
  computedInitialFundingValuePercentage: Scalars['Percent']['output'];
  computedPaymentAmount: Scalars['CurrencyUSD']['output'];
  createdAt: Scalars['Time']['output'];
  /** if the annuity payment failed, this is the amount that was actually paid */
  failedAnnuityPaymentAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  gratTrust?: Maybe<GratTrust>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** the percent of the initial funding value due to be paid with this annuity */
  initialFundingValuePercent: Scalars['Percent']['output'];
  /** the date the annuity was paid on */
  paidOn?: Maybe<Scalars['Time']['output']>;
  paymentWindowEndDate: Scalars['Time']['output'];
  paymentWindowStartDate: Scalars['Time']['output'];
  previousValuation: AssetValuationV2;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** the term duration of the GRAT that this annuity is associated with */
  termDurationYears: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
  /** which 1-indexed annuity payment this represents; if a 2, represents the second annuity payment */
  yearOfTerm: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type GratAnnuityV2Connection = {
  __typename?: 'GRATAnnuityV2Connection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GratAnnuityV2Edge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GratAnnuityV2Edge = {
  __typename?: 'GRATAnnuityV2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GratAnnuityV2>;
};

/** Ordering options for GRATAnnuityV2 connections */
export type GratAnnuityV2Order = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GRATAnnuityV2s. */
  field: GratAnnuityV2OrderField;
};

/** Properties by which GRATAnnuityV2 connections can be ordered. */
export enum GratAnnuityV2OrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * GRATAnnuityV2WhereInput is used for filtering GRATAnnuityV2 objects.
 * Input was generated by ent.
 */
export type GratAnnuityV2WhereInput = {
  and?: InputMaybe<Array<GratAnnuityV2WhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** failed_annuity_payment_amount field predicates */
  failedAnnuityPaymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  failedAnnuityPaymentAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  failedAnnuityPaymentAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  failedAnnuityPaymentAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  failedAnnuityPaymentAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  failedAnnuityPaymentAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  failedAnnuityPaymentAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  failedAnnuityPaymentAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** associated_asset_valuation edge predicates */
  hasAssociatedAssetValuation?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssociatedAssetValuationWith?: InputMaybe<Array<AssetValuationV2WhereInput>>;
  /** associated_task edge predicates */
  hasAssociatedTask?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssociatedTaskWith?: InputMaybe<Array<EntityTaskWhereInput>>;
  /** grat_trust edge predicates */
  hasGratTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasGratTrustWith?: InputMaybe<Array<GratTrustWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** initial_funding_value_percent field predicates */
  initialFundingValuePercent?: InputMaybe<Scalars['Percent']['input']>;
  initialFundingValuePercentGT?: InputMaybe<Scalars['Percent']['input']>;
  initialFundingValuePercentGTE?: InputMaybe<Scalars['Percent']['input']>;
  initialFundingValuePercentLT?: InputMaybe<Scalars['Percent']['input']>;
  initialFundingValuePercentLTE?: InputMaybe<Scalars['Percent']['input']>;
  initialFundingValuePercentNEQ?: InputMaybe<Scalars['Percent']['input']>;
  not?: InputMaybe<GratAnnuityV2WhereInput>;
  or?: InputMaybe<Array<GratAnnuityV2WhereInput>>;
  /** paid_on field predicates */
  paidOn?: InputMaybe<Scalars['Time']['input']>;
  paidOnGT?: InputMaybe<Scalars['Time']['input']>;
  paidOnGTE?: InputMaybe<Scalars['Time']['input']>;
  paidOnIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  paidOnLT?: InputMaybe<Scalars['Time']['input']>;
  paidOnLTE?: InputMaybe<Scalars['Time']['input']>;
  paidOnNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** term_duration_years field predicates */
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsGT?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsGTE?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsLT?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsLTE?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** year_of_term field predicates */
  yearOfTerm?: InputMaybe<Scalars['Int']['input']>;
  yearOfTermGT?: InputMaybe<Scalars['Int']['input']>;
  yearOfTermGTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfTermLT?: InputMaybe<Scalars['Int']['input']>;
  yearOfTermLTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfTermNEQ?: InputMaybe<Scalars['Int']['input']>;
};

export type GratDesignSummaryDetails = {
  __typename?: 'GRATDesignSummaryDetails';
  annuityPaymentAnnualIncreasePercentage: Scalars['String']['output'];
  annuityPayments: Array<SummaryAnnuityPaymentDetails>;
  assets: Array<SummaryAsset>;
  attorneyNotes?: Maybe<Scalars['String']['output']>;
  beneficiaries: Array<SummaryBeneficiaryv2>;
  displayName: Scalars['String']['output'];
  grantor: SummaryPerson;
  grantorRetainedInterest: Scalars['String']['output'];
  initialFundingValue: Scalars['String']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  officialInterestRate: Scalars['String']['output'];
  spouseDisplayName?: Maybe<Scalars['String']['output']>;
  successorTrustees: Array<SummaryPerson>;
  taxableGiftAmount: Scalars['String']['output'];
  termDescription: Scalars['String']['output'];
  termDetailsInfo: TermDetailsInfo;
  trustAdvisors: Array<SummaryPerson>;
  trustSitus?: Maybe<Scalars['String']['output']>;
  trustees: Array<SummaryPerson>;
};

export type GratProposalScenario = Node & {
  __typename?: 'GRATProposalScenario';
  createdAt: Scalars['Time']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  inTermCAGRV2: Scalars['Percent']['output'];
  inTermValuationType?: Maybe<GratProposalScenarioInTermValuationType>;
  /** the percent value for projected return after the lifetime of the GRAT */
  projectedAnnualReturnAfterTerm?: Maybe<Scalars['Percent']['output']>;
  /** the percent value for projected return during the lifetime of the GRAT */
  projectedAnnualReturnThroughTerm?: Maybe<Scalars['Percent']['output']>;
  projectedMarketValueAtTerm?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** the default selected time period for this projection */
  projectionTimePeriodYears: Scalars['Int']['output'];
  proposalScenario: ProposalScenario;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type GratProposalScenarioConnection = {
  __typename?: 'GRATProposalScenarioConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GratProposalScenarioEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GratProposalScenarioEdge = {
  __typename?: 'GRATProposalScenarioEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GratProposalScenario>;
};

/** GRATProposalScenarioInTermValuationType is enum for the field in_term_valuation_type */
export enum GratProposalScenarioInTermValuationType {
  EndTermValue = 'end_term_value',
  PercentRateOfReturn = 'percent_rate_of_return'
}

/** Ordering options for GRATProposalScenario connections */
export type GratProposalScenarioOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GRATProposalScenarios. */
  field: GratProposalScenarioOrderField;
};

/** Properties by which GRATProposalScenario connections can be ordered. */
export enum GratProposalScenarioOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * GRATProposalScenarioWhereInput is used for filtering GRATProposalScenario objects.
 * Input was generated by ent.
 */
export type GratProposalScenarioWhereInput = {
  and?: InputMaybe<Array<GratProposalScenarioWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** proposal_scenario edge predicates */
  hasProposalScenario?: InputMaybe<Scalars['Boolean']['input']>;
  hasProposalScenarioWith?: InputMaybe<Array<ProposalScenarioWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_term_valuation_type field predicates */
  inTermValuationType?: InputMaybe<GratProposalScenarioInTermValuationType>;
  inTermValuationTypeIn?: InputMaybe<Array<GratProposalScenarioInTermValuationType>>;
  inTermValuationTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inTermValuationTypeNEQ?: InputMaybe<GratProposalScenarioInTermValuationType>;
  inTermValuationTypeNotIn?: InputMaybe<Array<GratProposalScenarioInTermValuationType>>;
  inTermValuationTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<GratProposalScenarioWhereInput>;
  or?: InputMaybe<Array<GratProposalScenarioWhereInput>>;
  /** projected_annual_return_after_term field predicates */
  projectedAnnualReturnAfterTerm?: InputMaybe<Scalars['Percent']['input']>;
  projectedAnnualReturnAfterTermGT?: InputMaybe<Scalars['Percent']['input']>;
  projectedAnnualReturnAfterTermGTE?: InputMaybe<Scalars['Percent']['input']>;
  projectedAnnualReturnAfterTermIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectedAnnualReturnAfterTermLT?: InputMaybe<Scalars['Percent']['input']>;
  projectedAnnualReturnAfterTermLTE?: InputMaybe<Scalars['Percent']['input']>;
  projectedAnnualReturnAfterTermNEQ?: InputMaybe<Scalars['Percent']['input']>;
  projectedAnnualReturnAfterTermNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** projected_annual_return_through_term field predicates */
  projectedAnnualReturnThroughTerm?: InputMaybe<Scalars['Percent']['input']>;
  projectedAnnualReturnThroughTermGT?: InputMaybe<Scalars['Percent']['input']>;
  projectedAnnualReturnThroughTermGTE?: InputMaybe<Scalars['Percent']['input']>;
  projectedAnnualReturnThroughTermIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectedAnnualReturnThroughTermLT?: InputMaybe<Scalars['Percent']['input']>;
  projectedAnnualReturnThroughTermLTE?: InputMaybe<Scalars['Percent']['input']>;
  projectedAnnualReturnThroughTermNEQ?: InputMaybe<Scalars['Percent']['input']>;
  projectedAnnualReturnThroughTermNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** projected_market_value_at_term field predicates */
  projectedMarketValueAtTerm?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedMarketValueAtTermGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedMarketValueAtTermGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedMarketValueAtTermIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectedMarketValueAtTermLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedMarketValueAtTermLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedMarketValueAtTermNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedMarketValueAtTermNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** projection_time_period_years field predicates */
  projectionTimePeriodYears?: InputMaybe<Scalars['Int']['input']>;
  projectionTimePeriodYearsGT?: InputMaybe<Scalars['Int']['input']>;
  projectionTimePeriodYearsGTE?: InputMaybe<Scalars['Int']['input']>;
  projectionTimePeriodYearsLT?: InputMaybe<Scalars['Int']['input']>;
  projectionTimePeriodYearsLTE?: InputMaybe<Scalars['Int']['input']>;
  projectionTimePeriodYearsNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type GratTrust = EntitySubtype & Named & Node & Trust & {
  __typename?: 'GRATTrust';
  accounts?: Maybe<Array<Account>>;
  /** the annuities that are associated with this GRAT strategy instance */
  annuities?: Maybe<Array<GratAnnuityV2>>;
  /** the percent by which the annuity should increase each year in a variable annuity amount scenario */
  annuityAnnualIncreasePercent?: Maybe<Scalars['Percent']['output']>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  beneficiaries?: Maybe<Array<Beneficiary>>;
  completionDate?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this trust */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in trusts that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** the assets remaining in the GRAT that were distributed to the beneficiaries */
  distributionAssetValuation?: Maybe<AssetValuationV2>;
  /** the date that the trust remainder was distributed */
  distributionDate?: Maybe<Scalars['Time']['output']>;
  downsideThresholdPercent?: Maybe<Scalars['Percent']['output']>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  grantor?: Maybe<Principal>;
  grantorRetainedInterest: Scalars['CurrencyUSD']['output'];
  gratSummaryDisplay?: Maybe<Scalars['String']['output']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  /** notes from the advisor team to the implementing attorney */
  implementationNotesToAttorney?: Maybe<Scalars['String']['output']>;
  impliedEstateTaxSavings: Scalars['CurrencyUSD']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  initialFundingValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  officialInterestRatePercent?: Maybe<Scalars['Percent']['output']>;
  performanceReport: TrustPerformanceReport;
  projectedMarketValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  projectedRateOfReturn?: Maybe<Scalars['Percent']['output']>;
  projectedSharePrice?: Maybe<Scalars['CurrencyUSD']['output']>;
  rollingPeriodYears?: Maybe<Scalars['Int']['output']>;
  stateInEstateStatus: EntityInEstateStatus;
  successorTrustees?: Maybe<Array<Trustee>>;
  /** taxable gift that the advisor is trying to achieve; should be used as an input for annuities calcs */
  targetTaxableGift?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<TrustTaxStatus>;
  /** The actual taxable gift that was recorded for this GRAT */
  taxableGift?: Maybe<Scalars['CurrencyUSD']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  termDurationYears?: Maybe<Scalars['Int']['output']>;
  termEndDate?: Maybe<Scalars['Time']['output']>;
  trustAdvisors?: Maybe<Array<TrustAdvisor>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  trustees?: Maybe<Array<Trustee>>;
  updatedAt: Scalars['Time']['output'];
  /** If true, the upside threshold value is used for the GRAT substitution threshold instead of the upside threshold percent. */
  upsideAsTargetSurplus: Scalars['Boolean']['output'];
  upsideThresholdPercent?: Maybe<Scalars['Percent']['output']>;
  upsideThresholdValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  user: User;
};


export type GratTrustHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type GratTrustConnection = {
  __typename?: 'GRATTrustConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GratTrustEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GratTrustEdge = {
  __typename?: 'GRATTrustEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GratTrust>;
};

/** Ordering options for GRATTrust connections */
export type GratTrustOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GRATTrusts. */
  field: GratTrustOrderField;
};

/** Properties by which GRATTrust connections can be ordered. */
export enum GratTrustOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * GRATTrustWhereInput is used for filtering GRATTrust objects.
 * Input was generated by ent.
 */
export type GratTrustWhereInput = {
  and?: InputMaybe<Array<GratTrustWhereInput>>;
  /** annuity_annual_increase_percent field predicates */
  annuityAnnualIncreasePercent?: InputMaybe<Scalars['Percent']['input']>;
  annuityAnnualIncreasePercentGT?: InputMaybe<Scalars['Percent']['input']>;
  annuityAnnualIncreasePercentGTE?: InputMaybe<Scalars['Percent']['input']>;
  annuityAnnualIncreasePercentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  annuityAnnualIncreasePercentLT?: InputMaybe<Scalars['Percent']['input']>;
  annuityAnnualIncreasePercentLTE?: InputMaybe<Scalars['Percent']['input']>;
  annuityAnnualIncreasePercentNEQ?: InputMaybe<Scalars['Percent']['input']>;
  annuityAnnualIncreasePercentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** distribution_date field predicates */
  distributionDate?: InputMaybe<Scalars['Time']['input']>;
  distributionDateGT?: InputMaybe<Scalars['Time']['input']>;
  distributionDateGTE?: InputMaybe<Scalars['Time']['input']>;
  distributionDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  distributionDateLT?: InputMaybe<Scalars['Time']['input']>;
  distributionDateLTE?: InputMaybe<Scalars['Time']['input']>;
  distributionDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** downside_threshold_percent field predicates */
  downsideThresholdPercent?: InputMaybe<Scalars['Percent']['input']>;
  downsideThresholdPercentGT?: InputMaybe<Scalars['Percent']['input']>;
  downsideThresholdPercentGTE?: InputMaybe<Scalars['Percent']['input']>;
  downsideThresholdPercentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  downsideThresholdPercentLT?: InputMaybe<Scalars['Percent']['input']>;
  downsideThresholdPercentLTE?: InputMaybe<Scalars['Percent']['input']>;
  downsideThresholdPercentNEQ?: InputMaybe<Scalars['Percent']['input']>;
  downsideThresholdPercentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** annuities edge predicates */
  hasAnnuities?: InputMaybe<Scalars['Boolean']['input']>;
  hasAnnuitiesWith?: InputMaybe<Array<GratAnnuityV2WhereInput>>;
  /** beneficiaries edge predicates */
  hasBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** distribution_asset_valuation edge predicates */
  hasDistributionAssetValuation?: InputMaybe<Scalars['Boolean']['input']>;
  hasDistributionAssetValuationWith?: InputMaybe<Array<AssetValuationV2WhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** grantor edge predicates */
  hasGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrantorWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** successor_trustees edge predicates */
  hasSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuccessorTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** trust_advisors edge predicates */
  hasTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrustAdvisorsWith?: InputMaybe<Array<TrustAdvisorWhereInput>>;
  /** trustees edge predicates */
  hasTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** implementation_notes_to_attorney field predicates */
  implementationNotesToAttorney?: InputMaybe<Scalars['String']['input']>;
  implementationNotesToAttorneyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  implementationNotesToAttorneyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<GratTrustWhereInput>;
  /** official_interest_rate_percent field predicates */
  officialInterestRatePercent?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentGT?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentGTE?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  officialInterestRatePercentLT?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentLTE?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentNEQ?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<GratTrustWhereInput>>;
  /** projected_market_value field predicates */
  projectedMarketValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedMarketValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedMarketValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedMarketValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectedMarketValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedMarketValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedMarketValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedMarketValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** projected_rate_of_return field predicates */
  projectedRateOfReturn?: InputMaybe<Scalars['Percent']['input']>;
  projectedRateOfReturnGT?: InputMaybe<Scalars['Percent']['input']>;
  projectedRateOfReturnGTE?: InputMaybe<Scalars['Percent']['input']>;
  projectedRateOfReturnIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectedRateOfReturnLT?: InputMaybe<Scalars['Percent']['input']>;
  projectedRateOfReturnLTE?: InputMaybe<Scalars['Percent']['input']>;
  projectedRateOfReturnNEQ?: InputMaybe<Scalars['Percent']['input']>;
  projectedRateOfReturnNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** projected_share_price field predicates */
  projectedSharePrice?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedSharePriceGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedSharePriceGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedSharePriceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  projectedSharePriceLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedSharePriceLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedSharePriceNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedSharePriceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** rolling_period_years field predicates */
  rollingPeriodYears?: InputMaybe<Scalars['Int']['input']>;
  rollingPeriodYearsGT?: InputMaybe<Scalars['Int']['input']>;
  rollingPeriodYearsGTE?: InputMaybe<Scalars['Int']['input']>;
  rollingPeriodYearsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  rollingPeriodYearsLT?: InputMaybe<Scalars['Int']['input']>;
  rollingPeriodYearsLTE?: InputMaybe<Scalars['Int']['input']>;
  rollingPeriodYearsNEQ?: InputMaybe<Scalars['Int']['input']>;
  rollingPeriodYearsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** target_taxable_gift field predicates */
  targetTaxableGift?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  targetTaxableGiftGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  targetTaxableGiftGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  targetTaxableGiftIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  targetTaxableGiftLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  targetTaxableGiftLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  targetTaxableGiftNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  targetTaxableGiftNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<TrustTaxStatus>;
  taxStatusIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<TrustTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** taxable_gift field predicates */
  taxableGift?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableGiftGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableGiftGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableGiftIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxableGiftLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableGiftLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableGiftNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableGiftNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** term_duration_years field predicates */
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsGT?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsGTE?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  termDurationYearsLT?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsLTE?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsNEQ?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** trust_jurisdiction_state_code field predicates */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trustJurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  trustJurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** upside_as_target_surplus field predicates */
  upsideAsTargetSurplus?: InputMaybe<Scalars['Boolean']['input']>;
  /** upside_threshold_percent field predicates */
  upsideThresholdPercent?: InputMaybe<Scalars['Percent']['input']>;
  upsideThresholdPercentGT?: InputMaybe<Scalars['Percent']['input']>;
  upsideThresholdPercentGTE?: InputMaybe<Scalars['Percent']['input']>;
  upsideThresholdPercentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  upsideThresholdPercentLT?: InputMaybe<Scalars['Percent']['input']>;
  upsideThresholdPercentLTE?: InputMaybe<Scalars['Percent']['input']>;
  upsideThresholdPercentNEQ?: InputMaybe<Scalars['Percent']['input']>;
  upsideThresholdPercentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** upside_threshold_value field predicates */
  upsideThresholdValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  upsideThresholdValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  upsideThresholdValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  upsideThresholdValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  upsideThresholdValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  upsideThresholdValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  upsideThresholdValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  upsideThresholdValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GstTaxDetail = {
  __typename?: 'GSTTaxDetail';
  _cacheKey: Scalars['String']['output'];
  /** exemptionAvailable is the total available exemption before processing this tax event. */
  exemptionAvailable: Scalars['CurrencyUSD']['output'];
  /** exemptionUsed is the amount of exemption used during this tax event. */
  exemptionUsed: Scalars['CurrencyUSD']['output'];
  tax: Scalars['CurrencyUSD']['output'];
  taxableAmount: Scalars['CurrencyUSD']['output'];
  /** totalTransferAmount is the sum of all bequests to skip person(s) */
  totalTransferAmount: Scalars['CurrencyUSD']['output'];
  /** valuationDiscount is the amount by which the total trasnfer amount is reduced. */
  valuationDiscount?: Maybe<Scalars['CurrencyUSD']['output']>;
};

export type GenerateKnowledgeGraphInput = {
  documentIds: Array<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
};

export type GenerateMemoInput = {
  /** documentIDs are required for the TRUST_COMPARISON memo type, and should be null for all other memo types. */
  documentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdID: Scalars['ID']['input'];
  /** memoPromptID should be set if memoType is CUSTOM, and should be null otherwise. */
  memoPromptID?: InputMaybe<Scalars['ID']['input']>;
  /** The type of memo to generate. Pass CUSTOM here to generate a memo from a custom memo prompt, and pass one of the other types to generate a memo from a default memo prompt. */
  memoType: MemoPromptMemoPromptType;
  name: Scalars['String']['input'];
  /** rolePredicates is required when generating a ROLE_SUMMARY memo and must include at least 1 valid KGV2 statement predicate. */
  rolePredicates?: InputMaybe<Array<Scalars['String']['input']>>;
  specificInstructions?: InputMaybe<Scalars['String']['input']>;
};

/**
 * GeneratePresentationCustomSlidePromptInput defines ad-hoc one-off generation inputs.
 *
 * When currentSlideContent is provided the endpoint operates in refinement mode:
 * the model refines the existing content according to the prompt rather than
 * generating from scratch.
 */
export type GeneratePresentationCustomSlidePromptInput = {
  /**
   * currentSlideContent is the existing markdown body of the slide. When provided,
   * the model refines this content based on the prompt instead of writing new content.
   */
  currentSlideContent?: InputMaybe<Scalars['String']['input']>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  presentationID: Scalars['ID']['input'];
  prompt: Scalars['String']['input'];
};

/** GiftTaxDetail contains the gift tax due while outlining the taxable gifts made and the exemption used. */
export type GiftTaxDetail = {
  __typename?: 'GiftTaxDetail';
  _cacheKey: Scalars['String']['output'];
  /** exemptionUsed is the amount of exemption that was used to cover the gifts */
  exemptionUsed: Scalars['CurrencyUSD']['output'];
  tax: Scalars['CurrencyUSD']['output'];
  /** taxableAmount is the final amount, after exemption etc, that is taxed */
  taxableAmount: Scalars['CurrencyUSD']['output'];
  /** taxableGiftsMade is the amount of taxable gifts made */
  taxableGiftsMade: Scalars['CurrencyUSD']['output'];
};

/** GiftTaxSummary contains federal and gst git tax details. */
export type GiftTaxSummary = {
  __typename?: 'GiftTaxSummary';
  _cacheKey: Scalars['String']['output'];
  federalGiftTax?: Maybe<GiftTaxDetail>;
  gstGiftTax?: Maybe<GiftTaxDetail>;
  stateGiftTax?: Maybe<Array<StateGiftTaxDetail>>;
};

export type GiftingProposal = Node & {
  __typename?: 'GiftingProposal';
  /** The base cash flow items for this proposal that will be applied to all scenarios */
  baseCashFlows?: Maybe<Array<GiftingProposalCashFlow>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The default gifting scenario for this proposal. There can only be one default. */
  defaultGiftingScenario?: Maybe<GiftingProposalScenario>;
  /** Gift exemption grows by this amount each year. */
  exemptionGrowthRate?: Maybe<Scalars['Percent']['output']>;
  /**
   * If true, exemption amount is halved at the end of 2025, then continues growing. DEPRECATED: The 2017 Tax Cuts and Jobs Act sunset provision is no longer relevant
   * @deprecated The 2017 Tax Cuts and Jobs Act sunset provision is no longer relevant
   */
  exemptionSunsets?: Maybe<Scalars['Boolean']['output']>;
  /** The various gifting scenarios modeled for this proposal */
  giftingScenarios?: Maybe<Array<GiftingProposalScenario>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The total value of all assets in the client's estate */
  inEstatePortfolioValue: Scalars['CurrencyUSD']['output'];
  /** number of years to run the gifting analysis */
  lengthOfAnalysis: Scalars['Int']['output'];
  /** The out-of-estate portfolios modeled for this proposal */
  outOfEstatePortfolios?: Maybe<Array<GiftingProposalPortfolio>>;
  /** The high end of the pre-tax return percentage assumption */
  preTaxReturnPercentageHigh?: Maybe<Scalars['Percent']['output']>;
  /** The low end of the pre-tax return assumption */
  preTaxReturnPercentageLow?: Maybe<Scalars['Percent']['output']>;
  /** The medium pre-tax return percentage assumption */
  preTaxReturnPercentageMedium?: Maybe<Scalars['Percent']['output']>;
  proposal: Proposal;
  /** @deprecated no longer needed */
  proposalYears: GiftingProposalYears;
  /** The selected pre-tax return (and tax drag) category. Used when computing projections for scenarios. */
  selectedPreTaxReturnCategory?: Maybe<GiftingProposalSelectedPreTaxReturnCategory>;
  /** The selected year of analysis. Defaults to end year. Used when computing projections for scenarios. */
  selectedYearOfAnalysis?: Maybe<Scalars['Int']['output']>;
  /** If true, show after estate tax */
  showAfterEstateTax?: Maybe<Scalars['Boolean']['output']>;
  /** Status of the gifting proposal */
  status: GiftingProposalStatus;
  /** The associated tax drag for the high pre-tax return */
  taxDragPercentageHigh?: Maybe<Scalars['Percent']['output']>;
  /** The associated tax drag for the low pre-tax return */
  taxDragPercentageLow?: Maybe<Scalars['Percent']['output']>;
  /** The associated tax drag for the medium pre-tax return */
  taxDragPercentageMedium?: Maybe<Scalars['Percent']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

export type GiftingProposalCashFlow = Node & {
  __typename?: 'GiftingProposalCashFlow';
  /** Cash flow amount */
  amount: Scalars['CurrencyUSD']['output'];
  /** Whether this cash flow occurs every year or only once */
  annuallyRecurring?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the cash flow is an income or expense */
  cashFlowType: GiftingProposalCashFlowCashFlowType;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** the user-friendly name of this cash flow */
  displayName: Scalars['String']['output'];
  /** If recurring, the year this cash flow ends. If not recurring, this field is not set. */
  endYear?: Maybe<Scalars['Int']['output']>;
  /** Will be nil if this is a scenario cash flow, rather than a base cash flow for the whole proposal. */
  giftingProposal?: Maybe<GiftingProposal>;
  /** Will be nil if this is a base cash flow, rather than cash flow for a specific scenario. */
  giftingScenario?: Maybe<GiftingProposalScenario>;
  /** If recurring, the percentage that the cash flow amount grows each year */
  growthPercentage?: Maybe<Scalars['Percent']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The order to display cash flows in the UI */
  order: Scalars['Int']['output'];
  /** When present, this cashflow is attributed to an out-of-estate portfolio instead. */
  portfolio?: Maybe<GiftingProposalPortfolio>;
  /** If recurring, the year this cash flow starts. If not recurring, the year this cash flow occurs. */
  startYear: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** GiftingProposalCashFlowCashFlowType is enum for the field cash_flow_type */
export enum GiftingProposalCashFlowCashFlowType {
  Expense = 'EXPENSE',
  Income = 'INCOME'
}

/** A connection to a list of items. */
export type GiftingProposalCashFlowConnection = {
  __typename?: 'GiftingProposalCashFlowConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GiftingProposalCashFlowEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GiftingProposalCashFlowEdge = {
  __typename?: 'GiftingProposalCashFlowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GiftingProposalCashFlow>;
};

/** Ordering options for GiftingProposalCashFlow connections */
export type GiftingProposalCashFlowOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GiftingProposalCashFlows. */
  field: GiftingProposalCashFlowOrderField;
};

/** Properties by which GiftingProposalCashFlow connections can be ordered. */
export enum GiftingProposalCashFlowOrderField {
  CashFlowOrder = 'CASH_FLOW_ORDER',
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * GiftingProposalCashFlowWhereInput is used for filtering GiftingProposalCashFlow objects.
 * Input was generated by ent.
 */
export type GiftingProposalCashFlowWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  and?: InputMaybe<Array<GiftingProposalCashFlowWhereInput>>;
  /** annually_recurring field predicates */
  annuallyRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  annuallyRecurringIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  annuallyRecurringNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cash_flow_type field predicates */
  cashFlowType?: InputMaybe<GiftingProposalCashFlowCashFlowType>;
  cashFlowTypeIn?: InputMaybe<Array<GiftingProposalCashFlowCashFlowType>>;
  cashFlowTypeNEQ?: InputMaybe<GiftingProposalCashFlowCashFlowType>;
  cashFlowTypeNotIn?: InputMaybe<Array<GiftingProposalCashFlowCashFlowType>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** end_year field predicates */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  endYearGT?: InputMaybe<Scalars['Int']['input']>;
  endYearGTE?: InputMaybe<Scalars['Int']['input']>;
  endYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endYearLT?: InputMaybe<Scalars['Int']['input']>;
  endYearLTE?: InputMaybe<Scalars['Int']['input']>;
  endYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  endYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** growth_percentage field predicates */
  growthPercentage?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  growthPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** gifting_proposal edge predicates */
  hasGiftingProposal?: InputMaybe<Scalars['Boolean']['input']>;
  hasGiftingProposalWith?: InputMaybe<Array<GiftingProposalWhereInput>>;
  /** gifting_scenario edge predicates */
  hasGiftingScenario?: InputMaybe<Scalars['Boolean']['input']>;
  hasGiftingScenarioWith?: InputMaybe<Array<GiftingProposalScenarioWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** portfolio edge predicates */
  hasPortfolio?: InputMaybe<Scalars['Boolean']['input']>;
  hasPortfolioWith?: InputMaybe<Array<GiftingProposalPortfolioWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<GiftingProposalCashFlowWhereInput>;
  or?: InputMaybe<Array<GiftingProposalCashFlowWhereInput>>;
  /** order field predicates */
  order?: InputMaybe<Scalars['Int']['input']>;
  orderGT?: InputMaybe<Scalars['Int']['input']>;
  orderGTE?: InputMaybe<Scalars['Int']['input']>;
  orderLT?: InputMaybe<Scalars['Int']['input']>;
  orderLTE?: InputMaybe<Scalars['Int']['input']>;
  orderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** start_year field predicates */
  startYear?: InputMaybe<Scalars['Int']['input']>;
  startYearGT?: InputMaybe<Scalars['Int']['input']>;
  startYearGTE?: InputMaybe<Scalars['Int']['input']>;
  startYearLT?: InputMaybe<Scalars['Int']['input']>;
  startYearLTE?: InputMaybe<Scalars['Int']['input']>;
  startYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type GiftingProposalClientProjectionParams = {
  exemptionGrowthRate?: InputMaybe<Scalars['Percent']['input']>;
  exemptionSunsets?: InputMaybe<Scalars['Boolean']['input']>;
  giftingProposalId: Scalars['ID']['input'];
  preTaxReturnCategory?: InputMaybe<GiftingProposalSelectedPreTaxReturnCategory>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type GiftingProposalConnection = {
  __typename?: 'GiftingProposalConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GiftingProposalEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GiftingProposalEdge = {
  __typename?: 'GiftingProposalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GiftingProposal>;
};

export type GiftingProposalGift = Node & {
  __typename?: 'GiftingProposalGift';
  /** Gift amount */
  amount: Scalars['CurrencyUSD']['output'];
  /** Whether this gift occurs every year or only once */
  annuallyRecurring?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** If true, gift amount is discounted for gift tax purposes */
  discount?: Maybe<Scalars['Boolean']['output']>;
  /** If discount is true, the discount percentage applied to the gift amount */
  discountPercentage?: Maybe<Scalars['Percent']['output']>;
  /** the user-friendly name of this gifting scenario */
  displayName: Scalars['String']['output'];
  /** If recurring, the year this gift ends. If not recurring, this field is not set. */
  endYear?: Maybe<Scalars['Int']['output']>;
  giftingScenario?: Maybe<GiftingProposalScenario>;
  /** If recurring, the percentage that the gift amount grows each year */
  growthPercentage?: Maybe<Scalars['Percent']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** If true, gift is taxable, and sender will be one or both grantors. If false, can be annual exclusion, or charitable. */
  isTaxable: Scalars['Boolean']['output'];
  /** Will be null (or ignored) if gift is taxable. */
  nonTaxableGiftType?: Maybe<GiftingProposalGiftNonTaxableGiftType>;
  /** The order to display, and process the gifts when simulating the proposal scenarios */
  order: Scalars['Int']['output'];
  /** One of the client organizations that will receive the gift. Only one of the recipient fields will be set. */
  recipientClientOrganization?: Maybe<ClientOrganization>;
  /** One of the client profiles that will receive the gift. Only one of the recipient fields will be set. */
  recipientClientProfile?: Maybe<ClientProfile>;
  /** The kind of recipient for this gift. Either one of the modeled out-of-estate portfolios, an individual, or an organization. */
  recipientKind?: Maybe<GiftingProposalGiftRecipientKind>;
  /** One of the out-of-estate portfolios within the proposal that will receive the gift. Only one of the recipient fields will be set. */
  recipientPortfolio?: Maybe<GiftingProposalPortfolio>;
  /** The grantors of the gift */
  senders?: Maybe<Array<GiftingProposalGiftSender>>;
  /** If recurring, the year this gift starts. If not recurring, the year this gift occurs. */
  startYear: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type GiftingProposalGiftConnection = {
  __typename?: 'GiftingProposalGiftConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GiftingProposalGiftEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GiftingProposalGiftEdge = {
  __typename?: 'GiftingProposalGiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GiftingProposalGift>;
};

/** GiftingProposalGiftNonTaxableGiftType is enum for the field non_taxable_gift_type */
export enum GiftingProposalGiftNonTaxableGiftType {
  AnnualExclusion = 'ANNUAL_EXCLUSION',
  Charitable = 'CHARITABLE'
}

/** Ordering options for GiftingProposalGift connections */
export type GiftingProposalGiftOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GiftingProposalGifts. */
  field: GiftingProposalGiftOrderField;
};

/** Properties by which GiftingProposalGift connections can be ordered. */
export enum GiftingProposalGiftOrderField {
  GiftOrder = 'GIFT_ORDER',
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** GiftingProposalGiftRecipientKind is enum for the field recipient_kind */
export enum GiftingProposalGiftRecipientKind {
  Individual = 'INDIVIDUAL',
  Organization = 'ORGANIZATION',
  OutOfEstatePortfolio = 'OUT_OF_ESTATE_PORTFOLIO'
}

export type GiftingProposalGiftSender = Node & {
  __typename?: 'GiftingProposalGiftSender';
  createdAt: Scalars['Time']['output'];
  gift?: Maybe<GiftingProposalGift>;
  /** The client profile that is the grantor/sender */
  grantor: ClientProfile;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type GiftingProposalGiftSenderConnection = {
  __typename?: 'GiftingProposalGiftSenderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GiftingProposalGiftSenderEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GiftingProposalGiftSenderEdge = {
  __typename?: 'GiftingProposalGiftSenderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GiftingProposalGiftSender>;
};

/** Ordering options for GiftingProposalGiftSender connections */
export type GiftingProposalGiftSenderOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GiftingProposalGiftSenders. */
  field: GiftingProposalGiftSenderOrderField;
};

/** Properties by which GiftingProposalGiftSender connections can be ordered. */
export enum GiftingProposalGiftSenderOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * GiftingProposalGiftSenderWhereInput is used for filtering GiftingProposalGiftSender objects.
 * Input was generated by ent.
 */
export type GiftingProposalGiftSenderWhereInput = {
  and?: InputMaybe<Array<GiftingProposalGiftSenderWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** gift edge predicates */
  hasGift?: InputMaybe<Scalars['Boolean']['input']>;
  hasGiftWith?: InputMaybe<Array<GiftingProposalGiftWhereInput>>;
  /** grantor edge predicates */
  hasGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrantorWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<GiftingProposalGiftSenderWhereInput>;
  or?: InputMaybe<Array<GiftingProposalGiftSenderWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * GiftingProposalGiftWhereInput is used for filtering GiftingProposalGift objects.
 * Input was generated by ent.
 */
export type GiftingProposalGiftWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  and?: InputMaybe<Array<GiftingProposalGiftWhereInput>>;
  /** annually_recurring field predicates */
  annuallyRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  annuallyRecurringIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  annuallyRecurringNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** discount field predicates */
  discount?: InputMaybe<Scalars['Boolean']['input']>;
  discountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  discountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** discount_percentage field predicates */
  discountPercentage?: InputMaybe<Scalars['Percent']['input']>;
  discountPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  discountPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  discountPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  discountPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  discountPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  discountPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  discountPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** end_year field predicates */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  endYearGT?: InputMaybe<Scalars['Int']['input']>;
  endYearGTE?: InputMaybe<Scalars['Int']['input']>;
  endYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endYearLT?: InputMaybe<Scalars['Int']['input']>;
  endYearLTE?: InputMaybe<Scalars['Int']['input']>;
  endYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  endYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** growth_percentage field predicates */
  growthPercentage?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  growthPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  growthPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** gifting_scenario edge predicates */
  hasGiftingScenario?: InputMaybe<Scalars['Boolean']['input']>;
  hasGiftingScenarioWith?: InputMaybe<Array<GiftingProposalScenarioWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** recipient_client_organization edge predicates */
  hasRecipientClientOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecipientClientOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** recipient_client_profile edge predicates */
  hasRecipientClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecipientClientProfileWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** recipient_portfolio edge predicates */
  hasRecipientPortfolio?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecipientPortfolioWith?: InputMaybe<Array<GiftingProposalPortfolioWhereInput>>;
  /** senders edge predicates */
  hasSenders?: InputMaybe<Scalars['Boolean']['input']>;
  hasSendersWith?: InputMaybe<Array<GiftingProposalGiftSenderWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_taxable field predicates */
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  /** non_taxable_gift_type field predicates */
  nonTaxableGiftType?: InputMaybe<GiftingProposalGiftNonTaxableGiftType>;
  nonTaxableGiftTypeIn?: InputMaybe<Array<GiftingProposalGiftNonTaxableGiftType>>;
  nonTaxableGiftTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nonTaxableGiftTypeNEQ?: InputMaybe<GiftingProposalGiftNonTaxableGiftType>;
  nonTaxableGiftTypeNotIn?: InputMaybe<Array<GiftingProposalGiftNonTaxableGiftType>>;
  nonTaxableGiftTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<GiftingProposalGiftWhereInput>;
  or?: InputMaybe<Array<GiftingProposalGiftWhereInput>>;
  /** order field predicates */
  order?: InputMaybe<Scalars['Int']['input']>;
  orderGT?: InputMaybe<Scalars['Int']['input']>;
  orderGTE?: InputMaybe<Scalars['Int']['input']>;
  orderLT?: InputMaybe<Scalars['Int']['input']>;
  orderLTE?: InputMaybe<Scalars['Int']['input']>;
  orderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** recipient_kind field predicates */
  recipientKind?: InputMaybe<GiftingProposalGiftRecipientKind>;
  recipientKindIn?: InputMaybe<Array<GiftingProposalGiftRecipientKind>>;
  recipientKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  recipientKindNEQ?: InputMaybe<GiftingProposalGiftRecipientKind>;
  recipientKindNotIn?: InputMaybe<Array<GiftingProposalGiftRecipientKind>>;
  recipientKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** start_year field predicates */
  startYear?: InputMaybe<Scalars['Int']['input']>;
  startYearGT?: InputMaybe<Scalars['Int']['input']>;
  startYearGTE?: InputMaybe<Scalars['Int']['input']>;
  startYearLT?: InputMaybe<Scalars['Int']['input']>;
  startYearLTE?: InputMaybe<Scalars['Int']['input']>;
  startYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Ordering options for GiftingProposal connections */
export type GiftingProposalOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GiftingProposals. */
  field: GiftingProposalOrderField;
};

/** Properties by which GiftingProposal connections can be ordered. */
export enum GiftingProposalOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type GiftingProposalPortfolio = Node & {
  __typename?: 'GiftingProposalPortfolio';
  cashflows: GiftingProposalCashFlowConnection;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** the user-friendly name of the out-of-estate portfolio */
  displayName: Scalars['String']['output'];
  giftingProposal?: Maybe<GiftingProposal>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The order to display portfolios in the UI */
  order: Scalars['Int']['output'];
  /** Portfolio type */
  portfolioType: GiftingProposalPortfolioPortfolioType;
  recipientOf?: Maybe<Array<GiftingProposalGift>>;
  /** The starting value of the out-of-estate portfolio */
  startingAssetValue: Scalars['CurrencyUSD']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type GiftingProposalPortfolioCashflowsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GiftingProposalCashFlowOrder>>;
  where?: InputMaybe<GiftingProposalCashFlowWhereInput>;
};

/** A connection to a list of items. */
export type GiftingProposalPortfolioConnection = {
  __typename?: 'GiftingProposalPortfolioConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GiftingProposalPortfolioEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GiftingProposalPortfolioEdge = {
  __typename?: 'GiftingProposalPortfolioEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GiftingProposalPortfolio>;
};

/** Ordering options for GiftingProposalPortfolio connections */
export type GiftingProposalPortfolioOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GiftingProposalPortfolios. */
  field: GiftingProposalPortfolioOrderField;
};

/** Properties by which GiftingProposalPortfolio connections can be ordered. */
export enum GiftingProposalPortfolioOrderField {
  PortfolioOrder = 'PORTFOLIO_ORDER',
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** GiftingProposalPortfolioPortfolioType is enum for the field portfolio_type */
export enum GiftingProposalPortfolioPortfolioType {
  Charitable = 'CHARITABLE',
  GrantorTrust = 'GRANTOR_TRUST',
  NonGrantorIndividual = 'NON_GRANTOR_INDIVIDUAL',
  NonGrantorTrust = 'NON_GRANTOR_TRUST'
}

/**
 * GiftingProposalPortfolioWhereInput is used for filtering GiftingProposalPortfolio objects.
 * Input was generated by ent.
 */
export type GiftingProposalPortfolioWhereInput = {
  and?: InputMaybe<Array<GiftingProposalPortfolioWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** cashflows edge predicates */
  hasCashflows?: InputMaybe<Scalars['Boolean']['input']>;
  hasCashflowsWith?: InputMaybe<Array<GiftingProposalCashFlowWhereInput>>;
  /** gifting_proposal edge predicates */
  hasGiftingProposal?: InputMaybe<Scalars['Boolean']['input']>;
  hasGiftingProposalWith?: InputMaybe<Array<GiftingProposalWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** recipient_of edge predicates */
  hasRecipientOf?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecipientOfWith?: InputMaybe<Array<GiftingProposalGiftWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<GiftingProposalPortfolioWhereInput>;
  or?: InputMaybe<Array<GiftingProposalPortfolioWhereInput>>;
  /** order field predicates */
  order?: InputMaybe<Scalars['Int']['input']>;
  orderGT?: InputMaybe<Scalars['Int']['input']>;
  orderGTE?: InputMaybe<Scalars['Int']['input']>;
  orderLT?: InputMaybe<Scalars['Int']['input']>;
  orderLTE?: InputMaybe<Scalars['Int']['input']>;
  orderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** portfolio_type field predicates */
  portfolioType?: InputMaybe<GiftingProposalPortfolioPortfolioType>;
  portfolioTypeIn?: InputMaybe<Array<GiftingProposalPortfolioPortfolioType>>;
  portfolioTypeNEQ?: InputMaybe<GiftingProposalPortfolioPortfolioType>;
  portfolioTypeNotIn?: InputMaybe<Array<GiftingProposalPortfolioPortfolioType>>;
  /** starting_asset_value field predicates */
  startingAssetValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  startingAssetValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  startingAssetValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  startingAssetValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  startingAssetValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  startingAssetValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type GiftingProposalProjections = {
  __typename?: 'GiftingProposalProjections';
  estateTax: Scalars['CurrencyUSD']['output'];
  /** @deprecated use estateTaxSummaryV2 instead */
  estateTaxSummary: TaxSummary;
  /** estateTaxSummaryV2 returns the federal, gst, and state tax summaries. */
  estateTaxSummaryV2: TaxSummaryV2;
  giftTax: Scalars['CurrencyUSD']['output'];
  /** giftTaxSummary returns the gift tax details. */
  giftTaxSummary?: Maybe<GiftTaxSummary>;
  inEstateValueAfterTax: Scalars['CurrencyUSD']['output'];
  inEstateValueBeforeTax: Scalars['CurrencyUSD']['output'];
  lifetimeExemptionAppliedTowardGiftTax: Scalars['CurrencyUSD']['output'];
  outOfEstateCharitableValue: Scalars['CurrencyUSD']['output'];
  outOfEstateFamilyValue: Scalars['CurrencyUSD']['output'];
  outOfEstateTotalValue: Scalars['CurrencyUSD']['output'];
  remainingLifetimeExemption: Scalars['CurrencyUSD']['output'];
  scenario: GiftingProposalScenario;
  scenarioId: Scalars['ID']['output'];
  taxableGift: Scalars['CurrencyUSD']['output'];
  totalValue: Scalars['CurrencyUSD']['output'];
  /** When present, year in which the estate portfolio is depleted (reaches $0) for the first time. */
  yearInEstatePortfolioDepleted?: Maybe<Scalars['Int']['output']>;
};

export type GiftingProposalScenario = Node & {
  __typename?: 'GiftingProposalScenario';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** the user-friendly name of this gifting scenario */
  displayName: Scalars['String']['output'];
  /**
   * If true, exemption amount is halved at the end of 2025, then continues growing. When absent, uses the proposal level setting. DEPRECATED: The 2017 Tax Cuts and Jobs Act sunset provision is no longer relevant
   * @deprecated The 2017 Tax Cuts and Jobs Act sunset provision is no longer relevant
   */
  exemptionSunsets?: Maybe<Scalars['Boolean']['output']>;
  giftingProposal?: Maybe<GiftingProposal>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isBaseline: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  /** The order to display scenarios in the UI */
  order: Scalars['Int']['output'];
  projections: GiftingProposalProjections;
  /** The cash flows included in this scenario */
  scenarioCashFlows?: Maybe<Array<GiftingProposalCashFlow>>;
  /** The gifts included in this scenario */
  scenarioGifts?: Maybe<Array<GiftingProposalGift>>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type GiftingProposalScenarioConnection = {
  __typename?: 'GiftingProposalScenarioConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GiftingProposalScenarioEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GiftingProposalScenarioEdge = {
  __typename?: 'GiftingProposalScenarioEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GiftingProposalScenario>;
};

/** Ordering options for GiftingProposalScenario connections */
export type GiftingProposalScenarioOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GiftingProposalScenarios. */
  field: GiftingProposalScenarioOrderField;
};

/** Properties by which GiftingProposalScenario connections can be ordered. */
export enum GiftingProposalScenarioOrderField {
  ScenarioOrder = 'SCENARIO_ORDER',
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * GiftingProposalScenarioWhereInput is used for filtering GiftingProposalScenario objects.
 * Input was generated by ent.
 */
export type GiftingProposalScenarioWhereInput = {
  and?: InputMaybe<Array<GiftingProposalScenarioWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** exemption_sunsets field predicates */
  exemptionSunsets?: InputMaybe<Scalars['Boolean']['input']>;
  exemptionSunsetsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  exemptionSunsetsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** gifting_proposal edge predicates */
  hasGiftingProposal?: InputMaybe<Scalars['Boolean']['input']>;
  hasGiftingProposalWith?: InputMaybe<Array<GiftingProposalWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** scenario_cash_flows edge predicates */
  hasScenarioCashFlows?: InputMaybe<Scalars['Boolean']['input']>;
  hasScenarioCashFlowsWith?: InputMaybe<Array<GiftingProposalCashFlowWhereInput>>;
  /** scenario_gifts edge predicates */
  hasScenarioGifts?: InputMaybe<Scalars['Boolean']['input']>;
  hasScenarioGiftsWith?: InputMaybe<Array<GiftingProposalGiftWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<GiftingProposalScenarioWhereInput>;
  or?: InputMaybe<Array<GiftingProposalScenarioWhereInput>>;
  /** order field predicates */
  order?: InputMaybe<Scalars['Int']['input']>;
  orderGT?: InputMaybe<Scalars['Int']['input']>;
  orderGTE?: InputMaybe<Scalars['Int']['input']>;
  orderLT?: InputMaybe<Scalars['Int']['input']>;
  orderLTE?: InputMaybe<Scalars['Int']['input']>;
  orderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** GiftingProposalSelectedPreTaxReturnCategory is enum for the field selected_pre_tax_return_category */
export enum GiftingProposalSelectedPreTaxReturnCategory {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** GiftingProposalStatus is enum for the field status */
export enum GiftingProposalStatus {
  Draft = 'DRAFT',
  ProposalCreated = 'PROPOSAL_CREATED',
  ReadyForProposal = 'READY_FOR_PROPOSAL'
}

/**
 * GiftingProposalWhereInput is used for filtering GiftingProposal objects.
 * Input was generated by ent.
 */
export type GiftingProposalWhereInput = {
  and?: InputMaybe<Array<GiftingProposalWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** exemption_growth_rate field predicates */
  exemptionGrowthRate?: InputMaybe<Scalars['Percent']['input']>;
  exemptionGrowthRateGT?: InputMaybe<Scalars['Percent']['input']>;
  exemptionGrowthRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  exemptionGrowthRateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  exemptionGrowthRateLT?: InputMaybe<Scalars['Percent']['input']>;
  exemptionGrowthRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  exemptionGrowthRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  exemptionGrowthRateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** exemption_sunsets field predicates */
  exemptionSunsets?: InputMaybe<Scalars['Boolean']['input']>;
  exemptionSunsetsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  exemptionSunsetsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** base_cash_flows edge predicates */
  hasBaseCashFlows?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaseCashFlowsWith?: InputMaybe<Array<GiftingProposalCashFlowWhereInput>>;
  /** default_gifting_scenario edge predicates */
  hasDefaultGiftingScenario?: InputMaybe<Scalars['Boolean']['input']>;
  hasDefaultGiftingScenarioWith?: InputMaybe<Array<GiftingProposalScenarioWhereInput>>;
  /** gifting_scenarios edge predicates */
  hasGiftingScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasGiftingScenariosWith?: InputMaybe<Array<GiftingProposalScenarioWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** out_of_estate_portfolios edge predicates */
  hasOutOfEstatePortfolios?: InputMaybe<Scalars['Boolean']['input']>;
  hasOutOfEstatePortfoliosWith?: InputMaybe<Array<GiftingProposalPortfolioWhereInput>>;
  /** proposal edge predicates */
  hasProposal?: InputMaybe<Scalars['Boolean']['input']>;
  hasProposalWith?: InputMaybe<Array<ProposalWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_portfolio_value field predicates */
  inEstatePortfolioValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  inEstatePortfolioValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  inEstatePortfolioValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  inEstatePortfolioValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  inEstatePortfolioValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  inEstatePortfolioValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** length_of_analysis field predicates */
  lengthOfAnalysis?: InputMaybe<Scalars['Int']['input']>;
  lengthOfAnalysisGT?: InputMaybe<Scalars['Int']['input']>;
  lengthOfAnalysisGTE?: InputMaybe<Scalars['Int']['input']>;
  lengthOfAnalysisLT?: InputMaybe<Scalars['Int']['input']>;
  lengthOfAnalysisLTE?: InputMaybe<Scalars['Int']['input']>;
  lengthOfAnalysisNEQ?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<GiftingProposalWhereInput>;
  or?: InputMaybe<Array<GiftingProposalWhereInput>>;
  /** pre_tax_return_percentage_high field predicates */
  preTaxReturnPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighGT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighGTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  preTaxReturnPercentageHighLT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighLTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighNEQ?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageHighNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** pre_tax_return_percentage_low field predicates */
  preTaxReturnPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowGT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowGTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  preTaxReturnPercentageLowLT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowLTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowNEQ?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageLowNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** pre_tax_return_percentage_medium field predicates */
  preTaxReturnPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumGT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumGTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  preTaxReturnPercentageMediumLT?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumLTE?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumNEQ?: InputMaybe<Scalars['Percent']['input']>;
  preTaxReturnPercentageMediumNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** selected_pre_tax_return_category field predicates */
  selectedPreTaxReturnCategory?: InputMaybe<GiftingProposalSelectedPreTaxReturnCategory>;
  selectedPreTaxReturnCategoryIn?: InputMaybe<Array<GiftingProposalSelectedPreTaxReturnCategory>>;
  selectedPreTaxReturnCategoryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  selectedPreTaxReturnCategoryNEQ?: InputMaybe<GiftingProposalSelectedPreTaxReturnCategory>;
  selectedPreTaxReturnCategoryNotIn?: InputMaybe<Array<GiftingProposalSelectedPreTaxReturnCategory>>;
  selectedPreTaxReturnCategoryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** selected_year_of_analysis field predicates */
  selectedYearOfAnalysis?: InputMaybe<Scalars['Int']['input']>;
  selectedYearOfAnalysisGT?: InputMaybe<Scalars['Int']['input']>;
  selectedYearOfAnalysisGTE?: InputMaybe<Scalars['Int']['input']>;
  selectedYearOfAnalysisIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  selectedYearOfAnalysisLT?: InputMaybe<Scalars['Int']['input']>;
  selectedYearOfAnalysisLTE?: InputMaybe<Scalars['Int']['input']>;
  selectedYearOfAnalysisNEQ?: InputMaybe<Scalars['Int']['input']>;
  selectedYearOfAnalysisNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_after_estate_tax field predicates */
  showAfterEstateTax?: InputMaybe<Scalars['Boolean']['input']>;
  showAfterEstateTaxIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  showAfterEstateTaxNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<GiftingProposalStatus>;
  statusIn?: InputMaybe<Array<GiftingProposalStatus>>;
  statusNEQ?: InputMaybe<GiftingProposalStatus>;
  statusNotIn?: InputMaybe<Array<GiftingProposalStatus>>;
  /** tax_drag_percentage_high field predicates */
  taxDragPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDragPercentageHighLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageHighNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_drag_percentage_low field predicates */
  taxDragPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDragPercentageLowLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLowNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_drag_percentage_medium field predicates */
  taxDragPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDragPercentageMediumLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageMediumNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type GiftingProposalYears = {
  __typename?: 'GiftingProposalYears';
  end: Scalars['Int']['output'];
  median: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export type GiftsToIndividualsPerformanceReport = {
  __typename?: 'GiftsToIndividualsPerformanceReport';
  wealthTransferred: Scalars['CurrencyUSD']['output'];
};

export type GlobalSearchInput = {
  first?: InputMaybe<Scalars['Int']['input']>;
  maxDistance?: InputMaybe<Scalars['Float']['input']>;
  query: Scalars['String']['input'];
  searchTypes?: InputMaybe<Array<SearchableType>>;
};

export type GlobalSearchResult = {
  __typename?: 'GlobalSearchResult';
  clientOrganizationResults: Array<SearchResult>;
  clientProfileResults: Array<SearchResult>;
  documentResults: Array<SearchResult>;
  entityResults: Array<SearchResult>;
  householdResults: Array<SearchResult>;
  proposalResults: Array<SearchResult>;
};

export type GrantsToCharitableOrganizations = {
  __typename?: 'GrantsToCharitableOrganizations';
  entityID: Scalars['ID']['output'];
  grantingEntityName: Scalars['String']['output'];
  wealthTransferred: Scalars['CurrencyUSD']['output'];
};

export type GraphVisualizationGroup = Node & {
  __typename?: 'GraphVisualizationGroup';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** An optional namespace for this group. Can correspond to sections in the Graph Visualization. */
  namespace?: Maybe<Scalars['String']['output']>;
  /** The IDs of the nodes in this group. */
  nodeIds: Array<Scalars['ID']['output']>;
  nodes: Array<Node>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type GraphVisualizationGroupConnection = {
  __typename?: 'GraphVisualizationGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GraphVisualizationGroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GraphVisualizationGroupEdge = {
  __typename?: 'GraphVisualizationGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GraphVisualizationGroup>;
};

/** Ordering options for GraphVisualizationGroup connections */
export type GraphVisualizationGroupOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GraphVisualizationGroups. */
  field: GraphVisualizationGroupOrderField;
};

/** Properties by which GraphVisualizationGroup connections can be ordered. */
export enum GraphVisualizationGroupOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * GraphVisualizationGroupWhereInput is used for filtering GraphVisualizationGroup objects.
 * Input was generated by ent.
 */
export type GraphVisualizationGroupWhereInput = {
  and?: InputMaybe<Array<GraphVisualizationGroupWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** namespace field predicates */
  namespace?: InputMaybe<Scalars['String']['input']>;
  namespaceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  namespaceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<GraphVisualizationGroupWhereInput>;
  or?: InputMaybe<Array<GraphVisualizationGroupWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type GraphVisualizationNode = {
  group?: Maybe<GraphVisualizationGroup>;
  id: Scalars['ID']['output'];
  namespace?: Maybe<Scalars['String']['output']>;
  node: Node;
  nodeConfiguration?: Maybe<EntityGraphNodeConfiguration>;
};

/** The saved diagram type that owns a set of visualization groups. */
export enum GraphVisualizationOwnerType {
  EntityDiagram = 'ENTITY_DIAGRAM',
  EntityGraphView = 'ENTITY_GRAPH_VIEW'
}

/** GroupIdMapping maps a client-generated temporary ID to the server-assigned real ID. */
export type GroupIdMapping = {
  __typename?: 'GroupIdMapping';
  /** The real ID assigned by the server. */
  realId: Scalars['ID']['output'];
  /** The temporary ID provided by the client. */
  tempId: Scalars['String']['output'];
};

/** A stable question within a frozen group. */
export type GroupedQuestion = {
  __typename?: 'GroupedQuestion';
  id: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** A trimmed, nonblank answer to one question in a group. */
export type GroupedQuestionAnswerInput = {
  answer: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** Questions collected and resolved together. Unanswered questions are skipped. */
export type GroupedQuestionMessageContent = {
  __typename?: 'GroupedQuestionMessageContent';
  questions: Array<GroupedQuestion>;
};

export type GrowthProfile = Node & {
  __typename?: 'GrowthProfile';
  /** Assume assets will grow/shrink by this percentage each year. */
  assetGrowthReturn?: Maybe<Scalars['Percent']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
  estateWaterfalls: EstateWaterfallConnection;
  /** Lifetime exemption grows by around this each year. */
  exemptionGrowthRate: Scalars['Percent']['output'];
  growthProfileOverrides: GrowthProfileOverrideConnection;
  /** The type of growth to use for the growth profile. */
  growthType: GrowthProfileGrowthType;
  household: Household;
  id: Scalars['ID']['output'];
  /** This growth profile uses this income tax payment configuration. */
  incomeTaxPaymentConfig?: Maybe<IncomeTaxPaymentConfig>;
  /** If true, new waterfalls for this household will default to this growth profile. */
  isDefault: Scalars['Boolean']['output'];
  /** This growth profile uses this income tax drag configuration. */
  taxDragConfig?: Maybe<TaxDragConfig>;
  taxDragOverrides: TaxDragOverrideConnection;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type GrowthProfileEstateWaterfallsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EstateWaterfallOrder>>;
  where?: InputMaybe<EstateWaterfallWhereInput>;
};


export type GrowthProfileGrowthProfileOverridesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GrowthProfileOverrideOrder>>;
  where?: InputMaybe<GrowthProfileOverrideWhereInput>;
};


export type GrowthProfileTaxDragOverridesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaxDragOverrideOrder>>;
  where?: InputMaybe<TaxDragOverrideWhereInput>;
};

/** A connection to a list of items. */
export type GrowthProfileConnection = {
  __typename?: 'GrowthProfileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GrowthProfileEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GrowthProfileEdge = {
  __typename?: 'GrowthProfileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GrowthProfile>;
};

/** GrowthProfileGrowthType is enum for the field growth_type */
export enum GrowthProfileGrowthType {
  CustomGrowth = 'CUSTOM_GROWTH',
  DefaultGrowth = 'DEFAULT_GROWTH',
  GlobalGrowth = 'GLOBAL_GROWTH'
}

/** Ordering options for GrowthProfile connections */
export type GrowthProfileOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GrowthProfiles. */
  field: GrowthProfileOrderField;
};

/** Properties by which GrowthProfile connections can be ordered. */
export enum GrowthProfileOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type GrowthProfileOverride = Node & {
  __typename?: 'GrowthProfileOverride';
  /** This override applies to this asset class for this growth profile. */
  assetClass?: Maybe<AssetClass>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Expected growth rate. */
  customGrowthRate?: Maybe<Scalars['Percent']['output']>;
  /** This override applies to this entity for this growth profile. */
  entity?: Maybe<Entity>;
  /** Expected future value of the entity. */
  entityFutureValuationValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The year by which the entity is expected to reach its expected value. */
  entityFutureValuationYear?: Maybe<Scalars['Int']['output']>;
  /** Expected growth rate after the future valuation year. */
  entityGrowthAfterFutureValuation?: Maybe<Scalars['Percent']['output']>;
  /** Expected growth rate before the future valuation year. */
  entityGrowthBeforeFutureValuation?: Maybe<Scalars['Percent']['output']>;
  /** This override applies to this growth profile. */
  growthProfile?: Maybe<GrowthProfile>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The type of wealth module. */
  kind: GrowthProfileOverrideKind;
  /** This override applies to this proposal for this growth profile. */
  proposal?: Maybe<Proposal>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type GrowthProfileOverrideConnection = {
  __typename?: 'GrowthProfileOverrideConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GrowthProfileOverrideEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GrowthProfileOverrideEdge = {
  __typename?: 'GrowthProfileOverrideEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GrowthProfileOverride>;
};

/** GrowthProfileOverrideKind is enum for the field kind */
export enum GrowthProfileOverrideKind {
  Asset = 'ASSET',
  Entity = 'ENTITY',
  Proposal = 'PROPOSAL'
}

/** Ordering options for GrowthProfileOverride connections */
export type GrowthProfileOverrideOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GrowthProfileOverrides. */
  field: GrowthProfileOverrideOrderField;
};

/** Properties by which GrowthProfileOverride connections can be ordered. */
export enum GrowthProfileOverrideOrderField {
  CreatedAt = 'created_at',
  EntityFutureValuationValue = 'entity_future_valuation_value',
  EntityFutureValuationYear = 'entity_future_valuation_year',
  UpdatedAt = 'updated_at'
}

/**
 * GrowthProfileOverrideWhereInput is used for filtering GrowthProfileOverride objects.
 * Input was generated by ent.
 */
export type GrowthProfileOverrideWhereInput = {
  and?: InputMaybe<Array<GrowthProfileOverrideWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** custom_growth_rate field predicates */
  customGrowthRate?: InputMaybe<Scalars['Percent']['input']>;
  customGrowthRateGT?: InputMaybe<Scalars['Percent']['input']>;
  customGrowthRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  customGrowthRateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  customGrowthRateLT?: InputMaybe<Scalars['Percent']['input']>;
  customGrowthRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  customGrowthRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  customGrowthRateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_future_valuation_value field predicates */
  entityFutureValuationValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  entityFutureValuationValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  entityFutureValuationValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  entityFutureValuationValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  entityFutureValuationValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  entityFutureValuationValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  entityFutureValuationValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  entityFutureValuationValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_future_valuation_year field predicates */
  entityFutureValuationYear?: InputMaybe<Scalars['Int']['input']>;
  entityFutureValuationYearGT?: InputMaybe<Scalars['Int']['input']>;
  entityFutureValuationYearGTE?: InputMaybe<Scalars['Int']['input']>;
  entityFutureValuationYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  entityFutureValuationYearLT?: InputMaybe<Scalars['Int']['input']>;
  entityFutureValuationYearLTE?: InputMaybe<Scalars['Int']['input']>;
  entityFutureValuationYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  entityFutureValuationYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_growth_after_future_valuation field predicates */
  entityGrowthAfterFutureValuation?: InputMaybe<Scalars['Percent']['input']>;
  entityGrowthAfterFutureValuationGT?: InputMaybe<Scalars['Percent']['input']>;
  entityGrowthAfterFutureValuationGTE?: InputMaybe<Scalars['Percent']['input']>;
  entityGrowthAfterFutureValuationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  entityGrowthAfterFutureValuationLT?: InputMaybe<Scalars['Percent']['input']>;
  entityGrowthAfterFutureValuationLTE?: InputMaybe<Scalars['Percent']['input']>;
  entityGrowthAfterFutureValuationNEQ?: InputMaybe<Scalars['Percent']['input']>;
  entityGrowthAfterFutureValuationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_growth_before_future_valuation field predicates */
  entityGrowthBeforeFutureValuation?: InputMaybe<Scalars['Percent']['input']>;
  entityGrowthBeforeFutureValuationGT?: InputMaybe<Scalars['Percent']['input']>;
  entityGrowthBeforeFutureValuationGTE?: InputMaybe<Scalars['Percent']['input']>;
  entityGrowthBeforeFutureValuationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  entityGrowthBeforeFutureValuationLT?: InputMaybe<Scalars['Percent']['input']>;
  entityGrowthBeforeFutureValuationLTE?: InputMaybe<Scalars['Percent']['input']>;
  entityGrowthBeforeFutureValuationNEQ?: InputMaybe<Scalars['Percent']['input']>;
  entityGrowthBeforeFutureValuationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_class edge predicates */
  hasAssetClass?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetClassWith?: InputMaybe<Array<AssetClassWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** growth_profile edge predicates */
  hasGrowthProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrowthProfileWith?: InputMaybe<Array<GrowthProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** proposal edge predicates */
  hasProposal?: InputMaybe<Scalars['Boolean']['input']>;
  hasProposalWith?: InputMaybe<Array<ProposalWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<GrowthProfileOverrideKind>;
  kindIn?: InputMaybe<Array<GrowthProfileOverrideKind>>;
  kindNEQ?: InputMaybe<GrowthProfileOverrideKind>;
  kindNotIn?: InputMaybe<Array<GrowthProfileOverrideKind>>;
  not?: InputMaybe<GrowthProfileOverrideWhereInput>;
  or?: InputMaybe<Array<GrowthProfileOverrideWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * GrowthProfileWhereInput is used for filtering GrowthProfile objects.
 * Input was generated by ent.
 */
export type GrowthProfileWhereInput = {
  and?: InputMaybe<Array<GrowthProfileWhereInput>>;
  /** asset_growth_return field predicates */
  assetGrowthReturn?: InputMaybe<Scalars['Percent']['input']>;
  assetGrowthReturnGT?: InputMaybe<Scalars['Percent']['input']>;
  assetGrowthReturnGTE?: InputMaybe<Scalars['Percent']['input']>;
  assetGrowthReturnIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assetGrowthReturnLT?: InputMaybe<Scalars['Percent']['input']>;
  assetGrowthReturnLTE?: InputMaybe<Scalars['Percent']['input']>;
  assetGrowthReturnNEQ?: InputMaybe<Scalars['Percent']['input']>;
  assetGrowthReturnNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** exemption_growth_rate field predicates */
  exemptionGrowthRate?: InputMaybe<Scalars['Percent']['input']>;
  exemptionGrowthRateGT?: InputMaybe<Scalars['Percent']['input']>;
  exemptionGrowthRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  exemptionGrowthRateLT?: InputMaybe<Scalars['Percent']['input']>;
  exemptionGrowthRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  exemptionGrowthRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  /** growth_type field predicates */
  growthType?: InputMaybe<GrowthProfileGrowthType>;
  growthTypeIn?: InputMaybe<Array<GrowthProfileGrowthType>>;
  growthTypeNEQ?: InputMaybe<GrowthProfileGrowthType>;
  growthTypeNotIn?: InputMaybe<Array<GrowthProfileGrowthType>>;
  /** estate_waterfalls edge predicates */
  hasEstateWaterfalls?: InputMaybe<Scalars['Boolean']['input']>;
  hasEstateWaterfallsWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** growth_profile_overrides edge predicates */
  hasGrowthProfileOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrowthProfileOverridesWith?: InputMaybe<Array<GrowthProfileOverrideWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** income_tax_payment_config edge predicates */
  hasIncomeTaxPaymentConfig?: InputMaybe<Scalars['Boolean']['input']>;
  hasIncomeTaxPaymentConfigWith?: InputMaybe<Array<IncomeTaxPaymentConfigWhereInput>>;
  /** tax_drag_config edge predicates */
  hasTaxDragConfig?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaxDragConfigWith?: InputMaybe<Array<TaxDragConfigWhereInput>>;
  /** tax_drag_overrides edge predicates */
  hasTaxDragOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaxDragOverridesWith?: InputMaybe<Array<TaxDragOverrideWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_default field predicates */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<GrowthProfileWhereInput>;
  or?: InputMaybe<Array<GrowthProfileWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type HargroveAdvisorInput = {
  accountID: Scalars['String']['input'];
  applicationID: Scalars['String']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
};

export type HargroveClientInput = {
  advisorID: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: Scalars['Boolean']['input'];
  sendSMS?: Scalars['Boolean']['input'];
};

/** Raw NetLaw JSON returned for Luminary administrator diagnostics. */
export type HargroveQueryResults = {
  __typename?: 'HargroveQueryResults';
  results: Scalars['String']['output'];
};

export type Household = Node & {
  __typename?: 'Household';
  activities: ActivityConnection;
  /** When this household was archived */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** Employees assigned to this client */
  assignedEmployees?: Maybe<Array<Employee>>;
  /** Teams assigned to this client */
  assignedTeams?: Maybe<Array<Team>>;
  /** The balance sheet view configuration for this household */
  balanceSheetViewConfiguration?: Maybe<BalanceSheetViewConfiguration>;
  /** whether this client is billable or not. if not BILLABLE, this client's entities should be excluding from customer billing */
  billableKind: HouseholdBillableKind;
  branding: Branded;
  /** The cashflows associated with this household */
  cashflows?: Maybe<Array<Cashflow>>;
  clientOrganizations?: Maybe<Array<ClientOrganization>>;
  clientPerformanceReport: ClientOverallPerformanceReport;
  clientProfiles?: Maybe<Array<ClientProfile>>;
  /** Collaborators that can access this client */
  collaborators?: Maybe<Array<Collaborator>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The primary client selected by default when a workflow needs to model which client dies first */
  defaultFirstToDieClient?: Maybe<ClientProfile>;
  displayName: Scalars['String']['output'];
  documents?: Maybe<Array<Document>>;
  entities: EntityConnection;
  entityGraphViews?: Maybe<Array<EntityGraphView>>;
  /**
   * Per-entity current holdings across the household, in the same
   * shape Entity.currentHoldings exposes but loaded in a single
   * batched pass via the canonical entitymodel summary loader so
   * consumers like the cross-entity DP selector do not pay per-entity
   * fan-out costs.
   */
  entityHoldings: Array<EntityHoldingsBucket>;
  estateTaxScenarios?: Maybe<Array<EstateTaxScenario>>;
  /**
   * estateValueMetrics summarizes in/out-of-estate values across the household's entities.
   * When source is provided, the balance sheet filters configured on that surface
   * (hidden columns) are applied to the calculation.
   */
  estateValueMetrics: HouseholdMetrics;
  estateWaterfalls?: Maybe<Array<EstateWaterfall>>;
  /** Customer-supplied identifier from an external system. Unique per tenant when set. */
  externalID?: Maybe<Scalars['String']['output']>;
  /** The family tree configuration for this household */
  familyTreeConfiguration?: Maybe<Array<FamilyTreeConfiguration>>;
  growthProfiles: GrowthProfileConnection;
  /**
   * Whether an active validation run has published questions awaiting answers or skips.
   * This is household state, independent of a user's notification read status.
   */
  hasPendingValidationQuestions: Scalars['Boolean']['output'];
  /** Source that controls direct user assignment management for this household. SNOWFLAKE is set only after a successful sync and remains set while synchronization is paused. */
  householdManagementSource: HouseholdManagementSource;
  id: Scalars['ID']['output'];
  integrationClients?: Maybe<Array<IntegrationClient>>;
  /** Whether Smart Review is enabled for this household. */
  isSmartReviewEnabled: Scalars['Boolean']['output'];
  isTwoGrantor: Scalars['Boolean']['output'];
  /** The liabilities associated with this household */
  liabilities?: Maybe<Array<Liability>>;
  /** When set, individuals in this household were automatically accepted at this time; the frontend shows a banner prompting users to review them */
  newIndividualsAutomaticallyOnboardedAt?: Maybe<Scalars['Time']['output']>;
  nextTaskDue?: Maybe<EntityTask>;
  /** Free-form notes */
  notes?: Maybe<Scalars['String']['output']>;
  onboardingKgRoots: KgRootConnection;
  possibleGrantors: Array<ClientProfile>;
  possiblePrimaryClients: Array<ClientProfile>;
  /**
   * possibleTaskAssignees is a list of the users on the platform that are eligible to be a task assignee for this household.
   * We use Users rather than Employees because we expect that we will assign collaborators to tasks as well.
   * @deprecated Use possibleTaskAssigneesV2 instead
   */
  possibleTaskAssignees: Array<Maybe<User>>;
  presentationv2s: ClientPresentationV2Connection;
  primaryRelationshipOwner: User;
  /** Disables tenant-wide household access when true. */
  private: Scalars['Boolean']['output'];
  proposals?: Maybe<Array<Proposal>>;
  reportingEntities: Array<Maybe<Node>>;
  /** Show the prompt to generate V2 AI suggestions for a household on the frontend. This can be deprecated when no longer useful */
  showGenerateV2SuggestionsPrompt?: Maybe<Scalars['Boolean']['output']>;
  /** A programmatically-set field that is the last name (or names) of the household */
  sortableLastName?: Maybe<Scalars['String']['output']>;
  /** An optional sub-brand associated with this household */
  subBrand?: Maybe<SubBrand>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  testamentaryEntities: TestamentaryEntityConnection;
  updatedAt: Scalars['Time']['output'];
  user: User;
  /** When all validation questions for this household received answers or skips */
  validationQuestionsAnsweredAt?: Maybe<Scalars['Time']['output']>;
};


export type HouseholdActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityOrder>>;
  where?: InputMaybe<ActivityWhereInput>;
};


export type HouseholdEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityOrder>>;
  where?: InputMaybe<EntityWhereInput>;
};


export type HouseholdEstateValueMetricsArgs = {
  source?: InputMaybe<SummaryMetricsSourceInput>;
  where?: InputMaybe<EntityWhereInput>;
};


export type HouseholdGrowthProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GrowthProfileOrder>>;
  where?: InputMaybe<GrowthProfileWhereInput>;
};


export type HouseholdOnboardingKgRootsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KgRootOrder>>;
  where?: InputMaybe<KgRootWhereInput>;
};


export type HouseholdPresentationv2sArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClientPresentationV2Order>>;
  where?: InputMaybe<ClientPresentationV2WhereInput>;
};


export type HouseholdTestamentaryEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TestamentaryEntityOrder>>;
  where?: InputMaybe<TestamentaryEntityWhereInput>;
};

export type HouseholdAssetsSummary = {
  __typename?: 'HouseholdAssetsSummary';
  /** Percentage of total value that is illiquid (0-100) */
  illiquidPercentage: Scalars['Percent']['output'];
  /** Total illiquid asset value (assets with ILLIQUID liquidity status) */
  illiquidValue: Scalars['CurrencyUSD']['output'];
  /** Percentage of total value that is in-estate illiquid (0-100) */
  inEstateIlliquidPercentage: Scalars['Percent']['output'];
  /** In-estate illiquid asset value */
  inEstateIlliquidValue: Scalars['CurrencyUSD']['output'];
  /** Percentage of total value that is in-estate liquid (0-100) */
  inEstateLiquidPercentage: Scalars['Percent']['output'];
  /** In-estate liquid asset value */
  inEstateLiquidValue: Scalars['CurrencyUSD']['output'];
  /** Total in-estate value (liquid + illiquid) */
  inEstateValue: Scalars['CurrencyUSD']['output'];
  /** Percentage of total value that is liquid (0-100) */
  liquidPercentage: Scalars['Percent']['output'];
  /** Total liquid asset value (assets with LIQUID liquidity status) */
  liquidValue: Scalars['CurrencyUSD']['output'];
  /** Out-of-estate value for charitable entities (CRT, CLT, DAF, Private Foundation) */
  outOfEstateCharityValue: Scalars['CurrencyUSD']['output'];
  /** Out-of-estate value for non-charitable entities (family trusts, etc.) */
  outOfEstateFamilyValue: Scalars['CurrencyUSD']['output'];
  /** Percentage of total value that is out-of-estate illiquid (0-100) */
  outOfEstateIlliquidPercentage: Scalars['Percent']['output'];
  /** Out-of-estate illiquid asset value */
  outOfEstateIlliquidValue: Scalars['CurrencyUSD']['output'];
  /** Percentage of total value that is out-of-estate liquid (0-100) */
  outOfEstateLiquidPercentage: Scalars['Percent']['output'];
  /** Out-of-estate liquid asset value */
  outOfEstateLiquidValue: Scalars['CurrencyUSD']['output'];
  /** Total out-of-estate value (liquid + illiquid) */
  outOfEstateValue: Scalars['CurrencyUSD']['output'];
  /** Total value of all assets in the household */
  totalValue: Scalars['CurrencyUSD']['output'];
};

/** HouseholdBillableKind is enum for the field billable_kind */
export enum HouseholdBillableKind {
  Billable = 'BILLABLE',
  NonBillable = 'NON_BILLABLE',
  Prospect = 'PROSPECT'
}

/**
 * A high-level agent activity surfaced while the assistant is working
 * (e.g. searching the knowledge graph or consulting a specialist), used to
 * render a live "show your work" trace in the UI.
 */
export type HouseholdChatActivity = {
  __typename?: 'HouseholdChatActivity';
  /**
   * Optional supplementary detail derived from the tool's arguments, e.g. the
   * search terms being looked up. Empty when the tool exposes none.
   */
  detail?: Maybe<Scalars['String']['output']>;
  /** Coarse activity kind. */
  kind: HouseholdChatActivityKind;
  /** Human-readable label for display, e.g. "Searching the estate plan". */
  label: Scalars['String']['output'];
  /** The underlying tool or subagent name, when applicable. */
  toolName?: Maybe<Scalars['String']['output']>;
};

/** Coarse category for a household chat activity event. */
export enum HouseholdChatActivityKind {
  /** A delegated specialist subagent call. */
  Subagent = 'SUBAGENT',
  /** A regular tool call, such as searching the knowledge graph or reading documents. */
  Tool = 'TOOL'
}

export enum HouseholdChatFeedbackRating {
  Bad = 'BAD',
  Good = 'GOOD'
}

/**
 * Scopes a household chat message to one explicit object — the document, memo,
 * record, estate waterfall, … the user was focused on (on screen or on the page
 * of) when they chose to send the message with that focus attached, so the
 * assistant centers its answer on it. Typed and intended to grow over time
 * (e.g. object name for the context chip).
 */
export type HouseholdChatMessageContextInput = {
  /**
   * ID of the object the message is scoped to; its PULID prefix identifies the
   * object type.
   */
  objectID: Scalars['ID']['input'];
};

/** A selectable specialized household chat persona, with display metadata. */
export type HouseholdChatPersona = {
  __typename?: 'HouseholdChatPersona';
  /** One-sentence description of what the persona does. */
  description: Scalars['String']['output'];
  /** Short display name for the persona selector. */
  displayName: Scalars['String']['output'];
  /** The persona enum value to send back on HouseholdSendChatMessageInput. */
  persona: ChatPersona;
  /** Special traits that describe what the persona does. */
  personaFeatures: Array<Scalars['String']['output']>;
  /** Short summary shown with the persona display name. */
  subtitle: Scalars['String']['output'];
};

/**
 * The combined memo, diagram, and no-docs onboarding prompt types available for household chat messages.
 * GraphQL does not support unions of input enums. This combined enum lets one
 * input field accept values from all three prompt types.
 */
export enum HouseholdChatPromptTemplate {
  AbcJointTrust = 'ABC_JOINT_TRUST',
  AbcSeparateTrusts = 'ABC_SEPARATE_TRUSTS',
  AbJointTrust = 'AB_JOINT_TRUST',
  AbSeparateTrusts = 'AB_SEPARATE_TRUSTS',
  CoverLetter = 'COVER_LETTER',
  EqualShares = 'EQUAL_SHARES',
  EstateDistributionDetailed = 'ESTATE_DISTRIBUTION_DETAILED',
  EstateDistributionSimple = 'ESTATE_DISTRIBUTION_SIMPLE',
  EstatePlanSummary = 'ESTATE_PLAN_SUMMARY',
  ExecutiveSummary = 'EXECUTIVE_SUMMARY',
  FamilyTrust = 'FAMILY_TRUST',
  RoleSummary = 'ROLE_SUMMARY',
  SpecificBequests = 'SPECIFIC_BEQUESTS',
  SurvivingSpouse = 'SURVIVING_SPOUSE',
  TrustComparison = 'TRUST_COMPARISON'
}

/** Final, grounded result for a household chat turn. */
export type HouseholdChatResult = ChatResult & {
  __typename?: 'HouseholdChatResult';
  answer: Scalars['String']['output'];
  conversation: Conversation;
};

/**
 * Streaming event for household chat.
 * Exactly one of activity, textDelta, message, or result is set per event.
 */
export type HouseholdChatStreamEvent = {
  __typename?: 'HouseholdChatStreamEvent';
  activity?: Maybe<HouseholdChatActivity>;
  message?: Maybe<Message>;
  result?: Maybe<HouseholdChatResult>;
  textDelta?: Maybe<Scalars['String']['output']>;
  workflowTrackerID?: Maybe<Scalars['ID']['output']>;
};

/** A connection to a list of items. */
export type HouseholdConnection = {
  __typename?: 'HouseholdConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<HouseholdEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type HouseholdEdge = {
  __typename?: 'HouseholdEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Household>;
};

/** Health score for a single household's knowledge graph processing. */
export type HouseholdKgHealthScore = {
  __typename?: 'HouseholdKGHealthScore';
  /** The number of eligible documents for this household. */
  eligibleDocumentCount: Scalars['Int']['output'];
  /** The household ID. */
  householdID: Scalars['ID']['output'];
  /** The number of successfully processed KGV2 documents for this household. */
  processedDocumentCount: Scalars['Int']['output'];
  /**
   * The health score for this household, between 0 and 1.
   * 1 means all eligible documents have been successfully processed (or there are no eligible documents).
   */
  score: Scalars['Float']['output'];
};

/** HouseholdManagementSource is enum for the field household_management_source */
export enum HouseholdManagementSource {
  Manual = 'MANUAL',
  Snowflake = 'SNOWFLAKE'
}

export type HouseholdMetrics = {
  __typename?: 'HouseholdMetrics';
  inEstateValue: Scalars['CurrencyUSD']['output'];
  outOfEstateCharityValue: Scalars['CurrencyUSD']['output'];
  outOfEstateFamilyValue: Scalars['CurrencyUSD']['output'];
  outOfEstateValue: Scalars['CurrencyUSD']['output'];
  totalEstateValue: Scalars['CurrencyUSD']['output'];
};

/**
 * Represents a missing document for a household, including the document type
 * and the associated client profile (if applicable).
 */
export type HouseholdMissingDocument = {
  __typename?: 'HouseholdMissingDocument';
  /**
   * The client profile this missing document is associated with (if applicable).
   * For SIGNED_TRUST_DOCUMENT and TRUST_AMENDMENT, this will be null.
   * For WILL, WILL_CODICIL, LIVING_WILL, POWER_OF_ATTORNEY, and HEALTHCARE_PROXY,
   * this represents the client profile or minor child that needs the document.
   */
  clientProfile?: Maybe<ClientProfile>;
  /** The type of document that is missing */
  documentType: MissingDocumentOverrideDocumentType;
  /** The household this missing document is associated with */
  householdID: Scalars['ID']['output'];
  /** Whether an override exists to hide this missing document */
  isOverridden?: Maybe<Scalars['Boolean']['output']>;
};

/** Ordering options for Household connections */
export type HouseholdOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Households. */
  field: HouseholdOrderField;
};

/** Properties by which Household connections can be ordered. */
export enum HouseholdOrderField {
  PrimaryRelationshipOwnerName = 'PRIMARY_RELATIONSHIP_OWNER_NAME',
  SubBrandDisplayName = 'SUB_BRAND_DISPLAY_NAME',
  CreatedAt = 'created_at',
  SortableLastName = 'sortable_last_name',
  UpdatedAt = 'updated_at'
}

/**
 * Input for responding to a pending interactive message. The responding actor is derived from authentication
 * and the waiting workflow is resolved server-side from the message row — the
 * client supplies only the message, the response action, and any per-type
 * answer payload.
 */
export type HouseholdRespondToChatMessageInput = {
  /**
   * Free-form answer for a FREE_FORM_QUESTION_MESSAGE SUBMIT, or for a
   * multiple-choice SUBMIT in place of any selected options (never combined
   * with them); rejected for confirmations and omitted for DISMISS.
   */
  freeFormText?: InputMaybe<Scalars['String']['input']>;
  /** ID of the interactive message being responded to. */
  messageID: Scalars['ID']['input'];
  /** Nonblank answers for a grouped SUBMIT. Omitted questions are skipped. */
  questionAnswers?: InputMaybe<Array<GroupedQuestionAnswerInput>>;
  /**
   * The universal response action, accepted by every interactive message type:
   * SUBMIT answers the message (for CONFIRMATION_MESSAGE, approval to
   * proceed); DISMISS declines to engage with it (for CONFIRMATION_MESSAGE,
   * do not proceed).
   */
  responseAction: MessageResponseAction;
  /**
   * Values of the selected response options, from the options a message type
   * declares in its content. For a MULTIPLE_CHOICE_MULTI_SELECT_MESSAGE SUBMIT,
   * one or more declared values; for a MULTIPLE_CHOICE_SINGLE_SELECT_MESSAGE
   * SUBMIT, exactly one. Omitted when freeFormText answers a multiple-choice
   * question instead; rejected for message types that declare no options.
   */
  responseOptionValues?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Payload returned by respondToHouseholdChatMessage. Acknowledges submission to
 * the waiting workflow; the resolved message state arrives through the
 * conversation stream and the persisted message, which remain authoritative.
 */
export type HouseholdRespondToChatMessagePayload = {
  __typename?: 'HouseholdRespondToChatMessagePayload';
  freeFormText?: Maybe<Scalars['String']['output']>;
  messageID: Scalars['ID']['output'];
  responseAction: MessageResponseAction;
  responseOptionValues?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * Input for sending a message on an existing household chat conversation.
 * Subscribe to the conversation stream before calling this mutation.
 */
export type HouseholdSendChatMessageInput = {
  /**
   * Optional focus context: the explicit object the user was focused on when they
   * chose to send this message. Persisted on the message and used to center the
   * assistant's answer on that object.
   */
  context?: InputMaybe<HouseholdChatMessageContextInput>;
  /** Conversation receiving the new user message. */
  conversationID: Scalars['ID']['input'];
  /** Bounded editor state. Contains no identity or permissions. */
  diagramContext?: InputMaybe<DiagramEditorContextInput>;
  /** The household this chat is scoped to. */
  householdID: Scalars['ID']['input'];
  /** The user's message. */
  message: Scalars['String']['input'];
  /**
   * Optional research mode for this turn. Omitted defaults to DEEP server-side,
   * preserving the existing contract.
   */
  mode?: InputMaybe<ChatMode>;
  /**
   * Optional specialized persona for this turn. When set, the agent runs with the
   * persona's specialist configuration instead of the default chat behavior, and
   * mode is ignored.
   */
  persona?: InputMaybe<ChatPersona>;
  /**
   * Reference images uploaded with this message. Each PNG, JPEG, or WebP image
   * can be up to 20 MiB and 40 megapixels. Images are stored with the user
   * message, not as household documents.
   */
  uploadedFiles?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /**
   * Optional memo, diagram, or no-docs onboarding prompt template for this message.
   * For no-docs onboarding templates, message must contain the full resolved prompt text.
   */
  withPromptTemplate?: InputMaybe<HouseholdChatPromptTemplate>;
};

/**
 * Payload returned by sendHouseholdChatMessage.
 * Contains the workflow tracker for the started chat turn.
 */
export type HouseholdSendChatMessagePayload = {
  __typename?: 'HouseholdSendChatMessagePayload';
  workflowTracker: WorkflowTracker;
};

/**
 * Input for starting a household chat stream.
 * If conversationID is null, a new household-scoped conversation is created.
 * If provided, the existing conversation is reused.
 * Clients should subscribe to the conversation stream before sending the first message.
 */
export type HouseholdStartChatStreamInput = {
  /** Optional conversation ID. If null, creates a new conversation; if provided, reuses it. */
  conversationID?: InputMaybe<Scalars['ID']['input']>;
  /** The household this chat is scoped to. */
  householdID: Scalars['ID']['input'];
  /** Optional context about where/what the user was looking at when they opened the chat. */
  metadata?: InputMaybe<ConversationChatMetadataInput>;
};

/**
 * Payload returned by startHouseholdChatStream.
 * Contains the conversation that clients should subscribe to.
 */
export type HouseholdStartChatStreamPayload = {
  __typename?: 'HouseholdStartChatStreamPayload';
  conversation: Conversation;
};

/**
 * HouseholdWhereInput is used for filtering Household objects.
 * Input was generated by ent.
 */
export type HouseholdWhereInput = {
  and?: InputMaybe<Array<HouseholdWhereInput>>;
  /** archived_at field predicates */
  archivedAt?: InputMaybe<Scalars['Time']['input']>;
  archivedAtGT?: InputMaybe<Scalars['Time']['input']>;
  archivedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  archivedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  archivedAtLT?: InputMaybe<Scalars['Time']['input']>;
  archivedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  archivedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billable_kind field predicates */
  billableKind?: InputMaybe<HouseholdBillableKind>;
  billableKindIn?: InputMaybe<Array<HouseholdBillableKind>>;
  billableKindNEQ?: InputMaybe<HouseholdBillableKind>;
  billableKindNotIn?: InputMaybe<Array<HouseholdBillableKind>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** activities edge predicates */
  hasActivities?: InputMaybe<Scalars['Boolean']['input']>;
  hasActivitiesWith?: InputMaybe<Array<ActivityWhereInput>>;
  /** assigned_employees edge predicates */
  hasAssignedEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssignedEmployeesWith?: InputMaybe<Array<EmployeeWhereInput>>;
  /** assigned_teams edge predicates */
  hasAssignedTeams?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssignedTeamsWith?: InputMaybe<Array<TeamWhereInput>>;
  /** balance_sheet_view_configuration edge predicates */
  hasBalanceSheetViewConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBalanceSheetViewConfigurationWith?: InputMaybe<Array<BalanceSheetViewConfigurationWhereInput>>;
  /** cashflows edge predicates */
  hasCashflows?: InputMaybe<Scalars['Boolean']['input']>;
  hasCashflowsWith?: InputMaybe<Array<CashflowWhereInput>>;
  /** client_organizations edge predicates */
  hasClientOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientOrganizationsWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** client_profiles edge predicates */
  hasClientProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientProfilesWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** collaborators edge predicates */
  hasCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
  hasCollaboratorsWith?: InputMaybe<Array<CollaboratorWhereInput>>;
  /** default_first_to_die_client edge predicates */
  hasDefaultFirstToDieClient?: InputMaybe<Scalars['Boolean']['input']>;
  hasDefaultFirstToDieClientWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** documents edge predicates */
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** entities edge predicates */
  hasEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntitiesWith?: InputMaybe<Array<EntityWhereInput>>;
  /** entity_graph_views edge predicates */
  hasEntityGraphViews?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityGraphViewsWith?: InputMaybe<Array<EntityGraphViewWhereInput>>;
  /** estate_tax_scenarios edge predicates */
  hasEstateTaxScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasEstateTaxScenariosWith?: InputMaybe<Array<EstateTaxScenarioWhereInput>>;
  /** estate_waterfalls edge predicates */
  hasEstateWaterfalls?: InputMaybe<Scalars['Boolean']['input']>;
  hasEstateWaterfallsWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** family_tree_configuration edge predicates */
  hasFamilyTreeConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasFamilyTreeConfigurationWith?: InputMaybe<Array<FamilyTreeConfigurationWhereInput>>;
  /** growth_profiles edge predicates */
  hasGrowthProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrowthProfilesWith?: InputMaybe<Array<GrowthProfileWhereInput>>;
  /** integration_clients edge predicates */
  hasIntegrationClients?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntegrationClientsWith?: InputMaybe<Array<IntegrationClientWhereInput>>;
  /** liabilities edge predicates */
  hasLiabilities?: InputMaybe<Scalars['Boolean']['input']>;
  hasLiabilitiesWith?: InputMaybe<Array<LiabilityWhereInput>>;
  /** onboarding_kg_roots edge predicates */
  hasOnboardingKgRoots?: InputMaybe<Scalars['Boolean']['input']>;
  hasOnboardingKgRootsWith?: InputMaybe<Array<KgRootWhereInput>>;
  /** primary_relationship_owner edge predicates */
  hasPrimaryRelationshipOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasPrimaryRelationshipOwnerWith?: InputMaybe<Array<UserWhereInput>>;
  /** proposals edge predicates */
  hasProposals?: InputMaybe<Scalars['Boolean']['input']>;
  hasProposalsWith?: InputMaybe<Array<ProposalWhereInput>>;
  /** sub_brand edge predicates */
  hasSubBrand?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubBrandWith?: InputMaybe<Array<SubBrandWhereInput>>;
  /** testamentary_entities edge predicates */
  hasTestamentaryEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasTestamentaryEntitiesWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_management_source field predicates */
  householdManagementSource?: InputMaybe<HouseholdManagementSource>;
  householdManagementSourceIn?: InputMaybe<Array<HouseholdManagementSource>>;
  householdManagementSourceNEQ?: InputMaybe<HouseholdManagementSource>;
  householdManagementSourceNotIn?: InputMaybe<Array<HouseholdManagementSource>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** new_individuals_automatically_onboarded_at field predicates */
  newIndividualsAutomaticallyOnboardedAt?: InputMaybe<Scalars['Time']['input']>;
  newIndividualsAutomaticallyOnboardedAtGT?: InputMaybe<Scalars['Time']['input']>;
  newIndividualsAutomaticallyOnboardedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  newIndividualsAutomaticallyOnboardedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  newIndividualsAutomaticallyOnboardedAtLT?: InputMaybe<Scalars['Time']['input']>;
  newIndividualsAutomaticallyOnboardedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  newIndividualsAutomaticallyOnboardedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<HouseholdWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<HouseholdWhereInput>>;
  /** private field predicates */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_generate_v2_suggestions_prompt field predicates */
  showGenerateV2SuggestionsPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  showGenerateV2SuggestionsPromptIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  showGenerateV2SuggestionsPromptNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** validation_questions_answered_at field predicates */
  validationQuestionsAnsweredAt?: InputMaybe<Scalars['Time']['input']>;
  validationQuestionsAnsweredAtGT?: InputMaybe<Scalars['Time']['input']>;
  validationQuestionsAnsweredAtGTE?: InputMaybe<Scalars['Time']['input']>;
  validationQuestionsAnsweredAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  validationQuestionsAnsweredAtLT?: InputMaybe<Scalars['Time']['input']>;
  validationQuestionsAnsweredAtLTE?: InputMaybe<Scalars['Time']['input']>;
  validationQuestionsAnsweredAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Filtering options for a household's workflow tracker history. All populated
 * fields are combined with AND. Values within statusIn, statuses, and kinds are combined
 * with OR.
 */
export type HouseholdWorkflowTrackerFilter = {
  /** Return trackers that ended after this time. */
  endedAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Return trackers that ended before this time. */
  endedBefore?: InputMaybe<Scalars['Time']['input']>;
  /** Return trackers whose kind is any listed value. */
  kinds?: InputMaybe<Array<WorkflowTrackerKind>>;
  /** Return trackers that started after this time. */
  startedAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Return trackers that started before this time. */
  startedBefore?: InputMaybe<Scalars['Time']['input']>;
  /** Return trackers whose status is any listed value. */
  statusIn?: InputMaybe<Array<WorkflowTrackerStatus>>;
  /** Return trackers whose status is any listed value. */
  statuses?: InputMaybe<Array<WorkflowTrackerStatus>>;
};

export type HypotheticalClt = Node & {
  __typename?: 'HypotheticalCLT';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
  /** The funding source for this hypothetical CLT. */
  funding?: Maybe<HypotheticalTransferFundingSource>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  /** The estate waterfall this hypothetical CLT belongs to. */
  hypotheticalWaterfall: EstateWaterfall;
  id: Scalars['ID']['output'];
  /** The CLT proposal that is being simulated. */
  simulatedClt: Proposal;
  /** The entity from which to source the funding for this hypothetical CLT. */
  sourceEntity?: Maybe<Entity>;
  /** The individual from which to source the funding for this hypothetical CLT. */
  sourceIndividual?: Maybe<ClientProfile>;
  sourceKind?: Maybe<HypotheticalCltSourceKind>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};

/** A connection to a list of items. */
export type HypotheticalCltConnection = {
  __typename?: 'HypotheticalCLTConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<HypotheticalCltEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type HypotheticalCltEdge = {
  __typename?: 'HypotheticalCLTEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<HypotheticalClt>;
};

/** Ordering options for HypotheticalCLT connections */
export type HypotheticalCltOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order HypotheticalCLTs. */
  field: HypotheticalCltOrderField;
};

/** Properties by which HypotheticalCLT connections can be ordered. */
export enum HypotheticalCltOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** HypotheticalCLTSourceKind is enum for the field source_kind */
export enum HypotheticalCltSourceKind {
  Entity = 'ENTITY',
  Individual = 'INDIVIDUAL'
}

/**
 * HypotheticalCLTWhereInput is used for filtering HypotheticalCLT objects.
 * Input was generated by ent.
 */
export type HypotheticalCltWhereInput = {
  and?: InputMaybe<Array<HypotheticalCltWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** funding edge predicates */
  hasFunding?: InputMaybe<Scalars['Boolean']['input']>;
  hasFundingWith?: InputMaybe<Array<HypotheticalTransferFundingSourceWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_waterfall edge predicates */
  hasHypotheticalWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** simulated_clt edge predicates */
  hasSimulatedClt?: InputMaybe<Scalars['Boolean']['input']>;
  hasSimulatedCltWith?: InputMaybe<Array<ProposalWhereInput>>;
  /** source_entity edge predicates */
  hasSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** source_individual edge predicates */
  hasSourceIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<HypotheticalCltWhereInput>;
  or?: InputMaybe<Array<HypotheticalCltWhereInput>>;
  /** source_kind field predicates */
  sourceKind?: InputMaybe<HypotheticalCltSourceKind>;
  sourceKindIn?: InputMaybe<Array<HypotheticalCltSourceKind>>;
  sourceKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sourceKindNEQ?: InputMaybe<HypotheticalCltSourceKind>;
  sourceKindNotIn?: InputMaybe<Array<HypotheticalCltSourceKind>>;
  sourceKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type HypotheticalCrt = Node & {
  __typename?: 'HypotheticalCRT';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
  /** The funding source for this hypothetical CRT. */
  funding?: Maybe<HypotheticalTransferFundingSource>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  /** The estate waterfall this hypothetical CRT belongs to. */
  hypotheticalWaterfall: EstateWaterfall;
  id: Scalars['ID']['output'];
  /** The CRT proposal that is being simulated. */
  simulatedCrt: Proposal;
  /** The entity from which to source the funding for this hypothetical CRT. */
  sourceEntity?: Maybe<Entity>;
  /** The individual from which to source the funding for this hypothetical CRT. */
  sourceIndividual?: Maybe<ClientProfile>;
  sourceKind?: Maybe<HypotheticalCrtSourceKind>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};

/** A connection to a list of items. */
export type HypotheticalCrtConnection = {
  __typename?: 'HypotheticalCRTConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<HypotheticalCrtEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type HypotheticalCrtEdge = {
  __typename?: 'HypotheticalCRTEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<HypotheticalCrt>;
};

/** Ordering options for HypotheticalCRT connections */
export type HypotheticalCrtOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order HypotheticalCRTs. */
  field: HypotheticalCrtOrderField;
};

/** Properties by which HypotheticalCRT connections can be ordered. */
export enum HypotheticalCrtOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** HypotheticalCRTSourceKind is enum for the field source_kind */
export enum HypotheticalCrtSourceKind {
  Entity = 'ENTITY',
  Individual = 'INDIVIDUAL'
}

/**
 * HypotheticalCRTWhereInput is used for filtering HypotheticalCRT objects.
 * Input was generated by ent.
 */
export type HypotheticalCrtWhereInput = {
  and?: InputMaybe<Array<HypotheticalCrtWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** funding edge predicates */
  hasFunding?: InputMaybe<Scalars['Boolean']['input']>;
  hasFundingWith?: InputMaybe<Array<HypotheticalTransferFundingSourceWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_waterfall edge predicates */
  hasHypotheticalWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** simulated_crt edge predicates */
  hasSimulatedCrt?: InputMaybe<Scalars['Boolean']['input']>;
  hasSimulatedCrtWith?: InputMaybe<Array<ProposalWhereInput>>;
  /** source_entity edge predicates */
  hasSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** source_individual edge predicates */
  hasSourceIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<HypotheticalCrtWhereInput>;
  or?: InputMaybe<Array<HypotheticalCrtWhereInput>>;
  /** source_kind field predicates */
  sourceKind?: InputMaybe<HypotheticalCrtSourceKind>;
  sourceKindIn?: InputMaybe<Array<HypotheticalCrtSourceKind>>;
  sourceKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sourceKindNEQ?: InputMaybe<HypotheticalCrtSourceKind>;
  sourceKindNotIn?: InputMaybe<Array<HypotheticalCrtSourceKind>>;
  sourceKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type HypotheticalGrat = Node & {
  __typename?: 'HypotheticalGRAT';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
  /** The funding source for this hypothetical GRAT. */
  funding?: Maybe<HypotheticalTransferFundingSource>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  /** The estate waterfall this hypothetical GRAT belongs to. */
  hypotheticalWaterfall: EstateWaterfall;
  id: Scalars['ID']['output'];
  /** The GRAT trust that is being simulated. */
  simulatedGrat: Entity;
  /** The entity from which to source the funding for this hypothetical GRAT. */
  sourceEntity?: Maybe<Entity>;
  /** The individual from which to source the funding for this hypothetical GRAT. */
  sourceIndividual?: Maybe<ClientProfile>;
  sourceKind: HypotheticalGratSourceKind;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};

/** A connection to a list of items. */
export type HypotheticalGratConnection = {
  __typename?: 'HypotheticalGRATConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<HypotheticalGratEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type HypotheticalGratEdge = {
  __typename?: 'HypotheticalGRATEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<HypotheticalGrat>;
};

/** Ordering options for HypotheticalGRAT connections */
export type HypotheticalGratOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order HypotheticalGRATs. */
  field: HypotheticalGratOrderField;
};

/** Properties by which HypotheticalGRAT connections can be ordered. */
export enum HypotheticalGratOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** HypotheticalGRATSourceKind is enum for the field source_kind */
export enum HypotheticalGratSourceKind {
  Entity = 'ENTITY',
  Individual = 'INDIVIDUAL'
}

/**
 * HypotheticalGRATWhereInput is used for filtering HypotheticalGRAT objects.
 * Input was generated by ent.
 */
export type HypotheticalGratWhereInput = {
  and?: InputMaybe<Array<HypotheticalGratWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** funding edge predicates */
  hasFunding?: InputMaybe<Scalars['Boolean']['input']>;
  hasFundingWith?: InputMaybe<Array<HypotheticalTransferFundingSourceWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_waterfall edge predicates */
  hasHypotheticalWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** simulated_grat edge predicates */
  hasSimulatedGrat?: InputMaybe<Scalars['Boolean']['input']>;
  hasSimulatedGratWith?: InputMaybe<Array<EntityWhereInput>>;
  /** source_entity edge predicates */
  hasSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** source_individual edge predicates */
  hasSourceIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<HypotheticalGratWhereInput>;
  or?: InputMaybe<Array<HypotheticalGratWhereInput>>;
  /** source_kind field predicates */
  sourceKind?: InputMaybe<HypotheticalGratSourceKind>;
  sourceKindIn?: InputMaybe<Array<HypotheticalGratSourceKind>>;
  sourceKindNEQ?: InputMaybe<HypotheticalGratSourceKind>;
  sourceKindNotIn?: InputMaybe<Array<HypotheticalGratSourceKind>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type HypotheticalInsurance = Node & {
  __typename?: 'HypotheticalInsurance';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The new insurance policy this hypothetical insurance will create. */
  createdInsurancePolicy?: Maybe<InsurancePolicy>;
  /** The entity this hypothetical insurance will transfer to. */
  destinationEntity?: Maybe<Entity>;
  /** The entity this hypothetical insurance will transfer to. */
  destinationEntityID?: Maybe<Scalars['ID']['output']>;
  displayName: Scalars['String']['output'];
  /** The year this hypothetical insurance ends. Ignored if end_on_kind:YEAR is not set. */
  endYear?: Maybe<Scalars['Int']['output']>;
  /** The kind of the end date for this hypothetical insurance. */
  endsOnKind: HypotheticalInsuranceEndsOnKind;
  /** The estate waterfall this hypothetical insurance belongs to */
  estateWaterfall: EstateWaterfall;
  /** The existing insurance policy this hypothetical insurance will transfer. */
  existingInsurancePolicy?: Maybe<InsurancePolicy>;
  /** The entity this hypothetical insurance will transfer from. If this is set, then the existing_insurance_policy must also be set. */
  existingInsurancePolicyHolder?: Maybe<Entity>;
  /** The entity this hypothetical insurance will transfer from. If this is set, then the existing_insurance_policy must also be set. */
  existingInsurancePolicyHolderEntityID?: Maybe<Scalars['ID']['output']>;
  /** The existing insurance policy this hypothetical insurance will transfer. */
  existingInsurancePolicyID?: Maybe<Scalars['ID']['output']>;
  /**
   * This is the list of grantors that made the gift.
   * 			Will only be read if the transfer tax kind is GRANTOR_TAXABLE_GIFT.
   * 			Can set one or both grantors.
   * 			MUST NOT be empty if the transfer tax kind is GRANTOR_TAXABLE_GIFT.
   */
  giftingGrantors?: Maybe<Array<ClientProfile>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The entity from which to source the funding for this hypothetical insurance. */
  sourceEntity?: Maybe<Entity>;
  /** The entity from which to source the funding for this hypothetical insurance. */
  sourceEntityID?: Maybe<Scalars['ID']['output']>;
  /** The individual from which to source the funding for this hypothetical insurance. */
  sourceIndividual?: Maybe<ClientProfile>;
  /** The individual from which to source the funding for this hypothetical insurance. */
  sourceIndividualID?: Maybe<Scalars['ID']['output']>;
  /** The kind of the source for this hypothetical insurance. */
  sourceKind: HypotheticalInsuranceSourceKind;
  /** The year this insurance policy starts or is transferred. If not set then it is assumed to be the current year. */
  startYear?: Maybe<Scalars['Int']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The frequency of the transfer. */
  transferFrequency: HypotheticalInsuranceTransferFrequency;
  transferTaxKind: HypotheticalInsuranceTransferTaxKind;
  /** Value of this transfer. */
  transferValue: Scalars['CurrencyUSD']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};

/** A connection to a list of items. */
export type HypotheticalInsuranceConnection = {
  __typename?: 'HypotheticalInsuranceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<HypotheticalInsuranceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type HypotheticalInsuranceEdge = {
  __typename?: 'HypotheticalInsuranceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<HypotheticalInsurance>;
};

/** HypotheticalInsuranceEndsOnKind is enum for the field ends_on_kind */
export enum HypotheticalInsuranceEndsOnKind {
  PolicyHolderDeath = 'POLICY_HOLDER_DEATH',
  TrustTermination = 'TRUST_TERMINATION',
  Year = 'YEAR'
}

/** Ordering options for HypotheticalInsurance connections */
export type HypotheticalInsuranceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order HypotheticalInsurances. */
  field: HypotheticalInsuranceOrderField;
};

/** Properties by which HypotheticalInsurance connections can be ordered. */
export enum HypotheticalInsuranceOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** HypotheticalInsuranceSourceKind is enum for the field source_kind */
export enum HypotheticalInsuranceSourceKind {
  Entity = 'ENTITY',
  Individual = 'INDIVIDUAL'
}

/** HypotheticalInsuranceTransferFrequency is enum for the field transfer_frequency */
export enum HypotheticalInsuranceTransferFrequency {
  Annual = 'ANNUAL',
  OneTime = 'ONE_TIME'
}

/** HypotheticalInsuranceTransferTaxKind is enum for the field transfer_tax_kind */
export enum HypotheticalInsuranceTransferTaxKind {
  AnnualExclusionGiftWithCrummeyPowers = 'ANNUAL_EXCLUSION_GIFT_WITH_CRUMMEY_POWERS',
  GrantorTaxableGift = 'GRANTOR_TAXABLE_GIFT',
  NonTaxable = 'NON_TAXABLE'
}

/**
 * HypotheticalInsuranceWhereInput is used for filtering HypotheticalInsurance objects.
 * Input was generated by ent.
 */
export type HypotheticalInsuranceWhereInput = {
  and?: InputMaybe<Array<HypotheticalInsuranceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** destination_entity_id field predicates */
  destinationEntityID?: InputMaybe<Scalars['ID']['input']>;
  destinationEntityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  destinationEntityIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  destinationEntityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  destinationEntityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  destinationEntityIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** end_year field predicates */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  endYearGT?: InputMaybe<Scalars['Int']['input']>;
  endYearGTE?: InputMaybe<Scalars['Int']['input']>;
  endYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endYearLT?: InputMaybe<Scalars['Int']['input']>;
  endYearLTE?: InputMaybe<Scalars['Int']['input']>;
  endYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  endYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ends_on_kind field predicates */
  endsOnKind?: InputMaybe<HypotheticalInsuranceEndsOnKind>;
  endsOnKindIn?: InputMaybe<Array<HypotheticalInsuranceEndsOnKind>>;
  endsOnKindNEQ?: InputMaybe<HypotheticalInsuranceEndsOnKind>;
  endsOnKindNotIn?: InputMaybe<Array<HypotheticalInsuranceEndsOnKind>>;
  /** existing_insurance_policy_holder_entity_id field predicates */
  existingInsurancePolicyHolderEntityID?: InputMaybe<Scalars['ID']['input']>;
  existingInsurancePolicyHolderEntityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  existingInsurancePolicyHolderEntityIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  existingInsurancePolicyHolderEntityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  existingInsurancePolicyHolderEntityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  existingInsurancePolicyHolderEntityIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** existing_insurance_policy_id field predicates */
  existingInsurancePolicyID?: InputMaybe<Scalars['ID']['input']>;
  existingInsurancePolicyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  existingInsurancePolicyIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  existingInsurancePolicyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  existingInsurancePolicyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  existingInsurancePolicyIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_insurance_policy edge predicates */
  hasCreatedInsurancePolicy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedInsurancePolicyWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** destination_entity edge predicates */
  hasDestinationEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasDestinationEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** estate_waterfall edge predicates */
  hasEstateWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasEstateWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** existing_insurance_policy edge predicates */
  hasExistingInsurancePolicy?: InputMaybe<Scalars['Boolean']['input']>;
  /** existing_insurance_policy_holder edge predicates */
  hasExistingInsurancePolicyHolder?: InputMaybe<Scalars['Boolean']['input']>;
  hasExistingInsurancePolicyHolderWith?: InputMaybe<Array<EntityWhereInput>>;
  hasExistingInsurancePolicyWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** gifting_grantors edge predicates */
  hasGiftingGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  hasGiftingGrantorsWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** source_entity edge predicates */
  hasSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** source_individual edge predicates */
  hasSourceIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<HypotheticalInsuranceWhereInput>;
  or?: InputMaybe<Array<HypotheticalInsuranceWhereInput>>;
  /** source_entity_id field predicates */
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceEntityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceEntityIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sourceEntityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  sourceEntityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceEntityIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** source_individual_id field predicates */
  sourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  sourceIndividualIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceIndividualIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sourceIndividualIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  sourceIndividualIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceIndividualIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** source_kind field predicates */
  sourceKind?: InputMaybe<HypotheticalInsuranceSourceKind>;
  sourceKindIn?: InputMaybe<Array<HypotheticalInsuranceSourceKind>>;
  sourceKindNEQ?: InputMaybe<HypotheticalInsuranceSourceKind>;
  sourceKindNotIn?: InputMaybe<Array<HypotheticalInsuranceSourceKind>>;
  /** start_year field predicates */
  startYear?: InputMaybe<Scalars['Int']['input']>;
  startYearGT?: InputMaybe<Scalars['Int']['input']>;
  startYearGTE?: InputMaybe<Scalars['Int']['input']>;
  startYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startYearLT?: InputMaybe<Scalars['Int']['input']>;
  startYearLTE?: InputMaybe<Scalars['Int']['input']>;
  startYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  startYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** transfer_frequency field predicates */
  transferFrequency?: InputMaybe<HypotheticalInsuranceTransferFrequency>;
  transferFrequencyIn?: InputMaybe<Array<HypotheticalInsuranceTransferFrequency>>;
  transferFrequencyNEQ?: InputMaybe<HypotheticalInsuranceTransferFrequency>;
  transferFrequencyNotIn?: InputMaybe<Array<HypotheticalInsuranceTransferFrequency>>;
  /** transfer_tax_kind field predicates */
  transferTaxKind?: InputMaybe<HypotheticalInsuranceTransferTaxKind>;
  transferTaxKindIn?: InputMaybe<Array<HypotheticalInsuranceTransferTaxKind>>;
  transferTaxKindNEQ?: InputMaybe<HypotheticalInsuranceTransferTaxKind>;
  transferTaxKindNotIn?: InputMaybe<Array<HypotheticalInsuranceTransferTaxKind>>;
  /** transfer_value field predicates */
  transferValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  transferValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type HypotheticalSaleLoan = Node & {
  __typename?: 'HypotheticalSaleLoan';
  /** Applicable AFR for the sale or loan. */
  afrRate: Scalars['Percent']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
  funding?: Maybe<HypotheticalTransferFundingSource>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalWaterfall: EstateWaterfall;
  id: Scalars['ID']['output'];
  kind: HypotheticalSaleLoanKind;
  paymentModel: HypotheticalSaleLoanPaymentModel;
  pretermGrantorDeathHandling: HypotheticalSaleLoanPretermGrantorDeathHandling;
  recipientEntity?: Maybe<Entity>;
  recipientIndividual?: Maybe<ClientProfile>;
  recipientKind: HypotheticalSaleLoanRecipientKind;
  sourceEntity?: Maybe<Entity>;
  sourceIndividual?: Maybe<ClientProfile>;
  sourceKind: HypotheticalSaleLoanSourceKind;
  /** The effective date of the sale or loan for modeling purposes */
  startDate: Scalars['Time']['output'];
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  termLengthYears: Scalars['Int']['output'];
  /** How the transfer is made to the recipient. IN_KIND preserves the asset thus keeping the source asset growth characteristics, LIQUIDATE_TO_CASH sells the asset thus gaining the destination asset growth characteristics. */
  transferMethod: TransferMethod;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type HypotheticalSaleLoanConnection = {
  __typename?: 'HypotheticalSaleLoanConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<HypotheticalSaleLoanEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type HypotheticalSaleLoanEdge = {
  __typename?: 'HypotheticalSaleLoanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<HypotheticalSaleLoan>;
};

/** HypotheticalSaleLoanKind is enum for the field kind */
export enum HypotheticalSaleLoanKind {
  Loan = 'LOAN',
  Sale = 'SALE'
}

/** Ordering options for HypotheticalSaleLoan connections */
export type HypotheticalSaleLoanOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order HypotheticalSaleLoans. */
  field: HypotheticalSaleLoanOrderField;
};

/** Properties by which HypotheticalSaleLoan connections can be ordered. */
export enum HypotheticalSaleLoanOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** HypotheticalSaleLoanPaymentModel is enum for the field payment_model */
export enum HypotheticalSaleLoanPaymentModel {
  Amortizing = 'AMORTIZING',
  InterestOnlyWithBalloon = 'INTEREST_ONLY_WITH_BALLOON',
  LumpSum = 'LUMP_SUM'
}

/** HypotheticalSaleLoanPretermGrantorDeathHandling is enum for the field preterm_grantor_death_handling */
export enum HypotheticalSaleLoanPretermGrantorDeathHandling {
  Cancellation = 'CANCELLATION',
  Repayment = 'REPAYMENT'
}

/** HypotheticalSaleLoanRecipientKind is enum for the field recipient_kind */
export enum HypotheticalSaleLoanRecipientKind {
  Entity = 'ENTITY',
  Individual = 'INDIVIDUAL'
}

/** HypotheticalSaleLoanSourceKind is enum for the field source_kind */
export enum HypotheticalSaleLoanSourceKind {
  Entity = 'ENTITY',
  Individual = 'INDIVIDUAL'
}

/**
 * HypotheticalSaleLoanWhereInput is used for filtering HypotheticalSaleLoan objects.
 * Input was generated by ent.
 */
export type HypotheticalSaleLoanWhereInput = {
  /** afr_rate field predicates */
  afrRate?: InputMaybe<Scalars['Percent']['input']>;
  afrRateGT?: InputMaybe<Scalars['Percent']['input']>;
  afrRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  afrRateLT?: InputMaybe<Scalars['Percent']['input']>;
  afrRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  afrRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  and?: InputMaybe<Array<HypotheticalSaleLoanWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** funding edge predicates */
  hasFunding?: InputMaybe<Scalars['Boolean']['input']>;
  hasFundingWith?: InputMaybe<Array<HypotheticalTransferFundingSourceWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_waterfall edge predicates */
  hasHypotheticalWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** recipient_entity edge predicates */
  hasRecipientEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecipientEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** recipient_individual edge predicates */
  hasRecipientIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecipientIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** source_entity edge predicates */
  hasSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** source_individual edge predicates */
  hasSourceIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<HypotheticalSaleLoanKind>;
  kindIn?: InputMaybe<Array<HypotheticalSaleLoanKind>>;
  kindNEQ?: InputMaybe<HypotheticalSaleLoanKind>;
  kindNotIn?: InputMaybe<Array<HypotheticalSaleLoanKind>>;
  not?: InputMaybe<HypotheticalSaleLoanWhereInput>;
  or?: InputMaybe<Array<HypotheticalSaleLoanWhereInput>>;
  /** payment_model field predicates */
  paymentModel?: InputMaybe<HypotheticalSaleLoanPaymentModel>;
  paymentModelIn?: InputMaybe<Array<HypotheticalSaleLoanPaymentModel>>;
  paymentModelNEQ?: InputMaybe<HypotheticalSaleLoanPaymentModel>;
  paymentModelNotIn?: InputMaybe<Array<HypotheticalSaleLoanPaymentModel>>;
  /** preterm_grantor_death_handling field predicates */
  pretermGrantorDeathHandling?: InputMaybe<HypotheticalSaleLoanPretermGrantorDeathHandling>;
  pretermGrantorDeathHandlingIn?: InputMaybe<Array<HypotheticalSaleLoanPretermGrantorDeathHandling>>;
  pretermGrantorDeathHandlingNEQ?: InputMaybe<HypotheticalSaleLoanPretermGrantorDeathHandling>;
  pretermGrantorDeathHandlingNotIn?: InputMaybe<Array<HypotheticalSaleLoanPretermGrantorDeathHandling>>;
  /** recipient_kind field predicates */
  recipientKind?: InputMaybe<HypotheticalSaleLoanRecipientKind>;
  recipientKindIn?: InputMaybe<Array<HypotheticalSaleLoanRecipientKind>>;
  recipientKindNEQ?: InputMaybe<HypotheticalSaleLoanRecipientKind>;
  recipientKindNotIn?: InputMaybe<Array<HypotheticalSaleLoanRecipientKind>>;
  /** source_kind field predicates */
  sourceKind?: InputMaybe<HypotheticalSaleLoanSourceKind>;
  sourceKindIn?: InputMaybe<Array<HypotheticalSaleLoanSourceKind>>;
  sourceKindNEQ?: InputMaybe<HypotheticalSaleLoanSourceKind>;
  sourceKindNotIn?: InputMaybe<Array<HypotheticalSaleLoanSourceKind>>;
  /** start_date field predicates */
  startDate?: InputMaybe<Scalars['Time']['input']>;
  startDateGT?: InputMaybe<Scalars['Time']['input']>;
  startDateGTE?: InputMaybe<Scalars['Time']['input']>;
  startDateLT?: InputMaybe<Scalars['Time']['input']>;
  startDateLTE?: InputMaybe<Scalars['Time']['input']>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** term_length_years field predicates */
  termLengthYears?: InputMaybe<Scalars['Int']['input']>;
  termLengthYearsGT?: InputMaybe<Scalars['Int']['input']>;
  termLengthYearsGTE?: InputMaybe<Scalars['Int']['input']>;
  termLengthYearsLT?: InputMaybe<Scalars['Int']['input']>;
  termLengthYearsLTE?: InputMaybe<Scalars['Int']['input']>;
  termLengthYearsNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** transfer_method field predicates */
  transferMethod?: InputMaybe<TransferMethod>;
  transferMethodIn?: InputMaybe<Array<TransferMethod>>;
  transferMethodNEQ?: InputMaybe<TransferMethod>;
  transferMethodNotIn?: InputMaybe<Array<TransferMethod>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type HypotheticalTransferAsset = Node & {
  __typename?: 'HypotheticalTransferAsset';
  /** This is only present if kind is ASSET_CLASS */
  assetClass?: Maybe<AssetClass>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalTransferFundingSource?: Maybe<HypotheticalTransferFundingSource>;
  id: Scalars['ID']['output'];
  kind: HypotheticalTransferAssetKind;
  /** This is only present if kind is BUSINESS_OWNERSHIP. Must be a business entity. */
  ownedBusiness?: Maybe<Entity>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  /** The absolute value of this business or asset class being transferred. Present if the source `kind` is SPECIFIC_ASSETS_AMOUNT. */
  valueAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The percentage of the business or asset class being transferred. Present if the source `kind` is SPECIFIC_ASSETS_PERCENTAGE. */
  valuePercentage?: Maybe<Scalars['Percent']['output']>;
};

/** A connection to a list of items. */
export type HypotheticalTransferAssetConnection = {
  __typename?: 'HypotheticalTransferAssetConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<HypotheticalTransferAssetEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type HypotheticalTransferAssetEdge = {
  __typename?: 'HypotheticalTransferAssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<HypotheticalTransferAsset>;
};

/** HypotheticalTransferAssetKind is enum for the field kind */
export enum HypotheticalTransferAssetKind {
  AssetClass = 'ASSET_CLASS',
  BusinessOwnership = 'BUSINESS_OWNERSHIP'
}

/** Ordering options for HypotheticalTransferAsset connections */
export type HypotheticalTransferAssetOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order HypotheticalTransferAssets. */
  field: HypotheticalTransferAssetOrderField;
};

/** Properties by which HypotheticalTransferAsset connections can be ordered. */
export enum HypotheticalTransferAssetOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * HypotheticalTransferAssetWhereInput is used for filtering HypotheticalTransferAsset objects.
 * Input was generated by ent.
 */
export type HypotheticalTransferAssetWhereInput = {
  and?: InputMaybe<Array<HypotheticalTransferAssetWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** asset_class edge predicates */
  hasAssetClass?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetClassWith?: InputMaybe<Array<AssetClassWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_transfer_funding_source edge predicates */
  hasHypotheticalTransferFundingSource?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalTransferFundingSourceWith?: InputMaybe<Array<HypotheticalTransferFundingSourceWhereInput>>;
  /** owned_business edge predicates */
  hasOwnedBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnedBusinessWith?: InputMaybe<Array<EntityWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<HypotheticalTransferAssetKind>;
  kindIn?: InputMaybe<Array<HypotheticalTransferAssetKind>>;
  kindNEQ?: InputMaybe<HypotheticalTransferAssetKind>;
  kindNotIn?: InputMaybe<Array<HypotheticalTransferAssetKind>>;
  not?: InputMaybe<HypotheticalTransferAssetWhereInput>;
  or?: InputMaybe<Array<HypotheticalTransferAssetWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** value_amount field predicates */
  valueAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  valueAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** value_percentage field predicates */
  valuePercentage?: InputMaybe<Scalars['Percent']['input']>;
  valuePercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  valuePercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  valuePercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  valuePercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  valuePercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  valuePercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  valuePercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HypotheticalTransferFundingSource = Node & {
  __typename?: 'HypotheticalTransferFundingSource';
  assets: HypotheticalTransferAssetConnection;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalClt?: Maybe<HypotheticalClt>;
  hypotheticalCrt?: Maybe<HypotheticalCrt>;
  hypotheticalGrat?: Maybe<HypotheticalGrat>;
  hypotheticalSaleLoan?: Maybe<HypotheticalSaleLoan>;
  id: Scalars['ID']['output'];
  /** The strategy used to fund the transfer. NOTE: PRO_RATA_xxx is not actually pro_rata but rather our default disbursement strategy instead. */
  kind: HypotheticalTransferFundingSourceKind;
  /** The amount of the transfer. Only valid when kind is PRO_RATA_AMOUNT */
  proRataAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The percentage of the transfer. Only valid when kind is PRO_RATA_PERCENTAGE */
  proRataPercentage?: Maybe<Scalars['Percent']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** How the transfer is made to the recipient. IN_KIND preserves the asset thus keeping the source asset growth characteristics, LIQUIDATE_TO_CASH sells the asset thus gaining the destination asset growth characteristics. */
  transferMethod: TransferMethod;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type HypotheticalTransferFundingSourceAssetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HypotheticalTransferAssetOrder>>;
  where?: InputMaybe<HypotheticalTransferAssetWhereInput>;
};

/** A connection to a list of items. */
export type HypotheticalTransferFundingSourceConnection = {
  __typename?: 'HypotheticalTransferFundingSourceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<HypotheticalTransferFundingSourceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type HypotheticalTransferFundingSourceEdge = {
  __typename?: 'HypotheticalTransferFundingSourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<HypotheticalTransferFundingSource>;
};

/** HypotheticalTransferFundingSourceKind is enum for the field kind */
export enum HypotheticalTransferFundingSourceKind {
  ProRataAmount = 'PRO_RATA_AMOUNT',
  ProRataPercentage = 'PRO_RATA_PERCENTAGE',
  SpecificAssetsAmount = 'SPECIFIC_ASSETS_AMOUNT',
  SpecificAssetsPercentage = 'SPECIFIC_ASSETS_PERCENTAGE'
}

/** Ordering options for HypotheticalTransferFundingSource connections */
export type HypotheticalTransferFundingSourceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order HypotheticalTransferFundingSources. */
  field: HypotheticalTransferFundingSourceOrderField;
};

/** Properties by which HypotheticalTransferFundingSource connections can be ordered. */
export enum HypotheticalTransferFundingSourceOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * HypotheticalTransferFundingSourceWhereInput is used for filtering HypotheticalTransferFundingSource objects.
 * Input was generated by ent.
 */
export type HypotheticalTransferFundingSourceWhereInput = {
  and?: InputMaybe<Array<HypotheticalTransferFundingSourceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** assets edge predicates */
  hasAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetsWith?: InputMaybe<Array<HypotheticalTransferAssetWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_clt edge predicates */
  hasHypotheticalClt?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalCltWith?: InputMaybe<Array<HypotheticalCltWhereInput>>;
  /** hypothetical_crt edge predicates */
  hasHypotheticalCrt?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalCrtWith?: InputMaybe<Array<HypotheticalCrtWhereInput>>;
  /** hypothetical_grat edge predicates */
  hasHypotheticalGrat?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalGratWith?: InputMaybe<Array<HypotheticalGratWhereInput>>;
  /** hypothetical_sale_loan edge predicates */
  hasHypotheticalSaleLoan?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalSaleLoanWith?: InputMaybe<Array<HypotheticalSaleLoanWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<HypotheticalTransferFundingSourceKind>;
  kindIn?: InputMaybe<Array<HypotheticalTransferFundingSourceKind>>;
  kindNEQ?: InputMaybe<HypotheticalTransferFundingSourceKind>;
  kindNotIn?: InputMaybe<Array<HypotheticalTransferFundingSourceKind>>;
  not?: InputMaybe<HypotheticalTransferFundingSourceWhereInput>;
  or?: InputMaybe<Array<HypotheticalTransferFundingSourceWhereInput>>;
  /** pro_rata_amount field predicates */
  proRataAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  proRataAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  proRataAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  proRataAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  proRataAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  proRataAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  proRataAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  proRataAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** pro_rata_percentage field predicates */
  proRataPercentage?: InputMaybe<Scalars['Percent']['input']>;
  proRataPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  proRataPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  proRataPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  proRataPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  proRataPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  proRataPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  proRataPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** transfer_method field predicates */
  transferMethod?: InputMaybe<TransferMethod>;
  transferMethodIn?: InputMaybe<Array<TransferMethod>>;
  transferMethodNEQ?: InputMaybe<TransferMethod>;
  transferMethodNotIn?: InputMaybe<Array<TransferMethod>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type HypotheticalWaterfallDispositiveProvisionTemplate = Node & {
  __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate';
  /** The hypothetical estate waterfall associated with this template link. */
  associatedHypotheticalWaterfall: EstateWaterfall;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The dispositive provision template associated with this hypothetical waterfall. */
  dispositiveProvisionTemplate: DispositiveProvisionTemplate;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The testamentary entities that are associated with this hypothetical waterfall. */
  testamentaryEntity?: Maybe<TestamentaryEntity>;
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};

/** A connection to a list of items. */
export type HypotheticalWaterfallDispositiveProvisionTemplateConnection = {
  __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<HypotheticalWaterfallDispositiveProvisionTemplateEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type HypotheticalWaterfallDispositiveProvisionTemplateEdge = {
  __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<HypotheticalWaterfallDispositiveProvisionTemplate>;
};

/** Ordering options for HypotheticalWaterfallDispositiveProvisionTemplate connections */
export type HypotheticalWaterfallDispositiveProvisionTemplateOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order HypotheticalWaterfallDispositiveProvisionTemplates. */
  field: HypotheticalWaterfallDispositiveProvisionTemplateOrderField;
};

/** Properties by which HypotheticalWaterfallDispositiveProvisionTemplate connections can be ordered. */
export enum HypotheticalWaterfallDispositiveProvisionTemplateOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * HypotheticalWaterfallDispositiveProvisionTemplateWhereInput is used for filtering HypotheticalWaterfallDispositiveProvisionTemplate objects.
 * Input was generated by ent.
 */
export type HypotheticalWaterfallDispositiveProvisionTemplateWhereInput = {
  and?: InputMaybe<Array<HypotheticalWaterfallDispositiveProvisionTemplateWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** associated_hypothetical_waterfall edge predicates */
  hasAssociatedHypotheticalWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssociatedHypotheticalWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** dispositive_provision_template edge predicates */
  hasDispositiveProvisionTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositiveProvisionTemplateWith?: InputMaybe<Array<DispositiveProvisionTemplateWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** testamentary_entity edge predicates */
  hasTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasTestamentaryEntityWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<HypotheticalWaterfallDispositiveProvisionTemplateWhereInput>;
  or?: InputMaybe<Array<HypotheticalWaterfallDispositiveProvisionTemplateWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type IlitCrummeyLetter = Node & {
  __typename?: 'ILITCrummeyLetter';
  associatedTask?: Maybe<EntityTask>;
  createdAt: Scalars['Time']['output'];
  crummeyWithdrawalPeriodDays: Scalars['Int']['output'];
  /** Documents that are associated with this Crummey letter */
  documents?: Maybe<Array<Document>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  ilitTrust?: Maybe<IlitTrust>;
  recipient?: Maybe<ClientProfile>;
  sendBefore?: Maybe<Scalars['Time']['output']>;
  sentOn?: Maybe<Scalars['Time']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type IlitCrummeyLetterConnection = {
  __typename?: 'ILITCrummeyLetterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IlitCrummeyLetterEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IlitCrummeyLetterEdge = {
  __typename?: 'ILITCrummeyLetterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IlitCrummeyLetter>;
};

/** Ordering options for ILITCrummeyLetter connections */
export type IlitCrummeyLetterOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ILITCrummeyLetters. */
  field: IlitCrummeyLetterOrderField;
};

/** Properties by which ILITCrummeyLetter connections can be ordered. */
export enum IlitCrummeyLetterOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * ILITCrummeyLetterWhereInput is used for filtering ILITCrummeyLetter objects.
 * Input was generated by ent.
 */
export type IlitCrummeyLetterWhereInput = {
  and?: InputMaybe<Array<IlitCrummeyLetterWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** crummey_withdrawal_period_days field predicates */
  crummeyWithdrawalPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysGT?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysGTE?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysLT?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysLTE?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** associated_task edge predicates */
  hasAssociatedTask?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssociatedTaskWith?: InputMaybe<Array<EntityTaskWhereInput>>;
  /** documents edge predicates */
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** ilit_trust edge predicates */
  hasIlitTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasIlitTrustWith?: InputMaybe<Array<IlitTrustWhereInput>>;
  /** recipient edge predicates */
  hasRecipient?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecipientWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<IlitCrummeyLetterWhereInput>;
  or?: InputMaybe<Array<IlitCrummeyLetterWhereInput>>;
  /** send_before field predicates */
  sendBefore?: InputMaybe<Scalars['Time']['input']>;
  sendBeforeGT?: InputMaybe<Scalars['Time']['input']>;
  sendBeforeGTE?: InputMaybe<Scalars['Time']['input']>;
  sendBeforeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sendBeforeLT?: InputMaybe<Scalars['Time']['input']>;
  sendBeforeLTE?: InputMaybe<Scalars['Time']['input']>;
  sendBeforeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sent_on field predicates */
  sentOn?: InputMaybe<Scalars['Time']['input']>;
  sentOnGT?: InputMaybe<Scalars['Time']['input']>;
  sentOnGTE?: InputMaybe<Scalars['Time']['input']>;
  sentOnIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sentOnLT?: InputMaybe<Scalars['Time']['input']>;
  sentOnLTE?: InputMaybe<Scalars['Time']['input']>;
  sentOnNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type IlitTrust = EntitySubtype & Named & Node & Trust & {
  __typename?: 'ILITTrust';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  beneficiaries?: Maybe<Array<Beneficiary>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  crummeyLetters: IlitCrummeyLetterConnection;
  crummeyWithdrawalPeriodDays?: Maybe<Scalars['Int']['output']>;
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this trust */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in trusts that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  grantors?: Maybe<Array<Principal>>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  policies?: Maybe<Array<InsurancePolicy>>;
  stateInEstateStatus: EntityInEstateStatus;
  successorTrustees?: Maybe<Array<Trustee>>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<TrustTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  totalPolicyCashValue: Scalars['CurrencyUSD']['output'];
  trustAdvisors?: Maybe<Array<TrustAdvisor>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  trustees?: Maybe<Array<Trustee>>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type IlitTrustCrummeyLettersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IlitCrummeyLetterOrder>>;
  where?: InputMaybe<IlitCrummeyLetterWhereInput>;
};


export type IlitTrustHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type IlitTrustConnection = {
  __typename?: 'ILITTrustConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IlitTrustEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IlitTrustEdge = {
  __typename?: 'ILITTrustEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IlitTrust>;
};

/** Ordering options for ILITTrust connections */
export type IlitTrustOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ILITTrusts. */
  field: IlitTrustOrderField;
};

/** Properties by which ILITTrust connections can be ordered. */
export enum IlitTrustOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * ILITTrustWhereInput is used for filtering ILITTrust objects.
 * Input was generated by ent.
 */
export type IlitTrustWhereInput = {
  and?: InputMaybe<Array<IlitTrustWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** crummey_withdrawal_period_days field predicates */
  crummeyWithdrawalPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysGT?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysGTE?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  crummeyWithdrawalPeriodDaysLT?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysLTE?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysNEQ?: InputMaybe<Scalars['Int']['input']>;
  crummeyWithdrawalPeriodDaysNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** beneficiaries edge predicates */
  hasBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** crummey_letters edge predicates */
  hasCrummeyLetters?: InputMaybe<Scalars['Boolean']['input']>;
  hasCrummeyLettersWith?: InputMaybe<Array<IlitCrummeyLetterWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** grantors edge predicates */
  hasGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrantorsWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** successor_trustees edge predicates */
  hasSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuccessorTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** trust_advisors edge predicates */
  hasTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrustAdvisorsWith?: InputMaybe<Array<TrustAdvisorWhereInput>>;
  /** trustees edge predicates */
  hasTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<IlitTrustWhereInput>;
  or?: InputMaybe<Array<IlitTrustWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<TrustTaxStatus>;
  taxStatusIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<TrustTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** trust_jurisdiction_state_code field predicates */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trustJurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  trustJurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type IrsConstants = {
  __typename?: 'IRSConstants';
  annualGiftTaxExclusionAmount: Scalars['CurrencyUSD']['output'];
  availableStateEstateTaxes: Array<StateCode>;
  federalEstateTaxPercent: Scalars['Percent']['output'];
  federalLongTermCapitalGrainsTaxPercent: Scalars['Percent']['output'];
  federalOrdinaryIncomeTaxPercentMaxBracket: Scalars['Percent']['output'];
  gstExemptionAmount: Scalars['CurrencyUSD']['output'];
  lifetimeExemptionAmount: Scalars['CurrencyUSD']['output'];
  localFederalEstateTaxPercentFormatted?: Maybe<Scalars['String']['output']>;
  rate7520: Scalars['Percent']['output'];
};

export type Image = Node & {
  __typename?: 'Image';
  /** The size of the stored plaintext image bytes. */
  byteSize: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The encoding of the stored image bytes. The image route sets the HTTP content type from this value. */
  format: ImageFormat;
  /** The height of the stored image, in pixels. */
  height: Scalars['Int']['output'];
  household?: Maybe<Household>;
  /** the household this object belongs to */
  householdID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  luminaryOrganization?: Maybe<LuminaryOrganization>;
  /** NULL means tenant-only; non-NULL shares the row with every member of the organization. */
  luminaryOrganizationID?: Maybe<Scalars['ID']['output']>;
  /** Selects the access boundary of the image: one household or the whole tenant. */
  scope: ImageScope;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  /** The width of the stored image, in pixels. */
  width: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type ImageConnection = {
  __typename?: 'ImageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ImageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ImageEdge = {
  __typename?: 'ImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Image>;
};

/** ImageFormat is enum for the field format */
export enum ImageFormat {
  Jpeg = 'JPEG',
  Png = 'PNG'
}

/** Ordering options for Image connections */
export type ImageOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Images. */
  field: ImageOrderField;
};

/** Properties by which Image connections can be ordered. */
export enum ImageOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** ImageScope is enum for the field scope */
export enum ImageScope {
  Household = 'HOUSEHOLD',
  Tenant = 'TENANT'
}

export type ImproveEstate360DistributionDiagramInput = {
  /** The household ID to improve the diagram for. */
  householdID: Scalars['ID']['input'];
  /** The current mermaid diagram definition to improve. */
  mermaidDiagram: Scalars['String']['input'];
  /**
   * Optional presentation ID. When provided, the knowledge graph closest to the
   * presentation's creation time will be used as context instead of the most recent one.
   */
  presentationID?: InputMaybe<Scalars['ID']['input']>;
  /** The user's prompt describing how to improve the diagram. */
  prompt: Scalars['String']['input'];
};

export type ImprovePromptInput = {
  /** optional comments or guidance for improving the prompt */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** the current prompt text to improve */
  currentPrompt: Scalars['String']['input'];
  /** the document type this prompt is for */
  documentType: DocumentType;
};

/**
 * Editable assumptions for new income-tax-drag calculations, not tax liability rules.
 * The year identifies the reference table; saved profile assumptions do not change.
 */
export type IncomeTaxDragDefaults = {
  __typename?: 'IncomeTaxDragDefaults';
  federalIncomeTaxRate: Scalars['Percent']['output'];
  federalLongTermCapitalGainsRate: Scalars['Percent']['output'];
  stateRates: Array<IncomeTaxDragStateRates>;
  taxYear: Scalars['Int']['output'];
};

export type IncomeTaxDragStateRates = {
  __typename?: 'IncomeTaxDragStateRates';
  incomeTaxRate: Scalars['Percent']['output'];
  longTermCapitalGainsRate: Scalars['Percent']['output'];
  stateCode: StateCode;
};

export type IncomeTaxPaymentConfig = Node & {
  __typename?: 'IncomeTaxPaymentConfig';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The ordered entity IDs used when grantor_payment_method is CUSTOM. */
  customPayerOrder?: Maybe<Array<Scalars['ID']['output']>>;
  /** The method used to assign tax payments for grantor trusts and direct holdings. */
  grantorPaymentMethod: IncomeTaxPaymentConfigGrantorPaymentMethod;
  /** The growth profile that owns this income tax payment configuration. */
  growthProfile: GrowthProfile;
  /** The growth profile ID that this income tax payment configuration references. */
  growthProfileID: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The method used to assign tax payments for non-grantor entities. */
  nonGrantorPaymentMethod: IncomeTaxPaymentConfigNonGrantorPaymentMethod;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type IncomeTaxPaymentConfigConnection = {
  __typename?: 'IncomeTaxPaymentConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IncomeTaxPaymentConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IncomeTaxPaymentConfigEdge = {
  __typename?: 'IncomeTaxPaymentConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IncomeTaxPaymentConfig>;
};

/** IncomeTaxPaymentConfigGrantorPaymentMethod is enum for the field grantor_payment_method */
export enum IncomeTaxPaymentConfigGrantorPaymentMethod {
  Custom = 'CUSTOM',
  ProRata = 'PRO_RATA'
}

/** IncomeTaxPaymentConfigNonGrantorPaymentMethod is enum for the field non_grantor_payment_method */
export enum IncomeTaxPaymentConfigNonGrantorPaymentMethod {
  FollowGrantor = 'FOLLOW_GRANTOR',
  Self = 'SELF'
}

/** Ordering options for IncomeTaxPaymentConfig connections */
export type IncomeTaxPaymentConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order IncomeTaxPaymentConfigs. */
  field: IncomeTaxPaymentConfigOrderField;
};

/** Properties by which IncomeTaxPaymentConfig connections can be ordered. */
export enum IncomeTaxPaymentConfigOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * IncomeTaxPaymentConfigWhereInput is used for filtering IncomeTaxPaymentConfig objects.
 * Input was generated by ent.
 */
export type IncomeTaxPaymentConfigWhereInput = {
  and?: InputMaybe<Array<IncomeTaxPaymentConfigWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** grantor_payment_method field predicates */
  grantorPaymentMethod?: InputMaybe<IncomeTaxPaymentConfigGrantorPaymentMethod>;
  grantorPaymentMethodIn?: InputMaybe<Array<IncomeTaxPaymentConfigGrantorPaymentMethod>>;
  grantorPaymentMethodNEQ?: InputMaybe<IncomeTaxPaymentConfigGrantorPaymentMethod>;
  grantorPaymentMethodNotIn?: InputMaybe<Array<IncomeTaxPaymentConfigGrantorPaymentMethod>>;
  /** growth_profile_id field predicates */
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  growthProfileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  growthProfileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  growthProfileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** growth_profile edge predicates */
  hasGrowthProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrowthProfileWith?: InputMaybe<Array<GrowthProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** non_grantor_payment_method field predicates */
  nonGrantorPaymentMethod?: InputMaybe<IncomeTaxPaymentConfigNonGrantorPaymentMethod>;
  nonGrantorPaymentMethodIn?: InputMaybe<Array<IncomeTaxPaymentConfigNonGrantorPaymentMethod>>;
  nonGrantorPaymentMethodNEQ?: InputMaybe<IncomeTaxPaymentConfigNonGrantorPaymentMethod>;
  nonGrantorPaymentMethodNotIn?: InputMaybe<Array<IncomeTaxPaymentConfigNonGrantorPaymentMethod>>;
  not?: InputMaybe<IncomeTaxPaymentConfigWhereInput>;
  or?: InputMaybe<Array<IncomeTaxPaymentConfigWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type IndividualPersonalAccount = EntitySubtype & Named & Node & PersonalAccount & {
  __typename?: 'IndividualPersonalAccount';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  beneficiaries?: Maybe<Array<Beneficiary>>;
  controllingParties?: Maybe<Array<ControllingParty>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this personal account */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in entities that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  owner?: Maybe<Principal>;
  stateInEstateStatus: EntityInEstateStatus;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<NonTrustEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type IndividualPersonalAccountHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type IndividualPersonalAccountConnection = {
  __typename?: 'IndividualPersonalAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IndividualPersonalAccountEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IndividualPersonalAccountEdge = {
  __typename?: 'IndividualPersonalAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IndividualPersonalAccount>;
};

/** Ordering options for IndividualPersonalAccount connections */
export type IndividualPersonalAccountOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order IndividualPersonalAccounts. */
  field: IndividualPersonalAccountOrderField;
};

/** Properties by which IndividualPersonalAccount connections can be ordered. */
export enum IndividualPersonalAccountOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * IndividualPersonalAccountWhereInput is used for filtering IndividualPersonalAccount objects.
 * Input was generated by ent.
 */
export type IndividualPersonalAccountWhereInput = {
  and?: InputMaybe<Array<IndividualPersonalAccountWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** beneficiaries edge predicates */
  hasBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** controlling_parties edge predicates */
  hasControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  hasControllingPartiesWith?: InputMaybe<Array<ControllingPartyWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<IndividualPersonalAccountWhereInput>;
  or?: InputMaybe<Array<IndividualPersonalAccountWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type InferDocumentTypeInput = {
  fileName: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type InferDocumentTypeOutput = {
  __typename?: 'InferDocumentTypeOutput';
  documentType: DocumentType;
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type InferEntityKindInput = {
  entityName: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type InferEntityKindOutput = {
  __typename?: 'InferEntityKindOutput';
  entityKind: EntityKind;
  entityName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type InferNameMatchCandidateInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type InferNameMatchInput = {
  candidates: Array<InferNameMatchCandidateInput>;
  name: Scalars['String']['input'];
};

/**
 * InferPrimaryClientsInput is used to pass a string that represents the household name to the LLM
 * e.g. "John and Jane Doe" and ask it to return the likely names of primary clients
 * for that household. e.g. [{ firstName: "John", lastName: "Doe" }, { firstName: "Jane", lastName: "Doe" }]
 */
export type InferPrimaryClientsInput = {
  householdName: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** InferPrimaryClientsOutput is the output of the InferPrimaryClients query. */
export type InferPrimaryClientsOutput = {
  __typename?: 'InferPrimaryClientsOutput';
  householdName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  primaryClients: Array<PotentialPrimaryClient>;
};

export type InferredAccessAgeParameterDetails = {
  __typename?: 'InferredAccessAgeParameterDetails';
  ageRequirementEnd?: Maybe<Scalars['Int']['output']>;
  ageRequirementStart?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type InferredBeneficialOwnerDetails = InferredTrustActor & {
  __typename?: 'InferredBeneficialOwnerDetails';
  existingID?: Maybe<Scalars['ID']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['String']['output']>;
  referenceAIOnboardingSuggestionID?: Maybe<Scalars['ID']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type InferredBeneficiaryAccessParameterDetails = {
  __typename?: 'InferredBeneficiaryAccessParameterDetails';
  accessAgeParameters?: Maybe<InferredAccessAgeParameterDetails>;
  distributionAmount?: Maybe<Scalars['String']['output']>;
  distributionFrequency?: Maybe<AccessParameterFrequency>;
  distributionPercentage?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<AccessParameterKind>;
};

export type InferredBeneficiaryDetails = InferredTrustActor & {
  __typename?: 'InferredBeneficiaryDetails';
  distributionAmount?: Maybe<Scalars['String']['output']>;
  distributionFrequency?: Maybe<BeneficiaryDistributionDistributionFrequency>;
  distributionPercentage?: Maybe<Scalars['String']['output']>;
  existingID?: Maybe<Scalars['ID']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<BeneficiaryLevel>;
  organizationName?: Maybe<Scalars['String']['output']>;
  referenceAIOnboardingSuggestionID?: Maybe<Scalars['ID']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type InferredBeneficiaryDetailsV2 = InferredTrustActor & {
  __typename?: 'InferredBeneficiaryDetailsV2';
  accessParameters?: Maybe<Array<Maybe<InferredBeneficiaryAccessParameterDetails>>>;
  /**
   * Note that beneficiaryKind is only present for sub-trust beneficiaries, and is used for only the SURVIVING_SPOUSE
   * kind; all other kinds should be inferred from the other fields.
   */
  beneficiaryKind?: Maybe<BeneficiaryKind>;
  existingID?: Maybe<Scalars['ID']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<BeneficiaryLevel>;
  organizationName?: Maybe<Scalars['String']['output']>;
  powerOfAppointment?: Maybe<BeneficiaryPowerOfAppointmentPower>;
  powerOfAppointmentNotes?: Maybe<Scalars['String']['output']>;
  referenceAIOnboardingSuggestionID?: Maybe<Scalars['ID']['output']>;
  scheduledDistributions?: Maybe<Array<Maybe<InferredScheduledDistributionDetails>>>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type InferredBusinessEntityDetails = {
  __typename?: 'InferredBusinessEntityDetails';
  beneficialOwnersAsOfDate?: Maybe<Scalars['String']['output']>;
  beneficiaryOwners: Array<InferredBeneficialOwnerDetails>;
  doingBusinessAsName?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  finCenID?: Maybe<Scalars['String']['output']>;
  formationJurisdiction?: Maybe<Scalars['String']['output']>;
  keyPersons: Array<InferredKeyPersonDetails>;
  legalName?: Maybe<Scalars['String']['output']>;
  taxID?: Maybe<Scalars['String']['output']>;
  taxStatus?: Maybe<BusinessEntityTaxStatus>;
};

export type InferredField = Node & {
  __typename?: 'InferredField';
  /** Whether the user has accepted or rejected the inferred field */
  acceptanceStatus?: Maybe<InferredFieldAcceptanceStatus>;
  /** When the user set the acceptance status */
  acceptanceStatusSetAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Specific evidence for this field */
  evidence?: Maybe<Array<InferredFieldEvidence>>;
  /** The name of the field (db column) that we inferred for the `target_id` object. If absent, evidence is for the entire object. */
  fieldName?: Maybe<Scalars['String']['output']>;
  /** The file that powered this inference */
  file: File;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The object we inferred the field for */
  targetID: Scalars['String']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** InferredFieldAcceptanceStatus is enum for the field acceptance_status */
export enum InferredFieldAcceptanceStatus {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

export type InferredFieldEvidence = Node & {
  __typename?: 'InferredFieldEvidence';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  inferredField?: Maybe<InferredField>;
  /** The page (in the file) that this evidence is for */
  pageNumber: Scalars['Int']['output'];
  /** the polygon that was drawn to infer the field */
  polygon: Array<Coordinate>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for InferredFieldEvidence connections */
export type InferredFieldEvidenceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order InferredFieldEvidences. */
  field: InferredFieldEvidenceOrderField;
};

/** Properties by which InferredFieldEvidence connections can be ordered. */
export enum InferredFieldEvidenceOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * InferredFieldEvidenceWhereInput is used for filtering InferredFieldEvidence objects.
 * Input was generated by ent.
 */
export type InferredFieldEvidenceWhereInput = {
  and?: InputMaybe<Array<InferredFieldEvidenceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** inferred_field edge predicates */
  hasInferredField?: InputMaybe<Scalars['Boolean']['input']>;
  hasInferredFieldWith?: InputMaybe<Array<InferredFieldWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<InferredFieldEvidenceWhereInput>;
  or?: InputMaybe<Array<InferredFieldEvidenceWhereInput>>;
  /** page_number field predicates */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageNumberGT?: InputMaybe<Scalars['Int']['input']>;
  pageNumberGTE?: InputMaybe<Scalars['Int']['input']>;
  pageNumberLT?: InputMaybe<Scalars['Int']['input']>;
  pageNumberLTE?: InputMaybe<Scalars['Int']['input']>;
  pageNumberNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Ordering options for InferredField connections */
export type InferredFieldOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order InferredFields. */
  field: InferredFieldOrderField;
};

/** Properties by which InferredField connections can be ordered. */
export enum InferredFieldOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * InferredFieldWhereInput is used for filtering InferredField objects.
 * Input was generated by ent.
 */
export type InferredFieldWhereInput = {
  /** acceptance_status field predicates */
  acceptanceStatus?: InputMaybe<InferredFieldAcceptanceStatus>;
  acceptanceStatusIn?: InputMaybe<Array<InferredFieldAcceptanceStatus>>;
  acceptanceStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  acceptanceStatusNEQ?: InputMaybe<InferredFieldAcceptanceStatus>;
  acceptanceStatusNotIn?: InputMaybe<Array<InferredFieldAcceptanceStatus>>;
  acceptanceStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** acceptance_status_set_at field predicates */
  acceptanceStatusSetAt?: InputMaybe<Scalars['Time']['input']>;
  acceptanceStatusSetAtGT?: InputMaybe<Scalars['Time']['input']>;
  acceptanceStatusSetAtGTE?: InputMaybe<Scalars['Time']['input']>;
  acceptanceStatusSetAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  acceptanceStatusSetAtLT?: InputMaybe<Scalars['Time']['input']>;
  acceptanceStatusSetAtLTE?: InputMaybe<Scalars['Time']['input']>;
  acceptanceStatusSetAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<InferredFieldWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** field_name field predicates */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fieldNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** evidence edge predicates */
  hasEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  hasEvidenceWith?: InputMaybe<Array<InferredFieldEvidenceWhereInput>>;
  /** file edge predicates */
  hasFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileWith?: InputMaybe<Array<FileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<InferredFieldWhereInput>;
  or?: InputMaybe<Array<InferredFieldWhereInput>>;
  /** target_id field predicates */
  targetID?: InputMaybe<Scalars['String']['input']>;
  targetIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  targetIDNEQ?: InputMaybe<Scalars['String']['input']>;
  targetIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type InferredGrantorDetails = InferredTrustActor & {
  __typename?: 'InferredGrantorDetails';
  existingID?: Maybe<Scalars['ID']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  referenceAIOnboardingSuggestionID?: Maybe<Scalars['ID']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type InferredKeyPersonDetails = InferredTrustActor & {
  __typename?: 'InferredKeyPersonDetails';
  existingID?: Maybe<Scalars['ID']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  referenceAIOnboardingSuggestionID?: Maybe<Scalars['ID']['output']>;
  roles: Array<KeyPersonRoleKind>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type InferredScheduledDistributionDetails = {
  __typename?: 'InferredScheduledDistributionDetails';
  accessAgeParameters?: Maybe<InferredAccessAgeParameterDetails>;
  distributionAmount?: Maybe<Scalars['String']['output']>;
  distributionFrequency?: Maybe<ScheduledDistributionFrequency>;
  distributionPercentage?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<ScheduledDistributionKind>;
  notes?: Maybe<Scalars['String']['output']>;
};

/**
 * InferredSubtrustCreatedFromDetails represents the parent root trust entity
 * that creates this sub-trust upon the death of a grantor.
 *
 * For example, if a trust document states "Upon the death of the Grantor, the Trustee shall
 * divide the trust estate into the Family Trust and the Marital Trust", then both the Family
 * Trust and Marital Trust would have a "created from" suggestion pointing to the parent
 * revocable trust.
 */
export type InferredSubtrustCreatedFromDetails = {
  __typename?: 'InferredSubtrustCreatedFromDetails';
  /** The display name of the parent root trust (e.g., "John Smith Revocable Trust"). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The parent entity type (always TRUST). */
  type?: Maybe<SubtrustCreatedFromType>;
};

export type InferredTrustActor = {
  /**
   * The pulid of the existing client profile/org that this inferred actor corresponds to.
   * This is used to pre-populate the matched client profile/org in the Suggestions
   * Matcher UI when reviewing suggestions.
   */
  existingID?: Maybe<Scalars['ID']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  /** The pulid of an AI onboarding suggestion that this inferred actor corresponds to. */
  referenceAIOnboardingSuggestionID?: Maybe<Scalars['ID']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type InferredTrustAdvisorDetails = InferredTrustActor & {
  __typename?: 'InferredTrustAdvisorDetails';
  existingID?: Maybe<Scalars['ID']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  order: TrustAdvisorLevel;
  organizationName?: Maybe<Scalars['String']['output']>;
  referenceAIOnboardingSuggestionID?: Maybe<Scalars['ID']['output']>;
  roles: Array<TrustAdvisorRoleKind>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type InferredTrustDetails = {
  __typename?: 'InferredTrustDetails';
  beneficiaries: Array<InferredBeneficiaryDetails>;
  grantors: Array<InferredGrantorDetails>;
  trustAdvisors: Array<InferredTrustAdvisorDetails>;
  trustDate: Scalars['String']['output'];
  trustGSTStatus?: Maybe<EntityGstStatus>;
  trustJurisdiction: Scalars['String']['output'];
  trustName: Scalars['String']['output'];
  trustees: Array<InferredTrusteeDetails>;
};

export type InferredTrusteeDetails = InferredTrustActor & {
  __typename?: 'InferredTrusteeDetails';
  category: TrusteeTrusteeCategory;
  duties: Array<TrusteeDutyKind>;
  existingID?: Maybe<Scalars['ID']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  order?: Maybe<TrusteeLevel>;
  organizationName?: Maybe<Scalars['String']['output']>;
  referenceAIOnboardingSuggestionID?: Maybe<Scalars['ID']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export enum InfoMessageDisplayType {
  Standard = 'standard',
  Warning = 'warning'
}

export type InsightsTemplateBundleConfiguration = Node & {
  __typename?: 'InsightsTemplateBundleConfiguration';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** If true, includes active insights in the insights bundle. */
  includeActiveInsights: Scalars['Boolean']['output'];
  /** If true, includes completed insights in the insights bundle. */
  includeCompletedInsights: Scalars['Boolean']['output'];
  /** If true, includes missing documents in the insights bundle. */
  includeMissingDocuments: Scalars['Boolean']['output'];
  templateBundle?: Maybe<PresentationTemplateBundle>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type InsightsTemplateBundleConfigurationConnection = {
  __typename?: 'InsightsTemplateBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InsightsTemplateBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InsightsTemplateBundleConfigurationEdge = {
  __typename?: 'InsightsTemplateBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InsightsTemplateBundleConfiguration>;
};

/** Ordering options for InsightsTemplateBundleConfiguration connections */
export type InsightsTemplateBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order InsightsTemplateBundleConfigurations. */
  field: InsightsTemplateBundleConfigurationOrderField;
};

/** Properties by which InsightsTemplateBundleConfiguration connections can be ordered. */
export enum InsightsTemplateBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * InsightsTemplateBundleConfigurationWhereInput is used for filtering InsightsTemplateBundleConfiguration objects.
 * Input was generated by ent.
 */
export type InsightsTemplateBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<InsightsTemplateBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** template_bundle edge predicates */
  hasTemplateBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasTemplateBundleWith?: InputMaybe<Array<PresentationTemplateBundleWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_active_insights field predicates */
  includeActiveInsights?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_completed_insights field predicates */
  includeCompletedInsights?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_missing_documents field predicates */
  includeMissingDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<InsightsTemplateBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<InsightsTemplateBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type InsurancePersonalAccount = EntitySubtype & Named & Node & PersonalAccount & {
  __typename?: 'InsurancePersonalAccount';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  beneficiaryDesignationGroups: BeneficiaryDesignationGroupConnection;
  /**
   * Returns the primary and contingent beneficiary designation groups for this
   * insurance account. When hypotheticalWaterfallId is null or omitted, returns
   * live BDGs. When set, returns BDGs scoped to that waterfall when any exist;
   * otherwise falls back to live BDGs.
   */
  beneficiaryDesignations: BeneficiaryDesignations;
  /** The time at which the account's beneficiary designations were last reviewed/acknowledged. Used to suppress the 'no beneficiary designations' badge for accounts where the user has confirmed the empty state is intentional. */
  beneficiaryDesignationsReviewedAt?: Maybe<Scalars['Time']['output']>;
  controllingParties?: Maybe<Array<ControllingParty>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this personal account */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in entities that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalBeneficiaryDesignationGroups: BeneficiaryDesignationGroupConnection;
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  owners?: Maybe<Array<Principal>>;
  policies?: Maybe<Array<InsurancePolicy>>;
  stateInEstateStatus: EntityInEstateStatus;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<NonTrustEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  totalPolicyCashValue: Scalars['CurrencyUSD']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type InsurancePersonalAccountBeneficiaryDesignationGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BeneficiaryDesignationGroupOrder>>;
  where?: InputMaybe<BeneficiaryDesignationGroupWhereInput>;
};


export type InsurancePersonalAccountBeneficiaryDesignationsArgs = {
  hypotheticalWaterfallId?: InputMaybe<Scalars['ID']['input']>;
};


export type InsurancePersonalAccountHypotheticalBeneficiaryDesignationGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BeneficiaryDesignationGroupOrder>>;
  where?: InputMaybe<BeneficiaryDesignationGroupWhereInput>;
};


export type InsurancePersonalAccountHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type InsurancePersonalAccountConnection = {
  __typename?: 'InsurancePersonalAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InsurancePersonalAccountEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InsurancePersonalAccountEdge = {
  __typename?: 'InsurancePersonalAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InsurancePersonalAccount>;
};

/** Ordering options for InsurancePersonalAccount connections */
export type InsurancePersonalAccountOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order InsurancePersonalAccounts. */
  field: InsurancePersonalAccountOrderField;
};

/** Properties by which InsurancePersonalAccount connections can be ordered. */
export enum InsurancePersonalAccountOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * InsurancePersonalAccountWhereInput is used for filtering InsurancePersonalAccount objects.
 * Input was generated by ent.
 */
export type InsurancePersonalAccountWhereInput = {
  and?: InputMaybe<Array<InsurancePersonalAccountWhereInput>>;
  /** beneficiary_designations_reviewed_at field predicates */
  beneficiaryDesignationsReviewedAt?: InputMaybe<Scalars['Time']['input']>;
  beneficiaryDesignationsReviewedAtGT?: InputMaybe<Scalars['Time']['input']>;
  beneficiaryDesignationsReviewedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  beneficiaryDesignationsReviewedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  beneficiaryDesignationsReviewedAtLT?: InputMaybe<Scalars['Time']['input']>;
  beneficiaryDesignationsReviewedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  beneficiaryDesignationsReviewedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** beneficiary_designation_groups edge predicates */
  hasBeneficiaryDesignationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiaryDesignationGroupsWith?: InputMaybe<Array<BeneficiaryDesignationGroupWhereInput>>;
  /** controlling_parties edge predicates */
  hasControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  hasControllingPartiesWith?: InputMaybe<Array<ControllingPartyWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_beneficiary_designation_groups edge predicates */
  hasHypotheticalBeneficiaryDesignationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalBeneficiaryDesignationGroupsWith?: InputMaybe<Array<BeneficiaryDesignationGroupWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** owners edge predicates */
  hasOwners?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnersWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<InsurancePersonalAccountWhereInput>;
  or?: InputMaybe<Array<InsurancePersonalAccountWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type InsurancePolicy = Node & {
  __typename?: 'InsurancePolicy';
  carrierName?: Maybe<Scalars['String']['output']>;
  /** Only applicable for non-term policies */
  cashValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  cashValueDate?: Maybe<Scalars['Time']['output']>;
  /** The CCorp holding this policy, if any. */
  ccorp?: Maybe<CCorpBusinessEntity>;
  /** The clt trust holding this policy, if any. */
  cltTrust?: Maybe<CltTrust>;
  /** Only applicable for term policies */
  conversionDate?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The crt trust holding this policy, if any. */
  crtTrust?: Maybe<CrtTrust>;
  /** The DAF holding this policy, if any. */
  daf?: Maybe<DonorAdvisedFund>;
  deathBenefitAmount: Scalars['CurrencyUSD']['output'];
  /** The dispositive provisions that distribute this insurance policy. */
  dispositiveProvisions?: Maybe<Array<DispositiveProvision>>;
  /** documents that are associated with this policy */
  documents?: Maybe<Array<Document>>;
  /** The GP holding this policy, if any. */
  gp?: Maybe<GpBusinessEntity>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  /** The hypothetical insurance corresponding to this policy, if any. */
  hypotheticalInsurance?: Maybe<HypotheticalInsurance>;
  id: Scalars['ID']['output'];
  ilitTrust?: Maybe<IlitTrust>;
  initialPremiumDueDate?: Maybe<Scalars['Time']['output']>;
  insurancePersonalAccount?: Maybe<InsurancePersonalAccount>;
  integrationInsurance?: Maybe<IntegrationInsurance>;
  /** The irrevocable trust holding this policy, if any. */
  irrevocableTrust?: Maybe<IrrevocableTrust>;
  kgV2Nodes: Kgv2NodeConnection;
  kind: InsurancePolicyKind;
  /** The LLC holding this policy, if any. */
  llc?: Maybe<LlcBusinessEntity>;
  /** Only applicable for non-term policies */
  loanBalanceOutstanding?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The LP holding this policy, if any. */
  lp?: Maybe<LpBusinessEntity>;
  nextPremiumDueDate?: Maybe<Scalars['Time']['output']>;
  /** Free-form notes */
  notes?: Maybe<Scalars['String']['output']>;
  policyHolders?: Maybe<Array<ClientProfile>>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  premiumAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  premiumFrequency?: Maybe<InsurancePolicyPremiumFrequency>;
  /**
   * This is the list of grantors that made the gift.
   * Will only be read if the transfer tax kind is GRANTOR_TAXABLE_GIFT.
   * Can set one or both grantors.
   * MUST NOT be empty if the transfer tax kind is GRANTOR_TAXABLE_GIFT.
   */
  premiumPaymentGiftingGrantors?: Maybe<Array<ClientProfile>>;
  /** The entity who is paying the premiums for the policy. Only applicable for the ENTITY premium payment source kind. */
  premiumPaymentSourceEntity?: Maybe<Entity>;
  /** The entity who is paying the premiums for the policy. Only applicable for the ENTITY premium payment source kind. */
  premiumPaymentSourceEntityID?: Maybe<Scalars['ID']['output']>;
  /** The individual who is paying the premiums for the policy. Only applicable for the INDIVIDUAL premium payment source kind. */
  premiumPaymentSourceIndividual?: Maybe<ClientProfile>;
  /** The individual who is paying the premiums for the policy. Only applicable for the INDIVIDUAL premium payment source kind. */
  premiumPaymentSourceIndividualID?: Maybe<Scalars['ID']['output']>;
  /** The source of the premium payments. If not set, the waterfall will not process premium payments. */
  premiumPaymentSourceKind?: Maybe<InsurancePolicyPremiumPaymentSourceKind>;
  /** The entity who is paying the premiums for the policy. Only applicable for the TESTAMENTARY_ENTITY premium payment source kind. */
  premiumPaymentSourceTestamentaryEntity?: Maybe<Entity>;
  /** The entity who is paying the premiums for the policy. Only applicable for the TESTAMENTARY_ENTITY premium payment source kind. */
  premiumPaymentSourceTestamentaryEntityID?: Maybe<Scalars['ID']['output']>;
  /** The type of transfer of the premium payment, for tax purposes. Required if the premium payment source kind is not SELF. */
  premiumPaymentTransferTaxKind?: Maybe<InsurancePolicyPremiumPaymentTransferTaxKind>;
  premiumPayments: InsurancePremiumPaymentConnection;
  /** The private foundation holding this policy, if any. */
  privateFoundation?: Maybe<PrivateFoundation>;
  /** The revocable trust holding this policy, if any. */
  revocableTrust?: Maybe<RevocableTrust>;
  /** The SCorp holding this policy, if any. */
  scorp?: Maybe<SCorpBusinessEntity>;
  /** The slat trust holding this policy, if any. */
  slatTrust?: Maybe<SlatTrust>;
  startDate?: Maybe<Scalars['Time']['output']>;
  /** Only applicable for non-term policies. Allows multiple holders. */
  survivorship: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** Only applicable for term policies */
  termDurationYears?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type InsurancePolicyKgV2NodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2NodeOrder>>;
  where?: InputMaybe<Kgv2NodeWhereInput>;
};


export type InsurancePolicyPremiumPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InsurancePremiumPaymentOrder>>;
  where?: InputMaybe<InsurancePremiumPaymentWhereInput>;
};

/** A connection to a list of items. */
export type InsurancePolicyConnection = {
  __typename?: 'InsurancePolicyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InsurancePolicyEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InsurancePolicyEdge = {
  __typename?: 'InsurancePolicyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InsurancePolicy>;
};

/** InsurancePolicyKind is enum for the field kind */
export enum InsurancePolicyKind {
  Term = 'TERM',
  Universal = 'UNIVERSAL',
  Variable = 'VARIABLE',
  Whole = 'WHOLE'
}

/** Ordering options for InsurancePolicy connections */
export type InsurancePolicyOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order InsurancePolicies. */
  field: InsurancePolicyOrderField;
};

/** Properties by which InsurancePolicy connections can be ordered. */
export enum InsurancePolicyOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** InsurancePolicyPremiumFrequency is enum for the field premium_frequency */
export enum InsurancePolicyPremiumFrequency {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY'
}

/** InsurancePolicyPremiumPaymentSourceKind is enum for the field premium_payment_source_kind */
export enum InsurancePolicyPremiumPaymentSourceKind {
  Entity = 'ENTITY',
  Individual = 'INDIVIDUAL',
  Self = 'SELF',
  TestamentaryEntity = 'TESTAMENTARY_ENTITY'
}

/** InsurancePolicyPremiumPaymentTransferTaxKind is enum for the field premium_payment_transfer_tax_kind */
export enum InsurancePolicyPremiumPaymentTransferTaxKind {
  AnnualExclusionGiftWithCrummeyPowers = 'ANNUAL_EXCLUSION_GIFT_WITH_CRUMMEY_POWERS',
  GrantorTaxableGift = 'GRANTOR_TAXABLE_GIFT',
  NonTaxable = 'NON_TAXABLE'
}

/**
 * InsurancePolicyWhereInput is used for filtering InsurancePolicy objects.
 * Input was generated by ent.
 */
export type InsurancePolicyWhereInput = {
  and?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** carrier_name field predicates */
  carrierName?: InputMaybe<Scalars['String']['input']>;
  carrierNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  carrierNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cash_value field predicates */
  cashValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** cash_value_date field predicates */
  cashValueDate?: InputMaybe<Scalars['Time']['input']>;
  cashValueDateGT?: InputMaybe<Scalars['Time']['input']>;
  cashValueDateGTE?: InputMaybe<Scalars['Time']['input']>;
  cashValueDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cashValueDateLT?: InputMaybe<Scalars['Time']['input']>;
  cashValueDateLTE?: InputMaybe<Scalars['Time']['input']>;
  cashValueDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  cashValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  cashValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  cashValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cashValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  cashValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  cashValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  cashValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** conversion_date field predicates */
  conversionDate?: InputMaybe<Scalars['Time']['input']>;
  conversionDateGT?: InputMaybe<Scalars['Time']['input']>;
  conversionDateGTE?: InputMaybe<Scalars['Time']['input']>;
  conversionDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  conversionDateLT?: InputMaybe<Scalars['Time']['input']>;
  conversionDateLTE?: InputMaybe<Scalars['Time']['input']>;
  conversionDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** death_benefit_amount field predicates */
  deathBenefitAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  deathBenefitAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  deathBenefitAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  deathBenefitAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  deathBenefitAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  deathBenefitAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** ccorp edge predicates */
  hasCcorp?: InputMaybe<Scalars['Boolean']['input']>;
  hasCcorpWith?: InputMaybe<Array<CCorpBusinessEntityWhereInput>>;
  /** clt_trust edge predicates */
  hasCltTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasCltTrustWith?: InputMaybe<Array<CltTrustWhereInput>>;
  /** crt_trust edge predicates */
  hasCrtTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasCrtTrustWith?: InputMaybe<Array<CrtTrustWhereInput>>;
  /** daf edge predicates */
  hasDaf?: InputMaybe<Scalars['Boolean']['input']>;
  hasDafWith?: InputMaybe<Array<DonorAdvisedFundWhereInput>>;
  /** dispositive_provisions edge predicates */
  hasDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositiveProvisionsWith?: InputMaybe<Array<DispositiveProvisionWhereInput>>;
  /** documents edge predicates */
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** gp edge predicates */
  hasGp?: InputMaybe<Scalars['Boolean']['input']>;
  hasGpWith?: InputMaybe<Array<GpBusinessEntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_insurance edge predicates */
  hasHypotheticalInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalInsuranceWith?: InputMaybe<Array<HypotheticalInsuranceWhereInput>>;
  /** ilit_trust edge predicates */
  hasIlitTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasIlitTrustWith?: InputMaybe<Array<IlitTrustWhereInput>>;
  /** insurance_personal_account edge predicates */
  hasInsurancePersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasInsurancePersonalAccountWith?: InputMaybe<Array<InsurancePersonalAccountWhereInput>>;
  /** integration_insurance edge predicates */
  hasIntegrationInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntegrationInsuranceWith?: InputMaybe<Array<IntegrationInsuranceWhereInput>>;
  /** irrevocable_trust edge predicates */
  hasIrrevocableTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasIrrevocableTrustWith?: InputMaybe<Array<IrrevocableTrustWhereInput>>;
  /** kg_v2_nodes edge predicates */
  hasKgV2Nodes?: InputMaybe<Scalars['Boolean']['input']>;
  hasKgV2NodesWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** llc edge predicates */
  hasLlc?: InputMaybe<Scalars['Boolean']['input']>;
  hasLlcWith?: InputMaybe<Array<LlcBusinessEntityWhereInput>>;
  /** lp edge predicates */
  hasLp?: InputMaybe<Scalars['Boolean']['input']>;
  hasLpWith?: InputMaybe<Array<LpBusinessEntityWhereInput>>;
  /** policy_holders edge predicates */
  hasPolicyHolders?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolicyHoldersWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** premium_payment_gifting_grantors edge predicates */
  hasPremiumPaymentGiftingGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumPaymentGiftingGrantorsWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** premium_payment_source_entity edge predicates */
  hasPremiumPaymentSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumPaymentSourceEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** premium_payment_source_individual edge predicates */
  hasPremiumPaymentSourceIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumPaymentSourceIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** premium_payment_source_testamentary_entity edge predicates */
  hasPremiumPaymentSourceTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumPaymentSourceTestamentaryEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** premium_payments edge predicates */
  hasPremiumPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPremiumPaymentsWith?: InputMaybe<Array<InsurancePremiumPaymentWhereInput>>;
  /** private_foundation edge predicates */
  hasPrivateFoundation?: InputMaybe<Scalars['Boolean']['input']>;
  hasPrivateFoundationWith?: InputMaybe<Array<PrivateFoundationWhereInput>>;
  /** revocable_trust edge predicates */
  hasRevocableTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasRevocableTrustWith?: InputMaybe<Array<RevocableTrustWhereInput>>;
  /** scorp edge predicates */
  hasScorp?: InputMaybe<Scalars['Boolean']['input']>;
  hasScorpWith?: InputMaybe<Array<SCorpBusinessEntityWhereInput>>;
  /** slat_trust edge predicates */
  hasSlatTrust?: InputMaybe<Scalars['Boolean']['input']>;
  hasSlatTrustWith?: InputMaybe<Array<SlatTrustWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** initial_premium_due_date field predicates */
  initialPremiumDueDate?: InputMaybe<Scalars['Time']['input']>;
  initialPremiumDueDateGT?: InputMaybe<Scalars['Time']['input']>;
  initialPremiumDueDateGTE?: InputMaybe<Scalars['Time']['input']>;
  initialPremiumDueDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  initialPremiumDueDateLT?: InputMaybe<Scalars['Time']['input']>;
  initialPremiumDueDateLTE?: InputMaybe<Scalars['Time']['input']>;
  initialPremiumDueDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<InsurancePolicyKind>;
  kindIn?: InputMaybe<Array<InsurancePolicyKind>>;
  kindNEQ?: InputMaybe<InsurancePolicyKind>;
  kindNotIn?: InputMaybe<Array<InsurancePolicyKind>>;
  /** loan_balance_outstanding field predicates */
  loanBalanceOutstanding?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  loanBalanceOutstandingGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  loanBalanceOutstandingGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  loanBalanceOutstandingIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  loanBalanceOutstandingLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  loanBalanceOutstandingLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  loanBalanceOutstandingNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  loanBalanceOutstandingNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<InsurancePolicyWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** policy_number field predicates */
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  policyNumberIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  policyNumberNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** premium_amount field predicates */
  premiumAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  premiumAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** premium_frequency field predicates */
  premiumFrequency?: InputMaybe<InsurancePolicyPremiumFrequency>;
  premiumFrequencyIn?: InputMaybe<Array<InsurancePolicyPremiumFrequency>>;
  premiumFrequencyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  premiumFrequencyNEQ?: InputMaybe<InsurancePolicyPremiumFrequency>;
  premiumFrequencyNotIn?: InputMaybe<Array<InsurancePolicyPremiumFrequency>>;
  premiumFrequencyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** premium_payment_source_entity_id field predicates */
  premiumPaymentSourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  premiumPaymentSourceEntityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  premiumPaymentSourceEntityIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  premiumPaymentSourceEntityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  premiumPaymentSourceEntityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  premiumPaymentSourceEntityIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** premium_payment_source_individual_id field predicates */
  premiumPaymentSourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  premiumPaymentSourceIndividualIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  premiumPaymentSourceIndividualIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  premiumPaymentSourceIndividualIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  premiumPaymentSourceIndividualIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  premiumPaymentSourceIndividualIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** premium_payment_source_kind field predicates */
  premiumPaymentSourceKind?: InputMaybe<InsurancePolicyPremiumPaymentSourceKind>;
  premiumPaymentSourceKindIn?: InputMaybe<Array<InsurancePolicyPremiumPaymentSourceKind>>;
  premiumPaymentSourceKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  premiumPaymentSourceKindNEQ?: InputMaybe<InsurancePolicyPremiumPaymentSourceKind>;
  premiumPaymentSourceKindNotIn?: InputMaybe<Array<InsurancePolicyPremiumPaymentSourceKind>>;
  premiumPaymentSourceKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** premium_payment_source_testamentary_entity_id field predicates */
  premiumPaymentSourceTestamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
  premiumPaymentSourceTestamentaryEntityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  premiumPaymentSourceTestamentaryEntityIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  premiumPaymentSourceTestamentaryEntityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  premiumPaymentSourceTestamentaryEntityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  premiumPaymentSourceTestamentaryEntityIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** premium_payment_transfer_tax_kind field predicates */
  premiumPaymentTransferTaxKind?: InputMaybe<InsurancePolicyPremiumPaymentTransferTaxKind>;
  premiumPaymentTransferTaxKindIn?: InputMaybe<Array<InsurancePolicyPremiumPaymentTransferTaxKind>>;
  premiumPaymentTransferTaxKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  premiumPaymentTransferTaxKindNEQ?: InputMaybe<InsurancePolicyPremiumPaymentTransferTaxKind>;
  premiumPaymentTransferTaxKindNotIn?: InputMaybe<Array<InsurancePolicyPremiumPaymentTransferTaxKind>>;
  premiumPaymentTransferTaxKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** start_date field predicates */
  startDate?: InputMaybe<Scalars['Time']['input']>;
  startDateGT?: InputMaybe<Scalars['Time']['input']>;
  startDateGTE?: InputMaybe<Scalars['Time']['input']>;
  startDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startDateLT?: InputMaybe<Scalars['Time']['input']>;
  startDateLTE?: InputMaybe<Scalars['Time']['input']>;
  startDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** survivorship field predicates */
  survivorship?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** term_duration_years field predicates */
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsGT?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsGTE?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  termDurationYearsLT?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsLTE?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsNEQ?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type InsurancePremiumPayment = Node & {
  __typename?: 'InsurancePremiumPayment';
  associatedTask?: Maybe<EntityTask>;
  createdAt: Scalars['Time']['output'];
  /** Documents that are associated with the premium payment */
  documents?: Maybe<Array<Document>>;
  dueOn?: Maybe<Scalars['Time']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  paidOn?: Maybe<Scalars['Time']['output']>;
  policy?: Maybe<InsurancePolicy>;
  premiumAmount: Scalars['CurrencyUSD']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type InsurancePremiumPaymentConnection = {
  __typename?: 'InsurancePremiumPaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InsurancePremiumPaymentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InsurancePremiumPaymentEdge = {
  __typename?: 'InsurancePremiumPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InsurancePremiumPayment>;
};

/** Ordering options for InsurancePremiumPayment connections */
export type InsurancePremiumPaymentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order InsurancePremiumPayments. */
  field: InsurancePremiumPaymentOrderField;
};

/** Properties by which InsurancePremiumPayment connections can be ordered. */
export enum InsurancePremiumPaymentOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * InsurancePremiumPaymentWhereInput is used for filtering InsurancePremiumPayment objects.
 * Input was generated by ent.
 */
export type InsurancePremiumPaymentWhereInput = {
  and?: InputMaybe<Array<InsurancePremiumPaymentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** due_on field predicates */
  dueOn?: InputMaybe<Scalars['Time']['input']>;
  dueOnGT?: InputMaybe<Scalars['Time']['input']>;
  dueOnGTE?: InputMaybe<Scalars['Time']['input']>;
  dueOnIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dueOnLT?: InputMaybe<Scalars['Time']['input']>;
  dueOnLTE?: InputMaybe<Scalars['Time']['input']>;
  dueOnNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** associated_task edge predicates */
  hasAssociatedTask?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssociatedTaskWith?: InputMaybe<Array<EntityTaskWhereInput>>;
  /** documents edge predicates */
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** policy edge predicates */
  hasPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolicyWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<InsurancePremiumPaymentWhereInput>;
  or?: InputMaybe<Array<InsurancePremiumPaymentWhereInput>>;
  /** paid_on field predicates */
  paidOn?: InputMaybe<Scalars['Time']['input']>;
  paidOnGT?: InputMaybe<Scalars['Time']['input']>;
  paidOnGTE?: InputMaybe<Scalars['Time']['input']>;
  paidOnIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  paidOnLT?: InputMaybe<Scalars['Time']['input']>;
  paidOnLTE?: InputMaybe<Scalars['Time']['input']>;
  paidOnNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** premium_amount field predicates */
  premiumAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type InsuredClientProfileSuggestion = {
  __typename?: 'InsuredClientProfileSuggestion';
  clientProfileID?: Maybe<Scalars['ID']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleName: Scalars['String']['output'];
  suffix: Scalars['String']['output'];
};

export type InsuredClientProfileSuggestionInput = {
  clientProfileID?: InputMaybe<Scalars['ID']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName: Scalars['String']['input'];
  suffix: Scalars['String']['input'];
};

export type IntegrationAssetClass = Node & {
  __typename?: 'IntegrationAssetClass';
  assetClass?: Maybe<AssetClass>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /** We use this to map this integration_asset_class to the provider's asset class name. This is imperfect, because if someone updates a name then we will make a new asset class and reconnect it. */
  integrationName: Scalars['String']['output'];
  provider: IntegrationAssetClassProvider;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type IntegrationAssetClassConnection = {
  __typename?: 'IntegrationAssetClassConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IntegrationAssetClassEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IntegrationAssetClassEdge = {
  __typename?: 'IntegrationAssetClassEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IntegrationAssetClass>;
};

/** Ordering options for IntegrationAssetClass connections */
export type IntegrationAssetClassOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order IntegrationAssetClasses. */
  field: IntegrationAssetClassOrderField;
};

/** Properties by which IntegrationAssetClass connections can be ordered. */
export enum IntegrationAssetClassOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** IntegrationAssetClassProvider is enum for the field provider */
export enum IntegrationAssetClassProvider {
  Addepar = 'ADDEPAR',
  BlackDiamond = 'BLACK_DIAMOND',
  Emoney = 'EMONEY',
  Orion = 'ORION',
  Snowflake = 'SNOWFLAKE'
}

/**
 * IntegrationAssetClassWhereInput is used for filtering IntegrationAssetClass objects.
 * Input was generated by ent.
 */
export type IntegrationAssetClassWhereInput = {
  and?: InputMaybe<Array<IntegrationAssetClassWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** asset_class edge predicates */
  hasAssetClass?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetClassWith?: InputMaybe<Array<AssetClassWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integration_name field predicates */
  integrationName?: InputMaybe<Scalars['String']['input']>;
  integrationNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<IntegrationAssetClassWhereInput>;
  or?: InputMaybe<Array<IntegrationAssetClassWhereInput>>;
  /** provider field predicates */
  provider?: InputMaybe<IntegrationAssetClassProvider>;
  providerIn?: InputMaybe<Array<IntegrationAssetClassProvider>>;
  providerNEQ?: InputMaybe<IntegrationAssetClassProvider>;
  providerNotIn?: InputMaybe<Array<IntegrationAssetClassProvider>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type IntegrationCashflow = Node & {
  __typename?: 'IntegrationCashflow';
  /** Users who have access to this integration cashflow */
  allowedUsers?: Maybe<Array<User>>;
  /** Luminary cashflows that are linked with integration cashflow */
  cashflows?: Maybe<Array<Cashflow>>;
  createdAt: Scalars['Time']['output'];
  /** The end date of the cashflow */
  endDate?: Maybe<Scalars['Time']['output']>;
  externalKind: IntegrationCashflowExternalKind;
  /** The annual growth/indexing rate of the cashflow */
  growthRate?: Maybe<Scalars['Percent']['output']>;
  id: Scalars['ID']['output'];
  /** Integration client associated with this cashflow */
  integrationClient?: Maybe<IntegrationClient>;
  /** The unique identifier for this cashflow in the external system */
  integrationID: Scalars['String']['output'];
  kind: IntegrationCashflowKind;
  /** The name of the cashflow */
  name: Scalars['String']['output'];
  /** The name of the cashflow owner from the external system, CMK-encrypted */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** The start date of the cashflow */
  startDate?: Maybe<Scalars['Time']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  /** The most recent value of the integration cashflow */
  value?: Maybe<Scalars['CurrencyUSD']['output']>;
};

/** A connection to a list of items. */
export type IntegrationCashflowConnection = {
  __typename?: 'IntegrationCashflowConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IntegrationCashflowEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IntegrationCashflowEdge = {
  __typename?: 'IntegrationCashflowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IntegrationCashflow>;
};

/** IntegrationCashflowExternalKind is enum for the field external_kind */
export enum IntegrationCashflowExternalKind {
  EmoneyExpense = 'EMONEY_EXPENSE',
  EmoneyIncome = 'EMONEY_INCOME'
}

/** IntegrationCashflowKind is enum for the field kind */
export enum IntegrationCashflowKind {
  Emoney = 'EMONEY'
}

/** Ordering options for IntegrationCashflow connections */
export type IntegrationCashflowOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order IntegrationCashflows. */
  field: IntegrationCashflowOrderField;
};

/** Properties by which IntegrationCashflow connections can be ordered. */
export enum IntegrationCashflowOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * IntegrationCashflowWhereInput is used for filtering IntegrationCashflow objects.
 * Input was generated by ent.
 */
export type IntegrationCashflowWhereInput = {
  and?: InputMaybe<Array<IntegrationCashflowWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** end_date field predicates */
  endDate?: InputMaybe<Scalars['Time']['input']>;
  endDateGT?: InputMaybe<Scalars['Time']['input']>;
  endDateGTE?: InputMaybe<Scalars['Time']['input']>;
  endDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endDateLT?: InputMaybe<Scalars['Time']['input']>;
  endDateLTE?: InputMaybe<Scalars['Time']['input']>;
  endDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_kind field predicates */
  externalKind?: InputMaybe<IntegrationCashflowExternalKind>;
  externalKindIn?: InputMaybe<Array<IntegrationCashflowExternalKind>>;
  externalKindNEQ?: InputMaybe<IntegrationCashflowExternalKind>;
  externalKindNotIn?: InputMaybe<Array<IntegrationCashflowExternalKind>>;
  /** growth_rate field predicates */
  growthRate?: InputMaybe<Scalars['Percent']['input']>;
  growthRateGT?: InputMaybe<Scalars['Percent']['input']>;
  growthRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  growthRateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  growthRateLT?: InputMaybe<Scalars['Percent']['input']>;
  growthRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  growthRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  growthRateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** allowed_users edge predicates */
  hasAllowedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAllowedUsersWith?: InputMaybe<Array<UserWhereInput>>;
  /** cashflows edge predicates */
  hasCashflows?: InputMaybe<Scalars['Boolean']['input']>;
  hasCashflowsWith?: InputMaybe<Array<CashflowWhereInput>>;
  /** integration_client edge predicates */
  hasIntegrationClient?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntegrationClientWith?: InputMaybe<Array<IntegrationClientWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integration_id field predicates */
  integrationID?: InputMaybe<Scalars['String']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<IntegrationCashflowKind>;
  kindIn?: InputMaybe<Array<IntegrationCashflowKind>>;
  kindNEQ?: InputMaybe<IntegrationCashflowKind>;
  kindNotIn?: InputMaybe<Array<IntegrationCashflowKind>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<IntegrationCashflowWhereInput>;
  or?: InputMaybe<Array<IntegrationCashflowWhereInput>>;
  /** start_date field predicates */
  startDate?: InputMaybe<Scalars['Time']['input']>;
  startDateGT?: InputMaybe<Scalars['Time']['input']>;
  startDateGTE?: InputMaybe<Scalars['Time']['input']>;
  startDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startDateLT?: InputMaybe<Scalars['Time']['input']>;
  startDateLTE?: InputMaybe<Scalars['Time']['input']>;
  startDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** value field predicates */
  value?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  valueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntegrationClient = Node & {
  __typename?: 'IntegrationClient';
  allowedUsers?: Maybe<Array<User>>;
  /** Luminary households that are linked with this integration client. */
  clientHouseholds?: Maybe<Array<Household>>;
  createdAt: Scalars['Time']['output'];
  externalKind?: Maybe<IntegrationClientExternalKind>;
  id: Scalars['ID']['output'];
  integrationEntities: IntegrationEntityConnection;
  integrationID: Scalars['String']['output'];
  kind: IntegrationClientKind;
  name: Scalars['String']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type IntegrationClientIntegrationEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IntegrationEntityOrder>>;
  where?: InputMaybe<IntegrationEntityWhereInput>;
};

/** A connection to a list of items. */
export type IntegrationClientConnection = {
  __typename?: 'IntegrationClientConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IntegrationClientEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IntegrationClientEdge = {
  __typename?: 'IntegrationClientEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IntegrationClient>;
};

/** IntegrationClientExternalKind is enum for the field external_kind */
export enum IntegrationClientExternalKind {
  AddeparClient = 'ADDEPAR_CLIENT',
  AddeparGroup = 'ADDEPAR_GROUP',
  AddeparHousehold = 'ADDEPAR_HOUSEHOLD',
  BlackDiamondRelationship = 'BLACK_DIAMOND_RELATIONSHIP',
  EmoneyClient = 'EMONEY_CLIENT',
  OrionClient = 'ORION_CLIENT',
  SalesforceRecord = 'SALESFORCE_RECORD',
  SnowflakeHousehold = 'SNOWFLAKE_HOUSEHOLD'
}

/** IntegrationClientKind is enum for the field kind */
export enum IntegrationClientKind {
  Addepar = 'ADDEPAR',
  BlackDiamond = 'BLACK_DIAMOND',
  Emoney = 'EMONEY',
  Orion = 'ORION',
  Salesforce = 'SALESFORCE',
  Snowflake = 'SNOWFLAKE'
}

/** Ordering options for IntegrationClient connections */
export type IntegrationClientOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order IntegrationClients. */
  field: IntegrationClientOrderField;
};

/** Properties by which IntegrationClient connections can be ordered. */
export enum IntegrationClientOrderField {
  CreatedAt = 'created_at',
  Name = 'name',
  UpdatedAt = 'updated_at'
}

/**
 * IntegrationClientWhereInput is used for filtering IntegrationClient objects.
 * Input was generated by ent.
 */
export type IntegrationClientWhereInput = {
  and?: InputMaybe<Array<IntegrationClientWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** external_kind field predicates */
  externalKind?: InputMaybe<IntegrationClientExternalKind>;
  externalKindIn?: InputMaybe<Array<IntegrationClientExternalKind>>;
  externalKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalKindNEQ?: InputMaybe<IntegrationClientExternalKind>;
  externalKindNotIn?: InputMaybe<Array<IntegrationClientExternalKind>>;
  externalKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** allowed_users edge predicates */
  hasAllowedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAllowedUsersWith?: InputMaybe<Array<UserWhereInput>>;
  /** client_households edge predicates */
  hasClientHouseholds?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientHouseholdsWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** integration_entities edge predicates */
  hasIntegrationEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntegrationEntitiesWith?: InputMaybe<Array<IntegrationEntityWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integration_id field predicates */
  integrationID?: InputMaybe<Scalars['String']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<IntegrationClientKind>;
  kindIn?: InputMaybe<Array<IntegrationClientKind>>;
  kindNEQ?: InputMaybe<IntegrationClientKind>;
  kindNotIn?: InputMaybe<Array<IntegrationClientKind>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<IntegrationClientWhereInput>;
  or?: InputMaybe<Array<IntegrationClientWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type IntegrationConfiguration = Node & {
  __typename?: 'IntegrationConfiguration';
  /** The client ID for the Addepar OAuth app. */
  addeparClientID?: Maybe<Scalars['String']['output']>;
  addeparClientType: IntegrationConfigurationAddeparClientType;
  /** If set, we will attempt to query this asset class as a property from Addepar and use it to populate IntegrationAssetClasses. */
  addeparCustomAssetClassName?: Maybe<Scalars['String']['output']>;
  /** If set, we will use this field as the attribute ID to set the custom asset name in Addepar. */
  addeparCustomAssetNameAPIField?: Maybe<Scalars['String']['output']>;
  /** Addepar attribute ID used to exclude holding accounts and securities when its value is yes or true, ignoring case. */
  addeparCustomExclusionAPIField?: Maybe<Scalars['String']['output']>;
  /** When true, requests the entities_write property for Addepar OAuth and syncs household summary values to integrated Addepar households/clients. */
  addeparEnableHouseholdSummarySync: Scalars['Boolean']['output'];
  /** ID for Addepar account. */
  addeparFirmID?: Maybe<Scalars['String']['output']>;
  addeparLookThroughCompositeSecurities: Scalars['Boolean']['output'];
  /** The subdomain of the Addepar instance to connect to. */
  addeparSubdomain?: Maybe<Scalars['String']['output']>;
  /** Whether the tenant expects to use Black Diamond. We use this to expose prompts to users to authenticate to Black Diamond. */
  blackDiamondEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  /** The user-defined name for the source of the file valuation import. Exposed alongside the valuation to show where it came from. */
  csvValuationImportName?: Maybe<Scalars['String']['output']>;
  /** Whether the tenant expects to use eMoney. We use this to expose prompts to users to authenticate to eMoney. */
  emoneyEnabled: Scalars['Boolean']['output'];
  /** true to enable customer-owned LLM providers */
  enableLlmByok: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Whether the tenant expects to use the integration user for valuation syncing. */
  integrationUserEnabled: Scalars['Boolean']['output'];
  /** Whether the tenant expects to use Orion. We use this to expose prompts to users to authenticate to Orion. */
  orionEnabled: Scalars['Boolean']['output'];
  /** Whether user interfaces show the Salesforce integration as WealthHub. Only superusers can change it. */
  salesforceIsWealthhub: Scalars['Boolean']['output'];
  /** Legacy optional Snowflake assets view retained for API compatibility; integrations use SNOWFLAKE_ASSETS_VIEW */
  snowflakeDataSharingAssetsView?: Maybe<Scalars['String']['output']>;
  /** If snowflake_data_sharing_enabled=true, we will load customer asset data via this shared snowflake database */
  snowflakeDataSharingDatabase?: Maybe<Scalars['String']['output']>;
  /** true to enable customer data asset ingestion via snowflake data sharing */
  snowflakeDataSharingEnabled: Scalars['Boolean']['output'];
  /** If snowflake_data_sharing_enabled=true, we will load customer asset data using this tenant-specific snowflake role */
  snowflakeDataSharingRole?: Maybe<Scalars['String']['output']>;
  /** Legacy optional Snowflake schema retained for API compatibility; integrations use SNOWFLAKE_INTEGRATION_SCHEMA */
  snowflakeDataSharingSchema?: Maybe<Scalars['String']['output']>;
  /** Whether Snowflake household synchronization is enabled for this tenant */
  snowflakeHouseholdSyncEnabled: Scalars['Boolean']['output'];
  /** The display name to use for the snowflake integration (most customers do not know what snowflake is) */
  snowflakeIntegrationDisplayName?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** IntegrationConfigurationAddeparClientType is enum for the field addepar_client_type */
export enum IntegrationConfigurationAddeparClientType {
  All = 'ALL',
  Client = 'CLIENT',
  Group = 'GROUP',
  Household = 'HOUSEHOLD'
}

/** A connection to a list of items. */
export type IntegrationConfigurationConnection = {
  __typename?: 'IntegrationConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IntegrationConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IntegrationConfigurationEdge = {
  __typename?: 'IntegrationConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IntegrationConfiguration>;
};

/** Ordering options for IntegrationConfiguration connections */
export type IntegrationConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order IntegrationConfigurations. */
  field: IntegrationConfigurationOrderField;
};

/** Properties by which IntegrationConfiguration connections can be ordered. */
export enum IntegrationConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * IntegrationConfigurationWhereInput is used for filtering IntegrationConfiguration objects.
 * Input was generated by ent.
 */
export type IntegrationConfigurationWhereInput = {
  /** addepar_client_id field predicates */
  addeparClientID?: InputMaybe<Scalars['String']['input']>;
  addeparClientIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  addeparClientIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** addepar_client_type field predicates */
  addeparClientType?: InputMaybe<IntegrationConfigurationAddeparClientType>;
  addeparClientTypeIn?: InputMaybe<Array<IntegrationConfigurationAddeparClientType>>;
  addeparClientTypeNEQ?: InputMaybe<IntegrationConfigurationAddeparClientType>;
  addeparClientTypeNotIn?: InputMaybe<Array<IntegrationConfigurationAddeparClientType>>;
  /** addepar_custom_asset_class_name field predicates */
  addeparCustomAssetClassName?: InputMaybe<Scalars['String']['input']>;
  addeparCustomAssetClassNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  addeparCustomAssetClassNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** addepar_custom_asset_name_api_field field predicates */
  addeparCustomAssetNameAPIField?: InputMaybe<Scalars['String']['input']>;
  addeparCustomAssetNameAPIFieldIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  addeparCustomAssetNameAPIFieldNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** addepar_custom_exclusion_api_field field predicates */
  addeparCustomExclusionAPIField?: InputMaybe<Scalars['String']['input']>;
  addeparCustomExclusionAPIFieldIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  addeparCustomExclusionAPIFieldNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** addepar_enable_household_summary_sync field predicates */
  addeparEnableHouseholdSummarySync?: InputMaybe<Scalars['Boolean']['input']>;
  /** addepar_firm_id field predicates */
  addeparFirmID?: InputMaybe<Scalars['String']['input']>;
  addeparFirmIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  addeparFirmIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** addepar_look_through_composite_securities field predicates */
  addeparLookThroughCompositeSecurities?: InputMaybe<Scalars['Boolean']['input']>;
  /** addepar_subdomain field predicates */
  addeparSubdomain?: InputMaybe<Scalars['String']['input']>;
  addeparSubdomainIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  addeparSubdomainNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<IntegrationConfigurationWhereInput>>;
  /** black_diamond_enabled field predicates */
  blackDiamondEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** csv_valuation_import_name field predicates */
  csvValuationImportName?: InputMaybe<Scalars['String']['input']>;
  csvValuationImportNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  csvValuationImportNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** emoney_enabled field predicates */
  emoneyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable_llm_byok field predicates */
  enableLlmByok?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integration_user_enabled field predicates */
  integrationUserEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<IntegrationConfigurationWhereInput>;
  or?: InputMaybe<Array<IntegrationConfigurationWhereInput>>;
  /** orion_enabled field predicates */
  orionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** snowflake_data_sharing_assets_view field predicates */
  snowflakeDataSharingAssetsView?: InputMaybe<Scalars['String']['input']>;
  snowflakeDataSharingAssetsViewIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  snowflakeDataSharingAssetsViewNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** snowflake_data_sharing_enabled field predicates */
  snowflakeDataSharingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** snowflake_data_sharing_schema field predicates */
  snowflakeDataSharingSchema?: InputMaybe<Scalars['String']['input']>;
  snowflakeDataSharingSchemaIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  snowflakeDataSharingSchemaNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** snowflake_household_sync_enabled field predicates */
  snowflakeHouseholdSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** snowflake_integration_display_name field predicates */
  snowflakeIntegrationDisplayName?: InputMaybe<Scalars['String']['input']>;
  snowflakeIntegrationDisplayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  snowflakeIntegrationDisplayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type IntegrationEntity = Node & {
  __typename?: 'IntegrationEntity';
  allowedUsers?: Maybe<Array<User>>;
  /** Child entities that are linked to this integration entity in an integration import. */
  childEntities?: Maybe<Array<IntegrationEntity>>;
  createdAt: Scalars['Time']['output'];
  /** Luminary entities that are linked with integration entity. */
  entities?: Maybe<Array<Entity>>;
  externalKind?: Maybe<IntegrationEntityExternalKind>;
  id: Scalars['ID']['output'];
  /** Integration client associated with this entity */
  integrationClient?: Maybe<IntegrationClient>;
  integrationID: Scalars['String']['output'];
  kind: IntegrationEntityKind;
  name: Scalars['String']['output'];
  /** Parent entity that is linked with integration entity in an integration import. */
  parentEntity?: Maybe<IntegrationEntity>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  /** The most recent value of the integration entity, used for context for users when selecting entities in the UI */
  value?: Maybe<Scalars['CurrencyUSD']['output']>;
};

/** A connection to a list of items. */
export type IntegrationEntityConnection = {
  __typename?: 'IntegrationEntityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IntegrationEntityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IntegrationEntityEdge = {
  __typename?: 'IntegrationEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IntegrationEntity>;
};

/** IntegrationEntityExternalKind is enum for the field external_kind */
export enum IntegrationEntityExternalKind {
  AddeparHoldingAccount = 'ADDEPAR_HOLDING_ACCOUNT',
  AddeparLegalEntity = 'ADDEPAR_LEGAL_ENTITY',
  BlackDiamondAccount = 'BLACK_DIAMOND_ACCOUNT',
  BlackDiamondPortfolio = 'BLACK_DIAMOND_PORTFOLIO',
  EmoneyAsset = 'EMONEY_ASSET',
  EmoneyTrustAndPartnership = 'EMONEY_TRUST_AND_PARTNERSHIP',
  OrionAccount = 'ORION_ACCOUNT',
  OrionPortfolio = 'ORION_PORTFOLIO',
  SnowflakeAccount = 'SNOWFLAKE_ACCOUNT'
}

/** IntegrationEntityKind is enum for the field kind */
export enum IntegrationEntityKind {
  Addepar = 'ADDEPAR',
  BlackDiamondAccount = 'BLACK_DIAMOND_ACCOUNT',
  BlackDiamondPortfolio = 'BLACK_DIAMOND_PORTFOLIO',
  CsvImport = 'CSV_IMPORT',
  Emoney = 'EMONEY',
  Orion = 'ORION',
  Snowflake = 'SNOWFLAKE'
}

/** Ordering options for IntegrationEntity connections */
export type IntegrationEntityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order IntegrationEntities. */
  field: IntegrationEntityOrderField;
};

/** Properties by which IntegrationEntity connections can be ordered. */
export enum IntegrationEntityOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * IntegrationEntityWhereInput is used for filtering IntegrationEntity objects.
 * Input was generated by ent.
 */
export type IntegrationEntityWhereInput = {
  and?: InputMaybe<Array<IntegrationEntityWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** external_kind field predicates */
  externalKind?: InputMaybe<IntegrationEntityExternalKind>;
  externalKindIn?: InputMaybe<Array<IntegrationEntityExternalKind>>;
  externalKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalKindNEQ?: InputMaybe<IntegrationEntityExternalKind>;
  externalKindNotIn?: InputMaybe<Array<IntegrationEntityExternalKind>>;
  externalKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** allowed_users edge predicates */
  hasAllowedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAllowedUsersWith?: InputMaybe<Array<UserWhereInput>>;
  /** child_entities edge predicates */
  hasChildEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildEntitiesWith?: InputMaybe<Array<IntegrationEntityWhereInput>>;
  /** entities edge predicates */
  hasEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntitiesWith?: InputMaybe<Array<EntityWhereInput>>;
  /** integration_client edge predicates */
  hasIntegrationClient?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntegrationClientWith?: InputMaybe<Array<IntegrationClientWhereInput>>;
  /** parent_entity edge predicates */
  hasParentEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentEntityWith?: InputMaybe<Array<IntegrationEntityWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integration_id field predicates */
  integrationID?: InputMaybe<Scalars['String']['input']>;
  integrationIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<IntegrationEntityKind>;
  kindIn?: InputMaybe<Array<IntegrationEntityKind>>;
  kindNEQ?: InputMaybe<IntegrationEntityKind>;
  kindNotIn?: InputMaybe<Array<IntegrationEntityKind>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<IntegrationEntityWhereInput>;
  or?: InputMaybe<Array<IntegrationEntityWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** value field predicates */
  value?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  valueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** IntegrationExternalKind is enum for the field integration_kind */
export enum IntegrationExternalKind {
  AddeparHoldingAccount = 'ADDEPAR_HOLDING_ACCOUNT',
  AddeparLegalEntity = 'ADDEPAR_LEGAL_ENTITY',
  AddeparSecurity = 'ADDEPAR_SECURITY',
  BlackDiamondAccount = 'BLACK_DIAMOND_ACCOUNT',
  BlackDiamondAsset = 'BLACK_DIAMOND_ASSET',
  BlackDiamondPortfolio = 'BLACK_DIAMOND_PORTFOLIO',
  EmoneyAsset = 'EMONEY_ASSET',
  EmoneyHolding = 'EMONEY_HOLDING',
  EmoneyTrustAndPartnership = 'EMONEY_TRUST_AND_PARTNERSHIP',
  OrionAccount = 'ORION_ACCOUNT',
  OrionAsset = 'ORION_ASSET',
  OrionPortfolio = 'ORION_PORTFOLIO',
  SnowflakeAccount = 'SNOWFLAKE_ACCOUNT',
  SnowflakeAsset = 'SNOWFLAKE_ASSET'
}

export type IntegrationInsurance = Node & {
  __typename?: 'IntegrationInsurance';
  /** Users who have access to this integration insurance */
  allowedUsers?: Maybe<Array<User>>;
  /** The cash value of the insurance policy */
  cashValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  createdAt: Scalars['Time']['output'];
  externalKind: IntegrationInsuranceExternalKind;
  id: Scalars['ID']['output'];
  /** Luminary insurance policies that are linked with integration insurance */
  insurancePolicies?: Maybe<Array<InsurancePolicy>>;
  /** Integration client associated with this insurance */
  integrationClient?: Maybe<IntegrationClient>;
  /** The unique identifier for this insurance in the external system */
  integrationID: Scalars['String']['output'];
  kind: IntegrationInsuranceKind;
  /** The name of the insurance */
  name: Scalars['String']['output'];
  /** The person or entity that owns the policy */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** The name of the insured person */
  policyHolderName?: Maybe<Scalars['String']['output']>;
  /** The policy number from the external system */
  policyNumber?: Maybe<Scalars['String']['output']>;
  /** The human-readable policy type name from eMoney (e.g., 'Whole Life', 'Term Life') */
  policyType?: Maybe<Scalars['String']['output']>;
  /** The annual premium amount of the insurance policy */
  premiumAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The purchase/start date of the insurance policy */
  startDate?: Maybe<Scalars['Time']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The term length in years of the insurance policy */
  termDurationYears?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Time']['output'];
  /** The most recent value of the integration insurance */
  value?: Maybe<Scalars['CurrencyUSD']['output']>;
};

/** A connection to a list of items. */
export type IntegrationInsuranceConnection = {
  __typename?: 'IntegrationInsuranceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IntegrationInsuranceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IntegrationInsuranceEdge = {
  __typename?: 'IntegrationInsuranceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IntegrationInsurance>;
};

/** IntegrationInsuranceExternalKind is enum for the field external_kind */
export enum IntegrationInsuranceExternalKind {
  EmoneyLifeInsurance = 'EMONEY_LIFE_INSURANCE'
}

/** IntegrationInsuranceKind is enum for the field kind */
export enum IntegrationInsuranceKind {
  Emoney = 'EMONEY'
}

/** Ordering options for IntegrationInsurance connections */
export type IntegrationInsuranceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order IntegrationInsurances. */
  field: IntegrationInsuranceOrderField;
};

/** Properties by which IntegrationInsurance connections can be ordered. */
export enum IntegrationInsuranceOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * IntegrationInsuranceWhereInput is used for filtering IntegrationInsurance objects.
 * Input was generated by ent.
 */
export type IntegrationInsuranceWhereInput = {
  and?: InputMaybe<Array<IntegrationInsuranceWhereInput>>;
  /** cash_value field predicates */
  cashValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  cashValueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  cashValueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  cashValueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cashValueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  cashValueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  cashValueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  cashValueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** external_kind field predicates */
  externalKind?: InputMaybe<IntegrationInsuranceExternalKind>;
  externalKindIn?: InputMaybe<Array<IntegrationInsuranceExternalKind>>;
  externalKindNEQ?: InputMaybe<IntegrationInsuranceExternalKind>;
  externalKindNotIn?: InputMaybe<Array<IntegrationInsuranceExternalKind>>;
  /** allowed_users edge predicates */
  hasAllowedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAllowedUsersWith?: InputMaybe<Array<UserWhereInput>>;
  /** insurance_policies edge predicates */
  hasInsurancePolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasInsurancePoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** integration_client edge predicates */
  hasIntegrationClient?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntegrationClientWith?: InputMaybe<Array<IntegrationClientWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integration_id field predicates */
  integrationID?: InputMaybe<Scalars['String']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<IntegrationInsuranceKind>;
  kindIn?: InputMaybe<Array<IntegrationInsuranceKind>>;
  kindNEQ?: InputMaybe<IntegrationInsuranceKind>;
  kindNotIn?: InputMaybe<Array<IntegrationInsuranceKind>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<IntegrationInsuranceWhereInput>;
  or?: InputMaybe<Array<IntegrationInsuranceWhereInput>>;
  /** owner_name field predicates */
  ownerName?: InputMaybe<Scalars['String']['input']>;
  ownerNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownerNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** policy_holder_name field predicates */
  policyHolderName?: InputMaybe<Scalars['String']['input']>;
  policyHolderNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  policyHolderNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** policy_number field predicates */
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  policyNumberIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  policyNumberNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** policy_type field predicates */
  policyType?: InputMaybe<Scalars['String']['input']>;
  policyTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  policyTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** premium_amount field predicates */
  premiumAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  premiumAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** start_date field predicates */
  startDate?: InputMaybe<Scalars['Time']['input']>;
  startDateGT?: InputMaybe<Scalars['Time']['input']>;
  startDateGTE?: InputMaybe<Scalars['Time']['input']>;
  startDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startDateLT?: InputMaybe<Scalars['Time']['input']>;
  startDateLTE?: InputMaybe<Scalars['Time']['input']>;
  startDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** term_duration_years field predicates */
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsGT?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsGTE?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  termDurationYearsLT?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsLTE?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsNEQ?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** value field predicates */
  value?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  valueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntegrationLiability = Node & {
  __typename?: 'IntegrationLiability';
  /** Users who have access to this integration liability */
  allowedUsers?: Maybe<Array<User>>;
  createdAt: Scalars['Time']['output'];
  externalKind: IntegrationLiabilityExternalKind;
  id: Scalars['ID']['output'];
  /** Integration client associated with this liability */
  integrationClient?: Maybe<IntegrationClient>;
  /** The unique identifier for this liability in the external system */
  integrationID: Scalars['String']['output'];
  /** The interest rate of the liability */
  interestRate?: Maybe<Scalars['Percent']['output']>;
  kind: IntegrationLiabilityKind;
  /** Luminary liabilities that are linked with integration liability */
  liabilities?: Maybe<Array<Liability>>;
  /** The name of the liability */
  name: Scalars['String']['output'];
  /** The payment frequency of the liability */
  paymentFrequency?: Maybe<Scalars['String']['output']>;
  /** The name of the liability recipient (borrower) from the external system */
  recipientName?: Maybe<Scalars['String']['output']>;
  /** The recurring payment amount of the liability */
  recurringPaymentAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The end date of the liability term */
  termEnd?: Maybe<Scalars['Time']['output']>;
  /** The start date of the liability term */
  termStart?: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['Time']['output'];
  /** The most recent value of the integration liability */
  value?: Maybe<Scalars['CurrencyUSD']['output']>;
};

/** A connection to a list of items. */
export type IntegrationLiabilityConnection = {
  __typename?: 'IntegrationLiabilityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IntegrationLiabilityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IntegrationLiabilityEdge = {
  __typename?: 'IntegrationLiabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IntegrationLiability>;
};

/** IntegrationLiabilityExternalKind is enum for the field external_kind */
export enum IntegrationLiabilityExternalKind {
  EmoneyLiability = 'EMONEY_LIABILITY',
  EmoneyNoteReceivable = 'EMONEY_NOTE_RECEIVABLE'
}

/** IntegrationLiabilityKind is enum for the field kind */
export enum IntegrationLiabilityKind {
  Emoney = 'EMONEY'
}

/** Ordering options for IntegrationLiability connections */
export type IntegrationLiabilityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order IntegrationLiabilities. */
  field: IntegrationLiabilityOrderField;
};

/** Properties by which IntegrationLiability connections can be ordered. */
export enum IntegrationLiabilityOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * IntegrationLiabilityWhereInput is used for filtering IntegrationLiability objects.
 * Input was generated by ent.
 */
export type IntegrationLiabilityWhereInput = {
  and?: InputMaybe<Array<IntegrationLiabilityWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** external_kind field predicates */
  externalKind?: InputMaybe<IntegrationLiabilityExternalKind>;
  externalKindIn?: InputMaybe<Array<IntegrationLiabilityExternalKind>>;
  externalKindNEQ?: InputMaybe<IntegrationLiabilityExternalKind>;
  externalKindNotIn?: InputMaybe<Array<IntegrationLiabilityExternalKind>>;
  /** allowed_users edge predicates */
  hasAllowedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAllowedUsersWith?: InputMaybe<Array<UserWhereInput>>;
  /** integration_client edge predicates */
  hasIntegrationClient?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntegrationClientWith?: InputMaybe<Array<IntegrationClientWhereInput>>;
  /** liabilities edge predicates */
  hasLiabilities?: InputMaybe<Scalars['Boolean']['input']>;
  hasLiabilitiesWith?: InputMaybe<Array<LiabilityWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integration_id field predicates */
  integrationID?: InputMaybe<Scalars['String']['input']>;
  /** interest_rate field predicates */
  interestRate?: InputMaybe<Scalars['Percent']['input']>;
  interestRateGT?: InputMaybe<Scalars['Percent']['input']>;
  interestRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  interestRateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  interestRateLT?: InputMaybe<Scalars['Percent']['input']>;
  interestRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  interestRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  interestRateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<IntegrationLiabilityKind>;
  kindIn?: InputMaybe<Array<IntegrationLiabilityKind>>;
  kindNEQ?: InputMaybe<IntegrationLiabilityKind>;
  kindNotIn?: InputMaybe<Array<IntegrationLiabilityKind>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<IntegrationLiabilityWhereInput>;
  or?: InputMaybe<Array<IntegrationLiabilityWhereInput>>;
  /** payment_frequency field predicates */
  paymentFrequency?: InputMaybe<Scalars['String']['input']>;
  paymentFrequencyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  paymentFrequencyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** recipient_name field predicates */
  recipientName?: InputMaybe<Scalars['String']['input']>;
  recipientNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  recipientNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** recurring_payment_amount field predicates */
  recurringPaymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  recurringPaymentAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  recurringPaymentAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  recurringPaymentAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  recurringPaymentAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  recurringPaymentAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  recurringPaymentAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  recurringPaymentAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** term_end field predicates */
  termEnd?: InputMaybe<Scalars['Time']['input']>;
  termEndGT?: InputMaybe<Scalars['Time']['input']>;
  termEndGTE?: InputMaybe<Scalars['Time']['input']>;
  termEndIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  termEndLT?: InputMaybe<Scalars['Time']['input']>;
  termEndLTE?: InputMaybe<Scalars['Time']['input']>;
  termEndNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** term_start field predicates */
  termStart?: InputMaybe<Scalars['Time']['input']>;
  termStartGT?: InputMaybe<Scalars['Time']['input']>;
  termStartGTE?: InputMaybe<Scalars['Time']['input']>;
  termStartIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  termStartLT?: InputMaybe<Scalars['Time']['input']>;
  termStartLTE?: InputMaybe<Scalars['Time']['input']>;
  termStartNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** value field predicates */
  value?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  valueLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  valueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntegrationPerson = Node & {
  __typename?: 'IntegrationPerson';
  /** Users who have access to this integration person */
  allowedUsers?: Maybe<Array<User>>;
  /** Luminary client profiles that are linked with this integration person */
  clientProfiles?: Maybe<Array<ClientProfile>>;
  createdAt: Scalars['Time']['output'];
  externalKind: IntegrationPersonExternalKind;
  id: Scalars['ID']['output'];
  /** Integration client associated with this person */
  integrationClient?: Maybe<IntegrationClient>;
  /** The unique identifier for this person in the external system */
  integrationID: Scalars['String']['output'];
  kind: IntegrationPersonKind;
  /** The full name of the person */
  name: Scalars['String']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type IntegrationPersonConnection = {
  __typename?: 'IntegrationPersonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IntegrationPersonEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IntegrationPersonEdge = {
  __typename?: 'IntegrationPersonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IntegrationPerson>;
};

/** IntegrationPersonExternalKind is enum for the field external_kind */
export enum IntegrationPersonExternalKind {
  EmoneyPerson = 'EMONEY_PERSON',
  SnowflakeClient = 'SNOWFLAKE_CLIENT'
}

/** IntegrationPersonKind is enum for the field kind */
export enum IntegrationPersonKind {
  Emoney = 'EMONEY',
  Snowflake = 'SNOWFLAKE'
}

/** Ordering options for IntegrationPerson connections */
export type IntegrationPersonOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order IntegrationPersons. */
  field: IntegrationPersonOrderField;
};

/** Properties by which IntegrationPerson connections can be ordered. */
export enum IntegrationPersonOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * IntegrationPersonWhereInput is used for filtering IntegrationPerson objects.
 * Input was generated by ent.
 */
export type IntegrationPersonWhereInput = {
  and?: InputMaybe<Array<IntegrationPersonWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** external_kind field predicates */
  externalKind?: InputMaybe<IntegrationPersonExternalKind>;
  externalKindIn?: InputMaybe<Array<IntegrationPersonExternalKind>>;
  externalKindNEQ?: InputMaybe<IntegrationPersonExternalKind>;
  externalKindNotIn?: InputMaybe<Array<IntegrationPersonExternalKind>>;
  /** allowed_users edge predicates */
  hasAllowedUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAllowedUsersWith?: InputMaybe<Array<UserWhereInput>>;
  /** client_profiles edge predicates */
  hasClientProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientProfilesWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** integration_client edge predicates */
  hasIntegrationClient?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntegrationClientWith?: InputMaybe<Array<IntegrationClientWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integration_id field predicates */
  integrationID?: InputMaybe<Scalars['String']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<IntegrationPersonKind>;
  kindIn?: InputMaybe<Array<IntegrationPersonKind>>;
  kindNEQ?: InputMaybe<IntegrationPersonKind>;
  kindNotIn?: InputMaybe<Array<IntegrationPersonKind>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<IntegrationPersonWhereInput>;
  or?: InputMaybe<Array<IntegrationPersonWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export enum IntegrationProvider {
  Addepar = 'ADDEPAR',
  BlackDiamond = 'BLACK_DIAMOND',
  Emoney = 'EMONEY',
  Orion = 'ORION'
}

export type InterestRateDetails = {
  __typename?: 'InterestRateDetails';
  interestRate: Scalars['Percent']['output'];
  monthYearDisplay: Scalars['String']['output'];
};

export type InterestRateSummary = {
  __typename?: 'InterestRateSummary';
  currentMonth: InterestRateDetails;
  nextMonth?: Maybe<InterestRateDetails>;
};

export type IrrevocableTrust = EntitySubtype & Named & Node & Trust & {
  __typename?: 'IrrevocableTrust';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  beneficiaries?: Maybe<Array<Beneficiary>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this trust */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in trusts that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  grantors?: Maybe<Array<Principal>>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  performanceReport: TrustPerformanceReport;
  policies?: Maybe<Array<InsurancePolicy>>;
  stateInEstateStatus: EntityInEstateStatus;
  successorTrustees?: Maybe<Array<Trustee>>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<TrustTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  trustAdvisors?: Maybe<Array<TrustAdvisor>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  trustees?: Maybe<Array<Trustee>>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type IrrevocableTrustHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type IrrevocableTrustConnection = {
  __typename?: 'IrrevocableTrustConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IrrevocableTrustEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IrrevocableTrustEdge = {
  __typename?: 'IrrevocableTrustEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IrrevocableTrust>;
};

/** Ordering options for IrrevocableTrust connections */
export type IrrevocableTrustOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order IrrevocableTrusts. */
  field: IrrevocableTrustOrderField;
};

/** Properties by which IrrevocableTrust connections can be ordered. */
export enum IrrevocableTrustOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * IrrevocableTrustWhereInput is used for filtering IrrevocableTrust objects.
 * Input was generated by ent.
 */
export type IrrevocableTrustWhereInput = {
  and?: InputMaybe<Array<IrrevocableTrustWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** beneficiaries edge predicates */
  hasBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** grantors edge predicates */
  hasGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrantorsWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** successor_trustees edge predicates */
  hasSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuccessorTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** trust_advisors edge predicates */
  hasTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrustAdvisorsWith?: InputMaybe<Array<TrustAdvisorWhereInput>>;
  /** trustees edge predicates */
  hasTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<IrrevocableTrustWhereInput>;
  or?: InputMaybe<Array<IrrevocableTrustWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<TrustTaxStatus>;
  taxStatusIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<TrustTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** trust_jurisdiction_state_code field predicates */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trustJurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  trustJurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type IsLoggedIn = {
  __typename?: 'IsLoggedIn';
  externalUserName?: Maybe<Scalars['String']['output']>;
  isLoggedIn: Scalars['Boolean']['output'];
  isTokenValid: Scalars['Boolean']['output'];
};

export type IsLoggedInToAddepar = {
  __typename?: 'IsLoggedInToAddepar';
  externalUserName?: Maybe<Scalars['String']['output']>;
  isLoggedIn: Scalars['Boolean']['output'];
  isTokenValid: Scalars['Boolean']['output'];
};

export type JointPersonalAccount = EntitySubtype & Named & Node & PersonalAccount & {
  __typename?: 'JointPersonalAccount';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  beneficiaries?: Maybe<Array<Beneficiary>>;
  controllingParties?: Maybe<Array<ControllingParty>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this personal account */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in entities that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  owners?: Maybe<Array<Principal>>;
  stateInEstateStatus: EntityInEstateStatus;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<NonTrustEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  type?: Maybe<JointPersonalAccountType>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type JointPersonalAccountHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type JointPersonalAccountConnection = {
  __typename?: 'JointPersonalAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JointPersonalAccountEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type JointPersonalAccountEdge = {
  __typename?: 'JointPersonalAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<JointPersonalAccount>;
};

/** Ordering options for JointPersonalAccount connections */
export type JointPersonalAccountOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order JointPersonalAccounts. */
  field: JointPersonalAccountOrderField;
};

/** Properties by which JointPersonalAccount connections can be ordered. */
export enum JointPersonalAccountOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** JointPersonalAccountType is enum for the field type */
export enum JointPersonalAccountType {
  CommunityProperty = 'COMMUNITY_PROPERTY',
  CommunityPropertyWithRightOfSurvivorship = 'COMMUNITY_PROPERTY_WITH_RIGHT_OF_SURVIVORSHIP',
  JointTenants = 'JOINT_TENANTS',
  JointTenantsWithRightOfSurvivorship = 'JOINT_TENANTS_WITH_RIGHT_OF_SURVIVORSHIP',
  TenantsByEntirety = 'TENANTS_BY_ENTIRETY',
  TenantsInCommon = 'TENANTS_IN_COMMON'
}

/**
 * JointPersonalAccountWhereInput is used for filtering JointPersonalAccount objects.
 * Input was generated by ent.
 */
export type JointPersonalAccountWhereInput = {
  and?: InputMaybe<Array<JointPersonalAccountWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** beneficiaries edge predicates */
  hasBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** controlling_parties edge predicates */
  hasControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  hasControllingPartiesWith?: InputMaybe<Array<ControllingPartyWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** owners edge predicates */
  hasOwners?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnersWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<JointPersonalAccountWhereInput>;
  or?: InputMaybe<Array<JointPersonalAccountWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** type field predicates */
  type?: InputMaybe<JointPersonalAccountType>;
  typeIn?: InputMaybe<Array<JointPersonalAccountType>>;
  typeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  typeNEQ?: InputMaybe<JointPersonalAccountType>;
  typeNotIn?: InputMaybe<Array<JointPersonalAccountType>>;
  typeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Annotated household KGV2 document metadata used for amendment-aware prompt context. */
export type KgExportAnnotatedDocument = {
  __typename?: 'KGExportAnnotatedDocument';
  executedOn?: Maybe<Scalars['Time']['output']>;
  id: Scalars['String']['output'];
  instrumentName?: Maybe<Scalars['String']['output']>;
  revokesAllPrior?: Maybe<Scalars['Boolean']['output']>;
  supersededByDocumentID?: Maybe<Scalars['String']['output']>;
  supersedesDocumentID?: Maybe<Scalars['String']['output']>;
  supersessionKind?: Maybe<Scalars['String']['output']>;
  targetInstrumentTitle?: Maybe<Scalars['String']['output']>;
};

/** Structured whole-household annotated KGV2 data used to derive prompt-ready eval context. */
export type KgExportAnnotatedKnowledgeGraph = {
  __typename?: 'KGExportAnnotatedKnowledgeGraph';
  documents: Array<KgExportAnnotatedDocument>;
  nodes: Array<KgExportKnowledgeGraphNode>;
  statements: Array<KgExportAnnotatedStatement>;
};

/** Annotated household KGV2 statement data with amendment/current-truth metadata. */
export type KgExportAnnotatedStatement = {
  __typename?: 'KGExportAnnotatedStatement';
  conditionDescription?: Maybe<Scalars['String']['output']>;
  conditionType?: Maybe<Scalars['String']['output']>;
  confidence: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  documentID?: Maybe<Scalars['String']['output']>;
  effectiveCandidate: Scalars['Boolean']['output'];
  localID: Scalars['String']['output'];
  objectLocalID?: Maybe<Scalars['String']['output']>;
  polarity: Scalars['String']['output'];
  predicate: Scalars['String']['output'];
  sectionRef?: Maybe<Scalars['String']['output']>;
  snippet: Scalars['String']['output'];
  subjectLocalID: Scalars['String']['output'];
  supersededByDocumentID?: Maybe<Scalars['String']['output']>;
  supersededByStatementIDs: Array<Scalars['String']['output']>;
  supersedingDocumentRevokesAllPrior?: Maybe<Scalars['Boolean']['output']>;
  suppressionReasons: Array<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents a document's content for knowledge graph export.
 * Contains both plain text and annotated (with paragraph IDs) versions.
 */
export type KgExportDocument = {
  __typename?: 'KGExportDocument';
  /** Annotated content with paragraph IDs in [paragraph id="..."] tags */
  annotatedContent: Scalars['String']['output'];
  /** Document display name (used for filename generation) */
  displayName: Scalars['String']['output'];
  /** Plain text content - each line is a paragraph */
  plainTextContent: Scalars['String']['output'];
};

/** Structured whole-household KGV2 data used by suggestion-eval exports. */
export type KgExportKnowledgeGraph = {
  __typename?: 'KGExportKnowledgeGraph';
  nodes: Array<KgExportKnowledgeGraphNode>;
  statements: Array<KgExportKnowledgeGraphStatement>;
};

/** Structured whole-household KGV2 node data used by suggestion-eval exports. */
export type KgExportKnowledgeGraphNode = {
  __typename?: 'KGExportKnowledgeGraphNode';
  aliases: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  localID: Scalars['String']['output'];
  namePrimary: Scalars['String']['output'];
  nodeType: Scalars['String']['output'];
  sectionRef?: Maybe<Scalars['String']['output']>;
  snippet: Scalars['String']['output'];
};

/** Structured whole-household KGV2 statement data used by suggestion-eval exports. */
export type KgExportKnowledgeGraphStatement = {
  __typename?: 'KGExportKnowledgeGraphStatement';
  conditionDescription?: Maybe<Scalars['String']['output']>;
  conditionType?: Maybe<Scalars['String']['output']>;
  confidence: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  localID: Scalars['String']['output'];
  objectLocalID?: Maybe<Scalars['String']['output']>;
  predicate: Scalars['String']['output'];
  sectionRef?: Maybe<Scalars['String']['output']>;
  snippet: Scalars['String']['output'];
  subjectLocalID: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** Household-level lineage metadata for a single subtrust node. */
export type KgExportSubtrustLineage = {
  __typename?: 'KGExportSubtrustLineage';
  immediateParents: Array<KgExportSubtrustLineageNode>;
  rootTrustAncestors: Array<KgExportSubtrustLineageNode>;
  statementLocalIDs: Array<Scalars['String']['output']>;
  targetNodeID: Scalars['String']['output'];
};

/** Lineage node metadata for subtrust exports. */
export type KgExportSubtrustLineageNode = {
  __typename?: 'KGExportSubtrustLineageNode';
  localID: Scalars['String']['output'];
  namePrimary: Scalars['String']['output'];
  nodeType: Scalars['String']['output'];
  statementLocalIDs: Array<Scalars['String']['output']>;
};

/**
 * The complete export package for knowledge graph.
 * Contains the current document/entity export payload plus household-level
 * suggestion-eval state.
 */
export type KgHouseholdExport = {
  __typename?: 'KGHouseholdExport';
  /** The active KGV2 graph ID used for the export, if any */
  activeGraphID?: Maybe<Scalars['ID']['output']>;
  /** Whole-household annotated KGV2 data */
  annotatedKG: KgExportAnnotatedKnowledgeGraph;
  /** List of client organization exports used for onboarding eval fixtures */
  clientOrganizations: Array<ClientOrganization>;
  /** List of client profile exports used for onboarding eval fixtures */
  clientProfiles: Array<ClientProfile>;
  /** List of document exports (plain + annotated text files) */
  documents: Array<KgExportDocument>;
  /** List of entity exports (JSON files) */
  entities: Array<Entity>;
  /** Version of the suggestion-eval export contract */
  exportVersion: Scalars['String']['output'];
  /** The household ID the export was generated for */
  householdID: Scalars['ID']['output'];
  /** Optional markdown prompt context derived from the annotated household KG */
  markdown?: Maybe<Kgv2GraphMarkdown>;
  /** Whole-household plain KGV2 data */
  plainKG: KgExportKnowledgeGraph;
  /** List of testamentary entity (sub-trust) exports */
  subTrusts: Array<TestamentaryEntity>;
  /** Household-level subtrust lineage metadata keyed by target node ID */
  subtrustLineages: Array<KgExportSubtrustLineage>;
};

/**
 * A KGLoadingDocument projection: source document ID, progress, and decrypted preview.
 * Counts describe all discovered items; node and relationship arrays share a bounded
 * household response budget, with active sessions first.
 */
export type KgLoadingDocument = {
  __typename?: 'KGLoadingDocument';
  discoveredNodeCount: Scalars['Int']['output'];
  discoveredRelationshipCount: Scalars['Int']['output'];
  documentID: Scalars['ID']['output'];
  nodes: Array<KgLoadingNode>;
  relationships: Array<KgLoadingRelationship>;
  revision: Scalars['Int']['output'];
  status: KgLoadingStatus;
};

/** IDs are provisional and document-local, not canonical graph record IDs. */
export type KgLoadingNode = {
  __typename?: 'KGLoadingNode';
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** An edge from the encrypted document preview; endpoints reference preview node IDs. */
export type KgLoadingRelationship = {
  __typename?: 'KGLoadingRelationship';
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  sourceID: Scalars['ID']['output'];
  targetID: Scalars['ID']['output'];
};

/** One KGLoadingSession storage row with its selected document previews. */
export type KgLoadingSession = {
  __typename?: 'KGLoadingSession';
  completedAt?: Maybe<Scalars['Time']['output']>;
  documents: Array<KgLoadingDocument>;
  id: Scalars['ID']['output'];
  kind: KgLoadingSessionKind;
  startedAt: Scalars['Time']['output'];
  status: KgLoadingStatus;
  updatedAt: Scalars['Time']['output'];
};

/** Public counterpart of KGLoadingSession.kind, independent of its generated Ent enum. */
export enum KgLoadingSessionKind {
  Batch = 'BATCH',
  Regeneration = 'REGENERATION'
}

/**
 * A replacement loading-only snapshot, not canonical KG or application state.
 * Loading ends when document extraction workflows return, before household linking,
 * validation, and suggestions. Successful previews remain available after completion.
 * The Ent loading schemas skip automatic GraphQL generation; this API deliberately
 * exposes bounded display data rather than encrypted storage fields or run keys.
 */
export type KgLoadingState = {
  __typename?: 'KGLoadingState';
  householdID: Scalars['ID']['output'];
  isLoading: Scalars['Boolean']['output'];
  sessions: Array<KgLoadingSession>;
};

/**
 * Shared public status for the separate KGLoadingSession.status and
 * KGLoadingDocument.status Ent enums. Session status aggregates document outcomes;
 * it does not report whether canonical KG linking or validation has finished.
 */
export enum KgLoadingStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export type KgNode = Node & {
  __typename?: 'KGNode';
  /** The AI suggestions that were generated from this KGNode. This is only set if the node was created as a result of being merged into a KGRoot. */
  aiSuggestions?: Maybe<Array<AiSuggestion>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The LLM description of the node. */
  description?: Maybe<Scalars['String']['output']>;
  /** The evidence that supports this KGNode. This should only be set on KGNodes that get created from a document; NOT merged nodes. */
  evidence?: Maybe<Array<AiSuggestionEvidence>>;
  /** The file that this KGNode belongs to. A node can only belong to at most one file. Nodes that were created as a result of being merged into a KGRoot will not have this field set, since it could have relationships that were extracted from multiple files. */
  file?: Maybe<File>;
  /** The file_id that this KGNode belongs to. A node can only belong to at most one file. Nodes that were created as a result of being merged into a KGRoot will not have this field set, since it could have relationships that were extracted from multiple files. */
  fileID?: Maybe<Scalars['ID']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The relationships where this node is the target. The KGNode at the other end of the relationship is the source. */
  inboundRelationships?: Maybe<Array<KgRelationship>>;
  /** The KGRoot that this KGNode belongs to. This will only be set if the node was created as a result of being merged into a KGRoot. In this case, the file edge will not be set. */
  kgRoot?: Maybe<KgRoot>;
  /** KGNodes were merged to create this node. This is only set if the node was created as a result of being merged into a KGRoot. */
  mergedFrom?: Maybe<Array<KgNode>>;
  /** The name of the node. This uniquely identifies the node within the knowledge graph root. */
  name: Scalars['String']['output'];
  /** The relationships where this node is the source. The KGNode at the other end of the relationship is the target. */
  outboundRelationships?: Maybe<Array<KgRelationship>>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The type of the node. */
  type: KgNodeType;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type KgNodeConnection = {
  __typename?: 'KGNodeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<KgNodeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KgNodeEdge = {
  __typename?: 'KGNodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<KgNode>;
};

/** Ordering options for KGNode connections */
export type KgNodeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KGNodes. */
  field: KgNodeOrderField;
};

/** Properties by which KGNode connections can be ordered. */
export enum KgNodeOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** KGNodeType is enum for the field type */
export enum KgNodeType {
  AccountEntity = 'ACCOUNT_ENTITY',
  Asset = 'ASSET',
  BusinessEntity = 'BUSINESS_ENTITY',
  CharitableEntity = 'CHARITABLE_ENTITY',
  CharitableOrganization = 'CHARITABLE_ORGANIZATION',
  CorporateOrganization = 'CORPORATE_ORGANIZATION',
  DirectHoldingsGroup = 'DIRECT_HOLDINGS_GROUP',
  Liability = 'LIABILITY',
  LifeInsurance = 'LIFE_INSURANCE',
  Person = 'PERSON',
  TrustEntity = 'TRUST_ENTITY'
}

/**
 * KGNodeWhereInput is used for filtering KGNode objects.
 * Input was generated by ent.
 */
export type KgNodeWhereInput = {
  and?: InputMaybe<Array<KgNodeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** file_id field predicates */
  fileID?: InputMaybe<Scalars['ID']['input']>;
  fileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  fileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ai_suggestions edge predicates */
  hasAiSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  hasAiSuggestionsWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** evidence edge predicates */
  hasEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  hasEvidenceWith?: InputMaybe<Array<AiSuggestionEvidenceWhereInput>>;
  /** file edge predicates */
  hasFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileWith?: InputMaybe<Array<FileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** inbound_relationships edge predicates */
  hasInboundRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasInboundRelationshipsWith?: InputMaybe<Array<KgRelationshipWhereInput>>;
  /** kg_root edge predicates */
  hasKgRoot?: InputMaybe<Scalars['Boolean']['input']>;
  hasKgRootWith?: InputMaybe<Array<KgRootWhereInput>>;
  /** merged_from edge predicates */
  hasMergedFrom?: InputMaybe<Scalars['Boolean']['input']>;
  hasMergedFromWith?: InputMaybe<Array<KgNodeWhereInput>>;
  /** outbound_relationships edge predicates */
  hasOutboundRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasOutboundRelationshipsWith?: InputMaybe<Array<KgRelationshipWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<KgNodeWhereInput>;
  or?: InputMaybe<Array<KgNodeWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** type field predicates */
  type?: InputMaybe<KgNodeType>;
  typeIn?: InputMaybe<Array<KgNodeType>>;
  typeNEQ?: InputMaybe<KgNodeType>;
  typeNotIn?: InputMaybe<Array<KgNodeType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type KgRelationship = Node & {
  __typename?: 'KGRelationship';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The LLM description of the relationship. */
  description: Scalars['String']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The source node of the relationship. */
  source: KgNode;
  /** The KGNode ID that is the source of this relationship. */
  sourceNodeID: Scalars['ID']['output'];
  /** How confident the LLM is in the relationship. */
  strength?: Maybe<Scalars['Int']['output']>;
  /** The target node of the relationship. */
  target: KgNode;
  /** The KGNode ID that is the target of this relationship. */
  targetNodeID: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The type of the relationship between the source and target nodes. */
  type: KgRelationshipType;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for KGRelationship connections */
export type KgRelationshipOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KGRelationships. */
  field: KgRelationshipOrderField;
};

/** Properties by which KGRelationship connections can be ordered. */
export enum KgRelationshipOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** KGRelationshipType is enum for the field type */
export enum KgRelationshipType {
  BeneficiaryOf = 'BENEFICIARY_OF',
  ChildOf = 'CHILD_OF',
  CreatedUponTheDeathOf = 'CREATED_UPON_THE_DEATH_OF',
  DomesticPartnerOf = 'DOMESTIC_PARTNER_OF',
  DonorOf = 'DONOR_OF',
  ExSpouseOf = 'EX_SPOUSE_OF',
  FriendOf = 'FRIEND_OF',
  GrandchildOf = 'GRANDCHILD_OF',
  GrandparentOf = 'GRANDPARENT_OF',
  GrantorOf = 'GRANTOR_OF',
  InsuredBy = 'INSURED_BY',
  IsCreditorOf = 'IS_CREDITOR_OF',
  IsDebtorOf = 'IS_DEBTOR_OF',
  Other = 'OTHER',
  OwnerOf = 'OWNER_OF',
  Owns = 'OWNS',
  ParentOf = 'PARENT_OF',
  PoursOverTo = 'POURS_OVER_TO',
  ReceivesDistributionsUponGrantorDeath = 'RECEIVES_DISTRIBUTIONS_UPON_GRANTOR_DEATH',
  SiblingOf = 'SIBLING_OF',
  SpouseOf = 'SPOUSE_OF',
  StepChildOf = 'STEP_CHILD_OF',
  StepParentOf = 'STEP_PARENT_OF',
  TrusteeOf = 'TRUSTEE_OF',
  TrustAdvisorOf = 'TRUST_ADVISOR_OF'
}

/**
 * KGRelationshipWhereInput is used for filtering KGRelationship objects.
 * Input was generated by ent.
 */
export type KgRelationshipWhereInput = {
  and?: InputMaybe<Array<KgRelationshipWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** source edge predicates */
  hasSource?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceWith?: InputMaybe<Array<KgNodeWhereInput>>;
  /** target edge predicates */
  hasTarget?: InputMaybe<Scalars['Boolean']['input']>;
  hasTargetWith?: InputMaybe<Array<KgNodeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<KgRelationshipWhereInput>;
  or?: InputMaybe<Array<KgRelationshipWhereInput>>;
  /** source_node_id field predicates */
  sourceNodeID?: InputMaybe<Scalars['ID']['input']>;
  sourceNodeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceNodeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  sourceNodeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** strength field predicates */
  strength?: InputMaybe<Scalars['Int']['input']>;
  strengthGT?: InputMaybe<Scalars['Int']['input']>;
  strengthGTE?: InputMaybe<Scalars['Int']['input']>;
  strengthIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  strengthLT?: InputMaybe<Scalars['Int']['input']>;
  strengthLTE?: InputMaybe<Scalars['Int']['input']>;
  strengthNEQ?: InputMaybe<Scalars['Int']['input']>;
  strengthNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** target_node_id field predicates */
  targetNodeID?: InputMaybe<Scalars['ID']['input']>;
  targetNodeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetNodeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  targetNodeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** type field predicates */
  type?: InputMaybe<KgRelationshipType>;
  typeIn?: InputMaybe<Array<KgRelationshipType>>;
  typeNEQ?: InputMaybe<KgRelationshipType>;
  typeNotIn?: InputMaybe<Array<KgRelationshipType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type KgRoot = Node & {
  __typename?: 'KGRoot';
  /** The associated ai_suggestion that this knowledge graph represents data about. When a real entity or TE is created from this suggestion, the kg_root relationship will be set. */
  aiSuggestion?: Maybe<AiSuggestion>;
  /** The AI suggestions that were created from the nodes/relationships in this KGRoot. */
  aiSuggestions?: Maybe<Array<AiSuggestion>>;
  /** The async job to track the status of the KGRoot creation. */
  asyncJob?: Maybe<AsyncJob>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** The associated entity that this knowledge graph represents data about. */
  entity?: Maybe<Entity>;
  /** The files whose nodes/relationships should be included in this KGRoot. */
  files?: Maybe<Array<File>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** What is this knowledge graph a representation of. */
  kind: KgRootKind;
  nodes: KgNodeConnection;
  /** The status of the construction of this KGRoot. It will be COMPLETE when the KGNodes have all been generated for the associated files and merged into the root. */
  status: KgRootStatus;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The associated testamentary entity that this knowledge graph represents data about. */
  testamentaryEntity?: Maybe<TestamentaryEntity>;
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};


export type KgRootNodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KgNodeOrder>>;
  where?: InputMaybe<KgNodeWhereInput>;
};

/** A connection to a list of items. */
export type KgRootConnection = {
  __typename?: 'KGRootConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<KgRootEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KgRootEdge = {
  __typename?: 'KGRootEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<KgRoot>;
};

/** KGRootKind is enum for the field kind */
export enum KgRootKind {
  EntityDispositiveProvisionsGrantor_1DiesFirst = 'ENTITY_DISPOSITIVE_PROVISIONS_GRANTOR_1_DIES_FIRST',
  EntityDispositiveProvisionsGrantor_2DiesFirst = 'ENTITY_DISPOSITIVE_PROVISIONS_GRANTOR_2_DIES_FIRST',
  HouseholdAssets = 'HOUSEHOLD_ASSETS',
  HouseholdLiabilities = 'HOUSEHOLD_LIABILITIES',
  HouseholdLifeInsurance = 'HOUSEHOLD_LIFE_INSURANCE',
  HouseholdOnboarding = 'HOUSEHOLD_ONBOARDING',
  TestamentaryEntityDispositiveProvisions = 'TESTAMENTARY_ENTITY_DISPOSITIVE_PROVISIONS'
}

/** Ordering options for KGRoot connections */
export type KgRootOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KGRoots. */
  field: KgRootOrderField;
};

/** Properties by which KGRoot connections can be ordered. */
export enum KgRootOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** KGRootStatus is enum for the field status */
export enum KgRootStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  SuggestionReviewComplete = 'SUGGESTION_REVIEW_COMPLETE'
}

/**
 * KGRootWhereInput is used for filtering KGRoot objects.
 * Input was generated by ent.
 */
export type KgRootWhereInput = {
  and?: InputMaybe<Array<KgRootWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ai_suggestion edge predicates */
  hasAiSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasAiSuggestionWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** ai_suggestions edge predicates */
  hasAiSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  hasAiSuggestionsWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** async_job edge predicates */
  hasAsyncJob?: InputMaybe<Scalars['Boolean']['input']>;
  hasAsyncJobWith?: InputMaybe<Array<AsyncJobWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** files edge predicates */
  hasFiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasFilesWith?: InputMaybe<Array<FileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** nodes edge predicates */
  hasNodes?: InputMaybe<Scalars['Boolean']['input']>;
  hasNodesWith?: InputMaybe<Array<KgNodeWhereInput>>;
  /** testamentary_entity edge predicates */
  hasTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasTestamentaryEntityWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<KgRootKind>;
  kindIn?: InputMaybe<Array<KgRootKind>>;
  kindNEQ?: InputMaybe<KgRootKind>;
  kindNotIn?: InputMaybe<Array<KgRootKind>>;
  not?: InputMaybe<KgRootWhereInput>;
  or?: InputMaybe<Array<KgRootWhereInput>>;
  /** status field predicates */
  status?: InputMaybe<KgRootStatus>;
  statusIn?: InputMaybe<Array<KgRootStatus>>;
  statusNEQ?: InputMaybe<KgRootStatus>;
  statusNotIn?: InputMaybe<Array<KgRootStatus>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Kgv2Document = Node & {
  __typename?: 'KGV2Document';
  /** Number of times a worker has acquired the lease for the current phase. Reset to 0 when processing_state advances. */
  attemptCount: Scalars['Int']['output'];
  /** @deprecated Use KGV2DocumentModification.changes instead. */
  changes: Kgv2DocumentChangeConnection;
  createdAt: Scalars['Time']['output'];
  /** Links this per-graph document wrapper to the core Document (single source of truth for file/title/metadata) */
  document: Document;
  /** Signing/execution date (null for account statements). Kept here for MVP; may migrate to core Document later. */
  executedOn?: Maybe<Scalars['Time']['output']>;
  /** Monotonic revision of the extraction content. Incremented only when extraction content is saved. */
  extractionRevision: Scalars['Int']['output'];
  graph: Kgv2Graph;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Per-graph ingestion status for this document. Omitted is a terminal state for documents that KG V2 should not retry automatically. */
  ingestionState: Kgv2DocumentIngestionState;
  /** Canonical name of the legal instrument (e.g., 'John Smith Revocable Trust'). Used to group related documents for amendment linking. */
  instrumentName?: Maybe<Scalars['String']['output']>;
  /** Generic machine-readable categories extracted from the source document, such as trust_document or email. Labels must not contain PII. */
  labels: Array<Scalars['String']['output']>;
  /** Timestamp of the most recent failed attempt. Non-null indicates the last attempt failed. */
  lastErrorAt?: Maybe<Scalars['Time']['output']>;
  /** When the current lease expires. NULL means no active lease; a value in the past means the lease is stale and the row is available for pickup. */
  leaseExpiresAt?: Maybe<Scalars['Time']['output']>;
  modificationsMade: Kgv2DocumentModificationConnection;
  modificationsReceived: Kgv2DocumentModificationConnection;
  nodeAliases: Kgv2NodeAliasConnection;
  nodes: Kgv2NodeConnection;
  /** Optional machine-readable omission reason for terminally unprocessable documents, such as no_valid_paragraphs or context_window_exceeded. */
  omissionReason?: Maybe<Scalars['String']['output']>;
  /** Current phase in the processing pipeline. Advances on phase success; preserved across failures so workers can resume from the last known phase. */
  processingState: Kgv2DocumentProcessingState;
  /**
   * DEPRECATED: model 'revokes all prior versions' as a KGV2DocumentModification directive row.
   * @deprecated Use a KGV2DocumentModification directive row (kind=revokes, target_resolution=all_prior_of_instrument) instead.
   */
  revokesAllPrior?: Maybe<Scalars['Boolean']['output']>;
  statements: Kgv2StatementConnection;
  /**
   * DEPRECATED: use KGV2DocumentModification rows (from_document/to_document) instead. Kept during transition. See docs/design-docs/kg_v2/document_modification_schema.md.
   * @deprecated Use KGV2DocumentModification rows instead.
   */
  supersededBy?: Maybe<Kgv2Document>;
  supersedesDocument?: Maybe<Kgv2Document>;
  /**
   * DEPRECATED: see KGV2DocumentModification.kind.
   * @deprecated Use KGV2DocumentModification.kind instead.
   */
  supersessionKind?: Maybe<Kgv2DocumentSupersessionKind>;
  /**
   * DEPRECATED: see KGV2DocumentModification.target_descriptor_date.
   * @deprecated Use KGV2DocumentModification.target_descriptor_date instead.
   */
  targetInstrumentDate?: Maybe<Scalars['Time']['output']>;
  /**
   * DEPRECATED: see KGV2DocumentModification.target_descriptor_title.
   * @deprecated Use KGV2DocumentModification.target_descriptor_title instead.
   */
  targetInstrumentTitle?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type Kgv2DocumentChangesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2DocumentChangeOrder>>;
  where?: InputMaybe<Kgv2DocumentChangeWhereInput>;
};


export type Kgv2DocumentModificationsMadeArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2DocumentModificationOrder>>;
  where?: InputMaybe<Kgv2DocumentModificationWhereInput>;
};


export type Kgv2DocumentModificationsReceivedArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2DocumentModificationOrder>>;
  where?: InputMaybe<Kgv2DocumentModificationWhereInput>;
};


export type Kgv2DocumentNodeAliasesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2NodeAliasOrder>>;
  where?: InputMaybe<Kgv2NodeAliasWhereInput>;
};


export type Kgv2DocumentNodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2NodeOrder>>;
  where?: InputMaybe<Kgv2NodeWhereInput>;
};


export type Kgv2DocumentStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2StatementOrder>>;
  where?: InputMaybe<Kgv2StatementWhereInput>;
};

export type Kgv2DocumentChange = Node & {
  __typename?: 'KGV2DocumentChange';
  /** Type of change: restates (replaces), revokes (removes), amends (modifies), adds (new content), removes (deletes) */
  action: Kgv2DocumentChangeAction;
  createdAt: Scalars['Time']['output'];
  /** Brief explanation of the change */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The KGV2Document that contains this change. DEPRECATED: changes are being re-parented under KGV2DocumentModification. Kept Required during transition; new writes still populate this alongside 'modification'. See docs/design-docs/kg_v2/document_modification_schema.md.
   * @deprecated Use KGV2DocumentChange.modification instead.
   */
  document: Kgv2Document;
  evidence: FileParagraphConnection;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The KGV2DocumentModification this change belongs to. Optional at the Ent level so any pre-existing rows remain valid without backfill; service-layer write code requires it on new KGV2DocumentChange rows. */
  modification?: Maybe<Kgv2DocumentModification>;
  /** What this change affects: 'entire_document' or a specific section reference (e.g., 'Section 3.1', 'Article IV') */
  scope: Scalars['String']['output'];
  statementSupersessions: Kgv2StatementSupersessionConnection;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type Kgv2DocumentChangeEvidenceArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileParagraphOrder>>;
};


export type Kgv2DocumentChangeStatementSupersessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2StatementSupersessionOrder>>;
  where?: InputMaybe<Kgv2StatementSupersessionWhereInput>;
};

/** KGV2DocumentChangeAction is enum for the field action */
export enum Kgv2DocumentChangeAction {
  Adds = 'adds',
  Amends = 'amends',
  Removes = 'removes',
  Restates = 'restates',
  Revokes = 'revokes'
}

/** A connection to a list of items. */
export type Kgv2DocumentChangeConnection = {
  __typename?: 'KGV2DocumentChangeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Kgv2DocumentChangeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Kgv2DocumentChangeEdge = {
  __typename?: 'KGV2DocumentChangeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Kgv2DocumentChange>;
};

/** Ordering options for KGV2DocumentChange connections */
export type Kgv2DocumentChangeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KGV2DocumentChanges. */
  field: Kgv2DocumentChangeOrderField;
};

/** Properties by which KGV2DocumentChange connections can be ordered. */
export enum Kgv2DocumentChangeOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * KGV2DocumentChangeWhereInput is used for filtering KGV2DocumentChange objects.
 * Input was generated by ent.
 */
export type Kgv2DocumentChangeWhereInput = {
  /** action field predicates */
  action?: InputMaybe<Kgv2DocumentChangeAction>;
  actionIn?: InputMaybe<Array<Kgv2DocumentChangeAction>>;
  actionNEQ?: InputMaybe<Kgv2DocumentChangeAction>;
  actionNotIn?: InputMaybe<Array<Kgv2DocumentChangeAction>>;
  and?: InputMaybe<Array<Kgv2DocumentChangeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<Kgv2DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** modification edge predicates */
  hasModification?: InputMaybe<Scalars['Boolean']['input']>;
  hasModificationWith?: InputMaybe<Array<Kgv2DocumentModificationWhereInput>>;
  /** statement_supersessions edge predicates */
  hasStatementSupersessions?: InputMaybe<Scalars['Boolean']['input']>;
  hasStatementSupersessionsWith?: InputMaybe<Array<Kgv2StatementSupersessionWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<Kgv2DocumentChangeWhereInput>;
  or?: InputMaybe<Array<Kgv2DocumentChangeWhereInput>>;
  /** scope field predicates */
  scope?: InputMaybe<Scalars['String']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** A connection to a list of items. */
export type Kgv2DocumentConnection = {
  __typename?: 'KGV2DocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Kgv2DocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Kgv2DocumentEdge = {
  __typename?: 'KGV2DocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Kgv2Document>;
};

/** KGV2DocumentIngestionState is enum for the field ingestion_state */
export enum Kgv2DocumentIngestionState {
  Complete = 'complete',
  Error = 'error',
  Omitted = 'omitted',
  Pending = 'pending',
  Processing = 'processing'
}

export type Kgv2DocumentModification = Node & {
  __typename?: 'KGV2DocumentModification';
  /** Linking agent's reasoning when the row came from an LLM match. Persisted so we can audit re-decisions and surface them in UI. */
  agentReasoning?: Maybe<Scalars['String']['output']>;
  changes: Kgv2DocumentChangeConnection;
  /** LLM confidence when the linking agent produced this row. Null when not applicable. */
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Time']['output'];
  /** Free-form summary of the relationship. */
  description?: Maybe<Scalars['String']['output']>;
  evidence: FileParagraphConnection;
  /** The newer/superseding doc. Cascade on delete: removing the amending doc removes the modification row that references it. Both documents on a modification should belong to the same KGV2Graph; this invariant is enforced in service code, not the schema. */
  fromDocument: Kgv2Document;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Relationship-level effect. 'codicil' is intentionally absent — that is a legal-form property of from_document, not the relation. */
  kind: Kgv2DocumentModificationKind;
  /** Relation-level section reference for partial amendments (e.g., 'Article IV'). Per-section detail lives in child KGV2DocumentChange rows. */
  scope?: Maybe<Scalars['String']['output']>;
  statementSupersessions: Kgv2StatementSupersessionConnection;
  /** Date the doc claimed for its target. Provenance, not authoritative once resolved. */
  targetDescriptorDate?: Maybe<Scalars['Time']['output']>;
  /** What the doc claimed about its target (e.g. 'John Smith Trust dated January 1, 2010'). Preserved on resolved rows as evidence of the original claim. */
  targetDescriptorTitle?: Maybe<Scalars['String']['output']>;
  /** Disambiguates rows with to_document = null. resolved: to_document set. unresolved_specific: descriptor names a specific doc we do not have. all_prior_of_instrument: open-ended directive covering every prior version of from_document.instrument_name. */
  targetResolution: Kgv2DocumentModificationTargetResolution;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The older/superseded doc. Null when target_resolution != resolved. Cascade on delete: removing the original doc removes the modification row that references it. */
  toDocument?: Maybe<Kgv2Document>;
  updatedAt: Scalars['Time']['output'];
};


export type Kgv2DocumentModificationChangesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2DocumentChangeOrder>>;
  where?: InputMaybe<Kgv2DocumentChangeWhereInput>;
};


export type Kgv2DocumentModificationEvidenceArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FileParagraphOrder>>;
};


export type Kgv2DocumentModificationStatementSupersessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2StatementSupersessionOrder>>;
  where?: InputMaybe<Kgv2StatementSupersessionWhereInput>;
};

/** A connection to a list of items. */
export type Kgv2DocumentModificationConnection = {
  __typename?: 'KGV2DocumentModificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Kgv2DocumentModificationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Kgv2DocumentModificationEdge = {
  __typename?: 'KGV2DocumentModificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Kgv2DocumentModification>;
};

/** KGV2DocumentModificationKind is enum for the field kind */
export enum Kgv2DocumentModificationKind {
  Amends = 'amends',
  Restates = 'restates',
  Revokes = 'revokes'
}

/** Ordering options for KGV2DocumentModification connections */
export type Kgv2DocumentModificationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KGV2DocumentModifications. */
  field: Kgv2DocumentModificationOrderField;
};

/** Properties by which KGV2DocumentModification connections can be ordered. */
export enum Kgv2DocumentModificationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** KGV2DocumentModificationTargetResolution is enum for the field target_resolution */
export enum Kgv2DocumentModificationTargetResolution {
  AllPriorOfInstrument = 'all_prior_of_instrument',
  Resolved = 'resolved',
  UnresolvedSpecific = 'unresolved_specific'
}

/**
 * KGV2DocumentModificationWhereInput is used for filtering KGV2DocumentModification objects.
 * Input was generated by ent.
 */
export type Kgv2DocumentModificationWhereInput = {
  /** agent_reasoning field predicates */
  agentReasoning?: InputMaybe<Scalars['String']['input']>;
  agentReasoningIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  agentReasoningNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<Kgv2DocumentModificationWhereInput>>;
  /** confidence field predicates */
  confidence?: InputMaybe<Scalars['Float']['input']>;
  confidenceGT?: InputMaybe<Scalars['Float']['input']>;
  confidenceGTE?: InputMaybe<Scalars['Float']['input']>;
  confidenceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  confidenceLT?: InputMaybe<Scalars['Float']['input']>;
  confidenceLTE?: InputMaybe<Scalars['Float']['input']>;
  confidenceNEQ?: InputMaybe<Scalars['Float']['input']>;
  confidenceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** changes edge predicates */
  hasChanges?: InputMaybe<Scalars['Boolean']['input']>;
  hasChangesWith?: InputMaybe<Array<Kgv2DocumentChangeWhereInput>>;
  /** from_document edge predicates */
  hasFromDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasFromDocumentWith?: InputMaybe<Array<Kgv2DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** statement_supersessions edge predicates */
  hasStatementSupersessions?: InputMaybe<Scalars['Boolean']['input']>;
  hasStatementSupersessionsWith?: InputMaybe<Array<Kgv2StatementSupersessionWhereInput>>;
  /** to_document edge predicates */
  hasToDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasToDocumentWith?: InputMaybe<Array<Kgv2DocumentWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<Kgv2DocumentModificationKind>;
  kindIn?: InputMaybe<Array<Kgv2DocumentModificationKind>>;
  kindNEQ?: InputMaybe<Kgv2DocumentModificationKind>;
  kindNotIn?: InputMaybe<Array<Kgv2DocumentModificationKind>>;
  not?: InputMaybe<Kgv2DocumentModificationWhereInput>;
  or?: InputMaybe<Array<Kgv2DocumentModificationWhereInput>>;
  /** scope field predicates */
  scope?: InputMaybe<Scalars['String']['input']>;
  scopeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  scopeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** target_descriptor_date field predicates */
  targetDescriptorDate?: InputMaybe<Scalars['Time']['input']>;
  targetDescriptorDateGT?: InputMaybe<Scalars['Time']['input']>;
  targetDescriptorDateGTE?: InputMaybe<Scalars['Time']['input']>;
  targetDescriptorDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  targetDescriptorDateLT?: InputMaybe<Scalars['Time']['input']>;
  targetDescriptorDateLTE?: InputMaybe<Scalars['Time']['input']>;
  targetDescriptorDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** target_descriptor_title field predicates */
  targetDescriptorTitle?: InputMaybe<Scalars['String']['input']>;
  targetDescriptorTitleIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  targetDescriptorTitleNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** target_resolution field predicates */
  targetResolution?: InputMaybe<Kgv2DocumentModificationTargetResolution>;
  targetResolutionIn?: InputMaybe<Array<Kgv2DocumentModificationTargetResolution>>;
  targetResolutionNEQ?: InputMaybe<Kgv2DocumentModificationTargetResolution>;
  targetResolutionNotIn?: InputMaybe<Array<Kgv2DocumentModificationTargetResolution>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Ordering options for KGV2Document connections */
export type Kgv2DocumentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KGV2Documents. */
  field: Kgv2DocumentOrderField;
};

/** Properties by which KGV2Document connections can be ordered. */
export enum Kgv2DocumentOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** KGV2DocumentProcessingState is enum for the field processing_state */
export enum Kgv2DocumentProcessingState {
  Complete = 'complete',
  DedupeMerge = 'dedupe_merge',
  ExtractingMetadata = 'extracting_metadata',
  ExtractingNodes = 'extracting_nodes',
  ExtractingStatements = 'extracting_statements',
  MergingHousehold = 'merging_household',
  Pending = 'pending'
}

/** KGV2DocumentSupersessionKind is enum for the field supersession_kind */
export enum Kgv2DocumentSupersessionKind {
  Amends = 'amends',
  Codicil = 'codicil',
  Restates = 'restates',
  Revocation = 'revocation'
}

/**
 * KGV2DocumentWhereInput is used for filtering KGV2Document objects.
 * Input was generated by ent.
 */
export type Kgv2DocumentWhereInput = {
  and?: InputMaybe<Array<Kgv2DocumentWhereInput>>;
  /** attempt_count field predicates */
  attemptCount?: InputMaybe<Scalars['Int']['input']>;
  attemptCountGT?: InputMaybe<Scalars['Int']['input']>;
  attemptCountGTE?: InputMaybe<Scalars['Int']['input']>;
  attemptCountLT?: InputMaybe<Scalars['Int']['input']>;
  attemptCountLTE?: InputMaybe<Scalars['Int']['input']>;
  attemptCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** executed_on field predicates */
  executedOn?: InputMaybe<Scalars['Time']['input']>;
  executedOnGT?: InputMaybe<Scalars['Time']['input']>;
  executedOnGTE?: InputMaybe<Scalars['Time']['input']>;
  executedOnIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  executedOnLT?: InputMaybe<Scalars['Time']['input']>;
  executedOnLTE?: InputMaybe<Scalars['Time']['input']>;
  executedOnNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** extraction_revision field predicates */
  extractionRevision?: InputMaybe<Scalars['Int']['input']>;
  extractionRevisionGT?: InputMaybe<Scalars['Int']['input']>;
  extractionRevisionGTE?: InputMaybe<Scalars['Int']['input']>;
  extractionRevisionLT?: InputMaybe<Scalars['Int']['input']>;
  extractionRevisionLTE?: InputMaybe<Scalars['Int']['input']>;
  extractionRevisionNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** changes edge predicates */
  hasChanges?: InputMaybe<Scalars['Boolean']['input']>;
  hasChangesWith?: InputMaybe<Array<Kgv2DocumentChangeWhereInput>>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** graph edge predicates */
  hasGraph?: InputMaybe<Scalars['Boolean']['input']>;
  hasGraphWith?: InputMaybe<Array<Kgv2GraphWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** modifications_made edge predicates */
  hasModificationsMade?: InputMaybe<Scalars['Boolean']['input']>;
  hasModificationsMadeWith?: InputMaybe<Array<Kgv2DocumentModificationWhereInput>>;
  /** modifications_received edge predicates */
  hasModificationsReceived?: InputMaybe<Scalars['Boolean']['input']>;
  hasModificationsReceivedWith?: InputMaybe<Array<Kgv2DocumentModificationWhereInput>>;
  /** node_aliases edge predicates */
  hasNodeAliases?: InputMaybe<Scalars['Boolean']['input']>;
  hasNodeAliasesWith?: InputMaybe<Array<Kgv2NodeAliasWhereInput>>;
  /** nodes edge predicates */
  hasNodes?: InputMaybe<Scalars['Boolean']['input']>;
  hasNodesWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** statements edge predicates */
  hasStatements?: InputMaybe<Scalars['Boolean']['input']>;
  hasStatementsWith?: InputMaybe<Array<Kgv2StatementWhereInput>>;
  /** superseded_by edge predicates */
  hasSupersededBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupersededByWith?: InputMaybe<Array<Kgv2DocumentWhereInput>>;
  /** supersedes_document edge predicates */
  hasSupersedesDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupersedesDocumentWith?: InputMaybe<Array<Kgv2DocumentWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ingestion_state field predicates */
  ingestionState?: InputMaybe<Kgv2DocumentIngestionState>;
  ingestionStateIn?: InputMaybe<Array<Kgv2DocumentIngestionState>>;
  ingestionStateNEQ?: InputMaybe<Kgv2DocumentIngestionState>;
  ingestionStateNotIn?: InputMaybe<Array<Kgv2DocumentIngestionState>>;
  /** instrument_name field predicates */
  instrumentName?: InputMaybe<Scalars['String']['input']>;
  instrumentNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  instrumentNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_error_at field predicates */
  lastErrorAt?: InputMaybe<Scalars['Time']['input']>;
  lastErrorAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastErrorAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastErrorAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastErrorAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastErrorAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastErrorAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** lease_expires_at field predicates */
  leaseExpiresAt?: InputMaybe<Scalars['Time']['input']>;
  leaseExpiresAtGT?: InputMaybe<Scalars['Time']['input']>;
  leaseExpiresAtGTE?: InputMaybe<Scalars['Time']['input']>;
  leaseExpiresAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  leaseExpiresAtLT?: InputMaybe<Scalars['Time']['input']>;
  leaseExpiresAtLTE?: InputMaybe<Scalars['Time']['input']>;
  leaseExpiresAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<Kgv2DocumentWhereInput>;
  /** omission_reason field predicates */
  omissionReason?: InputMaybe<Scalars['String']['input']>;
  omissionReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  omissionReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<Kgv2DocumentWhereInput>>;
  /** processing_state field predicates */
  processingState?: InputMaybe<Kgv2DocumentProcessingState>;
  processingStateIn?: InputMaybe<Array<Kgv2DocumentProcessingState>>;
  processingStateNEQ?: InputMaybe<Kgv2DocumentProcessingState>;
  processingStateNotIn?: InputMaybe<Array<Kgv2DocumentProcessingState>>;
  /** revokes_all_prior field predicates */
  revokesAllPrior?: InputMaybe<Scalars['Boolean']['input']>;
  revokesAllPriorIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  revokesAllPriorNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** supersession_kind field predicates */
  supersessionKind?: InputMaybe<Kgv2DocumentSupersessionKind>;
  supersessionKindIn?: InputMaybe<Array<Kgv2DocumentSupersessionKind>>;
  supersessionKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  supersessionKindNEQ?: InputMaybe<Kgv2DocumentSupersessionKind>;
  supersessionKindNotIn?: InputMaybe<Array<Kgv2DocumentSupersessionKind>>;
  supersessionKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** target_instrument_date field predicates */
  targetInstrumentDate?: InputMaybe<Scalars['Time']['input']>;
  targetInstrumentDateGT?: InputMaybe<Scalars['Time']['input']>;
  targetInstrumentDateGTE?: InputMaybe<Scalars['Time']['input']>;
  targetInstrumentDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  targetInstrumentDateLT?: InputMaybe<Scalars['Time']['input']>;
  targetInstrumentDateLTE?: InputMaybe<Scalars['Time']['input']>;
  targetInstrumentDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** target_instrument_title field predicates */
  targetInstrumentTitle?: InputMaybe<Scalars['String']['input']>;
  targetInstrumentTitleIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  targetInstrumentTitleNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Kgv2Graph = Node & {
  __typename?: 'KGV2Graph';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Optional description of this graph version */
  description?: Maybe<Scalars['String']['output']>;
  documents: Kgv2DocumentConnection;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Whether this is the active/primary graph for the household */
  isActive: Scalars['Boolean']['output'];
  /**
   * Returns the graph serialized as JSON for use in LLM prompts.
   * Includes all nodes and statements from the graph.
   */
  markdown: Kgv2GraphMarkdown;
  /** Name/label for this graph version (e.g., 'Production', 'Experiment 2024-11-05') */
  name: Scalars['String']['output'];
  nodes: Kgv2NodeConnection;
  statements: Kgv2StatementConnection;
  /** Graph status */
  status: Kgv2GraphStatus;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type Kgv2GraphDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2DocumentOrder>>;
  where?: InputMaybe<Kgv2DocumentWhereInput>;
};


export type Kgv2GraphNodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2NodeOrder>>;
  where?: InputMaybe<Kgv2NodeWhereInput>;
};


export type Kgv2GraphStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2StatementOrder>>;
  where?: InputMaybe<Kgv2StatementWhereInput>;
};

/** A connection to a list of items. */
export type Kgv2GraphConnection = {
  __typename?: 'KGV2GraphConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Kgv2GraphEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Kgv2GraphEdge = {
  __typename?: 'KGV2GraphEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Kgv2Graph>;
};

/** JSON serialization of a KGV2 knowledge graph for LLM prompts. */
export type Kgv2GraphMarkdown = {
  __typename?: 'KGV2GraphMarkdown';
  /** JSON representation of all nodes in the graph. */
  nodesTable: Scalars['String']['output'];
  /** JSON representation of all statements in the graph. */
  statementsTable: Scalars['String']['output'];
};

/** Ordering options for KGV2Graph connections */
export type Kgv2GraphOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KGV2Graphs. */
  field: Kgv2GraphOrderField;
};

/** Properties by which KGV2Graph connections can be ordered. */
export enum Kgv2GraphOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** KGV2GraphStatus is enum for the field status */
export enum Kgv2GraphStatus {
  Active = 'active',
  Archived = 'archived',
  Draft = 'draft'
}

/**
 * KGV2GraphWhereInput is used for filtering KGV2Graph objects.
 * Input was generated by ent.
 */
export type Kgv2GraphWhereInput = {
  and?: InputMaybe<Array<Kgv2GraphWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** documents edge predicates */
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsWith?: InputMaybe<Array<Kgv2DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** nodes edge predicates */
  hasNodes?: InputMaybe<Scalars['Boolean']['input']>;
  hasNodesWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** statements edge predicates */
  hasStatements?: InputMaybe<Scalars['Boolean']['input']>;
  hasStatementsWith?: InputMaybe<Array<Kgv2StatementWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<Kgv2GraphWhereInput>;
  or?: InputMaybe<Array<Kgv2GraphWhereInput>>;
  /** status field predicates */
  status?: InputMaybe<Kgv2GraphStatus>;
  statusIn?: InputMaybe<Array<Kgv2GraphStatus>>;
  statusNEQ?: InputMaybe<Kgv2GraphStatus>;
  statusNotIn?: InputMaybe<Array<Kgv2GraphStatus>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Kgv2Node = Node & {
  __typename?: 'KGV2Node';
  aliases: Kgv2NodeAliasConnection;
  /** Type-specific attributes stored as JSONB */
  attrs?: Maybe<Scalars['Map']['output']>;
  createdAt: Scalars['Time']['output'];
  /** How this node was created: model (AI extraction) or manual */
  createdSource: Kgv2NodeCreatedSource;
  /** High-level context about this entity or observation (e.g., revocability language for trusts, entity purpose) */
  description?: Maybe<Scalars['String']['output']>;
  dpRecipientSuggestions: AiSuggestionConnection;
  evidence: Kgv2NodeEvidenceConnection;
  graph: Kgv2Graph;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** If manually merged, this points to the winner node */
  mergedFrom?: Maybe<Array<Kgv2Node>>;
  mergedInto?: Maybe<Kgv2Node>;
  /** Primary name for this node; observation nodes use a short stable label with content in description */
  namePrimary: Scalars['String']['output'];
  /** Type of node */
  nodeType: Kgv2NodeNodeType;
  onboardingSuggestions: AiSuggestionConnection;
  onboardingTestamentaryParentSuggestions: AiSuggestionConnection;
  resolvedAssets: AssetV2Connection;
  resolvedClientOrganizations: ClientOrganizationConnection;
  resolvedClientProfiles: ClientProfileConnection;
  resolvedEntities: EntityConnection;
  resolvedInsurancePolicies: InsurancePolicyConnection;
  resolvedLiabilities: LiabilityConnection;
  resolvedTestamentaryEntities: TestamentaryEntityConnection;
  sourceDocuments: Kgv2DocumentConnection;
  /** Node state: active, merged (into another node), or deprecated */
  state: Kgv2NodeState;
  statementsAsObject: Kgv2StatementConnection;
  statementsAsSubject: Kgv2StatementConnection;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type Kgv2NodeAliasesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2NodeAliasOrder>>;
  where?: InputMaybe<Kgv2NodeAliasWhereInput>;
};


export type Kgv2NodeDpRecipientSuggestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AiSuggestionOrder>>;
  where?: InputMaybe<AiSuggestionWhereInput>;
};


export type Kgv2NodeEvidenceArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2NodeEvidenceOrder>>;
  where?: InputMaybe<Kgv2NodeEvidenceWhereInput>;
};


export type Kgv2NodeOnboardingSuggestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AiSuggestionOrder>>;
  where?: InputMaybe<AiSuggestionWhereInput>;
};


export type Kgv2NodeOnboardingTestamentaryParentSuggestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AiSuggestionOrder>>;
  where?: InputMaybe<AiSuggestionWhereInput>;
};


export type Kgv2NodeResolvedAssetsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssetV2Order>>;
  where?: InputMaybe<AssetV2WhereInput>;
};


export type Kgv2NodeResolvedClientOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClientOrganizationOrder>>;
  where?: InputMaybe<ClientOrganizationWhereInput>;
};


export type Kgv2NodeResolvedClientProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClientProfileOrder>>;
  where?: InputMaybe<ClientProfileWhereInput>;
};


export type Kgv2NodeResolvedEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityOrder>>;
  where?: InputMaybe<EntityWhereInput>;
};


export type Kgv2NodeResolvedInsurancePoliciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InsurancePolicyOrder>>;
  where?: InputMaybe<InsurancePolicyWhereInput>;
};


export type Kgv2NodeResolvedLiabilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiabilityOrder>>;
  where?: InputMaybe<LiabilityWhereInput>;
};


export type Kgv2NodeResolvedTestamentaryEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TestamentaryEntityOrder>>;
  where?: InputMaybe<TestamentaryEntityWhereInput>;
};


export type Kgv2NodeSourceDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2DocumentOrder>>;
  where?: InputMaybe<Kgv2DocumentWhereInput>;
};


export type Kgv2NodeStatementsAsObjectArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2StatementOrder>>;
  where?: InputMaybe<Kgv2StatementWhereInput>;
};


export type Kgv2NodeStatementsAsSubjectArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2StatementOrder>>;
  where?: InputMaybe<Kgv2StatementWhereInput>;
};

export type Kgv2NodeAlias = Node & {
  __typename?: 'KGV2NodeAlias';
  /** Alternative name or label for the node */
  aliasText: Scalars['String']['output'];
  /** Type of alias: legal_name, nickname, doc_label (as appears in document), account_title, abbrev (abbreviation) */
  aliasType: Kgv2NodeAliasAliasType;
  createdAt: Scalars['Time']['output'];
  /** Optional: document where this alias was found */
  document?: Maybe<Kgv2Document>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  node: Kgv2Node;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** KGV2NodeAliasAliasType is enum for the field alias_type */
export enum Kgv2NodeAliasAliasType {
  Abbrev = 'abbrev',
  AccountTitle = 'account_title',
  DocLabel = 'doc_label',
  LegalName = 'legal_name',
  Nickname = 'nickname'
}

/** A connection to a list of items. */
export type Kgv2NodeAliasConnection = {
  __typename?: 'KGV2NodeAliasConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Kgv2NodeAliasEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Kgv2NodeAliasEdge = {
  __typename?: 'KGV2NodeAliasEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Kgv2NodeAlias>;
};

/** Ordering options for KGV2NodeAlias connections */
export type Kgv2NodeAliasOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KGV2NodeAliasSlice. */
  field: Kgv2NodeAliasOrderField;
};

/** Properties by which KGV2NodeAlias connections can be ordered. */
export enum Kgv2NodeAliasOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * KGV2NodeAliasWhereInput is used for filtering KGV2NodeAlias objects.
 * Input was generated by ent.
 */
export type Kgv2NodeAliasWhereInput = {
  /** alias_text field predicates */
  aliasText?: InputMaybe<Scalars['String']['input']>;
  /** alias_type field predicates */
  aliasType?: InputMaybe<Kgv2NodeAliasAliasType>;
  aliasTypeIn?: InputMaybe<Array<Kgv2NodeAliasAliasType>>;
  aliasTypeNEQ?: InputMaybe<Kgv2NodeAliasAliasType>;
  aliasTypeNotIn?: InputMaybe<Array<Kgv2NodeAliasAliasType>>;
  and?: InputMaybe<Array<Kgv2NodeAliasWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<Kgv2DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** node edge predicates */
  hasNode?: InputMaybe<Scalars['Boolean']['input']>;
  hasNodeWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<Kgv2NodeAliasWhereInput>;
  or?: InputMaybe<Array<Kgv2NodeAliasWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** A connection to a list of items. */
export type Kgv2NodeConnection = {
  __typename?: 'KGV2NodeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Kgv2NodeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** KGV2NodeCreatedSource is enum for the field created_source */
export enum Kgv2NodeCreatedSource {
  Manual = 'manual',
  Model = 'model'
}

/** An edge in a connection. */
export type Kgv2NodeEdge = {
  __typename?: 'KGV2NodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Kgv2Node>;
};

export type Kgv2NodeEvidence = Node & {
  __typename?: 'KGV2NodeEvidence';
  createdAt: Scalars['Time']['output'];
  /** Core document this evidence comes from (source of truth for file/pages/paragraphs) */
  document: Document;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  node: Kgv2Node;
  /** Section or clause reference (e.g., 'Article III', 'Preamble') */
  sectionRef?: Maybe<Scalars['String']['output']>;
  /** Text excerpt from the document mentioning this node */
  snippet?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type Kgv2NodeEvidenceConnection = {
  __typename?: 'KGV2NodeEvidenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Kgv2NodeEvidenceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Kgv2NodeEvidenceEdge = {
  __typename?: 'KGV2NodeEvidenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Kgv2NodeEvidence>;
};

/** Ordering options for KGV2NodeEvidence connections */
export type Kgv2NodeEvidenceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KGV2NodeEvidences. */
  field: Kgv2NodeEvidenceOrderField;
};

/** Properties by which KGV2NodeEvidence connections can be ordered. */
export enum Kgv2NodeEvidenceOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * KGV2NodeEvidenceWhereInput is used for filtering KGV2NodeEvidence objects.
 * Input was generated by ent.
 */
export type Kgv2NodeEvidenceWhereInput = {
  and?: InputMaybe<Array<Kgv2NodeEvidenceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** node edge predicates */
  hasNode?: InputMaybe<Scalars['Boolean']['input']>;
  hasNodeWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<Kgv2NodeEvidenceWhereInput>;
  or?: InputMaybe<Array<Kgv2NodeEvidenceWhereInput>>;
  /** section_ref field predicates */
  sectionRef?: InputMaybe<Scalars['String']['input']>;
  sectionRefIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sectionRefNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** snippet field predicates */
  snippet?: InputMaybe<Scalars['String']['input']>;
  snippetIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  snippetNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** KGV2NodeNodeType is enum for the field node_type */
export enum Kgv2NodeNodeType {
  Address = 'address',
  Asset = 'asset',
  BusinessEntity = 'business_entity',
  DonorAdvisedFund = 'donor_advised_fund',
  Liability = 'liability',
  LifeInsurance = 'life_insurance',
  Observation = 'observation',
  Org = 'org',
  PeopleGroup = 'people_group',
  Person = 'person',
  PersonalAccount = 'personal_account',
  PrivateFoundation = 'private_foundation',
  SubTrust = 'sub_trust',
  Trust = 'trust'
}

/** Target KG V2 node or statement to link a suggestion to. Only one field should be set. */
export type Kgv2NodeOrStatementTargetInput = {
  /** Link to a KG V2 node (for ONBOARDING_* suggestions via source_kg_v2_nodes edge). */
  kgV2NodeID?: InputMaybe<Scalars['ID']['input']>;
  /** Link to a KG V2 statement (for ENTITY_DETAIL suggestions via kg_v2_statements edge). */
  kgV2StatementID?: InputMaybe<Scalars['ID']['input']>;
};

/** Ordering options for KGV2Node connections */
export type Kgv2NodeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KGV2Nodes. */
  field: Kgv2NodeOrderField;
};

/** Properties by which KGV2Node connections can be ordered. */
export enum Kgv2NodeOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** KGV2NodeState is enum for the field state */
export enum Kgv2NodeState {
  Active = 'active',
  Deprecated = 'deprecated',
  Merged = 'merged'
}

/**
 * KGV2NodeWhereInput is used for filtering KGV2Node objects.
 * Input was generated by ent.
 */
export type Kgv2NodeWhereInput = {
  and?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_source field predicates */
  createdSource?: InputMaybe<Kgv2NodeCreatedSource>;
  createdSourceIn?: InputMaybe<Array<Kgv2NodeCreatedSource>>;
  createdSourceNEQ?: InputMaybe<Kgv2NodeCreatedSource>;
  createdSourceNotIn?: InputMaybe<Array<Kgv2NodeCreatedSource>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** aliases edge predicates */
  hasAliases?: InputMaybe<Scalars['Boolean']['input']>;
  hasAliasesWith?: InputMaybe<Array<Kgv2NodeAliasWhereInput>>;
  /** dp_recipient_suggestions edge predicates */
  hasDpRecipientSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  hasDpRecipientSuggestionsWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** evidence edge predicates */
  hasEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  hasEvidenceWith?: InputMaybe<Array<Kgv2NodeEvidenceWhereInput>>;
  /** graph edge predicates */
  hasGraph?: InputMaybe<Scalars['Boolean']['input']>;
  hasGraphWith?: InputMaybe<Array<Kgv2GraphWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** merged_from edge predicates */
  hasMergedFrom?: InputMaybe<Scalars['Boolean']['input']>;
  hasMergedFromWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** merged_into edge predicates */
  hasMergedInto?: InputMaybe<Scalars['Boolean']['input']>;
  hasMergedIntoWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** onboarding_suggestions edge predicates */
  hasOnboardingSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  hasOnboardingSuggestionsWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** onboarding_testamentary_parent_suggestions edge predicates */
  hasOnboardingTestamentaryParentSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  hasOnboardingTestamentaryParentSuggestionsWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** resolved_assets edge predicates */
  hasResolvedAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasResolvedAssetsWith?: InputMaybe<Array<AssetV2WhereInput>>;
  /** resolved_client_organizations edge predicates */
  hasResolvedClientOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  hasResolvedClientOrganizationsWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** resolved_client_profiles edge predicates */
  hasResolvedClientProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasResolvedClientProfilesWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** resolved_entities edge predicates */
  hasResolvedEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasResolvedEntitiesWith?: InputMaybe<Array<EntityWhereInput>>;
  /** resolved_insurance_policies edge predicates */
  hasResolvedInsurancePolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasResolvedInsurancePoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** resolved_liabilities edge predicates */
  hasResolvedLiabilities?: InputMaybe<Scalars['Boolean']['input']>;
  hasResolvedLiabilitiesWith?: InputMaybe<Array<LiabilityWhereInput>>;
  /** resolved_testamentary_entities edge predicates */
  hasResolvedTestamentaryEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasResolvedTestamentaryEntitiesWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** source_documents edge predicates */
  hasSourceDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceDocumentsWith?: InputMaybe<Array<Kgv2DocumentWhereInput>>;
  /** statements_as_object edge predicates */
  hasStatementsAsObject?: InputMaybe<Scalars['Boolean']['input']>;
  hasStatementsAsObjectWith?: InputMaybe<Array<Kgv2StatementWhereInput>>;
  /** statements_as_subject edge predicates */
  hasStatementsAsSubject?: InputMaybe<Scalars['Boolean']['input']>;
  hasStatementsAsSubjectWith?: InputMaybe<Array<Kgv2StatementWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name_primary field predicates */
  namePrimary?: InputMaybe<Scalars['String']['input']>;
  /** node_type field predicates */
  nodeType?: InputMaybe<Kgv2NodeNodeType>;
  nodeTypeIn?: InputMaybe<Array<Kgv2NodeNodeType>>;
  nodeTypeNEQ?: InputMaybe<Kgv2NodeNodeType>;
  nodeTypeNotIn?: InputMaybe<Array<Kgv2NodeNodeType>>;
  not?: InputMaybe<Kgv2NodeWhereInput>;
  or?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** state field predicates */
  state?: InputMaybe<Kgv2NodeState>;
  stateIn?: InputMaybe<Array<Kgv2NodeState>>;
  stateNEQ?: InputMaybe<Kgv2NodeState>;
  stateNotIn?: InputMaybe<Array<Kgv2NodeState>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Kgv2Statement = Node & {
  __typename?: 'KGV2Statement';
  /** The AI suggestions that were generated from this statement */
  aiSuggestions?: Maybe<Array<AiSuggestion>>;
  /** Human-readable description of the condition (e.g., 'attains age 30', 'upon grantor's death'). Null for unconditional statements. */
  conditionDescription?: Maybe<Scalars['String']['output']>;
  /** Type of condition governing this statement, if any (e.g., age, death, survival). Null for unconditional statements. */
  conditionType?: Maybe<Kgv2StatementConditionType>;
  /** Confidence score 0-1 for ML extractions (1.0 for manual) */
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Time']['output'];
  /** Source document for this statement */
  document?: Maybe<Kgv2Document>;
  /** Start date for this fact (defaults to document.executed_on) */
  effectiveFrom?: Maybe<Scalars['Time']['output']>;
  /** End date for this fact */
  effectiveTo?: Maybe<Scalars['Time']['output']>;
  evidence: Kgv2StatementEvidenceConnection;
  /** Free-form text representation of the fact */
  fact?: Maybe<Scalars['String']['output']>;
  graph: Kgv2Graph;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** For relationships; null for literal values */
  object?: Maybe<Kgv2Node>;
  /** Assert (add fact) or negate (remove fact) */
  polarity: Kgv2StatementPolarity;
  /** Predicate describing the relationship or attribute. Use snake_case (e.g., 'spouse_of', 'has_trustee', 'date_of_birth'). See common predicates in design doc. */
  predicate: Scalars['String']['output'];
  /** Section/clause reference from the document (e.g., 'Article III, Section B', 'Successor Trustee Provision'). Helps match amendment statements to originals. */
  sectionRef?: Maybe<Scalars['String']['output']>;
  subject: Kgv2Node;
  /** @deprecated Use KGV2StatementSupersession rows instead. */
  supersededByStatements: Kgv2StatementConnection;
  /** @deprecated Use KGV2StatementSupersession rows instead. */
  supersedesStatements: Kgv2StatementConnection;
  supersessionRecords: Kgv2StatementSupersessionConnection;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  /** Literal value for attributes (e.g., '1970-01-01', '$100,000 USD'). Null for relationships. */
  value?: Maybe<Scalars['String']['output']>;
};


export type Kgv2StatementEvidenceArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2StatementEvidenceOrder>>;
  where?: InputMaybe<Kgv2StatementEvidenceWhereInput>;
};


export type Kgv2StatementSupersededByStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2StatementOrder>>;
  where?: InputMaybe<Kgv2StatementWhereInput>;
};


export type Kgv2StatementSupersedesStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2StatementOrder>>;
  where?: InputMaybe<Kgv2StatementWhereInput>;
};


export type Kgv2StatementSupersessionRecordsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2StatementSupersessionOrder>>;
  where?: InputMaybe<Kgv2StatementSupersessionWhereInput>;
};

/** KGV2StatementConditionType is enum for the field condition_type */
export enum Kgv2StatementConditionType {
  Age = 'age',
  Date = 'date',
  Death = 'death',
  Event = 'event',
  Incapacity = 'incapacity',
  Other = 'other',
  Survival = 'survival'
}

/** A connection to a list of items. */
export type Kgv2StatementConnection = {
  __typename?: 'KGV2StatementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Kgv2StatementEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Kgv2StatementEdge = {
  __typename?: 'KGV2StatementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Kgv2Statement>;
};

export type Kgv2StatementEvidence = Node & {
  __typename?: 'KGV2StatementEvidence';
  /** Human-readable citation: 'Article III.B, p. 5' */
  citation?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  /** Core document this evidence comes from (source of truth for file/pages/paragraphs) */
  document: Document;
  /** Fine-grained provenance: specific paragraphs supporting this statement. Optional; page/snippet fields provide fallback. */
  fileParagraphs?: Maybe<Array<FileParagraph>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Page number in the document */
  page?: Maybe<Scalars['Int']['output']>;
  /** Explanation of why this evidence supports the statement */
  reasoning?: Maybe<Scalars['String']['output']>;
  /** Text excerpt from the document */
  snippet?: Maybe<Scalars['String']['output']>;
  statement: Kgv2Statement;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type Kgv2StatementEvidenceConnection = {
  __typename?: 'KGV2StatementEvidenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Kgv2StatementEvidenceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Kgv2StatementEvidenceEdge = {
  __typename?: 'KGV2StatementEvidenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Kgv2StatementEvidence>;
};

/** Ordering options for KGV2StatementEvidence connections */
export type Kgv2StatementEvidenceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KGV2StatementEvidences. */
  field: Kgv2StatementEvidenceOrderField;
};

/** Properties by which KGV2StatementEvidence connections can be ordered. */
export enum Kgv2StatementEvidenceOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * KGV2StatementEvidenceWhereInput is used for filtering KGV2StatementEvidence objects.
 * Input was generated by ent.
 */
export type Kgv2StatementEvidenceWhereInput = {
  and?: InputMaybe<Array<Kgv2StatementEvidenceWhereInput>>;
  /** citation field predicates */
  citation?: InputMaybe<Scalars['String']['input']>;
  citationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  citationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** statement edge predicates */
  hasStatement?: InputMaybe<Scalars['Boolean']['input']>;
  hasStatementWith?: InputMaybe<Array<Kgv2StatementWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<Kgv2StatementEvidenceWhereInput>;
  or?: InputMaybe<Array<Kgv2StatementEvidenceWhereInput>>;
  /** page field predicates */
  page?: InputMaybe<Scalars['Int']['input']>;
  pageGT?: InputMaybe<Scalars['Int']['input']>;
  pageGTE?: InputMaybe<Scalars['Int']['input']>;
  pageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  pageLT?: InputMaybe<Scalars['Int']['input']>;
  pageLTE?: InputMaybe<Scalars['Int']['input']>;
  pageNEQ?: InputMaybe<Scalars['Int']['input']>;
  pageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** reasoning field predicates */
  reasoning?: InputMaybe<Scalars['String']['input']>;
  reasoningIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  reasoningNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** snippet field predicates */
  snippet?: InputMaybe<Scalars['String']['input']>;
  snippetIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  snippetNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Ordering options for KGV2Statement connections */
export type Kgv2StatementOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KGV2Statements. */
  field: Kgv2StatementOrderField;
};

/** Properties by which KGV2Statement connections can be ordered. */
export enum Kgv2StatementOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** KGV2StatementPolarity is enum for the field polarity */
export enum Kgv2StatementPolarity {
  Assert = 'assert',
  Negate = 'negate'
}

export type Kgv2StatementSupersession = Node & {
  __typename?: 'KGV2StatementSupersession';
  /** The specific section-level change this deactivation is pinned to, when the agent identified one. SetNull on delete so losing a change weakens lineage without silently reactivating the statement. */
  change?: Maybe<Kgv2DocumentChange>;
  /** statementsagent match confidence 0-1. Null for deterministic restatement/revocation rows. */
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Time']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The document modification that caused the deactivation. Cascade on delete: removing the amending document cascades to its modification rows and then to these supersession rows, so the statements auto-reactivate. */
  modification: Kgv2DocumentModification;
  /** How this row was produced. restatement/revocation: deterministic whole-document expansion. agent_match: statementsagent partial match. */
  source: Kgv2StatementSupersessionSource;
  /** The deactivated statement. Cascade on delete: removing the statement removes its supersession rows. */
  statement: Kgv2Statement;
  /** The replacement statement when one exists. Null for whole-document restatement/revocation and for provision deletions. SetNull on delete (and mutable) so re-extraction of the amending document can refresh the replacement without reactivating the old statement. */
  supersededByStatement?: Maybe<Kgv2Statement>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type Kgv2StatementSupersessionConnection = {
  __typename?: 'KGV2StatementSupersessionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Kgv2StatementSupersessionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Kgv2StatementSupersessionEdge = {
  __typename?: 'KGV2StatementSupersessionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Kgv2StatementSupersession>;
};

/** Ordering options for KGV2StatementSupersession connections */
export type Kgv2StatementSupersessionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KGV2StatementSupersessions. */
  field: Kgv2StatementSupersessionOrderField;
};

/** Properties by which KGV2StatementSupersession connections can be ordered. */
export enum Kgv2StatementSupersessionOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** KGV2StatementSupersessionSource is enum for the field source */
export enum Kgv2StatementSupersessionSource {
  AgentMatch = 'agent_match',
  Restatement = 'restatement',
  Revocation = 'revocation'
}

/**
 * KGV2StatementSupersessionWhereInput is used for filtering KGV2StatementSupersession objects.
 * Input was generated by ent.
 */
export type Kgv2StatementSupersessionWhereInput = {
  and?: InputMaybe<Array<Kgv2StatementSupersessionWhereInput>>;
  /** confidence field predicates */
  confidence?: InputMaybe<Scalars['Float']['input']>;
  confidenceGT?: InputMaybe<Scalars['Float']['input']>;
  confidenceGTE?: InputMaybe<Scalars['Float']['input']>;
  confidenceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  confidenceLT?: InputMaybe<Scalars['Float']['input']>;
  confidenceLTE?: InputMaybe<Scalars['Float']['input']>;
  confidenceNEQ?: InputMaybe<Scalars['Float']['input']>;
  confidenceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** change edge predicates */
  hasChange?: InputMaybe<Scalars['Boolean']['input']>;
  hasChangeWith?: InputMaybe<Array<Kgv2DocumentChangeWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** modification edge predicates */
  hasModification?: InputMaybe<Scalars['Boolean']['input']>;
  hasModificationWith?: InputMaybe<Array<Kgv2DocumentModificationWhereInput>>;
  /** statement edge predicates */
  hasStatement?: InputMaybe<Scalars['Boolean']['input']>;
  hasStatementWith?: InputMaybe<Array<Kgv2StatementWhereInput>>;
  /** superseded_by_statement edge predicates */
  hasSupersededByStatement?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupersededByStatementWith?: InputMaybe<Array<Kgv2StatementWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<Kgv2StatementSupersessionWhereInput>;
  or?: InputMaybe<Array<Kgv2StatementSupersessionWhereInput>>;
  /** source field predicates */
  source?: InputMaybe<Kgv2StatementSupersessionSource>;
  sourceIn?: InputMaybe<Array<Kgv2StatementSupersessionSource>>;
  sourceNEQ?: InputMaybe<Kgv2StatementSupersessionSource>;
  sourceNotIn?: InputMaybe<Array<Kgv2StatementSupersessionSource>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * KGV2StatementWhereInput is used for filtering KGV2Statement objects.
 * Input was generated by ent.
 */
export type Kgv2StatementWhereInput = {
  and?: InputMaybe<Array<Kgv2StatementWhereInput>>;
  /** condition_description field predicates */
  conditionDescription?: InputMaybe<Scalars['String']['input']>;
  conditionDescriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  conditionDescriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** condition_type field predicates */
  conditionType?: InputMaybe<Kgv2StatementConditionType>;
  conditionTypeIn?: InputMaybe<Array<Kgv2StatementConditionType>>;
  conditionTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  conditionTypeNEQ?: InputMaybe<Kgv2StatementConditionType>;
  conditionTypeNotIn?: InputMaybe<Array<Kgv2StatementConditionType>>;
  conditionTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** confidence field predicates */
  confidence?: InputMaybe<Scalars['Float']['input']>;
  confidenceGT?: InputMaybe<Scalars['Float']['input']>;
  confidenceGTE?: InputMaybe<Scalars['Float']['input']>;
  confidenceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  confidenceLT?: InputMaybe<Scalars['Float']['input']>;
  confidenceLTE?: InputMaybe<Scalars['Float']['input']>;
  confidenceNEQ?: InputMaybe<Scalars['Float']['input']>;
  confidenceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** effective_from field predicates */
  effectiveFrom?: InputMaybe<Scalars['Time']['input']>;
  effectiveFromGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveFromGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveFromIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveFromLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveFromLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveFromNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** effective_to field predicates */
  effectiveTo?: InputMaybe<Scalars['Time']['input']>;
  effectiveToGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveToGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveToIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveToLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveToLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveToNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** fact field predicates */
  fact?: InputMaybe<Scalars['String']['input']>;
  factIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  factNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ai_suggestions edge predicates */
  hasAiSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  hasAiSuggestionsWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<Kgv2DocumentWhereInput>>;
  /** evidence edge predicates */
  hasEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  hasEvidenceWith?: InputMaybe<Array<Kgv2StatementEvidenceWhereInput>>;
  /** graph edge predicates */
  hasGraph?: InputMaybe<Scalars['Boolean']['input']>;
  hasGraphWith?: InputMaybe<Array<Kgv2GraphWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** object edge predicates */
  hasObject?: InputMaybe<Scalars['Boolean']['input']>;
  hasObjectWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** subject edge predicates */
  hasSubject?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubjectWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** superseded_by_statements edge predicates */
  hasSupersededByStatements?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupersededByStatementsWith?: InputMaybe<Array<Kgv2StatementWhereInput>>;
  /** supersedes_statements edge predicates */
  hasSupersedesStatements?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupersedesStatementsWith?: InputMaybe<Array<Kgv2StatementWhereInput>>;
  /** supersession_records edge predicates */
  hasSupersessionRecords?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupersessionRecordsWith?: InputMaybe<Array<Kgv2StatementSupersessionWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<Kgv2StatementWhereInput>;
  or?: InputMaybe<Array<Kgv2StatementWhereInput>>;
  /** polarity field predicates */
  polarity?: InputMaybe<Kgv2StatementPolarity>;
  polarityIn?: InputMaybe<Array<Kgv2StatementPolarity>>;
  polarityNEQ?: InputMaybe<Kgv2StatementPolarity>;
  polarityNotIn?: InputMaybe<Array<Kgv2StatementPolarity>>;
  /** predicate field predicates */
  predicate?: InputMaybe<Scalars['String']['input']>;
  /** section_ref field predicates */
  sectionRef?: InputMaybe<Scalars['String']['input']>;
  sectionRefIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sectionRefNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  valueNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KeyPerson = Node & {
  __typename?: 'KeyPerson';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** An edge to the key person, which is an entity */
  entity?: Maybe<Entity>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** An edge to the key person, which is an individual */
  individual?: Maybe<ClientProfile>;
  /** An edge to the key person, which is an organization */
  organization?: Maybe<ClientOrganization>;
  /** Roles of this key person */
  roles?: Maybe<Array<KeyPersonRole>>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for KeyPerson connections */
export type KeyPersonOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KeyPersons. */
  field: KeyPersonOrderField;
};

/** Properties by which KeyPerson connections can be ordered. */
export enum KeyPersonOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type KeyPersonRole = Node & {
  __typename?: 'KeyPersonRole';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Key person that this role belongs to */
  keyPerson: KeyPerson;
  kind?: Maybe<KeyPersonRoleKind>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** KeyPersonRoleKind is enum for the field kind */
export enum KeyPersonRoleKind {
  BoardMember = 'BOARD_MEMBER',
  ControllingPerson = 'CONTROLLING_PERSON',
  Director = 'DIRECTOR',
  GeneralPartner = 'GENERAL_PARTNER',
  Manager = 'MANAGER',
  Officer = 'OFFICER',
  Other = 'OTHER',
  President = 'PRESIDENT',
  Secretary = 'SECRETARY',
  Signatory = 'SIGNATORY',
  VicePresident = 'VICE_PRESIDENT'
}

/** Ordering options for KeyPersonRole connections */
export type KeyPersonRoleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order KeyPersonRoles. */
  field: KeyPersonRoleOrderField;
};

/** Properties by which KeyPersonRole connections can be ordered. */
export enum KeyPersonRoleOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * KeyPersonRoleWhereInput is used for filtering KeyPersonRole objects.
 * Input was generated by ent.
 */
export type KeyPersonRoleWhereInput = {
  and?: InputMaybe<Array<KeyPersonRoleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** key_person edge predicates */
  hasKeyPerson?: InputMaybe<Scalars['Boolean']['input']>;
  hasKeyPersonWith?: InputMaybe<Array<KeyPersonWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<KeyPersonRoleKind>;
  kindIn?: InputMaybe<Array<KeyPersonRoleKind>>;
  kindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  kindNEQ?: InputMaybe<KeyPersonRoleKind>;
  kindNotIn?: InputMaybe<Array<KeyPersonRoleKind>>;
  kindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<KeyPersonRoleWhereInput>;
  or?: InputMaybe<Array<KeyPersonRoleWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * KeyPersonWhereInput is used for filtering KeyPerson objects.
 * Input was generated by ent.
 */
export type KeyPersonWhereInput = {
  and?: InputMaybe<Array<KeyPersonWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** individual edge predicates */
  hasIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** roles edge predicates */
  hasRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasRolesWith?: InputMaybe<Array<KeyPersonRoleWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<KeyPersonWhereInput>;
  or?: InputMaybe<Array<KeyPersonWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**  A human-readable representation of a knowledge graph.  */
export type KnowledgeGraph = {
  __typename?: 'KnowledgeGraph';
  nodes: Array<KnowledgeGraphNode>;
  relationships: Array<KnowledgeGraphRelationship>;
};

/**  A human-readable representation of a knowledge graph node.  */
export type KnowledgeGraphNode = {
  __typename?: 'KnowledgeGraphNode';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/**  A human-readable representation of a knowledge graph relationship between two nodes.  */
export type KnowledgeGraphRelationship = {
  __typename?: 'KnowledgeGraphRelationship';
  description: Scalars['String']['output'];
  source: Scalars['String']['output'];
  strength: Scalars['Int']['output'];
  target: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LlcBusinessEntity = BusinessEntity & EntitySubtype & Named & Node & {
  __typename?: 'LLCBusinessEntity';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this business entity */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in trusts that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: Maybe<Scalars['String']['output']>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: Maybe<Scalars['Boolean']['output']>;
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: Maybe<Scalars['String']['output']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  grantorControlledDiscountedValue: Scalars['CurrencyUSD']['output'];
  grantorControlledPercentage: Scalars['Percent']['output'];
  grantorControlledValue: Scalars['CurrencyUSD']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  keyPeople?: Maybe<Array<KeyPerson>>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: Maybe<Scalars['String']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  nongrantorControlledPercentage: Scalars['Percent']['output'];
  nongrantorControlledValue: Scalars['CurrencyUSD']['output'];
  /** Ownership as-of date. */
  ownershipAsOfDate?: Maybe<Scalars['Time']['output']>;
  policies?: Maybe<Array<InsurancePolicy>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: Maybe<Scalars['Boolean']['output']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxID?: Maybe<Scalars['String']['output']>;
  taxStatus?: Maybe<BusinessEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type LlcBusinessEntityHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type LlcBusinessEntityConnection = {
  __typename?: 'LLCBusinessEntityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LlcBusinessEntityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LlcBusinessEntityEdge = {
  __typename?: 'LLCBusinessEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LlcBusinessEntity>;
};

/** Ordering options for LLCBusinessEntity connections */
export type LlcBusinessEntityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LLCBusinessEntities. */
  field: LlcBusinessEntityOrderField;
};

/** Properties by which LLCBusinessEntity connections can be ordered. */
export enum LlcBusinessEntityOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * LLCBusinessEntityWhereInput is used for filtering LLCBusinessEntity objects.
 * Input was generated by ent.
 */
export type LlcBusinessEntityWhereInput = {
  and?: InputMaybe<Array<LlcBusinessEntityWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** doing_business_as_name field predicates */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  doingBusinessAsNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  doingBusinessAsNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable_real_tpp_tax_exposure field predicates */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  enableRealTppTaxExposureIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  enableRealTppTaxExposureNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** fin_cen_id field predicates */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  finCenIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  finCenIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** formation_jurisdiction_state_code field predicates */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  formationJurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  formationJurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** key_people edge predicates */
  hasKeyPeople?: InputMaybe<Scalars['Boolean']['input']>;
  hasKeyPeopleWith?: InputMaybe<Array<KeyPersonWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key_people_notes field predicates */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  keyPeopleNotesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  keyPeopleNotesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<LlcBusinessEntityWhereInput>;
  or?: InputMaybe<Array<LlcBusinessEntityWhereInput>>;
  /** ownership_as_of_date field predicates */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateGT?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateGTE?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownershipAsOfDateLT?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateLTE?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** requires_cta_reporting field predicates */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCtaReportingIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCtaReportingNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_id field predicates */
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<BusinessEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<BusinessEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<BusinessEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type LpBusinessEntity = BusinessEntity & EntitySubtype & Named & Node & {
  __typename?: 'LPBusinessEntity';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this business entity */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in trusts that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: Maybe<Scalars['String']['output']>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: Maybe<Scalars['Boolean']['output']>;
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: Maybe<Scalars['String']['output']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  grantorControlledDiscountedValue: Scalars['CurrencyUSD']['output'];
  grantorControlledPercentage: Scalars['Percent']['output'];
  grantorControlledValue: Scalars['CurrencyUSD']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  keyPeople?: Maybe<Array<KeyPerson>>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: Maybe<Scalars['String']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  nongrantorControlledPercentage: Scalars['Percent']['output'];
  nongrantorControlledValue: Scalars['CurrencyUSD']['output'];
  /** Ownership as-of date. */
  ownershipAsOfDate?: Maybe<Scalars['Time']['output']>;
  policies?: Maybe<Array<InsurancePolicy>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: Maybe<Scalars['Boolean']['output']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxID?: Maybe<Scalars['String']['output']>;
  taxStatus?: Maybe<BusinessEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type LpBusinessEntityHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type LpBusinessEntityConnection = {
  __typename?: 'LPBusinessEntityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LpBusinessEntityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LpBusinessEntityEdge = {
  __typename?: 'LPBusinessEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LpBusinessEntity>;
};

/** Ordering options for LPBusinessEntity connections */
export type LpBusinessEntityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LPBusinessEntities. */
  field: LpBusinessEntityOrderField;
};

/** Properties by which LPBusinessEntity connections can be ordered. */
export enum LpBusinessEntityOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * LPBusinessEntityWhereInput is used for filtering LPBusinessEntity objects.
 * Input was generated by ent.
 */
export type LpBusinessEntityWhereInput = {
  and?: InputMaybe<Array<LpBusinessEntityWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** doing_business_as_name field predicates */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  doingBusinessAsNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  doingBusinessAsNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable_real_tpp_tax_exposure field predicates */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  enableRealTppTaxExposureIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  enableRealTppTaxExposureNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** fin_cen_id field predicates */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  finCenIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  finCenIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** formation_jurisdiction_state_code field predicates */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  formationJurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  formationJurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** key_people edge predicates */
  hasKeyPeople?: InputMaybe<Scalars['Boolean']['input']>;
  hasKeyPeopleWith?: InputMaybe<Array<KeyPersonWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key_people_notes field predicates */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  keyPeopleNotesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  keyPeopleNotesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<LpBusinessEntityWhereInput>;
  or?: InputMaybe<Array<LpBusinessEntityWhereInput>>;
  /** ownership_as_of_date field predicates */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateGT?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateGTE?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownershipAsOfDateLT?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateLTE?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** requires_cta_reporting field predicates */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCtaReportingIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCtaReportingNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_id field predicates */
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<BusinessEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<BusinessEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<BusinessEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type LastViewedWaterfallWhereInput = {
  householdId: Scalars['ID']['input'];
};

export type LiabilitiesBundleConfiguration = Node & {
  __typename?: 'LiabilitiesBundleConfiguration';
  bundle?: Maybe<PresentationBundle>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The display name for the liabilities bundle. */
  displayName?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type LiabilitiesBundleConfigurationConnection = {
  __typename?: 'LiabilitiesBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LiabilitiesBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LiabilitiesBundleConfigurationEdge = {
  __typename?: 'LiabilitiesBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LiabilitiesBundleConfiguration>;
};

/** Ordering options for LiabilitiesBundleConfiguration connections */
export type LiabilitiesBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LiabilitiesBundleConfigurations. */
  field: LiabilitiesBundleConfigurationOrderField;
};

/** Properties by which LiabilitiesBundleConfiguration connections can be ordered. */
export enum LiabilitiesBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * LiabilitiesBundleConfigurationWhereInput is used for filtering LiabilitiesBundleConfiguration objects.
 * Input was generated by ent.
 */
export type LiabilitiesBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<LiabilitiesBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<LiabilitiesBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<LiabilitiesBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Liability = Node & {
  __typename?: 'Liability';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  currentAmountAsOfDate?: Maybe<Scalars['Time']['output']>;
  displayName: Scalars['String']['output'];
  finalPaymentAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  household: Household;
  id: Scalars['ID']['output'];
  initialAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** Integration liability linked to this liability */
  integrationLiability?: Maybe<IntegrationLiability>;
  interestPaid?: Maybe<Scalars['CurrencyUSD']['output']>;
  interestRate?: Maybe<Scalars['Percent']['output']>;
  kgV2Nodes: Kgv2NodeConnection;
  /** Free-form notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** The entity that is paying this liabilities obligations. */
  payFromEntity?: Maybe<Entity>;
  paymentFrequency?: Maybe<LiabilityPaymentFrequency>;
  paymentKind?: Maybe<LiabilityPaymentKind>;
  payments?: Maybe<Array<LiabilityPayment>>;
  /** The entity that is the recipient (borrower) of this liability. */
  recipientEntity?: Maybe<Entity>;
  recurringPaymentAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The client organization that is the source (lender) of this liability. */
  sourceClientOrganization?: Maybe<ClientOrganization>;
  /** The client profile that is the source (lender) of this liability. */
  sourceClientProfile?: Maybe<ClientProfile>;
  /** The entity that is the source (lender) of this liability. */
  sourceEntity?: Maybe<Entity>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  termEnd?: Maybe<Scalars['Time']['output']>;
  termStart?: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type LiabilityKgV2NodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2NodeOrder>>;
  where?: InputMaybe<Kgv2NodeWhereInput>;
};

/** A connection to a list of items. */
export type LiabilityConnection = {
  __typename?: 'LiabilityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LiabilityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LiabilityEdge = {
  __typename?: 'LiabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Liability>;
};

/** Ordering options for Liability connections */
export type LiabilityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Liabilities. */
  field: LiabilityOrderField;
};

/** Properties by which Liability connections can be ordered. */
export enum LiabilityOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type LiabilityPayment = Node & {
  __typename?: 'LiabilityPayment';
  createdAt: Scalars['Time']['output'];
  date?: Maybe<Scalars['Time']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  interestPaymentAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  liability: Liability;
  newLiabilityAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  oldLiabilityAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  principalPaymentAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  totalPaymentAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type LiabilityPaymentCalculationDetails = {
  __typename?: 'LiabilityPaymentCalculationDetails';
  finalPaymentAmount: Scalars['CurrencyUSD']['output'];
  finalPaymentInterestAmount: Scalars['CurrencyUSD']['output'];
  finalPaymentPrincipalAmount: Scalars['CurrencyUSD']['output'];
  numberOfPayments: Scalars['Int']['output'];
  recurringPaymentAmount: Scalars['CurrencyUSD']['output'];
  termEnd: Scalars['Time']['output'];
  totalInterestPaid: Scalars['CurrencyUSD']['output'];
  totalPaid: Scalars['CurrencyUSD']['output'];
};

export type LiabilityPaymentCalculationInput = {
  interestRate: Scalars['Percent']['input'];
  paymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  paymentFrequency: LiabilityPaymentFrequency;
  paymentKind?: InputMaybe<LiabilityPaymentKind>;
  principalAmount: Scalars['CurrencyUSD']['input'];
  termEnd?: InputMaybe<Scalars['Time']['input']>;
  termStart: Scalars['Time']['input'];
};

/** LiabilityPaymentFrequency is enum for the field payment_frequency */
export enum LiabilityPaymentFrequency {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY'
}

/** LiabilityPaymentKind is enum for the field payment_kind */
export enum LiabilityPaymentKind {
  Amortized = 'AMORTIZED',
  InterestOnly = 'INTEREST_ONLY'
}

/** Ordering options for LiabilityPayment connections */
export type LiabilityPaymentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LiabilityPayments. */
  field: LiabilityPaymentOrderField;
};

/** Properties by which LiabilityPayment connections can be ordered. */
export enum LiabilityPaymentOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * LiabilityPaymentWhereInput is used for filtering LiabilityPayment objects.
 * Input was generated by ent.
 */
export type LiabilityPaymentWhereInput = {
  and?: InputMaybe<Array<LiabilityPaymentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** date field predicates */
  date?: InputMaybe<Scalars['Time']['input']>;
  dateGT?: InputMaybe<Scalars['Time']['input']>;
  dateGTE?: InputMaybe<Scalars['Time']['input']>;
  dateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dateLT?: InputMaybe<Scalars['Time']['input']>;
  dateLTE?: InputMaybe<Scalars['Time']['input']>;
  dateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** liability edge predicates */
  hasLiability?: InputMaybe<Scalars['Boolean']['input']>;
  hasLiabilityWith?: InputMaybe<Array<LiabilityWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** interest_payment_amount field predicates */
  interestPaymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  interestPaymentAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  interestPaymentAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  interestPaymentAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  interestPaymentAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  interestPaymentAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  interestPaymentAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  interestPaymentAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** new_liability_amount field predicates */
  newLiabilityAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  newLiabilityAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  newLiabilityAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  newLiabilityAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  newLiabilityAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  newLiabilityAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  newLiabilityAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  newLiabilityAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<LiabilityPaymentWhereInput>;
  /** old_liability_amount field predicates */
  oldLiabilityAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  oldLiabilityAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  oldLiabilityAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  oldLiabilityAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  oldLiabilityAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  oldLiabilityAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  oldLiabilityAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  oldLiabilityAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<LiabilityPaymentWhereInput>>;
  /** principal_payment_amount field predicates */
  principalPaymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  principalPaymentAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  principalPaymentAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  principalPaymentAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  principalPaymentAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  principalPaymentAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  principalPaymentAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  principalPaymentAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** total_payment_amount field predicates */
  totalPaymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  totalPaymentAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  totalPaymentAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  totalPaymentAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  totalPaymentAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  totalPaymentAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  totalPaymentAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  totalPaymentAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type LiabilitySuggestion = {
  __typename?: 'LiabilitySuggestion';
  asOfDate?: Maybe<Scalars['String']['output']>;
  debtorEntityID?: Maybe<Scalars['ID']['output']>;
  debtorEntityName?: Maybe<Scalars['String']['output']>;
  lenderEntityID?: Maybe<Scalars['ID']['output']>;
  lenderEntityName?: Maybe<Scalars['String']['output']>;
  liabilityName?: Maybe<Scalars['String']['output']>;
  nodeID?: Maybe<Scalars['ID']['output']>;
  outstandingBalance?: Maybe<Scalars['String']['output']>;
};

export type LiabilitySuggestionInput = {
  asOfDate?: InputMaybe<Scalars['String']['input']>;
  debtorEntityID?: InputMaybe<Scalars['ID']['input']>;
  debtorEntityName?: InputMaybe<Scalars['String']['input']>;
  lenderEntityID?: InputMaybe<Scalars['ID']['input']>;
  lenderEntityName?: InputMaybe<Scalars['String']['input']>;
  liabilityName?: InputMaybe<Scalars['String']['input']>;
  nodeID?: InputMaybe<Scalars['ID']['input']>;
  outstandingBalance?: InputMaybe<Scalars['String']['input']>;
};

/**
 * LiabilityWhereInput is used for filtering Liability objects.
 * Input was generated by ent.
 */
export type LiabilityWhereInput = {
  and?: InputMaybe<Array<LiabilityWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** current_amount field predicates */
  currentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** current_amount_as_of_date field predicates */
  currentAmountAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  currentAmountAsOfDateGT?: InputMaybe<Scalars['Time']['input']>;
  currentAmountAsOfDateGTE?: InputMaybe<Scalars['Time']['input']>;
  currentAmountAsOfDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  currentAmountAsOfDateLT?: InputMaybe<Scalars['Time']['input']>;
  currentAmountAsOfDateLTE?: InputMaybe<Scalars['Time']['input']>;
  currentAmountAsOfDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  currentAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  currentAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  currentAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  currentAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  currentAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  currentAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  currentAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** final_payment_amount field predicates */
  finalPaymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  finalPaymentAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  finalPaymentAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  finalPaymentAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  finalPaymentAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  finalPaymentAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  finalPaymentAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  finalPaymentAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** integration_liability edge predicates */
  hasIntegrationLiability?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntegrationLiabilityWith?: InputMaybe<Array<IntegrationLiabilityWhereInput>>;
  /** kg_v2_nodes edge predicates */
  hasKgV2Nodes?: InputMaybe<Scalars['Boolean']['input']>;
  hasKgV2NodesWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** pay_from_entity edge predicates */
  hasPayFromEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasPayFromEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** payments edge predicates */
  hasPayments?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaymentsWith?: InputMaybe<Array<LiabilityPaymentWhereInput>>;
  /** recipient_entity edge predicates */
  hasRecipientEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecipientEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** source_client_organization edge predicates */
  hasSourceClientOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceClientOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** source_client_profile edge predicates */
  hasSourceClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceClientProfileWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** source_entity edge predicates */
  hasSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** initial_amount field predicates */
  initialAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  initialAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  initialAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  initialAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  initialAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  initialAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  initialAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  initialAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** interest_paid field predicates */
  interestPaid?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  interestPaidGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  interestPaidGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  interestPaidIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  interestPaidLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  interestPaidLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  interestPaidNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  interestPaidNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** interest_rate field predicates */
  interestRate?: InputMaybe<Scalars['Percent']['input']>;
  interestRateGT?: InputMaybe<Scalars['Percent']['input']>;
  interestRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  interestRateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  interestRateLT?: InputMaybe<Scalars['Percent']['input']>;
  interestRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  interestRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  interestRateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<LiabilityWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<LiabilityWhereInput>>;
  /** payment_frequency field predicates */
  paymentFrequency?: InputMaybe<LiabilityPaymentFrequency>;
  paymentFrequencyIn?: InputMaybe<Array<LiabilityPaymentFrequency>>;
  paymentFrequencyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  paymentFrequencyNEQ?: InputMaybe<LiabilityPaymentFrequency>;
  paymentFrequencyNotIn?: InputMaybe<Array<LiabilityPaymentFrequency>>;
  paymentFrequencyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** payment_kind field predicates */
  paymentKind?: InputMaybe<LiabilityPaymentKind>;
  paymentKindIn?: InputMaybe<Array<LiabilityPaymentKind>>;
  paymentKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  paymentKindNEQ?: InputMaybe<LiabilityPaymentKind>;
  paymentKindNotIn?: InputMaybe<Array<LiabilityPaymentKind>>;
  paymentKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** recurring_payment_amount field predicates */
  recurringPaymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  recurringPaymentAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  recurringPaymentAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  recurringPaymentAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  recurringPaymentAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  recurringPaymentAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  recurringPaymentAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  recurringPaymentAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** term_end field predicates */
  termEnd?: InputMaybe<Scalars['Time']['input']>;
  termEndGT?: InputMaybe<Scalars['Time']['input']>;
  termEndGTE?: InputMaybe<Scalars['Time']['input']>;
  termEndIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  termEndLT?: InputMaybe<Scalars['Time']['input']>;
  termEndLTE?: InputMaybe<Scalars['Time']['input']>;
  termEndNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** term_start field predicates */
  termStart?: InputMaybe<Scalars['Time']['input']>;
  termStartGT?: InputMaybe<Scalars['Time']['input']>;
  termStartGTE?: InputMaybe<Scalars['Time']['input']>;
  termStartIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  termStartLT?: InputMaybe<Scalars['Time']['input']>;
  termStartLTE?: InputMaybe<Scalars['Time']['input']>;
  termStartNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type LifeInsuranceBundleConfiguration = Node & {
  __typename?: 'LifeInsuranceBundleConfiguration';
  bundle?: Maybe<PresentationBundle>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The display name for the life insurance bundle. */
  displayName?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type LifeInsuranceBundleConfigurationConnection = {
  __typename?: 'LifeInsuranceBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LifeInsuranceBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LifeInsuranceBundleConfigurationEdge = {
  __typename?: 'LifeInsuranceBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LifeInsuranceBundleConfiguration>;
};

/** Ordering options for LifeInsuranceBundleConfiguration connections */
export type LifeInsuranceBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LifeInsuranceBundleConfigurations. */
  field: LifeInsuranceBundleConfigurationOrderField;
};

/** Properties by which LifeInsuranceBundleConfiguration connections can be ordered. */
export enum LifeInsuranceBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * LifeInsuranceBundleConfigurationWhereInput is used for filtering LifeInsuranceBundleConfiguration objects.
 * Input was generated by ent.
 */
export type LifeInsuranceBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<LifeInsuranceBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<LifeInsuranceBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<LifeInsuranceBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type LifeInsuranceSuggestion = {
  __typename?: 'LifeInsuranceSuggestion';
  cashValueAmount?: Maybe<Scalars['String']['output']>;
  deathBenefitAmount?: Maybe<Scalars['String']['output']>;
  insuranceCarrier?: Maybe<Scalars['String']['output']>;
  insuredClientProfiles?: Maybe<Array<InsuredClientProfileSuggestion>>;
  insuredPeopleNodeIDs?: Maybe<Array<Scalars['ID']['output']>>;
  nodeID?: Maybe<Scalars['ID']['output']>;
  owningEntityID?: Maybe<Scalars['ID']['output']>;
  owningEntityName?: Maybe<Scalars['String']['output']>;
  policyType?: Maybe<InsurancePolicyKind>;
  termLengthYears?: Maybe<Scalars['Int']['output']>;
};

export type LifeInsuranceSuggestionInput = {
  cashValueAmount?: InputMaybe<Scalars['String']['input']>;
  deathBenefitAmount?: InputMaybe<Scalars['String']['input']>;
  insuranceCarrier?: InputMaybe<Scalars['String']['input']>;
  insuredClientProfiles?: InputMaybe<Array<InsuredClientProfileSuggestionInput>>;
  insuredPeopleNodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  nodeID?: InputMaybe<Scalars['ID']['input']>;
  owningEntityID?: InputMaybe<Scalars['ID']['input']>;
  owningEntityName?: InputMaybe<Scalars['String']['input']>;
  policyType?: InputMaybe<InsurancePolicyKind>;
  termLengthYears?: InputMaybe<Scalars['Int']['input']>;
};

export type LifetimeExclusionEvent = Node & {
  __typename?: 'LifetimeExclusionEvent';
  /** The amount of annual exclusion this gift used */
  annualExclusionAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The task which generated this exclusion event */
  associatedTask?: Maybe<EntityTask>;
  /** The end beneficiary of the gift if its not the recipient of the transfer */
  benefitOf?: Maybe<ClientProfile>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The amount of (implied) Connecticut exemption used */
  ctImpliedExemptionUsed?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** The amount of Connecticut taxes paid for this gift */
  ctTaxesPaidAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** Amount asset was discounted for exclusion */
  discountAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  documents?: Maybe<Array<Document>>;
  /** The date of gifting or when the adjustment was recorded */
  eventDate: Scalars['Time']['output'];
  /** The amount gifted to the recipient */
  giftAmount?: Maybe<Scalars['CurrencyUSD']['output']>;
  giftCategory?: Maybe<LifetimeExclusionEventGiftCategory>;
  /** The individual who's exclusion this is applied to */
  grantor: ClientProfile;
  grantorID: Scalars['ID']['output'];
  /** The amount of GST exclusion this gift used */
  gstExclusionAmount: Scalars['CurrencyUSD']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Whether or not this gift is subject to Connecticut state gift taxes */
  isSubjectToCtTaxes: Scalars['Boolean']['output'];
  kind: LifetimeExclusionEventKind;
  /** The amount of lifetime exclusion this gift used */
  lifetimeExclusionAmount: Scalars['CurrencyUSD']['output'];
  loggedTransfer?: Maybe<LoggedTransfer>;
  /** Free-form notes */
  notes?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Beneficiary>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type LifetimeExclusionEventConnection = {
  __typename?: 'LifetimeExclusionEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LifetimeExclusionEventEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LifetimeExclusionEventEdge = {
  __typename?: 'LifetimeExclusionEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LifetimeExclusionEvent>;
};

/** LifetimeExclusionEventGiftCategory is enum for the field gift_category */
export enum LifetimeExclusionEventGiftCategory {
  Cash = 'CASH',
  Other = 'OTHER',
  PublicStockSingle = 'PUBLIC_STOCK_SINGLE'
}

/** LifetimeExclusionEventKind is enum for the field kind */
export enum LifetimeExclusionEventKind {
  Adjustment = 'ADJUSTMENT',
  Gift = 'GIFT'
}

/** Ordering options for LifetimeExclusionEvent connections */
export type LifetimeExclusionEventOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LifetimeExclusionEvents. */
  field: LifetimeExclusionEventOrderField;
};

/** Properties by which LifetimeExclusionEvent connections can be ordered. */
export enum LifetimeExclusionEventOrderField {
  CreatedAt = 'created_at',
  EventDate = 'event_date',
  UpdatedAt = 'updated_at'
}

/**
 * LifetimeExclusionEventWhereInput is used for filtering LifetimeExclusionEvent objects.
 * Input was generated by ent.
 */
export type LifetimeExclusionEventWhereInput = {
  and?: InputMaybe<Array<LifetimeExclusionEventWhereInput>>;
  /** annual_exclusion_amount field predicates */
  annualExclusionAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annualExclusionAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annualExclusionAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annualExclusionAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  annualExclusionAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annualExclusionAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annualExclusionAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  annualExclusionAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ct_implied_exemption_used field predicates */
  ctImpliedExemptionUsed?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ctImpliedExemptionUsedGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ctImpliedExemptionUsedGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ctImpliedExemptionUsedIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ctImpliedExemptionUsedLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ctImpliedExemptionUsedLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ctImpliedExemptionUsedNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ctImpliedExemptionUsedNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ct_taxes_paid_amount field predicates */
  ctTaxesPaidAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ctTaxesPaidAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ctTaxesPaidAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ctTaxesPaidAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ctTaxesPaidAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ctTaxesPaidAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ctTaxesPaidAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ctTaxesPaidAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** discount_amount field predicates */
  discountAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  discountAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  discountAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  discountAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  discountAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  discountAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  discountAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  discountAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** event_date field predicates */
  eventDate?: InputMaybe<Scalars['Time']['input']>;
  eventDateGT?: InputMaybe<Scalars['Time']['input']>;
  eventDateGTE?: InputMaybe<Scalars['Time']['input']>;
  eventDateLT?: InputMaybe<Scalars['Time']['input']>;
  eventDateLTE?: InputMaybe<Scalars['Time']['input']>;
  /** gift_amount field predicates */
  giftAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  giftAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  giftAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  giftAmountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  giftAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  giftAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  giftAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  giftAmountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** gift_category field predicates */
  giftCategory?: InputMaybe<LifetimeExclusionEventGiftCategory>;
  giftCategoryIn?: InputMaybe<Array<LifetimeExclusionEventGiftCategory>>;
  giftCategoryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  giftCategoryNEQ?: InputMaybe<LifetimeExclusionEventGiftCategory>;
  giftCategoryNotIn?: InputMaybe<Array<LifetimeExclusionEventGiftCategory>>;
  giftCategoryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** grantor_id field predicates */
  grantorID?: InputMaybe<Scalars['ID']['input']>;
  grantorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  grantorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  grantorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** gst_exclusion_amount field predicates */
  gstExclusionAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  gstExclusionAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  gstExclusionAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  gstExclusionAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  gstExclusionAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  gstExclusionAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** associated_task edge predicates */
  hasAssociatedTask?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssociatedTaskWith?: InputMaybe<Array<EntityTaskWhereInput>>;
  /** benefit_of edge predicates */
  hasBenefitOf?: InputMaybe<Scalars['Boolean']['input']>;
  hasBenefitOfWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** documents edge predicates */
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** grantor edge predicates */
  hasGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrantorWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** logged_transfer edge predicates */
  hasLoggedTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  hasLoggedTransferWith?: InputMaybe<Array<LoggedTransferWhereInput>>;
  /** recipient edge predicates */
  hasRecipient?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecipientWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_subject_to_ct_taxes field predicates */
  isSubjectToCtTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<LifetimeExclusionEventKind>;
  kindIn?: InputMaybe<Array<LifetimeExclusionEventKind>>;
  kindNEQ?: InputMaybe<LifetimeExclusionEventKind>;
  kindNotIn?: InputMaybe<Array<LifetimeExclusionEventKind>>;
  /** lifetime_exclusion_amount field predicates */
  lifetimeExclusionAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  lifetimeExclusionAmountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  lifetimeExclusionAmountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  lifetimeExclusionAmountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  lifetimeExclusionAmountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  lifetimeExclusionAmountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  not?: InputMaybe<LifetimeExclusionEventWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<LifetimeExclusionEventWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Input for linking a KG V2 node to a data model record. */
export type LinkKgv2NodeToDataModelInput = {
  /** The household that owns both the node and the data model record. */
  householdID: Scalars['ID']['input'];
  /** The KG V2 node ID to link. */
  nodeID: Scalars['ID']['input'];
  /**
   * When true, clears existing links of the same data-model type before adding
   * the new one. Links of other types are preserved. Defaults to true.
   */
  replace?: InputMaybe<Scalars['Boolean']['input']>;
  /** The data model record to link to. Exactly one field must be set. */
  target: DataModelTargetInput;
};

/** Input for linking a suggestion to a KG V2 node or statement. */
export type LinkSuggestionWithKgv2NodeOrStatementInput = {
  /** Whether to clear existing KG V2 connections before linking. Defaults to true. */
  clearExisting?: InputMaybe<Scalars['Boolean']['input']>;
  /** The KG V2 node or statement to link to. Exactly one field should be set. */
  linkTo: Kgv2NodeOrStatementTargetInput;
  /** The suggestion ID to link. */
  suggestionID: Scalars['ID']['input'];
};

export type LoggedTransfer = Node & {
  __typename?: 'LoggedTransfer';
  /** The amount of logged transfer. */
  amount: Scalars['CurrencyUSD']['output'];
  /** The task which generated this transfer */
  associatedTask?: Maybe<EntityTask>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Documents that might be associated with the transfer. */
  documents?: Maybe<Array<Document>>;
  friendlyContributionPurpose?: Maybe<Scalars['String']['output']>;
  friendlyDistributionPurpose?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lifetimeExclusionEvents?: Maybe<Array<LifetimeExclusionEvent>>;
  /** Custom purpose if "Other" purpose is selected. */
  otherPurposeDescription?: Maybe<Scalars['String']['output']>;
  /** Purpose of transfer */
  purpose?: Maybe<LoggedTransferPurpose>;
  /** An edge to the receiving entity of the transfer */
  receivingEntity?: Maybe<Entity>;
  /** An edge to the receiving grantor of the transfer */
  receivingGrantor?: Maybe<ClientProfile>;
  /** An edge to the receiving organization of the transfer */
  receivingOrganization?: Maybe<ClientOrganization>;
  /** An edge to the source entity of the transfer */
  sourceEntity?: Maybe<Entity>;
  /** An edge to the source grantor of the transfer */
  sourceGrantor?: Maybe<ClientProfile>;
  /** An edge to the source organization of the transfer */
  sourceOrganization?: Maybe<ClientOrganization>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  transactionDate: Scalars['Time']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type LoggedTransferConnection = {
  __typename?: 'LoggedTransferConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LoggedTransferEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LoggedTransferEdge = {
  __typename?: 'LoggedTransferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LoggedTransfer>;
};

/** Ordering options for LoggedTransfer connections */
export type LoggedTransferOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LoggedTransfers. */
  field: LoggedTransferOrderField;
};

/** Properties by which LoggedTransfer connections can be ordered. */
export enum LoggedTransferOrderField {
  CreatedAt = 'created_at',
  TransactionDate = 'transaction_date',
  UpdatedAt = 'updated_at'
}

/** LoggedTransferPurpose is enum for the field purpose */
export enum LoggedTransferPurpose {
  BeneficiaryDistribution = 'BENEFICIARY_DISTRIBUTION',
  CharitableGift = 'CHARITABLE_GIFT',
  Grant = 'GRANT',
  GratRemainderDistribution = 'GRAT_REMAINDER_DISTRIBUTION',
  NonGiftAddition = 'NON_GIFT_ADDITION',
  Other = 'OTHER',
  TaxableGift = 'TAXABLE_GIFT'
}

/**
 * LoggedTransferWhereInput is used for filtering LoggedTransfer objects.
 * Input was generated by ent.
 */
export type LoggedTransferWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  and?: InputMaybe<Array<LoggedTransferWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** associated_task edge predicates */
  hasAssociatedTask?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssociatedTaskWith?: InputMaybe<Array<EntityTaskWhereInput>>;
  /** documents edge predicates */
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** lifetime_exclusion_events edge predicates */
  hasLifetimeExclusionEvents?: InputMaybe<Scalars['Boolean']['input']>;
  hasLifetimeExclusionEventsWith?: InputMaybe<Array<LifetimeExclusionEventWhereInput>>;
  /** receiving_entity edge predicates */
  hasReceivingEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasReceivingEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** receiving_grantor edge predicates */
  hasReceivingGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  hasReceivingGrantorWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** receiving_organization edge predicates */
  hasReceivingOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasReceivingOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** source_entity edge predicates */
  hasSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** source_grantor edge predicates */
  hasSourceGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceGrantorWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** source_organization edge predicates */
  hasSourceOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<LoggedTransferWhereInput>;
  or?: InputMaybe<Array<LoggedTransferWhereInput>>;
  /** other_purpose_description field predicates */
  otherPurposeDescription?: InputMaybe<Scalars['String']['input']>;
  otherPurposeDescriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  otherPurposeDescriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** purpose field predicates */
  purpose?: InputMaybe<LoggedTransferPurpose>;
  purposeIn?: InputMaybe<Array<LoggedTransferPurpose>>;
  purposeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  purposeNEQ?: InputMaybe<LoggedTransferPurpose>;
  purposeNotIn?: InputMaybe<Array<LoggedTransferPurpose>>;
  purposeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** transaction_date field predicates */
  transactionDate?: InputMaybe<Scalars['Time']['input']>;
  transactionDateGT?: InputMaybe<Scalars['Time']['input']>;
  transactionDateGTE?: InputMaybe<Scalars['Time']['input']>;
  transactionDateLT?: InputMaybe<Scalars['Time']['input']>;
  transactionDateLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type LuminaryOrganization = Node & {
  __typename?: 'LuminaryOrganization';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The name of the organization. */
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Designates the Luminary organization (partial unique index — at most one true row). */
  isLuminary: Scalars['Boolean']['output'];
  /** When customer JIT was enabled. NULL = disabled. (Luminary JIT lives on LuminaryTenantJIT.) */
  jitEnabledAt?: Maybe<Scalars['Time']['output']>;
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
  /** The WorkOSOrganization owned by this LuminaryOrganization. 1:1 for now. */
  workosOrganization?: Maybe<WorkOsOrganization>;
};

/** A connection to a list of items. */
export type LuminaryOrganizationConnection = {
  __typename?: 'LuminaryOrganizationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LuminaryOrganizationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LuminaryOrganizationEdge = {
  __typename?: 'LuminaryOrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LuminaryOrganization>;
};

/** Ordering options for LuminaryOrganization connections */
export type LuminaryOrganizationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LuminaryOrganizations. */
  field: LuminaryOrganizationOrderField;
};

/** Properties by which LuminaryOrganization connections can be ordered. */
export enum LuminaryOrganizationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * LuminaryOrganizationWhereInput is used for filtering LuminaryOrganization objects.
 * Input was generated by ent.
 */
export type LuminaryOrganizationWhereInput = {
  and?: InputMaybe<Array<LuminaryOrganizationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** workos_organization edge predicates */
  hasWorkosOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasWorkosOrganizationWith?: InputMaybe<Array<WorkOsOrganizationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_luminary field predicates */
  isLuminary?: InputMaybe<Scalars['Boolean']['input']>;
  /** jit_enabled_at field predicates */
  jitEnabledAt?: InputMaybe<Scalars['Time']['input']>;
  jitEnabledAtGT?: InputMaybe<Scalars['Time']['input']>;
  jitEnabledAtGTE?: InputMaybe<Scalars['Time']['input']>;
  jitEnabledAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  jitEnabledAtLT?: InputMaybe<Scalars['Time']['input']>;
  jitEnabledAtLTE?: InputMaybe<Scalars['Time']['input']>;
  jitEnabledAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<LuminaryOrganizationWhereInput>;
  or?: InputMaybe<Array<LuminaryOrganizationWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type LuminaryTenantJit = Node & {
  __typename?: 'LuminaryTenantJIT';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** When this JIT grant expires. NULL = no expiry (internal/demo). Paid tenants typically set this during onboarding. */
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  tenant: Tenant;
  /** The target tenant being granted Luminary JIT access. */
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};

/** A connection to a list of items. */
export type LuminaryTenantJitConnection = {
  __typename?: 'LuminaryTenantJITConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LuminaryTenantJitEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LuminaryTenantJitEdge = {
  __typename?: 'LuminaryTenantJITEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LuminaryTenantJit>;
};

/** Ordering options for LuminaryTenantJIT connections */
export type LuminaryTenantJitOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LuminaryTenantJITs. */
  field: LuminaryTenantJitOrderField;
};

/** Properties by which LuminaryTenantJIT connections can be ordered. */
export enum LuminaryTenantJitOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * LuminaryTenantJITWhereInput is used for filtering LuminaryTenantJIT objects.
 * Input was generated by ent.
 */
export type LuminaryTenantJitWhereInput = {
  and?: InputMaybe<Array<LuminaryTenantJitWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** expires_at field predicates */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAtLT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtLTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<LuminaryTenantJitWhereInput>;
  or?: InputMaybe<Array<LuminaryTenantJitWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** MCPAccess is enum for the field mcp_access */
export enum McpAccess {
  Off = 'OFF',
  Read = 'READ',
  ReadWrite = 'READ_WRITE'
}

export type ManagedSftpConnection = Node & {
  __typename?: 'ManagedSFTPConnection';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  instructions: ManagedSftpConnectionInstructions;
  publicKeys: Array<ManagedSftpPublicKey>;
  /** Live AWS state. A failed AWS read returns an error, not DISABLED. */
  status: ManagedSftpConnectionStatus;
  /** Stable generated AWS Transfer Family username. It cannot change after creation. */
  username: Scalars['String']['output'];
};

/** Customer-safe instructions for connecting to the managed SFTP endpoint. */
export type ManagedSftpConnectionInstructions = {
  __typename?: 'ManagedSFTPConnectionInstructions';
  hostKeyFingerprints: Array<ManagedSftpHostKeyFingerprint>;
  hostname: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  remoteRoot: Scalars['String']['output'];
};

/** Whether the tenant's managed SFTP connection is enabled. */
export enum ManagedSftpConnectionStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

/** An immediate child of a managed SFTP directory. Paths are relative to inbound. */
export type ManagedSftpFileEntry = {
  __typename?: 'ManagedSFTPFileEntry';
  isDirectory: Scalars['Boolean']['output'];
  /** S3 directory prefixes have no modification time. */
  lastModified?: Maybe<Scalars['Time']['output']>;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  /** File size in bytes. S3 directory prefixes have no size. */
  sizeBytes?: Maybe<Scalars['Float']['output']>;
};

/** A server host-key fingerprint that customers can verify before connecting. */
export type ManagedSftpHostKeyFingerprint = {
  __typename?: 'ManagedSFTPHostKeyFingerprint';
  fingerprint: Scalars['String']['output'];
};

/** A public key currently installed in AWS Transfer, not a stored application object. */
export type ManagedSftpPublicKey = {
  __typename?: 'ManagedSFTPPublicKey';
  algorithm: Scalars['String']['output'];
  /** The time AWS imported this public key. */
  createdAt: Scalars['Time']['output'];
  fingerprintSHA256: Scalars['String']['output'];
  /** AWS Transfer public-key identifier, scoped to the current tenant's user. */
  id: Scalars['String']['output'];
  status: ManagedSftpPublicKeyStatus;
};

/** Whether a public key is installed in AWS Transfer. */
export enum ManagedSftpPublicKeyStatus {
  Active = 'ACTIVE',
  Revoked = 'REVOKED'
}

export type MarkSuggestionAsDuplicateInput = {
  aiSuggestionID: Scalars['ID']['input'];
  clientOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
};

export type Marriage = {
  __typename?: 'Marriage';
  /** Children from this marriage */
  children: Array<Scalars['ID']['output']>;
  /** If not current, the reason (e.g., divorce or death) */
  endReason?: Maybe<MarriageEndReason>;
  /** Unique identifier for this marriage (compound of sorted spouse IDs) */
  id: Scalars['String']['output'];
  /** Whether this marriage is currently active (not divorced and both spouses alive) */
  isCurrent: Scalars['Boolean']['output'];
  /** The two people married in this relationship */
  spouses: Array<Scalars['ID']['output']>;
};

export enum MarriageEndReason {
  Death = 'DEATH',
  Divorced = 'DIVORCED'
}

export type Memo = Node & {
  __typename?: 'Memo';
  /** User feedback for AI-generated memo quality */
  aiFeedback?: Maybe<Scalars['String']['output']>;
  /** User rating for AI-generated memo quality */
  aiRating?: Maybe<MemoAiRating>;
  /** CMK-encrypted memo content */
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  documents: DocumentConnection;
  /** Whether the memo was AI-generated or user-authored */
  entryMode?: Maybe<MemoEntryMode>;
  /** The user who provided memo AI feedback */
  feedbackFrom?: Maybe<User>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The prompt used to generate this memo */
  memoPrompt?: Maybe<MemoPrompt>;
  /** User-editable memo name */
  name: Scalars['String']['output'];
  /** User-provided instructions used for generation */
  specificInstructions?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
  workflowTrackers: WorkflowTrackerConnection;
};


export type MemoDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentOrder>>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type MemoWorkflowTrackersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkflowTrackerOrder>>;
  where?: InputMaybe<WorkflowTrackerWhereInput>;
};

/** MemoAiRating is enum for the field ai_rating */
export enum MemoAiRating {
  Bad = 'BAD',
  Good = 'GOOD'
}

/** A connection to a list of items. */
export type MemoConnection = {
  __typename?: 'MemoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MemoEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MemoEdge = {
  __typename?: 'MemoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Memo>;
};

/** MemoEntryMode is enum for the field entry_mode */
export enum MemoEntryMode {
  AiUserInvoked = 'AI_USER_INVOKED',
  LuminaryAi = 'LUMINARY_AI',
  User = 'USER'
}

/** Ordering options for Memo connections */
export type MemoOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Memos. */
  field: MemoOrderField;
};

/** Properties by which Memo connections can be ordered. */
export enum MemoOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type MemoPrompt = Node & {
  __typename?: 'MemoPrompt';
  createdAt: Scalars['Time']['output'];
  /** Short description displayed in memo prompt cards */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Whether prompt markdown is resolved from code rather than DB */
  isSystemPrompt: Scalars['Boolean']['output'];
  /** Standard memo prompt type */
  memoPromptType: MemoPromptMemoPromptType;
  memos: MemoConnection;
  /** Human-readable prompt name */
  name: Scalars['String']['output'];
  /** Prompt markdown content. Required for non-system prompts. */
  promptMarkdown?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type MemoPromptMemosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemoOrder>>;
  where?: InputMaybe<MemoWhereInput>;
};

/** A connection to a list of items. */
export type MemoPromptConnection = {
  __typename?: 'MemoPromptConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MemoPromptEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MemoPromptEdge = {
  __typename?: 'MemoPromptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MemoPrompt>;
};

/** MemoPromptMemoPromptType is enum for the field memo_prompt_type */
export enum MemoPromptMemoPromptType {
  CoverLetter = 'COVER_LETTER',
  Custom = 'CUSTOM',
  EstatePlanSummary = 'ESTATE_PLAN_SUMMARY',
  ExecutiveSummary = 'EXECUTIVE_SUMMARY',
  RoleSummary = 'ROLE_SUMMARY',
  TrustComparison = 'TRUST_COMPARISON'
}

/** Ordering options for MemoPrompt connections */
export type MemoPromptOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order MemoPrompts. */
  field: MemoPromptOrderField;
};

/** Properties by which MemoPrompt connections can be ordered. */
export enum MemoPromptOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * MemoPromptWhereInput is used for filtering MemoPrompt objects.
 * Input was generated by ent.
 */
export type MemoPromptWhereInput = {
  and?: InputMaybe<Array<MemoPromptWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_system_prompt field predicates */
  isSystemPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  /** memo_prompt_type field predicates */
  memoPromptType?: InputMaybe<MemoPromptMemoPromptType>;
  memoPromptTypeIn?: InputMaybe<Array<MemoPromptMemoPromptType>>;
  memoPromptTypeNEQ?: InputMaybe<MemoPromptMemoPromptType>;
  memoPromptTypeNotIn?: InputMaybe<Array<MemoPromptMemoPromptType>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<MemoPromptWhereInput>;
  or?: InputMaybe<Array<MemoPromptWhereInput>>;
  /** prompt_markdown field predicates */
  promptMarkdown?: InputMaybe<Scalars['String']['input']>;
  promptMarkdownIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  promptMarkdownNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * MemoWhereInput is used for filtering Memo objects.
 * Input was generated by ent.
 */
export type MemoWhereInput = {
  /** ai_feedback field predicates */
  aiFeedback?: InputMaybe<Scalars['String']['input']>;
  aiFeedbackIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  aiFeedbackNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ai_rating field predicates */
  aiRating?: InputMaybe<MemoAiRating>;
  aiRatingIn?: InputMaybe<Array<MemoAiRating>>;
  aiRatingIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  aiRatingNEQ?: InputMaybe<MemoAiRating>;
  aiRatingNotIn?: InputMaybe<Array<MemoAiRating>>;
  aiRatingNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<MemoWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** entry_mode field predicates */
  entryMode?: InputMaybe<MemoEntryMode>;
  entryModeIn?: InputMaybe<Array<MemoEntryMode>>;
  entryModeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  entryModeNEQ?: InputMaybe<MemoEntryMode>;
  entryModeNotIn?: InputMaybe<Array<MemoEntryMode>>;
  entryModeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** documents edge predicates */
  hasDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** feedback_from edge predicates */
  hasFeedbackFrom?: InputMaybe<Scalars['Boolean']['input']>;
  hasFeedbackFromWith?: InputMaybe<Array<UserWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** memo_prompt edge predicates */
  hasMemoPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  hasMemoPromptWith?: InputMaybe<Array<MemoPromptWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** workflow_trackers edge predicates */
  hasWorkflowTrackers?: InputMaybe<Scalars['Boolean']['input']>;
  hasWorkflowTrackersWith?: InputMaybe<Array<WorkflowTrackerWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<MemoWhereInput>;
  or?: InputMaybe<Array<MemoWhereInput>>;
  /** specific_instructions field predicates */
  specificInstructions?: InputMaybe<Scalars['String']['input']>;
  specificInstructionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  specificInstructionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MergeClientProfilesInput = {
  keepClientProfileID: Scalars['ID']['input'];
  removeClientProfileID: Scalars['ID']['input'];
};

export type MergeEntitiesInput = {
  keepEntityID: Scalars['ID']['input'];
  removeEntityID: Scalars['ID']['input'];
};

/**
 * Input for merging one KG V2 node into another. The source node is marked as
 * merged and points to the target via merged_into; statements, aliases,
 * data-model resolutions, source documents, and AI suggestion references are
 * re-pointed from source to target.
 */
export type MergeKgv2NodesInput = {
  /** The household that owns both nodes. */
  householdID: Scalars['ID']['input'];
  /**
   * The node that will be absorbed. After the merge it has state="merged" and
   * merged_into pointing at the target.
   */
  sourceNodeID: Scalars['ID']['input'];
  /** The node that absorbs the source. */
  targetNodeID: Scalars['ID']['input'];
};

export type Message = Node & {
  __typename?: 'Message';
  /**
   * Typed card content when type = CONFIRMATION_MESSAGE; null for other message
   * types. Resolved server-side by decrypting the stored content.
   */
  confirmationContent?: Maybe<ConfirmationMessageContent>;
  /** The message content in markdown format */
  content: Scalars['String']['output'];
  /** The explicit object id (document, memo, record, waterfall, …) this user message is scoped to — what the user was focused on, or on the page of, when they chose to send the message with that focus. A plain id snapshot (no FK) so it survives object deletion. Set on user messages from the send-message input; null for assistant/system messages and unscoped turns. */
  context?: Maybe<MessageContext>;
  /** The conversation this message belongs to */
  conversation: Conversation;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The saved diagram referenced by this message. Its current name is separate from the encrypted message snapshot; absent for unsaved diagrams or after artifact deletion. */
  diagramArtifact?: Maybe<DiagramArtifact>;
  /**
   * Typed diagram snapshot when type = DIAGRAM_MESSAGE; null for other message
   * types. Resolved server-side by decrypting the stored content.
   */
  diagramContent?: Maybe<DiagramMessageContent>;
  /** Reserved for a future product-owned interactive-message expiration policy. Current interactive messages do not expire and leave this field null. */
  expiresAt?: Maybe<Scalars['Time']['output']>;
  /** References to specific paragraphs in a document that this message relates to */
  fileParagraphs?: Maybe<Array<FileParagraph>>;
  /**
   * Typed question content when type = FREE_FORM_QUESTION_MESSAGE; null for
   * other message types.
   */
  freeFormQuestionContent?: Maybe<FreeFormQuestionMessageContent>;
  /** Encrypted question group, present only for GROUPED_QUESTION_MESSAGE. */
  groupedQuestionContent?: Maybe<GroupedQuestionMessageContent>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** For an interactive message: the tracker of the interaction child workflow awaiting the response. Its temporal_id is the only stored Temporal routing and, being deterministic per tool call, the interaction store's idempotency key. */
  interactiveMessageWorkflowTracker?: Maybe<WorkflowTracker>;
  /** Answer-depth mode the user selected for this turn (QUICK fast roster+KG, DEEP comprehensive). Set on user messages from the send-message input; null for assistant/system messages. */
  mode?: Maybe<MessageMode>;
  /**
   * Typed question content when type = MULTIPLE_CHOICE_MULTI_SELECT_MESSAGE;
   * null for other message types.
   */
  multipleChoiceMultiSelectContent?: Maybe<MultipleChoiceMultiSelectMessageContent>;
  /**
   * Typed question content when type = MULTIPLE_CHOICE_SINGLE_SELECT_MESSAGE;
   * null for other message types.
   */
  multipleChoiceSingleSelectContent?: Maybe<MultipleChoiceSingleSelectMessageContent>;
  /** For a generated user response: the interactive message it answers. Written atomically with the interactive message's terminal status, never by clients. */
  respondsTo?: Maybe<Message>;
  /** The universal response action a GENERATED_USER_RESPONSE row records for the interactive message it answers: SUBMIT is a typed answer (for a confirmation, approval to proceed) and DISMISS declines to engage (for a confirmation, do not proceed). Each message type's content interprets the action's semantics. Written atomically with the interactive message's RESPONDED status, never by clients; null on all other rows. */
  responseAction?: Maybe<MessageResponseAction>;
  responseFor: MessageConnection;
  /** The role of the message sender (user, system, developer, assistant) */
  role: MessageRole;
  /** The user who sent this message, null for system messages */
  sender?: Maybe<User>;
  /** Response lifecycle of an interactive message: PENDING until the user responds (RESPONDED, whichever response action they took), the request expires, or infrastructure cancels the owning workflow (CANCELED, never user-initiated). Terminal states never revert. Null for non-interactive messages. */
  status?: Maybe<MessageStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** Number of input/output tokens from ChatCompletions API, used for context window management */
  tokenCount?: Maybe<Scalars['Int']['output']>;
  /** The content type of the message. TEXT is ordinary markdown. CONFIRMATION_MESSAGE, FREE_FORM_QUESTION_MESSAGE, and the MULTIPLE_CHOICE_*_SELECT_MESSAGE questions are interactive prompts whose typed card data is encrypted separately. GENERATED_USER_RESPONSE is server-generated text recording a user's structured response to an interactive message. Future rich types add their own `{type}_content_encrypted` columns. */
  type: MessageType;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userUploadedImages: ImageConnection;
  waterfallMsgContext: EstateWaterfallMessageContextConnection;
  /** The built-in prompt template selected in the send-message request. Null for messages sent without a template, assistant or system messages, and messages saved before template tracking. */
  withPromptTemplate?: Maybe<MessageWithPromptTemplate>;
};


export type MessageResponseForArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessageOrder>>;
  where?: InputMaybe<MessageWhereInput>;
};


export type MessageUserUploadedImagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImageOrder>>;
};


export type MessageWaterfallMsgContextArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EstateWaterfallMessageContextOrder>>;
  where?: InputMaybe<EstateWaterfallMessageContextWhereInput>;
};

/** A connection to a list of items. */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MessageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/**
 * The explicit object a message was scoped to, as stored on the message. Bound
 * to the Go type customstruct.MessageContext via gqlgen.yml; the output
 * counterpart of HouseholdChatMessageContextInput.
 */
export type MessageContext = {
  __typename?: 'MessageContext';
  /**
   * ID of the object the message is scoped to; its PULID prefix identifies the
   * object type.
   */
  objectID?: Maybe<Scalars['ID']['output']>;
};

/** An edge in a connection. */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Message>;
};

/** MessageMode is enum for the field mode */
export enum MessageMode {
  Deep = 'DEEP',
  Quick = 'QUICK'
}

/** Ordering options for Message connections */
export type MessageOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Messages. */
  field: MessageOrderField;
};

/** Properties by which Message connections can be ordered. */
export enum MessageOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** MessageResponseAction is enum for the field response_action */
export enum MessageResponseAction {
  Dismiss = 'DISMISS',
  Submit = 'SUBMIT'
}

/**
 * One selectable response option declared by an option-declaring interactive
 * message (the multiple-choice questions). Bound to the Go type
 * messagecontent.ResponseOption via gqlgen.yml.
 */
export type MessageResponseOption = {
  __typename?: 'MessageResponseOption';
  /** Display text for the option's button. */
  label: Scalars['String']['output'];
  /**
   * Stable semantic value the option stands for, echoed back through
   * responseOptionValues on the response mutation.
   */
  value: Scalars['String']['output'];
};

/** MessageRole is enum for the field role */
export enum MessageRole {
  Assistant = 'assistant',
  Developer = 'developer',
  System = 'system',
  User = 'user'
}

/** MessageStatus is enum for the field status */
export enum MessageStatus {
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Responded = 'RESPONDED'
}

/** MessageType is enum for the field type */
export enum MessageType {
  ConfirmationMessage = 'CONFIRMATION_MESSAGE',
  DiagramMessage = 'DIAGRAM_MESSAGE',
  FreeFormQuestionMessage = 'FREE_FORM_QUESTION_MESSAGE',
  GeneratedUserResponse = 'GENERATED_USER_RESPONSE',
  GroupedQuestionMessage = 'GROUPED_QUESTION_MESSAGE',
  MultipleChoiceMultiSelectMessage = 'MULTIPLE_CHOICE_MULTI_SELECT_MESSAGE',
  MultipleChoiceSingleSelectMessage = 'MULTIPLE_CHOICE_SINGLE_SELECT_MESSAGE',
  Text = 'TEXT'
}

/**
 * MessageWhereInput is used for filtering Message objects.
 * Input was generated by ent.
 */
export type MessageWhereInput = {
  and?: InputMaybe<Array<MessageWhereInput>>;
  /** content field predicates */
  content?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** expires_at field predicates */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAtLT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtLTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** conversation edge predicates */
  hasConversation?: InputMaybe<Scalars['Boolean']['input']>;
  hasConversationWith?: InputMaybe<Array<ConversationWhereInput>>;
  /** diagram_artifact edge predicates */
  hasDiagramArtifact?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiagramArtifactWith?: InputMaybe<Array<DiagramArtifactWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** interactive_message_workflow_tracker edge predicates */
  hasInteractiveMessageWorkflowTracker?: InputMaybe<Scalars['Boolean']['input']>;
  hasInteractiveMessageWorkflowTrackerWith?: InputMaybe<Array<WorkflowTrackerWhereInput>>;
  /** responds_to edge predicates */
  hasRespondsTo?: InputMaybe<Scalars['Boolean']['input']>;
  hasRespondsToWith?: InputMaybe<Array<MessageWhereInput>>;
  /** response_for edge predicates */
  hasResponseFor?: InputMaybe<Scalars['Boolean']['input']>;
  hasResponseForWith?: InputMaybe<Array<MessageWhereInput>>;
  /** sender edge predicates */
  hasSender?: InputMaybe<Scalars['Boolean']['input']>;
  hasSenderWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** waterfall_msg_context edge predicates */
  hasWaterfallMsgContext?: InputMaybe<Scalars['Boolean']['input']>;
  hasWaterfallMsgContextWith?: InputMaybe<Array<EstateWaterfallMessageContextWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** mode field predicates */
  mode?: InputMaybe<MessageMode>;
  modeIn?: InputMaybe<Array<MessageMode>>;
  modeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  modeNEQ?: InputMaybe<MessageMode>;
  modeNotIn?: InputMaybe<Array<MessageMode>>;
  modeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<MessageWhereInput>;
  or?: InputMaybe<Array<MessageWhereInput>>;
  /** response_action field predicates */
  responseAction?: InputMaybe<MessageResponseAction>;
  responseActionIn?: InputMaybe<Array<MessageResponseAction>>;
  responseActionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseActionNEQ?: InputMaybe<MessageResponseAction>;
  responseActionNotIn?: InputMaybe<Array<MessageResponseAction>>;
  responseActionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** role field predicates */
  role?: InputMaybe<MessageRole>;
  roleIn?: InputMaybe<Array<MessageRole>>;
  roleNEQ?: InputMaybe<MessageRole>;
  roleNotIn?: InputMaybe<Array<MessageRole>>;
  /** status field predicates */
  status?: InputMaybe<MessageStatus>;
  statusIn?: InputMaybe<Array<MessageStatus>>;
  statusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusNEQ?: InputMaybe<MessageStatus>;
  statusNotIn?: InputMaybe<Array<MessageStatus>>;
  statusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** token_count field predicates */
  tokenCount?: InputMaybe<Scalars['Int']['input']>;
  tokenCountGT?: InputMaybe<Scalars['Int']['input']>;
  tokenCountGTE?: InputMaybe<Scalars['Int']['input']>;
  tokenCountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  tokenCountLT?: InputMaybe<Scalars['Int']['input']>;
  tokenCountLTE?: InputMaybe<Scalars['Int']['input']>;
  tokenCountNEQ?: InputMaybe<Scalars['Int']['input']>;
  tokenCountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** type field predicates */
  type?: InputMaybe<MessageType>;
  typeIn?: InputMaybe<Array<MessageType>>;
  typeNEQ?: InputMaybe<MessageType>;
  typeNotIn?: InputMaybe<Array<MessageType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** with_prompt_template field predicates */
  withPromptTemplate?: InputMaybe<MessageWithPromptTemplate>;
  withPromptTemplateIn?: InputMaybe<Array<MessageWithPromptTemplate>>;
  withPromptTemplateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  withPromptTemplateNEQ?: InputMaybe<MessageWithPromptTemplate>;
  withPromptTemplateNotIn?: InputMaybe<Array<MessageWithPromptTemplate>>;
  withPromptTemplateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** MessageWithPromptTemplate is enum for the field with_prompt_template */
export enum MessageWithPromptTemplate {
  AbcJointTrust = 'ABC_JOINT_TRUST',
  AbcSeparateTrusts = 'ABC_SEPARATE_TRUSTS',
  AbJointTrust = 'AB_JOINT_TRUST',
  AbSeparateTrusts = 'AB_SEPARATE_TRUSTS',
  CoverLetter = 'COVER_LETTER',
  Custom = 'CUSTOM',
  EqualShares = 'EQUAL_SHARES',
  EstateDistributionDetailed = 'ESTATE_DISTRIBUTION_DETAILED',
  EstateDistributionSimple = 'ESTATE_DISTRIBUTION_SIMPLE',
  EstatePlanSummary = 'ESTATE_PLAN_SUMMARY',
  ExecutiveSummary = 'EXECUTIVE_SUMMARY',
  FamilyTrust = 'FAMILY_TRUST',
  RoleSummary = 'ROLE_SUMMARY',
  SpecificBequests = 'SPECIFIC_BEQUESTS',
  SurvivingSpouse = 'SURVIVING_SPOUSE',
  TrustComparison = 'TRUST_COMPARISON'
}

export type MissingDocumentOverride = Node & {
  __typename?: 'MissingDocumentOverride';
  /** Client profile to which this missing document type is associated */
  clientProfile?: Maybe<ClientProfile>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  documentType: MissingDocumentOverrideDocumentType;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};

/** MissingDocumentOverrideDocumentType is enum for the field document_type */
export enum MissingDocumentOverrideDocumentType {
  HealthcareProxy = 'HEALTHCARE_PROXY',
  LivingWill = 'LIVING_WILL',
  PowerOfAttorney = 'POWER_OF_ATTORNEY',
  SignedTrustDocument = 'SIGNED_TRUST_DOCUMENT',
  TrustAmendment = 'TRUST_AMENDMENT',
  Will = 'WILL',
  WillCodicil = 'WILL_CODICIL'
}

/** Ordering options for MissingDocumentOverride connections */
export type MissingDocumentOverrideOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order MissingDocumentOverrides. */
  field: MissingDocumentOverrideOrderField;
};

/** Properties by which MissingDocumentOverride connections can be ordered. */
export enum MissingDocumentOverrideOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * MissingDocumentOverrideWhereInput is used for filtering MissingDocumentOverride objects.
 * Input was generated by ent.
 */
export type MissingDocumentOverrideWhereInput = {
  and?: InputMaybe<Array<MissingDocumentOverrideWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** document_type field predicates */
  documentType?: InputMaybe<MissingDocumentOverrideDocumentType>;
  documentTypeIn?: InputMaybe<Array<MissingDocumentOverrideDocumentType>>;
  documentTypeNEQ?: InputMaybe<MissingDocumentOverrideDocumentType>;
  documentTypeNotIn?: InputMaybe<Array<MissingDocumentOverrideDocumentType>>;
  /** client_profile edge predicates */
  hasClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientProfileWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<MissingDocumentOverrideWhereInput>;
  or?: InputMaybe<Array<MissingDocumentOverrideWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MissingDocumentsPage = Node & {
  __typename?: 'MissingDocumentsPage';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The presentation page that this estate insight page is part of */
  presentationPage?: Maybe<PresentationPage>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type MissingDocumentsPageConnection = {
  __typename?: 'MissingDocumentsPageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MissingDocumentsPageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MissingDocumentsPageEdge = {
  __typename?: 'MissingDocumentsPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MissingDocumentsPage>;
};

export type ModelMapping = Node & {
  __typename?: 'ModelMapping';
  config?: Maybe<OpenaiSdkConfig>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /** The model name (e.g. gpt-4, claud-3-opus) */
  modelName: Scalars['String']['output'];
  modelPurpose: ModelMappingModelPurpose;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type ModelMappingConnection = {
  __typename?: 'ModelMappingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ModelMappingEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ModelMappingEdge = {
  __typename?: 'ModelMappingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ModelMapping>;
};

/** ModelMappingModelPurpose is enum for the field model_purpose */
export enum ModelMappingModelPurpose {
  AdvancedReasoning = 'ADVANCED_REASONING',
  DocumentSummaryHigh = 'DOCUMENT_SUMMARY_HIGH',
  DocumentSummaryStandard = 'DOCUMENT_SUMMARY_STANDARD',
  EvidenceSearch = 'EVIDENCE_SEARCH',
  Fast = 'FAST',
  KgReasoning = 'KG_REASONING',
  LongContext = 'LONG_CONTEXT',
  Mini = 'MINI',
  QuickSummary = 'QUICK_SUMMARY',
  ReasoningMax = 'REASONING_MAX',
  ReasoningMini = 'REASONING_MINI',
  ReasoningStandard = 'REASONING_STANDARD'
}

/** Ordering options for ModelMapping connections */
export type ModelMappingOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ModelMappings. */
  field: ModelMappingOrderField;
};

/** Properties by which ModelMapping connections can be ordered. */
export enum ModelMappingOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * ModelMappingWhereInput is used for filtering ModelMapping objects.
 * Input was generated by ent.
 */
export type ModelMappingWhereInput = {
  and?: InputMaybe<Array<ModelMappingWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** config edge predicates */
  hasConfig?: InputMaybe<Scalars['Boolean']['input']>;
  hasConfigWith?: InputMaybe<Array<OpenaiSdkConfigWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** model_name field predicates */
  modelName?: InputMaybe<Scalars['String']['input']>;
  /** model_purpose field predicates */
  modelPurpose?: InputMaybe<ModelMappingModelPurpose>;
  modelPurposeIn?: InputMaybe<Array<ModelMappingModelPurpose>>;
  modelPurposeNEQ?: InputMaybe<ModelMappingModelPurpose>;
  modelPurposeNotIn?: InputMaybe<Array<ModelMappingModelPurpose>>;
  not?: InputMaybe<ModelMappingWhereInput>;
  or?: InputMaybe<Array<ModelMappingWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type MostRecentlyViewedEntityMap = {
  __typename?: 'MostRecentlyViewedEntityMap';
  id?: Maybe<Scalars['ID']['output']>;
};

export type MostRecentlyViewedEntityMapWhereInput = {
  householdId: Scalars['ID']['input'];
};

export type MostRecentlyViewedWaterfall = {
  __typename?: 'MostRecentlyViewedWaterfall';
  id?: Maybe<Scalars['ID']['output']>;
};

/** Inputs for moving holdings between two entities in the same household. */
export type MoveHoldingsBetweenEntitiesInput = {
  /**
   * Static identities of the manual assets to move. Every static must be manual
   * (not integration-linked) and held in the source entity's current valuation.
   */
  assetStaticIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The entity to move them to. */
  destinationEntityID: Scalars['ID']['input'];
  /**
   * Insurance policies to move. Each must currently be owned by the source entity, and the
   * destination entity kind must be able to hold policies.
   */
  insurancePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The entity that currently holds the assets and/or policies. */
  sourceEntityID: Scalars['ID']['input'];
};

/** The holdings produced by moveHoldingsBetweenEntities. */
export type MoveHoldingsBetweenEntitiesResponse = {
  __typename?: 'MoveHoldingsBetweenEntitiesResponse';
  /** The destination entity's new current valuation. Null when no assets were moved. */
  destinationValuation?: Maybe<AssetValuationV2>;
  /** The policies created on the destination entity. Empty when no policies were moved. */
  movedPolicies: Array<InsurancePolicy>;
  /** The source entity's new current valuation. Null when no assets were moved. */
  sourceValuation?: Maybe<AssetValuationV2>;
};

/**
 * Typed content of a MULTIPLE_CHOICE_MULTI_SELECT_MESSAGE — a question that
 * declares response options and accepts one or more selected options, or a
 * free-form answer in place of any selection. Bound to the Go type
 * messagecontent.MultipleChoiceMultiSelectMessageContent via gqlgen.yml; stored
 * CMK-encrypted and decrypted by the Message.multipleChoiceMultiSelectContent
 * resolver.
 */
export type MultipleChoiceMultiSelectMessageContent = {
  __typename?: 'MultipleChoiceMultiSelectMessageContent';
  /** Hide Other and disallow free-form answers. Defaults to false. */
  hideOtherOption: Scalars['Boolean']['output'];
  /** The selectable response options declared by the question. */
  options: Array<MessageResponseOption>;
  /**
   * Optional supporting context shown under the title; empty when the question
   * declares none.
   */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The single focused question shown to the user. */
  title: Scalars['String']['output'];
};

/**
 * Typed content of a MULTIPLE_CHOICE_SINGLE_SELECT_MESSAGE — a question that
 * declares response options and accepts exactly one selected option, or a
 * free-form answer in place of any selection. Bound to the Go type
 * messagecontent.MultipleChoiceSingleSelectMessageContent via gqlgen.yml; stored
 * CMK-encrypted and decrypted by the Message.multipleChoiceSingleSelectContent
 * resolver.
 */
export type MultipleChoiceSingleSelectMessageContent = {
  __typename?: 'MultipleChoiceSingleSelectMessageContent';
  /** Hide Other and disallow free-form answers. Defaults to false. */
  hideOtherOption: Scalars['Boolean']['output'];
  /** The selectable response options declared by the question. */
  options: Array<MessageResponseOption>;
  /**
   * Optional supporting context shown under the title; empty when the question
   * declares none.
   */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The single focused question shown to the user. */
  title: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  DANGEROUS_deleteTestData?: Maybe<Scalars['Int']['output']>;
  /**
   * Decrypt a log-encrypted value. Only works with values encrypted using the
   * log-safe encryption scheme (values starting with 'log_v1:').
   * Requires Luminary admin access. All decryption attempts are audited.
   * Decryption fails if the value is more than 30 days old.
   * Tenant ID is derived from the authenticated user's context.
   */
  _decryptLogValue?: Maybe<Scalars['String']['output']>;
  /**
   * Applies pending v2 suggestions in dependency order within the selected scope.
   * Already acknowledged suggestions are unchanged. Suggestions that cannot be
   * applied are skipped; an unexpected failure rolls back the batch. Admin only.
   */
  acceptHouseholdAISuggestions: AcceptHouseholdAiSuggestionsPayload;
  /**
   * Updates the acceptance status of the AI suggestion, and associates it
   * with a client_profile/client_organization/entity row (if applicable).
   */
  acknowledgeAISuggestions: Array<AiSuggestion>;
  addManagedSFTPPublicKey: ManagedSftpPublicKey;
  /**
   * Attach a routing email domain to an existing WorkOSOrganization. Used
   * when a customer adds a new email domain post-onboarding.
   */
  addWorkOSOrganizationDomain: WorkOsOrganizationDomain;
  /**
   * Records the current user's attestation or approval of a presentation, as the
   * effective requirePresentationApproval configuration defines. The presentation
   * creator attests. When approval is also required, a user with the presentation
   * approver capability approves after the attestation; a creator who is also an
   * approver does both in one call. Returns NOT_FOUND if the presentation does not
   * exist, CONFLICT if no review is required or the presentation needs an
   * attestation first, and FORBIDDEN if the user cannot access the household or
   * can do neither step.
   */
  approveClientPresentationV2: ClientPresentationV2;
  archiveFormSubmission: Submission;
  /**
   * Ask a question about a document through AI chat.
   * Creates a new conversation (with system prompt) if conversationID is not provided,
   * or adds a message to an existing conversation.
   * Returns the conversation with all its messages.
   */
  askDocumentQuestion?: Maybe<Conversation>;
  assignEntityTasksToUser: Scalars['Int']['output'];
  /**
   * Backfills the document inference metadata for the specified documents.
   * Metadata includes:
   *    - Invoking the OCR Lambda to extract document content
   *    - Storing the file page info
   */
  asyncBackfillDocumentInferenceMetadata: Array<AsyncJob>;
  /**
   * Runs the OCR Lambda function for all documents in the tenant that have not been OCR'd yet.
   * @deprecated No longer supported
   */
  asyncDocumentOCRBackfill: Array<AsyncJob>;
  /** Summarizes the documents matching the where clause. */
  asyncSummarizeDocuments: Array<AsyncJob>;
  /** Generate a link to the audit logs for the current tenant. */
  auditLogsLink?: Maybe<Scalars['URL']['output']>;
  autoGroupEstateWaterfall: EstateWaterfall;
  /** Backfills KGV2 knowledge graph for households matching the where clause. */
  backfillKGV2: Scalars['Boolean']['output'];
  batchCreateEntityDiagram: BatchCreateEntityDiagramPayload;
  /**
   * batchUpdateEstateWaterfall atomically applies multiple diagram edit operations:
   * group creation, updates, deletion, and node configuration changes.
   *
   * Execution order:
   * 1. Create groups (so updates can reference newly created groups if needed)
   * 2. Update existing groups
   * 3. Delete groups
   * 4. Update node configurations
   *
   * All operations succeed or all fail (atomic).
   */
  batchUpdateEstateWaterfall: BatchUpdateEstateWaterfallPayload;
  batchUpdateGraphVisualization: BatchUpdateGraphVisualizationPayload;
  bulkUpsertAssetToCurrentValuation: Array<Maybe<Entity>>;
  cancelEntityTask: EntityTask;
  /**
   * Cleans up AISuggestions for households matching the where clause as part of
   * the v1 → v2 migration. Deletes leaked v2 suggestions and rejects pending v1
   * suggestions for every matched household.
   */
  cleanUpSuggestionsForV2Migration: CleanUpSuggestionsForV2MigrationPayload;
  clearFormSubmissionAnswer: FormSubmissionAnswerMutationPayload;
  completeEntityTask: EntityTask;
  completeFormSubmission: Submission;
  /**
   * Completes household onboarding after pending document processing finishes and
   * generates one presentation from each selected template. An empty template
   * list skips presentation generation.
   */
  completeHouseholdOnboarding: WorkflowTracker;
  convertEntity: Entity;
  /** @deprecated Use copyArchetypeHouseholdAsync instead */
  copyArchetypeHousehold: Household;
  /**
   * Copy a household from the archetype tenant into the current tenant
   * asynchronously via a Temporal workflow. Returns true once the workflow has
   * been started; progress is reported through the workflow tracker.
   */
  copyArchetypeHouseholdAsync: Scalars['Boolean']['output'];
  /**
   * Duplicate a document summary onto another document within the same household. The
   * source summary and the target document must both belong to the supplied household.
   */
  copyDocumentSummary: DocumentSummary;
  /** @deprecated Use copyHouseholdAsync instead */
  copyHousehold: Household;
  copyHouseholdAsync: Scalars['Boolean']['output'];
  /**
   * Duplicate an existing memo within the same household. The returned memo has the
   * same content, entry mode, AI metadata, role predicates, source documents, and
   * memo prompt as the source, with " (Copy)" appended to the name.
   */
  copyMemo: Memo;
  createActiveEstateInsightsPage: ActiveEstateInsightsPage;
  createAiSuggestion: AiSuggestion;
  createAssetClass: AssetClass;
  createAssetClasses: Array<Maybe<AssetClass>>;
  createAssetValuationV2: AssetValuationV2;
  createBalanceSheetBundleConfiguration: BalanceSheetBundleConfiguration;
  createBalanceSheetCategories: Array<Maybe<BalanceSheetCategory>>;
  createBalanceSheetCategory: BalanceSheetCategory;
  createBeneficiariesBundleConfiguration: BeneficiariesBundleConfiguration;
  createBeneficiariesTemplateBundleConfiguration: BeneficiariesTemplateBundleConfiguration;
  createBeneficiaryDesignationGroup: BeneficiaryDesignationGroup;
  createBeneficiaryPage: BeneficiaryPage;
  /**
   * Creates a presentation with a cover, table of contents, and the household's
   * effective firm and Luminary disclaimers. Requires household update permission.
   */
  createBlankClientPresentation: ClientPresentationV2;
  createCashflow: Cashflow;
  createClientOrganization: ClientOrganization;
  createClientOrganizations: Array<ClientOrganization>;
  createClientPresentationV2: ClientPresentationV2;
  createClientProfile: ClientProfile;
  createClientProfiles: Array<ClientProfile>;
  createComparedWaterfall: ComparedWaterfall;
  createCompletedEstateInsightsPage: CompletedEstateInsightsPage;
  createCoverPageConfiguration: CoverPageConfiguration;
  createDispositiveProvisionTemplate: DispositiveProvisionTemplate;
  createDividerBundleConfiguration: DividerBundleConfiguration;
  createDividerTemplateBundleConfiguration: DividerTemplateBundleConfiguration;
  createDocument: Document;
  createDocumentSummary: DocumentSummary;
  createDocumentSummaryPage: DocumentSummaryPage;
  createDocumentSummaryPrompt: DocumentSummaryPrompt;
  createDocumentSummaryTemplateBundleConfiguration: DocumentSummaryTemplateBundleConfiguration;
  createDocumentWithEntityRelationships: Document;
  createDocuments: Array<Document>;
  createDocumentsWithEntityRelationships: Array<Document>;
  createDsuePortability: DsuePortability;
  createEmployee: Employee;
  createEntities: Array<Maybe<Entity>>;
  createEntitiesOverviewBundleConfiguration: EntitiesOverviewBundleConfiguration;
  createEntitiesOverviewBundleConfigurationEntity: EntitiesOverviewBundleConfigurationEntity;
  createEntity: Entity;
  /** Create a new entity diagram */
  createEntityDiagram: EntityDiagram;
  createEntityDocumentRelationship: EntityDocumentRelationship;
  createEntityDocumentRelationships: Array<EntityDocumentRelationship>;
  createEntityGraphView: EntityGraphView;
  createEntityGraphViewBundleConfiguration: EntityGraphViewBundleConfiguration;
  createEntityNotes: EntityNotes;
  createEntitySummaryBundleConfiguration: EntitySummaryBundleConfiguration;
  createEntitySummaryTemplateBundleConfiguration: EntitySummaryTemplateBundleConfiguration;
  createEstateInsightsBundleConfiguration: EstateInsightsBundleConfiguration;
  createEstateTaxScenario: EstateTaxScenario;
  createEstateWaterfall: EstateWaterfall;
  createEstateWaterfallVisualizationConfig: EstateWaterfallVisualizationConfig;
  createEstateWaterfallVisualizationFilter: EstateWaterfallVisualizationFilter;
  createFamilyTreeBundleConfiguration: FamilyTreeBundleConfiguration;
  createForm: Form;
  createFormSubmission: Submission;
  createFormTestSnapshot: FormVersion;
  createGraphVisualizationGroup: GraphVisualizationGroup;
  createGrowthProfile: GrowthProfile;
  createHousehold: Household;
  createHouseholdV2: Household;
  createHouseholds: Array<Maybe<Household>>;
  createHypotheticalClt: HypotheticalClt;
  createHypotheticalCrt: HypotheticalCrt;
  createHypotheticalGrat: HypotheticalGrat;
  createHypotheticalInsurance: HypotheticalInsurance;
  createHypotheticalSaleLoan: HypotheticalSaleLoan;
  createHypotheticalTransferAsset: HypotheticalTransferAsset;
  createHypotheticalTransferFundingSource: HypotheticalTransferFundingSource;
  createHypotheticalWaterfallDispositiveProvisionTemplate: HypotheticalWaterfallDispositiveProvisionTemplate;
  createIncomeTaxPaymentConfig: IncomeTaxPaymentConfig;
  createInsightsTemplateBundleConfiguration: InsightsTemplateBundleConfiguration;
  createIntegrationEntitiesForUploadedCSV: Scalars['Boolean']['output'];
  createKgRoot: KgRoot;
  createLiabilities: Array<Liability>;
  createLiabilitiesBundleConfiguration: LiabilitiesBundleConfiguration;
  createLiability: Liability;
  createLifeInsuranceBundleConfiguration: LifeInsuranceBundleConfiguration;
  createLifetimeExclusionEvent: LifetimeExclusionEvent;
  createLoggedTransfer: LoggedTransfer;
  /**
   * Create a LuminaryOrganization together with its parent Tenant, 1:1
   * WorkOSOrganization, and any initial routing domains.
   */
  createLuminaryOrganization: CreateLuminaryOrganizationOutput;
  /**
   * Create a Tenant as a member of the authenticated parent tenant's
   * LuminaryOrganization. The new tenant reuses the organization's WorkOS
   * identity boundary.
   */
  createLuminaryOrganizationMemberTenant: Tenant;
  /**
   * Creates a missing document override for a household and document type if it does not already exist
   * and associates an optional client profile. Returns the created or existing override.
   */
  createMissingDocumentOverride: MissingDocumentOverride;
  createMissingDocumentsPage: MissingDocumentsPage;
  createModelMapping: ModelMapping;
  createOpenaiSdkConfig: OpenaiSdkConfig;
  createOrganizationDisclaimerConfiguration: OrganizationDisclaimerConfiguration;
  createOwnershipStake: OwnershipStake;
  createPlatformDocument: PlatformDocument;
  createPresentationAssetDistributionBundleConfiguration: PresentationAssetDistributionBundleConfiguration;
  createPresentationAssetDistributionItemConfiguration: PresentationAssetDistributionItemConfiguration;
  createPresentationAssetDistributionItemDetail: PresentationAssetDistributionItemDetail;
  createPresentationBundle: PresentationBundle;
  createPresentationBundleCoverPage: PresentationBundleCoverPage;
  createPresentationBusinessOverviewBundleConfiguration: PresentationBusinessOverviewBundleConfiguration;
  createPresentationBusinessOverviewBusinessConfiguration: PresentationBusinessOverviewBusinessConfiguration;
  createPresentationBusinessOverviewItem: PresentationBusinessOverviewItem;
  createPresentationCoverPage: PresentationCoverPage;
  createPresentationCustomPage: PresentationCustomPage;
  createPresentationCustomPageBundleConfiguration: PresentationCustomPageBundleConfiguration;
  createPresentationDiagramPage: PresentationDiagramPage;
  createPresentationDocumentsReviewedBundleConfiguration: PresentationDocumentsReviewedBundleConfiguration;
  createPresentationDocumentsReviewedDocument: PresentationDocumentsReviewedDocument;
  createPresentationFamilyOverviewBundleConfiguration: PresentationFamilyOverviewBundleConfiguration;
  createPresentationFamilyOverviewMemberConfiguration: PresentationFamilyOverviewMemberConfiguration;
  createPresentationHealthcareDirectiveBundleConfiguration: PresentationHealthcareDirectiveBundleConfiguration;
  createPresentationHealthcareDirectiveClientConfiguration: PresentationHealthcareDirectiveClientConfiguration;
  createPresentationHealthcareDirectiveItem: PresentationHealthcareDirectiveItem;
  createPresentationPage: PresentationPage;
  createPresentationPlanningOpportunitiesBundleConfiguration: PresentationPlanningOpportunitiesBundleConfiguration;
  createPresentationPlanningOpportunitiesItem: PresentationPlanningOpportunitiesItem;
  createPresentationPowerOfAttorneyBundleConfiguration: PresentationPowerOfAttorneyBundleConfiguration;
  createPresentationPowerOfAttorneyClientConfiguration: PresentationPowerOfAttorneyClientConfiguration;
  createPresentationPowerOfAttorneyItem: PresentationPowerOfAttorneyItem;
  createPresentationTemplate: PresentationTemplate;
  createPresentationTemplateBundle: PresentationTemplateBundle;
  createPresentationTemplateCoverPage: PresentationTemplateCoverPage;
  createPresentationTemplateCustomPage: PresentationTemplateCustomPage;
  createPresentationTemplateDiagramPage: PresentationTemplateDiagramPage;
  createPresentationTemplatePage: PresentationTemplatePage;
  createPresentationTrustOverviewBundleConfiguration: PresentationTrustOverviewBundleConfiguration;
  createPresentationTrustOverviewItem: PresentationTrustOverviewItem;
  createPresentationTrustOverviewTrustConfiguration: PresentationTrustOverviewTrustConfiguration;
  createPresentationWillBundleConfiguration: PresentationWillBundleConfiguration;
  createPresentationWillClientConfiguration: PresentationWillClientConfiguration;
  createPresentationWillItem: PresentationWillItem;
  createProfessionalTeamRole: ProfessionalTeamRole;
  createProposalSharingToken: SharingToken;
  createProposalV2: Proposal;
  createRole: Role;
  createSSOConnection: SsoConnection;
  createSubBrand: SubBrand;
  createSubBrandDisclaimerConfiguration: SubBrandDisclaimerConfiguration;
  createTaxDragConfig: TaxDragConfig;
  createTaxDragOverride: TaxDragOverride;
  createTeam: Team;
  createTenant?: Maybe<Scalars['ID']['output']>;
  createTenantDocument: TenantDocument;
  createTenantSSOConnection: TenantSsoConnection;
  createTenantSlideConfig: TenantSlideConfig;
  createTenantUserv2: User;
  createTestCmkEncryption: TestCmkEncryption;
  createTestamentaryEntities: Array<TestamentaryEntity>;
  createTestamentaryEntity: TestamentaryEntity;
  createUserFeedback: UserFeedback;
  createUserNotificationConfiguration: UserNotificationConfiguration;
  createWaterfallBundleConfiguration: WaterfallBundleConfiguration;
  createWaterfallBundleCoverPage: WaterfallBundleCoverPage;
  createWaterfallComparisonBundleConfiguration: WaterfallComparisonBundleConfiguration;
  createWaterfallComparisonTemplateBundleConfiguration: WaterfallComparisonTemplateBundleConfiguration;
  createWaterfallTemplateBundleConfiguration: WaterfallTemplateBundleConfiguration;
  /**
   * Copy a household from another tenant to the current tenant.
   * BLOCKED in production environments.
   */
  crossTenantCopyHousehold: Household;
  deleteAssetClass: Scalars['ID']['output'];
  deleteAssetValuationv2: Scalars['ID']['output'];
  deleteBalanceSheetCategory: Scalars['ID']['output'];
  deleteCashflows: Scalars['Int']['output'];
  deleteClientOrganization: Scalars['ID']['output'];
  deleteClientPresentationV2?: Maybe<Scalars['Int']['output']>;
  deleteClientProfile: Scalars['ID']['output'];
  /** deleteClientProfilesDsue deletes all DSUE associated with the given client profile IDs. */
  deleteClientProfilesDsue: Scalars['Boolean']['output'];
  deleteCollaborator: Scalars['ID']['output'];
  deleteDispositionScenario: Scalars['ID']['output'];
  deleteDispositiveProvision: Scalars['ID']['output'];
  deleteDispositiveProvisionTemplate: Scalars['ID']['output'];
  deleteDocument: Scalars['ID']['output'];
  deleteDocumentSummary: Scalars['Int']['output'];
  deleteDocumentSummaryPrompt: Scalars['Int']['output'];
  deleteDocuments: Scalars['Int']['output'];
  /** deleteDsuePortability deletes a DSUE. */
  deleteDsuePortability: Scalars['ID']['output'];
  deleteEntities: Scalars['Int']['output'];
  /** Delete an entity diagram */
  deleteEntityDiagram: EntityDiagram;
  deleteEntityDocumentRelationships: Array<Scalars['ID']['output']>;
  deleteEntityGraphView: Scalars['ID']['output'];
  deleteEstateWaterfall: Scalars['ID']['output'];
  deleteEstateWaterfallHypotheticalTransfers: Scalars['Int']['output'];
  deleteEstateWaterfallVisualizationFilter: Scalars['ID']['output'];
  deleteFeatureFlagQueryRule: Scalars['Int']['output'];
  deleteGraphVisualizationGroups: Array<Scalars['ID']['output']>;
  /** deleteGrowthProfile deletes a growth profile and all associated overrides. */
  deleteGrowthProfile: Scalars['ID']['output'];
  /**
   * Delete a household chat conversation the caller created, cascading to all of
   * its messages and their message-scoped edges (e.g. waterfall message context).
   * Shared records such as the linked document are detached, not deleted.
   * Returns the ID of the deleted conversation.
   */
  deleteHouseholdChatConversation: Scalars['ID']['output'];
  deleteHouseholds: Scalars['Int']['output'];
  deleteHypotheticalCLTs: Scalars['Int']['output'];
  deleteHypotheticalCRTs: Scalars['Int']['output'];
  deleteHypotheticalGRATs: Scalars['Int']['output'];
  deleteHypotheticalInsurances: Scalars['Int']['output'];
  deleteHypotheticalSaleLoan: Scalars['ID']['output'];
  /**
   * Permanently deletes active KG V2 nodes from a household's active graph.
   * Statements where a deleted node is the subject or object are also deleted.
   * Admin only.
   */
  deleteKGV2Nodes: DeleteKgv2NodesPayload;
  deleteLiability: Scalars['ID']['output'];
  deleteLifetimeExclusionEvent: Scalars['ID']['output'];
  deleteLoggedTransfer: Scalars['ID']['output'];
  deleteMemo: Scalars['ID']['output'];
  /** Delete a draft and its stored page and paragraph records. */
  deletePlatformDocument: Scalars['Boolean']['output'];
  deletePresentationTemplate?: Maybe<Scalars['Int']['output']>;
  deleteProposal: Scalars['ID']['output'];
  deleteRole: Scalars['Int']['output'];
  deleteSubBrand: Scalars['ID']['output'];
  deleteTeam: Scalars['ID']['output'];
  deleteTenant: Scalars['ID']['output'];
  deleteTenantSSOConnection: Scalars['ID']['output'];
  deleteTenantSlideConfig: Scalars['ID']['output'];
  deleteTenantUser: Scalars['ID']['output'];
  deleteTestamentaryEntity: Scalars['ID']['output'];
  /**
   * Deletes all IntegrationAssetClasses that are not currently associated with any AssetClass.
   * Returns the number of IntegrationAssetClasses that were deleted.
   */
  deleteUnassociatedIntegrationAssetClasses: Scalars['Int']['output'];
  /**
   * Detach a routing email domain from its WorkOSOrganization by deleting
   * the domain row. Returns the deleted id.
   */
  deleteWorkOSOrganizationDomain: Scalars['ID']['output'];
  demoteSuperuser?: Maybe<User>;
  /**
   * Deletes the AWS user and all installed keys. Existing AWS sessions are not
   * terminated. Enabling again requires customers to register keys again.
   */
  disableManagedSFTP: ManagedSftpConnection;
  dismissAllNotifications: Scalars['Int']['output'];
  dismissAllWorkflowTrackers: Scalars['Int']['output'];
  dismissNotification: Scalars['Boolean']['output'];
  dismissWorkflowTracker: Scalars['Boolean']['output'];
  downloadBalanceSheetExcel?: Maybe<File>;
  /** downloadBalanceSheetExcelV2 returns a signed token that can be used to download the balance sheet as an Excel file. */
  downloadBalanceSheetExcelV2?: Maybe<FileDownloadToken>;
  /** downloadEntityBreakdown returns a generated report breaking down the year to year transfers for each node on the estate waterfall. */
  downloadEntityBreakdownExcel: File;
  /** downloadEntityBreakdownExcelV2 returns a token that can be used to download the entity breakdown excel. */
  downloadEntityBreakdownExcelV2: FileDownloadToken;
  duplicateCashflow: Cashflow;
  duplicateClientPresentationV2?: Maybe<ClientPresentationV2>;
  duplicateEntity: Entity;
  duplicateEstateWaterfall: EstateWaterfall;
  duplicateEstateWaterfallHypotheticalTransfer: EstateWaterfallHypotheticalTransfer;
  /**
   * Duplicates a presentation template. The copy is never a system template (the
   * source's system_template_kind is not carried over), so end users can edit it.
   * When `type` is provided it sets whether the copy is a tenant- or user-level
   * template; otherwise the source template's level is preserved. A user-level
   * copy is owned by the calling user; a tenant-level copy is editable by anyone
   * with permission to manage tenant templates.
   */
  duplicatePresentationTemplate?: Maybe<PresentationTemplate>;
  duplicateProposal: Proposal;
  duplicateTestamentaryEntity: TestamentaryEntity;
  enableManagedSFTP: ManagedSftpConnection;
  /**
   * enqueueDocumentSummaryPrintJob starts an async Temporal workflow to generate a document summary PDF.
   * The frontend should watch for a DOCUMENT_SUMMARY_EXPORT workflow tracker on the document to know when it's done.
   */
  enqueueDocumentSummaryPrintJob: WorkflowTracker;
  /**
   * enqueueDocumentSummaryWordExport starts an async Temporal workflow to generate a document summary Word document.
   * The workflow fetches the summary markdown from the database and converts it to a .docx file server-side.
   * The frontend should watch for a DOCUMENT_SUMMARY_EXPORT workflow tracker on the document to know when it's done.
   */
  enqueueDocumentSummaryWordExport: WorkflowTracker;
  /** Generate a Word export asynchronously and return its workflow tracker. */
  enqueueFormSubmissionWordExport: WorkflowTracker;
  /**
   * enqueueMemoExportJob starts an async Temporal workflow to generate a memo PDF.
   * The frontend should watch for a MEMO_EXPORT workflow tracker on the memo to know when it's done.
   */
  enqueueMemoExportJob: WorkflowTracker;
  /**
   * enqueueMemoWordExport starts an async Temporal workflow to generate a memo Word document.
   * The workflow fetches the memo content from the database and converts it to a .docx file server-side.
   * The frontend should watch for a MEMO_EXPORT workflow tracker on the memo to know when it's done.
   */
  enqueueMemoWordExport: WorkflowTracker;
  /**
   * Starts a presentation PDF export and returns the tracker for this attempt.
   * When completed, the tracker contains the generated document to download.
   */
  enqueuePresentationExport: WorkflowTracker;
  enqueuePresentationPrintJob: AsyncJob;
  /** enqueuePresentationPrintJobV2 starts a presentation print workflow and returns after Temporal accepts it. */
  enqueuePresentationPrintJobV2: Scalars['Boolean']['output'];
  enqueueProposalPresentationPrintJob: AsyncJob;
  /** enqueueProposalPresentationPrintJobV2 starts a proposal presentation print workflow and returns after Temporal accepts it. */
  enqueueProposalPresentationPrintJobV2: Scalars['Boolean']['output'];
  /** Export every document summary in households that the requesting user can access. */
  exportDocumentSummariesExcel: FileDownloadToken;
  exportEntityReport: File;
  /** exportEntityReportV2 returns a token that can be used to download the entity report. */
  exportEntityReportV2: FileDownloadToken;
  exportFiduciaryReport: File;
  /** exportFiduciaryReportV2 returns a token that can be used to download the fiduciary report. */
  exportFiduciaryReportV2: FileDownloadToken;
  exportHousehold: Scalars['String']['output'];
  /** Returns a reference to a file containing basic household and entity information, as well as details of linked accounts */
  exportHouseholdAccounts: File;
  /** exportHouseholdAccountsV2 returns a token that can be used to download the household accounts. */
  exportHouseholdAccountsV2: FileDownloadToken;
  exportLiabilityReport: File;
  /** exportLiabilityReportV2 returns a token that can be used to download the liability report. */
  exportLiabilityReportV2: FileDownloadToken;
  exportLifetimeExclusionEvents: File;
  /** exportLifetimeExclusionEventsV2 returns a token that can be used to download the lifetime exclusion events. */
  exportLifetimeExclusionEventsV2: FileDownloadToken;
  exportMemoPDF: FileDownloadToken;
  exportMemoWord: FileDownloadToken;
  flushAndReloadAddeparClientsAndEntitiesForUser: Scalars['Boolean']['output'];
  /** Generate AI client presentation notes from a document summary for the entity */
  generateEntityNotesFromDocumentSummary: Array<EntityNotes>;
  /** Generates an estate overview for the given household. */
  generateEstateSnapshot: Scalars['Boolean']['output'];
  generateGRATDesignSummaryV2: Document;
  /**
   * DEPRECATED: Use startAIOnboardingWorkflow instead.
   *
   * Starts the AIOnboarding process, which generates knowledge graphs for each
   * given document, and returns the root node that contains the consolidated KG.
   * The root node will contain the status, and will be "complete" when all
   * documents are processed.
   */
  generateKnowledgeGraphFromDocuments: KgRoot;
  generateMemo: WorkflowTracker;
  /**
   * Generate a summary with a custom prompt. Returns true if the workflow was started successfully, false otherwise.
   * The actual summary will be created asynchronously by the workflow
   * and saved to DocumentSummaryPromptTestRun table. There will be an associated WorkflowTracker record.
   */
  generateSummaryWithPrompt: Scalars['Boolean']['output'];
  /** Connects entities with IntegrationIDs for integration_entities of kind CSV_IMPORT */
  importEntityAccountAssociations?: Maybe<CsvAccountImportResponse>;
  importHousehold: Household;
  /**
   * Improves an Estate 360 distribution diagram using the knowledge graph as context.
   * Takes the current mermaid diagram and a prompt, returns an improved mermaid diagram.
   */
  improveEstate360DistributionDiagram: Scalars['String']['output'];
  /**
   * Uses LLM metaprompting to improve a document summarization prompt.
   * Returns an improved prompt string within 10-15 seconds.
   */
  improvePrompt: Scalars['String']['output'];
  ingestValuationsFromCSV?: Maybe<CsvValuationImportResponse>;
  insertIntegrationConfiguration?: Maybe<IntegrationConfiguration>;
  /**
   * Links a KG V2 node to a data model record (Entity, ClientProfile,
   * ClientOrganization, or TestamentaryEntity). The node, the data model
   * record, and the household must all align. Admin only.
   */
  linkKGV2NodeToDataModel: Kgv2Node;
  /**
   * Links a suggestion to a KG V2 node (for ONBOARDING_* suggestions) or statement (for ENTITY_DETAIL suggestions).
   * If no ids are set in linkTo and clearExisting is true, clears all existing KG V2 links.
   * Admin only.
   */
  linkSuggestionWithKGV2NodeOrStatement: AiSuggestion;
  markAllNotificationsRead: Scalars['Int']['output'];
  markNotificationRead: Scalars['Boolean']['output'];
  markNotificationUnread: Scalars['Boolean']['output'];
  /**
   * Rejects an onboarding entity or testamentary entity suggestion and merges
   * its source KG V2 node into the selected existing record's active node.
   * Foundation and donor-advised fund suggestions can target a client organization.
   */
  markSuggestionAsDuplicate: AiSuggestion;
  mergeClientProfiles: ClientProfile;
  mergeEntities: Entity;
  /**
   * Merges the source KG V2 node into the target node within a single
   * household. The source is preserved as a tombstone (state="merged",
   * merged_into=target) for audit; all statements, aliases, data-model
   * resolutions, source documents, and AI suggestion references are
   * re-pointed to the target. Admin only.
   */
  mergeKGV2Nodes: Kgv2Node;
  /**
   * Moves manual assets and/or insurance policies from one entity to another. Returns the new
   * current valuation for each entity (when assets are moved) and the policies created on the
   * destination entity (when policies are moved). Both entities must belong to the same household.
   */
  moveHoldingsBetweenEntities: MoveHoldingsBetweenEntitiesResponse;
  /** Validate draftConfig JSON and replace all element IDs. Does not create or update a Form. */
  normalizeFormDraftConfig: Scalars['Map']['output'];
  /**
   * possibleTaskAssignees is a list of the users on the platform that are eligible to be a task assignee for this household.
   * We use Users rather than Employees because we expect that we will assign collaborators to tasks as well.
   */
  possibleTaskAssigneesV2: UserConnection;
  print: File;
  /** printV2 returns a signed token that can be used to download the print as a PDF file. */
  printV2: FileDownloadToken;
  promoteSuperuser?: Maybe<User>;
  /** Publishes a fresh snapshot of every household in evals.withluminary.dev. Returns a new workflow and eval set ID. */
  publishEvalSet: Scalars['String']['output'];
  publishForm: PublishFormPayload;
  /** Publish a processed draft and atomically retire the version it replaces. */
  publishPlatformDocument: PlatformDocument;
  /** Shares an owned, non-system tenant template with the caller's organization. */
  publishPresentationTemplate: PresentationTemplate;
  publishTenantSlideConfig: TenantSlideConfig;
  queryOrionAccount: OrionQueryResults;
  queryOrionAccountAssets: OrionQueryResults;
  queryOrionAccounts: OrionQueryResults;
  queryOrionClients: OrionQueryResults;
  queryOrionPortfolioGroupAccounts: OrionQueryResults;
  queryOrionPortfolioGroupAssets: OrionQueryResults;
  queryOrionPortfolioGroups: OrionQueryResults;
  queryOrionUserInfo: OrionQueryResults;
  /**
   * Save the caller's rating of a household chat answer. Negative ratings flag
   * its Braintrust trace for review. Notifications and analytics are best effort.
   * Returns the saved feedback ID.
   */
  rateHouseholdChatMessage: Scalars['ID']['output'];
  reInviteTenantUser: User;
  /**
   * Kicks off the HouseholdSuggestionRefreshWorkflow for the given household.
   * Requires edit access to the household.
   */
  refreshHouseholdSuggestions: Scalars['Boolean']['output'];
  /** Refresh integration data for household if the data is stale. */
  refreshIntegrationDataForHousehold: Scalars['Boolean']['output'];
  /**
   * Regenerates AI suggestions for a specific entity by kicking off the
   * AISuggestions V2 regeneration workflow.
   * @deprecated Use regenerateAISuggestionsV2ForTarget instead.
   */
  regenerateAISuggestionsV2: Scalars['Boolean']['output'];
  /**
   * Regenerates AI suggestions for a single target (e.g. entity, testamentary
   * entity). Single-target entry point that supersedes regenerateAISuggestionsV2.
   */
  regenerateAISuggestionsV2ForTarget: Scalars['Boolean']['output'];
  /**
   * Dev-only: deletes every v2 dispositive provision suggestion in the
   * household, then kicks off the v2 regeneration fan-out for each primary
   * grantor's first-death scenario. Fire-and-forget — monitor progress in
   * Temporal. Requires luminary admin.
   */
  regenerateAllDPSuggestionsV2: Scalars['Boolean']['output'];
  /**
   * Triggers KGV2 regeneration for a household. When replaceExistingGraphs is true,
   * the current active graph is archived first so all documents rebuild into a fresh graph.
   * When false, the workflow backfills missing files onto the current active graph.
   */
  regenerateKGForHousehold: Scalars['Boolean']['output'];
  regenerateMemo: WorkflowTracker;
  /** Regenerates a configurable presentation diagram using the household knowledge graph as context. */
  regeneratePresentationDiagram: RegeneratePresentationDiagramPayload;
  /**
   * Removes prior validation-question workflow attempts and answer-derived graph
   * assertions, then regenerates questions from the document-backed graph.
   */
  regenerateValidationQuestions: Scalars['Boolean']['output'];
  /** Rename a diagram, including during generation, without changing its content revision. */
  renameDiagramArtifact: DiagramArtifact;
  reopenFormSubmission: Submission;
  /**
   * requestClientPresentationV2Approval asks users to complete the approval steps
   * that the tenant requires for the presentation, and notifies them. It asks
   * the presentation creator to attest to the presentation unless it is already
   * attested; only the creator can attest. If the tenant also requires approval,
   * it asks each requested approver to approve it. Any user who can see the
   * presentation can call it again until the presentation is approved, for
   * example to add an approver. Each call creates and notifies only the requests
   * that are not already open, so repeating a call changes nothing. Returns a
   * BAD_REQUEST error if the tenant requires no review, if approval is required
   * and requestedApproverIDs is empty, or if a requested approver cannot approve
   * presentations in the household. Returns a CONFLICT error if the presentation
   * is already approved.
   */
  requestClientPresentationV2Approval: ClientPresentationV2;
  /**
   * requestDocumentDownload creates a signed token for downloading a document.
   * The token can be used with the /api/download/document endpoint.
   */
  requestDocumentDownload: DocumentDownloadToken;
  /**
   * requestFileDownload creates a signed token for downloading a file.
   * The token can be used with the /api/download/file endpoint.
   */
  requestFileDownload: FileDownloadToken;
  /** Reset insight summary + consideration text to default values */
  resetEstateInsight: EstateInsight;
  resolveSalesforceHouseholdRecord: IntegrationClient;
  /**
   * Respond to a pending interactive message through its card instead of
   * sending a chat message: SUBMIT answers it, DISMISS declines to engage with
   * it. Routes the authenticated user's response to the workflow waiting on
   * it; while such a message is pending, ordinary sends on the conversation
   * are rejected.
   */
  respondToHouseholdChatMessage: HouseholdRespondToChatMessagePayload;
  /**
   * Restores dismissed missing documents by deleting all missing document overrides for a household.
   * Returns the number of overrides that were deleted.
   */
  restoreDismissedMissingDocuments: Scalars['Int']['output'];
  retirePlatformDocument: PlatformDocument;
  /** Retry processing a draft. Completed OCR rows retain their identifiers. */
  retryPlatformDocument: Scalars['String']['output'];
  revertFormSubmissionAnswer: FormSubmissionAnswerMutationPayload;
  /** Returns true only when deletion or prior absence is confirmed. Unknown outcomes return an error. */
  revokeManagedSFTPPublicKey: Scalars['Boolean']['output'];
  runFormTest: Array<Submission>;
  /**
   * Creates a household with an entity and TE that have AI DP suggestions ready
   * for review.
   */
  seedAIDPSuggestions: SeedAidpSuggestionsOutput;
  /**
   * Creates a household with an entity and TE that have AI DP suggestions for
   * both grantor death events ready for review (DP Forms V2).
   */
  seedAIDPSuggestionsForBothDeathEvents: SeedAidpSuggestionsOutput;
  /** Creates a two-grantor household with some ai onboarding suggestions to review. */
  seedAIOnboardingSuggestions: Household;
  /** Creates and sets up a household with ASSET, LIABILITY, LIFE_INSURANCE suggestions. */
  seedAIOnboardingWithHoldingSuggestions: Household;
  /**
   * Creates a household from a family fixture by uploading that fixture's documents
   * through the real ingestion path, so OCR and paragraph extraction run normally.
   * Seeds the fixture's primary client profiles, which the asset-distribution section
   * needs in order to build a death-order roster.
   *
   * Knowledge-graph extraction is NOT run; trigger it from the app once the documents
   * have finished OCR. This can not be used in prod.
   */
  seedE360FixtureHousehold: SeedE360FixtureHouseholdOutput;
  /** Creates a household with empty ai onboarding suggestions to review. */
  seedEmptyAIOnboardingSuggestions: Household;
  /**
   * Creates a household with an entity and v2 entity detail AI suggestions that
   * include KGV2 graph infrastructure (graph, nodes, statements, evidence).
   * Used for E2E testing of the v2 AI suggestions flow with kgv2 statement provenance.
   */
  seedEntityDetailsSuggestionsV2: Household;
  /**
   * Given an entity id, seed it with some relevant data in order to test the AI
   * suggestions feature on the frontend.
   */
  seedEntityWithAISuggestions: Entity;
  /**
   * AB trust with survivors from https://docs.google.com/spreadsheets/d/1z2CtRcCrNmlutDmXfMjEwDhrwTby6Vb4BzPV6lzvSz8/edit#gid=1047548555
   * This can not be used in prod.
   * Expect this endpoint to be deleted once we ship estate waterfall feature.
   */
  seedEstateWaterfall: Household;
  seedEstateWaterfallSimpleCharity: Household;
  /**
   * SimpleTrustWithBequests from https://docs.google.com/spreadsheets/d/1z2CtRcCrNmlutDmXfMjEwDhrwTby6Vb4BzPV6lzvSz8/edit#gid=1047548555
   * This can not be used in prod.
   * Expect this endpoint to be deleted once we ship estate waterfall feature.
   */
  seedEstateWaterfallSimpleTrustWithBequests: Household;
  /**
   * Creates a household with two documents with annotations, relationship with
   * an entity and AISuggestions, to test the document annotation features.
   */
  seedHouseholdDocumentSuggestions: SeedHouseholdDocumentSuggestionsOutput;
  /** Creates a single-grantor household with some ai onboarding suggestions to review. */
  seedHouseholdWithMinorChild: Household;
  /**
   * Creates a household with a parent trust entity and multiple subtrusts
   * (TestamentaryEntities) with AI suggestions for all subtrust suggestion kinds
   * ready for review. Useful for E2E testing of the subtrust suggestions flow.
   */
  seedHouseholdWithSubtrustSuggestions: SeedSubtrustSuggestionsOutput;
  /** Creates a household with an in progress ai onboarding job. */
  seedInProgressAIOnboardingSuggestions: Household;
  /**
   * seedIntegrationClientsAndEntities seeds integration clients and entities and configures an integration
   * for the provided asset integration to enable e2e tests
   */
  seedIntegrationClientsAndEntities: Scalars['Int']['output'];
  seedIntegrationLogin: Scalars['Boolean']['output'];
  /**
   * Creates a household with KGV2 graph infrastructure (graph, nodes, statements, evidence),
   * and some Onboarding suggestions and default entity Holding suggestions that are ready to review.
   */
  seedKGV2Household: Household;
  /** Creates a household with a document, and seeds a number of notifications */
  seedNotifications: SeedNotificationsOutput;
  /** Creates a two-grantor household AI onboarding suggestions to review, for the onboarding_flow_v2. */
  seedOnboardingFlowV2: Household;
  seedSingleGrantor: Household;
  /** Creates a single-grantor household with some ai onboarding suggestions to review. */
  seedSingleGrantorHouseholdAIOnboardingSuggestions: Household;
  /**
   * Send a message on an already-subscribed household chat conversation.
   * Persists the user turn and starts the per-turn agent workflow.
   */
  sendHouseholdChatMessage: HouseholdSendChatMessagePayload;
  sendSupportUserRequest: Scalars['Boolean']['output'];
  /**
   * sessionHeartbeat updates the session's expiration time.
   * only effective for tenants with inactivity timeouts configured, noop otherwise.
   */
  sessionHeartbeat: SessionHeartbeat;
  setCollaboratorLastViewedAt: Scalars['Boolean']['output'];
  setEmployeeLastViewedAt: Scalars['Boolean']['output'];
  /**
   * Sets lastViewedPresentationApprovalsAt on the current user's employee to the
   * current server time and returns the employee. Presentation approval
   * requests created after this time are new to the employee.
   */
  setEmployeeLastViewedPresentationApprovalsAt: Employee;
  setFeatureFlagStatus: FeatureFlag;
  setFormSubmissionAnswer: FormSubmissionAnswerMutationPayload;
  setFormSubmissionAnswerNodeReferences: FormSubmissionAnswerMutationPayload;
  setFormSubmissionAnswerReferences: FormSubmissionAnswerMutationPayload;
  setFormSubmissionAnswerTree: FormSubmissionAnswerMutationPayload;
  /**
   * Enable or disable customer JIT access for an existing organization.
   * Enabling records the current time; disabling clears jitEnabledAt.
   */
  setLuminaryOrganizationJIT: LuminaryOrganization;
  setSalesforceHouseholdObject: Scalars['Boolean']['output'];
  /**
   * Kicks off the AI Dispositive Provision workflow for the given householdID.
   * Optionally, provide an entityID to only run the workflow for that entity only.
   * If an entityID is not provided, the AsyncJob that is returned tracks the progress
   * of the batch workflow. If an entityID is provided, the AsyncJob tracks the
   * progress of the single entity workflow.
   */
  startAIDispositiveProvisionWorkflow?: Maybe<AsyncJob>;
  /**
   * Kicks off the AI Dispositive Provision workflow for the given entities.
   * This will use the documents in the household that are relevant to the entities.
   * Each entity will have its own AsyncJob created for tracking.
   */
  startAIDispositiveProvisionWorkflowForEntities: Array<AsyncJob>;
  /**
   * Kicks off the AI Dispositive Provision workflow for the given testamentary
   * entities, using the given documents.
   */
  startAIDispositiveProvisionWorkflowForTE: AsyncJob;
  /**
   * Starts the AIOnboarding process, which generates knowledge graphs for each
   * given document, and returns the root node that contains the consolidated KG.
   * The root node will contain the status, and will be "complete" when all
   * documents are processed.
   */
  startAIOnboardingWorkflow: KgRoot;
  startCreatePresentationFromTemplate: StartCreatePresentationFromTemplatePayload;
  /**
   * Start a streaming document question workflow.
   * Creates a conversation (if needed), saves the user message, and kicks off
   * a Temporal workflow to stream the LLM response.
   * Returns a WorkflowTracker that can be used to subscribe to the stream.
   */
  startDocumentQuestionStream: StartDocumentQuestionStreamPayload;
  startFormSubmissionExtraction: Submission;
  /**
   * Prepare a household chat conversation for subscription.
   * Creates a conversation if needed and returns the conversation to subscribe to.
   */
  startHouseholdChatStream: HouseholdStartChatStreamPayload;
  /**
   * Add a comment to the caller's negative rating without flagging the trace again.
   * Returns the saved feedback ID.
   */
  submitHouseholdChatFeedback: Scalars['ID']['output'];
  submitSalesforceExport: SalesforceExportAttempt;
  summarizeDocument: Scalars['Boolean']['output'];
  syncAddeparEntityValuations: Scalars['Boolean']['output'];
  syncAddeparHouseholdSummary: Scalars['Boolean']['output'];
  /** Update whether or not to sync death order notes on the entity for all client profiles across the household */
  syncDeathOrderNotes: Entity;
  /**
   * Syncs a specific integrated cashflow with an external source.
   * This will update the cashflow with fresh data from the integration.
   * NOTE: This uses the calling users credentials to sync the cashflow.
   */
  syncIntegratedCashflow: Scalars['ID']['output'];
  /**
   * Syncs a specific integrated entity with an external source.
   * This will create a new valuation for that entity.
   * NOTE: This uses the calling users credentials to sync the entity.
   */
  syncIntegratedEntity: Scalars['ID']['output'];
  /**
   * Syncs a specific integrated insurance policy with an external source.
   * This will update the insurance policy with fresh data from the integration.
   * NOTE: This uses the calling users credentials to sync the insurance policy.
   */
  syncIntegratedInsurancePolicy: Scalars['ID']['output'];
  /**
   * Syncs a specific integrated liability with an external source.
   * This will update the liability with fresh data from the integration.
   * NOTE: This uses the calling users credentials to sync the liability.
   */
  syncIntegratedLiability: Scalars['ID']['output'];
  /**
   * Syncs a specific integrated person with an external source.
   * This will update the client profile with fresh data from the integration.
   * NOTE: This uses the calling users credentials to sync the person.
   */
  syncIntegratedPerson: Scalars['ID']['output'];
  /**
   * Syncs all integrated entities on the tenant with their external sources.
   * This will create a new valuation for each entity that is synced.
   * NOTE: This uses the integration users credentials to sync the entities.
   */
  syncIntegratedTenantEntities: Scalars['ID']['output'];
  /**
   * Syncs integration clients and entities for the user with the external integration.
   * A user should call this to refresh their list of integration clients and entities.
   * NOTE: This uses the calling users credentials to sync.
   */
  syncIntegrationClientsAndEntities: Scalars['ID']['output'];
  /** Starts the tenant's Snowflake asset synchronization and returns its workflow tracker ID. */
  syncSnowflakeAssets: Scalars['ID']['output'];
  /** Starts the tenant's Snowflake household synchronization and returns its workflow tracker ID. */
  syncSnowflakeHouseholds: Scalars['ID']['output'];
  /** Creates a real advisor profile; does not create its login account. */
  testHargroveCreateAdvisor: HargroveQueryResults;
  /** Creates a real client. Email and SMS invitations require explicit opt-in. */
  testHargroveCreateClient: HargroveQueryResults;
  /** Transcribes one ephemeral audio recording without storing it. */
  transcribeAudio: Scalars['String']['output'];
  triggerDailyEmail: Scalars['Boolean']['output'];
  /** Trigger insights for household */
  triggerInsightsForHousehold: Scalars['Boolean']['output'];
  /** Trigger insights for tenant */
  triggerInsightsForTenant: Scalars['Boolean']['output'];
  /**
   * Unlinks a KG V2 node from a data model record. The node, the data model
   * record, and the household must all align. Admin only.
   */
  unlinkKGV2NodeFromDataModel: Kgv2Node;
  /** Makes an owned tenant template private without deleting its contents. */
  unpublishPresentationTemplate: PresentationTemplate;
  unpublishTenantSlideConfig: TenantSlideConfig;
  updateActiveEstateInsightsPage: ActiveEstateInsightsPage;
  updateAiSuggestion: AiSuggestion;
  updateAssetClass: AssetClass;
  updateAssetClasses: Array<Maybe<AssetClass>>;
  updateAssetValuationV2: AssetValuationV2;
  /**
   * Use this to update all assets from one class to a previous class.
   * Used to remove all assets from association with a given class before deleting it.
   */
  updateAssetsToNewClass: Scalars['Int']['output'];
  updateBalanceSheetBundleConfiguration: BalanceSheetBundleConfiguration;
  updateBalanceSheetCategories: Array<Maybe<BalanceSheetCategory>>;
  updateBalanceSheetCategory: BalanceSheetCategory;
  updateBalanceSheetViewConfiguration: BalanceSheetViewConfiguration;
  updateBeneficiariesBundleConfiguration: BeneficiariesBundleConfiguration;
  updateBeneficiariesTemplateBundleConfiguration: BeneficiariesTemplateBundleConfiguration;
  updateBeneficiaryDesignationGroup: BeneficiaryDesignationGroup;
  updateBeneficiaryPage: BeneficiaryPage;
  updateCashflow: Cashflow;
  updateClientOrganization: ClientOrganization;
  updateClientOrganizations: Array<ClientOrganization>;
  updateClientPresentationV2: ClientPresentationV2;
  updateClientProfile: ClientProfile;
  updateClientProfileAddress: ClientProfile;
  updateClientProfileRelationships: Array<Maybe<ClientProfileRelationship>>;
  updateClientProfiles: Array<Maybe<ClientProfile>>;
  updateCollaborator: Collaborator;
  updateComparedWaterfall: ComparedWaterfall;
  updateCompletedEstateInsightsPage: CompletedEstateInsightsPage;
  updateCoverPageConfiguration: CoverPageConfiguration;
  /**
   * Upserts the cover slide config for the calling tenant or for a specific sub-brand.
   *
   * When `subBrandID` is omitted the tenant-default cover config is upserted.
   * When `subBrandID` is provided the upsert targets that sub-brand's cover
   * config: an existing one is updated in place, or a new one is created and
   * linked to the sub-brand on first call.
   */
  updateCoverSlideConfig: PresentationCoverSlideConfig;
  /** Update an existing diagram after revision and active-generation checks. */
  updateDiagram: DiagramArtifact;
  updateDispositiveProvisionTemplate: DispositiveProvisionTemplate;
  updateDividerBundleConfiguration: DividerBundleConfiguration;
  /**
   * Upserts the divider slide config for the calling tenant or for a specific
   * sub-brand. Behavior mirrors `updateCoverSlideConfig`.
   */
  updateDividerSlideConfig: PresentationCoverSlideConfig;
  updateDividerTemplateBundleConfiguration: DividerTemplateBundleConfiguration;
  updateDocument: Document;
  updateDocumentSummary: DocumentSummary;
  updateDocumentSummaryPage: DocumentSummaryPage;
  updateDocumentSummaryPrompt: DocumentSummaryPrompt;
  updateDocumentSummaryTemplateBundleConfiguration: DocumentSummaryTemplateBundleConfiguration;
  updateDocuments: Array<Document>;
  updateDsuePortability: DsuePortability;
  updateEmployee: Employee;
  updateEntities: Array<Maybe<Entity>>;
  updateEntitiesOverviewBundleConfiguration: EntitiesOverviewBundleConfiguration;
  updateEntitiesOverviewBundleConfigurationEntity: EntitiesOverviewBundleConfigurationEntity;
  updateEntity: Entity;
  /** Update an existing entity diagram */
  updateEntityDiagram: EntityDiagram;
  updateEntityDocumentRelationship: EntityDocumentRelationship;
  /**
   * Updates the suggestion precedence order of SOURCE_DOCUMENT relationships, which
   * is only relevant for entity<->document relationships.
   */
  updateEntityDocumentSuggestionPrecedence: Array<EntityDocumentRelationship>;
  updateEntityGraphView: EntityGraphView;
  updateEntityGraphViewBundleConfiguration: EntityGraphViewBundleConfiguration;
  updateEntityNotes: EntityNotes;
  updateEntitySummaryBundleConfiguration: EntitySummaryBundleConfiguration;
  updateEntitySummaryTemplateBundleConfiguration: EntitySummaryTemplateBundleConfiguration;
  updateEntityTask: EntityTask;
  /** Update EstateInsight */
  updateEstateInsight: EstateInsight;
  /** Move insight bucket from concerns to opportunities or the converse */
  updateEstateInsightBucket: EstateInsight;
  updateEstateInsightsBundleConfiguration: EstateInsightsBundleConfiguration;
  updateEstateTaxScenario: EstateTaxScenario;
  updateEstateWaterfall: EstateWaterfall;
  updateEstateWaterfallVisualizationConfig: EstateWaterfallVisualizationConfig;
  updateEstateWaterfallVisualizationFilter: EstateWaterfallVisualizationFilter;
  updateEstateWaterfalls: Array<Maybe<EstateWaterfall>>;
  updateFamilyTreeBundleConfiguration: FamilyTreeBundleConfiguration;
  /** Update per-node settings for a person in the family tree. */
  updateFamilyTreeNodeSettings: FamilyTreeNodeSettings;
  /** Update family tree settings for a household. Creates configuration if it doesn't exist. */
  updateFamilyTreeSettings: FamilyTreeSettings;
  updateFeatureFlagQueryRule: FeatureFlagQueryRule;
  updateFeatureFlagStatus: FeatureFlag;
  updateForm: Form;
  updateFormSubmissionName: Submission;
  updateGiftingProposal: GiftingProposal;
  updateGiftingProposalScenario: GiftingProposalScenario;
  updateGraphVisualizationGroup: GraphVisualizationGroup;
  updateGrowthProfile: GrowthProfile;
  updateHousehold: Household;
  updateHouseholds: Array<Maybe<Household>>;
  updateHypotheticalClt: HypotheticalClt;
  updateHypotheticalCrt: HypotheticalCrt;
  updateHypotheticalGrat: HypotheticalGrat;
  updateHypotheticalInsurance: HypotheticalInsurance;
  updateHypotheticalSaleLoan: HypotheticalSaleLoan;
  updateHypotheticalTransferAsset: HypotheticalTransferAsset;
  updateHypotheticalTransferFundingSource: HypotheticalTransferFundingSource;
  updateHypotheticalWaterfallDispositiveProvisionTemplate: HypotheticalWaterfallDispositiveProvisionTemplate;
  updateIncomeTaxPaymentConfig: IncomeTaxPaymentConfig;
  updateInsightsTemplateBundleConfiguration: InsightsTemplateBundleConfiguration;
  updateIntegrationConfiguration?: Maybe<IntegrationConfiguration>;
  /**  Updates the KGRoots with the given inputs.  */
  updateKGRoots: Array<KgRoot>;
  updateKgRoot: KgRoot;
  updateLiabilitiesBundleConfiguration: LiabilitiesBundleConfiguration;
  updateLiability: Liability;
  updateLifeInsuranceBundleConfiguration: LifeInsuranceBundleConfiguration;
  updateLifetimeExclusionEvent: LifetimeExclusionEvent;
  updateLoggedTransfer: LoggedTransfer;
  updateMemo: Memo;
  updateMissingDocumentsPage: MissingDocumentsPage;
  updateModelMapping: ModelMapping;
  updateNotificationPreference: NotificationPreference;
  updateOpenaiSdkConfig: OpenaiSdkConfig;
  updateOrganizationApplicationConfiguration: OrganizationApplicationConfiguration;
  updateOrganizationDisclaimerConfiguration: OrganizationDisclaimerConfiguration;
  updateOwnershipStake: OwnershipStake;
  updatePlatformDocument: PlatformDocument;
  updatePresentationAssetDistributionBundleConfiguration: PresentationAssetDistributionBundleConfiguration;
  updatePresentationAssetDistributionItemConfiguration: PresentationAssetDistributionItemConfiguration;
  updatePresentationAssetDistributionItemDetail: PresentationAssetDistributionItemDetail;
  updatePresentationBundle: PresentationBundle;
  updatePresentationBundleCoverPage: PresentationBundleCoverPage;
  updatePresentationBusinessOverviewBundleConfiguration: PresentationBusinessOverviewBundleConfiguration;
  updatePresentationBusinessOverviewBusinessConfiguration: PresentationBusinessOverviewBusinessConfiguration;
  updatePresentationBusinessOverviewItem: PresentationBusinessOverviewItem;
  updatePresentationCoverPage: PresentationCoverPage;
  updatePresentationCustomPage: PresentationCustomPage;
  updatePresentationCustomPageBundleConfiguration: PresentationCustomPageBundleConfiguration;
  updatePresentationDiagramPage: PresentationDiagramPage;
  updatePresentationDocumentsReviewedBundleConfiguration: PresentationDocumentsReviewedBundleConfiguration;
  updatePresentationDocumentsReviewedDocument: PresentationDocumentsReviewedDocument;
  updatePresentationFamilyOverviewBundleConfiguration: PresentationFamilyOverviewBundleConfiguration;
  updatePresentationFamilyOverviewMemberConfiguration: PresentationFamilyOverviewMemberConfiguration;
  updatePresentationHealthcareDirectiveBundleConfiguration: PresentationHealthcareDirectiveBundleConfiguration;
  updatePresentationHealthcareDirectiveClientConfiguration: PresentationHealthcareDirectiveClientConfiguration;
  updatePresentationHealthcareDirectiveItem: PresentationHealthcareDirectiveItem;
  updatePresentationPage: PresentationPage;
  updatePresentationPlanningOpportunitiesBundleConfiguration: PresentationPlanningOpportunitiesBundleConfiguration;
  updatePresentationPlanningOpportunitiesItem: PresentationPlanningOpportunitiesItem;
  updatePresentationPowerOfAttorneyBundleConfiguration: PresentationPowerOfAttorneyBundleConfiguration;
  updatePresentationPowerOfAttorneyClientConfiguration: PresentationPowerOfAttorneyClientConfiguration;
  updatePresentationPowerOfAttorneyItem: PresentationPowerOfAttorneyItem;
  updatePresentationTemplate: PresentationTemplate;
  updatePresentationTemplateBundle: PresentationTemplateBundle;
  updatePresentationTemplateCoverPage: PresentationTemplateCoverPage;
  updatePresentationTemplateCustomPage: PresentationTemplateCustomPage;
  updatePresentationTemplateDiagramPage: PresentationTemplateDiagramPage;
  updatePresentationTemplatePage: PresentationTemplatePage;
  updatePresentationTrustOverviewBundleConfiguration: PresentationTrustOverviewBundleConfiguration;
  updatePresentationTrustOverviewItem: PresentationTrustOverviewItem;
  updatePresentationTrustOverviewTrustConfiguration: PresentationTrustOverviewTrustConfiguration;
  updatePresentationWillBundleConfiguration: PresentationWillBundleConfiguration;
  updatePresentationWillClientConfiguration: PresentationWillClientConfiguration;
  updatePresentationWillItem: PresentationWillItem;
  updateProfessionalTeamRole: ProfessionalTeamRole;
  updateProposalV2: Proposal;
  updateRole: Role;
  updateSSOConnection: SsoConnection;
  updateSubBrand: SubBrand;
  updateSubBrandDisclaimerConfiguration: SubBrandDisclaimerConfiguration;
  updateTaxDragConfig: TaxDragConfig;
  updateTaxDragOverride: TaxDragOverride;
  updateTeam: Team;
  updateTenant: Tenant;
  updateTenantApplicationConfiguration?: Maybe<TenantApplicationConfiguration>;
  updateTenantBranding: TenantBranding;
  updateTenantDisclaimerConfiguration: TenantDisclaimerConfiguration;
  updateTenantDocument: TenantDocument;
  updateTenantReminderEmailsConfiguration: TenantReminderEmailsConfiguration;
  updateTenantSSOConnection: TenantSsoConnection;
  updateTenantSecurityConfiguration?: Maybe<TenantSecurityConfiguration>;
  updateTenantSlideConfig: TenantSlideConfig;
  updateTestCmkEncryption: TestCmkEncryption;
  updateTestamentaryEntity: TestamentaryEntity;
  updateUserNotificationConfiguration: UserNotificationConfiguration;
  updateWaterfallBundleConfiguration: WaterfallBundleConfiguration;
  updateWaterfallBundleCoverPage: WaterfallBundleCoverPage;
  updateWaterfallComparisonBundleConfiguration: WaterfallComparisonBundleConfiguration;
  updateWaterfallComparisonTemplateBundleConfiguration: WaterfallComparisonTemplateBundleConfiguration;
  updateWaterfallTemplateBundleConfiguration: WaterfallTemplateBundleConfiguration;
  /**
   * Update mutable fields on a WorkOSOrganization. Used to land the WorkOS
   * SSO connection ID and SCIM directory ID after WorkOS-side setup
   * completes.
   */
  updateWorkOSOrganization: WorkOsOrganization;
  /**
   * upgradeWaterfallOverviewBundles sets useUpdatedSummaryPage to true on the waterfall
   * overview bundle configurations in the household. If presentationID is set, only the
   * configurations of that presentation change. Configurations that already use the updated
   * summary page do not change. Returns the IDs of the bundles whose configurations changed.
   * Returns a NOT_FOUND error if the presentation is not in the household.
   */
  upgradeWaterfallOverviewBundles: Array<Scalars['ID']['output']>;
  uploadCSVImportFIle: FileUpload;
  /** uploadCSVImportFileV2 is the same as uploadCSVImportFile, but uses the new filev2 flow. */
  uploadCSVImportFileV2: File;
  /** @deprecated Use uploadFileV2 instead. The presigned-S3 upload path bypasses server-side file validation and is scheduled for removal. */
  uploadFile: FileUpload;
  /** uploadFileV2 uploads a file to the server. */
  uploadFileV2: File;
  /**
   * uploadImage stores a PNG, JPEG, or WebP image of up to 20 MB and returns the
   * stored Image. The server decodes and re-encodes the image, removes metadata
   * such as EXIF GPS positions, and scales it down so that its longest edge is at
   * most 2,750 pixels. Read the stored bytes from /api/images/{id}.
   *
   * HOUSEHOLD images need permission to update the household. Any user of the
   * tenant can upload a TENANT image.
   */
  uploadImage: Image;
  /** Upload global reference material. Only Luminary administrators can upload. */
  uploadPlatformFile: PlatformFile;
  uploadPresentationCoverSlideBackgroundImage: PresentationCoverSlideBackgroundImageUpload;
  uploadTenantBrandingLogo: TenantBrandingLogoUpload;
  upsertAssetToCurrentValuation: Entity;
  verifySalesforce: Scalars['Boolean']['output'];
};


export type MutationDangerous_DeleteTestDataArgs = {
  endTime?: InputMaybe<Scalars['Time']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  tenantID: Scalars['ID']['input'];
};


export type Mutation_DecryptLogValueArgs = {
  input: DecryptLogValueInput;
};


export type MutationAcceptHouseholdAiSuggestionsArgs = {
  input: AcceptHouseholdAiSuggestionsInput;
};


export type MutationAcknowledgeAiSuggestionsArgs = {
  input: Array<AcknowledgeAiSuggestionInput>;
};


export type MutationAddManagedSftpPublicKeyArgs = {
  input: AddManagedSftpPublicKeyInput;
};


export type MutationAddWorkOsOrganizationDomainArgs = {
  input: AddWorkOsOrganizationDomainInput;
};


export type MutationApproveClientPresentationV2Args = {
  presentationID: Scalars['ID']['input'];
};


export type MutationArchiveFormSubmissionArgs = {
  input: ArchiveFormSubmissionInput;
};


export type MutationAskDocumentQuestionArgs = {
  input: AskDocumentQuestionInput;
};


export type MutationAssignEntityTasksToUserArgs = {
  dueDate?: InputMaybe<Scalars['Time']['input']>;
  input: EntityTaskWhereInput;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAsyncBackfillDocumentInferenceMetadataArgs = {
  where: DocumentWhereInput;
};


export type MutationAsyncDocumentOcrBackfillArgs = {
  skipExistingOCR?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAsyncSummarizeDocumentsArgs = {
  input: SummarizeDocumentsInput;
};


export type MutationAutoGroupEstateWaterfallArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBackfillKgv2Args = {
  where: HouseholdWhereInput;
};


export type MutationBatchCreateEntityDiagramArgs = {
  input: BatchCreateEntityDiagramInput;
};


export type MutationBatchUpdateEstateWaterfallArgs = {
  input: BatchUpdateEstateWaterfallInput;
};


export type MutationBatchUpdateGraphVisualizationArgs = {
  input: BatchUpdateGraphVisualizationInput;
};


export type MutationBulkUpsertAssetToCurrentValuationArgs = {
  input: Array<UpsertAssetToCurrentValuationInput>;
};


export type MutationCancelEntityTaskArgs = {
  cancelledReason: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCleanUpSuggestionsForV2MigrationArgs = {
  where: HouseholdWhereInput;
};


export type MutationClearFormSubmissionAnswerArgs = {
  input: ClearFormSubmissionAnswerInput;
};


export type MutationCompleteEntityTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompleteFormSubmissionArgs = {
  input: CompleteFormSubmissionInput;
};


export type MutationCompleteHouseholdOnboardingArgs = {
  householdID: Scalars['ID']['input'];
  presentationTemplateIDs: Array<Scalars['ID']['input']>;
};


export type MutationConvertEntityArgs = {
  entityId: Scalars['ID']['input'];
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationCopyArchetypeHouseholdArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCopyArchetypeHouseholdAsyncArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCopyDocumentSummaryArgs = {
  input: CopyDocumentSummaryInput;
};


export type MutationCopyHouseholdArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCopyHouseholdAsyncArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCopyMemoArgs = {
  input: CopyMemoInput;
};


export type MutationCreateActiveEstateInsightsPageArgs = {
  input: AugmentedCreateActiveEstateInsightsPageInput;
};


export type MutationCreateAiSuggestionArgs = {
  input: AugmentedCreateAiSuggestionInput;
};


export type MutationCreateAssetClassArgs = {
  input: AugmentedCreateAssetClassInput;
};


export type MutationCreateAssetClassesArgs = {
  inputs: Array<InputMaybe<AugmentedCreateAssetClassInput>>;
};


export type MutationCreateAssetValuationV2Args = {
  input: AugmentedCreateAssetValuationV2Input;
};


export type MutationCreateBalanceSheetBundleConfigurationArgs = {
  input: AugmentedCreateBalanceSheetBundleConfigurationInput;
};


export type MutationCreateBalanceSheetCategoriesArgs = {
  inputs: Array<InputMaybe<AugmentedCreateBalanceSheetCategoryInput>>;
};


export type MutationCreateBalanceSheetCategoryArgs = {
  input: AugmentedCreateBalanceSheetCategoryInput;
};


export type MutationCreateBeneficiariesBundleConfigurationArgs = {
  input: AugmentedCreateBeneficiariesBundleConfigurationInput;
};


export type MutationCreateBeneficiariesTemplateBundleConfigurationArgs = {
  input: AugmentedCreateBeneficiariesTemplateBundleConfigurationInput;
};


export type MutationCreateBeneficiaryDesignationGroupArgs = {
  input: AugmentedCreateBeneficiaryDesignationGroupInput;
};


export type MutationCreateBeneficiaryPageArgs = {
  input: AugmentedCreateBeneficiaryPageInput;
};


export type MutationCreateBlankClientPresentationArgs = {
  householdID: Scalars['ID']['input'];
};


export type MutationCreateCashflowArgs = {
  input: AugmentedCreateCashflowInput;
};


export type MutationCreateClientOrganizationArgs = {
  input: AugmentedCreateClientOrganizationInput;
};


export type MutationCreateClientOrganizationsArgs = {
  input: Array<AugmentedCreateClientOrganizationInput>;
};


export type MutationCreateClientPresentationV2Args = {
  input: AugmentedCreateClientPresentationV2Input;
};


export type MutationCreateClientProfileArgs = {
  input: CreateClientProfileWithDetailsInput;
};


export type MutationCreateClientProfilesArgs = {
  input: Array<CreateClientProfileWithDetailsInput>;
};


export type MutationCreateComparedWaterfallArgs = {
  input: AugmentedCreateComparedWaterfallInput;
};


export type MutationCreateCompletedEstateInsightsPageArgs = {
  input: AugmentedCreateCompletedEstateInsightsPageInput;
};


export type MutationCreateCoverPageConfigurationArgs = {
  input: AugmentedCreateCoverPageConfigurationInput;
};


export type MutationCreateDispositiveProvisionTemplateArgs = {
  input: AugmentedCreateDispositiveProvisionTemplateInput;
};


export type MutationCreateDividerBundleConfigurationArgs = {
  input: AugmentedCreateDividerBundleConfigurationInput;
};


export type MutationCreateDividerTemplateBundleConfigurationArgs = {
  input: AugmentedCreateDividerTemplateBundleConfigurationInput;
};


export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationCreateDocumentSummaryArgs = {
  documentID: Scalars['ID']['input'];
  input: CreateDocumentSummaryInput;
};


export type MutationCreateDocumentSummaryPageArgs = {
  input: AugmentedCreateDocumentSummaryPageInput;
};


export type MutationCreateDocumentSummaryPromptArgs = {
  input: AugmentedCreateDocumentSummaryPromptInput;
};


export type MutationCreateDocumentSummaryTemplateBundleConfigurationArgs = {
  input: AugmentedCreateDocumentSummaryTemplateBundleConfigurationInput;
};


export type MutationCreateDocumentWithEntityRelationshipsArgs = {
  input: CreateDocumentWithEntityRelationshipsInput;
};


export type MutationCreateDocumentsArgs = {
  input: Array<CreateDocumentInput>;
};


export type MutationCreateDocumentsWithEntityRelationshipsArgs = {
  autoCreateFromOnboardingSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  input: Array<CreateDocumentWithEntityRelationshipsInput>;
};


export type MutationCreateDsuePortabilityArgs = {
  input: AugmentedCreateDsuePortabilityInput;
};


export type MutationCreateEmployeeArgs = {
  input: CreateEmployeeInput;
};


export type MutationCreateEntitiesArgs = {
  input: Array<InputMaybe<AugmentedCreateEntityInput>>;
  onboarding?: Scalars['Boolean']['input'];
};


export type MutationCreateEntitiesOverviewBundleConfigurationArgs = {
  input: AugmentedCreateEntitiesOverviewBundleConfigurationInput;
};


export type MutationCreateEntitiesOverviewBundleConfigurationEntityArgs = {
  input: AugmentedCreateEntitiesOverviewBundleConfigurationEntityInput;
};


export type MutationCreateEntityArgs = {
  input: AugmentedCreateEntityInput;
};


export type MutationCreateEntityDiagramArgs = {
  input: AugmentedCreateEntityDiagramInput;
};


export type MutationCreateEntityDocumentRelationshipArgs = {
  input: AugmentedCreateEntityDocumentRelationshipInput;
};


export type MutationCreateEntityDocumentRelationshipsArgs = {
  input: Array<CreateEntityDocumentRelationshipInput>;
};


export type MutationCreateEntityGraphViewArgs = {
  input: AugmentedCreateEntityGraphViewInput;
};


export type MutationCreateEntityGraphViewBundleConfigurationArgs = {
  input: AugmentedCreateEntityGraphViewBundleConfigurationInput;
};


export type MutationCreateEntityNotesArgs = {
  input: AugmentedCreateEntityNotesInput;
};


export type MutationCreateEntitySummaryBundleConfigurationArgs = {
  input: AugmentedCreateEntitySummaryBundleConfigurationInput;
};


export type MutationCreateEntitySummaryTemplateBundleConfigurationArgs = {
  input: AugmentedCreateEntitySummaryTemplateBundleConfigurationInput;
};


export type MutationCreateEstateInsightsBundleConfigurationArgs = {
  input: AugmentedCreateEstateInsightsBundleConfigurationInput;
};


export type MutationCreateEstateTaxScenarioArgs = {
  input: AugmentedCreateEstateTaxScenarioInput;
};


export type MutationCreateEstateWaterfallArgs = {
  input: AugmentedCreateEstateWaterfallInput;
  opts?: InputMaybe<CreateEstateWaterfallOptsInput>;
};


export type MutationCreateEstateWaterfallVisualizationConfigArgs = {
  input: AugmentedCreateEstateWaterfallVisualizationConfigInput;
};


export type MutationCreateEstateWaterfallVisualizationFilterArgs = {
  input: AugmentedCreateEstateWaterfallVisualizationFilterInput;
};


export type MutationCreateFamilyTreeBundleConfigurationArgs = {
  input: AugmentedCreateFamilyTreeBundleConfigurationInput;
};


export type MutationCreateFormArgs = {
  input: AugmentedCreateFormInput;
};


export type MutationCreateFormSubmissionArgs = {
  input: CreateFormSubmissionInput;
};


export type MutationCreateFormTestSnapshotArgs = {
  input: CreateFormTestSnapshotInput;
};


export type MutationCreateGraphVisualizationGroupArgs = {
  input: AugmentedCreateGraphVisualizationGroupInput;
};


export type MutationCreateGrowthProfileArgs = {
  input: AugmentedCreateGrowthProfileInput;
};


export type MutationCreateHouseholdArgs = {
  input: CreateHouseholdInput;
  relationshipToBetweenPrimaryClients?: InputMaybe<ClientProfileRelationshipType>;
};


export type MutationCreateHouseholdV2Args = {
  input: AugmentedCreateHouseholdInput;
  relationshipToBetweenPrimaryClients?: InputMaybe<ClientProfileRelationshipType>;
};


export type MutationCreateHouseholdsArgs = {
  inputs: Array<InputMaybe<AugmentedCreateHouseholdInput>>;
};


export type MutationCreateHypotheticalCltArgs = {
  input: AugmentedCreateHypotheticalCltInput;
};


export type MutationCreateHypotheticalCrtArgs = {
  input: AugmentedCreateHypotheticalCrtInput;
};


export type MutationCreateHypotheticalGratArgs = {
  input: AugmentedCreateHypotheticalGratInput;
};


export type MutationCreateHypotheticalInsuranceArgs = {
  input: AugmentedCreateHypotheticalInsuranceInput;
};


export type MutationCreateHypotheticalSaleLoanArgs = {
  input: AugmentedCreateHypotheticalSaleLoanInput;
};


export type MutationCreateHypotheticalTransferAssetArgs = {
  input: AugmentedCreateHypotheticalTransferAssetInput;
};


export type MutationCreateHypotheticalTransferFundingSourceArgs = {
  input: AugmentedCreateHypotheticalTransferFundingSourceInput;
};


export type MutationCreateHypotheticalWaterfallDispositiveProvisionTemplateArgs = {
  input: AugmentedCreateHypotheticalWaterfallDispositiveProvisionTemplateInput;
};


export type MutationCreateIncomeTaxPaymentConfigArgs = {
  input: AugmentedCreateIncomeTaxPaymentConfigInput;
};


export type MutationCreateInsightsTemplateBundleConfigurationArgs = {
  input: AugmentedCreateInsightsTemplateBundleConfigurationInput;
};


export type MutationCreateIntegrationEntitiesForUploadedCsvArgs = {
  entityValuationsFileID: Scalars['ID']['input'];
};


export type MutationCreateKgRootArgs = {
  input: AugmentedCreateKgRootInput;
};


export type MutationCreateLiabilitiesArgs = {
  input: Array<AugmentedCreateLiabilityInput>;
};


export type MutationCreateLiabilitiesBundleConfigurationArgs = {
  input: AugmentedCreateLiabilitiesBundleConfigurationInput;
};


export type MutationCreateLiabilityArgs = {
  input: AugmentedCreateLiabilityInput;
};


export type MutationCreateLifeInsuranceBundleConfigurationArgs = {
  input: AugmentedCreateLifeInsuranceBundleConfigurationInput;
};


export type MutationCreateLifetimeExclusionEventArgs = {
  input: AugmentedCreateLifetimeExclusionEventInput;
};


export type MutationCreateLoggedTransferArgs = {
  input: AugmentedCreateLoggedTransferInput;
};


export type MutationCreateLuminaryOrganizationArgs = {
  input: CreateLuminaryOrganizationInput;
};


export type MutationCreateLuminaryOrganizationMemberTenantArgs = {
  input: CreateLuminaryOrganizationMemberTenantInput;
};


export type MutationCreateMissingDocumentOverrideArgs = {
  input: CreateMissingDocumentOverrideInput;
};


export type MutationCreateMissingDocumentsPageArgs = {
  input: AugmentedCreateMissingDocumentsPageInput;
};


export type MutationCreateModelMappingArgs = {
  input: AugmentedCreateModelMappingInput;
};


export type MutationCreateOpenaiSdkConfigArgs = {
  input: AugmentedCreateOpenaiSdkConfigInput;
};


export type MutationCreateOrganizationDisclaimerConfigurationArgs = {
  input: AugmentedCreateOrganizationDisclaimerConfigurationInput;
};


export type MutationCreateOwnershipStakeArgs = {
  input: AugmentedCreateOwnershipStakeInput;
};


export type MutationCreatePlatformDocumentArgs = {
  input: AugmentedCreatePlatformDocumentInput;
};


export type MutationCreatePresentationAssetDistributionBundleConfigurationArgs = {
  input: AugmentedCreatePresentationAssetDistributionBundleConfigurationInput;
};


export type MutationCreatePresentationAssetDistributionItemConfigurationArgs = {
  input: AugmentedCreatePresentationAssetDistributionItemConfigurationInput;
};


export type MutationCreatePresentationAssetDistributionItemDetailArgs = {
  input: AugmentedCreatePresentationAssetDistributionItemDetailInput;
};


export type MutationCreatePresentationBundleArgs = {
  input: AugmentedCreatePresentationBundleInput;
};


export type MutationCreatePresentationBundleCoverPageArgs = {
  input: AugmentedCreatePresentationBundleCoverPageInput;
};


export type MutationCreatePresentationBusinessOverviewBundleConfigurationArgs = {
  input: AugmentedCreatePresentationBusinessOverviewBundleConfigurationInput;
};


export type MutationCreatePresentationBusinessOverviewBusinessConfigurationArgs = {
  input: AugmentedCreatePresentationBusinessOverviewBusinessConfigurationInput;
};


export type MutationCreatePresentationBusinessOverviewItemArgs = {
  input: AugmentedCreatePresentationBusinessOverviewItemInput;
};


export type MutationCreatePresentationCoverPageArgs = {
  input: AugmentedCreatePresentationCoverPageInput;
};


export type MutationCreatePresentationCustomPageArgs = {
  input: AugmentedCreatePresentationCustomPageInput;
};


export type MutationCreatePresentationCustomPageBundleConfigurationArgs = {
  input: AugmentedCreatePresentationCustomPageBundleConfigurationInput;
};


export type MutationCreatePresentationDiagramPageArgs = {
  input: AugmentedCreatePresentationDiagramPageInput;
};


export type MutationCreatePresentationDocumentsReviewedBundleConfigurationArgs = {
  input: AugmentedCreatePresentationDocumentsReviewedBundleConfigurationInput;
};


export type MutationCreatePresentationDocumentsReviewedDocumentArgs = {
  input: AugmentedCreatePresentationDocumentsReviewedDocumentInput;
};


export type MutationCreatePresentationFamilyOverviewBundleConfigurationArgs = {
  input: AugmentedCreatePresentationFamilyOverviewBundleConfigurationInput;
};


export type MutationCreatePresentationFamilyOverviewMemberConfigurationArgs = {
  input: AugmentedCreatePresentationFamilyOverviewMemberConfigurationInput;
};


export type MutationCreatePresentationHealthcareDirectiveBundleConfigurationArgs = {
  input: AugmentedCreatePresentationHealthcareDirectiveBundleConfigurationInput;
};


export type MutationCreatePresentationHealthcareDirectiveClientConfigurationArgs = {
  input: AugmentedCreatePresentationHealthcareDirectiveClientConfigurationInput;
};


export type MutationCreatePresentationHealthcareDirectiveItemArgs = {
  input: AugmentedCreatePresentationHealthcareDirectiveItemInput;
};


export type MutationCreatePresentationPageArgs = {
  input: AugmentedCreatePresentationPageInput;
};


export type MutationCreatePresentationPlanningOpportunitiesBundleConfigurationArgs = {
  input: AugmentedCreatePresentationPlanningOpportunitiesBundleConfigurationInput;
};


export type MutationCreatePresentationPlanningOpportunitiesItemArgs = {
  input: AugmentedCreatePresentationPlanningOpportunitiesItemInput;
};


export type MutationCreatePresentationPowerOfAttorneyBundleConfigurationArgs = {
  input: AugmentedCreatePresentationPowerOfAttorneyBundleConfigurationInput;
};


export type MutationCreatePresentationPowerOfAttorneyClientConfigurationArgs = {
  input: AugmentedCreatePresentationPowerOfAttorneyClientConfigurationInput;
};


export type MutationCreatePresentationPowerOfAttorneyItemArgs = {
  input: AugmentedCreatePresentationPowerOfAttorneyItemInput;
};


export type MutationCreatePresentationTemplateArgs = {
  input: AugmentedCreatePresentationTemplateInput;
};


export type MutationCreatePresentationTemplateBundleArgs = {
  input: AugmentedCreatePresentationTemplateBundleInput;
};


export type MutationCreatePresentationTemplateCoverPageArgs = {
  input: AugmentedCreatePresentationTemplateCoverPageInput;
};


export type MutationCreatePresentationTemplateCustomPageArgs = {
  input: AugmentedCreatePresentationTemplateCustomPageInput;
};


export type MutationCreatePresentationTemplateDiagramPageArgs = {
  input: AugmentedCreatePresentationTemplateDiagramPageInput;
};


export type MutationCreatePresentationTemplatePageArgs = {
  input: AugmentedCreatePresentationTemplatePageInput;
};


export type MutationCreatePresentationTrustOverviewBundleConfigurationArgs = {
  input: AugmentedCreatePresentationTrustOverviewBundleConfigurationInput;
};


export type MutationCreatePresentationTrustOverviewItemArgs = {
  input: AugmentedCreatePresentationTrustOverviewItemInput;
};


export type MutationCreatePresentationTrustOverviewTrustConfigurationArgs = {
  input: AugmentedCreatePresentationTrustOverviewTrustConfigurationInput;
};


export type MutationCreatePresentationWillBundleConfigurationArgs = {
  input: AugmentedCreatePresentationWillBundleConfigurationInput;
};


export type MutationCreatePresentationWillClientConfigurationArgs = {
  input: AugmentedCreatePresentationWillClientConfigurationInput;
};


export type MutationCreatePresentationWillItemArgs = {
  input: AugmentedCreatePresentationWillItemInput;
};


export type MutationCreateProfessionalTeamRoleArgs = {
  input: AugmentedCreateProfessionalTeamRoleInput;
};


export type MutationCreateProposalSharingTokenArgs = {
  proposalID: Scalars['ID']['input'];
};


export type MutationCreateProposalV2Args = {
  input: AugmentedCreateProposalInput;
};


export type MutationCreateRoleArgs = {
  input: AugmentedCreateRoleInput;
};


export type MutationCreateSsoConnectionArgs = {
  input: AugmentedCreateSsoConnectionInput;
};


export type MutationCreateSubBrandArgs = {
  input: AugmentedCreateSubBrandInput;
};


export type MutationCreateSubBrandDisclaimerConfigurationArgs = {
  input: AugmentedCreateSubBrandDisclaimerConfigurationInput;
};


export type MutationCreateTaxDragConfigArgs = {
  input: AugmentedCreateTaxDragConfigInput;
};


export type MutationCreateTaxDragOverrideArgs = {
  input: AugmentedCreateTaxDragOverrideInput;
};


export type MutationCreateTeamArgs = {
  input: AugmentedCreateTeamInput;
};


export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};


export type MutationCreateTenantDocumentArgs = {
  input: AugmentedCreateTenantDocumentInput;
};


export type MutationCreateTenantSsoConnectionArgs = {
  input: AugmentedCreateTenantSsoConnectionInput;
};


export type MutationCreateTenantSlideConfigArgs = {
  input: AugmentedCreateTenantSlideConfigInput;
};


export type MutationCreateTenantUserv2Args = {
  input: ExtendedCreateUserInput;
};


export type MutationCreateTestCmkEncryptionArgs = {
  input: AugmentedCreateTestCmkEncryptionInput;
};


export type MutationCreateTestamentaryEntitiesArgs = {
  input: Array<AugmentedCreateTestamentaryEntityInput>;
};


export type MutationCreateTestamentaryEntityArgs = {
  input: AugmentedCreateTestamentaryEntityInput;
};


export type MutationCreateUserFeedbackArgs = {
  input: CreateUserFeedbackInput;
};


export type MutationCreateUserNotificationConfigurationArgs = {
  input: AugmentedCreateUserNotificationConfigurationInput;
};


export type MutationCreateWaterfallBundleConfigurationArgs = {
  input: AugmentedCreateWaterfallBundleConfigurationInput;
};


export type MutationCreateWaterfallBundleCoverPageArgs = {
  input: AugmentedCreateWaterfallBundleCoverPageInput;
};


export type MutationCreateWaterfallComparisonBundleConfigurationArgs = {
  input: AugmentedCreateWaterfallComparisonBundleConfigurationInput;
};


export type MutationCreateWaterfallComparisonTemplateBundleConfigurationArgs = {
  input: AugmentedCreateWaterfallComparisonTemplateBundleConfigurationInput;
};


export type MutationCreateWaterfallTemplateBundleConfigurationArgs = {
  input: AugmentedCreateWaterfallTemplateBundleConfigurationInput;
};


export type MutationCrossTenantCopyHouseholdArgs = {
  input: CrossTenantCopyHouseholdInput;
};


export type MutationDeleteAssetClassArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAssetValuationv2Args = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBalanceSheetCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCashflowsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteClientOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientPresentationV2Args = {
  clientID: Scalars['ID']['input'];
  presentationID: Scalars['ID']['input'];
};


export type MutationDeleteClientProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientProfilesDsueArgs = {
  profileIDs: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCollaboratorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDispositionScenarioArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDispositiveProvisionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDispositiveProvisionTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentSummaryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentSummaryPromptArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteDsuePortabilityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEntitiesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteEntityDiagramArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEntityDocumentRelationshipsArgs = {
  input: Array<DeleteEntityDocumentRelationshipInput>;
};


export type MutationDeleteEntityGraphViewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEstateWaterfallArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEstateWaterfallHypotheticalTransfersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteEstateWaterfallVisualizationFilterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeatureFlagQueryRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGraphVisualizationGroupsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteGrowthProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHouseholdChatConversationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHouseholdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteHypotheticalClTsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteHypotheticalCrTsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteHypotheticalGraTsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteHypotheticalInsurancesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteHypotheticalSaleLoanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteKgv2NodesArgs = {
  input: DeleteKgv2NodesInput;
};


export type MutationDeleteLiabilityArgs = {
  liabilityId: Scalars['ID']['input'];
};


export type MutationDeleteLifetimeExclusionEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLoggedTransferArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMemoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePlatformDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePresentationTemplateArgs = {
  templateID: Scalars['ID']['input'];
};


export type MutationDeleteProposalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubBrandArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTenantArgs = {
  input: DeleteTenantInput;
};


export type MutationDeleteTenantSsoConnectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTenantSlideConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTenantUserArgs = {
  email: Scalars['String']['input'];
};


export type MutationDeleteTestamentaryEntityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkOsOrganizationDomainArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDemoteSuperuserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDismissNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDismissWorkflowTrackerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDownloadBalanceSheetExcelArgs = {
  householdID: Scalars['ID']['input'];
};


export type MutationDownloadBalanceSheetExcelV2Args = {
  householdID: Scalars['ID']['input'];
};


export type MutationDownloadEntityBreakdownExcelArgs = {
  estateWaterfallID: Scalars['ID']['input'];
  input?: InputMaybe<EstateWaterfallProjectionInput>;
};


export type MutationDownloadEntityBreakdownExcelV2Args = {
  estateWaterfallID: Scalars['ID']['input'];
  input?: InputMaybe<EstateWaterfallProjectionInput>;
};


export type MutationDuplicateCashflowArgs = {
  cashflowID: Scalars['ID']['input'];
};


export type MutationDuplicateClientPresentationV2Args = {
  presentationID: Scalars['ID']['input'];
};


export type MutationDuplicateEntityArgs = {
  entityId: Scalars['ID']['input'];
};


export type MutationDuplicateEstateWaterfallArgs = {
  input: DuplicateEstateWaterfallInput;
  opts?: InputMaybe<DuplicateEstateWaterfallOptsInput>;
};


export type MutationDuplicateEstateWaterfallHypotheticalTransferArgs = {
  input: DuplicateEstateWaterfallHypotheticalTransferInput;
};


export type MutationDuplicatePresentationTemplateArgs = {
  templateID: Scalars['ID']['input'];
  type?: InputMaybe<PresentationTemplateType>;
};


export type MutationDuplicateProposalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateTestamentaryEntityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnqueueDocumentSummaryPrintJobArgs = {
  input: PrintDocumentSummaryInput;
};


export type MutationEnqueueDocumentSummaryWordExportArgs = {
  input: ExportDocumentSummaryWordInput;
};


export type MutationEnqueueFormSubmissionWordExportArgs = {
  input: ExportFormSubmissionWordInput;
};


export type MutationEnqueueMemoExportJobArgs = {
  input: PrintMemoInput;
};


export type MutationEnqueueMemoWordExportArgs = {
  input: ExportMemoWordInput;
};


export type MutationEnqueuePresentationExportArgs = {
  input: PrintPresentationInput;
};


export type MutationEnqueuePresentationPrintJobArgs = {
  input: PrintPresentationInput;
};


export type MutationEnqueuePresentationPrintJobV2Args = {
  input: PrintPresentationInput;
};


export type MutationEnqueueProposalPresentationPrintJobArgs = {
  input: PrintProposalInput;
};


export type MutationEnqueueProposalPresentationPrintJobV2Args = {
  input: PrintProposalInput;
};


export type MutationExportEntityReportArgs = {
  householdID: Scalars['ID']['input'];
  options: EntityReportOptions;
};


export type MutationExportEntityReportV2Args = {
  householdID: Scalars['ID']['input'];
  options: EntityReportOptions;
};


export type MutationExportFiduciaryReportArgs = {
  householdID: Scalars['ID']['input'];
};


export type MutationExportFiduciaryReportV2Args = {
  householdID: Scalars['ID']['input'];
};


export type MutationExportHouseholdArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExportLiabilityReportArgs = {
  householdID: Scalars['ID']['input'];
};


export type MutationExportLiabilityReportV2Args = {
  householdID: Scalars['ID']['input'];
};


export type MutationExportLifetimeExclusionEventsArgs = {
  householdID: Scalars['ID']['input'];
  where?: InputMaybe<LifetimeExclusionEventWhereInput>;
};


export type MutationExportLifetimeExclusionEventsV2Args = {
  householdID: Scalars['ID']['input'];
  where?: InputMaybe<LifetimeExclusionEventWhereInput>;
};


export type MutationExportMemoPdfArgs = {
  memoID: Scalars['ID']['input'];
};


export type MutationExportMemoWordArgs = {
  memoID: Scalars['ID']['input'];
};


export type MutationGenerateEntityNotesFromDocumentSummaryArgs = {
  input: CreateEntityNotesFromDocumentSummaryInput;
};


export type MutationGenerateEstateSnapshotArgs = {
  documentIDs: Array<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
};


export type MutationGenerateGratDesignSummaryV2Args = {
  entityID: Scalars['ID']['input'];
};


export type MutationGenerateKnowledgeGraphFromDocumentsArgs = {
  input: GenerateKnowledgeGraphInput;
};


export type MutationGenerateMemoArgs = {
  input: GenerateMemoInput;
};


export type MutationGenerateSummaryWithPromptArgs = {
  documentID: Scalars['ID']['input'];
  documentSummaryPromptID: Scalars['ID']['input'];
  promptMarkdown: Scalars['String']['input'];
};


export type MutationImportEntityAccountAssociationsArgs = {
  fileID: Scalars['ID']['input'];
};


export type MutationImportHouseholdArgs = {
  data: Scalars['String']['input'];
};


export type MutationImproveEstate360DistributionDiagramArgs = {
  input: ImproveEstate360DistributionDiagramInput;
};


export type MutationImprovePromptArgs = {
  input: ImprovePromptInput;
};


export type MutationIngestValuationsFromCsvArgs = {
  entityValuationsFileID: Scalars['ID']['input'];
};


export type MutationInsertIntegrationConfigurationArgs = {
  input: AugmentedCreateIntegrationConfigurationInput;
};


export type MutationLinkKgv2NodeToDataModelArgs = {
  input: LinkKgv2NodeToDataModelInput;
};


export type MutationLinkSuggestionWithKgv2NodeOrStatementArgs = {
  input: LinkSuggestionWithKgv2NodeOrStatementInput;
};


export type MutationMarkNotificationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkNotificationUnreadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkSuggestionAsDuplicateArgs = {
  input: MarkSuggestionAsDuplicateInput;
};


export type MutationMergeClientProfilesArgs = {
  input: MergeClientProfilesInput;
};


export type MutationMergeEntitiesArgs = {
  input: MergeEntitiesInput;
};


export type MutationMergeKgv2NodesArgs = {
  input: MergeKgv2NodesInput;
};


export type MutationMoveHoldingsBetweenEntitiesArgs = {
  input: MoveHoldingsBetweenEntitiesInput;
};


export type MutationNormalizeFormDraftConfigArgs = {
  json: Scalars['String']['input'];
};


export type MutationPossibleTaskAssigneesV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type MutationPrintArgs = {
  input: PrintInput;
};


export type MutationPrintV2Args = {
  input: PrintInput;
};


export type MutationPromoteSuperuserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPublishFormArgs = {
  input: PublishFormInput;
};


export type MutationPublishPlatformDocumentArgs = {
  id: Scalars['ID']['input'];
  replacesID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationPublishPresentationTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPublishTenantSlideConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationQueryOrionAccountArgs = {
  accountID: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationQueryOrionAccountAssetsArgs = {
  accountID: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationQueryOrionAccountsArgs = {
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationQueryOrionClientsArgs = {
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationQueryOrionPortfolioGroupAccountsArgs = {
  portfolioGroupID: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationQueryOrionPortfolioGroupAssetsArgs = {
  portfolioGroupID: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationQueryOrionPortfolioGroupsArgs = {
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationQueryOrionUserInfoArgs = {
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRateHouseholdChatMessageArgs = {
  messageID: Scalars['ID']['input'];
  rating: HouseholdChatFeedbackRating;
};


export type MutationReInviteTenantUserArgs = {
  email: Scalars['String']['input'];
};


export type MutationRefreshHouseholdSuggestionsArgs = {
  input: RefreshHouseholdSuggestionsInput;
};


export type MutationRefreshIntegrationDataForHouseholdArgs = {
  force?: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRegenerateAiSuggestionsV2Args = {
  input: RegenerateAiSuggestionsV2Input;
};


export type MutationRegenerateAiSuggestionsV2ForTargetArgs = {
  input: RegenerateAiSuggestionsV2ForTargetInput;
};


export type MutationRegenerateAllDpSuggestionsV2Args = {
  input: RegenerateAllDpSuggestionsV2Input;
};


export type MutationRegenerateKgForHouseholdArgs = {
  householdID: Scalars['ID']['input'];
  replaceExistingGraphs?: Scalars['Boolean']['input'];
};


export type MutationRegenerateMemoArgs = {
  input: RegenerateMemoInput;
};


export type MutationRegeneratePresentationDiagramArgs = {
  input: RegeneratePresentationDiagramInput;
};


export type MutationRegenerateValidationQuestionsArgs = {
  householdID: Scalars['ID']['input'];
};


export type MutationRenameDiagramArtifactArgs = {
  input: RenameDiagramArtifactInput;
};


export type MutationReopenFormSubmissionArgs = {
  input: ReopenFormSubmissionInput;
};


export type MutationRequestClientPresentationV2ApprovalArgs = {
  input: RequestClientPresentationV2ApprovalInput;
};


export type MutationRequestDocumentDownloadArgs = {
  documentID: Scalars['ID']['input'];
};


export type MutationRequestFileDownloadArgs = {
  fileID: Scalars['ID']['input'];
};


export type MutationResetEstateInsightArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResolveSalesforceHouseholdRecordArgs = {
  householdID: Scalars['ID']['input'];
  recordID: Scalars['String']['input'];
};


export type MutationRespondToHouseholdChatMessageArgs = {
  input: HouseholdRespondToChatMessageInput;
};


export type MutationRestoreDismissedMissingDocumentsArgs = {
  householdID: Scalars['ID']['input'];
};


export type MutationRetirePlatformDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryPlatformDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevertFormSubmissionAnswerArgs = {
  input: RevertFormSubmissionAnswerInput;
};


export type MutationRevokeManagedSftpPublicKeyArgs = {
  input: RevokeManagedSftpPublicKeyInput;
};


export type MutationRunFormTestArgs = {
  input: RunFormTestInput;
};


export type MutationSeedE360FixtureHouseholdArgs = {
  input: SeedE360FixtureHouseholdInput;
};


export type MutationSeedEntityWithAiSuggestionsArgs = {
  input: SeedEntityWithAiSuggestionsInput;
};


export type MutationSeedIntegrationClientsAndEntitiesArgs = {
  input?: InputMaybe<SeedIntegrationClientsAndEntitiesInput>;
};


export type MutationSeedIntegrationLoginArgs = {
  input?: InputMaybe<SeedIntegrationLoginInput>;
};


export type MutationSendHouseholdChatMessageArgs = {
  input: HouseholdSendChatMessageInput;
};


export type MutationSendSupportUserRequestArgs = {
  input: SendSupportUserRequestInput;
};


export type MutationSetCollaboratorLastViewedAtArgs = {
  lastViewedAt: Scalars['Time']['input'];
};


export type MutationSetEmployeeLastViewedAtArgs = {
  lastViewedAt: Scalars['Time']['input'];
};


export type MutationSetFeatureFlagStatusArgs = {
  name: Scalars['String']['input'];
  releaseGroupId?: InputMaybe<Scalars['ID']['input']>;
  status: FlagEnablementStatus;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetFormSubmissionAnswerArgs = {
  input: SetFormSubmissionAnswerInput;
};


export type MutationSetFormSubmissionAnswerNodeReferencesArgs = {
  input: SetFormSubmissionAnswerNodeReferencesInput;
};


export type MutationSetFormSubmissionAnswerReferencesArgs = {
  input: SetFormSubmissionAnswerReferencesInput;
};


export type MutationSetFormSubmissionAnswerTreeArgs = {
  input: SetFormSubmissionAnswerTreeInput;
};


export type MutationSetLuminaryOrganizationJitArgs = {
  input: SetLuminaryOrganizationJitInput;
};


export type MutationSetSalesforceHouseholdObjectArgs = {
  object: Scalars['String']['input'];
};


export type MutationStartAiDispositiveProvisionWorkflowArgs = {
  input?: InputMaybe<StartAiDispositiveProvisionWorkflowInput>;
};


export type MutationStartAiDispositiveProvisionWorkflowForEntitiesArgs = {
  input?: InputMaybe<StartAiDispositiveProvisionWorkflowInputForEntitiesInput>;
};


export type MutationStartAiDispositiveProvisionWorkflowForTeArgs = {
  input?: InputMaybe<StartAiDispositiveProvisionWorkflowForTeInput>;
};


export type MutationStartAiOnboardingWorkflowArgs = {
  input: StartAiOnboardingWorkflowInput;
};


export type MutationStartCreatePresentationFromTemplateArgs = {
  householdID: Scalars['ID']['input'];
  templateID: Scalars['ID']['input'];
};


export type MutationStartDocumentQuestionStreamArgs = {
  input: AskDocumentQuestionInput;
};


export type MutationStartFormSubmissionExtractionArgs = {
  input: StartFormSubmissionExtractionInput;
};


export type MutationStartHouseholdChatStreamArgs = {
  input: HouseholdStartChatStreamInput;
};


export type MutationSubmitHouseholdChatFeedbackArgs = {
  feedback: Scalars['String']['input'];
  messageID: Scalars['ID']['input'];
};


export type MutationSubmitSalesforceExportArgs = {
  destination: SalesforceExportDestinationInput;
  householdID: Scalars['ID']['input'];
  submissionID: Scalars['ID']['input'];
};


export type MutationSummarizeDocumentArgs = {
  input: SummarizeDocumentInput;
};


export type MutationSyncDeathOrderNotesArgs = {
  input: SyncDeathOrderNotesInput;
};


export type MutationSyncIntegratedCashflowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSyncIntegratedEntityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSyncIntegratedInsurancePolicyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSyncIntegratedLiabilityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSyncIntegratedPersonArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSyncIntegrationClientsAndEntitiesArgs = {
  kind?: InputMaybe<IntegrationProvider>;
};


export type MutationTestHargroveCreateAdvisorArgs = {
  input: HargroveAdvisorInput;
};


export type MutationTestHargroveCreateClientArgs = {
  input: HargroveClientInput;
};


export type MutationTranscribeAudioArgs = {
  upload: Scalars['Upload']['input'];
};


export type MutationTriggerDailyEmailArgs = {
  userID: Scalars['ID']['input'];
};


export type MutationTriggerInsightsForHouseholdArgs = {
  id: Scalars['ID']['input'];
  input: TriggerEstateInsightsForHouseholdInput;
};


export type MutationTriggerInsightsForTenantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnlinkKgv2NodeFromDataModelArgs = {
  input: UnlinkKgv2NodeFromDataModelInput;
};


export type MutationUnpublishPresentationTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnpublishTenantSlideConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateActiveEstateInsightsPageArgs = {
  input: AugmentedUpdateActiveEstateInsightsPageInput;
};


export type MutationUpdateAiSuggestionArgs = {
  input: AugmentedUpdateAiSuggestionInput;
};


export type MutationUpdateAssetClassArgs = {
  input: AugmentedUpdateAssetClassInput;
};


export type MutationUpdateAssetClassesArgs = {
  inputs: Array<InputMaybe<AugmentedUpdateAssetClassInput>>;
};


export type MutationUpdateAssetValuationV2Args = {
  input: AugmentedUpdateAssetValuationV2Input;
};


export type MutationUpdateAssetsToNewClassArgs = {
  newCategoryID: Scalars['ID']['input'];
  previousCategoryID: Scalars['ID']['input'];
};


export type MutationUpdateBalanceSheetBundleConfigurationArgs = {
  input: AugmentedUpdateBalanceSheetBundleConfigurationInput;
};


export type MutationUpdateBalanceSheetCategoriesArgs = {
  inputs: Array<InputMaybe<AugmentedUpdateBalanceSheetCategoryInput>>;
};


export type MutationUpdateBalanceSheetCategoryArgs = {
  input: AugmentedUpdateBalanceSheetCategoryInput;
};


export type MutationUpdateBalanceSheetViewConfigurationArgs = {
  input: AugmentedUpdateBalanceSheetViewConfigurationInput;
};


export type MutationUpdateBeneficiariesBundleConfigurationArgs = {
  input: AugmentedUpdateBeneficiariesBundleConfigurationInput;
};


export type MutationUpdateBeneficiariesTemplateBundleConfigurationArgs = {
  input: AugmentedUpdateBeneficiariesTemplateBundleConfigurationInput;
};


export type MutationUpdateBeneficiaryDesignationGroupArgs = {
  input: AugmentedUpdateBeneficiaryDesignationGroupInput;
};


export type MutationUpdateBeneficiaryPageArgs = {
  input: AugmentedUpdateBeneficiaryPageInput;
};


export type MutationUpdateCashflowArgs = {
  input: AugmentedUpdateCashflowInput;
};


export type MutationUpdateClientOrganizationArgs = {
  input: AugmentedUpdateClientOrganizationInput;
};


export type MutationUpdateClientOrganizationsArgs = {
  inputs: Array<AugmentedUpdateClientOrganizationInput>;
};


export type MutationUpdateClientPresentationV2Args = {
  input: AugmentedUpdateClientPresentationV2Input;
};


export type MutationUpdateClientProfileArgs = {
  id: Scalars['ID']['input'];
  input: UpdateClientProfileInput;
};


export type MutationUpdateClientProfileAddressArgs = {
  id: Scalars['ID']['input'];
  input: UpdateClientProfileAddressInput;
};


export type MutationUpdateClientProfileRelationshipsArgs = {
  householdId: Scalars['ID']['input'];
  updateRelationships?: InputMaybe<Array<UpdateClientProfileRelationship>>;
};


export type MutationUpdateClientProfilesArgs = {
  householdId: Scalars['ID']['input'];
  inputs: Array<InputMaybe<AugmentedUpdateClientProfileInput>>;
};


export type MutationUpdateCollaboratorArgs = {
  input: UpdateCollaboratorByIdInput;
};


export type MutationUpdateComparedWaterfallArgs = {
  input: AugmentedUpdateComparedWaterfallInput;
};


export type MutationUpdateCompletedEstateInsightsPageArgs = {
  input: AugmentedUpdateCompletedEstateInsightsPageInput;
};


export type MutationUpdateCoverPageConfigurationArgs = {
  input: AugmentedUpdateCoverPageConfigurationInput;
};


export type MutationUpdateCoverSlideConfigArgs = {
  input: UpdatePresentationCoverSlideConfigInput;
  subBrandID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateDiagramArgs = {
  input: UpdateDiagramInput;
};


export type MutationUpdateDispositiveProvisionTemplateArgs = {
  input: AugmentedUpdateDispositiveProvisionTemplateInput;
};


export type MutationUpdateDividerBundleConfigurationArgs = {
  input: AugmentedUpdateDividerBundleConfigurationInput;
};


export type MutationUpdateDividerSlideConfigArgs = {
  input: UpdatePresentationCoverSlideConfigInput;
  subBrandID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateDividerTemplateBundleConfigurationArgs = {
  input: AugmentedUpdateDividerTemplateBundleConfigurationInput;
};


export type MutationUpdateDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDocumentInput;
};


export type MutationUpdateDocumentSummaryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDocumentSummaryInput;
};


export type MutationUpdateDocumentSummaryPageArgs = {
  input: AugmentedUpdateDocumentSummaryPageInput;
};


export type MutationUpdateDocumentSummaryPromptArgs = {
  input: AugmentedUpdateDocumentSummaryPromptInput;
};


export type MutationUpdateDocumentSummaryTemplateBundleConfigurationArgs = {
  input: AugmentedUpdateDocumentSummaryTemplateBundleConfigurationInput;
};


export type MutationUpdateDocumentsArgs = {
  input: Array<AugmentedUpdateDocumentInput>;
};


export type MutationUpdateDsuePortabilityArgs = {
  input: AugmentedUpdateDsuePortabilityInput;
};


export type MutationUpdateEmployeeArgs = {
  input: UpdateEmployeeInput;
};


export type MutationUpdateEntitiesArgs = {
  input: Array<InputMaybe<AugmentedUpdateEntityInput>>;
};


export type MutationUpdateEntitiesOverviewBundleConfigurationArgs = {
  input: AugmentedUpdateEntitiesOverviewBundleConfigurationInput;
};


export type MutationUpdateEntitiesOverviewBundleConfigurationEntityArgs = {
  input: AugmentedUpdateEntitiesOverviewBundleConfigurationEntityInput;
};


export type MutationUpdateEntityArgs = {
  input: AugmentedUpdateEntityInput;
};


export type MutationUpdateEntityDiagramArgs = {
  input: AugmentedUpdateEntityDiagramInput;
};


export type MutationUpdateEntityDocumentRelationshipArgs = {
  input: AugmentedUpdateEntityDocumentRelationshipInput;
};


export type MutationUpdateEntityDocumentSuggestionPrecedenceArgs = {
  input: Array<UpdateEntityDocumentSuggestionPrecedenceInput>;
};


export type MutationUpdateEntityGraphViewArgs = {
  input: AugmentedUpdateEntityGraphViewInput;
};


export type MutationUpdateEntityGraphViewBundleConfigurationArgs = {
  input: AugmentedUpdateEntityGraphViewBundleConfigurationInput;
};


export type MutationUpdateEntityNotesArgs = {
  input: AugmentedUpdateEntityNotesInput;
};


export type MutationUpdateEntitySummaryBundleConfigurationArgs = {
  input: AugmentedUpdateEntitySummaryBundleConfigurationInput;
};


export type MutationUpdateEntitySummaryTemplateBundleConfigurationArgs = {
  input: AugmentedUpdateEntitySummaryTemplateBundleConfigurationInput;
};


export type MutationUpdateEntityTaskArgs = {
  input: AugmentedUpdateEntityTaskInput;
};


export type MutationUpdateEstateInsightArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEstateInsightInput;
};


export type MutationUpdateEstateInsightBucketArgs = {
  input: UpdateEstateInsightBucketInput;
};


export type MutationUpdateEstateInsightsBundleConfigurationArgs = {
  input: AugmentedUpdateEstateInsightsBundleConfigurationInput;
};


export type MutationUpdateEstateTaxScenarioArgs = {
  input: AugmentedUpdateEstateTaxScenarioInput;
};


export type MutationUpdateEstateWaterfallArgs = {
  input: AugmentedUpdateEstateWaterfallInput;
};


export type MutationUpdateEstateWaterfallVisualizationConfigArgs = {
  input: AugmentedUpdateEstateWaterfallVisualizationConfigInput;
};


export type MutationUpdateEstateWaterfallVisualizationFilterArgs = {
  input: AugmentedUpdateEstateWaterfallVisualizationFilterInput;
};


export type MutationUpdateEstateWaterfallsArgs = {
  inputs: Array<InputMaybe<AugmentedUpdateEstateWaterfallInput>>;
};


export type MutationUpdateFamilyTreeBundleConfigurationArgs = {
  input: AugmentedUpdateFamilyTreeBundleConfigurationInput;
};


export type MutationUpdateFamilyTreeNodeSettingsArgs = {
  clientProfileId: Scalars['ID']['input'];
  settings: UpdateFamilyTreeNodeSettingsInput;
};


export type MutationUpdateFamilyTreeSettingsArgs = {
  householdId: Scalars['ID']['input'];
  settings: UpdateFamilyTreeSettingsInput;
};


export type MutationUpdateFeatureFlagQueryRuleArgs = {
  flagValue: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationUpdateFeatureFlagStatusArgs = {
  input: UpdateFeatureFlagInput;
  name: Scalars['String']['input'];
};


export type MutationUpdateFormArgs = {
  input: AugmentedUpdateFormInput;
};


export type MutationUpdateFormSubmissionNameArgs = {
  input: UpdateFormSubmissionNameInput;
};


export type MutationUpdateGiftingProposalArgs = {
  input: AugmentedUpdateGiftingProposalInput;
};


export type MutationUpdateGiftingProposalScenarioArgs = {
  input: AugmentedUpdateGiftingProposalScenarioInput;
};


export type MutationUpdateGraphVisualizationGroupArgs = {
  input: AugmentedUpdateGraphVisualizationGroupInput;
};


export type MutationUpdateGrowthProfileArgs = {
  input: AugmentedUpdateGrowthProfileInput;
};


export type MutationUpdateHouseholdArgs = {
  id: Scalars['ID']['input'];
  input: UpdateHouseholdInput;
  relationshipToBetweenPrimaryClients?: InputMaybe<ClientProfileRelationshipType>;
};


export type MutationUpdateHouseholdsArgs = {
  inputs: Array<InputMaybe<AugmentedUpdateHouseholdInput>>;
};


export type MutationUpdateHypotheticalCltArgs = {
  input: AugmentedUpdateHypotheticalCltInput;
};


export type MutationUpdateHypotheticalCrtArgs = {
  input: AugmentedUpdateHypotheticalCrtInput;
};


export type MutationUpdateHypotheticalGratArgs = {
  input: AugmentedUpdateHypotheticalGratInput;
};


export type MutationUpdateHypotheticalInsuranceArgs = {
  input: AugmentedUpdateHypotheticalInsuranceInput;
};


export type MutationUpdateHypotheticalSaleLoanArgs = {
  input: AugmentedUpdateHypotheticalSaleLoanInput;
};


export type MutationUpdateHypotheticalTransferAssetArgs = {
  input: AugmentedUpdateHypotheticalTransferAssetInput;
};


export type MutationUpdateHypotheticalTransferFundingSourceArgs = {
  input: AugmentedUpdateHypotheticalTransferFundingSourceInput;
};


export type MutationUpdateHypotheticalWaterfallDispositiveProvisionTemplateArgs = {
  input: AugmentedUpdateHypotheticalWaterfallDispositiveProvisionTemplateInput;
};


export type MutationUpdateIncomeTaxPaymentConfigArgs = {
  input: AugmentedUpdateIncomeTaxPaymentConfigInput;
};


export type MutationUpdateInsightsTemplateBundleConfigurationArgs = {
  input: AugmentedUpdateInsightsTemplateBundleConfigurationInput;
};


export type MutationUpdateIntegrationConfigurationArgs = {
  input: AugmentedUpdateIntegrationConfigurationInput;
};


export type MutationUpdateKgRootsArgs = {
  inputs: Array<AugmentedUpdateKgRootInput>;
};


export type MutationUpdateKgRootArgs = {
  input: AugmentedUpdateKgRootInput;
};


export type MutationUpdateLiabilitiesBundleConfigurationArgs = {
  input: AugmentedUpdateLiabilitiesBundleConfigurationInput;
};


export type MutationUpdateLiabilityArgs = {
  input: AugmentedUpdateLiabilityInput;
};


export type MutationUpdateLifeInsuranceBundleConfigurationArgs = {
  input: AugmentedUpdateLifeInsuranceBundleConfigurationInput;
};


export type MutationUpdateLifetimeExclusionEventArgs = {
  input: AugmentedUpdateLifetimeExclusionEventInput;
};


export type MutationUpdateLoggedTransferArgs = {
  input: AugmentedUpdateLoggedTransferInput;
};


export type MutationUpdateMemoArgs = {
  input: AugmentedUpdateMemoInput;
};


export type MutationUpdateMissingDocumentsPageArgs = {
  input: AugmentedUpdateMissingDocumentsPageInput;
};


export type MutationUpdateModelMappingArgs = {
  input: AugmentedUpdateModelMappingInput;
};


export type MutationUpdateNotificationPreferenceArgs = {
  input: AugmentedUpdateNotificationPreferenceInput;
};


export type MutationUpdateOpenaiSdkConfigArgs = {
  input: AugmentedUpdateOpenaiSdkConfigInput;
};


export type MutationUpdateOrganizationApplicationConfigurationArgs = {
  input: AugmentedUpdateOrganizationApplicationConfigurationInput;
};


export type MutationUpdateOrganizationDisclaimerConfigurationArgs = {
  input: AugmentedUpdateOrganizationDisclaimerConfigurationInput;
};


export type MutationUpdateOwnershipStakeArgs = {
  input: AugmentedUpdateOwnershipStakeInput;
};


export type MutationUpdatePlatformDocumentArgs = {
  input: AugmentedUpdatePlatformDocumentInput;
};


export type MutationUpdatePresentationAssetDistributionBundleConfigurationArgs = {
  input: AugmentedUpdatePresentationAssetDistributionBundleConfigurationInput;
};


export type MutationUpdatePresentationAssetDistributionItemConfigurationArgs = {
  input: AugmentedUpdatePresentationAssetDistributionItemConfigurationInput;
};


export type MutationUpdatePresentationAssetDistributionItemDetailArgs = {
  input: AugmentedUpdatePresentationAssetDistributionItemDetailInput;
};


export type MutationUpdatePresentationBundleArgs = {
  input: AugmentedUpdatePresentationBundleInput;
};


export type MutationUpdatePresentationBundleCoverPageArgs = {
  input: AugmentedUpdatePresentationBundleCoverPageInput;
};


export type MutationUpdatePresentationBusinessOverviewBundleConfigurationArgs = {
  input: AugmentedUpdatePresentationBusinessOverviewBundleConfigurationInput;
};


export type MutationUpdatePresentationBusinessOverviewBusinessConfigurationArgs = {
  input: AugmentedUpdatePresentationBusinessOverviewBusinessConfigurationInput;
};


export type MutationUpdatePresentationBusinessOverviewItemArgs = {
  input: AugmentedUpdatePresentationBusinessOverviewItemInput;
};


export type MutationUpdatePresentationCoverPageArgs = {
  input: AugmentedUpdatePresentationCoverPageInput;
};


export type MutationUpdatePresentationCustomPageArgs = {
  input: AugmentedUpdatePresentationCustomPageInput;
};


export type MutationUpdatePresentationCustomPageBundleConfigurationArgs = {
  input: AugmentedUpdatePresentationCustomPageBundleConfigurationInput;
};


export type MutationUpdatePresentationDiagramPageArgs = {
  input: AugmentedUpdatePresentationDiagramPageInput;
};


export type MutationUpdatePresentationDocumentsReviewedBundleConfigurationArgs = {
  input: AugmentedUpdatePresentationDocumentsReviewedBundleConfigurationInput;
};


export type MutationUpdatePresentationDocumentsReviewedDocumentArgs = {
  input: AugmentedUpdatePresentationDocumentsReviewedDocumentInput;
};


export type MutationUpdatePresentationFamilyOverviewBundleConfigurationArgs = {
  input: AugmentedUpdatePresentationFamilyOverviewBundleConfigurationInput;
};


export type MutationUpdatePresentationFamilyOverviewMemberConfigurationArgs = {
  input: AugmentedUpdatePresentationFamilyOverviewMemberConfigurationInput;
};


export type MutationUpdatePresentationHealthcareDirectiveBundleConfigurationArgs = {
  input: AugmentedUpdatePresentationHealthcareDirectiveBundleConfigurationInput;
};


export type MutationUpdatePresentationHealthcareDirectiveClientConfigurationArgs = {
  input: AugmentedUpdatePresentationHealthcareDirectiveClientConfigurationInput;
};


export type MutationUpdatePresentationHealthcareDirectiveItemArgs = {
  input: AugmentedUpdatePresentationHealthcareDirectiveItemInput;
};


export type MutationUpdatePresentationPageArgs = {
  input: AugmentedUpdatePresentationPageInput;
};


export type MutationUpdatePresentationPlanningOpportunitiesBundleConfigurationArgs = {
  input: AugmentedUpdatePresentationPlanningOpportunitiesBundleConfigurationInput;
};


export type MutationUpdatePresentationPlanningOpportunitiesItemArgs = {
  input: AugmentedUpdatePresentationPlanningOpportunitiesItemInput;
};


export type MutationUpdatePresentationPowerOfAttorneyBundleConfigurationArgs = {
  input: AugmentedUpdatePresentationPowerOfAttorneyBundleConfigurationInput;
};


export type MutationUpdatePresentationPowerOfAttorneyClientConfigurationArgs = {
  input: AugmentedUpdatePresentationPowerOfAttorneyClientConfigurationInput;
};


export type MutationUpdatePresentationPowerOfAttorneyItemArgs = {
  input: AugmentedUpdatePresentationPowerOfAttorneyItemInput;
};


export type MutationUpdatePresentationTemplateArgs = {
  input: AugmentedUpdatePresentationTemplateInput;
};


export type MutationUpdatePresentationTemplateBundleArgs = {
  input: AugmentedUpdatePresentationTemplateBundleInput;
};


export type MutationUpdatePresentationTemplateCoverPageArgs = {
  input: AugmentedUpdatePresentationTemplateCoverPageInput;
};


export type MutationUpdatePresentationTemplateCustomPageArgs = {
  input: AugmentedUpdatePresentationTemplateCustomPageInput;
};


export type MutationUpdatePresentationTemplateDiagramPageArgs = {
  input: AugmentedUpdatePresentationTemplateDiagramPageInput;
};


export type MutationUpdatePresentationTemplatePageArgs = {
  input: AugmentedUpdatePresentationTemplatePageInput;
};


export type MutationUpdatePresentationTrustOverviewBundleConfigurationArgs = {
  input: AugmentedUpdatePresentationTrustOverviewBundleConfigurationInput;
};


export type MutationUpdatePresentationTrustOverviewItemArgs = {
  input: AugmentedUpdatePresentationTrustOverviewItemInput;
};


export type MutationUpdatePresentationTrustOverviewTrustConfigurationArgs = {
  input: AugmentedUpdatePresentationTrustOverviewTrustConfigurationInput;
};


export type MutationUpdatePresentationWillBundleConfigurationArgs = {
  input: AugmentedUpdatePresentationWillBundleConfigurationInput;
};


export type MutationUpdatePresentationWillClientConfigurationArgs = {
  input: AugmentedUpdatePresentationWillClientConfigurationInput;
};


export type MutationUpdatePresentationWillItemArgs = {
  input: AugmentedUpdatePresentationWillItemInput;
};


export type MutationUpdateProfessionalTeamRoleArgs = {
  input: AugmentedUpdateProfessionalTeamRoleInput;
};


export type MutationUpdateProposalV2Args = {
  input: AugmentedUpdateProposalInput;
};


export type MutationUpdateRoleArgs = {
  input: AugmentedUpdateRoleInput;
};


export type MutationUpdateSsoConnectionArgs = {
  input: AugmentedUpdateSsoConnectionInput;
};


export type MutationUpdateSubBrandArgs = {
  input: AugmentedUpdateSubBrandInput;
};


export type MutationUpdateSubBrandDisclaimerConfigurationArgs = {
  input: AugmentedUpdateSubBrandDisclaimerConfigurationInput;
};


export type MutationUpdateTaxDragConfigArgs = {
  input: AugmentedUpdateTaxDragConfigInput;
};


export type MutationUpdateTaxDragOverrideArgs = {
  input: AugmentedUpdateTaxDragOverrideInput;
};


export type MutationUpdateTeamArgs = {
  input: AugmentedUpdateTeamInput;
};


export type MutationUpdateTenantArgs = {
  input: AugmentedUpdateTenantInput;
};


export type MutationUpdateTenantApplicationConfigurationArgs = {
  input: AugmentedUpdateTenantApplicationConfigurationInput;
};


export type MutationUpdateTenantBrandingArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTenantBrandingInput;
};


export type MutationUpdateTenantDisclaimerConfigurationArgs = {
  input: AugmentedUpdateTenantDisclaimerConfigurationInput;
};


export type MutationUpdateTenantDocumentArgs = {
  input: AugmentedUpdateTenantDocumentInput;
};


export type MutationUpdateTenantReminderEmailsConfigurationArgs = {
  input: AugmentedUpdateTenantReminderEmailsConfigurationInput;
};


export type MutationUpdateTenantSsoConnectionArgs = {
  input: AugmentedUpdateTenantSsoConnectionInput;
};


export type MutationUpdateTenantSecurityConfigurationArgs = {
  input: AugmentedUpdateTenantSecurityConfigurationInput;
};


export type MutationUpdateTenantSlideConfigArgs = {
  input: AugmentedUpdateTenantSlideConfigInput;
};


export type MutationUpdateTestCmkEncryptionArgs = {
  input: AugmentedUpdateTestCmkEncryptionInput;
};


export type MutationUpdateTestamentaryEntityArgs = {
  input: AugmentedUpdateTestamentaryEntityInput;
};


export type MutationUpdateUserNotificationConfigurationArgs = {
  input: AugmentedUpdateUserNotificationConfigurationInput;
};


export type MutationUpdateWaterfallBundleConfigurationArgs = {
  input: AugmentedUpdateWaterfallBundleConfigurationInput;
};


export type MutationUpdateWaterfallBundleCoverPageArgs = {
  input: AugmentedUpdateWaterfallBundleCoverPageInput;
};


export type MutationUpdateWaterfallComparisonBundleConfigurationArgs = {
  input: AugmentedUpdateWaterfallComparisonBundleConfigurationInput;
};


export type MutationUpdateWaterfallComparisonTemplateBundleConfigurationArgs = {
  input: AugmentedUpdateWaterfallComparisonTemplateBundleConfigurationInput;
};


export type MutationUpdateWaterfallTemplateBundleConfigurationArgs = {
  input: AugmentedUpdateWaterfallTemplateBundleConfigurationInput;
};


export type MutationUpdateWorkOsOrganizationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkOsOrganizationInput;
};


export type MutationUpgradeWaterfallOverviewBundlesArgs = {
  householdID: Scalars['ID']['input'];
  presentationID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUploadCsvImportFIleArgs = {
  input: CreateFileInput;
};


export type MutationUploadCsvImportFileV2Args = {
  input: CreateFileInput;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadFileArgs = {
  input: CreateFileInput;
};


export type MutationUploadFileV2Args = {
  input: CreateFileInput;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadImageArgs = {
  input: UploadImageInput;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadPlatformFileArgs = {
  input: CreateFileInput;
  upload: Scalars['Upload']['input'];
};


export type MutationUploadPresentationCoverSlideBackgroundImageArgs = {
  input: CreatePresentationCoverSlideBackgroundImageInput;
};


export type MutationUploadTenantBrandingLogoArgs = {
  input: CreateTenantBrandingLogoInput;
};


export type MutationUpsertAssetToCurrentValuationArgs = {
  entityID: Scalars['ID']['input'];
  input: Array<AugmentedCreateAssetV2Input>;
};

export type Named = {
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum NoDocumentsOnboardingPromptType {
  AbcJointTrust = 'ABC_JOINT_TRUST',
  AbcSeparateTrusts = 'ABC_SEPARATE_TRUSTS',
  AbJointTrust = 'AB_JOINT_TRUST',
  AbSeparateTrusts = 'AB_SEPARATE_TRUSTS',
  EqualShares = 'EQUAL_SHARES',
  FamilyTrust = 'FAMILY_TRUST',
  SpecificBequests = 'SPECIFIC_BEQUESTS',
  SurvivingSpouse = 'SURVIVING_SPOUSE'
}

export type NoPlanProjection = {
  __typename?: 'NoPlanProjection';
  projectedValue: Scalars['CurrencyUSD']['output'];
  yearly: Array<NoPlanProjectionYearly>;
};

export type NoPlanProjectionInput = {
  assetValue: Scalars['CurrencyUSD']['input'];
  costBasis: Scalars['CurrencyUSD']['input'];
  growthRate: Scalars['Percent']['input'];
  ignoreCapitalGainsTax?: InputMaybe<Scalars['Boolean']['input']>;
  taxDrag: Scalars['Percent']['input'];
  termYears: Scalars['Int']['input'];
};

export type NoPlanProjectionYearly = {
  __typename?: 'NoPlanProjectionYearly';
  beginningOfYear: Scalars['CurrencyUSD']['output'];
  endOfYear: Scalars['CurrencyUSD']['output'];
  growth: Scalars['CurrencyUSD']['output'];
  year: Scalars['Int']['output'];
};

/**
 * An object with an ID.
 * Follows the [Relay Global Object Identification Specification](https://relay.dev/graphql/objectidentification.htm)
 */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
};

export type NodeStateInEstateStatus = {
  __typename?: 'NodeStateInEstateStatus';
  inEstateStatus: EntityInEstateStatus;
  nonTaxableValue?: Maybe<Scalars['CurrencyUSD']['output']>;
  state: StateCode;
  taxableValue?: Maybe<Scalars['CurrencyUSD']['output']>;
};

/** NonTrustEntityTaxStatus is enum for the field tax_status */
export enum NonTrustEntityTaxStatus {
  NonTaxable = 'NON_TAXABLE',
  Taxable = 'TAXABLE'
}

export type NotificationApp = Node & {
  __typename?: 'NotificationApp';
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  data?: Maybe<NotificationAppData>;
  hasPriority: Scalars['Boolean']['output'];
  household?: Maybe<Household>;
  /** the household this object belongs to */
  householdID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  kind: NotificationKind;
  readAt?: Maybe<Scalars['Time']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type NotificationAppConnection = {
  __typename?: 'NotificationAppConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotificationAppEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type NotificationAppData = {
  __typename?: 'NotificationAppData';
  actionURL?: Maybe<Scalars['String']['output']>;
  isFailure?: Maybe<Scalars['Boolean']['output']>;
  targetIDs?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An edge in a connection. */
export type NotificationAppEdge = {
  __typename?: 'NotificationAppEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotificationApp>;
};

/** Ordering options for NotificationApp connections */
export type NotificationAppOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotificationApps. */
  field: NotificationAppOrderField;
};

/** Properties by which NotificationApp connections can be ordered. */
export enum NotificationAppOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * NotificationAppWhereInput is used for filtering NotificationApp objects.
 * Input was generated by ent.
 */
export type NotificationAppWhereInput = {
  and?: InputMaybe<Array<NotificationAppWhereInput>>;
  /** content field predicates */
  content?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** has_priority field predicates */
  hasPriority?: InputMaybe<Scalars['Boolean']['input']>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<NotificationKind>;
  kindIn?: InputMaybe<Array<NotificationKind>>;
  kindNEQ?: InputMaybe<NotificationKind>;
  kindNotIn?: InputMaybe<Array<NotificationKind>>;
  not?: InputMaybe<NotificationAppWhereInput>;
  or?: InputMaybe<Array<NotificationAppWhereInput>>;
  /** read_at field predicates */
  readAt?: InputMaybe<Scalars['Time']['input']>;
  readAtGT?: InputMaybe<Scalars['Time']['input']>;
  readAtGTE?: InputMaybe<Scalars['Time']['input']>;
  readAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  readAtLT?: InputMaybe<Scalars['Time']['input']>;
  readAtLTE?: InputMaybe<Scalars['Time']['input']>;
  readAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** NotificationKind is enum for the field kind */
export enum NotificationKind {
  AiSuggestion = 'AI_SUGGESTION',
  AiSuggestionRegen = 'AI_SUGGESTION_REGEN',
  DocumentSummary = 'DOCUMENT_SUMMARY',
  DocumentSummaryExported = 'DOCUMENT_SUMMARY_EXPORTED',
  EstateInsightsGenerated = 'ESTATE_INSIGHTS_GENERATED',
  EstateSnapshotGenerated = 'ESTATE_SNAPSHOT_GENERATED',
  FormExtractionCompleted = 'FORM_EXTRACTION_COMPLETED',
  ManualAiDp = 'MANUAL_AI_DP',
  MemoExported = 'MEMO_EXPORTED',
  MemoGenerated = 'MEMO_GENERATED',
  PresentationApprovalRequested = 'PRESENTATION_APPROVAL_REQUESTED',
  PresentationGenerated = 'PRESENTATION_GENERATED',
  ProposalGenerated = 'PROPOSAL_GENERATED',
  UnmappedIntegrationAssetClasses = 'UNMAPPED_INTEGRATION_ASSET_CLASSES',
  ValidationQuestions = 'VALIDATION_QUESTIONS'
}

export type NotificationPreference = Node & {
  __typename?: 'NotificationPreference';
  appEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  emailEnabled: Scalars['Boolean']['output'];
  emailFrequency: NotificationPreferenceEmailFrequency;
  id: Scalars['ID']['output'];
  kind: NotificationKind;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type NotificationPreferenceConnection = {
  __typename?: 'NotificationPreferenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotificationPreferenceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotificationPreferenceEdge = {
  __typename?: 'NotificationPreferenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotificationPreference>;
};

/** NotificationPreferenceEmailFrequency is enum for the field email_frequency */
export enum NotificationPreferenceEmailFrequency {
  Daily = 'DAILY',
  Immediate = 'IMMEDIATE',
  Weekly = 'WEEKLY'
}

/** Ordering options for NotificationPreference connections */
export type NotificationPreferenceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotificationPreferences. */
  field: NotificationPreferenceOrderField;
};

/** Properties by which NotificationPreference connections can be ordered. */
export enum NotificationPreferenceOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * NotificationPreferenceWhereInput is used for filtering NotificationPreference objects.
 * Input was generated by ent.
 */
export type NotificationPreferenceWhereInput = {
  and?: InputMaybe<Array<NotificationPreferenceWhereInput>>;
  /** app_enabled field predicates */
  appEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** email_enabled field predicates */
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** email_frequency field predicates */
  emailFrequency?: InputMaybe<NotificationPreferenceEmailFrequency>;
  emailFrequencyIn?: InputMaybe<Array<NotificationPreferenceEmailFrequency>>;
  emailFrequencyNEQ?: InputMaybe<NotificationPreferenceEmailFrequency>;
  emailFrequencyNotIn?: InputMaybe<Array<NotificationPreferenceEmailFrequency>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<NotificationKind>;
  kindIn?: InputMaybe<Array<NotificationKind>>;
  kindNEQ?: InputMaybe<NotificationKind>;
  kindNotIn?: InputMaybe<Array<NotificationKind>>;
  not?: InputMaybe<NotificationPreferenceWhereInput>;
  or?: InputMaybe<Array<NotificationPreferenceWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** A numbering-based hypothesis, not a verified legal citation. */
export type OcrInferredProvision = {
  __typename?: 'OCRInferredProvision';
  parserVersion: Scalars['Int']['output'];
  path: Array<OcrProvisionLabel>;
  status: OcrProvisionStatus;
};

/** Saved provider structure and optional numbering-based inference. */
export type OcrParagraphStructure = {
  __typename?: 'OCRParagraphStructure';
  apiVersion: Scalars['String']['output'];
  inferredProvision?: Maybe<OcrInferredProvision>;
  modelId: Scalars['String']['output'];
  role: Scalars['String']['output'];
  sectionPath: Array<OcrSectionLabel>;
  spans: Array<OcrTextSpan>;
  stringIndexType: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** Structural convention, not a legal designation of paragraph or clause. */
export enum OcrProvisionKind {
  Article = 'article',
  GenericHeading = 'genericHeading',
  ListItem = 'listItem',
  Section = 'section'
}

/** Label and zero-based index of the paragraph that starts the provision. */
export type OcrProvisionLabel = {
  __typename?: 'OCRProvisionLabel';
  /** Numbering-parser classification; null for metadata saved without kinds. */
  kind?: Maybe<OcrProvisionKind>;
  label: Scalars['String']['output'];
  paragraphIndex: Scalars['Int']['output'];
};

export enum OcrProvisionStatus {
  Continuation = 'continuation',
  Matched = 'matched',
  NoProvision = 'noProvision',
  Unresolved = 'unresolved'
}

/** Provider section identity; heading fields are absent for unheaded sections. */
export type OcrSectionLabel = {
  __typename?: 'OCRSectionLabel';
  heading: Scalars['String']['output'];
  headingParagraphIndex?: Maybe<Scalars['Int']['output']>;
  sectionIndex: Scalars['Int']['output'];
};

/** Offset and length in the saved OCR content, in stringIndexType units. */
export type OcrTextSpan = {
  __typename?: 'OCRTextSpan';
  length: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
};

export type OnboardingEntitySuggestion = {
  __typename?: 'OnboardingEntitySuggestion';
  /**  The properly capitalized and punctuated name generated by the LLM for display purposes  */
  displayName?: Maybe<Scalars['String']['output']>;
  entityKind?: Maybe<EntityKind>;
  /**  The raw entity name from the KGNode (may be all caps or poorly formatted)  */
  entityName?: Maybe<Scalars['String']['output']>;
  /**  The unique KGNode name within the merged KGRoot that this suggestion was created from  */
  nodeName: Scalars['String']['output'];
  /**  Any relevant, human-readable notes about the testamentary entity  */
  notes?: Maybe<Scalars['String']['output']>;
  /**  Deprecated: Use principalNodeIDs instead. Entity-type KGNodes that were identified that were identified to be the owners of the entity suggestion. Only relevant for business entities  */
  ownerEntityNodes: Array<Scalars['String']['output']>;
  /**  Deprecated: Use principalNodeIDs instead. ClientProfileIDs of existing Primary Clients that were identified to be the grantors/owners/donors of the entity suggestion  */
  principalClientProfileIDs: Array<Scalars['ID']['output']>;
  /**  KG V2 node IDs of principals (grantors/owners/donors). For trusts: grantors (people only). For business entities: owners (people or entities). For charitable entities: donors (people only).  */
  principalNodeIDs: Array<Scalars['String']['output']>;
  /**  Deprecated: Use principalNodeIDs instead. Person-type KGNodes (that are not Primary Clients) that were identified to be the grantors/owners/donors of the entity suggestion  */
  principalPersonNodes: Array<Scalars['String']['output']>;
  /**  SourceDocumentIDs are ids of documents that were identified to be the source document for the entity suggestion  */
  sourceDocumentIDs: Array<Scalars['ID']['output']>;
};

export type OnboardingEntitySuggestionInput = {
  /**  The properly capitalized and punctuated name generated by the LLM for display purposes  */
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityKind?: InputMaybe<EntityKind>;
  /**  The raw entity name from the KGNode (may be all caps or poorly formatted)  */
  entityName?: InputMaybe<Scalars['String']['input']>;
  /**  The unique KGNode name within the merged KGRoot that this suggestion was created from  */
  nodeName: Scalars['String']['input'];
  /**  Deprecated: Use principalNodeIDs instead. Entity-type KGNodes that were identified that were identified to be the owners of the entity suggestion. Only relevant for business entities  */
  ownerEntityNodes: Array<Scalars['String']['input']>;
  /**  Deprecated: Use principalNodeIDs instead. ClientProfileIDs of existing Primary Clients that were identified to be the grantors/owners/donors of the entity suggestion  */
  principalClientProfileIDs: Array<Scalars['ID']['input']>;
  /**  KG V2 node IDs of principals (grantors/owners/donors). For trusts: grantors (people only). For business entities: owners (people or entities). For charitable entities: donors (people only).  */
  principalNodeIDs: Array<Scalars['String']['input']>;
  /**  Deprecated: Use principalNodeIDs instead. Person-type KGNodes (that are not Primary Clients) that were identified to be the grantors/owners/donors of the entity suggestion  */
  principalPersonNodes: Array<Scalars['String']['input']>;
  /**  SourceDocumentIDs are ids of documents that were identified to be the source document for the entity suggestion  */
  sourceDocumentIDs: Array<Scalars['ID']['input']>;
};

export type OnboardingIndividualSuggestion = {
  __typename?: 'OnboardingIndividualSuggestion';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isSuggestedAsGrantor: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  /**  The unique KGNode name within the merged KGRoot that this suggestion was created from  */
  nodeName: Scalars['String']['output'];
  personalRelationships: Array<PersonalRelationshipSuggestion>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type OnboardingIndividualSuggestionInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isSuggestedAsGrantor: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  /**  The unique KGNode name within the merged KGRoot that this suggestion was created from  */
  nodeName: Scalars['String']['input'];
  personalRelationships: Array<PersonalRelationshipSuggestionInput>;
  suffix?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingOrganizationSuggestion = {
  __typename?: 'OnboardingOrganizationSuggestion';
  /**  The properly capitalized and punctuated name generated by the LLM for display purposes  */
  displayName?: Maybe<Scalars['String']['output']>;
  /**  The unique KGNode name within the merged KGRoot that this suggestion was created from  */
  nodeName: Scalars['String']['output'];
  organizationKind?: Maybe<ClientOrganizationKind>;
  /**  The raw organization name from the KGNode (may be all caps or poorly formatted)  */
  organizationName?: Maybe<Scalars['String']['output']>;
};

export type OnboardingOrganizationSuggestionInput = {
  /**  The properly capitalized and punctuated name generated by the LLM for display purposes  */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /**  The unique KGNode name within the merged KGRoot that this suggestion was created from  */
  nodeName: Scalars['String']['input'];
  organizationKind?: InputMaybe<ClientOrganizationKind>;
  /**  The raw organization name from the KGNode (may be all caps or poorly formatted)  */
  organizationName?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingTestamentaryEntitySuggestion = {
  __typename?: 'OnboardingTestamentaryEntitySuggestion';
  /**  The properly capitalized and punctuated name generated by the LLM for display purposes  */
  displayName?: Maybe<Scalars['String']['output']>;
  inEstateStatus?: Maybe<EntityInEstateStatus>;
  /**  The unique KGNode name within the merged KGRoot that this suggestion was created from  */
  nodeName: Scalars['String']['output'];
  /**  Any relevant, human-readable notes about the testamentary entity  */
  notes?: Maybe<Scalars['String']['output']>;
  testamentaryEntityKind?: Maybe<TestamentaryEntityKind>;
  /**  The raw testamentary entity name from the KGNode (may be all caps or poorly formatted)  */
  testamentaryEntityName?: Maybe<Scalars['String']['output']>;
};

export type OnboardingTestamentaryEntitySuggestionInput = {
  /**  The properly capitalized and punctuated name generated by the LLM for display purposes  */
  displayName?: InputMaybe<Scalars['String']['input']>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /**  The unique KGNode name within the merged KGRoot that this suggestion was created from  */
  nodeName: Scalars['String']['input'];
  testamentaryEntityKind?: InputMaybe<TestamentaryEntityKind>;
  /**  The raw testamentary entity name from the KGNode (may be all caps or poorly formatted)  */
  testamentaryEntityName?: InputMaybe<Scalars['String']['input']>;
};

export type OpenaiSdkConfig = Node & {
  __typename?: 'OpenaiSdkConfig';
  /** The base URL for the provider API. */
  baseURL?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  /** true to enable 'bring your own model provider' */
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  modelMappings: ModelMappingConnection;
  provider: OpenaiSdkConfigProvider;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};


export type OpenaiSdkConfigModelMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ModelMappingOrder>>;
  where?: InputMaybe<ModelMappingWhereInput>;
};

/** A connection to a list of items. */
export type OpenaiSdkConfigConnection = {
  __typename?: 'OpenaiSdkConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OpenaiSdkConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OpenaiSdkConfigEdge = {
  __typename?: 'OpenaiSdkConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OpenaiSdkConfig>;
};

/** Ordering options for OpenaiSdkConfig connections */
export type OpenaiSdkConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OpenaiSdkConfigs. */
  field: OpenaiSdkConfigOrderField;
};

/** Properties by which OpenaiSdkConfig connections can be ordered. */
export enum OpenaiSdkConfigOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** OpenaiSdkConfigProvider is enum for the field provider */
export enum OpenaiSdkConfigProvider {
  Azure = 'AZURE',
  Openai = 'OPENAI'
}

/**
 * OpenaiSdkConfigWhereInput is used for filtering OpenaiSdkConfig objects.
 * Input was generated by ent.
 */
export type OpenaiSdkConfigWhereInput = {
  and?: InputMaybe<Array<OpenaiSdkConfigWhereInput>>;
  /** base_url field predicates */
  baseURL?: InputMaybe<Scalars['String']['input']>;
  baseURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  baseURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** model_mappings edge predicates */
  hasModelMappings?: InputMaybe<Scalars['Boolean']['input']>;
  hasModelMappingsWith?: InputMaybe<Array<ModelMappingWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OpenaiSdkConfigWhereInput>;
  or?: InputMaybe<Array<OpenaiSdkConfigWhereInput>>;
  /** provider field predicates */
  provider?: InputMaybe<OpenaiSdkConfigProvider>;
  providerIn?: InputMaybe<Array<OpenaiSdkConfigProvider>>;
  providerNEQ?: InputMaybe<OpenaiSdkConfigProvider>;
  providerNotIn?: InputMaybe<Array<OpenaiSdkConfigProvider>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  /** Specifies an ascending order for a given `orderBy` argument. */
  Asc = 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  Desc = 'DESC'
}

export type OrganizationApplicationConfiguration = Node & {
  __typename?: 'OrganizationApplicationConfiguration';
  /** If false, USER_TEMPLATE create/duplicate/update/materialize is denied server-side. */
  allowUserPresentationTemplates: Scalars['Boolean']['output'];
  /** Optional allowlist of email domains that can be invited as collaborators. Do not include @. */
  collaboratorDomainAllowList?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['Time']['output'];
  /** If true, disables advanced analytics for member tenants. */
  disableAdvancedAnalytics: Scalars['Boolean']['output'];
  /** If true, disables all AI capabilities for member tenants. */
  disableAiCapabilities: Scalars['Boolean']['output'];
  /** If true, disables AI insights for member tenants. */
  disableAiInsights: Scalars['Boolean']['output'];
  /** If true, member tenants cannot create/update/delete roles; roles are org-managed. */
  disableRoleManagement: Scalars['Boolean']['output'];
  /** If true, organization disclaimer values take precedence over member tenant and sub-brand values; empty text values fall back to descendant values. */
  disclaimerConfigurationOverridesDescendants: Scalars['Boolean']['output'];
  /** If true, allows admins to set the employee.idp_id field via UI. */
  enableEmployeeIdpID: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  luminaryOrganization: LuminaryOrganization;
  luminaryOrganizationID: Scalars['ID']['output'];
  /** Maximum duration of a user session. */
  maxSessionDuration: OrganizationApplicationConfigurationMaxSessionDuration;
  /** Controls the operations available through Model Context Protocol for member tenants. */
  mcpAccess: McpAccess;
  /** When require_presentation_approval last started to require approval. Presentations created before this time need no approval. A null value means that approval is not required, or has been required since before this value existed. */
  presentationApprovalRequiredSince?: Maybe<Scalars['Time']['output']>;
  /** When require_presentation_approval last started to require attestation. Presentations created before this time need no review. A null value means that attestation is not required, or has been required since before this value existed. */
  presentationAttestationRequiredSince?: Maybe<Scalars['Time']['output']>;
  /** Controls the review steps that client presentations in member tenants require. */
  requirePresentationApproval: PresentationApprovalRequirement;
  /** If true, enables SmartReview for member tenants. */
  smartReviewEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['Time']['output'];
  /** User sessions expire after this period of inactivity. */
  userSessionInactivityTimeout: OrganizationApplicationConfigurationUserSessionInactivityTimeout;
};

/** A connection to a list of items. */
export type OrganizationApplicationConfigurationConnection = {
  __typename?: 'OrganizationApplicationConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationApplicationConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationApplicationConfigurationEdge = {
  __typename?: 'OrganizationApplicationConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganizationApplicationConfiguration>;
};

/** OrganizationApplicationConfigurationMaxSessionDuration is enum for the field max_session_duration */
export enum OrganizationApplicationConfigurationMaxSessionDuration {
  EightHours = 'EIGHT_HOURS',
  OneHour = 'ONE_HOUR',
  TwelveHours = 'TWELVE_HOURS',
  TwentyEightDays = 'TWENTY_EIGHT_DAYS'
}

/** Ordering options for OrganizationApplicationConfiguration connections */
export type OrganizationApplicationConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganizationApplicationConfigurations. */
  field: OrganizationApplicationConfigurationOrderField;
};

/** Properties by which OrganizationApplicationConfiguration connections can be ordered. */
export enum OrganizationApplicationConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** OrganizationApplicationConfigurationUserSessionInactivityTimeout is enum for the field user_session_inactivity_timeout */
export enum OrganizationApplicationConfigurationUserSessionInactivityTimeout {
  FifteenMinutes = 'FIFTEEN_MINUTES',
  FiveSecondsForTesting = 'FIVE_SECONDS_FOR_TESTING',
  Off = 'OFF',
  OneHour = 'ONE_HOUR'
}

/**
 * OrganizationApplicationConfigurationWhereInput is used for filtering OrganizationApplicationConfiguration objects.
 * Input was generated by ent.
 */
export type OrganizationApplicationConfigurationWhereInput = {
  /** allow_user_presentation_templates field predicates */
  allowUserPresentationTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<OrganizationApplicationConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** disable_advanced_analytics field predicates */
  disableAdvancedAnalytics?: InputMaybe<Scalars['Boolean']['input']>;
  /** disable_ai_capabilities field predicates */
  disableAiCapabilities?: InputMaybe<Scalars['Boolean']['input']>;
  /** disable_ai_insights field predicates */
  disableAiInsights?: InputMaybe<Scalars['Boolean']['input']>;
  /** disable_role_management field predicates */
  disableRoleManagement?: InputMaybe<Scalars['Boolean']['input']>;
  /** disclaimer_configuration_overrides_descendants field predicates */
  disclaimerConfigurationOverridesDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable_employee_idp_id field predicates */
  enableEmployeeIdpID?: InputMaybe<Scalars['Boolean']['input']>;
  /** luminary_organization edge predicates */
  hasLuminaryOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasLuminaryOrganizationWith?: InputMaybe<Array<LuminaryOrganizationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** luminary_organization_id field predicates */
  luminaryOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  luminaryOrganizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  luminaryOrganizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  luminaryOrganizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** max_session_duration field predicates */
  maxSessionDuration?: InputMaybe<OrganizationApplicationConfigurationMaxSessionDuration>;
  maxSessionDurationIn?: InputMaybe<Array<OrganizationApplicationConfigurationMaxSessionDuration>>;
  maxSessionDurationNEQ?: InputMaybe<OrganizationApplicationConfigurationMaxSessionDuration>;
  maxSessionDurationNotIn?: InputMaybe<Array<OrganizationApplicationConfigurationMaxSessionDuration>>;
  /** mcp_access field predicates */
  mcpAccess?: InputMaybe<McpAccess>;
  mcpAccessIn?: InputMaybe<Array<McpAccess>>;
  mcpAccessNEQ?: InputMaybe<McpAccess>;
  mcpAccessNotIn?: InputMaybe<Array<McpAccess>>;
  not?: InputMaybe<OrganizationApplicationConfigurationWhereInput>;
  or?: InputMaybe<Array<OrganizationApplicationConfigurationWhereInput>>;
  /** presentation_approval_required_since field predicates */
  presentationApprovalRequiredSince?: InputMaybe<Scalars['Time']['input']>;
  presentationApprovalRequiredSinceGT?: InputMaybe<Scalars['Time']['input']>;
  presentationApprovalRequiredSinceGTE?: InputMaybe<Scalars['Time']['input']>;
  presentationApprovalRequiredSinceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  presentationApprovalRequiredSinceLT?: InputMaybe<Scalars['Time']['input']>;
  presentationApprovalRequiredSinceLTE?: InputMaybe<Scalars['Time']['input']>;
  presentationApprovalRequiredSinceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** presentation_attestation_required_since field predicates */
  presentationAttestationRequiredSince?: InputMaybe<Scalars['Time']['input']>;
  presentationAttestationRequiredSinceGT?: InputMaybe<Scalars['Time']['input']>;
  presentationAttestationRequiredSinceGTE?: InputMaybe<Scalars['Time']['input']>;
  presentationAttestationRequiredSinceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  presentationAttestationRequiredSinceLT?: InputMaybe<Scalars['Time']['input']>;
  presentationAttestationRequiredSinceLTE?: InputMaybe<Scalars['Time']['input']>;
  presentationAttestationRequiredSinceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** require_presentation_approval field predicates */
  requirePresentationApproval?: InputMaybe<PresentationApprovalRequirement>;
  requirePresentationApprovalIn?: InputMaybe<Array<PresentationApprovalRequirement>>;
  requirePresentationApprovalNEQ?: InputMaybe<PresentationApprovalRequirement>;
  requirePresentationApprovalNotIn?: InputMaybe<Array<PresentationApprovalRequirement>>;
  /** smart_review_enabled field predicates */
  smartReviewEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** user_session_inactivity_timeout field predicates */
  userSessionInactivityTimeout?: InputMaybe<OrganizationApplicationConfigurationUserSessionInactivityTimeout>;
  userSessionInactivityTimeoutIn?: InputMaybe<Array<OrganizationApplicationConfigurationUserSessionInactivityTimeout>>;
  userSessionInactivityTimeoutNEQ?: InputMaybe<OrganizationApplicationConfigurationUserSessionInactivityTimeout>;
  userSessionInactivityTimeoutNotIn?: InputMaybe<Array<OrganizationApplicationConfigurationUserSessionInactivityTimeout>>;
};

export type OrganizationDisclaimerConfiguration = Node & {
  __typename?: 'OrganizationDisclaimerConfiguration';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /** If true, include the default Luminary company disclosures in the presentation */
  includeLuminaryDisclaimer: Scalars['Boolean']['output'];
  luminaryOrganization: LuminaryOrganization;
  luminaryOrganizationID: Scalars['ID']['output'];
  presentationCoverDisclaimerBody?: Maybe<Scalars['String']['output']>;
  presentationCoverDisclaimerTitle?: Maybe<Scalars['String']['output']>;
  presentationFooterDisclaimerBody?: Maybe<Scalars['String']['output']>;
  presentationFooterDisclaimerTitle?: Maybe<Scalars['String']['output']>;
  presentationStandaloneDisclaimerBody?: Maybe<Scalars['String']['output']>;
  presentationStandaloneDisclaimerTitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type OrganizationDisclaimerConfigurationConnection = {
  __typename?: 'OrganizationDisclaimerConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationDisclaimerConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationDisclaimerConfigurationEdge = {
  __typename?: 'OrganizationDisclaimerConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganizationDisclaimerConfiguration>;
};

export type OrionQueryResults = {
  __typename?: 'OrionQueryResults';
  requestMetadata?: Maybe<Scalars['String']['output']>;
  responseMetadata?: Maybe<Scalars['String']['output']>;
  results: Scalars['String']['output'];
};

export type OtherTenant = {
  __typename?: 'OtherTenant';
  branding: TenantBranding;
  name: Scalars['String']['output'];
};

export type OwnershipStake = Node & {
  __typename?: 'OwnershipStake';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The dispositive provisions that distribute this ownership stake. */
  dispositiveProvisions?: Maybe<Array<DispositiveProvision>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isGrantorControlled: Scalars['Boolean']['output'];
  /** The entity that this ownership stake is in. */
  ownedEntity?: Maybe<Entity>;
  ownedEntityID?: Maybe<Scalars['ID']['output']>;
  ownedValue: Scalars['CurrencyUSD']['output'];
  /** The percentage ownership of the underlying entity. */
  ownershipPercentage?: Maybe<Scalars['Percent']['output']>;
  /** The entity that owns this ownership stake. */
  owningEntity?: Maybe<Entity>;
  owningEntityID?: Maybe<Scalars['ID']['output']>;
  /** The individual that owns this ownership stake. */
  owningIndividual?: Maybe<ClientProfile>;
  owningIndividualID?: Maybe<Scalars['ID']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for OwnershipStake connections */
export type OwnershipStakeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OwnershipStakes. */
  field: OwnershipStakeOrderField;
};

/** Properties by which OwnershipStake connections can be ordered. */
export enum OwnershipStakeOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * OwnershipStakeWhereInput is used for filtering OwnershipStake objects.
 * Input was generated by ent.
 */
export type OwnershipStakeWhereInput = {
  and?: InputMaybe<Array<OwnershipStakeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** dispositive_provisions edge predicates */
  hasDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositiveProvisionsWith?: InputMaybe<Array<DispositiveProvisionWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** owned_entity edge predicates */
  hasOwnedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnedEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** owning_entity edge predicates */
  hasOwningEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwningEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** owning_individual edge predicates */
  hasOwningIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwningIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OwnershipStakeWhereInput>;
  or?: InputMaybe<Array<OwnershipStakeWhereInput>>;
  /** owned_entity_id field predicates */
  ownedEntityID?: InputMaybe<Scalars['ID']['input']>;
  ownedEntityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownedEntityIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownedEntityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownedEntityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownedEntityIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ownership_percentage field predicates */
  ownershipPercentage?: InputMaybe<Scalars['Percent']['input']>;
  ownershipPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  ownershipPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  ownershipPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownershipPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  ownershipPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  ownershipPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  ownershipPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** owning_entity_id field predicates */
  owningEntityID?: InputMaybe<Scalars['ID']['input']>;
  owningEntityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  owningEntityIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  owningEntityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  owningEntityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  owningEntityIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** owning_individual_id field predicates */
  owningIndividualID?: InputMaybe<Scalars['ID']['input']>;
  owningIndividualIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  owningIndividualIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  owningIndividualIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  owningIndividualIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  owningIndividualIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export enum PdfExportOrientation {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT'
}

/**
 * Information about pagination in a connection.
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type PartialCreateCollaboratorInput = {
  firstName: Scalars['String']['input'];
  householdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The role of the collaborator, for display purposes only */
  kind?: InputMaybe<CollaboratorKind>;
  lastName: Scalars['String']['input'];
  /** The name of the organization this collaborator works for */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  roleID?: InputMaybe<Scalars['ID']['input']>;
  /** The professional title of the collaborator, e.g. 'Associate' */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PartialCreateEmployeeInput = {
  assignedHouseholdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  idpID?: InputMaybe<Scalars['String']['input']>;
  roleIDs: Array<Scalars['ID']['input']>;
  teamIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tier?: InputMaybe<EmployeeTier>;
};

export type PercentageAccessParameterView = {
  __typename?: 'PercentageAccessParameterView';
  accessAgeParameters: Array<AccessAgeParameterView>;
  frequency?: Maybe<AccessParameterFrequency>;
  /** kind is the kind of access, always PERCENTAGE */
  kind: AccessParameterKind;
  percentage: Scalars['Percent']['output'];
};

export type PerformanceReport = {
  __typename?: 'PerformanceReport';
  grantsToCharity: Scalars['CurrencyUSD']['output'];
  wealthTransferred: Scalars['CurrencyUSD']['output'];
};

export type PersonNameParts = {
  __typename?: 'PersonNameParts';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleName: Scalars['String']['output'];
  suffix: Scalars['String']['output'];
};

export type PersonNamePartsInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName: Scalars['String']['input'];
  suffix: Scalars['String']['input'];
};

/**
 * PersonalAccount is a common interface for all
 * the accounts. It enforces some common
 * properties across all accounts.
 */
export type PersonalAccount = {
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  controllingParties?: Maybe<Array<ControllingParty>>;
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  description?: Maybe<Scalars['String']['output']>;
  designerAccount?: Maybe<Account>;
  displayName: Scalars['String']['output'];
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entityExists: Scalars['Boolean']['output'];
  gstStatus?: Maybe<EntityGstStatus>;
  id: Scalars['ID']['output'];
  inEstateStatus?: Maybe<EntityInEstateStatus>;
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  taxStatus?: Maybe<NonTrustEntityTaxStatus>;
};

export type PersonalRelationshipSuggestion = {
  __typename?: 'PersonalRelationshipSuggestion';
  clientProfileID?: Maybe<Scalars['ID']['output']>;
  relationshipType?: Maybe<ClientProfileRelationshipType>;
};

export type PersonalRelationshipSuggestionInput = {
  clientProfileID?: InputMaybe<Scalars['ID']['input']>;
  relationshipType?: InputMaybe<ClientProfileRelationshipType>;
};

export type PlatformDocument = Node & {
  __typename?: 'PlatformDocument';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  jurisdictionKind: PlatformDocumentJurisdictionKind;
  /** Descriptive source context. Fields that control application behavior use typed columns. */
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  nextVersion?: Maybe<PlatformDocument>;
  pdfFile?: Maybe<PlatformFile>;
  previousVersion?: Maybe<PlatformDocument>;
  /** Latest import state. UNKNOWN means no reliable history or completion evidence. Null means status lookup failed. */
  processingStatus?: Maybe<PlatformDocumentProcessingStatus>;
  sourceFile: PlatformFile;
  sourceVersion?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<PlatformDocumentStateCode>;
  status: PlatformDocumentStatus;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PlatformDocumentConnection = {
  __typename?: 'PlatformDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PlatformDocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PlatformDocumentEdge = {
  __typename?: 'PlatformDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PlatformDocument>;
};

/** PlatformDocumentJurisdictionKind is enum for the field jurisdiction_kind */
export enum PlatformDocumentJurisdictionKind {
  Federal = 'FEDERAL',
  ModelAct = 'MODEL_ACT',
  State = 'STATE'
}

/** Ordering options for PlatformDocument connections */
export type PlatformDocumentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PlatformDocuments. */
  field: PlatformDocumentOrderField;
};

/** Properties by which PlatformDocument connections can be ordered. */
export enum PlatformDocumentOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** Import processing state, independent of document publication. */
export enum PlatformDocumentProcessingStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Unknown = 'UNKNOWN'
}

/** PlatformDocumentStateCode is enum for the field state_code */
export enum PlatformDocumentStateCode {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

/** PlatformDocumentStatus is enum for the field status */
export enum PlatformDocumentStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Retired = 'RETIRED'
}

/**
 * PlatformDocumentWhereInput is used for filtering PlatformDocument objects.
 * Input was generated by ent.
 */
export type PlatformDocumentWhereInput = {
  and?: InputMaybe<Array<PlatformDocumentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** next_version edge predicates */
  hasNextVersion?: InputMaybe<Scalars['Boolean']['input']>;
  hasNextVersionWith?: InputMaybe<Array<PlatformDocumentWhereInput>>;
  /** pdf_file edge predicates */
  hasPdfFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPdfFileWith?: InputMaybe<Array<PlatformFileWhereInput>>;
  /** previous_version edge predicates */
  hasPreviousVersion?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreviousVersionWith?: InputMaybe<Array<PlatformDocumentWhereInput>>;
  /** source_file edge predicates */
  hasSourceFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceFileWith?: InputMaybe<Array<PlatformFileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** jurisdiction_kind field predicates */
  jurisdictionKind?: InputMaybe<PlatformDocumentJurisdictionKind>;
  jurisdictionKindIn?: InputMaybe<Array<PlatformDocumentJurisdictionKind>>;
  jurisdictionKindNEQ?: InputMaybe<PlatformDocumentJurisdictionKind>;
  jurisdictionKindNotIn?: InputMaybe<Array<PlatformDocumentJurisdictionKind>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<PlatformDocumentWhereInput>;
  or?: InputMaybe<Array<PlatformDocumentWhereInput>>;
  /** source_version field predicates */
  sourceVersion?: InputMaybe<Scalars['String']['input']>;
  sourceVersionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sourceVersionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state_code field predicates */
  stateCode?: InputMaybe<PlatformDocumentStateCode>;
  stateCodeIn?: InputMaybe<Array<PlatformDocumentStateCode>>;
  stateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  stateCodeNEQ?: InputMaybe<PlatformDocumentStateCode>;
  stateCodeNotIn?: InputMaybe<Array<PlatformDocumentStateCode>>;
  stateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<PlatformDocumentStatus>;
  statusIn?: InputMaybe<Array<PlatformDocumentStatus>>;
  statusNEQ?: InputMaybe<PlatformDocumentStatus>;
  statusNotIn?: InputMaybe<Array<PlatformDocumentStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PlatformFile = Node & {
  __typename?: 'PlatformFile';
  contentsSha256: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  document?: Maybe<PlatformDocument>;
  /** A short-lived URL. Draft files are available only to Luminary administrators. */
  downloadURL: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ingestionKind: PlatformFileIngestionKind;
  pages: PlatformFilePageConnection;
  paragraphs: PlatformFileParagraphConnection;
  pdfDocument?: Maybe<PlatformDocument>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PlatformFilePagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PlatformFilePageOrder>>;
  where?: InputMaybe<PlatformFilePageWhereInput>;
};


export type PlatformFileParagraphsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PlatformFileParagraphOrder>>;
  where?: InputMaybe<PlatformFileParagraphWhereInput>;
};

/** A connection to a list of items. */
export type PlatformFileConnection = {
  __typename?: 'PlatformFileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PlatformFileEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PlatformFileEdge = {
  __typename?: 'PlatformFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PlatformFile>;
};

/** PlatformFileIngestionKind is enum for the field ingestion_kind */
export enum PlatformFileIngestionKind {
  Generated = 'GENERATED',
  Uploaded = 'UPLOADED'
}

/** Ordering options for PlatformFile connections */
export type PlatformFileOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PlatformFiles. */
  field: PlatformFileOrderField;
};

/** Properties by which PlatformFile connections can be ordered. */
export enum PlatformFileOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type PlatformFilePage = Node & {
  __typename?: 'PlatformFilePage';
  angle?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  file: PlatformFile;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** One-based page number. */
  pageNumber: Scalars['Int']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  width?: Maybe<Scalars['Float']['output']>;
};

/** A connection to a list of items. */
export type PlatformFilePageConnection = {
  __typename?: 'PlatformFilePageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PlatformFilePageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PlatformFilePageEdge = {
  __typename?: 'PlatformFilePageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PlatformFilePage>;
};

/** Ordering options for PlatformFilePage connections */
export type PlatformFilePageOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PlatformFilePages. */
  field: PlatformFilePageOrderField;
};

/** Properties by which PlatformFilePage connections can be ordered. */
export enum PlatformFilePageOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PlatformFilePageWhereInput is used for filtering PlatformFilePage objects.
 * Input was generated by ent.
 */
export type PlatformFilePageWhereInput = {
  and?: InputMaybe<Array<PlatformFilePageWhereInput>>;
  /** angle field predicates */
  angle?: InputMaybe<Scalars['Float']['input']>;
  angleGT?: InputMaybe<Scalars['Float']['input']>;
  angleGTE?: InputMaybe<Scalars['Float']['input']>;
  angleIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  angleLT?: InputMaybe<Scalars['Float']['input']>;
  angleLTE?: InputMaybe<Scalars['Float']['input']>;
  angleNEQ?: InputMaybe<Scalars['Float']['input']>;
  angleNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** file edge predicates */
  hasFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileWith?: InputMaybe<Array<PlatformFileWhereInput>>;
  /** height field predicates */
  height?: InputMaybe<Scalars['Float']['input']>;
  heightGT?: InputMaybe<Scalars['Float']['input']>;
  heightGTE?: InputMaybe<Scalars['Float']['input']>;
  heightIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  heightLT?: InputMaybe<Scalars['Float']['input']>;
  heightLTE?: InputMaybe<Scalars['Float']['input']>;
  heightNEQ?: InputMaybe<Scalars['Float']['input']>;
  heightNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PlatformFilePageWhereInput>;
  or?: InputMaybe<Array<PlatformFilePageWhereInput>>;
  /** page_number field predicates */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageNumberGT?: InputMaybe<Scalars['Int']['input']>;
  pageNumberGTE?: InputMaybe<Scalars['Int']['input']>;
  pageNumberLT?: InputMaybe<Scalars['Int']['input']>;
  pageNumberLTE?: InputMaybe<Scalars['Int']['input']>;
  pageNumberNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** unit field predicates */
  unit?: InputMaybe<Scalars['String']['input']>;
  unitIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  unitNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** width field predicates */
  width?: InputMaybe<Scalars['Float']['input']>;
  widthGT?: InputMaybe<Scalars['Float']['input']>;
  widthGTE?: InputMaybe<Scalars['Float']['input']>;
  widthIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  widthLT?: InputMaybe<Scalars['Float']['input']>;
  widthLTE?: InputMaybe<Scalars['Float']['input']>;
  widthNEQ?: InputMaybe<Scalars['Float']['input']>;
  widthNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlatformFileParagraph = Node & {
  __typename?: 'PlatformFileParagraph';
  boundingRegions: Array<BoundingRegion>;
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  file: PlatformFile;
  id: Scalars['ID']['output'];
  impliedParagraphNumber: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PlatformFileParagraphConnection = {
  __typename?: 'PlatformFileParagraphConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PlatformFileParagraphEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PlatformFileParagraphEdge = {
  __typename?: 'PlatformFileParagraphEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PlatformFileParagraph>;
};

/** Ordering options for PlatformFileParagraph connections */
export type PlatformFileParagraphOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PlatformFileParagraphs. */
  field: PlatformFileParagraphOrderField;
};

/** Properties by which PlatformFileParagraph connections can be ordered. */
export enum PlatformFileParagraphOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PlatformFileParagraphWhereInput is used for filtering PlatformFileParagraph objects.
 * Input was generated by ent.
 */
export type PlatformFileParagraphWhereInput = {
  and?: InputMaybe<Array<PlatformFileParagraphWhereInput>>;
  /** content field predicates */
  content?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** file edge predicates */
  hasFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileWith?: InputMaybe<Array<PlatformFileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** implied_paragraph_number field predicates */
  impliedParagraphNumber?: InputMaybe<Scalars['Int']['input']>;
  impliedParagraphNumberGT?: InputMaybe<Scalars['Int']['input']>;
  impliedParagraphNumberGTE?: InputMaybe<Scalars['Int']['input']>;
  impliedParagraphNumberLT?: InputMaybe<Scalars['Int']['input']>;
  impliedParagraphNumberLTE?: InputMaybe<Scalars['Int']['input']>;
  impliedParagraphNumberNEQ?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<PlatformFileParagraphWhereInput>;
  or?: InputMaybe<Array<PlatformFileParagraphWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * PlatformFileWhereInput is used for filtering PlatformFile objects.
 * Input was generated by ent.
 */
export type PlatformFileWhereInput = {
  and?: InputMaybe<Array<PlatformFileWhereInput>>;
  /** contents_sha256 field predicates */
  contentsSha256?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** extension field predicates */
  extension?: InputMaybe<Scalars['String']['input']>;
  /** filename field predicates */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<PlatformDocumentWhereInput>>;
  /** pages edge predicates */
  hasPages?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagesWith?: InputMaybe<Array<PlatformFilePageWhereInput>>;
  /** paragraphs edge predicates */
  hasParagraphs?: InputMaybe<Scalars['Boolean']['input']>;
  hasParagraphsWith?: InputMaybe<Array<PlatformFileParagraphWhereInput>>;
  /** pdf_document edge predicates */
  hasPdfDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasPdfDocumentWith?: InputMaybe<Array<PlatformDocumentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ingestion_kind field predicates */
  ingestionKind?: InputMaybe<PlatformFileIngestionKind>;
  ingestionKindIn?: InputMaybe<Array<PlatformFileIngestionKind>>;
  ingestionKindNEQ?: InputMaybe<PlatformFileIngestionKind>;
  ingestionKindNotIn?: InputMaybe<Array<PlatformFileIngestionKind>>;
  not?: InputMaybe<PlatformFileWhereInput>;
  or?: InputMaybe<Array<PlatformFileWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** PotentialPrimaryClient is a type that represents a potential primary client. */
export type PotentialPrimaryClient = {
  __typename?: 'PotentialPrimaryClient';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type PresentationApprovalRequest = Node & {
  __typename?: 'PresentationApprovalRequest';
  /** Deletion is restricted because approvals are a write-once audit log. */
  approval?: Maybe<Approval>;
  /** The approval that fulfills the request. A null value means that the request is open. The approval records who acted, when, and identity snapshots. */
  approvalID?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  kind: PresentationApprovalRequestKind;
  presentation: ClientPresentationV2;
  presentationID: Scalars['ID']['output'];
  requestedApprover: User;
  /** The user asked to complete the step: the presentation creator for an attestation, or an approver for an approval. */
  requestedApproverID: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PresentationApprovalRequestConnection = {
  __typename?: 'PresentationApprovalRequestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationApprovalRequestEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationApprovalRequestEdge = {
  __typename?: 'PresentationApprovalRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationApprovalRequest>;
};

/** PresentationApprovalRequestKind is enum for the field kind */
export enum PresentationApprovalRequestKind {
  PresentationApproved = 'PRESENTATION_APPROVED',
  PresentationAttested = 'PRESENTATION_ATTESTED'
}

/** Ordering options for PresentationApprovalRequest connections */
export type PresentationApprovalRequestOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationApprovalRequests. */
  field: PresentationApprovalRequestOrderField;
};

/** Properties by which PresentationApprovalRequest connections can be ordered. */
export enum PresentationApprovalRequestOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationApprovalRequestWhereInput is used for filtering PresentationApprovalRequest objects.
 * Input was generated by ent.
 */
export type PresentationApprovalRequestWhereInput = {
  and?: InputMaybe<Array<PresentationApprovalRequestWhereInput>>;
  /** approval_id field predicates */
  approvalID?: InputMaybe<Scalars['ID']['input']>;
  approvalIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approvalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  approvalIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  approvalIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approvalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** approval edge predicates */
  hasApproval?: InputMaybe<Scalars['Boolean']['input']>;
  hasApprovalWith?: InputMaybe<Array<ApprovalWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** presentation edge predicates */
  hasPresentation?: InputMaybe<Scalars['Boolean']['input']>;
  hasPresentationWith?: InputMaybe<Array<ClientPresentationV2WhereInput>>;
  /** requested_approver edge predicates */
  hasRequestedApprover?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequestedApproverWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<PresentationApprovalRequestKind>;
  kindIn?: InputMaybe<Array<PresentationApprovalRequestKind>>;
  kindNEQ?: InputMaybe<PresentationApprovalRequestKind>;
  kindNotIn?: InputMaybe<Array<PresentationApprovalRequestKind>>;
  not?: InputMaybe<PresentationApprovalRequestWhereInput>;
  or?: InputMaybe<Array<PresentationApprovalRequestWhereInput>>;
  /** presentation_id field predicates */
  presentationID?: InputMaybe<Scalars['ID']['input']>;
  presentationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  presentationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  presentationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** requested_approver_id field predicates */
  requestedApproverID?: InputMaybe<Scalars['ID']['input']>;
  requestedApproverIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  requestedApproverIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  requestedApproverIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** PresentationApprovalRequirement is enum for the field require_presentation_approval */
export enum PresentationApprovalRequirement {
  AttestationAndApproval = 'ATTESTATION_AND_APPROVAL',
  AttestationOnly = 'ATTESTATION_ONLY',
  NotRequired = 'NOT_REQUIRED'
}

export type PresentationAssetDistributionBundleConfiguration = Node & {
  __typename?: 'PresentationAssetDistributionBundleConfiguration';
  bundle: PresentationBundle;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Display label indicating the death-order context for this distribution (e.g., 'After John's death' or 'After both deaths'). */
  deathOrderDisplay: Scalars['String']['output'];
  /** Prose description of the distribution scenario rendered beneath the page heading. */
  description: Scalars['String']['output'];
  /** Optional override for the bundle's display name on the asset-distribution page. */
  displayName?: Maybe<Scalars['String']['output']>;
  distributionItems: PresentationAssetDistributionItemConfigurationConnection;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Maximum number of distribution items rendered on each page. */
  itemsPerPage: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PresentationAssetDistributionBundleConfigurationDistributionItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationAssetDistributionItemConfigurationOrder>>;
  where?: InputMaybe<PresentationAssetDistributionItemConfigurationWhereInput>;
};

/** A connection to a list of items. */
export type PresentationAssetDistributionBundleConfigurationConnection = {
  __typename?: 'PresentationAssetDistributionBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationAssetDistributionBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationAssetDistributionBundleConfigurationEdge = {
  __typename?: 'PresentationAssetDistributionBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationAssetDistributionBundleConfiguration>;
};

/** Ordering options for PresentationAssetDistributionBundleConfiguration connections */
export type PresentationAssetDistributionBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationAssetDistributionBundleConfigurations. */
  field: PresentationAssetDistributionBundleConfigurationOrderField;
};

/** Properties by which PresentationAssetDistributionBundleConfiguration connections can be ordered. */
export enum PresentationAssetDistributionBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationAssetDistributionBundleConfigurationWhereInput is used for filtering PresentationAssetDistributionBundleConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationAssetDistributionBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationAssetDistributionBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** death_order_display field predicates */
  deathOrderDisplay?: InputMaybe<Scalars['String']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** distribution_items edge predicates */
  hasDistributionItems?: InputMaybe<Scalars['Boolean']['input']>;
  hasDistributionItemsWith?: InputMaybe<Array<PresentationAssetDistributionItemConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** items_per_page field predicates */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageGT?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageGTE?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageLT?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageLTE?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageNEQ?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<PresentationAssetDistributionBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationAssetDistributionBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationAssetDistributionItemConfiguration = Node & {
  __typename?: 'PresentationAssetDistributionItemConfiguration';
  /** The asset-distribution bundle configuration this distribution item belongs to. */
  bundleConfiguration: PresentationAssetDistributionBundleConfiguration;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The display name of the distribution item as it should appear on the page. */
  displayName: Scalars['String']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  itemDetails: PresentationAssetDistributionItemDetailConnection;
  /** The order in which this distribution item is rendered within the bundle. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PresentationAssetDistributionItemConfigurationItemDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationAssetDistributionItemDetailOrder>>;
  where?: InputMaybe<PresentationAssetDistributionItemDetailWhereInput>;
};

/** A connection to a list of items. */
export type PresentationAssetDistributionItemConfigurationConnection = {
  __typename?: 'PresentationAssetDistributionItemConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationAssetDistributionItemConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationAssetDistributionItemConfigurationEdge = {
  __typename?: 'PresentationAssetDistributionItemConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationAssetDistributionItemConfiguration>;
};

/** Ordering options for PresentationAssetDistributionItemConfiguration connections */
export type PresentationAssetDistributionItemConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationAssetDistributionItemConfigurations. */
  field: PresentationAssetDistributionItemConfigurationOrderField;
};

/** Properties by which PresentationAssetDistributionItemConfiguration connections can be ordered. */
export enum PresentationAssetDistributionItemConfigurationOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationAssetDistributionItemConfigurationWhereInput is used for filtering PresentationAssetDistributionItemConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationAssetDistributionItemConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationAssetDistributionItemConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** bundle_configuration edge predicates */
  hasBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleConfigurationWith?: InputMaybe<Array<PresentationAssetDistributionBundleConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** item_details edge predicates */
  hasItemDetails?: InputMaybe<Scalars['Boolean']['input']>;
  hasItemDetailsWith?: InputMaybe<Array<PresentationAssetDistributionItemDetailWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PresentationAssetDistributionItemConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationAssetDistributionItemConfigurationWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationAssetDistributionItemDetail = Node & {
  __typename?: 'PresentationAssetDistributionItemDetail';
  /** Body text rendered for the item. */
  body: Scalars['String']['output'];
  /** Source citations grounding this item. */
  citations?: Maybe<Array<PresentationItemCitation>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The asset-distribution item configuration this detail row belongs to. */
  itemConfiguration: PresentationAssetDistributionItemConfiguration;
  /** Short label rendered above the item body. */
  label: Scalars['String']['output'];
  /** The order in which this item is rendered within its parent. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PresentationAssetDistributionItemDetailConnection = {
  __typename?: 'PresentationAssetDistributionItemDetailConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationAssetDistributionItemDetailEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationAssetDistributionItemDetailEdge = {
  __typename?: 'PresentationAssetDistributionItemDetailEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationAssetDistributionItemDetail>;
};

/** Ordering options for PresentationAssetDistributionItemDetail connections */
export type PresentationAssetDistributionItemDetailOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationAssetDistributionItemDetails. */
  field: PresentationAssetDistributionItemDetailOrderField;
};

/** Properties by which PresentationAssetDistributionItemDetail connections can be ordered. */
export enum PresentationAssetDistributionItemDetailOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationAssetDistributionItemDetailWhereInput is used for filtering PresentationAssetDistributionItemDetail objects.
 * Input was generated by ent.
 */
export type PresentationAssetDistributionItemDetailWhereInput = {
  and?: InputMaybe<Array<PresentationAssetDistributionItemDetailWhereInput>>;
  /** body field predicates */
  body?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** citations edge predicates */
  hasCitations?: InputMaybe<Scalars['Boolean']['input']>;
  hasCitationsWith?: InputMaybe<Array<PresentationItemCitationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** item_configuration edge predicates */
  hasItemConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasItemConfigurationWith?: InputMaybe<Array<PresentationAssetDistributionItemConfigurationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<PresentationAssetDistributionItemDetailWhereInput>;
  or?: InputMaybe<Array<PresentationAssetDistributionItemDetailWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationBundle = Node & {
  __typename?: 'PresentationBundle';
  assetDistributionBundleConfiguration?: Maybe<PresentationAssetDistributionBundleConfiguration>;
  balanceSheetBundleConfiguration?: Maybe<BalanceSheetBundleConfiguration>;
  beneficiariesBundleConfiguration?: Maybe<BeneficiariesBundleConfiguration>;
  businessOverviewBundleConfiguration?: Maybe<PresentationBusinessOverviewBundleConfiguration>;
  clientPresentationV2?: Maybe<ClientPresentationV2>;
  coverPageConfiguration?: Maybe<CoverPageConfiguration>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  customPageBundleConfiguration?: Maybe<PresentationCustomPageBundleConfiguration>;
  dividerBundleConfiguration?: Maybe<DividerBundleConfiguration>;
  documentsReviewedBundleConfiguration?: Maybe<PresentationDocumentsReviewedBundleConfiguration>;
  entitiesOverviewBundleConfiguration?: Maybe<EntitiesOverviewBundleConfiguration>;
  entityGraphViewBundleConfiguration?: Maybe<EntityGraphViewBundleConfiguration>;
  entitySummaryBundleConfiguration?: Maybe<EntitySummaryBundleConfiguration>;
  estateInsightsBundleConfiguration?: Maybe<EstateInsightsBundleConfiguration>;
  /** will not be included in printed output if true */
  excludeFromOutput: Scalars['Boolean']['output'];
  /** Per-instance context prepended to runtime page prompts for expanded bundles. */
  expansionContext?: Maybe<Scalars['String']['output']>;
  familyOverviewBundleConfiguration?: Maybe<PresentationFamilyOverviewBundleConfiguration>;
  familyTreeBundleConfiguration?: Maybe<FamilyTreeBundleConfiguration>;
  healthcareDirectiveBundleConfiguration?: Maybe<PresentationHealthcareDirectiveBundleConfiguration>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The index of the bundle in the presentation */
  index: Scalars['Int']['output'];
  /** Indicates the kind of bundle this is. */
  kind: PresentationBundleKind;
  liabilitiesBundleConfiguration?: Maybe<LiabilitiesBundleConfiguration>;
  lifeInsuranceBundleConfiguration?: Maybe<LifeInsuranceBundleConfiguration>;
  pages: PresentationPageConnection;
  planningOpportunitiesBundleConfiguration?: Maybe<PresentationPlanningOpportunitiesBundleConfiguration>;
  powerOfAttorneyBundleConfiguration?: Maybe<PresentationPowerOfAttorneyBundleConfiguration>;
  /** The template bundle that produced this runtime bundle. */
  sourceTemplateBundle?: Maybe<PresentationTemplateBundle>;
  /** The template bundle that this runtime bundle was cloned from. */
  sourceTemplateBundleID?: Maybe<Scalars['ID']['output']>;
  /** Notes to advisors on how to use the bundle */
  templateNotes?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  trustOverviewBundleConfiguration?: Maybe<PresentationTrustOverviewBundleConfiguration>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  waterfallBundleConfiguration?: Maybe<WaterfallBundleConfiguration>;
  waterfallComparisonBundleConfiguration?: Maybe<WaterfallComparisonBundleConfiguration>;
  willBundleConfiguration?: Maybe<PresentationWillBundleConfiguration>;
};


export type PresentationBundlePagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationPageOrder>>;
  where?: InputMaybe<PresentationPageWhereInput>;
};

/** A connection to a list of items. */
export type PresentationBundleConnection = {
  __typename?: 'PresentationBundleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationBundleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type PresentationBundleCoverPage = Node & {
  __typename?: 'PresentationBundleCoverPage';
  /**
   * The content of the cover page.
   * @deprecated Use custom_content on the presentation cover page instead
   */
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PresentationBundleCoverPageConnection = {
  __typename?: 'PresentationBundleCoverPageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationBundleCoverPageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationBundleCoverPageEdge = {
  __typename?: 'PresentationBundleCoverPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationBundleCoverPage>;
};

/** An edge in a connection. */
export type PresentationBundleEdge = {
  __typename?: 'PresentationBundleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationBundle>;
};

/** PresentationBundleKind is enum for the field kind */
export enum PresentationBundleKind {
  AssetDistributionBundle = 'ASSET_DISTRIBUTION_BUNDLE',
  BalanceSheetBundle = 'BALANCE_SHEET_BUNDLE',
  BeneficiaryReportBundle = 'BENEFICIARY_REPORT_BUNDLE',
  BusinessOverviewBundle = 'BUSINESS_OVERVIEW_BUNDLE',
  CoverSlideBundle = 'COVER_SLIDE_BUNDLE',
  CustomPageBundle = 'CUSTOM_PAGE_BUNDLE',
  DiagramBundle = 'DIAGRAM_BUNDLE',
  DividerBundle = 'DIVIDER_BUNDLE',
  DocumentsReviewedBundle = 'DOCUMENTS_REVIEWED_BUNDLE',
  DocumentSummaryBundle = 'DOCUMENT_SUMMARY_BUNDLE',
  EducationPageBundle = 'EDUCATION_PAGE_BUNDLE',
  EntitiesOverviewBundle = 'ENTITIES_OVERVIEW_BUNDLE',
  EntityGraphViewBundle = 'ENTITY_GRAPH_VIEW_BUNDLE',
  EntitySummaryBundle = 'ENTITY_SUMMARY_BUNDLE',
  EstateInsightsBundle = 'ESTATE_INSIGHTS_BUNDLE',
  FamilyOverviewBundle = 'FAMILY_OVERVIEW_BUNDLE',
  FamilyTreeBundle = 'FAMILY_TREE_BUNDLE',
  HealthcareDirectiveBundle = 'HEALTHCARE_DIRECTIVE_BUNDLE',
  LiabilitiesBundle = 'LIABILITIES_BUNDLE',
  LifeInsuranceBundle = 'LIFE_INSURANCE_BUNDLE',
  LuminaryDisclaimerBundle = 'LUMINARY_DISCLAIMER_BUNDLE',
  PlanningOpportunitiesBundle = 'PLANNING_OPPORTUNITIES_BUNDLE',
  PowerOfAttorneyBundle = 'POWER_OF_ATTORNEY_BUNDLE',
  ProfessionalTeamBundle = 'PROFESSIONAL_TEAM_BUNDLE',
  StandaloneDisclaimerBundle = 'STANDALONE_DISCLAIMER_BUNDLE',
  TableOfContentsBundle = 'TABLE_OF_CONTENTS_BUNDLE',
  TrustOverviewBundle = 'TRUST_OVERVIEW_BUNDLE',
  WaterfallComparisonBundle = 'WATERFALL_COMPARISON_BUNDLE',
  WaterfallOverviewBundle = 'WATERFALL_OVERVIEW_BUNDLE',
  WillBundle = 'WILL_BUNDLE'
}

/** Ordering options for PresentationBundle connections */
export type PresentationBundleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationBundles. */
  field: PresentationBundleOrderField;
};

/** Properties by which PresentationBundle connections can be ordered. */
export enum PresentationBundleOrderField {
  CreatedAt = 'created_at',
  Index = 'index',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationBundleWhereInput is used for filtering PresentationBundle objects.
 * Input was generated by ent.
 */
export type PresentationBundleWhereInput = {
  and?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** exclude_from_output field predicates */
  excludeFromOutput?: InputMaybe<Scalars['Boolean']['input']>;
  /** expansion_context field predicates */
  expansionContext?: InputMaybe<Scalars['String']['input']>;
  expansionContextIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  expansionContextNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** asset_distribution_bundle_configuration edge predicates */
  hasAssetDistributionBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssetDistributionBundleConfigurationWith?: InputMaybe<Array<PresentationAssetDistributionBundleConfigurationWhereInput>>;
  /** balance_sheet_bundle_configuration edge predicates */
  hasBalanceSheetBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBalanceSheetBundleConfigurationWith?: InputMaybe<Array<BalanceSheetBundleConfigurationWhereInput>>;
  /** beneficiaries_bundle_configuration edge predicates */
  hasBeneficiariesBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesBundleConfigurationWith?: InputMaybe<Array<BeneficiariesBundleConfigurationWhereInput>>;
  /** business_overview_bundle_configuration edge predicates */
  hasBusinessOverviewBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBusinessOverviewBundleConfigurationWith?: InputMaybe<Array<PresentationBusinessOverviewBundleConfigurationWhereInput>>;
  /** client_presentation_v2 edge predicates */
  hasClientPresentationV2?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientPresentationV2With?: InputMaybe<Array<ClientPresentationV2WhereInput>>;
  /** cover_page_configuration edge predicates */
  hasCoverPageConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasCoverPageConfigurationWith?: InputMaybe<Array<CoverPageConfigurationWhereInput>>;
  /** custom_page_bundle_configuration edge predicates */
  hasCustomPageBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomPageBundleConfigurationWith?: InputMaybe<Array<PresentationCustomPageBundleConfigurationWhereInput>>;
  /** divider_bundle_configuration edge predicates */
  hasDividerBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasDividerBundleConfigurationWith?: InputMaybe<Array<DividerBundleConfigurationWhereInput>>;
  /** documents_reviewed_bundle_configuration edge predicates */
  hasDocumentsReviewedBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentsReviewedBundleConfigurationWith?: InputMaybe<Array<PresentationDocumentsReviewedBundleConfigurationWhereInput>>;
  /** entities_overview_bundle_configuration edge predicates */
  hasEntitiesOverviewBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntitiesOverviewBundleConfigurationWith?: InputMaybe<Array<EntitiesOverviewBundleConfigurationWhereInput>>;
  /** entity_graph_view_bundle_configuration edge predicates */
  hasEntityGraphViewBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityGraphViewBundleConfigurationWith?: InputMaybe<Array<EntityGraphViewBundleConfigurationWhereInput>>;
  /** entity_summary_bundle_configuration edge predicates */
  hasEntitySummaryBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntitySummaryBundleConfigurationWith?: InputMaybe<Array<EntitySummaryBundleConfigurationWhereInput>>;
  /** estate_insights_bundle_configuration edge predicates */
  hasEstateInsightsBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasEstateInsightsBundleConfigurationWith?: InputMaybe<Array<EstateInsightsBundleConfigurationWhereInput>>;
  /** family_overview_bundle_configuration edge predicates */
  hasFamilyOverviewBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasFamilyOverviewBundleConfigurationWith?: InputMaybe<Array<PresentationFamilyOverviewBundleConfigurationWhereInput>>;
  /** family_tree_bundle_configuration edge predicates */
  hasFamilyTreeBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasFamilyTreeBundleConfigurationWith?: InputMaybe<Array<FamilyTreeBundleConfigurationWhereInput>>;
  /** healthcare_directive_bundle_configuration edge predicates */
  hasHealthcareDirectiveBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasHealthcareDirectiveBundleConfigurationWith?: InputMaybe<Array<PresentationHealthcareDirectiveBundleConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** liabilities_bundle_configuration edge predicates */
  hasLiabilitiesBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasLiabilitiesBundleConfigurationWith?: InputMaybe<Array<LiabilitiesBundleConfigurationWhereInput>>;
  /** life_insurance_bundle_configuration edge predicates */
  hasLifeInsuranceBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasLifeInsuranceBundleConfigurationWith?: InputMaybe<Array<LifeInsuranceBundleConfigurationWhereInput>>;
  /** pages edge predicates */
  hasPages?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagesWith?: InputMaybe<Array<PresentationPageWhereInput>>;
  /** planning_opportunities_bundle_configuration edge predicates */
  hasPlanningOpportunitiesBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasPlanningOpportunitiesBundleConfigurationWith?: InputMaybe<Array<PresentationPlanningOpportunitiesBundleConfigurationWhereInput>>;
  /** power_of_attorney_bundle_configuration edge predicates */
  hasPowerOfAttorneyBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasPowerOfAttorneyBundleConfigurationWith?: InputMaybe<Array<PresentationPowerOfAttorneyBundleConfigurationWhereInput>>;
  /** source_template_bundle edge predicates */
  hasSourceTemplateBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceTemplateBundleWith?: InputMaybe<Array<PresentationTemplateBundleWhereInput>>;
  /** trust_overview_bundle_configuration edge predicates */
  hasTrustOverviewBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrustOverviewBundleConfigurationWith?: InputMaybe<Array<PresentationTrustOverviewBundleConfigurationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** waterfall_bundle_configuration edge predicates */
  hasWaterfallBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasWaterfallBundleConfigurationWith?: InputMaybe<Array<WaterfallBundleConfigurationWhereInput>>;
  /** waterfall_comparison_bundle_configuration edge predicates */
  hasWaterfallComparisonBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasWaterfallComparisonBundleConfigurationWith?: InputMaybe<Array<WaterfallComparisonBundleConfigurationWhereInput>>;
  /** will_bundle_configuration edge predicates */
  hasWillBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasWillBundleConfigurationWith?: InputMaybe<Array<PresentationWillBundleConfigurationWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** index field predicates */
  index?: InputMaybe<Scalars['Int']['input']>;
  indexGT?: InputMaybe<Scalars['Int']['input']>;
  indexGTE?: InputMaybe<Scalars['Int']['input']>;
  indexLT?: InputMaybe<Scalars['Int']['input']>;
  indexLTE?: InputMaybe<Scalars['Int']['input']>;
  indexNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<PresentationBundleKind>;
  kindIn?: InputMaybe<Array<PresentationBundleKind>>;
  kindNEQ?: InputMaybe<PresentationBundleKind>;
  kindNotIn?: InputMaybe<Array<PresentationBundleKind>>;
  not?: InputMaybe<PresentationBundleWhereInput>;
  or?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** source_template_bundle_id field predicates */
  sourceTemplateBundleID?: InputMaybe<Scalars['ID']['input']>;
  sourceTemplateBundleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceTemplateBundleIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sourceTemplateBundleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  sourceTemplateBundleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceTemplateBundleIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** template_notes field predicates */
  templateNotes?: InputMaybe<Scalars['String']['input']>;
  templateNotesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  templateNotesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationBusinessOverviewBundleConfiguration = Node & {
  __typename?: 'PresentationBusinessOverviewBundleConfiguration';
  bundle: PresentationBundle;
  businesses: PresentationBusinessOverviewBusinessConfigurationConnection;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Optional override for the bundle's display name on the business-overview page. CMK-encrypted. */
  displayName?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Maximum number of businesses rendered on each page. */
  itemsPerPage: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PresentationBusinessOverviewBundleConfigurationBusinessesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationBusinessOverviewBusinessConfigurationOrder>>;
  where?: InputMaybe<PresentationBusinessOverviewBusinessConfigurationWhereInput>;
};

/** A connection to a list of items. */
export type PresentationBusinessOverviewBundleConfigurationConnection = {
  __typename?: 'PresentationBusinessOverviewBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationBusinessOverviewBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationBusinessOverviewBundleConfigurationEdge = {
  __typename?: 'PresentationBusinessOverviewBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationBusinessOverviewBundleConfiguration>;
};

/** Ordering options for PresentationBusinessOverviewBundleConfiguration connections */
export type PresentationBusinessOverviewBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationBusinessOverviewBundleConfigurations. */
  field: PresentationBusinessOverviewBundleConfigurationOrderField;
};

/** Properties by which PresentationBusinessOverviewBundleConfiguration connections can be ordered. */
export enum PresentationBusinessOverviewBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationBusinessOverviewBundleConfigurationWhereInput is used for filtering PresentationBusinessOverviewBundleConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationBusinessOverviewBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationBusinessOverviewBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** businesses edge predicates */
  hasBusinesses?: InputMaybe<Scalars['Boolean']['input']>;
  hasBusinessesWith?: InputMaybe<Array<PresentationBusinessOverviewBusinessConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** items_per_page field predicates */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageGT?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageGTE?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageLT?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageLTE?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageNEQ?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<PresentationBusinessOverviewBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationBusinessOverviewBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationBusinessOverviewBusinessConfiguration = Node & {
  __typename?: 'PresentationBusinessOverviewBusinessConfiguration';
  /** The business-overview bundle configuration this business entry belongs to. */
  bundleConfiguration: PresentationBusinessOverviewBundleConfiguration;
  businessItems: PresentationBusinessOverviewItemConnection;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The display name of the business as it should appear on the page. CMK-encrypted. */
  displayName: Scalars['String']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The order in which this business is rendered within the bundle. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PresentationBusinessOverviewBusinessConfigurationBusinessItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationBusinessOverviewItemOrder>>;
  where?: InputMaybe<PresentationBusinessOverviewItemWhereInput>;
};

/** A connection to a list of items. */
export type PresentationBusinessOverviewBusinessConfigurationConnection = {
  __typename?: 'PresentationBusinessOverviewBusinessConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationBusinessOverviewBusinessConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationBusinessOverviewBusinessConfigurationEdge = {
  __typename?: 'PresentationBusinessOverviewBusinessConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationBusinessOverviewBusinessConfiguration>;
};

/** Ordering options for PresentationBusinessOverviewBusinessConfiguration connections */
export type PresentationBusinessOverviewBusinessConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationBusinessOverviewBusinessConfigurations. */
  field: PresentationBusinessOverviewBusinessConfigurationOrderField;
};

/** Properties by which PresentationBusinessOverviewBusinessConfiguration connections can be ordered. */
export enum PresentationBusinessOverviewBusinessConfigurationOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationBusinessOverviewBusinessConfigurationWhereInput is used for filtering PresentationBusinessOverviewBusinessConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationBusinessOverviewBusinessConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationBusinessOverviewBusinessConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** bundle_configuration edge predicates */
  hasBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleConfigurationWith?: InputMaybe<Array<PresentationBusinessOverviewBundleConfigurationWhereInput>>;
  /** business_items edge predicates */
  hasBusinessItems?: InputMaybe<Scalars['Boolean']['input']>;
  hasBusinessItemsWith?: InputMaybe<Array<PresentationBusinessOverviewItemWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PresentationBusinessOverviewBusinessConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationBusinessOverviewBusinessConfigurationWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationBusinessOverviewItem = Node & {
  __typename?: 'PresentationBusinessOverviewItem';
  /** Body text rendered for the item. */
  body: Scalars['String']['output'];
  /** The business-overview business configuration this item belongs to. */
  businessConfiguration: PresentationBusinessOverviewBusinessConfiguration;
  /** Source citations grounding this item. */
  citations?: Maybe<Array<PresentationItemCitation>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Short label rendered above the item body. */
  label: Scalars['String']['output'];
  /** The order in which this item is rendered within its parent. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PresentationBusinessOverviewItemConnection = {
  __typename?: 'PresentationBusinessOverviewItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationBusinessOverviewItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationBusinessOverviewItemEdge = {
  __typename?: 'PresentationBusinessOverviewItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationBusinessOverviewItem>;
};

/** Ordering options for PresentationBusinessOverviewItem connections */
export type PresentationBusinessOverviewItemOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationBusinessOverviewItems. */
  field: PresentationBusinessOverviewItemOrderField;
};

/** Properties by which PresentationBusinessOverviewItem connections can be ordered. */
export enum PresentationBusinessOverviewItemOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationBusinessOverviewItemWhereInput is used for filtering PresentationBusinessOverviewItem objects.
 * Input was generated by ent.
 */
export type PresentationBusinessOverviewItemWhereInput = {
  and?: InputMaybe<Array<PresentationBusinessOverviewItemWhereInput>>;
  /** body field predicates */
  body?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** business_configuration edge predicates */
  hasBusinessConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBusinessConfigurationWith?: InputMaybe<Array<PresentationBusinessOverviewBusinessConfigurationWhereInput>>;
  /** citations edge predicates */
  hasCitations?: InputMaybe<Scalars['Boolean']['input']>;
  hasCitationsWith?: InputMaybe<Array<PresentationItemCitationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<PresentationBusinessOverviewItemWhereInput>;
  or?: InputMaybe<Array<PresentationBusinessOverviewItemWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationCanvasBorder = {
  __typename?: 'PresentationCanvasBorder';
  color: PresentationCanvasColor;
  /** width is the line width in slide units. */
  width: Scalars['Float']['output'];
};

export type PresentationCanvasBorderInput = {
  color: PresentationCanvasColorInput;
  width: Scalars['Float']['input'];
};

/**
 * PresentationCanvasColor is a color of a canvas element. Exactly one field is
 * set. A theme color follows the current branding of the tenant or sub-brand.
 */
export type PresentationCanvasColor = {
  __typename?: 'PresentationCanvasColor';
  /** hex is a "#RRGGBB" value. */
  hex?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<PresentationCanvasThemeColor>;
};

export type PresentationCanvasColorInput = {
  hex?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<PresentationCanvasThemeColor>;
};

/**
 * PresentationCanvasDocument is the body of a CANVAS custom page: text, shape,
 * and image elements placed anywhere on the slide. Frames use slide units, one
 * hundredth of an inch from the top-left corner of the US Letter landscape
 * slide.
 */
export type PresentationCanvasDocument = {
  __typename?: 'PresentationCanvasDocument';
  /** elements is in paint order: later elements are drawn above earlier elements. */
  elements: Array<PresentationCanvasElement>;
  /** schemaVersion is the document format version. */
  schemaVersion: Scalars['Int']['output'];
};

export type PresentationCanvasDocumentInput = {
  elements: Array<PresentationCanvasElementInput>;
  schemaVersion: Scalars['Int']['input'];
};

/**
 * PresentationCanvasElement is one positioned item on a canvas slide. kind
 * selects which of text, shape, and image applies. A SHAPE element can also have
 * text, which renders inside the shape.
 */
export type PresentationCanvasElement = {
  __typename?: 'PresentationCanvasElement';
  /**
   * elementID is client-generated, unique in the document, and stable for the
   * life of the element. Copied pages keep the same element IDs.
   */
  elementID: Scalars['String']['output'];
  frame: PresentationCanvasFrame;
  image?: Maybe<PresentationCanvasImage>;
  kind: PresentationCanvasElementKind;
  shape?: Maybe<PresentationCanvasShape>;
  text?: Maybe<PresentationCanvasText>;
};

export type PresentationCanvasElementInput = {
  elementID: Scalars['String']['input'];
  frame: PresentationCanvasFrameInput;
  image?: InputMaybe<PresentationCanvasImageInput>;
  kind: PresentationCanvasElementKind;
  shape?: InputMaybe<PresentationCanvasShapeInput>;
  text?: InputMaybe<PresentationCanvasTextInput>;
};

export enum PresentationCanvasElementKind {
  Image = 'IMAGE',
  Shape = 'SHAPE',
  Text = 'TEXT'
}

/**
 * PresentationCanvasFrame is the top-left corner and size of an element, in
 * slide units.
 */
export type PresentationCanvasFrame = {
  __typename?: 'PresentationCanvasFrame';
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type PresentationCanvasFrameInput = {
  height: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

/**
 * PresentationCanvasImage places an Image in an IMAGE element. A client page
 * can place only HOUSEHOLD images of its household. A template page can place
 * only TENANT images of its tenant.
 */
export type PresentationCanvasImage = {
  __typename?: 'PresentationCanvasImage';
  /** altText describes the image for assistive technology and agents. */
  altText?: Maybe<Scalars['String']['output']>;
  fit: PresentationCanvasImageFit;
  imageID: Scalars['ID']['output'];
};

export enum PresentationCanvasImageFit {
  /** CONTAIN shows the whole image inside the frame. */
  Contain = 'CONTAIN',
  /** COVER fills the frame and crops the overflow. */
  Cover = 'COVER'
}

export type PresentationCanvasImageInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  fit: PresentationCanvasImageFit;
  imageID: Scalars['ID']['input'];
};

/** PresentationCanvasShape is the outline and fill of a SHAPE element. */
export type PresentationCanvasShape = {
  __typename?: 'PresentationCanvasShape';
  /** border is the outline. Null means no border. */
  border?: Maybe<PresentationCanvasBorder>;
  /**
   * cornerRadius is used by ROUNDED_RECTANGLE, in slide units. Null
   * means the renderer default.
   */
  cornerRadius?: Maybe<Scalars['Float']['output']>;
  /** fill is the background. Null means no fill. */
  fill?: Maybe<PresentationCanvasColor>;
  kind: PresentationCanvasShapeKind;
};

export type PresentationCanvasShapeInput = {
  border?: InputMaybe<PresentationCanvasBorderInput>;
  cornerRadius?: InputMaybe<Scalars['Float']['input']>;
  fill?: InputMaybe<PresentationCanvasColorInput>;
  kind: PresentationCanvasShapeKind;
};

export enum PresentationCanvasShapeKind {
  Ellipse = 'ELLIPSE',
  Rectangle = 'RECTANGLE',
  RoundedRectangle = 'ROUNDED_RECTANGLE'
}

/** PresentationCanvasText is the rich text of a TEXT or SHAPE element. */
export type PresentationCanvasText = {
  __typename?: 'PresentationCanvasText';
  /** content is a serialized Lexical editor state. */
  content: Scalars['LexicalEditorState']['output'];
  /**
   * defaultColor is the text color where the Lexical state sets none. Null
   * means the theme text color.
   */
  defaultColor?: Maybe<PresentationCanvasColor>;
  /**
   * padding is the inner space on every side, in slide units. Null
   * means the renderer default.
   */
  padding?: Maybe<Scalars['Float']['output']>;
  /** verticalAlign places the text in the frame. Null means TOP. */
  verticalAlign?: Maybe<PresentationCanvasVerticalAlign>;
};

export type PresentationCanvasTextInput = {
  content: Scalars['LexicalEditorState']['input'];
  defaultColor?: InputMaybe<PresentationCanvasColorInput>;
  padding?: InputMaybe<Scalars['Float']['input']>;
  verticalAlign?: InputMaybe<PresentationCanvasVerticalAlign>;
};

export enum PresentationCanvasThemeColor {
  DataVizPrimary = 'DATA_VIZ_PRIMARY',
  DataVizSecondary = 'DATA_VIZ_SECONDARY',
  DataVizTertiary = 'DATA_VIZ_TERTIARY',
  LightGray = 'LIGHT_GRAY',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Text = 'TEXT',
  White = 'WHITE'
}

export enum PresentationCanvasVerticalAlign {
  Bottom = 'BOTTOM',
  Middle = 'MIDDLE',
  Top = 'TOP'
}

export type PresentationCoverPage = Node & {
  __typename?: 'PresentationCoverPage';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The content of the cover page, rendered as Markdown. */
  customContent?: Maybe<Scalars['String']['output']>;
  /** Prompt used to generate the custom content. */
  customPrompt?: Maybe<Scalars['String']['output']>;
  /** Customizable title to display on the cover page. */
  displayTitle?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  page?: Maybe<PresentationPage>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

export type PresentationCoverSlideBackgroundImageUpload = {
  __typename?: 'PresentationCoverSlideBackgroundImageUpload';
  uploadMethod: Scalars['String']['output'];
  uploadURL: Scalars['String']['output'];
  uploadURLExpiresInSeconds: Scalars['Int']['output'];
};

export type PresentationCoverSlideConfig = Node & {
  __typename?: 'PresentationCoverSlideConfig';
  /** Alpha blending for the background (image and color); 1.0 = fully opaque. */
  backgroundAlpha?: Maybe<Scalars['Float']['output']>;
  /** Hex color code for the slide background. */
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** Background gradient angle in degrees, from 0 to 360. */
  backgroundGradientAngle?: Maybe<Scalars['Float']['output']>;
  /** Hex end color for the background gradient; when null, use the existing background. */
  backgroundGradientEndColor?: Maybe<Scalars['String']['output']>;
  /** X coordinate (origin) of the background image on the slide. */
  backgroundImageOriginX?: Maybe<Scalars['Float']['output']>;
  /** Y coordinate (origin) of the background image on the slide. */
  backgroundImageOriginY?: Maybe<Scalars['Float']['output']>;
  /** URL pointing to an uploaded background image asset. */
  backgroundImagePath?: Maybe<Scalars['String']['output']>;
  /** Scale of the background image on the slide, expressed as a percentage; clamped to [50, 150]. */
  backgroundImagePercentScale?: Maybe<Scalars['Float']['output']>;
  /** Sanitized SVG content if the uploaded background image is an SVG. */
  backgroundImageSvgContent?: Maybe<Scalars['String']['output']>;
  /** Overlay opacity, from 0 (transparent) to 1 (opaque). */
  backgroundOverlayAlpha?: Maybe<Scalars['Float']['output']>;
  /** Overlay X origin as a percentage of slide width, from 0 to 100. */
  backgroundOverlayOriginX?: Maybe<Scalars['Float']['output']>;
  /** Overlay Y origin as a percentage of slide height, from 0 to 100. */
  backgroundOverlayOriginY?: Maybe<Scalars['Float']['output']>;
  /** URL pointing to an asset uploaded through the background image endpoint. */
  backgroundOverlayPath?: Maybe<Scalars['String']['output']>;
  /** Overlay scale as a percentage, from 1 to 200. */
  backgroundOverlayPercentScale?: Maybe<Scalars['Float']['output']>;
  /** Horizontal alignment of the body text on the slide; defaults to left-aligned. */
  bodyTextAlignment?: Maybe<PresentationCoverSlideConfigBodyTextAlignment>;
  /** Hex color code for the slide body text; overrides text_color for body content. */
  bodyTextColor?: Maybe<Scalars['String']['output']>;
  /** Discriminator: whether this config applies to cover slides or divider slides. */
  configType: PresentationCoverSlideConfigConfigType;
  createdAt: Scalars['Time']['output'];
  /** Whether the divider slide inherits all visual configuration from the cover slide. */
  dividerInheritCover?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide background alpha.
   * @deprecated Use `dividerInheritCover` instead.
   */
  dividerInheritCoverBackgroundAlpha?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide background color.
   * @deprecated Use `dividerInheritCover` instead.
   */
  dividerInheritCoverBackgroundColor?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide background image path.
   * @deprecated Use `dividerInheritCover` instead.
   */
  dividerInheritCoverBackgroundImagePath?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide background image SVG content.
   * @deprecated Use `dividerInheritCover` instead.
   */
  dividerInheritCoverBackgroundImageSvgContent?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide header text size.
   * @deprecated Use `dividerInheritCover` instead.
   */
  dividerInheritCoverHeaderTextSize?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide include footer setting.
   * @deprecated Use `dividerInheritCover` instead.
   */
  dividerInheritCoverIncludeFooter?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide logo position.
   * @deprecated Use `dividerInheritCover` instead.
   */
  dividerInheritCoverLogoPosition?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide logo size.
   * @deprecated Use `dividerInheritCover` instead.
   */
  dividerInheritCoverLogoSize?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide text color.
   * @deprecated Use `dividerInheritCover` instead.
   */
  dividerInheritCoverTextColor?: Maybe<Scalars['Boolean']['output']>;
  /** Hex color code for the footer; when null, use the existing footer color. */
  footerColor?: Maybe<Scalars['String']['output']>;
  /** Size of the header text on the slide. */
  headerTextSize?: Maybe<PresentationCoverSlideConfigHeaderTextSize>;
  /** Whether to hide the logo on the slide; defaults to false. */
  hideLogo?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Whether to include the footer on the slide; defaults to true. */
  includeFooter?: Maybe<Scalars['Boolean']['output']>;
  /** X coordinate (origin) of the logo on the slide. */
  logoOriginX?: Maybe<Scalars['Float']['output']>;
  /** Y coordinate (origin) of the logo on the slide. */
  logoOriginY?: Maybe<Scalars['Float']['output']>;
  /** Scale of the logo on the slide, expressed as a percentage; clamped to [1, 200]. */
  logoPercentScale?: Maybe<Scalars['Float']['output']>;
  /**
   * Deprecated: use logo_origin_x/logo_origin_y and use_default_logo_position. Position of the logo on the slide.
   * @deprecated Use `logoOriginX`/`logoOriginY` and `useDefaultLogoPosition` instead.
   */
  logoPosition?: Maybe<PresentationCoverSlideConfigLogoPosition>;
  /**
   * Deprecated: use logo_percent_scale. Size of the logo on the slide.
   * @deprecated Use `logoPercentScale` instead.
   */
  logoSize?: Maybe<PresentationCoverSlideConfigLogoSize>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** Hex color code for the slide text. */
  textColor?: Maybe<Scalars['String']['output']>;
  /** X coordinate (origin) of the text on the slide. */
  textOriginX?: Maybe<Scalars['Float']['output']>;
  /** Y coordinate (origin) of the text on the slide. */
  textOriginY?: Maybe<Scalars['Float']['output']>;
  /** Width of the text box on the slide, in the same slide-coordinate pixels as text_origin_x; when null, the text box fills the slide width. */
  textWidth?: Maybe<Scalars['Float']['output']>;
  /** Size of the title text on the slide, expressed in rem units; clamped to [0.1, 5.5]; overrides title_text_size when set. */
  titleSizeRem?: Maybe<Scalars['Float']['output']>;
  /** Size of the title text on the slide. */
  titleTextSize?: Maybe<PresentationCoverSlideConfigTitleTextSize>;
  updatedAt: Scalars['Time']['output'];
  /** Whether to use the dark logo; when null, use the existing logo selection. */
  useDarkLogo?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to use the default logo position on the slide; when true, logo_origin_x and logo_origin_y are ignored. */
  useDefaultLogoPosition?: Maybe<Scalars['Boolean']['output']>;
};

/** PresentationCoverSlideConfigBodyTextAlignment is enum for the field body_text_alignment */
export enum PresentationCoverSlideConfigBodyTextAlignment {
  CenterAligned = 'CENTER_ALIGNED',
  LeftAligned = 'LEFT_ALIGNED',
  RightAligned = 'RIGHT_ALIGNED'
}

/** PresentationCoverSlideConfigConfigType is enum for the field config_type */
export enum PresentationCoverSlideConfigConfigType {
  CoverSlide = 'COVER_SLIDE',
  DividerSlide = 'DIVIDER_SLIDE'
}

/** PresentationCoverSlideConfigHeaderTextSize is enum for the field header_text_size */
export enum PresentationCoverSlideConfigHeaderTextSize {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

/** PresentationCoverSlideConfigLogoPosition is enum for the field logo_position */
export enum PresentationCoverSlideConfigLogoPosition {
  BottomLeft = 'BOTTOM_LEFT',
  BottomRight = 'BOTTOM_RIGHT',
  Default = 'DEFAULT',
  None = 'NONE',
  TopLeft = 'TOP_LEFT',
  TopRight = 'TOP_RIGHT'
}

/** PresentationCoverSlideConfigLogoSize is enum for the field logo_size */
export enum PresentationCoverSlideConfigLogoSize {
  ExtraLarge = 'EXTRA_LARGE',
  ExtraSmall = 'EXTRA_SMALL',
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

/** PresentationCoverSlideConfigTitleTextSize is enum for the field title_text_size */
export enum PresentationCoverSlideConfigTitleTextSize {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export type PresentationCustomPage = Node & {
  __typename?: 'PresentationCustomPage';
  /** Positioned text, shape, and image elements of a CANVAS page. */
  canvasDocument?: Maybe<PresentationCanvasDocument>;
  /** Increases by one on each write of canvas_document. */
  canvasRevision: Scalars['Int']['output'];
  /** Selects the page body: page_content for MARKDOWN or canvas_document for CANVAS. */
  contentFormat: PresentationCustomPageContentFormat;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Prompt used to generate the page content. */
  customPrompt?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  page?: Maybe<PresentationPage>;
  /** The content of a MARKDOWN custom page, rendered as Markdown. CANVAS pages store an empty string. */
  pageContent: Scalars['String']['output'];
  /** The title to display on the custom page. */
  pageName: Scalars['String']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

export type PresentationCustomPageBundleConfiguration = Node & {
  __typename?: 'PresentationCustomPageBundleConfiguration';
  bundle?: Maybe<PresentationBundle>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** If true, the page header and sub-header will be included on the page. */
  includePageHeader: Scalars['Boolean']['output'];
  /** The header to display on the page. */
  pageHeader?: Maybe<Scalars['String']['output']>;
  /** The sub-header to display on the page. */
  pageSubheader?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for PresentationCustomPageBundleConfiguration connections */
export type PresentationCustomPageBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationCustomPageBundleConfigurations. */
  field: PresentationCustomPageBundleConfigurationOrderField;
};

/** Properties by which PresentationCustomPageBundleConfiguration connections can be ordered. */
export enum PresentationCustomPageBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationCustomPageBundleConfigurationWhereInput is used for filtering PresentationCustomPageBundleConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationCustomPageBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationCustomPageBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_page_header field predicates */
  includePageHeader?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<PresentationCustomPageBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationCustomPageBundleConfigurationWhereInput>>;
  /** page_header field predicates */
  pageHeader?: InputMaybe<Scalars['String']['input']>;
  pageHeaderIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  pageHeaderNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** page_subheader field predicates */
  pageSubheader?: InputMaybe<Scalars['String']['input']>;
  pageSubheaderIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  pageSubheaderNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** A connection to a list of items. */
export type PresentationCustomPageConnection = {
  __typename?: 'PresentationCustomPageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationCustomPageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** PresentationCustomPageContentFormat is enum for the field content_format */
export enum PresentationCustomPageContentFormat {
  Canvas = 'CANVAS',
  Markdown = 'MARKDOWN'
}

/** An edge in a connection. */
export type PresentationCustomPageEdge = {
  __typename?: 'PresentationCustomPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationCustomPage>;
};

/** PresentationCustomSlidePromptResult is the result payload for one-off custom slide prompt generation. */
export type PresentationCustomSlidePromptResult = {
  __typename?: 'PresentationCustomSlidePromptResult';
  /** error contains a user-facing message when generation fails. */
  error?: Maybe<Scalars['String']['output']>;
  /** generatedContent is the final generated markdown content on the terminal success event. */
  generatedContent?: Maybe<Scalars['String']['output']>;
  /**
   * isComplete indicates whether generation for this request has finished.
   * Streaming chunk events set isComplete to false.
   */
  isComplete: Scalars['Boolean']['output'];
  /** textDelta is a streamed markdown chunk emitted while generation is in progress. */
  textDelta?: Maybe<Scalars['String']['output']>;
};

export type PresentationDiagramEdgeDefinition = DiagramEdge & {
  __typename?: 'PresentationDiagramEdgeDefinition';
  /**
   * conditional marks a transfer whose execution depends on a condition the
   * documents describe (e.g. a qualified disclaimer); rendered dashed.
   */
  conditional?: Maybe<Scalars['Boolean']['output']>;
  edgeID: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  sourceHandle?: Maybe<Scalars['String']['output']>;
  sourceNodeID: Scalars['ID']['output'];
  targetHandle?: Maybe<Scalars['String']['output']>;
  targetNodeID: Scalars['ID']['output'];
};

export type PresentationDiagramEdgeDefinitionInput = {
  /**
   * conditional marks a transfer whose execution depends on a condition the
   * documents describe (e.g. a qualified disclaimer); rendered dashed.
   */
  conditional?: InputMaybe<Scalars['Boolean']['input']>;
  edgeID: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  sourceHandle?: InputMaybe<Scalars['String']['input']>;
  sourceNodeID: Scalars['ID']['input'];
  targetHandle?: InputMaybe<Scalars['String']['input']>;
  targetNodeID: Scalars['ID']['input'];
};

export type PresentationDiagramNodeConfiguration = DiagramNode & {
  __typename?: 'PresentationDiagramNodeConfiguration';
  /**
   * entityNodeID is the knowledge-graph node this tile stands for, when the
   * diagram was generated with entity grounding. Null for beneficiary-group
   * tiles, user-created tiles, and diagrams generated before grounding existed.
   * Not enforced at the API layer.
   */
  entityNodeID?: Maybe<Scalars['ID']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  /**
   * iconShape controls the rendered shape of the node's icon/tile.
   * Expected values: "CIRCLE", "SQUARE", "TRIANGLE", "DIAMOND".
   * A null value defaults to circle on the client. Not enforced at the API layer.
   */
  iconShape?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  nodeID: Scalars['ID']['output'];
  /** notes holds user-authored markdown displayed inside the tile. */
  notes?: Maybe<Scalars['String']['output']>;
  /** phase is the zero-based life-event era in which the node is created/funded; null when the diagram has no phases. */
  phase?: Maybe<Scalars['Int']['output']>;
  semanticGroup: Scalars['String']['output'];
  /**
   * tileEmphasis controls the contrast level of non-icon tiles.
   * Expected values: "LOW", "MEDIUM", "HIGH".
   * A null value defaults to low on the client. Not enforced at the API layer.
   */
  tileEmphasis?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  xPosition?: Maybe<Scalars['Float']['output']>;
  yPosition?: Maybe<Scalars['Float']['output']>;
};

export type PresentationDiagramNodeConfigurationInput = {
  /**
   * entityNodeID is the knowledge-graph node this tile stands for, when the
   * diagram was generated with entity grounding. Null for beneficiary-group
   * tiles, user-created tiles, and diagrams generated before grounding existed.
   * Not enforced at the API layer.
   */
  entityNodeID?: InputMaybe<Scalars['ID']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  /**
   * iconShape controls the rendered shape of the node's icon/tile.
   * Expected values: "CIRCLE", "SQUARE", "TRIANGLE", "DIAMOND".
   * A null value defaults to circle on the client. Not enforced at the API layer.
   */
  iconShape?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  nodeID: Scalars['ID']['input'];
  /** notes holds user-authored markdown displayed inside the tile. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** phase is the zero-based life-event era in which the node is created/funded; null when the diagram has no phases. */
  phase?: InputMaybe<Scalars['Int']['input']>;
  semanticGroup: Scalars['String']['input'];
  /**
   * tileEmphasis controls the contrast level of non-icon tiles.
   * Expected values: "LOW", "MEDIUM", "HIGH".
   * A null value defaults to low on the client. Not enforced at the API layer.
   */
  tileEmphasis?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  xPosition?: InputMaybe<Scalars['Float']['input']>;
  yPosition?: InputMaybe<Scalars['Float']['input']>;
};

export type PresentationDiagramPage = Node & {
  __typename?: 'PresentationDiagramPage';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Prompt used to generate/update the diagram. */
  customPrompt?: Maybe<Scalars['String']['output']>;
  /** Canonical edge definitions for the diagram graph. */
  edgeDefinitions: Array<PresentationDiagramEdgeDefinition>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Canonical node definitions plus layout settings for the diagram graph. */
  nodeConfigurations: Array<PresentationDiagramNodeConfiguration>;
  page?: Maybe<PresentationPage>;
  /** The title to display on the diagram page. */
  pageName: Scalars['String']['output'];
  /** Optional life-event eras (phase bands) structuring the diagram top-to-bottom. */
  phases?: Maybe<PresentationDiagramPhases>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** PresentationDiagramPhaseBand labels a single phase transition (e.g. "At Phil's death"). */
export type PresentationDiagramPhaseBand = {
  __typename?: 'PresentationDiagramPhaseBand';
  belowPhaseIndex: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/** PresentationDiagramPhaseBandInput contains a single phase transition. */
export type PresentationDiagramPhaseBandInput = {
  belowPhaseIndex: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

/** PresentationDiagramPhases holds the optional life-event era structure for a diagram. */
export type PresentationDiagramPhases = {
  __typename?: 'PresentationDiagramPhases';
  bands: Array<PresentationDiagramPhaseBand>;
};

/** PresentationDiagramPhasesInput contains the optional life-event era structure for a diagram. */
export type PresentationDiagramPhasesInput = {
  bands: Array<PresentationDiagramPhaseBandInput>;
};

/** PresentationDocumentType is enum for the field document_type */
export enum PresentationDocumentType {
  AccountDocumentationStatement = 'ACCOUNT_DOCUMENTATION_STATEMENT',
  AdvanceDirective = 'ADVANCE_DIRECTIVE',
  ArticlesOfIncorporation = 'ARTICLES_OF_INCORPORATION',
  AssetValuation = 'ASSET_VALUATION',
  AssignmentOfInterest = 'ASSIGNMENT_OF_INTEREST',
  AssignmentOfTangibleProperty = 'ASSIGNMENT_OF_TANGIBLE_PROPERTY',
  BalanceSheet = 'BALANCE_SHEET',
  BeneficialOwnershipInformationReport = 'BENEFICIAL_OWNERSHIP_INFORMATION_REPORT',
  BeneficiaryDesignation = 'BENEFICIARY_DESIGNATION',
  Binder = 'BINDER',
  CertificateOfTrust = 'CERTIFICATE_OF_TRUST',
  CorporateBylaws = 'CORPORATE_BYLAWS',
  CrummeyLetter = 'CRUMMEY_LETTER',
  Deed = 'DEED',
  DivorceSettlement = 'DIVORCE_SETTLEMENT',
  DriversLicense = 'DRIVERS_LICENSE',
  ExistingRemainderTrustDocument = 'EXISTING_REMAINDER_TRUST_DOCUMENT',
  FincenFiling = 'FINCEN_FILING',
  GeneratedDocument = 'GENERATED_DOCUMENT',
  GeneratedPresentation = 'GENERATED_PRESENTATION',
  GiftTaxReturn = 'GIFT_TAX_RETURN',
  GratDesignSummary = 'GRAT_DESIGN_SUMMARY',
  HealthcareProxy = 'HEALTHCARE_PROXY',
  HipaaWaiver = 'HIPAA_WAIVER',
  HouseholdExport = 'HOUSEHOLD_EXPORT',
  IncomeTaxReturn = 'INCOME_TAX_RETURN',
  InsurancePolicy = 'INSURANCE_POLICY',
  InsurancePremiumPayment = 'INSURANCE_PREMIUM_PAYMENT',
  LetterOfWishes = 'LETTER_OF_WISHES',
  LivingWill = 'LIVING_WILL',
  LlcAgreement = 'LLC_AGREEMENT',
  LlcAgreementAmendment = 'LLC_AGREEMENT_AMENDMENT',
  LoanNoteAgreement = 'LOAN_NOTE_AGREEMENT',
  LoggedContribution = 'LOGGED_CONTRIBUTION',
  LoggedDistribution = 'LOGGED_DISTRIBUTION',
  OperatingAgreement = 'OPERATING_AGREEMENT',
  OperatingAgreementAmendment = 'OPERATING_AGREEMENT_AMENDMENT',
  Other = 'OTHER',
  PartnershipAgreement = 'PARTNERSHIP_AGREEMENT',
  PartnershipAgreementAmendment = 'PARTNERSHIP_AGREEMENT_AMENDMENT',
  Passport = 'PASSPORT',
  PowerOfAttorney = 'POWER_OF_ATTORNEY',
  PrenuptialAgreement = 'PRENUPTIAL_AGREEMENT',
  ShareholdersAgreement = 'SHAREHOLDERS_AGREEMENT',
  SignedTrustDocument = 'SIGNED_TRUST_DOCUMENT',
  StateBusinessFiling = 'STATE_BUSINESS_FILING',
  TaxFiling = 'TAX_FILING',
  TaxIdConfirmation = 'TAX_ID_CONFIRMATION',
  TaxReceipt = 'TAX_RECEIPT',
  TransferConfirmation = 'TRANSFER_CONFIRMATION',
  TrustAmendment = 'TRUST_AMENDMENT',
  TrustRelatedDocument = 'TRUST_RELATED_DOCUMENT',
  Will = 'WILL',
  WillCodicil = 'WILL_CODICIL'
}

export type PresentationDocumentsReviewedBundleConfiguration = Node & {
  __typename?: 'PresentationDocumentsReviewedBundleConfiguration';
  bundle?: Maybe<PresentationBundle>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Optional override for the bundle's display name on the documents-reviewed page. */
  displayName?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  reviewedDocuments: PresentationDocumentsReviewedDocumentConnection;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PresentationDocumentsReviewedBundleConfigurationReviewedDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationDocumentsReviewedDocumentOrder>>;
  where?: InputMaybe<PresentationDocumentsReviewedDocumentWhereInput>;
};

/** A connection to a list of items. */
export type PresentationDocumentsReviewedBundleConfigurationConnection = {
  __typename?: 'PresentationDocumentsReviewedBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationDocumentsReviewedBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationDocumentsReviewedBundleConfigurationEdge = {
  __typename?: 'PresentationDocumentsReviewedBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationDocumentsReviewedBundleConfiguration>;
};

/** Ordering options for PresentationDocumentsReviewedBundleConfiguration connections */
export type PresentationDocumentsReviewedBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationDocumentsReviewedBundleConfigurations. */
  field: PresentationDocumentsReviewedBundleConfigurationOrderField;
};

/** Properties by which PresentationDocumentsReviewedBundleConfiguration connections can be ordered. */
export enum PresentationDocumentsReviewedBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationDocumentsReviewedBundleConfigurationWhereInput is used for filtering PresentationDocumentsReviewedBundleConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationDocumentsReviewedBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationDocumentsReviewedBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** reviewed_documents edge predicates */
  hasReviewedDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasReviewedDocumentsWith?: InputMaybe<Array<PresentationDocumentsReviewedDocumentWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PresentationDocumentsReviewedBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationDocumentsReviewedBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationDocumentsReviewedDocument = Node & {
  __typename?: 'PresentationDocumentsReviewedDocument';
  /** The documents-reviewed bundle configuration this document entry belongs to. */
  bundleConfiguration?: Maybe<PresentationDocumentsReviewedBundleConfiguration>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Pre-formatted date label rendered alongside the document name. */
  dateDisplay: Scalars['String']['output'];
  /** Optional link to the underlying Document; document_name and date_display remain valid if the document is later removed. */
  document?: Maybe<Document>;
  /** The display name of the reviewed document. */
  documentName: Scalars['String']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The order in which this document should be displayed within the bundle. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PresentationDocumentsReviewedDocumentConnection = {
  __typename?: 'PresentationDocumentsReviewedDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationDocumentsReviewedDocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationDocumentsReviewedDocumentEdge = {
  __typename?: 'PresentationDocumentsReviewedDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationDocumentsReviewedDocument>;
};

/** Ordering options for PresentationDocumentsReviewedDocument connections */
export type PresentationDocumentsReviewedDocumentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationDocumentsReviewedDocuments. */
  field: PresentationDocumentsReviewedDocumentOrderField;
};

/** Properties by which PresentationDocumentsReviewedDocument connections can be ordered. */
export enum PresentationDocumentsReviewedDocumentOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationDocumentsReviewedDocumentWhereInput is used for filtering PresentationDocumentsReviewedDocument objects.
 * Input was generated by ent.
 */
export type PresentationDocumentsReviewedDocumentWhereInput = {
  and?: InputMaybe<Array<PresentationDocumentsReviewedDocumentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** date_display field predicates */
  dateDisplay?: InputMaybe<Scalars['String']['input']>;
  /** document_name field predicates */
  documentName?: InputMaybe<Scalars['String']['input']>;
  /** bundle_configuration edge predicates */
  hasBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleConfigurationWith?: InputMaybe<Array<PresentationDocumentsReviewedBundleConfigurationWhereInput>>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PresentationDocumentsReviewedDocumentWhereInput>;
  or?: InputMaybe<Array<PresentationDocumentsReviewedDocumentWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationFamilyOverviewBundleConfiguration = Node & {
  __typename?: 'PresentationFamilyOverviewBundleConfiguration';
  bundle: PresentationBundle;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Optional override for the bundle's display name on the family-overview page. */
  displayName?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  members: PresentationFamilyOverviewMemberConfigurationConnection;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PresentationFamilyOverviewBundleConfigurationMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationFamilyOverviewMemberConfigurationOrder>>;
  where?: InputMaybe<PresentationFamilyOverviewMemberConfigurationWhereInput>;
};

/** A connection to a list of items. */
export type PresentationFamilyOverviewBundleConfigurationConnection = {
  __typename?: 'PresentationFamilyOverviewBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationFamilyOverviewBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationFamilyOverviewBundleConfigurationEdge = {
  __typename?: 'PresentationFamilyOverviewBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationFamilyOverviewBundleConfiguration>;
};

/** Ordering options for PresentationFamilyOverviewBundleConfiguration connections */
export type PresentationFamilyOverviewBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationFamilyOverviewBundleConfigurations. */
  field: PresentationFamilyOverviewBundleConfigurationOrderField;
};

/** Properties by which PresentationFamilyOverviewBundleConfiguration connections can be ordered. */
export enum PresentationFamilyOverviewBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationFamilyOverviewBundleConfigurationWhereInput is used for filtering PresentationFamilyOverviewBundleConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationFamilyOverviewBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationFamilyOverviewBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** members edge predicates */
  hasMembers?: InputMaybe<Scalars['Boolean']['input']>;
  hasMembersWith?: InputMaybe<Array<PresentationFamilyOverviewMemberConfigurationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PresentationFamilyOverviewBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationFamilyOverviewBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationFamilyOverviewMemberConfiguration = Node & {
  __typename?: 'PresentationFamilyOverviewMemberConfiguration';
  /** The family-overview bundle configuration this member belongs to. */
  bundleConfiguration: PresentationFamilyOverviewBundleConfiguration;
  /** Source citations grounding this family member entry. */
  citations?: Maybe<Array<PresentationItemCitation>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** A short prose description of the family member rendered beneath the name and relationship. */
  description: Scalars['String']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The display name of the family member as it should appear on the page. */
  name: Scalars['String']['output'];
  /** The family member's relationship to the household (e.g., 'Spouse', 'Daughter'). */
  relationship: Scalars['String']['output'];
  /** The order in which this family member is rendered within the bundle. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PresentationFamilyOverviewMemberConfigurationConnection = {
  __typename?: 'PresentationFamilyOverviewMemberConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationFamilyOverviewMemberConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationFamilyOverviewMemberConfigurationEdge = {
  __typename?: 'PresentationFamilyOverviewMemberConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationFamilyOverviewMemberConfiguration>;
};

/** Ordering options for PresentationFamilyOverviewMemberConfiguration connections */
export type PresentationFamilyOverviewMemberConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationFamilyOverviewMemberConfigurations. */
  field: PresentationFamilyOverviewMemberConfigurationOrderField;
};

/** Properties by which PresentationFamilyOverviewMemberConfiguration connections can be ordered. */
export enum PresentationFamilyOverviewMemberConfigurationOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationFamilyOverviewMemberConfigurationWhereInput is used for filtering PresentationFamilyOverviewMemberConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationFamilyOverviewMemberConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationFamilyOverviewMemberConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  /** bundle_configuration edge predicates */
  hasBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleConfigurationWith?: InputMaybe<Array<PresentationFamilyOverviewBundleConfigurationWhereInput>>;
  /** citations edge predicates */
  hasCitations?: InputMaybe<Scalars['Boolean']['input']>;
  hasCitationsWith?: InputMaybe<Array<PresentationItemCitationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<PresentationFamilyOverviewMemberConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationFamilyOverviewMemberConfigurationWhereInput>>;
  /** relationship field predicates */
  relationship?: InputMaybe<Scalars['String']['input']>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** PresentationHeaderFontFace is enum for the field presentation_header_font_face */
export enum PresentationHeaderFontFace {
  Arial = 'ARIAL',
  Default = 'DEFAULT'
}

export type PresentationHealthcareDirectiveBundleConfiguration = Node & {
  __typename?: 'PresentationHealthcareDirectiveBundleConfiguration';
  bundle: PresentationBundle;
  clients: PresentationHealthcareDirectiveClientConfigurationConnection;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Optional override for the bundle's display name on the healthcare-directive page. */
  displayName?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Maximum number of clients rendered on each page. */
  itemsPerPage: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PresentationHealthcareDirectiveBundleConfigurationClientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationHealthcareDirectiveClientConfigurationOrder>>;
  where?: InputMaybe<PresentationHealthcareDirectiveClientConfigurationWhereInput>;
};

/** A connection to a list of items. */
export type PresentationHealthcareDirectiveBundleConfigurationConnection = {
  __typename?: 'PresentationHealthcareDirectiveBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationHealthcareDirectiveBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationHealthcareDirectiveBundleConfigurationEdge = {
  __typename?: 'PresentationHealthcareDirectiveBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationHealthcareDirectiveBundleConfiguration>;
};

/** Ordering options for PresentationHealthcareDirectiveBundleConfiguration connections */
export type PresentationHealthcareDirectiveBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationHealthcareDirectiveBundleConfigurations. */
  field: PresentationHealthcareDirectiveBundleConfigurationOrderField;
};

/** Properties by which PresentationHealthcareDirectiveBundleConfiguration connections can be ordered. */
export enum PresentationHealthcareDirectiveBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationHealthcareDirectiveBundleConfigurationWhereInput is used for filtering PresentationHealthcareDirectiveBundleConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationHealthcareDirectiveBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationHealthcareDirectiveBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** clients edge predicates */
  hasClients?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientsWith?: InputMaybe<Array<PresentationHealthcareDirectiveClientConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** items_per_page field predicates */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageGT?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageGTE?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageLT?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageLTE?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageNEQ?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<PresentationHealthcareDirectiveBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationHealthcareDirectiveBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationHealthcareDirectiveClientConfiguration = Node & {
  __typename?: 'PresentationHealthcareDirectiveClientConfiguration';
  /** The healthcare-directive bundle configuration this client entry belongs to. */
  bundleConfiguration: PresentationHealthcareDirectiveBundleConfiguration;
  /** The display name of the client as it should appear on the page. */
  client: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  healthcareDirectiveItems: PresentationHealthcareDirectiveItemConnection;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The order in which this client is rendered within the bundle. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PresentationHealthcareDirectiveClientConfigurationHealthcareDirectiveItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationHealthcareDirectiveItemOrder>>;
  where?: InputMaybe<PresentationHealthcareDirectiveItemWhereInput>;
};

/** A connection to a list of items. */
export type PresentationHealthcareDirectiveClientConfigurationConnection = {
  __typename?: 'PresentationHealthcareDirectiveClientConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationHealthcareDirectiveClientConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationHealthcareDirectiveClientConfigurationEdge = {
  __typename?: 'PresentationHealthcareDirectiveClientConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationHealthcareDirectiveClientConfiguration>;
};

/** Ordering options for PresentationHealthcareDirectiveClientConfiguration connections */
export type PresentationHealthcareDirectiveClientConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationHealthcareDirectiveClientConfigurations. */
  field: PresentationHealthcareDirectiveClientConfigurationOrderField;
};

/** Properties by which PresentationHealthcareDirectiveClientConfiguration connections can be ordered. */
export enum PresentationHealthcareDirectiveClientConfigurationOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationHealthcareDirectiveClientConfigurationWhereInput is used for filtering PresentationHealthcareDirectiveClientConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationHealthcareDirectiveClientConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationHealthcareDirectiveClientConfigurationWhereInput>>;
  /** client field predicates */
  client?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** bundle_configuration edge predicates */
  hasBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleConfigurationWith?: InputMaybe<Array<PresentationHealthcareDirectiveBundleConfigurationWhereInput>>;
  /** healthcare_directive_items edge predicates */
  hasHealthcareDirectiveItems?: InputMaybe<Scalars['Boolean']['input']>;
  hasHealthcareDirectiveItemsWith?: InputMaybe<Array<PresentationHealthcareDirectiveItemWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PresentationHealthcareDirectiveClientConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationHealthcareDirectiveClientConfigurationWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationHealthcareDirectiveItem = Node & {
  __typename?: 'PresentationHealthcareDirectiveItem';
  /** Body text rendered for the item. */
  body: Scalars['String']['output'];
  /** Source citations grounding this item. */
  citations?: Maybe<Array<PresentationItemCitation>>;
  /** The healthcare-directive client configuration this item belongs to. */
  clientConfiguration: PresentationHealthcareDirectiveClientConfiguration;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Short label rendered above the item body. */
  label: Scalars['String']['output'];
  /** The order in which this item is rendered within its parent. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PresentationHealthcareDirectiveItemConnection = {
  __typename?: 'PresentationHealthcareDirectiveItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationHealthcareDirectiveItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationHealthcareDirectiveItemEdge = {
  __typename?: 'PresentationHealthcareDirectiveItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationHealthcareDirectiveItem>;
};

/** Ordering options for PresentationHealthcareDirectiveItem connections */
export type PresentationHealthcareDirectiveItemOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationHealthcareDirectiveItems. */
  field: PresentationHealthcareDirectiveItemOrderField;
};

/** Properties by which PresentationHealthcareDirectiveItem connections can be ordered. */
export enum PresentationHealthcareDirectiveItemOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationHealthcareDirectiveItemWhereInput is used for filtering PresentationHealthcareDirectiveItem objects.
 * Input was generated by ent.
 */
export type PresentationHealthcareDirectiveItemWhereInput = {
  and?: InputMaybe<Array<PresentationHealthcareDirectiveItemWhereInput>>;
  /** body field predicates */
  body?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** citations edge predicates */
  hasCitations?: InputMaybe<Scalars['Boolean']['input']>;
  hasCitationsWith?: InputMaybe<Array<PresentationItemCitationWhereInput>>;
  /** client_configuration edge predicates */
  hasClientConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientConfigurationWith?: InputMaybe<Array<PresentationHealthcareDirectiveClientConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<PresentationHealthcareDirectiveItemWhereInput>;
  or?: InputMaybe<Array<PresentationHealthcareDirectiveItemWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationItemCitation = Node & {
  __typename?: 'PresentationItemCitation';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Source document the cited span belongs to; deleting it removes the citation. */
  document: Document;
  /** The document span grounding the item — the file paragraphs whose text establishes it. */
  fileParagraphs?: Maybe<Array<FileParagraph>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for PresentationItemCitation connections */
export type PresentationItemCitationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationItemCitations. */
  field: PresentationItemCitationOrderField;
};

/** Properties by which PresentationItemCitation connections can be ordered. */
export enum PresentationItemCitationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationItemCitationWhereInput is used for filtering PresentationItemCitation objects.
 * Input was generated by ent.
 */
export type PresentationItemCitationWhereInput = {
  and?: InputMaybe<Array<PresentationItemCitationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** document edge predicates */
  hasDocument?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PresentationItemCitationWhereInput>;
  or?: InputMaybe<Array<PresentationItemCitationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationPage = Node & {
  __typename?: 'PresentationPage';
  activeEstateInsightsPage?: Maybe<ActiveEstateInsightsPage>;
  balanceSheetBundleConfiguration?: Maybe<BalanceSheetBundleConfiguration>;
  beneficiaryPage?: Maybe<BeneficiaryPage>;
  bundle?: Maybe<PresentationBundle>;
  completedEstateInsightsPage?: Maybe<CompletedEstateInsightsPage>;
  coverPage?: Maybe<PresentationCoverPage>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  customPage?: Maybe<PresentationCustomPage>;
  diagramPage?: Maybe<PresentationDiagramPage>;
  documentSummaryPage?: Maybe<DocumentSummaryPage>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The index of the page in the bundle */
  index: Scalars['Int']['output'];
  /** Indicates the kind of page this is. */
  kind: PresentationPageKind;
  missingDocumentsPage?: Maybe<MissingDocumentsPage>;
  presentationBundleCoverPage?: Maybe<PresentationBundleCoverPage>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /**
   * The effective database content override for this Education Page.
   * An organization-shared override takes precedence over a local override.
   * Returns null when the frontend must use bundled content or the page is not an
   * Education Page.
   */
  tenantSlideConfig?: Maybe<EffectiveEducationPageOverride>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  waterfallBundleCoverPage?: Maybe<WaterfallBundleCoverPage>;
};

/** A connection to a list of items. */
export type PresentationPageConnection = {
  __typename?: 'PresentationPageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationPageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationPageEdge = {
  __typename?: 'PresentationPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationPage>;
};

/** PresentationPageKind is enum for the field kind */
export enum PresentationPageKind {
  ActiveEstateInsightsPage = 'ACTIVE_ESTATE_INSIGHTS_PAGE',
  AssetDistributionPage = 'ASSET_DISTRIBUTION_PAGE',
  BalanceSheetExpandedCategoriesPage = 'BALANCE_SHEET_EXPANDED_CATEGORIES_PAGE',
  BalanceSheetExportPage = 'BALANCE_SHEET_EXPORT_PAGE',
  BalanceSheetPage = 'BALANCE_SHEET_PAGE',
  BeneficiaryReportBeneficiary = 'BENEFICIARY_REPORT_BENEFICIARY',
  BeneficiaryReportHousehold = 'BENEFICIARY_REPORT_HOUSEHOLD',
  BeneficiaryReportPage = 'BENEFICIARY_REPORT_PAGE',
  BusinessOverviewPage = 'BUSINESS_OVERVIEW_PAGE',
  CltStrategyExplainer = 'CLT_STRATEGY_EXPLAINER',
  CompletedEstateInsightsPage = 'COMPLETED_ESTATE_INSIGHTS_PAGE',
  ConnecticutEstateAndGiftTax = 'CONNECTICUT_ESTATE_AND_GIFT_TAX',
  CoverPage = 'COVER_PAGE',
  CrtStrategyExplainer = 'CRT_STRATEGY_EXPLAINER',
  CustomPage = 'CUSTOM_PAGE',
  DiagramPage = 'DIAGRAM_PAGE',
  DistrictOfColumbiaTax = 'DISTRICT_OF_COLUMBIA_TAX',
  Divider = 'DIVIDER',
  DocumentsReviewedPage = 'DOCUMENTS_REVIEWED_PAGE',
  DocumentSummaryPage = 'DOCUMENT_SUMMARY_PAGE',
  EntitiesDiagramPage = 'ENTITIES_DIAGRAM_PAGE',
  EntitiesSummaryPage = 'ENTITIES_SUMMARY_PAGE',
  EntityBalanceSheetExportPage = 'ENTITY_BALANCE_SHEET_EXPORT_PAGE',
  EntityBalanceSheetPage = 'ENTITY_BALANCE_SHEET_PAGE',
  EntityBeneficiariesAndDispositionsPage = 'ENTITY_BENEFICIARIES_AND_DISPOSITIONS_PAGE',
  EntityDiagramAndNotesPage = 'ENTITY_DIAGRAM_AND_NOTES_PAGE',
  EntityGraphViewPage = 'ENTITY_GRAPH_VIEW_PAGE',
  EntityInsurancePolicyPage = 'ENTITY_INSURANCE_POLICY_PAGE',
  EntitySummaryPage = 'ENTITY_SUMMARY_PAGE',
  EstatePlanningChecklist = 'ESTATE_PLANNING_CHECKLIST',
  EstatePlanningGlossary = 'ESTATE_PLANNING_GLOSSARY',
  EstateTaxesExplainer = 'ESTATE_TAXES_EXPLAINER',
  FamilyOverviewPage = 'FAMILY_OVERVIEW_PAGE',
  FamilyTreePage = 'FAMILY_TREE_PAGE',
  FlpStrategyExplainer = 'FLP_STRATEGY_EXPLAINER',
  GratStrategyExplainer = 'GRAT_STRATEGY_EXPLAINER',
  GstExplainer = 'GST_EXPLAINER',
  HawaiiEstateTax = 'HAWAII_ESTATE_TAX',
  HealthcareDirectivePage = 'HEALTHCARE_DIRECTIVE_PAGE',
  IdgtStrategyExplainer = 'IDGT_STRATEGY_EXPLAINER',
  IlitStrategyExplainer = 'ILIT_STRATEGY_EXPLAINER',
  IllinoisEstateTax = 'ILLINOIS_ESTATE_TAX',
  InstallmentSaleStrategyExplainer = 'INSTALLMENT_SALE_STRATEGY_EXPLAINER',
  KentuckyInheritanceTax = 'KENTUCKY_INHERITANCE_TAX',
  LiabilitiesPage = 'LIABILITIES_PAGE',
  LifeInsurancePage = 'LIFE_INSURANCE_PAGE',
  LuminaryDisclaimerPage = 'LUMINARY_DISCLAIMER_PAGE',
  MaineEstateTax = 'MAINE_ESTATE_TAX',
  ManagingRecentInheritance = 'MANAGING_RECENT_INHERITANCE',
  MarylandEstateAndInheritanceTax = 'MARYLAND_ESTATE_AND_INHERITANCE_TAX',
  MassachusettsEstateTax = 'MASSACHUSETTS_ESTATE_TAX',
  MinnesotaEstateTax = 'MINNESOTA_ESTATE_TAX',
  MissingDocumentsPage = 'MISSING_DOCUMENTS_PAGE',
  NebraskaInheritanceTax = 'NEBRASKA_INHERITANCE_TAX',
  NewJerseyInheritanceTax = 'NEW_JERSEY_INHERITANCE_TAX',
  NewYorkEstateTax = 'NEW_YORK_ESTATE_TAX',
  NoEstatePlanningConsequences = 'NO_ESTATE_PLANNING_CONSEQUENCES',
  OregonEstateTax = 'OREGON_ESTATE_TAX',
  PennsylvaniaInheritanceTax = 'PENNSYLVANIA_INHERITANCE_TAX',
  PhilanthropicPlanningExplainer = 'PHILANTHROPIC_PLANNING_EXPLAINER',
  PlanningOpportunitiesPage = 'PLANNING_OPPORTUNITIES_PAGE',
  PopularPlanningStrategies = 'POPULAR_PLANNING_STRATEGIES',
  PowerOfAttorneyPage = 'POWER_OF_ATTORNEY_PAGE',
  PresentationBundleCoverPage = 'PRESENTATION_BUNDLE_COVER_PAGE',
  ProfessionalTeamPage = 'PROFESSIONAL_TEAM_PAGE',
  QprtStrategyExplainer = 'QPRT_STRATEGY_EXPLAINER',
  RhodeIslandEstateTax = 'RHODE_ISLAND_ESTATE_TAX',
  SettingUpEstatePlan = 'SETTING_UP_ESTATE_PLAN',
  SlatStrategyExplainer = 'SLAT_STRATEGY_EXPLAINER',
  StandaloneDisclaimerPage = 'STANDALONE_DISCLAIMER_PAGE',
  StateInheritanceTaxExplainer = 'STATE_INHERITANCE_TAX_EXPLAINER',
  TableOfContentsPage = 'TABLE_OF_CONTENTS_PAGE',
  TrustBasics = 'TRUST_BASICS',
  TrustOverviewPage = 'TRUST_OVERVIEW_PAGE',
  VermontEstateTax = 'VERMONT_ESTATE_TAX',
  WashingtonEstateTax = 'WASHINGTON_ESTATE_TAX',
  WaterfallAssumptionsPage = 'WATERFALL_ASSUMPTIONS_PAGE',
  WaterfallBeneficiariesPage = 'WATERFALL_BENEFICIARIES_PAGE',
  WaterfallComparisonAssumptionsPage = 'WATERFALL_COMPARISON_ASSUMPTIONS_PAGE',
  WaterfallComparisonCoverPage = 'WATERFALL_COMPARISON_COVER_PAGE',
  WaterfallComparisonPage = 'WATERFALL_COMPARISON_PAGE',
  WaterfallCoverPage = 'WATERFALL_COVER_PAGE',
  WaterfallDiagramPage = 'WATERFALL_DIAGRAM_PAGE',
  WaterfallSummaryPage = 'WATERFALL_SUMMARY_PAGE',
  WaterfallTaxOverviewPage = 'WATERFALL_TAX_OVERVIEW_PAGE',
  WhyEstatePlanningMatters = 'WHY_ESTATE_PLANNING_MATTERS',
  WhyUseTrust = 'WHY_USE_TRUST',
  WillPage = 'WILL_PAGE'
}

/** Ordering options for PresentationPage connections */
export type PresentationPageOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationPages. */
  field: PresentationPageOrderField;
};

/** Properties by which PresentationPage connections can be ordered. */
export enum PresentationPageOrderField {
  CreatedAt = 'created_at',
  Index = 'index',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationPageWhereInput is used for filtering PresentationPage objects.
 * Input was generated by ent.
 */
export type PresentationPageWhereInput = {
  and?: InputMaybe<Array<PresentationPageWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** balance_sheet_bundle_configuration edge predicates */
  hasBalanceSheetBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBalanceSheetBundleConfigurationWith?: InputMaybe<Array<BalanceSheetBundleConfigurationWhereInput>>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** index field predicates */
  index?: InputMaybe<Scalars['Int']['input']>;
  indexGT?: InputMaybe<Scalars['Int']['input']>;
  indexGTE?: InputMaybe<Scalars['Int']['input']>;
  indexLT?: InputMaybe<Scalars['Int']['input']>;
  indexLTE?: InputMaybe<Scalars['Int']['input']>;
  indexNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<PresentationPageKind>;
  kindIn?: InputMaybe<Array<PresentationPageKind>>;
  kindNEQ?: InputMaybe<PresentationPageKind>;
  kindNotIn?: InputMaybe<Array<PresentationPageKind>>;
  not?: InputMaybe<PresentationPageWhereInput>;
  or?: InputMaybe<Array<PresentationPageWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationPlanningOpportunitiesBundleConfiguration = Node & {
  __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration';
  bundle: PresentationBundle;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Optional override for the bundle's display name on the planning-opportunities page. */
  displayName?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  items: PresentationPlanningOpportunitiesItemConnection;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PresentationPlanningOpportunitiesBundleConfigurationItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationPlanningOpportunitiesItemOrder>>;
  where?: InputMaybe<PresentationPlanningOpportunitiesItemWhereInput>;
};

/** A connection to a list of items. */
export type PresentationPlanningOpportunitiesBundleConfigurationConnection = {
  __typename?: 'PresentationPlanningOpportunitiesBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationPlanningOpportunitiesBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationPlanningOpportunitiesBundleConfigurationEdge = {
  __typename?: 'PresentationPlanningOpportunitiesBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationPlanningOpportunitiesBundleConfiguration>;
};

/** Ordering options for PresentationPlanningOpportunitiesBundleConfiguration connections */
export type PresentationPlanningOpportunitiesBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationPlanningOpportunitiesBundleConfigurations. */
  field: PresentationPlanningOpportunitiesBundleConfigurationOrderField;
};

/** Properties by which PresentationPlanningOpportunitiesBundleConfiguration connections can be ordered. */
export enum PresentationPlanningOpportunitiesBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationPlanningOpportunitiesBundleConfigurationWhereInput is used for filtering PresentationPlanningOpportunitiesBundleConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationPlanningOpportunitiesBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationPlanningOpportunitiesBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** items edge predicates */
  hasItems?: InputMaybe<Scalars['Boolean']['input']>;
  hasItemsWith?: InputMaybe<Array<PresentationPlanningOpportunitiesItemWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PresentationPlanningOpportunitiesBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationPlanningOpportunitiesBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationPlanningOpportunitiesItem = Node & {
  __typename?: 'PresentationPlanningOpportunitiesItem';
  /**
   * DEPRECATED: use the section-specific *_body fields instead.
   * @deprecated Use the section-specific *_body fields (opportunity_body, rationale_body, next_step_body) instead.
   */
  body?: Maybe<Scalars['String']['output']>;
  /** The planning-opportunities bundle configuration this item belongs to. */
  bundleConfiguration: PresentationPlanningOpportunitiesBundleConfiguration;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /**
   * DEPRECATED: use the section-specific *_label fields instead.
   * @deprecated Use the section-specific *_label fields (opportunity_label, rationale_label, next_step_label) instead.
   */
  label?: Maybe<Scalars['String']['output']>;
  /** Body text for the next step section of the item. */
  nextStepBody?: Maybe<Scalars['String']['output']>;
  /** Short label for the next step section of the item. */
  nextStepLabel?: Maybe<Scalars['String']['output']>;
  /** Body text for the opportunity section of the item. */
  opportunityBody?: Maybe<Scalars['String']['output']>;
  /** Short label for the opportunity section of the item. */
  opportunityLabel?: Maybe<Scalars['String']['output']>;
  /** Body text for the rationale section of the item. */
  rationaleBody?: Maybe<Scalars['String']['output']>;
  /** Short label for the rationale section of the item. */
  rationaleLabel?: Maybe<Scalars['String']['output']>;
  /** The order in which this item is rendered within its parent. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PresentationPlanningOpportunitiesItemConnection = {
  __typename?: 'PresentationPlanningOpportunitiesItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationPlanningOpportunitiesItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationPlanningOpportunitiesItemEdge = {
  __typename?: 'PresentationPlanningOpportunitiesItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationPlanningOpportunitiesItem>;
};

/** Ordering options for PresentationPlanningOpportunitiesItem connections */
export type PresentationPlanningOpportunitiesItemOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationPlanningOpportunitiesItems. */
  field: PresentationPlanningOpportunitiesItemOrderField;
};

/** Properties by which PresentationPlanningOpportunitiesItem connections can be ordered. */
export enum PresentationPlanningOpportunitiesItemOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationPlanningOpportunitiesItemWhereInput is used for filtering PresentationPlanningOpportunitiesItem objects.
 * Input was generated by ent.
 */
export type PresentationPlanningOpportunitiesItemWhereInput = {
  and?: InputMaybe<Array<PresentationPlanningOpportunitiesItemWhereInput>>;
  /** body field predicates */
  body?: InputMaybe<Scalars['String']['input']>;
  bodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  bodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** bundle_configuration edge predicates */
  hasBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleConfigurationWith?: InputMaybe<Array<PresentationPlanningOpportunitiesBundleConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  labelNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** next_step_body field predicates */
  nextStepBody?: InputMaybe<Scalars['String']['input']>;
  nextStepBodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nextStepBodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** next_step_label field predicates */
  nextStepLabel?: InputMaybe<Scalars['String']['input']>;
  nextStepLabelIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nextStepLabelNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<PresentationPlanningOpportunitiesItemWhereInput>;
  /** opportunity_body field predicates */
  opportunityBody?: InputMaybe<Scalars['String']['input']>;
  opportunityBodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityBodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** opportunity_label field predicates */
  opportunityLabel?: InputMaybe<Scalars['String']['input']>;
  opportunityLabelIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityLabelNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<PresentationPlanningOpportunitiesItemWhereInput>>;
  /** rationale_body field predicates */
  rationaleBody?: InputMaybe<Scalars['String']['input']>;
  rationaleBodyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  rationaleBodyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** rationale_label field predicates */
  rationaleLabel?: InputMaybe<Scalars['String']['input']>;
  rationaleLabelIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  rationaleLabelNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationPowerOfAttorneyBundleConfiguration = Node & {
  __typename?: 'PresentationPowerOfAttorneyBundleConfiguration';
  bundle: PresentationBundle;
  clients: PresentationPowerOfAttorneyClientConfigurationConnection;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Optional override for the bundle's display name on the powers-of-attorney page. */
  displayName?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Maximum number of clients rendered on each page. */
  itemsPerPage: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PresentationPowerOfAttorneyBundleConfigurationClientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationPowerOfAttorneyClientConfigurationOrder>>;
  where?: InputMaybe<PresentationPowerOfAttorneyClientConfigurationWhereInput>;
};

/** A connection to a list of items. */
export type PresentationPowerOfAttorneyBundleConfigurationConnection = {
  __typename?: 'PresentationPowerOfAttorneyBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationPowerOfAttorneyBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationPowerOfAttorneyBundleConfigurationEdge = {
  __typename?: 'PresentationPowerOfAttorneyBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationPowerOfAttorneyBundleConfiguration>;
};

/** Ordering options for PresentationPowerOfAttorneyBundleConfiguration connections */
export type PresentationPowerOfAttorneyBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationPowerOfAttorneyBundleConfigurations. */
  field: PresentationPowerOfAttorneyBundleConfigurationOrderField;
};

/** Properties by which PresentationPowerOfAttorneyBundleConfiguration connections can be ordered. */
export enum PresentationPowerOfAttorneyBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationPowerOfAttorneyBundleConfigurationWhereInput is used for filtering PresentationPowerOfAttorneyBundleConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationPowerOfAttorneyBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationPowerOfAttorneyBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** clients edge predicates */
  hasClients?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientsWith?: InputMaybe<Array<PresentationPowerOfAttorneyClientConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** items_per_page field predicates */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageGT?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageGTE?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageLT?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageLTE?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageNEQ?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<PresentationPowerOfAttorneyBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationPowerOfAttorneyBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationPowerOfAttorneyClientConfiguration = Node & {
  __typename?: 'PresentationPowerOfAttorneyClientConfiguration';
  /** The powers-of-attorney bundle configuration this client entry belongs to. */
  bundleConfiguration: PresentationPowerOfAttorneyBundleConfiguration;
  /** The display name of the client as it should appear on the page. */
  client: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  powerOfAttorneyItems: PresentationPowerOfAttorneyItemConnection;
  /** The order in which this client is rendered within the bundle. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PresentationPowerOfAttorneyClientConfigurationPowerOfAttorneyItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationPowerOfAttorneyItemOrder>>;
  where?: InputMaybe<PresentationPowerOfAttorneyItemWhereInput>;
};

/** A connection to a list of items. */
export type PresentationPowerOfAttorneyClientConfigurationConnection = {
  __typename?: 'PresentationPowerOfAttorneyClientConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationPowerOfAttorneyClientConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationPowerOfAttorneyClientConfigurationEdge = {
  __typename?: 'PresentationPowerOfAttorneyClientConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationPowerOfAttorneyClientConfiguration>;
};

/** Ordering options for PresentationPowerOfAttorneyClientConfiguration connections */
export type PresentationPowerOfAttorneyClientConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationPowerOfAttorneyClientConfigurations. */
  field: PresentationPowerOfAttorneyClientConfigurationOrderField;
};

/** Properties by which PresentationPowerOfAttorneyClientConfiguration connections can be ordered. */
export enum PresentationPowerOfAttorneyClientConfigurationOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationPowerOfAttorneyClientConfigurationWhereInput is used for filtering PresentationPowerOfAttorneyClientConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationPowerOfAttorneyClientConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationPowerOfAttorneyClientConfigurationWhereInput>>;
  /** client field predicates */
  client?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** bundle_configuration edge predicates */
  hasBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleConfigurationWith?: InputMaybe<Array<PresentationPowerOfAttorneyBundleConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** power_of_attorney_items edge predicates */
  hasPowerOfAttorneyItems?: InputMaybe<Scalars['Boolean']['input']>;
  hasPowerOfAttorneyItemsWith?: InputMaybe<Array<PresentationPowerOfAttorneyItemWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PresentationPowerOfAttorneyClientConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationPowerOfAttorneyClientConfigurationWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationPowerOfAttorneyItem = Node & {
  __typename?: 'PresentationPowerOfAttorneyItem';
  /** Body text rendered for the item. */
  body: Scalars['String']['output'];
  /** Source citations grounding this item. */
  citations?: Maybe<Array<PresentationItemCitation>>;
  /** The powers-of-attorney client configuration this item belongs to. */
  clientConfiguration: PresentationPowerOfAttorneyClientConfiguration;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Short label rendered above the item body. */
  label: Scalars['String']['output'];
  /** The order in which this item is rendered within its parent. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PresentationPowerOfAttorneyItemConnection = {
  __typename?: 'PresentationPowerOfAttorneyItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationPowerOfAttorneyItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationPowerOfAttorneyItemEdge = {
  __typename?: 'PresentationPowerOfAttorneyItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationPowerOfAttorneyItem>;
};

/** Ordering options for PresentationPowerOfAttorneyItem connections */
export type PresentationPowerOfAttorneyItemOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationPowerOfAttorneyItems. */
  field: PresentationPowerOfAttorneyItemOrderField;
};

/** Properties by which PresentationPowerOfAttorneyItem connections can be ordered. */
export enum PresentationPowerOfAttorneyItemOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationPowerOfAttorneyItemWhereInput is used for filtering PresentationPowerOfAttorneyItem objects.
 * Input was generated by ent.
 */
export type PresentationPowerOfAttorneyItemWhereInput = {
  and?: InputMaybe<Array<PresentationPowerOfAttorneyItemWhereInput>>;
  /** body field predicates */
  body?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** citations edge predicates */
  hasCitations?: InputMaybe<Scalars['Boolean']['input']>;
  hasCitationsWith?: InputMaybe<Array<PresentationItemCitationWhereInput>>;
  /** client_configuration edge predicates */
  hasClientConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientConfigurationWith?: InputMaybe<Array<PresentationPowerOfAttorneyClientConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<PresentationPowerOfAttorneyItemWhereInput>;
  or?: InputMaybe<Array<PresentationPowerOfAttorneyItemWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** PresentationSystemPrompt is a user-selectable built-in page prompt. */
export type PresentationSystemPrompt = {
  __typename?: 'PresentationSystemPrompt';
  /**
   * Stable identifier for the system prompt. The value is one of the
   * `enums.SystemPromptKey` values (e.g. `EXECUTIVE_SUMMARY`). Exposed as a
   * String so the endpoint can add prompts without a GraphQL schema change.
   */
  key: Scalars['String']['output'];
  /**
   * Default prompt text resolved from the in-code registry, with surrounding
   * whitespace trimmed.
   */
  prompt: Scalars['String']['output'];
};

export type PresentationTemplate = Node & {
  __typename?: 'PresentationTemplate';
  bundles: PresentationTemplateBundleConnection;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Whether this template is the tenant's default presentation template. */
  isDefault: Scalars['Boolean']['output'];
  /** Whether this template is available as a pinned presentation template. */
  isPinned: Scalars['Boolean']['output'];
  luminaryOrganization?: Maybe<LuminaryOrganization>;
  /** NULL means tenant-only; non-NULL shares the row with every member of the organization. */
  luminaryOrganizationID?: Maybe<Scalars['ID']['output']>;
  /** Identifies the kind of system template. Non-nil means the template is system-owned. */
  systemTemplateKind?: Maybe<PresentationTemplateSystemTemplateKind>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  type: PresentationTemplateType;
  updatedAt: Scalars['Time']['output'];
  user?: Maybe<User>;
};


export type PresentationTemplateBundlesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationTemplateBundleOrder>>;
  where?: InputMaybe<PresentationTemplateBundleWhereInput>;
};

export type PresentationTemplateBundle = Node & {
  __typename?: 'PresentationTemplateBundle';
  /** Firm-authored instructions appended to the built-in AI generation prompt for this bundle. Only DIAGRAM_BUNDLE (the Estate 360 asset distribution diagram) reads this value. */
  additionalPromptContext?: Maybe<Scalars['String']['output']>;
  beneficiariesTemplateBundleConfiguration?: Maybe<BeneficiariesTemplateBundleConfiguration>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  dividerTemplateBundleConfiguration?: Maybe<DividerTemplateBundleConfiguration>;
  documentSummaryTemplateBundleConfiguration?: Maybe<DocumentSummaryTemplateBundleConfiguration>;
  entitySummaryTemplateBundleConfiguration?: Maybe<EntitySummaryTemplateBundleConfiguration>;
  /** will not be included in printed output if true */
  excludeFromOutput: Scalars['Boolean']['output'];
  /** Controls whether the template bundle expands into one runtime bundle or a planned set of runtime bundles. */
  expansionMode: PresentationTemplateBundleExpansionMode;
  /** Instructions for planning 0..N runtime bundle instances when expansion_mode is PLANNED. */
  expansionPrompt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The index of the bundle in the presentation */
  index: Scalars['Int']['output'];
  insightsTemplateBundleConfiguration?: Maybe<InsightsTemplateBundleConfiguration>;
  kind: PresentationBundleKind;
  pages: PresentationTemplatePageConnection;
  presentationTemplate?: Maybe<PresentationTemplate>;
  runtimeBundles: PresentationBundleConnection;
  /** Notes to advisors on how to use the bundle */
  templateNotes?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  waterfallComparisonTemplateBundleConfiguration?: Maybe<WaterfallComparisonTemplateBundleConfiguration>;
  waterfallTemplateBundleConfiguration?: Maybe<WaterfallTemplateBundleConfiguration>;
};


export type PresentationTemplateBundlePagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationTemplatePageOrder>>;
  where?: InputMaybe<PresentationTemplatePageWhereInput>;
};


export type PresentationTemplateBundleRuntimeBundlesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationBundleOrder>>;
  where?: InputMaybe<PresentationBundleWhereInput>;
};

/** A connection to a list of items. */
export type PresentationTemplateBundleConnection = {
  __typename?: 'PresentationTemplateBundleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationTemplateBundleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationTemplateBundleEdge = {
  __typename?: 'PresentationTemplateBundleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationTemplateBundle>;
};

/** PresentationTemplateBundleExpansionMode is enum for the field expansion_mode */
export enum PresentationTemplateBundleExpansionMode {
  None = 'NONE',
  Planned = 'PLANNED'
}

/** Ordering options for PresentationTemplateBundle connections */
export type PresentationTemplateBundleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationTemplateBundles. */
  field: PresentationTemplateBundleOrderField;
};

/** Properties by which PresentationTemplateBundle connections can be ordered. */
export enum PresentationTemplateBundleOrderField {
  CreatedAt = 'created_at',
  Index = 'index',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationTemplateBundleWhereInput is used for filtering PresentationTemplateBundle objects.
 * Input was generated by ent.
 */
export type PresentationTemplateBundleWhereInput = {
  /** additional_prompt_context field predicates */
  additionalPromptContext?: InputMaybe<Scalars['String']['input']>;
  additionalPromptContextIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  additionalPromptContextNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<PresentationTemplateBundleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** exclude_from_output field predicates */
  excludeFromOutput?: InputMaybe<Scalars['Boolean']['input']>;
  /** expansion_mode field predicates */
  expansionMode?: InputMaybe<PresentationTemplateBundleExpansionMode>;
  expansionModeIn?: InputMaybe<Array<PresentationTemplateBundleExpansionMode>>;
  expansionModeNEQ?: InputMaybe<PresentationTemplateBundleExpansionMode>;
  expansionModeNotIn?: InputMaybe<Array<PresentationTemplateBundleExpansionMode>>;
  /** expansion_prompt field predicates */
  expansionPrompt?: InputMaybe<Scalars['String']['input']>;
  expansionPromptIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  expansionPromptNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** beneficiaries_template_bundle_configuration edge predicates */
  hasBeneficiariesTemplateBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesTemplateBundleConfigurationWith?: InputMaybe<Array<BeneficiariesTemplateBundleConfigurationWhereInput>>;
  /** divider_template_bundle_configuration edge predicates */
  hasDividerTemplateBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasDividerTemplateBundleConfigurationWith?: InputMaybe<Array<DividerTemplateBundleConfigurationWhereInput>>;
  /** document_summary_template_bundle_configuration edge predicates */
  hasDocumentSummaryTemplateBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasDocumentSummaryTemplateBundleConfigurationWith?: InputMaybe<Array<DocumentSummaryTemplateBundleConfigurationWhereInput>>;
  /** entity_summary_template_bundle_configuration edge predicates */
  hasEntitySummaryTemplateBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntitySummaryTemplateBundleConfigurationWith?: InputMaybe<Array<EntitySummaryTemplateBundleConfigurationWhereInput>>;
  /** insights_template_bundle_configuration edge predicates */
  hasInsightsTemplateBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasInsightsTemplateBundleConfigurationWith?: InputMaybe<Array<InsightsTemplateBundleConfigurationWhereInput>>;
  /** pages edge predicates */
  hasPages?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagesWith?: InputMaybe<Array<PresentationTemplatePageWhereInput>>;
  /** presentation_template edge predicates */
  hasPresentationTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  hasPresentationTemplateWith?: InputMaybe<Array<PresentationTemplateWhereInput>>;
  /** runtime_bundles edge predicates */
  hasRuntimeBundles?: InputMaybe<Scalars['Boolean']['input']>;
  hasRuntimeBundlesWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** waterfall_comparison_template_bundle_configuration edge predicates */
  hasWaterfallComparisonTemplateBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasWaterfallComparisonTemplateBundleConfigurationWith?: InputMaybe<Array<WaterfallComparisonTemplateBundleConfigurationWhereInput>>;
  /** waterfall_template_bundle_configuration edge predicates */
  hasWaterfallTemplateBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasWaterfallTemplateBundleConfigurationWith?: InputMaybe<Array<WaterfallTemplateBundleConfigurationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** index field predicates */
  index?: InputMaybe<Scalars['Int']['input']>;
  indexGT?: InputMaybe<Scalars['Int']['input']>;
  indexGTE?: InputMaybe<Scalars['Int']['input']>;
  indexLT?: InputMaybe<Scalars['Int']['input']>;
  indexLTE?: InputMaybe<Scalars['Int']['input']>;
  indexNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<PresentationBundleKind>;
  kindIn?: InputMaybe<Array<PresentationBundleKind>>;
  kindNEQ?: InputMaybe<PresentationBundleKind>;
  kindNotIn?: InputMaybe<Array<PresentationBundleKind>>;
  not?: InputMaybe<PresentationTemplateBundleWhereInput>;
  or?: InputMaybe<Array<PresentationTemplateBundleWhereInput>>;
  /** template_notes field predicates */
  templateNotes?: InputMaybe<Scalars['String']['input']>;
  templateNotesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  templateNotesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** A connection to a list of items. */
export type PresentationTemplateConnection = {
  __typename?: 'PresentationTemplateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationTemplateEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type PresentationTemplateCoverPage = Node & {
  __typename?: 'PresentationTemplateCoverPage';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The content of the cover page, rendered as Markdown. */
  customContent?: Maybe<Scalars['String']['output']>;
  /** Prompt used to generate the custom content. */
  customPrompt?: Maybe<Scalars['String']['output']>;
  /** Customizable title to display on the cover page. */
  displayTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Identifies a system-defined prompt resolved from code at presentation-creation time. */
  systemPromptKey?: Maybe<PresentationTemplateCoverPageSystemPromptKey>;
  templatePage?: Maybe<PresentationTemplatePage>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** PresentationTemplateCoverPageSystemPromptKey is enum for the field system_prompt_key */
export enum PresentationTemplateCoverPageSystemPromptKey {
  AssetDistributionDetail = 'ASSET_DISTRIBUTION_DETAIL',
  AssetDistributionDiagram = 'ASSET_DISTRIBUTION_DIAGRAM',
  DocumentsReviewed = 'DOCUMENTS_REVIEWED',
  ExecutiveSummary = 'EXECUTIVE_SUMMARY',
  FamilyOverview = 'FAMILY_OVERVIEW',
  HealthcareDirectiveOverview = 'HEALTHCARE_DIRECTIVE_OVERVIEW',
  KeyInformationWills = 'KEY_INFORMATION_WILLS',
  PlanningConsiderations = 'PLANNING_CONSIDERATIONS',
  PowerOfAttorneyOverview = 'POWER_OF_ATTORNEY_OVERVIEW',
  TrustsOverview = 'TRUSTS_OVERVIEW'
}

export type PresentationTemplateCustomPage = Node & {
  __typename?: 'PresentationTemplateCustomPage';
  /** Positioned text, shape, and image elements of a CANVAS page. */
  canvasDocument?: Maybe<PresentationCanvasDocument>;
  /** Increases by one on each write of canvas_document. */
  canvasRevision: Scalars['Int']['output'];
  /** Selects the page body: page_content for MARKDOWN or canvas_document for CANVAS. */
  contentFormat: PresentationCustomPageContentFormat;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Prompt used to generate the page content. */
  customPrompt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether to include the page header on the custom page. */
  includePageHeader?: Maybe<Scalars['Boolean']['output']>;
  /** The content of a MARKDOWN custom page, rendered as Markdown. CANVAS pages store an empty string. */
  pageContent: Scalars['String']['output'];
  /** The header to display on the custom page. */
  pageHeader: Scalars['String']['output'];
  /** The title to display on the custom page. */
  pageName: Scalars['String']['output'];
  /** The subheader to display on the custom page. */
  pageSubheader?: Maybe<Scalars['String']['output']>;
  /** Identifies a system-defined prompt resolved from code at presentation-creation time. */
  systemPromptKey?: Maybe<PresentationTemplateCustomPageSystemPromptKey>;
  templatePage?: Maybe<PresentationTemplatePage>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PresentationTemplateCustomPageConnection = {
  __typename?: 'PresentationTemplateCustomPageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationTemplateCustomPageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationTemplateCustomPageEdge = {
  __typename?: 'PresentationTemplateCustomPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationTemplateCustomPage>;
};

/** PresentationTemplateCustomPageSystemPromptKey is enum for the field system_prompt_key */
export enum PresentationTemplateCustomPageSystemPromptKey {
  AssetDistributionDetail = 'ASSET_DISTRIBUTION_DETAIL',
  AssetDistributionDiagram = 'ASSET_DISTRIBUTION_DIAGRAM',
  DocumentsReviewed = 'DOCUMENTS_REVIEWED',
  ExecutiveSummary = 'EXECUTIVE_SUMMARY',
  FamilyOverview = 'FAMILY_OVERVIEW',
  HealthcareDirectiveOverview = 'HEALTHCARE_DIRECTIVE_OVERVIEW',
  KeyInformationWills = 'KEY_INFORMATION_WILLS',
  PlanningConsiderations = 'PLANNING_CONSIDERATIONS',
  PowerOfAttorneyOverview = 'POWER_OF_ATTORNEY_OVERVIEW',
  TrustsOverview = 'TRUSTS_OVERVIEW'
}

export type PresentationTemplateDiagramPage = Node & {
  __typename?: 'PresentationTemplateDiagramPage';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Prompt used to generate the diagram when materializing this template. */
  customPrompt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The title to display on the diagram page. */
  pageName: Scalars['String']['output'];
  /** Identifies a system-defined prompt resolved from code at presentation-creation time. */
  systemPromptKey?: Maybe<PresentationTemplateDiagramPageSystemPromptKey>;
  templatePage?: Maybe<PresentationTemplatePage>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** PresentationTemplateDiagramPageSystemPromptKey is enum for the field system_prompt_key */
export enum PresentationTemplateDiagramPageSystemPromptKey {
  AssetDistributionDetail = 'ASSET_DISTRIBUTION_DETAIL',
  AssetDistributionDiagram = 'ASSET_DISTRIBUTION_DIAGRAM',
  DocumentsReviewed = 'DOCUMENTS_REVIEWED',
  ExecutiveSummary = 'EXECUTIVE_SUMMARY',
  FamilyOverview = 'FAMILY_OVERVIEW',
  HealthcareDirectiveOverview = 'HEALTHCARE_DIRECTIVE_OVERVIEW',
  KeyInformationWills = 'KEY_INFORMATION_WILLS',
  PlanningConsiderations = 'PLANNING_CONSIDERATIONS',
  PowerOfAttorneyOverview = 'POWER_OF_ATTORNEY_OVERVIEW',
  TrustsOverview = 'TRUSTS_OVERVIEW'
}

/**
 * PresentationTemplateDiagramRegenerationResult reports the state of one diagram regeneration subscription.
 * The terminal event contains either payload or error.
 */
export type PresentationTemplateDiagramRegenerationResult = {
  __typename?: 'PresentationTemplateDiagramRegenerationResult';
  /** error contains a user-facing message on the terminal failure event. */
  error?: Maybe<Scalars['String']['output']>;
  /** isComplete indicates whether regeneration has finished. */
  isComplete: Scalars['Boolean']['output'];
  /** payload contains the regenerated diagram on the terminal success event. */
  payload?: Maybe<RegeneratePresentationDiagramPayload>;
};

/** An edge in a connection. */
export type PresentationTemplateEdge = {
  __typename?: 'PresentationTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationTemplate>;
};

/** Ordering options for PresentationTemplate connections */
export type PresentationTemplateOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationTemplates. */
  field: PresentationTemplateOrderField;
};

/** Properties by which PresentationTemplate connections can be ordered. */
export enum PresentationTemplateOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type PresentationTemplatePage = Node & {
  __typename?: 'PresentationTemplatePage';
  bundle?: Maybe<PresentationTemplateBundle>;
  coverPage?: Maybe<PresentationTemplateCoverPage>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  customPage?: Maybe<PresentationTemplateCustomPage>;
  diagramPage?: Maybe<PresentationTemplateDiagramPage>;
  id: Scalars['ID']['output'];
  /** The index of the page in the bundle */
  index: Scalars['Int']['output'];
  /** Indicates the kind of page this is. */
  kind: PresentationPageKind;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PresentationTemplatePageConnection = {
  __typename?: 'PresentationTemplatePageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationTemplatePageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationTemplatePageEdge = {
  __typename?: 'PresentationTemplatePageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationTemplatePage>;
};

/** Ordering options for PresentationTemplatePage connections */
export type PresentationTemplatePageOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationTemplatePages. */
  field: PresentationTemplatePageOrderField;
};

/** Properties by which PresentationTemplatePage connections can be ordered. */
export enum PresentationTemplatePageOrderField {
  CreatedAt = 'created_at',
  Index = 'index',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationTemplatePageWhereInput is used for filtering PresentationTemplatePage objects.
 * Input was generated by ent.
 */
export type PresentationTemplatePageWhereInput = {
  and?: InputMaybe<Array<PresentationTemplatePageWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationTemplateBundleWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** index field predicates */
  index?: InputMaybe<Scalars['Int']['input']>;
  indexGT?: InputMaybe<Scalars['Int']['input']>;
  indexGTE?: InputMaybe<Scalars['Int']['input']>;
  indexLT?: InputMaybe<Scalars['Int']['input']>;
  indexLTE?: InputMaybe<Scalars['Int']['input']>;
  indexNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<PresentationPageKind>;
  kindIn?: InputMaybe<Array<PresentationPageKind>>;
  kindNEQ?: InputMaybe<PresentationPageKind>;
  kindNotIn?: InputMaybe<Array<PresentationPageKind>>;
  not?: InputMaybe<PresentationTemplatePageWhereInput>;
  or?: InputMaybe<Array<PresentationTemplatePageWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** PresentationTemplateSystemTemplateKind is enum for the field system_template_kind */
export enum PresentationTemplateSystemTemplateKind {
  BeneficiaryOutcomes = 'BENEFICIARY_OUTCOMES',
  CurrentEstatePlanReview = 'CURRENT_ESTATE_PLAN_REVIEW',
  DocumentReviewAndInventory = 'DOCUMENT_REVIEW_AND_INVENTORY',
  Estate_360 = 'ESTATE_360',
  EstateOverview = 'ESTATE_OVERVIEW',
  HypotheticalEstatePlanChanges = 'HYPOTHETICAL_ESTATE_PLAN_CHANGES'
}

/** PresentationTemplateType is enum for the field type */
export enum PresentationTemplateType {
  TenantTemplate = 'TENANT_TEMPLATE',
  UserTemplate = 'USER_TEMPLATE'
}

/**
 * PresentationTemplateWhereInput is used for filtering PresentationTemplate objects.
 * Input was generated by ent.
 */
export type PresentationTemplateWhereInput = {
  and?: InputMaybe<Array<PresentationTemplateWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** bundles edge predicates */
  hasBundles?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundlesWith?: InputMaybe<Array<PresentationTemplateBundleWhereInput>>;
  /** luminary_organization edge predicates */
  hasLuminaryOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasLuminaryOrganizationWith?: InputMaybe<Array<LuminaryOrganizationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_default field predicates */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_pinned field predicates */
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** luminary_organization_id field predicates */
  luminaryOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  luminaryOrganizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  luminaryOrganizationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  luminaryOrganizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  luminaryOrganizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  luminaryOrganizationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<PresentationTemplateWhereInput>;
  or?: InputMaybe<Array<PresentationTemplateWhereInput>>;
  /** system_template_kind field predicates */
  systemTemplateKind?: InputMaybe<PresentationTemplateSystemTemplateKind>;
  systemTemplateKindIn?: InputMaybe<Array<PresentationTemplateSystemTemplateKind>>;
  systemTemplateKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  systemTemplateKindNEQ?: InputMaybe<PresentationTemplateSystemTemplateKind>;
  systemTemplateKindNotIn?: InputMaybe<Array<PresentationTemplateSystemTemplateKind>>;
  systemTemplateKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** type field predicates */
  type?: InputMaybe<PresentationTemplateType>;
  typeIn?: InputMaybe<Array<PresentationTemplateType>>;
  typeNEQ?: InputMaybe<PresentationTemplateType>;
  typeNotIn?: InputMaybe<Array<PresentationTemplateType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationTrustOverviewBundleConfiguration = Node & {
  __typename?: 'PresentationTrustOverviewBundleConfiguration';
  bundle: PresentationBundle;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Optional override for the bundle's display name on the trust-overview page. */
  displayName?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Maximum number of trusts rendered on each page. */
  itemsPerPage: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  trusts: PresentationTrustOverviewTrustConfigurationConnection;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PresentationTrustOverviewBundleConfigurationTrustsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationTrustOverviewTrustConfigurationOrder>>;
  where?: InputMaybe<PresentationTrustOverviewTrustConfigurationWhereInput>;
};

/** A connection to a list of items. */
export type PresentationTrustOverviewBundleConfigurationConnection = {
  __typename?: 'PresentationTrustOverviewBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationTrustOverviewBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationTrustOverviewBundleConfigurationEdge = {
  __typename?: 'PresentationTrustOverviewBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationTrustOverviewBundleConfiguration>;
};

/** Ordering options for PresentationTrustOverviewBundleConfiguration connections */
export type PresentationTrustOverviewBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationTrustOverviewBundleConfigurations. */
  field: PresentationTrustOverviewBundleConfigurationOrderField;
};

/** Properties by which PresentationTrustOverviewBundleConfiguration connections can be ordered. */
export enum PresentationTrustOverviewBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationTrustOverviewBundleConfigurationWhereInput is used for filtering PresentationTrustOverviewBundleConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationTrustOverviewBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationTrustOverviewBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** trusts edge predicates */
  hasTrusts?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrustsWith?: InputMaybe<Array<PresentationTrustOverviewTrustConfigurationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** items_per_page field predicates */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageGT?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageGTE?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageLT?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageLTE?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageNEQ?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<PresentationTrustOverviewBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationTrustOverviewBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationTrustOverviewItem = Node & {
  __typename?: 'PresentationTrustOverviewItem';
  /** Body text rendered for the item. */
  body: Scalars['String']['output'];
  /** Source citations grounding this item. */
  citations?: Maybe<Array<PresentationItemCitation>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Short label rendered above the item body. */
  label: Scalars['String']['output'];
  /** The order in which this item is rendered within its parent. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The trust-overview trust configuration this item belongs to. */
  trustConfiguration: PresentationTrustOverviewTrustConfiguration;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PresentationTrustOverviewItemConnection = {
  __typename?: 'PresentationTrustOverviewItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationTrustOverviewItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationTrustOverviewItemEdge = {
  __typename?: 'PresentationTrustOverviewItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationTrustOverviewItem>;
};

/** Ordering options for PresentationTrustOverviewItem connections */
export type PresentationTrustOverviewItemOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationTrustOverviewItems. */
  field: PresentationTrustOverviewItemOrderField;
};

/** Properties by which PresentationTrustOverviewItem connections can be ordered. */
export enum PresentationTrustOverviewItemOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationTrustOverviewItemWhereInput is used for filtering PresentationTrustOverviewItem objects.
 * Input was generated by ent.
 */
export type PresentationTrustOverviewItemWhereInput = {
  and?: InputMaybe<Array<PresentationTrustOverviewItemWhereInput>>;
  /** body field predicates */
  body?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** citations edge predicates */
  hasCitations?: InputMaybe<Scalars['Boolean']['input']>;
  hasCitationsWith?: InputMaybe<Array<PresentationItemCitationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** trust_configuration edge predicates */
  hasTrustConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrustConfigurationWith?: InputMaybe<Array<PresentationTrustOverviewTrustConfigurationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<PresentationTrustOverviewItemWhereInput>;
  or?: InputMaybe<Array<PresentationTrustOverviewItemWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationTrustOverviewTrustConfiguration = Node & {
  __typename?: 'PresentationTrustOverviewTrustConfiguration';
  /** The trust-overview bundle configuration this trust entry belongs to. */
  bundleConfiguration: PresentationTrustOverviewBundleConfiguration;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The display name of the trust as it should appear on the page. */
  displayName: Scalars['String']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The order in which this trust is rendered within the bundle. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  trustItems: PresentationTrustOverviewItemConnection;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PresentationTrustOverviewTrustConfigurationTrustItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationTrustOverviewItemOrder>>;
  where?: InputMaybe<PresentationTrustOverviewItemWhereInput>;
};

/** A connection to a list of items. */
export type PresentationTrustOverviewTrustConfigurationConnection = {
  __typename?: 'PresentationTrustOverviewTrustConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationTrustOverviewTrustConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationTrustOverviewTrustConfigurationEdge = {
  __typename?: 'PresentationTrustOverviewTrustConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationTrustOverviewTrustConfiguration>;
};

/** Ordering options for PresentationTrustOverviewTrustConfiguration connections */
export type PresentationTrustOverviewTrustConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationTrustOverviewTrustConfigurations. */
  field: PresentationTrustOverviewTrustConfigurationOrderField;
};

/** Properties by which PresentationTrustOverviewTrustConfiguration connections can be ordered. */
export enum PresentationTrustOverviewTrustConfigurationOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationTrustOverviewTrustConfigurationWhereInput is used for filtering PresentationTrustOverviewTrustConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationTrustOverviewTrustConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationTrustOverviewTrustConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** bundle_configuration edge predicates */
  hasBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleConfigurationWith?: InputMaybe<Array<PresentationTrustOverviewBundleConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** trust_items edge predicates */
  hasTrustItems?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrustItemsWith?: InputMaybe<Array<PresentationTrustOverviewItemWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PresentationTrustOverviewTrustConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationTrustOverviewTrustConfigurationWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationWillBundleConfiguration = Node & {
  __typename?: 'PresentationWillBundleConfiguration';
  bundle: PresentationBundle;
  clients: PresentationWillClientConfigurationConnection;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Optional override for the bundle's display name on the wills page. */
  displayName?: Maybe<Scalars['String']['output']>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Maximum number of clients rendered on each page. */
  itemsPerPage: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PresentationWillBundleConfigurationClientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationWillClientConfigurationOrder>>;
  where?: InputMaybe<PresentationWillClientConfigurationWhereInput>;
};

/** A connection to a list of items. */
export type PresentationWillBundleConfigurationConnection = {
  __typename?: 'PresentationWillBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationWillBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationWillBundleConfigurationEdge = {
  __typename?: 'PresentationWillBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationWillBundleConfiguration>;
};

/** Ordering options for PresentationWillBundleConfiguration connections */
export type PresentationWillBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationWillBundleConfigurations. */
  field: PresentationWillBundleConfigurationOrderField;
};

/** Properties by which PresentationWillBundleConfiguration connections can be ordered. */
export enum PresentationWillBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationWillBundleConfigurationWhereInput is used for filtering PresentationWillBundleConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationWillBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationWillBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** clients edge predicates */
  hasClients?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientsWith?: InputMaybe<Array<PresentationWillClientConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** items_per_page field predicates */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageGT?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageGTE?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageLT?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageLTE?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPageNEQ?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<PresentationWillBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationWillBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationWillClientConfiguration = Node & {
  __typename?: 'PresentationWillClientConfiguration';
  /** The wills bundle configuration this client entry belongs to. */
  bundleConfiguration: PresentationWillBundleConfiguration;
  /** The display name of the client as it should appear on the page. */
  client: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The order in which this client is rendered within the bundle. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  willItems: PresentationWillItemConnection;
};


export type PresentationWillClientConfigurationWillItemsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationWillItemOrder>>;
  where?: InputMaybe<PresentationWillItemWhereInput>;
};

/** A connection to a list of items. */
export type PresentationWillClientConfigurationConnection = {
  __typename?: 'PresentationWillClientConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationWillClientConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationWillClientConfigurationEdge = {
  __typename?: 'PresentationWillClientConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationWillClientConfiguration>;
};

/** Ordering options for PresentationWillClientConfiguration connections */
export type PresentationWillClientConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationWillClientConfigurations. */
  field: PresentationWillClientConfigurationOrderField;
};

/** Properties by which PresentationWillClientConfiguration connections can be ordered. */
export enum PresentationWillClientConfigurationOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationWillClientConfigurationWhereInput is used for filtering PresentationWillClientConfiguration objects.
 * Input was generated by ent.
 */
export type PresentationWillClientConfigurationWhereInput = {
  and?: InputMaybe<Array<PresentationWillClientConfigurationWhereInput>>;
  /** client field predicates */
  client?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** bundle_configuration edge predicates */
  hasBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleConfigurationWith?: InputMaybe<Array<PresentationWillBundleConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** will_items edge predicates */
  hasWillItems?: InputMaybe<Scalars['Boolean']['input']>;
  hasWillItemsWith?: InputMaybe<Array<PresentationWillItemWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PresentationWillClientConfigurationWhereInput>;
  or?: InputMaybe<Array<PresentationWillClientConfigurationWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PresentationWillItem = Node & {
  __typename?: 'PresentationWillItem';
  /** Body text rendered for the item. */
  body: Scalars['String']['output'];
  /** Source citations grounding this item. */
  citations?: Maybe<Array<PresentationItemCitation>>;
  /** The wills client configuration this item belongs to. */
  clientConfiguration: PresentationWillClientConfiguration;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Short label rendered above the item body. */
  label: Scalars['String']['output'];
  /** The order in which this item is rendered within its parent. */
  sortOrder: Scalars['Int']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type PresentationWillItemConnection = {
  __typename?: 'PresentationWillItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresentationWillItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PresentationWillItemEdge = {
  __typename?: 'PresentationWillItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PresentationWillItem>;
};

/** Ordering options for PresentationWillItem connections */
export type PresentationWillItemOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PresentationWillItems. */
  field: PresentationWillItemOrderField;
};

/** Properties by which PresentationWillItem connections can be ordered. */
export enum PresentationWillItemOrderField {
  CreatedAt = 'created_at',
  SortOrder = 'sort_order',
  UpdatedAt = 'updated_at'
}

/**
 * PresentationWillItemWhereInput is used for filtering PresentationWillItem objects.
 * Input was generated by ent.
 */
export type PresentationWillItemWhereInput = {
  and?: InputMaybe<Array<PresentationWillItemWhereInput>>;
  /** body field predicates */
  body?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** citations edge predicates */
  hasCitations?: InputMaybe<Scalars['Boolean']['input']>;
  hasCitationsWith?: InputMaybe<Array<PresentationItemCitationWhereInput>>;
  /** client_configuration edge predicates */
  hasClientConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasClientConfigurationWith?: InputMaybe<Array<PresentationWillClientConfigurationWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<PresentationWillItemWhereInput>;
  or?: InputMaybe<Array<PresentationWillItemWhereInput>>;
  /** sort_order field predicates */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderGTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLT?: InputMaybe<Scalars['Int']['input']>;
  sortOrderLTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrderNEQ?: InputMaybe<Scalars['Int']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Principal = Node & {
  __typename?: 'Principal';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** An edge to the principal, which is an individual */
  individual?: Maybe<ClientProfile>;
  /**
   * The percentage ownership of the underlying entity, funded by these principals.
   * 			Typically only valid for multiple ownership, non-trust non-charitable entities (eg: LLC, LP, ...)
   */
  ownershipPercentage?: Maybe<Scalars['Percent']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for Principal connections */
export type PrincipalOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Principals. */
  field: PrincipalOrderField;
};

/** Properties by which Principal connections can be ordered. */
export enum PrincipalOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type PrincipalSuggestion = {
  __typename?: 'PrincipalSuggestion';
  firstName?: Maybe<Scalars['String']['output']>;
  individualID?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/**
 * PrincipalWhereInput is used for filtering Principal objects.
 * Input was generated by ent.
 */
export type PrincipalWhereInput = {
  and?: InputMaybe<Array<PrincipalWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PrincipalWhereInput>;
  or?: InputMaybe<Array<PrincipalWhereInput>>;
  /** ownership_percentage field predicates */
  ownershipPercentage?: InputMaybe<Scalars['Percent']['input']>;
  ownershipPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  ownershipPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  ownershipPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownershipPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  ownershipPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  ownershipPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  ownershipPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PrintDocumentSummaryInput = {
  documentID: Scalars['ID']['input'];
  documentSummaryID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  orientation?: InputMaybe<PdfExportOrientation>;
  relativePath: Scalars['String']['input'];
};

export type PrintInput = {
  householdID: Scalars['ID']['input'];
  relativePath: Scalars['String']['input'];
};

export type PrintMemoInput = {
  householdID: Scalars['ID']['input'];
  memoID: Scalars['ID']['input'];
  relativePath: Scalars['String']['input'];
};

export type PrintPresentationInput = {
  householdID: Scalars['ID']['input'];
  presentationID: Scalars['ID']['input'];
  relativePath: Scalars['String']['input'];
};

export type PrintProposalInput = {
  householdID: Scalars['ID']['input'];
  proposalID: Scalars['ID']['input'];
  relativePath: Scalars['String']['input'];
};

export type PrivateFoundation = EntitySubtype & Named & Node & {
  __typename?: 'PrivateFoundation';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  beneficiaries?: Maybe<Array<Beneficiary>>;
  controllingParties?: Maybe<Array<ControllingParty>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this personal account */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in entities that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  donors?: Maybe<Array<Principal>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  performanceReport: PerformanceReport;
  policies?: Maybe<Array<InsurancePolicy>>;
  stateInEstateStatus: EntityInEstateStatus;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<NonTrustEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type PrivateFoundationHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type PrivateFoundationConnection = {
  __typename?: 'PrivateFoundationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PrivateFoundationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PrivateFoundationEdge = {
  __typename?: 'PrivateFoundationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PrivateFoundation>;
};

/** Ordering options for PrivateFoundation connections */
export type PrivateFoundationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PrivateFoundations. */
  field: PrivateFoundationOrderField;
};

/** Properties by which PrivateFoundation connections can be ordered. */
export enum PrivateFoundationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * PrivateFoundationWhereInput is used for filtering PrivateFoundation objects.
 * Input was generated by ent.
 */
export type PrivateFoundationWhereInput = {
  and?: InputMaybe<Array<PrivateFoundationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** beneficiaries edge predicates */
  hasBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** controlling_parties edge predicates */
  hasControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  hasControllingPartiesWith?: InputMaybe<Array<ControllingPartyWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** donors edge predicates */
  hasDonors?: InputMaybe<Scalars['Boolean']['input']>;
  hasDonorsWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<PrivateFoundationWhereInput>;
  or?: InputMaybe<Array<PrivateFoundationWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type ProfessionalTeamRole = Node & {
  __typename?: 'ProfessionalTeamRole';
  /** The client that this team member is associated with or a fiduciary of */
  associatedClientIndividual?: Maybe<ClientProfile>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  id: Scalars['ID']['output'];
  /** The client_profile that represents this professional team member */
  individual?: Maybe<ClientProfile>;
  kind: ProfessionalTeamRoleKind;
  /** The client_organization that represents this professional team member */
  organization?: Maybe<ClientOrganization>;
  /** If the kind is OTHER, this is the custom role name */
  otherRoleName?: Maybe<Scalars['String']['output']>;
  /** If the kind is POWER_OF_ATTORNEY, this is the type of power of attorney */
  powerOfAttorneyKind?: Maybe<ProfessionalTeamRolePowerOfAttorneyKind>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type ProfessionalTeamRoleConnection = {
  __typename?: 'ProfessionalTeamRoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProfessionalTeamRoleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProfessionalTeamRoleEdge = {
  __typename?: 'ProfessionalTeamRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProfessionalTeamRole>;
};

/** ProfessionalTeamRoleKind is enum for the field kind */
export enum ProfessionalTeamRoleKind {
  AccountantCpa = 'ACCOUNTANT_CPA',
  Attorney = 'ATTORNEY',
  Bookkeeper = 'BOOKKEEPER',
  BusinessManager = 'BUSINESS_MANAGER',
  Conservator = 'CONSERVATOR',
  EstateExecutor = 'ESTATE_EXECUTOR',
  FinancialAdvisor = 'FINANCIAL_ADVISOR',
  Guardian = 'GUARDIAN',
  HealthcareAgent = 'HEALTHCARE_AGENT',
  InsuranceAgent = 'INSURANCE_AGENT',
  Other = 'OTHER',
  Physician = 'PHYSICIAN',
  PowerOfAttorney = 'POWER_OF_ATTORNEY'
}

/** Ordering options for ProfessionalTeamRole connections */
export type ProfessionalTeamRoleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ProfessionalTeamRoles. */
  field: ProfessionalTeamRoleOrderField;
};

/** Properties by which ProfessionalTeamRole connections can be ordered. */
export enum ProfessionalTeamRoleOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** ProfessionalTeamRolePowerOfAttorneyKind is enum for the field power_of_attorney_kind */
export enum ProfessionalTeamRolePowerOfAttorneyKind {
  Durable = 'DURABLE',
  General = 'GENERAL',
  Limited = 'LIMITED'
}

/**
 * ProfessionalTeamRoleWhereInput is used for filtering ProfessionalTeamRole objects.
 * Input was generated by ent.
 */
export type ProfessionalTeamRoleWhereInput = {
  and?: InputMaybe<Array<ProfessionalTeamRoleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** associated_client_individual edge predicates */
  hasAssociatedClientIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssociatedClientIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** individual edge predicates */
  hasIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<ProfessionalTeamRoleKind>;
  kindIn?: InputMaybe<Array<ProfessionalTeamRoleKind>>;
  kindNEQ?: InputMaybe<ProfessionalTeamRoleKind>;
  kindNotIn?: InputMaybe<Array<ProfessionalTeamRoleKind>>;
  not?: InputMaybe<ProfessionalTeamRoleWhereInput>;
  or?: InputMaybe<Array<ProfessionalTeamRoleWhereInput>>;
  /** other_role_name field predicates */
  otherRoleName?: InputMaybe<Scalars['String']['input']>;
  otherRoleNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  otherRoleNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** power_of_attorney_kind field predicates */
  powerOfAttorneyKind?: InputMaybe<ProfessionalTeamRolePowerOfAttorneyKind>;
  powerOfAttorneyKindIn?: InputMaybe<Array<ProfessionalTeamRolePowerOfAttorneyKind>>;
  powerOfAttorneyKindIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  powerOfAttorneyKindNEQ?: InputMaybe<ProfessionalTeamRolePowerOfAttorneyKind>;
  powerOfAttorneyKindNotIn?: InputMaybe<Array<ProfessionalTeamRolePowerOfAttorneyKind>>;
  powerOfAttorneyKindNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Projection = {
  __typename?: 'Projection';
  grantorRetainedInterest: Scalars['CurrencyUSD']['output'];
  initialFundingValue: Scalars['CurrencyUSD']['output'];
  rollingProjections: Array<Projection>;
  scenarioTableRows: Array<ScenarioTableRow>;
  taxableGiftAmount: Scalars['CurrencyUSD']['output'];
  totalAnnuityPayments: Scalars['CurrencyUSD']['output'];
  totalAssetValue: Scalars['CurrencyUSD']['output'];
  transferredOutOfEstate: Scalars['CurrencyUSD']['output'];
};

export type ProjectionParams = {
  annualAnnuityIncrease: Scalars['Percent']['input'];
  initialFundingValue: Scalars['CurrencyUSD']['input'];
  officialInterestRate: Scalars['Percent']['input'];
  projectedRateOfReturn: Scalars['Percent']['input'];
  rollingPeriodYears?: InputMaybe<Scalars['Int']['input']>;
  targetGift: Scalars['CurrencyUSD']['input'];
  termDurationYears: Scalars['Int']['input'];
};

export type Proposal = Node & {
  __typename?: 'Proposal';
  /** notes to the client that accompany the proposal */
  clientNotes: Scalars['String']['output'];
  /** The associated CLT proposal */
  cltProposal?: Maybe<CltProposal>;
  createdAt: Scalars['Time']['output'];
  /** The associated CRT proposal */
  crtProposal?: Maybe<CrtProposal>;
  /** the user-friendly name of the proposal */
  displayName: Scalars['String']['output'];
  /** The entities included in this proposal */
  entityProposals?: Maybe<Array<EntityProposal>>;
  /** The associated gifting proposal */
  giftingProposal?: Maybe<GiftingProposal>;
  household: Household;
  id: Scalars['ID']['output'];
  /** whether or not to include a "cumulative view" tab on the proposal */
  includeCumulativeView: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type ProposalConnection = {
  __typename?: 'ProposalConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProposalEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProposalEdge = {
  __typename?: 'ProposalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Proposal>;
};

/** Ordering options for Proposal connections */
export type ProposalOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Proposals. */
  field: ProposalOrderField;
};

/** Properties by which Proposal connections can be ordered. */
export enum ProposalOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type ProposalScenario = Node & {
  __typename?: 'ProposalScenario';
  createdAt: Scalars['Time']['output'];
  gratProposalScenario?: Maybe<GratProposalScenario>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type ProposalScenarioConnection = {
  __typename?: 'ProposalScenarioConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProposalScenarioEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProposalScenarioEdge = {
  __typename?: 'ProposalScenarioEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProposalScenario>;
};

/** Ordering options for ProposalScenario connections */
export type ProposalScenarioOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ProposalScenarios. */
  field: ProposalScenarioOrderField;
};

/** Properties by which ProposalScenario connections can be ordered. */
export enum ProposalScenarioOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type ProposalScenarioProjection = {
  __typename?: 'ProposalScenarioProjection';
  noPlan: ProposalScenarioProjectionValue;
  withPlan: ProposalScenarioProjectionValue;
};

export type ProposalScenarioProjectionParamsV2 = {
  afterTermAnnualRateOfReturn: Scalars['Percent']['input'];
  endTermProjectedValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  entityID: Scalars['ID']['input'];
  inTermAnnualRateOfReturn?: InputMaybe<Scalars['Percent']['input']>;
  projectionTimelineYears: Scalars['Int']['input'];
  taxDragEstimate: Scalars['Percent']['input'];
};

export type ProposalScenarioProjectionResult = {
  __typename?: 'ProposalScenarioProjectionResult';
  postTax: ProposalScenarioProjection;
  preTax: ProposalScenarioProjection;
};

export type ProposalScenarioProjectionValue = {
  __typename?: 'ProposalScenarioProjectionValue';
  estateTax: Scalars['CurrencyUSD']['output'];
  inEstate: Scalars['CurrencyUSD']['output'];
  outOfEstate: Scalars['CurrencyUSD']['output'];
};

/**
 * ProposalScenarioWhereInput is used for filtering ProposalScenario objects.
 * Input was generated by ent.
 */
export type ProposalScenarioWhereInput = {
  and?: InputMaybe<Array<ProposalScenarioWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** grat_proposal_scenario edge predicates */
  hasGratProposalScenario?: InputMaybe<Scalars['Boolean']['input']>;
  hasGratProposalScenarioWith?: InputMaybe<Array<GratProposalScenarioWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProposalScenarioWhereInput>;
  or?: InputMaybe<Array<ProposalScenarioWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * ProposalWhereInput is used for filtering Proposal objects.
 * Input was generated by ent.
 */
export type ProposalWhereInput = {
  and?: InputMaybe<Array<ProposalWhereInput>>;
  /** client_notes field predicates */
  clientNotes?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** clt_proposal edge predicates */
  hasCltProposal?: InputMaybe<Scalars['Boolean']['input']>;
  hasCltProposalWith?: InputMaybe<Array<CltProposalWhereInput>>;
  /** crt_proposal edge predicates */
  hasCrtProposal?: InputMaybe<Scalars['Boolean']['input']>;
  hasCrtProposalWith?: InputMaybe<Array<CrtProposalWhereInput>>;
  /** entity_proposals edge predicates */
  hasEntityProposals?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityProposalsWith?: InputMaybe<Array<EntityProposalWhereInput>>;
  /** gifting_proposal edge predicates */
  hasGiftingProposal?: InputMaybe<Scalars['Boolean']['input']>;
  hasGiftingProposalWith?: InputMaybe<Array<GiftingProposalWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_cumulative_view field predicates */
  includeCumulativeView?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ProposalWhereInput>;
  or?: InputMaybe<Array<ProposalWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type PublishFormInput = {
  id: Scalars['ID']['input'];
};

export type PublishFormPayload = {
  __typename?: 'PublishFormPayload';
  form: Form;
  version: FormVersion;
};

export type QprtTrust = EntitySubtype & Named & Node & Trust & {
  __typename?: 'QPRTTrust';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  beneficiaries?: Maybe<Array<Beneficiary>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this trust */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in trusts that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  grantors?: Maybe<Array<Principal>>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  officialInterestRatePercent?: Maybe<Scalars['Percent']['output']>;
  stateInEstateStatus: EntityInEstateStatus;
  successorTrustees?: Maybe<Array<Trustee>>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<TrustTaxStatus>;
  /** The actual taxable gift that was recorded for this QPRT */
  taxableGift?: Maybe<Scalars['CurrencyUSD']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  termDurationYears?: Maybe<Scalars['Int']['output']>;
  termEndDate?: Maybe<Scalars['Time']['output']>;
  terminationDate?: Maybe<Scalars['Time']['output']>;
  trustAdvisors?: Maybe<Array<TrustAdvisor>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  trustees?: Maybe<Array<Trustee>>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type QprtTrustHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type QprtTrustConnection = {
  __typename?: 'QPRTTrustConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<QprtTrustEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type QprtTrustEdge = {
  __typename?: 'QPRTTrustEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<QprtTrust>;
};

/** Ordering options for QPRTTrust connections */
export type QprtTrustOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order QPRTTrusts. */
  field: QprtTrustOrderField;
};

/** Properties by which QPRTTrust connections can be ordered. */
export enum QprtTrustOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * QPRTTrustWhereInput is used for filtering QPRTTrust objects.
 * Input was generated by ent.
 */
export type QprtTrustWhereInput = {
  and?: InputMaybe<Array<QprtTrustWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** beneficiaries edge predicates */
  hasBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** grantors edge predicates */
  hasGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrantorsWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** successor_trustees edge predicates */
  hasSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuccessorTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** trust_advisors edge predicates */
  hasTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrustAdvisorsWith?: InputMaybe<Array<TrustAdvisorWhereInput>>;
  /** trustees edge predicates */
  hasTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<QprtTrustWhereInput>;
  /** official_interest_rate_percent field predicates */
  officialInterestRatePercent?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentGT?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentGTE?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  officialInterestRatePercentLT?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentLTE?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentNEQ?: InputMaybe<Scalars['Percent']['input']>;
  officialInterestRatePercentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<QprtTrustWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<TrustTaxStatus>;
  taxStatusIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<TrustTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** taxable_gift field predicates */
  taxableGift?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableGiftGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableGiftGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableGiftIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxableGiftLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableGiftLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableGiftNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  taxableGiftNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** term_duration_years field predicates */
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsGT?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsGTE?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  termDurationYearsLT?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsLTE?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsNEQ?: InputMaybe<Scalars['Int']['input']>;
  termDurationYearsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** termination_date field predicates */
  terminationDate?: InputMaybe<Scalars['Time']['input']>;
  terminationDateGT?: InputMaybe<Scalars['Time']['input']>;
  terminationDateGTE?: InputMaybe<Scalars['Time']['input']>;
  terminationDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  terminationDateLT?: InputMaybe<Scalars['Time']['input']>;
  terminationDateLTE?: InputMaybe<Scalars['Time']['input']>;
  terminationDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** trust_jurisdiction_state_code field predicates */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trustJurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  trustJurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type QualifiedTuitionPersonalAccount = EntitySubtype & Named & Node & PersonalAccount & {
  __typename?: 'QualifiedTuitionPersonalAccount';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  beneficiaries?: Maybe<Array<Beneficiary>>;
  controllingParties?: Maybe<Array<ControllingParty>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this personal account */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in entities that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  owner?: Maybe<Principal>;
  stateInEstateStatus: EntityInEstateStatus;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<NonTrustEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type QualifiedTuitionPersonalAccountHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type QualifiedTuitionPersonalAccountConnection = {
  __typename?: 'QualifiedTuitionPersonalAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<QualifiedTuitionPersonalAccountEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type QualifiedTuitionPersonalAccountEdge = {
  __typename?: 'QualifiedTuitionPersonalAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<QualifiedTuitionPersonalAccount>;
};

/** Ordering options for QualifiedTuitionPersonalAccount connections */
export type QualifiedTuitionPersonalAccountOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order QualifiedTuitionPersonalAccounts. */
  field: QualifiedTuitionPersonalAccountOrderField;
};

/** Properties by which QualifiedTuitionPersonalAccount connections can be ordered. */
export enum QualifiedTuitionPersonalAccountOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * QualifiedTuitionPersonalAccountWhereInput is used for filtering QualifiedTuitionPersonalAccount objects.
 * Input was generated by ent.
 */
export type QualifiedTuitionPersonalAccountWhereInput = {
  and?: InputMaybe<Array<QualifiedTuitionPersonalAccountWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** beneficiaries edge predicates */
  hasBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** controlling_parties edge predicates */
  hasControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  hasControllingPartiesWith?: InputMaybe<Array<ControllingPartyWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<QualifiedTuitionPersonalAccountWhereInput>;
  or?: InputMaybe<Array<QualifiedTuitionPersonalAccountWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Query = {
  __typename?: 'Query';
  activityGroups: ActivityGroupConnection;
  /** Returns all active tenants for Luminary administration. */
  adminListTenants: Array<TenantSummary>;
  adminWorkflowTrackers: WorkflowTrackerConnection;
  aiSuggestions: AiSuggestionConnection;
  applicationAuthorization: ApplicationAuthorization;
  archetypeHouseholds: HouseholdConnection;
  assetClasses: AssetClassConnection;
  availablePresentationTemplatePins: Array<PresentationTemplate>;
  /**
   * Returns a generated balance sheet data structure based on the specified household. When presentationConfiguration
   * is true, reads from a default BalanceSheetViewConfiguration rather than one that's configured for the household.
   * When bundleID is provided, uses the bundle's BalanceSheetBundleConfiguration for rendering if one exists;
   * otherwise falls back to the household's BalanceSheetViewConfiguration.
   * When configurationID is provided, uses that specific BalanceSheetBundleConfiguration directly for rendering.
   * configurationID takes precedence over bundleID if both are provided.
   */
  balanceSheet: BalanceSheet;
  balanceSheetBundleConfigurations: BalanceSheetBundleConfigurationConnection;
  balanceSheetCategories: BalanceSheetCategoryConnection;
  beneficiariesTemplateBundleConfigurations: BeneficiariesTemplateBundleConfigurationConnection;
  beneficiarySummariesv2: Array<Maybe<SummaryBeneficiaryv2>>;
  capabilities: Array<Capability>;
  cashflows: CashflowConnection;
  clientOrganizations: ClientOrganizationConnection;
  clientPresentationV2s: ClientPresentationV2Connection;
  clientProfiles: ClientProfileConnection;
  cltOptimization: CltOptimization;
  cltProposalProjection: CltProposalProjection;
  collaboratorRoles: Array<Maybe<Role>>;
  collaborators: CollaboratorConnection;
  comparedWaterfalls: ComparedWaterfallConnection;
  conversations: ConversationConnection;
  coverPageConfigurations: CoverPageConfigurationConnection;
  coverSlideConfig?: Maybe<PresentationCoverSlideConfig>;
  crtOptimization: CrtOptimization;
  crtProposalProjection: CrtProposalProjection;
  currentUser?: Maybe<User>;
  /**
   * Returns the current user's workflow tracker history, including active and
   * terminal trackers, ordered from newest to oldest.
   */
  currentUserWorkflowTrackerHistory: WorkflowTrackerConnection;
  /**
   * Built-in diagram instruction text from code. No tenant or household prompt records are required.
   * Stored tenant library records are available through diagramArtifactPrompts.
   */
  defaultDiagramPrompts: Array<DefaultDiagramPrompt>;
  defaultMemoPrompts: Array<DefaultMemoPrompt>;
  /**
   * Current built-in onboarding prompts, including shared context and the selected template.
   * No database records are required.
   */
  defaultNoDocumentsOnboardingPrompts: Array<DefaultNoDocumentsOnboardingPrompt>;
  diagramArtifactPrompts: DiagramArtifactPromptConnection;
  diagramArtifacts: DiagramArtifactConnection;
  dispositiveProvisionTemplates: DispositiveProvisionTemplateConnection;
  dividerBundleConfigurations: DividerBundleConfigurationConnection;
  dividerSlideConfig?: Maybe<PresentationCoverSlideConfig>;
  dividerTemplateBundleConfigurations: DividerTemplateBundleConfigurationConnection;
  documentSummaries: DocumentSummaryConnection;
  documentSummaryPrompts: DocumentSummaryPromptConnection;
  documentSummaryTemplateBundleConfigurations: DocumentSummaryTemplateBundleConfigurationConnection;
  documents: DocumentConnection;
  /** Returns application configuration currently in effect for the authenticated tenant. */
  effectiveApplicationConfiguration: EffectiveApplicationConfiguration;
  /** Returns disclaimer configuration currently in effect for the authenticated tenant. */
  effectiveDisclaimerConfiguration: EffectiveDisclaimerConfiguration;
  /**
   * Returns deterministic effective Education Page overrides for the
   * authenticated tenant. Organization-shared rows take precedence over local
   * rows, including hidden tombstones.
   */
  effectiveEducationPageOverrides: Array<EffectiveEducationPageOverride>;
  employees: EmployeeConnection;
  entities: EntityConnection;
  entitiesOverviewBundleConfigurations: EntitiesOverviewBundleConfigurationConnection;
  /** Returns the balance sheet for one entity. */
  entityBalanceSheet: BalanceSheet;
  entityDiagrams: EntityDiagramConnection;
  entityGraphViewBundleConfigurations: EntityGraphViewBundleConfigurationConnection;
  entityGraphViews: EntityGraphViewConnection;
  entitySummaryBundleConfigurations: EntitySummaryBundleConfigurationConnection;
  entitySummaryTemplateBundleConfigurations: EntitySummaryTemplateBundleConfigurationConnection;
  entityTasks: EntityTaskConnection;
  estateInsights: EstateInsightConnection;
  estateInsightsBundleConfigurations: EstateInsightsBundleConfigurationConnection;
  estateTaxScenarioPossibleEntities: Array<Node>;
  estateTaxScenarios: EstateTaxScenarioConnection;
  estateWaterfalls: EstateWaterfallConnection;
  /**
   * Export household data for knowledge graph training/evaluation.
   * Returns the current export payload plus household-level suggestion-eval inputs.
   */
  exportHouseholdForKnowledgeGraph: KgHouseholdExport;
  /**
   * Get the complete family tree for a household with generation information.
   * Primary clients are generation 0, parents are -1, children are 1, grandparents are -2,
   * grandchildren are 2, great-grandparents are -3, great-grandchildren are 3, etc.
   * Nephews/nieces are 1, uncles/aunts are -1, cousins/siblings/spouses are 0,
   * others are -99 (indeterminate/unspecified relationships).
   * Supports unlimited generational depth. Includes people connected via direct family
   * relationship paths and standalone non-family relationship nodes.
   */
  familyTree?: Maybe<FamilyTree>;
  familyTreeBundleConfigurations: FamilyTreeBundleConfigurationConnection;
  featureFlagEvaluationResult: Array<FeatureFlagEvaluationResult>;
  /**
   * Resolved feature flag values for the current caller, used by the app at startup.
   * Available to all authenticated users; carries no flag metadata. For the admin
   * flag-management view use featureFlagEvaluationResult.
   */
  featureFlagEvaluations: Array<FeatureFlagEvaluation>;
  /**
   * Cross-tenant enablement for one or more feature flags in a single request.
   * Omit names to include all flags. Returns every tenant.
   */
  featureFlagTenantEnablements: Array<FeatureFlagTenantEnablement>;
  featureFlags: FeatureFlagConnection;
  /** Fetches the active KGV2 knowledge graph for a household. */
  fetchHouseholdKGV2?: Maybe<Kgv2Graph>;
  /**
   * Resolves specific KG V2 nodes by ID within a household the caller can read.
   * IDs that don't exist or aren't in the household are silently omitted.
   */
  fetchHouseholdKGV2Nodes: Array<Kgv2Node>;
  formDraftImportContract: FormDraftImportContract;
  /** Internal-only read links for Forms extraction operations in one household. */
  formSubmissionDiagnostics: Array<FormSubmissionDiagnostics>;
  forms: FormConnection;
  /**
   * Returns the AI DP workflow jobs started by the given user, that are in progress,
   * or are ready for review.
   */
  getAIDPWorkflowJobs: Array<AsyncJob>;
  getAddeparCacheJobStatusAndResults: AddeparJobStatusAndResults;
  getAddeparIntegrationEntityResults: Scalars['String']['output'];
  getAddeparJobStatusAndResults: AddeparJobStatusAndResults;
  getAddeparValuationJobStatusAndResults: AddeparJobStatusAndResults;
  getAssociatedDocuments?: Maybe<Array<Maybe<Document>>>;
  /** Returns the list of page ranges from a binder document. */
  getBinderDocumentPageRanges: Array<Scalars['String']['output']>;
  getCollaboratorUser?: Maybe<User>;
  /**  Returns a human-readable representation of the document's knowledge graph.  */
  getDocumentKnowledgeGraph: KnowledgeGraph;
  /** Read paragraphs after authorization on their file, in paragraph number and ID order. */
  getFileParagraphs: Array<FileParagraph>;
  /**  Returns a human-readable representation of a knowledge graph root.  */
  getKnowledgeGraph: KnowledgeGraph;
  getMostRecentDocumentAsyncJobs: Array<AsyncJob>;
  getParagraphs: Array<FileParagraph>;
  giftingProposalClientProjections: Array<GiftingProposalProjections>;
  globalSearch: GlobalSearchResult;
  /**
   * grantors is intended to be the literal definition of grantors, which is to say "client profiles who are eligible
   * or likely to put assets into trusts." This is distinct from being a "primary client".
   */
  grantors: Array<ClientProfile>;
  gratAnnuityV2s: GratAnnuityV2Connection;
  gratDesignSummaryDetails: GratDesignSummaryDetails;
  gratScenarioProjection: Projection;
  growthProfiles: GrowthProfileConnection;
  /**
   * householdAssetsSummary summarizes the household's assets by liquidity and estate
   * status. When source is provided, the balance sheet filters configured on that
   * surface (hidden columns) are applied to the calculation.
   */
  householdAssetsSummary: HouseholdAssetsSummary;
  /** The specialized household chat personas available to this user. */
  householdChatPersonas: Array<HouseholdChatPersona>;
  /**
   * Selection groups ordered by primary document ID, including documents without
   * completed extraction. Accepted links are previous versions, KG supersession,
   * and resolved KG modifications. Both endpoints must be readable documents in
   * this household. KG links require complete documents in the same active graph.
   */
  householdDocumentSelection: Array<DocumentSelectionGroup>;
  /**
   * Returns a list of missing documents for a household.
   * This query:
   * 1. Identifies required documents for the household and its grantors/minor children
   * 2. Checks which documents are missing (not uploaded)
   * 3. Filters out documents where a MissingDocumentOverride exists
   * 4. Returns a denormalized list of missing documents
   *
   * Missing document types checked:
   * - SIGNED_TRUST_DOCUMENT or TRUST_AMENDMENT for revocable trusts
   * - For each primary client profile:
   *   - HEALTHCARE_PROXY
   *   - WILL, WILL_CODICIL, or LIVING_WILL
   *   - POWER_OF_ATTORNEY
   * - For each minor child:
   *   - HEALTHCARE_PROXY
   */
  householdMissingDocuments: Array<HouseholdMissingDocument>;
  /**
   * Returns a household's workflow tracker history, including active and
   * terminal trackers, ordered from newest to oldest.
   */
  householdWorkflowTrackerHistory: WorkflowTrackerConnection;
  householdWorkflowTrackers: WorkflowTrackerConnection;
  households: HouseholdConnection;
  incomeTaxDragDefaults: IncomeTaxDragDefaults;
  /** Invokes the LLM to infer the DocumentType based on the input file name. */
  inferDocumentTypes: Array<InferDocumentTypeOutput>;
  /** Invokes the LLM to infer the EntityType based on the integration entities' names */
  inferEntityKinds: Array<InferEntityKindOutput>;
  /**
   * Invokes the LLM to infer the InsurancePolicyKind based on an input string.
   * Returns null if the string cannot be mapped to a known policy kind.
   */
  inferInsurancePolicyKind?: Maybe<InsurancePolicyKind>;
  /**
   * Invokes the LLM to find the best name match from a list of candidates.
   * Returns the matched candidate's ID, or null if no match is found.
   */
  inferNameMatch?: Maybe<Scalars['ID']['output']>;
  /** Invokes the LLM to infer the primary clients for a household. */
  inferPrimaryClients: Array<InferPrimaryClientsOutput>;
  insightsTemplateBundleConfigurations: InsightsTemplateBundleConfigurationConnection;
  insurancePolicies: InsurancePolicyConnection;
  integrationAssetClasses: IntegrationAssetClassConnection;
  integrationCashflows: IntegrationCashflowConnection;
  integrationClients: IntegrationClientConnection;
  integrationConfiguration?: Maybe<IntegrationConfiguration>;
  integrationEntities: IntegrationEntityConnection;
  integrationInsurances: IntegrationInsuranceConnection;
  integrationLiabilities: IntegrationLiabilityConnection;
  integrationPersons: IntegrationPersonConnection;
  irsConstants: IrsConstants;
  isIntegrationUserLoggedInToAddepar: IsLoggedInToAddepar;
  isIntegrationUserLoggedInToBlackDiamond: IsLoggedIn;
  isIntegrationUserLoggedInToEMoney: IsLoggedIn;
  isIntegrationUserLoggedInToOrion: IsLoggedIn;
  isUserLoggedInToAddepar: IsLoggedInToAddepar;
  isUserLoggedInToBlackDiamond: IsLoggedIn;
  isUserLoggedInToEMoney: IsLoggedIn;
  isUserLoggedInToOrion: IsLoggedIn;
  kgLoadingState: KgLoadingState;
  kgRoots: KgRootConnection;
  liabilities: LiabilityConnection;
  liabilitiesBundleConfigurations: LiabilitiesBundleConfigurationConnection;
  liabilityPaymentCalculation: LiabilityPaymentCalculationDetails;
  lifeInsuranceBundleConfigurations: LifeInsuranceBundleConfigurationConnection;
  lifetimeExclusionEvents: LifetimeExclusionEventConnection;
  loggedTransfers: LoggedTransferConnection;
  luminaryOrganizations: LuminaryOrganizationConnection;
  luminaryTenantJiTs: LuminaryTenantJitConnection;
  /**
   * Returns the current tenant's managed SFTP connection. Returns null before the
   * tenant has enabled managed SFTP for the first time.
   */
  managedSFTP?: Maybe<ManagedSftpConnection>;
  /** Lists only the immediate children of a relative path in the current tenant's inbound folder. */
  managedSFTPFiles: Array<ManagedSftpFileEntry>;
  memoPrompts: MemoPromptConnection;
  memos: MemoConnection;
  modelMappings: ModelMappingConnection;
  noPlanProjection: NoPlanProjection;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Lookup nodes by a list of IDs. */
  nodes: Array<Maybe<Node>>;
  notificationApps: NotificationAppConnection;
  notificationPreferences: NotificationPreferenceConnection;
  npv: Scalars['CurrencyUSD']['output'];
  official7520InterestRate: InterestRateSummary;
  openaiSdkConfigs: OpenaiSdkConfigConnection;
  organizationApplicationConfigurations: OrganizationApplicationConfigurationConnection;
  /**
   * Returns the organization disclaimer configuration that currently overrides
   * the authenticated tenant, or null when organization overrides are not active.
   */
  organizationDisclaimerConfiguration?: Maybe<OrganizationDisclaimerConfiguration>;
  /**
   * The presentation approval requests that the current user can still act on:
   * open approval requests that ask the current user to approve a presentation
   * that has no approval yet. When any permitted user approves a presentation,
   * its requests leave this list for every approver. Attestation requests are
   * not included. Employee.newPresentationApprovalRequestCount counts the same
   * requests that were created after lastViewedPresentationApprovalsAt.
   */
  pendingPresentationApprovalRequests: PresentationApprovalRequestConnection;
  /** Get the total value of assets administered on the platform */
  platformAUM: Scalars['CurrencyUSD']['output'];
  platformDocuments: PlatformDocumentConnection;
  possibleHypotheticalTransferEntities: EntityConnection;
  /**
   * possibleRelationshipOwners is a list of the employees on the platform that are eligible to be a relationship owner for an advisorClient
   * @deprecated Use possibleRelationshipOwnersV2 instead
   */
  possibleRelationshipOwners: Array<Maybe<Employee>>;
  possibleRelationshipOwnersV2: EmployeeConnection;
  presentationApprovalRequests: PresentationApprovalRequestConnection;
  /**
   * The users who can approve presentations in the household, sorted by name.
   * A user is eligible when one of their roles in the tenant has the
   * presentation approver capability and they have the approve_presentation
   * permission on the household. Use their IDs as requestedApproverIDs in
   * requestClientPresentationV2Approval. To search by name or email, filter
   * with searchNameContainsFold or emailContainsFold.
   *
   * Returns FORBIDDEN when the current user cannot view the household.
   */
  presentationApprovers: UserConnection;
  presentationAssetDistributionBundleConfigurations: PresentationAssetDistributionBundleConfigurationConnection;
  presentationBusinessOverviewBundleConfigurations: PresentationBusinessOverviewBundleConfigurationConnection;
  presentationDocumentsReviewedBundleConfigurations: PresentationDocumentsReviewedBundleConfigurationConnection;
  presentationFamilyOverviewBundleConfigurations: PresentationFamilyOverviewBundleConfigurationConnection;
  presentationHealthcareDirectiveBundleConfigurations: PresentationHealthcareDirectiveBundleConfigurationConnection;
  presentationPlanningOpportunitiesBundleConfigurations: PresentationPlanningOpportunitiesBundleConfigurationConnection;
  presentationPowerOfAttorneyBundleConfigurations: PresentationPowerOfAttorneyBundleConfigurationConnection;
  /**
   * presentationSystemPrompts returns the built-in page prompts that users can
   * apply in the slide editor. Internal and compatibility-only prompts are not
   * included.
   */
  presentationSystemPrompts: Array<PresentationSystemPrompt>;
  presentationTemplates: PresentationTemplateConnection;
  presentationTrustOverviewBundleConfigurations: PresentationTrustOverviewBundleConfigurationConnection;
  presentationWillBundleConfigurations: PresentationWillBundleConfigurationConnection;
  proposalScenarioProjectionV2: ProposalScenarioProjectionResult;
  proposalYearProjectionOptionsV2: Array<YearProjectionOption>;
  proposals: ProposalConnection;
  queryAddeparUserInfo: AddeparQueryResults;
  queryBlackDiamondAccount: BlackDiamondQueryResults;
  queryBlackDiamondAccountDetails: BlackDiamondQueryResults;
  queryBlackDiamondBatch: BlackDiamondBulkQueryResults;
  queryBlackDiamondPortfolio: BlackDiamondQueryResults;
  queryBlackDiamondRelationships: BlackDiamondQueryResults;
  /**
   * Searches the document to find bounding regions that best answer the query,
   * and generates a response to the query synchronously.
   */
  queryDocument: QueryDocumentResultWithResponse;
  queryEMoneyAsset: EMoneyQueryResults;
  queryEMoneyAssetHoldings: EMoneyQueryResults;
  queryEMoneyClientPlans: EMoneyQueryResults;
  queryEMoneyClients: EMoneyQueryResults;
  queryEMoneyExpense: EMoneyQueryResults;
  queryEMoneyIncome: EMoneyQueryResults;
  queryEMoneyLifeInsurance: EMoneyQueryResults;
  queryEMoneyPlanAssets: EMoneyQueryResults;
  queryEMoneyPlanExpenses: EMoneyQueryResults;
  queryEMoneyPlanIncomes: EMoneyQueryResults;
  queryEMoneyPlanLiabilities: EMoneyQueryResults;
  queryEMoneyPlanLifeInsurance: EMoneyQueryResults;
  queryEMoneyPlanTrustsAndPartnerships: EMoneyQueryResults;
  queryEMoneyTrust: EMoneyQueryResults;
  queryHargroveAdvisors: HargroveQueryResults;
  queryHargroveClients: HargroveQueryResults;
  recentClients: Array<Household>;
  recentDocuments: Array<Document>;
  recentEntities: Array<Entity>;
  recentProposals: Array<Proposal>;
  releaseGroups: ReleaseGroupConnection;
  /** The grouped ROLE_SUMMARY filter options available to the frontend, including display labels and the raw KGV2 statement predicates they expand to. */
  roleSummaryPredicateOptions: Array<RoleSummaryPredicateOption>;
  roles: RoleConnection;
  salesforceConnection?: Maybe<SalesforceConnectionStatus>;
  salesforceDestinationAccounts: Array<SalesforceDestinationAccount>;
  salesforceDestinationLegalEntities: Array<SalesforceDestinationLegalEntity>;
  salesforceExportAttempts: SalesforceExportAttemptConnection;
  salesforceHouseholdConnection: SalesforceConnectionStatus;
  salesforceHouseholdSuggestions: Array<SalesforceHouseholdSuggestion>;
  salesforceLayouts: Array<SalesforceLayout>;
  salesforceObjectDescription: SalesforceObjectDescription;
  salesforceObjects: Array<SalesforceObject>;
  salesforceValidateDestination: Scalars['Boolean']['output'];
  searchHouseholds: HouseholdConnection;
  searchRelevantDocumentParagraphs: Array<SearchResult>;
  searchRelevantDocumentParagraphsBulk: Array<SearchResult>;
  /**
   * Lists the family fixtures that can be seeded as e360 corpus households.
   * Returns an empty list in production.
   */
  seedableE360FixtureFamilies: Array<SeedableE360FixtureFamily>;
  /** @deprecated Use the new dispositive provisions API */
  simulateDispositiveProvisions: SimulateDispositiveProvisions;
  ssoConnections: SsoConnectionConnection;
  subBrands: SubBrandConnection;
  submissions: SubmissionConnection;
  suggestEntityDetailsFromText: BasicEntityDetailsSuggestion;
  teams: TeamConnection;
  tenantApplicationConfiguration?: Maybe<TenantApplicationConfiguration>;
  tenantDocuments: TenantDocumentConnection;
  tenantInformation: TenantInformation;
  /**
   * Returns the knowledge graph health score for the currently authenticated tenant.
   * The score is computed as the average of per-household health scores.
   */
  tenantKGHealthScore: TenantKgHealthScore;
  tenantSSOConnections: TenantSsoConnectionConnection;
  tenantSecurityConfiguration?: Maybe<TenantSecurityConfiguration>;
  tenantSlideConfigs: TenantSlideConfigConnection;
  testamentaryEntities: TestamentaryEntityConnection;
  unreadNotificationCount: Scalars['Int']['output'];
  userNotificationConfigurations: UserNotificationConfigurationConnection;
  waterfallBundleConfigurations: WaterfallBundleConfigurationConnection;
  waterfallComparisonTemplateBundleConfigurations: WaterfallComparisonTemplateBundleConfigurationConnection;
  waterfallTemplateBundleConfigurations: WaterfallTemplateBundleConfigurationConnection;
  workOsOrganizationDomains: WorkOsOrganizationDomainConnection;
  workOsOrganizations: WorkOsOrganizationConnection;
  workflowTrackers: WorkflowTrackerConnection;
};


export type QueryActivityGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first: Scalars['Int']['input'];
  where?: InputMaybe<ActivityWhereInput>;
};


export type QueryAdminWorkflowTrackersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkflowTrackerOrder>>;
  where?: InputMaybe<WorkflowTrackerWhereInput>;
};


export type QueryAiSuggestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AiSuggestionOrder>>;
  where?: InputMaybe<AiSuggestionWhereInput>;
};


export type QueryArchetypeHouseholdsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HouseholdOrder>>;
  where?: InputMaybe<HouseholdWhereInput>;
};


export type QueryAssetClassesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssetClassOrder>>;
  where?: InputMaybe<AssetClassWhereInput>;
};


export type QueryBalanceSheetArgs = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  configurationID?: InputMaybe<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
  presentationConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBalanceSheetBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BalanceSheetBundleConfigurationOrder>>;
  where?: InputMaybe<BalanceSheetBundleConfigurationWhereInput>;
};


export type QueryBalanceSheetCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BalanceSheetCategoryOrder>>;
  where?: InputMaybe<BalanceSheetCategoryWhereInput>;
};


export type QueryBeneficiariesTemplateBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BeneficiariesTemplateBundleConfigurationOrder>>;
  where?: InputMaybe<BeneficiariesTemplateBundleConfigurationWhereInput>;
};


export type QueryBeneficiarySummariesv2Args = {
  grantorClientProfileId: Scalars['ID']['input'];
  inputs: Array<BeneficiarySummaryQueryv2>;
};


export type QueryCashflowsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CashflowOrder>>;
  where?: InputMaybe<CashflowWhereInput>;
};


export type QueryClientOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClientOrganizationOrder>>;
  where?: InputMaybe<ClientOrganizationWhereInput>;
};


export type QueryClientPresentationV2sArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClientPresentationV2Order>>;
  where?: InputMaybe<ClientPresentationV2WhereInput>;
};


export type QueryClientProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClientProfileOrder>>;
  where?: InputMaybe<ClientProfileWhereInput>;
};


export type QueryCltOptimizationArgs = {
  input?: InputMaybe<CltOptimizationInput>;
};


export type QueryCltProposalProjectionArgs = {
  input: CltProposalProjectionInput;
};


export type QueryCollaboratorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CollaboratorOrder>>;
  where?: InputMaybe<CollaboratorWhereInput>;
};


export type QueryComparedWaterfallsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ComparedWaterfallOrder>>;
  where?: InputMaybe<ComparedWaterfallWhereInput>;
};


export type QueryConversationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConversationOrder>>;
  where?: InputMaybe<ConversationWhereInput>;
};


export type QueryCoverPageConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CoverPageConfigurationOrder>>;
  where?: InputMaybe<CoverPageConfigurationWhereInput>;
};


export type QueryCrtOptimizationArgs = {
  input?: InputMaybe<CrtOptimizationInput>;
};


export type QueryCrtProposalProjectionArgs = {
  input: CrtProposalProjectionInput;
};


export type QueryCurrentUserWorkflowTrackerHistoryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<CurrentUserWorkflowTrackerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDiagramArtifactPromptsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DiagramArtifactPromptOrder>>;
  where?: InputMaybe<DiagramArtifactPromptWhereInput>;
};


export type QueryDiagramArtifactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DiagramArtifactOrder>>;
  where?: InputMaybe<DiagramArtifactWhereInput>;
};


export type QueryDispositiveProvisionTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositiveProvisionTemplateOrder>>;
  where?: InputMaybe<DispositiveProvisionTemplateWhereInput>;
};


export type QueryDividerBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DividerBundleConfigurationOrder>>;
  where?: InputMaybe<DividerBundleConfigurationWhereInput>;
};


export type QueryDividerTemplateBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DividerTemplateBundleConfigurationOrder>>;
  where?: InputMaybe<DividerTemplateBundleConfigurationWhereInput>;
};


export type QueryDocumentSummariesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSummaryOrder>>;
  where?: InputMaybe<DocumentSummaryWhereInput>;
};


export type QueryDocumentSummaryPromptsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSummaryPromptOrder>>;
  where?: InputMaybe<DocumentSummaryPromptWhereInput>;
};


export type QueryDocumentSummaryTemplateBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSummaryTemplateBundleConfigurationOrder>>;
  where?: InputMaybe<DocumentSummaryTemplateBundleConfigurationWhereInput>;
};


export type QueryDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentOrder>>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type QueryEffectiveDisclaimerConfigurationArgs = {
  subBrandID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmployeeOrder>>;
  where?: InputMaybe<EmployeeWhereInput>;
};


export type QueryEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityOrder>>;
  where?: InputMaybe<EntityWhereInput>;
};


export type QueryEntitiesOverviewBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntitiesOverviewBundleConfigurationOrder>>;
  where?: InputMaybe<EntitiesOverviewBundleConfigurationWhereInput>;
};


export type QueryEntityBalanceSheetArgs = {
  entityID: Scalars['ID']['input'];
};


export type QueryEntityDiagramsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityDiagramOrder>>;
  where?: InputMaybe<EntityDiagramWhereInput>;
};


export type QueryEntityGraphViewBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityGraphViewBundleConfigurationOrder>>;
  where?: InputMaybe<EntityGraphViewBundleConfigurationWhereInput>;
};


export type QueryEntityGraphViewsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityGraphViewOrder>>;
  where?: InputMaybe<EntityGraphViewWhereInput>;
};


export type QueryEntitySummaryBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntitySummaryBundleConfigurationOrder>>;
  where?: InputMaybe<EntitySummaryBundleConfigurationWhereInput>;
};


export type QueryEntitySummaryTemplateBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntitySummaryTemplateBundleConfigurationOrder>>;
  where?: InputMaybe<EntitySummaryTemplateBundleConfigurationWhereInput>;
};


export type QueryEntityTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityTaskOrder>>;
  where?: InputMaybe<EntityTaskWhereInput>;
};


export type QueryEstateInsightsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EstateInsightOrder>>;
  where?: InputMaybe<EstateInsightWhereInput>;
};


export type QueryEstateInsightsBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EstateInsightsBundleConfigurationOrder>>;
  where?: InputMaybe<EstateInsightsBundleConfigurationWhereInput>;
};


export type QueryEstateTaxScenarioPossibleEntitiesArgs = {
  input: EstateTaxScenarioPossibleEntitiesInput;
};


export type QueryEstateTaxScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EstateTaxScenarioOrder>>;
  where?: InputMaybe<EstateTaxScenarioWhereInput>;
};


export type QueryEstateWaterfallsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EstateWaterfallOrder>>;
  where?: InputMaybe<EstateWaterfallWhereInput>;
};


export type QueryExportHouseholdForKnowledgeGraphArgs = {
  householdID: Scalars['ID']['input'];
};


export type QueryFamilyTreeArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryFamilyTreeBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FamilyTreeBundleConfigurationOrder>>;
  where?: InputMaybe<FamilyTreeBundleConfigurationWhereInput>;
};


export type QueryFeatureFlagTenantEnablementsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryFeatureFlagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FeatureFlagOrder>>;
  where?: InputMaybe<FeatureFlagWhereInput>;
};


export type QueryFetchHouseholdKgv2Args = {
  input: FetchHouseholdKgv2Input;
};


export type QueryFetchHouseholdKgv2NodesArgs = {
  input: FetchHouseholdKgv2NodesInput;
};


export type QueryFormSubmissionDiagnosticsArgs = {
  householdID: Scalars['ID']['input'];
};


export type QueryFormsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FormOrder>>;
  where?: InputMaybe<FormWhereInput>;
};


export type QueryGetAidpWorkflowJobsArgs = {
  userID: Scalars['ID']['input'];
};


export type QueryGetAddeparCacheJobStatusAndResultsArgs = {
  jobID?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAddeparIntegrationEntityResultsArgs = {
  integrationIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAddeparJobStatusAndResultsArgs = {
  jobID: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAddeparValuationJobStatusAndResultsArgs = {
  jobID?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAssociatedDocumentsArgs = {
  documentID: Scalars['ID']['input'];
};


export type QueryGetBinderDocumentPageRangesArgs = {
  documentID: Scalars['ID']['input'];
};


export type QueryGetCollaboratorUserArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetDocumentKnowledgeGraphArgs = {
  documentID: Scalars['ID']['input'];
};


export type QueryGetFileParagraphsArgs = {
  fileID: Scalars['ID']['input'];
};


export type QueryGetKnowledgeGraphArgs = {
  kgRootID: Scalars['ID']['input'];
};


export type QueryGetMostRecentDocumentAsyncJobsArgs = {
  kind: AsyncJobKind;
};


export type QueryGetParagraphsArgs = {
  paragraphIDs: Array<Scalars['ID']['input']>;
};


export type QueryGiftingProposalClientProjectionsArgs = {
  params: GiftingProposalClientProjectionParams;
};


export type QueryGlobalSearchArgs = {
  input: GlobalSearchInput;
};


export type QueryGrantorsArgs = {
  query: Scalars['String']['input'];
};


export type QueryGratAnnuityV2sArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GratAnnuityV2Order>>;
  where?: InputMaybe<GratAnnuityV2WhereInput>;
};


export type QueryGratDesignSummaryDetailsArgs = {
  entityID: Scalars['ID']['input'];
};


export type QueryGratScenarioProjectionArgs = {
  params: ProjectionParams;
};


export type QueryGrowthProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GrowthProfileOrder>>;
  where?: InputMaybe<GrowthProfileWhereInput>;
};


export type QueryHouseholdAssetsSummaryArgs = {
  id: Scalars['ID']['input'];
  source?: InputMaybe<SummaryMetricsSourceInput>;
};


export type QueryHouseholdDocumentSelectionArgs = {
  householdID: Scalars['ID']['input'];
};


export type QueryHouseholdMissingDocumentsArgs = {
  householdID: Scalars['ID']['input'];
};


export type QueryHouseholdWorkflowTrackerHistoryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<HouseholdWorkflowTrackerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdID: Scalars['ID']['input'];
};


export type QueryHouseholdWorkflowTrackersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdID: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkflowTrackerOrder>>;
  where?: InputMaybe<WorkflowTrackerWhereInput>;
};


export type QueryHouseholdsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HouseholdOrder>>;
  where?: InputMaybe<HouseholdWhereInput>;
};


export type QueryInferDocumentTypesArgs = {
  input: Array<InferDocumentTypeInput>;
};


export type QueryInferEntityKindsArgs = {
  input: Array<InferEntityKindInput>;
};


export type QueryInferInsurancePolicyKindArgs = {
  input: Scalars['String']['input'];
};


export type QueryInferNameMatchArgs = {
  input: InferNameMatchInput;
};


export type QueryInferPrimaryClientsArgs = {
  input: Array<InferPrimaryClientsInput>;
};


export type QueryInsightsTemplateBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InsightsTemplateBundleConfigurationOrder>>;
  where?: InputMaybe<InsightsTemplateBundleConfigurationWhereInput>;
};


export type QueryInsurancePoliciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InsurancePolicyOrder>>;
  where?: InputMaybe<InsurancePolicyWhereInput>;
};


export type QueryIntegrationAssetClassesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IntegrationAssetClassOrder>>;
  where?: InputMaybe<IntegrationAssetClassWhereInput>;
};


export type QueryIntegrationCashflowsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IntegrationCashflowOrder>>;
  where?: InputMaybe<IntegrationCashflowWhereInput>;
};


export type QueryIntegrationClientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IntegrationClientOrder>>;
  where?: InputMaybe<IntegrationClientWhereInput>;
};


export type QueryIntegrationEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IntegrationEntityOrder>>;
  where?: InputMaybe<IntegrationEntityWhereInput>;
};


export type QueryIntegrationInsurancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IntegrationInsuranceOrder>>;
  where?: InputMaybe<IntegrationInsuranceWhereInput>;
};


export type QueryIntegrationLiabilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IntegrationLiabilityOrder>>;
  where?: InputMaybe<IntegrationLiabilityWhereInput>;
};


export type QueryIntegrationPersonsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IntegrationPersonOrder>>;
  where?: InputMaybe<IntegrationPersonWhereInput>;
};


export type QueryIrsConstantsArgs = {
  at?: InputMaybe<Scalars['Time']['input']>;
};


export type QueryKgLoadingStateArgs = {
  householdID: Scalars['ID']['input'];
};


export type QueryKgRootsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KgRootOrder>>;
  where?: InputMaybe<KgRootWhereInput>;
};


export type QueryLiabilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiabilityOrder>>;
  where?: InputMaybe<LiabilityWhereInput>;
};


export type QueryLiabilitiesBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiabilitiesBundleConfigurationOrder>>;
  where?: InputMaybe<LiabilitiesBundleConfigurationWhereInput>;
};


export type QueryLiabilityPaymentCalculationArgs = {
  params: LiabilityPaymentCalculationInput;
};


export type QueryLifeInsuranceBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LifeInsuranceBundleConfigurationOrder>>;
  where?: InputMaybe<LifeInsuranceBundleConfigurationWhereInput>;
};


export type QueryLifetimeExclusionEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LifetimeExclusionEventOrder>>;
  where?: InputMaybe<LifetimeExclusionEventWhereInput>;
};


export type QueryLoggedTransfersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LoggedTransferOrder>>;
  where?: InputMaybe<LoggedTransferWhereInput>;
};


export type QueryLuminaryOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LuminaryOrganizationOrder>>;
  where?: InputMaybe<LuminaryOrganizationWhereInput>;
};


export type QueryLuminaryTenantJiTsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LuminaryTenantJitOrder>>;
  where?: InputMaybe<LuminaryTenantJitWhereInput>;
};


export type QueryManagedSftpFilesArgs = {
  path: Scalars['String']['input'];
};


export type QueryMemoPromptsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemoPromptOrder>>;
  where?: InputMaybe<MemoPromptWhereInput>;
};


export type QueryMemosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemoOrder>>;
  where?: InputMaybe<MemoWhereInput>;
};


export type QueryModelMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ModelMappingOrder>>;
  where?: InputMaybe<ModelMappingWhereInput>;
};


export type QueryNoPlanProjectionArgs = {
  input: NoPlanProjectionInput;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryNotificationAppsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationAppOrder>>;
  where?: InputMaybe<NotificationAppWhereInput>;
};


export type QueryNotificationPreferencesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationPreferenceOrder>>;
  where?: InputMaybe<NotificationPreferenceWhereInput>;
};


export type QueryNpvArgs = {
  cashFlows: Array<Scalars['CurrencyUSD']['input']>;
  discountPercent: Scalars['Percent']['input'];
};


export type QueryOpenaiSdkConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OpenaiSdkConfigOrder>>;
  where?: InputMaybe<OpenaiSdkConfigWhereInput>;
};


export type QueryOrganizationApplicationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationApplicationConfigurationOrder>>;
  where?: InputMaybe<OrganizationApplicationConfigurationWhereInput>;
};


export type QueryPendingPresentationApprovalRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationApprovalRequestOrder>>;
  where?: InputMaybe<PresentationApprovalRequestWhereInput>;
};


export type QueryPlatformDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PlatformDocumentOrder>>;
  where?: InputMaybe<PlatformDocumentWhereInput>;
};


export type QueryPossibleHypotheticalTransferEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityOrder>>;
  where?: InputMaybe<EntityWhereInput>;
};


export type QueryPossibleRelationshipOwnersV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmployeeOrder>>;
  where?: InputMaybe<EmployeeWhereInput>;
};


export type QueryPresentationApprovalRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationApprovalRequestOrder>>;
  where?: InputMaybe<PresentationApprovalRequestWhereInput>;
};


export type QueryPresentationApproversArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdID: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryPresentationAssetDistributionBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationAssetDistributionBundleConfigurationOrder>>;
  where?: InputMaybe<PresentationAssetDistributionBundleConfigurationWhereInput>;
};


export type QueryPresentationBusinessOverviewBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationBusinessOverviewBundleConfigurationOrder>>;
  where?: InputMaybe<PresentationBusinessOverviewBundleConfigurationWhereInput>;
};


export type QueryPresentationDocumentsReviewedBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationDocumentsReviewedBundleConfigurationOrder>>;
  where?: InputMaybe<PresentationDocumentsReviewedBundleConfigurationWhereInput>;
};


export type QueryPresentationFamilyOverviewBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationFamilyOverviewBundleConfigurationOrder>>;
  where?: InputMaybe<PresentationFamilyOverviewBundleConfigurationWhereInput>;
};


export type QueryPresentationHealthcareDirectiveBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationHealthcareDirectiveBundleConfigurationOrder>>;
  where?: InputMaybe<PresentationHealthcareDirectiveBundleConfigurationWhereInput>;
};


export type QueryPresentationPlanningOpportunitiesBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationPlanningOpportunitiesBundleConfigurationOrder>>;
  where?: InputMaybe<PresentationPlanningOpportunitiesBundleConfigurationWhereInput>;
};


export type QueryPresentationPowerOfAttorneyBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationPowerOfAttorneyBundleConfigurationOrder>>;
  where?: InputMaybe<PresentationPowerOfAttorneyBundleConfigurationWhereInput>;
};


export type QueryPresentationTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationTemplateOrder>>;
  where?: InputMaybe<PresentationTemplateWhereInput>;
};


export type QueryPresentationTrustOverviewBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationTrustOverviewBundleConfigurationOrder>>;
  where?: InputMaybe<PresentationTrustOverviewBundleConfigurationWhereInput>;
};


export type QueryPresentationWillBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PresentationWillBundleConfigurationOrder>>;
  where?: InputMaybe<PresentationWillBundleConfigurationWhereInput>;
};


export type QueryProposalScenarioProjectionV2Args = {
  input: ProposalScenarioProjectionParamsV2;
};


export type QueryProposalYearProjectionOptionsV2Args = {
  entityId: Scalars['ID']['input'];
};


export type QueryProposalsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProposalOrder>>;
  where?: InputMaybe<ProposalWhereInput>;
};


export type QueryQueryAddeparUserInfoArgs = {
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryBlackDiamondAccountArgs = {
  accountID: Scalars['String']['input'];
};


export type QueryQueryBlackDiamondAccountDetailsArgs = {
  accountID: Scalars['String']['input'];
};


export type QueryQueryBlackDiamondBatchArgs = {
  batchID?: InputMaybe<Scalars['String']['input']>;
  fileExpression?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQueryBlackDiamondPortfolioArgs = {
  portfolioID: Scalars['String']['input'];
};


export type QueryQueryBlackDiamondRelationshipsArgs = {
  userID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQueryDocumentArgs = {
  input: DocumentBoundingRegionQueryInput;
};


export type QueryQueryEMoneyAssetArgs = {
  assetID: Scalars['String']['input'];
  clientID: Scalars['String']['input'];
  planID?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryEMoneyAssetHoldingsArgs = {
  assetID: Scalars['String']['input'];
  clientID: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryEMoneyClientPlansArgs = {
  clientID: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryEMoneyClientsArgs = {
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryEMoneyExpenseArgs = {
  clientID: Scalars['String']['input'];
  expenseID: Scalars['String']['input'];
  planID?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryEMoneyIncomeArgs = {
  clientID: Scalars['String']['input'];
  incomeID: Scalars['String']['input'];
  planID?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryEMoneyLifeInsuranceArgs = {
  clientID: Scalars['String']['input'];
  lifeInsuranceID: Scalars['String']['input'];
  planID?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryEMoneyPlanAssetsArgs = {
  clientID: Scalars['String']['input'];
  planID?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryEMoneyPlanExpensesArgs = {
  clientID: Scalars['String']['input'];
  planID?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryEMoneyPlanIncomesArgs = {
  clientID: Scalars['String']['input'];
  planID?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryEMoneyPlanLiabilitiesArgs = {
  clientID: Scalars['String']['input'];
  planID?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryEMoneyPlanLifeInsuranceArgs = {
  clientID: Scalars['String']['input'];
  planID?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryEMoneyPlanTrustsAndPartnershipsArgs = {
  clientID: Scalars['String']['input'];
  planID?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryEMoneyTrustArgs = {
  clientID: Scalars['String']['input'];
  planID?: InputMaybe<Scalars['String']['input']>;
  trustID: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryQueryHargroveAdvisorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  partnerID: Scalars['String']['input'];
};


export type QueryQueryHargroveClientsArgs = {
  advisorID: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecentClientsArgs = {
  first: Scalars['Int']['input'];
};


export type QueryRecentDocumentsArgs = {
  first: Scalars['Int']['input'];
  where: RecentEntityWhereInput;
};


export type QueryRecentEntitiesArgs = {
  first: Scalars['Int']['input'];
  where: RecentEntityWhereInput;
};


export type QueryRecentProposalsArgs = {
  first: Scalars['Int']['input'];
  where: RecentEntityWhereInput;
};


export type QueryReleaseGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReleaseGroupOrder>>;
  where?: InputMaybe<ReleaseGroupWhereInput>;
};


export type QueryRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RoleOrder>>;
  where?: InputMaybe<RoleWhereInput>;
};


export type QuerySalesforceDestinationAccountsArgs = {
  householdID: Scalars['ID']['input'];
};


export type QuerySalesforceDestinationLegalEntitiesArgs = {
  destination: SalesforceExportDestinationInput;
  householdID: Scalars['ID']['input'];
};


export type QuerySalesforceExportAttemptsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SalesforceExportAttemptOrder>>;
  where?: InputMaybe<SalesforceExportAttemptWhereInput>;
};


export type QuerySalesforceHouseholdConnectionArgs = {
  householdID: Scalars['ID']['input'];
};


export type QuerySalesforceHouseholdSuggestionsArgs = {
  householdID: Scalars['ID']['input'];
  prefix: Scalars['String']['input'];
};


export type QuerySalesforceLayoutsArgs = {
  object: Scalars['String']['input'];
};


export type QuerySalesforceObjectDescriptionArgs = {
  object: Scalars['String']['input'];
};


export type QuerySalesforceValidateDestinationArgs = {
  destination: SalesforceExportDestinationInput;
  householdID: Scalars['ID']['input'];
};


export type QuerySearchHouseholdsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HouseholdOrder>>;
  query: Scalars['String']['input'];
  where?: InputMaybe<HouseholdWhereInput>;
};


export type QuerySearchRelevantDocumentParagraphsArgs = {
  input: SearchRelevantDocumentParagraphsInput;
};


export type QuerySearchRelevantDocumentParagraphsBulkArgs = {
  input: SearchRelevantDocumentParagraphsBulkInput;
};


export type QuerySimulateDispositiveProvisionsArgs = {
  input: SimulateDispositiveProvisionsInput;
};


export type QuerySsoConnectionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SsoConnectionOrder>>;
  where?: InputMaybe<SsoConnectionWhereInput>;
};


export type QuerySubBrandsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubBrandOrder>>;
  where?: InputMaybe<SubBrandWhereInput>;
};


export type QuerySubmissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubmissionOrder>>;
  where?: InputMaybe<SubmissionWhereInput>;
};


export type QuerySuggestEntityDetailsFromTextArgs = {
  household: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type QueryTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamOrder>>;
  where?: InputMaybe<TeamWhereInput>;
};


export type QueryTenantDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantDocumentOrder>>;
  where?: InputMaybe<TenantDocumentWhereInput>;
};


export type QueryTenantSsoConnectionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantSsoConnectionOrder>>;
  where?: InputMaybe<TenantSsoConnectionWhereInput>;
};


export type QueryTenantSlideConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantSlideConfigOrder>>;
  where?: InputMaybe<TenantSlideConfigWhereInput>;
};


export type QueryTestamentaryEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TestamentaryEntityOrder>>;
  where?: InputMaybe<TestamentaryEntityWhereInput>;
};


export type QueryUserNotificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserNotificationConfigurationOrder>>;
  where?: InputMaybe<UserNotificationConfigurationWhereInput>;
};


export type QueryWaterfallBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WaterfallBundleConfigurationOrder>>;
  where?: InputMaybe<WaterfallBundleConfigurationWhereInput>;
};


export type QueryWaterfallComparisonTemplateBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WaterfallComparisonTemplateBundleConfigurationOrder>>;
  where?: InputMaybe<WaterfallComparisonTemplateBundleConfigurationWhereInput>;
};


export type QueryWaterfallTemplateBundleConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WaterfallTemplateBundleConfigurationOrder>>;
  where?: InputMaybe<WaterfallTemplateBundleConfigurationWhereInput>;
};


export type QueryWorkOsOrganizationDomainsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkOsOrganizationDomainOrder>>;
  where?: InputMaybe<WorkOsOrganizationDomainWhereInput>;
};


export type QueryWorkOsOrganizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkOsOrganizationOrder>>;
  where?: InputMaybe<WorkOsOrganizationWhereInput>;
};


export type QueryWorkflowTrackersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkflowTrackerOrder>>;
  where?: InputMaybe<WorkflowTrackerWhereInput>;
};

export type QueryDocumentResultWithResponse = {
  __typename?: 'QueryDocumentResultWithResponse';
  boundingRegions: Array<BoundingRegion>;
  paragraphIds: Array<Scalars['ID']['output']>;
  response: Scalars['String']['output'];
};

export type RecentEntityWhereInput = {
  clientID?: InputMaybe<Scalars['ID']['input']>;
};

export type RefreshHouseholdSuggestionsInput = {
  householdID: Scalars['ID']['input'];
};

export type RegenerateAiSuggestionsV2ForTargetInput = {
  /** ID of the household that owns the target. */
  householdID: Scalars['ID']['input'];
  /** Optional knobs. When omitted, every applicable suggestion kind for the target regenerates. */
  opts?: InputMaybe<RegenerateAiSuggestionsV2ForTargetOpts>;
  /**
   * ID of the target whose suggestions to regenerate. Parsed server-side to
   * discover the underlying target type (e.g. entity, testamentary entity).
   * Unsupported target kinds return an error.
   */
  targetID: Scalars['ID']['input'];
};

export type RegenerateAiSuggestionsV2ForTargetOpts = {
  /** When true (default), include DP (distribution planning) suggestions in regeneration. */
  includeDPSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true (default), include entity-detail suggestions (trustee, grantor, etc.) in regeneration. */
  includeDetailsSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegenerateAiSuggestionsV2Input = {
  entityID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
};

export type RegenerateAllDpSuggestionsV2Input = {
  /** The householdID whose v2 DP suggestions should be wiped and regenerated. */
  householdID: Scalars['ID']['input'];
};

export type RegenerateMemoInput = {
  id: Scalars['ID']['input'];
  specificInstructions?: InputMaybe<Scalars['String']['input']>;
};

export type RegeneratePresentationDiagramInput = {
  /** The current canonical edge definitions for the diagram graph. */
  edgeDefinitions: Array<PresentationDiagramEdgeDefinitionInput>;
  /** The household ID to regenerate the diagram for. */
  householdID: Scalars['ID']['input'];
  /** The current canonical node definitions plus layout settings for the diagram graph. */
  nodeConfigurations: Array<PresentationDiagramNodeConfigurationInput>;
  /**
   * Optional presentation ID. When provided, the knowledge graph closest to the
   * presentation's creation time will be used as context instead of the most recent one.
   */
  presentationID?: InputMaybe<Scalars['ID']['input']>;
  /** The user's prompt describing how to update the diagram. */
  prompt: Scalars['String']['input'];
};

export type RegeneratePresentationDiagramPayload = {
  __typename?: 'RegeneratePresentationDiagramPayload';
  /** The regenerated canonical edge definitions for the diagram graph. */
  edgeDefinitions: Array<PresentationDiagramEdgeDefinition>;
  /** Short user-facing summary of the diagram changes. */
  message: Scalars['String']['output'];
  /** The regenerated canonical node definitions plus layout settings for the diagram graph. */
  nodeConfigurations: Array<PresentationDiagramNodeConfiguration>;
  /**
   * The regenerated death-event bands, or null when the diagram has no timeline.
   * Persist these together with nodeConfigurations: each node's phase index is
   * meaningless against a stale set of bands.
   */
  phases?: Maybe<PresentationDiagramPhases>;
};

export type RegeneratePresentationTemplateDiagramInput = {
  /** The current canonical edge definitions for the diagram graph. */
  edgeDefinitions: Array<PresentationDiagramEdgeDefinitionInput>;
  /** The household ID whose KG and documents provide context. */
  householdID: Scalars['ID']['input'];
  /** The current canonical node definitions plus layout settings for the diagram graph. */
  nodeConfigurations: Array<PresentationDiagramNodeConfigurationInput>;
  /**
   * The diagram's current death-event bands, when it has a timeline. Supplying them
   * lets the agent edit the existing timeline instead of re-deriving it; the
   * regenerated bands come back on the payload's phases field.
   */
  phases?: InputMaybe<PresentationDiagramPhasesInput>;
  /** The presentation ID; used to scope KG context to the correct point in time. */
  presentationID: Scalars['ID']['input'];
  /** The user's prompt describing how to update the diagram. */
  prompt: Scalars['String']['input'];
};

export type ReleaseGroup = Node & {
  __typename?: 'ReleaseGroup';
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: ReleaseGroupName;
  tenants?: Maybe<Array<Tenant>>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type ReleaseGroupConnection = {
  __typename?: 'ReleaseGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReleaseGroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReleaseGroupEdge = {
  __typename?: 'ReleaseGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ReleaseGroup>;
};

/** ReleaseGroupName is enum for the field name */
export enum ReleaseGroupName {
  FriendsOfLuminary = 'FRIENDS_OF_LUMINARY',
  LimitedReleaseBroad = 'LIMITED_RELEASE_BROAD',
  LimitedReleaseNormal = 'LIMITED_RELEASE_NORMAL'
}

/** Ordering options for ReleaseGroup connections */
export type ReleaseGroupOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ReleaseGroups. */
  field: ReleaseGroupOrderField;
};

/** Properties by which ReleaseGroup connections can be ordered. */
export enum ReleaseGroupOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * ReleaseGroupWhereInput is used for filtering ReleaseGroup objects.
 * Input was generated by ent.
 */
export type ReleaseGroupWhereInput = {
  and?: InputMaybe<Array<ReleaseGroupWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<ReleaseGroupName>;
  nameIn?: InputMaybe<Array<ReleaseGroupName>>;
  nameNEQ?: InputMaybe<ReleaseGroupName>;
  nameNotIn?: InputMaybe<Array<ReleaseGroupName>>;
  not?: InputMaybe<ReleaseGroupWhereInput>;
  or?: InputMaybe<Array<ReleaseGroupWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type ReminderEmailNotificationRecord = Node & {
  __typename?: 'ReminderEmailNotificationRecord';
  createdAt: Scalars['Time']['output'];
  /** The entity that this email notification is associated with. */
  entities?: Maybe<Array<Entity>>;
  id: Scalars['ID']['output'];
  /** User readable name of the template used for the email. */
  notificationType: ReminderEmailNotificationRecordNotificationType;
  /** The user who received this email notification. */
  recipient: User;
  /** The external ID of the SendGrid email. This can be used to look up the email contents in SendGrid. */
  sendgridExternalID: Scalars['String']['output'];
  /** The template ID of the SendGrid template used for the email. */
  sendgridTemplateID: Scalars['String']['output'];
  /** The time at which this email notification was sent. */
  sentAt: Scalars['Time']['output'];
  /** The task(s) that this email notification is associated with. If this is null, then this email notification is not associated with any task. */
  tasks?: Maybe<Array<EntityTask>>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type ReminderEmailNotificationRecordConnection = {
  __typename?: 'ReminderEmailNotificationRecordConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReminderEmailNotificationRecordEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReminderEmailNotificationRecordEdge = {
  __typename?: 'ReminderEmailNotificationRecordEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ReminderEmailNotificationRecord>;
};

/** ReminderEmailNotificationRecordNotificationType is enum for the field notification_type */
export enum ReminderEmailNotificationRecordNotificationType {
  AnnualGiftExclusionToIlit = 'ANNUAL_GIFT_EXCLUSION_TO_ILIT',
  AnnuityPaymentDue = 'ANNUITY_PAYMENT_DUE',
  AssignedTask = 'ASSIGNED_TASK',
  CrummeyLetterDue = 'CRUMMEY_LETTER_DUE',
  DistributeTrustRemainder = 'DISTRIBUTE_TRUST_REMAINDER',
  GratAssetSubstitutionThresholdReached = 'GRAT_ASSET_SUBSTITUTION_THRESHOLD_REACHED',
  InsurancePremiumDue = 'INSURANCE_PREMIUM_DUE',
  OverdueTaskReminder = 'OVERDUE_TASK_REMINDER',
  UnassignedTask = 'UNASSIGNED_TASK',
  UnassignedTaskReminder = 'UNASSIGNED_TASK_REMINDER'
}

/** Ordering options for ReminderEmailNotificationRecord connections */
export type ReminderEmailNotificationRecordOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ReminderEmailNotificationRecords. */
  field: ReminderEmailNotificationRecordOrderField;
};

/** Properties by which ReminderEmailNotificationRecord connections can be ordered. */
export enum ReminderEmailNotificationRecordOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * ReminderEmailNotificationRecordWhereInput is used for filtering ReminderEmailNotificationRecord objects.
 * Input was generated by ent.
 */
export type ReminderEmailNotificationRecordWhereInput = {
  and?: InputMaybe<Array<ReminderEmailNotificationRecordWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** entities edge predicates */
  hasEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntitiesWith?: InputMaybe<Array<EntityWhereInput>>;
  /** recipient edge predicates */
  hasRecipient?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecipientWith?: InputMaybe<Array<UserWhereInput>>;
  /** tasks edge predicates */
  hasTasks?: InputMaybe<Scalars['Boolean']['input']>;
  hasTasksWith?: InputMaybe<Array<EntityTaskWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ReminderEmailNotificationRecordWhereInput>;
  /** notification_type field predicates */
  notificationType?: InputMaybe<ReminderEmailNotificationRecordNotificationType>;
  notificationTypeIn?: InputMaybe<Array<ReminderEmailNotificationRecordNotificationType>>;
  notificationTypeNEQ?: InputMaybe<ReminderEmailNotificationRecordNotificationType>;
  notificationTypeNotIn?: InputMaybe<Array<ReminderEmailNotificationRecordNotificationType>>;
  or?: InputMaybe<Array<ReminderEmailNotificationRecordWhereInput>>;
  /** sendgrid_external_id field predicates */
  sendgridExternalID?: InputMaybe<Scalars['String']['input']>;
  /** sendgrid_template_id field predicates */
  sendgridTemplateID?: InputMaybe<Scalars['String']['input']>;
  /** sent_at field predicates */
  sentAt?: InputMaybe<Scalars['Time']['input']>;
  sentAtGT?: InputMaybe<Scalars['Time']['input']>;
  sentAtGTE?: InputMaybe<Scalars['Time']['input']>;
  sentAtLT?: InputMaybe<Scalars['Time']['input']>;
  sentAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Library metadata that can change independently of diagram generation. */
export type RenameDiagramArtifactInput = {
  diagramArtifactID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ReopenFormSubmissionInput = {
  id: Scalars['ID']['input'];
};

export type RequestClientPresentationV2ApprovalInput = {
  /** The presentation to review. */
  presentationID: Scalars['ID']['input'];
  /**
   * The users to ask for approval. Each user must have permission to approve
   * presentations in the household of the presentation. The list is ignored
   * when the tenant requires only attestation.
   */
  requestedApproverIDs: Array<Scalars['ID']['input']>;
};

export type RetirementPersonalAccount = EntitySubtype & Named & Node & PersonalAccount & {
  __typename?: 'RetirementPersonalAccount';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  beneficiaries?: Maybe<Array<Beneficiary>>;
  beneficiaryDesignationGroups: BeneficiaryDesignationGroupConnection;
  /**
   * Returns the primary and contingent beneficiary designation groups for this
   * retirement account. When hypotheticalWaterfallId is null or omitted, returns
   * live BDGs. When set, returns BDGs scoped to that waterfall when any exist;
   * otherwise falls back to live BDGs.
   */
  beneficiaryDesignations: BeneficiaryDesignations;
  /** The time at which the account's beneficiary designations were last reviewed/acknowledged. Used to suppress the 'no beneficiary designations' badge for accounts where the user has confirmed the empty state is intentional. */
  beneficiaryDesignationsReviewedAt?: Maybe<Scalars['Time']['output']>;
  controllingParties?: Maybe<Array<ControllingParty>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** The custodian institution that holds this retirement account. */
  custodian?: Maybe<Scalars['String']['output']>;
  /** Description for this personal account */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in entities that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalBeneficiaryDesignationGroups: BeneficiaryDesignationGroupConnection;
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  owner?: Maybe<Principal>;
  stateInEstateStatus: EntityInEstateStatus;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<NonTrustEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  type?: Maybe<RetirementPersonalAccountType>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type RetirementPersonalAccountBeneficiaryDesignationGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BeneficiaryDesignationGroupOrder>>;
  where?: InputMaybe<BeneficiaryDesignationGroupWhereInput>;
};


export type RetirementPersonalAccountBeneficiaryDesignationsArgs = {
  hypotheticalWaterfallId?: InputMaybe<Scalars['ID']['input']>;
};


export type RetirementPersonalAccountHypotheticalBeneficiaryDesignationGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BeneficiaryDesignationGroupOrder>>;
  where?: InputMaybe<BeneficiaryDesignationGroupWhereInput>;
};


export type RetirementPersonalAccountHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type RetirementPersonalAccountConnection = {
  __typename?: 'RetirementPersonalAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RetirementPersonalAccountEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RetirementPersonalAccountEdge = {
  __typename?: 'RetirementPersonalAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RetirementPersonalAccount>;
};

/** Ordering options for RetirementPersonalAccount connections */
export type RetirementPersonalAccountOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order RetirementPersonalAccounts. */
  field: RetirementPersonalAccountOrderField;
};

/** Properties by which RetirementPersonalAccount connections can be ordered. */
export enum RetirementPersonalAccountOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** RetirementPersonalAccountType is enum for the field type */
export enum RetirementPersonalAccountType {
  DefinedBenefitPlan = 'DEFINED_BENEFIT_PLAN',
  InheritedIra = 'INHERITED_IRA',
  InheritedRothIra = 'INHERITED_ROTH_IRA',
  Ira = 'IRA',
  Other = 'OTHER',
  RothIra = 'ROTH_IRA',
  Type_401K = 'TYPE_401K'
}

/**
 * RetirementPersonalAccountWhereInput is used for filtering RetirementPersonalAccount objects.
 * Input was generated by ent.
 */
export type RetirementPersonalAccountWhereInput = {
  and?: InputMaybe<Array<RetirementPersonalAccountWhereInput>>;
  /** beneficiary_designations_reviewed_at field predicates */
  beneficiaryDesignationsReviewedAt?: InputMaybe<Scalars['Time']['input']>;
  beneficiaryDesignationsReviewedAtGT?: InputMaybe<Scalars['Time']['input']>;
  beneficiaryDesignationsReviewedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  beneficiaryDesignationsReviewedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  beneficiaryDesignationsReviewedAtLT?: InputMaybe<Scalars['Time']['input']>;
  beneficiaryDesignationsReviewedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  beneficiaryDesignationsReviewedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** custodian field predicates */
  custodian?: InputMaybe<Scalars['String']['input']>;
  custodianIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  custodianNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** beneficiaries edge predicates */
  hasBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** beneficiary_designation_groups edge predicates */
  hasBeneficiaryDesignationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiaryDesignationGroupsWith?: InputMaybe<Array<BeneficiaryDesignationGroupWhereInput>>;
  /** controlling_parties edge predicates */
  hasControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  hasControllingPartiesWith?: InputMaybe<Array<ControllingPartyWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_beneficiary_designation_groups edge predicates */
  hasHypotheticalBeneficiaryDesignationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalBeneficiaryDesignationGroupsWith?: InputMaybe<Array<BeneficiaryDesignationGroupWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<RetirementPersonalAccountWhereInput>;
  or?: InputMaybe<Array<RetirementPersonalAccountWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** type field predicates */
  type?: InputMaybe<RetirementPersonalAccountType>;
  typeIn?: InputMaybe<Array<RetirementPersonalAccountType>>;
  typeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  typeNEQ?: InputMaybe<RetirementPersonalAccountType>;
  typeNotIn?: InputMaybe<Array<RetirementPersonalAccountType>>;
  typeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type RevertFormSubmissionAnswerInput = {
  expectedLockVersion: Scalars['Int']['input'];
  fieldID: Scalars['String']['input'];
  revisionID: Scalars['ID']['input'];
  submissionID: Scalars['ID']['input'];
};

export type RevocableTrust = EntitySubtype & Named & Node & Trust & {
  __typename?: 'RevocableTrust';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  beneficiaries?: Maybe<Array<Beneficiary>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this trust */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in trusts that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  grantors?: Maybe<Array<Principal>>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  policies?: Maybe<Array<InsurancePolicy>>;
  stateInEstateStatus: EntityInEstateStatus;
  successorTrustees?: Maybe<Array<Trustee>>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<TrustTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  trustAdvisors?: Maybe<Array<TrustAdvisor>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  trustees?: Maybe<Array<Trustee>>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type RevocableTrustHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type RevocableTrustConnection = {
  __typename?: 'RevocableTrustConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RevocableTrustEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RevocableTrustEdge = {
  __typename?: 'RevocableTrustEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RevocableTrust>;
};

/** Ordering options for RevocableTrust connections */
export type RevocableTrustOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order RevocableTrusts. */
  field: RevocableTrustOrderField;
};

/** Properties by which RevocableTrust connections can be ordered. */
export enum RevocableTrustOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * RevocableTrustWhereInput is used for filtering RevocableTrust objects.
 * Input was generated by ent.
 */
export type RevocableTrustWhereInput = {
  and?: InputMaybe<Array<RevocableTrustWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** beneficiaries edge predicates */
  hasBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** grantors edge predicates */
  hasGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrantorsWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** successor_trustees edge predicates */
  hasSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuccessorTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** trust_advisors edge predicates */
  hasTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrustAdvisorsWith?: InputMaybe<Array<TrustAdvisorWhereInput>>;
  /** trustees edge predicates */
  hasTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<RevocableTrustWhereInput>;
  or?: InputMaybe<Array<RevocableTrustWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<TrustTaxStatus>;
  taxStatusIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<TrustTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** trust_jurisdiction_state_code field predicates */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trustJurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  trustJurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Deletes one installed public key by its AWS Transfer identifier. */
export type RevokeManagedSftpPublicKeyInput = {
  id: Scalars['String']['input'];
};

export type Role = Node & {
  __typename?: 'Role';
  /** The capabilities that this role has. */
  capabilities?: Maybe<Array<Capability>>;
  collaborators: CollaboratorConnection;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
  employees: EmployeeConnection;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  /**
   * ADMINISTRATOR roles are assigned to administrators, and are not editable.
   * COLLABORATOR roles are assigned to collaborators, and are not editable.
   * CUSTOM roles are editable, even the initially-populated roles.
   */
  kind: RoleKind;
  slug: Scalars['String']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type RoleCollaboratorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CollaboratorOrder>>;
  where?: InputMaybe<CollaboratorWhereInput>;
};


export type RoleEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmployeeOrder>>;
  where?: InputMaybe<EmployeeWhereInput>;
};

/** A connection to a list of items. */
export type RoleConnection = {
  __typename?: 'RoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RoleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RoleEdge = {
  __typename?: 'RoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Role>;
};

/** RoleKind is enum for the field kind */
export enum RoleKind {
  Administrator = 'ADMINISTRATOR',
  Collaborator = 'COLLABORATOR',
  Custom = 'CUSTOM'
}

/** Ordering options for Role connections */
export type RoleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Roles. */
  field: RoleOrderField;
};

/** Properties by which Role connections can be ordered. */
export enum RoleOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type RoleSummaryPredicateOption = {
  __typename?: 'RoleSummaryPredicateOption';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  predicates: Array<Scalars['String']['output']>;
};

/**
 * RoleWhereInput is used for filtering Role objects.
 * Input was generated by ent.
 */
export type RoleWhereInput = {
  and?: InputMaybe<Array<RoleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** capabilities edge predicates */
  hasCapabilities?: InputMaybe<Scalars['Boolean']['input']>;
  hasCapabilitiesWith?: InputMaybe<Array<CapabilityWhereInput>>;
  /** collaborators edge predicates */
  hasCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
  hasCollaboratorsWith?: InputMaybe<Array<CollaboratorWhereInput>>;
  /** employees edge predicates */
  hasEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmployeesWith?: InputMaybe<Array<EmployeeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_default field predicates */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<RoleKind>;
  kindIn?: InputMaybe<Array<RoleKind>>;
  kindNEQ?: InputMaybe<RoleKind>;
  kindNotIn?: InputMaybe<Array<RoleKind>>;
  not?: InputMaybe<RoleWhereInput>;
  or?: InputMaybe<Array<RoleWhereInput>>;
  /** slug field predicates */
  slug?: InputMaybe<Scalars['String']['input']>;
  slugIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type RunFormTestInput = {
  cases: Array<FormTestCaseInput>;
  formVersionID: Scalars['ID']['input'];
};

export type SCorpBusinessEntity = BusinessEntity & EntitySubtype & Named & Node & {
  __typename?: 'SCorpBusinessEntity';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this business entity */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in trusts that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: Maybe<Scalars['String']['output']>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: Maybe<Scalars['Boolean']['output']>;
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: Maybe<Scalars['String']['output']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  grantorControlledDiscountedValue: Scalars['CurrencyUSD']['output'];
  grantorControlledPercentage: Scalars['Percent']['output'];
  grantorControlledValue: Scalars['CurrencyUSD']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  keyPeople?: Maybe<Array<KeyPerson>>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: Maybe<Scalars['String']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  nongrantorControlledPercentage: Scalars['Percent']['output'];
  nongrantorControlledValue: Scalars['CurrencyUSD']['output'];
  /** Ownership as-of date. */
  ownershipAsOfDate?: Maybe<Scalars['Time']['output']>;
  policies?: Maybe<Array<InsurancePolicy>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: Maybe<Scalars['Boolean']['output']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxID?: Maybe<Scalars['String']['output']>;
  taxStatus?: Maybe<BusinessEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type SCorpBusinessEntityHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type SCorpBusinessEntityConnection = {
  __typename?: 'SCorpBusinessEntityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SCorpBusinessEntityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SCorpBusinessEntityEdge = {
  __typename?: 'SCorpBusinessEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SCorpBusinessEntity>;
};

/** Ordering options for SCorpBusinessEntity connections */
export type SCorpBusinessEntityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order SCorpBusinessEntities. */
  field: SCorpBusinessEntityOrderField;
};

/** Properties by which SCorpBusinessEntity connections can be ordered. */
export enum SCorpBusinessEntityOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * SCorpBusinessEntityWhereInput is used for filtering SCorpBusinessEntity objects.
 * Input was generated by ent.
 */
export type SCorpBusinessEntityWhereInput = {
  and?: InputMaybe<Array<SCorpBusinessEntityWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** doing_business_as_name field predicates */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  doingBusinessAsNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  doingBusinessAsNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable_real_tpp_tax_exposure field predicates */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  enableRealTppTaxExposureIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  enableRealTppTaxExposureNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** fin_cen_id field predicates */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  finCenIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  finCenIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** formation_jurisdiction_state_code field predicates */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  formationJurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  formationJurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** key_people edge predicates */
  hasKeyPeople?: InputMaybe<Scalars['Boolean']['input']>;
  hasKeyPeopleWith?: InputMaybe<Array<KeyPersonWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key_people_notes field predicates */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  keyPeopleNotesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  keyPeopleNotesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<SCorpBusinessEntityWhereInput>;
  or?: InputMaybe<Array<SCorpBusinessEntityWhereInput>>;
  /** ownership_as_of_date field predicates */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateGT?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateGTE?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownershipAsOfDateLT?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateLTE?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** requires_cta_reporting field predicates */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCtaReportingIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCtaReportingNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_id field predicates */
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<BusinessEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<BusinessEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<BusinessEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type SlatTrust = EntitySubtype & Named & Node & Trust & {
  __typename?: 'SLATTrust';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this trust */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in trusts that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  /** Display name */
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  grantor?: Maybe<Principal>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  inEstateStatus: EntityInEstateStatus;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  lifetimeBeneficiaries?: Maybe<Array<Beneficiary>>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  performanceReport: TrustPerformanceReport;
  policies?: Maybe<Array<InsurancePolicy>>;
  remainderBeneficiaries?: Maybe<Array<Beneficiary>>;
  stateInEstateStatus: EntityInEstateStatus;
  successorTrustees?: Maybe<Array<Trustee>>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxStatus?: Maybe<TrustTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  trustAdvisors?: Maybe<Array<TrustAdvisor>>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  trustees?: Maybe<Array<Trustee>>;
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type SlatTrustHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type SlatTrustConnection = {
  __typename?: 'SLATTrustConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SlatTrustEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SlatTrustEdge = {
  __typename?: 'SLATTrustEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SlatTrust>;
};

/** Ordering options for SLATTrust connections */
export type SlatTrustOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order SLATTrusts. */
  field: SlatTrustOrderField;
};

/** Properties by which SLATTrust connections can be ordered. */
export enum SlatTrustOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * SLATTrustWhereInput is used for filtering SLATTrust objects.
 * Input was generated by ent.
 */
export type SlatTrustWhereInput = {
  and?: InputMaybe<Array<SlatTrustWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** grantor edge predicates */
  hasGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrantorWith?: InputMaybe<Array<PrincipalWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** lifetime_beneficiaries edge predicates */
  hasLifetimeBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasLifetimeBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** policies edge predicates */
  hasPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoliciesWith?: InputMaybe<Array<InsurancePolicyWhereInput>>;
  /** remainder_beneficiaries edge predicates */
  hasRemainderBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasRemainderBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** successor_trustees edge predicates */
  hasSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuccessorTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** trust_advisors edge predicates */
  hasTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrustAdvisorsWith?: InputMaybe<Array<TrustAdvisorWhereInput>>;
  /** trustees edge predicates */
  hasTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<SlatTrustWhereInput>;
  or?: InputMaybe<Array<SlatTrustWhereInput>>;
  /** state_in_estate_status field predicates */
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  stateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  stateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<TrustTaxStatus>;
  taxStatusIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<TrustTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<TrustTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** trust_jurisdiction_state_code field predicates */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  trustJurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  trustJurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type SsoConnection = Node & {
  __typename?: 'SSOConnection';
  /** A list of email domains that are allowed to use this SSO connection. Do not include the @ symbol. */
  boundEmailDomains: Array<Scalars['String']['output']>;
  configuredTenants?: Maybe<Array<Tenant>>;
  createdAt: Scalars['Time']['output'];
  /** The name of the SSO connection. */
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Special designator for the Luminary sso connection */
  isLuminary: Scalars['Boolean']['output'];
  tenantSSOConnections?: Maybe<Array<TenantSsoConnection>>;
  updatedAt: Scalars['Time']['output'];
  /** The ID of the WorkOS organization this SSO connection corresponds to. */
  workosOrganizationID: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type SsoConnectionConnection = {
  __typename?: 'SSOConnectionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SsoConnectionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SsoConnectionEdge = {
  __typename?: 'SSOConnectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SsoConnection>;
};

/** Ordering options for SSOConnection connections */
export type SsoConnectionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order SSOConnections. */
  field: SsoConnectionOrderField;
};

/** Properties by which SSOConnection connections can be ordered. */
export enum SsoConnectionOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * SSOConnectionWhereInput is used for filtering SSOConnection objects.
 * Input was generated by ent.
 */
export type SsoConnectionWhereInput = {
  and?: InputMaybe<Array<SsoConnectionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** tenant_sso_connections edge predicates */
  hasTenantSSOConnections?: InputMaybe<Scalars['Boolean']['input']>;
  hasTenantSSOConnectionsWith?: InputMaybe<Array<TenantSsoConnectionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_luminary field predicates */
  isLuminary?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<SsoConnectionWhereInput>;
  or?: InputMaybe<Array<SsoConnectionWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** workos_organization_id field predicates */
  workosOrganizationID?: InputMaybe<Scalars['String']['input']>;
};

/** SaleOrLoanType distinguishes between sale and loan transfers when kind is HYPOTHETICAL_SALE_LOAN */
export enum SaleOrLoanType {
  Loan = 'LOAN',
  Sale = 'SALE'
}

export type SalesforceConnectionStatus = {
  __typename?: 'SalesforceConnectionStatus';
  connected: Scalars['Boolean']['output'];
  domain: Scalars['String']['output'];
  object?: Maybe<Scalars['String']['output']>;
};

export type SalesforceDestinationAccount = {
  __typename?: 'SalesforceDestinationAccount';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SalesforceDestinationLegalEntity = {
  __typename?: 'SalesforceDestinationLegalEntity';
  classification: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isTrust: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type SalesforceExportAttempt = Node & {
  __typename?: 'SalesforceExportAttempt';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  destination: SalesforceExportDestination;
  destinationLabels?: Maybe<SalesforceExportDestinationLabels>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  objectAPIName: Scalars['String']['output'];
  objectLabel?: Maybe<Scalars['String']['output']>;
  recordName?: Maybe<Scalars['String']['output']>;
  recordURL?: Maybe<Scalars['String']['output']>;
  /** Salesforce's created record ID. Required for SUCCEEDED; absent for REJECTED or UNKNOWN. */
  salesforceRecordID?: Maybe<Scalars['String']['output']>;
  status: SalesforceExportAttemptStatus;
  submission: Submission;
  submissionID: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};

/** A connection to a list of items. */
export type SalesforceExportAttemptConnection = {
  __typename?: 'SalesforceExportAttemptConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SalesforceExportAttemptEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SalesforceExportAttemptEdge = {
  __typename?: 'SalesforceExportAttemptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SalesforceExportAttempt>;
};

/** Ordering options for SalesforceExportAttempt connections */
export type SalesforceExportAttemptOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order SalesforceExportAttempts. */
  field: SalesforceExportAttemptOrderField;
};

/** Properties by which SalesforceExportAttempt connections can be ordered. */
export enum SalesforceExportAttemptOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** SalesforceExportAttemptStatus is enum for the field status */
export enum SalesforceExportAttemptStatus {
  Rejected = 'REJECTED',
  Succeeded = 'SUCCEEDED',
  Unknown = 'UNKNOWN'
}

/**
 * SalesforceExportAttemptWhereInput is used for filtering SalesforceExportAttempt objects.
 * Input was generated by ent.
 */
export type SalesforceExportAttemptWhereInput = {
  and?: InputMaybe<Array<SalesforceExportAttemptWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** submission edge predicates */
  hasSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubmissionWith?: InputMaybe<Array<SubmissionWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<SalesforceExportAttemptWhereInput>;
  /** object_api_name field predicates */
  objectAPIName?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<SalesforceExportAttemptWhereInput>>;
  /** salesforce_record_id field predicates */
  salesforceRecordID?: InputMaybe<Scalars['String']['input']>;
  salesforceRecordIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  salesforceRecordIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<SalesforceExportAttemptStatus>;
  statusIn?: InputMaybe<Array<SalesforceExportAttemptStatus>>;
  statusNEQ?: InputMaybe<SalesforceExportAttemptStatus>;
  statusNotIn?: InputMaybe<Array<SalesforceExportAttemptStatus>>;
  /** submission_id field predicates */
  submissionID?: InputMaybe<Scalars['ID']['input']>;
  submissionIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  submissionIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  submissionIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SalesforceExportDestination = {
  __typename?: 'SalesforceExportDestination';
  accountID: Scalars['String']['output'];
  householdRecordID: Scalars['String']['output'];
  legalEntityID?: Maybe<Scalars['String']['output']>;
};

export type SalesforceExportDestinationInput = {
  accountID: Scalars['String']['input'];
  householdRecordID: Scalars['String']['input'];
  legalEntityID?: InputMaybe<Scalars['String']['input']>;
};

export type SalesforceExportDestinationLabels = {
  __typename?: 'SalesforceExportDestinationLabels';
  accountName?: Maybe<Scalars['String']['output']>;
  householdName?: Maybe<Scalars['String']['output']>;
  legalEntityName?: Maybe<Scalars['String']['output']>;
};

export type SalesforceField = {
  __typename?: 'SalesforceField';
  autoNumber: Scalars['Boolean']['output'];
  calculated: Scalars['Boolean']['output'];
  createable: Scalars['Boolean']['output'];
  custom: Scalars['Boolean']['output'];
  defaultedOnCreate: Scalars['Boolean']['output'];
  inlineHelpText: Scalars['String']['output'];
  label: Scalars['String']['output'];
  length: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nillable: Scalars['Boolean']['output'];
  picklistValues: Array<SalesforcePicklistValue>;
  referenceTo: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type SalesforceHouseholdSuggestion = {
  __typename?: 'SalesforceHouseholdSuggestion';
  name: Scalars['String']['output'];
  recordID: Scalars['String']['output'];
  /**
   * The record type label, such as Household or Family. Null when the object has
   * no record types or the label could not be read.
   */
  recordTypeName?: Maybe<Scalars['String']['output']>;
};

export type SalesforceLayout = {
  __typename?: 'SalesforceLayout';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  sections: Array<SalesforceLayoutSection>;
};

export type SalesforceLayoutSection = {
  __typename?: 'SalesforceLayoutSection';
  fieldApiNames: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type SalesforceObject = {
  __typename?: 'SalesforceObject';
  createable: Scalars['Boolean']['output'];
  custom: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  queryable: Scalars['Boolean']['output'];
};

export type SalesforceObjectDescription = {
  __typename?: 'SalesforceObjectDescription';
  createable: Scalars['Boolean']['output'];
  custom: Scalars['Boolean']['output'];
  fields: Array<SalesforceField>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SalesforcePicklistValue = {
  __typename?: 'SalesforcePicklistValue';
  active: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ScenarioTableRow = {
  __typename?: 'ScenarioTableRow';
  annuityPayment: Scalars['CurrencyUSD']['output'];
  annuityPaymentPercentOfInitialFunding: Scalars['Percent']['output'];
  beginningPrincipal: Scalars['CurrencyUSD']['output'];
  principalGrowth: Scalars['CurrencyUSD']['output'];
  remainderValue: Scalars['CurrencyUSD']['output'];
  year: Scalars['Int']['output'];
};

export type ScheduledDistribution = Node & {
  __typename?: 'ScheduledDistribution';
  /** The end of the age requirement for this distribution */
  ageRequirementEnd?: Maybe<Scalars['Int']['output']>;
  /** The start of the age requirement for this distribution */
  ageRequirementStart?: Maybe<Scalars['Int']['output']>;
  /** The AMOUNT kind of distribution. Only valid when kind is AMOUNT */
  amount?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** the beneficiary this scheduled distribution is for */
  beneficiary?: Maybe<Beneficiary>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The frequency of the distribution to beneficiaries */
  frequency?: Maybe<ScheduledDistributionFrequency>;
  /** If true, the distribution will grow by the inflation rate specified in the growth profile.Only applicable if the distribution is kind AMOUNT. */
  growByInflation: Scalars['Boolean']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The kind of scheduled distribution */
  kind: ScheduledDistributionKind;
  /** The percentage of the distribution. Only valid when kind is PERCENTAGE or ALL_INCOME */
  percentage?: Maybe<Scalars['Percent']['output']>;
  /** The notes for the scheduled distribution */
  scheduledDistributionNotes?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type ScheduledDistributionConnection = {
  __typename?: 'ScheduledDistributionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ScheduledDistributionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ScheduledDistributionEdge = {
  __typename?: 'ScheduledDistributionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ScheduledDistribution>;
};

/** ScheduledDistributionFrequency is enum for the field frequency */
export enum ScheduledDistributionFrequency {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY'
}

/** ScheduledDistributionKind is enum for the field kind */
export enum ScheduledDistributionKind {
  AllIncome = 'ALL_INCOME',
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE'
}

/** Ordering options for ScheduledDistribution connections */
export type ScheduledDistributionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ScheduledDistributions. */
  field: ScheduledDistributionOrderField;
};

/** Properties by which ScheduledDistribution connections can be ordered. */
export enum ScheduledDistributionOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * ScheduledDistributionWhereInput is used for filtering ScheduledDistribution objects.
 * Input was generated by ent.
 */
export type ScheduledDistributionWhereInput = {
  /** age_requirement_end field predicates */
  ageRequirementEnd?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementEndGT?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementEndGTE?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementEndIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ageRequirementEndLT?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementEndLTE?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementEndNEQ?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementEndNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** age_requirement_start field predicates */
  ageRequirementStart?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementStartGT?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementStartGTE?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementStartIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ageRequirementStartLT?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementStartLTE?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementStartNEQ?: InputMaybe<Scalars['Int']['input']>;
  ageRequirementStartNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** amount field predicates */
  amount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountGT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountGTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  amountLT?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountLTE?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountNEQ?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  amountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<ScheduledDistributionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** frequency field predicates */
  frequency?: InputMaybe<ScheduledDistributionFrequency>;
  frequencyIn?: InputMaybe<Array<ScheduledDistributionFrequency>>;
  frequencyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  frequencyNEQ?: InputMaybe<ScheduledDistributionFrequency>;
  frequencyNotIn?: InputMaybe<Array<ScheduledDistributionFrequency>>;
  frequencyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** grow_by_inflation field predicates */
  growByInflation?: InputMaybe<Scalars['Boolean']['input']>;
  /** beneficiary edge predicates */
  hasBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiaryWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<ScheduledDistributionKind>;
  kindIn?: InputMaybe<Array<ScheduledDistributionKind>>;
  kindNEQ?: InputMaybe<ScheduledDistributionKind>;
  kindNotIn?: InputMaybe<Array<ScheduledDistributionKind>>;
  not?: InputMaybe<ScheduledDistributionWhereInput>;
  or?: InputMaybe<Array<ScheduledDistributionWhereInput>>;
  /** percentage field predicates */
  percentage?: InputMaybe<Scalars['Percent']['input']>;
  percentageGT?: InputMaybe<Scalars['Percent']['input']>;
  percentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  percentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  percentageLT?: InputMaybe<Scalars['Percent']['input']>;
  percentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  percentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  percentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** scheduled_distribution_notes field predicates */
  scheduledDistributionNotes?: InputMaybe<Scalars['String']['input']>;
  scheduledDistributionNotesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledDistributionNotesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type SearchRelevantDocumentParagraphsBulkInput = {
  documentID: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  matchThreshold?: InputMaybe<Scalars['Float']['input']>;
  query: Array<Scalars['String']['input']>;
};

export type SearchRelevantDocumentParagraphsInput = {
  documentID: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  matchThreshold?: InputMaybe<Scalars['Float']['input']>;
  query: Scalars['String']['input'];
};

export type SearchResult = {
  __typename?: 'SearchResult';
  node: Node;
  nodes: Array<Node>;
  score: Scalars['Float']['output'];
};

export enum SearchableType {
  ClientOrganization = 'CLIENT_ORGANIZATION',
  ClientProfile = 'CLIENT_PROFILE',
  Document = 'DOCUMENT',
  Entity = 'ENTITY',
  Household = 'HOUSEHOLD',
  Proposal = 'PROPOSAL'
}

export type SeedAidpSuggestionsOutput = {
  __typename?: 'SeedAIDPSuggestionsOutput';
  entityID: Scalars['ID']['output'];
  householdID: Scalars['ID']['output'];
};

export type SeedE360FixtureHouseholdInput = {
  /**
   * The family fixture to seed, e.g. "whitlock". Must be one of the families
   * returned by seedableE360FixtureFamilies.
   */
  family: Scalars['String']['input'];
};

export type SeedE360FixtureHouseholdOutput = {
  __typename?: 'SeedE360FixtureHouseholdOutput';
  documentIDs: Array<Scalars['ID']['output']>;
  household: Household;
  /**
   * Fixture files that were not uploaded, with the reason. Pre-baked OCR variants
   * are skipped because real OCR regenerates that content.
   */
  skippedFiles: Array<Scalars['String']['output']>;
};

export type SeedEntityWithAiSuggestionsInput = {
  entityID: Scalars['ID']['input'];
};

export type SeedHouseholdDocumentSuggestionsOutput = {
  __typename?: 'SeedHouseholdDocumentSuggestionsOutput';
  documentIDs: Array<Scalars['ID']['output']>;
  entityID: Scalars['ID']['output'];
  householdID: Scalars['ID']['output'];
};

export type SeedIntegrationClientsAndEntitiesInput = {
  integrationProvider: SeedIntegrationProvider;
};

export type SeedIntegrationLoginInput = {
  integrationProvider: SeedIntegrationProvider;
};

export enum SeedIntegrationProvider {
  Addepar = 'ADDEPAR',
  BlackDiamond = 'BLACK_DIAMOND'
}

export type SeedKgv2HouseholdInput = {
  householdName: Scalars['String']['input'];
};

export type SeedNotificationsOutput = {
  __typename?: 'SeedNotificationsOutput';
  householdID: Scalars['ID']['output'];
  notificationIDs: Array<Scalars['ID']['output']>;
};

export type SeedSubtrustSuggestionsOutput = {
  __typename?: 'SeedSubtrustSuggestionsOutput';
  entityID: Scalars['ID']['output'];
  householdID: Scalars['ID']['output'];
  testamentaryEntityIDs: Array<Scalars['ID']['output']>;
};

/** SeedableE360FixtureFamily describes one family fixture available for seeding. */
export type SeedableE360FixtureFamily = {
  __typename?: 'SeedableE360FixtureFamily';
  displayName: Scalars['String']['output'];
  documentCount: Scalars['Int']['output'];
  /**
   * Markdown describing the diagram these documents should produce, including
   * the transfers a correct diagram leaves out. Empty when the family ships no
   * expected-diagram note.
   */
  expectedDiagram: Scalars['String']['output'];
  family: Scalars['String']['output'];
  /**
   * How many primary clients the plan has. The asset-distribution section
   * behaves differently for one- and two-grantor plans.
   */
  grantors: Scalars['Int']['output'];
  /**
   * The externalID written onto a household seeded from this family. Query
   * households by this value to find what has already been seeded, rather than
   * tracking it client-side.
   */
  householdExternalID: Scalars['String']['output'];
  /** A short description of the estate-planning pattern. */
  shape: Scalars['String']['output'];
  /** The planning techniques the plan uses, for filtering the corpus by scheme. */
  strategies: Array<Scalars['String']['output']>;
  /** A couple of sentences on the household's situation. */
  summary: Scalars['String']['output'];
};

export type SendSupportUserRequestInput = {
  accessLevel: EmployeeTier;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

/**
 * SessionHeartbeat is the response when a session is updated
 * via a heartbeat.
 */
export type SessionHeartbeat = {
  __typename?: 'SessionHeartbeat';
  /** inactiveAt is the time the session will be considered inactive. */
  inactiveAt?: Maybe<Scalars['Time']['output']>;
  /** notAfter is the maximum time the session is valid. */
  notAfter: Scalars['Time']['output'];
};

export type SetFormSubmissionAnswerInput = {
  expectedLockVersion: Scalars['Int']['input'];
  fieldID: Scalars['String']['input'];
  submissionID: Scalars['ID']['input'];
  value: Scalars['JSON']['input'];
};

export type SetFormSubmissionAnswerNodeReferencesInput = {
  expectedLockVersion: Scalars['Int']['input'];
  fieldID: Scalars['String']['input'];
  paragraphIDs: Array<Scalars['ID']['input']>;
  submissionID: Scalars['ID']['input'];
  target: FormAnswerTargetInput;
};

/** Replace the ordered references without changing the value or AI history. */
export type SetFormSubmissionAnswerReferencesInput = {
  expectedLockVersion: Scalars['Int']['input'];
  fieldID: Scalars['String']['input'];
  paragraphIDs: Array<Scalars['ID']['input']>;
  submissionID: Scalars['ID']['input'];
};

export type SetFormSubmissionAnswerTreeInput = {
  expectedLockVersion: Scalars['Int']['input'];
  fieldID: Scalars['String']['input'];
  submissionID: Scalars['ID']['input'];
  value: FormAnswerValueInput;
};

/** Input for changing customer JIT access on an organization. */
export type SetLuminaryOrganizationJitInput = {
  /** Whether customer JIT access is enabled for the organization. */
  enabled: Scalars['Boolean']['input'];
  /** The organization to update. */
  id: Scalars['ID']['input'];
};

export type SharingToken = {
  __typename?: 'SharingToken';
  NotAfter: Scalars['Time']['output'];
  Token: Scalars['String']['output'];
  URL: Scalars['String']['output'];
};

export type SimulateDispositiveProvision = {
  __typename?: 'SimulateDispositiveProvision';
  transferAmount: Scalars['CurrencyUSD']['output'];
  transferAmountWasClipped: Scalars['Boolean']['output'];
};

export type SimulateDispositiveProvisionInput = {
  dispositionAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  dispositionKind: DispositiveProvisionDispositionKind;
  dispositionPercentage?: InputMaybe<Scalars['Percent']['input']>;
};

export type SimulateDispositiveProvisions = {
  __typename?: 'SimulateDispositiveProvisions';
  firstDeath: Array<SimulateDispositiveProvision>;
  secondDeath: Array<SimulateDispositiveProvision>;
  valueRemainingAfterFirstDeath: Scalars['CurrencyUSD']['output'];
  valueRemainingAfterSecondDeath: Scalars['CurrencyUSD']['output'];
};

export type SimulateDispositiveProvisionsInput = {
  firstDeathClientProfile: Scalars['ID']['input'];
  /** Order matters! */
  firstDeathProvisions: Array<SimulateDispositiveProvisionInput>;
  secondDeathClientProfile?: InputMaybe<Scalars['ID']['input']>;
  /** Order matters! */
  secondDeathProvisions: Array<SimulateDispositiveProvisionInput>;
  valueToDistribute: Scalars['CurrencyUSD']['input'];
};

export type SoleProprietorshipBusinessEntity = BusinessEntity & EntitySubtype & Named & Node & {
  __typename?: 'SoleProprietorshipBusinessEntity';
  accounts?: Maybe<Array<Account>>;
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  /** Description for this business entity */
  description?: Maybe<Scalars['String']['output']>;
  /** This is a "dummy" account that we use for modeling assets in trusts that aren't integrated with an asset provider like Addepar */
  designerAccount?: Maybe<Account>;
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: Maybe<Scalars['String']['output']>;
  /** Effective date. */
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: Maybe<Scalars['Boolean']['output']>;
  entity: Entity;
  /** Whether the entity has already been created and is in effect */
  entityExists: Scalars['Boolean']['output'];
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: Maybe<Scalars['String']['output']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  grantorControlledDiscountedValue: Scalars['CurrencyUSD']['output'];
  grantorControlledPercentage: Scalars['Percent']['output'];
  grantorControlledValue: Scalars['CurrencyUSD']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  id: Scalars['ID']['output'];
  keyPeople?: Maybe<Array<KeyPerson>>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: Maybe<Scalars['String']['output']>;
  /** Legal name */
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  mostRecentValuationDate?: Maybe<Scalars['Time']['output']>;
  nongrantorControlledPercentage: Scalars['Percent']['output'];
  nongrantorControlledValue: Scalars['CurrencyUSD']['output'];
  /** Ownership as-of date. */
  ownershipAsOfDate?: Maybe<Scalars['Time']['output']>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: Maybe<Scalars['Boolean']['output']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: Maybe<Scalars['Percent']['output']>;
  taxID?: Maybe<Scalars['String']['output']>;
  taxStatus?: Maybe<BusinessEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type SoleProprietorshipBusinessEntityHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};

/** A connection to a list of items. */
export type SoleProprietorshipBusinessEntityConnection = {
  __typename?: 'SoleProprietorshipBusinessEntityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SoleProprietorshipBusinessEntityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SoleProprietorshipBusinessEntityEdge = {
  __typename?: 'SoleProprietorshipBusinessEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SoleProprietorshipBusinessEntity>;
};

/** Ordering options for SoleProprietorshipBusinessEntity connections */
export type SoleProprietorshipBusinessEntityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order SoleProprietorshipBusinessEntities. */
  field: SoleProprietorshipBusinessEntityOrderField;
};

/** Properties by which SoleProprietorshipBusinessEntity connections can be ordered. */
export enum SoleProprietorshipBusinessEntityOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * SoleProprietorshipBusinessEntityWhereInput is used for filtering SoleProprietorshipBusinessEntity objects.
 * Input was generated by ent.
 */
export type SoleProprietorshipBusinessEntityWhereInput = {
  and?: InputMaybe<Array<SoleProprietorshipBusinessEntityWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** doing_business_as_name field predicates */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  doingBusinessAsNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  doingBusinessAsNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** effective_date field predicates */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDateLT?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  effectiveDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable_real_tpp_tax_exposure field predicates */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  enableRealTppTaxExposureIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  enableRealTppTaxExposureNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** entity_exists field predicates */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** fin_cen_id field predicates */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  finCenIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  finCenIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** formation_jurisdiction_state_code field predicates */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  formationJurisdictionStateCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  formationJurisdictionStateCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** accounts edge predicates */
  hasAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountsWith?: InputMaybe<Array<AccountWhereInput>>;
  /** designer_account edge predicates */
  hasDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hasDesignerAccountWith?: InputMaybe<Array<AccountWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** key_people edge predicates */
  hasKeyPeople?: InputMaybe<Scalars['Boolean']['input']>;
  hasKeyPeopleWith?: InputMaybe<Array<KeyPersonWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key_people_notes field predicates */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  keyPeopleNotesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  keyPeopleNotesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** legal_name field predicates */
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  legalNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<SoleProprietorshipBusinessEntityWhereInput>;
  or?: InputMaybe<Array<SoleProprietorshipBusinessEntityWhereInput>>;
  /** ownership_as_of_date field predicates */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateGT?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateGTE?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownershipAsOfDateLT?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateLTE?: InputMaybe<Scalars['Time']['input']>;
  ownershipAsOfDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** requires_cta_reporting field predicates */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCtaReportingIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCtaReportingNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_discount field predicates */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxDiscountLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxDiscountNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_id field predicates */
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<BusinessEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<BusinessEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<BusinessEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type StartAiDispositiveProvisionWorkflowForTeInput = {
  /** The document ID's to use for the AI DP workflow. */
  documentIDs: Array<Scalars['ID']['input']>;
  /** The householdID is required. */
  householdID: Scalars['ID']['input'];
  /** The TE's to run the AI DP workflow for. */
  testamentaryEntityIDs: Array<Scalars['ID']['input']>;
};

export type StartAiDispositiveProvisionWorkflowInput = {
  /**
   * The entityID is optional. If given, DP's will only be run for the 1 entity.
   * Otherwise, we'll run the workflow for all eligible entities in the household.
   */
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** The householdID is required. */
  householdID: Scalars['ID']['input'];
};

export type StartAiDispositiveProvisionWorkflowInputForEntitiesInput = {
  /** The entities to run the AI DP workflow for. */
  entityIDs: Array<Scalars['ID']['input']>;
  /** The householdID is required. */
  householdID: Scalars['ID']['input'];
};

export type StartAiOnboardingWorkflowInput = {
  documentIds: Array<Scalars['ID']['input']>;
  householdID: Scalars['ID']['input'];
};

export type StartCreatePresentationFromTemplatePayload = {
  __typename?: 'StartCreatePresentationFromTemplatePayload';
  presentation: ClientPresentationV2;
  workflowTracker?: Maybe<WorkflowTracker>;
};

/**
 * Payload returned by startDocumentQuestionStream mutation.
 * Contains the workflow tracker for subscribing to the stream and the conversation.
 */
export type StartDocumentQuestionStreamPayload = {
  __typename?: 'StartDocumentQuestionStreamPayload';
  /** The conversation that was created or found. */
  conversation: Conversation;
  /** The workflow tracker ID to use for subscribing to the stream. */
  workflowTracker: WorkflowTracker;
};

export type StartFormSubmissionExtractionInput = {
  id: Scalars['ID']['input'];
};

/** StateCode is enum for the field tax_situs_state_code */
export enum StateCode {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

/** StateGiftTaxDetail contains state-level gift tax details. */
export type StateGiftTaxDetail = {
  __typename?: 'StateGiftTaxDetail';
  _cacheKey: Scalars['String']['output'];
  /** For Connecticut state gift tax, ctTaxesPaid is the amount of Connecticut state tax already paid on gifts made during the grantor's lifetime. */
  ctTaxesPaid?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** exemptionUsed is the amount of exemption that was used to cover the gifts */
  exemptionUsed: Scalars['CurrencyUSD']['output'];
  stateCode: StateCode;
  tax: Scalars['CurrencyUSD']['output'];
  /** taxableAmount is the final amount, after exemption etc, that is taxed */
  taxableAmount: Scalars['CurrencyUSD']['output'];
  /** taxableGiftsMade is the amount of taxable gifts made */
  taxableGiftsMade: Scalars['CurrencyUSD']['output'];
};

export type StateInheritanceTaxDetail = {
  __typename?: 'StateInheritanceTaxDetail';
  _cacheKey: Scalars['String']['output'];
  /**
   * exemptionUsed is the per-beneficiary-class exemption applied for this state
   * (e.g. New Jersey Class C's $25k per-beneficiary exemption).
   */
  exemptionUsed: Scalars['CurrencyUSD']['output'];
  /**
   * federalEstateTaxDeduction is the federal estate tax deducted from this state's
   * inheritance-tax base before tax (Nebraska deducts it under IRC §2058). Nil when
   * the state deducts no federal estate tax.
   */
  federalEstateTaxDeduction?: Maybe<Scalars['CurrencyUSD']['output']>;
  /**
   * nonResidentStateTaxDeduction is the deduction for death taxes another
   * (non-resident) state levied on the same property (Pennsylvania / New Jersey
   * deduct it under §2128). Nil when the state grants no such deduction.
   */
  nonResidentStateTaxDeduction?: Maybe<Scalars['CurrencyUSD']['output']>;
  stateCode: StateCode;
  stateDisclosure?: Maybe<Scalars['String']['output']>;
  tax: Scalars['CurrencyUSD']['output'];
  /**
   * taxableAmount is the final amount subject to tax, net of valuation
   * discounts, out-of-state offsets, and exemptions.
   */
  taxableAmount: Scalars['CurrencyUSD']['output'];
  /** totalTransferAmount is the total beneficiary inheritance for this state */
  totalTransferAmount: Scalars['CurrencyUSD']['output'];
  /** valuationDiscount is the amount by which the total transfer amount is reduced. */
  valuationDiscount?: Maybe<Scalars['CurrencyUSD']['output']>;
};

export type StateTaxDetail = {
  __typename?: 'StateTaxDetail';
  _cacheKey: Scalars['String']['output'];
  /**
   * adjustedTaxableGifts is the amount of taxable gifts made by the dying grantor in their lifetime
   * Only relevant for Illinois state taxes.
   */
  adjustedTaxableGifts: Scalars['CurrencyUSD']['output'];
  /**
   * apportionmentRatio is the fraction applied to the tentative tax for fractional
   * apportionment states (e.g. 0.8). Nil when apportionment does not apply.
   */
  apportionmentRatio?: Maybe<Scalars['Percent']['output']>;
  /** For Connecticut state gift tax, ctTaxesPaid is the amount of Connecticut state tax already paid on gifts made during the grantor's lifetime. */
  ctTaxesPaid?: Maybe<Scalars['CurrencyUSD']['output']>;
  exemptionAvailable: Scalars['CurrencyUSD']['output'];
  exemptionUsed: Scalars['CurrencyUSD']['output'];
  grossEstate: Scalars['CurrencyUSD']['output'];
  /**
   * inheritanceTaxCredit is the inheritance tax credited against this state's estate
   * tax (MD couples the two: net estate = max(0, estate - inheritance)). Nil when the
   * state has no inheritance tax to credit.
   */
  inheritanceTaxCredit?: Maybe<Scalars['CurrencyUSD']['output']>;
  /**
   * isTaxableAmountOverCliff is true if the state taxable estate is over the exemption cliff.
   * If this is true, no state exemption can be used.
   */
  isTaxableAmountOverCliff: Scalars['Boolean']['output'];
  nonTaxableTransfers: Scalars['CurrencyUSD']['output'];
  stateCode?: Maybe<StateCode>;
  stateDisclosure?: Maybe<Scalars['String']['output']>;
  tax: Scalars['CurrencyUSD']['output'];
  /**
   * taxableAmount is the final amount subject to tax.
   * In the case of Illinois, it will be the sum of the taxableEstate and the adjustedTaxableGifts.
   * Otherwise, it will be the same as the taxableEstate.
   */
  taxableAmount: Scalars['CurrencyUSD']['output'];
  /** taxableEstate is the amount of the estate that is subject to tax */
  taxableEstate: Scalars['CurrencyUSD']['output'];
  /**
   * tentativeStateTax is the pre-apportionment tax amount for fractional
   * apportionment states (e.g. CT, MN, OR). Nil when apportionment does not apply.
   */
  tentativeStateTax?: Maybe<Scalars['CurrencyUSD']['output']>;
  /** valuationDiscount is the amount by which the taxable portion of the gross estate is reduced. */
  valuationDiscount?: Maybe<Scalars['CurrencyUSD']['output']>;
};

export type SubBrand = Branded & Named & Node & {
  __typename?: 'SubBrand';
  buttonsLinkColor: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  darkSquareLogoURL?: Maybe<Scalars['String']['output']>;
  darkWideLogoURL?: Maybe<Scalars['String']['output']>;
  dataVisualizationNegativeColor?: Maybe<Scalars['String']['output']>;
  dataVisualizationPrimaryColor: Scalars['String']['output'];
  dataVisualizationSecondaryColor: Scalars['String']['output'];
  dataVisualizationTertiaryColor?: Maybe<Scalars['String']['output']>;
  disclaimerConfiguration?: Maybe<SubBrandDisclaimerConfiguration>;
  displayName: Scalars['String']['output'];
  households: HouseholdConnection;
  id: Scalars['ID']['output'];
  logoURL: Scalars['String']['output'];
  /** Optional sub-brand-specific cover slide config. */
  presentationCoverSlideConfig?: Maybe<PresentationCoverSlideConfig>;
  /** Optional sub-brand-specific divider slide config. */
  presentationDividerSlideConfig?: Maybe<PresentationCoverSlideConfig>;
  /** Font face for presentation headers and cover/divider slides. */
  presentationHeaderFontFace: PresentationHeaderFontFace;
  primaryColor: Scalars['String']['output'];
  secondaryColor: Scalars['String']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};


export type SubBrandHouseholdsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HouseholdOrder>>;
  where?: InputMaybe<HouseholdWhereInput>;
};

/** A connection to a list of items. */
export type SubBrandConnection = {
  __typename?: 'SubBrandConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubBrandEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type SubBrandDisclaimerConfiguration = Node & {
  __typename?: 'SubBrandDisclaimerConfiguration';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** If true, include the default Luminary company disclosures in the presentation */
  includeLuminaryDisclaimer: Scalars['Boolean']['output'];
  presentationCoverDisclaimerBody?: Maybe<Scalars['String']['output']>;
  presentationCoverDisclaimerTitle?: Maybe<Scalars['String']['output']>;
  presentationFooterDisclaimerBody?: Maybe<Scalars['String']['output']>;
  presentationFooterDisclaimerTitle?: Maybe<Scalars['String']['output']>;
  presentationStandaloneDisclaimerBody?: Maybe<Scalars['String']['output']>;
  presentationStandaloneDisclaimerTitle?: Maybe<Scalars['String']['output']>;
  subBrand: SubBrand;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** An edge in a connection. */
export type SubBrandEdge = {
  __typename?: 'SubBrandEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SubBrand>;
};

/** Ordering options for SubBrand connections */
export type SubBrandOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order SubBrands. */
  field: SubBrandOrderField;
};

/** Properties by which SubBrand connections can be ordered. */
export enum SubBrandOrderField {
  DisplayName = 'DISPLAY_NAME',
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * SubBrandWhereInput is used for filtering SubBrand objects.
 * Input was generated by ent.
 */
export type SubBrandWhereInput = {
  and?: InputMaybe<Array<SubBrandWhereInput>>;
  /** buttons_link_color field predicates */
  buttonsLinkColor?: InputMaybe<Scalars['String']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** dark_square_logo_url field predicates */
  darkSquareLogoURL?: InputMaybe<Scalars['String']['input']>;
  darkSquareLogoURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  darkSquareLogoURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** dark_wide_logo_url field predicates */
  darkWideLogoURL?: InputMaybe<Scalars['String']['input']>;
  darkWideLogoURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  darkWideLogoURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** data_visualization_negative_color field predicates */
  dataVisualizationNegativeColor?: InputMaybe<Scalars['String']['input']>;
  dataVisualizationNegativeColorIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dataVisualizationNegativeColorNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** data_visualization_primary_color field predicates */
  dataVisualizationPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  /** data_visualization_secondary_color field predicates */
  dataVisualizationSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  /** data_visualization_tertiary_color field predicates */
  dataVisualizationTertiaryColor?: InputMaybe<Scalars['String']['input']>;
  dataVisualizationTertiaryColorIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dataVisualizationTertiaryColorNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** logo_url field predicates */
  logoURL?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<SubBrandWhereInput>;
  or?: InputMaybe<Array<SubBrandWhereInput>>;
  /** presentation_header_font_face field predicates */
  presentationHeaderFontFace?: InputMaybe<PresentationHeaderFontFace>;
  presentationHeaderFontFaceIn?: InputMaybe<Array<PresentationHeaderFontFace>>;
  presentationHeaderFontFaceNEQ?: InputMaybe<PresentationHeaderFontFace>;
  presentationHeaderFontFaceNotIn?: InputMaybe<Array<PresentationHeaderFontFace>>;
  /** primary_color field predicates */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** secondary_color field predicates */
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type Submission = Node & {
  __typename?: 'Submission';
  /** The stable field answer slots for this submission */
  answers?: Maybe<Array<Answer>>;
  /** When a user archived this submission */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The user who archived this submission */
  archivedBy?: Maybe<User>;
  /** When a user marked this submission as completed */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** The user who marked this submission as completed */
  completedBy?: Maybe<User>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The published form version that this submission executes */
  formVersion: FormVersion;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** User-editable name for the review */
  name?: Maybe<Scalars['String']['output']>;
  sourceDocuments: DocumentConnection;
  /** The current extraction and human review state */
  status: SubmissionStatus;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};


export type SubmissionSourceDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentOrder>>;
  where?: InputMaybe<DocumentWhereInput>;
};

/** A connection to a list of items. */
export type SubmissionConnection = {
  __typename?: 'SubmissionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubmissionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubmissionEdge = {
  __typename?: 'SubmissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Submission>;
};

/** Ordering options for Submission connections */
export type SubmissionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Submissions. */
  field: SubmissionOrderField;
};

/** Properties by which Submission connections can be ordered. */
export enum SubmissionOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** SubmissionStatus is enum for the field status */
export enum SubmissionStatus {
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Extracting = 'EXTRACTING',
  Failed = 'FAILED',
  InReview = 'IN_REVIEW'
}

/**
 * SubmissionWhereInput is used for filtering Submission objects.
 * Input was generated by ent.
 */
export type SubmissionWhereInput = {
  and?: InputMaybe<Array<SubmissionWhereInput>>;
  /** archived_at field predicates */
  archivedAt?: InputMaybe<Scalars['Time']['input']>;
  archivedAtGT?: InputMaybe<Scalars['Time']['input']>;
  archivedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  archivedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  archivedAtLT?: InputMaybe<Scalars['Time']['input']>;
  archivedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  archivedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** completed_at field predicates */
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  completedAtGT?: InputMaybe<Scalars['Time']['input']>;
  completedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  completedAtLT?: InputMaybe<Scalars['Time']['input']>;
  completedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** answers edge predicates */
  hasAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAnswersWith?: InputMaybe<Array<AnswerWhereInput>>;
  /** archived_by edge predicates */
  hasArchivedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasArchivedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** completed_by edge predicates */
  hasCompletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCompletedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** form_version edge predicates */
  hasFormVersion?: InputMaybe<Scalars['Boolean']['input']>;
  hasFormVersionWith?: InputMaybe<Array<FormVersionWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** source_documents edge predicates */
  hasSourceDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasSourceDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<SubmissionWhereInput>;
  or?: InputMaybe<Array<SubmissionWhereInput>>;
  /** status field predicates */
  status?: InputMaybe<SubmissionStatus>;
  statusIn?: InputMaybe<Array<SubmissionStatus>>;
  statusNEQ?: InputMaybe<SubmissionStatus>;
  statusNotIn?: InputMaybe<Array<SubmissionStatus>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Ask a question about a document with streaming response.
   * Streams text chunks as they are generated, then sends a final result
   * with the complete answer, supporting paragraph IDs, and conversation.
   */
  askDocumentQuestionStreaming: AskDocumentQuestionStreamEvent;
  /**
   * Streams the current user's active and recently updated workflow trackers,
   * followed by later status updates.
   */
  currentUserWorkflowTrackerUpdates: WorkflowTracker;
  /** generatePresentationCustomSlidePrompt streams markdown chunks for one custom slide and emits a terminal result. */
  generatePresentationCustomSlidePrompt: PresentationCustomSlidePromptResult;
  /**
   * generateTileNotes streams generated notes for multiple tiles in a waterfall diagram.
   *
   * matchSummaryFormats, when true, will generate the first tile's notes normally,
   * then use that tile's format as a template for all subsequent tiles to maintain
   * consistent summary formatting across all tiles.
   */
  generateTileNotes: TileNotesResult;
  household: Household;
  /**
   * Streams a household's active and recently updated workflow trackers,
   * followed by later status updates.
   */
  householdWorkflowTrackerUpdates: WorkflowTracker;
  /**
   * Streams the improved prompt tokens as they are generated.
   * Use this instead of the mutation to avoid timeouts with long-running LLM models like o3.
   */
  improvePromptStreaming: Scalars['String']['output'];
  kgLoadingStateUpdated: KgLoadingState;
  newNotification: NotificationApp;
  /** Current document and an update when its latest import finishes. Reconnect to watch a retry. */
  platformDocumentProcessingUpdates: PlatformDocument;
  /** Regenerates a presentation-template diagram using iterative evidence-retrieval tools. */
  regeneratePresentationTemplateDiagram: PresentationTemplateDiagramRegenerationResult;
  /**
   * Subscribe to a document question stream.
   * Takes the workflow tracker ID from startDocumentQuestionStream and
   * streams tokens as they are generated by the LLM.
   */
  subscribeDocumentQuestion: AskDocumentQuestionStreamEvent;
  /**
   * Subscribe to a household chat stream by conversation ID.
   * Streams activity events and answer token deltas, then a final structured result.
   */
  subscribeHouseholdChat: HouseholdChatStreamEvent;
  workflowTrackerHouseholdUpdates: WorkflowTracker;
  workflowTrackerUpdates: WorkflowTracker;
};


export type SubscriptionAskDocumentQuestionStreamingArgs = {
  input: AskDocumentQuestionInput;
};


export type SubscriptionGeneratePresentationCustomSlidePromptArgs = {
  input: GeneratePresentationCustomSlidePromptInput;
};


export type SubscriptionGenerateTileNotesArgs = {
  input: Array<TileNotesInput>;
  matchSummaryFormats?: InputMaybe<Scalars['Boolean']['input']>;
  prompt: Scalars['String']['input'];
};


export type SubscriptionHouseholdArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionHouseholdWorkflowTrackerUpdatesArgs = {
  householdID: Scalars['ID']['input'];
};


export type SubscriptionImprovePromptStreamingArgs = {
  input: ImprovePromptInput;
};


export type SubscriptionKgLoadingStateUpdatedArgs = {
  householdID: Scalars['ID']['input'];
};


export type SubscriptionPlatformDocumentProcessingUpdatesArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionRegeneratePresentationTemplateDiagramArgs = {
  input: RegeneratePresentationTemplateDiagramInput;
};


export type SubscriptionSubscribeDocumentQuestionArgs = {
  workflowTrackerId: Scalars['ID']['input'];
};


export type SubscriptionSubscribeHouseholdChatArgs = {
  conversationId: Scalars['ID']['input'];
};


export type SubscriptionWorkflowTrackerHouseholdUpdatesArgs = {
  householdID: Scalars['ID']['input'];
};

/**
 * SubtrustCreatedFromType indicates the type of parent entity that a sub-trust is created from.
 * Only root trust (Entity) parents are supported.
 */
export enum SubtrustCreatedFromType {
  /** The sub-trust is created from a root trust (Entity). */
  Trust = 'TRUST'
}

export type SummarizeDocumentInput = {
  /** an optional user prompt to add additional details to the summary */
  additionalSummaryDetailsPrompt?: InputMaybe<Scalars['String']['input']>;
  /** the ID of the document to summarize */
  documentID: Scalars['ID']['input'];
  /** an optional ID of a summary to reference for formatting similarity */
  formatReferenceSummaryID?: InputMaybe<Scalars['ID']['input']>;
  /** whether or not to include associated documents in the summary */
  includeAssociatedDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * an optional display name for the summary; this should be used if
   * you're making a new summary
   */
  summaryDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** an optional ID of a DocumentSummaryPrompt to use for the summary */
  summaryPromptID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * an optional ID of a document summary to update. when provided,
   * the summary will be updated; otherwise, a new summary will be created
   */
  updateDocumentSummaryID?: InputMaybe<Scalars['ID']['input']>;
};

export type SummarizeDocumentsInput = {
  summaryEntryMode?: DocumentSummaryEntryMode;
  where: DocumentWhereInput;
};

export type SummaryAnnuityPaymentDetails = {
  __typename?: 'SummaryAnnuityPaymentDetails';
  label: Scalars['String']['output'];
  paymentPercentage: Scalars['String']['output'];
};

export type SummaryAsset = {
  __typename?: 'SummaryAsset';
  displayName: Scalars['String']['output'];
  qsbsDetails?: Maybe<Scalars['String']['output']>;
  shareCount?: Maybe<Scalars['String']['output']>;
  sharePrice?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SummaryBeneficiary = {
  __typename?: 'SummaryBeneficiary';
  additionalContext: Array<Maybe<Scalars['String']['output']>>;
  badgeText?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  displayType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ownershipPercentage: Scalars['String']['output'];
};

export enum SummaryBeneficiaryKindv2 {
  ClientProfile = 'CLIENT_PROFILE',
  Entity = 'ENTITY',
  Organization = 'ORGANIZATION',
  TestamentaryEntity = 'TESTAMENTARY_ENTITY'
}

export type SummaryBeneficiaryv2 = {
  __typename?: 'SummaryBeneficiaryv2';
  additionalContext: Array<Maybe<Scalars['String']['output']>>;
  badgeText?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  displayType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: SummaryBeneficiaryKindv2;
  ownershipPercentage: Scalars['String']['output'];
};

/**
 * SummaryMetricsSourceInput identifies where a summary-metrics query is coming from so the
 * backend can resolve that surface's balance sheet column filters and apply them to the
 * metric calculations. When omitted, metrics are computed over all entities.
 */
export type SummaryMetricsSourceInput = {
  /**
   * Presentation bundle whose BalanceSheetBundleConfiguration supplies the filters.
   * Only used when kind is PRESENTATION.
   */
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Specific BalanceSheetBundleConfiguration (per-page config) supplying the filters.
   * Takes precedence over bundleID. Only used when kind is PRESENTATION.
   */
  configurationID?: InputMaybe<Scalars['ID']['input']>;
  kind: SummaryMetricsSourceKind;
};

/** SummaryMetricsSourceKind identifies the surface a summary-metrics query is issued from. */
export enum SummaryMetricsSourceKind {
  /** The in-app estate page balance sheet; filters come from the household's BalanceSheetViewConfiguration. */
  BalanceSheet = 'BALANCE_SHEET',
  /** The in-app household overview; applies the household's death-benefit valuation but no column/section filters, so metrics reflect the full estate. */
  Household = 'HOUSEHOLD',
  /** A presentation balance sheet slide; filters come from the bundle or per-page BalanceSheetBundleConfiguration. */
  Presentation = 'PRESENTATION'
}

export type SummaryPerson = {
  __typename?: 'SummaryPerson';
  additionalContext?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  address: Scalars['String']['output'];
  badgeText?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  displayType?: Maybe<Scalars['String']['output']>;
};

export type SyncDeathOrderNotesInput = {
  activeDeathOrderID?: InputMaybe<Scalars['ID']['input']>;
  entityID: Scalars['ID']['input'];
  householdID: Scalars['ID']['input'];
  sync: Scalars['Boolean']['input'];
};

export type TaxDetail = {
  __typename?: 'TaxDetail';
  _cacheKey: Scalars['String']['output'];
  deductions: Scalars['CurrencyUSD']['output'];
  exemptionAvailable: Scalars['CurrencyUSD']['output'];
  exemptionCliff?: Maybe<Scalars['CurrencyUSD']['output']>;
  exemptionUsed: Scalars['CurrencyUSD']['output'];
  portableExemption?: Maybe<Scalars['CurrencyUSD']['output']>;
  stateCode?: Maybe<StateCode>;
  stateDisclosure?: Maybe<Scalars['String']['output']>;
  tax: Scalars['CurrencyUSD']['output'];
  taxableAmount: Scalars['CurrencyUSD']['output'];
  /** taxableAmountAfterExemption is the taxable amount after considering exemption. */
  taxableAmountAfterExemption: Scalars['CurrencyUSD']['output'];
  taxableAmountOverCliff?: Maybe<Scalars['Boolean']['output']>;
  taxableTransfers: Scalars['CurrencyUSD']['output'];
  totalExemption: Scalars['CurrencyUSD']['output'];
  /** valuationDiscountApplied is the amount of valuation discount applied. */
  valuationDiscountApplied?: Maybe<Scalars['CurrencyUSD']['output']>;
};

export type TaxDragConfig = Node & {
  __typename?: 'TaxDragConfig';
  /** The method used to determine the tax drag percentage. */
  calculationMethod: TaxDragConfigCalculationMethod;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The federal ordinary income tax rate used for a computed tax drag. */
  federalIncomeTaxRate?: Maybe<Scalars['Percent']['output']>;
  /** The federal long-term capital gains tax rate used for a computed tax drag. */
  federalLongTermCapitalGainsRate?: Maybe<Scalars['Percent']['output']>;
  /** The growth profile that owns this tax drag configuration. */
  growthProfile: GrowthProfile;
  /** The growth profile ID that this tax drag configuration references. */
  growthProfileID: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The share of investment return treated as long-term capital gains. */
  longTermCapitalGainReturnPercentage?: Maybe<Scalars['Percent']['output']>;
  /** Whether the computed tax drag includes net investment income tax. */
  niitEnabled: Scalars['Boolean']['output'];
  /** The share of investment return treated as ordinary income. */
  ordinaryIncomeReturnPercentage?: Maybe<Scalars['Percent']['output']>;
  /** The share of investment return treated as qualified dividends. */
  qualifiedDividendReturnPercentage?: Maybe<Scalars['Percent']['output']>;
  /** The state ordinary income tax rate used for a computed tax drag. */
  stateIncomeTaxRate?: Maybe<Scalars['Percent']['output']>;
  /** The state long-term capital gains tax rate used for a computed tax drag. */
  stateLongTermCapitalGainsRate?: Maybe<Scalars['Percent']['output']>;
  /** The manual or server-computed effective tax drag percentage. */
  taxDragPercentage: Scalars['Percent']['output'];
  /** The share of investment return treated as tax-free income. */
  taxFreeIncomeReturnPercentage?: Maybe<Scalars['Percent']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** TaxDragConfigCalculationMethod is enum for the field calculation_method */
export enum TaxDragConfigCalculationMethod {
  Computed = 'COMPUTED',
  Manual = 'MANUAL'
}

/** A connection to a list of items. */
export type TaxDragConfigConnection = {
  __typename?: 'TaxDragConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TaxDragConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TaxDragConfigEdge = {
  __typename?: 'TaxDragConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TaxDragConfig>;
};

/** Ordering options for TaxDragConfig connections */
export type TaxDragConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TaxDragConfigs. */
  field: TaxDragConfigOrderField;
};

/** Properties by which TaxDragConfig connections can be ordered. */
export enum TaxDragConfigOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * TaxDragConfigWhereInput is used for filtering TaxDragConfig objects.
 * Input was generated by ent.
 */
export type TaxDragConfigWhereInput = {
  and?: InputMaybe<Array<TaxDragConfigWhereInput>>;
  /** calculation_method field predicates */
  calculationMethod?: InputMaybe<TaxDragConfigCalculationMethod>;
  calculationMethodIn?: InputMaybe<Array<TaxDragConfigCalculationMethod>>;
  calculationMethodNEQ?: InputMaybe<TaxDragConfigCalculationMethod>;
  calculationMethodNotIn?: InputMaybe<Array<TaxDragConfigCalculationMethod>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** federal_income_tax_rate field predicates */
  federalIncomeTaxRate?: InputMaybe<Scalars['Percent']['input']>;
  federalIncomeTaxRateGT?: InputMaybe<Scalars['Percent']['input']>;
  federalIncomeTaxRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  federalIncomeTaxRateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  federalIncomeTaxRateLT?: InputMaybe<Scalars['Percent']['input']>;
  federalIncomeTaxRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  federalIncomeTaxRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  federalIncomeTaxRateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** federal_long_term_capital_gains_rate field predicates */
  federalLongTermCapitalGainsRate?: InputMaybe<Scalars['Percent']['input']>;
  federalLongTermCapitalGainsRateGT?: InputMaybe<Scalars['Percent']['input']>;
  federalLongTermCapitalGainsRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  federalLongTermCapitalGainsRateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  federalLongTermCapitalGainsRateLT?: InputMaybe<Scalars['Percent']['input']>;
  federalLongTermCapitalGainsRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  federalLongTermCapitalGainsRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  federalLongTermCapitalGainsRateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** growth_profile_id field predicates */
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  growthProfileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  growthProfileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  growthProfileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** growth_profile edge predicates */
  hasGrowthProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrowthProfileWith?: InputMaybe<Array<GrowthProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** long_term_capital_gain_return_percentage field predicates */
  longTermCapitalGainReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  longTermCapitalGainReturnPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  longTermCapitalGainReturnPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  longTermCapitalGainReturnPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  longTermCapitalGainReturnPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  longTermCapitalGainReturnPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  longTermCapitalGainReturnPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  longTermCapitalGainReturnPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** niit_enabled field predicates */
  niitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<TaxDragConfigWhereInput>;
  or?: InputMaybe<Array<TaxDragConfigWhereInput>>;
  /** ordinary_income_return_percentage field predicates */
  ordinaryIncomeReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  ordinaryIncomeReturnPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  ordinaryIncomeReturnPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  ordinaryIncomeReturnPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ordinaryIncomeReturnPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  ordinaryIncomeReturnPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  ordinaryIncomeReturnPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  ordinaryIncomeReturnPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** qualified_dividend_return_percentage field predicates */
  qualifiedDividendReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  qualifiedDividendReturnPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  qualifiedDividendReturnPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  qualifiedDividendReturnPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  qualifiedDividendReturnPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  qualifiedDividendReturnPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  qualifiedDividendReturnPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  qualifiedDividendReturnPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state_income_tax_rate field predicates */
  stateIncomeTaxRate?: InputMaybe<Scalars['Percent']['input']>;
  stateIncomeTaxRateGT?: InputMaybe<Scalars['Percent']['input']>;
  stateIncomeTaxRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  stateIncomeTaxRateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  stateIncomeTaxRateLT?: InputMaybe<Scalars['Percent']['input']>;
  stateIncomeTaxRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  stateIncomeTaxRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  stateIncomeTaxRateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state_long_term_capital_gains_rate field predicates */
  stateLongTermCapitalGainsRate?: InputMaybe<Scalars['Percent']['input']>;
  stateLongTermCapitalGainsRateGT?: InputMaybe<Scalars['Percent']['input']>;
  stateLongTermCapitalGainsRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  stateLongTermCapitalGainsRateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  stateLongTermCapitalGainsRateLT?: InputMaybe<Scalars['Percent']['input']>;
  stateLongTermCapitalGainsRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  stateLongTermCapitalGainsRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  stateLongTermCapitalGainsRateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_drag_percentage field predicates */
  taxDragPercentage?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  /** tax_free_income_return_percentage field predicates */
  taxFreeIncomeReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  taxFreeIncomeReturnPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  taxFreeIncomeReturnPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxFreeIncomeReturnPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxFreeIncomeReturnPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  taxFreeIncomeReturnPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxFreeIncomeReturnPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxFreeIncomeReturnPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type TaxDragOverride = Node & {
  __typename?: 'TaxDragOverride';
  /** The method used to determine the tax drag percentage. */
  calculationMethod: TaxDragOverrideCalculationMethod;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The entity that uses this tax drag override. */
  entity?: Maybe<Entity>;
  /** The entity ID that this tax drag override references. */
  entityID?: Maybe<Scalars['ID']['output']>;
  /** The federal ordinary income tax rate used for a computed tax drag. */
  federalIncomeTaxRate?: Maybe<Scalars['Percent']['output']>;
  /** The federal long-term capital gains tax rate used for a computed tax drag. */
  federalLongTermCapitalGainsRate?: Maybe<Scalars['Percent']['output']>;
  /** The growth profile that owns this tax drag override. */
  growthProfile: GrowthProfile;
  /** The growth profile ID that this tax drag override references. */
  growthProfileID: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The share of investment return treated as long-term capital gains. */
  longTermCapitalGainReturnPercentage?: Maybe<Scalars['Percent']['output']>;
  /** Whether the computed tax drag includes net investment income tax. */
  niitEnabled: Scalars['Boolean']['output'];
  /** The share of investment return treated as ordinary income. */
  ordinaryIncomeReturnPercentage?: Maybe<Scalars['Percent']['output']>;
  /** The proposal that uses this tax drag override. */
  proposal?: Maybe<Proposal>;
  /** The proposal ID that this tax drag override references. */
  proposalID?: Maybe<Scalars['ID']['output']>;
  /** The share of investment return treated as qualified dividends. */
  qualifiedDividendReturnPercentage?: Maybe<Scalars['Percent']['output']>;
  /** The state ordinary income tax rate used for a computed tax drag. */
  stateIncomeTaxRate?: Maybe<Scalars['Percent']['output']>;
  /** The state long-term capital gains tax rate used for a computed tax drag. */
  stateLongTermCapitalGainsRate?: Maybe<Scalars['Percent']['output']>;
  /** The manual or server-computed effective tax drag percentage. */
  taxDragPercentage: Scalars['Percent']['output'];
  /** The share of investment return treated as tax-free income. */
  taxFreeIncomeReturnPercentage?: Maybe<Scalars['Percent']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** TaxDragOverrideCalculationMethod is enum for the field calculation_method */
export enum TaxDragOverrideCalculationMethod {
  Computed = 'COMPUTED',
  Manual = 'MANUAL'
}

/** A connection to a list of items. */
export type TaxDragOverrideConnection = {
  __typename?: 'TaxDragOverrideConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TaxDragOverrideEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TaxDragOverrideEdge = {
  __typename?: 'TaxDragOverrideEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TaxDragOverride>;
};

/** Ordering options for TaxDragOverride connections */
export type TaxDragOverrideOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TaxDragOverrides. */
  field: TaxDragOverrideOrderField;
};

/** Properties by which TaxDragOverride connections can be ordered. */
export enum TaxDragOverrideOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * TaxDragOverrideWhereInput is used for filtering TaxDragOverride objects.
 * Input was generated by ent.
 */
export type TaxDragOverrideWhereInput = {
  and?: InputMaybe<Array<TaxDragOverrideWhereInput>>;
  /** calculation_method field predicates */
  calculationMethod?: InputMaybe<TaxDragOverrideCalculationMethod>;
  calculationMethodIn?: InputMaybe<Array<TaxDragOverrideCalculationMethod>>;
  calculationMethodNEQ?: InputMaybe<TaxDragOverrideCalculationMethod>;
  calculationMethodNotIn?: InputMaybe<Array<TaxDragOverrideCalculationMethod>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** entity_id field predicates */
  entityID?: InputMaybe<Scalars['ID']['input']>;
  entityIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  entityIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  entityIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** federal_income_tax_rate field predicates */
  federalIncomeTaxRate?: InputMaybe<Scalars['Percent']['input']>;
  federalIncomeTaxRateGT?: InputMaybe<Scalars['Percent']['input']>;
  federalIncomeTaxRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  federalIncomeTaxRateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  federalIncomeTaxRateLT?: InputMaybe<Scalars['Percent']['input']>;
  federalIncomeTaxRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  federalIncomeTaxRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  federalIncomeTaxRateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** federal_long_term_capital_gains_rate field predicates */
  federalLongTermCapitalGainsRate?: InputMaybe<Scalars['Percent']['input']>;
  federalLongTermCapitalGainsRateGT?: InputMaybe<Scalars['Percent']['input']>;
  federalLongTermCapitalGainsRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  federalLongTermCapitalGainsRateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  federalLongTermCapitalGainsRateLT?: InputMaybe<Scalars['Percent']['input']>;
  federalLongTermCapitalGainsRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  federalLongTermCapitalGainsRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  federalLongTermCapitalGainsRateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** growth_profile_id field predicates */
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  growthProfileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  growthProfileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  growthProfileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** growth_profile edge predicates */
  hasGrowthProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrowthProfileWith?: InputMaybe<Array<GrowthProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** proposal edge predicates */
  hasProposal?: InputMaybe<Scalars['Boolean']['input']>;
  hasProposalWith?: InputMaybe<Array<ProposalWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** long_term_capital_gain_return_percentage field predicates */
  longTermCapitalGainReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  longTermCapitalGainReturnPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  longTermCapitalGainReturnPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  longTermCapitalGainReturnPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  longTermCapitalGainReturnPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  longTermCapitalGainReturnPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  longTermCapitalGainReturnPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  longTermCapitalGainReturnPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** niit_enabled field predicates */
  niitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<TaxDragOverrideWhereInput>;
  or?: InputMaybe<Array<TaxDragOverrideWhereInput>>;
  /** ordinary_income_return_percentage field predicates */
  ordinaryIncomeReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  ordinaryIncomeReturnPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  ordinaryIncomeReturnPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  ordinaryIncomeReturnPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ordinaryIncomeReturnPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  ordinaryIncomeReturnPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  ordinaryIncomeReturnPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  ordinaryIncomeReturnPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** proposal_id field predicates */
  proposalID?: InputMaybe<Scalars['ID']['input']>;
  proposalIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  proposalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  proposalIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  proposalIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  proposalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** qualified_dividend_return_percentage field predicates */
  qualifiedDividendReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  qualifiedDividendReturnPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  qualifiedDividendReturnPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  qualifiedDividendReturnPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  qualifiedDividendReturnPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  qualifiedDividendReturnPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  qualifiedDividendReturnPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  qualifiedDividendReturnPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state_income_tax_rate field predicates */
  stateIncomeTaxRate?: InputMaybe<Scalars['Percent']['input']>;
  stateIncomeTaxRateGT?: InputMaybe<Scalars['Percent']['input']>;
  stateIncomeTaxRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  stateIncomeTaxRateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  stateIncomeTaxRateLT?: InputMaybe<Scalars['Percent']['input']>;
  stateIncomeTaxRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  stateIncomeTaxRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  stateIncomeTaxRateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state_long_term_capital_gains_rate field predicates */
  stateLongTermCapitalGainsRate?: InputMaybe<Scalars['Percent']['input']>;
  stateLongTermCapitalGainsRateGT?: InputMaybe<Scalars['Percent']['input']>;
  stateLongTermCapitalGainsRateGTE?: InputMaybe<Scalars['Percent']['input']>;
  stateLongTermCapitalGainsRateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  stateLongTermCapitalGainsRateLT?: InputMaybe<Scalars['Percent']['input']>;
  stateLongTermCapitalGainsRateLTE?: InputMaybe<Scalars['Percent']['input']>;
  stateLongTermCapitalGainsRateNEQ?: InputMaybe<Scalars['Percent']['input']>;
  stateLongTermCapitalGainsRateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_drag_percentage field predicates */
  taxDragPercentage?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxDragPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  /** tax_free_income_return_percentage field predicates */
  taxFreeIncomeReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  taxFreeIncomeReturnPercentageGT?: InputMaybe<Scalars['Percent']['input']>;
  taxFreeIncomeReturnPercentageGTE?: InputMaybe<Scalars['Percent']['input']>;
  taxFreeIncomeReturnPercentageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxFreeIncomeReturnPercentageLT?: InputMaybe<Scalars['Percent']['input']>;
  taxFreeIncomeReturnPercentageLTE?: InputMaybe<Scalars['Percent']['input']>;
  taxFreeIncomeReturnPercentageNEQ?: InputMaybe<Scalars['Percent']['input']>;
  taxFreeIncomeReturnPercentageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** TaxShortfallReason is the reason for a tax shortfall. */
export enum TaxShortfallReason {
  NotEnoughTaxBearingDps = 'NOT_ENOUGH_TAX_BEARING_DPS',
  Unsatisfiable = 'UNSATISFIABLE'
}

export type TaxSummary = {
  __typename?: 'TaxSummary';
  _cacheKey: Scalars['String']['output'];
  federalTax?: Maybe<TaxDetail>;
  stateTax?: Maybe<Array<TaxDetail>>;
};

/** TaxSummaryV2 contains the federal, gst, and state tax summaries for the estate waterfall death event. */
export type TaxSummaryV2 = {
  __typename?: 'TaxSummaryV2';
  _cacheKey: Scalars['String']['output'];
  federalTax?: Maybe<FederalTaxDetail>;
  gstTax?: Maybe<GstTaxDetail>;
  stateInheritanceTax?: Maybe<Array<StateInheritanceTaxDetail>>;
  stateTax?: Maybe<Array<StateTaxDetail>>;
  /**
   * taxShortfallReason is the reason for a tax shortfall.
   * this could be because we've excluded too many DPs from being tax bearing or because we have outstanding loans/CLT/etc
   * that create a shortfall.
   * if the tax shortfall is due to a DPS, the reason will be NOT_ENOUGH_TAX_BEARING_DPS.
   * if the tax shortfall is due to an unsatisifiable tax event, the reason will be UNSATISFIABLE.
   * if the tax shortfall is nil, there is no tax shortfall.
   */
  taxShortfallReason?: Maybe<TaxShortfallReason>;
};

export type Team = Node & {
  __typename?: 'Team';
  assignedHouseholds: HouseholdConnection;
  children?: Maybe<Array<Team>>;
  createdAt: Scalars['Time']['output'];
  employees: EmployeeConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner?: Maybe<Employee>;
  parent?: Maybe<Team>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  /** The WorkOS directory group id, if directory sync is enabled for this workos organization */
  workosDirectoryGroupID?: Maybe<Scalars['String']['output']>;
  /** The WorkOS updated_at timestamp */
  workosUpdatedAt?: Maybe<Scalars['Time']['output']>;
};


export type TeamAssignedHouseholdsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HouseholdOrder>>;
  where?: InputMaybe<HouseholdWhereInput>;
};


export type TeamEmployeesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmployeeOrder>>;
  where?: InputMaybe<EmployeeWhereInput>;
};

/** A connection to a list of items. */
export type TeamConnection = {
  __typename?: 'TeamConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TeamEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TeamEdge = {
  __typename?: 'TeamEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Team>;
};

/** Ordering options for Team connections */
export type TeamOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Teams. */
  field: TeamOrderField;
};

/** Properties by which Team connections can be ordered. */
export enum TeamOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * TeamWhereInput is used for filtering Team objects.
 * Input was generated by ent.
 */
export type TeamWhereInput = {
  and?: InputMaybe<Array<TeamWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** children edge predicates */
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildrenWith?: InputMaybe<Array<TeamWhereInput>>;
  /** employees edge predicates */
  hasEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmployeesWith?: InputMaybe<Array<EmployeeWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<EmployeeWhereInput>>;
  /** parent edge predicates */
  hasParent?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentWith?: InputMaybe<Array<TeamWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<TeamWhereInput>;
  or?: InputMaybe<Array<TeamWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** workos_directory_group_id field predicates */
  workosDirectoryGroupID?: InputMaybe<Scalars['String']['input']>;
  workosDirectoryGroupIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  workosDirectoryGroupIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** workos_updated_at field predicates */
  workosUpdatedAt?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  workosUpdatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Tenant = Node & {
  __typename?: 'Tenant';
  /** Whether the tenant has the asset provider integration addon enabled. */
  addonAssetProviderIntegrationEnabled: Scalars['Boolean']['output'];
  branding?: Maybe<TenantBranding>;
  /**
   * WARNING: FOR ANALYTICS/REPORTING ONLY. NOT FOR BUSINESS LOGIC. The date the contract started.
   * @deprecated This field is deprecated and will be removed in a future release.
   */
  contractStartDate?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  kind: TenantKind;
  luminaryOrganization?: Maybe<LuminaryOrganization>;
  /** The LuminaryOrganization this tenant belongs to. NULL = standalone tenant. */
  luminaryOrganizationID?: Maybe<Scalars['ID']['output']>;
  /** NOTE: Name is only used to initialize the tenant name. It is not used for display purposes. Use the TenantBranding.DisplayName property instead. */
  name: Scalars['String']['output'];
  /** PARENT (one per org) or MEMBER. NULL iff luminary_organization_id is NULL. */
  orgMembershipType?: Maybe<TenantOrgMembershipType>;
  /** The date when the tenant pending deletion was set. Automatically set when the tenant is marked for deletion. */
  pendingDeletionSetAt?: Maybe<Scalars['Time']['output']>;
  /** The product tier for this tenant. */
  productTier: TenantProductTier;
  /** These are sso_connections that are allowed to be used by this tenant. */
  ssoConnections?: Maybe<Array<SsoConnection>>;
  subdomain: Scalars['String']['output'];
  tenantSSOConnections?: Maybe<Array<TenantSsoConnection>>;
  /** The date when the tenant's trial period ends. */
  trialEndDate?: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['Time']['output'];
  /** WARNING: FOR ANALYTICS/REPORTING ONLY. NOT FOR BUSINESS LOGIC. This is the bucket that the tenant falls into for usage tracking. */
  usageBucket: TenantUsageBucket;
  /** The WorkOS directory id, if directory sync is enabled for this workos organization */
  workosDirectoryID?: Maybe<Scalars['String']['output']>;
  /** The WorkOS M2M application client_id for this tenant. When set, M2M access tokens must carry an app_client_id claim matching this value. */
  workosM2mClientID?: Maybe<Scalars['String']['output']>;
  /** The WorkOS Connect (OAuth) application client_id for this tenant. When set, Connect access tokens must carry an app_client_id claim matching this value. */
  workosOauthClientID?: Maybe<Scalars['String']['output']>;
  /** The corresponding WorkOS organization ID for this tenant. */
  workosOrganizationID?: Maybe<Scalars['String']['output']>;
  /** The WorkOS updated_at timestamp */
  workosUpdatedAt?: Maybe<Scalars['Time']['output']>;
};

export type TenantApplicationConfiguration = Node & {
  __typename?: 'TenantApplicationConfiguration';
  /** Optional allowlist of email domains that can be invited as collaborators. Do not include @. */
  collaboratorDomainAllowList?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['Time']['output'];
  /** If true, disables advanced analytics for this tenant. */
  disableAdvancedAnalytics: Scalars['Boolean']['output'];
  /** If true, disables all AI capabilities for this tenant. */
  disableAiCapabilities: Scalars['Boolean']['output'];
  /** If true, disables AI insights for member tenants. */
  disableAiInsights: Scalars['Boolean']['output'];
  /** If true, allows admins to set the employee.idp_id field via UI */
  enableEmployeeIdpID: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The maximum duration of a user session. This is used to control the maximum duration of a user session. This is used to control the maximum duration of a user session. */
  maxSessionDuration: TenantApplicationConfigurationMaxSessionDuration;
  /** Controls the operations available through Model Context Protocol for this tenant. */
  mcpAccess: McpAccess;
  /** The mechanism that will be used to login if the user does not have an SSO connection. */
  nonSSOLoginMechanism: TenantApplicationConfigurationNonSsoLoginMechanism;
  /** The email address of the tenant's operations contact. */
  operationsContactEmailAddress?: Maybe<Scalars['String']['output']>;
  /** The full name of the tenant's operations contact. */
  operationsContactFullName?: Maybe<Scalars['String']['output']>;
  /** When require_presentation_approval last started to require approval. Presentations created before this time need no approval. A null value means that approval is not required, or has been required since before this value existed. */
  presentationApprovalRequiredSince?: Maybe<Scalars['Time']['output']>;
  /** When require_presentation_approval last started to require attestation. Presentations created before this time need no review. A null value means that attestation is not required, or has been required since before this value existed. */
  presentationAttestationRequiredSince?: Maybe<Scalars['Time']['output']>;
  /** Controls the review steps that client presentations in this tenant require. */
  requirePresentationApproval: PresentationApprovalRequirement;
  /** The email address of the tenant's security contact. */
  securityContactEmailAddress?: Maybe<Scalars['String']['output']>;
  /** The full name of the tenant's security contact. */
  securityContactFullName?: Maybe<Scalars['String']['output']>;
  /** If true, enables SmartReview for this tenant. */
  smartReviewEnabled: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  /** User Sessions expire after a period of inactivity. This field controls the timeout period. */
  userSessionInactivityTimeout: TenantApplicationConfigurationUserSessionInactivityTimeout;
};

/** TenantApplicationConfigurationMaxSessionDuration is enum for the field max_session_duration */
export enum TenantApplicationConfigurationMaxSessionDuration {
  EightHours = 'EIGHT_HOURS',
  OneHour = 'ONE_HOUR',
  TwelveHours = 'TWELVE_HOURS',
  TwentyEightDays = 'TWENTY_EIGHT_DAYS'
}

/** TenantApplicationConfigurationNonSSOLoginMechanism is enum for the field non_sso_login_mechanism */
export enum TenantApplicationConfigurationNonSsoLoginMechanism {
  MagicCode = 'MAGIC_CODE',
  MagicLink = 'MAGIC_LINK'
}

/** Ordering options for TenantApplicationConfiguration connections */
export type TenantApplicationConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TenantApplicationConfigurations. */
  field: TenantApplicationConfigurationOrderField;
};

/** Properties by which TenantApplicationConfiguration connections can be ordered. */
export enum TenantApplicationConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** TenantApplicationConfigurationUserSessionInactivityTimeout is enum for the field user_session_inactivity_timeout */
export enum TenantApplicationConfigurationUserSessionInactivityTimeout {
  FifteenMinutes = 'FIFTEEN_MINUTES',
  FiveSecondsForTesting = 'FIVE_SECONDS_FOR_TESTING',
  Off = 'OFF',
  OneHour = 'ONE_HOUR'
}

/**
 * TenantApplicationConfigurationWhereInput is used for filtering TenantApplicationConfiguration objects.
 * Input was generated by ent.
 */
export type TenantApplicationConfigurationWhereInput = {
  and?: InputMaybe<Array<TenantApplicationConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** disable_advanced_analytics field predicates */
  disableAdvancedAnalytics?: InputMaybe<Scalars['Boolean']['input']>;
  /** disable_ai_capabilities field predicates */
  disableAiCapabilities?: InputMaybe<Scalars['Boolean']['input']>;
  /** disable_ai_insights field predicates */
  disableAiInsights?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable_employee_idp_id field predicates */
  enableEmployeeIdpID?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** max_session_duration field predicates */
  maxSessionDuration?: InputMaybe<TenantApplicationConfigurationMaxSessionDuration>;
  maxSessionDurationIn?: InputMaybe<Array<TenantApplicationConfigurationMaxSessionDuration>>;
  maxSessionDurationNEQ?: InputMaybe<TenantApplicationConfigurationMaxSessionDuration>;
  maxSessionDurationNotIn?: InputMaybe<Array<TenantApplicationConfigurationMaxSessionDuration>>;
  /** mcp_access field predicates */
  mcpAccess?: InputMaybe<McpAccess>;
  mcpAccessIn?: InputMaybe<Array<McpAccess>>;
  mcpAccessNEQ?: InputMaybe<McpAccess>;
  mcpAccessNotIn?: InputMaybe<Array<McpAccess>>;
  not?: InputMaybe<TenantApplicationConfigurationWhereInput>;
  /** operations_contact_email_address field predicates */
  operationsContactEmailAddress?: InputMaybe<Scalars['String']['input']>;
  operationsContactEmailAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  operationsContactEmailAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** operations_contact_full_name field predicates */
  operationsContactFullName?: InputMaybe<Scalars['String']['input']>;
  operationsContactFullNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  operationsContactFullNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<TenantApplicationConfigurationWhereInput>>;
  /** presentation_approval_required_since field predicates */
  presentationApprovalRequiredSince?: InputMaybe<Scalars['Time']['input']>;
  presentationApprovalRequiredSinceGT?: InputMaybe<Scalars['Time']['input']>;
  presentationApprovalRequiredSinceGTE?: InputMaybe<Scalars['Time']['input']>;
  presentationApprovalRequiredSinceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  presentationApprovalRequiredSinceLT?: InputMaybe<Scalars['Time']['input']>;
  presentationApprovalRequiredSinceLTE?: InputMaybe<Scalars['Time']['input']>;
  presentationApprovalRequiredSinceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** presentation_attestation_required_since field predicates */
  presentationAttestationRequiredSince?: InputMaybe<Scalars['Time']['input']>;
  presentationAttestationRequiredSinceGT?: InputMaybe<Scalars['Time']['input']>;
  presentationAttestationRequiredSinceGTE?: InputMaybe<Scalars['Time']['input']>;
  presentationAttestationRequiredSinceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  presentationAttestationRequiredSinceLT?: InputMaybe<Scalars['Time']['input']>;
  presentationAttestationRequiredSinceLTE?: InputMaybe<Scalars['Time']['input']>;
  presentationAttestationRequiredSinceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** require_presentation_approval field predicates */
  requirePresentationApproval?: InputMaybe<PresentationApprovalRequirement>;
  requirePresentationApprovalIn?: InputMaybe<Array<PresentationApprovalRequirement>>;
  requirePresentationApprovalNEQ?: InputMaybe<PresentationApprovalRequirement>;
  requirePresentationApprovalNotIn?: InputMaybe<Array<PresentationApprovalRequirement>>;
  /** security_contact_email_address field predicates */
  securityContactEmailAddress?: InputMaybe<Scalars['String']['input']>;
  securityContactEmailAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  securityContactEmailAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** security_contact_full_name field predicates */
  securityContactFullName?: InputMaybe<Scalars['String']['input']>;
  securityContactFullNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  securityContactFullNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** smart_review_enabled field predicates */
  smartReviewEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** user_session_inactivity_timeout field predicates */
  userSessionInactivityTimeout?: InputMaybe<TenantApplicationConfigurationUserSessionInactivityTimeout>;
  userSessionInactivityTimeoutIn?: InputMaybe<Array<TenantApplicationConfigurationUserSessionInactivityTimeout>>;
  userSessionInactivityTimeoutNEQ?: InputMaybe<TenantApplicationConfigurationUserSessionInactivityTimeout>;
  userSessionInactivityTimeoutNotIn?: InputMaybe<Array<TenantApplicationConfigurationUserSessionInactivityTimeout>>;
};

export type TenantBranding = Branded & Node & {
  __typename?: 'TenantBranding';
  buttonsLinkColor: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  darkSquareLogoURL?: Maybe<Scalars['String']['output']>;
  darkWideLogoURL?: Maybe<Scalars['String']['output']>;
  dataVisualizationNegativeColor?: Maybe<Scalars['String']['output']>;
  dataVisualizationPrimaryColor: Scalars['String']['output'];
  dataVisualizationSecondaryColor: Scalars['String']['output'];
  dataVisualizationTertiaryColor?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logoURL: Scalars['String']['output'];
  /** Font face for presentation headers and cover/divider slides. */
  presentationHeaderFontFace: PresentationHeaderFontFace;
  primaryColor: Scalars['String']['output'];
  secondaryColor: Scalars['String']['output'];
  tenant: Tenant;
  updatedAt: Scalars['Time']['output'];
};

export type TenantBrandingLogoUpload = {
  __typename?: 'TenantBrandingLogoUpload';
  uploadMethod: Scalars['String']['output'];
  uploadURL: Scalars['String']['output'];
  uploadURLExpiresInSeconds: Scalars['Int']['output'];
};

export type TenantDisclaimerConfiguration = Node & {
  __typename?: 'TenantDisclaimerConfiguration';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /** If true, include the default Luminary company disclosures in the presentation */
  includeLuminaryDisclaimer: Scalars['Boolean']['output'];
  presentationCoverDisclaimerBody?: Maybe<Scalars['String']['output']>;
  presentationCoverDisclaimerTitle?: Maybe<Scalars['String']['output']>;
  presentationFooterDisclaimerBody?: Maybe<Scalars['String']['output']>;
  presentationFooterDisclaimerTitle?: Maybe<Scalars['String']['output']>;
  presentationStandaloneDisclaimerBody?: Maybe<Scalars['String']['output']>;
  presentationStandaloneDisclaimerTitle?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  updatedAt: Scalars['Time']['output'];
};

export type TenantDocument = Node & {
  __typename?: 'TenantDocument';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The source file for PDF uploads, or the generated PDF after conversion. */
  pdfFile?: Maybe<File>;
  sourceFile: File;
  status: TenantDocumentStatus;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type TenantDocumentConnection = {
  __typename?: 'TenantDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TenantDocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TenantDocumentEdge = {
  __typename?: 'TenantDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TenantDocument>;
};

/** Ordering options for TenantDocument connections */
export type TenantDocumentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TenantDocuments. */
  field: TenantDocumentOrderField;
};

/** Properties by which TenantDocument connections can be ordered. */
export enum TenantDocumentOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** TenantDocumentStatus is enum for the field status */
export enum TenantDocumentStatus {
  Archived = 'ARCHIVED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Ready = 'READY'
}

/**
 * TenantDocumentWhereInput is used for filtering TenantDocument objects.
 * Input was generated by ent.
 */
export type TenantDocumentWhereInput = {
  and?: InputMaybe<Array<TenantDocumentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<TenantDocumentWhereInput>;
  or?: InputMaybe<Array<TenantDocumentWhereInput>>;
  /** status field predicates */
  status?: InputMaybe<TenantDocumentStatus>;
  statusIn?: InputMaybe<Array<TenantDocumentStatus>>;
  statusNEQ?: InputMaybe<TenantDocumentStatus>;
  statusNotIn?: InputMaybe<Array<TenantDocumentStatus>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type TenantInformation = {
  __typename?: 'TenantInformation';
  addonAssetProviderIntegrationEnabled: Scalars['Boolean']['output'];
  assetIntegrationsEnabled: FeatureEnablementStatus;
  branding: TenantBranding;
  contractStartDate?: Maybe<Scalars['Time']['output']>;
  disclosuresConfiguration?: Maybe<TenantDisclaimerConfiguration>;
  /** Whether the caller can read an active published review in this tenant. */
  hasPublishedReviews: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isCustomerSSOEnabled: Scalars['Boolean']['output'];
  kind: TenantKind;
  luminaryOrganizationID?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  orgMembershipType?: Maybe<TenantOrgMembershipType>;
  otherTenantBranding?: Maybe<Array<Maybe<OtherTenant>>>;
  projectionFunctionalityEnabled: FeatureEnablementStatus;
  tenantSSOConnections: Array<TenantSsoConnection>;
  tier: TenantProductTier;
  trialEndDate?: Maybe<Scalars['Time']['output']>;
  usageBucket: TenantUsageBucket;
  workosOrganizationId?: Maybe<Scalars['String']['output']>;
};

/** Tenant-level knowledge graph health score. */
export type TenantKgHealthScore = {
  __typename?: 'TenantKGHealthScore';
  /** The total number of households included in the calculation. */
  householdCount: Scalars['Int']['output'];
  /** Per-household health score breakdown. */
  householdScores: Array<HouseholdKgHealthScore>;
  /** The overall health score for the tenant, computed as the average of all household scores. */
  score: Scalars['Float']['output'];
};

/** TenantKind is enum for the field kind */
export enum TenantKind {
  NonProduction = 'NON_PRODUCTION',
  Production = 'PRODUCTION'
}

/** TenantOrgMembershipType is enum for the field org_membership_type */
export enum TenantOrgMembershipType {
  Member = 'MEMBER',
  Parent = 'PARENT'
}

/** TenantProductTier is enum for the field product_tier */
export enum TenantProductTier {
  Enterprise = 'ENTERPRISE',
  Go = 'GO',
  Pro = 'PRO'
}

export type TenantReminderEmailsConfiguration = Node & {
  __typename?: 'TenantReminderEmailsConfiguration';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /** If true, do NOT send periodic reminder emails for tasks. */
  reminderEmailsDisabled: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type TenantSsoConnection = Node & {
  __typename?: 'TenantSSOConnection';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /** The time at which JIT was enabled for this tenant. If null, JIT is disabled. JIT means that users will be created on the fly when they sign in with SSO. */
  jitEnabledAt?: Maybe<Scalars['Time']['output']>;
  ssoConnection: SsoConnection;
  ssoConnectionID: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type TenantSsoConnectionConnection = {
  __typename?: 'TenantSSOConnectionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TenantSsoConnectionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TenantSsoConnectionEdge = {
  __typename?: 'TenantSSOConnectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TenantSsoConnection>;
};

/** Ordering options for TenantSSOConnection connections */
export type TenantSsoConnectionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TenantSSOConnections. */
  field: TenantSsoConnectionOrderField;
};

/** Properties by which TenantSSOConnection connections can be ordered. */
export enum TenantSsoConnectionOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * TenantSSOConnectionWhereInput is used for filtering TenantSSOConnection objects.
 * Input was generated by ent.
 */
export type TenantSsoConnectionWhereInput = {
  and?: InputMaybe<Array<TenantSsoConnectionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** jit_enabled_at field predicates */
  jitEnabledAt?: InputMaybe<Scalars['Time']['input']>;
  jitEnabledAtGT?: InputMaybe<Scalars['Time']['input']>;
  jitEnabledAtGTE?: InputMaybe<Scalars['Time']['input']>;
  jitEnabledAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  jitEnabledAtLT?: InputMaybe<Scalars['Time']['input']>;
  jitEnabledAtLTE?: InputMaybe<Scalars['Time']['input']>;
  jitEnabledAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<TenantSsoConnectionWhereInput>;
  or?: InputMaybe<Array<TenantSsoConnectionWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type TenantSecurityConfiguration = Node & {
  __typename?: 'TenantSecurityConfiguration';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /** If true, Luminary support access to this tenant is controlled by the customer rather than approved internally. Enterprise-only. */
  luminaryAccessControlEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The customer-configured Luminary support access policy. Only meaningful when luminary_access_control_enabled is true. */
  luminarySupportAccess: TenantSecurityConfigurationLuminarySupportAccess;
  /** The end date for Luminary support access. Only populated when luminary_support_access is TIME_BOUND. */
  luminarySupportAccessEndDate?: Maybe<Scalars['Time']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** TenantSecurityConfigurationLuminarySupportAccess is enum for the field luminary_support_access */
export enum TenantSecurityConfigurationLuminarySupportAccess {
  Indefinite = 'INDEFINITE',
  NoAccess = 'NO_ACCESS',
  TimeBound = 'TIME_BOUND'
}

/** Ordering options for TenantSecurityConfiguration connections */
export type TenantSecurityConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TenantSecurityConfigurations. */
  field: TenantSecurityConfigurationOrderField;
};

/** Properties by which TenantSecurityConfiguration connections can be ordered. */
export enum TenantSecurityConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * TenantSecurityConfigurationWhereInput is used for filtering TenantSecurityConfiguration objects.
 * Input was generated by ent.
 */
export type TenantSecurityConfigurationWhereInput = {
  and?: InputMaybe<Array<TenantSecurityConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** luminary_access_control_enabled field predicates */
  luminaryAccessControlEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  luminaryAccessControlEnabledIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  luminaryAccessControlEnabledNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** luminary_support_access field predicates */
  luminarySupportAccess?: InputMaybe<TenantSecurityConfigurationLuminarySupportAccess>;
  /** luminary_support_access_end_date field predicates */
  luminarySupportAccessEndDate?: InputMaybe<Scalars['Time']['input']>;
  luminarySupportAccessEndDateGT?: InputMaybe<Scalars['Time']['input']>;
  luminarySupportAccessEndDateGTE?: InputMaybe<Scalars['Time']['input']>;
  luminarySupportAccessEndDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  luminarySupportAccessEndDateLT?: InputMaybe<Scalars['Time']['input']>;
  luminarySupportAccessEndDateLTE?: InputMaybe<Scalars['Time']['input']>;
  luminarySupportAccessEndDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  luminarySupportAccessIn?: InputMaybe<Array<TenantSecurityConfigurationLuminarySupportAccess>>;
  luminarySupportAccessNEQ?: InputMaybe<TenantSecurityConfigurationLuminarySupportAccess>;
  luminarySupportAccessNotIn?: InputMaybe<Array<TenantSecurityConfigurationLuminarySupportAccess>>;
  not?: InputMaybe<TenantSecurityConfigurationWhereInput>;
  or?: InputMaybe<Array<TenantSecurityConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type TenantSlideConfig = Node & {
  __typename?: 'TenantSlideConfig';
  /** The type of slide configuration */
  configType: TenantSlideConfigConfigType;
  /** Custom slide content in JSON format with versioned block structure */
  contentJSON: Scalars['Map']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Display name for the slide (for admin UI organization and custom template titles) */
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** When true, this slide will not be available to use in presentations */
  isHidden: Scalars['Boolean']['output'];
  luminaryOrganization?: Maybe<LuminaryOrganization>;
  /** NULL means tenant-only; non-NULL shares the row with every member of the organization. */
  luminaryOrganizationID?: Maybe<Scalars['ID']['output']>;
  /** Identifier for the slide being configured. For education overrides, this is the education slide type (e.g., 'CLT_STRATEGY_EXPLAINER'). For custom templates, this is a user-defined identifier. For other overrides, this references the slide being overridden. */
  slideIdentifier: Scalars['String']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
};

/** TenantSlideConfigConfigType is enum for the field config_type */
export enum TenantSlideConfigConfigType {
  CustomSlideTemplate = 'CUSTOM_SLIDE_TEMPLATE',
  EducationSlideOverride = 'EDUCATION_SLIDE_OVERRIDE'
}

/** A connection to a list of items. */
export type TenantSlideConfigConnection = {
  __typename?: 'TenantSlideConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TenantSlideConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TenantSlideConfigEdge = {
  __typename?: 'TenantSlideConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TenantSlideConfig>;
};

/** Ordering options for TenantSlideConfig connections */
export type TenantSlideConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TenantSlideConfigs. */
  field: TenantSlideConfigOrderField;
};

/** Properties by which TenantSlideConfig connections can be ordered. */
export enum TenantSlideConfigOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * TenantSlideConfigWhereInput is used for filtering TenantSlideConfig objects.
 * Input was generated by ent.
 */
export type TenantSlideConfigWhereInput = {
  and?: InputMaybe<Array<TenantSlideConfigWhereInput>>;
  /** config_type field predicates */
  configType?: InputMaybe<TenantSlideConfigConfigType>;
  configTypeIn?: InputMaybe<Array<TenantSlideConfigConfigType>>;
  configTypeNEQ?: InputMaybe<TenantSlideConfigConfigType>;
  configTypeNotIn?: InputMaybe<Array<TenantSlideConfigConfigType>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** luminary_organization edge predicates */
  hasLuminaryOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasLuminaryOrganizationWith?: InputMaybe<Array<LuminaryOrganizationWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_hidden field predicates */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** luminary_organization_id field predicates */
  luminaryOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  luminaryOrganizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  luminaryOrganizationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  luminaryOrganizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  luminaryOrganizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  luminaryOrganizationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<TenantSlideConfigWhereInput>;
  or?: InputMaybe<Array<TenantSlideConfigWhereInput>>;
  /** slide_identifier field predicates */
  slideIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Basic tenant information for Luminary administration. */
export type TenantSummary = {
  __typename?: 'TenantSummary';
  id: Scalars['ID']['output'];
  luminaryOrganization?: Maybe<LuminaryOrganization>;
  name: Scalars['String']['output'];
  orgMembershipType?: Maybe<TenantOrgMembershipType>;
  subdomain: Scalars['String']['output'];
};

/** TenantUsageBucket is enum for the field usage_bucket */
export enum TenantUsageBucket {
  Churned = 'CHURNED',
  Internal = 'INTERNAL',
  InternalTest = 'INTERNAL_TEST',
  Paid = 'PAID',
  PendingDeletion = 'PENDING_DELETION',
  Unpaid = 'UNPAID',
  UnpaidTrial = 'UNPAID_TRIAL'
}

export type TermDetailsInfo = {
  __typename?: 'TermDetailsInfo';
  display: Scalars['String']['output'];
  displayType: InfoMessageDisplayType;
};

export type TestCmkEncryption = Node & {
  __typename?: 'TestCMKEncryption';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** encrypted int */
  encryptedInt: Scalars['Int']['output'];
  /** encrypted string */
  encryptedString: Scalars['String']['output'];
  /** encrypted time */
  encryptedTime: Scalars['Time']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  ignoreMe: Scalars['String']['output'];
  /** nillable encrypted string */
  nilEncryptedString?: Maybe<Scalars['String']['output']>;
  /** optional encrypted string */
  optionalEncryptedString?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** Ordering options for TestCMKEncryption connections */
export type TestCmkEncryptionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TestCMKEncryptions. */
  field: TestCmkEncryptionOrderField;
};

/** Properties by which TestCMKEncryption connections can be ordered. */
export enum TestCmkEncryptionOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * TestCMKEncryptionWhereInput is used for filtering TestCMKEncryption objects.
 * Input was generated by ent.
 */
export type TestCmkEncryptionWhereInput = {
  and?: InputMaybe<Array<TestCmkEncryptionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ignore_me field predicates */
  ignoreMe?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<TestCmkEncryptionWhereInput>;
  or?: InputMaybe<Array<TestCmkEncryptionWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type TestamentaryEntity = Node & {
  __typename?: 'TestamentaryEntity';
  /** The inheriting beneficiary who owns this inherited retirement account, not the deceased owner of the source account. For an Inherited IRA FBO recipient, this is the named FBO recipient. Only valid when kind = INHERITED_RETIREMENT_ACCOUNT. */
  accountOwner?: Maybe<ClientProfile>;
  additionalDocuments: DocumentConnection;
  asyncJobs: AsyncJobConnection;
  beneficiaries?: Maybe<Array<Beneficiary>>;
  /** This is only valid when the AC has 2 grantors */
  beneficiariesAfterBothGrantorDeaths?: Maybe<Array<Beneficiary>>;
  /** Dispositive provisions that benefit this testamentary entity. We need to be careful to filter out DPs bound to hypothetical waterfalls. */
  benefitsFrom?: Maybe<Array<DispositiveProvision>>;
  controllingParties?: Maybe<Array<ControllingParty>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  createdFromEntities: EntityConnection;
  /** Description for this testamentary entity */
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  dispositionScenarios?: Maybe<Array<DispositionScenario>>;
  /** @deprecated Use scenarios instead */
  dispositiveProvisions: DispositiveProvisionConnection;
  /**
   * The dispositive provision template associated with this scenario. When present, dispositive_provisions will be ignored.
   * @deprecated Use disposition scenarios instead
   */
  dispositiveProvisionsTemplate?: Maybe<DispositiveProvisionTemplate>;
  entityDocumentRelationships: EntityDocumentRelationshipConnection;
  /**
   * Testamentary entities are created when a grantor dies. This testamentary entity corresponds to this grantor's death specifically.
   * @deprecated We do not respect grantor death order for TEs anymore
   */
  grantorDeath?: Maybe<ClientProfile>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: Maybe<EntityGstStatus>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  hypotheticalDispositionScenarios: DispositionScenarioConnection;
  /** @deprecated Use scenarios instead */
  hypotheticalDispositiveProvisions: DispositiveProvisionConnection;
  /** @deprecated Use scenarios instead */
  hypotheticalDispositiveProvisionsTemplates: HypotheticalWaterfallDispositiveProvisionTemplateConnection;
  id: Scalars['ID']['output'];
  inEstateStatus?: Maybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: Maybe<Scalars['Decimal']['output']>;
  kgV2Nodes: Kgv2NodeConnection;
  /** Type of testamentary entity. */
  kind: TestamentaryEntityKind;
  /** The onboarding suggestion that this testamentary entity was created from */
  onboardingTestamentaryEntitySuggestion?: Maybe<Array<AiSuggestion>>;
  /** The existing testamentary_entity that potentially matches the suggestion based on the LLM's analysis of the existing testamentary_entity names (before the suggestion is accepted) */
  potentialTestamentaryEntitySuggestion?: Maybe<Array<AiSuggestion>>;
  /** The time at which the scenario was last reviewed. This can be used to indicate that a user has looked at these provisions and they are correct, even if they are empty. */
  reviewedAt?: Maybe<Scalars['Time']['output']>;
  successorTrustees?: Maybe<Array<Trustee>>;
  /** The knowledge graph root that associated with this TE; used for AI suggestions. */
  suggestionKgRoot?: Maybe<Array<KgRoot>>;
  survivingSpouseStateInEstateStatus?: Maybe<EntityInEstateStatus>;
  /** Normalized tax inclusion information for this testamentary entity */
  taxInfo?: Maybe<EntityTaxInfo>;
  taxStatus?: Maybe<NonTrustEntityTaxStatus>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  trustAdvisors?: Maybe<Array<TrustAdvisor>>;
  trustees?: Maybe<Array<Trustee>>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  /** Workflow trackers associated with this testamentary entity */
  workflowTrackers?: Maybe<Array<WorkflowTracker>>;
};


export type TestamentaryEntityAdditionalDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentOrder>>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type TestamentaryEntityAsyncJobsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AsyncJobOrder>>;
  where?: InputMaybe<AsyncJobWhereInput>;
};


export type TestamentaryEntityCreatedFromEntitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityOrder>>;
  where?: InputMaybe<EntityWhereInput>;
};


export type TestamentaryEntityDispositiveProvisionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositiveProvisionOrder>>;
  where?: InputMaybe<DispositiveProvisionWhereInput>;
};


export type TestamentaryEntityEntityDocumentRelationshipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityDocumentRelationshipOrder>>;
  where?: InputMaybe<EntityDocumentRelationshipWhereInput>;
};


export type TestamentaryEntityHypotheticalDispositionScenariosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositionScenarioOrder>>;
  where?: InputMaybe<DispositionScenarioWhereInput>;
};


export type TestamentaryEntityHypotheticalDispositiveProvisionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DispositiveProvisionOrder>>;
  where?: InputMaybe<DispositiveProvisionWhereInput>;
};


export type TestamentaryEntityHypotheticalDispositiveProvisionsTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HypotheticalWaterfallDispositiveProvisionTemplateOrder>>;
  where?: InputMaybe<HypotheticalWaterfallDispositiveProvisionTemplateWhereInput>;
};


export type TestamentaryEntityKgV2NodesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Kgv2NodeOrder>>;
  where?: InputMaybe<Kgv2NodeWhereInput>;
};

/** A connection to a list of items. */
export type TestamentaryEntityConnection = {
  __typename?: 'TestamentaryEntityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TestamentaryEntityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TestamentaryEntityEdge = {
  __typename?: 'TestamentaryEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TestamentaryEntity>;
};

/** TestamentaryEntityKind is enum for the field kind */
export enum TestamentaryEntityKind {
  CharitableEntity = 'CHARITABLE_ENTITY',
  CharitableTrust = 'CHARITABLE_TRUST',
  GrantorEstate = 'GRANTOR_ESTATE',
  InheritedRetirementAccount = 'INHERITED_RETIREMENT_ACCOUNT',
  TestamentaryTrust = 'TESTAMENTARY_TRUST'
}

/** Ordering options for TestamentaryEntity connections */
export type TestamentaryEntityOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TestamentaryEntities. */
  field: TestamentaryEntityOrderField;
};

/** Properties by which TestamentaryEntity connections can be ordered. */
export enum TestamentaryEntityOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * TestamentaryEntityWhereInput is used for filtering TestamentaryEntity objects.
 * Input was generated by ent.
 */
export type TestamentaryEntityWhereInput = {
  and?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** gst_status field predicates */
  gstStatus?: InputMaybe<EntityGstStatus>;
  gstStatusIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  gstStatusNEQ?: InputMaybe<EntityGstStatus>;
  gstStatusNotIn?: InputMaybe<Array<EntityGstStatus>>;
  gstStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** account_owner edge predicates */
  hasAccountOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccountOwnerWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** additional_documents edge predicates */
  hasAdditionalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasAdditionalDocumentsWith?: InputMaybe<Array<DocumentWhereInput>>;
  /** async_jobs edge predicates */
  hasAsyncJobs?: InputMaybe<Scalars['Boolean']['input']>;
  hasAsyncJobsWith?: InputMaybe<Array<AsyncJobWhereInput>>;
  /** beneficiaries edge predicates */
  hasBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  /** beneficiaries_after_both_grantor_deaths edge predicates */
  hasBeneficiariesAfterBothGrantorDeaths?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeneficiariesAfterBothGrantorDeathsWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  hasBeneficiariesWith?: InputMaybe<Array<BeneficiaryWhereInput>>;
  /** benefits_from edge predicates */
  hasBenefitsFrom?: InputMaybe<Scalars['Boolean']['input']>;
  hasBenefitsFromWith?: InputMaybe<Array<DispositiveProvisionWhereInput>>;
  /** controlling_parties edge predicates */
  hasControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  hasControllingPartiesWith?: InputMaybe<Array<ControllingPartyWhereInput>>;
  /** created_from_entities edge predicates */
  hasCreatedFromEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasCreatedFromEntitiesWith?: InputMaybe<Array<EntityWhereInput>>;
  /** disposition_scenarios edge predicates */
  hasDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** dispositive_provisions edge predicates */
  hasDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  /** dispositive_provisions_template edge predicates */
  hasDispositiveProvisionsTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  hasDispositiveProvisionsTemplateWith?: InputMaybe<Array<DispositiveProvisionTemplateWhereInput>>;
  hasDispositiveProvisionsWith?: InputMaybe<Array<DispositiveProvisionWhereInput>>;
  /** entity_document_relationships edge predicates */
  hasEntityDocumentRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityDocumentRelationshipsWith?: InputMaybe<Array<EntityDocumentRelationshipWhereInput>>;
  /** grantor_death edge predicates */
  hasGrantorDeath?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrantorDeathWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** hypothetical_disposition_scenarios edge predicates */
  hasHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositionScenariosWith?: InputMaybe<Array<DispositionScenarioWhereInput>>;
  /** hypothetical_dispositive_provisions edge predicates */
  hasHypotheticalDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  /** hypothetical_dispositive_provisions_templates edge predicates */
  hasHypotheticalDispositiveProvisionsTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  hasHypotheticalDispositiveProvisionsTemplatesWith?: InputMaybe<Array<HypotheticalWaterfallDispositiveProvisionTemplateWhereInput>>;
  hasHypotheticalDispositiveProvisionsWith?: InputMaybe<Array<DispositiveProvisionWhereInput>>;
  /** kg_v2_nodes edge predicates */
  hasKgV2Nodes?: InputMaybe<Scalars['Boolean']['input']>;
  hasKgV2NodesWith?: InputMaybe<Array<Kgv2NodeWhereInput>>;
  /** onboarding_testamentary_entity_suggestion edge predicates */
  hasOnboardingTestamentaryEntitySuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasOnboardingTestamentaryEntitySuggestionWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** potential_testamentary_entity_suggestion edge predicates */
  hasPotentialTestamentaryEntitySuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  hasPotentialTestamentaryEntitySuggestionWith?: InputMaybe<Array<AiSuggestionWhereInput>>;
  /** successor_trustees edge predicates */
  hasSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuccessorTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** suggestion_kg_root edge predicates */
  hasSuggestionKgRoot?: InputMaybe<Scalars['Boolean']['input']>;
  hasSuggestionKgRootWith?: InputMaybe<Array<KgRootWhereInput>>;
  /** tax_info edge predicates */
  hasTaxInfo?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaxInfoWith?: InputMaybe<Array<EntityTaxInfoWhereInput>>;
  /** trust_advisors edge predicates */
  hasTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrustAdvisorsWith?: InputMaybe<Array<TrustAdvisorWhereInput>>;
  /** trustees edge predicates */
  hasTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrusteesWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** workflow_trackers edge predicates */
  hasWorkflowTrackers?: InputMaybe<Scalars['Boolean']['input']>;
  hasWorkflowTrackersWith?: InputMaybe<Array<WorkflowTrackerWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in_estate_status field predicates */
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  inEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  inEstateStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** inclusion_ratio field predicates */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioGTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  inclusionRatioLT?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioLTE?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNEQ?: InputMaybe<Scalars['Decimal']['input']>;
  inclusionRatioNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** kind field predicates */
  kind?: InputMaybe<TestamentaryEntityKind>;
  kindIn?: InputMaybe<Array<TestamentaryEntityKind>>;
  kindNEQ?: InputMaybe<TestamentaryEntityKind>;
  kindNotIn?: InputMaybe<Array<TestamentaryEntityKind>>;
  not?: InputMaybe<TestamentaryEntityWhereInput>;
  or?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** reviewed_at field predicates */
  reviewedAt?: InputMaybe<Scalars['Time']['input']>;
  reviewedAtGT?: InputMaybe<Scalars['Time']['input']>;
  reviewedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  reviewedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  reviewedAtLT?: InputMaybe<Scalars['Time']['input']>;
  reviewedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  reviewedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** surviving_spouse_state_in_estate_status field predicates */
  survivingSpouseStateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  survivingSpouseStateInEstateStatusIn?: InputMaybe<Array<EntityInEstateStatus>>;
  survivingSpouseStateInEstateStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  survivingSpouseStateInEstateStatusNEQ?: InputMaybe<EntityInEstateStatus>;
  survivingSpouseStateInEstateStatusNotIn?: InputMaybe<Array<EntityInEstateStatus>>;
  survivingSpouseStateInEstateStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tax_status field predicates */
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  taxStatusNEQ?: InputMaybe<NonTrustEntityTaxStatus>;
  taxStatusNotIn?: InputMaybe<Array<NonTrustEntityTaxStatus>>;
  taxStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** TileNotesInput is the input for generating notes for a single tile in the waterfall diagram. */
export type TileNotesInput = {
  /** deathSection indicates which death section this tile belongs to. */
  deathSection: AfterDeath;
  /**
   * entityID is the ID of the entity associated with this tile, if any.
   * Deprecated: Use entityIDs instead for both single entities and groups.
   * @deprecated Use entityIDs instead
   */
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * entityIDs is a list of entity IDs associated with this tile.
   * Use this for both single entities and grouped tiles.
   */
  entityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * groupDescription is a description for a grouped tile.
   * Optional: used when the tile represents a group of entities that may not be persisted.
   */
  groupDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * groupDisplayName is the display name for a grouped tile.
   * Optional: used when the tile represents a group of entities that may not be persisted.
   */
  groupDisplayName?: InputMaybe<Scalars['String']['input']>;
  /**
   * testamentaryEntityID is the ID of the testamentary entity associated with this tile, if any.
   * Deprecated: Use testamentaryEntityIDs instead for both single entities and groups.
   * @deprecated Use testamentaryEntityIDs instead
   */
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * testamentaryEntityIDs is a list of testamentary entity IDs associated with this tile.
   * Use this for both single testamentary entities and grouped tiles.
   */
  testamentaryEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** tileID is the unique identifier for the tile. */
  tileID: Scalars['ID']['input'];
};

/** TileNotesResult is the result of generating notes for a single tile. */
export type TileNotesResult = {
  __typename?: 'TileNotesResult';
  /** error contains any error message if the note generation failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** isComplete indicates whether the note generation for this tile is complete. */
  isComplete: Scalars['Boolean']['output'];
  /** notes is the generated notes content for the tile. */
  notes?: Maybe<Scalars['String']['output']>;
  /** tileID is the unique identifier for the tile. */
  tileID: Scalars['ID']['output'];
};

/** TransferMethod is enum for the field transfer_method */
export enum TransferMethod {
  InKind = 'IN_KIND',
  LiquidateToCash = 'LIQUIDATE_TO_CASH'
}

export type TriggerEstateInsightsForHouseholdInput = {
  documentTypes: Array<DocumentType>;
  triggerClientProfileInsights: Scalars['Boolean']['input'];
  triggerDocumentInsights: Scalars['Boolean']['input'];
  triggerHouseholdInsights: Scalars['Boolean']['input'];
};

/**
 * Trust is a common interface for all
 * the trusts. It enforces some common
 * properties across all trusts.
 */
export type Trust = {
  assetSummaryDisplay?: Maybe<Scalars['String']['output']>;
  currentDiscountedValue: Scalars['CurrencyUSD']['output'];
  currentValue: Scalars['CurrencyUSD']['output'];
  description?: Maybe<Scalars['String']['output']>;
  designerAccount?: Maybe<Account>;
  displayName: Scalars['String']['output'];
  effectiveDate?: Maybe<Scalars['Time']['output']>;
  effectiveDiscountPercent: Scalars['Percent']['output'];
  id: Scalars['ID']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  mostRecentValuation?: Maybe<AssetValuationV2>;
  successorTrustees?: Maybe<Array<Trustee>>;
  trustAdvisors?: Maybe<Array<TrustAdvisor>>;
  trustJurisdictionStateCode?: Maybe<Scalars['String']['output']>;
  trustees?: Maybe<Array<Trustee>>;
};

export type TrustAdvisor = Node & {
  __typename?: 'TrustAdvisor';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** An edge to the trust advisor, which is an individual */
  individual?: Maybe<ClientProfile>;
  /** The level of this trust advisor. */
  level: TrustAdvisorLevel;
  /** A Note about this trust advisor. Only relevant if the level is "OTHER". */
  note?: Maybe<Scalars['String']['output']>;
  /** An edge to the trustee, which is an organization */
  organization?: Maybe<ClientOrganization>;
  /** Roles of this trust advisor. */
  roles?: Maybe<Array<TrustAdvisorRole>>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** TrustAdvisorLevel is enum for the field level */
export enum TrustAdvisorLevel {
  Other = 'OTHER',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

/** Ordering options for TrustAdvisor connections */
export type TrustAdvisorOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TrustAdvisors. */
  field: TrustAdvisorOrderField;
};

/** Properties by which TrustAdvisor connections can be ordered. */
export enum TrustAdvisorOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type TrustAdvisorRole = Node & {
  __typename?: 'TrustAdvisorRole';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The role of this trust advisor. */
  kind: TrustAdvisorRoleKind;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** Trust advisor that this role belongs to. */
  trustAdvisor: TrustAdvisor;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** TrustAdvisorRoleKind is enum for the field kind */
export enum TrustAdvisorRoleKind {
  DistributionAdvisor = 'DISTRIBUTION_ADVISOR',
  InvestmentAdvisor = 'INVESTMENT_ADVISOR',
  Other = 'OTHER',
  TrustProtector = 'TRUST_PROTECTOR'
}

/** Ordering options for TrustAdvisorRole connections */
export type TrustAdvisorRoleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TrustAdvisorRoles. */
  field: TrustAdvisorRoleOrderField;
};

/** Properties by which TrustAdvisorRole connections can be ordered. */
export enum TrustAdvisorRoleOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * TrustAdvisorRoleWhereInput is used for filtering TrustAdvisorRole objects.
 * Input was generated by ent.
 */
export type TrustAdvisorRoleWhereInput = {
  and?: InputMaybe<Array<TrustAdvisorRoleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** trust_advisor edge predicates */
  hasTrustAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrustAdvisorWith?: InputMaybe<Array<TrustAdvisorWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<TrustAdvisorRoleKind>;
  kindIn?: InputMaybe<Array<TrustAdvisorRoleKind>>;
  kindNEQ?: InputMaybe<TrustAdvisorRoleKind>;
  kindNotIn?: InputMaybe<Array<TrustAdvisorRoleKind>>;
  not?: InputMaybe<TrustAdvisorRoleWhereInput>;
  or?: InputMaybe<Array<TrustAdvisorRoleWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * TrustAdvisorWhereInput is used for filtering TrustAdvisor objects.
 * Input was generated by ent.
 */
export type TrustAdvisorWhereInput = {
  and?: InputMaybe<Array<TrustAdvisorWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** individual edge predicates */
  hasIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** roles edge predicates */
  hasRoles?: InputMaybe<Scalars['Boolean']['input']>;
  hasRolesWith?: InputMaybe<Array<TrustAdvisorRoleWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** level field predicates */
  level?: InputMaybe<TrustAdvisorLevel>;
  levelIn?: InputMaybe<Array<TrustAdvisorLevel>>;
  levelNEQ?: InputMaybe<TrustAdvisorLevel>;
  levelNotIn?: InputMaybe<Array<TrustAdvisorLevel>>;
  not?: InputMaybe<TrustAdvisorWhereInput>;
  /** note field predicates */
  note?: InputMaybe<Scalars['String']['input']>;
  noteIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  noteNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<TrustAdvisorWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type TrustIncomeAccessParameterView = {
  __typename?: 'TrustIncomeAccessParameterView';
  accessAgeParameters: Array<AccessAgeParameterView>;
  amount?: Maybe<Scalars['CurrencyUSD']['output']>;
  frequency?: Maybe<AccessParameterFrequency>;
  /** kind is the kind of access, always TRUST_INCOME */
  kind: AccessParameterKind;
  percentage?: Maybe<Scalars['Percent']['output']>;
};

export type TrustPerformanceReport = {
  __typename?: 'TrustPerformanceReport';
  distributions: Scalars['CurrencyUSD']['output'];
  impliedEstateTaxSavings: Scalars['CurrencyUSD']['output'];
  outOfEstateGrowth: Scalars['CurrencyUSD']['output'];
  taxableGifts: Scalars['CurrencyUSD']['output'];
  transfers: Scalars['CurrencyUSD']['output'];
  wealthTransferred: Scalars['CurrencyUSD']['output'];
};

/** TrustTaxStatus is enum for the field tax_status */
export enum TrustTaxStatus {
  GrantorTrust = 'GRANTOR_TRUST',
  NonGrantorTrust = 'NON_GRANTOR_TRUST',
  NonTaxableTrust = 'NON_TAXABLE_TRUST'
}

export type Trustee = Node & {
  __typename?: 'Trustee';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Duties of this trustee */
  duties?: Maybe<Array<TrusteeDuty>>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** An edge to the trustee, which is an individual */
  individual?: Maybe<ClientProfile>;
  level?: Maybe<TrusteeLevel>;
  /** Free-form notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** An edge to the trustee, which is an organization */
  organization?: Maybe<ClientOrganization>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  trusteeCategory: TrusteeTrusteeCategory;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

export type TrusteeDuty = Node & {
  __typename?: 'TrusteeDuty';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The kind of duty for this trustee */
  kind: TrusteeDutyKind;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** Trustee that this duty belongs to */
  trustee: Trustee;
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** TrusteeDutyKind is enum for the field kind */
export enum TrusteeDutyKind {
  Administration = 'ADMINISTRATION',
  Distribution = 'DISTRIBUTION',
  Investment = 'INVESTMENT',
  Special = 'SPECIAL'
}

/** Ordering options for TrusteeDuty connections */
export type TrusteeDutyOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TrusteeDuties. */
  field: TrusteeDutyOrderField;
};

/** Properties by which TrusteeDuty connections can be ordered. */
export enum TrusteeDutyOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * TrusteeDutyWhereInput is used for filtering TrusteeDuty objects.
 * Input was generated by ent.
 */
export type TrusteeDutyWhereInput = {
  and?: InputMaybe<Array<TrusteeDutyWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** trustee edge predicates */
  hasTrustee?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrusteeWith?: InputMaybe<Array<TrusteeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<TrusteeDutyKind>;
  kindIn?: InputMaybe<Array<TrusteeDutyKind>>;
  kindNEQ?: InputMaybe<TrusteeDutyKind>;
  kindNotIn?: InputMaybe<Array<TrusteeDutyKind>>;
  not?: InputMaybe<TrusteeDutyWhereInput>;
  or?: InputMaybe<Array<TrusteeDutyWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** TrusteeLevel is enum for the field level */
export enum TrusteeLevel {
  Other = 'OTHER',
  Primary = 'PRIMARY',
  Quaternary = 'QUATERNARY',
  Quinary = 'QUINARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

/** Ordering options for Trustee connections */
export type TrusteeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Trustees. */
  field: TrusteeOrderField;
};

/** Properties by which Trustee connections can be ordered. */
export enum TrusteeOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** TrusteeTrusteeCategory is enum for the field trustee_category */
export enum TrusteeTrusteeCategory {
  Primary = 'PRIMARY',
  Successor = 'SUCCESSOR'
}

/**
 * TrusteeWhereInput is used for filtering Trustee objects.
 * Input was generated by ent.
 */
export type TrusteeWhereInput = {
  and?: InputMaybe<Array<TrusteeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** duties edge predicates */
  hasDuties?: InputMaybe<Scalars['Boolean']['input']>;
  hasDutiesWith?: InputMaybe<Array<TrusteeDutyWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** individual edge predicates */
  hasIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndividualWith?: InputMaybe<Array<ClientProfileWhereInput>>;
  /** organization edge predicates */
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganizationWith?: InputMaybe<Array<ClientOrganizationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** level field predicates */
  level?: InputMaybe<TrusteeLevel>;
  levelIn?: InputMaybe<Array<TrusteeLevel>>;
  levelIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  levelNEQ?: InputMaybe<TrusteeLevel>;
  levelNotIn?: InputMaybe<Array<TrusteeLevel>>;
  levelNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<TrusteeWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<TrusteeWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** trustee_category field predicates */
  trusteeCategory?: InputMaybe<TrusteeTrusteeCategory>;
  trusteeCategoryIn?: InputMaybe<Array<TrusteeTrusteeCategory>>;
  trusteeCategoryNEQ?: InputMaybe<TrusteeTrusteeCategory>;
  trusteeCategoryNotIn?: InputMaybe<Array<TrusteeTrusteeCategory>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Input for unlinking a KG V2 node from a data model record. */
export type UnlinkKgv2NodeFromDataModelInput = {
  /** The household that owns both the node and the data model record. */
  householdID: Scalars['ID']['input'];
  /** The KG V2 node ID to unlink. */
  nodeID: Scalars['ID']['input'];
  /** The data model record to unlink from. Exactly one field must be set. */
  target: DataModelTargetInput;
};

/**
 * UpdateAISuggestionInput is used for update AISuggestion object.
 * Input was generated by ent.
 */
export type UpdateAiSuggestionInput = {
  /** Whether the suggestion was accepted or rejected */
  acceptanceStatus?: InputMaybe<AiSuggestionAcceptanceStatus>;
  addDpRecipientKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEvidenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKgV2StatementIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOwnedOnboardedEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addReferencedBySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSourceKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuggestionKgRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAcceptanceStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearClientOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  clearClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositiveProvision?: InputMaybe<Scalars['Boolean']['input']>;
  clearDpRecipientKgV2nodes?: InputMaybe<Scalars['Boolean']['input']>;
  clearDpTargetKind?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  clearHasMatched?: InputMaybe<Scalars['Boolean']['input']>;
  clearKgV2statements?: InputMaybe<Scalars['Boolean']['input']>;
  clearOnboardedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearOnboardedIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  clearOnboardedOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  clearOnboardedTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearOnboardingEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearOnboardingIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  clearOnboardingOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  clearOnboardingTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnedOnboardedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearPotentialClientOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  clearPotentialClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  clearPotentialEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearPotentialTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearReferenceAiOnboardingSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  clearReferencedBySuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceKgV2nodes?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuggestionKgRoots?: InputMaybe<Scalars['Boolean']['input']>;
  clearTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearVersion?: InputMaybe<Scalars['Boolean']['input']>;
  clientOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  clientProfileID?: InputMaybe<Scalars['ID']['input']>;
  dispositiveProvisionID?: InputMaybe<Scalars['ID']['input']>;
  /** The kind of the target for DP V2 suggestions. This should only be set if the kind is DP_RECIPIENT_V2. */
  dpTargetKind?: InputMaybe<AiSuggestionDpTargetKind>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** Only relevant if the suggestion is for a grantor/trustee/trustAdvisor/beneficiary. This indicates if the user has gone through the process to attempt to match the suggestion with a client profile/organization row. */
  hasMatched?: InputMaybe<Scalars['Boolean']['input']>;
  onboardedEntityID?: InputMaybe<Scalars['ID']['input']>;
  onboardedIndividualID?: InputMaybe<Scalars['ID']['input']>;
  onboardedOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  onboardedTestamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
  /** The suggested entity to onboard. This should only be set if the kind is ONBOARDING_ENTITY */
  onboardingEntity?: InputMaybe<OnboardingEntitySuggestionInput>;
  /** The suggested person to onboard. This should only be set if the kind is ONBOARDING_INDIVIDUAL */
  onboardingIndividual?: InputMaybe<OnboardingIndividualSuggestionInput>;
  /** The suggested organization to onboard. This should only be set if the kind is ONBOARDING_ORGANIZATION */
  onboardingOrganization?: InputMaybe<OnboardingOrganizationSuggestionInput>;
  /** The suggested testamentary entity to onboard. This should only be set if the kind is ONBOARDING_TESTAMENTARY_ENTITY */
  onboardingTestamentaryEntity?: InputMaybe<OnboardingTestamentaryEntitySuggestionInput>;
  potentialClientOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  potentialClientProfileID?: InputMaybe<Scalars['ID']['input']>;
  potentialEntityID?: InputMaybe<Scalars['ID']['input']>;
  potentialTestamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
  referenceAiOnboardingSuggestionID?: InputMaybe<Scalars['ID']['input']>;
  removeDpRecipientKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEvidenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKgV2StatementIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOwnedOnboardedEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeReferencedBySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSourceKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuggestionKgRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
  /** The version of the suggestion pipeline that produced this record. 1 = v1 (document inference), 2 = v2 (KG V2). */
  version?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateAccessAgeParameterInput is used for update AccessAgeParameter object.
 * Input was generated by ent.
 */
export type UpdateAccessAgeParameterInput = {
  accessParameterID?: InputMaybe<Scalars['ID']['input']>;
  /** The end of the age requirement for this distribution */
  ageRequirementEnd?: InputMaybe<Scalars['Int']['input']>;
  /** The start of the age requirement for this distribution */
  ageRequirementStart?: InputMaybe<Scalars['Int']['input']>;
  clearAccessParameter?: InputMaybe<Scalars['Boolean']['input']>;
  clearAgeRequirementEnd?: InputMaybe<Scalars['Boolean']['input']>;
  clearAgeRequirementStart?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateAccessParameterInput is used for update AccessParameter object.
 * Input was generated by ent.
 */
export type UpdateAccessParameterInput = {
  addAccessAgeParameterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The amount of access, as a dollar value. Valid when kind is AMOUNT or TRUST_INCOME */
  amount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  beneficiaryID?: InputMaybe<Scalars['ID']['input']>;
  clearAccessAgeParameters?: InputMaybe<Scalars['Boolean']['input']>;
  clearAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  clearFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  clearPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  /** The frequency of the access */
  frequency?: InputMaybe<AccessParameterFrequency>;
  /** If true, access will grow by the inflation rate specified in the growth profile.Only applicable if the access is kind AMOUNT or TRUST_INCOME. */
  growByInflation?: InputMaybe<Scalars['Boolean']['input']>;
  /** The kind of access parameter */
  kind?: InputMaybe<AccessParameterKind>;
  /** The percentage of access. Valid when kind is PERCENTAGE or TRUST_INCOME */
  percentage?: InputMaybe<Scalars['Percent']['input']>;
  removeAccessAgeParameterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateAccountInput is used for update Account object.
 * Input was generated by ent.
 */
export type UpdateAccountInput = {
  addValuationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearInitialValuation?: InputMaybe<Scalars['Boolean']['input']>;
  clearValuations?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  initialValuationID?: InputMaybe<Scalars['ID']['input']>;
  removeValuationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateActiveEstateInsightsPageInput is used for update ActiveEstateInsightsPage object.
 * Input was generated by ent.
 */
export type UpdateActiveEstateInsightsPageInput = {
  clearPresentationPage?: InputMaybe<Scalars['Boolean']['input']>;
  presentationPageID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateAddressInput is used for update Address object.
 * Input was generated by ent.
 */
export type UpdateAddressInput = {
  addClientProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  clearCityName?: InputMaybe<Scalars['Boolean']['input']>;
  clearClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  clearPostalCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearStreetLineOne?: InputMaybe<Scalars['Boolean']['input']>;
  clearStreetLineTwo?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  removeClientProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether the individual at this address resides outside the United States. */
  residesOutsideUnitedStates?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  streetLineOne?: InputMaybe<Scalars['String']['input']>;
  streetLineTwo?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateAssetClassInput is used for update AssetClass object.
 * Input was generated by ent.
 */
export type UpdateAssetClassInput = {
  addIntegrationAssetClassIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  balanceSheetCategoryID?: InputMaybe<Scalars['ID']['input']>;
  clearBalanceSheetCategory?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrowthRate?: InputMaybe<Scalars['Boolean']['input']>;
  clearIntegrationAssetClasses?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The defined growth rate for the asset class */
  growthRate?: InputMaybe<Scalars['Percent']['input']>;
  /** Whether this class is considered real or tangible personal property */
  isRealTpp?: InputMaybe<Scalars['Boolean']['input']>;
  liquidityStatus?: InputMaybe<AssetClassLiquidityStatus>;
  removeIntegrationAssetClassIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The order in which this asset class should be displayed in the UI */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The share of annual return paid as income tax when a growth profile uses asset-category defaults */
  taxDragRate?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * UpdateAssetGroupInput is used for update AssetGroup object.
 * Input was generated by ent.
 */
export type UpdateAssetGroupInput = {
  addAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addChildIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAssets?: InputMaybe<Scalars['Boolean']['input']>;
  clearChildren?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  clearParent?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentID?: InputMaybe<Scalars['ID']['input']>;
  removeAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeChildIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateAssetStaticInput is used for update AssetStatic object.
 * Input was generated by ent.
 */
export type UpdateAssetStaticInput = {
  addAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAssets?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  clearGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxSitusGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxSitusKind?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxSitusStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  taxSitusGrantorID?: InputMaybe<Scalars['ID']['input']>;
  taxSitusKind?: InputMaybe<AssetTaxSitusKind>;
  taxSitusStateCode?: InputMaybe<StateCode>;
};

/**
 * UpdateAssetV2Input is used for update AssetV2 object.
 * Input was generated by ent.
 */
export type UpdateAssetV2Input = {
  /** The name of the account that this asset is part of. */
  accountName?: InputMaybe<Scalars['String']['input']>;
  addKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  classID?: InputMaybe<Scalars['ID']['input']>;
  clearAccountName?: InputMaybe<Scalars['Boolean']['input']>;
  clearIntegratedAccountID?: InputMaybe<Scalars['Boolean']['input']>;
  clearIntegrationType?: InputMaybe<Scalars['Boolean']['input']>;
  clearKgV2nodes?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnedValue?: InputMaybe<Scalars['Boolean']['input']>;
  clearValuation?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The entity ID of the integrated account that this asset is part of. */
  integratedAccountID?: InputMaybe<Scalars['Int']['input']>;
  /** The integration this asset was ingested as part of. */
  integrationType?: InputMaybe<AssetV2IntegrationType>;
  ownedValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  qsbsEligibility?: InputMaybe<AssetV2QsbsEligibility>;
  removeKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  valuationID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateAssetValuationV2Input is used for update AssetValuationV2 object.
 * Input was generated by ent.
 */
export type UpdateAssetValuationV2Input = {
  addAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAssets?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearFixedValuationAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearValuationReason?: InputMaybe<Scalars['Boolean']['input']>;
  /** Free-form notes */
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Valuations can work in two ways.
   * The first is manually specifying all the assets+values for a valuation; we tally them up.
   * The second is by specifying a valuation_amount.
   * If a valuation amount is present, we use this to compute the value of a valuation
   * and ignore the value of underlying assets, etc.
   */
  fixedValuationAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  removeAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  valuationReason?: InputMaybe<AssetValuationV2ValuationReason>;
  valuationSource?: InputMaybe<AssetValuationV2ValuationSource>;
};

/**
 * UpdateAssetValueV2Input is used for update AssetValueV2 object.
 * Input was generated by ent.
 */
export type UpdateAssetValueV2Input = {
  assetID?: InputMaybe<Scalars['ID']['input']>;
  clearAsset?: InputMaybe<Scalars['Boolean']['input']>;
  clearCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnedPercent?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnedValue?: InputMaybe<Scalars['Boolean']['input']>;
  clearShareCount?: InputMaybe<Scalars['Boolean']['input']>;
  clearShareValue?: InputMaybe<Scalars['Boolean']['input']>;
  clearTotalValue?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  ownedPercent?: InputMaybe<Scalars['Percent']['input']>;
  ownedValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  ownershipType?: InputMaybe<AssetValueV2OwnershipType>;
  shareCount?: InputMaybe<Scalars['Decimal']['input']>;
  shareValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  totalValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
};

/**
 * UpdateBalanceSheetBundleConfigurationInput is used for update BalanceSheetBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateBalanceSheetBundleConfigurationInput = {
  appendColumnOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  appendHiddenColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  /** The order that columns should show up */
  columnOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The display name for the bundle. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Column IDs that should be hidden from the balance sheet display */
  hiddenColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether to hide small values on the balance sheet */
  hideSmallValues?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, life insurance death benefit drives balance sheet totals and summary metrics; when false, cash value does */
  includeDeathBenefitInTotals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include a separate expanded asset categories slide in the bundle */
  includeExpandedAssetCategoriesSlide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include a full export slide that is not confined to standard page dimensions */
  includeExportSlide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to separate directly held assets in the estate into client 1/client 2/joint */
  separateInEstateDirectlyHeld?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show separate columns for trusts that are in the estate */
  separateInEstateTrusts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show separate columns for trusts that are out of the estate */
  separateOutOfEstateTrusts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show expanded asset categories on the balance sheet */
  showExpandedAssetCategories?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show assets in the estate */
  showInEstate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show assets out of the estate */
  showOutOfEstate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to display summary metrics at the top of the balance sheet */
  showSummaryMetrics?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateBalanceSheetCategoryInput is used for update BalanceSheetCategory object.
 * Input was generated by ent.
 */
export type UpdateBalanceSheetCategoryInput = {
  addAssetClassIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAssetClasses?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  removeAssetClassIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The order in which this balance sheet category should be displayed in the UI */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateBalanceSheetViewConfigurationInput is used for update BalanceSheetViewConfiguration object.
 * Input was generated by ent.
 */
export type UpdateBalanceSheetViewConfigurationInput = {
  appendColumnOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  appendHiddenColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The order that columns should show up */
  columnOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Column IDs that should be hidden from the balance sheet display */
  hiddenColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether to hide small values on the balance sheet */
  hideSmallValues?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, life insurance death benefit drives balance sheet totals and summary metrics; when false, cash value does */
  includeDeathBenefitInTotals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to separate directly held assets in the estate into client 1/client 2/joint */
  separateInEstateDirectlyHeld?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show separate columns for trusts that are in the estate */
  separateInEstateTrusts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show separate columns for trusts that are out of the estate */
  separateOutOfEstateTrusts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show expanded asset categories on the balance sheet */
  showExpandedAssetCategories?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show assets in the estate */
  showInEstate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show assets out of the estate */
  showOutOfEstate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to display summary metrics at the top of the balance sheet */
  showSummaryMetrics?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateBeneficiariesBundleConfigurationInput is used for update BeneficiariesBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateBeneficiariesBundleConfigurationInput = {
  addHouseholdOverviewOrganizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHouseholdOverviewProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addIndividualOverviewOrganizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addIndividualOverviewProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Used in beneficiary reporting to calculate non-quantifiable accessto a single entity across multiple beneficiaries. */
  beneficiaryAccessCalcMethod?: InputMaybe<BeneficiariesBundleConfigurationBeneficiaryAccessCalcMethod>;
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  clearEstateWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  clearFirstDeathYear?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrowthProfile?: InputMaybe<Scalars['Boolean']['input']>;
  clearHouseholdOverviewOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  clearHouseholdOverviewProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearIndividualOverviewOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  clearIndividualOverviewProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearSecondDeathYear?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name for the bundle. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  estateWaterfallID?: InputMaybe<Scalars['ID']['input']>;
  /** The year of the first death in the beneficiaries bundle. */
  firstDeathYear?: InputMaybe<Scalars['Int']['input']>;
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  /** If true, include the detailed breakdown in each individual report alongside the chart in individual_overview_profiles and individual_overview_organizations */
  includeDetailedBreakdownsInIndividualOverviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, include a household-level slide that compares the beneficiaries in household_overview_profiles and household_overview_organizations */
  includeHouseholdOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, include a chart for each profile and organization in individual_overview_profiles and individual_overview_organizations */
  includeIndividualOverviews?: InputMaybe<Scalars['Boolean']['input']>;
  removeHouseholdOverviewOrganizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHouseholdOverviewProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeIndividualOverviewOrganizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeIndividualOverviewProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The year of the second death in the beneficiaries bundle. */
  secondDeathYear?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateBeneficiariesTemplateBundleConfigurationInput is used for update BeneficiariesTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateBeneficiariesTemplateBundleConfigurationInput = {
  /** If true, includes the household overview slide in the beneficiaries bundle. */
  includeHouseholdOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the individual overview slides in the beneficiaries bundle. */
  includeIndividualOverviews?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateBeneficiaryAccessParameterInput is used for update BeneficiaryAccessParameter object.
 * Input was generated by ent.
 */
export type UpdateBeneficiaryAccessParameterInput = {
  /** Notes for when age is an access parameter */
  accessParameterAgeNote?: InputMaybe<Scalars['String']['input']>;
  /** Notes for when other is an access parameter */
  accessParameterOtherNote?: InputMaybe<Scalars['String']['input']>;
  clearAccessParameterAgeNote?: InputMaybe<Scalars['Boolean']['input']>;
  clearAccessParameterOtherNote?: InputMaybe<Scalars['Boolean']['input']>;
  /** The kind of distribution parameter */
  kind?: InputMaybe<BeneficiaryAccessParameterKind>;
};

/**
 * UpdateBeneficiaryDesignationGroupInput is used for update BeneficiaryDesignationGroup object.
 * Input was generated by ent.
 */
export type UpdateBeneficiaryDesignationGroupInput = {
  addDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  associatedHypotheticalWaterfallID?: InputMaybe<Scalars['ID']['input']>;
  clearAssociatedHypotheticalWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalInsurancePersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalRetirementPersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearInsurancePersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearRetirementPersonalAccount?: InputMaybe<Scalars['Boolean']['input']>;
  hypotheticalInsurancePersonalAccountID?: InputMaybe<Scalars['ID']['input']>;
  hypotheticalRetirementPersonalAccountID?: InputMaybe<Scalars['ID']['input']>;
  insurancePersonalAccountID?: InputMaybe<Scalars['ID']['input']>;
  removeDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** if true, the residuary recipient(s) for this group's tier pays taxes by default. if false, each recipient's bearsTax field can be configured separately */
  residuaryPaysAllTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  retirementPersonalAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Whether this group represents primary or contingent beneficiaries on the account. */
  tier?: InputMaybe<BeneficiaryDesignationTier>;
};

/**
 * UpdateBeneficiaryDistributionInput is used for update BeneficiaryDistribution object.
 * Input was generated by ent.
 */
export type UpdateBeneficiaryDistributionInput = {
  addDistributionParameterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryID?: InputMaybe<Scalars['ID']['input']>;
  clearBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  clearDistributionAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDistributionFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  clearDistributionParameter?: InputMaybe<Scalars['Boolean']['input']>;
  clearDistributionParameterUponReachingAge?: InputMaybe<Scalars['Boolean']['input']>;
  clearDistributionParameters?: InputMaybe<Scalars['Boolean']['input']>;
  clearDistributionPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  /** The AMOUNT kind of distribution. Only valid when distribution_kind is AMOUNT */
  distributionAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The frequency of the distribution to beneficiaries */
  distributionFrequency?: InputMaybe<BeneficiaryDistributionDistributionFrequency>;
  /** The kind of distribution for this beneficiary */
  distributionKind?: InputMaybe<BeneficiaryDistributionDistributionKind>;
  distributionParameter?: InputMaybe<BeneficiaryDistributionDistributionParameter>;
  /** The age at which the beneficiary will receive the distribution. Only valid when distribution_parameter is UPON_REACHING_AGE */
  distributionParameterUponReachingAge?: InputMaybe<Scalars['Int']['input']>;
  /** The percentage of the distribution. Only valid when distribution_kind is PERCENTAGE */
  distributionPercentage?: InputMaybe<Scalars['Percent']['input']>;
  removeDistributionParameterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateBeneficiaryDistributionParameterInput is used for update BeneficiaryDistributionParameter object.
 * Input was generated by ent.
 */
export type UpdateBeneficiaryDistributionParameterInput = {
  /** The kind of distribution parameter for this distribution */
  kind?: InputMaybe<BeneficiaryDistributionParameterKind>;
};

/**
 * UpdateBeneficiaryInput is used for update Beneficiary object.
 * Input was generated by ent.
 */
export type UpdateBeneficiaryInput = {
  addAccessParameterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDistributionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addScheduledDistributionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  beneficiaryGratID?: InputMaybe<Scalars['ID']['input']>;
  clearAccessParameters?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaryGrat?: InputMaybe<Scalars['Boolean']['input']>;
  clearDistributions?: InputMaybe<Scalars['Boolean']['input']>;
  clearLevel?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearPowerOfAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  clearScheduledDistributions?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<BeneficiaryLevel>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  powerOfAppointmentID?: InputMaybe<Scalars['ID']['input']>;
  removeAccessParameterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDistributionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeScheduledDistributionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateBeneficiaryPageInput is used for update BeneficiaryPage object.
 * Input was generated by ent.
 */
export type UpdateBeneficiaryPageInput = {
  /** The ID of the beneficiary to display - either a client profile or client organization. */
  beneficiaryID?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateBeneficiaryPowerOfAppointmentInput is used for update BeneficiaryPowerOfAppointment object.
 * Input was generated by ent.
 */
export type UpdateBeneficiaryPowerOfAppointmentInput = {
  beneficiaryID?: InputMaybe<Scalars['ID']['input']>;
  clearBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  clearPower?: InputMaybe<Scalars['Boolean']['input']>;
  clearPowerOtherNote?: InputMaybe<Scalars['Boolean']['input']>;
  /** The power of appointment for the beneficiary */
  power?: InputMaybe<BeneficiaryPowerOfAppointmentPower>;
  /** Notes for when other is an access parameter */
  powerOtherNote?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateCCorpBusinessEntityInput is used for update CCorpBusinessEntity object.
 * Input was generated by ent.
 */
export type UpdateCCorpBusinessEntityInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKeyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearDoingBusinessAsName?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearEnableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  clearFinCenID?: InputMaybe<Scalars['Boolean']['input']>;
  clearFormationJurisdictionStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearKeyPeople?: InputMaybe<Scalars['Boolean']['input']>;
  clearKeyPeopleNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnershipAsOfDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearRequiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxID?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this business entity */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Ownership as-of date. */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKeyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
};

/**
 * UpdateCLTProposalInput is used for update CLTProposal object.
 * Input was generated by ent.
 */
export type UpdateCltProposalInput = {
  addCharitableIncomeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDonorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRemainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The amount of the annuity payout. Only valid when payout_kind is ANNUITY */
  annuityPayoutAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The cost basis of assets proposed to be transferred to this CRT */
  assetCostBasis?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** Notes about the assets proposed to be transferred to this CRT */
  assetNotes?: InputMaybe<Scalars['String']['input']>;
  /** The total value of assets proposed to be transferred to this CRT */
  assetValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  calculationMethod?: InputMaybe<CharitableTrustCalculationMethod>;
  clearAnnuityPayoutAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearCalculationMethod?: InputMaybe<Scalars['Boolean']['input']>;
  clearCharitableIncomeBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearOptimizationTarget?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreTaxReturnPercentageHigh?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreTaxReturnPercentageLow?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreTaxReturnPercentageMedium?: InputMaybe<Scalars['Boolean']['input']>;
  clearRate7520?: InputMaybe<Scalars['Boolean']['input']>;
  clearRemainderBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDragPercentageHigh?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDragPercentageLow?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDragPercentageMedium?: InputMaybe<Scalars['Boolean']['input']>;
  clearUnitrustKind?: InputMaybe<Scalars['Boolean']['input']>;
  clearUnitrustPayoutPercent?: InputMaybe<Scalars['Boolean']['input']>;
  clearYearOfAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  optimizationTarget?: InputMaybe<CharitableTrustOptimizationTarget>;
  /** The frequency of payouts for this charitable trust. */
  payoutFrequency?: InputMaybe<CharitableTrustPayoutFrequency>;
  payoutKind?: InputMaybe<CharitableTrustPayoutKind>;
  /** The high end of the pre-tax return percentage assumption */
  preTaxReturnPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  /** The low end of the pre-tax return assumption */
  preTaxReturnPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  /** The medium pre-tax return percentage assumption */
  preTaxReturnPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  rate7520?: InputMaybe<Scalars['Percent']['input']>;
  removeCharitableIncomeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDonorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRemainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The associated tax drag for the high pre-tax return */
  taxDragPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  /** The associated tax drag for the low pre-tax return */
  taxDragPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  /** The associated tax drag for the medium pre-tax return */
  taxDragPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  /** Tax status for this trust */
  taxStatus?: InputMaybe<TrustTaxStatus>;
  termKind?: InputMaybe<CharitableTrustTermKind>;
  /** The number of years the CRT will pay out for. Only valid if term_kind is FIXED */
  termYears?: InputMaybe<Scalars['Int']['input']>;
  /** The kind of unitrust. Only valid when payout_kind is UNITRUST; ignored otherwise. */
  unitrustKind?: InputMaybe<CharitableTrustUnitrustKind>;
  /** The percent of the unitrust payout. Only valid when payout_kind is UNITRUST */
  unitrustPayoutPercent?: InputMaybe<Scalars['Percent']['input']>;
  /** This is the year of analysis. If not specified, it will either default to the actuarial tables or the term_years */
  yearOfAnalysis?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateCLTTrustInput is used for update CLTTrust object.
 * Input was generated by ent.
 */
export type UpdateCltTrustInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLifetimeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRemainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Taxable deduction that was recorded for funding this CLT */
  charitableDeduction?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearCharitableDeduction?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearLifetimeBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearOfficialInterestRatePercent?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearRemainderBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearTermDurationYears?: InputMaybe<Scalars['Boolean']['input']>;
  clearTerminationDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustJurisdictionStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  officialInterestRatePercent?: InputMaybe<Scalars['Percent']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLifetimeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRemainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  /** If true, term_duration_years will be ignored */
  termDurationLifetime?: InputMaybe<Scalars['Boolean']['input']>;
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  terminationDate?: InputMaybe<Scalars['Time']['input']>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateCRTProposalInput is used for update CRTProposal object.
 * Input was generated by ent.
 */
export type UpdateCrtProposalInput = {
  addCharitableRemainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDonorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addIncomeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The amount of the annuity payout. Only valid when payout_kind is ANNUITY */
  annuityPayoutAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The cost basis of assets proposed to be transferred to this CRT */
  assetCostBasis?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** Notes about the assets proposed to be transferred to this CRT */
  assetNotes?: InputMaybe<Scalars['String']['input']>;
  /** The total value of assets proposed to be transferred to this CRT */
  assetValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  calculationMethod?: InputMaybe<CharitableTrustCalculationMethod>;
  clearAnnuityPayoutAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssetNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearCalculationMethod?: InputMaybe<Scalars['Boolean']['input']>;
  clearCharitableRemainderBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearIncomeBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearOptimizationTarget?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreTaxReturnPercentageHigh?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreTaxReturnPercentageLow?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreTaxReturnPercentageMedium?: InputMaybe<Scalars['Boolean']['input']>;
  clearRate7520?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDragPercentageHigh?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDragPercentageLow?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDragPercentageMedium?: InputMaybe<Scalars['Boolean']['input']>;
  clearUnitrustKind?: InputMaybe<Scalars['Boolean']['input']>;
  clearUnitrustPayoutPercent?: InputMaybe<Scalars['Boolean']['input']>;
  clearYearOfAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  optimizationTarget?: InputMaybe<CharitableTrustOptimizationTarget>;
  /** The frequency of payouts for this charitable trust. */
  payoutFrequency?: InputMaybe<CharitableTrustPayoutFrequency>;
  payoutKind?: InputMaybe<CharitableTrustPayoutKind>;
  /** The high end of the pre-tax return percentage assumption */
  preTaxReturnPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  /** The low end of the pre-tax return assumption */
  preTaxReturnPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  /** The medium pre-tax return percentage assumption */
  preTaxReturnPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  rate7520?: InputMaybe<Scalars['Percent']['input']>;
  removeCharitableRemainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDonorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeIncomeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The associated tax drag for the high pre-tax return */
  taxDragPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  /** The associated tax drag for the low pre-tax return */
  taxDragPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  /** The associated tax drag for the medium pre-tax return */
  taxDragPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  termKind?: InputMaybe<CharitableTrustTermKind>;
  /** The number of years the CRT will pay out for. Only valid if term_kind is FIXED; ignored otherwise. */
  termYears?: InputMaybe<Scalars['Int']['input']>;
  /** The kind of unitrust. Only valid when payout_kind is UNITRUST; ignored otherwise. */
  unitrustKind?: InputMaybe<CharitableTrustUnitrustKind>;
  /** The percent of the unitrust payout. Only valid when payout_kind is UNITRUST */
  unitrustPayoutPercent?: InputMaybe<Scalars['Percent']['input']>;
  /** This is the year of analysis. If not specified, it will either default to the actuarial tables or the term_years */
  yearOfAnalysis?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateCRTTrustInput is used for update CRTTrust object.
 * Input was generated by ent.
 */
export type UpdateCrtTrustInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLifetimeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRemainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Taxable deduction that was recorded for funding this CRT */
  charitableDeduction?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearCharitableDeduction?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearLifetimeBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearOfficialInterestRatePercent?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearRemainderBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearTermDurationYears?: InputMaybe<Scalars['Boolean']['input']>;
  clearTerminationDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustJurisdictionStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  officialInterestRatePercent?: InputMaybe<Scalars['Percent']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLifetimeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRemainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  /** If true, term_duration_years will be ignored */
  termDurationLifetime?: InputMaybe<Scalars['Boolean']['input']>;
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  terminationDate?: InputMaybe<Scalars['Time']['input']>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateCashflowInput is used for update Cashflow object.
 * Input was generated by ent.
 */
export type UpdateCashflowInput = {
  /** This dynamically sets the end date of this transfer to the year when both individuals die. It superceeds end_year and end_at_clients_death. Ignored if start_year is not set.  */
  afterBothDeaths?: InputMaybe<Scalars['Boolean']['input']>;
  clearAfterBothDeaths?: InputMaybe<Scalars['Boolean']['input']>;
  clearEndAtClientsDeath?: InputMaybe<Scalars['Boolean']['input']>;
  clearEndYear?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrowthPercent?: InputMaybe<Scalars['Boolean']['input']>;
  clearIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  clearIntegrationCashflow?: InputMaybe<Scalars['Boolean']['input']>;
  clearStartYear?: InputMaybe<Scalars['Boolean']['input']>;
  clearTransferPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  clearTransferValue?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  endAtClientsDeathID?: InputMaybe<Scalars['ID']['input']>;
  /** The year this transfer ends. Ignored if start_year is not set. */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** The yearly growth percent of this transfer. Can be negative. Only valid when kind is AMOUNT */
  growthPercent?: InputMaybe<Scalars['Percent']['input']>;
  individualID?: InputMaybe<Scalars['ID']['input']>;
  integrationCashflowID?: InputMaybe<Scalars['ID']['input']>;
  /** The year this transfer starts. If start_year is not set, it is assumed to be a one time transfer happening in the current year. If start_year is set, this is a yearly recurring transfer until end_year is reached. */
  startYear?: InputMaybe<Scalars['Int']['input']>;
  /** The percentage of the transfer. Positive for income, negative for expense. Only valid when kind is PERCENTAGE */
  transferPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** Value of this transfer. Positive for income, negative for expense. Only valid when kind is AMOUNT */
  transferValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
};

/**
 * UpdateClientOrganizationInput is used for update ClientOrganization object.
 * Input was generated by ent.
 */
export type UpdateClientOrganizationInput = {
  addKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOnboardedOrganizationSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPotentialClientOrganizationSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addProfessionalTeamRoleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuggestedClientOrganizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addressID?: InputMaybe<Scalars['ID']['input']>;
  clearAddress?: InputMaybe<Scalars['Boolean']['input']>;
  clearKgV2nodes?: InputMaybe<Scalars['Boolean']['input']>;
  clearKind?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearOnboardedOrganizationSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  clearPointOfContactEmail?: InputMaybe<Scalars['Boolean']['input']>;
  clearPointOfContactLastName?: InputMaybe<Scalars['Boolean']['input']>;
  clearPointOfContactName?: InputMaybe<Scalars['Boolean']['input']>;
  clearPointOfContactPhone?: InputMaybe<Scalars['Boolean']['input']>;
  clearPotentialClientOrganizationSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  clearProfessionalTeamRoles?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuggestedClientOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<ClientOrganizationKind>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  pointOfContactEmail?: InputMaybe<Scalars['String']['input']>;
  pointOfContactLastName?: InputMaybe<Scalars['String']['input']>;
  pointOfContactName?: InputMaybe<Scalars['String']['input']>;
  pointOfContactPhone?: InputMaybe<Scalars['String']['input']>;
  removeKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOnboardedOrganizationSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePotentialClientOrganizationSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeProfessionalTeamRoleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuggestedClientOrganizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateClientPresentationV2Input is used for update ClientPresentationV2 object.
 * Input was generated by ent.
 */
export type UpdateClientPresentationV2Input = {
  addBundleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearBundles?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumberToStartFrom?: InputMaybe<Scalars['Int']['input']>;
  removeBundleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  showClientNamesInHeader?: InputMaybe<Scalars['Boolean']['input']>;
  showLegalDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  showPageNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  showPageNumbersOnCoverSlide?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateClientProfileAddressInput = {
  cityName?: InputMaybe<Scalars['String']['input']>;
  clearCityName?: InputMaybe<Scalars['Boolean']['input']>;
  clearPostalCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearStreetLineOne?: InputMaybe<Scalars['Boolean']['input']>;
  clearStreetLineTwo?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  residesOutsideUnitedStates?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  streetLineOne?: InputMaybe<Scalars['String']['input']>;
  streetLineTwo?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateClientProfileInput is used for update ClientProfile object.
 * Input was generated by ent.
 */
export type UpdateClientProfileInput = {
  addCashflowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEstateWaterfallFilterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLifetimeExclusionEventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addMissingDocumentOverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOnboardedIndividualSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOwnedOwnershipStakeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPotentialClientProfileSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addProfessionalTeamRoleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRelationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuggestedClientProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTestamentaryEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Use updateClientProfileAddress instead. */
  address?: InputMaybe<UpdateAddressInput>;
  addressID?: InputMaybe<Scalars['ID']['input']>;
  clearAddress?: InputMaybe<Scalars['Boolean']['input']>;
  clearCashflows?: InputMaybe<Scalars['Boolean']['input']>;
  clearDateOfBirth?: InputMaybe<Scalars['Boolean']['input']>;
  clearDateOfDeath?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearDsue?: InputMaybe<Scalars['Boolean']['input']>;
  clearEmail?: InputMaybe<Scalars['Boolean']['input']>;
  clearEstateWaterfallFilters?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearFamilyTreeNodeSettings?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearIntegrationPerson?: InputMaybe<Scalars['Boolean']['input']>;
  clearKgV2nodes?: InputMaybe<Scalars['Boolean']['input']>;
  clearLifetimeExclusionEvents?: InputMaybe<Scalars['Boolean']['input']>;
  clearMiddleName?: InputMaybe<Scalars['Boolean']['input']>;
  clearMissingDocumentOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearOnboardedIndividualSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnedOwnershipStakes?: InputMaybe<Scalars['Boolean']['input']>;
  clearPastDistributions?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearPotentialClientProfileSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreferredName?: InputMaybe<Scalars['Boolean']['input']>;
  clearProfessionalTeamRoles?: InputMaybe<Scalars['Boolean']['input']>;
  clearRelations?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuffix?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuggestedClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  clearTestamentaryEntities?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Time']['input']>;
  dateOfDeath?: InputMaybe<Scalars['Time']['input']>;
  /** Controls which name parts appear in the client profile display name. */
  displayNamePattern?: InputMaybe<ClientProfileDisplayNamePattern>;
  dsueID?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Customer-supplied identifier from an external system. Unique per tenant when set. */
  externalID?: InputMaybe<Scalars['String']['input']>;
  familyTreeNodeSettingsID?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  integrationPersonID?: InputMaybe<Scalars['ID']['input']>;
  /** Whether this client profile is deceased. */
  isDeceased?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this client profile should be an eligible grantor/owner/other principal for entities. */
  isGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this client_profile is one of the (at most) two primary clients on this household. */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Used in beneficiary reporting to adjust beneficiary totalswith distributions made in the past */
  pastDistributions?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  removeCashflowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEstateWaterfallFilterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLifetimeExclusionEventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeMissingDocumentOverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOnboardedIndividualSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOwnedOwnershipStakeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePotentialClientProfileSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeProfessionalTeamRoleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRelationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuggestedClientProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTestamentaryEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  updateRelationships?: InputMaybe<Array<UpdateClientProfileRelationship>>;
};

export type UpdateClientProfileRelationship = {
  clearRelationship?: InputMaybe<Scalars['Boolean']['input']>;
  fromClientProfileID: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  relationship?: InputMaybe<UpdateClientProfileRelationshipInput>;
  toClientProfileID: Scalars['ID']['input'];
};

/**
 * UpdateClientProfileRelationshipInput is used for update ClientProfileRelationship object.
 * Input was generated by ent.
 */
export type UpdateClientProfileRelationshipInput = {
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** the relationship between the 'from' ClientProfile and the 'to' ClientProfile */
  type?: InputMaybe<ClientProfileRelationshipType>;
};

export type UpdateCollaboratorByIdInput = {
  id: Scalars['ID']['input'];
  update: UpdateCollaboratorInput;
};

/**
 * UpdateCollaboratorInput is used for update Collaborator object.
 * Input was generated by ent.
 */
export type UpdateCollaboratorInput = {
  addHouseholdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRoleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearHouseholds?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastViewedNotificationsListAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganizationName?: InputMaybe<Scalars['Boolean']['input']>;
  clearRoles?: InputMaybe<Scalars['Boolean']['input']>;
  clearTitle?: InputMaybe<Scalars['Boolean']['input']>;
  clearUser?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The role of the collaborator, for display purposes only */
  kind?: InputMaybe<CollaboratorKind>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The timestamp when the collaborator last viewed the notifications list */
  lastViewedNotificationsListAt?: InputMaybe<Scalars['Time']['input']>;
  /** The name of the organization this collaborator works for */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  removeHouseholdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRoleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The professional title of the collaborator, e.g. 'Associate' */
  title?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateComparedWaterfallInput is used for update ComparedWaterfall object.
 * Input was generated by ent.
 */
export type UpdateComparedWaterfallInput = {
  clearEstateWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  clearFirstDeathYear?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrowthProfile?: InputMaybe<Scalars['Boolean']['input']>;
  clearSecondDeathYear?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name for the compared waterfall. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  estateWaterfallID?: InputMaybe<Scalars['ID']['input']>;
  /** The year of the first death in the compared waterfall. */
  firstDeathYear?: InputMaybe<Scalars['Int']['input']>;
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  /** The year of the second death in the compared waterfall. */
  secondDeathYear?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateCompletedEstateInsightsPageInput is used for update CompletedEstateInsightsPage object.
 * Input was generated by ent.
 */
export type UpdateCompletedEstateInsightsPageInput = {
  clearPresentationPage?: InputMaybe<Scalars['Boolean']['input']>;
  presentationPageID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateControllingPartyInput is used for update ControllingParty object.
 * Input was generated by ent.
 */
export type UpdateControllingPartyInput = {
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateCoverPageConfigurationInput is used for update CoverPageConfiguration object.
 * Input was generated by ent.
 */
export type UpdateCoverPageConfigurationInput = {
  bundleID?: InputMaybe<Scalars['ID']['input']>;
  clearBundle?: InputMaybe<Scalars['Boolean']['input']>;
  clearCustomText?: InputMaybe<Scalars['Boolean']['input']>;
  clearTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** The custom text to display on the cover page, stored as Markdown. */
  customText?: InputMaybe<Scalars['String']['input']>;
  /** The title to display on the cover page. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateCustodialPersonalAccountInput is used for update CustodialPersonalAccount object.
 * Input was generated by ent.
 */
export type UpdateCustodialPersonalAccountInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwner?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
};

/**
 * UpdateDSUEPortabilityInput is used for update DSUEPortability object.
 * Input was generated by ent.
 */
export type UpdateDsuePortabilityInput = {
  addDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The amount of DSUE ported to the recipient */
  amount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date of when the DSUE was recorded */
  eventDate?: InputMaybe<Scalars['Time']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  recipientID?: InputMaybe<Scalars['ID']['input']>;
  removeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateDiagramInput = {
  diagram: DiagramInput;
  /** The existing household diagram to update; manual updates cannot create artifacts. */
  diagramArtifactID: Scalars['ID']['input'];
  /** The last saved revision read, not local edits. A different revision rejects the update. */
  expectedRevision: Scalars['Int']['input'];
  householdID: Scalars['ID']['input'];
};

/**
 * UpdateDispositionScenarioInput is used for update DispositionScenario object.
 * Input was generated by ent.
 */
export type UpdateDispositionScenarioInput = {
  addDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSecondDeathDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  associatedHypotheticalWaterfallID?: InputMaybe<Scalars['ID']['input']>;
  clearAssociatedHypotheticalWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositiveProvisionsTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  clearFirstDeathResiduaryPaysAllTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  clearJointAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearReviewedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearSecondDeathDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  clearSecondDeathDispositiveProvisionsTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  clearSecondDeathResiduaryPaysAllTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  clearTransferMethod?: InputMaybe<Scalars['Boolean']['input']>;
  dispositiveProvisionsTemplateID?: InputMaybe<Scalars['ID']['input']>;
  /** if true, the residuary recipient(s) for this death order pays taxes by default. if false, each recipient's bearsTax field can be configured separately */
  firstDeathResiduaryPaysAllTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  firstGrantorDeathID?: InputMaybe<Scalars['ID']['input']>;
  jointAccountID?: InputMaybe<Scalars['ID']['input']>;
  removeDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSecondDeathDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The time at which the scenario was last reviewed. This can be used to indicate that a user has looked at these provisions and they are correct, even if they are empty. */
  reviewedAt?: InputMaybe<Scalars['Time']['input']>;
  secondDeathDispositiveProvisionsTemplateID?: InputMaybe<Scalars['ID']['input']>;
  /** if true, the residuary recipient(s) for this death order pays taxes by default. if false, each recipient's bearsTax field can be configured separately */
  secondDeathResiduaryPaysAllTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** How the transfer is made to the recipient. IN_KIND preserves the asset thus keeping the source asset growth characteristics, LIQUIDATE_TO_CASH sells the asset thus gaining the destination asset growth characteristics. */
  transferMethod?: InputMaybe<TransferMethod>;
};

/**
 * UpdateDispositiveProvisionInput is used for update DispositiveProvision object.
 * Input was generated by ent.
 */
export type UpdateDispositiveProvisionInput = {
  addAssetGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addAssetStaticIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addInsurancePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOwnershipStakeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuggestedDpRecipientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  associatedHypotheticalWaterfallID?: InputMaybe<Scalars['ID']['input']>;
  /** If true, the disposition will bear (pay) taxes. */
  bearsTax?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssetGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssetStatics?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssociatedHypotheticalWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionFormulaicPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionLimit?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  clearInsurancePolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnershipStakes?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuggestedDpRecipient?: InputMaybe<Scalars['Boolean']['input']>;
  /** The AMOUNT kind of disposition. Only valid when disposition_kind is AMOUNT */
  dispositionAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The percentage of the disposition. Only valid when disposition_kind is formulaic */
  dispositionFormulaicPercentage?: InputMaybe<Scalars['Percent']['input']>;
  dispositionKind?: InputMaybe<DispositiveProvisionDispositionKind>;
  /** If set, the disposition will be no more than the set amount.Only applicable if the disposition is not kind AMOUNT. */
  dispositionLimit?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The order of the disposition in the list of dispositions */
  dispositionOrder?: InputMaybe<Scalars['Int']['input']>;
  /** The percentage of the disposition. Only valid when disposition_kind is PERCENTAGE */
  dispositionPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** If true, the disposition amount will be grossed up to try and make disposition_amount the post-tax amount. This is only valid when disposition_kind is AMOUNT. */
  grossUpDispositionAmount?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the disposition will grow by the inflation rate specified in the growth profile.Only applicable if the disposition is kind AMOUNT. */
  growByInflation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  removeAssetGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeAssetStaticIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeInsurancePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOwnershipStakeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuggestedDpRecipientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** How the transfer is made to the recipient.IN_KIND preserves the asset thus keeping the source asset growth characteristics,LIQUIDATE_TO_CASH sells the asset thus gaining the destination asset growth characteristics.The default is IN_KIND. */
  transferMethod?: InputMaybe<TransferMethod>;
  transferTaxKind?: InputMaybe<DispositiveProvisionTransferTaxKind>;
};

/**
 * UpdateDispositiveProvisionTemplateInput is used for update DispositiveProvisionTemplate object.
 * Input was generated by ent.
 */
export type UpdateDispositiveProvisionTemplateInput = {
  addDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  clearDocument?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the template */
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentID?: InputMaybe<Scalars['ID']['input']>;
  /** If true, disposition amounts will be sourced from the total sum of all entities linked to this template.Otherwise amounts will be sourced from each entity linked. */
  proRata?: InputMaybe<Scalars['Boolean']['input']>;
  removeDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether the residuary pays all taxes; only applies to DEFAULT kinds */
  residuaryPaysAllTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** The sub kind of dispositive provision tempalte */
  subKind?: InputMaybe<DispositiveProvisionTemplateSubKind>;
};

/**
 * UpdateDividerBundleConfigurationInput is used for update DividerBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateDividerBundleConfigurationInput = {
  clearCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  clearDividerTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** The content of the divider page, rendered as Markdown. */
  customContent?: InputMaybe<Scalars['String']['input']>;
  /** The title displayed on the divider page. */
  dividerTitle?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateDividerTemplateBundleConfigurationInput is used for update DividerTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateDividerTemplateBundleConfigurationInput = {
  clearCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  clearDividerTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** The content of the divider page, rendered as Markdown. */
  customContent?: InputMaybe<Scalars['String']['input']>;
  /** The title displayed on the divider page. */
  dividerTitle?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateDocumentInput is used for update Document object.
 * Input was generated by ent.
 */
export type UpdateDocumentInput = {
  addAdditionalEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addAdditionalTestamentaryEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addConversationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDsueIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEntityDocumentRelationshipIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEstateInsightIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLifetimeExclusionEventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLoggedTransferIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addMemoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSplitDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSummaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWorkflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The precedence that the suggestions from this document should take when extracting data. If this is not explicitly set, suggestions order will be inferred by uploaded date (most recent first). Only applicable for documents associated with entities. */
  aiSuggestionOrder?: InputMaybe<Scalars['Int']['input']>;
  clearAdditionalEntities?: InputMaybe<Scalars['Boolean']['input']>;
  clearAdditionalTestamentaryEntities?: InputMaybe<Scalars['Boolean']['input']>;
  clearAiSuggestionOrder?: InputMaybe<Scalars['Boolean']['input']>;
  clearClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  clearConversations?: InputMaybe<Scalars['Boolean']['input']>;
  clearDefaultDocumentOfEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearDsue?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntityDocumentRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  clearEstateInsights?: InputMaybe<Scalars['Boolean']['input']>;
  clearLifetimeExclusionEvent?: InputMaybe<Scalars['Boolean']['input']>;
  clearLoggedTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  clearMemos?: InputMaybe<Scalars['Boolean']['input']>;
  clearNextVersion?: InputMaybe<Scalars['Boolean']['input']>;
  clearParsingStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearPdfFile?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreviousVersion?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceBinder?: InputMaybe<Scalars['Boolean']['input']>;
  clearSplitDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearSummaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearWorkflowTrackers?: InputMaybe<Scalars['Boolean']['input']>;
  clientProfileID?: InputMaybe<Scalars['ID']['input']>;
  defaultDocumentOfEntityID?: InputMaybe<Scalars['ID']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  fileID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextVersionID?: InputMaybe<Scalars['ID']['input']>;
  /** The current processing stage or terminal result for this document. */
  parsingStatus?: InputMaybe<DocumentParsingStatus>;
  pdfFileID?: InputMaybe<Scalars['ID']['input']>;
  previousVersionID?: InputMaybe<Scalars['ID']['input']>;
  removeAdditionalEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeAdditionalTestamentaryEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeConversationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDsueIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEntityDocumentRelationshipIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEstateInsightIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLifetimeExclusionEventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLoggedTransferIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeMemoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSplitDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSummaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWorkflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceBinderID?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<DocumentType>;
};

/**
 * UpdateDocumentSummaryInput is used for update DocumentSummary object.
 * Input was generated by ent.
 */
export type UpdateDocumentSummaryInput = {
  addEntityNoteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPresentationPageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWorkflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The user's feedback on the AI-generated summary. Ignore if entry_mode is USER */
  aiSummaryFeedback?: InputMaybe<Scalars['String']['input']>;
  /** The user's rating of the AI-generated summary. Ignore if entry_mode is USER */
  aiSummaryRating?: InputMaybe<DocumentSummaryAiSummaryRating>;
  clearAiSummaryFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  clearAiSummaryRating?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntityNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntryMode?: InputMaybe<Scalars['Boolean']['input']>;
  clearFeedbackFrom?: InputMaybe<Scalars['Boolean']['input']>;
  clearGeneratedFromPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationPages?: InputMaybe<Scalars['Boolean']['input']>;
  clearSummaryFormat?: InputMaybe<Scalars['Boolean']['input']>;
  clearWorkflowTrackers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name for the document summary. Default: 'Default summary' */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the summary content was updated by the user or generated by AI. Default: AI_AUTO */
  entryMode?: InputMaybe<DocumentSummaryEntryMode>;
  feedbackFromID?: InputMaybe<Scalars['ID']['input']>;
  generatedFromPromptID?: InputMaybe<Scalars['ID']['input']>;
  removeEntityNoteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePresentationPageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWorkflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The most recently-edited summary for the document */
  summary?: InputMaybe<Scalars['String']['input']>;
  /** The format of the summary string when displaying it to the user on the frontend. Default: MARKDOWN */
  summaryFormat?: InputMaybe<DocumentSummarySummaryFormat>;
};

/**
 * UpdateDocumentSummaryPageInput is used for update DocumentSummaryPage object.
 * Input was generated by ent.
 */
export type UpdateDocumentSummaryPageInput = {
  addRelevantClientProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDocumentType?: InputMaybe<Scalars['Boolean']['input']>;
  clearRelevantClientProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearSummary?: InputMaybe<Scalars['Boolean']['input']>;
  /** The document type for this document summary page. */
  documentType?: InputMaybe<PresentationDocumentType>;
  removeRelevantClientProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  summaryID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateDocumentSummaryPromptInput is used for update DocumentSummaryPrompt object.
 * Input was generated by ent.
 */
export type UpdateDocumentSummaryPromptInput = {
  addTestRunIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearPromptMarkdown?: InputMaybe<Scalars['Boolean']['input']>;
  clearTestRuns?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name for the prompt */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The document type this prompt is for */
  documentType?: InputMaybe<DocumentSummaryPromptDocumentType>;
  /** Whether this prompt is the default for the document type; if set to true, clears any other default for the document type */
  isDefaultForDocType?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this is a system-provided prompt */
  isSystemPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  /** The prompt content in markdown format. Required for non-system prompts. */
  promptMarkdown?: InputMaybe<Scalars['String']['input']>;
  removeTestRunIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When enabled, this prompt will auto-run for uploads of its document type. */
  shouldAutoRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** When enabled, uses a more capable model to generate the summary. */
  useExtendedThinkingModal?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateDocumentSummaryTemplateBundleConfigurationInput is used for update DocumentSummaryTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateDocumentSummaryTemplateBundleConfigurationInput = {
  clearDocumentType?: InputMaybe<Scalars['Boolean']['input']>;
  /** The document type filter for this document summary bundle. */
  documentType?: InputMaybe<PresentationDocumentType>;
  /** If true, includes document summaries for the first grantor. */
  includeFirstGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes document summaries for the second grantor. */
  includeSecondGrantor?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateDonorAdvisedFundInput is used for update DonorAdvisedFund object.
 * Input was generated by ent.
 */
export type UpdateDonorAdvisedFundInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDonorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearDonors?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDonorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
};

/**
 * UpdateEmployeeInput is used for update Employee object.
 * Input was generated by ent.
 */
export type UpdateEmployeeInput = {
  addAssignedHouseholdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRoleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTeamIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTeamOwnerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAssignedHouseholds?: InputMaybe<Scalars['Boolean']['input']>;
  clearIdpID?: InputMaybe<Scalars['Boolean']['input']>;
  clearIsAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastViewedNotificationsListAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearRoles?: InputMaybe<Scalars['Boolean']['input']>;
  clearTeamOwner?: InputMaybe<Scalars['Boolean']['input']>;
  clearTeams?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user's unique id in their identify provider (automatically mapped as idp_id in WorkOS) */
  idpID?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** The timestamp when the employee last viewed the notifications list */
  lastViewedNotificationsListAt?: InputMaybe<Scalars['Time']['input']>;
  removeAssignedHouseholdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRoleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTeamIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTeamOwnerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tier?: InputMaybe<EmployeeTier>;
  user?: InputMaybe<UpdateUserInput>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateEntitiesOverviewBundleConfigurationEntityInput is used for update EntitiesOverviewBundleConfigurationEntity object.
 * Input was generated by ent.
 */
export type UpdateEntitiesOverviewBundleConfigurationEntityInput = {
  /** The order of the entity in the bundle. */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** If true, the entity is hidden in the bundle. */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateEntitiesOverviewBundleConfigurationInput is used for update EntitiesOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateEntitiesOverviewBundleConfigurationInput = {
  addEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntities?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name for the bundle. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  removeEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If true, shows summary metrics in the bundle. */
  showSummaryMetrics?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateEntityDiagramInput is used for update EntityDiagram object.
 * Input was generated by ent.
 */
export type UpdateEntityDiagramInput = {
  addVisualizationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  appendNodeConfigurations?: InputMaybe<Array<EntityGraphNodeConfigurationInput>>;
  clearFirstGrantorDeath?: InputMaybe<Scalars['Boolean']['input']>;
  clearVisualizationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  firstGrantorDeathID?: InputMaybe<Scalars['ID']['input']>;
  /** Whether group tiles hide their entity lists by default */
  hideEntitiesListInGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of node configurations containing positions and other display properties */
  nodeConfigurations?: InputMaybe<Array<EntityGraphNodeConfigurationInput>>;
  removeVisualizationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateEntityDocumentRelationshipInput is used for update EntityDocumentRelationship object.
 * Input was generated by ent.
 */
export type UpdateEntityDocumentRelationshipInput = {
  clearSuggestionPrecedenceOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** The precedence for AI suggestions. Only applies when relationship_type is SOURCE_DOCUMENT */
  suggestionPrecedenceOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateEntityDocumentSuggestionPrecedenceInput = {
  documentID: Scalars['ID']['input'];
  entityID: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

/**
 * UpdateEntityGraphViewBundleConfigurationInput is used for update EntityGraphViewBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateEntityGraphViewBundleConfigurationInput = {
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntityGraphView?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name for the entity graph view. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityGraphViewID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateEntityGraphViewInput is used for update EntityGraphView object.
 * Input was generated by ent.
 */
export type UpdateEntityGraphViewInput = {
  addVisualizationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  appendNodeConfigurations?: InputMaybe<Array<EntityGraphNodeConfigurationInput>>;
  clearOrientation?: InputMaybe<Scalars['Boolean']['input']>;
  clearVisualizationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Whether group tiles hide their entity lists by default */
  hideEntitiesListInGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides dollar values on entity tiles. */
  hideEntityValues?: InputMaybe<Scalars['Boolean']['input']>;
  /** the definitions of the nodes in the graph */
  nodeConfigurations?: InputMaybe<Array<EntityGraphNodeConfigurationInput>>;
  orientation?: InputMaybe<EntityGraphViewOrientation>;
  removeVisualizationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If true, shows labels on ownership lines. */
  showLineLabels?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateEntityInput is used for update Entity object.
 * Input was generated by ent.
 */
export type UpdateEntityInput = {
  addActivityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addAdditionalDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addCashflowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addCreatedSubtrustIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeathOrderNoteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEmailNotificationRecordIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEntityDiagramIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEntityDocumentRelationshipIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEntityProposalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEstateWaterfallFilterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addIntegrationEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLiabilitiesOwedIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOnboardingEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOwnedByStakeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOwnedOwnershipStakeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOwningOnboardingEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPotentialEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRelatedSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuggestionKgRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTaskIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWorkflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** when true, indicates that the addepar entity this is linked to isn't owned by the grantor on addepar. this could be because the grantor on addepar is deceased or not present on Luminary. */
  addeparLinkedToNongrantorEntity?: InputMaybe<Scalars['Boolean']['input']>;
  /** how the entity got created */
  attributionSource?: InputMaybe<EntityAttributionSource>;
  balanceSheetCategoryOverrideID?: InputMaybe<Scalars['ID']['input']>;
  clearActivities?: InputMaybe<Scalars['Boolean']['input']>;
  clearAddeparLinkedToNongrantorEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearAdditionalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearAttributionSource?: InputMaybe<Scalars['Boolean']['input']>;
  clearBalanceSheetCategoryOverride?: InputMaybe<Scalars['Boolean']['input']>;
  clearCashflows?: InputMaybe<Scalars['Boolean']['input']>;
  clearCreatedSubtrusts?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeathOrderNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearDefaultDocument?: InputMaybe<Scalars['Boolean']['input']>;
  clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearEmailNotificationRecords?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntityDiagrams?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntityDocumentRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntityProposals?: InputMaybe<Scalars['Boolean']['input']>;
  clearEstateWaterfallFilters?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearIntegrationEntities?: InputMaybe<Scalars['Boolean']['input']>;
  clearKgV2nodes?: InputMaybe<Scalars['Boolean']['input']>;
  clearLiabilitiesOwed?: InputMaybe<Scalars['Boolean']['input']>;
  clearOnboardingEntitySuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnedByStakes?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnedOwnershipStakes?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwningOnboardingEntitySuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  clearPotentialEntitySuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  clearRelatedSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuggestionKgRoots?: InputMaybe<Scalars['Boolean']['input']>;
  clearTasks?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxInfo?: InputMaybe<Scalars['Boolean']['input']>;
  clearWorkflowTrackers?: InputMaybe<Scalars['Boolean']['input']>;
  defaultDocumentID?: InputMaybe<Scalars['ID']['input']>;
  /** Customer-supplied identifier from an external system. Unique per tenant when set. */
  externalID?: InputMaybe<Scalars['String']['input']>;
  /** When true, assets will be grouped by category and account in the valuation */
  groupIntegrationAssetValues?: InputMaybe<Scalars['Boolean']['input']>;
  /** Controls how liquidity is determined for this entity. ASSET_BASED derives from underlying asset classes, LIQUID/ILLIQUID overrides all owned assets beneath it. */
  liquidityStatus?: InputMaybe<EntityLiquidityStatus>;
  /** When true, integration syncs do not update this entity's valuations or ownership. */
  pauseIntegrationSync?: InputMaybe<Scalars['Boolean']['input']>;
  removeActivityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeAdditionalDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeCashflowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeCreatedSubtrustIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeathOrderNoteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEmailNotificationRecordIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEntityDiagramIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEntityDocumentRelationshipIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEntityProposalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEstateWaterfallFilterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeIntegrationEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLiabilitiesOwedIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOnboardingEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOwnedByStakeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOwnedOwnershipStakeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOwningOnboardingEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePotentialEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRelatedSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuggestionKgRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTaskIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWorkflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When true, the entity name will be shown on the balance sheet rather than the names of the underlying assets */
  showEntityNameOnBalanceSheet?: InputMaybe<Scalars['Boolean']['input']>;
  /** the lifecycle stage of the entity. not all stages are applicable to all entities; most go directly into ACTIVE */
  stage?: InputMaybe<EntityStage>;
  /** When true, the same entity notes apply for all client profiles in the household */
  syncDeathOrderNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to sync ownership percentage from integrations. */
  syncOwnership?: InputMaybe<Scalars['Boolean']['input']>;
  taxInfoID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateEntityNotesInput is used for update EntityNotes object.
 * Input was generated by ent.
 */
export type UpdateEntityNotesInput = {
  clearClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  clearDocumentSummary?: InputMaybe<Scalars['Boolean']['input']>;
  clientProfileID?: InputMaybe<Scalars['ID']['input']>;
  documentSummaryID?: InputMaybe<Scalars['ID']['input']>;
  /** Markdown formatted notes for this entity's death order */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateEntityProposalInput is used for update EntityProposal object.
 * Input was generated by ent.
 */
export type UpdateEntityProposalInput = {
  addProposalScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetValuationProjectionType?: InputMaybe<EntityProposalAssetValuationProjectionType>;
  clearProposalScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDrag?: InputMaybe<Scalars['Boolean']['input']>;
  removeProposalScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** the percent value for tax drag for the entity */
  taxDrag?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * UpdateEntitySummaryBundleConfigurationInput is used for update EntitySummaryBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateEntitySummaryBundleConfigurationInput = {
  addDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  deathOrderID?: InputMaybe<Scalars['ID']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** If true, includes the full-sheet entity balance sheet page in the bundle. */
  includeBalanceSheetExportPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the entity balance sheet page in the bundle. */
  includeBalanceSheetPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the beneficiaries and dispositions page in the bundle. */
  includeBeneficiariesAndDispositionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the notes and diagram page in the bundle. */
  includeDiagramAndNotesPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the entity notes on the diagram page. */
  includeEntityNotesOnSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the entity summary/title page in the bundle. */
  includeEntitySummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the insurance policy slides in the bundle. */
  includeInsurancePolicySlides?: InputMaybe<Scalars['Boolean']['input']>;
  removeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateEntitySummaryTemplateBundleConfigurationInput is used for update EntitySummaryTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateEntitySummaryTemplateBundleConfigurationInput = {
  appendEntityTypes?: InputMaybe<Array<EntitySummaryEntityType>>;
  /** Which household entities this bundle expands into, one runtime bundle per match. */
  entityTypes?: InputMaybe<Array<EntitySummaryEntityType>>;
  /** If true, includes the full-sheet entity balance sheet page in each expanded bundle. */
  includeBalanceSheetExportPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the entity balance sheet page in each expanded bundle. */
  includeBalanceSheetPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the beneficiaries and dispositions page in each expanded bundle. */
  includeBeneficiariesAndDispositionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the notes and diagram page in each expanded bundle. */
  includeDiagramAndNotesPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the entity notes on the diagram page in each expanded bundle. */
  includeEntityNotesOnSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the entity summary/title page in each expanded bundle. */
  includeEntitySummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the insurance policy slides in each expanded bundle. */
  includeInsurancePolicySlides?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateEntityTaskInput is used for update EntityTask object.
 * Input was generated by ent.
 */
export type UpdateEntityTaskInput = {
  addReminderEmailNotificationRecordIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTaskDependencyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTaskDependentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedByID?: InputMaybe<Scalars['ID']['input']>;
  assignedToID?: InputMaybe<Scalars['ID']['input']>;
  /** the reason this task was cancelled. if present, the task status is computed as canceled */
  cancelledReason?: InputMaybe<Scalars['String']['input']>;
  clearAssignedBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssignedTo?: InputMaybe<Scalars['Boolean']['input']>;
  clearCancelledReason?: InputMaybe<Scalars['Boolean']['input']>;
  clearCompletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearCompletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearReminderEmailNotificationRecord?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaskDependencies?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaskDependents?: InputMaybe<Scalars['Boolean']['input']>;
  /** the timestamp at which this task was marked as complete */
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  completedByID?: InputMaybe<Scalars['ID']['input']>;
  /** the date at which this task is due */
  dueAt?: InputMaybe<Scalars['Time']['input']>;
  removeReminderEmailNotificationRecordIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTaskDependencyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTaskDependentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<EntityTaskType>;
};

/**
 * UpdateEntityTaxInfoInput is used for update EntityTaxInfo object.
 * Input was generated by ent.
 */
export type UpdateEntityTaxInfoInput = {
  clearStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  federalInEstate?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<StateCode>;
  stateInEstate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEstateInsightBucketInput = {
  /** ID of the EstateInsight */
  id: Scalars['ID']['input'];
  /** Destination bucket to which insight was dragged */
  newBucket: EstateInsightBucket;
  /** New position of the insight in its bucket */
  newPosition: Scalars['Int']['input'];
  /** Source bucket from which insight was dragged */
  oldBucket: EstateInsightBucket;
};

/**
 * UpdateEstateInsightInput is used for update EstateInsight object.
 * Input was generated by ent.
 */
export type UpdateEstateInsightInput = {
  addDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEstateInsightsBundleConfigurationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addReferenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether this insight needs review or represents a concern or opportunity */
  bucket?: InputMaybe<EstateInsightBucket>;
  /** Category classification of the estate insight */
  category?: InputMaybe<EstateInsightCategory>;
  clearCompletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearEstateInsightsBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearReferences?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date when the estate insight was marked as completed */
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  /** Markdown formatted detailed consideration for the estate insight */
  consideration?: InputMaybe<Scalars['String']['input']>;
  /** Whether this insight is marked as critical */
  isCritical?: InputMaybe<Scalars['Boolean']['input']>;
  /** The specific type of estate insight identified */
  kind?: InputMaybe<EstateInsightKind>;
  /** 0‑based ordinal within this household's insights within bucket */
  position?: InputMaybe<Scalars['Int']['input']>;
  removeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEstateInsightsBundleConfigurationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeReferenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Current status of the estate insight */
  status?: InputMaybe<EstateInsightStatus>;
  /** Plain text summary of the estate insight */
  summary?: InputMaybe<Scalars['String']['input']>;
  /** Title of the estate insight */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateEstateInsightReferenceInput is used for update EstateInsightReference object.
 * Input was generated by ent.
 */
export type UpdateEstateInsightReferenceInput = {
  addFileParagraphIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearFileParagraphs?: InputMaybe<Scalars['Boolean']['input']>;
  clearSectionLabel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description of the reference */
  description?: InputMaybe<Scalars['String']['input']>;
  estateInsightID?: InputMaybe<Scalars['ID']['input']>;
  removeFileParagraphIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional section label for the reference */
  sectionLabel?: InputMaybe<Scalars['String']['input']>;
  /** Title of the reference */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateEstateInsightsBundleConfigurationInput is used for update EstateInsightsBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateEstateInsightsBundleConfigurationInput = {
  addEstateInsightIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  clearEstateInsights?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name for the bundle. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** If true, includes the annual exclusion gifting insight in the bundle. */
  includeAnnualExclusionGiftingPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the automatic outright distribution to spouse insight in the bundle. */
  includeAutomaticOutrightDistributionToSpousePage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the bypass trust funded solely via disclaimer insight in the bundle. */
  includeBypassTrustFundedSolelyViaDisclaimerPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the corporate trustee insight in the bundle. */
  includeCorporateTrusteePage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes this different state of residence from estate documents insight in the bundle. */
  includeDifferentStateOfResidenceFromEstateDocumentsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the ex spouse listed as beneficiary insight in the bundle. */
  includeExSpouseListedAsBeneficiaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the ex spouse listed as trustee insight in the bundle. */
  includeExSpouseListedAsTrusteePage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the ex spouse listed in will insight in the bundle. */
  includeExSpouseListedInWillPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the full use of lifetime exemption insight in the bundle. */
  includeFullUseOfLifetimeExemptionPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the gift to charity insight in the bundle. */
  includeGiftToCharityPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes this missing documents page in the bundle. */
  includeMissingDocumentsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the missing guardian provisions insight in the bundle. */
  includeMissingGuardianProvisionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the missing powers of appointment for surviving spouse insight in the bundle. */
  includeMissingPoaForSurivivingSpousePage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the no alternative agent listed in healthcare proxy insight in the bundle. */
  includeNoAlternativeAgentListedHealthcareProxyPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the no alternative agent listed in power of attorney insight in the bundle. */
  includeNoAlternativeAgentListedPoaPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the open 529 account insight in the bundle. */
  includeOpen529AccountPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the outright distributions to children insight in the bundle. */
  includeOutrightDistributionsToChildrenPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the retirement account beneficiary designations insight in the bundle. */
  includeRetirementAccountBeneficiaryDesignationsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes this retitle assets to revocable trust insight in the bundle. */
  includeRetitleAssetsToRevocableTrustPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes this specific bequests insight in the bundle. */
  includeSpecificBequestsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the state estate tax insight in the bundle. */
  includeStateEstateTaxPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the state inheritance tax insight in the bundle. */
  includeStateInheritanceTaxPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes this trustee domiciled in different state insight in the bundle. */
  includeTrusteeDomiciledInDifferentState?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the trustees not updated insight in the bundle. */
  includeTrusteesNotUpdatedPage?: InputMaybe<Scalars['Boolean']['input']>;
  removeEstateInsightIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateEstateTaxScenarioInput is used for update EstateTaxScenario object.
 * Input was generated by ent.
 */
export type UpdateEstateTaxScenarioInput = {
  appendFirstDeathPayoutOrder?: InputMaybe<Array<Scalars['ID']['input']>>;
  appendSecondDeathPayoutOrder?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearSecondDeathPayoutOrder?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The order of payout for the first death. Includes Entities and Testamentary Entities. */
  firstDeathPayoutOrder?: InputMaybe<Array<Scalars['ID']['input']>>;
  firstGrantorDeathID?: InputMaybe<Scalars['ID']['input']>;
  isExemptionPortable?: InputMaybe<Scalars['Boolean']['input']>;
  payoutKind?: InputMaybe<EstateTaxScenarioPayoutKind>;
  /** The order of payout for the second death, only valid when there are multiple grantors. Includes Entities and Testamentary Entities. */
  secondDeathPayoutOrder?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateEstateWaterfallHypotheticalStateChangeInput is used for update EstateWaterfallHypotheticalStateChange object.
 * Input was generated by ent.
 */
export type UpdateEstateWaterfallHypotheticalStateChangeInput = {
  clearStartYear?: InputMaybe<Scalars['Boolean']['input']>;
  grantorID?: InputMaybe<Scalars['ID']['input']>;
  /** The state change applies from the start of this year until the grantor's next state change or death. If not set, it applies from the start of the projection. */
  startYear?: InputMaybe<Scalars['Int']['input']>;
  /** The grantor's state of residence in this hypothetical scenario. */
  stateCode?: InputMaybe<StateCode>;
};

/**
 * UpdateEstateWaterfallHypotheticalTransferInput is used for update EstateWaterfallHypotheticalTransfer object.
 * Input was generated by ent.
 */
export type UpdateEstateWaterfallHypotheticalTransferInput = {
  addGiftingGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** This dynamically sets the end date of this transfer to the year when both individuals die. It superceeds end_year and end_at_clients_death. Ignored if start_year is not set.  */
  afterBothDeaths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Assume transfers will grow/shrink by this percentage each year. Only valid for recurring transfers. */
  assetGrowthReturn?: InputMaybe<Scalars['Percent']['input']>;
  clearAfterBothDeaths?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssetGrowthReturn?: InputMaybe<Scalars['Boolean']['input']>;
  clearDestinationEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearDestinationIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  clearDestinationOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  clearEndAtClientsDeath?: InputMaybe<Scalars['Boolean']['input']>;
  clearEndYear?: InputMaybe<Scalars['Boolean']['input']>;
  clearGiftingGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  clearName?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceInsurancePolicy?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceOwnedBusinessEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceOwnedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceOwnershipStake?: InputMaybe<Scalars['Boolean']['input']>;
  clearStartYear?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxableValue?: InputMaybe<Scalars['Boolean']['input']>;
  clearTransferValue?: InputMaybe<Scalars['Boolean']['input']>;
  destinationEntityID?: InputMaybe<Scalars['ID']['input']>;
  destinationIndividualID?: InputMaybe<Scalars['ID']['input']>;
  /** The kind of destination for this transfer. */
  destinationKind?: InputMaybe<EstateWaterfallHypotheticalTransferDestinationKind>;
  destinationOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  endAtClientsDeathID?: InputMaybe<Scalars['ID']['input']>;
  /** The year this transfer ends. Ignored if start_year is not set. */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  /** If true, this is a GST gift. Only valid when transfer_tax_kind is GRANTOR_TAXABLE_GIFT. */
  isGstGift?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeGiftingGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  sourceInsurancePolicyID?: InputMaybe<Scalars['ID']['input']>;
  /** The kind of the source for this transfer. */
  sourceKind?: InputMaybe<EstateWaterfallHypotheticalTransferSourceKind>;
  sourceOwnedBusinessEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceOwnedEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceOwnershipStakeID?: InputMaybe<Scalars['ID']['input']>;
  /** The year this transfer starts. If start_year is not set, it is assumed to be a one time transfer happening in the current year. If start_year is set, this is a yearly recurring transfer until end_year is reached. */
  startYear?: InputMaybe<Scalars['Int']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  /** Taxable value of the transfer. If nil, it will be calculated. */
  taxableValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The order of this transfer in the list of transfers for a given source. */
  transferOrder?: InputMaybe<Scalars['Int']['input']>;
  transferTaxKind?: InputMaybe<EstateWaterfallHypotheticalTransferTransferTaxKind>;
  /** Value of this transfer. */
  transferValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
};

/**
 * UpdateEstateWaterfallInput is used for update EstateWaterfall object.
 * Input was generated by ent.
 */
export type UpdateEstateWaterfallInput = {
  addHypotheticalCltIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalCrtIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalGratIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalInsuranceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalSaleLoanIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalStateChangeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalTransferIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addVisualizationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  appendNodeConfigurations?: InputMaybe<Array<EntityGraphNodeConfigurationInput>>;
  /** Used in beneficiary reporting to calculate non-quantifiable accessto a single entity across multiple beneficiaries. */
  beneficiaryAccessCalcMethod?: InputMaybe<EstateWaterfallBeneficiaryAccessCalcMethod>;
  clearFilter?: InputMaybe<Scalars['Boolean']['input']>;
  clearFirstGrantorDeathYear?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrowthProfile?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalClts?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalCrts?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalGrats?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalSaleLoans?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalStateChanges?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  clearParent?: InputMaybe<Scalars['Boolean']['input']>;
  clearSecondGrantorDeathYear?: InputMaybe<Scalars['Boolean']['input']>;
  clearShowSummaryTileDetails?: InputMaybe<Scalars['Boolean']['input']>;
  clearVisualizationConfig?: InputMaybe<Scalars['Boolean']['input']>;
  clearVisualizationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  filterID?: InputMaybe<Scalars['ID']['input']>;
  /** Projected year that the first grantor dies. */
  firstGrantorDeathYear?: InputMaybe<Scalars['Int']['input']>;
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  /** the definitions of the nodes in the graph */
  nodeConfigurations?: InputMaybe<Array<EntityGraphNodeConfigurationInput>>;
  parentID?: InputMaybe<Scalars['ID']['input']>;
  removeHypotheticalCltIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalCrtIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalGratIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalInsuranceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalSaleLoanIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalStateChangeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalTransferIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeVisualizationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Projected year that the second grantor dies. Only applicable when there are two grantors. */
  secondGrantorDeathYear?: InputMaybe<Scalars['Int']['input']>;
  /** When set, controls whether summary tile details are shown or hidden. */
  showSummaryTileDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** When set, asset growth is not applied in the current year of the waterfall projection. */
  skipCurrentYearGrowth?: InputMaybe<Scalars['Boolean']['input']>;
  visualizationConfigID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateEstateWaterfallVisualizationConfigInput is used for update EstateWaterfallVisualizationConfig object.
 * Input was generated by ent.
 */
export type UpdateEstateWaterfallVisualizationConfigInput = {
  /** If true, always shows edge labels. */
  alwaysShowEdgeLabels?: InputMaybe<Scalars['Boolean']['input']>;
  clearWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides edges. */
  hideEdges?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides list of entities in a group. */
  hideEntitiesListInGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides dollar values on the entity tile. */
  hideEntityValues?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides all tax tiles. */
  hideTaxTiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides unfunded tiles. */
  hideUnfundedTiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, shows zero dollar tiles. */
  showZeroDollarTiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, uses brand colors instead of luminary defaults. */
  useBrandColors?: InputMaybe<Scalars['Boolean']['input']>;
  waterfallID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateEstateWaterfallVisualizationFilterInput is used for update EstateWaterfallVisualizationFilter object.
 * Input was generated by ent.
 */
export type UpdateEstateWaterfallVisualizationFilterInput = {
  addIncludedClientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addIncludedEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearIncludedClients?: InputMaybe<Scalars['Boolean']['input']>;
  clearIncludedEntities?: InputMaybe<Scalars['Boolean']['input']>;
  removeIncludedClientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeIncludedEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  waterfallID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateFamilyTreeBundleConfigurationInput is used for update FamilyTreeBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateFamilyTreeBundleConfigurationInput = {
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  clearFamilyTreeConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name for the family tree. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  familyTreeConfigurationID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateFamilyTreeNodeSettingsInput = {
  /** Whether to show this individual on the tree diagram */
  showIndividualOnTree?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show notes for this individual on the tree diagram */
  showNotesForIndividual?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFamilyTreeSettingsInput = {
  /** Array of node configurations containing positions and other display properties */
  nodeConfigurations?: InputMaybe<Array<EntityGraphNodeConfigurationInput>>;
  /** Whether to show age on the family tree diagram */
  showAge?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show hidden individuals on the family tree diagram */
  showHiddenIndividuals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show notes for all nodes on the family tree diagram */
  showNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show state of residence on the family tree diagram */
  showStateOfResidence?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateFeatureFlagInput is used for update FeatureFlag object.
 * Input was generated by ent.
 */
export type UpdateFeatureFlagInput = {
  addQueryRuleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearFlagDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearGroup?: InputMaybe<Scalars['Boolean']['input']>;
  clearQueryRules?: InputMaybe<Scalars['Boolean']['input']>;
  clearTeam?: InputMaybe<Scalars['Boolean']['input']>;
  flagDescription?: InputMaybe<Scalars['String']['input']>;
  flagStatus?: InputMaybe<FeatureFlagFlagStatus>;
  /** Conceptual group for flag */
  group?: InputMaybe<FeatureFlagGroup>;
  ownedBy?: InputMaybe<Scalars['String']['input']>;
  removeQueryRuleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Luminary engineering team responsible for the feature flag */
  team?: InputMaybe<FeatureFlagTeam>;
};

/**
 * UpdateFeatureFlagQueryRuleInput is used for update FeatureFlagQueryRule object.
 * Input was generated by ent.
 */
export type UpdateFeatureFlagQueryRuleInput = {
  clearKind?: InputMaybe<Scalars['Boolean']['input']>;
  clearReleaseGroup?: InputMaybe<Scalars['Boolean']['input']>;
  featureFlagID?: InputMaybe<Scalars['ID']['input']>;
  flagQuery?: InputMaybe<Scalars['String']['input']>;
  flagVariationName?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<FeatureFlagQueryRuleKind>;
  releaseGroupID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateFormInput is used for update Form object.
 * Input was generated by ent.
 */
export type UpdateFormInput = {
  /** Description of the form */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Mutable working copy of the form configuration */
  draftConfig?: InputMaybe<Scalars['Map']['input']>;
  /** Display name for the form */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFormSubmissionNameInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/**
 * UpdateGPBusinessEntityInput is used for update GPBusinessEntity object.
 * Input was generated by ent.
 */
export type UpdateGpBusinessEntityInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKeyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearDoingBusinessAsName?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearEnableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  clearFinCenID?: InputMaybe<Scalars['Boolean']['input']>;
  clearFormationJurisdictionStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearKeyPeople?: InputMaybe<Scalars['Boolean']['input']>;
  clearKeyPeopleNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnershipAsOfDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearRequiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxID?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this business entity */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Ownership as-of date. */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKeyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
};

/**
 * UpdateGRATAnnuityV2Input is used for update GRATAnnuityV2 object.
 * Input was generated by ent.
 */
export type UpdateGratAnnuityV2Input = {
  associatedAssetValuationID?: InputMaybe<Scalars['ID']['input']>;
  associatedTaskID?: InputMaybe<Scalars['ID']['input']>;
  clearAssociatedAssetValuation?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssociatedTask?: InputMaybe<Scalars['Boolean']['input']>;
  clearFailedAnnuityPaymentAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearPaidOn?: InputMaybe<Scalars['Boolean']['input']>;
  /** if the annuity payment failed, this is the amount that was actually paid */
  failedAnnuityPaymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** the percent of the initial funding value due to be paid with this annuity */
  initialFundingValuePercent?: InputMaybe<Scalars['Percent']['input']>;
  /** the date the annuity was paid on */
  paidOn?: InputMaybe<Scalars['Time']['input']>;
  /** the term duration of the GRAT that this annuity is associated with */
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  /** which 1-indexed annuity payment this represents; if a 2, represents the second annuity payment */
  yearOfTerm?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateGRATProposalScenarioInput is used for update GRATProposalScenario object.
 * Input was generated by ent.
 */
export type UpdateGratProposalScenarioInput = {
  clearInTermValuationType?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectedAnnualReturnAfterTerm?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectedAnnualReturnThroughTerm?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectedMarketValueAtTerm?: InputMaybe<Scalars['Boolean']['input']>;
  inTermValuationType?: InputMaybe<GratProposalScenarioInTermValuationType>;
  /** the percent value for projected return after the lifetime of the GRAT */
  projectedAnnualReturnAfterTerm?: InputMaybe<Scalars['Percent']['input']>;
  /** the percent value for projected return during the lifetime of the GRAT */
  projectedAnnualReturnThroughTerm?: InputMaybe<Scalars['Percent']['input']>;
  projectedMarketValueAtTerm?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** the default selected time period for this projection */
  projectionTimePeriodYears?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateGRATTrustInput is used for update GRATTrust object.
 * Input was generated by ent.
 */
export type UpdateGratTrustInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addAnnuityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** the percent by which the annuity should increase each year in a variable annuity amount scenario */
  annuityAnnualIncreasePercent?: InputMaybe<Scalars['Percent']['input']>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearAnnuities?: InputMaybe<Scalars['Boolean']['input']>;
  clearAnnuityAnnualIncreasePercent?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearDistributionAssetValuation?: InputMaybe<Scalars['Boolean']['input']>;
  clearDistributionDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearDownsideThresholdPercent?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearImplementationNotesToAttorney?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOfficialInterestRatePercent?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectedMarketValue?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectedRateOfReturn?: InputMaybe<Scalars['Boolean']['input']>;
  clearProjectedSharePrice?: InputMaybe<Scalars['Boolean']['input']>;
  clearRollingPeriodYears?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  clearTargetTaxableGift?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxableGift?: InputMaybe<Scalars['Boolean']['input']>;
  clearTermDurationYears?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustJurisdictionStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  clearUpsideThresholdPercent?: InputMaybe<Scalars['Boolean']['input']>;
  clearUpsideThresholdValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  distributionAssetValuationID?: InputMaybe<Scalars['ID']['input']>;
  /** the date that the trust remainder was distributed */
  distributionDate?: InputMaybe<Scalars['Time']['input']>;
  downsideThresholdPercent?: InputMaybe<Scalars['Percent']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  grantorID?: InputMaybe<Scalars['ID']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  /** notes from the advisor team to the implementing attorney */
  implementationNotesToAttorney?: InputMaybe<Scalars['String']['input']>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  officialInterestRatePercent?: InputMaybe<Scalars['Percent']['input']>;
  projectedMarketValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  projectedRateOfReturn?: InputMaybe<Scalars['Percent']['input']>;
  projectedSharePrice?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeAnnuityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  rollingPeriodYears?: InputMaybe<Scalars['Int']['input']>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** taxable gift that the advisor is trying to achieve; should be used as an input for annuities calcs */
  targetTaxableGift?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  /** The actual taxable gift that was recorded for this GRAT */
  taxableGift?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  /** If true, the upside threshold value is used for the GRAT substitution threshold instead of the upside threshold percent. */
  upsideAsTargetSurplus?: InputMaybe<Scalars['Boolean']['input']>;
  upsideThresholdPercent?: InputMaybe<Scalars['Percent']['input']>;
  upsideThresholdValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
};

/**
 * UpdateGiftingProposalCashFlowInput is used for update GiftingProposalCashFlow object.
 * Input was generated by ent.
 */
export type UpdateGiftingProposalCashFlowInput = {
  /** Cash flow amount */
  amount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** Whether this cash flow occurs every year or only once */
  annuallyRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the cash flow is an income or expense */
  cashFlowType?: InputMaybe<GiftingProposalCashFlowCashFlowType>;
  clearAnnuallyRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  clearEndYear?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrowthPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  clearPortfolio?: InputMaybe<Scalars['Boolean']['input']>;
  /** the user-friendly name of this cash flow */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** If recurring, the year this cash flow ends. If not recurring, this field is not set. */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  /** If recurring, the percentage that the cash flow amount grows each year */
  growthPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** The order to display cash flows in the UI */
  order?: InputMaybe<Scalars['Int']['input']>;
  portfolioID?: InputMaybe<Scalars['ID']['input']>;
  /** If recurring, the year this cash flow starts. If not recurring, the year this cash flow occurs. */
  startYear?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateGiftingProposalGiftInput is used for update GiftingProposalGift object.
 * Input was generated by ent.
 */
export type UpdateGiftingProposalGiftInput = {
  addSenderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Gift amount */
  amount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** Whether this gift occurs every year or only once */
  annuallyRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  clearAnnuallyRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  clearDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDiscountPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  clearEndYear?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrowthPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  clearNonTaxableGiftType?: InputMaybe<Scalars['Boolean']['input']>;
  clearRecipientClientOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  clearRecipientClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  clearRecipientKind?: InputMaybe<Scalars['Boolean']['input']>;
  clearRecipientPortfolio?: InputMaybe<Scalars['Boolean']['input']>;
  clearSenders?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, gift amount is discounted for gift tax purposes */
  discount?: InputMaybe<Scalars['Boolean']['input']>;
  /** If discount is true, the discount percentage applied to the gift amount */
  discountPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** the user-friendly name of this gifting scenario */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** If recurring, the year this gift ends. If not recurring, this field is not set. */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  /** If recurring, the percentage that the gift amount grows each year */
  growthPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** If true, gift is taxable, and sender will be one or both grantors. If false, can be annual exclusion, or charitable. */
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Will be null (or ignored) if gift is taxable. */
  nonTaxableGiftType?: InputMaybe<GiftingProposalGiftNonTaxableGiftType>;
  /** The order to display, and process the gifts when simulating the proposal scenarios */
  order?: InputMaybe<Scalars['Int']['input']>;
  recipientClientOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  recipientClientProfileID?: InputMaybe<Scalars['ID']['input']>;
  /** The kind of recipient for this gift. Either one of the modeled out-of-estate portfolios, an individual, or an organization. */
  recipientKind?: InputMaybe<GiftingProposalGiftRecipientKind>;
  recipientPortfolioID?: InputMaybe<Scalars['ID']['input']>;
  removeSenderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If recurring, the year this gift starts. If not recurring, the year this gift occurs. */
  startYear?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateGiftingProposalGiftSenderInput is used for update GiftingProposalGiftSender object.
 * Input was generated by ent.
 */
export type UpdateGiftingProposalGiftSenderInput = {
  grantorID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateGiftingProposalInput is used for update GiftingProposal object.
 * Input was generated by ent.
 */
export type UpdateGiftingProposalInput = {
  addBaseCashFlowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGiftingScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOutOfEstatePortfolioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearBaseCashFlows?: InputMaybe<Scalars['Boolean']['input']>;
  clearDefaultGiftingScenario?: InputMaybe<Scalars['Boolean']['input']>;
  clearExemptionGrowthRate?: InputMaybe<Scalars['Boolean']['input']>;
  clearExemptionSunsets?: InputMaybe<Scalars['Boolean']['input']>;
  clearGiftingScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearOutOfEstatePortfolios?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreTaxReturnPercentageHigh?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreTaxReturnPercentageLow?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreTaxReturnPercentageMedium?: InputMaybe<Scalars['Boolean']['input']>;
  clearSelectedPreTaxReturnCategory?: InputMaybe<Scalars['Boolean']['input']>;
  clearSelectedYearOfAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  clearShowAfterEstateTax?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDragPercentageHigh?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDragPercentageLow?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDragPercentageMedium?: InputMaybe<Scalars['Boolean']['input']>;
  defaultGiftingScenarioID?: InputMaybe<Scalars['ID']['input']>;
  /** Gift exemption grows by this amount each year. */
  exemptionGrowthRate?: InputMaybe<Scalars['Percent']['input']>;
  /** If true, exemption amount is halved at the end of 2025, then continues growing. DEPRECATED: The 2017 Tax Cuts and Jobs Act sunset provision is no longer relevant */
  exemptionSunsets?: InputMaybe<Scalars['Boolean']['input']>;
  /** The total value of all assets in the client's estate */
  inEstatePortfolioValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** number of years to run the gifting analysis */
  lengthOfAnalysis?: InputMaybe<Scalars['Int']['input']>;
  /** The high end of the pre-tax return percentage assumption */
  preTaxReturnPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  /** The low end of the pre-tax return assumption */
  preTaxReturnPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  /** The medium pre-tax return percentage assumption */
  preTaxReturnPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
  removeBaseCashFlowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGiftingScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOutOfEstatePortfolioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The selected pre-tax return (and tax drag) category. Used when computing projections for scenarios. */
  selectedPreTaxReturnCategory?: InputMaybe<GiftingProposalSelectedPreTaxReturnCategory>;
  /** The selected year of analysis. Defaults to end year. Used when computing projections for scenarios. */
  selectedYearOfAnalysis?: InputMaybe<Scalars['Int']['input']>;
  /** If true, show after estate tax */
  showAfterEstateTax?: InputMaybe<Scalars['Boolean']['input']>;
  /** Status of the gifting proposal */
  status?: InputMaybe<GiftingProposalStatus>;
  /** The associated tax drag for the high pre-tax return */
  taxDragPercentageHigh?: InputMaybe<Scalars['Percent']['input']>;
  /** The associated tax drag for the low pre-tax return */
  taxDragPercentageLow?: InputMaybe<Scalars['Percent']['input']>;
  /** The associated tax drag for the medium pre-tax return */
  taxDragPercentageMedium?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * UpdateGiftingProposalPortfolioInput is used for update GiftingProposalPortfolio object.
 * Input was generated by ent.
 */
export type UpdateGiftingProposalPortfolioInput = {
  addCashflowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRecipientOfIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearCashflows?: InputMaybe<Scalars['Boolean']['input']>;
  clearRecipientOf?: InputMaybe<Scalars['Boolean']['input']>;
  /** the user-friendly name of the out-of-estate portfolio */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The order to display portfolios in the UI */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Portfolio type */
  portfolioType?: InputMaybe<GiftingProposalPortfolioPortfolioType>;
  removeCashflowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRecipientOfIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The starting value of the out-of-estate portfolio */
  startingAssetValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
};

/**
 * UpdateGiftingProposalScenarioInput is used for update GiftingProposalScenario object.
 * Input was generated by ent.
 */
export type UpdateGiftingProposalScenarioInput = {
  addScenarioCashFlowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addScenarioGiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearExemptionSunsets?: InputMaybe<Scalars['Boolean']['input']>;
  clearScenarioCashFlows?: InputMaybe<Scalars['Boolean']['input']>;
  clearScenarioGifts?: InputMaybe<Scalars['Boolean']['input']>;
  /** the user-friendly name of this gifting scenario */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** If true, exemption amount is halved at the end of 2025, then continues growing. When absent, uses the proposal level setting. DEPRECATED: The 2017 Tax Cuts and Jobs Act sunset provision is no longer relevant */
  exemptionSunsets?: InputMaybe<Scalars['Boolean']['input']>;
  /** The order to display scenarios in the UI */
  order?: InputMaybe<Scalars['Int']['input']>;
  removeScenarioCashFlowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeScenarioGiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateGraphVisualizationGroupInput is used for update GraphVisualizationGroup object.
 * Input was generated by ent.
 */
export type UpdateGraphVisualizationGroupInput = {
  appendNodeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  clearNamespace?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** An optional namespace for this group. Can correspond to sections in the Graph Visualization. */
  namespace?: InputMaybe<Scalars['String']['input']>;
  /** The IDs of the nodes in this group. */
  nodeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateGrowthProfileInput is used for update GrowthProfile object.
 * Input was generated by ent.
 */
export type UpdateGrowthProfileInput = {
  addEstateWaterfallIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGrowthProfileOverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTaxDragOverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Assume assets will grow/shrink by this percentage each year. */
  assetGrowthReturn?: InputMaybe<Scalars['Percent']['input']>;
  clearAssetGrowthReturn?: InputMaybe<Scalars['Boolean']['input']>;
  clearEstateWaterfalls?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrowthProfileOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  clearIncomeTaxPaymentConfig?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDragConfig?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDragOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Lifetime exemption grows by around this each year. */
  exemptionGrowthRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The type of growth to use for the growth profile. */
  growthType?: InputMaybe<GrowthProfileGrowthType>;
  incomeTaxPaymentConfigID?: InputMaybe<Scalars['ID']['input']>;
  /** If true, new waterfalls for this household will default to this growth profile. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  removeEstateWaterfallIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGrowthProfileOverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTaxDragOverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  taxDragConfigID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateGrowthProfileOverrideInput is used for update GrowthProfileOverride object.
 * Input was generated by ent.
 */
export type UpdateGrowthProfileOverrideInput = {
  assetClassID?: InputMaybe<Scalars['ID']['input']>;
  clearAssetClass?: InputMaybe<Scalars['Boolean']['input']>;
  clearCustomGrowthRate?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntityFutureValuationValue?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntityFutureValuationYear?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntityGrowthAfterFutureValuation?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntityGrowthBeforeFutureValuation?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrowthProfile?: InputMaybe<Scalars['Boolean']['input']>;
  clearProposal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Expected growth rate. */
  customGrowthRate?: InputMaybe<Scalars['Percent']['input']>;
  /** Expected future value of the entity. */
  entityFutureValuationValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The year by which the entity is expected to reach its expected value. */
  entityFutureValuationYear?: InputMaybe<Scalars['Int']['input']>;
  /** Expected growth rate after the future valuation year. */
  entityGrowthAfterFutureValuation?: InputMaybe<Scalars['Percent']['input']>;
  /** Expected growth rate before the future valuation year. */
  entityGrowthBeforeFutureValuation?: InputMaybe<Scalars['Percent']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  /** The type of wealth module. */
  kind?: InputMaybe<GrowthProfileOverrideKind>;
  proposalID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateHouseholdInput is used for update Household object.
 * Input was generated by ent.
 */
export type UpdateHouseholdInput = {
  addActivityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addAssignedEmployeeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addAssignedTeamIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addCashflowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addClientOrganizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addClientProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addCollaboratorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEntityGraphViewIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEstateTaxScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEstateWaterfallIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addFamilyTreeConfigurationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGrowthProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addIntegrationClientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLiabilityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOnboardingKgRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPresentationV2IDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addProposalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTestamentaryEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When this household was archived */
  archivedAt?: InputMaybe<Scalars['Time']['input']>;
  balanceSheetViewConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** whether this client is billable or not. if not BILLABLE, this client's entities should be excluding from customer billing */
  billableKind?: InputMaybe<HouseholdBillableKind>;
  clearActivities?: InputMaybe<Scalars['Boolean']['input']>;
  clearArchivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssignedEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssignedTeams?: InputMaybe<Scalars['Boolean']['input']>;
  clearBalanceSheetViewConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearCashflows?: InputMaybe<Scalars['Boolean']['input']>;
  clearClientOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  clearClientProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
  clearDefaultFirstToDieClient?: InputMaybe<Scalars['Boolean']['input']>;
  clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntities?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntityGraphViews?: InputMaybe<Scalars['Boolean']['input']>;
  clearEstateTaxScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearEstateWaterfalls?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearFamilyTreeConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrowthProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearIntegrationClients?: InputMaybe<Scalars['Boolean']['input']>;
  clearLiabilities?: InputMaybe<Scalars['Boolean']['input']>;
  clearNewIndividualsAutomaticallyOnboardedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearOnboardingKgRoots?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationV2s?: InputMaybe<Scalars['Boolean']['input']>;
  clearProposals?: InputMaybe<Scalars['Boolean']['input']>;
  clearShowGenerateV2SuggestionsPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  clearSmartReviewEnabledByUser?: InputMaybe<Scalars['Boolean']['input']>;
  clearSubBrand?: InputMaybe<Scalars['Boolean']['input']>;
  clearTestamentaryEntities?: InputMaybe<Scalars['Boolean']['input']>;
  defaultFirstToDieClientID?: InputMaybe<Scalars['ID']['input']>;
  /** Enables Smart Review and records the authenticated caller as the enabler. */
  enableSmartReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Customer-supplied identifier from an external system. Unique per tenant when set. */
  externalID?: InputMaybe<Scalars['String']['input']>;
  /** When set, individuals in this household were automatically accepted at this time; the frontend shows a banner prompting users to review them */
  newIndividualsAutomaticallyOnboardedAt?: InputMaybe<Scalars['Time']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  primaryRelationshipOwnerID?: InputMaybe<Scalars['ID']['input']>;
  /** Disables tenant-wide household access when true. */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  removeActivityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeAssignedEmployeeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeAssignedTeamIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeCashflowIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeClientOrganizationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeClientProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeCollaboratorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEntityGraphViewIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEstateTaxScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEstateWaterfallIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeFamilyTreeConfigurationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGrowthProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeIntegrationClientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLiabilityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOnboardingKgRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePresentationV2IDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeProposalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTestamentaryEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Show the prompt to generate V2 AI suggestions for a household on the frontend. This can be deprecated when no longer useful */
  showGenerateV2SuggestionsPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  smartReviewEnabledByUserID?: InputMaybe<Scalars['ID']['input']>;
  subBrandID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateHypotheticalCLTInput is used for update HypotheticalCLT object.
 * Input was generated by ent.
 */
export type UpdateHypotheticalCltInput = {
  clearFunding?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceKind?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fundingID?: InputMaybe<Scalars['ID']['input']>;
  simulatedCltID?: InputMaybe<Scalars['ID']['input']>;
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  sourceKind?: InputMaybe<HypotheticalCltSourceKind>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * UpdateHypotheticalCRTInput is used for update HypotheticalCRT object.
 * Input was generated by ent.
 */
export type UpdateHypotheticalCrtInput = {
  clearFunding?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceKind?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fundingID?: InputMaybe<Scalars['ID']['input']>;
  simulatedCrtID?: InputMaybe<Scalars['ID']['input']>;
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  sourceKind?: InputMaybe<HypotheticalCrtSourceKind>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * UpdateHypotheticalGRATInput is used for update HypotheticalGRAT object.
 * Input was generated by ent.
 */
export type UpdateHypotheticalGratInput = {
  clearFunding?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fundingID?: InputMaybe<Scalars['ID']['input']>;
  simulatedGratID?: InputMaybe<Scalars['ID']['input']>;
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  sourceKind?: InputMaybe<HypotheticalGratSourceKind>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * UpdateHypotheticalInsuranceInput is used for update HypotheticalInsurance object.
 * Input was generated by ent.
 */
export type UpdateHypotheticalInsuranceInput = {
  addGiftingGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearCreatedInsurancePolicy?: InputMaybe<Scalars['Boolean']['input']>;
  clearDestinationEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearEndYear?: InputMaybe<Scalars['Boolean']['input']>;
  clearExistingInsurancePolicy?: InputMaybe<Scalars['Boolean']['input']>;
  clearExistingInsurancePolicyHolder?: InputMaybe<Scalars['Boolean']['input']>;
  clearGiftingGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  clearStartYear?: InputMaybe<Scalars['Boolean']['input']>;
  createdInsurancePolicyID?: InputMaybe<Scalars['ID']['input']>;
  destinationEntityID?: InputMaybe<Scalars['ID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The year this hypothetical insurance ends. Ignored if end_on_kind:YEAR is not set. */
  endYear?: InputMaybe<Scalars['Int']['input']>;
  /** The kind of the end date for this hypothetical insurance. */
  endsOnKind?: InputMaybe<HypotheticalInsuranceEndsOnKind>;
  existingInsurancePolicyHolderID?: InputMaybe<Scalars['ID']['input']>;
  existingInsurancePolicyID?: InputMaybe<Scalars['ID']['input']>;
  removeGiftingGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  /** The kind of the source for this hypothetical insurance. */
  sourceKind?: InputMaybe<HypotheticalInsuranceSourceKind>;
  /** The year this insurance policy starts or is transferred. If not set then it is assumed to be the current year. */
  startYear?: InputMaybe<Scalars['Int']['input']>;
  /** The frequency of the transfer. */
  transferFrequency?: InputMaybe<HypotheticalInsuranceTransferFrequency>;
  transferTaxKind?: InputMaybe<HypotheticalInsuranceTransferTaxKind>;
  /** Value of this transfer. */
  transferValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
};

/**
 * UpdateHypotheticalSaleLoanInput is used for update HypotheticalSaleLoan object.
 * Input was generated by ent.
 */
export type UpdateHypotheticalSaleLoanInput = {
  /** Applicable AFR for the sale or loan. */
  afrRate?: InputMaybe<Scalars['Percent']['input']>;
  clearFunding?: InputMaybe<Scalars['Boolean']['input']>;
  clearRecipientEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearRecipientIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fundingID?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<HypotheticalSaleLoanKind>;
  paymentModel?: InputMaybe<HypotheticalSaleLoanPaymentModel>;
  pretermGrantorDeathHandling?: InputMaybe<HypotheticalSaleLoanPretermGrantorDeathHandling>;
  recipientEntityID?: InputMaybe<Scalars['ID']['input']>;
  recipientIndividualID?: InputMaybe<Scalars['ID']['input']>;
  recipientKind?: InputMaybe<HypotheticalSaleLoanRecipientKind>;
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  sourceKind?: InputMaybe<HypotheticalSaleLoanSourceKind>;
  /** The effective date of the sale or loan for modeling purposes */
  startDate?: InputMaybe<Scalars['Time']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  termLengthYears?: InputMaybe<Scalars['Int']['input']>;
  /** How the transfer is made to the recipient. IN_KIND preserves the asset thus keeping the source asset growth characteristics, LIQUIDATE_TO_CASH sells the asset thus gaining the destination asset growth characteristics. */
  transferMethod?: InputMaybe<TransferMethod>;
};

/**
 * UpdateHypotheticalTransferAssetInput is used for update HypotheticalTransferAsset object.
 * Input was generated by ent.
 */
export type UpdateHypotheticalTransferAssetInput = {
  assetClassID?: InputMaybe<Scalars['ID']['input']>;
  clearAssetClass?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalTransferFundingSource?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnedBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  clearValueAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearValuePercentage?: InputMaybe<Scalars['Boolean']['input']>;
  hypotheticalTransferFundingSourceID?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<HypotheticalTransferAssetKind>;
  ownedBusinessID?: InputMaybe<Scalars['ID']['input']>;
  /** The absolute value of this business or asset class being transferred. Present if the source `kind` is SPECIFIC_ASSETS_AMOUNT. */
  valueAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The percentage of the business or asset class being transferred. Present if the source `kind` is SPECIFIC_ASSETS_PERCENTAGE. */
  valuePercentage?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * UpdateHypotheticalTransferFundingSourceInput is used for update HypotheticalTransferFundingSource object.
 * Input was generated by ent.
 */
export type UpdateHypotheticalTransferFundingSourceInput = {
  addAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAssets?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalClt?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalCrt?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalGrat?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalSaleLoan?: InputMaybe<Scalars['Boolean']['input']>;
  clearProRataAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearProRataPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  hypotheticalCltID?: InputMaybe<Scalars['ID']['input']>;
  hypotheticalCrtID?: InputMaybe<Scalars['ID']['input']>;
  hypotheticalGratID?: InputMaybe<Scalars['ID']['input']>;
  hypotheticalSaleLoanID?: InputMaybe<Scalars['ID']['input']>;
  /** The strategy used to fund the transfer. NOTE: PRO_RATA_xxx is not actually pro_rata but rather our default disbursement strategy instead. */
  kind?: InputMaybe<HypotheticalTransferFundingSourceKind>;
  /** The amount of the transfer. Only valid when kind is PRO_RATA_AMOUNT */
  proRataAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The percentage of the transfer. Only valid when kind is PRO_RATA_PERCENTAGE */
  proRataPercentage?: InputMaybe<Scalars['Percent']['input']>;
  removeAssetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** How the transfer is made to the recipient. IN_KIND preserves the asset thus keeping the source asset growth characteristics, LIQUIDATE_TO_CASH sells the asset thus gaining the destination asset growth characteristics. */
  transferMethod?: InputMaybe<TransferMethod>;
};

/**
 * UpdateHypotheticalWaterfallDispositiveProvisionTemplateInput is used for update HypotheticalWaterfallDispositiveProvisionTemplate object.
 * Input was generated by ent.
 */
export type UpdateHypotheticalWaterfallDispositiveProvisionTemplateInput = {
  clearTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  dispositiveProvisionTemplateID?: InputMaybe<Scalars['ID']['input']>;
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateILITCrummeyLetterInput is used for update ILITCrummeyLetter object.
 * Input was generated by ent.
 */
export type UpdateIlitCrummeyLetterInput = {
  addDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearSendBefore?: InputMaybe<Scalars['Boolean']['input']>;
  clearSentOn?: InputMaybe<Scalars['Boolean']['input']>;
  crummeyWithdrawalPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  removeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  sendBefore?: InputMaybe<Scalars['Time']['input']>;
  sentOn?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateILITTrustInput is used for update ILITTrust object.
 * Input was generated by ent.
 */
export type UpdateIlitTrustInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearCrummeyWithdrawalPeriodDays?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustJurisdictionStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  crummeyWithdrawalPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateIncomeTaxPaymentConfigInput is used for update IncomeTaxPaymentConfig object.
 * Input was generated by ent.
 */
export type UpdateIncomeTaxPaymentConfigInput = {
  appendCustomPayerOrder?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearCustomPayerOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ordered entity IDs used when grantor_payment_method is CUSTOM. */
  customPayerOrder?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The method used to assign tax payments for grantor trusts and direct holdings. */
  grantorPaymentMethod?: InputMaybe<IncomeTaxPaymentConfigGrantorPaymentMethod>;
  /** The method used to assign tax payments for non-grantor entities. */
  nonGrantorPaymentMethod?: InputMaybe<IncomeTaxPaymentConfigNonGrantorPaymentMethod>;
};

/**
 * UpdateIndividualPersonalAccountInput is used for update IndividualPersonalAccount object.
 * Input was generated by ent.
 */
export type UpdateIndividualPersonalAccountInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwner?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
};

/**
 * UpdateInferredFieldEvidenceInput is used for update InferredFieldEvidence object.
 * Input was generated by ent.
 */
export type UpdateInferredFieldEvidenceInput = {
  appendPolygon?: InputMaybe<Array<CoordinateInput>>;
  clearInferredField?: InputMaybe<Scalars['Boolean']['input']>;
  inferredFieldID?: InputMaybe<Scalars['ID']['input']>;
  /** The page (in the file) that this evidence is for */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** the polygon that was drawn to infer the field */
  polygon?: InputMaybe<Array<CoordinateInput>>;
};

/**
 * UpdateInferredFieldInput is used for update InferredField object.
 * Input was generated by ent.
 */
export type UpdateInferredFieldInput = {
  /** Whether the user has accepted or rejected the inferred field */
  acceptanceStatus?: InputMaybe<InferredFieldAcceptanceStatus>;
  /** When the user set the acceptance status */
  acceptanceStatusSetAt?: InputMaybe<Scalars['Time']['input']>;
  addEvidenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAcceptanceStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearAcceptanceStatusSetAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  clearFieldName?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the field (db column) that we inferred for the `target_id` object. If absent, evidence is for the entire object. */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fileID?: InputMaybe<Scalars['ID']['input']>;
  removeEvidenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The object we inferred the field for */
  targetID?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateInsightsTemplateBundleConfigurationInput is used for update InsightsTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateInsightsTemplateBundleConfigurationInput = {
  /** If true, includes active insights in the insights bundle. */
  includeActiveInsights?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes completed insights in the insights bundle. */
  includeCompletedInsights?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes missing documents in the insights bundle. */
  includeMissingDocuments?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateInsurancePersonalAccountInput is used for update InsurancePersonalAccount object.
 * Input was generated by ent.
 */
export type UpdateInsurancePersonalAccountInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryDesignationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalBeneficiaryDesignationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOwnerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The time at which the account's beneficiary designations were last reviewed/acknowledged. Used to suppress the 'no beneficiary designations' badge for accounts where the user has confirmed the empty state is intentional. */
  beneficiaryDesignationsReviewedAt?: InputMaybe<Scalars['Time']['input']>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaryDesignationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaryDesignationsReviewedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalBeneficiaryDesignationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwners?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryDesignationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalBeneficiaryDesignationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOwnerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
};

/**
 * UpdateInsurancePolicyInput is used for update InsurancePolicy object.
 * Input was generated by ent.
 */
export type UpdateInsurancePolicyInput = {
  addDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyHolderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPremiumPaymentGiftingGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  /** Only applicable for non-term policies */
  cashValue?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  cashValueDate?: InputMaybe<Scalars['Time']['input']>;
  clearCarrierName?: InputMaybe<Scalars['Boolean']['input']>;
  clearCashValue?: InputMaybe<Scalars['Boolean']['input']>;
  clearCashValueDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearConversionDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  clearInitialPremiumDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearIntegrationInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  clearKgV2nodes?: InputMaybe<Scalars['Boolean']['input']>;
  clearLoanBalanceOutstanding?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicyHolders?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicyNumber?: InputMaybe<Scalars['Boolean']['input']>;
  clearPremiumAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearPremiumFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  clearPremiumPaymentGiftingGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  clearPremiumPaymentSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearPremiumPaymentSourceIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  clearPremiumPaymentSourceKind?: InputMaybe<Scalars['Boolean']['input']>;
  clearPremiumPaymentSourceTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearPremiumPaymentTransferTaxKind?: InputMaybe<Scalars['Boolean']['input']>;
  clearStartDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearTermDurationYears?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only applicable for term policies */
  conversionDate?: InputMaybe<Scalars['Time']['input']>;
  deathBenefitAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  hypotheticalInsuranceID?: InputMaybe<Scalars['ID']['input']>;
  initialPremiumDueDate?: InputMaybe<Scalars['Time']['input']>;
  integrationInsuranceID?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<InsurancePolicyKind>;
  /** Only applicable for non-term policies */
  loanBalanceOutstanding?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  premiumAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  premiumFrequency?: InputMaybe<InsurancePolicyPremiumFrequency>;
  premiumPaymentSourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  premiumPaymentSourceIndividualID?: InputMaybe<Scalars['ID']['input']>;
  /** The source of the premium payments. If not set, the waterfall will not process premium payments. */
  premiumPaymentSourceKind?: InputMaybe<InsurancePolicyPremiumPaymentSourceKind>;
  premiumPaymentSourceTestamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
  /** The type of transfer of the premium payment, for tax purposes. Required if the premium payment source kind is not SELF. */
  premiumPaymentTransferTaxKind?: InputMaybe<InsurancePolicyPremiumPaymentTransferTaxKind>;
  removeDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyHolderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePremiumPaymentGiftingGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  /** Only applicable for non-term policies. Allows multiple holders. */
  survivorship?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only applicable for term policies */
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateInsurancePremiumPaymentInput is used for update InsurancePremiumPayment object.
 * Input was generated by ent.
 */
export type UpdateInsurancePremiumPaymentInput = {
  addDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearDueOn?: InputMaybe<Scalars['Boolean']['input']>;
  clearPaidOn?: InputMaybe<Scalars['Boolean']['input']>;
  dueOn?: InputMaybe<Scalars['Time']['input']>;
  paidOn?: InputMaybe<Scalars['Time']['input']>;
  premiumAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  removeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateIntegrationAssetClassInput is used for update IntegrationAssetClass object.
 * Input was generated by ent.
 */
export type UpdateIntegrationAssetClassInput = {
  assetClassID?: InputMaybe<Scalars['ID']['input']>;
  clearAssetClass?: InputMaybe<Scalars['Boolean']['input']>;
  /** We use this to map this integration_asset_class to the provider's asset class name. This is imperfect, because if someone updates a name then we will make a new asset class and reconnect it. */
  integrationName?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<IntegrationAssetClassProvider>;
};

/**
 * UpdateIntegrationConfigurationInput is used for update IntegrationConfiguration object.
 * Input was generated by ent.
 */
export type UpdateIntegrationConfigurationInput = {
  /** The client ID for the Addepar OAuth app. */
  addeparClientID?: InputMaybe<Scalars['String']['input']>;
  /** The client Secret for the Addepar OAuth app. */
  addeparClientSecret?: InputMaybe<Scalars['String']['input']>;
  addeparClientType?: InputMaybe<IntegrationConfigurationAddeparClientType>;
  /** If set, we will attempt to query this asset class as a property from Addepar and use it to populate IntegrationAssetClasses. */
  addeparCustomAssetClassName?: InputMaybe<Scalars['String']['input']>;
  /** If set, we will use this field as the attribute ID to set the custom asset name in Addepar. */
  addeparCustomAssetNameAPIField?: InputMaybe<Scalars['String']['input']>;
  /** Addepar attribute ID used to exclude holding accounts and securities when its value is yes or true, ignoring case. */
  addeparCustomExclusionAPIField?: InputMaybe<Scalars['String']['input']>;
  /** When true, requests the entities_write property for Addepar OAuth and syncs household summary values to integrated Addepar households/clients. */
  addeparEnableHouseholdSummarySync?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID for Addepar account. */
  addeparFirmID?: InputMaybe<Scalars['String']['input']>;
  addeparLookThroughCompositeSecurities?: InputMaybe<Scalars['Boolean']['input']>;
  /** The subdomain of the Addepar instance to connect to. */
  addeparSubdomain?: InputMaybe<Scalars['String']['input']>;
  /** Whether the tenant expects to use Black Diamond. We use this to expose prompts to users to authenticate to Black Diamond. */
  blackDiamondEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  clearAddeparClientID?: InputMaybe<Scalars['Boolean']['input']>;
  clearAddeparClientSecret?: InputMaybe<Scalars['Boolean']['input']>;
  clearAddeparCustomAssetClassName?: InputMaybe<Scalars['Boolean']['input']>;
  clearAddeparCustomAssetNameAPIField?: InputMaybe<Scalars['Boolean']['input']>;
  clearAddeparCustomExclusionAPIField?: InputMaybe<Scalars['Boolean']['input']>;
  clearAddeparFirmID?: InputMaybe<Scalars['Boolean']['input']>;
  clearAddeparSubdomain?: InputMaybe<Scalars['Boolean']['input']>;
  clearCsvValuationImportName?: InputMaybe<Scalars['Boolean']['input']>;
  clearSalesforceClientID?: InputMaybe<Scalars['Boolean']['input']>;
  clearSalesforceClientSecret?: InputMaybe<Scalars['Boolean']['input']>;
  clearSalesforceLoginDomain?: InputMaybe<Scalars['Boolean']['input']>;
  clearSnowflakeDataSharingAssetsView?: InputMaybe<Scalars['Boolean']['input']>;
  clearSnowflakeDataSharingDatabase?: InputMaybe<Scalars['Boolean']['input']>;
  clearSnowflakeDataSharingRole?: InputMaybe<Scalars['Boolean']['input']>;
  clearSnowflakeDataSharingSchema?: InputMaybe<Scalars['Boolean']['input']>;
  clearSnowflakeIntegrationDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user-defined name for the source of the file valuation import. Exposed alongside the valuation to show where it came from. */
  csvValuationImportName?: InputMaybe<Scalars['String']['input']>;
  /** Whether the tenant expects to use eMoney. We use this to expose prompts to users to authenticate to eMoney. */
  emoneyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** true to enable customer-owned LLM providers */
  enableLlmByok?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the tenant expects to use the integration user for valuation syncing. */
  integrationUserEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the tenant expects to use Orion. We use this to expose prompts to users to authenticate to Orion. */
  orionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  salesforceClientID?: InputMaybe<Scalars['String']['input']>;
  salesforceClientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Whether user interfaces show the Salesforce integration as WealthHub. Only superusers can change it. */
  salesforceIsWealthhub?: InputMaybe<Scalars['Boolean']['input']>;
  salesforceLoginDomain?: InputMaybe<Scalars['String']['input']>;
  /** Legacy optional Snowflake assets view retained for API compatibility; integrations use SNOWFLAKE_ASSETS_VIEW */
  snowflakeDataSharingAssetsView?: InputMaybe<Scalars['String']['input']>;
  /** If snowflake_data_sharing_enabled=true, we will load customer asset data via this shared snowflake database */
  snowflakeDataSharingDatabase?: InputMaybe<Scalars['String']['input']>;
  /** true to enable customer data asset ingestion via snowflake data sharing */
  snowflakeDataSharingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If snowflake_data_sharing_enabled=true, we will load customer asset data using this tenant-specific snowflake role */
  snowflakeDataSharingRole?: InputMaybe<Scalars['String']['input']>;
  /** Legacy optional Snowflake schema retained for API compatibility; integrations use SNOWFLAKE_INTEGRATION_SCHEMA */
  snowflakeDataSharingSchema?: InputMaybe<Scalars['String']['input']>;
  /** Whether Snowflake household synchronization is enabled for this tenant */
  snowflakeHouseholdSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name to use for the snowflake integration (most customers do not know what snowflake is) */
  snowflakeIntegrationDisplayName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateIrrevocableTrustInput is used for update IrrevocableTrust object.
 * Input was generated by ent.
 */
export type UpdateIrrevocableTrustInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustJurisdictionStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateJointPersonalAccountInput is used for update JointPersonalAccount object.
 * Input was generated by ent.
 */
export type UpdateJointPersonalAccountInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOwnerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwners?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearType?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOwnerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
  type?: InputMaybe<JointPersonalAccountType>;
};

/**
 * UpdateKGRootInput is used for update KGRoot object.
 * Input was generated by ent.
 */
export type UpdateKgRootInput = {
  addAiSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addFileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addNodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  aiSuggestionID?: InputMaybe<Scalars['ID']['input']>;
  asyncJobID?: InputMaybe<Scalars['ID']['input']>;
  clearAiSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  clearAiSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  clearAsyncJob?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearFiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearNodes?: InputMaybe<Scalars['Boolean']['input']>;
  clearTestamentaryEntity?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityID?: InputMaybe<Scalars['ID']['input']>;
  /** What is this knowledge graph a representation of. */
  kind?: InputMaybe<KgRootKind>;
  removeAiSuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeFileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeNodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The status of the construction of this KGRoot. It will be COMPLETE when the KGNodes have all been generated for the associated files and merged into the root. */
  status?: InputMaybe<KgRootStatus>;
  testamentaryEntityID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateKeyPersonInput is used for update KeyPerson object.
 * Input was generated by ent.
 */
export type UpdateKeyPersonInput = {
  addRoleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearRoles?: InputMaybe<Scalars['Boolean']['input']>;
  removeRoleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateKeyPersonRoleInput is used for update KeyPersonRole object.
 * Input was generated by ent.
 */
export type UpdateKeyPersonRoleInput = {
  clearKind?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<KeyPersonRoleKind>;
};

/**
 * UpdateLLCBusinessEntityInput is used for update LLCBusinessEntity object.
 * Input was generated by ent.
 */
export type UpdateLlcBusinessEntityInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKeyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearDoingBusinessAsName?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearEnableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  clearFinCenID?: InputMaybe<Scalars['Boolean']['input']>;
  clearFormationJurisdictionStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearKeyPeople?: InputMaybe<Scalars['Boolean']['input']>;
  clearKeyPeopleNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnershipAsOfDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearRequiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxID?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this business entity */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Ownership as-of date. */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKeyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
};

/**
 * UpdateLPBusinessEntityInput is used for update LPBusinessEntity object.
 * Input was generated by ent.
 */
export type UpdateLpBusinessEntityInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKeyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearDoingBusinessAsName?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearEnableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  clearFinCenID?: InputMaybe<Scalars['Boolean']['input']>;
  clearFormationJurisdictionStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearKeyPeople?: InputMaybe<Scalars['Boolean']['input']>;
  clearKeyPeopleNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnershipAsOfDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearRequiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxID?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this business entity */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Ownership as-of date. */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKeyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
};

/**
 * UpdateLiabilitiesBundleConfigurationInput is used for update LiabilitiesBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateLiabilitiesBundleConfigurationInput = {
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name for the liabilities bundle. */
  displayName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateLiabilityInput is used for update Liability object.
 * Input was generated by ent.
 */
export type UpdateLiabilityInput = {
  addKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPaymentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearCurrentAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearCurrentAmountAsOfDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearFinalPaymentAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearInitialAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearIntegrationLiability?: InputMaybe<Scalars['Boolean']['input']>;
  clearInterestPaid?: InputMaybe<Scalars['Boolean']['input']>;
  clearInterestRate?: InputMaybe<Scalars['Boolean']['input']>;
  clearKgV2nodes?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearPayFromEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearPaymentFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  clearPaymentKind?: InputMaybe<Scalars['Boolean']['input']>;
  clearPayments?: InputMaybe<Scalars['Boolean']['input']>;
  clearRecipientEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearRecurringPaymentAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceClientOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceClientProfile?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearTermEnd?: InputMaybe<Scalars['Boolean']['input']>;
  clearTermStart?: InputMaybe<Scalars['Boolean']['input']>;
  currentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  currentAmountAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  finalPaymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  initialAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  integrationLiabilityID?: InputMaybe<Scalars['ID']['input']>;
  interestPaid?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  interestRate?: InputMaybe<Scalars['Percent']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  payFromEntityID?: InputMaybe<Scalars['ID']['input']>;
  paymentFrequency?: InputMaybe<LiabilityPaymentFrequency>;
  paymentKind?: InputMaybe<LiabilityPaymentKind>;
  recipientEntityID?: InputMaybe<Scalars['ID']['input']>;
  recurringPaymentAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  removeKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePaymentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceClientOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  sourceClientProfileID?: InputMaybe<Scalars['ID']['input']>;
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  termEnd?: InputMaybe<Scalars['Time']['input']>;
  termStart?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateLifeInsuranceBundleConfigurationInput is used for update LifeInsuranceBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateLifeInsuranceBundleConfigurationInput = {
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name for the life insurance bundle. */
  displayName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateLifetimeExclusionEventInput is used for update LifetimeExclusionEvent object.
 * Input was generated by ent.
 */
export type UpdateLifetimeExclusionEventInput = {
  addDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The amount of annual exclusion this gift used */
  annualExclusionAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  benefitOfID?: InputMaybe<Scalars['ID']['input']>;
  clearAnnualExclusionAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearBenefitOf?: InputMaybe<Scalars['Boolean']['input']>;
  clearCtImpliedExemptionUsed?: InputMaybe<Scalars['Boolean']['input']>;
  clearCtTaxesPaidAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDiscountAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearGiftAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearGiftCategory?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearRecipient?: InputMaybe<Scalars['Boolean']['input']>;
  /** The amount of (implied) Connecticut exemption used */
  ctImpliedExemptionUsed?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The amount of Connecticut taxes paid for this gift */
  ctTaxesPaidAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** Amount asset was discounted for exclusion */
  discountAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** The date of gifting or when the adjustment was recorded */
  eventDate?: InputMaybe<Scalars['Time']['input']>;
  /** The amount gifted to the recipient */
  giftAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  giftCategory?: InputMaybe<LifetimeExclusionEventGiftCategory>;
  grantorID?: InputMaybe<Scalars['ID']['input']>;
  /** The amount of GST exclusion this gift used */
  gstExclusionAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** Whether or not this gift is subject to Connecticut state gift taxes */
  isSubjectToCtTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** The amount of lifetime exclusion this gift used */
  lifetimeExclusionAmount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  recipientID?: InputMaybe<Scalars['ID']['input']>;
  removeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateLoggedTransferInput is used for update LoggedTransfer object.
 * Input was generated by ent.
 */
export type UpdateLoggedTransferInput = {
  addDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLifetimeExclusionEventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The amount of logged transfer. */
  amount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearLifetimeExclusionEvents?: InputMaybe<Scalars['Boolean']['input']>;
  clearOtherPurposeDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearPurpose?: InputMaybe<Scalars['Boolean']['input']>;
  clearReceivingEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearReceivingGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  clearReceivingOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom purpose if "Other" purpose is selected. */
  otherPurposeDescription?: InputMaybe<Scalars['String']['input']>;
  /** Purpose of transfer */
  purpose?: InputMaybe<LoggedTransferPurpose>;
  receivingEntityID?: InputMaybe<Scalars['ID']['input']>;
  receivingGrantorID?: InputMaybe<Scalars['ID']['input']>;
  receivingOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  removeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLifetimeExclusionEventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceEntityID?: InputMaybe<Scalars['ID']['input']>;
  sourceGrantorID?: InputMaybe<Scalars['ID']['input']>;
  sourceOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  transactionDate?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateMemoInput is used for update Memo object.
 * Input was generated by ent.
 */
export type UpdateMemoInput = {
  addDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWorkflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** User feedback for AI-generated memo quality */
  aiFeedback?: InputMaybe<Scalars['String']['input']>;
  /** User rating for AI-generated memo quality */
  aiRating?: InputMaybe<MemoAiRating>;
  clearAiFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  clearAiRating?: InputMaybe<Scalars['Boolean']['input']>;
  clearContentEncrypted?: InputMaybe<Scalars['Boolean']['input']>;
  clearDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntryMode?: InputMaybe<Scalars['Boolean']['input']>;
  clearFeedbackFrom?: InputMaybe<Scalars['Boolean']['input']>;
  clearMemoPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  clearSpecificInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  clearWorkflowTrackers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Plaintext memo content. Stored encrypted at rest. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** CMK-encrypted memo content */
  contentEncrypted?: InputMaybe<Scalars['String']['input']>;
  /** Whether the memo was AI-generated or user-authored */
  entryMode?: InputMaybe<MemoEntryMode>;
  feedbackFromID?: InputMaybe<Scalars['ID']['input']>;
  memoPromptID?: InputMaybe<Scalars['ID']['input']>;
  /** User-editable memo name */
  name?: InputMaybe<Scalars['String']['input']>;
  removeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWorkflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** User-provided instructions used for generation */
  specificInstructions?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateMissingDocumentsPageInput is used for update MissingDocumentsPage object.
 * Input was generated by ent.
 */
export type UpdateMissingDocumentsPageInput = {
  clearPresentationPage?: InputMaybe<Scalars['Boolean']['input']>;
  presentationPageID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateModelMappingInput is used for update ModelMapping object.
 * Input was generated by ent.
 */
export type UpdateModelMappingInput = {
  /** The model name (e.g. gpt-4, claud-3-opus) */
  modelName?: InputMaybe<Scalars['String']['input']>;
  modelPurpose?: InputMaybe<ModelMappingModelPurpose>;
};

/**
 * UpdateNotificationPreferenceInput is used for update NotificationPreference object.
 * Input was generated by ent.
 */
export type UpdateNotificationPreferenceInput = {
  appEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailFrequency?: InputMaybe<NotificationPreferenceEmailFrequency>;
  kind?: InputMaybe<NotificationKind>;
};

/**
 * UpdateOpenaiSdkConfigInput is used for update OpenaiSdkConfig object.
 * Input was generated by ent.
 */
export type UpdateOpenaiSdkConfigInput = {
  addModelMappingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The API key for the provider. */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** The base URL for the provider API. */
  baseURL?: InputMaybe<Scalars['String']['input']>;
  clearBaseURL?: InputMaybe<Scalars['Boolean']['input']>;
  clearModelMappings?: InputMaybe<Scalars['Boolean']['input']>;
  /** true to enable 'bring your own model provider' */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<OpenaiSdkConfigProvider>;
  removeModelMappingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateOrganizationApplicationConfigurationInput is used for update OrganizationApplicationConfiguration object.
 * Input was generated by ent.
 */
export type UpdateOrganizationApplicationConfigurationInput = {
  /** If false, USER_TEMPLATE create/duplicate/update/materialize is denied server-side. */
  allowUserPresentationTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  appendCollaboratorDomainAllowList?: InputMaybe<Array<Scalars['String']['input']>>;
  clearCollaboratorDomainAllowList?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional allowlist of email domains that can be invited as collaborators. Do not include @. */
  collaboratorDomainAllowList?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, disables advanced analytics for member tenants. */
  disableAdvancedAnalytics?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, disables all AI capabilities for member tenants. */
  disableAiCapabilities?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, disables AI insights for member tenants. */
  disableAiInsights?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, member tenants cannot create/update/delete roles; roles are org-managed. */
  disableRoleManagement?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, organization disclaimer values take precedence over member tenant and sub-brand values; empty text values fall back to descendant values. */
  disclaimerConfigurationOverridesDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, allows admins to set the employee.idp_id field via UI. */
  enableEmployeeIdpID?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum duration of a user session. */
  maxSessionDuration?: InputMaybe<OrganizationApplicationConfigurationMaxSessionDuration>;
  /** Controls the operations available through Model Context Protocol for member tenants. */
  mcpAccess?: InputMaybe<McpAccess>;
  /** Controls the review steps that client presentations in member tenants require. */
  requirePresentationApproval?: InputMaybe<PresentationApprovalRequirement>;
  /** If true, enables SmartReview for member tenants. */
  smartReviewEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** User sessions expire after this period of inactivity. */
  userSessionInactivityTimeout?: InputMaybe<OrganizationApplicationConfigurationUserSessionInactivityTimeout>;
};

/**
 * UpdateOrganizationDisclaimerConfigurationInput is used for update OrganizationDisclaimerConfiguration object.
 * Input was generated by ent.
 */
export type UpdateOrganizationDisclaimerConfigurationInput = {
  clearPresentationCoverDisclaimerBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationCoverDisclaimerTitle?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationFooterDisclaimerBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationFooterDisclaimerTitle?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationStandaloneDisclaimerBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationStandaloneDisclaimerTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, include the default Luminary company disclosures in the presentation */
  includeLuminaryDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  presentationCoverDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationCoverDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
  presentationFooterDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationFooterDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
  presentationStandaloneDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationStandaloneDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateOwnershipStakeInput is used for update OwnershipStake object.
 * Input was generated by ent.
 */
export type UpdateOwnershipStakeInput = {
  addDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnershipPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  ownedEntityID?: InputMaybe<Scalars['ID']['input']>;
  /** The percentage ownership of the underlying entity. */
  ownershipPercentage?: InputMaybe<Scalars['Percent']['input']>;
  removeDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdatePlatformDocumentInput is used for update PlatformDocument object.
 * Input was generated by ent.
 */
export type UpdatePlatformDocumentInput = {
  clearMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  clearSourceVersion?: InputMaybe<Scalars['Boolean']['input']>;
  clearStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdictionKind?: InputMaybe<PlatformDocumentJurisdictionKind>;
  /** Descriptive source context. Fields that control application behavior use typed columns. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceVersion?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<PlatformDocumentStateCode>;
};

/**
 * UpdatePresentationAssetDistributionBundleConfigurationInput is used for update PresentationAssetDistributionBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationAssetDistributionBundleConfigurationInput = {
  addDistributionItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  clearDistributionItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display label indicating the death-order context for this distribution (e.g., 'After John's death' or 'After both deaths'). */
  deathOrderDisplay?: InputMaybe<Scalars['String']['input']>;
  /** Prose description of the distribution scenario rendered beneath the page heading. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional override for the bundle's display name on the asset-distribution page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of distribution items rendered on each page. */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  removeDistributionItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdatePresentationAssetDistributionItemConfigurationInput is used for update PresentationAssetDistributionItemConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationAssetDistributionItemConfigurationInput = {
  addItemDetailIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearItemDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name of the distribution item as it should appear on the page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  removeItemDetailIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The order in which this distribution item is rendered within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationAssetDistributionItemDetailInput is used for update PresentationAssetDistributionItemDetail object.
 * Input was generated by ent.
 */
export type UpdatePresentationAssetDistributionItemDetailInput = {
  /** Body text rendered for the item. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** Short label rendered above the item body. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The order in which this item is rendered within its parent. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationBundleCoverPageInput is used for update PresentationBundleCoverPage object.
 * Input was generated by ent.
 */
export type UpdatePresentationBundleCoverPageInput = {
  /** The content of the cover page. */
  content?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdatePresentationBundleInput is used for update PresentationBundle object.
 * Input was generated by ent.
 */
export type UpdatePresentationBundleInput = {
  addPageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  assetDistributionBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  balanceSheetBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  beneficiariesBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  businessOverviewBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  clearAssetDistributionBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearBalanceSheetBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiariesBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearBusinessOverviewBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearCoverPageConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearCustomPageBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearDividerBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearDocumentsReviewedBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntitiesOverviewBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntityGraphViewBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntitySummaryBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearEstateInsightsBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearExpansionContext?: InputMaybe<Scalars['Boolean']['input']>;
  clearFamilyOverviewBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearFamilyTreeBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearHealthcareDirectiveBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearLiabilitiesBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearLifeInsuranceBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearPages?: InputMaybe<Scalars['Boolean']['input']>;
  clearPlanningOpportunitiesBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearPowerOfAttorneyBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearTemplateNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustOverviewBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearWaterfallBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearWaterfallComparisonBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearWillBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  coverPageConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  customPageBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  dividerBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  documentsReviewedBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  entitiesOverviewBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  entityGraphViewBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  entitySummaryBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  estateInsightsBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** will not be included in printed output if true */
  excludeFromOutput?: InputMaybe<Scalars['Boolean']['input']>;
  /** Per-instance context prepended to runtime page prompts for expanded bundles. */
  expansionContext?: InputMaybe<Scalars['String']['input']>;
  familyOverviewBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  familyTreeBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  healthcareDirectiveBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** The index of the bundle in the presentation */
  index?: InputMaybe<Scalars['Int']['input']>;
  liabilitiesBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  lifeInsuranceBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  planningOpportunitiesBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  powerOfAttorneyBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  removePageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Notes to advisors on how to use the bundle */
  templateNotes?: InputMaybe<Scalars['String']['input']>;
  trustOverviewBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  waterfallBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  waterfallComparisonBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  willBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdatePresentationBusinessOverviewBundleConfigurationInput is used for update PresentationBusinessOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationBusinessOverviewBundleConfigurationInput = {
  addBusinessIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearBusinesses?: InputMaybe<Scalars['Boolean']['input']>;
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional override for the bundle's display name on the business-overview page. CMK-encrypted. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of businesses rendered on each page. */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  removeBusinessIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdatePresentationBusinessOverviewBusinessConfigurationInput is used for update PresentationBusinessOverviewBusinessConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationBusinessOverviewBusinessConfigurationInput = {
  addBusinessItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearBusinessItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name of the business as it should appear on the page. CMK-encrypted. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  removeBusinessItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The order in which this business is rendered within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationBusinessOverviewItemInput is used for update PresentationBusinessOverviewItem object.
 * Input was generated by ent.
 */
export type UpdatePresentationBusinessOverviewItemInput = {
  /** Body text rendered for the item. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** Short label rendered above the item body. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The order in which this item is rendered within its parent. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationCoverPageInput is used for update PresentationCoverPage object.
 * Input was generated by ent.
 */
export type UpdatePresentationCoverPageInput = {
  clearCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  clearCustomPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  clearDisplayTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** The content of the cover page, rendered as Markdown. */
  customContent?: InputMaybe<Scalars['String']['input']>;
  /** Prompt used to generate the custom content. */
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Customizable title to display on the cover page. */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdatePresentationCoverSlideConfigInput is used for update PresentationCoverSlideConfig object.
 * Input was generated by ent.
 */
export type UpdatePresentationCoverSlideConfigInput = {
  /** Alpha blending for the background (image and color); 1.0 = fully opaque. */
  backgroundAlpha?: InputMaybe<Scalars['Float']['input']>;
  /** Hex color code for the slide background. */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Background gradient angle in degrees, from 0 to 360. */
  backgroundGradientAngle?: InputMaybe<Scalars['Float']['input']>;
  /** Hex end color for the background gradient; when null, use the existing background. */
  backgroundGradientEndColor?: InputMaybe<Scalars['String']['input']>;
  /** X coordinate (origin) of the background image on the slide. */
  backgroundImageOriginX?: InputMaybe<Scalars['Float']['input']>;
  /** Y coordinate (origin) of the background image on the slide. */
  backgroundImageOriginY?: InputMaybe<Scalars['Float']['input']>;
  /** URL pointing to an uploaded background image asset. */
  backgroundImagePath?: InputMaybe<Scalars['String']['input']>;
  /** Scale of the background image on the slide, expressed as a percentage; clamped to [50, 150]. */
  backgroundImagePercentScale?: InputMaybe<Scalars['Float']['input']>;
  /** Sanitized SVG content if the uploaded background image is an SVG. */
  backgroundImageSvgContent?: InputMaybe<Scalars['String']['input']>;
  /** Overlay opacity, from 0 (transparent) to 1 (opaque). */
  backgroundOverlayAlpha?: InputMaybe<Scalars['Float']['input']>;
  /** Overlay X origin as a percentage of slide width, from 0 to 100. */
  backgroundOverlayOriginX?: InputMaybe<Scalars['Float']['input']>;
  /** Overlay Y origin as a percentage of slide height, from 0 to 100. */
  backgroundOverlayOriginY?: InputMaybe<Scalars['Float']['input']>;
  /** URL pointing to an asset uploaded through the background image endpoint. */
  backgroundOverlayPath?: InputMaybe<Scalars['String']['input']>;
  /** Overlay scale as a percentage, from 1 to 200. */
  backgroundOverlayPercentScale?: InputMaybe<Scalars['Float']['input']>;
  /** Horizontal alignment of the body text on the slide; defaults to left-aligned. */
  bodyTextAlignment?: InputMaybe<PresentationCoverSlideConfigBodyTextAlignment>;
  /** Hex color code for the slide body text; overrides text_color for body content. */
  bodyTextColor?: InputMaybe<Scalars['String']['input']>;
  clearBackgroundAlpha?: InputMaybe<Scalars['Boolean']['input']>;
  clearBackgroundColor?: InputMaybe<Scalars['Boolean']['input']>;
  clearBackgroundGradientAngle?: InputMaybe<Scalars['Boolean']['input']>;
  clearBackgroundGradientEndColor?: InputMaybe<Scalars['Boolean']['input']>;
  clearBackgroundImageOriginX?: InputMaybe<Scalars['Boolean']['input']>;
  clearBackgroundImageOriginY?: InputMaybe<Scalars['Boolean']['input']>;
  clearBackgroundImagePath?: InputMaybe<Scalars['Boolean']['input']>;
  clearBackgroundImagePercentScale?: InputMaybe<Scalars['Boolean']['input']>;
  clearBackgroundImageSvgContent?: InputMaybe<Scalars['Boolean']['input']>;
  clearBackgroundOverlayAlpha?: InputMaybe<Scalars['Boolean']['input']>;
  clearBackgroundOverlayOriginX?: InputMaybe<Scalars['Boolean']['input']>;
  clearBackgroundOverlayOriginY?: InputMaybe<Scalars['Boolean']['input']>;
  clearBackgroundOverlayPath?: InputMaybe<Scalars['Boolean']['input']>;
  clearBackgroundOverlayPercentScale?: InputMaybe<Scalars['Boolean']['input']>;
  clearBodyTextAlignment?: InputMaybe<Scalars['Boolean']['input']>;
  clearBodyTextColor?: InputMaybe<Scalars['Boolean']['input']>;
  clearDividerInheritCover?: InputMaybe<Scalars['Boolean']['input']>;
  clearDividerInheritCoverBackgroundAlpha?: InputMaybe<Scalars['Boolean']['input']>;
  clearDividerInheritCoverBackgroundColor?: InputMaybe<Scalars['Boolean']['input']>;
  clearDividerInheritCoverBackgroundImagePath?: InputMaybe<Scalars['Boolean']['input']>;
  clearDividerInheritCoverBackgroundImageSvgContent?: InputMaybe<Scalars['Boolean']['input']>;
  clearDividerInheritCoverHeaderTextSize?: InputMaybe<Scalars['Boolean']['input']>;
  clearDividerInheritCoverIncludeFooter?: InputMaybe<Scalars['Boolean']['input']>;
  clearDividerInheritCoverLogoPosition?: InputMaybe<Scalars['Boolean']['input']>;
  clearDividerInheritCoverLogoSize?: InputMaybe<Scalars['Boolean']['input']>;
  clearDividerInheritCoverTextColor?: InputMaybe<Scalars['Boolean']['input']>;
  clearFooterColor?: InputMaybe<Scalars['Boolean']['input']>;
  clearHeaderTextSize?: InputMaybe<Scalars['Boolean']['input']>;
  clearHideLogo?: InputMaybe<Scalars['Boolean']['input']>;
  clearIncludeFooter?: InputMaybe<Scalars['Boolean']['input']>;
  clearLogoOriginX?: InputMaybe<Scalars['Boolean']['input']>;
  clearLogoOriginY?: InputMaybe<Scalars['Boolean']['input']>;
  clearLogoPercentScale?: InputMaybe<Scalars['Boolean']['input']>;
  clearLogoPosition?: InputMaybe<Scalars['Boolean']['input']>;
  clearLogoSize?: InputMaybe<Scalars['Boolean']['input']>;
  clearTextColor?: InputMaybe<Scalars['Boolean']['input']>;
  clearTextOriginX?: InputMaybe<Scalars['Boolean']['input']>;
  clearTextOriginY?: InputMaybe<Scalars['Boolean']['input']>;
  clearTextWidth?: InputMaybe<Scalars['Boolean']['input']>;
  clearTitleSizeRem?: InputMaybe<Scalars['Boolean']['input']>;
  clearTitleTextSize?: InputMaybe<Scalars['Boolean']['input']>;
  clearUseDarkLogo?: InputMaybe<Scalars['Boolean']['input']>;
  clearUseDefaultLogoPosition?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the divider slide inherits all visual configuration from the cover slide. */
  dividerInheritCover?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide background alpha. */
  dividerInheritCoverBackgroundAlpha?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide background color. */
  dividerInheritCoverBackgroundColor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide background image path. */
  dividerInheritCoverBackgroundImagePath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide background image SVG content. */
  dividerInheritCoverBackgroundImageSvgContent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide header text size. */
  dividerInheritCoverHeaderTextSize?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide include footer setting. */
  dividerInheritCoverIncludeFooter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide logo position. */
  dividerInheritCoverLogoPosition?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide logo size. */
  dividerInheritCoverLogoSize?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated: use divider_inherit_cover. Whether the divider slide inherits the cover slide text color. */
  dividerInheritCoverTextColor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hex color code for the footer; when null, use the existing footer color. */
  footerColor?: InputMaybe<Scalars['String']['input']>;
  /** Size of the header text on the slide. */
  headerTextSize?: InputMaybe<PresentationCoverSlideConfigHeaderTextSize>;
  /** Whether to hide the logo on the slide; defaults to false. */
  hideLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to include the footer on the slide; defaults to true. */
  includeFooter?: InputMaybe<Scalars['Boolean']['input']>;
  /** X coordinate (origin) of the logo on the slide. */
  logoOriginX?: InputMaybe<Scalars['Float']['input']>;
  /** Y coordinate (origin) of the logo on the slide. */
  logoOriginY?: InputMaybe<Scalars['Float']['input']>;
  /** Scale of the logo on the slide, expressed as a percentage; clamped to [1, 200]. */
  logoPercentScale?: InputMaybe<Scalars['Float']['input']>;
  /** Deprecated: use logo_origin_x/logo_origin_y and use_default_logo_position. Position of the logo on the slide. */
  logoPosition?: InputMaybe<PresentationCoverSlideConfigLogoPosition>;
  /** Deprecated: use logo_percent_scale. Size of the logo on the slide. */
  logoSize?: InputMaybe<PresentationCoverSlideConfigLogoSize>;
  /** Hex color code for the slide text. */
  textColor?: InputMaybe<Scalars['String']['input']>;
  /** X coordinate (origin) of the text on the slide. */
  textOriginX?: InputMaybe<Scalars['Float']['input']>;
  /** Y coordinate (origin) of the text on the slide. */
  textOriginY?: InputMaybe<Scalars['Float']['input']>;
  /** Width of the text box on the slide, in the same slide-coordinate pixels as text_origin_x; when null, the text box fills the slide width. */
  textWidth?: InputMaybe<Scalars['Float']['input']>;
  /** Size of the title text on the slide, expressed in rem units; clamped to [0.1, 5.5]; overrides title_text_size when set. */
  titleSizeRem?: InputMaybe<Scalars['Float']['input']>;
  /** Size of the title text on the slide. */
  titleTextSize?: InputMaybe<PresentationCoverSlideConfigTitleTextSize>;
  /** Whether to use the dark logo; when null, use the existing logo selection. */
  useDarkLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to use the default logo position on the slide; when true, logo_origin_x and logo_origin_y are ignored. */
  useDefaultLogoPosition?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdatePresentationCustomPageBundleConfigurationInput is used for update PresentationCustomPageBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationCustomPageBundleConfigurationInput = {
  clearPageHeader?: InputMaybe<Scalars['Boolean']['input']>;
  clearPageSubheader?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the page header and sub-header will be included on the page. */
  includePageHeader?: InputMaybe<Scalars['Boolean']['input']>;
  /** The header to display on the page. */
  pageHeader?: InputMaybe<Scalars['String']['input']>;
  /** The sub-header to display on the page. */
  pageSubheader?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdatePresentationCustomPageInput is used for update PresentationCustomPage object.
 * Input was generated by ent.
 */
export type UpdatePresentationCustomPageInput = {
  clearCustomPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Prompt used to generate the page content. */
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  /** The content of a MARKDOWN custom page, rendered as Markdown. CANVAS pages store an empty string. */
  pageContent?: InputMaybe<Scalars['String']['input']>;
  /** The title to display on the custom page. */
  pageName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdatePresentationDiagramPageInput is used for update PresentationDiagramPage object.
 * Input was generated by ent.
 */
export type UpdatePresentationDiagramPageInput = {
  appendEdgeDefinitions?: InputMaybe<Array<PresentationDiagramEdgeDefinitionInput>>;
  appendNodeConfigurations?: InputMaybe<Array<PresentationDiagramNodeConfigurationInput>>;
  clearCustomPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  clearPhases?: InputMaybe<Scalars['Boolean']['input']>;
  /** Prompt used to generate/update the diagram. */
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Canonical edge definitions for the diagram graph. */
  edgeDefinitions?: InputMaybe<Array<PresentationDiagramEdgeDefinitionInput>>;
  /** Canonical node definitions plus layout settings for the diagram graph. */
  nodeConfigurations?: InputMaybe<Array<PresentationDiagramNodeConfigurationInput>>;
  /** The title to display on the diagram page. */
  pageName?: InputMaybe<Scalars['String']['input']>;
  /** Optional life-event eras (phase bands) structuring the diagram top-to-bottom. */
  phases?: InputMaybe<PresentationDiagramPhasesInput>;
};

/**
 * UpdatePresentationDocumentsReviewedBundleConfigurationInput is used for update PresentationDocumentsReviewedBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationDocumentsReviewedBundleConfigurationInput = {
  addReviewedDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  clearReviewedDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional override for the bundle's display name on the documents-reviewed page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  removeReviewedDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdatePresentationDocumentsReviewedDocumentInput is used for update PresentationDocumentsReviewedDocument object.
 * Input was generated by ent.
 */
export type UpdatePresentationDocumentsReviewedDocumentInput = {
  clearDocument?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pre-formatted date label rendered alongside the document name. */
  dateDisplay?: InputMaybe<Scalars['String']['input']>;
  documentID?: InputMaybe<Scalars['ID']['input']>;
  /** The display name of the reviewed document. */
  documentName?: InputMaybe<Scalars['String']['input']>;
  /** The order in which this document should be displayed within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationFamilyOverviewBundleConfigurationInput is used for update PresentationFamilyOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationFamilyOverviewBundleConfigurationInput = {
  addMemberIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  clearMembers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional override for the bundle's display name on the family-overview page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  removeMemberIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdatePresentationFamilyOverviewMemberConfigurationInput is used for update PresentationFamilyOverviewMemberConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationFamilyOverviewMemberConfigurationInput = {
  /** A short prose description of the family member rendered beneath the name and relationship. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The display name of the family member as it should appear on the page. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The family member's relationship to the household (e.g., 'Spouse', 'Daughter'). */
  relationship?: InputMaybe<Scalars['String']['input']>;
  /** The order in which this family member is rendered within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationHealthcareDirectiveBundleConfigurationInput is used for update PresentationHealthcareDirectiveBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationHealthcareDirectiveBundleConfigurationInput = {
  addClientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearClients?: InputMaybe<Scalars['Boolean']['input']>;
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional override for the bundle's display name on the healthcare-directive page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of clients rendered on each page. */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  removeClientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdatePresentationHealthcareDirectiveClientConfigurationInput is used for update PresentationHealthcareDirectiveClientConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationHealthcareDirectiveClientConfigurationInput = {
  addHealthcareDirectiveItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearHealthcareDirectiveItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name of the client as it should appear on the page. */
  client?: InputMaybe<Scalars['String']['input']>;
  removeHealthcareDirectiveItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The order in which this client is rendered within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationHealthcareDirectiveItemInput is used for update PresentationHealthcareDirectiveItem object.
 * Input was generated by ent.
 */
export type UpdatePresentationHealthcareDirectiveItemInput = {
  /** Body text rendered for the item. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** Short label rendered above the item body. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The order in which this item is rendered within its parent. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationItemCitationInput is used for update PresentationItemCitation object.
 * Input was generated by ent.
 */
export type UpdatePresentationItemCitationInput = {
  addFileParagraphIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearFileParagraphs?: InputMaybe<Scalars['Boolean']['input']>;
  removeFileParagraphIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdatePresentationPageInput is used for update PresentationPage object.
 * Input was generated by ent.
 */
export type UpdatePresentationPageInput = {
  activeEstateInsightsPageID?: InputMaybe<Scalars['ID']['input']>;
  balanceSheetBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  beneficiaryPageID?: InputMaybe<Scalars['ID']['input']>;
  clearActiveEstateInsightsPage?: InputMaybe<Scalars['Boolean']['input']>;
  clearBalanceSheetBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  clearCompletedEstateInsightsPage?: InputMaybe<Scalars['Boolean']['input']>;
  clearCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  clearCustomPage?: InputMaybe<Scalars['Boolean']['input']>;
  clearDiagramPage?: InputMaybe<Scalars['Boolean']['input']>;
  clearDocumentSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  clearMissingDocumentsPage?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationBundleCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  clearWaterfallBundleCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  completedEstateInsightsPageID?: InputMaybe<Scalars['ID']['input']>;
  coverPageID?: InputMaybe<Scalars['ID']['input']>;
  customPageID?: InputMaybe<Scalars['ID']['input']>;
  diagramPageID?: InputMaybe<Scalars['ID']['input']>;
  documentSummaryPageID?: InputMaybe<Scalars['ID']['input']>;
  /** The index of the page in the bundle */
  index?: InputMaybe<Scalars['Int']['input']>;
  missingDocumentsPageID?: InputMaybe<Scalars['ID']['input']>;
  presentationBundleCoverPageID?: InputMaybe<Scalars['ID']['input']>;
  waterfallBundleCoverPageID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdatePresentationPlanningOpportunitiesBundleConfigurationInput is used for update PresentationPlanningOpportunitiesBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationPlanningOpportunitiesBundleConfigurationInput = {
  addItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  clearItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional override for the bundle's display name on the planning-opportunities page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  removeItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdatePresentationPlanningOpportunitiesItemInput is used for update PresentationPlanningOpportunitiesItem object.
 * Input was generated by ent.
 */
export type UpdatePresentationPlanningOpportunitiesItemInput = {
  /** DEPRECATED: use the section-specific *_body fields instead. */
  body?: InputMaybe<Scalars['String']['input']>;
  clearBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearLabel?: InputMaybe<Scalars['Boolean']['input']>;
  clearNextStepBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearNextStepLabel?: InputMaybe<Scalars['Boolean']['input']>;
  clearOpportunityBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearOpportunityLabel?: InputMaybe<Scalars['Boolean']['input']>;
  clearRationaleBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearRationaleLabel?: InputMaybe<Scalars['Boolean']['input']>;
  /** DEPRECATED: use the section-specific *_label fields instead. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Body text for the next step section of the item. */
  nextStepBody?: InputMaybe<Scalars['String']['input']>;
  /** Short label for the next step section of the item. */
  nextStepLabel?: InputMaybe<Scalars['String']['input']>;
  /** Body text for the opportunity section of the item. */
  opportunityBody?: InputMaybe<Scalars['String']['input']>;
  /** Short label for the opportunity section of the item. */
  opportunityLabel?: InputMaybe<Scalars['String']['input']>;
  /** Body text for the rationale section of the item. */
  rationaleBody?: InputMaybe<Scalars['String']['input']>;
  /** Short label for the rationale section of the item. */
  rationaleLabel?: InputMaybe<Scalars['String']['input']>;
  /** The order in which this item is rendered within its parent. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationPowerOfAttorneyBundleConfigurationInput is used for update PresentationPowerOfAttorneyBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationPowerOfAttorneyBundleConfigurationInput = {
  addClientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearClients?: InputMaybe<Scalars['Boolean']['input']>;
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional override for the bundle's display name on the powers-of-attorney page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of clients rendered on each page. */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  removeClientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdatePresentationPowerOfAttorneyClientConfigurationInput is used for update PresentationPowerOfAttorneyClientConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationPowerOfAttorneyClientConfigurationInput = {
  addPowerOfAttorneyItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearPowerOfAttorneyItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name of the client as it should appear on the page. */
  client?: InputMaybe<Scalars['String']['input']>;
  removePowerOfAttorneyItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The order in which this client is rendered within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationPowerOfAttorneyItemInput is used for update PresentationPowerOfAttorneyItem object.
 * Input was generated by ent.
 */
export type UpdatePresentationPowerOfAttorneyItemInput = {
  /** Body text rendered for the item. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** Short label rendered above the item body. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The order in which this item is rendered within its parent. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationTemplateBundleInput is used for update PresentationTemplateBundle object.
 * Input was generated by ent.
 */
export type UpdatePresentationTemplateBundleInput = {
  addPageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRuntimeBundleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Firm-authored instructions appended to the built-in AI generation prompt for this bundle. Only DIAGRAM_BUNDLE (the Estate 360 asset distribution diagram) reads this value. */
  additionalPromptContext?: InputMaybe<Scalars['String']['input']>;
  beneficiariesTemplateBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  clearAdditionalPromptContext?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiariesTemplateBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearDividerTemplateBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearDocumentSummaryTemplateBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntitySummaryTemplateBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearExpansionPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  clearInsightsTemplateBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearPages?: InputMaybe<Scalars['Boolean']['input']>;
  clearRuntimeBundles?: InputMaybe<Scalars['Boolean']['input']>;
  clearTemplateNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearWaterfallComparisonTemplateBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearWaterfallTemplateBundleConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  dividerTemplateBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  documentSummaryTemplateBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  entitySummaryTemplateBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  /** will not be included in printed output if true */
  excludeFromOutput?: InputMaybe<Scalars['Boolean']['input']>;
  /** Controls whether the template bundle expands into one runtime bundle or a planned set of runtime bundles. */
  expansionMode?: InputMaybe<PresentationTemplateBundleExpansionMode>;
  /** Instructions for planning 0..N runtime bundle instances when expansion_mode is PLANNED. */
  expansionPrompt?: InputMaybe<Scalars['String']['input']>;
  /** The index of the bundle in the presentation */
  index?: InputMaybe<Scalars['Int']['input']>;
  insightsTemplateBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<PresentationBundleKind>;
  removePageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRuntimeBundleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Notes to advisors on how to use the bundle */
  templateNotes?: InputMaybe<Scalars['String']['input']>;
  waterfallComparisonTemplateBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  waterfallTemplateBundleConfigurationID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdatePresentationTemplateCoverPageInput is used for update PresentationTemplateCoverPage object.
 * Input was generated by ent.
 */
export type UpdatePresentationTemplateCoverPageInput = {
  clearCustomContent?: InputMaybe<Scalars['Boolean']['input']>;
  clearCustomPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  clearDisplayTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** The content of the cover page, rendered as Markdown. */
  customContent?: InputMaybe<Scalars['String']['input']>;
  /** Prompt used to generate the custom content. */
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Customizable title to display on the cover page. */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdatePresentationTemplateCustomPageInput is used for update PresentationTemplateCustomPage object.
 * Input was generated by ent.
 */
export type UpdatePresentationTemplateCustomPageInput = {
  clearCustomPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  clearIncludePageHeader?: InputMaybe<Scalars['Boolean']['input']>;
  clearPageSubheader?: InputMaybe<Scalars['Boolean']['input']>;
  /** Prompt used to generate the page content. */
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include the page header on the custom page. */
  includePageHeader?: InputMaybe<Scalars['Boolean']['input']>;
  /** The content of a MARKDOWN custom page, rendered as Markdown. CANVAS pages store an empty string. */
  pageContent?: InputMaybe<Scalars['String']['input']>;
  /** The header to display on the custom page. */
  pageHeader?: InputMaybe<Scalars['String']['input']>;
  /** The title to display on the custom page. */
  pageName?: InputMaybe<Scalars['String']['input']>;
  /** The subheader to display on the custom page. */
  pageSubheader?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdatePresentationTemplateDiagramPageInput is used for update PresentationTemplateDiagramPage object.
 * Input was generated by ent.
 */
export type UpdatePresentationTemplateDiagramPageInput = {
  clearCustomPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Prompt used to generate the diagram when materializing this template. */
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  /** The title to display on the diagram page. */
  pageName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdatePresentationTemplateInput is used for update PresentationTemplate object.
 * Input was generated by ent.
 */
export type UpdatePresentationTemplateInput = {
  addBundleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearBundles?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Whether this template is the tenant's default presentation template. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this template is available as a pinned presentation template. */
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  removeBundleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdatePresentationTemplatePageInput is used for update PresentationTemplatePage object.
 * Input was generated by ent.
 */
export type UpdatePresentationTemplatePageInput = {
  clearCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  clearCustomPage?: InputMaybe<Scalars['Boolean']['input']>;
  clearDiagramPage?: InputMaybe<Scalars['Boolean']['input']>;
  coverPageID?: InputMaybe<Scalars['ID']['input']>;
  customPageID?: InputMaybe<Scalars['ID']['input']>;
  diagramPageID?: InputMaybe<Scalars['ID']['input']>;
  /** The index of the page in the bundle */
  index?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationTrustOverviewBundleConfigurationInput is used for update PresentationTrustOverviewBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationTrustOverviewBundleConfigurationInput = {
  addTrustIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrusts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional override for the bundle's display name on the trust-overview page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of trusts rendered on each page. */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  removeTrustIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdatePresentationTrustOverviewItemInput is used for update PresentationTrustOverviewItem object.
 * Input was generated by ent.
 */
export type UpdatePresentationTrustOverviewItemInput = {
  /** Body text rendered for the item. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** Short label rendered above the item body. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The order in which this item is rendered within its parent. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationTrustOverviewTrustConfigurationInput is used for update PresentationTrustOverviewTrustConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationTrustOverviewTrustConfigurationInput = {
  addTrustItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearTrustItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name of the trust as it should appear on the page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  removeTrustItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The order in which this trust is rendered within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationWillBundleConfigurationInput is used for update PresentationWillBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationWillBundleConfigurationInput = {
  addClientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearClients?: InputMaybe<Scalars['Boolean']['input']>;
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional override for the bundle's display name on the wills page. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of clients rendered on each page. */
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  removeClientIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdatePresentationWillClientConfigurationInput is used for update PresentationWillClientConfiguration object.
 * Input was generated by ent.
 */
export type UpdatePresentationWillClientConfigurationInput = {
  addWillItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearWillItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name of the client as it should appear on the page. */
  client?: InputMaybe<Scalars['String']['input']>;
  removeWillItemIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The order in which this client is rendered within the bundle. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePresentationWillItemInput is used for update PresentationWillItem object.
 * Input was generated by ent.
 */
export type UpdatePresentationWillItemInput = {
  /** Body text rendered for the item. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** Short label rendered above the item body. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** The order in which this item is rendered within its parent. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdatePrincipalInput is used for update Principal object.
 * Input was generated by ent.
 */
export type UpdatePrincipalInput = {
  clearOwnershipPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The percentage ownership of the underlying entity, funded by these principals.
   * 			Typically only valid for multiple ownership, non-trust non-charitable entities (eg: LLC, LP, ...)
   */
  ownershipPercentage?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * UpdatePrivateFoundationInput is used for update PrivateFoundation object.
 * Input was generated by ent.
 */
export type UpdatePrivateFoundationInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDonorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearDonors?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDonorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
};

/**
 * UpdateProfessionalTeamRoleInput is used for update ProfessionalTeamRole object.
 * Input was generated by ent.
 */
export type UpdateProfessionalTeamRoleInput = {
  associatedClientIndividualID?: InputMaybe<Scalars['ID']['input']>;
  clearAssociatedClientIndividual?: InputMaybe<Scalars['Boolean']['input']>;
  clearOtherRoleName?: InputMaybe<Scalars['Boolean']['input']>;
  clearPowerOfAttorneyKind?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<ProfessionalTeamRoleKind>;
  /** If the kind is OTHER, this is the custom role name */
  otherRoleName?: InputMaybe<Scalars['String']['input']>;
  /** If the kind is POWER_OF_ATTORNEY, this is the type of power of attorney */
  powerOfAttorneyKind?: InputMaybe<ProfessionalTeamRolePowerOfAttorneyKind>;
};

/**
 * UpdateProposalInput is used for update Proposal object.
 * Input was generated by ent.
 */
export type UpdateProposalInput = {
  addEntityProposalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearCltProposal?: InputMaybe<Scalars['Boolean']['input']>;
  clearCrtProposal?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntityProposals?: InputMaybe<Scalars['Boolean']['input']>;
  clearGiftingProposal?: InputMaybe<Scalars['Boolean']['input']>;
  /** notes to the client that accompany the proposal */
  clientNotes?: InputMaybe<Scalars['String']['input']>;
  cltProposalID?: InputMaybe<Scalars['ID']['input']>;
  crtProposalID?: InputMaybe<Scalars['ID']['input']>;
  /** the user-friendly name of the proposal */
  displayName?: InputMaybe<Scalars['String']['input']>;
  giftingProposalID?: InputMaybe<Scalars['ID']['input']>;
  /** whether or not to include a "cumulative view" tab on the proposal */
  includeCumulativeView?: InputMaybe<Scalars['Boolean']['input']>;
  removeEntityProposalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateProposalScenarioInput is used for update ProposalScenario object.
 * Input was generated by ent.
 */
export type UpdateProposalScenarioInput = {
  clearGratProposalScenario?: InputMaybe<Scalars['Boolean']['input']>;
  gratProposalScenarioID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateQPRTTrustInput is used for update QPRTTrust object.
 * Input was generated by ent.
 */
export type UpdateQprtTrustInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOfficialInterestRatePercent?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxableGift?: InputMaybe<Scalars['Boolean']['input']>;
  clearTermDurationYears?: InputMaybe<Scalars['Boolean']['input']>;
  clearTerminationDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustJurisdictionStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  officialInterestRatePercent?: InputMaybe<Scalars['Percent']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  /** The actual taxable gift that was recorded for this QPRT */
  taxableGift?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  termDurationYears?: InputMaybe<Scalars['Int']['input']>;
  terminationDate?: InputMaybe<Scalars['Time']['input']>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateQualifiedTuitionPersonalAccountInput is used for update QualifiedTuitionPersonalAccount object.
 * Input was generated by ent.
 */
export type UpdateQualifiedTuitionPersonalAccountInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwner?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
};

/**
 * UpdateRetirementPersonalAccountInput is used for update RetirementPersonalAccount object.
 * Input was generated by ent.
 */
export type UpdateRetirementPersonalAccountInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryDesignationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalBeneficiaryDesignationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The time at which the account's beneficiary designations were last reviewed/acknowledged. Used to suppress the 'no beneficiary designations' badge for accounts where the user has confirmed the empty state is intentional. */
  beneficiaryDesignationsReviewedAt?: InputMaybe<Scalars['Time']['input']>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaryDesignationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaryDesignationsReviewedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  clearCustodian?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalBeneficiaryDesignationGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwner?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearType?: InputMaybe<Scalars['Boolean']['input']>;
  /** The custodian institution that holds this retirement account. */
  custodian?: InputMaybe<Scalars['String']['input']>;
  /** Description for this personal account */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryDesignationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalBeneficiaryDesignationGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
  type?: InputMaybe<RetirementPersonalAccountType>;
};

/**
 * UpdateRevocableTrustInput is used for update RevocableTrust object.
 * Input was generated by ent.
 */
export type UpdateRevocableTrustInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrantors?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustJurisdictionStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGrantorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateRoleInput is used for update Role object.
 * Input was generated by ent.
 */
export type UpdateRoleInput = {
  addCapabilityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addCollaboratorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEmployeeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearCapabilities?: InputMaybe<Scalars['Boolean']['input']>;
  clearCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
  clearEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * ADMINISTRATOR roles are assigned to administrators, and are not editable.
   * COLLABORATOR roles are assigned to collaborators, and are not editable.
   * CUSTOM roles are editable, even the initially-populated roles.
   */
  kind?: InputMaybe<RoleKind>;
  removeCapabilityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeCollaboratorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEmployeeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateSCorpBusinessEntityInput is used for update SCorpBusinessEntity object.
 * Input was generated by ent.
 */
export type UpdateSCorpBusinessEntityInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKeyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearDoingBusinessAsName?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearEnableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  clearFinCenID?: InputMaybe<Scalars['Boolean']['input']>;
  clearFormationJurisdictionStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearKeyPeople?: InputMaybe<Scalars['Boolean']['input']>;
  clearKeyPeopleNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnershipAsOfDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearRequiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxID?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this business entity */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Ownership as-of date. */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKeyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
};

/**
 * UpdateSLATTrustInput is used for update SLATTrust object.
 * Input was generated by ent.
 */
export type UpdateSlatTrustInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLifetimeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRemainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrantor?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearLifetimeBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearPolicies?: InputMaybe<Scalars['Boolean']['input']>;
  clearRemainderBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustJurisdictionStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this trust */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  /** Display name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  grantorID?: InputMaybe<Scalars['ID']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLifetimeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePolicyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRemainderBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxStatus?: InputMaybe<TrustTaxStatus>;
  /** State code for the jurisdiction of this trust. Can also be 'OFFSHORE' if formed outside of the United States. */
  trustJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateSSOConnectionInput is used for update SSOConnection object.
 * Input was generated by ent.
 */
export type UpdateSsoConnectionInput = {
  addConfiguredTenantIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  appendBoundEmailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of email domains that are allowed to use this SSO connection. Do not include the @ symbol. */
  boundEmailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  clearConfiguredTenants?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special designator for the Luminary sso connection */
  isLuminary?: InputMaybe<Scalars['Boolean']['input']>;
  removeConfiguredTenantIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The ID of the WorkOS organization this SSO connection corresponds to. */
  workosOrganizationID?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateScheduledDistributionInput is used for update ScheduledDistribution object.
 * Input was generated by ent.
 */
export type UpdateScheduledDistributionInput = {
  /** The end of the age requirement for this distribution */
  ageRequirementEnd?: InputMaybe<Scalars['Int']['input']>;
  /** The start of the age requirement for this distribution */
  ageRequirementStart?: InputMaybe<Scalars['Int']['input']>;
  /** The AMOUNT kind of distribution. Only valid when kind is AMOUNT */
  amount?: InputMaybe<Scalars['CurrencyUSD']['input']>;
  beneficiaryID?: InputMaybe<Scalars['ID']['input']>;
  clearAgeRequirementEnd?: InputMaybe<Scalars['Boolean']['input']>;
  clearAgeRequirementStart?: InputMaybe<Scalars['Boolean']['input']>;
  clearAmount?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  clearFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  clearPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  clearScheduledDistributionNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** The frequency of the distribution to beneficiaries */
  frequency?: InputMaybe<ScheduledDistributionFrequency>;
  /** If true, the distribution will grow by the inflation rate specified in the growth profile.Only applicable if the distribution is kind AMOUNT. */
  growByInflation?: InputMaybe<Scalars['Boolean']['input']>;
  /** The kind of scheduled distribution */
  kind?: InputMaybe<ScheduledDistributionKind>;
  /** The percentage of the distribution. Only valid when kind is PERCENTAGE or ALL_INCOME */
  percentage?: InputMaybe<Scalars['Percent']['input']>;
  /** The notes for the scheduled distribution */
  scheduledDistributionNotes?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateSoleProprietorshipBusinessEntityInput is used for update SoleProprietorshipBusinessEntity object.
 * Input was generated by ent.
 */
export type UpdateSoleProprietorshipBusinessEntityInput = {
  addAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKeyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDesignerAccount?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearDoingBusinessAsName?: InputMaybe<Scalars['Boolean']['input']>;
  clearEffectiveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearEnableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  clearFinCenID?: InputMaybe<Scalars['Boolean']['input']>;
  clearFormationJurisdictionStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearKeyPeople?: InputMaybe<Scalars['Boolean']['input']>;
  clearKeyPeopleNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegalName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnershipAsOfDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearRequiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxID?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this business entity */
  description?: InputMaybe<Scalars['String']['input']>;
  designerAccountID?: InputMaybe<Scalars['ID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The name with which the entity is doing business as. */
  doingBusinessAsName?: InputMaybe<Scalars['String']['input']>;
  /** Effective date. */
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  /** When true, this enables tax exposure for real and tangible personal property of the assets held within the business. */
  enableRealTppTaxExposure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the entity has already been created and is in effect */
  entityExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  finCenID?: InputMaybe<Scalars['String']['input']>;
  /** State code for the formation jurisdiction of this business entity. Can also be 'OFFSHORE' if formed outside of the United States. */
  formationJurisdictionStateCode?: InputMaybe<Scalars['String']['input']>;
  /** Notes for Key People associated with this business entity */
  keyPeopleNotes?: InputMaybe<Scalars['String']['input']>;
  /** Legal name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Ownership as-of date. */
  ownershipAsOfDate?: InputMaybe<Scalars['Time']['input']>;
  removeAccountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKeyPersonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Corporate Transparency Act (CTA) is a law passed in 2021 that requires certain companies to report information about their beneficial owners to the Financial Crimes Enforcement Network (FinCEN). */
  requiresCtaReporting?: InputMaybe<Scalars['Boolean']['input']>;
  /** The percentage by which assets are discounted for tax purposes. */
  taxDiscount?: InputMaybe<Scalars['Percent']['input']>;
  taxID?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<BusinessEntityTaxStatus>;
};

/**
 * UpdateSubBrandDisclaimerConfigurationInput is used for update SubBrandDisclaimerConfiguration object.
 * Input was generated by ent.
 */
export type UpdateSubBrandDisclaimerConfigurationInput = {
  clearPresentationCoverDisclaimerBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationCoverDisclaimerTitle?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationFooterDisclaimerBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationFooterDisclaimerTitle?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationStandaloneDisclaimerBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationStandaloneDisclaimerTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, include the default Luminary company disclosures in the presentation */
  includeLuminaryDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  presentationCoverDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationCoverDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
  presentationFooterDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationFooterDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
  presentationStandaloneDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationStandaloneDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
  subBrandID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateSubBrandInput is used for update SubBrand object.
 * Input was generated by ent.
 */
export type UpdateSubBrandInput = {
  addHouseholdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  buttonsLinkColor?: InputMaybe<Scalars['String']['input']>;
  clearDarkSquareLogoURL?: InputMaybe<Scalars['Boolean']['input']>;
  clearDarkWideLogoURL?: InputMaybe<Scalars['Boolean']['input']>;
  clearDataVisualizationNegativeColor?: InputMaybe<Scalars['Boolean']['input']>;
  clearDataVisualizationTertiaryColor?: InputMaybe<Scalars['Boolean']['input']>;
  clearDisclaimerConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  clearHouseholds?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationCoverSlideConfig?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationDividerSlideConfig?: InputMaybe<Scalars['Boolean']['input']>;
  darkSquareLogoURL?: InputMaybe<Scalars['String']['input']>;
  darkWideLogoURL?: InputMaybe<Scalars['String']['input']>;
  dataVisualizationNegativeColor?: InputMaybe<Scalars['String']['input']>;
  dataVisualizationPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  dataVisualizationSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  dataVisualizationTertiaryColor?: InputMaybe<Scalars['String']['input']>;
  disclaimerConfigurationID?: InputMaybe<Scalars['ID']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  logoURL?: InputMaybe<Scalars['String']['input']>;
  presentationCoverSlideConfigID?: InputMaybe<Scalars['ID']['input']>;
  presentationDividerSlideConfigID?: InputMaybe<Scalars['ID']['input']>;
  /** Font face for presentation headers and cover/divider slides. */
  presentationHeaderFontFace?: InputMaybe<PresentationHeaderFontFace>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  removeHouseholdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateTaxDragConfigInput is used for update TaxDragConfig object.
 * Input was generated by ent.
 */
export type UpdateTaxDragConfigInput = {
  /** The method used to determine the tax drag percentage. */
  calculationMethod?: InputMaybe<TaxDragConfigCalculationMethod>;
  clearFederalIncomeTaxRate?: InputMaybe<Scalars['Boolean']['input']>;
  clearFederalLongTermCapitalGainsRate?: InputMaybe<Scalars['Boolean']['input']>;
  clearLongTermCapitalGainReturnPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrdinaryIncomeReturnPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  clearQualifiedDividendReturnPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  clearStateIncomeTaxRate?: InputMaybe<Scalars['Boolean']['input']>;
  clearStateLongTermCapitalGainsRate?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxFreeIncomeReturnPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  /** The federal ordinary income tax rate used for a computed tax drag. */
  federalIncomeTaxRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The federal long-term capital gains tax rate used for a computed tax drag. */
  federalLongTermCapitalGainsRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The share of investment return treated as long-term capital gains. */
  longTermCapitalGainReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** Whether the computed tax drag includes net investment income tax. */
  niitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The share of investment return treated as ordinary income. */
  ordinaryIncomeReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** The share of investment return treated as qualified dividends. */
  qualifiedDividendReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** The state ordinary income tax rate used for a computed tax drag. */
  stateIncomeTaxRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The state long-term capital gains tax rate used for a computed tax drag. */
  stateLongTermCapitalGainsRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The manual or server-computed effective tax drag percentage. */
  taxDragPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** The share of investment return treated as tax-free income. */
  taxFreeIncomeReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * UpdateTaxDragOverrideInput is used for update TaxDragOverride object.
 * Input was generated by ent.
 */
export type UpdateTaxDragOverrideInput = {
  /** The method used to determine the tax drag percentage. */
  calculationMethod?: InputMaybe<TaxDragOverrideCalculationMethod>;
  clearFederalIncomeTaxRate?: InputMaybe<Scalars['Boolean']['input']>;
  clearFederalLongTermCapitalGainsRate?: InputMaybe<Scalars['Boolean']['input']>;
  clearLongTermCapitalGainReturnPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrdinaryIncomeReturnPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  clearQualifiedDividendReturnPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  clearStateIncomeTaxRate?: InputMaybe<Scalars['Boolean']['input']>;
  clearStateLongTermCapitalGainsRate?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxFreeIncomeReturnPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  /** The federal ordinary income tax rate used for a computed tax drag. */
  federalIncomeTaxRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The federal long-term capital gains tax rate used for a computed tax drag. */
  federalLongTermCapitalGainsRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The share of investment return treated as long-term capital gains. */
  longTermCapitalGainReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** Whether the computed tax drag includes net investment income tax. */
  niitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The share of investment return treated as ordinary income. */
  ordinaryIncomeReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** The share of investment return treated as qualified dividends. */
  qualifiedDividendReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** The state ordinary income tax rate used for a computed tax drag. */
  stateIncomeTaxRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The state long-term capital gains tax rate used for a computed tax drag. */
  stateLongTermCapitalGainsRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The manual or server-computed effective tax drag percentage. */
  taxDragPercentage?: InputMaybe<Scalars['Percent']['input']>;
  /** The share of investment return treated as tax-free income. */
  taxFreeIncomeReturnPercentage?: InputMaybe<Scalars['Percent']['input']>;
};

/**
 * UpdateTeamInput is used for update Team object.
 * Input was generated by ent.
 */
export type UpdateTeamInput = {
  addAssignedHouseholdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addChildIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEmployeeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAssignedHouseholds?: InputMaybe<Scalars['Boolean']['input']>;
  clearChildren?: InputMaybe<Scalars['Boolean']['input']>;
  clearEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwner?: InputMaybe<Scalars['Boolean']['input']>;
  clearParent?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  parentID?: InputMaybe<Scalars['ID']['input']>;
  removeAssignedHouseholdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeChildIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEmployeeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateTenantApplicationConfigurationInput is used for update TenantApplicationConfiguration object.
 * Input was generated by ent.
 */
export type UpdateTenantApplicationConfigurationInput = {
  appendCollaboratorDomainAllowList?: InputMaybe<Array<Scalars['String']['input']>>;
  clearCollaboratorDomainAllowList?: InputMaybe<Scalars['Boolean']['input']>;
  clearOperationsContactEmailAddress?: InputMaybe<Scalars['Boolean']['input']>;
  clearOperationsContactFullName?: InputMaybe<Scalars['Boolean']['input']>;
  clearSecurityContactEmailAddress?: InputMaybe<Scalars['Boolean']['input']>;
  clearSecurityContactFullName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional allowlist of email domains that can be invited as collaborators. Do not include @. */
  collaboratorDomainAllowList?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, disables advanced analytics for this tenant. */
  disableAdvancedAnalytics?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, disables all AI capabilities for this tenant. */
  disableAiCapabilities?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, disables AI insights for member tenants. */
  disableAiInsights?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, allows admins to set the employee.idp_id field via UI */
  enableEmployeeIdpID?: InputMaybe<Scalars['Boolean']['input']>;
  /** The maximum duration of a user session. This is used to control the maximum duration of a user session. This is used to control the maximum duration of a user session. */
  maxSessionDuration?: InputMaybe<TenantApplicationConfigurationMaxSessionDuration>;
  /** Controls the operations available through Model Context Protocol for this tenant. */
  mcpAccess?: InputMaybe<McpAccess>;
  /** The mechanism that will be used to login if the user does not have an SSO connection. */
  nonSSOLoginMechanism?: InputMaybe<TenantApplicationConfigurationNonSsoLoginMechanism>;
  /** The email address of the tenant's operations contact. */
  operationsContactEmailAddress?: InputMaybe<Scalars['String']['input']>;
  /** The full name of the tenant's operations contact. */
  operationsContactFullName?: InputMaybe<Scalars['String']['input']>;
  /** Controls the review steps that client presentations in this tenant require. */
  requirePresentationApproval?: InputMaybe<PresentationApprovalRequirement>;
  /** The email address of the tenant's security contact. */
  securityContactEmailAddress?: InputMaybe<Scalars['String']['input']>;
  /** The full name of the tenant's security contact. */
  securityContactFullName?: InputMaybe<Scalars['String']['input']>;
  /** If true, enables SmartReview for this tenant. */
  smartReviewEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** User Sessions expire after a period of inactivity. This field controls the timeout period. */
  userSessionInactivityTimeout?: InputMaybe<TenantApplicationConfigurationUserSessionInactivityTimeout>;
};

/**
 * UpdateTenantBrandingInput is used for update TenantBranding object.
 * Input was generated by ent.
 */
export type UpdateTenantBrandingInput = {
  buttonsLinkColor?: InputMaybe<Scalars['String']['input']>;
  clearDarkSquareLogoURL?: InputMaybe<Scalars['Boolean']['input']>;
  clearDarkWideLogoURL?: InputMaybe<Scalars['Boolean']['input']>;
  clearDataVisualizationNegativeColor?: InputMaybe<Scalars['Boolean']['input']>;
  clearDataVisualizationTertiaryColor?: InputMaybe<Scalars['Boolean']['input']>;
  darkSquareLogoURL?: InputMaybe<Scalars['String']['input']>;
  darkWideLogoURL?: InputMaybe<Scalars['String']['input']>;
  dataVisualizationNegativeColor?: InputMaybe<Scalars['String']['input']>;
  dataVisualizationPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  dataVisualizationSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  dataVisualizationTertiaryColor?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  logoURL?: InputMaybe<Scalars['String']['input']>;
  /** Font face for presentation headers and cover/divider slides. */
  presentationHeaderFontFace?: InputMaybe<PresentationHeaderFontFace>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  tenantID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateTenantDisclaimerConfigurationInput is used for update TenantDisclaimerConfiguration object.
 * Input was generated by ent.
 */
export type UpdateTenantDisclaimerConfigurationInput = {
  clearPresentationCoverDisclaimerBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationCoverDisclaimerTitle?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationFooterDisclaimerBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationFooterDisclaimerTitle?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationStandaloneDisclaimerBody?: InputMaybe<Scalars['Boolean']['input']>;
  clearPresentationStandaloneDisclaimerTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, include the default Luminary company disclosures in the presentation */
  includeLuminaryDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  presentationCoverDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationCoverDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
  presentationFooterDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationFooterDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
  presentationStandaloneDisclaimerBody?: InputMaybe<Scalars['String']['input']>;
  presentationStandaloneDisclaimerTitle?: InputMaybe<Scalars['String']['input']>;
  tenantID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateTenantDocumentInput is used for update TenantDocument object.
 * Input was generated by ent.
 */
export type UpdateTenantDocumentInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TenantDocumentStatus>;
};

/**
 * UpdateTenantInput is used for update Tenant object.
 * Input was generated by ent.
 */
export type UpdateTenantInput = {
  addSSOConnectionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether the tenant has the asset provider integration addon enabled. */
  addonAssetProviderIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  brandingID?: InputMaybe<Scalars['ID']['input']>;
  clearBranding?: InputMaybe<Scalars['Boolean']['input']>;
  clearContractStartDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearSSOConnections?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrialEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearWorkosDirectoryID?: InputMaybe<Scalars['Boolean']['input']>;
  clearWorkosM2mClientID?: InputMaybe<Scalars['Boolean']['input']>;
  clearWorkosOauthClientID?: InputMaybe<Scalars['Boolean']['input']>;
  clearWorkosOrganizationID?: InputMaybe<Scalars['Boolean']['input']>;
  clearWorkosUpdatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  /** WARNING: FOR ANALYTICS/REPORTING ONLY. NOT FOR BUSINESS LOGIC. The date the contract started. */
  contractStartDate?: InputMaybe<Scalars['Time']['input']>;
  kind?: InputMaybe<TenantKind>;
  /** The product tier for this tenant. */
  productTier?: InputMaybe<TenantProductTier>;
  removeSSOConnectionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The date when the tenant's trial period ends. */
  trialEndDate?: InputMaybe<Scalars['Time']['input']>;
  /** WARNING: FOR ANALYTICS/REPORTING ONLY. NOT FOR BUSINESS LOGIC. This is the bucket that the tenant falls into for usage tracking. */
  usageBucket?: InputMaybe<TenantUsageBucket>;
  /** The WorkOS directory id, if directory sync is enabled for this workos organization */
  workosDirectoryID?: InputMaybe<Scalars['String']['input']>;
  /** The WorkOS M2M application client_id for this tenant. When set, M2M access tokens must carry an app_client_id claim matching this value. */
  workosM2mClientID?: InputMaybe<Scalars['String']['input']>;
  /** The WorkOS Connect (OAuth) application client_id for this tenant. When set, Connect access tokens must carry an app_client_id claim matching this value. */
  workosOauthClientID?: InputMaybe<Scalars['String']['input']>;
  /** The corresponding WorkOS organization ID for this tenant. */
  workosOrganizationID?: InputMaybe<Scalars['String']['input']>;
  /** The WorkOS updated_at timestamp */
  workosUpdatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateTenantReminderEmailsConfigurationInput is used for update TenantReminderEmailsConfiguration object.
 * Input was generated by ent.
 */
export type UpdateTenantReminderEmailsConfigurationInput = {
  /** If true, do NOT send periodic reminder emails for tasks. */
  reminderEmailsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateTenantSSOConnectionInput is used for update TenantSSOConnection object.
 * Input was generated by ent.
 */
export type UpdateTenantSsoConnectionInput = {
  clearJitEnabledAt?: InputMaybe<Scalars['Boolean']['input']>;
  enableJIT?: InputMaybe<Scalars['Boolean']['input']>;
  /** The time at which JIT was enabled for this tenant. If null, JIT is disabled. JIT means that users will be created on the fly when they sign in with SSO. */
  jitEnabledAt?: InputMaybe<Scalars['Time']['input']>;
  ssoConnectionID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateTenantSecurityConfigurationInput is used for update TenantSecurityConfiguration object.
 * Input was generated by ent.
 */
export type UpdateTenantSecurityConfigurationInput = {
  clearLuminaryAccessControlEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  clearLuminarySupportAccessEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, Luminary support access to this tenant is controlled by the customer rather than approved internally. Enterprise-only. */
  luminaryAccessControlEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer-configured Luminary support access policy. Only meaningful when luminary_access_control_enabled is true. */
  luminarySupportAccess?: InputMaybe<TenantSecurityConfigurationLuminarySupportAccess>;
  /** The end date for Luminary support access. Only populated when luminary_support_access is TIME_BOUND. */
  luminarySupportAccessEndDate?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateTenantSlideConfigInput is used for update TenantSlideConfig object.
 * Input was generated by ent.
 */
export type UpdateTenantSlideConfigInput = {
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom slide content in JSON format with versioned block structure */
  contentJSON?: InputMaybe<Scalars['Map']['input']>;
  /** Display name for the slide (for admin UI organization and custom template titles) */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** When true, this slide will not be available to use in presentations */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateTestCMKEncryptionInput is used for update TestCMKEncryption object.
 * Input was generated by ent.
 */
export type UpdateTestCmkEncryptionInput = {
  clearNilEncryptedString?: InputMaybe<Scalars['Boolean']['input']>;
  clearOptionalEncryptedString?: InputMaybe<Scalars['Boolean']['input']>;
  /** encrypted int */
  encryptedInt?: InputMaybe<Scalars['Int']['input']>;
  /** encrypted string */
  encryptedString?: InputMaybe<Scalars['String']['input']>;
  /** encrypted time */
  encryptedTime?: InputMaybe<Scalars['Time']['input']>;
  ignoreMe?: InputMaybe<Scalars['String']['input']>;
  /** nillable encrypted string */
  nilEncryptedString?: InputMaybe<Scalars['String']['input']>;
  /** optional encrypted string */
  optionalEncryptedString?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateTestamentaryEntityInput is used for update TestamentaryEntity object.
 * Input was generated by ent.
 */
export type UpdateTestamentaryEntityInput = {
  accountOwnerID?: InputMaybe<Scalars['ID']['input']>;
  addAdditionalDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiariesAfterBothGrantorDeathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBenefitsFromIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addCreatedFromEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEntityDocumentRelationshipIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHypotheticalDispositiveProvisionsTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOnboardingTestamentaryEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPotentialTestamentaryEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSuggestionKgRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWorkflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAccountOwner?: InputMaybe<Scalars['Boolean']['input']>;
  clearAdditionalDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiaries?: InputMaybe<Scalars['Boolean']['input']>;
  clearBeneficiariesAfterBothGrantorDeaths?: InputMaybe<Scalars['Boolean']['input']>;
  clearBenefitsFrom?: InputMaybe<Scalars['Boolean']['input']>;
  clearControllingParties?: InputMaybe<Scalars['Boolean']['input']>;
  clearCreatedFromEntities?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  clearDispositiveProvisionsTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  clearEntityDocumentRelationships?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrantorDeath?: InputMaybe<Scalars['Boolean']['input']>;
  clearGstStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositionScenarios?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositiveProvisions?: InputMaybe<Scalars['Boolean']['input']>;
  clearHypotheticalDispositiveProvisionsTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  clearInEstateStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearInclusionRatio?: InputMaybe<Scalars['Boolean']['input']>;
  clearKgV2nodes?: InputMaybe<Scalars['Boolean']['input']>;
  clearOnboardingTestamentaryEntitySuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  clearPotentialTestamentaryEntitySuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  clearReviewedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuccessorTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  clearSuggestionKgRoot?: InputMaybe<Scalars['Boolean']['input']>;
  clearSurvivingSpouseStateInEstateStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxInfo?: InputMaybe<Scalars['Boolean']['input']>;
  clearTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrustees?: InputMaybe<Scalars['Boolean']['input']>;
  clearWorkflowTrackers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description for this testamentary entity */
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  dispositiveProvisionsTemplateID?: InputMaybe<Scalars['ID']['input']>;
  grantorDeathID?: InputMaybe<Scalars['ID']['input']>;
  /** GST status for this entity. Only valid when in_estate_status is OUT_OF_ESTATE */
  gstStatus?: InputMaybe<EntityGstStatus>;
  inEstateStatus?: InputMaybe<EntityInEstateStatus>;
  /** Inclusion ratio for this trust. Only valid when gst_status is MIXED_GST */
  inclusionRatio?: InputMaybe<Scalars['Decimal']['input']>;
  /** Type of testamentary entity. */
  kind?: InputMaybe<TestamentaryEntityKind>;
  removeAdditionalDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiariesAfterBothGrantorDeathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBeneficiaryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBenefitsFromIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeControllingPartyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeCreatedFromEntityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEntityDocumentRelationshipIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositionScenarioIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositiveProvisionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHypotheticalDispositiveProvisionsTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKgV2NodeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOnboardingTestamentaryEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePotentialTestamentaryEntitySuggestionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuccessorTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSuggestionKgRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrustAdvisorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTrusteeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWorkflowTrackerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The time at which the scenario was last reviewed. This can be used to indicate that a user has looked at these provisions and they are correct, even if they are empty. */
  reviewedAt?: InputMaybe<Scalars['Time']['input']>;
  survivingSpouseStateInEstateStatus?: InputMaybe<EntityInEstateStatus>;
  taxInfoID?: InputMaybe<Scalars['ID']['input']>;
  taxStatus?: InputMaybe<NonTrustEntityTaxStatus>;
};

/**
 * UpdateTrustAdvisorInput is used for update TrustAdvisor object.
 * Input was generated by ent.
 */
export type UpdateTrustAdvisorInput = {
  addRoleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearNote?: InputMaybe<Scalars['Boolean']['input']>;
  clearRoles?: InputMaybe<Scalars['Boolean']['input']>;
  /** The level of this trust advisor. */
  level?: InputMaybe<TrustAdvisorLevel>;
  /** A Note about this trust advisor. Only relevant if the level is "OTHER". */
  note?: InputMaybe<Scalars['String']['input']>;
  removeRoleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateTrustAdvisorRoleInput is used for update TrustAdvisorRole object.
 * Input was generated by ent.
 */
export type UpdateTrustAdvisorRoleInput = {
  /** The role of this trust advisor. */
  kind?: InputMaybe<TrustAdvisorRoleKind>;
};

/**
 * UpdateTrusteeDutyInput is used for update TrusteeDuty object.
 * Input was generated by ent.
 */
export type UpdateTrusteeDutyInput = {
  /** The kind of duty for this trustee */
  kind?: InputMaybe<TrusteeDutyKind>;
};

/**
 * UpdateTrusteeInput is used for update Trustee object.
 * Input was generated by ent.
 */
export type UpdateTrusteeInput = {
  addDutyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDuties?: InputMaybe<Scalars['Boolean']['input']>;
  clearLevel?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<TrusteeLevel>;
  /** Free-form notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  removeDutyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateUserInput is used for update User object.
 * Input was generated by ent.
 */
export type UpdateUserInput = {
  addAssignedTaskIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addAsyncJobIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addCollaboratorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEmployeeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRelationshipOwnerHouseholdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAssignedTasks?: InputMaybe<Scalars['Boolean']['input']>;
  clearAsyncJobs?: InputMaybe<Scalars['Boolean']['input']>;
  clearCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
  clearEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  clearRelationshipOwnerHouseholds?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  removeAssignedTaskIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeAsyncJobIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeCollaboratorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEmployeeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRelationshipOwnerHouseholdIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateUserNotificationConfigurationInput is used for update UserNotificationConfiguration object.
 * Input was generated by ent.
 */
export type UpdateUserNotificationConfigurationInput = {
  /** Whether or not the user has enabled receiving reminder email notifications. */
  allRemainderEmailsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateWaterfallBundleConfigurationInput is used for update WaterfallBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateWaterfallBundleConfigurationInput = {
  clearDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  clearEstateWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  clearFirstDeathYear?: InputMaybe<Scalars['Boolean']['input']>;
  clearGrowthProfile?: InputMaybe<Scalars['Boolean']['input']>;
  clearIncludeSummaryBars?: InputMaybe<Scalars['Boolean']['input']>;
  clearIncludeSummaryTiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearSecondDeathYear?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name for the waterfall. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  estateWaterfallID?: InputMaybe<Scalars['ID']['input']>;
  /** The year of the first death in the waterfall. */
  firstDeathYear?: InputMaybe<Scalars['Int']['input']>;
  growthProfileID?: InputMaybe<Scalars['ID']['input']>;
  /** Include the state after the first death in the waterfall summary page. */
  includeAfterFirstDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include the state after the second death in the waterfall summary page. */
  includeAfterSecondDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the assumptions page in the waterfall bundle. */
  includeAssumptionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include the state before the first death in the waterfall summary page. */
  includeBeforeFirstDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the beneficiary page in the waterfall bundle. */
  includeBeneficiaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the cover page in the waterfall bundle. */
  includeCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the diagrams page in the waterfall bundle. */
  includeDiagramPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include the overview in the waterfall summary page. */
  includeOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the summary bars on the summary page in the waterfall bundle. */
  includeSummaryBars?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the summary page in the waterfall bundle. */
  includeSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the summary tiles on the summary page in the waterfall bundle. */
  includeSummaryTiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the tax overview page in the waterfall bundle. */
  includeTaxOverviewPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** The year of the second death in the waterfall. */
  secondDeathYear?: InputMaybe<Scalars['Int']['input']>;
  /** If true, shows the line-item details on the summary tiles on the summary page in the waterfall bundle. */
  showSummaryTileDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides line items with a $0 value and no insurance from the updated waterfall summary page. */
  summaryHideZeroDollarItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use the updated waterfall summary page instead of the original design. */
  useUpdatedSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateWaterfallBundleCoverPageInput is used for update WaterfallBundleCoverPage object.
 * Input was generated by ent.
 */
export type UpdateWaterfallBundleCoverPageInput = {
  /** The content of the cover page. */
  content?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateWaterfallComparisonBundleConfigurationInput is used for update WaterfallComparisonBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateWaterfallComparisonBundleConfigurationInput = {
  addComparedWaterfallIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearComparedWaterfalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** The display name for the waterfall comparison bundle. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** If true, includes the assumptions page in the waterfall comparison bundle. */
  includeAssumptionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the cover page in the waterfall comparison bundle. */
  includeCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  removeComparedWaterfallIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateWaterfallComparisonTemplateBundleConfigurationInput is used for update WaterfallComparisonTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateWaterfallComparisonTemplateBundleConfigurationInput = {
  /** If true, includes the assumptions page in the waterfall comparison bundle. */
  includeAssumptionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the cover page in the waterfall comparison bundle. */
  includeCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateWaterfallTemplateBundleConfigurationInput is used for update WaterfallTemplateBundleConfiguration object.
 * Input was generated by ent.
 */
export type UpdateWaterfallTemplateBundleConfigurationInput = {
  clearIncludeSummaryBars?: InputMaybe<Scalars['Boolean']['input']>;
  clearIncludeSummaryTiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include the state after the first death in the waterfall summary page. */
  includeAfterFirstDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include the state after the second death in the waterfall summary page. */
  includeAfterSecondDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the assumptions page in the waterfall bundle. */
  includeAssumptionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include the state before the first death in the waterfall summary page. */
  includeBeforeFirstDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the cover page in the waterfall bundle. */
  includeCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the diagrams page in the waterfall bundle. */
  includeDiagramPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include the overview in the waterfall summary page. */
  includeOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the summary bars on the summary page in the waterfall bundle. */
  includeSummaryBars?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the summary page in the waterfall bundle. */
  includeSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the summary tiles on the summary page in the waterfall bundle. */
  includeSummaryTiles?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, includes the tax overview page in the waterfall bundle. */
  includeTaxOverviewPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, shows the line-item details on the summary tiles on the summary page in the waterfall bundle. */
  showSummaryTileDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, hides line items with a $0 value and no insurance from the updated waterfall summary page. */
  summaryHideZeroDollarItems?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Input for updateWorkOSOrganization. Only mutable fields are exposed;
 * externalID and the LuminaryOrganization link are immutable. Fields left
 * null are unchanged. The connection/directory IDs typically land here
 * after WorkOS-side SSO/SCIM setup completes.
 */
export type UpdateWorkOsOrganizationInput = {
  /** Clear the WorkOS SSO connection ID. */
  clearWorkosConnectionID?: InputMaybe<Scalars['Boolean']['input']>;
  /** Clear the WorkOS directory ID. */
  clearWorkosDirectoryID?: InputMaybe<Scalars['Boolean']['input']>;
  /** WorkOS SSO connection ID, populated once SSO is configured. */
  workosConnectionID?: InputMaybe<Scalars['String']['input']>;
  /** WorkOS directory ID, populated once SCIM directory sync is enabled. */
  workosDirectoryID?: InputMaybe<Scalars['String']['input']>;
};

/** UploadImageInput selects the access boundary of an uploaded image. */
export type UploadImageInput = {
  /**
   * The household that owns the image. Required when scope is HOUSEHOLD, and must
   * be empty when scope is TENANT.
   */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * HOUSEHOLD stores the image for one household. TENANT stores it for the whole
   * firm, for example for presentation templates.
   */
  scope: ImageScope;
};

export type UpsertAssetToCurrentValuationInput = {
  entityID: Scalars['ID']['input'];
  input: Array<AugmentedCreateAssetV2Input>;
};

export type User = Node & {
  __typename?: 'User';
  assignedTasks: EntityTaskConnection;
  asyncJobs: AsyncJobConnection;
  collaborators?: Maybe<Array<Collaborator>>;
  createdAt: Scalars['Time']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  employees?: Maybe<Array<Employee>>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initials: Scalars['String']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  localMostRecentlyViewedEntityMap?: Maybe<MostRecentlyViewedEntityMap>;
  localMostRecentlyViewedWaterfall?: Maybe<MostRecentlyViewedWaterfall>;
  nameWithLastInitial: Scalars['String']['output'];
  relationshipOwnerHouseholds?: Maybe<Array<Household>>;
  /** this field is populated with 'first_name + last_name' and is used for search purposes */
  searchName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  /** The WorkOS directory user id */
  workosDirectoryUserID?: Maybe<Scalars['String']['output']>;
  /** The WorkOS updated_at timestamp */
  workosUpdatedAt?: Maybe<Scalars['Time']['output']>;
};


export type UserAssignedTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityTaskOrder>>;
  where?: InputMaybe<EntityTaskWhereInput>;
};


export type UserAsyncJobsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AsyncJobOrder>>;
  where?: InputMaybe<AsyncJobWhereInput>;
};


export type UserLocalMostRecentlyViewedEntityMapArgs = {
  where?: InputMaybe<MostRecentlyViewedEntityMapWhereInput>;
};


export type UserLocalMostRecentlyViewedWaterfallArgs = {
  where?: InputMaybe<LastViewedWaterfallWhereInput>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserFeedback = Node & {
  __typename?: 'UserFeedback';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The entity that the feedback is about */
  entity?: Maybe<Entity>;
  /** The user's feedback */
  feedback: Scalars['String']['output'];
  /** The piece of functionality the feedback is about */
  feedbackCategory: UserFeedbackFeedbackCategory;
  household: Household;
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** UserFeedbackFeedbackCategory is enum for the field feedback_category */
export enum UserFeedbackFeedbackCategory {
  AiDpSuggestions = 'AI_DP_SUGGESTIONS',
  AiOnboardingSuggestions = 'AI_ONBOARDING_SUGGESTIONS',
  EntityFormAiSuggestions = 'ENTITY_FORM_AI_SUGGESTIONS'
}

/** Ordering options for UserFeedback connections */
export type UserFeedbackOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order UserFeedbacks. */
  field: UserFeedbackOrderField;
};

/** Properties by which UserFeedback connections can be ordered. */
export enum UserFeedbackOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * UserFeedbackWhereInput is used for filtering UserFeedback objects.
 * Input was generated by ent.
 */
export type UserFeedbackWhereInput = {
  and?: InputMaybe<Array<UserFeedbackWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** feedback field predicates */
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** feedback_category field predicates */
  feedbackCategory?: InputMaybe<UserFeedbackFeedbackCategory>;
  feedbackCategoryIn?: InputMaybe<Array<UserFeedbackFeedbackCategory>>;
  feedbackCategoryNEQ?: InputMaybe<UserFeedbackFeedbackCategory>;
  feedbackCategoryNotIn?: InputMaybe<Array<UserFeedbackFeedbackCategory>>;
  /** entity edge predicates */
  hasEntity?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntityWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<UserFeedbackWhereInput>;
  or?: InputMaybe<Array<UserFeedbackWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UserKind is a description of the class of user currently interacting with the application, which
 * governs the behavior of some parts of the experience.
 */
export enum UserKind {
  /** ANONYMOUS: A user who is not logged in, possibly using an issued token for access */
  Anonymous = 'ANONYMOUS',
  /** DATADOG_INTERNAL: Elevated access to Dev Tools for synthetics */
  DatadogInternal = 'DATADOG_INTERNAL',
  /** EMPLOYEE: Access is fully controlled by the assigned roles and related permissions. */
  Employee = 'EMPLOYEE',
  /** LUMINARY_INTERNAL: Elevated access to things like Dev Tools and other advanced functionality */
  LuminaryInternal = 'LUMINARY_INTERNAL',
  /**
   * THIRD_PARTY: An external user, so we guarantee that some sections of the application like the
   * employee homepage and admin sections are never available regardless of permissions.
   */
  ThirdParty = 'THIRD_PARTY'
}

export type UserNotificationConfiguration = Node & {
  __typename?: 'UserNotificationConfiguration';
  /** Whether or not the user has enabled receiving reminder email notifications. */
  allRemainderEmailsDisabled: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /** The user for whom this notification configuration is for. */
  receivingUser: User;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type UserNotificationConfigurationConnection = {
  __typename?: 'UserNotificationConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserNotificationConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserNotificationConfigurationEdge = {
  __typename?: 'UserNotificationConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserNotificationConfiguration>;
};

/** Ordering options for UserNotificationConfiguration connections */
export type UserNotificationConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order UserNotificationConfigurations. */
  field: UserNotificationConfigurationOrderField;
};

/** Properties by which UserNotificationConfiguration connections can be ordered. */
export enum UserNotificationConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * UserNotificationConfigurationWhereInput is used for filtering UserNotificationConfiguration objects.
 * Input was generated by ent.
 */
export type UserNotificationConfigurationWhereInput = {
  /** all_remainder_emails_disabled field predicates */
  allRemainderEmailsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<UserNotificationConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** receiving_user edge predicates */
  hasReceivingUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasReceivingUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<UserNotificationConfigurationWhereInput>;
  or?: InputMaybe<Array<UserNotificationConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

/** Ordering options for User connections */
export type UserOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Users. */
  field: UserOrderField;
};

/** Properties by which User connections can be ordered. */
export enum UserOrderField {
  Name = 'NAME',
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * UserWhereInput is used for filtering User objects.
 * Input was generated by ent.
 */
export type UserWhereInput = {
  and?: InputMaybe<Array<UserWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  /** first_name field predicates */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** async_jobs edge predicates */
  hasAsyncJobs?: InputMaybe<Scalars['Boolean']['input']>;
  hasAsyncJobsWith?: InputMaybe<Array<AsyncJobWhereInput>>;
  /** collaborators edge predicates */
  hasCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
  hasCollaboratorsWith?: InputMaybe<Array<CollaboratorWhereInput>>;
  /** employees edge predicates */
  hasEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmployeesWith?: InputMaybe<Array<EmployeeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_superuser field predicates */
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_name field predicates */
  lastName?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<UserWhereInput>;
  or?: InputMaybe<Array<UserWhereInput>>;
  /** search_name field predicates */
  searchName?: InputMaybe<Scalars['String']['input']>;
  searchNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  searchNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  searchNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** workos_directory_user_id field predicates */
  workosDirectoryUserID?: InputMaybe<Scalars['String']['input']>;
  workosDirectoryUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  workosDirectoryUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** workos_updated_at field predicates */
  workosUpdatedAt?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  workosUpdatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  workosUpdatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WaterfallBundleConfiguration = Node & {
  __typename?: 'WaterfallBundleConfiguration';
  bundle?: Maybe<PresentationBundle>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The display name for the waterfall. */
  displayName?: Maybe<Scalars['String']['output']>;
  estateWaterfall?: Maybe<EstateWaterfall>;
  /**
   * estateWaterfallViz is a waterfall visualization for any waterfall that respects the
   * configuration of the bundle.
   * @deprecated Use estateWaterfallVizNullable instead, which returns null when the waterfall or growth profile edge is missing.
   */
  estateWaterfallViz: EstateWaterfallViz;
  /**
   * estateWaterfallVizNonHypothetical is a waterfall visualization that respects the configuration
   * of the bundle configuration, but runs the waterfall as a non-hypothetical to create a
   * comparison baseline.
   * @deprecated Use estateWaterfallVizNonHypotheticalNullable instead, which returns null when the waterfall or growth profile edge is missing.
   */
  estateWaterfallVizNonHypothetical: EstateWaterfallViz;
  /**
   * estateWaterfallVizNonHypotheticalNullable is a waterfall visualization that respects the
   * configuration of the bundle, but runs the waterfall as a non-hypothetical to create a
   * comparison baseline. Returns null if the estate waterfall or growth profile edge is missing.
   */
  estateWaterfallVizNonHypotheticalNullable?: Maybe<EstateWaterfallViz>;
  /**
   * estateWaterfallVizNullable is a waterfall visualization for any waterfall that respects the
   * configuration of the bundle. Returns null if the estate waterfall or growth profile edge is missing.
   */
  estateWaterfallVizNullable?: Maybe<EstateWaterfallViz>;
  /** The year of the first death in the waterfall. */
  firstDeathYear?: Maybe<Scalars['Int']['output']>;
  growthProfile?: Maybe<GrowthProfile>;
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Include the state after the first death in the waterfall summary page. */
  includeAfterFirstDeath: Scalars['Boolean']['output'];
  /** Include the state after the second death in the waterfall summary page. */
  includeAfterSecondDeath: Scalars['Boolean']['output'];
  /** If true, includes the assumptions page in the waterfall bundle. */
  includeAssumptionsPage: Scalars['Boolean']['output'];
  /** Include the state before the first death in the waterfall summary page. */
  includeBeforeFirstDeath: Scalars['Boolean']['output'];
  /**
   * If true, includes the beneficiary page in the waterfall bundle.
   * @deprecated No longer supported
   */
  includeBeneficiaryPage: Scalars['Boolean']['output'];
  /** If true, includes the cover page in the waterfall bundle. */
  includeCoverPage: Scalars['Boolean']['output'];
  /** If true, includes the diagrams page in the waterfall bundle. */
  includeDiagramPage: Scalars['Boolean']['output'];
  /** Include the overview in the waterfall summary page. */
  includeOverview: Scalars['Boolean']['output'];
  /** If true, includes the summary bars on the summary page in the waterfall bundle. */
  includeSummaryBars?: Maybe<Scalars['Boolean']['output']>;
  /** If true, includes the summary page in the waterfall bundle. */
  includeSummaryPage: Scalars['Boolean']['output'];
  /** If true, includes the summary tiles on the summary page in the waterfall bundle. */
  includeSummaryTiles?: Maybe<Scalars['Boolean']['output']>;
  /** If true, includes the tax overview page in the waterfall bundle. */
  includeTaxOverviewPage: Scalars['Boolean']['output'];
  /** The year of the second death in the waterfall. */
  secondDeathYear?: Maybe<Scalars['Int']['output']>;
  /** If true, shows the line-item details on the summary tiles on the summary page in the waterfall bundle. */
  showSummaryTileDetails: Scalars['Boolean']['output'];
  /** If true, hides line items with a $0 value and no insurance from the updated waterfall summary page. */
  summaryHideZeroDollarItems: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  /** Use the updated waterfall summary page instead of the original design. */
  useUpdatedSummaryPage: Scalars['Boolean']['output'];
  user: User;
};

/** A connection to a list of items. */
export type WaterfallBundleConfigurationConnection = {
  __typename?: 'WaterfallBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WaterfallBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WaterfallBundleConfigurationEdge = {
  __typename?: 'WaterfallBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WaterfallBundleConfiguration>;
};

/** Ordering options for WaterfallBundleConfiguration connections */
export type WaterfallBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WaterfallBundleConfigurations. */
  field: WaterfallBundleConfigurationOrderField;
};

/** Properties by which WaterfallBundleConfiguration connections can be ordered. */
export enum WaterfallBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * WaterfallBundleConfigurationWhereInput is used for filtering WaterfallBundleConfiguration objects.
 * Input was generated by ent.
 */
export type WaterfallBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<WaterfallBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  displayNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** first_death_year field predicates */
  firstDeathYear?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearGT?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearGTE?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  firstDeathYearLT?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearLTE?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  firstDeathYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** estate_waterfall edge predicates */
  hasEstateWaterfall?: InputMaybe<Scalars['Boolean']['input']>;
  hasEstateWaterfallWith?: InputMaybe<Array<EstateWaterfallWhereInput>>;
  /** growth_profile edge predicates */
  hasGrowthProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrowthProfileWith?: InputMaybe<Array<GrowthProfileWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_after_first_death field predicates */
  includeAfterFirstDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_after_second_death field predicates */
  includeAfterSecondDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_assumptions_page field predicates */
  includeAssumptionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_before_first_death field predicates */
  includeBeforeFirstDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_beneficiary_page field predicates */
  includeBeneficiaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_cover_page field predicates */
  includeCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_diagram_page field predicates */
  includeDiagramPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_overview field predicates */
  includeOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_summary_bars field predicates */
  includeSummaryBars?: InputMaybe<Scalars['Boolean']['input']>;
  includeSummaryBarsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  includeSummaryBarsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_summary_page field predicates */
  includeSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_summary_tiles field predicates */
  includeSummaryTiles?: InputMaybe<Scalars['Boolean']['input']>;
  includeSummaryTilesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  includeSummaryTilesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_tax_overview_page field predicates */
  includeTaxOverviewPage?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<WaterfallBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<WaterfallBundleConfigurationWhereInput>>;
  /** second_death_year field predicates */
  secondDeathYear?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearGT?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearGTE?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  secondDeathYearLT?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearLTE?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  secondDeathYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_summary_tile_details field predicates */
  showSummaryTileDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** summary_hide_zero_dollar_items field predicates */
  summaryHideZeroDollarItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** use_updated_summary_page field predicates */
  useUpdatedSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WaterfallBundleCoverPage = Node & {
  __typename?: 'WaterfallBundleCoverPage';
  /** The content of the cover page. */
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type WaterfallBundleCoverPageConnection = {
  __typename?: 'WaterfallBundleCoverPageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WaterfallBundleCoverPageEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WaterfallBundleCoverPageEdge = {
  __typename?: 'WaterfallBundleCoverPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WaterfallBundleCoverPage>;
};

export type WaterfallComparisonBundleConfiguration = Node & {
  __typename?: 'WaterfallComparisonBundleConfiguration';
  bundle?: Maybe<PresentationBundle>;
  comparedWaterfalls?: Maybe<Array<ComparedWaterfall>>;
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** The display name for the waterfall comparison bundle. */
  displayName: Scalars['String']['output'];
  household: Household;
  /** the household this object belongs to */
  householdID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** If true, includes the assumptions page in the waterfall comparison bundle. */
  includeAssumptionsPage: Scalars['Boolean']['output'];
  /** If true, includes the cover page in the waterfall comparison bundle. */
  includeCoverPage: Scalars['Boolean']['output'];
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type WaterfallComparisonBundleConfigurationConnection = {
  __typename?: 'WaterfallComparisonBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WaterfallComparisonBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WaterfallComparisonBundleConfigurationEdge = {
  __typename?: 'WaterfallComparisonBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WaterfallComparisonBundleConfiguration>;
};

/** Ordering options for WaterfallComparisonBundleConfiguration connections */
export type WaterfallComparisonBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WaterfallComparisonBundleConfigurations. */
  field: WaterfallComparisonBundleConfigurationOrderField;
};

/** Properties by which WaterfallComparisonBundleConfiguration connections can be ordered. */
export enum WaterfallComparisonBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * WaterfallComparisonBundleConfigurationWhereInput is used for filtering WaterfallComparisonBundleConfiguration objects.
 * Input was generated by ent.
 */
export type WaterfallComparisonBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<WaterfallComparisonBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** bundle edge predicates */
  hasBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasBundleWith?: InputMaybe<Array<PresentationBundleWhereInput>>;
  /** compared_waterfalls edge predicates */
  hasComparedWaterfalls?: InputMaybe<Scalars['Boolean']['input']>;
  hasComparedWaterfallsWith?: InputMaybe<Array<ComparedWaterfallWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_assumptions_page field predicates */
  includeAssumptionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_cover_page field predicates */
  includeCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<WaterfallComparisonBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<WaterfallComparisonBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type WaterfallComparisonTemplateBundleConfiguration = Node & {
  __typename?: 'WaterfallComparisonTemplateBundleConfiguration';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** If true, includes the assumptions page in the waterfall comparison bundle. */
  includeAssumptionsPage: Scalars['Boolean']['output'];
  /** If true, includes the cover page in the waterfall comparison bundle. */
  includeCoverPage: Scalars['Boolean']['output'];
  templateBundle?: Maybe<PresentationTemplateBundle>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type WaterfallComparisonTemplateBundleConfigurationConnection = {
  __typename?: 'WaterfallComparisonTemplateBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WaterfallComparisonTemplateBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WaterfallComparisonTemplateBundleConfigurationEdge = {
  __typename?: 'WaterfallComparisonTemplateBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WaterfallComparisonTemplateBundleConfiguration>;
};

/** Ordering options for WaterfallComparisonTemplateBundleConfiguration connections */
export type WaterfallComparisonTemplateBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WaterfallComparisonTemplateBundleConfigurations. */
  field: WaterfallComparisonTemplateBundleConfigurationOrderField;
};

/** Properties by which WaterfallComparisonTemplateBundleConfiguration connections can be ordered. */
export enum WaterfallComparisonTemplateBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * WaterfallComparisonTemplateBundleConfigurationWhereInput is used for filtering WaterfallComparisonTemplateBundleConfiguration objects.
 * Input was generated by ent.
 */
export type WaterfallComparisonTemplateBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<WaterfallComparisonTemplateBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** template_bundle edge predicates */
  hasTemplateBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasTemplateBundleWith?: InputMaybe<Array<PresentationTemplateBundleWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_assumptions_page field predicates */
  includeAssumptionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_cover_page field predicates */
  includeCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<WaterfallComparisonTemplateBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<WaterfallComparisonTemplateBundleConfigurationWhereInput>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type WaterfallSummaryTileDetailsWhereInput = {
  waterfallId: Scalars['ID']['input'];
};

export type WaterfallTemplateBundleConfiguration = Node & {
  __typename?: 'WaterfallTemplateBundleConfiguration';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Include the state after the first death in the waterfall summary page. */
  includeAfterFirstDeath: Scalars['Boolean']['output'];
  /** Include the state after the second death in the waterfall summary page. */
  includeAfterSecondDeath: Scalars['Boolean']['output'];
  /** If true, includes the assumptions page in the waterfall bundle. */
  includeAssumptionsPage: Scalars['Boolean']['output'];
  /** Include the state before the first death in the waterfall summary page. */
  includeBeforeFirstDeath: Scalars['Boolean']['output'];
  /** If true, includes the cover page in the waterfall bundle. */
  includeCoverPage: Scalars['Boolean']['output'];
  /** If true, includes the diagrams page in the waterfall bundle. */
  includeDiagramPage: Scalars['Boolean']['output'];
  /** Include the overview in the waterfall summary page. */
  includeOverview: Scalars['Boolean']['output'];
  /** If true, includes the summary bars on the summary page in the waterfall bundle. */
  includeSummaryBars?: Maybe<Scalars['Boolean']['output']>;
  /** If true, includes the summary page in the waterfall bundle. */
  includeSummaryPage: Scalars['Boolean']['output'];
  /** If true, includes the summary tiles on the summary page in the waterfall bundle. */
  includeSummaryTiles?: Maybe<Scalars['Boolean']['output']>;
  /** If true, includes the tax overview page in the waterfall bundle. */
  includeTaxOverviewPage: Scalars['Boolean']['output'];
  /** If true, shows the line-item details on the summary tiles on the summary page in the waterfall bundle. */
  showSummaryTileDetails: Scalars['Boolean']['output'];
  /** If true, hides line items with a $0 value and no insurance from the updated waterfall summary page. */
  summaryHideZeroDollarItems: Scalars['Boolean']['output'];
  templateBundle?: Maybe<PresentationTemplateBundle>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
};

/** A connection to a list of items. */
export type WaterfallTemplateBundleConfigurationConnection = {
  __typename?: 'WaterfallTemplateBundleConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WaterfallTemplateBundleConfigurationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WaterfallTemplateBundleConfigurationEdge = {
  __typename?: 'WaterfallTemplateBundleConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WaterfallTemplateBundleConfiguration>;
};

/** Ordering options for WaterfallTemplateBundleConfiguration connections */
export type WaterfallTemplateBundleConfigurationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WaterfallTemplateBundleConfigurations. */
  field: WaterfallTemplateBundleConfigurationOrderField;
};

/** Properties by which WaterfallTemplateBundleConfiguration connections can be ordered. */
export enum WaterfallTemplateBundleConfigurationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * WaterfallTemplateBundleConfigurationWhereInput is used for filtering WaterfallTemplateBundleConfiguration objects.
 * Input was generated by ent.
 */
export type WaterfallTemplateBundleConfigurationWhereInput = {
  and?: InputMaybe<Array<WaterfallTemplateBundleConfigurationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** template_bundle edge predicates */
  hasTemplateBundle?: InputMaybe<Scalars['Boolean']['input']>;
  hasTemplateBundleWith?: InputMaybe<Array<PresentationTemplateBundleWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** include_after_first_death field predicates */
  includeAfterFirstDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_after_second_death field predicates */
  includeAfterSecondDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_assumptions_page field predicates */
  includeAssumptionsPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_before_first_death field predicates */
  includeBeforeFirstDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_cover_page field predicates */
  includeCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_diagram_page field predicates */
  includeDiagramPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_overview field predicates */
  includeOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_summary_bars field predicates */
  includeSummaryBars?: InputMaybe<Scalars['Boolean']['input']>;
  includeSummaryBarsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  includeSummaryBarsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_summary_page field predicates */
  includeSummaryPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_summary_tiles field predicates */
  includeSummaryTiles?: InputMaybe<Scalars['Boolean']['input']>;
  includeSummaryTilesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  includeSummaryTilesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** include_tax_overview_page field predicates */
  includeTaxOverviewPage?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<WaterfallTemplateBundleConfigurationWhereInput>;
  or?: InputMaybe<Array<WaterfallTemplateBundleConfigurationWhereInput>>;
  /** show_summary_tile_details field predicates */
  showSummaryTileDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** summary_hide_zero_dollar_items field predicates */
  summaryHideZeroDollarItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type WorkOsOrganization = Node & {
  __typename?: 'WorkOSOrganization';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Human-readable label. */
  displayName: Scalars['String']['output'];
  domains: WorkOsOrganizationDomainConnection;
  /** WorkOS organization ID (e.g. org_xxx) from the WorkOS dashboard. */
  externalID: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The owning LuminaryOrganization. */
  luminaryOrganization: LuminaryOrganization;
  /** FK to the owning LuminaryOrganization. 1:1 cardinality is enforced by the edge. */
  luminaryOrganizationID: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
  /** WorkOS SSO connection ID, if SSO is configured. */
  workosConnectionID?: Maybe<Scalars['String']['output']>;
  /** WorkOS directory ID, if SCIM directory sync is enabled. */
  workosDirectoryID?: Maybe<Scalars['String']['output']>;
  /** When WorkOS directory sync was last applied. */
  workosDirectoryUpdatedAt?: Maybe<Scalars['Time']['output']>;
};


export type WorkOsOrganizationDomainsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkOsOrganizationDomainOrder>>;
  where?: InputMaybe<WorkOsOrganizationDomainWhereInput>;
};

/** A connection to a list of items. */
export type WorkOsOrganizationConnection = {
  __typename?: 'WorkOSOrganizationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WorkOsOrganizationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type WorkOsOrganizationDomain = Node & {
  __typename?: 'WorkOSOrganizationDomain';
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['ID']['output'];
  /** Email domain bound to this org (e.g. '@acme.com'). Globally unique. */
  emailDomain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updateUser: User;
  updatedAt: Scalars['Time']['output'];
  updatedBy: Scalars['ID']['output'];
  user: User;
  workosOrganization: WorkOsOrganization;
  /** FK to the owning WorkOSOrganization. */
  workosOrganizationID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type WorkOsOrganizationDomainConnection = {
  __typename?: 'WorkOSOrganizationDomainConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WorkOsOrganizationDomainEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WorkOsOrganizationDomainEdge = {
  __typename?: 'WorkOSOrganizationDomainEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WorkOsOrganizationDomain>;
};

/** Ordering options for WorkOSOrganizationDomain connections */
export type WorkOsOrganizationDomainOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WorkOSOrganizationDomains. */
  field: WorkOsOrganizationDomainOrderField;
};

/** Properties by which WorkOSOrganizationDomain connections can be ordered. */
export enum WorkOsOrganizationDomainOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * WorkOSOrganizationDomainWhereInput is used for filtering WorkOSOrganizationDomain objects.
 * Input was generated by ent.
 */
export type WorkOsOrganizationDomainWhereInput = {
  and?: InputMaybe<Array<WorkOsOrganizationDomainWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** email_domain field predicates */
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** workos_organization edge predicates */
  hasWorkosOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasWorkosOrganizationWith?: InputMaybe<Array<WorkOsOrganizationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<WorkOsOrganizationDomainWhereInput>;
  or?: InputMaybe<Array<WorkOsOrganizationDomainWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** workos_organization_id field predicates */
  workosOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  workosOrganizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  workosOrganizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  workosOrganizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** An edge in a connection. */
export type WorkOsOrganizationEdge = {
  __typename?: 'WorkOSOrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WorkOsOrganization>;
};

/** Ordering options for WorkOSOrganization connections */
export type WorkOsOrganizationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WorkOSOrganizations. */
  field: WorkOsOrganizationOrderField;
};

/** Properties by which WorkOSOrganization connections can be ordered. */
export enum WorkOsOrganizationOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/**
 * WorkOSOrganizationWhereInput is used for filtering WorkOSOrganization objects.
 * Input was generated by ent.
 */
export type WorkOsOrganizationWhereInput = {
  and?: InputMaybe<Array<WorkOsOrganizationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** display_name field predicates */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  /** domains edge predicates */
  hasDomains?: InputMaybe<Scalars['Boolean']['input']>;
  hasDomainsWith?: InputMaybe<Array<WorkOsOrganizationDomainWhereInput>>;
  /** luminary_organization edge predicates */
  hasLuminaryOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasLuminaryOrganizationWith?: InputMaybe<Array<LuminaryOrganizationWhereInput>>;
  /** update_user edge predicates */
  hasUpdateUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpdateUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** luminary_organization_id field predicates */
  luminaryOrganizationID?: InputMaybe<Scalars['ID']['input']>;
  luminaryOrganizationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  luminaryOrganizationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  luminaryOrganizationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<WorkOsOrganizationWhereInput>;
  or?: InputMaybe<Array<WorkOsOrganizationWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** workos_connection_id field predicates */
  workosConnectionID?: InputMaybe<Scalars['String']['input']>;
  workosConnectionIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  workosConnectionIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** workos_directory_id field predicates */
  workosDirectoryID?: InputMaybe<Scalars['String']['input']>;
  workosDirectoryIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  workosDirectoryIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** workos_directory_updated_at field predicates */
  workosDirectoryUpdatedAt?: InputMaybe<Scalars['Time']['input']>;
  workosDirectoryUpdatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  workosDirectoryUpdatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  workosDirectoryUpdatedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  workosDirectoryUpdatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  workosDirectoryUpdatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  workosDirectoryUpdatedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkflowTracker = Node & {
  __typename?: 'WorkflowTracker';
  /** The conversation that is associated with this workflow */
  conversation?: Maybe<Conversation>;
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** The saved diagram being edited or first created by this generation */
  diagramArtifact?: Maybe<DiagramArtifact>;
  documentSummaries: DocumentSummaryConnection;
  /** The document summary prompt test run associated with this workflow */
  documentSummaryPromptTestRun?: Maybe<DocumentSummaryPromptTestRun>;
  /** The documents that are associated with this workflow */
  documents?: Maybe<Array<Document>>;
  endedAt?: Maybe<Scalars['Time']['output']>;
  /** The entities that this workflow is associated with */
  entities?: Maybe<Array<Entity>>;
  failureReason?: Maybe<Scalars['String']['output']>;
  household?: Maybe<Household>;
  /** the household this object belongs to */
  householdID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  kind: WorkflowTrackerKind;
  memos: MemoConnection;
  /** The presentation that this workflow tracker is associated with */
  presentation?: Maybe<ClientPresentationV2>;
  startedAt: Scalars['Time']['output'];
  status: WorkflowTrackerStatus;
  /** The Temporal workflow ID for the execution that currently owns this tracker */
  temporalID: Scalars['String']['output'];
  /** The Temporal run ID that disambiguates the current workflow execution */
  temporalRunID?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantID: Scalars['ID']['output'];
  /** The testamentary entities that this workflow is associated with */
  testamentaryEntities?: Maybe<Array<TestamentaryEntity>>;
  updatedAt: Scalars['Time']['output'];
};


export type WorkflowTrackerDocumentSummariesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentSummaryOrder>>;
};


export type WorkflowTrackerMemosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemoOrder>>;
};

/** A connection to a list of items. */
export type WorkflowTrackerConnection = {
  __typename?: 'WorkflowTrackerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WorkflowTrackerEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WorkflowTrackerEdge = {
  __typename?: 'WorkflowTrackerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WorkflowTracker>;
};

/** WorkflowTrackerKind is enum for the field kind */
export enum WorkflowTrackerKind {
  AddeparCacheSync = 'ADDEPAR_CACHE_SYNC',
  AddeparEntitySync = 'ADDEPAR_ENTITY_SYNC',
  AddeparHouseholdSummarySync = 'ADDEPAR_HOUSEHOLD_SUMMARY_SYNC',
  AikgV2Extraction = 'AIKG_V2_EXTRACTION',
  AiSuggestionsV2DpGeneration = 'AI_SUGGESTIONS_V2_DP_GENERATION',
  AiSuggestionsV2EntityDetailsGeneration = 'AI_SUGGESTIONS_V2_ENTITY_DETAILS_GENERATION',
  AiSuggestionsV2HoldingsGeneration = 'AI_SUGGESTIONS_V2_HOLDINGS_GENERATION',
  AiSuggestionsV2HouseholdRegen = 'AI_SUGGESTIONS_V2_HOUSEHOLD_REGEN',
  AiSuggestionsV2OnboardingGeneration = 'AI_SUGGESTIONS_V2_ONBOARDING_GENERATION',
  AiSuggestionsV2SubtrustDetailsGeneration = 'AI_SUGGESTIONS_V2_SUBTRUST_DETAILS_GENERATION',
  ApplyEntityAidpSuggestions = 'APPLY_ENTITY_AIDP_SUGGESTIONS',
  ApplyEntityDetailsSuggestions = 'APPLY_ENTITY_DETAILS_SUGGESTIONS',
  BlackDiamondCacheSync = 'BLACK_DIAMOND_CACHE_SYNC',
  BlackDiamondEntitySync = 'BLACK_DIAMOND_ENTITY_SYNC',
  DiagramGeneration = 'DIAGRAM_GENERATION',
  DocumentChatStream = 'DOCUMENT_CHAT_STREAM',
  DocumentExtraction = 'DOCUMENT_EXTRACTION',
  DocumentOcr = 'DOCUMENT_OCR',
  DocumentSplitBinder = 'DOCUMENT_SPLIT_BINDER',
  DocumentSummary = 'DOCUMENT_SUMMARY',
  DocumentSummaryExport = 'DOCUMENT_SUMMARY_EXPORT',
  DocumentSummaryPromptTestRun = 'DOCUMENT_SUMMARY_PROMPT_TEST_RUN',
  EmoneyCacheSync = 'EMONEY_CACHE_SYNC',
  EmoneyEntitySync = 'EMONEY_ENTITY_SYNC',
  EstateSnapshotGeneration = 'ESTATE_SNAPSHOT_GENERATION',
  EstateWaterfallChatStream = 'ESTATE_WATERFALL_CHAT_STREAM',
  FormExtraction = 'FORM_EXTRACTION',
  FormSubmissionExport = 'FORM_SUBMISSION_EXPORT',
  HouseholdChatInteraction = 'HOUSEHOLD_CHAT_INTERACTION',
  HouseholdChatStream = 'HOUSEHOLD_CHAT_STREAM',
  HouseholdCopy = 'HOUSEHOLD_COPY',
  HouseholdOnboardingCompletion = 'HOUSEHOLD_ONBOARDING_COMPLETION',
  ManualAiDp = 'MANUAL_AI_DP',
  MemoExport = 'MEMO_EXPORT',
  MemoGeneration = 'MEMO_GENERATION',
  OrionCacheSync = 'ORION_CACHE_SYNC',
  OrionEntitySync = 'ORION_ENTITY_SYNC',
  PresentationGeneration = 'PRESENTATION_GENERATION',
  PresentationTemplatePromptGeneration = 'PRESENTATION_TEMPLATE_PROMPT_GENERATION',
  ProposalGeneration = 'PROPOSAL_GENERATION',
  SnowflakeAssetsSync = 'SNOWFLAKE_ASSETS_SYNC',
  SnowflakeAssetValuationSync = 'SNOWFLAKE_ASSET_VALUATION_SYNC',
  SnowflakeDataSharingSync = 'SNOWFLAKE_DATA_SHARING_SYNC',
  SnowflakeHouseholdsSync = 'SNOWFLAKE_HOUSEHOLDS_SYNC',
  ValidationQuestions = 'VALIDATION_QUESTIONS'
}

/** Ordering options for WorkflowTracker connections */
export type WorkflowTrackerOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WorkflowTrackers. */
  field: WorkflowTrackerOrderField;
};

/** Properties by which WorkflowTracker connections can be ordered. */
export enum WorkflowTrackerOrderField {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

/** WorkflowTrackerStatus is enum for the field status */
export enum WorkflowTrackerStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Started = 'STARTED'
}

/**
 * WorkflowTrackerWhereInput is used for filtering WorkflowTracker objects.
 * Input was generated by ent.
 */
export type WorkflowTrackerWhereInput = {
  and?: InputMaybe<Array<WorkflowTrackerWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** ended_at field predicates */
  endedAt?: InputMaybe<Scalars['Time']['input']>;
  endedAtGT?: InputMaybe<Scalars['Time']['input']>;
  endedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  endedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endedAtLT?: InputMaybe<Scalars['Time']['input']>;
  endedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  endedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** failure_reason field predicates */
  failureReason?: InputMaybe<Scalars['String']['input']>;
  failureReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  failureReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** diagram_artifact edge predicates */
  hasDiagramArtifact?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiagramArtifactWith?: InputMaybe<Array<DiagramArtifactWhereInput>>;
  /** entities edge predicates */
  hasEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntitiesWith?: InputMaybe<Array<EntityWhereInput>>;
  /** household edge predicates */
  hasHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  hasHouseholdWith?: InputMaybe<Array<HouseholdWhereInput>>;
  /** testamentary_entities edge predicates */
  hasTestamentaryEntities?: InputMaybe<Scalars['Boolean']['input']>;
  hasTestamentaryEntitiesWith?: InputMaybe<Array<TestamentaryEntityWhereInput>>;
  /** household_id field predicates */
  householdID?: InputMaybe<Scalars['ID']['input']>;
  householdIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  householdIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  householdIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  householdIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<WorkflowTrackerKind>;
  kindIn?: InputMaybe<Array<WorkflowTrackerKind>>;
  kindNEQ?: InputMaybe<WorkflowTrackerKind>;
  kindNotIn?: InputMaybe<Array<WorkflowTrackerKind>>;
  not?: InputMaybe<WorkflowTrackerWhereInput>;
  or?: InputMaybe<Array<WorkflowTrackerWhereInput>>;
  /** started_at field predicates */
  startedAt?: InputMaybe<Scalars['Time']['input']>;
  startedAtGT?: InputMaybe<Scalars['Time']['input']>;
  startedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  startedAtLT?: InputMaybe<Scalars['Time']['input']>;
  startedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  /** status field predicates */
  status?: InputMaybe<WorkflowTrackerStatus>;
  statusIn?: InputMaybe<Array<WorkflowTrackerStatus>>;
  statusNEQ?: InputMaybe<WorkflowTrackerStatus>;
  statusNotIn?: InputMaybe<Array<WorkflowTrackerStatus>>;
  /** tenant_id field predicates */
  tenantID?: InputMaybe<Scalars['ID']['input']>;
  tenantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tenantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
};

export type YearProjectionOption = {
  __typename?: 'YearProjectionOption';
  display: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};
